window.storeLocations = [
  {
    "id": "18760",
    "name": "SPROUTS",
    "address": "Old Spanish Trail 1212, Houston, TX, 77054",
    "phone": "346-326-7639",
    "hours": "Call for hours",
    "lat": 29.69196,
    "lng": -95.4117
  },
  {
    "id": "18759",
    "name": "SPROUTS",
    "address": "West Cuthbert Boulevard 640, Haddon Township, NJ, 8108",
    "phone": "856-873-9052",
    "hours": "Call for hours",
    "lat": 39.90631,
    "lng": -75.0606
  },
  {
    "id": "18758",
    "name": "SPROUTS",
    "address": "SR 73 931, Marlton, NJ, 8053",
    "phone": "856-355-8228",
    "hours": "Call for hours",
    "lat": 39.86205,
    "lng": -74.9228
  },
  {
    "id": "18757",
    "name": "SPROUTS",
    "address": "University Boulevard 13550, Sugarland, TX, 77479",
    "phone": "281-201-3470",
    "hours": "Call for hours",
    "lat": 29.58409,
    "lng": -95.6479
  },
  {
    "id": "18756",
    "name": "SPROUTS",
    "address": "Old Columbia Pike 15793, Burtonsville, MD, 20866",
    "phone": "240-883-9223",
    "hours": "Call for hours",
    "lat": 39.11914,
    "lng": -76.9316
  },
  {
    "id": "18755",
    "name": "SPROUTS",
    "address": "Boston Street 3800, Baltimore, MD, 21224",
    "phone": "443-836-5882",
    "hours": "Call for hours",
    "lat": 39.27794,
    "lng": -76.5639
  },
  {
    "id": "18754",
    "name": "SPROUTS",
    "address": "Ritchie Highway 8048, Pasadena, MD, 21122",
    "phone": "443-960-8484",
    "hours": "Call for hours",
    "lat": 39.12503,
    "lng": -76.5916
  },
  {
    "id": "18753",
    "name": "SPROUTS",
    "address": "Marketplace Drive 680, Bel Air, MD, 21014",
    "phone": "443-567-7788",
    "hours": "Call for hours",
    "lat": 39.52689,
    "lng": -76.3486
  },
  {
    "id": "18752",
    "name": "SPROUTS",
    "address": "Goucher Boulevard 803, Towson, MD, 21286",
    "phone": "410-842-6010",
    "hours": "Call for hours",
    "lat": 39.39791,
    "lng": -76.5846
  },
  {
    "id": "18751",
    "name": "SPROUTS",
    "address": "Baltimore National Pike 9150, Ellicott City, MD, 21042",
    "phone": "410-696-3160",
    "hours": "Call for hours",
    "lat": 39.27817,
    "lng": -76.8264
  },
  {
    "id": "18750",
    "name": "SPROUTS",
    "address": "Sudley Road 8431, Manassas, VA, 20109",
    "phone": "571-579-3257",
    "hours": "Call for hours",
    "lat": 38.77384,
    "lng": -77.4993
  },
  {
    "id": "18749",
    "name": "SPROUTS",
    "address": "Elden Street 494, Herndon, VA, 20170",
    "phone": "703-480-7930",
    "hours": "Call for hours",
    "lat": 38.96853,
    "lng": -77.3782
  },
  {
    "id": "18748",
    "name": "SPROUTS",
    "address": "Welsh Road 2001, Dresher, PA, 19025",
    "phone": "267-715-0602",
    "hours": "Call for hours",
    "lat": 40.15955,
    "lng": -75.1482
  },
  {
    "id": "18747",
    "name": "SPROUTS",
    "address": "South Broad Street 1000, Philadelphia, PA, 19146",
    "phone": "215-606-2400",
    "hours": "Call for hours",
    "lat": 39.93895,
    "lng": -75.1667
  },
  {
    "id": "18746",
    "name": "SPROUTS",
    "address": "Concord Pike 4801, Wilmington, DE, 19803",
    "phone": "302-467-2344",
    "hours": "Call for hours",
    "lat": 39.82549,
    "lng": -75.545
  },
  {
    "id": "18745",
    "name": "SPROUTS",
    "address": "South Pennsylvania Avenue 12100, Oklahoma City, OK, 73170",
    "phone": "405-416-7650",
    "hours": "Call for hours",
    "lat": 35.34768,
    "lng": -97.5475
  },
  {
    "id": "18744",
    "name": "SPROUTS",
    "address": "West 6th Avenue 909, Stillwater, OK, 74074",
    "phone": "405-571-3153",
    "hours": "Call for hours",
    "lat": 36.11555,
    "lng": -97.0696
  },
  {
    "id": "18743",
    "name": "SPROUTS",
    "address": "Garth Brooks Boulevard 1105, Yukon, OK, 73099",
    "phone": "405-494-3054",
    "hours": "Call for hours",
    "lat": 35.49762,
    "lng": -97.7601
  },
  {
    "id": "18742",
    "name": "SPROUTS",
    "address": "North MacArthur Boulevard 12200, Oklahoma City, OK, 73162",
    "phone": "405-384-7577",
    "hours": "Call for hours",
    "lat": 35.59322,
    "lng": -97.6206
  },
  {
    "id": "18741",
    "name": "SPROUTS",
    "address": "Westheimer Road 11940, Houston, TX, 77077",
    "phone": "281-582-6794",
    "hours": "Call for hours",
    "lat": 29.73632,
    "lng": -95.5895
  },
  {
    "id": "18740",
    "name": "SPROUTS",
    "address": "North 133rd Avenue East 9601, Owasso, OK, 74055",
    "phone": "918-516-6656",
    "hours": "Call for hours",
    "lat": 36.29429,
    "lng": -95.8263
  },
  {
    "id": "18739",
    "name": "SPROUTS",
    "address": "East Hillside Drive North 851, Broken Arrow (Tulsa), OK, 74012",
    "phone": "918-806-0810",
    "hours": "Call for hours",
    "lat": 36.06672,
    "lng": -95.7812
  },
  {
    "id": "18738",
    "name": "SPROUTS",
    "address": "South Harvard Avenue 4123, Tulsa, OK, 74135",
    "phone": "918-858-8850",
    "hours": "Call for hours",
    "lat": 36.10391,
    "lng": -95.9401
  },
  {
    "id": "18737",
    "name": "SPROUTS",
    "address": "South Memorial Drive 10111, Tulsa, OK, 74133",
    "phone": "918-364-7272",
    "hours": "Call for hours",
    "lat": 36.01712,
    "lng": -95.8864
  },
  {
    "id": "18736",
    "name": "SPROUTS",
    "address": "West Main Street 559, Norman, OK, 73069",
    "phone": "405-217-4601",
    "hours": "Call for hours",
    "lat": 35.21895,
    "lng": -97.451
  },
  {
    "id": "18735",
    "name": "SPROUTS",
    "address": "East 2nd Street 24, Edmond, OK, 73034",
    "phone": "405-341-5727",
    "hours": "Call for hours",
    "lat": 35.65308,
    "lng": -97.4811
  },
  {
    "id": "18734",
    "name": "SPROUTS",
    "address": "North May Avenue 6410, Oklahoma City, OK, 73116",
    "phone": "405-879-9989",
    "hours": "Call for hours",
    "lat": 35.53702,
    "lng": -97.5658
  },
  {
    "id": "18733",
    "name": "SPROUTS",
    "address": "NE M 291 Highway 800, Lee's Summit, MO, 64086",
    "phone": "816-272-7038",
    "hours": "Call for hours",
    "lat": 38.92661,
    "lng": -94.3609
  },
  {
    "id": "18732",
    "name": "SPROUTS",
    "address": "Nacogdoches Road 2502, San Antonio, TX, 78217",
    "phone": "210-824-7800",
    "hours": "Call for hours",
    "lat": 29.51782,
    "lng": -98.4493
  },
  {
    "id": "18731",
    "name": "SPROUTS",
    "address": "Tom Watson Parkway 6061, Kansas City, MO, 64151",
    "phone": "816-303-6503",
    "hours": "Call for hours",
    "lat": 39.20985,
    "lng": -94.6503
  },
  {
    "id": "18730",
    "name": "SPROUTS",
    "address": "North Booth Avenue 8383, Kansas City (Liberty), MO, 64158",
    "phone": "816-222-0202",
    "hours": "Call for hours",
    "lat": 39.24362,
    "lng": -94.4747
  },
  {
    "id": "18729",
    "name": "SPROUTS",
    "address": "East Lohman Avenue 2340, Las Cruces, NM, 88001",
    "phone": "575-680-3680",
    "hours": "Call for hours",
    "lat": 32.31303,
    "lng": -106.751
  },
  {
    "id": "18728",
    "name": "SPROUTS",
    "address": "Coors Boulevard Northwest 5600, Albuquerque, NM, 87120",
    "phone": "505-355-3850",
    "hours": "Call for hours",
    "lat": 35.14626,
    "lng": -106.688
  },
  {
    "id": "18727",
    "name": "SPROUTS",
    "address": "Central Avenue Southeast 13150, Albuquerque, NM, 87123",
    "phone": "505-998-1025",
    "hours": "Call for hours",
    "lat": 35.06643,
    "lng": -106.499
  },
  {
    "id": "18726",
    "name": "SPROUTS",
    "address": "West Anderson Lane 2917, Austin, TX, 78757",
    "phone": "512-451-0669",
    "hours": "Call for hours",
    "lat": 30.35968,
    "lng": -97.7387
  },
  {
    "id": "18725",
    "name": "SPROUTS",
    "address": "Paseo de Peralta 199, Santa Fe, NM, 87501",
    "phone": "505-988-1140",
    "hours": "Call for hours",
    "lat": 35.69226,
    "lng": -105.948
  },
  {
    "id": "18724",
    "name": "SPROUTS",
    "address": "Zafarano Drive 3201, Santa Fe, NM, 87507",
    "phone": "505-424-1900",
    "hours": "Call for hours",
    "lat": 35.64569,
    "lng": -106.014
  },
  {
    "id": "18723",
    "name": "SPROUTS",
    "address": "San Mateo Boulevard Northeast 6300, Albuquerque, NM, 87109",
    "phone": "505-821-7000",
    "hours": "Call for hours",
    "lat": 35.14865,
    "lng": -106.586
  },
  {
    "id": "18722",
    "name": "SPROUTS",
    "address": "Montgomery Boulevard Northeast 11201, Albuquerque, NM, 87111",
    "phone": "505-298-2447",
    "hours": "Call for hours",
    "lat": 35.13075,
    "lng": -106.516
  },
  {
    "id": "18721",
    "name": "SPROUTS",
    "address": "Lomas Boulevard Northeast 5112, Albuquerque, NM, 87110",
    "phone": "505-268-5127",
    "hours": "Call for hours",
    "lat": 35.08673,
    "lng": -106.588
  },
  {
    "id": "18720",
    "name": "SPROUTS",
    "address": "Corrales Road Northwest 10701, Albuquerque, NM, 87114",
    "phone": "505-890-7900",
    "hours": "Call for hours",
    "lat": 35.20502,
    "lng": -106.647
  },
  {
    "id": "18719",
    "name": "SPROUTS",
    "address": "Rouzan Square Avenue 4841, Baton Rouge, LA, 70808",
    "phone": "225-614-9131",
    "hours": "Call for hours",
    "lat": 30.41405,
    "lng": -91.1385
  },
  {
    "id": "18718",
    "name": "SPROUTS",
    "address": "Tamiami Trail 2000, Port Charlotte, FL, 33948",
    "phone": "941-699-2501",
    "hours": "Call for hours",
    "lat": 27.00356,
    "lng": -82.1282
  },
  {
    "id": "18717",
    "name": "SPROUTS",
    "address": "Hollywood Boulevard, West Melbourne, FL, 32904",
    "phone": "321-462-3184",
    "hours": "Call for hours",
    "lat": 28.07551,
    "lng": -80.6536
  },
  {
    "id": "18716",
    "name": "SPROUTS",
    "address": "Southwest 27th Terrace 2750, Miami, FL, 33133",
    "phone": "561-765-2216",
    "hours": "Call for hours",
    "lat": 25.74061,
    "lng": -80.239
  },
  {
    "id": "18715",
    "name": "SPROUTS",
    "address": "66th Street North 4571, Kenneth City, FL, 33709",
    "phone": "727-620-6030",
    "hours": "Call for hours",
    "lat": 27.81331,
    "lng": -82.7285
  },
  {
    "id": "18714",
    "name": "SPROUTS",
    "address": "College Parkway 8595, Ft. Myers, FL, 33919",
    "phone": "239-396-5883",
    "hours": "Call for hours",
    "lat": 26.55651,
    "lng": -81.8975
  },
  {
    "id": "18713",
    "name": "SPROUTS",
    "address": "Northeast Pine Island Road 1800, Cape Coral, FL, 33909",
    "phone": "239-392-1396",
    "hours": "Call for hours",
    "lat": 26.66972,
    "lng": -81.9366
  },
  {
    "id": "18712",
    "name": "SPROUTS",
    "address": "Lake Underhill Road 12500, Orlando, FL, 32828",
    "phone": "689-303-4690",
    "hours": "Call for hours",
    "lat": 28.54575,
    "lng": -81.2012
  },
  {
    "id": "18711",
    "name": "SPROUTS",
    "address": "Buena Vista Boulevard, The Villages, FL, 32162",
    "phone": "352-706-2925",
    "hours": "Call for hours",
    "lat": 28.95867,
    "lng": -82.002
  },
  {
    "id": "18710",
    "name": "SPROUTS",
    "address": "East Fowler Avenue 2150, Tampa, FL, 33612",
    "phone": "813-771-9936",
    "hours": "Call for hours",
    "lat": 28.05458,
    "lng": -82.4352
  },
  {
    "id": "18709",
    "name": "SPROUTS",
    "address": "Glades Road 9831, West Boca Raton, FL, 33434",
    "phone": "561-880-9105",
    "hours": "Call for hours",
    "lat": 26.36798,
    "lng": -80.1943
  },
  {
    "id": "18708",
    "name": "SPROUTS",
    "address": "Semoran Boulevard 2283, Apopka, FL, 32703",
    "phone": "689-336-2070",
    "hours": "Call for hours",
    "lat": 28.67484,
    "lng": -81.4691
  },
  {
    "id": "18707",
    "name": "SPROUTS",
    "address": "Cortez Road West 1149, Bradenton, FL, 34207",
    "phone": "941-297-2359",
    "hours": "Call for hours",
    "lat": 27.46255,
    "lng": -82.5746
  },
  {
    "id": "18706",
    "name": "SPROUTS",
    "address": "North Military Trail 1901, West Palm Beach, FL, 33409",
    "phone": "561-835-5418",
    "hours": "Call for hours",
    "lat": 26.70495,
    "lng": -80.1112
  },
  {
    "id": "18705",
    "name": "SPROUTS",
    "address": "West Atlantic Avenue 5030, Delray Beach, FL, 33484",
    "phone": "561-654-2692",
    "hours": "Call for hours",
    "lat": 26.45768,
    "lng": -80.1231
  },
  {
    "id": "18704",
    "name": "SPROUTS",
    "address": "East Colonial Drive 2530, Orlando, FL, 32803",
    "phone": "689-219-8967",
    "hours": "Call for hours",
    "lat": 28.55301,
    "lng": -81.3507
  },
  {
    "id": "18703",
    "name": "SPROUTS",
    "address": "Northeast 10th Court 2631, Homestead, FL, 33033",
    "phone": "754-764-7247",
    "hours": "Call for hours",
    "lat": 25.48054,
    "lng": -80.4392
  },
  {
    "id": "18702",
    "name": "SPROUTS",
    "address": "Nw St Lucie West Boulevard 1759, Port St Lucie, FL, 34986",
    "phone": "772-310-5465",
    "hours": "Call for hours",
    "lat": 27.31349,
    "lng": -80.406
  },
  {
    "id": "18701",
    "name": "SPROUTS",
    "address": "South Compass Way 150, Dania Beach, FL, 33004",
    "phone": "954-715-3376",
    "hours": "Call for hours",
    "lat": 26.04916,
    "lng": -80.1577
  },
  {
    "id": "18700",
    "name": "SPROUTS",
    "address": "Southwest 88th Street 12690, Miami, FL, 33186",
    "phone": "786-798-7074",
    "hours": "Call for hours",
    "lat": 25.68581,
    "lng": -80.4004
  },
  {
    "id": "18699",
    "name": "SPROUTS",
    "address": "East Oakland Park Boulevard 700, Oakland Park, FL, 33334",
    "phone": "561-894-0789",
    "hours": "Call for hours",
    "lat": 26.16681,
    "lng": -80.1374
  },
  {
    "id": "18698",
    "name": "SPROUTS",
    "address": "West 7th Avenue 101, Tampa, FL, 33602",
    "phone": "813-807-3146",
    "hours": "Call for hours",
    "lat": 27.96051,
    "lng": -82.4621
  },
  {
    "id": "18697",
    "name": "SPROUTS",
    "address": "Causeway Boulevard 11339, Brandon, FL, 33511",
    "phone": "813-725-1220",
    "hours": "Call for hours",
    "lat": 27.92312,
    "lng": -82.322
  },
  {
    "id": "18696",
    "name": "SPROUTS",
    "address": "Turkey Lake Road 7603, Orlando, FL, 32819",
    "phone": "321-340-2023",
    "hours": "Call for hours",
    "lat": 28.45435,
    "lng": -81.4764
  },
  {
    "id": "18695",
    "name": "SPROUTS",
    "address": "Sheldon Road 10619, Tampa, FL, 33626",
    "phone": "772-348-2150",
    "hours": "Call for hours",
    "lat": 28.04595,
    "lng": -82.5826
  },
  {
    "id": "18694",
    "name": "SPROUTS",
    "address": "South Jog Road 9850, Boynton Beach, FL, 33437",
    "phone": "561-739-1834",
    "hours": "Call for hours",
    "lat": 26.53,
    "lng": -80.1457
  },
  {
    "id": "18693",
    "name": "SPROUTS",
    "address": "South Tamiami Trail 19990, Estero, FL, 33928",
    "phone": "239-306-5384",
    "hours": "Call for hours",
    "lat": 26.44835,
    "lng": -81.8189
  },
  {
    "id": "18692",
    "name": "SPROUTS",
    "address": "Hunters Village Road 8620, Tampa, FL, 33647",
    "phone": "813-683-8072",
    "hours": "Call for hours",
    "lat": 28.1393,
    "lng": -82.358
  },
  {
    "id": "18691",
    "name": "SPROUTS",
    "address": "Southeast Federal Highway 3150, Stuart, FL, 34994",
    "phone": "772-272-9698",
    "hours": "Call for hours",
    "lat": 27.16631,
    "lng": -80.2271
  },
  {
    "id": "18690",
    "name": "SPROUTS",
    "address": "Seminole Boulevard 7263, Seminole, FL, 33772",
    "phone": "727-655-9055",
    "hours": "Call for hours",
    "lat": 27.83876,
    "lng": -82.787
  },
  {
    "id": "18689",
    "name": "SPROUTS",
    "address": "Beach Boulevard 12675, Jacksonville, FL, 32246",
    "phone": "904-539-8317",
    "hours": "Call for hours",
    "lat": 30.28891,
    "lng": -81.4858
  },
  {
    "id": "18688",
    "name": "SPROUTS",
    "address": "Miramar Parkway 12216, Miramar, FL, 33025",
    "phone": "754-799-8177",
    "hours": "Call for hours",
    "lat": 25.97889,
    "lng": -80.3086
  },
  {
    "id": "18687",
    "name": "SPROUTS",
    "address": "Military Trail 3757, Jupiter, FL, 33458",
    "phone": "561-658-4062",
    "hours": "Call for hours",
    "lat": 26.91094,
    "lng": -80.1024
  },
  {
    "id": "18686",
    "name": "SPROUTS",
    "address": "Town Center Parkway 4873, Jacksonville, FL, 32246",
    "phone": "904-438-7840",
    "hours": "Call for hours",
    "lat": 30.2536,
    "lng": -81.5333
  },
  {
    "id": "18685",
    "name": "SPROUTS",
    "address": "South Us Highway 301 12960, Riverview, FL, 33578",
    "phone": "813-284-3440",
    "hours": "Call for hours",
    "lat": 27.80038,
    "lng": -82.3329
  },
  {
    "id": "18684",
    "name": "SPROUTS",
    "address": "Strength Avenue 8840, New Port Richey, FL, 34655",
    "phone": "727-807-2200",
    "hours": "Call for hours",
    "lat": 28.20474,
    "lng": -82.669
  },
  {
    "id": "18683",
    "name": "SPROUTS",
    "address": "Alafaya Trail 1121, Oviedo, FL, 32765",
    "phone": "407-542-6070",
    "hours": "Call for hours",
    "lat": 28.65351,
    "lng": -81.2096
  },
  {
    "id": "18682",
    "name": "SPROUTS",
    "address": "South Federal Highway 930, Deerfield Beach, FL, 33441",
    "phone": "954-363-2070",
    "hours": "Call for hours",
    "lat": 26.30564,
    "lng": -80.0927
  },
  {
    "id": "18681",
    "name": "SPROUTS",
    "address": "Us Highway 19 North 23656, Clearwater, FL, 33765",
    "phone": "727-437-1455",
    "hours": "Call for hours",
    "lat": 27.98755,
    "lng": -82.731
  },
  {
    "id": "18680",
    "name": "SPROUTS",
    "address": "Aloma Avenue 1999, Winter Park, FL, 32792",
    "phone": "407-702-1212",
    "hours": "Call for hours",
    "lat": 28.60099,
    "lng": -81.3249
  },
  {
    "id": "18679",
    "name": "SPROUTS",
    "address": "Logan Boulevard North 2224, Naples, FL, 34119",
    "phone": "239-325-6950",
    "hours": "Call for hours",
    "lat": 26.27094,
    "lng": -81.7207
  },
  {
    "id": "18678",
    "name": "SPROUTS",
    "address": "South Tamiami Trail 8330, S. Sarasota, FL, 34238",
    "phone": "941-218-8119",
    "hours": "Call for hours",
    "lat": 27.23299,
    "lng": -82.4971
  },
  {
    "id": "18677",
    "name": "SPROUTS",
    "address": "Lithia Pinecrest Road 3315, Valrico, FL, 33596",
    "phone": "813-603-9630",
    "hours": "Call for hours",
    "lat": 27.89339,
    "lng": -82.2435
  },
  {
    "id": "18676",
    "name": "SPROUTS",
    "address": "North Dale Mabry Highway 15110, Tampa, FL, 33618",
    "phone": "813-619-4000",
    "hours": "Call for hours",
    "lat": 28.08717,
    "lng": -82.5043
  },
  {
    "id": "18675",
    "name": "SPROUTS",
    "address": "Us Highway 19 North 33652, Palm Harbor, FL, 34684",
    "phone": "727-437-3824",
    "hours": "Call for hours",
    "lat": 28.07808,
    "lng": -82.7412
  },
  {
    "id": "18674",
    "name": "SPROUTS",
    "address": "South Dale Mabry Highway 1523, S. Tampa, FL, 33629",
    "phone": "813-466-3390",
    "hours": "Call for hours",
    "lat": 27.92975,
    "lng": -82.5059
  },
  {
    "id": "18673",
    "name": "SPROUTS",
    "address": "4000 West 11519 S, South Jordan, UT, 84009",
    "phone": "385-695-6809",
    "hours": "Call for hours",
    "lat": 40.54089,
    "lng": -111.985
  },
  {
    "id": "18672",
    "name": "SPROUTS",
    "address": "East Murray Holladay Road 1785, Holladay, UT, 84117",
    "phone": "385-695-6817",
    "hours": "Call for hours",
    "lat": 40.66701,
    "lng": -111.841
  },
  {
    "id": "18671",
    "name": "SPROUTS",
    "address": "700 East 216 South, Salt Lake City, UT, 84102",
    "phone": "801-364-1602",
    "hours": "Call for hours",
    "lat": 40.76457,
    "lng": -111.873
  },
  {
    "id": "18670",
    "name": "SPROUTS",
    "address": "South State Street 1375, Orem, UT, 84097",
    "phone": "801-434-1501",
    "hours": "Call for hours",
    "lat": 40.27194,
    "lng": -111.683
  },
  {
    "id": "18669",
    "name": "SPROUTS",
    "address": "South State Street 6284, Murray, UT, 84107",
    "phone": "801-266-3566",
    "hours": "Call for hours",
    "lat": 40.63451,
    "lng": -111.89
  },
  {
    "id": "18668",
    "name": "SPROUTS",
    "address": "Nolensville Pike 5821, Nashville, TN, 37211",
    "phone": "629-736-3268",
    "hours": "Call for hours",
    "lat": 36.04223,
    "lng": -86.713
  },
  {
    "id": "18667",
    "name": "SPROUTS",
    "address": "South Perkins Road 576, Memphis, TN, 38117",
    "phone": "901-620-4405",
    "hours": "Call for hours",
    "lat": 35.11543,
    "lng": -89.907
  },
  {
    "id": "18666",
    "name": "SPROUTS",
    "address": "Highway 70 South 7620, Nashville, TN, 37221",
    "phone": "615-209-7940",
    "hours": "Call for hours",
    "lat": 36.07991,
    "lng": -86.9489
  },
  {
    "id": "18665",
    "name": "SPROUTS",
    "address": "Wendelwood Drive 143, Murfreesboro, TN, 37129",
    "phone": "615-486-6081",
    "hours": "Call for hours",
    "lat": 35.88022,
    "lng": -86.3868
  },
  {
    "id": "18664",
    "name": "SPROUTS",
    "address": "Murfreesboro Road 1010, Franklin, TN, 37064",
    "phone": "615-567-0191",
    "hours": "Call for hours",
    "lat": 35.91641,
    "lng": -86.8388
  },
  {
    "id": "18663",
    "name": "SPROUTS",
    "address": "Village Shops Drive 3150, Germantown, TN, 38138",
    "phone": "901-259-7020",
    "hours": "Call for hours",
    "lat": 35.06499,
    "lng": -89.7589
  },
  {
    "id": "18662",
    "name": "SPROUTS",
    "address": "Us Highway 64 9050, Lakeland, TN, 38002",
    "phone": "901-259-3450",
    "hours": "Call for hours",
    "lat": 35.20591,
    "lng": -89.7613
  },
  {
    "id": "18661",
    "name": "SPROUTS",
    "address": "Steele Creek Road 14124, Charlotte, NC, 28273",
    "phone": "828-705-3910",
    "hours": "Call for hours",
    "lat": 35.10182,
    "lng": -80.9884
  },
  {
    "id": "18660",
    "name": "SPROUTS",
    "address": "Woodruff Road 2200, Simpsonville, SC, 29681",
    "phone": "864-757-3240",
    "hours": "Call for hours",
    "lat": 34.81887,
    "lng": -82.2549
  },
  {
    "id": "18659",
    "name": "SPROUTS",
    "address": "West Lake Mead Parkway 280, Henderson, NV, 89015",
    "phone": "725-286-2723",
    "hours": "Call for hours",
    "lat": 36.03649,
    "lng": -114.992
  },
  {
    "id": "18658",
    "name": "SPROUTS",
    "address": "Losee Road 6506, North Las Vegas, NV, 89086",
    "phone": "702-857-6362",
    "hours": "Call for hours",
    "lat": 36.2783,
    "lng": -115.117
  },
  {
    "id": "18657",
    "name": "SPROUTS",
    "address": "East Plumb Lane 299, Reno, NV, 89502",
    "phone": "775-446-3979",
    "hours": "Call for hours",
    "lat": 39.5058,
    "lng": -119.801
  },
  {
    "id": "18656",
    "name": "SPROUTS",
    "address": "South Rainbow Boulevard 771, Las Vegas, NV, 89145",
    "phone": "702-984-4330",
    "hours": "Call for hours",
    "lat": 36.1644,
    "lng": -115.246
  },
  {
    "id": "18655",
    "name": "SPROUTS",
    "address": "North Decatur Boulevard 6150, Las Vegas, NV, 89130",
    "phone": "702-273-3490",
    "hours": "Call for hours",
    "lat": 36.26996,
    "lng": -115.207
  },
  {
    "id": "18654",
    "name": "SPROUTS",
    "address": "Battleground Avenue 3357, Greensboro, NC, 27410",
    "phone": "336-252-5250",
    "hours": "Call for hours",
    "lat": 36.123,
    "lng": -79.8458
  },
  {
    "id": "18653",
    "name": "SPROUTS",
    "address": "West NC Highway 54 105, Durham, NC, 27713",
    "phone": "919-768-4055",
    "hours": "Call for hours",
    "lat": 35.90975,
    "lng": -78.9388
  },
  {
    "id": "18652",
    "name": "SPROUTS",
    "address": "Freedom Parkway Drive 2810, Fayetteville, NC, 28314",
    "phone": "910-748-5985",
    "hours": "Call for hours",
    "lat": 35.05758,
    "lng": -78.9698
  },
  {
    "id": "18651",
    "name": "SPROUTS",
    "address": "Ballancroft Parkway 15121, Charlotte, NC, 28277",
    "phone": "704-778-3010",
    "hours": "Call for hours",
    "lat": 35.04087,
    "lng": -80.848
  },
  {
    "id": "18650",
    "name": "SPROUTS",
    "address": "Falls of Neuse Road 9414, Raleigh, NC, 27615",
    "phone": "919-326-2530",
    "hours": "Call for hours",
    "lat": 35.90245,
    "lng": -78.6049
  },
  {
    "id": "18649",
    "name": "SPROUTS",
    "address": "Cumberland Boulevard Southeast 2530, Smyrna, GA, 30080",
    "phone": "470-750-1841",
    "hours": "Call for hours",
    "lat": 33.89012,
    "lng": -84.4767
  },
  {
    "id": "18648",
    "name": "SPROUTS",
    "address": "Buford Drive 2925, Buford, GA, 30519",
    "phone": "470-600-6528",
    "hours": "Call for hours",
    "lat": 34.05134,
    "lng": -83.9913
  },
  {
    "id": "18647",
    "name": "SPROUTS",
    "address": "Crane Creek Drive 630, Augusta, GA, 30907",
    "phone": "706-993-9150",
    "hours": "Call for hours",
    "lat": 33.49704,
    "lng": -82.0801
  },
  {
    "id": "18646",
    "name": "SPROUTS",
    "address": "Lavista Road 4310, Tucker, GA, 30084",
    "phone": "470-260-2368",
    "hours": "Call for hours",
    "lat": 33.84813,
    "lng": -84.2404
  },
  {
    "id": "18645",
    "name": "SPROUTS",
    "address": "Marietta, GA, 30064",
    "phone": "678-919-8701",
    "hours": "Call for hours",
    "lat": 33.95723,
    "lng": -84.5427
  },
  {
    "id": "18644",
    "name": "SPROUTS",
    "address": "Blackmon Drive 2551, Decatur, GA, 30033",
    "phone": "404-965-6290",
    "hours": "Call for hours",
    "lat": 33.7952,
    "lng": -84.2873
  },
  {
    "id": "18643",
    "name": "SPROUTS",
    "address": "W Highway 54 2015, Peachtree City, GA, 30269",
    "phone": "678-586-2577",
    "hours": "Call for hours",
    "lat": 33.41976,
    "lng": -84.5594
  },
  {
    "id": "18642",
    "name": "SPROUTS",
    "address": "Towne Lake Parkway 1430, Woodstock, GA, 30189",
    "phone": "678-224-9799",
    "hours": "Call for hours",
    "lat": 34.10624,
    "lng": -84.54
  },
  {
    "id": "18641",
    "name": "SPROUTS",
    "address": "Roswell Road 4101, Marietta, GA, 30062",
    "phone": "770-200-9172",
    "hours": "Call for hours",
    "lat": 33.98165,
    "lng": -84.4345
  },
  {
    "id": "18640",
    "name": "SPROUTS",
    "address": "Alpharetta Highway 10800, Roswell, GA, 30076",
    "phone": "678-353-0102",
    "hours": "Call for hours",
    "lat": 34.04436,
    "lng": -84.3411
  },
  {
    "id": "18639",
    "name": "SPROUTS",
    "address": "Piedmont Avenue Northeast 1845, Atlanta, GA, 30324",
    "phone": "404-751-0605",
    "hours": "Call for hours",
    "lat": 33.80638,
    "lng": -84.3667
  },
  {
    "id": "18638",
    "name": "SPROUTS",
    "address": "East-West Connector, Smyrna, GA, 30082",
    "phone": "770-200-7587",
    "hours": "Call for hours",
    "lat": 33.83835,
    "lng": -84.5108
  },
  {
    "id": "18637",
    "name": "SPROUTS",
    "address": "Peachtree Parkway 3630, Suwanee (John's Creek), GA, 30024",
    "phone": "678-690-1243",
    "hours": "Call for hours",
    "lat": 34.07369,
    "lng": -84.1659
  },
  {
    "id": "18636",
    "name": "SPROUTS",
    "address": "Lakeland Plaza 530, Cumming, GA, 30040",
    "phone": "470-505-2000",
    "hours": "Call for hours",
    "lat": 34.18419,
    "lng": -84.1435
  },
  {
    "id": "18635",
    "name": "SPROUTS",
    "address": "Mount Vernon Road 2480, Dunwoody, GA, 30338",
    "phone": "678-690-1237",
    "hours": "Call for hours",
    "lat": 33.95808,
    "lng": -84.3017
  },
  {
    "id": "18634",
    "name": "SPROUTS",
    "address": "Peachtree Parkway Northwest 5600, Norcross, GA, 30092",
    "phone": "678-690-1249",
    "hours": "Call for hours",
    "lat": 33.9667,
    "lng": -84.2218
  },
  {
    "id": "18633",
    "name": "SPROUTS",
    "address": "Scenic Highway 1250, Lawrenceville, GA, 30045",
    "phone": "678-690-1279",
    "hours": "Call for hours",
    "lat": 33.90032,
    "lng": -84.0056
  },
  {
    "id": "18632",
    "name": "SPROUTS",
    "address": "Disc Drive 125, Sparks, NV, 89436",
    "phone": "775-834-0210",
    "hours": "Call for hours",
    "lat": 39.57647,
    "lng": -119.743
  },
  {
    "id": "18631",
    "name": "SPROUTS",
    "address": "South Rainbow Boulevard 7375, Las Vegas, NV, 89139",
    "phone": "702-670-4450",
    "hours": "Call for hours",
    "lat": 36.05445,
    "lng": -115.245
  },
  {
    "id": "18630",
    "name": "SPROUTS",
    "address": "East Silverado Ranch Boulevard 1140, Las Vegas, NV, 89183",
    "phone": "702-750-3570",
    "hours": "Call for hours",
    "lat": 36.01335,
    "lng": -115.138
  },
  {
    "id": "18629",
    "name": "SPROUTS",
    "address": "South Meadows Parkway 587, Reno, NV, 89521",
    "phone": "775-335-1055",
    "hours": "Call for hours",
    "lat": 39.43872,
    "lng": -119.759
  },
  {
    "id": "18628",
    "name": "SPROUTS",
    "address": "West Lake Mead Boulevard 7530, Las Vegas, NV, 89128",
    "phone": "702-216-3556",
    "hours": "Call for hours",
    "lat": 36.1962,
    "lng": -115.258
  },
  {
    "id": "18627",
    "name": "SPROUTS",
    "address": "Farm Road 8441, Las Vegas, NV, 89131",
    "phone": "702-583-3830",
    "hours": "Call for hours",
    "lat": 36.29908,
    "lng": -115.279
  },
  {
    "id": "18626",
    "name": "SPROUTS",
    "address": "West Sahara Avenue 10000, Las Vegas, NV, 89117",
    "phone": "702-216-5060",
    "hours": "Call for hours",
    "lat": 36.14447,
    "lng": -115.314
  },
  {
    "id": "18625",
    "name": "SPROUTS",
    "address": "North Stephanie Street 515, Henderson (Stephanie), NV, 89014",
    "phone": "702-777-7095",
    "hours": "Call for hours",
    "lat": 36.06049,
    "lng": -115.046
  },
  {
    "id": "18624",
    "name": "SPROUTS",
    "address": "South Green Valley Parkway 635, Henderson (Green Valley), NV, 89052",
    "phone": "702-322-2229",
    "hours": "Call for hours",
    "lat": 36.00474,
    "lng": -115.083
  },
  {
    "id": "18623",
    "name": "SPROUTS",
    "address": "South Rainbow Boulevard 4020, Las Vegas, NV, 89103",
    "phone": "702-876-4888",
    "hours": "Call for hours",
    "lat": 36.11535,
    "lng": -115.241
  },
  {
    "id": "18622",
    "name": "SPROUTS",
    "address": "East Tropicana Avenue 3365, Las Vegas, NV, 89121",
    "phone": "702-777-0650",
    "hours": "Call for hours",
    "lat": 36.09878,
    "lng": -115.102
  },
  {
    "id": "18621",
    "name": "SPROUTS",
    "address": "US 280, Birmingham, AL, 35242",
    "phone": "205-263-2808",
    "hours": "Call for hours",
    "lat": 33.42659,
    "lng": -86.7055
  },
  {
    "id": "18620",
    "name": "SPROUTS",
    "address": "Peachtree Industrial Boulevard 2220, Duluth, GA, 30097",
    "phone": "470-362-7283",
    "hours": "Call for hours",
    "lat": 34.02321,
    "lng": -84.1156
  },
  {
    "id": "18619",
    "name": "SPROUTS",
    "address": "Us 72 W Highway NW 7504, Madison, AL, 35758",
    "phone": "256-203-8334",
    "hours": "Call for hours",
    "lat": 34.75816,
    "lng": -86.7301
  },
  {
    "id": "18618",
    "name": "SPROUTS",
    "address": "Medford Drive 5250, Hoover, AL, 35244",
    "phone": "205-263-4970",
    "hours": "Call for hours",
    "lat": 33.35626,
    "lng": -86.8561
  },
  {
    "id": "18617",
    "name": "SPROUTS",
    "address": "South Mooney Boulevard 3501, Visalia, CA, 93277",
    "phone": "559-553-4044",
    "hours": "Call for hours",
    "lat": 36.29958,
    "lng": -119.314
  },
  {
    "id": "18616",
    "name": "SPROUTS",
    "address": "Amargosa Road 12450, Victorville, CA, 92392",
    "phone": "442-327-1306",
    "hours": "Call for hours",
    "lat": 34.4755,
    "lng": -117.343
  },
  {
    "id": "18615",
    "name": "SPROUTS",
    "address": "Roswell Road Northeast 4600, Sandy Springs, GA, 30342",
    "phone": "678-954-5294",
    "hours": "Call for hours",
    "lat": 33.87971,
    "lng": -84.3809
  },
  {
    "id": "18614",
    "name": "SPROUTS",
    "address": "Highway 111 74895, Indian Wells, CA, 92210",
    "phone": "442-305-5258",
    "hours": "Call for hours",
    "lat": 33.72058,
    "lng": -116.359
  },
  {
    "id": "18613",
    "name": "SPROUTS",
    "address": "Atlantic Avenue 7925, Cudahy, CA, 90201",
    "phone": "213-259-2223",
    "hours": "Call for hours",
    "lat": 33.96248,
    "lng": -118.186
  },
  {
    "id": "18612",
    "name": "SPROUTS",
    "address": "Golden Valley Parkway, Lathrop, CA, 95330",
    "phone": "209-670-1663",
    "hours": "Call for hours",
    "lat": 37.82801,
    "lng": -121.295
  },
  {
    "id": "18611",
    "name": "SPROUTS",
    "address": "Pacific Avenue 5308, Stockton, CA, 95207",
    "phone": "209-751-0474",
    "hours": "Call for hours",
    "lat": 37.99775,
    "lng": -121.315
  },
  {
    "id": "18610",
    "name": "SPROUTS",
    "address": "Coleman Avenue 615, San Jose, CA, 95110",
    "phone": "669-444-3186",
    "hours": "Call for hours",
    "lat": 37.34113,
    "lng": -121.909
  },
  {
    "id": "18609",
    "name": "SPROUTS",
    "address": "East Yosemite Avenue 171, Merced, CA, 95340",
    "phone": "209-720-1439",
    "hours": "Call for hours",
    "lat": 37.33221,
    "lng": -120.468
  },
  {
    "id": "18608",
    "name": "SPROUTS",
    "address": "Panama Lane 3535, Bakersfield, CA, 93313",
    "phone": "661-529-3501",
    "hours": "Call for hours",
    "lat": 35.29582,
    "lng": -119.041
  },
  {
    "id": "18607",
    "name": "SPROUTS",
    "address": "15th Street West 43668, Lancaster, CA, 93534",
    "phone": "661-499-2651",
    "hours": "Call for hours",
    "lat": 34.6778,
    "lng": -118.156
  },
  {
    "id": "18606",
    "name": "SPROUTS",
    "address": "Pacific Crest Place Northwest 11066, Silverdale, WA, 98383",
    "phone": "360-900-4125",
    "hours": "Call for hours",
    "lat": 47.66335,
    "lng": -122.694
  },
  {
    "id": "18605",
    "name": "SPROUTS",
    "address": "Aurora Avenue North 13010, Seattle, WA, 98133",
    "phone": "206-337-4625",
    "hours": "Call for hours",
    "lat": 47.72343,
    "lng": -122.345
  },
  {
    "id": "18604",
    "name": "SPROUTS",
    "address": "Bothell-Everett Highway 13314, Mill Creek, WA, 98012",
    "phone": "425-332-6670",
    "hours": "Call for hours",
    "lat": 47.87681,
    "lng": -122.214
  },
  {
    "id": "18603",
    "name": "SPROUTS",
    "address": "Highway 99 19630, Lynnwood, WA, 98036",
    "phone": "425-412-1946",
    "hours": "Call for hours",
    "lat": 47.82079,
    "lng": -122.316
  },
  {
    "id": "18602",
    "name": "SPROUTS",
    "address": "10th Street West 39258, Palmdale, CA, 93551",
    "phone": "661-485-1280",
    "hours": "Call for hours",
    "lat": 34.59623,
    "lng": -118.147
  },
  {
    "id": "18601",
    "name": "SPROUTS",
    "address": "East Main Street 1430, Woodland, CA, 95776",
    "phone": "530-631-7172",
    "hours": "Call for hours",
    "lat": 38.67725,
    "lng": -121.755
  },
  {
    "id": "18600",
    "name": "SPROUTS",
    "address": "Bear Hollow Drive 10846, Rancho Cordova, CA, 95670",
    "phone": "279-278-7553",
    "hours": "Call for hours",
    "lat": 38.57734,
    "lng": -121.282
  },
  {
    "id": "18599",
    "name": "SPROUTS",
    "address": "Alondra Boulevard 11522, Norwalk, CA, 90650",
    "phone": "562-564-5410",
    "hours": "Call for hours",
    "lat": 33.88774,
    "lng": -118.088
  },
  {
    "id": "18598",
    "name": "SPROUTS",
    "address": "South Riverside Avenue 1524, Rialto, CA, 92376",
    "phone": "840-220-4266",
    "hours": "Call for hours",
    "lat": 34.07458,
    "lng": -117.37
  },
  {
    "id": "18597",
    "name": "SPROUTS",
    "address": "Magnolia Street 17950, Fountain Valley, CA, 92708",
    "phone": "657-733-4525",
    "hours": "Call for hours",
    "lat": 33.70221,
    "lng": -117.97
  },
  {
    "id": "18596",
    "name": "SPROUTS",
    "address": "Hemlock Avenue 24101, Moreno Valley, CA, 92557",
    "phone": "951-567-7549",
    "hours": "Call for hours",
    "lat": 33.94259,
    "lng": -117.243
  },
  {
    "id": "18595",
    "name": "SPROUTS",
    "address": "Chapman Avenue 9838, Garden Grove, CA, 92841",
    "phone": "657-427-6713",
    "hours": "Call for hours",
    "lat": 33.78849,
    "lng": -117.961
  },
  {
    "id": "18594",
    "name": "SPROUTS",
    "address": "Newport Road 27281, Menifee, CA, 92584",
    "phone": "951-370-1317",
    "hours": "Call for hours",
    "lat": 33.68495,
    "lng": -117.184
  },
  {
    "id": "18593",
    "name": "SPROUTS",
    "address": "South Milpas Street 29, Santa Barbara, CA, 93103",
    "phone": "805-837-0356",
    "hours": "Call for hours",
    "lat": 34.42137,
    "lng": -119.678
  },
  {
    "id": "18592",
    "name": "SPROUTS",
    "address": "Limonite Avenue 13985, Eastvale, CA, 92880",
    "phone": "909-655-5356",
    "hours": "Call for hours",
    "lat": 33.97644,
    "lng": -117.59
  },
  {
    "id": "18591",
    "name": "SPROUTS",
    "address": "Rockfield Boulevard 24332, Lake Forest, CA, 92630",
    "phone": "949-427-4020",
    "hours": "Call for hours",
    "lat": 33.61572,
    "lng": -117.703
  },
  {
    "id": "18590",
    "name": "SPROUTS",
    "address": "East Workman Avenue, W. Covina, CA, 91791",
    "phone": "626-257-9787",
    "hours": "Call for hours",
    "lat": 34.07584,
    "lng": -117.904
  },
  {
    "id": "18589",
    "name": "SPROUTS",
    "address": "South La Brea Avenue 1302, Los Angeles, CA, 90019",
    "phone": "323-801-7510",
    "hours": "Call for hours",
    "lat": 34.04994,
    "lng": -118.344
  },
  {
    "id": "18588",
    "name": "SPROUTS",
    "address": "Hilltop Drive 1401, Redding, CA, 96003",
    "phone": "530-999-0988",
    "hours": "Call for hours",
    "lat": 40.58791,
    "lng": -122.358
  },
  {
    "id": "18587",
    "name": "SPROUTS",
    "address": "East Vista Way 1400, Vista, CA, 92084",
    "phone": "760-936-4010",
    "hours": "Call for hours",
    "lat": 33.21968,
    "lng": -117.226
  },
  {
    "id": "18586",
    "name": "SPROUTS",
    "address": "Marconi Avenue 2735, Sacramento, CA, 95821",
    "phone": "916-999-3410",
    "hours": "Call for hours",
    "lat": 38.61806,
    "lng": -121.399
  },
  {
    "id": "18585",
    "name": "SPROUTS",
    "address": "East Capitol Expressway 1771, San Jose, CA, 95121",
    "phone": "669-234-5260",
    "hours": "Call for hours",
    "lat": 37.3086,
    "lng": -121.81
  },
  {
    "id": "18584",
    "name": "SPROUTS",
    "address": "Helen Power Drive 1041, Vacaville, CA, 95687",
    "phone": "707-301-4300",
    "hours": "Call for hours",
    "lat": 38.36534,
    "lng": -121.962
  },
  {
    "id": "18583",
    "name": "SPROUTS",
    "address": "East Harney Lane 250, Lodi, CA, 95240",
    "phone": "209-371-6656",
    "hours": "Call for hours",
    "lat": 38.10143,
    "lng": -121.268
  },
  {
    "id": "18582",
    "name": "SPROUTS",
    "address": "Mira Mesa Boulevard 8142, San Diego, CA, 92126",
    "phone": "858-880-0210",
    "hours": "Call for hours",
    "lat": 32.91272,
    "lng": -117.147
  },
  {
    "id": "18581",
    "name": "SPROUTS",
    "address": "South Highland Avenue 16964, Fontana, CA, 92336",
    "phone": "909-320-5360",
    "hours": "Call for hours",
    "lat": 34.13381,
    "lng": -117.434
  },
  {
    "id": "18580",
    "name": "SPROUTS",
    "address": "Ferrari Ranch Road 115, Lincoln, CA, 95648",
    "phone": "916-209-5346",
    "hours": "Call for hours",
    "lat": 38.87424,
    "lng": -121.304
  },
  {
    "id": "18579",
    "name": "SPROUTS",
    "address": "Madonna Road 313, San Luis Obispo, CA, 93405",
    "phone": "805-858-3350",
    "hours": "Call for hours",
    "lat": 35.26114,
    "lng": -120.678
  },
  {
    "id": "18578",
    "name": "SPROUTS",
    "address": "South Street 11900, Cerritos, CA, 90703",
    "phone": "562-274-0602",
    "hours": "Call for hours",
    "lat": 33.85839,
    "lng": -118.079
  },
  {
    "id": "18577",
    "name": "SPROUTS",
    "address": "Jarvis Avenue 6399, Newark, CA, 94560",
    "phone": "510-789-0361",
    "hours": "Call for hours",
    "lat": 37.54794,
    "lng": -122.052
  },
  {
    "id": "18576",
    "name": "SPROUTS",
    "address": "Carnelian Street 6753, Rancho Cucamonga, CA, 91701",
    "phone": "909-296-3094",
    "hours": "Call for hours",
    "lat": 34.13171,
    "lng": -117.616
  },
  {
    "id": "18575",
    "name": "SPROUTS",
    "address": "Del Paso Road 2810, Sacramento, CA, 95834",
    "phone": "916-431-1111",
    "hours": "Call for hours",
    "lat": 38.656,
    "lng": -121.524
  },
  {
    "id": "18574",
    "name": "SPROUTS",
    "address": "West Stuart Avenue 560, Redlands, CA, 92374",
    "phone": "909-283-7162",
    "hours": "Call for hours",
    "lat": 34.06087,
    "lng": -117.189
  },
  {
    "id": "18573",
    "name": "SPROUTS",
    "address": "South Diamond Bar Boulevard 239, Diamond Bar, CA, 91765",
    "phone": "909-378-4980",
    "hours": "Call for hours",
    "lat": 34.02149,
    "lng": -117.81
  },
  {
    "id": "18572",
    "name": "SPROUTS",
    "address": "South State Road 7 820, Wellington, FL, 33414",
    "phone": "561-515-8625",
    "hours": "Call for hours",
    "lat": 26.66567,
    "lng": -80.2008
  },
  {
    "id": "18571",
    "name": "SPROUTS",
    "address": "Las Posas Road 2400, Camarillo, CA, 93010",
    "phone": "805-233-3755",
    "hours": "Call for hours",
    "lat": 34.23675,
    "lng": -119.038
  },
  {
    "id": "18570",
    "name": "SPROUTS",
    "address": "Foothill Boulevard 1375, LaVerne, CA, 91750",
    "phone": "909-582-2836",
    "hours": "Call for hours",
    "lat": 34.1178,
    "lng": -117.778
  },
  {
    "id": "18569",
    "name": "SPROUTS",
    "address": "Clairemont Drive 3015, San Diego, CA, 92117",
    "phone": "619-764-6015",
    "hours": "Call for hours",
    "lat": 32.79458,
    "lng": -117.194
  },
  {
    "id": "18568",
    "name": "SPROUTS",
    "address": "Gateway Road 2634, Carlsbad, CA, 92009",
    "phone": "760-827-8916",
    "hours": "Call for hours",
    "lat": 33.12758,
    "lng": -117.255
  },
  {
    "id": "18567",
    "name": "SPROUTS",
    "address": "Telephone Road 4870, Ventura, CA, 93003",
    "phone": "805-941-4013",
    "hours": "Call for hours",
    "lat": 34.26338,
    "lng": -119.226
  },
  {
    "id": "18566",
    "name": "SPROUTS",
    "address": "East Bidwell Street 905, Folsom, CA, 95630",
    "phone": "916-605-7050",
    "hours": "Call for hours",
    "lat": 38.66953,
    "lng": -121.155
  },
  {
    "id": "18565",
    "name": "SPROUTS",
    "address": "Cochran Street 2800, Simi Valley, CA, 93065",
    "phone": "805-422-3363",
    "hours": "Call for hours",
    "lat": 34.27892,
    "lng": -118.742
  },
  {
    "id": "18564",
    "name": "SPROUTS",
    "address": "North Fairview Avenue 175, Goleta, CA, 93117",
    "phone": "805-979-9589",
    "hours": "Call for hours",
    "lat": 34.44259,
    "lng": -119.831
  },
  {
    "id": "18563",
    "name": "SPROUTS",
    "address": "Venice Boulevard 8985, Los Angeles, CA, 90034",
    "phone": "424-361-6611",
    "hours": "Call for hours",
    "lat": 34.02711,
    "lng": -118.393
  },
  {
    "id": "18562",
    "name": "SPROUTS",
    "address": "South Grand Avenue 655, Glendora, CA, 91740",
    "phone": "626-250-6625",
    "hours": "Call for hours",
    "lat": 34.12619,
    "lng": -117.873
  },
  {
    "id": "18561",
    "name": "SPROUTS",
    "address": "Paseo del Sur 16415, San Diego, CA, 92127",
    "phone": "858-798-8232",
    "hours": "Call for hours",
    "lat": 33.01989,
    "lng": -117.124
  },
  {
    "id": "18560",
    "name": "SPROUTS",
    "address": "Douglas Boulevard 2030, Roseville, CA, 95661",
    "phone": "916-462-5047",
    "hours": "Call for hours",
    "lat": 38.7442,
    "lng": -121.25
  },
  {
    "id": "18559",
    "name": "SPROUTS",
    "address": "East Main Street 150, Alhambra, CA, 91801",
    "phone": "626-863-1096",
    "hours": "Call for hours",
    "lat": 34.09542,
    "lng": -118.125
  },
  {
    "id": "18558",
    "name": "SPROUTS",
    "address": "East Brokaw Road 1028, San Jose, CA, 95131",
    "phone": "408-490-3041",
    "hours": "Call for hours",
    "lat": 37.3827,
    "lng": -121.897
  },
  {
    "id": "18557",
    "name": "SPROUTS",
    "address": "Herndon Avenue 850, Clovis, CA, 93612",
    "phone": "559-326-1169",
    "hours": "Call for hours",
    "lat": 36.83731,
    "lng": -119.699
  },
  {
    "id": "18556",
    "name": "SPROUTS",
    "address": "Sand Creek Road 2325, Brentwood, CA, 94513",
    "phone": "925-308-1965",
    "hours": "Call for hours",
    "lat": 37.94358,
    "lng": -121.735
  },
  {
    "id": "18555",
    "name": "SPROUTS",
    "address": "Yosemite Drive 2245, Eagle Rock, CA, 90041",
    "phone": "323-423-1128",
    "hours": "Call for hours",
    "lat": 34.13542,
    "lng": -118.216
  },
  {
    "id": "18554",
    "name": "SPROUTS",
    "address": "Pinole Valley Road 1300, Pinole, CA, 94564",
    "phone": "510-640-8111",
    "hours": "Call for hours",
    "lat": 37.99961,
    "lng": -122.287
  },
  {
    "id": "18553",
    "name": "SPROUTS",
    "address": "South Nevada Avenue 1720, Colorado Springs, CO, 80905",
    "phone": "719-719-1957",
    "hours": "Call for hours",
    "lat": 38.80935,
    "lng": -104.822
  },
  {
    "id": "18552",
    "name": "SPROUTS",
    "address": "Tower Road 5670, Denver, CO, 80249",
    "phone": "720-850-5026",
    "hours": "Call for hours",
    "lat": 39.79956,
    "lng": -104.772
  },
  {
    "id": "18551",
    "name": "SPROUTS",
    "address": "North Central Park Boulevard 3555, Denver, CO, 80238",
    "phone": "720-780-6422",
    "hours": "Call for hours",
    "lat": 39.76634,
    "lng": -104.891
  },
  {
    "id": "18550",
    "name": "SPROUTS",
    "address": "West 64th Avenue 15050, Arvada, CO, 80007",
    "phone": "303-801-4570",
    "hours": "Call for hours",
    "lat": 39.81257,
    "lng": -105.168
  },
  {
    "id": "18549",
    "name": "SPROUTS",
    "address": "Barnes Road 5617, Colorado Springs, CO, 80917",
    "phone": "719-313-4405",
    "hours": "Call for hours",
    "lat": 38.8942,
    "lng": -104.723
  },
  {
    "id": "18548",
    "name": "SPROUTS",
    "address": "North Lincoln Avenue 1440, Loveland, CO, 80538",
    "phone": "970-800-5607",
    "hours": "Call for hours",
    "lat": 40.4077,
    "lng": -105.073
  },
  {
    "id": "18547",
    "name": "SPROUTS",
    "address": "Voyager Parkway 13415, Colorado Springs, CO, 80921",
    "phone": "719-884-7900",
    "hours": "Call for hours",
    "lat": 39.02658,
    "lng": -104.814
  },
  {
    "id": "18546",
    "name": "SPROUTS",
    "address": "East Mississippi Avenue 197, Denver, CO, 80209",
    "phone": "720-458-2873",
    "hours": "Call for hours",
    "lat": 39.69671,
    "lng": -104.985
  },
  {
    "id": "18545",
    "name": "SPROUTS",
    "address": "Wadsworth Boulevard 98, Lakewood, CO, 80226",
    "phone": "303-957-9276",
    "hours": "Call for hours",
    "lat": 39.71833,
    "lng": -105.081
  },
  {
    "id": "18544",
    "name": "SPROUTS",
    "address": "Kipling Street 3725, Wheat Ridge, CO, 80033",
    "phone": "720-305-0219",
    "hours": "Call for hours",
    "lat": 39.76836,
    "lng": -105.11
  },
  {
    "id": "18543",
    "name": "SPROUTS",
    "address": "South Broadway 5001, Englewood, CO, 80113",
    "phone": "720-612-6595",
    "hours": "Call for hours",
    "lat": 39.62586,
    "lng": -104.988
  },
  {
    "id": "18542",
    "name": "SPROUTS",
    "address": "West Independent Avenue 1450, Grand Junction, CO, 81505",
    "phone": "970-549-3001",
    "hours": "Call for hours",
    "lat": 39.08017,
    "lng": -108.587
  },
  {
    "id": "18541",
    "name": "SPROUTS",
    "address": "South Hover Street 1101, Longmont, CO, 80501",
    "phone": "303-834-4124",
    "hours": "Call for hours",
    "lat": 40.14822,
    "lng": -105.131
  },
  {
    "id": "18540",
    "name": "SPROUTS",
    "address": "East Colfax Avenue 3625, Denver, CO, 80206",
    "phone": "720-347-4205",
    "hours": "Call for hours",
    "lat": 39.74024,
    "lng": -104.945
  },
  {
    "id": "18539",
    "name": "SPROUTS",
    "address": "East 120th Avenue 1131, Thornton, CO, 80233",
    "phone": "303-457-3600",
    "hours": "Call for hours",
    "lat": 39.91685,
    "lng": -104.973
  },
  {
    "id": "18538",
    "name": "SPROUTS",
    "address": "West Cross Drive 8601, Littleton, CO, 80123",
    "phone": "720-214-0410",
    "hours": "Call for hours",
    "lat": 39.6148,
    "lng": -105.096
  },
  {
    "id": "18537",
    "name": "SPROUTS",
    "address": "West South Boulder Road 555, Lafayette, CO, 80026",
    "phone": "303-664-1902",
    "hours": "Call for hours",
    "lat": 39.98875,
    "lng": -105.096
  },
  {
    "id": "18536",
    "name": "SPROUTS",
    "address": "East County Line Road 1980, Highlands Ranch, CO, 80126",
    "phone": "303-243-5060",
    "hours": "Call for hours",
    "lat": 39.56602,
    "lng": -104.965
  },
  {
    "id": "18535",
    "name": "SPROUTS",
    "address": "East Briarwood Circle 15405, Aurora, CO, 80016",
    "phone": "303-690-4600",
    "hours": "Call for hours",
    "lat": 39.59397,
    "lng": -104.809
  },
  {
    "id": "18534",
    "name": "SPROUTS",
    "address": "East Arapahoe Road 8557, Greenwood Village, CO, 80112",
    "phone": "303-721-1400",
    "hours": "Call for hours",
    "lat": 39.59504,
    "lng": -104.889
  },
  {
    "id": "18533",
    "name": "SPROUTS",
    "address": "South Lemay Avenue 2601, Fort Collins, CO, 80525",
    "phone": "970-282-8003",
    "hours": "Call for hours",
    "lat": 40.55185,
    "lng": -105.06
  },
  {
    "id": "18532",
    "name": "SPROUTS",
    "address": "South Colorado Boulevard 2880, Denver, CO, 80222",
    "phone": "303-758-4400",
    "hours": "Call for hours",
    "lat": 39.66465,
    "lng": -104.941
  },
  {
    "id": "18531",
    "name": "SPROUTS",
    "address": "West 38th Avenue 4700, Denver, CO, 80212",
    "phone": "303-433-2350",
    "hours": "Call for hours",
    "lat": 39.76928,
    "lng": -105.048
  },
  {
    "id": "18530",
    "name": "SPROUTS",
    "address": "Dublin Boulevard 1730, Colorado Springs, CO, 80918",
    "phone": "719-590-8890",
    "hours": "Call for hours",
    "lat": 38.9258,
    "lng": -104.794
  },
  {
    "id": "18529",
    "name": "SPROUTS",
    "address": "Arapahoe Avenue 2525, Boulder, CO, 80302",
    "phone": "303-449-0777",
    "hours": "Call for hours",
    "lat": 40.01523,
    "lng": -105.262
  },
  {
    "id": "18528",
    "name": "SPROUTS",
    "address": "Wadsworth Boulevard 7725, Arvada, CO, 80003",
    "phone": "303-463-4828",
    "hours": "Call for hours",
    "lat": 39.83742,
    "lng": -105.082
  },
  {
    "id": "18527",
    "name": "SPROUTS",
    "address": "Commons Street 10018, Lone Tree, CO, 80124",
    "phone": "720-279-6616",
    "hours": "Call for hours",
    "lat": 39.53419,
    "lng": -104.88
  },
  {
    "id": "18526",
    "name": "SPROUTS",
    "address": "West 29th Street, Greeley, CO, 80634",
    "phone": "970-576-3050",
    "hours": "Call for hours",
    "lat": 40.39005,
    "lng": -104.788
  },
  {
    "id": "18525",
    "name": "SPROUTS",
    "address": "Allen Way 5650, Castle Rock, CO, 80108",
    "phone": "720-305-0684",
    "hours": "Call for hours",
    "lat": 39.41524,
    "lng": -104.864
  },
  {
    "id": "18524",
    "name": "SPROUTS",
    "address": "East Smoky Hill Road 20831, Centennial, CO, 80015",
    "phone": "720-305-0959",
    "hours": "Call for hours",
    "lat": 39.60824,
    "lng": -104.746
  },
  {
    "id": "18523",
    "name": "SPROUTS",
    "address": "South Ironton Street 1150, Aurora, CO, 80012",
    "phone": "720-278-2008",
    "hours": "Call for hours",
    "lat": 39.696,
    "lng": -104.863
  },
  {
    "id": "18522",
    "name": "SPROUTS",
    "address": "Baseline Road 2950, Boulder, CO, 80303",
    "phone": "720-279-6758",
    "hours": "Call for hours",
    "lat": 39.9997,
    "lng": -105.254
  },
  {
    "id": "18521",
    "name": "SPROUTS",
    "address": "Corbett Drive 4345, Fort Collins, CO, 80525",
    "phone": "970-416-3350",
    "hours": "Call for hours",
    "lat": 40.52662,
    "lng": -105.027
  },
  {
    "id": "18520",
    "name": "SPROUTS",
    "address": "South Parker Road 9751, Parker, CO, 80134",
    "phone": "720-475-8684",
    "hours": "Call for hours",
    "lat": 39.50647,
    "lng": -104.763
  },
  {
    "id": "18519",
    "name": "SPROUTS",
    "address": "West 120th Avenue 5150, Westminster, CO, 80020",
    "phone": "303-803-1010",
    "hours": "Call for hours",
    "lat": 39.91431,
    "lng": -105.052
  },
  {
    "id": "18518",
    "name": "SPROUTS",
    "address": "Camino de Estrella 550, San Clemente, CA, 92672",
    "phone": "949-542-1036",
    "hours": "Call for hours",
    "lat": 33.4568,
    "lng": -117.656
  },
  {
    "id": "18517",
    "name": "SPROUTS",
    "address": "Irwin Street 655, San Rafael, CA, 94901",
    "phone": "415-524-1159",
    "hours": "Call for hours",
    "lat": 37.96783,
    "lng": -122.522
  },
  {
    "id": "18516",
    "name": "SPROUTS",
    "address": "West Imperial Highway 1431, La Habra, CA, 90631",
    "phone": "562-265-2151",
    "hours": "Call for hours",
    "lat": 33.91726,
    "lng": -117.967
  },
  {
    "id": "18515",
    "name": "SPROUTS",
    "address": "North La Brea Avenue 915, Los Angeles, CA, 90038",
    "phone": "323-217-1642",
    "hours": "Call for hours",
    "lat": 34.08742,
    "lng": -118.344
  },
  {
    "id": "18514",
    "name": "SPROUTS",
    "address": "Monroe Street 1075, Albany, CA, 94706",
    "phone": "510-345-0461",
    "hours": "Call for hours",
    "lat": 37.88436,
    "lng": -122.298
  },
  {
    "id": "18513",
    "name": "SPROUTS",
    "address": "El Camino Real 2060, Santa Clara, CA, 95050",
    "phone": "408-780-7248",
    "hours": "Call for hours",
    "lat": 37.35219,
    "lng": -121.961
  },
  {
    "id": "18512",
    "name": "SPROUTS",
    "address": "West Foothill Boulevard 847, Upland, CA, 91786",
    "phone": "909-912-1461",
    "hours": "Call for hours",
    "lat": 34.10706,
    "lng": -117.662
  },
  {
    "id": "18511",
    "name": "SPROUTS",
    "address": "Stockdale Highway 10650, Bakersfield, CA, 93311",
    "phone": "661-617-8957",
    "hours": "Call for hours",
    "lat": 35.35227,
    "lng": -119.118
  },
  {
    "id": "18510",
    "name": "SPROUTS",
    "address": "Broadway 3035, Oakland, CA, 94611",
    "phone": "510-851-7688",
    "hours": "Call for hours",
    "lat": 37.81897,
    "lng": -122.262
  },
  {
    "id": "18509",
    "name": "SPROUTS",
    "address": "Crow Canyon Place 3181, San Ramon, CA, 94583",
    "phone": "925-302-1395",
    "hours": "Call for hours",
    "lat": 37.77761,
    "lng": -121.971
  },
  {
    "id": "18508",
    "name": "SPROUTS",
    "address": "Warner Avenue 6942, Huntington Beach, CA, 92647",
    "phone": "714-369-1160",
    "hours": "Call for hours",
    "lat": 33.71539,
    "lng": -118.008
  },
  {
    "id": "18507",
    "name": "SPROUTS",
    "address": "Gellert Boulevard 301, Daly City, CA, 94015",
    "phone": "415-325-1091",
    "hours": "Call for hours",
    "lat": 37.664,
    "lng": -122.469
  },
  {
    "id": "18506",
    "name": "SPROUTS",
    "address": "Westwood Boulevard 1751, Los Angeles, CA, 90024",
    "phone": "310-500-1192",
    "hours": "Call for hours",
    "lat": 34.05078,
    "lng": -118.438
  },
  {
    "id": "18505",
    "name": "SPROUTS",
    "address": "Kenilworth Drive 401, Petaluma, CA, 94952",
    "phone": "707-789-4976",
    "hours": "Call for hours",
    "lat": 38.24449,
    "lng": -122.628
  },
  {
    "id": "18504",
    "name": "SPROUTS",
    "address": "North Blackstone Avenue 7477, Fresno, CA, 93720",
    "phone": "559-256-1735",
    "hours": "Call for hours",
    "lat": 36.84483,
    "lng": -119.793
  },
  {
    "id": "18503",
    "name": "SPROUTS",
    "address": "Fallbrook Avenue 6607, West Hills, CA, 91307",
    "phone": "818-867-2104",
    "hours": "Call for hours",
    "lat": 34.19006,
    "lng": -118.623
  },
  {
    "id": "18502",
    "name": "SPROUTS",
    "address": "Branham Lane 1130, San Jose, CA, 95118",
    "phone": "408-833-1152",
    "hours": "Call for hours",
    "lat": 37.26271,
    "lng": -121.878
  },
  {
    "id": "18501",
    "name": "SPROUTS",
    "address": "Prospect Road 5205, San Jose, CA, 95129",
    "phone": "408-725-3970",
    "hours": "Call for hours",
    "lat": 37.2929,
    "lng": -121.993
  },
  {
    "id": "18500",
    "name": "SPROUTS",
    "address": "Del Rio Road 4408, Roseville, CA, 95822",
    "phone": "916-455-4200",
    "hours": "Call for hours",
    "lat": 38.53726,
    "lng": -121.504
  },
  {
    "id": "18499",
    "name": "SPROUTS",
    "address": "Roseville Square 424, Roseville, CA, 95678",
    "phone": "916-960-1201",
    "hours": "Call for hours",
    "lat": 38.74488,
    "lng": -121.276
  },
  {
    "id": "18498",
    "name": "SPROUTS",
    "address": "McHenry Avenue 1700, Modesto, CA, 95350",
    "phone": "209-527-7575",
    "hours": "Call for hours",
    "lat": 37.6702,
    "lng": -120.994
  },
  {
    "id": "18497",
    "name": "SPROUTS",
    "address": "Whittier Boulevard 15801, Whittier, CA, 90603",
    "phone": "562-265-2109",
    "hours": "Call for hours",
    "lat": 33.94376,
    "lng": -117.992
  },
  {
    "id": "18496",
    "name": "SPROUTS",
    "address": "Greenback Lane 7905, Citrus Heights, CA, 95610",
    "phone": "916-560-2000",
    "hours": "Call for hours",
    "lat": 38.67851,
    "lng": -121.271
  },
  {
    "id": "18495",
    "name": "SPROUTS",
    "address": "Old Canal Road 22401, Yorba Linda, CA, 92887",
    "phone": "714-464-1824",
    "hours": "Call for hours",
    "lat": 33.87308,
    "lng": -117.746
  },
  {
    "id": "18494",
    "name": "SPROUTS",
    "address": "Foothill Boulevard 920, La Canada Flintridge, CA, 91011",
    "phone": "818-495-1103",
    "hours": "Call for hours",
    "lat": 34.20363,
    "lng": -118.199
  },
  {
    "id": "18493",
    "name": "SPROUTS",
    "address": "Woodruff Avenue 4253, Lakewood, CA, 90713",
    "phone": "562-739-2541",
    "hours": "Call for hours",
    "lat": 33.8348,
    "lng": -118.117
  },
  {
    "id": "18492",
    "name": "SPROUTS",
    "address": "Geary Road 1530, Walnut Creek, CA, 94597",
    "phone": "925-953-1113",
    "hours": "Call for hours",
    "lat": 37.92648,
    "lng": -122.065
  },
  {
    "id": "18491",
    "name": "SPROUTS",
    "address": "East 17th Street 225, Costa Mesa, CA, 92627",
    "phone": "949-698-1094",
    "hours": "Call for hours",
    "lat": 33.63408,
    "lng": -117.919
  },
  {
    "id": "18490",
    "name": "SPROUTS",
    "address": "West Huntington Drive 400, Monrovia, CA, 91016",
    "phone": "626-358-6845",
    "hours": "Call for hours",
    "lat": 34.14022,
    "lng": -118.008
  },
  {
    "id": "18489",
    "name": "SPROUTS",
    "address": "El Camino Real 3011, Tustin, CA, 92782",
    "phone": "714-734-8760",
    "hours": "Call for hours",
    "lat": 33.72278,
    "lng": -117.793
  },
  {
    "id": "18488",
    "name": "SPROUTS",
    "address": "Ventura Boulevard 21821, Woodland Hills, CA, 91364",
    "phone": "818-887-6473",
    "hours": "Call for hours",
    "lat": 34.1685,
    "lng": -118.603
  },
  {
    "id": "18487",
    "name": "SPROUTS",
    "address": "Mission Gorge Road 9361, Santee, CA, 92071",
    "phone": "619-562-0145",
    "hours": "Call for hours",
    "lat": 32.83859,
    "lng": -116.995
  },
  {
    "id": "18486",
    "name": "SPROUTS",
    "address": "West 13th Avenue 510, Escondido, CA, 92025",
    "phone": "760-743-1528",
    "hours": "Call for hours",
    "lat": 33.10803,
    "lng": -117.08
  },
  {
    "id": "18485",
    "name": "SPROUTS",
    "address": "North Western Avenue 820, San Pedro, CA, 90732",
    "phone": "310-831-7836",
    "hours": "Call for hours",
    "lat": 33.75036,
    "lng": -118.309
  },
  {
    "id": "18484",
    "name": "SPROUTS",
    "address": "Winchester Road 39606, Temecula, CA, 92591",
    "phone": "951-694-3680",
    "hours": "Call for hours",
    "lat": 33.54058,
    "lng": -117.144
  },
  {
    "id": "18483",
    "name": "SPROUTS",
    "address": "College Boulevard 471, Oceanside, CA, 92057",
    "phone": "760-726-7274",
    "hours": "Call for hours",
    "lat": 33.24943,
    "lng": -117.296
  },
  {
    "id": "18482",
    "name": "SPROUTS",
    "address": "Bernardo Heights Parkway 15727, San Diego, CA, 92128",
    "phone": "858-385-1606",
    "hours": "Call for hours",
    "lat": 33.00341,
    "lng": -117.059
  },
  {
    "id": "18481",
    "name": "SPROUTS",
    "address": "Hwy 79 South 32413, Temecula, CA, 92592",
    "phone": "951-303-0087",
    "hours": "Call for hours",
    "lat": 33.48099,
    "lng": -117.092
  },
  {
    "id": "18480",
    "name": "SPROUTS",
    "address": "Camino de Los Coches 3243, Carlsbad, CA, 92009",
    "phone": "760-635-0625",
    "hours": "Call for hours",
    "lat": 33.07572,
    "lng": -117.237
  },
  {
    "id": "18479",
    "name": "SPROUTS",
    "address": "Highway 111 79050, La Quinta, CA, 92253",
    "phone": "760-771-2485",
    "hours": "Call for hours",
    "lat": 33.7083,
    "lng": -116.285
  },
  {
    "id": "18478",
    "name": "SPROUTS",
    "address": "Day Creek Boulevard 7355, Rancho Cucamonga, CA, 91739",
    "phone": "909-803-5730",
    "hours": "Call for hours",
    "lat": 34.12063,
    "lng": -117.537
  },
  {
    "id": "18477",
    "name": "SPROUTS",
    "address": "South Harbor Boulevard 1447, Fullerton, CA, 92832",
    "phone": "714-441-1233",
    "hours": "Call for hours",
    "lat": 33.85588,
    "lng": -117.924
  },
  {
    "id": "18476",
    "name": "SPROUTS",
    "address": "West Ontario Avenue 120, Corona, CA, 92882",
    "phone": "951-371-4227",
    "hours": "Call for hours",
    "lat": 33.85632,
    "lng": -117.57
  },
  {
    "id": "18475",
    "name": "SPROUTS",
    "address": "Santa Margarita Parkway 27765, Mission Viejo, CA, 92691",
    "phone": "949-587-3003",
    "hours": "Call for hours",
    "lat": 33.65239,
    "lng": -117.646
  },
  {
    "id": "18474",
    "name": "SPROUTS",
    "address": "Grand Avenue 3630, Chino Hills, CA, 91709",
    "phone": "909-548-0440",
    "hours": "Call for hours",
    "lat": 34.00301,
    "lng": -117.727
  },
  {
    "id": "18473",
    "name": "SPROUTS",
    "address": "Harbor Boulevard 3030, Costa Mesa, CA, 92626",
    "phone": "714-751-6399",
    "hours": "Call for hours",
    "lat": 33.68174,
    "lng": -117.919
  },
  {
    "id": "18472",
    "name": "SPROUTS",
    "address": "El Camino Real 2618, Carlsbad, CA, 92008",
    "phone": "760-730-1123",
    "hours": "Call for hours",
    "lat": 33.17723,
    "lng": -117.326
  },
  {
    "id": "18471",
    "name": "SPROUTS",
    "address": "Yorba Linda Boulevard 17482, Yorba Linda, CA, 92886",
    "phone": "714-572-3535",
    "hours": "Call for hours",
    "lat": 33.88861,
    "lng": -117.827
  },
  {
    "id": "18470",
    "name": "SPROUTS",
    "address": "La Paz Road 27271, Laguna Niguel, CA, 92677",
    "phone": "949-349-1999",
    "hours": "Call for hours",
    "lat": 33.56741,
    "lng": -117.708
  },
  {
    "id": "18469",
    "name": "SPROUTS",
    "address": "North San Fernando Boulevard 1011, Burbank, CA, 91504",
    "phone": "818-566-4089",
    "hours": "Call for hours",
    "lat": 34.18805,
    "lng": -118.319
  },
  {
    "id": "18468",
    "name": "SPROUTS",
    "address": "West Florida Avenue 2207, Hemet, CA, 92545",
    "phone": "951-537-1975",
    "hours": "Call for hours",
    "lat": 33.74735,
    "lng": -116.995
  },
  {
    "id": "18467",
    "name": "SPROUTS",
    "address": "Genesee Avenue 4439, San Diego, CA, 92117",
    "phone": "858-268-2400",
    "hours": "Call for hours",
    "lat": 32.82409,
    "lng": -117.184
  },
  {
    "id": "18466",
    "name": "SPROUTS",
    "address": "Lemon Grove Avenue 3205, Lemon Grove, CA, 91945",
    "phone": "619-667-8686",
    "hours": "Call for hours",
    "lat": 32.74116,
    "lng": -117.03
  },
  {
    "id": "18465",
    "name": "SPROUTS",
    "address": "Governor Drive 3358, San Diego, CA, 92122",
    "phone": "858-457-5006",
    "hours": "Call for hours",
    "lat": 32.85091,
    "lng": -117.214
  },
  {
    "id": "18464",
    "name": "SPROUTS",
    "address": "Santa Monica Boulevard 8550, W. Hollywood, CA, 90069",
    "phone": "323-603-2599",
    "hours": "Call for hours",
    "lat": 34.0897,
    "lng": -118.376
  },
  {
    "id": "18463",
    "name": "SPROUTS",
    "address": "Lomas Santa Fe Drive 931, Solana Beach, CA, 92075",
    "phone": "858-350-7900",
    "hours": "Call for hours",
    "lat": 32.99413,
    "lng": -117.254
  },
  {
    "id": "18462",
    "name": "SPROUTS",
    "address": "Stevens Creek Boulevard 20558, Cupertino, CA, 95014",
    "phone": "408-780-7748",
    "hours": "Call for hours",
    "lat": 37.32272,
    "lng": -122.033
  },
  {
    "id": "18461",
    "name": "SPROUTS",
    "address": "Laguna Boulevard 8211, Elk Grove, CA, 95758",
    "phone": "916-478-9595",
    "hours": "Call for hours",
    "lat": 38.42219,
    "lng": -121.403
  },
  {
    "id": "18460",
    "name": "SPROUTS",
    "address": "Poway Road 13536, Poway, CA, 92064",
    "phone": "858-486-7851",
    "hours": "Call for hours",
    "lat": 32.95712,
    "lng": -117.037
  },
  {
    "id": "18459",
    "name": "SPROUTS",
    "address": "Rosecrans Street 3315, San Diego, CA, 92110",
    "phone": "619-523-3640",
    "hours": "Call for hours",
    "lat": 32.74857,
    "lng": -117.207
  },
  {
    "id": "18458",
    "name": "SPROUTS",
    "address": "Garnet Avenue 1260, San Diego, CA, 92109",
    "phone": "858-270-8200",
    "hours": "Call for hours",
    "lat": 32.79879,
    "lng": -117.247
  },
  {
    "id": "18457",
    "name": "SPROUTS",
    "address": "Park Boulevard 4175, San Diego, CA, 92103",
    "phone": "619-291-8287",
    "hours": "Call for hours",
    "lat": 32.75346,
    "lng": -117.146
  },
  {
    "id": "18456",
    "name": "SPROUTS",
    "address": "Palm Avenue 4630, La Mesa, CA, 91941",
    "phone": "619-460-7722",
    "hours": "Call for hours",
    "lat": 32.76284,
    "lng": -117.018
  },
  {
    "id": "18455",
    "name": "SPROUTS",
    "address": "Encinitas Boulevard 1327, Encinitas, CA, 92024",
    "phone": "760-633-4747",
    "hours": "Call for hours",
    "lat": 33.04459,
    "lng": -117.261
  },
  {
    "id": "18454",
    "name": "SPROUTS",
    "address": "North Zelzah Avenue 10821, Granada Hills, CA, 91344",
    "phone": "818-366-0717",
    "hours": "Call for hours",
    "lat": 34.26672,
    "lng": -118.524
  },
  {
    "id": "18453",
    "name": "SPROUTS",
    "address": "Hawthorne Boulevard 1515, Redondo Beach, CA, 90278",
    "phone": "424-903-7028",
    "hours": "Call for hours",
    "lat": 33.86879,
    "lng": -118.353
  },
  {
    "id": "18452",
    "name": "SPROUTS",
    "address": "Amador Plaza Road 7153, Dublin, CA, 94568",
    "phone": "925-307-1172",
    "hours": "Call for hours",
    "lat": 37.70745,
    "lng": -121.929
  },
  {
    "id": "18451",
    "name": "SPROUTS",
    "address": "South Westlake Boulevard 1012, Westlake, CA, 91361",
    "phone": "805-917-4200",
    "hours": "Call for hours",
    "lat": 34.1532,
    "lng": -118.828
  },
  {
    "id": "18450",
    "name": "SPROUTS",
    "address": "Stanford Ranch Road 6760, Roseville, CA, 95678",
    "phone": "916-774-1120",
    "hours": "Call for hours",
    "lat": 38.78036,
    "lng": -121.269
  },
  {
    "id": "18449",
    "name": "SPROUTS",
    "address": "Magic Mountain Parkway 24285, Valencia, CA, 91355",
    "phone": "661-414-1109",
    "hours": "Call for hours",
    "lat": 34.42017,
    "lng": -118.559
  },
  {
    "id": "18448",
    "name": "SPROUTS",
    "address": "North Rosemead Boulevard 39, Pasadena, CA, 91107",
    "phone": "626-696-1290",
    "hours": "Call for hours",
    "lat": 34.14718,
    "lng": -118.074
  },
  {
    "id": "18447",
    "name": "SPROUTS",
    "address": "San Antonio Road 630, Mountain View, CA, 94040",
    "phone": "650-397-3001",
    "hours": "Call for hours",
    "lat": 37.40205,
    "lng": -122.113
  },
  {
    "id": "18446",
    "name": "SPROUTS",
    "address": "East El Camino Real 111, Sunnyvale, CA, 94087",
    "phone": "408-702-1172",
    "hours": "Call for hours",
    "lat": 37.36746,
    "lng": -122.03
  },
  {
    "id": "18445",
    "name": "SPROUTS",
    "address": "Sepulveda Boulevard 5660, Culver City, CA, 90230",
    "phone": "310-591-1028",
    "hours": "Call for hours",
    "lat": 33.98926,
    "lng": -118.395
  },
  {
    "id": "18444",
    "name": "SPROUTS",
    "address": "Mowry Avenue 3900, Fremont, CA, 94538",
    "phone": "510-284-1050",
    "hours": "Call for hours",
    "lat": 37.54926,
    "lng": -121.988
  },
  {
    "id": "18443",
    "name": "SPROUTS",
    "address": "West Hillcrest Drive 600, Thousand Oaks, CA, 91360",
    "phone": "805-716-4373",
    "hours": "Call for hours",
    "lat": 34.18616,
    "lng": -118.887
  },
  {
    "id": "18442",
    "name": "SPROUTS",
    "address": "Carmel Mountain Road 11710, San Diego, CA, 92128",
    "phone": "858-798-7200",
    "hours": "Call for hours",
    "lat": 32.97958,
    "lng": -117.08
  },
  {
    "id": "18441",
    "name": "SPROUTS",
    "address": "Adams Avenue 9861, Huntington Beach, CA, 92646",
    "phone": "714-369-1139",
    "hours": "Call for hours",
    "lat": 33.67218,
    "lng": -117.96
  },
  {
    "id": "18440",
    "name": "SPROUTS",
    "address": "East Village Way 1500, Orange, CA, 92865",
    "phone": "714-464-1060",
    "hours": "Call for hours",
    "lat": 33.82619,
    "lng": -117.838
  },
  {
    "id": "18439",
    "name": "SPROUTS",
    "address": "Alessandro Boulevard 475, Riverside, CA, 92508",
    "phone": "951-565-5400",
    "hours": "Call for hours",
    "lat": 33.91416,
    "lng": -117.323
  },
  {
    "id": "18438",
    "name": "SPROUTS",
    "address": "East Birch Street 735, Brea, CA, 92821",
    "phone": "714-482-1000",
    "hours": "Call for hours",
    "lat": 33.91787,
    "lng": -117.889
  },
  {
    "id": "18437",
    "name": "SPROUTS",
    "address": "Seal Beach Boulevard 12301, Seal Beach, CA, 90740",
    "phone": "562-794-2125",
    "hours": "Call for hours",
    "lat": 33.78434,
    "lng": -118.072
  },
  {
    "id": "18436",
    "name": "SPROUTS",
    "address": "Holt Avenue 14945, Tustin, CA, 92780",
    "phone": "714-415-4381",
    "hours": "Call for hours",
    "lat": 33.74726,
    "lng": -117.814
  },
  {
    "id": "18435",
    "name": "SPROUTS",
    "address": "Alton Parkway 3775, Irvine, CA, 92606",
    "phone": "949-705-5435",
    "hours": "Call for hours",
    "lat": 33.68243,
    "lng": -117.814
  },
  {
    "id": "18434",
    "name": "SPROUTS",
    "address": "West Foothill Boulevard 835, Claremont, CA, 91711",
    "phone": "909-267-1049",
    "hours": "Call for hours",
    "lat": 34.10757,
    "lng": -117.73
  },
  {
    "id": "18433",
    "name": "SPROUTS",
    "address": "Pacific Coast Highway 4230, Torrance, CA, 90505",
    "phone": "424-903-7062",
    "hours": "Call for hours",
    "lat": 33.80778,
    "lng": -118.358
  },
  {
    "id": "18432",
    "name": "SPROUTS",
    "address": "South Las Posas Road 149, San Marcos, CA, 92078",
    "phone": "760-208-6041",
    "hours": "Call for hours",
    "lat": 33.14334,
    "lng": -117.191
  },
  {
    "id": "18431",
    "name": "SPROUTS",
    "address": "North 2nd Street 152, El Cajon, CA, 92021",
    "phone": "619-579-8251",
    "hours": "Call for hours",
    "lat": 32.79654,
    "lng": -116.936
  },
  {
    "id": "18430",
    "name": "SPROUTS",
    "address": "Nall Avenue 9628, Overland Park, KS, 66207",
    "phone": "913-643-9170",
    "hours": "Call for hours",
    "lat": 38.9547,
    "lng": -94.6491
  },
  {
    "id": "18429",
    "name": "SPROUTS",
    "address": "East Central Avenue 7728, Wichita, KS, 67206",
    "phone": "316-448-5254",
    "hours": "Call for hours",
    "lat": 37.69391,
    "lng": -97.2465
  },
  {
    "id": "18428",
    "name": "SPROUTS",
    "address": "Maurer Road 8550, Lenexa, KS, 66219",
    "phone": "913-312-1586",
    "hours": "Call for hours",
    "lat": 38.97343,
    "lng": -94.7716
  },
  {
    "id": "18427",
    "name": "SPROUTS",
    "address": "Bauer Farm Drive 4740, Lawrence, KS, 66049",
    "phone": "785-727-7314",
    "hours": "Call for hours",
    "lat": 38.97236,
    "lng": -95.3038
  },
  {
    "id": "18426",
    "name": "SPROUTS",
    "address": "West 135th Street 6821, Overland Park, KS, 66223",
    "phone": "913-643-4190",
    "hours": "Call for hours",
    "lat": 38.88366,
    "lng": -94.665
  },
  {
    "id": "18425",
    "name": "SPROUTS",
    "address": "East Interstate 30 469, Rockwall, TX, 75087",
    "phone": "254-269-4011",
    "hours": "Call for hours",
    "lat": 32.89404,
    "lng": -96.4723
  },
  {
    "id": "18424",
    "name": "SPROUTS",
    "address": "Dallas Parkway 17795, Dallas, TX, 75287",
    "phone": "469-865-1876",
    "hours": "Call for hours",
    "lat": 32.99658,
    "lng": -96.829
  },
  {
    "id": "18423",
    "name": "SPROUTS",
    "address": "Barbara Jordan Boulevard 1201, Austin, TX, 78723",
    "phone": "737-301-5648",
    "hours": "Call for hours",
    "lat": 30.3059,
    "lng": -97.7082
  },
  {
    "id": "18422",
    "name": "SPROUTS",
    "address": "State Hwy 151 9702, San Antonio, TX, 78251",
    "phone": "726-227-8068",
    "hours": "Call for hours",
    "lat": 29.44503,
    "lng": -98.673
  },
  {
    "id": "18421",
    "name": "SPROUTS",
    "address": "East Mockingbird Lane 6465, Dallas, TX, 75214",
    "phone": "945-219-3141",
    "hours": "Call for hours",
    "lat": 32.83693,
    "lng": -96.7516
  },
  {
    "id": "18420",
    "name": "SPROUTS",
    "address": "South Carrier Parkway 2500, Grand Prairie, TX, 75052",
    "phone": "469-870-7863",
    "hours": "Call for hours",
    "lat": 32.70788,
    "lng": -97.0161
  },
  {
    "id": "18419",
    "name": "SPROUTS",
    "address": "North MacArthur Boulevard 7730, Irving, TX, 75063",
    "phone": "972-232-7926",
    "hours": "Call for hours",
    "lat": 32.91141,
    "lng": -96.9589
  },
  {
    "id": "18418",
    "name": "SPROUTS",
    "address": "South Broadway Avenue 4015, Tyler, TX, 75701",
    "phone": "903-747-1118",
    "hours": "Call for hours",
    "lat": 32.30582,
    "lng": -95.3008
  },
  {
    "id": "18417",
    "name": "SPROUTS",
    "address": "North Town East Boulevard 1220, Mesquite, TX, 75150",
    "phone": "469-983-2045",
    "hours": "Call for hours",
    "lat": 32.81063,
    "lng": -96.6133
  },
  {
    "id": "18416",
    "name": "SPROUTS",
    "address": "Gateway Boulevard West 9801, El Paso, TX, 79925",
    "phone": "915-444-3585",
    "hours": "Call for hours",
    "lat": 31.76053,
    "lng": -106.357
  },
  {
    "id": "18415",
    "name": "SPROUTS",
    "address": "Eldorado Parkway 2500, Frisco, TX, 75033",
    "phone": "469-731-7261",
    "hours": "Call for hours",
    "lat": 33.17843,
    "lng": -96.87
  },
  {
    "id": "18414",
    "name": "SPROUTS",
    "address": "North Zaragoza Road 2036, El Paso, TX, 79938",
    "phone": "915-218-2954",
    "hours": "Call for hours",
    "lat": 31.76968,
    "lng": -106.259
  },
  {
    "id": "18413",
    "name": "SPROUTS",
    "address": "Skillman Street 7110, Dallas, TX, 75231",
    "phone": "469-210-8166",
    "hours": "Call for hours",
    "lat": 32.87608,
    "lng": -96.735
  },
  {
    "id": "18412",
    "name": "SPROUTS",
    "address": "Teasley Lane 4930, Denton, TX, 76210",
    "phone": "940-999-2263",
    "hours": "Call for hours",
    "lat": 33.1488,
    "lng": -97.1054
  },
  {
    "id": "18411",
    "name": "SPROUTS",
    "address": "West Exchange Parkway 1265, Allen, TX, 75013",
    "phone": "972-521-0057",
    "hours": "Call for hours",
    "lat": 33.11557,
    "lng": -96.6978
  },
  {
    "id": "18410",
    "name": "SPROUTS",
    "address": "Old Chocolate Bayou Road 2718, Pearland, TX, 77584",
    "phone": "713-482-3987",
    "hours": "Call for hours",
    "lat": 29.55876,
    "lng": -95.3478
  },
  {
    "id": "18409",
    "name": "SPROUTS",
    "address": "Lakeview Parkway 3001, Rowlett, TX, 75088",
    "phone": "972-265-0386",
    "hours": "Call for hours",
    "lat": 32.90743,
    "lng": -96.5746
  },
  {
    "id": "18408",
    "name": "SPROUTS",
    "address": "Waverly Way 6300, Fort Worth, TX, 76116",
    "phone": "682-747-5456",
    "hours": "Call for hours",
    "lat": 32.72444,
    "lng": -97.4182
  },
  {
    "id": "18407",
    "name": "SPROUTS",
    "address": "East Debbie Lane 1550, Mansfield, TX, 76063",
    "phone": "682-422-0061",
    "hours": "Call for hours",
    "lat": 32.60605,
    "lng": -97.1131
  },
  {
    "id": "18406",
    "name": "SPROUTS",
    "address": "Grapevine Highway 316, Hurst, TX, 76054",
    "phone": "682-325-5977",
    "hours": "Call for hours",
    "lat": 32.86903,
    "lng": -97.1717
  },
  {
    "id": "18405",
    "name": "SPROUTS",
    "address": "West Interstate 20 5711, Arlington, TX, 76017",
    "phone": "682-587-0086",
    "hours": "Call for hours",
    "lat": 32.67552,
    "lng": -97.1947
  },
  {
    "id": "18404",
    "name": "SPROUTS",
    "address": "Kuykendahl Road 20708, Spring, TX, 77379",
    "phone": "832-764-5424",
    "hours": "Call for hours",
    "lat": 30.07098,
    "lng": -95.5079
  },
  {
    "id": "18403",
    "name": "SPROUTS",
    "address": "South Lakeline Boulevard 1831, Cedar Park, TX, 78613",
    "phone": "512-279-8312",
    "hours": "Call for hours",
    "lat": 30.48098,
    "lng": -97.8296
  },
  {
    "id": "18402",
    "name": "SPROUTS",
    "address": "Yale Street 195, Houston, TX, 77007",
    "phone": "713-395-4590",
    "hours": "Call for hours",
    "lat": 29.77501,
    "lng": -95.4003
  },
  {
    "id": "18401",
    "name": "SPROUTS",
    "address": "S Main 2003, Keller, TX, 76248",
    "phone": "817-380-7024",
    "hours": "Call for hours",
    "lat": 32.89757,
    "lng": -97.2555
  },
  {
    "id": "18400",
    "name": "SPROUTS",
    "address": "Virginia Parkway 9241, McKinney, TX, 75071",
    "phone": "469-481-5000",
    "hours": "Call for hours",
    "lat": 33.2035,
    "lng": -96.7353
  },
  {
    "id": "18399",
    "name": "SPROUTS",
    "address": "North Highway 6 7055, Houston, TX, 77095",
    "phone": "832-575-2201",
    "hours": "Call for hours",
    "lat": 29.8807,
    "lng": -95.6467
  },
  {
    "id": "18398",
    "name": "SPROUTS",
    "address": "Tomball Parkway 22506, Houston, TX, 77070",
    "phone": "832-698-0004",
    "hours": "Call for hours",
    "lat": 30.01185,
    "lng": -95.5875
  },
  {
    "id": "18397",
    "name": "SPROUTS",
    "address": "Cinco Ranch Boulevard 23105, Katy, TX, 77494",
    "phone": "281-769-0444",
    "hours": "Call for hours",
    "lat": 29.74391,
    "lng": -95.7687
  },
  {
    "id": "18396",
    "name": "SPROUTS",
    "address": "North Henderson Avenue 1800, Dallas, TX, 75206",
    "phone": "214-826-2937",
    "hours": "Call for hours",
    "lat": 32.81098,
    "lng": -96.7739
  },
  {
    "id": "18395",
    "name": "SPROUTS",
    "address": "Manchaca Road 6920, Austin, TX, 78745",
    "phone": "512-687-2204",
    "hours": "Call for hours",
    "lat": 30.20247,
    "lng": -97.8082
  },
  {
    "id": "18394",
    "name": "SPROUTS",
    "address": "Quaker Avenue 8201, Lubbock, TX, 79424",
    "phone": "806-794-4900",
    "hours": "Call for hours",
    "lat": 33.51963,
    "lng": -101.905
  },
  {
    "id": "18393",
    "name": "SPROUTS",
    "address": "Bulverde Road 22135, San Antonio, TX, 78259",
    "phone": "210-350-3985",
    "hours": "Call for hours",
    "lat": 29.64661,
    "lng": -98.4278
  },
  {
    "id": "18392",
    "name": "SPROUTS",
    "address": "North 10th Street 5800, McAllen, TX, 78504",
    "phone": "956-331-2123",
    "hours": "Call for hours",
    "lat": 26.25536,
    "lng": -98.2211
  },
  {
    "id": "18391",
    "name": "SPROUTS",
    "address": "Sunland Park Drive 655, El Paso, TX, 79912",
    "phone": "915-833-3380",
    "hours": "Call for hours",
    "lat": 31.82111,
    "lng": -106.54
  },
  {
    "id": "18390",
    "name": "SPROUTS",
    "address": "Airline Road 1440, Corpus Christi, TX, 78412",
    "phone": "361-993-2850",
    "hours": "Call for hours",
    "lat": 27.70584,
    "lng": -97.3626
  },
  {
    "id": "18389",
    "name": "SPROUTS",
    "address": "Callaghan Road 8101, San Antonio, TX, 78230",
    "phone": "210-979-8121",
    "hours": "Call for hours",
    "lat": 29.51279,
    "lng": -98.5511
  },
  {
    "id": "18388",
    "name": "SPROUTS",
    "address": "South Lamar Boulevard 4006, Austin, TX, 78704",
    "phone": "512-444-3079",
    "hours": "Call for hours",
    "lat": 30.23695,
    "lng": -97.7919
  },
  {
    "id": "18387",
    "name": "SPROUTS",
    "address": "East Hebron Parkway 1745, Carrollton, TX, 75010",
    "phone": "972-428-5785",
    "hours": "Call for hours",
    "lat": 33.0248,
    "lng": -96.8875
  },
  {
    "id": "18386",
    "name": "SPROUTS",
    "address": "Southwest Loop 820 4650, Fort Worth, TX, 76109",
    "phone": "682-747-5790",
    "hours": "Call for hours",
    "lat": 32.68188,
    "lng": -97.3941
  },
  {
    "id": "18385",
    "name": "SPROUTS",
    "address": "East FM 1382 362, Cedar Hill, TX, 75104",
    "phone": "972-637-5108",
    "hours": "Call for hours",
    "lat": 32.59422,
    "lng": -96.939
  },
  {
    "id": "18384",
    "name": "SPROUTS",
    "address": "Research Boulevard 10225, Austin, TX, 78759",
    "phone": "512-225-9101",
    "hours": "Call for hours",
    "lat": 30.3946,
    "lng": -97.7447
  },
  {
    "id": "18383",
    "name": "SPROUTS",
    "address": "Bee Caves Road 2805, Rollingwood, TX, 78746",
    "phone": "512-439-5782",
    "hours": "Call for hours",
    "lat": 30.27113,
    "lng": -97.7888
  },
  {
    "id": "18382",
    "name": "SPROUTS",
    "address": "North Interstate 35 110, Round Rock, TX, 78681",
    "phone": "512-334-4684",
    "hours": "Call for hours",
    "lat": 30.50791,
    "lng": -97.6865
  },
  {
    "id": "18381",
    "name": "SPROUTS",
    "address": "Brodie Lane 5601, Sunset Valley, TX, 78745",
    "phone": "512-334-4175",
    "hours": "Call for hours",
    "lat": 30.22689,
    "lng": -97.8213
  },
  {
    "id": "18380",
    "name": "SPROUTS",
    "address": "West Sandy Lake Road 110, Coppell, TX, 75019",
    "phone": "972-350-8051",
    "hours": "Call for hours",
    "lat": 32.96943,
    "lng": -96.994
  },
  {
    "id": "18379",
    "name": "SPROUTS",
    "address": "East Fm 544 207, Murphy, TX, 75094",
    "phone": "972-265-4770",
    "hours": "Call for hours",
    "lat": 33.01331,
    "lng": -96.6083
  },
  {
    "id": "18378",
    "name": "SPROUTS",
    "address": "West Campbell Road 1343, Richardson, TX, 75080",
    "phone": "214-442-5961",
    "hours": "Call for hours",
    "lat": 32.97805,
    "lng": -96.7649
  },
  {
    "id": "18377",
    "name": "SPROUTS",
    "address": "Preston Road 5190, Frisco, TX, 75034",
    "phone": "972-464-5776",
    "hours": "Call for hours",
    "lat": 33.12223,
    "lng": -96.8057
  },
  {
    "id": "18376",
    "name": "SPROUTS",
    "address": "Davis Boulevard 220, Southlake, TX, 76092",
    "phone": "682-223-5805",
    "hours": "Call for hours",
    "lat": 32.93854,
    "lng": -97.1869
  },
  {
    "id": "18375",
    "name": "SPROUTS",
    "address": "Marsh Lane 11722, Dallas, TX, 75229",
    "phone": "214-350-0574",
    "hours": "Call for hours",
    "lat": 32.90839,
    "lng": -96.8526
  },
  {
    "id": "18374",
    "name": "SPROUTS",
    "address": "Cross Timbers Road 2301, Flower Mound, TX, 75028",
    "phone": "972-874-7380",
    "hours": "Call for hours",
    "lat": 33.03487,
    "lng": -97.0639
  },
  {
    "id": "18373",
    "name": "SPROUTS",
    "address": "Legacy Drive 4100, Plano, TX, 75024",
    "phone": "972-618-8902",
    "hours": "Call for hours",
    "lat": 33.07019,
    "lng": -96.7736
  },
  {
    "id": "18372",
    "name": "SPROUTS",
    "address": "North Gantzel Road 37666, Queen Creek, AZ, 85140",
    "phone": "520-614-0304",
    "hours": "Call for hours",
    "lat": 33.22471,
    "lng": -111.563
  },
  {
    "id": "18371",
    "name": "SPROUTS",
    "address": "S Landing Way 4800, Tucson, AZ, 85714",
    "phone": "520-524-0290",
    "hours": "Call for hours",
    "lat": 32.16525,
    "lng": -110.988
  },
  {
    "id": "18370",
    "name": "SPROUTS",
    "address": "North Prasada Parkway 13650, Surprise, AZ, 85388",
    "phone": "480-864-1358",
    "hours": "Call for hours",
    "lat": 33.60834,
    "lng": -112.417
  },
  {
    "id": "18369",
    "name": "SPROUTS",
    "address": "North John Wayne Parkway 20300, Maricopa, AZ, 85139",
    "phone": "520-532-1093",
    "hours": "Call for hours",
    "lat": 33.06437,
    "lng": -112.048
  },
  {
    "id": "18368",
    "name": "SPROUTS",
    "address": "East Carefree Highway 5355, Cave Creek, AZ, 85331",
    "phone": "480-637-4699",
    "hours": "Call for hours",
    "lat": 33.79874,
    "lng": -111.966
  },
  {
    "id": "18367",
    "name": "SPROUTS",
    "address": "South Signal Butte Road 1240, Mesa, AZ, 85209",
    "phone": "480-586-3710",
    "hours": "Call for hours",
    "lat": 33.3923,
    "lng": -111.598
  },
  {
    "id": "18366",
    "name": "SPROUTS",
    "address": "South Nogales Highway 18755, Green Valley, AZ, 85614",
    "phone": "520-729-3370",
    "hours": "Call for hours",
    "lat": 31.90854,
    "lng": -110.979
  },
  {
    "id": "18365",
    "name": "SPROUTS",
    "address": "North 7th Avenue 3320, Phoenix, AZ, 85013",
    "phone": "602-384-2650",
    "hours": "Call for hours",
    "lat": 33.48722,
    "lng": -112.085
  },
  {
    "id": "18364",
    "name": "SPROUTS",
    "address": "South 59th Avenue 7700, Laveen, AZ, 85339",
    "phone": "480-210-4896",
    "hours": "Call for hours",
    "lat": 33.37604,
    "lng": -112.188
  },
  {
    "id": "18363",
    "name": "SPROUTS",
    "address": "North Scottsdale Road 8787, Scottsdale, AZ, 85253",
    "phone": "480-534-3620",
    "hours": "Call for hours",
    "lat": 33.56432,
    "lng": -111.924
  },
  {
    "id": "18362",
    "name": "SPROUTS",
    "address": "Tempe, AZ, 85284",
    "phone": "480-567-7040",
    "hours": "Call for hours",
    "lat": 33.40323,
    "lng": -111.923
  },
  {
    "id": "18361",
    "name": "SPROUTS",
    "address": "East Longbow Parkway 5910, Mesa, AZ, 85215",
    "phone": "480-401-3870",
    "hours": "Call for hours",
    "lat": 33.47233,
    "lng": -111.703
  },
  {
    "id": "18360",
    "name": "SPROUTS",
    "address": "East Sheldon Street 174, Prescott, AZ, 86301",
    "phone": "928-499-3350",
    "hours": "Call for hours",
    "lat": 34.5455,
    "lng": -112.468
  },
  {
    "id": "18359",
    "name": "SPROUTS",
    "address": "South 4th Avenue 1590, Yuma, AZ, 85364",
    "phone": "928-388-6016",
    "hours": "Call for hours",
    "lat": 32.69874,
    "lng": -114.625
  },
  {
    "id": "18358",
    "name": "SPROUTS",
    "address": "East Baseline Road 2060, Mesa, AZ, 85204",
    "phone": "480-401-3758",
    "hours": "Call for hours",
    "lat": 33.3791,
    "lng": -111.788
  },
  {
    "id": "18357",
    "name": "SPROUTS",
    "address": "South Gilbert Road 4065, Chandler, AZ, 85249",
    "phone": "480-781-0088",
    "hours": "Call for hours",
    "lat": 33.24748,
    "lng": -111.789
  },
  {
    "id": "18356",
    "name": "SPROUTS",
    "address": "South Ellsworth Loop Road 21181, Queen Creek, AZ, 85142",
    "phone": "623-385-3213",
    "hours": "Call for hours",
    "lat": 33.25908,
    "lng": -111.638
  },
  {
    "id": "18355",
    "name": "SPROUTS",
    "address": "West Happy Valley Parkway 10134, Peoria, AZ, 85383",
    "phone": "602-385-3392",
    "hours": "Call for hours",
    "lat": 33.71302,
    "lng": -112.278
  },
  {
    "id": "18354",
    "name": "SPROUTS",
    "address": "East High Street 5455, Phoenix, AZ, 85054",
    "phone": "602-682-3200",
    "hours": "Call for hours",
    "lat": 33.67514,
    "lng": -111.964
  },
  {
    "id": "18353",
    "name": "SPROUTS",
    "address": "North Scottsdale Road 23269, Scottsdale, AZ, 85255",
    "phone": "480-295-4789",
    "hours": "Call for hours",
    "lat": 33.6976,
    "lng": -111.923
  },
  {
    "id": "18352",
    "name": "SPROUTS",
    "address": "East State Route 69 5645, Prescott Valley, AZ, 86314",
    "phone": "928-379-8000",
    "hours": "Call for hours",
    "lat": 34.57438,
    "lng": -112.364
  },
  {
    "id": "18351",
    "name": "SPROUTS",
    "address": "West Deer Valley Road 6760, Glendale, AZ, 85310",
    "phone": "623-385-4430",
    "hours": "Call for hours",
    "lat": 33.68192,
    "lng": -112.205
  },
  {
    "id": "18350",
    "name": "SPROUTS",
    "address": "South Riordan Ranch Street 1540, Flagstaff, AZ, 86001",
    "phone": "928-679-6000",
    "hours": "Call for hours",
    "lat": 35.18543,
    "lng": -111.66
  },
  {
    "id": "18349",
    "name": "SPROUTS",
    "address": "East Speedway Boulevard 4645, Tucson, AZ, 85712",
    "phone": "520-325-1320",
    "hours": "Call for hours",
    "lat": 32.23629,
    "lng": -110.894
  },
  {
    "id": "18348",
    "name": "SPROUTS",
    "address": "North 1st Avenue 4282, Tucson, AZ, 85719",
    "phone": "520-407-5132",
    "hours": "Call for hours",
    "lat": 32.28496,
    "lng": -110.961
  },
  {
    "id": "18347",
    "name": "SPROUTS",
    "address": "East Broadway Boulevard 7877, Tucson, AZ, 85710",
    "phone": "520-546-6112",
    "hours": "Call for hours",
    "lat": 32.22105,
    "lng": -110.824
  },
  {
    "id": "18346",
    "name": "SPROUTS",
    "address": "W River Road 3860, Tucson, AZ, 85741",
    "phone": "520-204-1787",
    "hours": "Call for hours",
    "lat": 32.32251,
    "lng": -111.044
  },
  {
    "id": "18345",
    "name": "SPROUTS",
    "address": "East Southern Avenue 1706, Tempe, AZ, 85282",
    "phone": "480-820-4900",
    "hours": "Call for hours",
    "lat": 33.39307,
    "lng": -111.911
  },
  {
    "id": "18344",
    "name": "SPROUTS",
    "address": "North Miller Road 4402, Scottsdale, AZ, 85251",
    "phone": "480-941-6001",
    "hours": "Call for hours",
    "lat": 33.49975,
    "lng": -111.918
  },
  {
    "id": "18343",
    "name": "SPROUTS",
    "address": "East Bell Road 245, Phoenix, AZ, 85022",
    "phone": "602-218-4949",
    "hours": "Call for hours",
    "lat": 33.64019,
    "lng": -112.071
  },
  {
    "id": "18342",
    "name": "SPROUTS",
    "address": "East Glendale Avenue 1625, Phoenix, AZ, 85020",
    "phone": "602-385-2150",
    "hours": "Call for hours",
    "lat": 33.5382,
    "lng": -112.045
  },
  {
    "id": "18341",
    "name": "SPROUTS",
    "address": "East Ray Road 4735, Phoenix, AZ, 85044",
    "phone": "480-295-4901",
    "hours": "Call for hours",
    "lat": 33.31975,
    "lng": -111.982
  },
  {
    "id": "18340",
    "name": "SPROUTS",
    "address": "South Alma School Road 2855, Chandler, AZ, 85286",
    "phone": "480-814-2700",
    "hours": "Call for hours",
    "lat": 33.26464,
    "lng": -111.856
  },
  {
    "id": "18339",
    "name": "SPROUTS",
    "address": "South Val Vista Drive 2582, Gilbert, AZ, 85295",
    "phone": "480-821-1511",
    "hours": "Call for hours",
    "lat": 33.30353,
    "lng": -111.756
  },
  {
    "id": "18338",
    "name": "SPROUTS",
    "address": "North Dysart Road 1813, Avondale, AZ, 85392",
    "phone": "623-535-8989",
    "hours": "Call for hours",
    "lat": 33.46641,
    "lng": -112.341
  },
  {
    "id": "18337",
    "name": "SPROUTS",
    "address": "West Bell Road 13759, Surprise, AZ, 85374",
    "phone": "623-544-3121",
    "hours": "Call for hours",
    "lat": 33.6385,
    "lng": -112.355
  },
  {
    "id": "18336",
    "name": "SPROUTS",
    "address": "North Oracle Road 7665, Oro Valley, AZ, 85704",
    "phone": "520-297-5446",
    "hours": "Call for hours",
    "lat": 32.34666,
    "lng": -110.978
  },
  {
    "id": "18335",
    "name": "SPROUTS",
    "address": "East Southern Avenue 5225, Mesa, AZ, 85206",
    "phone": "480-218-6491",
    "hours": "Call for hours",
    "lat": 33.39379,
    "lng": -111.719
  },
  {
    "id": "18334",
    "name": "SPROUTS",
    "address": "West Thunderbird Road 4201, Phoenix, AZ, 85053",
    "phone": "602-960-4587",
    "hours": "Call for hours",
    "lat": 33.61081,
    "lng": -112.15
  },
  {
    "id": "18333",
    "name": "SPROUTS",
    "address": "East Indian School Road 2824, Phoenix, AZ, 85016",
    "phone": "602-553-3131",
    "hours": "Call for hours",
    "lat": 33.49514,
    "lng": -112.021
  },
  {
    "id": "18332",
    "name": "SPROUTS",
    "address": "West Bell Road 5665, Glendale, AZ, 85308",
    "phone": "602-896-0300",
    "hours": "Call for hours",
    "lat": 33.63874,
    "lng": -112.181
  },
  {
    "id": "18331",
    "name": "SPROUTS",
    "address": "North 19th Avenue 8040, Phoenix, AZ, 85021",
    "phone": "602-864-6130",
    "hours": "Call for hours",
    "lat": 33.55389,
    "lng": -112.1
  },
  {
    "id": "18330",
    "name": "SPROUTS",
    "address": "West Thunderbird Road 8375, Peoria, AZ, 85381",
    "phone": "623-334-1111",
    "hours": "Call for hours",
    "lat": 33.60852,
    "lng": -112.239
  },
  {
    "id": "18329",
    "name": "SPROUTS",
    "address": "East Brown Road 1933, Mesa, AZ, 85203",
    "phone": "480-668-0800",
    "hours": "Call for hours",
    "lat": 33.4371,
    "lng": -111.789
  },
  {
    "id": "18328",
    "name": "SPROUTS",
    "address": "Montgomery Highway 1031, Vestavia Hills, AL, 35216",
    "phone": "205-484-0084",
    "hours": "Call for hours",
    "lat": 33.43897,
    "lng": -86.7889
  },
  {
    "id": "18327",
    "name": "SPROUTS",
    "address": "North Tatum Boulevard 12415, Phoenix, AZ, 85032",
    "phone": "602-971-4177",
    "hours": "Call for hours",
    "lat": 33.59951,
    "lng": -111.979
  },
  {
    "id": "18326",
    "name": "SPROUTS",
    "address": "East Shea Boulevard 9301, Scottsdale, AZ, 85260",
    "phone": "480-551-9665",
    "hours": "Call for hours",
    "lat": 33.58046,
    "lng": -111.88
  },
  {
    "id": "18325",
    "name": "SPROUTS",
    "address": "West Ray Road 1959, Chandler, AZ, 85224",
    "phone": "480-732-1012",
    "hours": "Call for hours",
    "lat": 33.3205,
    "lng": -111.875
  },
  {
    "id": "18324",
    "name": "SPROUTS",
    "address": "Old Spanish Trail 1212, Houston, TX, 77054",
    "phone": "346-326-7639",
    "hours": "Call for hours",
    "lat": 29.69196,
    "lng": -95.4117
  },
  {
    "id": "18323",
    "name": "SPROUTS",
    "address": "West Cuthbert Boulevard 640, Haddon Township, NJ, 8108",
    "phone": "856-873-9052",
    "hours": "Call for hours",
    "lat": 39.90631,
    "lng": -75.0606
  },
  {
    "id": "18322",
    "name": "SPROUTS",
    "address": "SR 73 931, Marlton, NJ, 8053",
    "phone": "856-355-8228",
    "hours": "Call for hours",
    "lat": 39.86205,
    "lng": -74.9228
  },
  {
    "id": "18321",
    "name": "SPROUTS",
    "address": "University Boulevard 13550, Sugarland, TX, 77479",
    "phone": "281-201-3470",
    "hours": "Call for hours",
    "lat": 29.58409,
    "lng": -95.6479
  },
  {
    "id": "18320",
    "name": "SPROUTS",
    "address": "Old Columbia Pike 15793, Burtonsville, MD, 20866",
    "phone": "240-883-9223",
    "hours": "Call for hours",
    "lat": 39.11914,
    "lng": -76.9316
  },
  {
    "id": "18319",
    "name": "SPROUTS",
    "address": "Boston Street 3800, Baltimore, MD, 21224",
    "phone": "443-836-5882",
    "hours": "Call for hours",
    "lat": 39.27794,
    "lng": -76.5639
  },
  {
    "id": "18318",
    "name": "SPROUTS",
    "address": "Ritchie Highway 8048, Pasadena, MD, 21122",
    "phone": "443-960-8484",
    "hours": "Call for hours",
    "lat": 39.12503,
    "lng": -76.5916
  },
  {
    "id": "18317",
    "name": "SPROUTS",
    "address": "Marketplace Drive 680, Bel Air, MD, 21014",
    "phone": "443-567-7788",
    "hours": "Call for hours",
    "lat": 39.52689,
    "lng": -76.3486
  },
  {
    "id": "18316",
    "name": "SPROUTS",
    "address": "Goucher Boulevard 803, Towson, MD, 21286",
    "phone": "410-842-6010",
    "hours": "Call for hours",
    "lat": 39.39791,
    "lng": -76.5846
  },
  {
    "id": "18315",
    "name": "SPROUTS",
    "address": "Baltimore National Pike 9150, Ellicott City, MD, 21042",
    "phone": "410-696-3160",
    "hours": "Call for hours",
    "lat": 39.27817,
    "lng": -76.8264
  },
  {
    "id": "18314",
    "name": "SPROUTS",
    "address": "Sudley Road 8431, Manassas, VA, 20109",
    "phone": "571-579-3257",
    "hours": "Call for hours",
    "lat": 38.77384,
    "lng": -77.4993
  },
  {
    "id": "18313",
    "name": "SPROUTS",
    "address": "Elden Street 494, Herndon, VA, 20170",
    "phone": "703-480-7930",
    "hours": "Call for hours",
    "lat": 38.96853,
    "lng": -77.3782
  },
  {
    "id": "18312",
    "name": "SPROUTS",
    "address": "Welsh Road 2001, Dresher, PA, 19025",
    "phone": "267-715-0602",
    "hours": "Call for hours",
    "lat": 40.15955,
    "lng": -75.1482
  },
  {
    "id": "18311",
    "name": "SPROUTS",
    "address": "South Broad Street 1000, Philadelphia, PA, 19146",
    "phone": "215-606-2400",
    "hours": "Call for hours",
    "lat": 39.93895,
    "lng": -75.1667
  },
  {
    "id": "18310",
    "name": "SPROUTS",
    "address": "Concord Pike 4801, Wilmington, DE, 19803",
    "phone": "302-467-2344",
    "hours": "Call for hours",
    "lat": 39.82549,
    "lng": -75.545
  },
  {
    "id": "18309",
    "name": "SPROUTS",
    "address": "South Pennsylvania Avenue 12100, Oklahoma City, OK, 73170",
    "phone": "405-416-7650",
    "hours": "Call for hours",
    "lat": 35.34768,
    "lng": -97.5475
  },
  {
    "id": "18308",
    "name": "SPROUTS",
    "address": "West 6th Avenue 909, Stillwater, OK, 74074",
    "phone": "405-571-3153",
    "hours": "Call for hours",
    "lat": 36.11555,
    "lng": -97.0696
  },
  {
    "id": "18307",
    "name": "SPROUTS",
    "address": "Garth Brooks Boulevard 1105, Yukon, OK, 73099",
    "phone": "405-494-3054",
    "hours": "Call for hours",
    "lat": 35.49762,
    "lng": -97.7601
  },
  {
    "id": "18306",
    "name": "SPROUTS",
    "address": "North MacArthur Boulevard 12200, Oklahoma City, OK, 73162",
    "phone": "405-384-7577",
    "hours": "Call for hours",
    "lat": 35.59322,
    "lng": -97.6206
  },
  {
    "id": "18305",
    "name": "SPROUTS",
    "address": "Westheimer Road 11940, Houston, TX, 77077",
    "phone": "281-582-6794",
    "hours": "Call for hours",
    "lat": 29.73632,
    "lng": -95.5895
  },
  {
    "id": "18304",
    "name": "SPROUTS",
    "address": "North 133rd Avenue East 9601, Owasso, OK, 74055",
    "phone": "918-516-6656",
    "hours": "Call for hours",
    "lat": 36.29429,
    "lng": -95.8263
  },
  {
    "id": "18303",
    "name": "SPROUTS",
    "address": "East Hillside Drive North 851, Broken Arrow (Tulsa), OK, 74012",
    "phone": "918-806-0810",
    "hours": "Call for hours",
    "lat": 36.06672,
    "lng": -95.7812
  },
  {
    "id": "18302",
    "name": "SPROUTS",
    "address": "South Harvard Avenue 4123, Tulsa, OK, 74135",
    "phone": "918-858-8850",
    "hours": "Call for hours",
    "lat": 36.10391,
    "lng": -95.9401
  },
  {
    "id": "18301",
    "name": "SPROUTS",
    "address": "South Memorial Drive 10111, Tulsa, OK, 74133",
    "phone": "918-364-7272",
    "hours": "Call for hours",
    "lat": 36.01712,
    "lng": -95.8864
  },
  {
    "id": "18300",
    "name": "SPROUTS",
    "address": "West Main Street 559, Norman, OK, 73069",
    "phone": "405-217-4601",
    "hours": "Call for hours",
    "lat": 35.21895,
    "lng": -97.451
  },
  {
    "id": "18299",
    "name": "SPROUTS",
    "address": "East 2nd Street 24, Edmond, OK, 73034",
    "phone": "405-341-5727",
    "hours": "Call for hours",
    "lat": 35.65308,
    "lng": -97.4811
  },
  {
    "id": "18298",
    "name": "SPROUTS",
    "address": "North May Avenue 6410, Oklahoma City, OK, 73116",
    "phone": "405-879-9989",
    "hours": "Call for hours",
    "lat": 35.53702,
    "lng": -97.5658
  },
  {
    "id": "18297",
    "name": "SPROUTS",
    "address": "NE M 291 Highway 800, Lee's Summit, MO, 64086",
    "phone": "816-272-7038",
    "hours": "Call for hours",
    "lat": 38.92661,
    "lng": -94.3609
  },
  {
    "id": "18296",
    "name": "SPROUTS",
    "address": "Nacogdoches Road 2502, San Antonio, TX, 78217",
    "phone": "210-824-7800",
    "hours": "Call for hours",
    "lat": 29.51782,
    "lng": -98.4493
  },
  {
    "id": "18295",
    "name": "SPROUTS",
    "address": "Tom Watson Parkway 6061, Kansas City, MO, 64151",
    "phone": "816-303-6503",
    "hours": "Call for hours",
    "lat": 39.20985,
    "lng": -94.6503
  },
  {
    "id": "18294",
    "name": "SPROUTS",
    "address": "North Booth Avenue 8383, Kansas City (Liberty), MO, 64158",
    "phone": "816-222-0202",
    "hours": "Call for hours",
    "lat": 39.24362,
    "lng": -94.4747
  },
  {
    "id": "18293",
    "name": "SPROUTS",
    "address": "East Lohman Avenue 2340, Las Cruces, NM, 88001",
    "phone": "575-680-3680",
    "hours": "Call for hours",
    "lat": 32.31303,
    "lng": -106.751
  },
  {
    "id": "18292",
    "name": "SPROUTS",
    "address": "Coors Boulevard Northwest 5600, Albuquerque, NM, 87120",
    "phone": "505-355-3850",
    "hours": "Call for hours",
    "lat": 35.14626,
    "lng": -106.688
  },
  {
    "id": "18291",
    "name": "SPROUTS",
    "address": "Central Avenue Southeast 13150, Albuquerque, NM, 87123",
    "phone": "505-998-1025",
    "hours": "Call for hours",
    "lat": 35.06643,
    "lng": -106.499
  },
  {
    "id": "18290",
    "name": "SPROUTS",
    "address": "West Anderson Lane 2917, Austin, TX, 78757",
    "phone": "512-451-0669",
    "hours": "Call for hours",
    "lat": 30.35968,
    "lng": -97.7387
  },
  {
    "id": "18289",
    "name": "SPROUTS",
    "address": "Paseo de Peralta 199, Santa Fe, NM, 87501",
    "phone": "505-988-1140",
    "hours": "Call for hours",
    "lat": 35.69226,
    "lng": -105.948
  },
  {
    "id": "18288",
    "name": "SPROUTS",
    "address": "Zafarano Drive 3201, Santa Fe, NM, 87507",
    "phone": "505-424-1900",
    "hours": "Call for hours",
    "lat": 35.64569,
    "lng": -106.014
  },
  {
    "id": "18287",
    "name": "SPROUTS",
    "address": "San Mateo Boulevard Northeast 6300, Albuquerque, NM, 87109",
    "phone": "505-821-7000",
    "hours": "Call for hours",
    "lat": 35.14865,
    "lng": -106.586
  },
  {
    "id": "18286",
    "name": "SPROUTS",
    "address": "Montgomery Boulevard Northeast 11201, Albuquerque, NM, 87111",
    "phone": "505-298-2447",
    "hours": "Call for hours",
    "lat": 35.13075,
    "lng": -106.516
  },
  {
    "id": "18285",
    "name": "SPROUTS",
    "address": "Lomas Boulevard Northeast 5112, Albuquerque, NM, 87110",
    "phone": "505-268-5127",
    "hours": "Call for hours",
    "lat": 35.08673,
    "lng": -106.588
  },
  {
    "id": "18284",
    "name": "SPROUTS",
    "address": "Corrales Road Northwest 10701, Albuquerque, NM, 87114",
    "phone": "505-890-7900",
    "hours": "Call for hours",
    "lat": 35.20502,
    "lng": -106.647
  },
  {
    "id": "18283",
    "name": "SPROUTS",
    "address": "Rouzan Square Avenue 4841, Baton Rouge, LA, 70808",
    "phone": "225-614-9131",
    "hours": "Call for hours",
    "lat": 30.41405,
    "lng": -91.1385
  },
  {
    "id": "18282",
    "name": "SPROUTS",
    "address": "Tamiami Trail 2000, Port Charlotte, FL, 33948",
    "phone": "941-699-2501",
    "hours": "Call for hours",
    "lat": 27.00356,
    "lng": -82.1282
  },
  {
    "id": "18281",
    "name": "SPROUTS",
    "address": "Hollywood Boulevard, West Melbourne, FL, 32904",
    "phone": "321-462-3184",
    "hours": "Call for hours",
    "lat": 28.07551,
    "lng": -80.6536
  },
  {
    "id": "18280",
    "name": "SPROUTS",
    "address": "Southwest 27th Terrace 2750, Miami, FL, 33133",
    "phone": "561-765-2216",
    "hours": "Call for hours",
    "lat": 25.74061,
    "lng": -80.239
  },
  {
    "id": "18279",
    "name": "SPROUTS",
    "address": "66th Street North 4571, Kenneth City, FL, 33709",
    "phone": "727-620-6030",
    "hours": "Call for hours",
    "lat": 27.81331,
    "lng": -82.7285
  },
  {
    "id": "18278",
    "name": "SPROUTS",
    "address": "College Parkway 8595, Ft. Myers, FL, 33919",
    "phone": "239-396-5883",
    "hours": "Call for hours",
    "lat": 26.55651,
    "lng": -81.8975
  },
  {
    "id": "18277",
    "name": "SPROUTS",
    "address": "Northeast Pine Island Road 1800, Cape Coral, FL, 33909",
    "phone": "239-392-1396",
    "hours": "Call for hours",
    "lat": 26.66972,
    "lng": -81.9366
  },
  {
    "id": "18276",
    "name": "SPROUTS",
    "address": "Lake Underhill Road 12500, Orlando, FL, 32828",
    "phone": "689-303-4690",
    "hours": "Call for hours",
    "lat": 28.54575,
    "lng": -81.2012
  },
  {
    "id": "18275",
    "name": "SPROUTS",
    "address": "Buena Vista Boulevard, The Villages, FL, 32162",
    "phone": "352-706-2925",
    "hours": "Call for hours",
    "lat": 28.95867,
    "lng": -82.002
  },
  {
    "id": "18274",
    "name": "SPROUTS",
    "address": "East Fowler Avenue 2150, Tampa, FL, 33612",
    "phone": "813-771-9936",
    "hours": "Call for hours",
    "lat": 28.05458,
    "lng": -82.4352
  },
  {
    "id": "18273",
    "name": "SPROUTS",
    "address": "Glades Road 9831, West Boca Raton, FL, 33434",
    "phone": "561-880-9105",
    "hours": "Call for hours",
    "lat": 26.36798,
    "lng": -80.1943
  },
  {
    "id": "18272",
    "name": "SPROUTS",
    "address": "Semoran Boulevard 2283, Apopka, FL, 32703",
    "phone": "689-336-2070",
    "hours": "Call for hours",
    "lat": 28.67484,
    "lng": -81.4691
  },
  {
    "id": "18271",
    "name": "SPROUTS",
    "address": "Cortez Road West 1149, Bradenton, FL, 34207",
    "phone": "941-297-2359",
    "hours": "Call for hours",
    "lat": 27.46255,
    "lng": -82.5746
  },
  {
    "id": "18270",
    "name": "SPROUTS",
    "address": "North Military Trail 1901, West Palm Beach, FL, 33409",
    "phone": "561-835-5418",
    "hours": "Call for hours",
    "lat": 26.70495,
    "lng": -80.1112
  },
  {
    "id": "18269",
    "name": "SPROUTS",
    "address": "West Atlantic Avenue 5030, Delray Beach, FL, 33484",
    "phone": "561-654-2692",
    "hours": "Call for hours",
    "lat": 26.45768,
    "lng": -80.1231
  },
  {
    "id": "18268",
    "name": "SPROUTS",
    "address": "East Colonial Drive 2530, Orlando, FL, 32803",
    "phone": "689-219-8967",
    "hours": "Call for hours",
    "lat": 28.55301,
    "lng": -81.3507
  },
  {
    "id": "18267",
    "name": "SPROUTS",
    "address": "Northeast 10th Court 2631, Homestead, FL, 33033",
    "phone": "754-764-7247",
    "hours": "Call for hours",
    "lat": 25.48054,
    "lng": -80.4392
  },
  {
    "id": "18266",
    "name": "SPROUTS",
    "address": "Nw St Lucie West Boulevard 1759, Port St Lucie, FL, 34986",
    "phone": "772-310-5465",
    "hours": "Call for hours",
    "lat": 27.31349,
    "lng": -80.406
  },
  {
    "id": "18265",
    "name": "SPROUTS",
    "address": "South Compass Way 150, Dania Beach, FL, 33004",
    "phone": "954-715-3376",
    "hours": "Call for hours",
    "lat": 26.04916,
    "lng": -80.1577
  },
  {
    "id": "18264",
    "name": "SPROUTS",
    "address": "Southwest 88th Street 12690, Miami, FL, 33186",
    "phone": "786-798-7074",
    "hours": "Call for hours",
    "lat": 25.68581,
    "lng": -80.4004
  },
  {
    "id": "18263",
    "name": "SPROUTS",
    "address": "East Oakland Park Boulevard 700, Oakland Park, FL, 33334",
    "phone": "561-894-0789",
    "hours": "Call for hours",
    "lat": 26.16681,
    "lng": -80.1374
  },
  {
    "id": "18262",
    "name": "SPROUTS",
    "address": "West 7th Avenue 101, Tampa, FL, 33602",
    "phone": "813-807-3146",
    "hours": "Call for hours",
    "lat": 27.96051,
    "lng": -82.4621
  },
  {
    "id": "18261",
    "name": "SPROUTS",
    "address": "Causeway Boulevard 11339, Brandon, FL, 33511",
    "phone": "813-725-1220",
    "hours": "Call for hours",
    "lat": 27.92312,
    "lng": -82.322
  },
  {
    "id": "18260",
    "name": "SPROUTS",
    "address": "Turkey Lake Road 7603, Orlando, FL, 32819",
    "phone": "321-340-2023",
    "hours": "Call for hours",
    "lat": 28.45435,
    "lng": -81.4764
  },
  {
    "id": "18259",
    "name": "SPROUTS",
    "address": "Sheldon Road 10619, Tampa, FL, 33626",
    "phone": "772-348-2150",
    "hours": "Call for hours",
    "lat": 28.04595,
    "lng": -82.5826
  },
  {
    "id": "18258",
    "name": "SPROUTS",
    "address": "South Jog Road 9850, Boynton Beach, FL, 33437",
    "phone": "561-739-1834",
    "hours": "Call for hours",
    "lat": 26.53,
    "lng": -80.1457
  },
  {
    "id": "18257",
    "name": "SPROUTS",
    "address": "South Tamiami Trail 19990, Estero, FL, 33928",
    "phone": "239-306-5384",
    "hours": "Call for hours",
    "lat": 26.44835,
    "lng": -81.8189
  },
  {
    "id": "18256",
    "name": "SPROUTS",
    "address": "Hunters Village Road 8620, Tampa, FL, 33647",
    "phone": "813-683-8072",
    "hours": "Call for hours",
    "lat": 28.1393,
    "lng": -82.358
  },
  {
    "id": "18255",
    "name": "SPROUTS",
    "address": "Southeast Federal Highway 3150, Stuart, FL, 34994",
    "phone": "772-272-9698",
    "hours": "Call for hours",
    "lat": 27.16631,
    "lng": -80.2271
  },
  {
    "id": "18254",
    "name": "SPROUTS",
    "address": "Seminole Boulevard 7263, Seminole, FL, 33772",
    "phone": "727-655-9055",
    "hours": "Call for hours",
    "lat": 27.83876,
    "lng": -82.787
  },
  {
    "id": "18253",
    "name": "SPROUTS",
    "address": "Beach Boulevard 12675, Jacksonville, FL, 32246",
    "phone": "904-539-8317",
    "hours": "Call for hours",
    "lat": 30.28891,
    "lng": -81.4858
  },
  {
    "id": "18252",
    "name": "SPROUTS",
    "address": "Miramar Parkway 12216, Miramar, FL, 33025",
    "phone": "754-799-8177",
    "hours": "Call for hours",
    "lat": 25.97889,
    "lng": -80.3086
  },
  {
    "id": "18251",
    "name": "SPROUTS",
    "address": "Military Trail 3757, Jupiter, FL, 33458",
    "phone": "561-658-4062",
    "hours": "Call for hours",
    "lat": 26.91094,
    "lng": -80.1024
  },
  {
    "id": "18250",
    "name": "SPROUTS",
    "address": "Town Center Parkway 4873, Jacksonville, FL, 32246",
    "phone": "904-438-7840",
    "hours": "Call for hours",
    "lat": 30.2536,
    "lng": -81.5333
  },
  {
    "id": "18249",
    "name": "SPROUTS",
    "address": "South Us Highway 301 12960, Riverview, FL, 33578",
    "phone": "813-284-3440",
    "hours": "Call for hours",
    "lat": 27.80038,
    "lng": -82.3329
  },
  {
    "id": "18248",
    "name": "SPROUTS",
    "address": "Strength Avenue 8840, New Port Richey, FL, 34655",
    "phone": "727-807-2200",
    "hours": "Call for hours",
    "lat": 28.20474,
    "lng": -82.669
  },
  {
    "id": "18247",
    "name": "SPROUTS",
    "address": "Alafaya Trail 1121, Oviedo, FL, 32765",
    "phone": "407-542-6070",
    "hours": "Call for hours",
    "lat": 28.65351,
    "lng": -81.2096
  },
  {
    "id": "18246",
    "name": "SPROUTS",
    "address": "South Federal Highway 930, Deerfield Beach, FL, 33441",
    "phone": "954-363-2070",
    "hours": "Call for hours",
    "lat": 26.30564,
    "lng": -80.0927
  },
  {
    "id": "18245",
    "name": "SPROUTS",
    "address": "Us Highway 19 North 23656, Clearwater, FL, 33765",
    "phone": "727-437-1455",
    "hours": "Call for hours",
    "lat": 27.98755,
    "lng": -82.731
  },
  {
    "id": "18244",
    "name": "SPROUTS",
    "address": "Aloma Avenue 1999, Winter Park, FL, 32792",
    "phone": "407-702-1212",
    "hours": "Call for hours",
    "lat": 28.60099,
    "lng": -81.3249
  },
  {
    "id": "18243",
    "name": "SPROUTS",
    "address": "Logan Boulevard North 2224, Naples, FL, 34119",
    "phone": "239-325-6950",
    "hours": "Call for hours",
    "lat": 26.27094,
    "lng": -81.7207
  },
  {
    "id": "18242",
    "name": "SPROUTS",
    "address": "South Tamiami Trail 8330, S. Sarasota, FL, 34238",
    "phone": "941-218-8119",
    "hours": "Call for hours",
    "lat": 27.23299,
    "lng": -82.4971
  },
  {
    "id": "18241",
    "name": "SPROUTS",
    "address": "Lithia Pinecrest Road 3315, Valrico, FL, 33596",
    "phone": "813-603-9630",
    "hours": "Call for hours",
    "lat": 27.89339,
    "lng": -82.2435
  },
  {
    "id": "18240",
    "name": "SPROUTS",
    "address": "North Dale Mabry Highway 15110, Tampa, FL, 33618",
    "phone": "813-619-4000",
    "hours": "Call for hours",
    "lat": 28.08717,
    "lng": -82.5043
  },
  {
    "id": "18239",
    "name": "SPROUTS",
    "address": "Us Highway 19 North 33652, Palm Harbor, FL, 34684",
    "phone": "727-437-3824",
    "hours": "Call for hours",
    "lat": 28.07808,
    "lng": -82.7412
  },
  {
    "id": "18238",
    "name": "SPROUTS",
    "address": "South Dale Mabry Highway 1523, S. Tampa, FL, 33629",
    "phone": "813-466-3390",
    "hours": "Call for hours",
    "lat": 27.92975,
    "lng": -82.5059
  },
  {
    "id": "18237",
    "name": "SPROUTS",
    "address": "4000 West 11519 S, South Jordan, UT, 84009",
    "phone": "385-695-6809",
    "hours": "Call for hours",
    "lat": 40.54089,
    "lng": -111.985
  },
  {
    "id": "18236",
    "name": "SPROUTS",
    "address": "East Murray Holladay Road 1785, Holladay, UT, 84117",
    "phone": "385-695-6817",
    "hours": "Call for hours",
    "lat": 40.66701,
    "lng": -111.841
  },
  {
    "id": "18235",
    "name": "SPROUTS",
    "address": "700 East 216 South, Salt Lake City, UT, 84102",
    "phone": "801-364-1602",
    "hours": "Call for hours",
    "lat": 40.76457,
    "lng": -111.873
  },
  {
    "id": "18234",
    "name": "SPROUTS",
    "address": "South State Street 1375, Orem, UT, 84097",
    "phone": "801-434-1501",
    "hours": "Call for hours",
    "lat": 40.27194,
    "lng": -111.683
  },
  {
    "id": "18233",
    "name": "SPROUTS",
    "address": "South State Street 6284, Murray, UT, 84107",
    "phone": "801-266-3566",
    "hours": "Call for hours",
    "lat": 40.63451,
    "lng": -111.89
  },
  {
    "id": "18232",
    "name": "SPROUTS",
    "address": "Nolensville Pike 5821, Nashville, TN, 37211",
    "phone": "629-736-3268",
    "hours": "Call for hours",
    "lat": 36.04223,
    "lng": -86.713
  },
  {
    "id": "18231",
    "name": "SPROUTS",
    "address": "South Perkins Road 576, Memphis, TN, 38117",
    "phone": "901-620-4405",
    "hours": "Call for hours",
    "lat": 35.11543,
    "lng": -89.907
  },
  {
    "id": "18230",
    "name": "SPROUTS",
    "address": "Highway 70 South 7620, Nashville, TN, 37221",
    "phone": "615-209-7940",
    "hours": "Call for hours",
    "lat": 36.07991,
    "lng": -86.9489
  },
  {
    "id": "18229",
    "name": "SPROUTS",
    "address": "Wendelwood Drive 143, Murfreesboro, TN, 37129",
    "phone": "615-486-6081",
    "hours": "Call for hours",
    "lat": 35.88022,
    "lng": -86.3868
  },
  {
    "id": "18228",
    "name": "SPROUTS",
    "address": "Murfreesboro Road 1010, Franklin, TN, 37064",
    "phone": "615-567-0191",
    "hours": "Call for hours",
    "lat": 35.91641,
    "lng": -86.8388
  },
  {
    "id": "18227",
    "name": "SPROUTS",
    "address": "Village Shops Drive 3150, Germantown, TN, 38138",
    "phone": "901-259-7020",
    "hours": "Call for hours",
    "lat": 35.06499,
    "lng": -89.7589
  },
  {
    "id": "18226",
    "name": "SPROUTS",
    "address": "Us Highway 64 9050, Lakeland, TN, 38002",
    "phone": "901-259-3450",
    "hours": "Call for hours",
    "lat": 35.20591,
    "lng": -89.7613
  },
  {
    "id": "18225",
    "name": "SPROUTS",
    "address": "Steele Creek Road 14124, Charlotte, NC, 28273",
    "phone": "828-705-3910",
    "hours": "Call for hours",
    "lat": 35.10182,
    "lng": -80.9884
  },
  {
    "id": "18224",
    "name": "SPROUTS",
    "address": "Woodruff Road 2200, Simpsonville, SC, 29681",
    "phone": "864-757-3240",
    "hours": "Call for hours",
    "lat": 34.81887,
    "lng": -82.2549
  },
  {
    "id": "18223",
    "name": "SPROUTS",
    "address": "West Lake Mead Parkway 280, Henderson, NV, 89015",
    "phone": "725-286-2723",
    "hours": "Call for hours",
    "lat": 36.03649,
    "lng": -114.992
  },
  {
    "id": "18222",
    "name": "SPROUTS",
    "address": "Losee Road 6506, North Las Vegas, NV, 89086",
    "phone": "702-857-6362",
    "hours": "Call for hours",
    "lat": 36.2783,
    "lng": -115.117
  },
  {
    "id": "18221",
    "name": "SPROUTS",
    "address": "East Plumb Lane 299, Reno, NV, 89502",
    "phone": "775-446-3979",
    "hours": "Call for hours",
    "lat": 39.5058,
    "lng": -119.801
  },
  {
    "id": "18220",
    "name": "SPROUTS",
    "address": "South Rainbow Boulevard 771, Las Vegas, NV, 89145",
    "phone": "702-984-4330",
    "hours": "Call for hours",
    "lat": 36.1644,
    "lng": -115.246
  },
  {
    "id": "18219",
    "name": "SPROUTS",
    "address": "North Decatur Boulevard 6150, Las Vegas, NV, 89130",
    "phone": "702-273-3490",
    "hours": "Call for hours",
    "lat": 36.26996,
    "lng": -115.207
  },
  {
    "id": "18218",
    "name": "SPROUTS",
    "address": "Battleground Avenue 3357, Greensboro, NC, 27410",
    "phone": "336-252-5250",
    "hours": "Call for hours",
    "lat": 36.123,
    "lng": -79.8458
  },
  {
    "id": "18217",
    "name": "SPROUTS",
    "address": "West NC Highway 54 105, Durham, NC, 27713",
    "phone": "919-768-4055",
    "hours": "Call for hours",
    "lat": 35.90975,
    "lng": -78.9388
  },
  {
    "id": "18216",
    "name": "SPROUTS",
    "address": "Freedom Parkway Drive 2810, Fayetteville, NC, 28314",
    "phone": "910-748-5985",
    "hours": "Call for hours",
    "lat": 35.05758,
    "lng": -78.9698
  },
  {
    "id": "18215",
    "name": "SPROUTS",
    "address": "Ballancroft Parkway 15121, Charlotte, NC, 28277",
    "phone": "704-778-3010",
    "hours": "Call for hours",
    "lat": 35.04087,
    "lng": -80.848
  },
  {
    "id": "18214",
    "name": "SPROUTS",
    "address": "Falls of Neuse Road 9414, Raleigh, NC, 27615",
    "phone": "919-326-2530",
    "hours": "Call for hours",
    "lat": 35.90245,
    "lng": -78.6049
  },
  {
    "id": "18213",
    "name": "SPROUTS",
    "address": "Cumberland Boulevard Southeast 2530, Smyrna, GA, 30080",
    "phone": "470-750-1841",
    "hours": "Call for hours",
    "lat": 33.89012,
    "lng": -84.4767
  },
  {
    "id": "18212",
    "name": "SPROUTS",
    "address": "Buford Drive 2925, Buford, GA, 30519",
    "phone": "470-600-6528",
    "hours": "Call for hours",
    "lat": 34.05134,
    "lng": -83.9913
  },
  {
    "id": "18211",
    "name": "SPROUTS",
    "address": "Crane Creek Drive 630, Augusta, GA, 30907",
    "phone": "706-993-9150",
    "hours": "Call for hours",
    "lat": 33.49704,
    "lng": -82.0801
  },
  {
    "id": "18210",
    "name": "SPROUTS",
    "address": "Lavista Road 4310, Tucker, GA, 30084",
    "phone": "470-260-2368",
    "hours": "Call for hours",
    "lat": 33.84813,
    "lng": -84.2404
  },
  {
    "id": "18209",
    "name": "SPROUTS",
    "address": "Marietta, GA, 30064",
    "phone": "678-919-8701",
    "hours": "Call for hours",
    "lat": 33.95723,
    "lng": -84.5427
  },
  {
    "id": "18208",
    "name": "SPROUTS",
    "address": "Blackmon Drive 2551, Decatur, GA, 30033",
    "phone": "404-965-6290",
    "hours": "Call for hours",
    "lat": 33.7952,
    "lng": -84.2873
  },
  {
    "id": "18207",
    "name": "SPROUTS",
    "address": "W Highway 54 2015, Peachtree City, GA, 30269",
    "phone": "678-586-2577",
    "hours": "Call for hours",
    "lat": 33.41976,
    "lng": -84.5594
  },
  {
    "id": "18206",
    "name": "SPROUTS",
    "address": "Towne Lake Parkway 1430, Woodstock, GA, 30189",
    "phone": "678-224-9799",
    "hours": "Call for hours",
    "lat": 34.10624,
    "lng": -84.54
  },
  {
    "id": "18205",
    "name": "SPROUTS",
    "address": "Roswell Road 4101, Marietta, GA, 30062",
    "phone": "770-200-9172",
    "hours": "Call for hours",
    "lat": 33.98165,
    "lng": -84.4345
  },
  {
    "id": "18204",
    "name": "SPROUTS",
    "address": "Alpharetta Highway 10800, Roswell, GA, 30076",
    "phone": "678-353-0102",
    "hours": "Call for hours",
    "lat": 34.04436,
    "lng": -84.3411
  },
  {
    "id": "18203",
    "name": "SPROUTS",
    "address": "Piedmont Avenue Northeast 1845, Atlanta, GA, 30324",
    "phone": "404-751-0605",
    "hours": "Call for hours",
    "lat": 33.80638,
    "lng": -84.3667
  },
  {
    "id": "18202",
    "name": "SPROUTS",
    "address": "East-West Connector, Smyrna, GA, 30082",
    "phone": "770-200-7587",
    "hours": "Call for hours",
    "lat": 33.83835,
    "lng": -84.5108
  },
  {
    "id": "18201",
    "name": "SPROUTS",
    "address": "Peachtree Parkway 3630, Suwanee (John's Creek), GA, 30024",
    "phone": "678-690-1243",
    "hours": "Call for hours",
    "lat": 34.07369,
    "lng": -84.1659
  },
  {
    "id": "18200",
    "name": "SPROUTS",
    "address": "Lakeland Plaza 530, Cumming, GA, 30040",
    "phone": "470-505-2000",
    "hours": "Call for hours",
    "lat": 34.18419,
    "lng": -84.1435
  },
  {
    "id": "18199",
    "name": "SPROUTS",
    "address": "Mount Vernon Road 2480, Dunwoody, GA, 30338",
    "phone": "678-690-1237",
    "hours": "Call for hours",
    "lat": 33.95808,
    "lng": -84.3017
  },
  {
    "id": "18198",
    "name": "SPROUTS",
    "address": "Peachtree Parkway Northwest 5600, Norcross, GA, 30092",
    "phone": "678-690-1249",
    "hours": "Call for hours",
    "lat": 33.9667,
    "lng": -84.2218
  },
  {
    "id": "18197",
    "name": "SPROUTS",
    "address": "Scenic Highway 1250, Lawrenceville, GA, 30045",
    "phone": "678-690-1279",
    "hours": "Call for hours",
    "lat": 33.90032,
    "lng": -84.0056
  },
  {
    "id": "18196",
    "name": "SPROUTS",
    "address": "Disc Drive 125, Sparks, NV, 89436",
    "phone": "775-834-0210",
    "hours": "Call for hours",
    "lat": 39.57647,
    "lng": -119.743
  },
  {
    "id": "18195",
    "name": "SPROUTS",
    "address": "South Rainbow Boulevard 7375, Las Vegas, NV, 89139",
    "phone": "702-670-4450",
    "hours": "Call for hours",
    "lat": 36.05445,
    "lng": -115.245
  },
  {
    "id": "18194",
    "name": "SPROUTS",
    "address": "East Silverado Ranch Boulevard 1140, Las Vegas, NV, 89183",
    "phone": "702-750-3570",
    "hours": "Call for hours",
    "lat": 36.01335,
    "lng": -115.138
  },
  {
    "id": "18193",
    "name": "SPROUTS",
    "address": "South Meadows Parkway 587, Reno, NV, 89521",
    "phone": "775-335-1055",
    "hours": "Call for hours",
    "lat": 39.43872,
    "lng": -119.759
  },
  {
    "id": "18192",
    "name": "SPROUTS",
    "address": "West Lake Mead Boulevard 7530, Las Vegas, NV, 89128",
    "phone": "702-216-3556",
    "hours": "Call for hours",
    "lat": 36.1962,
    "lng": -115.258
  },
  {
    "id": "18191",
    "name": "SPROUTS",
    "address": "Farm Road 8441, Las Vegas, NV, 89131",
    "phone": "702-583-3830",
    "hours": "Call for hours",
    "lat": 36.29908,
    "lng": -115.279
  },
  {
    "id": "18190",
    "name": "SPROUTS",
    "address": "West Sahara Avenue 10000, Las Vegas, NV, 89117",
    "phone": "702-216-5060",
    "hours": "Call for hours",
    "lat": 36.14447,
    "lng": -115.314
  },
  {
    "id": "18189",
    "name": "SPROUTS",
    "address": "North Stephanie Street 515, Henderson (Stephanie), NV, 89014",
    "phone": "702-777-7095",
    "hours": "Call for hours",
    "lat": 36.06049,
    "lng": -115.046
  },
  {
    "id": "18188",
    "name": "SPROUTS",
    "address": "South Green Valley Parkway 635, Henderson (Green Valley), NV, 89052",
    "phone": "702-322-2229",
    "hours": "Call for hours",
    "lat": 36.00474,
    "lng": -115.083
  },
  {
    "id": "18187",
    "name": "SPROUTS",
    "address": "South Rainbow Boulevard 4020, Las Vegas, NV, 89103",
    "phone": "702-876-4888",
    "hours": "Call for hours",
    "lat": 36.11535,
    "lng": -115.241
  },
  {
    "id": "18186",
    "name": "SPROUTS",
    "address": "East Tropicana Avenue 3365, Las Vegas, NV, 89121",
    "phone": "702-777-0650",
    "hours": "Call for hours",
    "lat": 36.09878,
    "lng": -115.102
  },
  {
    "id": "18185",
    "name": "SPROUTS",
    "address": "US 280, Birmingham, AL, 35242",
    "phone": "205-263-2808",
    "hours": "Call for hours",
    "lat": 33.42659,
    "lng": -86.7055
  },
  {
    "id": "18184",
    "name": "SPROUTS",
    "address": "Peachtree Industrial Boulevard 2220, Duluth, GA, 30097",
    "phone": "470-362-7283",
    "hours": "Call for hours",
    "lat": 34.02321,
    "lng": -84.1156
  },
  {
    "id": "18183",
    "name": "SPROUTS",
    "address": "Us 72 W Highway NW 7504, Madison, AL, 35758",
    "phone": "256-203-8334",
    "hours": "Call for hours",
    "lat": 34.75816,
    "lng": -86.7301
  },
  {
    "id": "18182",
    "name": "SPROUTS",
    "address": "Medford Drive 5250, Hoover, AL, 35244",
    "phone": "205-263-4970",
    "hours": "Call for hours",
    "lat": 33.35626,
    "lng": -86.8561
  },
  {
    "id": "18181",
    "name": "SPROUTS",
    "address": "South Mooney Boulevard 3501, Visalia, CA, 93277",
    "phone": "559-553-4044",
    "hours": "Call for hours",
    "lat": 36.29958,
    "lng": -119.314
  },
  {
    "id": "18180",
    "name": "SPROUTS",
    "address": "Amargosa Road 12450, Victorville, CA, 92392",
    "phone": "442-327-1306",
    "hours": "Call for hours",
    "lat": 34.4755,
    "lng": -117.343
  },
  {
    "id": "18179",
    "name": "SPROUTS",
    "address": "Roswell Road Northeast 4600, Sandy Springs, GA, 30342",
    "phone": "678-954-5294",
    "hours": "Call for hours",
    "lat": 33.87971,
    "lng": -84.3809
  },
  {
    "id": "18178",
    "name": "SPROUTS",
    "address": "Highway 111 74895, Indian Wells, CA, 92210",
    "phone": "442-305-5258",
    "hours": "Call for hours",
    "lat": 33.72058,
    "lng": -116.359
  },
  {
    "id": "18177",
    "name": "SPROUTS",
    "address": "Atlantic Avenue 7925, Cudahy, CA, 90201",
    "phone": "213-259-2223",
    "hours": "Call for hours",
    "lat": 33.96248,
    "lng": -118.186
  },
  {
    "id": "18176",
    "name": "SPROUTS",
    "address": "Golden Valley Parkway, Lathrop, CA, 95330",
    "phone": "209-670-1663",
    "hours": "Call for hours",
    "lat": 37.82801,
    "lng": -121.295
  },
  {
    "id": "18175",
    "name": "SPROUTS",
    "address": "Pacific Avenue 5308, Stockton, CA, 95207",
    "phone": "209-751-0474",
    "hours": "Call for hours",
    "lat": 37.99775,
    "lng": -121.315
  },
  {
    "id": "18174",
    "name": "SPROUTS",
    "address": "Coleman Avenue 615, San Jose, CA, 95110",
    "phone": "669-444-3186",
    "hours": "Call for hours",
    "lat": 37.34113,
    "lng": -121.909
  },
  {
    "id": "18173",
    "name": "SPROUTS",
    "address": "East Yosemite Avenue 171, Merced, CA, 95340",
    "phone": "209-720-1439",
    "hours": "Call for hours",
    "lat": 37.33221,
    "lng": -120.468
  },
  {
    "id": "18172",
    "name": "SPROUTS",
    "address": "Panama Lane 3535, Bakersfield, CA, 93313",
    "phone": "661-529-3501",
    "hours": "Call for hours",
    "lat": 35.29582,
    "lng": -119.041
  },
  {
    "id": "18171",
    "name": "SPROUTS",
    "address": "15th Street West 43668, Lancaster, CA, 93534",
    "phone": "661-499-2651",
    "hours": "Call for hours",
    "lat": 34.6778,
    "lng": -118.156
  },
  {
    "id": "18170",
    "name": "SPROUTS",
    "address": "Pacific Crest Place Northwest 11066, Silverdale, WA, 98383",
    "phone": "360-900-4125",
    "hours": "Call for hours",
    "lat": 47.66335,
    "lng": -122.694
  },
  {
    "id": "18169",
    "name": "SPROUTS",
    "address": "Aurora Avenue North 13010, Seattle, WA, 98133",
    "phone": "206-337-4625",
    "hours": "Call for hours",
    "lat": 47.72343,
    "lng": -122.345
  },
  {
    "id": "18168",
    "name": "SPROUTS",
    "address": "Bothell-Everett Highway 13314, Mill Creek, WA, 98012",
    "phone": "425-332-6670",
    "hours": "Call for hours",
    "lat": 47.87681,
    "lng": -122.214
  },
  {
    "id": "18167",
    "name": "SPROUTS",
    "address": "Highway 99 19630, Lynnwood, WA, 98036",
    "phone": "425-412-1946",
    "hours": "Call for hours",
    "lat": 47.82079,
    "lng": -122.316
  },
  {
    "id": "18166",
    "name": "SPROUTS",
    "address": "10th Street West 39258, Palmdale, CA, 93551",
    "phone": "661-485-1280",
    "hours": "Call for hours",
    "lat": 34.59623,
    "lng": -118.147
  },
  {
    "id": "18165",
    "name": "SPROUTS",
    "address": "East Main Street 1430, Woodland, CA, 95776",
    "phone": "530-631-7172",
    "hours": "Call for hours",
    "lat": 38.67725,
    "lng": -121.755
  },
  {
    "id": "18164",
    "name": "SPROUTS",
    "address": "Bear Hollow Drive 10846, Rancho Cordova, CA, 95670",
    "phone": "279-278-7553",
    "hours": "Call for hours",
    "lat": 38.57734,
    "lng": -121.282
  },
  {
    "id": "18163",
    "name": "SPROUTS",
    "address": "Alondra Boulevard 11522, Norwalk, CA, 90650",
    "phone": "562-564-5410",
    "hours": "Call for hours",
    "lat": 33.88774,
    "lng": -118.088
  },
  {
    "id": "18162",
    "name": "SPROUTS",
    "address": "South Riverside Avenue 1524, Rialto, CA, 92376",
    "phone": "840-220-4266",
    "hours": "Call for hours",
    "lat": 34.07458,
    "lng": -117.37
  },
  {
    "id": "18161",
    "name": "SPROUTS",
    "address": "Magnolia Street 17950, Fountain Valley, CA, 92708",
    "phone": "657-733-4525",
    "hours": "Call for hours",
    "lat": 33.70221,
    "lng": -117.97
  },
  {
    "id": "18160",
    "name": "SPROUTS",
    "address": "Hemlock Avenue 24101, Moreno Valley, CA, 92557",
    "phone": "951-567-7549",
    "hours": "Call for hours",
    "lat": 33.94259,
    "lng": -117.243
  },
  {
    "id": "18159",
    "name": "SPROUTS",
    "address": "Chapman Avenue 9838, Garden Grove, CA, 92841",
    "phone": "657-427-6713",
    "hours": "Call for hours",
    "lat": 33.78849,
    "lng": -117.961
  },
  {
    "id": "18158",
    "name": "SPROUTS",
    "address": "Newport Road 27281, Menifee, CA, 92584",
    "phone": "951-370-1317",
    "hours": "Call for hours",
    "lat": 33.68495,
    "lng": -117.184
  },
  {
    "id": "18157",
    "name": "SPROUTS",
    "address": "South Milpas Street 29, Santa Barbara, CA, 93103",
    "phone": "805-837-0356",
    "hours": "Call for hours",
    "lat": 34.42137,
    "lng": -119.678
  },
  {
    "id": "18156",
    "name": "SPROUTS",
    "address": "Limonite Avenue 13985, Eastvale, CA, 92880",
    "phone": "909-655-5356",
    "hours": "Call for hours",
    "lat": 33.97644,
    "lng": -117.59
  },
  {
    "id": "18155",
    "name": "SPROUTS",
    "address": "Rockfield Boulevard 24332, Lake Forest, CA, 92630",
    "phone": "949-427-4020",
    "hours": "Call for hours",
    "lat": 33.61572,
    "lng": -117.703
  },
  {
    "id": "18154",
    "name": "SPROUTS",
    "address": "East Workman Avenue, W. Covina, CA, 91791",
    "phone": "626-257-9787",
    "hours": "Call for hours",
    "lat": 34.07584,
    "lng": -117.904
  },
  {
    "id": "18153",
    "name": "SPROUTS",
    "address": "South La Brea Avenue 1302, Los Angeles, CA, 90019",
    "phone": "323-801-7510",
    "hours": "Call for hours",
    "lat": 34.04994,
    "lng": -118.344
  },
  {
    "id": "18152",
    "name": "SPROUTS",
    "address": "Hilltop Drive 1401, Redding, CA, 96003",
    "phone": "530-999-0988",
    "hours": "Call for hours",
    "lat": 40.58791,
    "lng": -122.358
  },
  {
    "id": "18151",
    "name": "SPROUTS",
    "address": "East Vista Way 1400, Vista, CA, 92084",
    "phone": "760-936-4010",
    "hours": "Call for hours",
    "lat": 33.21968,
    "lng": -117.226
  },
  {
    "id": "18150",
    "name": "SPROUTS",
    "address": "Marconi Avenue 2735, Sacramento, CA, 95821",
    "phone": "916-999-3410",
    "hours": "Call for hours",
    "lat": 38.61806,
    "lng": -121.399
  },
  {
    "id": "18149",
    "name": "SPROUTS",
    "address": "East Capitol Expressway 1771, San Jose, CA, 95121",
    "phone": "669-234-5260",
    "hours": "Call for hours",
    "lat": 37.3086,
    "lng": -121.81
  },
  {
    "id": "18148",
    "name": "SPROUTS",
    "address": "Helen Power Drive 1041, Vacaville, CA, 95687",
    "phone": "707-301-4300",
    "hours": "Call for hours",
    "lat": 38.36534,
    "lng": -121.962
  },
  {
    "id": "18147",
    "name": "SPROUTS",
    "address": "East Harney Lane 250, Lodi, CA, 95240",
    "phone": "209-371-6656",
    "hours": "Call for hours",
    "lat": 38.10143,
    "lng": -121.268
  },
  {
    "id": "18146",
    "name": "SPROUTS",
    "address": "Mira Mesa Boulevard 8142, San Diego, CA, 92126",
    "phone": "858-880-0210",
    "hours": "Call for hours",
    "lat": 32.91272,
    "lng": -117.147
  },
  {
    "id": "18145",
    "name": "SPROUTS",
    "address": "South Highland Avenue 16964, Fontana, CA, 92336",
    "phone": "909-320-5360",
    "hours": "Call for hours",
    "lat": 34.13381,
    "lng": -117.434
  },
  {
    "id": "18144",
    "name": "SPROUTS",
    "address": "Ferrari Ranch Road 115, Lincoln, CA, 95648",
    "phone": "916-209-5346",
    "hours": "Call for hours",
    "lat": 38.87424,
    "lng": -121.304
  },
  {
    "id": "18143",
    "name": "SPROUTS",
    "address": "Madonna Road 313, San Luis Obispo, CA, 93405",
    "phone": "805-858-3350",
    "hours": "Call for hours",
    "lat": 35.26114,
    "lng": -120.678
  },
  {
    "id": "18142",
    "name": "SPROUTS",
    "address": "South Street 11900, Cerritos, CA, 90703",
    "phone": "562-274-0602",
    "hours": "Call for hours",
    "lat": 33.85839,
    "lng": -118.079
  },
  {
    "id": "18141",
    "name": "SPROUTS",
    "address": "Jarvis Avenue 6399, Newark, CA, 94560",
    "phone": "510-789-0361",
    "hours": "Call for hours",
    "lat": 37.54794,
    "lng": -122.052
  },
  {
    "id": "18140",
    "name": "SPROUTS",
    "address": "Carnelian Street 6753, Rancho Cucamonga, CA, 91701",
    "phone": "909-296-3094",
    "hours": "Call for hours",
    "lat": 34.13171,
    "lng": -117.616
  },
  {
    "id": "18139",
    "name": "SPROUTS",
    "address": "Del Paso Road 2810, Sacramento, CA, 95834",
    "phone": "916-431-1111",
    "hours": "Call for hours",
    "lat": 38.656,
    "lng": -121.524
  },
  {
    "id": "18138",
    "name": "SPROUTS",
    "address": "West Stuart Avenue 560, Redlands, CA, 92374",
    "phone": "909-283-7162",
    "hours": "Call for hours",
    "lat": 34.06087,
    "lng": -117.189
  },
  {
    "id": "18137",
    "name": "SPROUTS",
    "address": "South Diamond Bar Boulevard 239, Diamond Bar, CA, 91765",
    "phone": "909-378-4980",
    "hours": "Call for hours",
    "lat": 34.02149,
    "lng": -117.81
  },
  {
    "id": "18136",
    "name": "SPROUTS",
    "address": "South State Road 7 820, Wellington, FL, 33414",
    "phone": "561-515-8625",
    "hours": "Call for hours",
    "lat": 26.66567,
    "lng": -80.2008
  },
  {
    "id": "18135",
    "name": "SPROUTS",
    "address": "Las Posas Road 2400, Camarillo, CA, 93010",
    "phone": "805-233-3755",
    "hours": "Call for hours",
    "lat": 34.23675,
    "lng": -119.038
  },
  {
    "id": "18134",
    "name": "SPROUTS",
    "address": "Foothill Boulevard 1375, LaVerne, CA, 91750",
    "phone": "909-582-2836",
    "hours": "Call for hours",
    "lat": 34.1178,
    "lng": -117.778
  },
  {
    "id": "18133",
    "name": "SPROUTS",
    "address": "Clairemont Drive 3015, San Diego, CA, 92117",
    "phone": "619-764-6015",
    "hours": "Call for hours",
    "lat": 32.79458,
    "lng": -117.194
  },
  {
    "id": "18132",
    "name": "SPROUTS",
    "address": "Gateway Road 2634, Carlsbad, CA, 92009",
    "phone": "760-827-8916",
    "hours": "Call for hours",
    "lat": 33.12758,
    "lng": -117.255
  },
  {
    "id": "18131",
    "name": "SPROUTS",
    "address": "Telephone Road 4870, Ventura, CA, 93003",
    "phone": "805-941-4013",
    "hours": "Call for hours",
    "lat": 34.26338,
    "lng": -119.226
  },
  {
    "id": "18130",
    "name": "SPROUTS",
    "address": "East Bidwell Street 905, Folsom, CA, 95630",
    "phone": "916-605-7050",
    "hours": "Call for hours",
    "lat": 38.66953,
    "lng": -121.155
  },
  {
    "id": "18129",
    "name": "SPROUTS",
    "address": "Cochran Street 2800, Simi Valley, CA, 93065",
    "phone": "805-422-3363",
    "hours": "Call for hours",
    "lat": 34.27892,
    "lng": -118.742
  },
  {
    "id": "18128",
    "name": "SPROUTS",
    "address": "North Fairview Avenue 175, Goleta, CA, 93117",
    "phone": "805-979-9589",
    "hours": "Call for hours",
    "lat": 34.44259,
    "lng": -119.831
  },
  {
    "id": "18127",
    "name": "SPROUTS",
    "address": "Venice Boulevard 8985, Los Angeles, CA, 90034",
    "phone": "424-361-6611",
    "hours": "Call for hours",
    "lat": 34.02711,
    "lng": -118.393
  },
  {
    "id": "18126",
    "name": "SPROUTS",
    "address": "South Grand Avenue 655, Glendora, CA, 91740",
    "phone": "626-250-6625",
    "hours": "Call for hours",
    "lat": 34.12619,
    "lng": -117.873
  },
  {
    "id": "18125",
    "name": "SPROUTS",
    "address": "Paseo del Sur 16415, San Diego, CA, 92127",
    "phone": "858-798-8232",
    "hours": "Call for hours",
    "lat": 33.01989,
    "lng": -117.124
  },
  {
    "id": "18124",
    "name": "SPROUTS",
    "address": "Douglas Boulevard 2030, Roseville, CA, 95661",
    "phone": "916-462-5047",
    "hours": "Call for hours",
    "lat": 38.7442,
    "lng": -121.25
  },
  {
    "id": "18123",
    "name": "SPROUTS",
    "address": "East Main Street 150, Alhambra, CA, 91801",
    "phone": "626-863-1096",
    "hours": "Call for hours",
    "lat": 34.09542,
    "lng": -118.125
  },
  {
    "id": "18122",
    "name": "SPROUTS",
    "address": "East Brokaw Road 1028, San Jose, CA, 95131",
    "phone": "408-490-3041",
    "hours": "Call for hours",
    "lat": 37.3827,
    "lng": -121.897
  },
  {
    "id": "18121",
    "name": "SPROUTS",
    "address": "Herndon Avenue 850, Clovis, CA, 93612",
    "phone": "559-326-1169",
    "hours": "Call for hours",
    "lat": 36.83731,
    "lng": -119.699
  },
  {
    "id": "18120",
    "name": "SPROUTS",
    "address": "Sand Creek Road 2325, Brentwood, CA, 94513",
    "phone": "925-308-1965",
    "hours": "Call for hours",
    "lat": 37.94358,
    "lng": -121.735
  },
  {
    "id": "18119",
    "name": "SPROUTS",
    "address": "Yosemite Drive 2245, Eagle Rock, CA, 90041",
    "phone": "323-423-1128",
    "hours": "Call for hours",
    "lat": 34.13542,
    "lng": -118.216
  },
  {
    "id": "18118",
    "name": "SPROUTS",
    "address": "Pinole Valley Road 1300, Pinole, CA, 94564",
    "phone": "510-640-8111",
    "hours": "Call for hours",
    "lat": 37.99961,
    "lng": -122.287
  },
  {
    "id": "18117",
    "name": "SPROUTS",
    "address": "South Nevada Avenue 1720, Colorado Springs, CO, 80905",
    "phone": "719-719-1957",
    "hours": "Call for hours",
    "lat": 38.80935,
    "lng": -104.822
  },
  {
    "id": "18116",
    "name": "SPROUTS",
    "address": "Tower Road 5670, Denver, CO, 80249",
    "phone": "720-850-5026",
    "hours": "Call for hours",
    "lat": 39.79956,
    "lng": -104.772
  },
  {
    "id": "18115",
    "name": "SPROUTS",
    "address": "North Central Park Boulevard 3555, Denver, CO, 80238",
    "phone": "720-780-6422",
    "hours": "Call for hours",
    "lat": 39.76634,
    "lng": -104.891
  },
  {
    "id": "18114",
    "name": "SPROUTS",
    "address": "West 64th Avenue 15050, Arvada, CO, 80007",
    "phone": "303-801-4570",
    "hours": "Call for hours",
    "lat": 39.81257,
    "lng": -105.168
  },
  {
    "id": "18113",
    "name": "SPROUTS",
    "address": "Barnes Road 5617, Colorado Springs, CO, 80917",
    "phone": "719-313-4405",
    "hours": "Call for hours",
    "lat": 38.8942,
    "lng": -104.723
  },
  {
    "id": "18112",
    "name": "SPROUTS",
    "address": "North Lincoln Avenue 1440, Loveland, CO, 80538",
    "phone": "970-800-5607",
    "hours": "Call for hours",
    "lat": 40.4077,
    "lng": -105.073
  },
  {
    "id": "18111",
    "name": "SPROUTS",
    "address": "Voyager Parkway 13415, Colorado Springs, CO, 80921",
    "phone": "719-884-7900",
    "hours": "Call for hours",
    "lat": 39.02658,
    "lng": -104.814
  },
  {
    "id": "18110",
    "name": "SPROUTS",
    "address": "East Mississippi Avenue 197, Denver, CO, 80209",
    "phone": "720-458-2873",
    "hours": "Call for hours",
    "lat": 39.69671,
    "lng": -104.985
  },
  {
    "id": "18109",
    "name": "SPROUTS",
    "address": "Wadsworth Boulevard 98, Lakewood, CO, 80226",
    "phone": "303-957-9276",
    "hours": "Call for hours",
    "lat": 39.71833,
    "lng": -105.081
  },
  {
    "id": "18108",
    "name": "SPROUTS",
    "address": "Kipling Street 3725, Wheat Ridge, CO, 80033",
    "phone": "720-305-0219",
    "hours": "Call for hours",
    "lat": 39.76836,
    "lng": -105.11
  },
  {
    "id": "18107",
    "name": "SPROUTS",
    "address": "South Broadway 5001, Englewood, CO, 80113",
    "phone": "720-612-6595",
    "hours": "Call for hours",
    "lat": 39.62586,
    "lng": -104.988
  },
  {
    "id": "18106",
    "name": "SPROUTS",
    "address": "West Independent Avenue 1450, Grand Junction, CO, 81505",
    "phone": "970-549-3001",
    "hours": "Call for hours",
    "lat": 39.08017,
    "lng": -108.587
  },
  {
    "id": "18105",
    "name": "SPROUTS",
    "address": "South Hover Street 1101, Longmont, CO, 80501",
    "phone": "303-834-4124",
    "hours": "Call for hours",
    "lat": 40.14822,
    "lng": -105.131
  },
  {
    "id": "18104",
    "name": "SPROUTS",
    "address": "East Colfax Avenue 3625, Denver, CO, 80206",
    "phone": "720-347-4205",
    "hours": "Call for hours",
    "lat": 39.74024,
    "lng": -104.945
  },
  {
    "id": "18103",
    "name": "SPROUTS",
    "address": "East 120th Avenue 1131, Thornton, CO, 80233",
    "phone": "303-457-3600",
    "hours": "Call for hours",
    "lat": 39.91685,
    "lng": -104.973
  },
  {
    "id": "18102",
    "name": "SPROUTS",
    "address": "West Cross Drive 8601, Littleton, CO, 80123",
    "phone": "720-214-0410",
    "hours": "Call for hours",
    "lat": 39.6148,
    "lng": -105.096
  },
  {
    "id": "18101",
    "name": "SPROUTS",
    "address": "West South Boulder Road 555, Lafayette, CO, 80026",
    "phone": "303-664-1902",
    "hours": "Call for hours",
    "lat": 39.98875,
    "lng": -105.096
  },
  {
    "id": "18100",
    "name": "SPROUTS",
    "address": "East County Line Road 1980, Highlands Ranch, CO, 80126",
    "phone": "303-243-5060",
    "hours": "Call for hours",
    "lat": 39.56602,
    "lng": -104.965
  },
  {
    "id": "18099",
    "name": "SPROUTS",
    "address": "East Briarwood Circle 15405, Aurora, CO, 80016",
    "phone": "303-690-4600",
    "hours": "Call for hours",
    "lat": 39.59397,
    "lng": -104.809
  },
  {
    "id": "18098",
    "name": "SPROUTS",
    "address": "East Arapahoe Road 8557, Greenwood Village, CO, 80112",
    "phone": "303-721-1400",
    "hours": "Call for hours",
    "lat": 39.59504,
    "lng": -104.889
  },
  {
    "id": "18097",
    "name": "SPROUTS",
    "address": "South Lemay Avenue 2601, Fort Collins, CO, 80525",
    "phone": "970-282-8003",
    "hours": "Call for hours",
    "lat": 40.55185,
    "lng": -105.06
  },
  {
    "id": "18096",
    "name": "SPROUTS",
    "address": "South Colorado Boulevard 2880, Denver, CO, 80222",
    "phone": "303-758-4400",
    "hours": "Call for hours",
    "lat": 39.66465,
    "lng": -104.941
  },
  {
    "id": "18095",
    "name": "SPROUTS",
    "address": "West 38th Avenue 4700, Denver, CO, 80212",
    "phone": "303-433-2350",
    "hours": "Call for hours",
    "lat": 39.76928,
    "lng": -105.048
  },
  {
    "id": "18094",
    "name": "SPROUTS",
    "address": "Dublin Boulevard 1730, Colorado Springs, CO, 80918",
    "phone": "719-590-8890",
    "hours": "Call for hours",
    "lat": 38.9258,
    "lng": -104.794
  },
  {
    "id": "18093",
    "name": "SPROUTS",
    "address": "Arapahoe Avenue 2525, Boulder, CO, 80302",
    "phone": "303-449-0777",
    "hours": "Call for hours",
    "lat": 40.01523,
    "lng": -105.262
  },
  {
    "id": "18092",
    "name": "SPROUTS",
    "address": "Wadsworth Boulevard 7725, Arvada, CO, 80003",
    "phone": "303-463-4828",
    "hours": "Call for hours",
    "lat": 39.83742,
    "lng": -105.082
  },
  {
    "id": "18091",
    "name": "SPROUTS",
    "address": "Commons Street 10018, Lone Tree, CO, 80124",
    "phone": "720-279-6616",
    "hours": "Call for hours",
    "lat": 39.53419,
    "lng": -104.88
  },
  {
    "id": "18090",
    "name": "SPROUTS",
    "address": "West 29th Street, Greeley, CO, 80634",
    "phone": "970-576-3050",
    "hours": "Call for hours",
    "lat": 40.39005,
    "lng": -104.788
  },
  {
    "id": "18089",
    "name": "SPROUTS",
    "address": "Allen Way 5650, Castle Rock, CO, 80108",
    "phone": "720-305-0684",
    "hours": "Call for hours",
    "lat": 39.41524,
    "lng": -104.864
  },
  {
    "id": "18088",
    "name": "SPROUTS",
    "address": "East Smoky Hill Road 20831, Centennial, CO, 80015",
    "phone": "720-305-0959",
    "hours": "Call for hours",
    "lat": 39.60824,
    "lng": -104.746
  },
  {
    "id": "18087",
    "name": "SPROUTS",
    "address": "South Ironton Street 1150, Aurora, CO, 80012",
    "phone": "720-278-2008",
    "hours": "Call for hours",
    "lat": 39.696,
    "lng": -104.863
  },
  {
    "id": "18086",
    "name": "SPROUTS",
    "address": "Baseline Road 2950, Boulder, CO, 80303",
    "phone": "720-279-6758",
    "hours": "Call for hours",
    "lat": 39.9997,
    "lng": -105.254
  },
  {
    "id": "18085",
    "name": "SPROUTS",
    "address": "Corbett Drive 4345, Fort Collins, CO, 80525",
    "phone": "970-416-3350",
    "hours": "Call for hours",
    "lat": 40.52662,
    "lng": -105.027
  },
  {
    "id": "18084",
    "name": "SPROUTS",
    "address": "South Parker Road 9751, Parker, CO, 80134",
    "phone": "720-475-8684",
    "hours": "Call for hours",
    "lat": 39.50647,
    "lng": -104.763
  },
  {
    "id": "18083",
    "name": "SPROUTS",
    "address": "West 120th Avenue 5150, Westminster, CO, 80020",
    "phone": "303-803-1010",
    "hours": "Call for hours",
    "lat": 39.91431,
    "lng": -105.052
  },
  {
    "id": "18082",
    "name": "SPROUTS",
    "address": "Camino de Estrella 550, San Clemente, CA, 92672",
    "phone": "949-542-1036",
    "hours": "Call for hours",
    "lat": 33.4568,
    "lng": -117.656
  },
  {
    "id": "18081",
    "name": "SPROUTS",
    "address": "Irwin Street 655, San Rafael, CA, 94901",
    "phone": "415-524-1159",
    "hours": "Call for hours",
    "lat": 37.96783,
    "lng": -122.522
  },
  {
    "id": "18080",
    "name": "SPROUTS",
    "address": "West Imperial Highway 1431, La Habra, CA, 90631",
    "phone": "562-265-2151",
    "hours": "Call for hours",
    "lat": 33.91726,
    "lng": -117.967
  },
  {
    "id": "18079",
    "name": "SPROUTS",
    "address": "North La Brea Avenue 915, Los Angeles, CA, 90038",
    "phone": "323-217-1642",
    "hours": "Call for hours",
    "lat": 34.08742,
    "lng": -118.344
  },
  {
    "id": "18078",
    "name": "SPROUTS",
    "address": "Monroe Street 1075, Albany, CA, 94706",
    "phone": "510-345-0461",
    "hours": "Call for hours",
    "lat": 37.88436,
    "lng": -122.298
  },
  {
    "id": "18077",
    "name": "SPROUTS",
    "address": "El Camino Real 2060, Santa Clara, CA, 95050",
    "phone": "408-780-7248",
    "hours": "Call for hours",
    "lat": 37.35219,
    "lng": -121.961
  },
  {
    "id": "18076",
    "name": "SPROUTS",
    "address": "West Foothill Boulevard 847, Upland, CA, 91786",
    "phone": "909-912-1461",
    "hours": "Call for hours",
    "lat": 34.10706,
    "lng": -117.662
  },
  {
    "id": "18075",
    "name": "SPROUTS",
    "address": "Stockdale Highway 10650, Bakersfield, CA, 93311",
    "phone": "661-617-8957",
    "hours": "Call for hours",
    "lat": 35.35227,
    "lng": -119.118
  },
  {
    "id": "18074",
    "name": "SPROUTS",
    "address": "Broadway 3035, Oakland, CA, 94611",
    "phone": "510-851-7688",
    "hours": "Call for hours",
    "lat": 37.81897,
    "lng": -122.262
  },
  {
    "id": "18073",
    "name": "SPROUTS",
    "address": "Crow Canyon Place 3181, San Ramon, CA, 94583",
    "phone": "925-302-1395",
    "hours": "Call for hours",
    "lat": 37.77761,
    "lng": -121.971
  },
  {
    "id": "18072",
    "name": "SPROUTS",
    "address": "Warner Avenue 6942, Huntington Beach, CA, 92647",
    "phone": "714-369-1160",
    "hours": "Call for hours",
    "lat": 33.71539,
    "lng": -118.008
  },
  {
    "id": "18071",
    "name": "SPROUTS",
    "address": "Gellert Boulevard 301, Daly City, CA, 94015",
    "phone": "415-325-1091",
    "hours": "Call for hours",
    "lat": 37.664,
    "lng": -122.469
  },
  {
    "id": "18070",
    "name": "SPROUTS",
    "address": "Westwood Boulevard 1751, Los Angeles, CA, 90024",
    "phone": "310-500-1192",
    "hours": "Call for hours",
    "lat": 34.05078,
    "lng": -118.438
  },
  {
    "id": "18069",
    "name": "SPROUTS",
    "address": "Kenilworth Drive 401, Petaluma, CA, 94952",
    "phone": "707-789-4976",
    "hours": "Call for hours",
    "lat": 38.24449,
    "lng": -122.628
  },
  {
    "id": "18068",
    "name": "SPROUTS",
    "address": "North Blackstone Avenue 7477, Fresno, CA, 93720",
    "phone": "559-256-1735",
    "hours": "Call for hours",
    "lat": 36.84483,
    "lng": -119.793
  },
  {
    "id": "18067",
    "name": "SPROUTS",
    "address": "Fallbrook Avenue 6607, West Hills, CA, 91307",
    "phone": "818-867-2104",
    "hours": "Call for hours",
    "lat": 34.19006,
    "lng": -118.623
  },
  {
    "id": "18066",
    "name": "SPROUTS",
    "address": "Branham Lane 1130, San Jose, CA, 95118",
    "phone": "408-833-1152",
    "hours": "Call for hours",
    "lat": 37.26271,
    "lng": -121.878
  },
  {
    "id": "18065",
    "name": "SPROUTS",
    "address": "Prospect Road 5205, San Jose, CA, 95129",
    "phone": "408-725-3970",
    "hours": "Call for hours",
    "lat": 37.2929,
    "lng": -121.993
  },
  {
    "id": "18064",
    "name": "SPROUTS",
    "address": "Del Rio Road 4408, Roseville, CA, 95822",
    "phone": "916-455-4200",
    "hours": "Call for hours",
    "lat": 38.53726,
    "lng": -121.504
  },
  {
    "id": "18063",
    "name": "SPROUTS",
    "address": "Roseville Square 424, Roseville, CA, 95678",
    "phone": "916-960-1201",
    "hours": "Call for hours",
    "lat": 38.74488,
    "lng": -121.276
  },
  {
    "id": "18062",
    "name": "SPROUTS",
    "address": "McHenry Avenue 1700, Modesto, CA, 95350",
    "phone": "209-527-7575",
    "hours": "Call for hours",
    "lat": 37.6702,
    "lng": -120.994
  },
  {
    "id": "18061",
    "name": "SPROUTS",
    "address": "Whittier Boulevard 15801, Whittier, CA, 90603",
    "phone": "562-265-2109",
    "hours": "Call for hours",
    "lat": 33.94376,
    "lng": -117.992
  },
  {
    "id": "18060",
    "name": "SPROUTS",
    "address": "Greenback Lane 7905, Citrus Heights, CA, 95610",
    "phone": "916-560-2000",
    "hours": "Call for hours",
    "lat": 38.67851,
    "lng": -121.271
  },
  {
    "id": "18059",
    "name": "SPROUTS",
    "address": "Old Canal Road 22401, Yorba Linda, CA, 92887",
    "phone": "714-464-1824",
    "hours": "Call for hours",
    "lat": 33.87308,
    "lng": -117.746
  },
  {
    "id": "18058",
    "name": "SPROUTS",
    "address": "Foothill Boulevard 920, La Canada Flintridge, CA, 91011",
    "phone": "818-495-1103",
    "hours": "Call for hours",
    "lat": 34.20363,
    "lng": -118.199
  },
  {
    "id": "18057",
    "name": "SPROUTS",
    "address": "Woodruff Avenue 4253, Lakewood, CA, 90713",
    "phone": "562-739-2541",
    "hours": "Call for hours",
    "lat": 33.8348,
    "lng": -118.117
  },
  {
    "id": "18056",
    "name": "SPROUTS",
    "address": "Geary Road 1530, Walnut Creek, CA, 94597",
    "phone": "925-953-1113",
    "hours": "Call for hours",
    "lat": 37.92648,
    "lng": -122.065
  },
  {
    "id": "18055",
    "name": "SPROUTS",
    "address": "East 17th Street 225, Costa Mesa, CA, 92627",
    "phone": "949-698-1094",
    "hours": "Call for hours",
    "lat": 33.63408,
    "lng": -117.919
  },
  {
    "id": "18054",
    "name": "SPROUTS",
    "address": "West Huntington Drive 400, Monrovia, CA, 91016",
    "phone": "626-358-6845",
    "hours": "Call for hours",
    "lat": 34.14022,
    "lng": -118.008
  },
  {
    "id": "18053",
    "name": "SPROUTS",
    "address": "El Camino Real 3011, Tustin, CA, 92782",
    "phone": "714-734-8760",
    "hours": "Call for hours",
    "lat": 33.72278,
    "lng": -117.793
  },
  {
    "id": "18052",
    "name": "SPROUTS",
    "address": "Ventura Boulevard 21821, Woodland Hills, CA, 91364",
    "phone": "818-887-6473",
    "hours": "Call for hours",
    "lat": 34.1685,
    "lng": -118.603
  },
  {
    "id": "18051",
    "name": "SPROUTS",
    "address": "Mission Gorge Road 9361, Santee, CA, 92071",
    "phone": "619-562-0145",
    "hours": "Call for hours",
    "lat": 32.83859,
    "lng": -116.995
  },
  {
    "id": "18050",
    "name": "SPROUTS",
    "address": "West 13th Avenue 510, Escondido, CA, 92025",
    "phone": "760-743-1528",
    "hours": "Call for hours",
    "lat": 33.10803,
    "lng": -117.08
  },
  {
    "id": "18049",
    "name": "SPROUTS",
    "address": "North Western Avenue 820, San Pedro, CA, 90732",
    "phone": "310-831-7836",
    "hours": "Call for hours",
    "lat": 33.75036,
    "lng": -118.309
  },
  {
    "id": "18048",
    "name": "SPROUTS",
    "address": "Winchester Road 39606, Temecula, CA, 92591",
    "phone": "951-694-3680",
    "hours": "Call for hours",
    "lat": 33.54058,
    "lng": -117.144
  },
  {
    "id": "18047",
    "name": "SPROUTS",
    "address": "College Boulevard 471, Oceanside, CA, 92057",
    "phone": "760-726-7274",
    "hours": "Call for hours",
    "lat": 33.24943,
    "lng": -117.296
  },
  {
    "id": "18046",
    "name": "SPROUTS",
    "address": "Bernardo Heights Parkway 15727, San Diego, CA, 92128",
    "phone": "858-385-1606",
    "hours": "Call for hours",
    "lat": 33.00341,
    "lng": -117.059
  },
  {
    "id": "18045",
    "name": "SPROUTS",
    "address": "Hwy 79 South 32413, Temecula, CA, 92592",
    "phone": "951-303-0087",
    "hours": "Call for hours",
    "lat": 33.48099,
    "lng": -117.092
  },
  {
    "id": "18044",
    "name": "SPROUTS",
    "address": "Camino de Los Coches 3243, Carlsbad, CA, 92009",
    "phone": "760-635-0625",
    "hours": "Call for hours",
    "lat": 33.07572,
    "lng": -117.237
  },
  {
    "id": "18043",
    "name": "SPROUTS",
    "address": "Highway 111 79050, La Quinta, CA, 92253",
    "phone": "760-771-2485",
    "hours": "Call for hours",
    "lat": 33.7083,
    "lng": -116.285
  },
  {
    "id": "18042",
    "name": "SPROUTS",
    "address": "Day Creek Boulevard 7355, Rancho Cucamonga, CA, 91739",
    "phone": "909-803-5730",
    "hours": "Call for hours",
    "lat": 34.12063,
    "lng": -117.537
  },
  {
    "id": "18041",
    "name": "SPROUTS",
    "address": "South Harbor Boulevard 1447, Fullerton, CA, 92832",
    "phone": "714-441-1233",
    "hours": "Call for hours",
    "lat": 33.85588,
    "lng": -117.924
  },
  {
    "id": "18040",
    "name": "SPROUTS",
    "address": "West Ontario Avenue 120, Corona, CA, 92882",
    "phone": "951-371-4227",
    "hours": "Call for hours",
    "lat": 33.85632,
    "lng": -117.57
  },
  {
    "id": "18039",
    "name": "SPROUTS",
    "address": "Santa Margarita Parkway 27765, Mission Viejo, CA, 92691",
    "phone": "949-587-3003",
    "hours": "Call for hours",
    "lat": 33.65239,
    "lng": -117.646
  },
  {
    "id": "18038",
    "name": "SPROUTS",
    "address": "Grand Avenue 3630, Chino Hills, CA, 91709",
    "phone": "909-548-0440",
    "hours": "Call for hours",
    "lat": 34.00301,
    "lng": -117.727
  },
  {
    "id": "18037",
    "name": "SPROUTS",
    "address": "Harbor Boulevard 3030, Costa Mesa, CA, 92626",
    "phone": "714-751-6399",
    "hours": "Call for hours",
    "lat": 33.68174,
    "lng": -117.919
  },
  {
    "id": "18036",
    "name": "SPROUTS",
    "address": "El Camino Real 2618, Carlsbad, CA, 92008",
    "phone": "760-730-1123",
    "hours": "Call for hours",
    "lat": 33.17723,
    "lng": -117.326
  },
  {
    "id": "18035",
    "name": "SPROUTS",
    "address": "Yorba Linda Boulevard 17482, Yorba Linda, CA, 92886",
    "phone": "714-572-3535",
    "hours": "Call for hours",
    "lat": 33.88861,
    "lng": -117.827
  },
  {
    "id": "18034",
    "name": "SPROUTS",
    "address": "La Paz Road 27271, Laguna Niguel, CA, 92677",
    "phone": "949-349-1999",
    "hours": "Call for hours",
    "lat": 33.56741,
    "lng": -117.708
  },
  {
    "id": "18033",
    "name": "SPROUTS",
    "address": "North San Fernando Boulevard 1011, Burbank, CA, 91504",
    "phone": "818-566-4089",
    "hours": "Call for hours",
    "lat": 34.18805,
    "lng": -118.319
  },
  {
    "id": "18032",
    "name": "SPROUTS",
    "address": "West Florida Avenue 2207, Hemet, CA, 92545",
    "phone": "951-537-1975",
    "hours": "Call for hours",
    "lat": 33.74735,
    "lng": -116.995
  },
  {
    "id": "18031",
    "name": "SPROUTS",
    "address": "Genesee Avenue 4439, San Diego, CA, 92117",
    "phone": "858-268-2400",
    "hours": "Call for hours",
    "lat": 32.82409,
    "lng": -117.184
  },
  {
    "id": "18030",
    "name": "SPROUTS",
    "address": "Lemon Grove Avenue 3205, Lemon Grove, CA, 91945",
    "phone": "619-667-8686",
    "hours": "Call for hours",
    "lat": 32.74116,
    "lng": -117.03
  },
  {
    "id": "18029",
    "name": "SPROUTS",
    "address": "Governor Drive 3358, San Diego, CA, 92122",
    "phone": "858-457-5006",
    "hours": "Call for hours",
    "lat": 32.85091,
    "lng": -117.214
  },
  {
    "id": "18028",
    "name": "SPROUTS",
    "address": "Santa Monica Boulevard 8550, W. Hollywood, CA, 90069",
    "phone": "323-603-2599",
    "hours": "Call for hours",
    "lat": 34.0897,
    "lng": -118.376
  },
  {
    "id": "18027",
    "name": "SPROUTS",
    "address": "Lomas Santa Fe Drive 931, Solana Beach, CA, 92075",
    "phone": "858-350-7900",
    "hours": "Call for hours",
    "lat": 32.99413,
    "lng": -117.254
  },
  {
    "id": "18026",
    "name": "SPROUTS",
    "address": "Stevens Creek Boulevard 20558, Cupertino, CA, 95014",
    "phone": "408-780-7748",
    "hours": "Call for hours",
    "lat": 37.32272,
    "lng": -122.033
  },
  {
    "id": "18025",
    "name": "SPROUTS",
    "address": "Laguna Boulevard 8211, Elk Grove, CA, 95758",
    "phone": "916-478-9595",
    "hours": "Call for hours",
    "lat": 38.42219,
    "lng": -121.403
  },
  {
    "id": "18024",
    "name": "SPROUTS",
    "address": "Poway Road 13536, Poway, CA, 92064",
    "phone": "858-486-7851",
    "hours": "Call for hours",
    "lat": 32.95712,
    "lng": -117.037
  },
  {
    "id": "18023",
    "name": "SPROUTS",
    "address": "Rosecrans Street 3315, San Diego, CA, 92110",
    "phone": "619-523-3640",
    "hours": "Call for hours",
    "lat": 32.74857,
    "lng": -117.207
  },
  {
    "id": "18022",
    "name": "SPROUTS",
    "address": "Garnet Avenue 1260, San Diego, CA, 92109",
    "phone": "858-270-8200",
    "hours": "Call for hours",
    "lat": 32.79879,
    "lng": -117.247
  },
  {
    "id": "18021",
    "name": "SPROUTS",
    "address": "Park Boulevard 4175, San Diego, CA, 92103",
    "phone": "619-291-8287",
    "hours": "Call for hours",
    "lat": 32.75346,
    "lng": -117.146
  },
  {
    "id": "18020",
    "name": "SPROUTS",
    "address": "Palm Avenue 4630, La Mesa, CA, 91941",
    "phone": "619-460-7722",
    "hours": "Call for hours",
    "lat": 32.76284,
    "lng": -117.018
  },
  {
    "id": "18019",
    "name": "SPROUTS",
    "address": "Encinitas Boulevard 1327, Encinitas, CA, 92024",
    "phone": "760-633-4747",
    "hours": "Call for hours",
    "lat": 33.04459,
    "lng": -117.261
  },
  {
    "id": "18018",
    "name": "SPROUTS",
    "address": "North Zelzah Avenue 10821, Granada Hills, CA, 91344",
    "phone": "818-366-0717",
    "hours": "Call for hours",
    "lat": 34.26672,
    "lng": -118.524
  },
  {
    "id": "18017",
    "name": "SPROUTS",
    "address": "Hawthorne Boulevard 1515, Redondo Beach, CA, 90278",
    "phone": "424-903-7028",
    "hours": "Call for hours",
    "lat": 33.86879,
    "lng": -118.353
  },
  {
    "id": "18016",
    "name": "SPROUTS",
    "address": "Amador Plaza Road 7153, Dublin, CA, 94568",
    "phone": "925-307-1172",
    "hours": "Call for hours",
    "lat": 37.70745,
    "lng": -121.929
  },
  {
    "id": "18015",
    "name": "SPROUTS",
    "address": "South Westlake Boulevard 1012, Westlake, CA, 91361",
    "phone": "805-917-4200",
    "hours": "Call for hours",
    "lat": 34.1532,
    "lng": -118.828
  },
  {
    "id": "18014",
    "name": "SPROUTS",
    "address": "Stanford Ranch Road 6760, Roseville, CA, 95678",
    "phone": "916-774-1120",
    "hours": "Call for hours",
    "lat": 38.78036,
    "lng": -121.269
  },
  {
    "id": "18013",
    "name": "SPROUTS",
    "address": "Magic Mountain Parkway 24285, Valencia, CA, 91355",
    "phone": "661-414-1109",
    "hours": "Call for hours",
    "lat": 34.42017,
    "lng": -118.559
  },
  {
    "id": "18012",
    "name": "SPROUTS",
    "address": "North Rosemead Boulevard 39, Pasadena, CA, 91107",
    "phone": "626-696-1290",
    "hours": "Call for hours",
    "lat": 34.14718,
    "lng": -118.074
  },
  {
    "id": "18011",
    "name": "SPROUTS",
    "address": "San Antonio Road 630, Mountain View, CA, 94040",
    "phone": "650-397-3001",
    "hours": "Call for hours",
    "lat": 37.40205,
    "lng": -122.113
  },
  {
    "id": "18010",
    "name": "SPROUTS",
    "address": "East El Camino Real 111, Sunnyvale, CA, 94087",
    "phone": "408-702-1172",
    "hours": "Call for hours",
    "lat": 37.36746,
    "lng": -122.03
  },
  {
    "id": "18009",
    "name": "SPROUTS",
    "address": "Sepulveda Boulevard 5660, Culver City, CA, 90230",
    "phone": "310-591-1028",
    "hours": "Call for hours",
    "lat": 33.98926,
    "lng": -118.395
  },
  {
    "id": "18008",
    "name": "SPROUTS",
    "address": "Mowry Avenue 3900, Fremont, CA, 94538",
    "phone": "510-284-1050",
    "hours": "Call for hours",
    "lat": 37.54926,
    "lng": -121.988
  },
  {
    "id": "18007",
    "name": "SPROUTS",
    "address": "West Hillcrest Drive 600, Thousand Oaks, CA, 91360",
    "phone": "805-716-4373",
    "hours": "Call for hours",
    "lat": 34.18616,
    "lng": -118.887
  },
  {
    "id": "18006",
    "name": "SPROUTS",
    "address": "Carmel Mountain Road 11710, San Diego, CA, 92128",
    "phone": "858-798-7200",
    "hours": "Call for hours",
    "lat": 32.97958,
    "lng": -117.08
  },
  {
    "id": "18005",
    "name": "SPROUTS",
    "address": "Adams Avenue 9861, Huntington Beach, CA, 92646",
    "phone": "714-369-1139",
    "hours": "Call for hours",
    "lat": 33.67218,
    "lng": -117.96
  },
  {
    "id": "18004",
    "name": "SPROUTS",
    "address": "East Village Way 1500, Orange, CA, 92865",
    "phone": "714-464-1060",
    "hours": "Call for hours",
    "lat": 33.82619,
    "lng": -117.838
  },
  {
    "id": "18003",
    "name": "SPROUTS",
    "address": "Alessandro Boulevard 475, Riverside, CA, 92508",
    "phone": "951-565-5400",
    "hours": "Call for hours",
    "lat": 33.91416,
    "lng": -117.323
  },
  {
    "id": "18002",
    "name": "SPROUTS",
    "address": "East Birch Street 735, Brea, CA, 92821",
    "phone": "714-482-1000",
    "hours": "Call for hours",
    "lat": 33.91787,
    "lng": -117.889
  },
  {
    "id": "18001",
    "name": "SPROUTS",
    "address": "Seal Beach Boulevard 12301, Seal Beach, CA, 90740",
    "phone": "562-794-2125",
    "hours": "Call for hours",
    "lat": 33.78434,
    "lng": -118.072
  },
  {
    "id": "18000",
    "name": "SPROUTS",
    "address": "Holt Avenue 14945, Tustin, CA, 92780",
    "phone": "714-415-4381",
    "hours": "Call for hours",
    "lat": 33.74726,
    "lng": -117.814
  },
  {
    "id": "17999",
    "name": "SPROUTS",
    "address": "Alton Parkway 3775, Irvine, CA, 92606",
    "phone": "949-705-5435",
    "hours": "Call for hours",
    "lat": 33.68243,
    "lng": -117.814
  },
  {
    "id": "17998",
    "name": "SPROUTS",
    "address": "West Foothill Boulevard 835, Claremont, CA, 91711",
    "phone": "909-267-1049",
    "hours": "Call for hours",
    "lat": 34.10757,
    "lng": -117.73
  },
  {
    "id": "17997",
    "name": "SPROUTS",
    "address": "Pacific Coast Highway 4230, Torrance, CA, 90505",
    "phone": "424-903-7062",
    "hours": "Call for hours",
    "lat": 33.80778,
    "lng": -118.358
  },
  {
    "id": "17996",
    "name": "SPROUTS",
    "address": "South Las Posas Road 149, San Marcos, CA, 92078",
    "phone": "760-208-6041",
    "hours": "Call for hours",
    "lat": 33.14334,
    "lng": -117.191
  },
  {
    "id": "17995",
    "name": "SPROUTS",
    "address": "North 2nd Street 152, El Cajon, CA, 92021",
    "phone": "619-579-8251",
    "hours": "Call for hours",
    "lat": 32.79654,
    "lng": -116.936
  },
  {
    "id": "17994",
    "name": "SPROUTS",
    "address": "Nall Avenue 9628, Overland Park, KS, 66207",
    "phone": "913-643-9170",
    "hours": "Call for hours",
    "lat": 38.9547,
    "lng": -94.6491
  },
  {
    "id": "17993",
    "name": "SPROUTS",
    "address": "East Central Avenue 7728, Wichita, KS, 67206",
    "phone": "316-448-5254",
    "hours": "Call for hours",
    "lat": 37.69391,
    "lng": -97.2465
  },
  {
    "id": "17992",
    "name": "SPROUTS",
    "address": "Maurer Road 8550, Lenexa, KS, 66219",
    "phone": "913-312-1586",
    "hours": "Call for hours",
    "lat": 38.97343,
    "lng": -94.7716
  },
  {
    "id": "17991",
    "name": "SPROUTS",
    "address": "Bauer Farm Drive 4740, Lawrence, KS, 66049",
    "phone": "785-727-7314",
    "hours": "Call for hours",
    "lat": 38.97236,
    "lng": -95.3038
  },
  {
    "id": "17990",
    "name": "SPROUTS",
    "address": "West 135th Street 6821, Overland Park, KS, 66223",
    "phone": "913-643-4190",
    "hours": "Call for hours",
    "lat": 38.88366,
    "lng": -94.665
  },
  {
    "id": "17989",
    "name": "SPROUTS",
    "address": "East Interstate 30 469, Rockwall, TX, 75087",
    "phone": "254-269-4011",
    "hours": "Call for hours",
    "lat": 32.89404,
    "lng": -96.4723
  },
  {
    "id": "17988",
    "name": "SPROUTS",
    "address": "Dallas Parkway 17795, Dallas, TX, 75287",
    "phone": "469-865-1876",
    "hours": "Call for hours",
    "lat": 32.99658,
    "lng": -96.829
  },
  {
    "id": "17987",
    "name": "SPROUTS",
    "address": "Barbara Jordan Boulevard 1201, Austin, TX, 78723",
    "phone": "737-301-5648",
    "hours": "Call for hours",
    "lat": 30.3059,
    "lng": -97.7082
  },
  {
    "id": "17986",
    "name": "SPROUTS",
    "address": "State Hwy 151 9702, San Antonio, TX, 78251",
    "phone": "726-227-8068",
    "hours": "Call for hours",
    "lat": 29.44503,
    "lng": -98.673
  },
  {
    "id": "17985",
    "name": "SPROUTS",
    "address": "East Mockingbird Lane 6465, Dallas, TX, 75214",
    "phone": "945-219-3141",
    "hours": "Call for hours",
    "lat": 32.83693,
    "lng": -96.7516
  },
  {
    "id": "17984",
    "name": "SPROUTS",
    "address": "South Carrier Parkway 2500, Grand Prairie, TX, 75052",
    "phone": "469-870-7863",
    "hours": "Call for hours",
    "lat": 32.70788,
    "lng": -97.0161
  },
  {
    "id": "17983",
    "name": "SPROUTS",
    "address": "North MacArthur Boulevard 7730, Irving, TX, 75063",
    "phone": "972-232-7926",
    "hours": "Call for hours",
    "lat": 32.91141,
    "lng": -96.9589
  },
  {
    "id": "17982",
    "name": "SPROUTS",
    "address": "South Broadway Avenue 4015, Tyler, TX, 75701",
    "phone": "903-747-1118",
    "hours": "Call for hours",
    "lat": 32.30582,
    "lng": -95.3008
  },
  {
    "id": "17981",
    "name": "SPROUTS",
    "address": "North Town East Boulevard 1220, Mesquite, TX, 75150",
    "phone": "469-983-2045",
    "hours": "Call for hours",
    "lat": 32.81063,
    "lng": -96.6133
  },
  {
    "id": "17980",
    "name": "SPROUTS",
    "address": "Gateway Boulevard West 9801, El Paso, TX, 79925",
    "phone": "915-444-3585",
    "hours": "Call for hours",
    "lat": 31.76053,
    "lng": -106.357
  },
  {
    "id": "17979",
    "name": "SPROUTS",
    "address": "Eldorado Parkway 2500, Frisco, TX, 75033",
    "phone": "469-731-7261",
    "hours": "Call for hours",
    "lat": 33.17843,
    "lng": -96.87
  },
  {
    "id": "17978",
    "name": "SPROUTS",
    "address": "North Zaragoza Road 2036, El Paso, TX, 79938",
    "phone": "915-218-2954",
    "hours": "Call for hours",
    "lat": 31.76968,
    "lng": -106.259
  },
  {
    "id": "17977",
    "name": "SPROUTS",
    "address": "Skillman Street 7110, Dallas, TX, 75231",
    "phone": "469-210-8166",
    "hours": "Call for hours",
    "lat": 32.87608,
    "lng": -96.735
  },
  {
    "id": "17976",
    "name": "SPROUTS",
    "address": "Teasley Lane 4930, Denton, TX, 76210",
    "phone": "940-999-2263",
    "hours": "Call for hours",
    "lat": 33.1488,
    "lng": -97.1054
  },
  {
    "id": "17975",
    "name": "SPROUTS",
    "address": "West Exchange Parkway 1265, Allen, TX, 75013",
    "phone": "972-521-0057",
    "hours": "Call for hours",
    "lat": 33.11557,
    "lng": -96.6978
  },
  {
    "id": "17974",
    "name": "SPROUTS",
    "address": "Old Chocolate Bayou Road 2718, Pearland, TX, 77584",
    "phone": "713-482-3987",
    "hours": "Call for hours",
    "lat": 29.55876,
    "lng": -95.3478
  },
  {
    "id": "17973",
    "name": "SPROUTS",
    "address": "Lakeview Parkway 3001, Rowlett, TX, 75088",
    "phone": "972-265-0386",
    "hours": "Call for hours",
    "lat": 32.90743,
    "lng": -96.5746
  },
  {
    "id": "17972",
    "name": "SPROUTS",
    "address": "Waverly Way 6300, Fort Worth, TX, 76116",
    "phone": "682-747-5456",
    "hours": "Call for hours",
    "lat": 32.72444,
    "lng": -97.4182
  },
  {
    "id": "17971",
    "name": "SPROUTS",
    "address": "East Debbie Lane 1550, Mansfield, TX, 76063",
    "phone": "682-422-0061",
    "hours": "Call for hours",
    "lat": 32.60605,
    "lng": -97.1131
  },
  {
    "id": "17970",
    "name": "SPROUTS",
    "address": "Grapevine Highway 316, Hurst, TX, 76054",
    "phone": "682-325-5977",
    "hours": "Call for hours",
    "lat": 32.86903,
    "lng": -97.1717
  },
  {
    "id": "17969",
    "name": "SPROUTS",
    "address": "West Interstate 20 5711, Arlington, TX, 76017",
    "phone": "682-587-0086",
    "hours": "Call for hours",
    "lat": 32.67552,
    "lng": -97.1947
  },
  {
    "id": "17968",
    "name": "SPROUTS",
    "address": "Kuykendahl Road 20708, Spring, TX, 77379",
    "phone": "832-764-5424",
    "hours": "Call for hours",
    "lat": 30.07098,
    "lng": -95.5079
  },
  {
    "id": "17967",
    "name": "SPROUTS",
    "address": "South Lakeline Boulevard 1831, Cedar Park, TX, 78613",
    "phone": "512-279-8312",
    "hours": "Call for hours",
    "lat": 30.48098,
    "lng": -97.8296
  },
  {
    "id": "17966",
    "name": "SPROUTS",
    "address": "Yale Street 195, Houston, TX, 77007",
    "phone": "713-395-4590",
    "hours": "Call for hours",
    "lat": 29.77501,
    "lng": -95.4003
  },
  {
    "id": "17965",
    "name": "SPROUTS",
    "address": "S Main 2003, Keller, TX, 76248",
    "phone": "817-380-7024",
    "hours": "Call for hours",
    "lat": 32.89757,
    "lng": -97.2555
  },
  {
    "id": "17964",
    "name": "SPROUTS",
    "address": "Virginia Parkway 9241, McKinney, TX, 75071",
    "phone": "469-481-5000",
    "hours": "Call for hours",
    "lat": 33.2035,
    "lng": -96.7353
  },
  {
    "id": "17963",
    "name": "SPROUTS",
    "address": "North Highway 6 7055, Houston, TX, 77095",
    "phone": "832-575-2201",
    "hours": "Call for hours",
    "lat": 29.8807,
    "lng": -95.6467
  },
  {
    "id": "17962",
    "name": "SPROUTS",
    "address": "Tomball Parkway 22506, Houston, TX, 77070",
    "phone": "832-698-0004",
    "hours": "Call for hours",
    "lat": 30.01185,
    "lng": -95.5875
  },
  {
    "id": "17961",
    "name": "SPROUTS",
    "address": "Cinco Ranch Boulevard 23105, Katy, TX, 77494",
    "phone": "281-769-0444",
    "hours": "Call for hours",
    "lat": 29.74391,
    "lng": -95.7687
  },
  {
    "id": "17960",
    "name": "SPROUTS",
    "address": "North Henderson Avenue 1800, Dallas, TX, 75206",
    "phone": "214-826-2937",
    "hours": "Call for hours",
    "lat": 32.81098,
    "lng": -96.7739
  },
  {
    "id": "17959",
    "name": "SPROUTS",
    "address": "Manchaca Road 6920, Austin, TX, 78745",
    "phone": "512-687-2204",
    "hours": "Call for hours",
    "lat": 30.20247,
    "lng": -97.8082
  },
  {
    "id": "17958",
    "name": "SPROUTS",
    "address": "Quaker Avenue 8201, Lubbock, TX, 79424",
    "phone": "806-794-4900",
    "hours": "Call for hours",
    "lat": 33.51963,
    "lng": -101.905
  },
  {
    "id": "17957",
    "name": "SPROUTS",
    "address": "Bulverde Road 22135, San Antonio, TX, 78259",
    "phone": "210-350-3985",
    "hours": "Call for hours",
    "lat": 29.64661,
    "lng": -98.4278
  },
  {
    "id": "17956",
    "name": "SPROUTS",
    "address": "North 10th Street 5800, McAllen, TX, 78504",
    "phone": "956-331-2123",
    "hours": "Call for hours",
    "lat": 26.25536,
    "lng": -98.2211
  },
  {
    "id": "17955",
    "name": "SPROUTS",
    "address": "Sunland Park Drive 655, El Paso, TX, 79912",
    "phone": "915-833-3380",
    "hours": "Call for hours",
    "lat": 31.82111,
    "lng": -106.54
  },
  {
    "id": "17954",
    "name": "SPROUTS",
    "address": "Airline Road 1440, Corpus Christi, TX, 78412",
    "phone": "361-993-2850",
    "hours": "Call for hours",
    "lat": 27.70584,
    "lng": -97.3626
  },
  {
    "id": "17953",
    "name": "SPROUTS",
    "address": "Callaghan Road 8101, San Antonio, TX, 78230",
    "phone": "210-979-8121",
    "hours": "Call for hours",
    "lat": 29.51279,
    "lng": -98.5511
  },
  {
    "id": "17952",
    "name": "SPROUTS",
    "address": "South Lamar Boulevard 4006, Austin, TX, 78704",
    "phone": "512-444-3079",
    "hours": "Call for hours",
    "lat": 30.23695,
    "lng": -97.7919
  },
  {
    "id": "17951",
    "name": "SPROUTS",
    "address": "East Hebron Parkway 1745, Carrollton, TX, 75010",
    "phone": "972-428-5785",
    "hours": "Call for hours",
    "lat": 33.0248,
    "lng": -96.8875
  },
  {
    "id": "17950",
    "name": "SPROUTS",
    "address": "Southwest Loop 820 4650, Fort Worth, TX, 76109",
    "phone": "682-747-5790",
    "hours": "Call for hours",
    "lat": 32.68188,
    "lng": -97.3941
  },
  {
    "id": "17949",
    "name": "SPROUTS",
    "address": "East FM 1382 362, Cedar Hill, TX, 75104",
    "phone": "972-637-5108",
    "hours": "Call for hours",
    "lat": 32.59422,
    "lng": -96.939
  },
  {
    "id": "17948",
    "name": "SPROUTS",
    "address": "Research Boulevard 10225, Austin, TX, 78759",
    "phone": "512-225-9101",
    "hours": "Call for hours",
    "lat": 30.3946,
    "lng": -97.7447
  },
  {
    "id": "17947",
    "name": "SPROUTS",
    "address": "Bee Caves Road 2805, Rollingwood, TX, 78746",
    "phone": "512-439-5782",
    "hours": "Call for hours",
    "lat": 30.27113,
    "lng": -97.7888
  },
  {
    "id": "17946",
    "name": "SPROUTS",
    "address": "North Interstate 35 110, Round Rock, TX, 78681",
    "phone": "512-334-4684",
    "hours": "Call for hours",
    "lat": 30.50791,
    "lng": -97.6865
  },
  {
    "id": "17945",
    "name": "SPROUTS",
    "address": "Brodie Lane 5601, Sunset Valley, TX, 78745",
    "phone": "512-334-4175",
    "hours": "Call for hours",
    "lat": 30.22689,
    "lng": -97.8213
  },
  {
    "id": "17944",
    "name": "SPROUTS",
    "address": "West Sandy Lake Road 110, Coppell, TX, 75019",
    "phone": "972-350-8051",
    "hours": "Call for hours",
    "lat": 32.96943,
    "lng": -96.994
  },
  {
    "id": "17943",
    "name": "SPROUTS",
    "address": "East Fm 544 207, Murphy, TX, 75094",
    "phone": "972-265-4770",
    "hours": "Call for hours",
    "lat": 33.01331,
    "lng": -96.6083
  },
  {
    "id": "17942",
    "name": "SPROUTS",
    "address": "West Campbell Road 1343, Richardson, TX, 75080",
    "phone": "214-442-5961",
    "hours": "Call for hours",
    "lat": 32.97805,
    "lng": -96.7649
  },
  {
    "id": "17941",
    "name": "SPROUTS",
    "address": "Preston Road 5190, Frisco, TX, 75034",
    "phone": "972-464-5776",
    "hours": "Call for hours",
    "lat": 33.12223,
    "lng": -96.8057
  },
  {
    "id": "17940",
    "name": "SPROUTS",
    "address": "Davis Boulevard 220, Southlake, TX, 76092",
    "phone": "682-223-5805",
    "hours": "Call for hours",
    "lat": 32.93854,
    "lng": -97.1869
  },
  {
    "id": "17939",
    "name": "SPROUTS",
    "address": "Marsh Lane 11722, Dallas, TX, 75229",
    "phone": "214-350-0574",
    "hours": "Call for hours",
    "lat": 32.90839,
    "lng": -96.8526
  },
  {
    "id": "17938",
    "name": "SPROUTS",
    "address": "Cross Timbers Road 2301, Flower Mound, TX, 75028",
    "phone": "972-874-7380",
    "hours": "Call for hours",
    "lat": 33.03487,
    "lng": -97.0639
  },
  {
    "id": "17937",
    "name": "SPROUTS",
    "address": "Legacy Drive 4100, Plano, TX, 75024",
    "phone": "972-618-8902",
    "hours": "Call for hours",
    "lat": 33.07019,
    "lng": -96.7736
  },
  {
    "id": "17936",
    "name": "SPROUTS",
    "address": "North Gantzel Road 37666, Queen Creek, AZ, 85140",
    "phone": "520-614-0304",
    "hours": "Call for hours",
    "lat": 33.22471,
    "lng": -111.563
  },
  {
    "id": "17935",
    "name": "SPROUTS",
    "address": "S Landing Way 4800, Tucson, AZ, 85714",
    "phone": "520-524-0290",
    "hours": "Call for hours",
    "lat": 32.16525,
    "lng": -110.988
  },
  {
    "id": "17934",
    "name": "SPROUTS",
    "address": "North Prasada Parkway 13650, Surprise, AZ, 85388",
    "phone": "480-864-1358",
    "hours": "Call for hours",
    "lat": 33.60834,
    "lng": -112.417
  },
  {
    "id": "17933",
    "name": "SPROUTS",
    "address": "North John Wayne Parkway 20300, Maricopa, AZ, 85139",
    "phone": "520-532-1093",
    "hours": "Call for hours",
    "lat": 33.06437,
    "lng": -112.048
  },
  {
    "id": "17932",
    "name": "SPROUTS",
    "address": "East Carefree Highway 5355, Cave Creek, AZ, 85331",
    "phone": "480-637-4699",
    "hours": "Call for hours",
    "lat": 33.79874,
    "lng": -111.966
  },
  {
    "id": "17931",
    "name": "SPROUTS",
    "address": "South Signal Butte Road 1240, Mesa, AZ, 85209",
    "phone": "480-586-3710",
    "hours": "Call for hours",
    "lat": 33.3923,
    "lng": -111.598
  },
  {
    "id": "17930",
    "name": "SPROUTS",
    "address": "South Nogales Highway 18755, Green Valley, AZ, 85614",
    "phone": "520-729-3370",
    "hours": "Call for hours",
    "lat": 31.90854,
    "lng": -110.979
  },
  {
    "id": "17929",
    "name": "SPROUTS",
    "address": "North 7th Avenue 3320, Phoenix, AZ, 85013",
    "phone": "602-384-2650",
    "hours": "Call for hours",
    "lat": 33.48722,
    "lng": -112.085
  },
  {
    "id": "17928",
    "name": "SPROUTS",
    "address": "South 59th Avenue 7700, Laveen, AZ, 85339",
    "phone": "480-210-4896",
    "hours": "Call for hours",
    "lat": 33.37604,
    "lng": -112.188
  },
  {
    "id": "17927",
    "name": "SPROUTS",
    "address": "North Scottsdale Road 8787, Scottsdale, AZ, 85253",
    "phone": "480-534-3620",
    "hours": "Call for hours",
    "lat": 33.56432,
    "lng": -111.924
  },
  {
    "id": "17926",
    "name": "SPROUTS",
    "address": "Tempe, AZ, 85284",
    "phone": "480-567-7040",
    "hours": "Call for hours",
    "lat": 33.40323,
    "lng": -111.923
  },
  {
    "id": "17925",
    "name": "SPROUTS",
    "address": "East Longbow Parkway 5910, Mesa, AZ, 85215",
    "phone": "480-401-3870",
    "hours": "Call for hours",
    "lat": 33.47233,
    "lng": -111.703
  },
  {
    "id": "17924",
    "name": "SPROUTS",
    "address": "East Sheldon Street 174, Prescott, AZ, 86301",
    "phone": "928-499-3350",
    "hours": "Call for hours",
    "lat": 34.5455,
    "lng": -112.468
  },
  {
    "id": "17923",
    "name": "SPROUTS",
    "address": "South 4th Avenue 1590, Yuma, AZ, 85364",
    "phone": "928-388-6016",
    "hours": "Call for hours",
    "lat": 32.69874,
    "lng": -114.625
  },
  {
    "id": "17922",
    "name": "SPROUTS",
    "address": "East Baseline Road 2060, Mesa, AZ, 85204",
    "phone": "480-401-3758",
    "hours": "Call for hours",
    "lat": 33.3791,
    "lng": -111.788
  },
  {
    "id": "17921",
    "name": "SPROUTS",
    "address": "South Gilbert Road 4065, Chandler, AZ, 85249",
    "phone": "480-781-0088",
    "hours": "Call for hours",
    "lat": 33.24748,
    "lng": -111.789
  },
  {
    "id": "17920",
    "name": "SPROUTS",
    "address": "South Ellsworth Loop Road 21181, Queen Creek, AZ, 85142",
    "phone": "623-385-3213",
    "hours": "Call for hours",
    "lat": 33.25908,
    "lng": -111.638
  },
  {
    "id": "17919",
    "name": "SPROUTS",
    "address": "West Happy Valley Parkway 10134, Peoria, AZ, 85383",
    "phone": "602-385-3392",
    "hours": "Call for hours",
    "lat": 33.71302,
    "lng": -112.278
  },
  {
    "id": "17918",
    "name": "SPROUTS",
    "address": "East High Street 5455, Phoenix, AZ, 85054",
    "phone": "602-682-3200",
    "hours": "Call for hours",
    "lat": 33.67514,
    "lng": -111.964
  },
  {
    "id": "17917",
    "name": "SPROUTS",
    "address": "North Scottsdale Road 23269, Scottsdale, AZ, 85255",
    "phone": "480-295-4789",
    "hours": "Call for hours",
    "lat": 33.6976,
    "lng": -111.923
  },
  {
    "id": "17916",
    "name": "SPROUTS",
    "address": "East State Route 69 5645, Prescott Valley, AZ, 86314",
    "phone": "928-379-8000",
    "hours": "Call for hours",
    "lat": 34.57438,
    "lng": -112.364
  },
  {
    "id": "17915",
    "name": "SPROUTS",
    "address": "West Deer Valley Road 6760, Glendale, AZ, 85310",
    "phone": "623-385-4430",
    "hours": "Call for hours",
    "lat": 33.68192,
    "lng": -112.205
  },
  {
    "id": "17914",
    "name": "SPROUTS",
    "address": "South Riordan Ranch Street 1540, Flagstaff, AZ, 86001",
    "phone": "928-679-6000",
    "hours": "Call for hours",
    "lat": 35.18543,
    "lng": -111.66
  },
  {
    "id": "17913",
    "name": "SPROUTS",
    "address": "East Speedway Boulevard 4645, Tucson, AZ, 85712",
    "phone": "520-325-1320",
    "hours": "Call for hours",
    "lat": 32.23629,
    "lng": -110.894
  },
  {
    "id": "17912",
    "name": "SPROUTS",
    "address": "North 1st Avenue 4282, Tucson, AZ, 85719",
    "phone": "520-407-5132",
    "hours": "Call for hours",
    "lat": 32.28496,
    "lng": -110.961
  },
  {
    "id": "17911",
    "name": "SPROUTS",
    "address": "East Broadway Boulevard 7877, Tucson, AZ, 85710",
    "phone": "520-546-6112",
    "hours": "Call for hours",
    "lat": 32.22105,
    "lng": -110.824
  },
  {
    "id": "17910",
    "name": "SPROUTS",
    "address": "W River Road 3860, Tucson, AZ, 85741",
    "phone": "520-204-1787",
    "hours": "Call for hours",
    "lat": 32.32251,
    "lng": -111.044
  },
  {
    "id": "17909",
    "name": "SPROUTS",
    "address": "East Southern Avenue 1706, Tempe, AZ, 85282",
    "phone": "480-820-4900",
    "hours": "Call for hours",
    "lat": 33.39307,
    "lng": -111.911
  },
  {
    "id": "17908",
    "name": "SPROUTS",
    "address": "North Miller Road 4402, Scottsdale, AZ, 85251",
    "phone": "480-941-6001",
    "hours": "Call for hours",
    "lat": 33.49975,
    "lng": -111.918
  },
  {
    "id": "17907",
    "name": "SPROUTS",
    "address": "East Bell Road 245, Phoenix, AZ, 85022",
    "phone": "602-218-4949",
    "hours": "Call for hours",
    "lat": 33.64019,
    "lng": -112.071
  },
  {
    "id": "17906",
    "name": "SPROUTS",
    "address": "East Glendale Avenue 1625, Phoenix, AZ, 85020",
    "phone": "602-385-2150",
    "hours": "Call for hours",
    "lat": 33.5382,
    "lng": -112.045
  },
  {
    "id": "17905",
    "name": "SPROUTS",
    "address": "East Ray Road 4735, Phoenix, AZ, 85044",
    "phone": "480-295-4901",
    "hours": "Call for hours",
    "lat": 33.31975,
    "lng": -111.982
  },
  {
    "id": "17904",
    "name": "SPROUTS",
    "address": "South Alma School Road 2855, Chandler, AZ, 85286",
    "phone": "480-814-2700",
    "hours": "Call for hours",
    "lat": 33.26464,
    "lng": -111.856
  },
  {
    "id": "17903",
    "name": "SPROUTS",
    "address": "South Val Vista Drive 2582, Gilbert, AZ, 85295",
    "phone": "480-821-1511",
    "hours": "Call for hours",
    "lat": 33.30353,
    "lng": -111.756
  },
  {
    "id": "17902",
    "name": "SPROUTS",
    "address": "North Dysart Road 1813, Avondale, AZ, 85392",
    "phone": "623-535-8989",
    "hours": "Call for hours",
    "lat": 33.46641,
    "lng": -112.341
  },
  {
    "id": "17901",
    "name": "SPROUTS",
    "address": "West Bell Road 13759, Surprise, AZ, 85374",
    "phone": "623-544-3121",
    "hours": "Call for hours",
    "lat": 33.6385,
    "lng": -112.355
  },
  {
    "id": "17900",
    "name": "SPROUTS",
    "address": "North Oracle Road 7665, Oro Valley, AZ, 85704",
    "phone": "520-297-5446",
    "hours": "Call for hours",
    "lat": 32.34666,
    "lng": -110.978
  },
  {
    "id": "17899",
    "name": "SPROUTS",
    "address": "East Southern Avenue 5225, Mesa, AZ, 85206",
    "phone": "480-218-6491",
    "hours": "Call for hours",
    "lat": 33.39379,
    "lng": -111.719
  },
  {
    "id": "17898",
    "name": "SPROUTS",
    "address": "West Thunderbird Road 4201, Phoenix, AZ, 85053",
    "phone": "602-960-4587",
    "hours": "Call for hours",
    "lat": 33.61081,
    "lng": -112.15
  },
  {
    "id": "17897",
    "name": "SPROUTS",
    "address": "East Indian School Road 2824, Phoenix, AZ, 85016",
    "phone": "602-553-3131",
    "hours": "Call for hours",
    "lat": 33.49514,
    "lng": -112.021
  },
  {
    "id": "17896",
    "name": "SPROUTS",
    "address": "West Bell Road 5665, Glendale, AZ, 85308",
    "phone": "602-896-0300",
    "hours": "Call for hours",
    "lat": 33.63874,
    "lng": -112.181
  },
  {
    "id": "17895",
    "name": "SPROUTS",
    "address": "North 19th Avenue 8040, Phoenix, AZ, 85021",
    "phone": "602-864-6130",
    "hours": "Call for hours",
    "lat": 33.55389,
    "lng": -112.1
  },
  {
    "id": "17894",
    "name": "SPROUTS",
    "address": "West Thunderbird Road 8375, Peoria, AZ, 85381",
    "phone": "623-334-1111",
    "hours": "Call for hours",
    "lat": 33.60852,
    "lng": -112.239
  },
  {
    "id": "17893",
    "name": "SPROUTS",
    "address": "East Brown Road 1933, Mesa, AZ, 85203",
    "phone": "480-668-0800",
    "hours": "Call for hours",
    "lat": 33.4371,
    "lng": -111.789
  },
  {
    "id": "17892",
    "name": "SPROUTS",
    "address": "Montgomery Highway 1031, Vestavia Hills, AL, 35216",
    "phone": "205-484-0084",
    "hours": "Call for hours",
    "lat": 33.43897,
    "lng": -86.7889
  },
  {
    "id": "17891",
    "name": "SPROUTS",
    "address": "North Tatum Boulevard 12415, Phoenix, AZ, 85032",
    "phone": "602-971-4177",
    "hours": "Call for hours",
    "lat": 33.59951,
    "lng": -111.979
  },
  {
    "id": "17890",
    "name": "SPROUTS",
    "address": "East Shea Boulevard 9301, Scottsdale, AZ, 85260",
    "phone": "480-551-9665",
    "hours": "Call for hours",
    "lat": 33.58046,
    "lng": -111.88
  },
  {
    "id": "17889",
    "name": "SPROUTS",
    "address": "West Ray Road 1959, Chandler, AZ, 85224",
    "phone": "480-732-1012",
    "hours": "Call for hours",
    "lat": 33.3205,
    "lng": -111.875
  },
  {
    "id": "17888",
    "name": "SPROUTS",
    "address": "15793 Old Columbia Pike, Burtonsville, Maryland, 20866-1030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1151512,
    "lng": -76.9322038
  },
  {
    "id": "17887",
    "name": "SPROUTS",
    "address": "2000 Tamiami Trail, Unit 224, Port Charlotte, Florida, 33948",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0044065,
    "lng": -82.1281219
  },
  {
    "id": "17886",
    "name": "SPROUTS",
    "address": "2750 SW 27th Ter Ste 102, Miami, 33133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7406273,
    "lng": -80.2381712
  },
  {
    "id": "17885",
    "name": "SPROUTS",
    "address": "11066 Pacific Crest Place NW, Ste A150, Silverdale, WA, 98383",
    "phone": "360.900.4125",
    "hours": "Call for hours",
    "lat": 47.663023,
    "lng": -122.694095
  },
  {
    "id": "17884",
    "name": "SPROUTS",
    "address": "13010 Aurora Ave N, Seattle, WA, 98133",
    "phone": "206.337.4625",
    "hours": "Call for hours",
    "lat": 47.7237541,
    "lng": -122.3434494
  },
  {
    "id": "17883",
    "name": "SPROUTS",
    "address": "19630 Highway 99, Lynnwood, WA, 98036",
    "phone": "425.412.1946",
    "hours": "Call for hours",
    "lat": 47.8202075,
    "lng": -122.3188639
  },
  {
    "id": "17882",
    "name": "SPROUTS",
    "address": "13314 Bothell-Everett Highway, Mill Creek, WA, 98012",
    "phone": "425.332.6670",
    "hours": "Call for hours",
    "lat": 47.6621,
    "lng": -122.6981
  },
  {
    "id": "17881",
    "name": "SPROUTS",
    "address": "1401 Hilltop Dr, Redding, CA, 96003",
    "phone": "530.999.0988",
    "hours": "Call for hours",
    "lat": 47.7377,
    "lng": -122.3431
  },
  {
    "id": "17880",
    "name": "SPROUTS",
    "address": "2810 Del Paso Road, Sacramento, CA, 95834",
    "phone": "916.431.1111",
    "hours": "Call for hours",
    "lat": 47.8049,
    "lng": -122.2855
  },
  {
    "id": "17879",
    "name": "SPROUTS",
    "address": "4408 Del Rio Road, Roseville, CA, 95822",
    "phone": "916.455.4200",
    "hours": "Call for hours",
    "lat": 47.8401,
    "lng": -122.1972
  },
  {
    "id": "17878",
    "name": "SPROUTS",
    "address": "2735 Marconi Ave, Ste 100, Sacramento, CA, 95821",
    "phone": "916.999.3410",
    "hours": "Call for hours",
    "lat": 21.4505,
    "lng": -157.768
  },
  {
    "id": "17877",
    "name": "SPROUTS",
    "address": "1430 East Main Street, Woodland, CA, 95776",
    "phone": "530.631.7172",
    "hours": "Call for hours",
    "lat": 21.316,
    "lng": -157.8677
  },
  {
    "id": "17876",
    "name": "SPROUTS",
    "address": "8211 Laguna Blvd., Elk Grove, CA, 95758",
    "phone": "916.478.9595",
    "hours": "Call for hours",
    "lat": 21.3448,
    "lng": -157.9774
  },
  {
    "id": "17875",
    "name": "SPROUTS",
    "address": "1041 Helen Power Drive, Vacaville, CA, 95687",
    "phone": "707.301.4300",
    "hours": "Call for hours",
    "lat": 21.316,
    "lng": -157.8677
  },
  {
    "id": "17874",
    "name": "SPROUTS",
    "address": "424 Roseville Square, Roseville, CA, 95678",
    "phone": "916.960.1201",
    "hours": "Call for hours",
    "lat": 40.6278,
    "lng": -122.353
  },
  {
    "id": "17873",
    "name": "SPROUTS",
    "address": "6760 Stanford Ranch Road, Roseville, CA, 95678",
    "phone": "916.774.1120",
    "hours": "Call for hours",
    "lat": 38.6383,
    "lng": -121.5072
  },
  {
    "id": "17872",
    "name": "SPROUTS",
    "address": "10846 Bear Hollow Drive, Rancho Cordova, CA, 95670",
    "phone": "279.278.7553",
    "hours": "Call for hours",
    "lat": 38.5091,
    "lng": -121.4935
  },
  {
    "id": "17871",
    "name": "SPROUTS",
    "address": "2030 Douglas Blvd., Ste 9, Roseville, CA, 95661",
    "phone": "916.462.5047",
    "hours": "Call for hours",
    "lat": 38.6239,
    "lng": -121.3837
  },
  {
    "id": "17870",
    "name": "SPROUTS",
    "address": "115 Ferrari Ranch Road, Lincoln, CA, 95648",
    "phone": "916.209.5346",
    "hours": "Call for hours",
    "lat": 38.6808,
    "lng": -121.7411
  },
  {
    "id": "17869",
    "name": "SPROUTS",
    "address": "905 East Bidwell Street, Folsom, CA, 95630",
    "phone": "916.605.7050",
    "hours": "Call for hours",
    "lat": 38.4243,
    "lng": -121.437
  },
  {
    "id": "17868",
    "name": "SPROUTS",
    "address": "7905 Greenback Lane, Citrus Heights, CA, 95610",
    "phone": "916.560.2000",
    "hours": "Call for hours",
    "lat": 38.3482,
    "lng": -121.9538
  },
  {
    "id": "17867",
    "name": "SPROUTS",
    "address": "1700 McHenry Avenue, Modesto, CA, 95350",
    "phone": "209.527.7575",
    "hours": "Call for hours",
    "lat": 38.7609,
    "lng": -121.2867
  },
  {
    "id": "17866",
    "name": "SPROUTS",
    "address": "171 E Yosemite Avenue, Merced, CA, 95340",
    "phone": "209.720.1439",
    "hours": "Call for hours",
    "lat": 38.6072,
    "lng": -121.2761
  },
  {
    "id": "17865",
    "name": "SPROUTS",
    "address": "16576 Golden Valley Parkway, Lathrop, CA, 95330",
    "phone": "209.670.1663",
    "hours": "Call for hours",
    "lat": 38.7346,
    "lng": -121.234
  },
  {
    "id": "17864",
    "name": "SPROUTS",
    "address": "250 East Harney Lane, Lodi, CA, 95240",
    "phone": "209.371.6656",
    "hours": "Call for hours",
    "lat": 38.8942,
    "lng": -121.2908
  },
  {
    "id": "17863",
    "name": "SPROUTS",
    "address": "5308 Pacific Avenue, Suite #1040, Stockton, CA, 95207",
    "phone": "209.751.0474",
    "hours": "Call for hours",
    "lat": 38.6709,
    "lng": -121.1529
  },
  {
    "id": "17862",
    "name": "SPROUTS",
    "address": "1028 East Brokaw Road, San Jose, CA, 95131",
    "phone": "408.490.3041",
    "hours": "Call for hours",
    "lat": 38.6946,
    "lng": -121.2692
  },
  {
    "id": "17861",
    "name": "SPROUTS",
    "address": "5205 Prospect Road, San Jose, CA, 95129",
    "phone": "408.725.3970",
    "hours": "Call for hours",
    "lat": 37.6746,
    "lng": -121.0113
  },
  {
    "id": "17860",
    "name": "SPROUTS",
    "address": "1771 East Capitol Expressway, San Jose, CA, 95121",
    "phone": "669.234.5260",
    "hours": "Call for hours",
    "lat": 37.2983,
    "lng": -120.4649
  },
  {
    "id": "17859",
    "name": "SPROUTS",
    "address": "1130 Branham Lane, San Jose, CA, 95118",
    "phone": "408.833.1152",
    "hours": "Call for hours",
    "lat": 37.8209,
    "lng": -121.2827
  },
  {
    "id": "17858",
    "name": "SPROUTS",
    "address": "615 Coleman Avenue, San Jose, CA, 95110",
    "phone": "669.444.3186",
    "hours": "Call for hours",
    "lat": 38.1222,
    "lng": -121.2555
  },
  {
    "id": "17857",
    "name": "SPROUTS",
    "address": "2060 El Camino Real, Santa Clara, CA, 95050",
    "phone": "408.780.7248",
    "hours": "Call for hours",
    "lat": 38.0024,
    "lng": -121.3238
  },
  {
    "id": "17856",
    "name": "SPROUTS",
    "address": "20558 Stevens Creek Blvd, Cupertino, CA, 95014",
    "phone": "408.780.7748",
    "hours": "Call for hours",
    "lat": 37.3864,
    "lng": -121.88
  },
  {
    "id": "17855",
    "name": "SPROUTS",
    "address": "401 Kenilworth Drive, Ste. 1040, Petaluma, CA, 94952",
    "phone": "707.789.4976",
    "hours": "Call for hours",
    "lat": 37.3066,
    "lng": -122.0002
  },
  {
    "id": "17854",
    "name": "SPROUTS",
    "address": "655 Irwin Street, Ste A, San Rafael, CA, 94901",
    "phone": "415.524.1159",
    "hours": "Call for hours",
    "lat": 37.3042,
    "lng": -121.8099
  },
  {
    "id": "17853",
    "name": "SPROUTS",
    "address": "1075 Monroe Street, Albany, CA, 94706",
    "phone": "510.345.0461",
    "hours": "Call for hours",
    "lat": 37.2568,
    "lng": -121.8896
  },
  {
    "id": "17852",
    "name": "SPROUTS",
    "address": "3035 Broadway, Oakland, CA, 94611",
    "phone": "510.851.7688",
    "hours": "Call for hours",
    "lat": 37.3391,
    "lng": -121.9016
  },
  {
    "id": "17851",
    "name": "SPROUTS",
    "address": "1530 Geary Road, Walnut Creek, CA, 94597",
    "phone": "925.953.1113",
    "hours": "Call for hours",
    "lat": 37.3492,
    "lng": -121.953
  },
  {
    "id": "17850",
    "name": "SPROUTS",
    "address": "3181 Crow Canyon Place, Ste. A, San Ramon, CA, 94583",
    "phone": "925.302.1395",
    "hours": "Call for hours",
    "lat": 37.318,
    "lng": -122.0449
  },
  {
    "id": "17849",
    "name": "SPROUTS",
    "address": "7153 Amador Plaza Road, Dublin, CA, 94568",
    "phone": "925.307.1172",
    "hours": "Call for hours",
    "lat": 38.2403,
    "lng": -122.6777
  },
  {
    "id": "17848",
    "name": "SPROUTS",
    "address": "1300 Pinole Valley Road, Pinole, CA, 94564",
    "phone": "510.640.8111",
    "hours": "Call for hours",
    "lat": 37.9691,
    "lng": -122.5105
  },
  {
    "id": "17847",
    "name": "SPROUTS",
    "address": "6399 Jarvis Avenue, Newark, CA, 94560",
    "phone": "510.789.0361",
    "hours": "Call for hours",
    "lat": 37.89,
    "lng": -122.2954
  },
  {
    "id": "17846",
    "name": "SPROUTS",
    "address": "3900 Mowry Avenue, Fremont, CA, 94538",
    "phone": "510.284.1050",
    "hours": "Call for hours",
    "lat": 37.8471,
    "lng": -122.2223
  },
  {
    "id": "17845",
    "name": "SPROUTS",
    "address": "2325 Sand Creek Road, Brentwood, CA, 94513",
    "phone": "925.308.1965",
    "hours": "Call for hours",
    "lat": 37.9182,
    "lng": -122.0717
  },
  {
    "id": "17844",
    "name": "SPROUTS",
    "address": "111 East El Camino Real, Sunnyvale, CA, 94087",
    "phone": "408.702.1172",
    "hours": "Call for hours",
    "lat": 37.7562,
    "lng": -121.9522
  },
  {
    "id": "17843",
    "name": "SPROUTS",
    "address": "630 San Antonio Road, Mountain View, CA, 94040",
    "phone": "650.397.3001",
    "hours": "Call for hours",
    "lat": 37.7166,
    "lng": -121.9226
  },
  {
    "id": "17842",
    "name": "SPROUTS",
    "address": "301 Gellert Blvd, Daly City, CA, 94015",
    "phone": "415.325.1091",
    "hours": "Call for hours",
    "lat": 37.9969,
    "lng": -122.2875
  },
  {
    "id": "17841",
    "name": "SPROUTS",
    "address": "7477 North Blackstone, Fresno, CA, 93720",
    "phone": "559.256.1735",
    "hours": "Call for hours",
    "lat": 37.5368,
    "lng": -122.032
  },
  {
    "id": "17840",
    "name": "SPROUTS",
    "address": "850 Herndon Avenue, Ste 103, Clovis, CA, 93612",
    "phone": "559.326.1169",
    "hours": "Call for hours",
    "lat": 37.5308,
    "lng": -121.9712
  },
  {
    "id": "17839",
    "name": "SPROUTS",
    "address": "39258 10th Street West, Palmdale, CA, 93551",
    "phone": "661.485.1280",
    "hours": "Call for hours",
    "lat": 37.9324,
    "lng": -121.6894
  },
  {
    "id": "17838",
    "name": "SPROUTS",
    "address": "43668 15th St West, Lancaster, CA, 93534",
    "phone": "661.499.2651",
    "hours": "Call for hours",
    "lat": 37.3502,
    "lng": -122.0349
  },
  {
    "id": "17837",
    "name": "SPROUTS",
    "address": "313 Madonna Road, Ste A, San Luis Obispo, CA, 93405",
    "phone": "805.858.3350",
    "hours": "Call for hours",
    "lat": 37.3855,
    "lng": -122.088
  },
  {
    "id": "17836",
    "name": "SPROUTS",
    "address": "10650 Stockdale Highway, Ste. 400, Bakersfield, CA, 93311",
    "phone": "661.617.8957",
    "hours": "Call for hours",
    "lat": 37.6787,
    "lng": -122.478
  },
  {
    "id": "17835",
    "name": "SPROUTS",
    "address": "3501 South Mooney Blvd, Unit 120, Visalia, CA, 93277",
    "phone": "559.553.4044",
    "hours": "Call for hours",
    "lat": 36.8579,
    "lng": -119.7655
  },
  {
    "id": "17834",
    "name": "SPROUTS",
    "address": "175 North Fairview Avenue, Ste 120, Goleta, CA, 93117",
    "phone": "805.979.9589",
    "hours": "Call for hours",
    "lat": 36.8149,
    "lng": -119.7106
  },
  {
    "id": "17833",
    "name": "SPROUTS",
    "address": "29 South Milpas Street, Santa Barbara, CA, 93103",
    "phone": "805.837.0356",
    "hours": "Call for hours",
    "lat": 34.6017,
    "lng": -118.231
  },
  {
    "id": "17832",
    "name": "SPROUTS",
    "address": "2800 Cochran Street, Simi Valley, CA, 93065",
    "phone": "805.422.3363",
    "hours": "Call for hours",
    "lat": 34.6909,
    "lng": -118.1491
  },
  {
    "id": "17831",
    "name": "SPROUTS",
    "address": "2400 Las Posas Road, Ste A, Camarillo, CA, 93010",
    "phone": "805.233.3755",
    "hours": "Call for hours",
    "lat": 35.2901,
    "lng": -120.6817
  },
  {
    "id": "17830",
    "name": "SPROUTS",
    "address": "4870 Telephone Road, Ventura, CA, 93003",
    "phone": "805.941.4013",
    "hours": "Call for hours",
    "lat": 35.3039,
    "lng": -119.1056
  },
  {
    "id": "17829",
    "name": "SPROUTS",
    "address": "22401 Old Canal Road, Yorba Linda, CA, 92887",
    "phone": "714.464.1824",
    "hours": "Call for hours",
    "lat": 36.3114,
    "lng": -119.3065
  },
  {
    "id": "17828",
    "name": "SPROUTS",
    "address": "17482 Yorba Linda Blvd., Yorba Linda, CA, 92886",
    "phone": "714.572.3535",
    "hours": "Call for hours",
    "lat": 34.4296,
    "lng": -119.8612
  },
  {
    "id": "17827",
    "name": "SPROUTS",
    "address": "120 West Ontario Avenue, Corona, CA, 92882",
    "phone": "951.371.4227",
    "hours": "Call for hours",
    "lat": 34.4291,
    "lng": -119.6833
  },
  {
    "id": "17826",
    "name": "SPROUTS",
    "address": "13985 Limonite Avenue, Eastvale, CA, 92880",
    "phone": "909.655.5356",
    "hours": "Call for hours",
    "lat": 34.2656,
    "lng": -118.7653
  },
  {
    "id": "17825",
    "name": "SPROUTS",
    "address": "1500 East Village Way, Ste. #2279, Orange, CA, 92865",
    "phone": "714.464.1060",
    "hours": "Call for hours",
    "lat": 34.2313,
    "lng": -119.0464
  },
  {
    "id": "17824",
    "name": "SPROUTS",
    "address": "9838 Chapman Avenue, Garden Grove, CA, 92841",
    "phone": "657.427.6713",
    "hours": "Call for hours",
    "lat": 34.2846,
    "lng": -119.2222
  },
  {
    "id": "17823",
    "name": "SPROUTS",
    "address": "1447 South Harbor Blvd., Fullerton, CA, 92832",
    "phone": "714.441.1233",
    "hours": "Call for hours",
    "lat": 33.8841,
    "lng": -117.7304
  },
  {
    "id": "17822",
    "name": "SPROUTS",
    "address": "735 East Birch Street, Brea, CA, 92821",
    "phone": "714.482.1000",
    "hours": "Call for hours",
    "lat": 33.9058,
    "lng": -117.7865
  },
  {
    "id": "17821",
    "name": "SPROUTS",
    "address": "3011 El Camino Real, Tustin, CA, 92782",
    "phone": "714.734.8760",
    "hours": "Call for hours",
    "lat": 33.8419,
    "lng": -117.6043
  },
  {
    "id": "17820",
    "name": "SPROUTS",
    "address": "14945 Holt Avenue, Tustin, CA, 92780",
    "phone": "714.415.4381",
    "hours": "Call for hours",
    "lat": 33.9208,
    "lng": -117.6096
  },
  {
    "id": "17819",
    "name": "SPROUTS",
    "address": "17950 Magnolia Street, Fountain Valley, CA, 92708",
    "phone": "657.733.4525",
    "hours": "Call for hours",
    "lat": 33.8263,
    "lng": -117.8511
  },
  {
    "id": "17818",
    "name": "SPROUTS",
    "address": "27765 Santa Margarita Parkway, Mission Viejo, CA, 92691",
    "phone": "949.587.3003",
    "hours": "Call for hours",
    "lat": 33.7817,
    "lng": -117.9766
  },
  {
    "id": "17817",
    "name": "SPROUTS",
    "address": "27271 La Paz Road, Laguna Niguel, CA, 92677",
    "phone": "949.349.1999",
    "hours": "Call for hours",
    "lat": 33.868,
    "lng": -117.9265
  },
  {
    "id": "17816",
    "name": "SPROUTS",
    "address": "550 Camino De Estrella, Unit C, San Clemente, CA, 92672",
    "phone": "949.542.1036",
    "hours": "Call for hours",
    "lat": 33.9291,
    "lng": -117.8845
  },
  {
    "id": "17815",
    "name": "SPROUTS",
    "address": "6942 Warner Avenue, Huntington Beach, CA, 92647",
    "phone": "714.369.1160",
    "hours": "Call for hours",
    "lat": 33.7346,
    "lng": -117.7869
  },
  {
    "id": "17814",
    "name": "SPROUTS",
    "address": "9861 Adams Avenue, Huntington Beach, CA, 92646",
    "phone": "714.369.1139",
    "hours": "Call for hours",
    "lat": 33.7364,
    "lng": -117.8229
  },
  {
    "id": "17813",
    "name": "SPROUTS",
    "address": "24332 Rockfield Blvd, Lake Forest, CA, 92630",
    "phone": "949.427.4020",
    "hours": "Call for hours",
    "lat": 33.7102,
    "lng": -117.9503
  },
  {
    "id": "17812",
    "name": "SPROUTS",
    "address": "225 E. 17th Street, Costa Mesa, CA, 92627",
    "phone": "949.698.1094",
    "hours": "Call for hours",
    "lat": 33.6128,
    "lng": -117.6622
  },
  {
    "id": "17811",
    "name": "SPROUTS",
    "address": "3030 Harbor Blvd. Ste. D, Costa Mesa, CA, 92626",
    "phone": "714.751.6399",
    "hours": "Call for hours",
    "lat": 33.5145,
    "lng": -117.7084
  },
  {
    "id": "17810",
    "name": "SPROUTS",
    "address": "3775 Alton Parkway, Irvine, CA, 92606",
    "phone": "949.705.5435",
    "hours": "Call for hours",
    "lat": 33.4361,
    "lng": -117.6231
  },
  {
    "id": "17809",
    "name": "SPROUTS",
    "address": "32413 Highway 79 South, Temecula, CA, 92592",
    "phone": "951.303.0087",
    "hours": "Call for hours",
    "lat": 33.721,
    "lng": -118.0033
  },
  {
    "id": "17808",
    "name": "SPROUTS",
    "address": "39606 Winchester Road, Temecula, CA, 92591",
    "phone": "951.694.3680",
    "hours": "Call for hours",
    "lat": 33.6654,
    "lng": -117.9686
  },
  {
    "id": "17807",
    "name": "SPROUTS",
    "address": "27281 Newport Road, Menifee, CA, 92584",
    "phone": "951.370.1317",
    "hours": "Call for hours",
    "lat": 33.6437,
    "lng": -117.6868
  },
  {
    "id": "17806",
    "name": "SPROUTS",
    "address": "24101 Hemlock Avenue, Moreno Valley, CA, 92557",
    "phone": "951.567.7549",
    "hours": "Call for hours",
    "lat": 33.6483,
    "lng": -117.9155
  },
  {
    "id": "17805",
    "name": "SPROUTS",
    "address": "2207 W Florida Avenue, Hemet, CA, 92545",
    "phone": "951.537.1975",
    "hours": "Call for hours",
    "lat": 33.6801,
    "lng": -117.9085
  },
  {
    "id": "17804",
    "name": "SPROUTS",
    "address": "475 East Alessandro Blvd., Riverside, CA, 92508",
    "phone": "951.565.5400",
    "hours": "Call for hours",
    "lat": 33.6951,
    "lng": -117.8224
  },
  {
    "id": "17803",
    "name": "SPROUTS",
    "address": "1524 South Riverside Avenue, Rialto, CA, 92376",
    "phone": "840.220.4266",
    "hours": "Call for hours",
    "lat": 33.4983,
    "lng": -117.0958
  },
  {
    "id": "17802",
    "name": "SPROUTS",
    "address": "560 West Stuart Avenue, Redlands, CA, 92374",
    "phone": "909.283.7162",
    "hours": "Call for hours",
    "lat": 33.5217,
    "lng": -117.1286
  },
  {
    "id": "17801",
    "name": "SPROUTS",
    "address": "16964 South Highland Avenue, Fontana, CA, 92336",
    "phone": "909.320.5360",
    "hours": "Call for hours",
    "lat": 33.6647,
    "lng": -117.1743
  },
  {
    "id": "17800",
    "name": "SPROUTS",
    "address": "79050 Highway 111, La Quinta, CA, 92253",
    "phone": "760.771.2485",
    "hours": "Call for hours",
    "lat": 33.9553,
    "lng": -117.2457
  },
  {
    "id": "17799",
    "name": "SPROUTS",
    "address": "74895 US Highway 111, Indian Wells, CA, 92210",
    "phone": "442.305.5258",
    "hours": "Call for hours",
    "lat": 33.7399,
    "lng": -117.0151
  },
  {
    "id": "17798",
    "name": "SPROUTS",
    "address": "15727 Bernardo Heights Pwky, San Diego, CA, 92128",
    "phone": "858.385.1606",
    "hours": "Call for hours",
    "lat": 33.8897,
    "lng": -117.3043
  },
  {
    "id": "17797",
    "name": "SPROUTS",
    "address": "11710 Carmel Mountain Road, San Diego, CA, 92128",
    "phone": "858.798.7200",
    "hours": "Call for hours",
    "lat": 34.1132,
    "lng": -117.3771
  },
  {
    "id": "17796",
    "name": "SPROUTS",
    "address": "16415 Paseo Del Sur, San Diego, CA, 92127",
    "phone": "858.798.8232",
    "hours": "Call for hours",
    "lat": 34.065,
    "lng": -117.1672
  },
  {
    "id": "17795",
    "name": "SPROUTS",
    "address": "8142 Mira Mesa Blvd, San Diego, CA, 92126",
    "phone": "858.880.0210",
    "hours": "Call for hours",
    "lat": 34.1173,
    "lng": -117.4378
  },
  {
    "id": "17794",
    "name": "SPROUTS",
    "address": "3358 Governor Drive, San Diego, CA, 92122",
    "phone": "858.457.5006",
    "hours": "Call for hours",
    "lat": 33.6685,
    "lng": -116.3081
  },
  {
    "id": "17793",
    "name": "SPROUTS",
    "address": "3015 Clairemont Drive, San Diego, CA, 92117",
    "phone": "619.764.6015",
    "hours": "Call for hours",
    "lat": 33.7163,
    "lng": -116.3381
  },
  {
    "id": "17792",
    "name": "SPROUTS",
    "address": "4439 Genesee Avenue, San Diego, CA, 92117",
    "phone": "858.268.2400",
    "hours": "Call for hours",
    "lat": 33.0067,
    "lng": -117.069
  },
  {
    "id": "17791",
    "name": "SPROUTS",
    "address": "3315 Rosecrans Street, Ste. B, San Diego, CA, 92110",
    "phone": "619.523.3640",
    "hours": "Call for hours",
    "lat": 33.0279,
    "lng": -117.0856
  },
  {
    "id": "17790",
    "name": "SPROUTS",
    "address": "1260 Garnet Avenue, San Diego, CA, 92109",
    "phone": "858.270.8200",
    "hours": "Call for hours",
    "lat": 32.9161,
    "lng": -117.1402
  },
  {
    "id": "17789",
    "name": "SPROUTS",
    "address": "4175 Park Boulevard, San Diego, CA, 92103",
    "phone": "619.291.8287",
    "hours": "Call for hours",
    "lat": 32.8577,
    "lng": -117.2115
  },
  {
    "id": "17788",
    "name": "SPROUTS",
    "address": "1400 East Vista Way, Vista, CA, 92084",
    "phone": "760.936.4010",
    "hours": "Call for hours",
    "lat": 32.8239,
    "lng": -117.1965
  },
  {
    "id": "17787",
    "name": "SPROUTS",
    "address": "149 South Las Posas Road, San Marcos, CA, 92078",
    "phone": "760.208.6041",
    "hours": "Call for hours",
    "lat": 32.7635,
    "lng": -117.2028
  },
  {
    "id": "17786",
    "name": "SPROUTS",
    "address": "659 Lomas Sante Fe, Solana Beach, CA, 92075",
    "phone": "858.350.7900",
    "hours": "Call for hours",
    "lat": 32.7969,
    "lng": -117.2405
  },
  {
    "id": "17785",
    "name": "SPROUTS",
    "address": "9361 Mission Gorge Road, Santee, CA, 92071",
    "phone": "619.562.0145",
    "hours": "Call for hours",
    "lat": 32.7466,
    "lng": -117.1636
  },
  {
    "id": "17784",
    "name": "SPROUTS",
    "address": "13536 Poway Road, Poway, CA, 92064",
    "phone": "858.486.7851",
    "hours": "Call for hours",
    "lat": 33.2131,
    "lng": -117.2243
  },
  {
    "id": "17783",
    "name": "SPROUTS",
    "address": "471 College Boulevard, Oceanside, CA, 92057",
    "phone": "760.726.7274",
    "hours": "Call for hours",
    "lat": 33.1193,
    "lng": -117.185
  },
  {
    "id": "17782",
    "name": "SPROUTS",
    "address": "510 West 13th Avenue, Escondido, CA, 92025",
    "phone": "760.743.1528",
    "hours": "Call for hours",
    "lat": 32.9937,
    "lng": -117.2598
  },
  {
    "id": "17781",
    "name": "SPROUTS",
    "address": "1327 Encinitas Blvd., Encinitas, CA, 92024",
    "phone": "760.633.4747",
    "hours": "Call for hours",
    "lat": 32.8486,
    "lng": -116.9862
  },
  {
    "id": "17780",
    "name": "SPROUTS",
    "address": "152 North 2nd Street, El Cajon, CA, 92021",
    "phone": "619.579.8251",
    "hours": "Call for hours",
    "lat": 32.9756,
    "lng": -117.0402
  },
  {
    "id": "17779",
    "name": "SPROUTS",
    "address": "2634 Gateway Road, Carlsbad, CA, 92009",
    "phone": "760.827.8916",
    "hours": "Call for hours",
    "lat": 33.2407,
    "lng": -117.3025
  },
  {
    "id": "17778",
    "name": "SPROUTS",
    "address": "3243 Camino de los Coches, Carlsbad, CA, 92009",
    "phone": "760.635.0625",
    "hours": "Call for hours",
    "lat": 33.1101,
    "lng": -117.07
  },
  {
    "id": "17777",
    "name": "SPROUTS",
    "address": "2618 El Camino Real, Carlsbad, CA, 92008",
    "phone": "760.730.1123",
    "hours": "Call for hours",
    "lat": 33.0535,
    "lng": -117.2689
  },
  {
    "id": "17776",
    "name": "SPROUTS",
    "address": "3205 Lemon Grove Avenue, Lemon Grove, CA, 91945",
    "phone": "619.667.8686",
    "hours": "Call for hours",
    "lat": 32.8178,
    "lng": -116.9223
  },
  {
    "id": "17775",
    "name": "SPROUTS",
    "address": "4630 Palm Avenue, La Mesa, CA, 91941",
    "phone": "619.460.7722",
    "hours": "Call for hours",
    "lat": 33.0954,
    "lng": -117.2619
  },
  {
    "id": "17774",
    "name": "SPROUTS",
    "address": "150 East Main St., Ste 150, Alhambra, CA, 91801",
    "phone": "626.863.1096",
    "hours": "Call for hours",
    "lat": 33.1602,
    "lng": -117.325
  },
  {
    "id": "17773",
    "name": "SPROUTS",
    "address": "2630 East Workman St, Ste 315A, W. Covina, CA, 91791",
    "phone": "626.257.9787",
    "hours": "Call for hours",
    "lat": 32.7332,
    "lng": -117.0326
  },
  {
    "id": "17772",
    "name": "SPROUTS",
    "address": "847 West Foothill Blvd., Upland, CA, 91786",
    "phone": "909.912.1461",
    "hours": "Call for hours",
    "lat": 32.7604,
    "lng": -117.0115
  },
  {
    "id": "17771",
    "name": "SPROUTS",
    "address": "239 South Diamond Bar Blvd, Diamond Bar, CA, 91765",
    "phone": "909.378.4980",
    "hours": "Call for hours",
    "lat": 34.0914,
    "lng": -118.1293
  },
  {
    "id": "17770",
    "name": "SPROUTS",
    "address": "1375 Foothill Blvd, LaVerne, CA, 91750",
    "phone": "909.582.2836",
    "hours": "Call for hours",
    "lat": 34.0653,
    "lng": -117.8978
  },
  {
    "id": "17769",
    "name": "SPROUTS",
    "address": "655 South Grand Avenue, Glendora, CA, 91740",
    "phone": "626.250.6625",
    "hours": "Call for hours",
    "lat": 34.1144,
    "lng": -117.6583
  },
  {
    "id": "17768",
    "name": "SPROUTS",
    "address": "7355 Day Creek Boulevard, Rancho Cucamonga, CA, 91739",
    "phone": "909.803.5730",
    "hours": "Call for hours",
    "lat": 34.0066,
    "lng": -117.8098
  },
  {
    "id": "17767",
    "name": "SPROUTS",
    "address": "835 West Foothill Blvd, Claremont, CA, 91711",
    "phone": "909.267.1049",
    "hours": "Call for hours",
    "lat": 34.1159,
    "lng": -117.7708
  },
  {
    "id": "17766",
    "name": "SPROUTS",
    "address": "3630 Grand Avenue, Chino Hills, CA, 91709",
    "phone": "909.548.0440",
    "hours": "Call for hours",
    "lat": 34.1287,
    "lng": -117.8552
  },
  {
    "id": "17765",
    "name": "SPROUTS",
    "address": "6753 Carnelian Street, Rancho Cucamonga, CA, 91701",
    "phone": "909.296.3094",
    "hours": "Call for hours",
    "lat": 34.1705,
    "lng": -117.5182
  },
  {
    "id": "17764",
    "name": "SPROUTS",
    "address": "1011 North San Fernando Blvd., Burbank, CA, 91504",
    "phone": "818.566.4089",
    "hours": "Call for hours",
    "lat": 34.1092,
    "lng": -117.7183
  },
  {
    "id": "17763",
    "name": "SPROUTS",
    "address": "21821 Ventura Blvd., Woodland Hills, CA, 91364",
    "phone": "818.887.6473",
    "hours": "Call for hours",
    "lat": 33.9797,
    "lng": -117.7308
  },
  {
    "id": "17762",
    "name": "SPROUTS",
    "address": "1012 South Westlake Blvd., Westlake, CA, 91361",
    "phone": "805.917.4200",
    "hours": "Call for hours",
    "lat": 34.1376,
    "lng": -117.5999
  },
  {
    "id": "17761",
    "name": "SPROUTS",
    "address": "600 West Hillcrest Drive, Thousand Oaks, CA, 91360",
    "phone": "805.716.4373",
    "hours": "Call for hours",
    "lat": 34.2001,
    "lng": -118.3264
  },
  {
    "id": "17760",
    "name": "SPROUTS",
    "address": "24285 Magic Mountain Parkway, Valencia, CA, 91355",
    "phone": "661.414.1109",
    "hours": "Call for hours",
    "lat": 34.1557,
    "lng": -118.6
  },
  {
    "id": "17759",
    "name": "SPROUTS",
    "address": "10821 North Zelzah Avenue, Granada Hills, CA, 91344",
    "phone": "818.366.0717",
    "hours": "Call for hours",
    "lat": 34.1472,
    "lng": -118.8383
  },
  {
    "id": "17758",
    "name": "SPROUTS",
    "address": "6607 Fallbrook Avenue, West Hills, CA, 91307",
    "phone": "818.867.2104",
    "hours": "Call for hours",
    "lat": 34.2092,
    "lng": -118.8739
  },
  {
    "id": "17757",
    "name": "SPROUTS",
    "address": "39 North Rosemead Blvd., Pasadena, CA, 91107",
    "phone": "626.696.1290",
    "hours": "Call for hours",
    "lat": 34.3985,
    "lng": -118.5535
  },
  {
    "id": "17756",
    "name": "SPROUTS",
    "address": "400 West Huntington Drive, Monrovia, CA, 91016",
    "phone": "626.358.6845",
    "hours": "Call for hours",
    "lat": 34.2771,
    "lng": -118.4992
  },
  {
    "id": "17755",
    "name": "SPROUTS",
    "address": "920 Foothill Blvd., La Canada Flintridge, CA, 91011",
    "phone": "818.495.1103",
    "hours": "Call for hours",
    "lat": 34.1963,
    "lng": -118.6389
  },
  {
    "id": "17754",
    "name": "SPROUTS",
    "address": "12301 Seal Beach Blvd., Seal Beach, CA, 90740",
    "phone": "562.794.2125",
    "hours": "Call for hours",
    "lat": 34.151,
    "lng": -118.0889
  },
  {
    "id": "17753",
    "name": "SPROUTS",
    "address": "820 North Western Avenue, San Pedro, CA, 90732",
    "phone": "310.831.7836",
    "hours": "Call for hours",
    "lat": 34.144,
    "lng": -118.0014
  },
  {
    "id": "17752",
    "name": "SPROUTS",
    "address": "4253 Woodruff Avenue, Lakewood, CA, 90713",
    "phone": "562.739.2541",
    "hours": "Call for hours",
    "lat": 34.2217,
    "lng": -118.2051
  },
  {
    "id": "17751",
    "name": "SPROUTS",
    "address": "11900 South Street, Ste 129, Cerritos, CA, 90703",
    "phone": "562.274.0602",
    "hours": "Call for hours",
    "lat": 33.7602,
    "lng": -118.0808
  },
  {
    "id": "17750",
    "name": "SPROUTS",
    "address": "11522 Alondra Blvd, Norwalk, CA, 90650",
    "phone": "562.564.5410",
    "hours": "Call for hours",
    "lat": 33.742,
    "lng": -118.3121
  },
  {
    "id": "17749",
    "name": "SPROUTS",
    "address": "1431 West Imperial Highway, La Habra, CA, 90631",
    "phone": "562.265.2151",
    "hours": "Call for hours",
    "lat": 33.8473,
    "lng": -118.1115
  },
  {
    "id": "17748",
    "name": "SPROUTS",
    "address": "15801 Whittier Blvd, Whittier, CA, 90603",
    "phone": "562.265.2109",
    "hours": "Call for hours",
    "lat": 33.8669,
    "lng": -118.0686
  },
  {
    "id": "17747",
    "name": "SPROUTS",
    "address": "4230 Pacific Coast Highway, Torrance, CA, 90505",
    "phone": "424.903.7062",
    "hours": "Call for hours",
    "lat": 33.9056,
    "lng": -118.0818
  },
  {
    "id": "17746",
    "name": "SPROUTS",
    "address": "1515 Hawthorne Blvd., Redondo Beach, CA, 90278",
    "phone": "424.903.7028",
    "hours": "Call for hours",
    "lat": 33.9331,
    "lng": -117.9493
  },
  {
    "id": "17745",
    "name": "SPROUTS",
    "address": "5660 Sepulveda Blvd., Culver City, CA, 90230",
    "phone": "310.591.1028",
    "hours": "Call for hours",
    "lat": 33.9432,
    "lng": -117.9927
  },
  {
    "id": "17744",
    "name": "SPROUTS",
    "address": "8550 Santa Monica Blvd, Ste 100, W. Hollywood, CA, 90069",
    "phone": "323.603.2599",
    "hours": "Call for hours",
    "lat": 33.8106,
    "lng": -118.3507
  },
  {
    "id": "17743",
    "name": "SPROUTS",
    "address": "2245 Yosemite Drive, Eagle Rock, CA, 90041",
    "phone": "323.423.1128",
    "hours": "Call for hours",
    "lat": 33.8707,
    "lng": -118.3715
  },
  {
    "id": "17742",
    "name": "SPROUTS",
    "address": "915 North La Brea Avenue, Los Angeles, CA, 90038",
    "phone": "323.217.1642",
    "hours": "Call for hours",
    "lat": 33.9949,
    "lng": -118.3991
  },
  {
    "id": "17741",
    "name": "SPROUTS",
    "address": "8985 Venice Blvd, Ste B, Los Angeles, CA, 90034",
    "phone": "424.361.6611",
    "hours": "Call for hours",
    "lat": 34.0906,
    "lng": -118.3788
  },
  {
    "id": "17740",
    "name": "SPROUTS",
    "address": "1751 Westwood Blvd, Los Angeles, CA, 90024",
    "phone": "310.500.1192",
    "hours": "Call for hours",
    "lat": 34.1339,
    "lng": -118.2082
  },
  {
    "id": "17739",
    "name": "SPROUTS",
    "address": "1302 South La Brea Avenue, Ste C, Los Angeles, CA, 90019",
    "phone": "323.801.7510",
    "hours": "Call for hours",
    "lat": 34.0898,
    "lng": -118.3215
  },
  {
    "id": "17738",
    "name": "SPROUTS",
    "address": "587 South Meadows Pkwy, Reno, NV, 89521",
    "phone": "775.335.1055",
    "hours": "Call for hours",
    "lat": 34.029,
    "lng": -118.4005
  },
  {
    "id": "17737",
    "name": "SPROUTS",
    "address": "299 East Plumb Lane, Ste 120, Reno, NV, 89502",
    "phone": "775.446.3979",
    "hours": "Call for hours",
    "lat": 34.0637,
    "lng": -118.4408
  },
  {
    "id": "17736",
    "name": "SPROUTS",
    "address": "125 Disc Drive, Sparks, NV, 89436",
    "phone": "775.834.0210",
    "hours": "Call for hours",
    "lat": 34.0482,
    "lng": -118.3343
  },
  {
    "id": "17735",
    "name": "SPROUTS",
    "address": "1140 East Silverado Ranch Blvd, Las Vegas, NV, 89183",
    "phone": "702.750.3570",
    "hours": "Call for hours",
    "lat": 39.3809,
    "lng": -119.6859
  },
  {
    "id": "17734",
    "name": "SPROUTS",
    "address": "771 South Rainbow Blvd, #130, Las Vegas, NV, 89145",
    "phone": "702.984.4330",
    "hours": "Call for hours",
    "lat": 39.4972,
    "lng": -119.7764
  },
  {
    "id": "17733",
    "name": "SPROUTS",
    "address": "7375 South Rainbow Blvd, Las Vegas, NV, 89139",
    "phone": "702.670.4450",
    "hours": "Call for hours",
    "lat": 39.6269,
    "lng": -119.7081
  },
  {
    "id": "17732",
    "name": "SPROUTS",
    "address": "8441 Farm Road, Las Vegas, NV, 89131",
    "phone": "702.583.3830",
    "hours": "Call for hours",
    "lat": 35.9959,
    "lng": -115.1576
  },
  {
    "id": "17731",
    "name": "SPROUTS",
    "address": "6150 North Decatur Blvd, #600, Las Vegas, NV, 89130",
    "phone": "702.273.3490",
    "hours": "Call for hours",
    "lat": 36.1693,
    "lng": -115.2828
  },
  {
    "id": "17730",
    "name": "SPROUTS",
    "address": "7530 West Lake Mead Blvd., Ste 120, Las Vegas, NV, 89128",
    "phone": "702.216.3556",
    "hours": "Call for hours",
    "lat": 36.0129,
    "lng": -115.2118
  },
  {
    "id": "17729",
    "name": "SPROUTS",
    "address": "3365 East Tropicana Avenue, Las Vegas, NV, 89121",
    "phone": "702.777.0650",
    "hours": "Call for hours",
    "lat": 36.2956,
    "lng": -115.2419
  },
  {
    "id": "17728",
    "name": "SPROUTS",
    "address": "10000 West Sahara Avenue, Ste. 180, Las Vegas, NV, 89117",
    "phone": "702.216.5060",
    "hours": "Call for hours",
    "lat": 36.2471,
    "lng": -115.221
  },
  {
    "id": "17727",
    "name": "SPROUTS",
    "address": "4020 South Rainbow Blvd, Las Vegas, NV, 89103",
    "phone": "702.876.4888",
    "hours": "Call for hours",
    "lat": 36.1968,
    "lng": -115.2644
  },
  {
    "id": "17726",
    "name": "SPROUTS",
    "address": "6506 North Losee Road, North Las Vegas, NV, 89086",
    "phone": "702.857.6362",
    "hours": "Call for hours",
    "lat": 36.1232,
    "lng": -115.0902
  },
  {
    "id": "17725",
    "name": "SPROUTS",
    "address": "635 South Green Valley Pkwy, Henderson (Green Valley), NV, 89052",
    "phone": "702.322.2229",
    "hours": "Call for hours",
    "lat": 36.1302,
    "lng": -115.2755
  },
  {
    "id": "17724",
    "name": "SPROUTS",
    "address": "280 West Lake Mead Parkway, Henderson, NV, 89015",
    "phone": "725.286.2723",
    "hours": "Call for hours",
    "lat": 36.1149,
    "lng": -115.2161
  },
  {
    "id": "17723",
    "name": "SPROUTS",
    "address": "515 North Stephanie Street, Henderson (Stephanie), NV, 89014",
    "phone": "702.777.7095",
    "hours": "Call for hours",
    "lat": 36.2809,
    "lng": -115.1349
  },
  {
    "id": "17722",
    "name": "SPROUTS",
    "address": "2340 East Lohman Avenue, Ste B, Las Cruces, NM, 88001",
    "phone": "575.680.3680",
    "hours": "Call for hours",
    "lat": 35.9878,
    "lng": -115.1167
  },
  {
    "id": "17721",
    "name": "SPROUTS",
    "address": "3201 Zafarano Drive, Ste. 20, Santa Fe, NM, 87507",
    "phone": "505.424.1900",
    "hours": "Call for hours",
    "lat": 36.0357,
    "lng": -114.9718
  },
  {
    "id": "17720",
    "name": "SPROUTS",
    "address": "199 Paseo de Peralta, Santa Fe, NM, 87501",
    "phone": "505.988.1140",
    "hours": "Call for hours",
    "lat": 36.0564,
    "lng": -115.078
  },
  {
    "id": "17719",
    "name": "SPROUTS",
    "address": "13150 Central Avenue SE, Albuquerque, NM, 87123",
    "phone": "505.998.1025",
    "hours": "Call for hours",
    "lat": 32.2901,
    "lng": -106.7539
  },
  {
    "id": "17718",
    "name": "SPROUTS",
    "address": "5600 Coors Blvd NW, Albuquerque, NM, 87120",
    "phone": "505.355.3850",
    "hours": "Call for hours",
    "lat": 35.6567,
    "lng": -106.0152
  },
  {
    "id": "17717",
    "name": "SPROUTS",
    "address": "10701 Corrales Rd, NW, Albuquerque, NM, 87114",
    "phone": "505.890.7900",
    "hours": "Call for hours",
    "lat": 35.6975,
    "lng": -105.9821
  },
  {
    "id": "17716",
    "name": "SPROUTS",
    "address": "11201A Montgomery Blvd, NE, Albuquerque, NM, 87111",
    "phone": "505.298.2447",
    "hours": "Call for hours",
    "lat": 35.0717,
    "lng": -106.509
  },
  {
    "id": "17715",
    "name": "SPROUTS",
    "address": "5112 Lomas Blvd, NE, Albuquerque, NM, 87110",
    "phone": "505.268.5127",
    "hours": "Call for hours",
    "lat": 35.1421,
    "lng": -106.7041
  },
  {
    "id": "17714",
    "name": "SPROUTS",
    "address": "6300 San Mateo Blvd, NE, Albuquerque, NM, 87109",
    "phone": "505.821.7000",
    "hours": "Call for hours",
    "lat": 35.1868,
    "lng": -106.6652
  },
  {
    "id": "17713",
    "name": "SPROUTS",
    "address": "5645 East SR69, Prescott Valley, AZ, 86314",
    "phone": "928.379.8000",
    "hours": "Call for hours",
    "lat": 35.1347,
    "lng": -106.5222
  },
  {
    "id": "17712",
    "name": "SPROUTS",
    "address": "174 East Sheldon Street, Prescott, AZ, 86301",
    "phone": "928.499.3350",
    "hours": "Call for hours",
    "lat": 35.1104,
    "lng": -106.5781
  },
  {
    "id": "17711",
    "name": "SPROUTS",
    "address": "1540 South Riordan Ranch Street, Flagstaff, AZ, 86001",
    "phone": "928.679.6000",
    "hours": "Call for hours",
    "lat": 35.1506,
    "lng": -106.569
  },
  {
    "id": "17710",
    "name": "SPROUTS",
    "address": "3860 West River Road, Tucson, AZ, 85741",
    "phone": "520.204.1787",
    "hours": "Call for hours",
    "lat": 34.6019,
    "lng": -112.3264
  },
  {
    "id": "17709",
    "name": "SPROUTS",
    "address": "4282 North 1st Avenue, Tucson, AZ, 85719",
    "phone": "520.407.5132",
    "hours": "Call for hours",
    "lat": 34.5917,
    "lng": -112.4265
  },
  {
    "id": "17708",
    "name": "SPROUTS",
    "address": "4800 South Landing Way, Tucson, AZ, 85714",
    "phone": "520.524.0290",
    "hours": "Call for hours",
    "lat": 35.1859,
    "lng": -111.662
  },
  {
    "id": "17707",
    "name": "SPROUTS",
    "address": "4645 East Speedway Blvd, Tucson, AZ, 85712",
    "phone": "520.325.1320",
    "hours": "Call for hours",
    "lat": 32.3472,
    "lng": -111.0419
  },
  {
    "id": "17706",
    "name": "SPROUTS",
    "address": "7877 East Broadway Blvd, Tucson, AZ, 85710",
    "phone": "520.546.6112",
    "hours": "Call for hours",
    "lat": 32.2474,
    "lng": -110.9491
  },
  {
    "id": "17705",
    "name": "SPROUTS",
    "address": "7665 North Oracle Way, Oro Valley, AZ, 85704",
    "phone": "520.297.5446",
    "hours": "Call for hours",
    "lat": 32.1707,
    "lng": -110.9719
  },
  {
    "id": "17704",
    "name": "SPROUTS",
    "address": "18755 South Nogales Highway, Green Valley, AZ, 85614",
    "phone": "520.729.3370",
    "hours": "Call for hours",
    "lat": 32.25,
    "lng": -110.8869
  },
  {
    "id": "17703",
    "name": "SPROUTS",
    "address": "1813 North Dysart Road, Avondale, AZ, 85392",
    "phone": "623.535.8989",
    "hours": "Call for hours",
    "lat": 32.2138,
    "lng": -110.824
  },
  {
    "id": "17702",
    "name": "SPROUTS",
    "address": "13650 North Prasada Parkway, Surprise, AZ, 85388",
    "phone": "480.864.1358",
    "hours": "Call for hours",
    "lat": 32.3379,
    "lng": -110.9855
  },
  {
    "id": "17701",
    "name": "SPROUTS",
    "address": "10134 West Happy Valley Road, Peoria, AZ, 85383",
    "phone": "602.385.3392",
    "hours": "Call for hours",
    "lat": 31.8543,
    "lng": -111.0003
  },
  {
    "id": "17700",
    "name": "SPROUTS",
    "address": "8375 West Thunderbird Road, Peoria, AZ, 85381",
    "phone": "623.334.1111",
    "hours": "Call for hours",
    "lat": 33.4777,
    "lng": -112.3093
  },
  {
    "id": "17699",
    "name": "SPROUTS",
    "address": "13759 West Bell Road, Surprise, AZ, 85374",
    "phone": "623.544.3121",
    "hours": "Call for hours",
    "lat": 33.6134,
    "lng": -112.4512
  },
  {
    "id": "17698",
    "name": "SPROUTS",
    "address": "1590 South 4th Avenue, Unit  A, Yuma, AZ, 85364",
    "phone": "928.388.6016",
    "hours": "Call for hours",
    "lat": 33.7169,
    "lng": -112.238
  },
  {
    "id": "17697",
    "name": "SPROUTS",
    "address": "7700 South 59th Avenue, Laveen, AZ, 85339",
    "phone": "480.210.4896",
    "hours": "Call for hours",
    "lat": 33.6048,
    "lng": -112.2237
  },
  {
    "id": "17696",
    "name": "SPROUTS",
    "address": "5355 E Carefree Hwy, Bldg A, Cave Creek, AZ, 85331",
    "phone": "480.637.4699",
    "hours": "Call for hours",
    "lat": 33.63,
    "lng": -112.3314
  },
  {
    "id": "17695",
    "name": "SPROUTS",
    "address": "6760 West Deer Valley Road, Glendale, AZ, 85310",
    "phone": "623.385.4430",
    "hours": "Call for hours",
    "lat": 32.7015,
    "lng": -114.6424
  },
  {
    "id": "17694",
    "name": "SPROUTS",
    "address": "5665 West Bell Road, Glendale, AZ, 85308",
    "phone": "602.896.0300",
    "hours": "Call for hours",
    "lat": 33.3436,
    "lng": -112.1716
  },
  {
    "id": "17693",
    "name": "SPROUTS",
    "address": "2582 South Val Vista Drive, Gilbert, AZ, 85295",
    "phone": "480.821.1511",
    "hours": "Call for hours",
    "lat": 33.8851,
    "lng": -111.9349
  },
  {
    "id": "17692",
    "name": "SPROUTS",
    "address": "2855 South Alma School Road, Chandler, AZ, 85286",
    "phone": "480.814.2700",
    "hours": "Call for hours",
    "lat": 33.7047,
    "lng": -112.1641
  },
  {
    "id": "17691",
    "name": "SPROUTS",
    "address": "931 East Elliott Road, Ste 110, Tempe, AZ, 85284",
    "phone": "480.567.7040",
    "hours": "Call for hours",
    "lat": 33.6539,
    "lng": -112.1694
  },
  {
    "id": "17690",
    "name": "SPROUTS",
    "address": "1706 East Southern Avenue, Tempe, AZ, 85282",
    "phone": "480.820.4900",
    "hours": "Call for hours",
    "lat": 33.3054,
    "lng": -111.7408
  },
  {
    "id": "17689",
    "name": "SPROUTS",
    "address": "9301 East Shea Blvd. #132, Scottsdale, AZ, 85260",
    "phone": "480.551.9665",
    "hours": "Call for hours",
    "lat": 33.2711,
    "lng": -111.8311
  },
  {
    "id": "17688",
    "name": "SPROUTS",
    "address": "23269 North Scottsdale Road, Scottsdale, AZ, 85255",
    "phone": "480.295.4789",
    "hours": "Call for hours",
    "lat": 33.3363,
    "lng": -111.9197
  },
  {
    "id": "17687",
    "name": "SPROUTS",
    "address": "8787 North Scottsdale Road, Ste 124, Scottsdale, AZ, 85253",
    "phone": "480.534.3620",
    "hours": "Call for hours",
    "lat": 33.3917,
    "lng": -111.9249
  },
  {
    "id": "17686",
    "name": "SPROUTS",
    "address": "4402 North Miller Road, Scottsdale, AZ, 85251",
    "phone": "480.941.6001",
    "hours": "Call for hours",
    "lat": 33.6013,
    "lng": -111.8867
  },
  {
    "id": "17685",
    "name": "SPROUTS",
    "address": "4065 South Gilbert Road, Chandler, AZ, 85249",
    "phone": "480.781.0088",
    "hours": "Call for hours",
    "lat": 33.6968,
    "lng": -111.8892
  },
  {
    "id": "17684",
    "name": "SPROUTS",
    "address": "1959 West Ray Road, Chandler, AZ, 85224",
    "phone": "480.732.1012",
    "hours": "Call for hours",
    "lat": 33.5494,
    "lng": -111.9565
  },
  {
    "id": "17683",
    "name": "SPROUTS",
    "address": "5918 East Longbow Parkway, Mesa, AZ, 85215",
    "phone": "480.401.3870",
    "hours": "Call for hours",
    "lat": 33.4936,
    "lng": -111.9167
  },
  {
    "id": "17682",
    "name": "SPROUTS",
    "address": "1240 South Signal Butte Road, Mesa, AZ, 85209",
    "phone": "480.586.3710",
    "hours": "Call for hours",
    "lat": 33.2414,
    "lng": -111.7745
  },
  {
    "id": "17681",
    "name": "SPROUTS",
    "address": "5225 East Southern Avenue, Mesa, AZ, 85206",
    "phone": "480.218.6491",
    "hours": "Call for hours",
    "lat": 33.3301,
    "lng": -111.8632
  },
  {
    "id": "17680",
    "name": "SPROUTS",
    "address": "2060 East Baseline Road, Mesa, AZ, 85204",
    "phone": "480.401.3758",
    "hours": "Call for hours",
    "lat": 33.4707,
    "lng": -111.7188
  },
  {
    "id": "17679",
    "name": "SPROUTS",
    "address": "1933 East Brown Road, Mesa, AZ, 85203",
    "phone": "480.668.0800",
    "hours": "Call for hours",
    "lat": 33.3782,
    "lng": -111.6406
  },
  {
    "id": "17678",
    "name": "SPROUTS",
    "address": "21181 South Ellsworth Loop Rd, Queen Creek, AZ, 85142",
    "phone": "623.385.3213",
    "hours": "Call for hours",
    "lat": 33.4026,
    "lng": -111.7242
  },
  {
    "id": "17677",
    "name": "SPROUTS",
    "address": "37666 North Gantzel Road, Queen Creek, AZ, 85140",
    "phone": "520.614.0304",
    "hours": "Call for hours",
    "lat": 33.3992,
    "lng": -111.7896
  },
  {
    "id": "17676",
    "name": "SPROUTS",
    "address": "20300 North John Wayne Parkway, Maricopa, AZ, 85139",
    "phone": "520.532.1093",
    "hours": "Call for hours",
    "lat": 33.437,
    "lng": -111.8057
  },
  {
    "id": "17675",
    "name": "SPROUTS",
    "address": "5455 East High Street, Ste. 107, Phoenix, AZ, 85054",
    "phone": "602.682.3200",
    "hours": "Call for hours",
    "lat": 33.2487,
    "lng": -111.6343
  },
  {
    "id": "17674",
    "name": "SPROUTS",
    "address": "4201 West Thunderbird Road, Phoenix, AZ, 85053",
    "phone": "602.960.4587",
    "hours": "Call for hours",
    "lat": 33.1911,
    "lng": -111.528
  },
  {
    "id": "17673",
    "name": "SPROUTS",
    "address": "4735 East Ray Road, Unit A 001, Phoenix, AZ, 85044",
    "phone": "480.295.4901",
    "hours": "Call for hours",
    "lat": 32.9576,
    "lng": -112.0534
  },
  {
    "id": "17672",
    "name": "SPROUTS",
    "address": "12415 North Tatum Blvd., Phoenix, AZ, 85032",
    "phone": "602.971.4177",
    "hours": "Call for hours",
    "lat": 33.6731,
    "lng": -111.9461
  },
  {
    "id": "17671",
    "name": "SPROUTS",
    "address": "245 East Bell Road  #15, Phoenix, AZ, 85022",
    "phone": "602.218.4949",
    "hours": "Call for hours",
    "lat": 33.6299,
    "lng": -112.1316
  },
  {
    "id": "17670",
    "name": "SPROUTS",
    "address": "8040 North 19th Avenue, Phoenix, AZ, 85021",
    "phone": "602.864.6130",
    "hours": "Call for hours",
    "lat": 33.3291,
    "lng": -111.9943
  },
  {
    "id": "17669",
    "name": "SPROUTS",
    "address": "1625 East Glendale Avenue, Phoenix, AZ, 85020",
    "phone": "602.385.2150",
    "hours": "Call for hours",
    "lat": 33.6238,
    "lng": -112.0044
  },
  {
    "id": "17668",
    "name": "SPROUTS",
    "address": "2824 East Indian School Road. #126, Phoenix, AZ, 85016",
    "phone": "602.553.3131",
    "hours": "Call for hours",
    "lat": 33.6315,
    "lng": -112.052
  },
  {
    "id": "17667",
    "name": "SPROUTS",
    "address": "3320 North 7th Avenue, Phoenix, AZ, 85013",
    "phone": "602.384.2650",
    "hours": "Call for hours",
    "lat": 33.56,
    "lng": -112.0927
  },
  {
    "id": "17666",
    "name": "SPROUTS",
    "address": "1785 East Murray-Holladay Road, Ste. A, Holladay, UT, 84117",
    "phone": "385.695.6817",
    "hours": "Call for hours",
    "lat": 33.5623,
    "lng": -112.0559
  },
  {
    "id": "17665",
    "name": "SPROUTS",
    "address": "6284 South State Street, Murray, UT, 84107",
    "phone": "801.266.3566",
    "hours": "Call for hours",
    "lat": 33.5021,
    "lng": -112.0305
  },
  {
    "id": "17664",
    "name": "SPROUTS",
    "address": "216 South 700 East, Salt Lake City, UT, 84102",
    "phone": "801.364.1602",
    "hours": "Call for hours",
    "lat": 33.5085,
    "lng": -112.0827
  },
  {
    "id": "17663",
    "name": "SPROUTS",
    "address": "1375 South State Street, Orem, UT, 84097",
    "phone": "801.434.1501",
    "hours": "Call for hours",
    "lat": 40.6551,
    "lng": -111.834
  },
  {
    "id": "17662",
    "name": "SPROUTS",
    "address": "11519 S 4000 W, South Jordan, UT, 84009",
    "phone": "385.695.6809",
    "hours": "Call for hours",
    "lat": 40.6568,
    "lng": -111.8904
  },
  {
    "id": "17661",
    "name": "SPROUTS",
    "address": "1450 West Independent Avenue, Grand Junction, CO, 81505",
    "phone": "970.549.3001",
    "hours": "Call for hours",
    "lat": 40.76,
    "lng": -111.8627
  },
  {
    "id": "17660",
    "name": "SPROUTS",
    "address": "13415 Voyager Parkway, Colorado Springs, CO, 80921",
    "phone": "719.884.7900",
    "hours": "Call for hours",
    "lat": 40.2972,
    "lng": -111.6705
  },
  {
    "id": "17659",
    "name": "SPROUTS",
    "address": "1730 Dublin Blvd, Colorado Springs, CO, 80918",
    "phone": "719.590.8890",
    "hours": "Call for hours",
    "lat": 40.5622,
    "lng": -111.9297
  },
  {
    "id": "17658",
    "name": "SPROUTS",
    "address": "5617 Barnes Road, Colorado Springs, CO, 80917",
    "phone": "719.313.4405",
    "hours": "Call for hours",
    "lat": 39.1071,
    "lng": -108.5968
  },
  {
    "id": "17657",
    "name": "SPROUTS",
    "address": "1720 South Nevada Avenue, Colorado Springs, CO, 80905",
    "phone": "719.719.1957",
    "hours": "Call for hours",
    "lat": 39.0487,
    "lng": -104.814
  },
  {
    "id": "17656",
    "name": "SPROUTS",
    "address": "4759 West 29th  Street, Unit B, Greeley, CO, 80634",
    "phone": "970.576.3050",
    "hours": "Call for hours",
    "lat": 38.9129,
    "lng": -104.7734
  },
  {
    "id": "17655",
    "name": "SPROUTS",
    "address": "1440 North Lincoln Avenue, Loveland, CO, 80538",
    "phone": "970.800.5607",
    "hours": "Call for hours",
    "lat": 38.886,
    "lng": -104.7399
  },
  {
    "id": "17654",
    "name": "SPROUTS",
    "address": "2601 South Lemay Avenue, Fort Collins, CO, 80525",
    "phone": "970.282.8003",
    "hours": "Call for hours",
    "lat": 38.8377,
    "lng": -104.837
  },
  {
    "id": "17653",
    "name": "SPROUTS",
    "address": "4345 Corbett Drive, Fort Collins, CO, 80525",
    "phone": "970.416.3350",
    "hours": "Call for hours",
    "lat": 40.4109,
    "lng": -104.7541
  },
  {
    "id": "17652",
    "name": "SPROUTS",
    "address": "1101 South Hover, Longmont, CO, 80501",
    "phone": "303.834.4124",
    "hours": "Call for hours",
    "lat": 40.4262,
    "lng": -105.09
  },
  {
    "id": "17651",
    "name": "SPROUTS",
    "address": "2950 Baseline Road, Boulder, CO, 80303",
    "phone": "720.279.6758",
    "hours": "Call for hours",
    "lat": 40.5384,
    "lng": -105.0547
  },
  {
    "id": "17650",
    "name": "SPROUTS",
    "address": "2525 Arapahoe Avenue, Boulder, CO, 80302",
    "phone": "303.449.0777",
    "hours": "Call for hours",
    "lat": 40.1779,
    "lng": -105.1009
  },
  {
    "id": "17649",
    "name": "SPROUTS",
    "address": "5670 North Tower Road, Denver, CO, 80249",
    "phone": "720.850.5026",
    "hours": "Call for hours",
    "lat": 39.9914,
    "lng": -105.2392
  },
  {
    "id": "17648",
    "name": "SPROUTS",
    "address": "3555 North Central Park Blvd, Denver, CO, 80238",
    "phone": "720.780.6422",
    "hours": "Call for hours",
    "lat": 40.0172,
    "lng": -105.2851
  },
  {
    "id": "17647",
    "name": "SPROUTS",
    "address": "1131 East 120th Avenue, Thornton, CO, 80233",
    "phone": "303.457.3600",
    "hours": "Call for hours",
    "lat": 39.7783,
    "lng": -104.7557
  },
  {
    "id": "17646",
    "name": "SPROUTS",
    "address": "98 Wadsworth Blvd., Unit 112, Lakewood, CO, 80226",
    "phone": "303.957.9276",
    "hours": "Call for hours",
    "lat": 39.7392,
    "lng": -104.9847
  },
  {
    "id": "17645",
    "name": "SPROUTS",
    "address": "2880 South Colorado Blvd, Denver, CO, 80222",
    "phone": "303.758.4400",
    "hours": "Call for hours",
    "lat": 39.9015,
    "lng": -104.9407
  },
  {
    "id": "17644",
    "name": "SPROUTS",
    "address": "4700 West 38th Avenue, Denver, CO, 80212",
    "phone": "303.433.2350",
    "hours": "Call for hours",
    "lat": 39.7123,
    "lng": -105.0918
  },
  {
    "id": "17643",
    "name": "SPROUTS",
    "address": "197 East  Mississippi Avenue, Denver, CO, 80209",
    "phone": "720.458.2873",
    "hours": "Call for hours",
    "lat": 39.671,
    "lng": -104.9279
  },
  {
    "id": "17642",
    "name": "SPROUTS",
    "address": "3625 East Colfax Avenue, Denver, CO, 80206",
    "phone": "720.347.4205",
    "hours": "Call for hours",
    "lat": 39.7683,
    "lng": -105.0493
  },
  {
    "id": "17641",
    "name": "SPROUTS",
    "address": "9751 South Parker Road, Parker, CO, 80134",
    "phone": "720.475.8684",
    "hours": "Call for hours",
    "lat": 39.7074,
    "lng": -104.9686
  },
  {
    "id": "17640",
    "name": "SPROUTS",
    "address": "1980 East County Line Road, Highlands Ranch, CO, 80126",
    "phone": "303.243.5060",
    "hours": "Call for hours",
    "lat": 39.7331,
    "lng": -104.9524
  },
  {
    "id": "17639",
    "name": "SPROUTS",
    "address": "10018 Commons Street, Lone Tree, CO, 80124",
    "phone": "720.279.6616",
    "hours": "Call for hours",
    "lat": 39.4895,
    "lng": -104.8447
  },
  {
    "id": "17638",
    "name": "SPROUTS",
    "address": "8601 West Cross Drive, Unit P4, Littleton, CO, 80123",
    "phone": "720.214.0410",
    "hours": "Call for hours",
    "lat": 39.5437,
    "lng": -104.9691
  },
  {
    "id": "17637",
    "name": "SPROUTS",
    "address": "5001 South Broadway, Englewood, CO, 80113",
    "phone": "720.612.6595",
    "hours": "Call for hours",
    "lat": 39.5517,
    "lng": -104.8863
  },
  {
    "id": "17636",
    "name": "SPROUTS",
    "address": "8557 East Arapahoe Road #B, Greenwood Village, CO, 80112",
    "phone": "303.721.1400",
    "hours": "Call for hours",
    "lat": 39.6206,
    "lng": -105.0901
  },
  {
    "id": "17635",
    "name": "SPROUTS",
    "address": "5650 Allen Way, Castle Rock, CO, 80108",
    "phone": "720.305.0684",
    "hours": "Call for hours",
    "lat": 39.6405,
    "lng": -104.9614
  },
  {
    "id": "17634",
    "name": "SPROUTS",
    "address": "3725 Kipling Street, Wheat Ridge, CO, 80033",
    "phone": "720.305.0219",
    "hours": "Call for hours",
    "lat": 39.5805,
    "lng": -104.9011
  },
  {
    "id": "17633",
    "name": "SPROUTS",
    "address": "555 West South Boulder Road, Lafayette, CO, 80026",
    "phone": "303.664.1902",
    "hours": "Call for hours",
    "lat": 39.4455,
    "lng": -104.853
  },
  {
    "id": "17632",
    "name": "SPROUTS",
    "address": "5150 West 120th Avenue, Westminster, CO, 80020",
    "phone": "303.803.1010",
    "hours": "Call for hours",
    "lat": 39.774,
    "lng": -105.0962
  },
  {
    "id": "17631",
    "name": "SPROUTS",
    "address": "15405 East Briarwood Circle, Ste A, Aurora, CO, 80016",
    "phone": "303.690.4600",
    "hours": "Call for hours",
    "lat": 39.998,
    "lng": -105.0963
  },
  {
    "id": "17630",
    "name": "SPROUTS",
    "address": "20831 East Smoky Hill Road, Centennial, CO, 80015",
    "phone": "720.305.0959",
    "hours": "Call for hours",
    "lat": 39.9245,
    "lng": -105.0609
  },
  {
    "id": "17629",
    "name": "SPROUTS",
    "address": "1150 South Ironton Street, Unit 130, Aurora, CO, 80012",
    "phone": "720.278.2008",
    "hours": "Call for hours",
    "lat": 39.6012,
    "lng": -104.7394
  },
  {
    "id": "17628",
    "name": "SPROUTS",
    "address": "15050 West 64th Avenue, Arvada, CO, 80007",
    "phone": "303.801.4570",
    "hours": "Call for hours",
    "lat": 39.6255,
    "lng": -104.7874
  },
  {
    "id": "17627",
    "name": "SPROUTS",
    "address": "7725 Wadsworth Blvd, Arvada, CO, 80003",
    "phone": "303.463.4828",
    "hours": "Call for hours",
    "lat": 39.6987,
    "lng": -104.8377
  },
  {
    "id": "17626",
    "name": "SPROUTS",
    "address": "2036 North Zaragoza Road, Ste E, El Paso, TX, 79938",
    "phone": "915.218.2954",
    "hours": "Call for hours",
    "lat": 39.8634,
    "lng": -105.1724
  },
  {
    "id": "17625",
    "name": "SPROUTS",
    "address": "9801 Gateway Blvd West, Ste E, El Paso, TX, 79925",
    "phone": "915.444.3585",
    "hours": "Call for hours",
    "lat": 39.8286,
    "lng": -105.0655
  },
  {
    "id": "17624",
    "name": "SPROUTS",
    "address": "655 Sunland Park Drive, Ste. B, El Paso, TX, 79912",
    "phone": "915.833.3380",
    "hours": "Call for hours",
    "lat": 31.8045,
    "lng": -105.9661
  },
  {
    "id": "17623",
    "name": "SPROUTS",
    "address": "8201 Quaker Avenue, Ste. 140, Lubbock, TX, 79424",
    "phone": "806.794.4900",
    "hours": "Call for hours",
    "lat": 31.7814,
    "lng": -106.3613
  },
  {
    "id": "17622",
    "name": "SPROUTS",
    "address": "10225 Research Blvd. #1000, Austin, TX, 78759",
    "phone": "512.225.9101",
    "hours": "Call for hours",
    "lat": 31.8383,
    "lng": -106.5364
  },
  {
    "id": "17621",
    "name": "SPROUTS",
    "address": "2917 W. Anderson Lane, Austin, TX, 78757",
    "phone": "512.451.0669",
    "hours": "Call for hours",
    "lat": 33.5159,
    "lng": -101.9344
  },
  {
    "id": "17620",
    "name": "SPROUTS",
    "address": "2805 Bee Cave Rd. Ste. 400, Rollingwood, TX, 78746",
    "phone": "512.439.5782",
    "hours": "Call for hours",
    "lat": 30.4036,
    "lng": -97.7526
  },
  {
    "id": "17619",
    "name": "SPROUTS",
    "address": "6920 Manchaca Road, Austin, TX, 78745",
    "phone": "512.687.2204",
    "hours": "Call for hours",
    "lat": 30.3437,
    "lng": -97.7316
  },
  {
    "id": "17618",
    "name": "SPROUTS",
    "address": "5601 Brodie Ln. Ste. 800, Sunset Valley, TX, 78745",
    "phone": "512.334.4175",
    "hours": "Call for hours",
    "lat": 30.2971,
    "lng": -97.8181
  },
  {
    "id": "17617",
    "name": "SPROUTS",
    "address": "1201 Barbara Jordan Blvd., Bldg 7, Austin, TX, 78723",
    "phone": "737.301.5648",
    "hours": "Call for hours",
    "lat": 30.2063,
    "lng": -97.7956
  },
  {
    "id": "17616",
    "name": "SPROUTS",
    "address": "4006 South Lamar Blvd. Ste 400, Austin, TX, 78704",
    "phone": "512.444.3079",
    "hours": "Call for hours",
    "lat": 30.3085,
    "lng": -97.6849
  },
  {
    "id": "17615",
    "name": "SPROUTS",
    "address": "110 IH 35 North, Ste. 299, Round Rock, TX, 78681",
    "phone": "512.334.4684",
    "hours": "Call for hours",
    "lat": 30.2428,
    "lng": -97.7658
  },
  {
    "id": "17614",
    "name": "SPROUTS",
    "address": "1831 South Lakeline Blvd, Cedar Park, TX, 78613",
    "phone": "512.279.8312",
    "hours": "Call for hours",
    "lat": 30.5083,
    "lng": -97.6789
  },
  {
    "id": "17613",
    "name": "SPROUTS",
    "address": "5800 North 10th Street, Bldg. 200, McAllen, TX, 78504",
    "phone": "956.331.2123",
    "hours": "Call for hours",
    "lat": 30.5052,
    "lng": -97.8203
  },
  {
    "id": "17612",
    "name": "SPROUTS",
    "address": "1440 Airline Road, Corpus Christi, TX, 78412",
    "phone": "361.993.2850",
    "hours": "Call for hours",
    "lat": 26.2556,
    "lng": -98.2303
  },
  {
    "id": "17611",
    "name": "SPROUTS",
    "address": "22135 South Bulverde Road, San Antonio, TX, 78259",
    "phone": "210.350.3985",
    "hours": "Call for hours",
    "lat": 27.7061,
    "lng": -97.3537
  },
  {
    "id": "17610",
    "name": "SPROUTS",
    "address": "9702 State Highway 151, San Antonio, TX, 78251",
    "phone": "726.227.8068",
    "hours": "Call for hours",
    "lat": 29.6283,
    "lng": -98.4445
  },
  {
    "id": "17609",
    "name": "SPROUTS",
    "address": "8101 Callaghan Road, San Antonio, TX, 78230",
    "phone": "210.979.8121",
    "hours": "Call for hours",
    "lat": 29.4597,
    "lng": -98.6555
  },
  {
    "id": "17608",
    "name": "SPROUTS",
    "address": "2502 Nacogdoches Rd., San Antonio, TX, 78217",
    "phone": "210.824.7800",
    "hours": "Call for hours",
    "lat": 29.5407,
    "lng": -98.5521
  },
  {
    "id": "17607",
    "name": "SPROUTS",
    "address": "2718 Old Chocolate Bayou Rd, Pearland, TX, 77584",
    "phone": "713.482.3987",
    "hours": "Call for hours",
    "lat": 29.5395,
    "lng": -98.4194
  },
  {
    "id": "17606",
    "name": "SPROUTS",
    "address": "23105 Cinco Ranch Blvd, Katy, TX, 77494",
    "phone": "281.769.0444",
    "hours": "Call for hours",
    "lat": 29.5405,
    "lng": -95.3208
  },
  {
    "id": "17605",
    "name": "SPROUTS",
    "address": "13550 University Blvd, Sugarland, TX, 77479",
    "phone": "281.201.3470",
    "hours": "Call for hours",
    "lat": 29.7404,
    "lng": -95.8304
  },
  {
    "id": "17604",
    "name": "SPROUTS",
    "address": "20708 Kuykendahl Road, Spring, TX, 77379",
    "phone": "832.764.5424",
    "hours": "Call for hours",
    "lat": 29.5785,
    "lng": -95.6066
  },
  {
    "id": "17603",
    "name": "SPROUTS",
    "address": "7055 State Hwy 6 North, Ste. A, Houston, TX, 77095",
    "phone": "832.575.2201",
    "hours": "Call for hours",
    "lat": 30.0377,
    "lng": -95.5326
  },
  {
    "id": "17602",
    "name": "SPROUTS",
    "address": "11940  Westheimer Road, Houston, TX, 77077",
    "phone": "281.582.6794",
    "hours": "Call for hours",
    "lat": 29.8941,
    "lng": -95.6481
  },
  {
    "id": "17601",
    "name": "SPROUTS",
    "address": "22506 Tomball Parkway, Houston, TX, 77070",
    "phone": "832.698.0004",
    "hours": "Call for hours",
    "lat": 29.7477,
    "lng": -95.603
  },
  {
    "id": "17600",
    "name": "SPROUTS",
    "address": "1212 Old Spanish Trail, Houston, TX, 77054",
    "phone": "346.326.7639",
    "hours": "Call for hours",
    "lat": 29.9781,
    "lng": -95.5803
  },
  {
    "id": "17599",
    "name": "SPROUTS",
    "address": "195 Yale Street, Ste. 100, Houston, TX, 77007",
    "phone": "713.395.4590",
    "hours": "Call for hours",
    "lat": 29.6852,
    "lng": -95.4017
  },
  {
    "id": "17598",
    "name": "SPROUTS",
    "address": "2003 South Main, Keller, TX, 76248",
    "phone": "817.380.7024",
    "hours": "Call for hours",
    "lat": 29.7736,
    "lng": -95.4034
  },
  {
    "id": "17597",
    "name": "SPROUTS",
    "address": "4930 Teasley Lane, Denton, TX, 76210",
    "phone": "940.999.2263",
    "hours": "Call for hours",
    "lat": 32.9276,
    "lng": -97.2489
  },
  {
    "id": "17596",
    "name": "SPROUTS",
    "address": "6300 Waverly Way, Fort Worth, TX, 76116",
    "phone": "682.747.5456",
    "hours": "Call for hours",
    "lat": 33.1428,
    "lng": -97.0727
  },
  {
    "id": "17595",
    "name": "SPROUTS",
    "address": "4650 SW Loop 820, Fort Worth, TX, 76109",
    "phone": "682.747.5790",
    "hours": "Call for hours",
    "lat": 32.723,
    "lng": -97.4483
  },
  {
    "id": "17594",
    "name": "SPROUTS",
    "address": "220 Randol Mill Avenue, Southlake, TX, 76092",
    "phone": "682.223.5805",
    "hours": "Call for hours",
    "lat": 32.7002,
    "lng": -97.3789
  },
  {
    "id": "17593",
    "name": "SPROUTS",
    "address": "1550 East Debbie Lane, Mansfield, TX, 76063",
    "phone": "682.422.0061",
    "hours": "Call for hours",
    "lat": 32.9485,
    "lng": -97.1524
  },
  {
    "id": "17592",
    "name": "SPROUTS",
    "address": "316 Grapevine Highway, Hurst, TX, 76054",
    "phone": "682.325.5977",
    "hours": "Call for hours",
    "lat": 32.5773,
    "lng": -97.1416
  },
  {
    "id": "17591",
    "name": "SPROUTS",
    "address": "5711 West Interstate 20, Arlington, TX, 76017",
    "phone": "682.587.0086",
    "hours": "Call for hours",
    "lat": 32.8558,
    "lng": -97.1755
  },
  {
    "id": "17590",
    "name": "SPROUTS",
    "address": "4015 South Broadway Avenue, Tyler, TX, 75701",
    "phone": "903.747.1118",
    "hours": "Call for hours",
    "lat": 32.6555,
    "lng": -97.1599
  },
  {
    "id": "17589",
    "name": "SPROUTS",
    "address": "17795 Dallas Parkway, Dallas, TX, 75287",
    "phone": "469.865.1876",
    "hours": "Call for hours",
    "lat": 32.3254,
    "lng": -95.2922
  },
  {
    "id": "17588",
    "name": "SPROUTS",
    "address": "7110 Skillman St, Dallas, TX, 75231",
    "phone": "469.210.8166",
    "hours": "Call for hours",
    "lat": 33.0005,
    "lng": -96.8314
  },
  {
    "id": "17587",
    "name": "SPROUTS",
    "address": "11722 Marsh Lane #317, Dallas, TX, 75229",
    "phone": "214.350.0574",
    "hours": "Call for hours",
    "lat": 32.8756,
    "lng": -96.7495
  },
  {
    "id": "17586",
    "name": "SPROUTS",
    "address": "6465 East Mockingbird Lane, Ste 322, Dallas, TX, 75214",
    "phone": "945.219.3141",
    "hours": "Call for hours",
    "lat": 32.8958,
    "lng": -96.8588
  },
  {
    "id": "17585",
    "name": "SPROUTS",
    "address": "1800 North Henderson Avenue, Dallas, TX, 75206",
    "phone": "214.826.2937",
    "hours": "Call for hours",
    "lat": 32.8248,
    "lng": -96.7498
  },
  {
    "id": "17584",
    "name": "SPROUTS",
    "address": "1220 N Town East Blvd, Ste 650, Mesquite, TX, 75150",
    "phone": "469.983.2045",
    "hours": "Call for hours",
    "lat": 32.831,
    "lng": -96.7692
  },
  {
    "id": "17583",
    "name": "SPROUTS",
    "address": "362 East FM 1382, Cedar Hill, TX, 75104",
    "phone": "972.637.5108",
    "hours": "Call for hours",
    "lat": 32.8154,
    "lng": -96.6307
  },
  {
    "id": "17582",
    "name": "SPROUTS",
    "address": "207 E. FM 544, Murphy, TX, 75094",
    "phone": "972.265.4770",
    "hours": "Call for hours",
    "lat": 32.5885,
    "lng": -96.9438
  },
  {
    "id": "17581",
    "name": "SPROUTS",
    "address": "3001 Lakeview Parkway, Rowlett, TX, 75088",
    "phone": "972.265.0386",
    "hours": "Call for hours",
    "lat": 33.0148,
    "lng": -96.6189
  },
  {
    "id": "17580",
    "name": "SPROUTS",
    "address": "1343 West Campbell Road, Richardson, TX, 75080",
    "phone": "214.442.5961",
    "hours": "Call for hours",
    "lat": 32.9031,
    "lng": -96.5472
  },
  {
    "id": "17579",
    "name": "SPROUTS",
    "address": "9241 Virginia Parkway, McKinney, TX, 75071",
    "phone": "469.481.5000",
    "hours": "Call for hours",
    "lat": 32.966,
    "lng": -96.7452
  },
  {
    "id": "17578",
    "name": "SPROUTS",
    "address": "7730 North MacArthur Blvd, Ste 150, Irving, TX, 75063",
    "phone": "972.232.7926",
    "hours": "Call for hours",
    "lat": 33.1976,
    "lng": -96.6153
  },
  {
    "id": "17577",
    "name": "SPROUTS",
    "address": "2500 South Carrier Parkway, Ste B, Grand Prairie, TX, 75052",
    "phone": "469.870.7863",
    "hours": "Call for hours",
    "lat": 32.9247,
    "lng": -96.9598
  },
  {
    "id": "17576",
    "name": "SPROUTS",
    "address": "5190 Preston Road, Frisco, TX, 75034",
    "phone": "972.464.5776",
    "hours": "Call for hours",
    "lat": 32.6605,
    "lng": -97.0311
  },
  {
    "id": "17575",
    "name": "SPROUTS",
    "address": "2500 Eldorado Pkwy, Frisco, TX, 75033",
    "phone": "469.731.7261",
    "hours": "Call for hours",
    "lat": 33.1499,
    "lng": -96.8241
  },
  {
    "id": "17574",
    "name": "SPROUTS",
    "address": "2301 Cross Timbers Road #200, Flower Mound, TX, 75028",
    "phone": "972.874.7380",
    "hours": "Call for hours",
    "lat": 33.2559,
    "lng": -96.8853
  },
  {
    "id": "17573",
    "name": "SPROUTS",
    "address": "4100 East Legacy Drive #401, Plano, TX, 75024",
    "phone": "972.618.8902",
    "hours": "Call for hours",
    "lat": 33.0383,
    "lng": -97.0745
  },
  {
    "id": "17572",
    "name": "SPROUTS",
    "address": "110 West Sandy Lake Road, Ste. 180, Coppell, TX, 75019",
    "phone": "972.350.8051",
    "hours": "Call for hours",
    "lat": 33.0752,
    "lng": -96.7843
  },
  {
    "id": "17571",
    "name": "SPROUTS",
    "address": "1265 West Exchange Pkwy, Allen, TX, 75013",
    "phone": "972.521.0057",
    "hours": "Call for hours",
    "lat": 32.9673,
    "lng": -96.9805
  },
  {
    "id": "17570",
    "name": "SPROUTS",
    "address": "1745 East Hebron Parkway, Ste. 200, Carrollton, TX, 75010",
    "phone": "972.428.5785",
    "hours": "Call for hours",
    "lat": 33.1186,
    "lng": -96.6773
  },
  {
    "id": "17569",
    "name": "SPROUTS",
    "address": "4123 South Harvard Avenue, Tulsa, OK, 74135",
    "phone": "918.858.8850",
    "hours": "Call for hours",
    "lat": 33.0304,
    "lng": -96.8777
  },
  {
    "id": "17568",
    "name": "SPROUTS",
    "address": "10111 South Memorial Drive, Tulsa, OK, 74133",
    "phone": "918.364.7272",
    "hours": "Call for hours",
    "lat": 36.0976,
    "lng": -95.9228
  },
  {
    "id": "17567",
    "name": "SPROUTS",
    "address": "909 West 6th Avenue, Stillwater, OK, 74074",
    "phone": "405.571.3153",
    "hours": "Call for hours",
    "lat": 36.0467,
    "lng": -95.8841
  },
  {
    "id": "17566",
    "name": "SPROUTS",
    "address": "9601 North 133rd East Avenue, Owasso, OK, 74055",
    "phone": "918.516.6656",
    "hours": "Call for hours",
    "lat": 36.1043,
    "lng": -97.0609
  },
  {
    "id": "17565",
    "name": "SPROUTS",
    "address": "851 East Hillside Drive, Broken Arrow (Tulsa), OK, 74012",
    "phone": "918.806.0810",
    "hours": "Call for hours",
    "lat": 36.2863,
    "lng": -95.8222
  },
  {
    "id": "17564",
    "name": "SPROUTS",
    "address": "12100 S Pennsylvania Avenue, Oklahoma City, OK, 73170",
    "phone": "405.416.7650",
    "hours": "Call for hours",
    "lat": 36.0447,
    "lng": -95.8079
  },
  {
    "id": "17563",
    "name": "SPROUTS",
    "address": "12200 North MacArthur Blvd., Ste C, Oklahoma City, OK, 73162",
    "phone": "405.384.7577",
    "hours": "Call for hours",
    "lat": 35.327,
    "lng": -97.5556
  },
  {
    "id": "17562",
    "name": "SPROUTS",
    "address": "6410 North May Avenue, Oklahoma City, OK, 73116",
    "phone": "405.879.9989",
    "hours": "Call for hours",
    "lat": 35.5806,
    "lng": -97.6419
  },
  {
    "id": "17561",
    "name": "SPROUTS",
    "address": "1105 Garth Brooks Blvd., Ste C, Yukon, OK, 73099",
    "phone": "405.494.3054",
    "hours": "Call for hours",
    "lat": 35.5463,
    "lng": -97.5642
  },
  {
    "id": "17560",
    "name": "SPROUTS",
    "address": "559 West Main, Norman, OK, 73069",
    "phone": "405.217.4601",
    "hours": "Call for hours",
    "lat": 35.4977,
    "lng": -97.7323
  },
  {
    "id": "17559",
    "name": "SPROUTS",
    "address": "24 East 2nd Street, Edmond, OK, 73034",
    "phone": "405.341.5727",
    "hours": "Call for hours",
    "lat": 35.2204,
    "lng": -97.4577
  },
  {
    "id": "17558",
    "name": "SPROUTS",
    "address": "4841 Rouzan Square Avenue, Baton Rouge, LA, 70808",
    "phone": "225.614.9131",
    "hours": "Call for hours",
    "lat": 35.6665,
    "lng": -97.4798
  },
  {
    "id": "17557",
    "name": "SPROUTS",
    "address": "7728 East Central Avenue, Wichita, KS, 67206",
    "phone": "316.448.5254",
    "hours": "Call for hours",
    "lat": 30.4066,
    "lng": -91.1468
  },
  {
    "id": "17556",
    "name": "SPROUTS",
    "address": "6821 West 135th Street, Overland Park, KS, 66223",
    "phone": "913.643.4190",
    "hours": "Call for hours",
    "lat": 37.7038,
    "lng": -97.2253
  },
  {
    "id": "17555",
    "name": "SPROUTS",
    "address": "8550 Maurer Road, Lenexa, KS, 66219",
    "phone": "913.312.1586",
    "hours": "Call for hours",
    "lat": 38.8619,
    "lng": -94.661
  },
  {
    "id": "17554",
    "name": "SPROUTS",
    "address": "9628 Nall Avenue, Overland Park, KS, 66207",
    "phone": "913.643.9170",
    "hours": "Call for hours",
    "lat": 38.9536,
    "lng": -94.7336
  },
  {
    "id": "17553",
    "name": "SPROUTS",
    "address": "4740 Bauer Farm Drive, Lawrence, KS, 66049",
    "phone": "785.727.7314",
    "hours": "Call for hours",
    "lat": 38.9575,
    "lng": -94.6452
  },
  {
    "id": "17552",
    "name": "SPROUTS",
    "address": "8383 North Booth Avenue, Kansas City (Liberty), MO, 64158",
    "phone": "816.222.0202",
    "hours": "Call for hours",
    "lat": 38.9704,
    "lng": -95.2769
  },
  {
    "id": "17551",
    "name": "SPROUTS",
    "address": "6061 N.W. 64th Street, Kansas City, MO, 64151",
    "phone": "816.303.6503",
    "hours": "Call for hours",
    "lat": 39.2284,
    "lng": -94.472
  },
  {
    "id": "17550",
    "name": "SPROUTS",
    "address": "800 NE Hwy 291, Lee's Summit, MO, 64086",
    "phone": "816.272.7038",
    "hours": "Call for hours",
    "lat": 39.2127,
    "lng": -94.6383
  },
  {
    "id": "17549",
    "name": "SPROUTS",
    "address": "3150 Village Shops Drive, Ste. 105, Germantown, TN, 38138",
    "phone": "901.259.7020",
    "hours": "Call for hours",
    "lat": 38.944,
    "lng": -94.2881
  },
  {
    "id": "17548",
    "name": "SPROUTS",
    "address": "576 South Perkins Road, Memphis, TN, 38117",
    "phone": "901.620.4405",
    "hours": "Call for hours",
    "lat": 35.0883,
    "lng": -89.8053
  },
  {
    "id": "17547",
    "name": "SPROUTS",
    "address": "9050 Hwy 64, Ste. A, Lakeland, TN, 38002",
    "phone": "901.259.3450",
    "hours": "Call for hours",
    "lat": 35.1124,
    "lng": -89.9034
  },
  {
    "id": "17546",
    "name": "SPROUTS",
    "address": "7620 Highway 70 S, Nashville, TN, 37221",
    "phone": "615.209.7940",
    "hours": "Call for hours",
    "lat": 35.2752,
    "lng": -89.7295
  },
  {
    "id": "17545",
    "name": "SPROUTS",
    "address": "5821 Nolensville Pike, Nashville, TN, 37211",
    "phone": "629.736.3268",
    "hours": "Call for hours",
    "lat": 36.0662,
    "lng": -86.9639
  },
  {
    "id": "17544",
    "name": "SPROUTS",
    "address": "143 Wendelwood Drive, Murfreesboro, TN, 37129",
    "phone": "615.486.6081",
    "hours": "Call for hours",
    "lat": 36.0725,
    "lng": -86.724
  },
  {
    "id": "17543",
    "name": "SPROUTS",
    "address": "1010 Murfreesboro Road, Ste. 194, Franklin, TN, 37064",
    "phone": "615.567.0191",
    "hours": "Call for hours",
    "lat": 35.871,
    "lng": -86.4181
  },
  {
    "id": "17542",
    "name": "SPROUTS",
    "address": "7504 US 72 West NW, Unit B, Madison, AL, 35758",
    "phone": "256.203.8334",
    "hours": "Call for hours",
    "lat": 35.9328,
    "lng": -86.8788
  },
  {
    "id": "17541",
    "name": "SPROUTS",
    "address": "5250 Medford Drive, Ste. 120, Hoover, AL, 35244",
    "phone": "205.263.4970",
    "hours": "Call for hours",
    "lat": 34.7108,
    "lng": -86.7425
  },
  {
    "id": "17540",
    "name": "SPROUTS",
    "address": "5265 US 280, Birmingham, AL, 35242",
    "phone": "205.263.2808",
    "hours": "Call for hours",
    "lat": 33.3538,
    "lng": -86.8254
  },
  {
    "id": "17539",
    "name": "SPROUTS",
    "address": "1031 Montgomery Hwy., Ste 101, Vestavia Hills, AL, 35216",
    "phone": "205.484.0084",
    "hours": "Call for hours",
    "lat": 33.3813,
    "lng": -86.7046
  },
  {
    "id": "17538",
    "name": "SPROUTS",
    "address": "3150 SE Federal Hwy, Stuart, FL, 34994",
    "phone": "772.272.9698",
    "hours": "Call for hours",
    "lat": 33.4188,
    "lng": -86.7867
  },
  {
    "id": "17537",
    "name": "SPROUTS",
    "address": "1759 NW Saint Lucie West Blvd, Port St Lucie, FL, 34986",
    "phone": "772.310.5465",
    "hours": "Call for hours",
    "lat": 27.1968,
    "lng": -80.2538
  },
  {
    "id": "17536",
    "name": "SPROUTS",
    "address": "33652 US Highway 19 N, Palm Harbor, FL, 34684",
    "phone": "727.437.3824",
    "hours": "Call for hours",
    "lat": 27.3215,
    "lng": -80.403
  },
  {
    "id": "17535",
    "name": "SPROUTS",
    "address": "8840 Strength Avenue, New Port Richey, FL, 34655",
    "phone": "727.807.2200",
    "hours": "Call for hours",
    "lat": 28.0848,
    "lng": -82.7253
  },
  {
    "id": "17534",
    "name": "SPROUTS",
    "address": "8330 South Tamiami Trail, S. Sarasota, FL, 34238",
    "phone": "941.218.8119",
    "hours": "Call for hours",
    "lat": 28.2129,
    "lng": -82.6807
  },
  {
    "id": "17533",
    "name": "SPROUTS",
    "address": "1149 Cortez Road West, Bradenton, FL, 34207",
    "phone": "941.297.2359",
    "hours": "Call for hours",
    "lat": 27.2427,
    "lng": -82.4751
  },
  {
    "id": "17532",
    "name": "SPROUTS",
    "address": "2224 Logan Blvd North, Naples, FL, 34119",
    "phone": "239.325.6950",
    "hours": "Call for hours",
    "lat": 27.4394,
    "lng": -82.5778
  },
  {
    "id": "17531",
    "name": "SPROUTS",
    "address": "2000 Tamiami Trail, Unit 224, Port Charlotte, FL, 33948",
    "phone": "941.699.2501",
    "hours": "Call for hours",
    "lat": 26.2665,
    "lng": -81.7146
  },
  {
    "id": "17530",
    "name": "SPROUTS",
    "address": "19990 South Tamiami Trail, Estero, FL, 33928",
    "phone": "239.306.5384",
    "hours": "Call for hours",
    "lat": 26.9827,
    "lng": -82.1412
  },
  {
    "id": "17529",
    "name": "SPROUTS",
    "address": "8595 College Parkway, Ste 210, Ft. Myers, FL, 33919",
    "phone": "239.396.5883",
    "hours": "Call for hours",
    "lat": 26.4351,
    "lng": -81.8102
  },
  {
    "id": "17528",
    "name": "SPROUTS",
    "address": "1800 NE Pine Island Road, Cape Coral, FL, 33909",
    "phone": "239.392.1396",
    "hours": "Call for hours",
    "lat": 26.5567,
    "lng": -81.9034
  },
  {
    "id": "17527",
    "name": "SPROUTS",
    "address": "7263 Seminole Blvd, Seminole, FL, 33772",
    "phone": "727.655.9055",
    "hours": "Call for hours",
    "lat": 26.6939,
    "lng": -81.9452
  },
  {
    "id": "17526",
    "name": "SPROUTS",
    "address": "23656 US Highway 19 N, Clearwater, FL, 33765",
    "phone": "727.437.1455",
    "hours": "Call for hours",
    "lat": 27.8466,
    "lng": -82.7954
  },
  {
    "id": "17525",
    "name": "SPROUTS",
    "address": "4571 66th Street North, Kenneth City, FL, 33709",
    "phone": "727.620.6030",
    "hours": "Call for hours",
    "lat": 27.9902,
    "lng": -82.7433
  },
  {
    "id": "17524",
    "name": "SPROUTS",
    "address": "8620 Hunter Village Road, Tampa, FL, 33647",
    "phone": "813.683.8072",
    "hours": "Call for hours",
    "lat": 27.8201,
    "lng": -82.7308
  },
  {
    "id": "17523",
    "name": "SPROUTS",
    "address": "1523 S Dale Mabry Hwy, S. Tampa, FL, 33629",
    "phone": "813.466.3390",
    "hours": "Call for hours",
    "lat": 28.1147,
    "lng": -82.3678
  },
  {
    "id": "17522",
    "name": "SPROUTS",
    "address": "10619 Sheldon Road, Tampa, FL, 33626",
    "phone": "772.348.2150",
    "hours": "Call for hours",
    "lat": 27.921,
    "lng": -82.5079
  },
  {
    "id": "17521",
    "name": "SPROUTS",
    "address": "15110 North Dale Mabry Hwy, Tampa, FL, 33618",
    "phone": "813.619.4000",
    "hours": "Call for hours",
    "lat": 28.0509,
    "lng": -82.6164
  },
  {
    "id": "17520",
    "name": "SPROUTS",
    "address": "2150 East Fowler Avenue, Tampa, FL, 33612",
    "phone": "813.771.9936",
    "hours": "Call for hours",
    "lat": 28.0763,
    "lng": -82.4852
  },
  {
    "id": "17519",
    "name": "SPROUTS",
    "address": "101 West 7th Avenue, Tampa, FL, 33602",
    "phone": "813.807.3146",
    "hours": "Call for hours",
    "lat": 28.0502,
    "lng": -82.45
  },
  {
    "id": "17518",
    "name": "SPROUTS",
    "address": "3315 Lithia Pinecrest Road, Valrico, FL, 33596",
    "phone": "813.603.9630",
    "hours": "Call for hours",
    "lat": 27.9614,
    "lng": -82.4597
  },
  {
    "id": "17517",
    "name": "SPROUTS",
    "address": "12960 South US Hwy 301, Riverview, FL, 33578",
    "phone": "813.284.3440",
    "hours": "Call for hours",
    "lat": 27.8925,
    "lng": -82.243
  },
  {
    "id": "17516",
    "name": "SPROUTS",
    "address": "11339 Causeway Blvd, Brandon, FL, 33511",
    "phone": "813.725.1220",
    "hours": "Call for hours",
    "lat": 27.8633,
    "lng": -82.3499
  },
  {
    "id": "17515",
    "name": "SPROUTS",
    "address": "5030 West Atlantic Avenue, Delray Beach, FL, 33484",
    "phone": "561.654.2692",
    "hours": "Call for hours",
    "lat": 27.9056,
    "lng": -82.2881
  },
  {
    "id": "17514",
    "name": "SPROUTS",
    "address": "3757 Military Trail, Jupiter, FL, 33458",
    "phone": "561.658.4062",
    "hours": "Call for hours",
    "lat": 26.4543,
    "lng": -80.1346
  },
  {
    "id": "17513",
    "name": "SPROUTS",
    "address": "930 South Federal Hwy, Deerfield Beach, FL, 33441",
    "phone": "954.363.2070",
    "hours": "Call for hours",
    "lat": 26.9339,
    "lng": -80.1201
  },
  {
    "id": "17512",
    "name": "SPROUTS",
    "address": "9850 South Jog Road, Boynton Beach, FL, 33437",
    "phone": "561.739.1834",
    "hours": "Call for hours",
    "lat": 26.3096,
    "lng": -80.0992
  },
  {
    "id": "17511",
    "name": "SPROUTS",
    "address": "9831 Glades Road, West Boca Raton, FL, 33434",
    "phone": "561.880.9105",
    "hours": "Call for hours",
    "lat": 26.5312,
    "lng": -80.1418
  },
  {
    "id": "17510",
    "name": "SPROUTS",
    "address": "820 S State Rd 7, Wellington, FL, 33414",
    "phone": "561.515.8625",
    "hours": "Call for hours",
    "lat": 26.3839,
    "lng": -80.1749
  },
  {
    "id": "17509",
    "name": "SPROUTS",
    "address": "1901-B North Military Trail, West Palm Beach, FL, 33409",
    "phone": "561.835.5418",
    "hours": "Call for hours",
    "lat": 26.6587,
    "lng": -80.2414
  },
  {
    "id": "17508",
    "name": "SPROUTS",
    "address": "700 East Oakland Park Blvd, Oakland Park, FL, 33334",
    "phone": "561.894.0789",
    "hours": "Call for hours",
    "lat": 26.7162,
    "lng": -80.0965
  },
  {
    "id": "17507",
    "name": "SPROUTS",
    "address": "12690 SW 88th Street, Miami, FL, 33186",
    "phone": "786.798.7074",
    "hours": "Call for hours",
    "lat": 26.1845,
    "lng": -80.1344
  },
  {
    "id": "17506",
    "name": "SPROUTS",
    "address": "2631 NE 10th Ct, Homestead, FL, 33033",
    "phone": "754.764.7247",
    "hours": "Call for hours",
    "lat": 25.6694,
    "lng": -80.4085
  },
  {
    "id": "17505",
    "name": "SPROUTS",
    "address": "12216 Miramar Parkway, Miramar, FL, 33025",
    "phone": "754.799.8177",
    "hours": "Call for hours",
    "lat": 25.4906,
    "lng": -80.438
  },
  {
    "id": "17504",
    "name": "SPROUTS",
    "address": "150 South Compass Way, Dania Beach, FL, 33004",
    "phone": "954.715.3376",
    "hours": "Call for hours",
    "lat": 25.9921,
    "lng": -80.2712
  },
  {
    "id": "17503",
    "name": "SPROUTS",
    "address": "4460 Hollywood Blvd, West Melbourne, FL, 32904",
    "phone": "321.462.3184",
    "hours": "Call for hours",
    "lat": 26.0476,
    "lng": -80.1447
  },
  {
    "id": "17502",
    "name": "SPROUTS",
    "address": "12500 Lake Underhill Road, Orlando, FL, 32828",
    "phone": "689.303.4690",
    "hours": "Call for hours",
    "lat": 28.0673,
    "lng": -80.678
  },
  {
    "id": "17501",
    "name": "SPROUTS",
    "address": "7603 Turkey Lake Road, Ste 101, Orlando, FL, 32819",
    "phone": "321.340.2023",
    "hours": "Call for hours",
    "lat": 28.5523,
    "lng": -81.1795
  },
  {
    "id": "17500",
    "name": "SPROUTS",
    "address": "2530 East Colonial Drive, Orlando, FL, 32803",
    "phone": "689.219.8967",
    "hours": "Call for hours",
    "lat": 28.4522,
    "lng": -81.4678
  },
  {
    "id": "17499",
    "name": "SPROUTS",
    "address": "1999 Aloma Avenue, Winter Park, FL, 32792",
    "phone": "407.702.1212",
    "hours": "Call for hours",
    "lat": 28.5559,
    "lng": -81.3535
  },
  {
    "id": "17498",
    "name": "SPROUTS",
    "address": "1121 Alafaya Trail, Ste 1091, Oviedo, FL, 32765",
    "phone": "407.542.6070",
    "hours": "Call for hours",
    "lat": 28.5974,
    "lng": -81.3036
  },
  {
    "id": "17497",
    "name": "SPROUTS",
    "address": "2283 E Semoran Blvd, Apopka, FL, 32703",
    "phone": "689.336.2070",
    "hours": "Call for hours",
    "lat": 28.6513,
    "lng": -81.2066
  },
  {
    "id": "17496",
    "name": "SPROUTS",
    "address": "12675 Beach Blvd. Ste 200, Jacksonville, FL, 32246",
    "phone": "904.539.8317",
    "hours": "Call for hours",
    "lat": 28.6354,
    "lng": -81.4888
  },
  {
    "id": "17495",
    "name": "SPROUTS",
    "address": "4873 Town Center Parkway, Jacksonville, FL, 32246",
    "phone": "904.438.7840",
    "hours": "Call for hours",
    "lat": 30.2933,
    "lng": -81.5092
  },
  {
    "id": "17494",
    "name": "SPROUTS",
    "address": "330 Buena Vista Blvd, The Villages, FL, 32162",
    "phone": "352.706.2925",
    "hours": "Call for hours",
    "lat": 28.9341,
    "lng": -81.9599
  },
  {
    "id": "17493",
    "name": "SPROUTS",
    "address": "630 Crane Creek Drive, Augusta, GA, 30907",
    "phone": "706.993.9150",
    "hours": "Call for hours",
    "lat": 33.5229,
    "lng": -82.0852
  },
  {
    "id": "17492",
    "name": "SPROUTS",
    "address": "2925 Buford Drive, Ste 2400, Buford, GA, 30519",
    "phone": "470.600.6528",
    "hours": "Call for hours",
    "lat": 34.0797,
    "lng": -83.9308
  },
  {
    "id": "17491",
    "name": "SPROUTS",
    "address": "4600 Roswell Road, Ste.  A100, Sandy Springs, GA, 30342",
    "phone": "678.954.5294",
    "hours": "Call for hours",
    "lat": 33.8842,
    "lng": -84.3761
  },
  {
    "id": "17490",
    "name": "SPROUTS",
    "address": "2480 Mount Vernon Road, Dunwoody, GA, 30338",
    "phone": "678.690.1237",
    "hours": "Call for hours",
    "lat": 33.9669,
    "lng": -84.3249
  },
  {
    "id": "17489",
    "name": "SPROUTS",
    "address": "1845 Piedmont Ave NE, Ste 500, Atlanta, GA, 30324",
    "phone": "404.751.0605",
    "hours": "Call for hours",
    "lat": 33.8206,
    "lng": -84.3549
  },
  {
    "id": "17488",
    "name": "SPROUTS",
    "address": "2015 East Highway 54, Peachtree City, GA, 30269",
    "phone": "678.586.2577",
    "hours": "Call for hours",
    "lat": 33.3915,
    "lng": -84.5635
  },
  {
    "id": "17487",
    "name": "SPROUTS",
    "address": "1430 Towne Lake Parkway, Woodstock, GA, 30189",
    "phone": "678.224.9799",
    "hours": "Call for hours",
    "lat": 34.1281,
    "lng": -84.5717
  },
  {
    "id": "17486",
    "name": "SPROUTS",
    "address": "2220 Peachtree Industrial Blvd., Ste 200, Duluth, GA, 30097",
    "phone": "470.362.7283",
    "hours": "Call for hours",
    "lat": 34.026,
    "lng": -84.147
  },
  {
    "id": "17485",
    "name": "SPROUTS",
    "address": "5130 Peachtree Parkway, #100, Norcross, GA, 30092",
    "phone": "678.690.1249",
    "hours": "Call for hours",
    "lat": 33.9701,
    "lng": -84.2216
  },
  {
    "id": "17484",
    "name": "SPROUTS",
    "address": "4310 Lavista Road, Ste A200, Tucker, GA, 30084",
    "phone": "470.260.2368",
    "hours": "Call for hours",
    "lat": 33.857,
    "lng": -84.216
  },
  {
    "id": "17483",
    "name": "SPROUTS",
    "address": "4330 East West Connector, Smyrna, GA, 30082",
    "phone": "770.200.7587",
    "hours": "Call for hours",
    "lat": 33.8631,
    "lng": -84.5382
  },
  {
    "id": "17482",
    "name": "SPROUTS",
    "address": "2530 Cumberland Blvd SE, Smyrna, GA, 30080",
    "phone": "470.750.1841",
    "hours": "Call for hours",
    "lat": 33.8796,
    "lng": -84.5023
  },
  {
    "id": "17481",
    "name": "SPROUTS",
    "address": "10800 Alpharetta Hwy., Ste. C-410, Roswell, GA, 30076",
    "phone": "678.353.0102",
    "hours": "Call for hours",
    "lat": 34.0213,
    "lng": -84.3104
  },
  {
    "id": "17480",
    "name": "SPROUTS",
    "address": "3805 Dallas Hwy SW, Ste 200, Marietta, GA, 30064",
    "phone": "678.919.8701",
    "hours": "Call for hours",
    "lat": 33.9343,
    "lng": -84.6076
  },
  {
    "id": "17479",
    "name": "SPROUTS",
    "address": "4101 Roswell Road NE, Ste. 700, Marietta, GA, 30062",
    "phone": "770.200.9172",
    "hours": "Call for hours",
    "lat": 34.0025,
    "lng": -84.4633
  },
  {
    "id": "17478",
    "name": "SPROUTS",
    "address": "1250 Scenic Highway, Ste. 1704, Lawrenceville, GA, 30045",
    "phone": "678.690.1279",
    "hours": "Call for hours",
    "lat": 33.9367,
    "lng": -83.9573
  },
  {
    "id": "17477",
    "name": "SPROUTS",
    "address": "530 Lakeland Plaza, Ste. B, Cumming, GA, 30040",
    "phone": "470.505.2000",
    "hours": "Call for hours",
    "lat": 34.2321,
    "lng": -84.158
  },
  {
    "id": "17476",
    "name": "SPROUTS",
    "address": "2551 Blackmon Drive, Decatur, GA, 30033",
    "phone": "404.965.6290",
    "hours": "Call for hours",
    "lat": 33.8123,
    "lng": -84.2819
  },
  {
    "id": "17475",
    "name": "SPROUTS",
    "address": "3630 Peachtree Parkway, #99, Suwanee (John's Creek), GA, 30024",
    "phone": "678.690.1243",
    "hours": "Call for hours",
    "lat": 34.0425,
    "lng": -84.0262
  },
  {
    "id": "17474",
    "name": "SPROUTS",
    "address": "2200 Woodruff Road, Ste 300, Simpsonville, SC, 29681",
    "phone": "864.757.3240",
    "hours": "Call for hours",
    "lat": 34.7512,
    "lng": -82.255
  },
  {
    "id": "17473",
    "name": "SPROUTS",
    "address": "2810 Freedom Parkway Drive, Fayetteville, NC, 28314",
    "phone": "910.748.5985",
    "hours": "Call for hours",
    "lat": 35.0583,
    "lng": -79.008
  },
  {
    "id": "17472",
    "name": "SPROUTS",
    "address": "15121 Ballancroft Pkwy, Ste A, Charlotte, NC, 28277",
    "phone": "704.778.3010",
    "hours": "Call for hours",
    "lat": 35.0552,
    "lng": -80.8195
  },
  {
    "id": "17471",
    "name": "SPROUTS",
    "address": "14124 Steele Creek Road, Charlotte, NC, 28273",
    "phone": "828.705.3910",
    "hours": "Call for hours",
    "lat": 35.1287,
    "lng": -80.9338
  },
  {
    "id": "17470",
    "name": "SPROUTS",
    "address": "105 West NC Hwy 54, Ste 237A, Durham, NC, 27713",
    "phone": "919.768.4055",
    "hours": "Call for hours",
    "lat": 35.9112,
    "lng": -78.9178
  },
  {
    "id": "17469",
    "name": "SPROUTS",
    "address": "9414 Falls of Neuse Road, Ste. 120, Raleigh, NC, 27615",
    "phone": "919.326.2530",
    "hours": "Call for hours",
    "lat": 35.8887,
    "lng": -78.6393
  },
  {
    "id": "17468",
    "name": "SPROUTS",
    "address": "3357 Battleground Avenue, Greensboro, NC, 27410",
    "phone": "336.252.5250",
    "hours": "Call for hours",
    "lat": 36.1032,
    "lng": -79.8794
  },
  {
    "id": "17467",
    "name": "SPROUTS",
    "address": "803 Goucher Blvd, Ste 102, Towson, MD, 21286",
    "phone": "410.842.6010",
    "hours": "Call for hours",
    "lat": 39.4143,
    "lng": -76.5761
  },
  {
    "id": "17466",
    "name": "SPROUTS",
    "address": "3800 Boston Street, Baltimore, MD, 21224",
    "phone": "443.836.5882",
    "hours": "Call for hours",
    "lat": 39.2876,
    "lng": -76.5568
  },
  {
    "id": "17465",
    "name": "SPROUTS",
    "address": "8048 Ritchie Hwy #6B, Pasadena, MD, 21122",
    "phone": "443.960.8484",
    "hours": "Call for hours",
    "lat": 39.1206,
    "lng": -76.495
  },
  {
    "id": "17464",
    "name": "SPROUTS",
    "address": "9150 Baltimore National Pike, Ste 1, Ellicott City, MD, 21042",
    "phone": "410.696.3160",
    "hours": "Call for hours",
    "lat": 39.2726,
    "lng": -76.8614
  },
  {
    "id": "17463",
    "name": "SPROUTS",
    "address": "680 Marketplace Drive, Bel Air, MD, 21014",
    "phone": "443.567.7788",
    "hours": "Call for hours",
    "lat": 39.5394,
    "lng": -76.3564
  },
  {
    "id": "17462",
    "name": "SPROUTS",
    "address": "494 Elden Street, Ste 110, Herndon, VA, 20170",
    "phone": "703.480.7930",
    "hours": "Call for hours",
    "lat": 38.9839,
    "lng": -77.3675
  },
  {
    "id": "17461",
    "name": "SPROUTS",
    "address": "8431 Sudley Road, Manassas, VA, 20109",
    "phone": "571.579.3257",
    "hours": "Call for hours",
    "lat": 38.793,
    "lng": -77.5266
  },
  {
    "id": "17460",
    "name": "SPROUTS",
    "address": "4801 Concord Pike, Wilmington, DE, 19803",
    "phone": "302.467.2344",
    "hours": "Call for hours",
    "lat": 39.7994,
    "lng": -75.5317
  },
  {
    "id": "17459",
    "name": "SPROUTS",
    "address": "1000 South Broad Street, Unit C, Philadelphia, PA, 19146",
    "phone": "215.606.2400",
    "hours": "Call for hours",
    "lat": 39.9379,
    "lng": -75.1794
  },
  {
    "id": "17458",
    "name": "SPROUTS",
    "address": "2001 Welsh Road, Dresher, PA, 19025",
    "phone": "267.715.0602",
    "hours": "Call for hours",
    "lat": 40.1431,
    "lng": -75.1624
  },
  {
    "id": "17457",
    "name": "SPROUTS",
    "address": "640 West Cuthbert Blvd, Haddon Township, NJ, 8108",
    "phone": "856.873.9052",
    "hours": "Call for hours",
    "lat": 39.9157,
    "lng": -75.0634
  },
  {
    "id": "17456",
    "name": "SPROUTS",
    "address": "227 Route 73 South, Marlton, NJ, 8053",
    "phone": "856.355.8228",
    "hours": "Call for hours",
    "lat": 39.8845,
    "lng": -74.9067
  },
  {
    "id": "17455",
    "name": "HEB",
    "address": "10161 W GRAND PARKWAY S, RICHMOND, TX, 77407-8643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6607294,
    "lng": -95.7369549
  },
  {
    "id": "17454",
    "name": "HEB",
    "address": "10919 LOUETTA RD, HOUSTON, TX, 77070-1667",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9954598,
    "lng": -95.5763325
  },
  {
    "id": "17453",
    "name": "HEB",
    "address": "1503 FM 1431, MARBLE FALLS, TX, 78654-4902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5828556,
    "lng": -98.2799355
  },
  {
    "id": "17452",
    "name": "HEB",
    "address": "1701 WEST ALABAMA ST, HOUSTON, TX, 77098-2807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7380744,
    "lng": -95.4026268
  },
  {
    "id": "17451",
    "name": "HEB",
    "address": "17238 BULVERDE ROAD, SAN ANTONIO, TX, 78247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5949446,
    "lng": -98.4175657
  },
  {
    "id": "17450",
    "name": "HEB",
    "address": "1900 TEXAS AVENUE SOUTH, COLLEGE STATION, TX, 77840-3914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6124687,
    "lng": -96.3187858
  },
  {
    "id": "17449",
    "name": "HEB",
    "address": "19900 SOUTHWEST FWY, SUGAR LAND, TX, 77479-6505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5647388,
    "lng": -95.6853256
  },
  {
    "id": "17448",
    "name": "HEB",
    "address": "2000 RANCH ROAD 620 S, LAKEWAY, TX, 78734-6238",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3442707,
    "lng": -97.9665978
  },
  {
    "id": "17447",
    "name": "HEB",
    "address": "2755 E.LEAGUE CITY PARKWAY, LEAGUE CITY, TX, 77573-3360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5056442,
    "lng": -95.0388653
  },
  {
    "id": "17446",
    "name": "HEB",
    "address": "2800 EAST WHITESTONE, CEDAR PARK, TX, 78613-7273",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.531944,
    "lng": -97.78531
  },
  {
    "id": "17445",
    "name": "HEB",
    "address": "3301 SHERWOOD WAY, SAN ANGELO, TX, 76901-3528",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.4446956,
    "lng": -100.4802085
  },
  {
    "id": "17444",
    "name": "HEB",
    "address": "3540 RAYFORD RD, SPRING, TX, 77386-4343",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1094173,
    "lng": -95.3874011
  },
  {
    "id": "17443",
    "name": "HEB",
    "address": "3601 FM 1488, THE WOODLANDS, TX, 77384-3943",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2260365,
    "lng": -95.5196119
  },
  {
    "id": "17442",
    "name": "HEB",
    "address": "3875 W.DAVIS ST., CONROE, TX, 77304-1837",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3256173,
    "lng": -95.5002316
  },
  {
    "id": "17441",
    "name": "HEB",
    "address": "4517 KINGWOOD DRIVE, KINGWOOD, TX, 77345-2621",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0510409,
    "lng": -95.1821126
  },
  {
    "id": "17440",
    "name": "HEB",
    "address": "4701 EAST BLVD, DEER PARK, TX, 77536-5404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6671373,
    "lng": -95.0968024
  },
  {
    "id": "17439",
    "name": "HEB",
    "address": "4950 FM 1463, KATY, TX, 77494-5426",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7198165,
    "lng": -95.8480494
  },
  {
    "id": "17438",
    "name": "HEB",
    "address": "4955 BEECHNUT STREET, HOUSTON, TX, 77096-4001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6888799,
    "lng": -95.4642686
  },
  {
    "id": "17437",
    "name": "HEB",
    "address": "5106 BISSONNET, BELLAIRE, TX, 77401-4019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7076365,
    "lng": -95.4695077
  },
  {
    "id": "17436",
    "name": "HEB",
    "address": "530 HWY 6, SUGAR LAND, TX, 77478-4947",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6085407,
    "lng": -95.6443163
  },
  {
    "id": "17435",
    "name": "HEB",
    "address": "5895 SAN FELIPE STREET, HOUSTON, TX, 77057-3061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7480668,
    "lng": -95.4855231
  },
  {
    "id": "17434",
    "name": "HEB",
    "address": "6210 FAIRMONT PKWY, PASADENA, TX, 77505-4027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6486915,
    "lng": -95.1443471
  },
  {
    "id": "17433",
    "name": "HEB",
    "address": "6900 BRODIE LANE, AUSTIN, TX, 78745-5008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2163545,
    "lng": -97.8308463
  },
  {
    "id": "17432",
    "name": "HEB",
    "address": "725 E VILLA MARIA RD STE 1300, BRYAN, TX, 77802-5320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6437652,
    "lng": -96.3508301
  },
  {
    "id": "17431",
    "name": "HEB",
    "address": "7405 FM 1960 EAST, HUMBLE, TX, 77346-3128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0001716,
    "lng": -95.1635513
  },
  {
    "id": "17430",
    "name": "HEB",
    "address": "7988 FM 1488, MAGNOLIA, TX, 77354-1611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2215521,
    "lng": -95.5843133
  },
  {
    "id": "17429",
    "name": "HEB",
    "address": "8503 NW MILITARY HWY, SAN ANTONIO, TX, 78231-1841",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5529585,
    "lng": -98.5341673
  },
  {
    "id": "17428",
    "name": "HEB",
    "address": "8900 HWY 6, MISSOURI CITY, TX, 77459-6931",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5386894,
    "lng": -95.5367219
  },
  {
    "id": "17427",
    "name": "HEB",
    "address": "9595 SIX PINES RD, THE WOODLANDS, TX, 77380-1531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1639605,
    "lng": -95.4643004
  },
  {
    "id": "17426",
    "name": "HEB",
    "address": "97 OYSTER CREEK DRIVE, LAKE JACKSON, TX, 77566-4622",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.0423654,
    "lng": -95.4460047
  },
  {
    "id": "17425",
    "name": "HEB",
    "address": "999 EAST BASSE ROAD, SAN ANTONIO, TX, 78209-1804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.495244,
    "lng": -98.479745
  },
  {
    "id": "17424",
    "name": "HEB",
    "address": "104 HASLER BLVD, BASTROP, TX, 78602-3740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1096641,
    "lng": -97.3344405
  },
  {
    "id": "17423",
    "name": "HEB",
    "address": "10718 POTRANCO ROAD, SAN ANTONIO, TX, 78251-3312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4343223,
    "lng": -98.7028066
  },
  {
    "id": "17422",
    "name": "HEB",
    "address": "1150 NW LOOP 1604, SAN ANTONIO, TX, 78248-4552",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6066299,
    "lng": -98.5103109
  },
  {
    "id": "17421",
    "name": "HEB",
    "address": "11521 NORTH FM620, BUILDING A, AUSTIN, TX, 78726-1168",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4522444,
    "lng": -97.8268947
  },
  {
    "id": "17420",
    "name": "HEB",
    "address": "1700 EAST PALM VALLEY BLVD, ROUND ROCK, TX, 78664-4677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5190708,
    "lng": -97.6560614
  },
  {
    "id": "17419",
    "name": "HEB",
    "address": "17460 I.H. 35 NORTH, SCHERTZ, TX, 78154-1264",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5973982,
    "lng": -98.2794652
  },
  {
    "id": "17418",
    "name": "HEB",
    "address": "20725 HWY 46, SPRING BRANCH, TX, 78070-6270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.796134,
    "lng": -98.4299032
  },
  {
    "id": "17417",
    "name": "HEB",
    "address": "20935 US HIGHWAY 281 NORTH, SAN ANTONIO, TX, 78258-7587",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6413127,
    "lng": -98.4573271
  },
  {
    "id": "17416",
    "name": "HEB",
    "address": "2508 EAST RIVERSIDE DRIVE, AUSTIN, TX, 78741-3037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2364302,
    "lng": -97.7221515
  },
  {
    "id": "17415",
    "name": "HEB",
    "address": "420 WEST BANDERA ROAD, BOERNE, TX, 78006-2523",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7810596,
    "lng": -98.7350177
  },
  {
    "id": "17414",
    "name": "HEB",
    "address": "5000 GATTIS SCHOOL RD, HUTTO, TX, 78634-2025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5022607,
    "lng": -97.5822847
  },
  {
    "id": "17413",
    "name": "HEB",
    "address": "5401 SOUTH FM 1626, KYLE, Â TX, 78640-6038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0158656,
    "lng": -97.8620114
  },
  {
    "id": "17412",
    "name": "HEB",
    "address": "651 N. US HWY 183, LEANDER, TX, 78641-7001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5833317,
    "lng": -97.8554744
  },
  {
    "id": "17411",
    "name": "HEB",
    "address": "9238 N.LOOP 1604 WEST, SAN ANTONIO, TX, 78249-2577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5536932,
    "lng": -98.664184
  },
  {
    "id": "17410",
    "name": "ZOE SOZO'S LLC",
    "address": "215 W HWY 54, ELDORADO SPRINGS, MO, 64744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8635823,
    "lng": -94.0267232
  },
  {
    "id": "17409",
    "name": "WOOLBRIGHT FARMERS MARKET",
    "address": "141 SW WOOLBRIGHT ROAD, BOYNTON BEACH, FL, 33435",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5148971,
    "lng": -80.065563
  },
  {
    "id": "17408",
    "name": "WOODSIDE HEALTH & TENNIS",
    "address": "2000 W 47TH PLACE, WESTWOOD, KS, 66205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0434157,
    "lng": -94.6102567
  },
  {
    "id": "17407",
    "name": "WOOD MEADOW MARKET",
    "address": "342 MAIN STREET, ENOSBURG FALLS, VT, 5450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9073613,
    "lng": -72.8047922
  },
  {
    "id": "17406",
    "name": "WONDERFUL LIFE FOODS",
    "address": "115 NORTH MAIN STREET, CROOKSTON, MN, 56716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7749118,
    "lng": -96.6080789
  },
  {
    "id": "17405",
    "name": "WILD MARKET",
    "address": "3435 SOCO ROAD, MAGGIE VALLEY, NC, 28751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.51567,
    "lng": -83.085784
  },
  {
    "id": "17404",
    "name": "WHOLE HEALTH NAT FDS LLC",
    "address": "1175 GRAND AVE, MARION, IA, 52302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0197004,
    "lng": -91.5974375
  },
  {
    "id": "17403",
    "name": "VENCOPIA LLC",
    "address": "6224 3RD STREET NW, WASHINGTON, DC, 20011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9657388,
    "lng": -77.016436
  },
  {
    "id": "17402",
    "name": "VEGAN'S DELIGHT",
    "address": "3565 B BOSTON RD, BRONX, NY, 10469",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8786459,
    "lng": -73.8443447
  },
  {
    "id": "17401",
    "name": "TOWN HILL MARKET",
    "address": "1339 RT 102, BAR HARBOR, ME, 4609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3992206,
    "lng": -68.3344854
  },
  {
    "id": "17400",
    "name": "THISTLE & SHAMROCK",
    "address": "62 WALDEN STREET, CAMBRIDGE, MA, 2140",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3889758,
    "lng": -71.1247736
  },
  {
    "id": "17399",
    "name": "THE WELL IN BEDFORD",
    "address": "126 S BRIDGE ST, BEDFORD, VA, 24523",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3336706,
    "lng": -79.5241397
  },
  {
    "id": "17398",
    "name": "THE LAMB SHOPPE",
    "address": "61231 HWY 7 W, HUTCHINSON, MN, 55350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9420795,
    "lng": -94.538043
  },
  {
    "id": "17397",
    "name": "THE FARM LIFE GENERAL STR",
    "address": "2090 PRINCESS ANNE ROAD, VIRGINIA BEACH, VA, 23456",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7497318,
    "lng": -76.01063
  },
  {
    "id": "17396",
    "name": "TAO NATURAL FOODS",
    "address": "2200 HENNEPIN AVE S, MINNEAPOLIS, MN, 55405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9608039,
    "lng": -93.2933752
  },
  {
    "id": "17395",
    "name": "SYNCHRONICITY FOUNDATION",
    "address": "2610 ADIAL ROAD, FABER, VA, 22938",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8712032,
    "lng": -78.8605584
  },
  {
    "id": "17394",
    "name": "SQUAM LAKE MARKETPLACE",
    "address": "863 ROUTE 3, HOLDERNESS, NH, 3245",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.7310544,
    "lng": -71.5877366
  },
  {
    "id": "17393",
    "name": "SOUTH ROYALTON MARKET",
    "address": "222 CHELSEA STREET, SOUTH ROYALTON, VT, 5068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.8202116,
    "lng": -72.5219762
  },
  {
    "id": "17392",
    "name": "SOUTH RIVER CMPNG PHARM",
    "address": "3656 MAYLAND COURT, RICHMOND, VA, 23233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6400891,
    "lng": -77.5702804
  },
  {
    "id": "17391",
    "name": "SOHO ORGANIC MARKET",
    "address": "406 SOUTH GRIFFIN ST, ELIZABETH CITY, NC, 27909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2967133,
    "lng": -76.2337447
  },
  {
    "id": "17390",
    "name": "SIMPLY WHOLESOME LIFE",
    "address": "33 INDIAN ROCK ROAD, WINDHAM, NH, 3087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8066379,
    "lng": -71.293685
  },
  {
    "id": "17389",
    "name": "SEEDS OF SOMMER",
    "address": "4464 MAIN ST, PEQUOT LAKES, MN, 56472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.6031315,
    "lng": -94.310444
  },
  {
    "id": "17388",
    "name": "SECRETS OF NATURE INC",
    "address": "3923 SOUTH CAPITOL ST, WASHINGTON, DC, 20032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8320216,
    "lng": -77.0085591
  },
  {
    "id": "17387",
    "name": "SANO HEALTH FOOD CENTER",
    "address": "4069 BROADWAY, NEW YORK, NY, 10032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8437302,
    "lng": -73.939309
  },
  {
    "id": "17386",
    "name": "RIVER BEND FARM MARKET",
    "address": "625 RT 30, TOWNSHEND, VT, 5353",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0278389,
    "lng": -72.6584484
  },
  {
    "id": "17385",
    "name": "RED FOX MARKET",
    "address": "112 S MICHIGAN AVE, BIG RAPIDS, MI, 49307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6978645,
    "lng": -85.4823901
  },
  {
    "id": "17384",
    "name": "REAL FOOD SHOPPE,THE",
    "address": "211 W MAIN STREET, PLAINFIELD, IN, 46168",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7024482,
    "lng": -86.4032769
  },
  {
    "id": "17383",
    "name": "RAIL CITY MARKET, INC.",
    "address": "8 SOUTH MAIN, ST. ALBANS, VT, 5478",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8111134,
    "lng": -73.0836966
  },
  {
    "id": "17382",
    "name": "R&R CAFE",
    "address": "129-32B MERRICK BLVD, JAMAICA, NY, 11434",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6802798,
    "lng": -73.7633798
  },
  {
    "id": "17381",
    "name": "PURE PASTURES DEARBORN",
    "address": "23309 FORD ROAD, DEARBORN, MI, 48128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3267257,
    "lng": -83.2641694
  },
  {
    "id": "17380",
    "name": "PROVISION AT YOUR DOOR",
    "address": "721 HWY 99, WAYNESBORO, TN, 38485",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3250457,
    "lng": -87.743859
  },
  {
    "id": "17379",
    "name": "PITTSFIELD HEALTH FOOD CT",
    "address": "407 NORTH STREET, PITTSFIELD, MA, 1201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4544396,
    "lng": -73.252485
  },
  {
    "id": "17378",
    "name": "PIGGLY WIGGLY #260 BUYLO",
    "address": "3314 CLAIRMONT AVE, BIRMINGHAM, AL, 35221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5132177,
    "lng": -86.7805148
  },
  {
    "id": "17377",
    "name": "PETERS CORNUCOPIA DOWNTOW",
    "address": "1707 ORISKANY STREET WEST, UTICA, NY, 13502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1096833,
    "lng": -75.2540587
  },
  {
    "id": "17376",
    "name": "PEACE PHARMACY INC",
    "address": "2366 UNIVERSITY AVE, BRONX, NY, 10468",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8624782,
    "lng": -73.9046821
  },
  {
    "id": "17375",
    "name": "PARADISE NATURAL FOODS",
    "address": "ROUTE 20 1823 WESTERN AV, ALBANY, NY, 12203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6898307,
    "lng": -73.8661932
  },
  {
    "id": "17374",
    "name": "PALMYRA NATURAL FOODS",
    "address": "120 E. MAIN STREET, PALMYRA, PA, 17078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3083929,
    "lng": -76.5936336
  },
  {
    "id": "17373",
    "name": "OUR KORNER KUPBOARD",
    "address": "201 STATION RD, QUAKERTOWN, PA, 18951",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4318078,
    "lng": -75.3306502
  },
  {
    "id": "17372",
    "name": "ONE LIFE NATURAL MARKET",
    "address": "2312 W CUMBERLAND ST, DUNN, NC, 28334",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.322805,
    "lng": -78.636597
  },
  {
    "id": "17371",
    "name": "OH MY CHIVES NATURAL MRKT",
    "address": "7332 NOLENSVILLE STE 304, NOLENSVILLE, TN, 37135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9509024,
    "lng": -86.6680709
  },
  {
    "id": "17370",
    "name": "OCEAN CITY ORGANICS",
    "address": "11944 OCEAN GATEWAY, OCEAN CITY, MD, 21842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3369521,
    "lng": -75.140446
  },
  {
    "id": "17369",
    "name": "OBERLIN MARKET, THE",
    "address": "22 CARPENTER CT, OBERLIN, OH, 44074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2907882,
    "lng": -82.2181507
  },
  {
    "id": "17368",
    "name": "NUTRITION HERBS & DIET",
    "address": "3615 NICHOLAS ST, EASTON, PA, 18045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6717905,
    "lng": -75.2648253
  },
  {
    "id": "17367",
    "name": "NORTHWIND NATURAL FOODS C",
    "address": "116 SOUTH SUFFOLK ST., IRONWOOD, MI, 49938",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.4549728,
    "lng": -90.1684706
  },
  {
    "id": "17366",
    "name": "NATURE'S WAREHOUSE",
    "address": "6563 ROUTE 9, HOWELL, NJ, 7731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1183897,
    "lng": -74.2178876
  },
  {
    "id": "17365",
    "name": "NATURE'S REMEDY",
    "address": "26 MONROE STREET, ELLICOTTVILLE, NY, 14731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2752377,
    "lng": -78.6706103
  },
  {
    "id": "17364",
    "name": "NATURE'S HARVEST",
    "address": "1955 SOUTH ROAD, POUGHKEEPSIE, NY, 12601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6223698,
    "lng": -73.9184632
  },
  {
    "id": "17363",
    "name": "NATURE'S HARMONY FOOD ST",
    "address": "6368 BELLE AVE, LEWISTOWN, PA, 17044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5920004,
    "lng": -77.5777479
  },
  {
    "id": "17362",
    "name": "NATURE'S GRACE",
    "address": "947 MAIN ST., HONESDALE, PA, 18431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5743106,
    "lng": -75.2564628
  },
  {
    "id": "17361",
    "name": "NATURAL HEALTH",
    "address": "2001 COLLEGE DR DOOR #1, CLEMENTON, NJ, 8021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8031749,
    "lng": -75.0240105
  },
  {
    "id": "17360",
    "name": "NATURAL GROCER",
    "address": "14453 POTOMAC MILLS RD, DALE CITY, VA, 22192",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6351457,
    "lng": -77.2935124
  },
  {
    "id": "17359",
    "name": "NANNI HEALTH FOOD STORE",
    "address": "5222 CHURCH AVENUE, BROOKLYN, NY, 11203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6521726,
    "lng": -73.9277839
  },
  {
    "id": "17358",
    "name": "MR FRESH FARMERS MARKET",
    "address": "13601 BISCAYNE BLVD, NORTH MIAMI BEACH, FL, 33181",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9011859,
    "lng": -80.1594733
  },
  {
    "id": "17357",
    "name": "MOTHER EARTH FOODS",
    "address": "102 EAST MAIN STREET, WILKESBORO, NC, 28697",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1487349,
    "lng": -81.1509314
  },
  {
    "id": "17356",
    "name": "MOONEY'S MARKET & EMPRIUM",
    "address": "1265 W MAIN ST, MONTEAGLE, TN, 37356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2277473,
    "lng": -85.8647162
  },
  {
    "id": "17355",
    "name": "MOHAWK HARVEST CO-OP MKT",
    "address": "51 N MAIN STREET, GLOVERSVILLE, NY, 12078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0520428,
    "lng": -74.344932
  },
  {
    "id": "17354",
    "name": "MOH-HEALTH & HARMONY",
    "address": "470 HUDSON, NEW YORK, NY, 10014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7319216,
    "lng": -74.0063648
  },
  {
    "id": "17353",
    "name": "MISSION NUTRITION",
    "address": "204 NEW YORK AVE, HUNTINGTON, NY, 11743",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8753394,
    "lng": -73.4238682
  },
  {
    "id": "17352",
    "name": "MEHURONS SUPER MARKET",
    "address": "VILLAGE SQUARE SHOP CTR, WAITSFIELD, VT, 5673",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1845712,
    "lng": -72.8355482
  },
  {
    "id": "17351",
    "name": "MEADOWBROOK NATURAL FOODS",
    "address": "238 W. MAIN, WEST PLAINS, MO, 65775",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7278529,
    "lng": -91.8547804
  },
  {
    "id": "17350",
    "name": "MCNALLYS FOODS",
    "address": "1026 MAIN STREET, GRINNELL, IA, 50112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7457319,
    "lng": -92.7253096
  },
  {
    "id": "17349",
    "name": "MARKET ZERO",
    "address": "62 W 8TH ST, HOLLAND, MI, 49423",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7901763,
    "lng": -86.1104354
  },
  {
    "id": "17348",
    "name": "MARCUS MARKET",
    "address": "4614 SECOND AVENUE, DETROIT, MI, 48201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3526826,
    "lng": -83.0668842
  },
  {
    "id": "17347",
    "name": "MAIN STREET FARM",
    "address": "36 MAIN STREET, LIVINGSTON MANOR, NY, 12758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.901359,
    "lng": -74.8272727
  },
  {
    "id": "17346",
    "name": "LIVINGWELL",
    "address": "12004 CHERRY HILL RD., SILVER SPRINGS, MD, 20904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.054977,
    "lng": -76.9537305
  },
  {
    "id": "17345",
    "name": "LIVING WELL SN",
    "address": "12004 CHERRY HILL RD, SILVER SPRINGS, MD, 20904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.054977,
    "lng": -76.9537305
  },
  {
    "id": "17344",
    "name": "LIVE WELL FRANKLIN",
    "address": "400 DOWNS BLVD, FRANKLIN, TN, 37064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9087666,
    "lng": -86.8843991
  },
  {
    "id": "17343",
    "name": "LIM'S HEALTH FOODS",
    "address": "359 COTT GROV RD., BLOOMFIELD, CT, 6002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8180103,
    "lng": -72.7161826
  },
  {
    "id": "17342",
    "name": "LAKES REGION NUTR CENTER",
    "address": "73 MAIN ST, MEREDITH, NH, 3253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6558479,
    "lng": -71.5005861
  },
  {
    "id": "17341",
    "name": "LAKE ROAD MARKET",
    "address": "20267 LAKE ROAD, ROCKY RIVER, OH, 44116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4831958,
    "lng": -81.8454886
  },
  {
    "id": "17340",
    "name": "LAKE NUTRITION CTR-LADY L",
    "address": "1112 BICHARA BLVD, LADY LAKE, FL, 32159",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9415156,
    "lng": -81.9477024
  },
  {
    "id": "17339",
    "name": "KEY INGREDIENTS FOR HLTH",
    "address": "2505 MAPLE AVE, SLAYTON, MN, 56172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.9889799,
    "lng": -95.753064
  },
  {
    "id": "17338",
    "name": "KADEJAN MARKET",
    "address": "500 12TH ST NE, GLENWOOD, MN, 56334",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6554862,
    "lng": -95.3720207
  },
  {
    "id": "17337",
    "name": "JOHNSON COMPOUNDING CENTR",
    "address": "577 MAIN STREET, WALTHAM, MA, 2452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3768545,
    "lng": -71.2341956
  },
  {
    "id": "17336",
    "name": "JO ROB'S NATURALS",
    "address": "1130 TEXAS PALMYRA HWY, HONESDALE, PA, 18431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5525933,
    "lng": -75.2194183
  },
  {
    "id": "17335",
    "name": "INERGY MARKET",
    "address": "8310 E OAK ISLAND DR, OAK ISLAND, NC, 28465",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9090317,
    "lng": -78.0813725
  },
  {
    "id": "17334",
    "name": "IGA SHELTER ISLAND",
    "address": "75 N FERRY RD, SHELTER ISLAND, NY, 11964",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0747026,
    "lng": -72.3404552
  },
  {
    "id": "17333",
    "name": "IGA MASSAPEQUA PARK",
    "address": "1038 PARK BLVD, MASSAPEQUA PARK, NY, 11762",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6799705,
    "lng": -73.4558736
  },
  {
    "id": "17332",
    "name": "HUNNERS MARKET",
    "address": "720 JAMES STREET, CLAYTON, NY, 13624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.2351866,
    "lng": -76.0841669
  },
  {
    "id": "17331",
    "name": "HOUSE OF NUTRITION",
    "address": "50 MAIN STREET, LUZERNE, PA, 18709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2828662,
    "lng": -75.8932878
  },
  {
    "id": "17330",
    "name": "HONEY TREE, LLC",
    "address": "331 TILTON RD, NORTHFIELD, NJ, 8225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3862103,
    "lng": -74.5541779
  },
  {
    "id": "17329",
    "name": "HERB SHOP-NATURE'S GARDEN",
    "address": "8151 VAUGHN ROAD, MONTGOMERY, AL, 36117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.339446,
    "lng": -86.1722751
  },
  {
    "id": "17328",
    "name": "HENDERSONVILLE PRODUCE",
    "address": "760 E MAIN ST, HENDERSONVILLE, TN, 37075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3269363,
    "lng": -86.5634577
  },
  {
    "id": "17327",
    "name": "HEALTHY HABITS NATURAL MK",
    "address": "1120 CENTRE TPKE, ORWIGSBURG, PA, 17961",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6400878,
    "lng": -76.0940972
  },
  {
    "id": "17326",
    "name": "HEALTH WORKS",
    "address": "425 NORFOLK AVE, NORFOLK, NE, 68701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0323832,
    "lng": -97.4129995
  },
  {
    "id": "17325",
    "name": "HEALTH STORE, THE",
    "address": "160 E SANILAC RD, SANDUSKY, MI, 48471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4211289,
    "lng": -82.8251409
  },
  {
    "id": "17324",
    "name": "HEALTH SHOPPE",
    "address": "8025 KINGSTON PIKE, KNOXVILLE, TN, 37919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9263603,
    "lng": -84.0464782
  },
  {
    "id": "17323",
    "name": "HEALTH PRODUCTS AND YOG",
    "address": "1021 E SHOTWELL ST, BAINBRIDGE, GA, 39819",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.904174,
    "lng": -84.5625712
  },
  {
    "id": "17322",
    "name": "HEALTH NUT",
    "address": "4000 VIRGINA BEACH BLVD, VIRGINIA BEACH, VA, 23452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8427633,
    "lng": -76.113512
  },
  {
    "id": "17321",
    "name": "HEALTH IN HAND",
    "address": "639 NORTH PIERCE AVE., LANCASTER, OH, 43130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.721632,
    "lng": -82.6186714
  },
  {
    "id": "17320",
    "name": "HEALTH FOOD CORNER",
    "address": "390 MAIN STREET, WINSTED, CT, 6098",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9212678,
    "lng": -73.0705494
  },
  {
    "id": "17319",
    "name": "HEALTH COUNTRY",
    "address": "1631 4TH ST SW, MASON CITY, IA, 50401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1470854,
    "lng": -93.2258425
  },
  {
    "id": "17318",
    "name": "HEALTH CONSCIOUS NAT FDS",
    "address": "231-22 MERRICK BLVD, LAURELTON, NY, 11413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6753005,
    "lng": -73.7389366
  },
  {
    "id": "17317",
    "name": "HARVEST MARKET",
    "address": "308 MAIN ST, MILFORD, OH, 45150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1751722,
    "lng": -84.2949206
  },
  {
    "id": "17316",
    "name": "HAMILTON WHOLE FOODS, LTD",
    "address": "28 BROAD ST, HAMILTON, NY, 13346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8262185,
    "lng": -75.5442737
  },
  {
    "id": "17315",
    "name": "H I M HEALTH FOOD MARKET",
    "address": "4374 B WHITE PLAINS ROAD, BRONX, NY, 10466",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8978134,
    "lng": -73.8546422
  },
  {
    "id": "17314",
    "name": "GULF COAST NUTRITION^^",
    "address": "2906 ALT 19, PALM HARBOR, FL, 34685",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0949321,
    "lng": -82.7721926
  },
  {
    "id": "17313",
    "name": "GREEN PLANET",
    "address": "969 FULTON STREET, BROOKLYN, NY, 11238",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.68315,
    "lng": -73.9643383
  },
  {
    "id": "17312",
    "name": "GREEN MARKET",
    "address": "17 RIVER ROAD #3, LISBON, CT, 6351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5996156,
    "lng": -71.9897988
  },
  {
    "id": "17311",
    "name": "GREEN GROCER, THE",
    "address": "24 W GENEVA ST, WILLIAMS BAY, WI, 53191",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5780452,
    "lng": -88.5417616
  },
  {
    "id": "17310",
    "name": "GREEN EARTH MARKETPLACE",
    "address": "1328 CHESTNUT ST, EMMAUS, PA, 18049",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5263275,
    "lng": -75.5101544
  },
  {
    "id": "17309",
    "name": "GRAND ORGANIC 4TH STREET",
    "address": "901 NE 4TH STREET, GRAND RAPIDS, MN, 55744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2363105,
    "lng": -93.5141512
  },
  {
    "id": "17308",
    "name": "GOOD STEWARD",
    "address": "602 2ND ST SW, WADENA, MN, 56482",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.4372166,
    "lng": -95.1428842
  },
  {
    "id": "17307",
    "name": "GARDEN MARKET",
    "address": "ROUTE 11, LONDONDERRY, VT, 5148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2264495,
    "lng": -72.8064751
  },
  {
    "id": "17306",
    "name": "FOOD FOR THOUGHT",
    "address": "5800 OVERSEAS HIGHWAY, MARATHON, FL, 33050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 24.7183366,
    "lng": -81.0726628
  },
  {
    "id": "17305",
    "name": "FARE SHARE-MAINE(2)",
    "address": "443 Main Street, NORWAY, ME, 4268",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.213964,
    "lng": -70.542978
  },
  {
    "id": "17304",
    "name": "DOWNTOWN FARM STAND",
    "address": "125 E MAIN STREET, MUNCIE, IN, 47305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1934004,
    "lng": -85.3855888
  },
  {
    "id": "17303",
    "name": "DOWN TO EARTH AMSTERDAM",
    "address": "4758 ST HWY 30, AMSTERDAM, NY, 12010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9776495,
    "lng": -74.1888068
  },
  {
    "id": "17302",
    "name": "DON VICTORIOS MARKET",
    "address": "7504 S DIXIE HWY, WEST PALM BEACH, FL, 33405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6496386,
    "lng": -80.0559477
  },
  {
    "id": "17301",
    "name": "CREATIVE HEALTH FOODS",
    "address": "2801-B BROADWAY (108TH), NEW YORK, NY, 10025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.803174,
    "lng": -73.967782
  },
  {
    "id": "17300",
    "name": "COUNTRY VIEW BULK FOODS",
    "address": "177 N GERMANIA RD, SNOVER, MI, 48472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4191899,
    "lng": -83.0081474
  },
  {
    "id": "17299",
    "name": "COMMODITIES MARKET",
    "address": "165 1ST AVE, NEW YORK, NY, 10013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7290597,
    "lng": -73.9845946
  },
  {
    "id": "17298",
    "name": "CENTRAL ART MART CORP",
    "address": "1705 S PROSPECT, CHAMPAIGN, IL, 61801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0961392,
    "lng": -88.2580576
  },
  {
    "id": "17297",
    "name": "BUMPYS NATURAL AND ORGANC",
    "address": "908 ALLEN ST, SPRINGFIELD, MA, 1118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0909397,
    "lng": -72.5307195
  },
  {
    "id": "17296",
    "name": "BROWNS MARKET",
    "address": "5718 SILVER HILL ROAD, DISTRICT HEIGHTS, MD, 20747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8552935,
    "lng": -76.9110583
  },
  {
    "id": "17295",
    "name": "BOLD CITY DISTRIBUTORS",
    "address": "8930 WESTERN WAY, JACKSONVILLE, FL, 32256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2039538,
    "lng": -81.5590498
  },
  {
    "id": "17294",
    "name": "BLUE PLANET",
    "address": "C/O MARK HAIM, COLUMBIA, MO, 65201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9514057,
    "lng": -92.3283762
  },
  {
    "id": "17293",
    "name": "BB's HEALTH FOOD STORE &M",
    "address": "8154 HIGHWAY 59 STE 205, FOLEY, AL, 36535",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.343109,
    "lng": -87.681911
  },
  {
    "id": "17292",
    "name": "BACK TO NATURE",
    "address": "1125 MAY ROAD, BLUFTON, SC, 29910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.239262,
    "lng": -80.8792222
  },
  {
    "id": "17291",
    "name": "B & C NUT SHOP",
    "address": "1362 NAAMAN'S CREEK ROAD, BOOTHWYN, PA, 19060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.840388,
    "lng": -75.496459
  },
  {
    "id": "17290",
    "name": "AUTUMN HARVEST",
    "address": "1625 E. 2ND ST, SCOTCH PLAIN, NJ, 7076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6450505,
    "lng": -74.4007367
  },
  {
    "id": "17289",
    "name": "ALTRU CHEMISTS",
    "address": "987 MANHATTAN AVE, BROOKLYN, NY, 11222",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7327645,
    "lng": -73.954976
  },
  {
    "id": "17288",
    "name": "ALL IS WELL HEALTH/INSPIR",
    "address": "1029 E THREE NOTCH ST, ANDALUSIA, AL, 36420",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3103548,
    "lng": -86.4684259
  },
  {
    "id": "17287",
    "name": "AIDLEYCO LLC",
    "address": "532 PATTERSON AVE, MOORESVILLE, NC, 28115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5926806,
    "lng": -80.8068067
  },
  {
    "id": "17286",
    "name": "AGORIA",
    "address": "224 N SYCAMORE STREET, PETERSBURG, VA, 23803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2308764,
    "lng": -77.4047147
  },
  {
    "id": "17285",
    "name": "A NEW LEAF",
    "address": "261 CABOT STREET, BEVERLY, MA, 1915",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.550186,
    "lng": -70.8777001
  },
  {
    "id": "17284",
    "name": "*BE WELLNESS^^",
    "address": "419 MAIN AVE, CLEARLAKE, IA, 50428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1368058,
    "lng": -93.380189
  },
  {
    "id": "17283",
    "name": "ZUPANS",
    "address": "2340 W BURNSIDE ST, PORTLAND, OR, 97210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5230462,
    "lng": -122.6988855
  },
  {
    "id": "17282",
    "name": "ZANOTTOS",
    "address": "1421 FOXWORTHY AVE, SAN JOSE, CA, 95118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2753744,
    "lng": -121.8922768
  },
  {
    "id": "17281",
    "name": "YES! ORGANIC MARKET, INC.",
    "address": "410 8TH ST SE, WASHINGTON, DC, 20003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8833919,
    "lng": -76.9947674
  },
  {
    "id": "17280",
    "name": "YES! ORGANIC MARKET, INC.",
    "address": "2123 14TH ST NW, WASHINGTON, DC, 20009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9185024,
    "lng": -77.0317459
  },
  {
    "id": "17279",
    "name": "WIND RIVER MERCANTILE",
    "address": "C/O LINDA DENISON, RIVERTON, WY, 82501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0245069,
    "lng": -108.3880983
  },
  {
    "id": "17278",
    "name": "WILDBERRIES",
    "address": "747 13TH STREET, ARCATA, CA, 95521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8717394,
    "lng": -124.0853047
  },
  {
    "id": "17277",
    "name": "WILD OAK",
    "address": "100 ADOBE RD, PENNGROVE, CA, 94928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2995207,
    "lng": -122.6710756
  },
  {
    "id": "17276",
    "name": "WILD OAK",
    "address": "550 DIVISADERO ST, SAN FRANCISCO, CA, 94143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7747991,
    "lng": -122.4373902
  },
  {
    "id": "17275",
    "name": "WILD BY NATURE",
    "address": "2709 LONG BEACH ROAD, OCEANSIDE, NY, 11572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6452111,
    "lng": -73.6378459
  },
  {
    "id": "17274",
    "name": "WILD BY NATURE",
    "address": "369 WEST MAIN STREET, HUNTINGTON, NY, 11743",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8708201,
    "lng": -73.4315568
  },
  {
    "id": "17273",
    "name": "WESTBORN MARKETS",
    "address": "27659 WOODWARD AVENUE, BERKLEY, MI, 48072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4937116,
    "lng": -83.1640626
  },
  {
    "id": "17272",
    "name": "WEST REGION CUSTOMER SN",
    "address": "2564 KING AVE W, STE J, BILLINGS, MT, 59102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.7546206,
    "lng": -108.5802002
  },
  {
    "id": "17271",
    "name": "WEST REGION CUSTOMER SN",
    "address": "44 VESTA LN, EMIGRANT, MT, 59027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.3643089,
    "lng": -110.7621456
  },
  {
    "id": "17270",
    "name": "WEST REGION CUSTOMER SN",
    "address": "12125 BALSAM RD, VICTORVILLE, CA, 92395",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.471514,
    "lng": -117.3296491
  },
  {
    "id": "17269",
    "name": "WEST REGION CUSTOMER SN",
    "address": "2380 N TUSTIN AVE, SANTA ANA, CA, 92705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7685297,
    "lng": -117.8367301
  },
  {
    "id": "17268",
    "name": "WEST REGION CUSTOMER SN",
    "address": "459 WALT WHITMAN RD, MELVILLE, NY, 11747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8139488,
    "lng": -73.4105968
  },
  {
    "id": "17267",
    "name": "Wan Bai Chain",
    "address": "4-76 47TH RD, LONG ISLAND CITY, NY, 11101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7448849,
    "lng": -73.9563251
  },
  {
    "id": "17266",
    "name": "Wan Bai Chain",
    "address": "321 BROAD AVENUE, RIDGEFIELD, NJ, 7657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8253667,
    "lng": -74.0098603
  },
  {
    "id": "17265",
    "name": "Wan Bai Chain",
    "address": "CITY FRESH, BROOKLYN, NY, 11237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.703138,
    "lng": -73.925435
  },
  {
    "id": "17264",
    "name": "Wan Bai Chain",
    "address": "28-19 QUEENS PLAZA SOUTH, LONG ISLAND CITY, NY, 11101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7495067,
    "lng": -73.9383053
  },
  {
    "id": "17263",
    "name": "Wan Bai Chain",
    "address": "21-30 Newtown Ave, QUEENS, NY, 11102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7712853,
    "lng": -73.9250977
  },
  {
    "id": "17262",
    "name": "Wan Bai Chain",
    "address": "2220 BOSTON RD, BRONX, NY, 10467",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8580049,
    "lng": -73.8678644
  },
  {
    "id": "17261",
    "name": "WALTER STEWARTS MKT",
    "address": "229 ELM STREET, NEW CANAAN, CT, 6840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1461963,
    "lng": -73.4980298
  },
  {
    "id": "17260",
    "name": "VITAMIN PLUS",
    "address": "5109 82ND STREET, LUBBOCK, TX, 79424",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5183491,
    "lng": -101.9211834
  },
  {
    "id": "17259",
    "name": "VITAMIN PLUS",
    "address": "5819 E KINGS HWY, SHREVEPORT, LA, 71105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4543291,
    "lng": -93.7078854
  },
  {
    "id": "17258",
    "name": "VITAMIN PLUS",
    "address": "5900 BOSQUE BLVD, WACO, TX, 76710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5302086,
    "lng": -97.1965424
  },
  {
    "id": "17257",
    "name": "VITAMIN PLUS",
    "address": "4210B S.W. 45TH AVE, AMARILLO, TX, 79109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.164834,
    "lng": -101.8848668
  },
  {
    "id": "17256",
    "name": "VITAMIN CITY",
    "address": "642 WEST ARROW HWY, SAN DIMAS, CA, 91773",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1047176,
    "lng": -117.8195072
  },
  {
    "id": "17255",
    "name": "VITAMIN AND HERB STORE",
    "address": "1130 E CLARK AVE - STE 12, SANTA MARIA, CA, 93455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8637468,
    "lng": -120.4167548
  },
  {
    "id": "17254",
    "name": "VITAMIN AND HERB STORE",
    "address": "1130 E CLARK AVE, ORCUTT, CA, 93455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8637468,
    "lng": -120.4167548
  },
  {
    "id": "17253",
    "name": "VINEYARD GROCER",
    "address": "C/O CHELSEA PRODUCE CENTR, CHELSEA, MA, 2150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3972167,
    "lng": -71.0512554
  },
  {
    "id": "17252",
    "name": "VINEYARD GROCER",
    "address": "105 MARKET ST, CHELSEA, MA, 2150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3954644,
    "lng": -71.0485403
  },
  {
    "id": "17251",
    "name": "VILLAGE MARKET",
    "address": "455 MOUNTAIN VALLAGE BLVD #B, TELLURIDE, CO, 81435",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9325364,
    "lng": -107.8539531
  },
  {
    "id": "17250",
    "name": "VILLAGE MARKET",
    "address": "6555 AMBROSIA DR STE 1131, SAN DIEGO, CA, 92124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7946457,
    "lng": -117.1085736
  },
  {
    "id": "17249",
    "name": "UNIVERSITY OF OREGON",
    "address": "1460 COLUMBIA ST, EUGENE, OR, 97403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0411105,
    "lng": -123.0680264
  },
  {
    "id": "17248",
    "name": "UNIVERSAL HERBS",
    "address": "7910 EAST BALTIMORE ST, BALTIMORE, MD, 21224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2992187,
    "lng": -76.5156737
  },
  {
    "id": "17247",
    "name": "TOWN & COUNTRY FOODS DILLON",
    "address": "110 SOUTHSIDE BLVD, DILLON, MT, 59725-3536",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.2034934,
    "lng": -112.6461599
  },
  {
    "id": "17246",
    "name": "TOPS",
    "address": "35 FRANKLIN PLAZA, DANSVILLE, NY, 14437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5636858,
    "lng": -77.7109803
  },
  {
    "id": "17245",
    "name": "TOPS",
    "address": "5351 NORTH BURDICK ROAD, FAYETTEVILLE, NY, 13066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0298162,
    "lng": -76.0172977
  },
  {
    "id": "17244",
    "name": "TOPS",
    "address": "5274 MAIN & UNION, WILLIAMSVILLE, NY, 14221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.962604,
    "lng": -78.75786
  },
  {
    "id": "17243",
    "name": "TOPS",
    "address": "6914 ERIE ROAD, DERBY, NY, 14047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6988804,
    "lng": -78.9880316
  },
  {
    "id": "17242",
    "name": "TOPS",
    "address": "4000 VINEYARD DRIVE, DUNKIRK, NY, 14048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4584283,
    "lng": -79.3207826
  },
  {
    "id": "17241",
    "name": "TOPS",
    "address": "890 YOUNG STREET, TONAWANDA, NY, 14150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0013686,
    "lng": -78.8579294
  },
  {
    "id": "17240",
    "name": "TOPS",
    "address": "3500 MAIN STREET, AMHERST, NY, 14226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9591483,
    "lng": -78.8177352
  },
  {
    "id": "17239",
    "name": "TOPS",
    "address": "1006 N ELMIRA ST, SAYRE, PA, 18840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9881673,
    "lng": -76.546453
  },
  {
    "id": "17238",
    "name": "TOPS",
    "address": "GREEN GARDEN &, ERIE, PA, 16508",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0988242,
    "lng": -80.1079873
  },
  {
    "id": "17237",
    "name": "TOPS",
    "address": "1702 EAST 38TH STREET, ERIE, PA, 16510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1177445,
    "lng": -80.0306123
  },
  {
    "id": "17236",
    "name": "TOPS",
    "address": "830 CONSUMER SQUARE PLAZA, ELMIRA, NY, 14903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1529948,
    "lng": -76.879642
  },
  {
    "id": "17235",
    "name": "TOPS",
    "address": "2300 N TRIPHAMMER, ITHACA, NY, 14120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4815338,
    "lng": -76.4874855
  },
  {
    "id": "17234",
    "name": "TOPS",
    "address": "74 MARKET STREET, WARREN, PA, 16365",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8430748,
    "lng": -79.1436527
  },
  {
    "id": "17233",
    "name": "TOPS",
    "address": "1936 US ROUTE 6, CARMEL, NY, 10512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4127818,
    "lng": -73.6660969
  },
  {
    "id": "17232",
    "name": "TOPS",
    "address": "271 MAIN STREET, NEW PALTZ, NY, 12561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7441296,
    "lng": -74.0687957
  },
  {
    "id": "17231",
    "name": "TOPS",
    "address": "6726 ROUTE 9, RHINEBECK, NY, 12572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9466307,
    "lng": -73.8997708
  },
  {
    "id": "17230",
    "name": "TOPS",
    "address": "3918 STATE ROUTE 281, CORTLAND, NY, 13045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5964781,
    "lng": -76.2055649
  },
  {
    "id": "17229",
    "name": "TOPS",
    "address": "2140 WALWORTH-PENFIELD RD, WALWORTH, NY, 14568",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1378071,
    "lng": -77.2773307
  },
  {
    "id": "17228",
    "name": "TOPS",
    "address": "3507 MT READ/ MAIDEN, GREECE, NY, 14616",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2227778,
    "lng": -77.6616667
  },
  {
    "id": "17227",
    "name": "TOPS",
    "address": "1601 PENFIELD ROAD, ROCHESTER, NY, 14625",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1336712,
    "lng": -77.4957399
  },
  {
    "id": "17226",
    "name": "TOPS",
    "address": "1225 JEFFERSON RD, HENRIETTA, NY, 14623",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0854124,
    "lng": -77.6011071
  },
  {
    "id": "17225",
    "name": "TOPS",
    "address": "6272 FURNACE ROAD, ONTARIO, NY, 14519",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2264561,
    "lng": -77.2811687
  },
  {
    "id": "17224",
    "name": "TOPS",
    "address": "2345 BUFFALO ROAD/PIXLEY, GATES, NY, 14624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.146176,
    "lng": -77.710153
  },
  {
    "id": "17223",
    "name": "TOPS",
    "address": "390 W MAIN STREET, BATAVIA, NY, 14020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0069175,
    "lng": -78.2043536
  },
  {
    "id": "17222",
    "name": "TOPS",
    "address": "S 6150 SOUTH PARK AVENUE, HAMBURG, NY, 14075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7276661,
    "lng": -78.8237502
  },
  {
    "id": "17221",
    "name": "TOPS",
    "address": "2101 ELMWOOD AVE, BUFFALO, NY, 14207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9551998,
    "lng": -78.8767977
  },
  {
    "id": "17220",
    "name": "TOPS",
    "address": "9660 TRANSIT ROAD, EAST AMHERST, NY, 14051",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0327777,
    "lng": -78.6975497
  },
  {
    "id": "17219",
    "name": "TOPS",
    "address": "2351 MAPLE ROAD AT TRANSI, AMHERST, NY, 14221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9883745,
    "lng": -78.6995553
  },
  {
    "id": "17218",
    "name": "TOPS",
    "address": "4777 TRANSIT ROAD, DEPEW, NY, 14043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8686186,
    "lng": -78.6964422
  },
  {
    "id": "17217",
    "name": "TOPS",
    "address": "4250 MCKINLEY PARKWAY, HAMBURG, NY, 14075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7687307,
    "lng": -78.8127572
  },
  {
    "id": "17216",
    "name": "TOPS",
    "address": "1460 S. PARK AVENUE, BUFFALO, NY, 14220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.857608,
    "lng": -78.8297922
  },
  {
    "id": "17215",
    "name": "TOPS",
    "address": "2401 W STATE STREET, OLEAN, NY, 14760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.076776,
    "lng": -78.4577659
  },
  {
    "id": "17214",
    "name": "TOPS",
    "address": "3865 UNION ROAD, CHEEKTOWAGA, NY, 14225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9199849,
    "lng": -78.7513402
  },
  {
    "id": "17213",
    "name": "TOPS",
    "address": "2140 GRAND ISLAND BLVD., GRAND ISLAND, NY, 14072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0193992,
    "lng": -78.9629613
  },
  {
    "id": "17212",
    "name": "TOPS",
    "address": "123 GREY ST, EAST AURORA, NY, 14212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7663627,
    "lng": -78.6344656
  },
  {
    "id": "17211",
    "name": "TOPS",
    "address": "906 CENTER STREET, LEWISTON, NY, 14092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1714347,
    "lng": -79.0314506
  },
  {
    "id": "17210",
    "name": "TOPS",
    "address": "5175 BROADWAY, DEPEW, NY, 14043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8987913,
    "lng": -78.6836307
  },
  {
    "id": "17209",
    "name": "TOPS",
    "address": "355 ORCHARD PARK ROAD, WEST SENECA, NY, 14224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8328272,
    "lng": -78.7839792
  },
  {
    "id": "17208",
    "name": "TOPS",
    "address": "3980 MAPLE ROAD, AMHERST, NY, 14226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9923992,
    "lng": -78.8154343
  },
  {
    "id": "17207",
    "name": "TOPS",
    "address": "5827 S TRANSIT ROAD, LOCKPORT, NY, 14094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1418121,
    "lng": -78.6939011
  },
  {
    "id": "17206",
    "name": "TICONDEROGA NATURAL FOODS",
    "address": "111 MONTCALM ST, TICONDEROGA, NY, 12883",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.8490204,
    "lng": -73.4243407
  },
  {
    "id": "17205",
    "name": "THYME & SEASON NAT MARKET",
    "address": "40 HUNTINGTON STREET, SHELTON, CT, 6484",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2952984,
    "lng": -73.1456185
  },
  {
    "id": "17204",
    "name": "THE STORE",
    "address": "2050 E 6200 S, HOLLADAY, UT, 84121",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6380219,
    "lng": -111.8326388
  },
  {
    "id": "17203",
    "name": "TEXAS SINGLE STORE",
    "address": "5511 FM 2722, NEW BRAUNFELS, TX, 78132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8060865,
    "lng": -98.2292659
  },
  {
    "id": "17202",
    "name": "TEXAS SINGLE STORE",
    "address": "2918 N LAURENT, VICTORIA, TX, 77901-4141",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.8207013,
    "lng": -96.9913991
  },
  {
    "id": "17201",
    "name": "TEXAS SINGLE STORE",
    "address": "15845 HWY 105 WEST #100, MONTGOMERY, TX, 77356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3607386,
    "lng": -95.6033198
  },
  {
    "id": "17200",
    "name": "TEXAS SINGLE STORE",
    "address": "4603 SIENNA PKWY, MISSOURI CITY, TX, 77459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.515488,
    "lng": -95.5294248
  },
  {
    "id": "17199",
    "name": "TEXAS SINGLE STORE",
    "address": "19143 TIMBER FOREST DR, HUMBLE, TX, 77346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0001776,
    "lng": -95.1938066
  },
  {
    "id": "17198",
    "name": "TEXAS SINGLE STORE",
    "address": "206 N AVE D, MARATHON, TX, 79842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2072303,
    "lng": -103.245044
  },
  {
    "id": "17197",
    "name": "SWANSON HEALTH",
    "address": "4501 15TH AVE S STE 101, FARGO, ND, 58103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8589135,
    "lng": -96.8633503
  },
  {
    "id": "17196",
    "name": "SUPER 1 FOODS",
    "address": "15837 N. WESTWOOD DR, RATHDRUM, ID, 83858",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.8156144,
    "lng": -116.87665
  },
  {
    "id": "17195",
    "name": "SUNAC,SHINE,NAMI",
    "address": "440-446 UNION AVE, BROOKLYN, NY, 11211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7136514,
    "lng": -73.9512756
  },
  {
    "id": "17194",
    "name": "STUMPS",
    "address": "845 S MAIN ST, FALLBROOK, CA, 92028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3753678,
    "lng": -117.2527354
  },
  {
    "id": "17193",
    "name": "STAFF OF LIFE",
    "address": "1266 SOQUEL AVE, SANTA CRUZ, CA, 95062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9803601,
    "lng": -122.0083541
  },
  {
    "id": "17192",
    "name": "SPROUTS FARMERS MARKET",
    "address": "29 S. MILPAS ST, SANTA BARBARA, CA, 93103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4214956,
    "lng": -119.6776412
  },
  {
    "id": "17191",
    "name": "SPROUTS FARMERS MARKET",
    "address": "1101 S HOVER, LONGMONT, CO, 80501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1459316,
    "lng": -105.13322
  },
  {
    "id": "17190",
    "name": "SPROUTS FARMERS MARKET",
    "address": "820 NORTH WESTERN AVE, SAN PEDRO, CA, 90732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7503356,
    "lng": -118.3079507
  },
  {
    "id": "17189",
    "name": "SPROUTS FARMERS MARKET",
    "address": "1240 S SIGNAL BUTTE RD, MESA, AZ, 85209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3918222,
    "lng": -111.5991861
  },
  {
    "id": "17188",
    "name": "SOMETHING HEALTHY",
    "address": "119 W MAIN STREET, NEWCASTLE, WY, 82701-2123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.8552937,
    "lng": -104.2040348
  },
  {
    "id": "17187",
    "name": "SMOOTHIE KING",
    "address": "703 LONG ROAD CROSSING, CHESTERFIELD, MO, 63005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.668999,
    "lng": -90.6200834
  },
  {
    "id": "17186",
    "name": "SINGLE STORE WYOMING",
    "address": "1034 13TH ST, CODY, WY, 82414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5265602,
    "lng": -109.0619319
  },
  {
    "id": "17185",
    "name": "SINGLE STORE WYOMING",
    "address": "530 BROADWAY ST, THERMOPOLIS, WY, 82443",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6463948,
    "lng": -108.2113825
  },
  {
    "id": "17184",
    "name": "SINGLE STORE WYOMING",
    "address": "5655 W HWY 22, WILSON, WY, 83014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4986115,
    "lng": -110.8743284
  },
  {
    "id": "17183",
    "name": "SINGLE STORE WYOMING",
    "address": "371 SINCLAIR STREET, GILLETTE, WY, 82718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.2623379,
    "lng": -105.4988936
  },
  {
    "id": "17182",
    "name": "SINGLE STORE WYOMING",
    "address": "625 E. 5TH ST. SUITE #101, SHERIDAN, WY, 82801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.807167,
    "lng": -106.945487
  },
  {
    "id": "17181",
    "name": "SINGLE STORE WYOMING",
    "address": "414 E MAIN, RIVERTON, WY, 82501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0249371,
    "lng": -108.3855321
  },
  {
    "id": "17180",
    "name": "SINGLE STORE WYOMING",
    "address": "219 E PINE ST, PINEDALE, WY, 82941",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8673258,
    "lng": -109.858094
  },
  {
    "id": "17179",
    "name": "SINGLE STORE WYOMING",
    "address": "105 IVANSON AVENUE, LARAMIE, WY, 82070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3122606,
    "lng": -105.5956342
  },
  {
    "id": "17178",
    "name": "SINGLE STORE WYOMING",
    "address": "635 BIG HORN AVE, WORLAND, WY, 82401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0170991,
    "lng": -107.9603688
  },
  {
    "id": "17177",
    "name": "SINGLE STORE WYOMING",
    "address": "120 E 2ND ST, CASPER, WY, 82601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8489454,
    "lng": -106.3244954
  },
  {
    "id": "17176",
    "name": "SINGLE STORE WASHINGTON",
    "address": "308 E YELM AVE, YELM, WA, 98597",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.9403629,
    "lng": -122.6033074
  },
  {
    "id": "17175",
    "name": "SINGLE STORE WASHINGTON",
    "address": "222 W WENATCHEE AVE, WENATCHEE, WA, 98801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.427696,
    "lng": -120.3144861
  },
  {
    "id": "17174",
    "name": "SINGLE STORE WASHINGTON",
    "address": "21 W. 4TH., TONASKET, WA, 98855",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.704791,
    "lng": -119.440945
  },
  {
    "id": "17173",
    "name": "SINGLE STORE WASHINGTON",
    "address": "121 E CHANCE ALA MER NE, OCEAN SHORES, WA, 98569",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.0068302,
    "lng": -124.1605836
  },
  {
    "id": "17172",
    "name": "SINGLE STORE WASHINGTON",
    "address": "765 WONN RD #B101, GREENBANK, WA, 98253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.106919,
    "lng": -122.5740519
  },
  {
    "id": "17171",
    "name": "SINGLE STORE WASHINGTON",
    "address": "33521 SE REDMOND/FALL CITY, FALL CITY, WA, 98024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5681201,
    "lng": -121.8921125
  },
  {
    "id": "17170",
    "name": "SINGLE STORE UTAH",
    "address": "290 S MAIN ST, MOAB, UT, 84532-2509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5693429,
    "lng": -109.5517737
  },
  {
    "id": "17169",
    "name": "SINGLE STORE UTAH",
    "address": "341 27TH ST, OGDEN, UT, 84401-3603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2162359,
    "lng": -111.9720442
  },
  {
    "id": "17168",
    "name": "SINGLE STORE OREGON",
    "address": "555 SW OAK ST, PORTLAND, OR, 97204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5221915,
    "lng": -122.6760872
  },
  {
    "id": "17167",
    "name": "SINGLE STORE OREGON",
    "address": "357-A VAN BUREN ST, EUGENE, OR, 97402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0559391,
    "lng": -123.1092587
  },
  {
    "id": "17166",
    "name": "SINGLE STORE OREGON",
    "address": "159 SE 2ND ST, NEWPORT, OR, 97365-3126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.635158,
    "lng": -124.0510382
  },
  {
    "id": "17165",
    "name": "SINGLE STORE OREGON",
    "address": "1101 WEST 8TH AVE, EUGENE, OR, 97402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0511338,
    "lng": -123.1096864
  },
  {
    "id": "17164",
    "name": "SINGLE STORE OREGON",
    "address": "48444 HWY 101, LANGLOIS, OR, 97450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9276887,
    "lng": -124.4504872
  },
  {
    "id": "17163",
    "name": "SINGLE STORE OREGON",
    "address": "1222 SE DIVISION ST, PORTLAND, OR, 97202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5046652,
    "lng": -122.6531757
  },
  {
    "id": "17162",
    "name": "SINGLE STORE OREGON",
    "address": "251 NE THIRD ST, MCMINNVILLE, OR, 97128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.2102334,
    "lng": -123.1971243
  },
  {
    "id": "17161",
    "name": "SINGLE STORE OREGON",
    "address": "8130 NE NICHOALS CT STE 3, HILLSBORO, OR, 97124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.531681,
    "lng": -122.896113
  },
  {
    "id": "17160",
    "name": "SINGLE STORE OREGON",
    "address": "603 ROGUE RIVER HWY(474-0252, GRANTS PASS, OR, 97527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4242229,
    "lng": -123.3280288
  },
  {
    "id": "17159",
    "name": "SINGLE STORE OREGON",
    "address": "745 MAIN ST, DALLAS, OR, 97338",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9221134,
    "lng": -123.3170877
  },
  {
    "id": "17158",
    "name": "SINGLE STORE OREGON",
    "address": "686 UNION, GRANTS PASS, OR, 97527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4225512,
    "lng": -123.3431921
  },
  {
    "id": "17157",
    "name": "SINGLE STORE NEW MEXICO",
    "address": "HWY 518 & CALVARY RD, MORA, NM, 87732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9742434,
    "lng": -105.3301106
  },
  {
    "id": "17156",
    "name": "SINGLE STORE NEW MEXICO",
    "address": "PO BOX 53, ARROYO SECO, NM, 87514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.518457,
    "lng": -105.568807
  },
  {
    "id": "17155",
    "name": "SINGLE STORE NEW MEXICO",
    "address": "SUITE 13, ALBUQUERQUE, NM, 87111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0832409,
    "lng": -106.6550276
  },
  {
    "id": "17154",
    "name": "SINGLE STORE NEW MEXICO",
    "address": "745 N RIVERSIDE DR STE F, ESPANOLA, NM, 87532-2889",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0014677,
    "lng": -106.0625035
  },
  {
    "id": "17153",
    "name": "SINGLE STORE NEW MEXICO",
    "address": "630 N BROADWAY, TRUTH OR CONSEQUEN, NM, 87901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1283134,
    "lng": -107.2582354
  },
  {
    "id": "17152",
    "name": "SINGLE STORE NEVADA",
    "address": "7575 W WASHINGTON AVE #129, LAS VEGAS, NV, 89128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1808401,
    "lng": -115.1433576
  },
  {
    "id": "17151",
    "name": "SINGLE STORE NEVADA",
    "address": "4441 W. CHARLESTON BLVD, LAS VEGAS, NV, 89102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1581566,
    "lng": -115.2001013
  },
  {
    "id": "17150",
    "name": "SINGLE STORE MONTANA",
    "address": "301 NORTHWEST BYP, GREAT FALLS, MT, 59404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5166001,
    "lng": -111.3214723
  },
  {
    "id": "17149",
    "name": "SINGLE STORE MONTANA",
    "address": "237 BLAINE ST, MISSOULA, MT, 59801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8611525,
    "lng": -113.9987344
  },
  {
    "id": "17148",
    "name": "SINGLE STORE MONTANA",
    "address": "8570 HWY 35, BIGFORK, MT, 59911",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.0559435,
    "lng": -114.0743674
  },
  {
    "id": "17147",
    "name": "SINGLE STORE MONTANA",
    "address": "6755 LYNX LN, BOZEMAN, MT, 59806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6677164,
    "lng": -111.1510381
  },
  {
    "id": "17146",
    "name": "SINGLE STORE MONTANA",
    "address": "30938 US HWY 2, LIBBY, MT, 59923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.4034395,
    "lng": -115.5848445
  },
  {
    "id": "17145",
    "name": "SINGLE STORE LOUISIANA",
    "address": "2372 ST CLAUDE, NEW ORLEANS, LA, 70117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9685777,
    "lng": -90.0525283
  },
  {
    "id": "17144",
    "name": "SINGLE STORE IDAHO",
    "address": "922 16 TH AVE, LEWISTON, ID, 83501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.4038026,
    "lng": -117.0190055
  },
  {
    "id": "17143",
    "name": "SINGLE STORE IDAHO",
    "address": "88 W COMMERCE, HAYDEN LAKE, ID, 83835",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7528662,
    "lng": -116.7878459
  },
  {
    "id": "17142",
    "name": "SINGLE STORE HAWAII",
    "address": "375 W KUIAHA STE 35, HAIKU MAUI, HI, 96708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 20.9204426,
    "lng": -156.3082185
  },
  {
    "id": "17141",
    "name": "SINGLE STORE HAWAII",
    "address": "3-3122 KUHIO HWY A-9, LIHUE, KAUAI, HI, 96766",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.9780146,
    "lng": -159.3682236
  },
  {
    "id": "17140",
    "name": "SINGLE STORE HAWAII",
    "address": "92-8676 LOTUS BLOSSOM LN, OCEAN VIEW, HAWAII, HI, 96737",
    "phone": "",
    "hours": "Call for hours",
    "lat": 19.0847048,
    "lng": -155.7743094
  },
  {
    "id": "17139",
    "name": "SINGLE STORE HAWAII",
    "address": "8441 WARNER DR, CULVER CITY, CA, 96814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0233211,
    "lng": -118.3788581
  },
  {
    "id": "17138",
    "name": "SINGLE STORE COLORADO",
    "address": "545 US HWY 24N, BUENA VISTA, CO, 81211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.846767,
    "lng": -106.1350754
  },
  {
    "id": "17137",
    "name": "SINGLE STORE COLORADO",
    "address": "511 ZEREX ST UNIT 108, FRASER, CO, 80442",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9429767,
    "lng": -105.8121887
  },
  {
    "id": "17136",
    "name": "SINGLE STORE COLORADO",
    "address": "PO BOX 1683, WESTCLIFFE, CO, 81252",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1347219,
    "lng": -105.4658353
  },
  {
    "id": "17135",
    "name": "SINGLE STORE COLORADO",
    "address": "680 GRAND AVE, DEL NORTE, CO, 81132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6790845,
    "lng": -106.3535766
  },
  {
    "id": "17134",
    "name": "SINGLE STORE COLORADO",
    "address": "668 PEORIA ST, AURORA, CO, 80011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7266669,
    "lng": -104.8460492
  },
  {
    "id": "17133",
    "name": "SINGLE STORE COLORADO",
    "address": "PO BOX 1184, CRESTED BUTTE, CO, 81224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8697146,
    "lng": -106.9878231
  },
  {
    "id": "17132",
    "name": "SINGLE STORE COLORADO",
    "address": "790 RED FEATHER LANE, WOODLAND PARK, CO, 80863",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0034854,
    "lng": -105.0625454
  },
  {
    "id": "17131",
    "name": "SINGLE STORE COLORADO",
    "address": "1902 17TH STREET SUITE A, CODY, WY, 82414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5173241,
    "lng": -109.0534737
  },
  {
    "id": "17130",
    "name": "SINGLE STORE COLORADO",
    "address": "240 FRONT STREET, PLACERVILLE, CO, 81430",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0167525,
    "lng": -108.0530467
  },
  {
    "id": "17129",
    "name": "SINGLE STORE COLORADO",
    "address": "117 NAVAJO TRAIL DR STE T, PAGOSA SPRINGS, CO, 81147-9033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2536203,
    "lng": -107.0811335
  },
  {
    "id": "17128",
    "name": "SINGLE STORE COLORADO",
    "address": "230 GRAND AVE, PAONIA, CO, 81428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8680804,
    "lng": -107.5981583
  },
  {
    "id": "17127",
    "name": "SINGLE STORE COLORADO",
    "address": "2035 W VICTORY WAY, CRAIG, CO, 81625",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5145851,
    "lng": -107.5703742
  },
  {
    "id": "17126",
    "name": "SINGLE STORE COLORADO",
    "address": "31424 HIGHWAY 92, HOTCHKISS, CO, 81419",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7999097,
    "lng": -107.7734987
  },
  {
    "id": "17125",
    "name": "SINGLE STORE COLORADO",
    "address": "804 N MAIN ST, GUNNISON, CO, 81230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5525646,
    "lng": -106.9256924
  },
  {
    "id": "17124",
    "name": "SINGLE STORE COLORADO",
    "address": "235 HWY 133, HOTCHKISS, CO, 81419",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.800666,
    "lng": -107.7123875
  },
  {
    "id": "17123",
    "name": "SINGLE STORE COLORADO",
    "address": "PO BOX 9, PAONIA, CO, 81428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8665517,
    "lng": -107.5975851
  },
  {
    "id": "17122",
    "name": "SINGLE STORE COLORADO",
    "address": "191 W GALENA AVE, CRESTONE, CO, 81131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9954799,
    "lng": -105.6999123
  },
  {
    "id": "17121",
    "name": "SINGLE STORE COLORADO",
    "address": "306 E MAIN ST, ASPEN, CO, 81611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1911994,
    "lng": -106.8200962
  },
  {
    "id": "17120",
    "name": "SINGLE STORE COLORADO",
    "address": "13006 HWY 65, ECKERT, CO, 81418",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8427182,
    "lng": -107.9622112
  },
  {
    "id": "17119",
    "name": "SINGLE STORE COLORADO",
    "address": "209 ELK AVE, CRESTED BUTTE, CO, 81224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8699453,
    "lng": -106.986984
  },
  {
    "id": "17118",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "802 E OJAI AV_______________, OJAI, CA, 93023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4486664,
    "lng": -119.2379807
  },
  {
    "id": "17117",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "18711 TIFFENI DR, TWAIN HARTE, CA, 95383",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0398664,
    "lng": -120.2255334
  },
  {
    "id": "17116",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "15057 W WHITESBRIDGE AVE, KERMAN, CA, 93630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7339408,
    "lng": -120.0611072
  },
  {
    "id": "17115",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "20221 VALLEY BLVD, TEHACHAPI, CA, 93561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1247917,
    "lng": -118.489658
  },
  {
    "id": "17114",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "10820 VENTURA BLVD, STUDIO CITY, CA, 91604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.138805,
    "lng": -118.3666775
  },
  {
    "id": "17113",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "3068 CLAREMONT AV, BERKELEY, CA, 94705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8547489,
    "lng": -122.2482619
  },
  {
    "id": "17112",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "2244 MAIN ST, CAMBRIA, CA, 93428-3018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5639442,
    "lng": -121.0820347
  },
  {
    "id": "17111",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "117 E HWY 4, MURPHYS, CA, 95247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1379881,
    "lng": -120.4571408
  },
  {
    "id": "17110",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "99531 HWY 96, SOMES BAR, CA, 95568",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.382865,
    "lng": -123.496262
  },
  {
    "id": "17109",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "17766 PENN VALLEY DRIVE, PENN VALLEY, CA, 95946",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1991854,
    "lng": -121.1822582
  },
  {
    "id": "17108",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "4756 ADMIRALTY, MARINA DEL REY, CA, 90292",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9785932,
    "lng": -118.438563
  },
  {
    "id": "17107",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "3930 JUDAH ST, SAN FRANCISCO, CA, 94122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7606337,
    "lng": -122.5043581
  },
  {
    "id": "17106",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "523 W COMPTON BLVD, COMPTON, CA, 90220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8960926,
    "lng": -118.23258
  },
  {
    "id": "17105",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "1080 A MAIN ST, SAINT HELENA, CA, 94574",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5030794,
    "lng": -122.4663836
  },
  {
    "id": "17104",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "2000 H ST, BAKERSFIELD, CA, 93301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.377408,
    "lng": -119.0208753
  },
  {
    "id": "17103",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "2302 ARTESIA BLVD, REDONDO BEACH, CA, 90278",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.872589,
    "lng": -118.370346
  },
  {
    "id": "17102",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "314 NORTH MT SHASTA BLVD, MT. SHASTA, CA, 96067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3139898,
    "lng": -122.3126827
  },
  {
    "id": "17101",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "508 MAIN ST, WEAVERVILLE, CA, 96093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.729795,
    "lng": -122.9398403
  },
  {
    "id": "17100",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "12 CORTE MADERA AVE, MILL VALLEY, CA, 94941",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9067815,
    "lng": -122.5473663
  },
  {
    "id": "17099",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "31109 RANCHO VIEJO RD, SAN JUAN CAPISTRAN, CA, 92765",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5082288,
    "lng": -117.65914
  },
  {
    "id": "17098",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "496 BROAD ST, SAN LUIS OBISPO, CA, 93405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2849134,
    "lng": -120.6686326
  },
  {
    "id": "17097",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "WILL CALL ROC, ROCKLIN, CA, 95765",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.780713,
    "lng": -121.2393089
  },
  {
    "id": "17096",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "5468 SKYLANE BLVD, SANTA ROSA, CA, 95403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5145356,
    "lng": -122.7981144
  },
  {
    "id": "17095",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "860 DIVISADERO STREET, SAN FRANCISCO, CA, 94117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7776986,
    "lng": -122.4381094
  },
  {
    "id": "17094",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "625 SOUTH HIGHWAY 49, JACKSON, CA, 95642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3417355,
    "lng": -120.7664575
  },
  {
    "id": "17093",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "308 BRODERICK ST, SAN FRANCISCO, CA, 94117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7732175,
    "lng": -122.4389052
  },
  {
    "id": "17092",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "23812 SPINNAKER COURT, VALENCIA, CA, 91355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4276728,
    "lng": -118.5520066
  },
  {
    "id": "17091",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "115 S. FRANKLIN STREET, FORT BRAGG, CA, 95437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4413772,
    "lng": -123.8048817
  },
  {
    "id": "17090",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "3615 MT DIABLO BLVD, LAFAYETTE, CA, 94549",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8906975,
    "lng": -122.1244815
  },
  {
    "id": "17089",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "2745 BECHELLI LANE, REDDING, CA, 96002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.567259,
    "lng": -122.362393
  },
  {
    "id": "17088",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "45015 UKIAH ST, MENDOCINO, CA, 95460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.30592,
    "lng": -123.7993845
  },
  {
    "id": "17087",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "3416 INTERNATIONAL BLVD, OAKLAND, CA, 94601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7767676,
    "lng": -122.2233089
  },
  {
    "id": "17086",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "2200 EL CAMINO REAL, SANTA MARGARITA, CA, 93453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3927328,
    "lng": -120.6062497
  },
  {
    "id": "17085",
    "name": "SINGLE STORE CALIFORNIA",
    "address": "2354 CLEMENT STREET, SAN FRANCISCO, CA, 941221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7822271,
    "lng": -122.4847353
  },
  {
    "id": "17084",
    "name": "SINGLE STORE ARIZONA",
    "address": "347 MCKEOWN AVE, PATAGONIA, AZ, 85624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5393284,
    "lng": -110.7543623
  },
  {
    "id": "17083",
    "name": "SINGLE STORE ARIZONA",
    "address": "2565 NORTHERN AVE, KINGMAN, AZ, 86409",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.254191,
    "lng": -114.0193691
  },
  {
    "id": "17082",
    "name": "SINGLE STORE ARIZONA",
    "address": "5549 HWY 260, LAKSIDE, AZ, 85929",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.190557,
    "lng": -110.015004
  },
  {
    "id": "17081",
    "name": "SINGLE STORE ALASKA",
    "address": "410 TRAINOR GATE RD, FAIRBANKS, AK, 99701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 64.8429875,
    "lng": -147.6603929
  },
  {
    "id": "17080",
    "name": "SINGLE STORE ALASKA",
    "address": "3525 COLLEGE RD, FAIRBANKS, AK, 99709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 64.8560676,
    "lng": -147.8088545
  },
  {
    "id": "17079",
    "name": "SINGLE STORE ALASKA",
    "address": "MARGINAL WAY SW, SEATTLE, WA, 98124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5548994,
    "lng": -122.3482109
  },
  {
    "id": "17078",
    "name": "SINGLE STORE ALASKA",
    "address": "937 PORTAGE ST 778 SMALL TRD, HAINES, AK, 99827",
    "phone": "",
    "hours": "Call for hours",
    "lat": 59.2358333,
    "lng": -135.445
  },
  {
    "id": "17077",
    "name": "SINGLE STORE ALASKA",
    "address": "12498 KENAI SPUR HWY UNIT 2A, KENAI, AK, 99611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 60.5614668,
    "lng": -151.2856332
  },
  {
    "id": "17076",
    "name": "SINGLE STORE ALASKA",
    "address": "2610 SPENARD ROAD SUITE B, ANCHORAGE, AK, 99503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 61.1970637,
    "lng": -149.9057301
  },
  {
    "id": "17075",
    "name": "SINGLE STORE ALASKA",
    "address": "140 S WILLOW ST, KENAI, AK, 99611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 60.5575008,
    "lng": -151.2526462
  },
  {
    "id": "17074",
    "name": "SINGLE STORE ALASKA",
    "address": "140 S  WILLOW ST, KENAI, AK, 99611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 60.5575008,
    "lng": -151.2526462
  },
  {
    "id": "17073",
    "name": "SHOP N KART ASHLAND",
    "address": "2268 ASHLAND ST, ASHLAND, OR, 97520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1840102,
    "lng": -122.6729042
  },
  {
    "id": "17072",
    "name": "SAVE U MORE (AK)",
    "address": "3611 GREATLAND STREET, HOMER, AK, 99603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 59.6424867,
    "lng": -151.5479871
  },
  {
    "id": "17071",
    "name": "SAVE U MORE (AK)",
    "address": "2105 FRANK ALBERT RD E, FIFE, WA, 98424",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2356711,
    "lng": -122.3656692
  },
  {
    "id": "17070",
    "name": "ROYAL BLUE GROCERY",
    "address": "360 NUECES ST A-1, AUSTIN, TX, 78701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2673094,
    "lng": -97.7499037
  },
  {
    "id": "17069",
    "name": "ROBERTS MARKETS",
    "address": "3015 WOODSIDE ROAD, WOODSIDE, CA, 94062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4293953,
    "lng": -122.2542665
  },
  {
    "id": "17068",
    "name": "ROBERTS MARKETS",
    "address": "4420 ALPINE RD, PORTOLA VALLEY, CA, 94028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.372905,
    "lng": -122.2073279
  },
  {
    "id": "17067",
    "name": "RIESBECK MARKETS",
    "address": "55 SOUTH 23RD STREET, CAMBRIDGE, OH, 43725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0272883,
    "lng": -81.5639273
  },
  {
    "id": "17066",
    "name": "RIESBECK MARKETS",
    "address": "2485 NATIONAL ROAD, WHEELING, WV, 26003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0475303,
    "lng": -80.6494263
  },
  {
    "id": "17065",
    "name": "RETAIL SOUTH DAKOTA",
    "address": "638 MAIN ST, SPEARFISH, SD, 57783",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4897545,
    "lng": -103.8584718
  },
  {
    "id": "17064",
    "name": "RETAIL SOUTH DAKOTA",
    "address": "127 W HWY 14, SPEARFISH, SD, 57783",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4920043,
    "lng": -108.0220621
  },
  {
    "id": "17063",
    "name": "REAL FOOD MARKET/HEALTH NUT",
    "address": "2209 SOUTH HIGHLAND DR, SUGARHOUSE, UT, 84106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7229859,
    "lng": -111.8580696
  },
  {
    "id": "17062",
    "name": "REAL FOOD MARKET/HEALTH NUT",
    "address": "420 W 800 N, OREM, UT, 84057",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3132716,
    "lng": -111.7061241
  },
  {
    "id": "17061",
    "name": "RE-DISTRIBUTOR ACCT FDSVC",
    "address": "3563 MAPLE CT, OCEANSIDE, NY, 11572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.623156,
    "lng": -73.6524451
  },
  {
    "id": "17060",
    "name": "RE-DISTRIBUTOR ACCT FDSVC",
    "address": "2520 EAST PIEDMONT RD, MARIETTA, GA, 30062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0131942,
    "lng": -84.4930889
  },
  {
    "id": "17059",
    "name": "RE-DISTRIBUTOR ACCT FDSVC",
    "address": "200 BRENNER DR, CONGERS, NY, 10920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1586314,
    "lng": -73.9380028
  },
  {
    "id": "17058",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1601 W CAPITOL AVE, W SACRAMENTO, CA, 95691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5798351,
    "lng": -121.5293519
  },
  {
    "id": "17057",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4650 NATOMAS BLVD, SACRAMENTO, CA, 95835",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.657521,
    "lng": -121.5099016
  },
  {
    "id": "17056",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "311 S LOWER SACRAMENTO RD, LODI, CA, 95242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1290203,
    "lng": -121.308788
  },
  {
    "id": "17055",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4900 ELK GROVE BLVD, ELK GROVE, CA, 95758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4073273,
    "lng": -121.4482961
  },
  {
    "id": "17054",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4030 SUNRISE BLVD, RANCHO CORDOVA, CA, 95742",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5574637,
    "lng": -121.2448046
  },
  {
    "id": "17053",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2075 FAIR OAKS BLVD STE 130, SACRAMENTO, CA, 95825",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5751643,
    "lng": -121.4171353
  },
  {
    "id": "17052",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "5159 FAIR OAKS BLVD, CARMICHAEL, CA, 95608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5977064,
    "lng": -121.3453175
  },
  {
    "id": "17051",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "781 S HWY 49, JACKSON, CA, 95642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3393262,
    "lng": -120.7667825
  },
  {
    "id": "17050",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3935 PARK DR, EL DORADO HILLS, CA, 95762",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6557779,
    "lng": -121.0695541
  },
  {
    "id": "17049",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "166 PLACERVILLE DR, PLACERVILLE, CA, 95667",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7271194,
    "lng": -120.8352686
  },
  {
    "id": "17048",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "8870 MADISON AVE, FAIR OAKS, CA, 95628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6622853,
    "lng": -121.2277634
  },
  {
    "id": "17047",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "8391 FOLSOM BLVD, SACRAMENTO, CA, 95826",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5488456,
    "lng": -121.3947194
  },
  {
    "id": "17046",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4840 SAN JUAN AVE, FAIR OAKS, CA, 95628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6542344,
    "lng": -121.2909626
  },
  {
    "id": "17045",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3518 MARCONI AVE, SACRAMENTO, CA, 95821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6165211,
    "lng": -121.3814999
  },
  {
    "id": "17044",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4700 FREEPORT BLVD, SACRAMENTO, CA, 95822",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5327811,
    "lng": -121.496204
  },
  {
    "id": "17043",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "6845 DOUGLAS BLVD, GRANITE BAY, CA, 95746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7445725,
    "lng": -121.1733655
  },
  {
    "id": "17042",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "25025 BLUE RAVINE RD, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6889153,
    "lng": -121.1225195
  },
  {
    "id": "17041",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "715 EAST BIDWELL ST, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6699466,
    "lng": -121.1598527
  },
  {
    "id": "17040",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3061 ALAMO DR, VACAVILLE, CA, 95687",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3365965,
    "lng": -121.9547971
  },
  {
    "id": "17039",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "890 SOUTHHAMPTON RD, BENICIA, CA, 94510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0665797,
    "lng": -122.1676894
  },
  {
    "id": "17038",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "8852 LAKEWOOD DR, WINDSOR, CA, 95492",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5489782,
    "lng": -122.8047469
  },
  {
    "id": "17037",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "40041 HWY 49, OAKHURST, CA, 93644",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3332583,
    "lng": -119.6567705
  },
  {
    "id": "17036",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3020 FLOYD AVE STE 139, MODESTO, CA, 95355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.676576,
    "lng": -120.93818
  },
  {
    "id": "17035",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "100 RALEYS TOWN CENTER, ROHNERT PARK, CA, 94928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.346625,
    "lng": -122.707047
  },
  {
    "id": "17034",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2400 SAND CREEK RD, BRENTWOOD, CA, 94513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9418666,
    "lng": -121.737713
  },
  {
    "id": "17033",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3632 LONE TREE WAY, ANTIOCH, CA, 94509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9858459,
    "lng": -121.8073263
  },
  {
    "id": "17032",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3001 TRAVIS BLVD, FAIRFIELD, CA, 94534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2576621,
    "lng": -122.0657729
  },
  {
    "id": "17031",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3330 N TEXAS ST, FAIRFIELD, CA, 94533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2886778,
    "lng": -122.0327796
  },
  {
    "id": "17030",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "270 SUNSET AVE, SUISUN CITY, CA, 94585",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2460507,
    "lng": -122.0217368
  },
  {
    "id": "17029",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "157 N MCDOWELL BLVD, PETALUMA, CA, 94954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.248197,
    "lng": -122.6285466
  },
  {
    "id": "17028",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1315 N STATE ST, UKIAH, CA, 95482",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1685178,
    "lng": -123.2087586
  },
  {
    "id": "17027",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3360 SAN PABLO DAM RD, SAN PABLO, CA, 94806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9616917,
    "lng": -122.3247465
  },
  {
    "id": "17026",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "217 SOSCOL AVE, NAPA, CA, 94559",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2834315,
    "lng": -122.2776174
  },
  {
    "id": "17025",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2550 S TRACY BLVD, TRACY, CA, 95376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7124385,
    "lng": -121.43249
  },
  {
    "id": "17024",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "5420 SUNOL BLVD, PLEASANTON, CA, 94566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6519522,
    "lng": -121.8785236
  },
  {
    "id": "17023",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "39200 PASEO PADRE PKWY, FREMONT, CA, 94538",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.553851,
    "lng": -121.9788878
  },
  {
    "id": "17022",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1407 FULTON RD, SANTA ROSA, CA, 95403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4539553,
    "lng": -122.7712408
  },
  {
    "id": "17021",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1280 W. LATHROP RD., MANTECA, CA, 95336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.825829,
    "lng": -121.2384372
  },
  {
    "id": "17020",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2900 GEER RD, TURLOCK, CA, 95380",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5185801,
    "lng": -120.8486439
  },
  {
    "id": "17019",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3550 N G ST, MERCED, CA, 95340",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.155706,
    "lng": -117.2987833
  },
  {
    "id": "17018",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3430 TULLY RD STE 40, MODESTO, CA, 95350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6884894,
    "lng": -121.0107525
  },
  {
    "id": "17017",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4255 E MORANDA LN, STOCKTON, CA, 95212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0397206,
    "lng": -121.2602845
  },
  {
    "id": "17016",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2077 MAIN ST, OAKLEY, CA, 94561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0030733,
    "lng": -121.7340654
  },
  {
    "id": "17015",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "10430 TWIN CITIES RD, GALT, CA, 95632",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2895689,
    "lng": -121.3072857
  },
  {
    "id": "17014",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2485 NOTRE DAME BLVD, CHICO, CA, 95928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7160899,
    "lng": -121.7949113
  },
  {
    "id": "17013",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "201 LAKE BLVD, REDDING, CA, 96003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6116355,
    "lng": -122.379846
  },
  {
    "id": "17012",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1842 FORT JONES ST, YREKA, CA, 96097",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7004631,
    "lng": -122.6440695
  },
  {
    "id": "17011",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "211 W EAST AVE, CHICO, CA, 95926",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7543669,
    "lng": -121.86215
  },
  {
    "id": "17010",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "700 W ONSTOTT FRONTAGE RD, YUBA CITY, CA, 95991",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1331299,
    "lng": -121.6374339
  },
  {
    "id": "17009",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "7847 LICHEN DR, CITRUS HEIGHTS, CA, 95621",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7095317,
    "lng": -121.3129672
  },
  {
    "id": "17008",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2325 MYERS ST, OROVILLE, CA, 95966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5063709,
    "lng": -121.5494884
  },
  {
    "id": "17007",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2325 MYERS  ST, OROVILLE, CA, 95966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5063709,
    "lng": -121.5494884
  },
  {
    "id": "17006",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "725 S MAIN ST, RED BLUFF, CA, 96080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.16312,
    "lng": -122.2294036
  },
  {
    "id": "17005",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "6119 HORSESHOE BAR RD, LOOMIS, CA, 95650",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.818281,
    "lng": -121.1883978
  },
  {
    "id": "17004",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "39 LINCOLN BLVD, LINCOLN, CA, 95648",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8723179,
    "lng": -121.2967301
  },
  {
    "id": "17003",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "13384 LINCOLN WAY, AUBURN, CA, 95603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9240428,
    "lng": -121.0540688
  },
  {
    "id": "17002",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4051 WOODCREEK OAKS BLVD, ROSEVILLE, CA, 95747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.769742,
    "lng": -121.3321818
  },
  {
    "id": "17001",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1915 DOUGLAS BLVD, ROSEVILLE, CA, 95661",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7457212,
    "lng": -121.2565993
  },
  {
    "id": "17000",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "692 FREEMAN LANE, GRASS VALLEY, CA, 95949",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2024975,
    "lng": -121.0655784
  },
  {
    "id": "16999",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "367 WEST MAIN ST, WOODLAND, CA, 95695",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6764695,
    "lng": -121.8009187
  },
  {
    "id": "16998",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1040 EMERALD BAY RD, SOUTH LAKE TAHOE, CA, 96150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9119399,
    "lng": -120.0058923
  },
  {
    "id": "16997",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "10001 SOARING RANCH ROAD, TRUCKEE, CA, 96161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3198942,
    "lng": -120.1550206
  },
  {
    "id": "16996",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4788 CAUGHLIN PKWY, RENO, NV, 89519",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4828887,
    "lng": -119.8538567
  },
  {
    "id": "16995",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "HWY 95 AIR FORCE RD, TONOPAH, NV, 89049",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0596202,
    "lng": -117.2181768
  },
  {
    "id": "16994",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4000 LAKE TAHOE BLVD #6, SOUTH LAKE TAHOE, CA, 96150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9543216,
    "lng": -119.9433365
  },
  {
    "id": "16993",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "4061 GATEWAY PK BLVD, SACRAMENTO, CA, 95691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6426383,
    "lng": -121.5059309
  },
  {
    "id": "16992",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1075 N HILLS BLVD, RENO, NV, 89506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.605509,
    "lng": -119.8397515
  },
  {
    "id": "16991",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3701 S CARSON CITY ST, CARSON CITY, NV, 89701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1326451,
    "lng": -119.7690911
  },
  {
    "id": "16990",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "930 TAHOE BLVD, INCLINE VILLAGE, NV, 89451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2498357,
    "lng": -119.9494352
  },
  {
    "id": "16989",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2389 WINGFIELD HILLS RD, SPANISH SPRINGS, NV, 89436",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6078853,
    "lng": -119.6992547
  },
  {
    "id": "16988",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1363 HIGHWAY 395 NORTH, GARDNERVILLE, NV, 89410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9380921,
    "lng": -119.7410544
  },
  {
    "id": "16987",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "18144 WEDGE PARKWAY, RENO, NV, 89511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3950405,
    "lng": -119.7655854
  },
  {
    "id": "16986",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "701 KEYSTONE AVE, RENO, NV, 89503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5313499,
    "lng": -119.8324572
  },
  {
    "id": "16985",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1630 ROBB DR, RENO, NV, 89523",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5278151,
    "lng": -119.8798932
  },
  {
    "id": "16984",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2895 N MCCARRAN BLVD, RENO, NV, 89431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5553254,
    "lng": -119.75439
  },
  {
    "id": "16983",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3555 MONROE ST, SANTA CLARA, CA, 95051",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3677956,
    "lng": -121.9938739
  },
  {
    "id": "16982",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "6061 SNELL AVE, SAN JOSE, CA, 95123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2376707,
    "lng": -121.8322681
  },
  {
    "id": "16981",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1250 GRANT RD, MOUNTAIN VIEW, CA, 94040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3784468,
    "lng": -122.0764675
  },
  {
    "id": "16980",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2531 BLANDING AVE, ALAMEDA, CA, 94501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7691843,
    "lng": -122.2329495
  },
  {
    "id": "16979",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "919 EAST STANLEY, LIVERMORE, CA, 94550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.677248,
    "lng": -121.7848091
  },
  {
    "id": "16978",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "130 MARKET PLACE, SAN RAMON, CA, 94583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.762713,
    "lng": -121.9516421
  },
  {
    "id": "16977",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "270 REDWOOD SHORES PKWY, REDWOOD CITY, CA, 94065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5232684,
    "lng": -122.2515326
  },
  {
    "id": "16976",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "222 MT HERMON RD, SCOTTS VALLEY, CA, 95066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0482575,
    "lng": -122.0262518
  },
  {
    "id": "16975",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1912 MAIN ST, WATSONVILLE, CA, 95076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9192108,
    "lng": -121.7803613
  },
  {
    "id": "16974",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "809 BAY AVE, CAPITOLA, CA, 95010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9802496,
    "lng": -121.9559932
  },
  {
    "id": "16973",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1700 AIRLINE HWY, HOLLISTER, CA, 95023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8371371,
    "lng": -121.3915311
  },
  {
    "id": "16972",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "777 FIRST ST, GILROY, CA, 95020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0144443,
    "lng": -121.5847865
  },
  {
    "id": "16971",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "7315 MURIETA DR, RANCHO MURIETA, CA, 95683",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4942296,
    "lng": -121.0982723
  },
  {
    "id": "16970",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3250 ARENA BLVD, SACRAMENTO, CA, 85834",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6418084,
    "lng": -121.5339673
  },
  {
    "id": "16969",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1885 EAST GIBSON RD, WOODLAND, CA, 95776",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6639722,
    "lng": -121.7397297
  },
  {
    "id": "16968",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "9435 ELK GROVE BLVD, ELK GROVE, CA, 95624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4096442,
    "lng": -121.3514827
  },
  {
    "id": "16967",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2760 E BIDWELL, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6561807,
    "lng": -121.1217781
  },
  {
    "id": "16966",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "8425 ELK GROVE FLORIN, ELK GROVE, CA, 95624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4513834,
    "lng": -121.3700608
  },
  {
    "id": "16965",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "2155 GOLDEN CENTRE LN, GOLD RIVER, CA, 95670",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6254426,
    "lng": -121.2635308
  },
  {
    "id": "16964",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1286 STABLER LN, YUBA CITY, CA, 95993",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.147759,
    "lng": -121.6462243
  },
  {
    "id": "16963",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "7901 WALERGA RD, ANTELOPE, CA, 95843",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7118684,
    "lng": -121.3662672
  },
  {
    "id": "16962",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "3510 PALMER DR, CAMERON PARK, CA, 95682",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6604268,
    "lng": -120.9666096
  },
  {
    "id": "16961",
    "name": "RALEYS/BEL AIR SUPERMARKETS",
    "address": "1540 W EL CAMINO AVE, SACRAMENTO, CA, 95833",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6118176,
    "lng": -121.4964048
  },
  {
    "id": "16960",
    "name": "RAISE THE BAR",
    "address": "171 BOATYARD DRIVE, FORT BRAGG, CA, 95437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4216676,
    "lng": -123.8063376
  },
  {
    "id": "16959",
    "name": "RAISE THE BAR",
    "address": "1345 HEALDSBURG AVE, HEALDSBURG, CA, 95448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6266885,
    "lng": -122.8737522
  },
  {
    "id": "16958",
    "name": "RAINBOW ACRES",
    "address": "13208 W. WASHINGTON BLVD, LOS ANGELES, CA, 90066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.993428,
    "lng": -118.441783
  },
  {
    "id": "16957",
    "name": "PLUM MARKET",
    "address": "6565 ORCHARD LAKE RD, WEST BLOOMFIELD, MI, 48322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5419951,
    "lng": -83.3587777
  },
  {
    "id": "16956",
    "name": "PLUM MARKET",
    "address": "3675 W MAPLE RD., BLOOMFIELD TWNSHP, MI, 48301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5441864,
    "lng": -83.2631025
  },
  {
    "id": "16955",
    "name": "PLUM MARKET",
    "address": "3601 PLYMOUTH ROAD, ANN ARBOR, MI, 48105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3059839,
    "lng": -83.6910989
  },
  {
    "id": "16954",
    "name": "PLUM MARKET",
    "address": "375 N MAPLE RD, ANN ARBOR, MI, 48103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.284853,
    "lng": -83.7815669
  },
  {
    "id": "16953",
    "name": "PLUM MARKET",
    "address": "1233 N WELLS ST, CHICAGO, IL, 60610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.904931,
    "lng": -87.6341005
  },
  {
    "id": "16952",
    "name": "PILGRIMS",
    "address": "1316 NORTH 4TH AVE, COEUR D`ALENE, ID, 83814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6878666,
    "lng": -116.780187
  },
  {
    "id": "16951",
    "name": "PIGGLY WIGGLY MIDWEST",
    "address": "724 PHILIPS BLVD, SAUK CITY, WI, 53583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2704955,
    "lng": -89.73088
  },
  {
    "id": "16950",
    "name": "PIGGLY WIGGLY",
    "address": "100 PLANTATION POINTE AVE, FAIRHOPE, AL, 36532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5249497,
    "lng": -87.8841542
  },
  {
    "id": "16949",
    "name": "PARK SLOPE SELECT NUTR",
    "address": "782 UNION ST., BROOKLYN, NY, 11215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6747478,
    "lng": -73.9767357
  },
  {
    "id": "16948",
    "name": "PALO ALTO EGG COMPANY",
    "address": "2038 CONCOURSE DR, SAN JOSE, CA, 95131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.395715,
    "lng": -121.8928145
  },
  {
    "id": "16947",
    "name": "ORGANICA PANAMA/DRY",
    "address": "6735 NW 36TH ST, STE390, MIAMI, FL, 33122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8124179,
    "lng": -80.3086242
  },
  {
    "id": "16946",
    "name": "ORGANIC VALLEY",
    "address": "507 MAIN ST, LA FARGE, WI, 54639",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.5741786,
    "lng": -90.6418512
  },
  {
    "id": "16945",
    "name": "ORGANIC ROOTS",
    "address": "40458 WINCHESTER ROAD, TEMECULA, CA, 92591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.527982,
    "lng": -117.1500967
  },
  {
    "id": "16944",
    "name": "ORGANIC PLANET",
    "address": "205 N 9TH STREET, BROOKLYN, NY, 11217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7180018,
    "lng": -73.9547643
  },
  {
    "id": "16943",
    "name": "ORGANIC NATURAL SNACKS",
    "address": "1929 BALTIC WAY, FERNDALE, WA, 98248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.8745968,
    "lng": -122.5857078
  },
  {
    "id": "16942",
    "name": "OREGON STATE UNIVERSITY",
    "address": "1701 SW WESTERN BLVD, CORVALLIS, OR, 97331-1215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5601832,
    "lng": -123.276129
  },
  {
    "id": "16941",
    "name": "OREGON NATURAL FOODS",
    "address": "373 SW 1ST ST, ONTARIO, OR, 97914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.023611,
    "lng": -116.9657234
  },
  {
    "id": "16940",
    "name": "ORDER DOG",
    "address": "328 1ST STREET, MANISTEE, MI, 49660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.2459843,
    "lng": -86.3193534
  },
  {
    "id": "16939",
    "name": "ORDER DOG",
    "address": "433 JEFFERSON ST., PADUCAH, KY, 42001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0874256,
    "lng": -88.59989
  },
  {
    "id": "16938",
    "name": "OLIVERS MARKETS",
    "address": "461 STONY POINT ROAD, SANTA ROSA, CA, 95401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4325504,
    "lng": -122.7439869
  },
  {
    "id": "16937",
    "name": "OLIVERS MARKETS",
    "address": "546 E. COTATI AVE, COTATI, CA, 94931",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3280134,
    "lng": -122.6981063
  },
  {
    "id": "16936",
    "name": "OLD CREAMERY GROCERY",
    "address": "445 BERKSHIRE TR RT 9, CUMMINGTON, MA, 1026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4640525,
    "lng": -72.9053135
  },
  {
    "id": "16935",
    "name": "OKLAHOMA SINGLE STORE",
    "address": "206 W 6TH ST, OKMULGEE, OK, 74447",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6231103,
    "lng": -95.9730917
  },
  {
    "id": "16934",
    "name": "OKLAHOMA SINGLE STORE",
    "address": "2212 E SHAWNEE, MUSKOGEE, OK, 74403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7719501,
    "lng": -95.3475511
  },
  {
    "id": "16933",
    "name": "OKLAHOMA SINGLE STORE",
    "address": "309 S FLOOD AVE, NORMAN, OK, 73069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2155878,
    "lng": -97.4527513
  },
  {
    "id": "16932",
    "name": "OKLAHOMA SINGLE STORE",
    "address": "1413 ARLINGTON, ADA, OK, 74820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7815191,
    "lng": -96.6582074
  },
  {
    "id": "16931",
    "name": "OAKES FARM",
    "address": "4835 IMMOKALEE RD, NAPLES, FL, 34109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2743932,
    "lng": -81.7528735
  },
  {
    "id": "16930",
    "name": "NYZET3- STEVE LANDAU",
    "address": "9 BASIN DRIVE, KEARNY, NJ, 7032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7271907,
    "lng": -74.1043128
  },
  {
    "id": "16929",
    "name": "NUTRITION SMART",
    "address": "12702 RACE TRACK ROAD, TAMPA, FL, 33626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0673772,
    "lng": -82.6358097
  },
  {
    "id": "16928",
    "name": "NUTRITION SMART",
    "address": "1821 BRUCE B DOWNS BLVD, WESLEY CHAPEL, FL, 33544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1834921,
    "lng": -82.3545739
  },
  {
    "id": "16927",
    "name": "NUTRITION SMART",
    "address": "464 SW PORT ST LUCIE BLVD, PORT ST LUCIE, FL, 34953",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2715863,
    "lng": -80.3595574
  },
  {
    "id": "16926",
    "name": "NUTRITION SMART",
    "address": "4155 B NORTHLAKE BLVD, PALM BEACH GRDN, FL, 33410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.8099248,
    "lng": -80.1005432
  },
  {
    "id": "16925",
    "name": "NUTRITION SMART",
    "address": "10980 PINES BLVD, PEMBROKE, FL, 33026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0076473,
    "lng": -80.293555
  },
  {
    "id": "16924",
    "name": "NUTRITION DEPOT-GA",
    "address": "3549 PEACHTREE IND BLVD, DULUTH, GA, 30096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0029285,
    "lng": -84.1719098
  },
  {
    "id": "16923",
    "name": "NORTHWEST GROCERS",
    "address": "1030 W SUMMIT PARKWAY, SPOKANE, WA, 99201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6626442,
    "lng": -117.4271326
  },
  {
    "id": "16922",
    "name": "NORTH SHORE MARKETPLACE",
    "address": "777 PULASKI RD, GREENLAWN, NY, 11740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8671712,
    "lng": -73.3500534
  },
  {
    "id": "16921",
    "name": "NORTH COUNTRY FOOD COOP",
    "address": "25 BRIDGE ST, PLATTSBURGH, NY, 12901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.6978325,
    "lng": -73.4516127
  },
  {
    "id": "16920",
    "name": "NOREL-POM NATURAL FOODS",
    "address": "6971 STATE HWY 3, HAYFORK, CA, 96041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5542439,
    "lng": -123.1857471
  },
  {
    "id": "16919",
    "name": "NIP-TURNIP TRUCK NAT.MKT",
    "address": "5001 CHARLOTTE PIKE, NASHVILLE, TN, 37209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1516308,
    "lng": -86.8475229
  },
  {
    "id": "16918",
    "name": "NIP-TURNIP TRUCK NAT.MKT",
    "address": "321 12TH AVE SOUTH, NASHVILLE, TN, 37203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1527429,
    "lng": -86.785503
  },
  {
    "id": "16917",
    "name": "NIP-TURNIP TRUCK NAT.MKT",
    "address": "4 JACKSON WALK PLAZA, JACKSON, TN, 38301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6166498,
    "lng": -88.8196599
  },
  {
    "id": "16916",
    "name": "NIEMANN FOOD OPEN APL",
    "address": "2029 SOUTH NEIL STREET, CHAMPAIGN, IL, 61820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0909474,
    "lng": -88.2480957
  },
  {
    "id": "16915",
    "name": "NEBRASKA SINGLE STORE",
    "address": "119 W 4TH ST, ALLIANCE, NE, 69301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0980794,
    "lng": -102.8715606
  },
  {
    "id": "16914",
    "name": "NEBRASKA BUYING CLUB",
    "address": "803 S DEWEY, NORTH PLATTE, NE, 69101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1268767,
    "lng": -100.7625945
  },
  {
    "id": "16913",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "4001 S LAMAR BLVD, AUSTIN, TX, 78704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2348134,
    "lng": -97.7917649
  },
  {
    "id": "16912",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "3101 GUADALUPE ST, AUSTIN, TX, 78705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2975692,
    "lng": -97.7410812
  },
  {
    "id": "16911",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "202 SOUTH 1ST STREET, MOUNT VERNON, WA, 98273",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.4209476,
    "lng": -122.3365981
  },
  {
    "id": "16910",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "2820 R STREET, SACRAMENTO, CA, 95816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5645409,
    "lng": -121.4726654
  },
  {
    "id": "16909",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "414 KEARNEY STREET, PORT TOWNSEND, WA, 98368",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.1108346,
    "lng": -122.7704546
  },
  {
    "id": "16908",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "380 N COLLEGE AVE, FAYETTEVILLE, AR, 72701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0678234,
    "lng": -94.157215
  },
  {
    "id": "16907",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "138 N BEACH RD, EASTSOUND, WA, 98245",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.6953888,
    "lng": -122.9059383
  },
  {
    "id": "16906",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "25 4TH STREET, EUREKA, CA, 95501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8025908,
    "lng": -124.1712531
  },
  {
    "id": "16905",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "945 S RIVERSIDE AVE, MEDFORD, OR, 97501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3179488,
    "lng": -122.8632728
  },
  {
    "id": "16904",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "901 MENAUL NE, ALBUQUERQUE, NM, 87107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1099345,
    "lng": -106.6345645
  },
  {
    "id": "16903",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "2400 RIOGRANDE NW, ALBUQUERQUE, NM, 87104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1179497,
    "lng": -106.674654
  },
  {
    "id": "16902",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "6575 SEVILLE ROAD, ISLA VISTA, CA, 93117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4115719,
    "lng": -119.8576206
  },
  {
    "id": "16901",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "240 COURT ST, RENO, NV, 89501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5226672,
    "lng": -119.8154491
  },
  {
    "id": "16900",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "412 NORTH 4TH AVENUE, TUCSON, AZ, 85705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2268458,
    "lng": -110.9653563
  },
  {
    "id": "16899",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "575 E 8TH AVE, DURANGO, CO, 81301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.267939,
    "lng": -107.8725025
  },
  {
    "id": "16898",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "8770 WASHINGTON BLVD, CULVER CITY, CA, 90232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0282885,
    "lng": -118.3857678
  },
  {
    "id": "16897",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "1525 BROADWAY, SANTA MONICA, CA, 90404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0243456,
    "lng": -118.4827792
  },
  {
    "id": "16896",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "1220 N FOREST, BELLINGHAM, WA, 98256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.747292,
    "lng": -122.4762386
  },
  {
    "id": "16895",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "1600 E. MADISON STREET, SEATTLE, WA, 98122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6153435,
    "lng": -122.3111959
  },
  {
    "id": "16894",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "888 W FORT ST, BOISE, ID, 83702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6228421,
    "lng": -116.1983638
  },
  {
    "id": "16893",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "237 N FIRST ST, ASHLAND, OR, 97520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1988279,
    "lng": -122.7116687
  },
  {
    "id": "16892",
    "name": "NCGA, NATIONAL CO-OP GROCERS ASSOCIATION",
    "address": "811 I STREET, ARCATA, CA, 95521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8692544,
    "lng": -124.0886314
  },
  {
    "id": "16891",
    "name": "NATURWAY NATURAL FOODS",
    "address": "10309 S LAKEWOOD BLVD, DOWNEY, CA, 90241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9461339,
    "lng": -118.1186114
  },
  {
    "id": "16890",
    "name": "NATURE'S MARKET",
    "address": "303 CENTER HILL ROAD, MANCHESTER CENTER, VT, 5255",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1767969,
    "lng": -73.0522878
  },
  {
    "id": "16889",
    "name": "NATURAL RETAIL GROUP",
    "address": "3005 W LAKE MARY BLVD, LAKE MARY, FL, 32746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.7549128,
    "lng": -81.3319481
  },
  {
    "id": "16888",
    "name": "NATURAL RETAIL GROUP",
    "address": "30555 US HWY 19 NORTH, PALM HARBOR, FL, 34684",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.050757,
    "lng": -82.735902
  },
  {
    "id": "16887",
    "name": "NATURAL RETAIL GROUP",
    "address": "2000 TAMIAMI TRAIL, PORT CHARLOTTE, FL, 33948",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0042662,
    "lng": -82.127925
  },
  {
    "id": "16886",
    "name": "NATURAL RETAIL GROUP",
    "address": "DBA THE GRANARY, SARASOTA, FL, 34232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4747601,
    "lng": -82.4333055
  },
  {
    "id": "16885",
    "name": "NATURAL RETAIL GROUP",
    "address": "1930 STICKNEY POINT, SARASOTA, FL, 34232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2588374,
    "lng": -82.5230229
  },
  {
    "id": "16884",
    "name": "NATURAL RETAIL GROUP",
    "address": "1279 BENEVA RD SOUTH, SARASOTA, FL, 34232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3216628,
    "lng": -82.4968485
  },
  {
    "id": "16883",
    "name": "NATURAL RETAIL GROUP",
    "address": "1917 E SILVER SPRINGS BLV, OCALA, FL, 34470",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.1878555,
    "lng": -82.1120647
  },
  {
    "id": "16882",
    "name": "NATURAL RETAIL GROUP",
    "address": "1237 NW 76TH BLVD, GAINESVILLE, FL, 32606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6636556,
    "lng": -82.4232618
  },
  {
    "id": "16881",
    "name": "NATURAL RETAIL GROUP",
    "address": "6651 CENTRAL AVE, ST PETERSBURG, FL, 33710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7713863,
    "lng": -82.7294036
  },
  {
    "id": "16880",
    "name": "NATURAL RETAIL GROUP",
    "address": "6651 CENTRAL AVENUE, ST PETERSBURG, FL, 33710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7713863,
    "lng": -82.7294036
  },
  {
    "id": "16879",
    "name": "NATURAL PANTRY (AK)",
    "address": "3680 BARROW ST, ANCHORAGE, AK, 99503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 61.187302,
    "lng": -149.8819121
  },
  {
    "id": "16878",
    "name": "NATURAL FRONTIER",
    "address": "31-28 DITMARS BLVD, ASTORIA, NY, 11105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7752981,
    "lng": -73.9101594
  },
  {
    "id": "16877",
    "name": "NATURAL FOOD",
    "address": "140 7TH STREET, GARDEN CITY, NY, 11530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7247276,
    "lng": -73.6355003
  },
  {
    "id": "16876",
    "name": "N2CXD CUB FOODS",
    "address": "300 2ND AVE S, HOPKINS, MN, 55343",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9184793,
    "lng": -93.4050492
  },
  {
    "id": "16875",
    "name": "MYRTLE PHARMACY SN",
    "address": "260 BROADWAY, BROOKLYN, NY, 11211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7086929,
    "lng": -73.95957
  },
  {
    "id": "16874",
    "name": "MUSTARD SEED",
    "address": "3885 WEST MARKET STREET, AKRON, OH, 44333",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1362904,
    "lng": -81.6382603
  },
  {
    "id": "16873",
    "name": "MR MAMA NATURAL FOOD INC",
    "address": "1625 W UINTAH, COLORADO SPRINGS, CO, 80904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8474807,
    "lng": -104.8439504
  },
  {
    "id": "16872",
    "name": "MOTHERS MARKETS",
    "address": "16400 PACIFIC COAST HWY #112, SUNSET BEACH, CA, 92649",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7241038,
    "lng": -118.0759916
  },
  {
    "id": "16871",
    "name": "MOTHERS MARKETS",
    "address": "1700 ROSECRANS STE C, MANHATTAN BEACH, CA, 90266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9011087,
    "lng": -118.3824297
  },
  {
    "id": "16870",
    "name": "MOTHERS MARKETS",
    "address": "2475 CHERRY AVE, SIGNAL HILL, CA, 90755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8022134,
    "lng": -118.1680998
  },
  {
    "id": "16869",
    "name": "MOTHERS MARKETS",
    "address": "413 S ASSOCIATED RD, BREA, CA, 92821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9126502,
    "lng": -117.880472
  },
  {
    "id": "16868",
    "name": "MOTHERS MARKETS",
    "address": "5759 E SANTA ANA CANYON RD, ANAHEIM HILLS, CA, 92807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8532314,
    "lng": -117.7882973
  },
  {
    "id": "16867",
    "name": "MOTHERS MARKETS",
    "address": "151 MEMORY LANE, SANTA ANA, CA, 92706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7731601,
    "lng": -117.8658497
  },
  {
    "id": "16866",
    "name": "MOTHERS MARKETS",
    "address": "24165 PASEO DE VALENCIA, LAGUNA HILLS, CA, 92653",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6117614,
    "lng": -117.714289
  },
  {
    "id": "16865",
    "name": "MOTHERS MARKETS",
    "address": "2963 MICHAELSON DRIVE, IRVINE, CA, 92627",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6719512,
    "lng": -117.8459623
  },
  {
    "id": "16864",
    "name": "MOTHERS MARKETS",
    "address": "19770 BEACH BLVD., HUNTINGTON BEACH, CA, 92648",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6749561,
    "lng": -117.9870883
  },
  {
    "id": "16863",
    "name": "MOTHERS MARKETS",
    "address": "1890 NEWPORT BLVD, COSTA MESA, CA, 92627",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6426219,
    "lng": -117.9163871
  },
  {
    "id": "16862",
    "name": "MORTON WILLIAM",
    "address": "1066 3RD AVE 63RD ST N, NEW YORK, NY, 10065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7644404,
    "lng": -73.9648828
  },
  {
    "id": "16861",
    "name": "MOON COOPERATIVE SERVICES",
    "address": "512 SOUTH LOCUST ST, OXFORD, OH, 45056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.505897,
    "lng": -84.750663
  },
  {
    "id": "16860",
    "name": "MONTANA FOODWORKS",
    "address": "412 E PARK ST, LIVINGSTON, MT, 59047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6643855,
    "lng": -110.5567925
  },
  {
    "id": "16859",
    "name": "MONMOUTH HEALTH FOODS",
    "address": "181 MAIN ST, MANASQUAN, NJ, 8736",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1222866,
    "lng": -74.0494966
  },
  {
    "id": "16858",
    "name": "MOLLIE STONES",
    "address": "1477 CHAPIN AVENUE, BURLINGAME, CA, 94010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5772168,
    "lng": -122.350384
  },
  {
    "id": "16857",
    "name": "MISSOULA FRESH MARKET",
    "address": "701 S ORANGE ST, MISSOULA, MT, 59801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8643053,
    "lng": -114.0040402
  },
  {
    "id": "16856",
    "name": "MIDWEST REGION CUST SN",
    "address": "810 WATER AVE, HILLSBORO, WI, 54634",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6507289,
    "lng": -90.3396326
  },
  {
    "id": "16855",
    "name": "MIDWEST REGION CUST SN",
    "address": "291 COVENANT SQUARE, BILOXI, MS, 39531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4009485,
    "lng": -88.9779209
  },
  {
    "id": "16854",
    "name": "MIDWEST REGION CUST SN",
    "address": "118 E PEARL ST, WINAMAC, IN, 46996",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0518231,
    "lng": -86.6036587
  },
  {
    "id": "16853",
    "name": "MIDWEST REGION CUST SN",
    "address": "918 N MAIN ST, PRINCETON, IL, 61356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3836978,
    "lng": -89.4653737
  },
  {
    "id": "16852",
    "name": "MIDWEST REGION CUST SN",
    "address": "109 E MADISON AVE, IOLA, KS, 66749",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9211256,
    "lng": -95.4028723
  },
  {
    "id": "16851",
    "name": "MIDWEST REGION CUST SN",
    "address": "c/o JEANETTE BARCUS, MARYVILLE, MO, 64468",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3461017,
    "lng": -94.8724706
  },
  {
    "id": "16850",
    "name": "MIDWEST REGION CUST SN",
    "address": "3295 E COLBY, STE 1, WHITEHALL, MI, 49461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.409024,
    "lng": -86.323405
  },
  {
    "id": "16849",
    "name": "MIDWEST REGION CUST SN",
    "address": "146 E CHAPMAN ST, ELY, MN, 55731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.9021148,
    "lng": -91.8641599
  },
  {
    "id": "16848",
    "name": "MIDWEST REGION CUST SN",
    "address": "508 N CASSADY, BEXLEY, OH, 43209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9809567,
    "lng": -82.9316895
  },
  {
    "id": "16847",
    "name": "MICHAEL WEBB CHI ZONE IND",
    "address": "1810 S BLUE ISLAND AVE, CHICAGO, IL, 60608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8574274,
    "lng": -87.6619264
  },
  {
    "id": "16846",
    "name": "MIAMI UNIVERSITY",
    "address": "426 WELLS MILL DR, OXFORD, OH, 45056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5058383,
    "lng": -84.7519438
  },
  {
    "id": "16845",
    "name": "METROPOLITAN MARKET",
    "address": "301 228TH AVE STE 100, SAMMAMISH, WA, 98074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6058352,
    "lng": -122.0359098
  },
  {
    "id": "16844",
    "name": "METROPOLITAN MARKET",
    "address": "2755 77TH AVE SE, MERCER ISLAND, WA, 98040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5853123,
    "lng": -122.2357506
  },
  {
    "id": "16843",
    "name": "METROPOLITAN MARKET",
    "address": "5010 POINT FOSDICK DR STE A, GIG HARBOR, WA, 98335",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.3037952,
    "lng": -122.5815377
  },
  {
    "id": "16842",
    "name": "METROPOLITAN MARKET",
    "address": "5250 40TH AVE NW, SEATTLE, WA, 98105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6681924,
    "lng": -122.2836355
  },
  {
    "id": "16841",
    "name": "METROPOLITAN MARKET",
    "address": "100 MERCER ST, SEATTLE, WA, 98109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6247988,
    "lng": -122.3548324
  },
  {
    "id": "16840",
    "name": "METROPOLITAN MARKET",
    "address": "2420 N PROCTOR, TACOMA, WA, 98407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2694876,
    "lng": -122.4896853
  },
  {
    "id": "16839",
    "name": "METROPOLITAN MARKET",
    "address": "3830 34TH AVE W, SEATTLE, WA, 98199",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6551873,
    "lng": -122.4004719
  },
  {
    "id": "16838",
    "name": "METROPOLITAN MARKET",
    "address": "10611 NE 68TH ST, KIRKLAND, WA, 98033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6658272,
    "lng": -122.197287
  },
  {
    "id": "16837",
    "name": "METROPOLITAN MARKET",
    "address": "2320 42ND SW, SEATTLE, WA, 98116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5820281,
    "lng": -122.3847483
  },
  {
    "id": "16836",
    "name": "METRO DRUGS",
    "address": "931 LEXINGTON AVE, NEW YORK, NY, 10065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.768064,
    "lng": -73.9635291
  },
  {
    "id": "16835",
    "name": "MCKINNON'S",
    "address": "2454 LAFAYETTE RD, PORTSMOUTH, NH, 3801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0361557,
    "lng": -70.784958
  },
  {
    "id": "16834",
    "name": "MASTERS MARKET/ANANDA VILLAGE",
    "address": "14618 TYLER FOOTE ROAD, NEVADA CITY, CA, 95959",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3672524,
    "lng": -121.0483584
  },
  {
    "id": "16833",
    "name": "MARKET SQUARE",
    "address": "1964 SOUTHFIELD RD, BIRMINGHAM, MI, 48009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5317291,
    "lng": -83.2245845
  },
  {
    "id": "16832",
    "name": "MARKET OF CHOICE",
    "address": "1475 SISKIYOU BLVD, ASHLAND, OR, 97520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1846047,
    "lng": -122.6891247
  },
  {
    "id": "16831",
    "name": "MARKET OF CHOICE",
    "address": "1960 FRANKLIN BLVD, EUGENE, OR, 97403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0435309,
    "lng": -123.0637035
  },
  {
    "id": "16830",
    "name": "MARKET OF CHOICE",
    "address": "67 W 29TH AVE, EUGENE, OR, 97405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0269413,
    "lng": -123.0939892
  },
  {
    "id": "16829",
    "name": "MARKET OF CHOICE",
    "address": "115 NW SISEMORE ST, BEND, OR, 97701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0520789,
    "lng": -121.3121128
  },
  {
    "id": "16828",
    "name": "MARKET OF CHOICE",
    "address": "922 NW CIRCLE BLVD, CORVALLIS, OR, 97330",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5882183,
    "lng": -123.2578289
  },
  {
    "id": "16827",
    "name": "MARKET OF CHOICE",
    "address": "1060 GREEN ACRES ROAD, EUGENE, OR, 97401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0928404,
    "lng": -123.0935323
  },
  {
    "id": "16826",
    "name": "MARKET OF CHOICE",
    "address": "5639 HOOD STREET, WEST LINN, OR, 97068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.3666637,
    "lng": -122.6115982
  },
  {
    "id": "16825",
    "name": "MARKET OF CHOICE",
    "address": "1300 BIDDLE ROAD, MEDFORD, OR, 97504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3424846,
    "lng": -122.8718348
  },
  {
    "id": "16824",
    "name": "MARKET OF CHOICE",
    "address": "1090 SE BELMONT ST, PORTLAND, OR, 97214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5163556,
    "lng": -122.6549004
  },
  {
    "id": "16823",
    "name": "MARKET OF CHOICE",
    "address": "250 NW LOST SPRINGS TERRACE, PORTLAND, OR, 97229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5206313,
    "lng": -122.8015698
  },
  {
    "id": "16822",
    "name": "MARKET OF CHOICE",
    "address": "2580 WILLAKENZIE RD, EUGENE, OR, 97401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0799008,
    "lng": -123.070034
  },
  {
    "id": "16821",
    "name": "MARKET 515",
    "address": "915 R ST, SACRAMENTO, CA, 95811",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5719429,
    "lng": -121.4978772
  },
  {
    "id": "16820",
    "name": "MARIPOSA MARKET",
    "address": "500 S MAIN ST, WILLITS, CA, 95490",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4065463,
    "lng": -123.3527792
  },
  {
    "id": "16819",
    "name": "MARCZYK FINE FOODS",
    "address": "5100 E COLFAX, DENVER, CO, 80220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7398205,
    "lng": -104.9276151
  },
  {
    "id": "16818",
    "name": "MANNA HEALTH MARKET",
    "address": "351 CENTRAL AVE, LAWRENCE, NY, 11559",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.617873,
    "lng": -73.728797
  },
  {
    "id": "16817",
    "name": "MACA COOP",
    "address": "6500 SEVEN LOCKS ROAD, CABIN JOHN, MD, 20818",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9752833,
    "lng": -77.1618624
  },
  {
    "id": "16816",
    "name": "LUEKEN'S",
    "address": "1171 PAUL BUNYAN DRIVE, BEMIDJI, MN, 56601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.4932659,
    "lng": -94.8968262
  },
  {
    "id": "16815",
    "name": "LUCKY VITAMIN CORP",
    "address": "1620 Central Ave, ROSELLE, IL, 60172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9829472,
    "lng": -88.1195034
  },
  {
    "id": "16814",
    "name": "LOMAR",
    "address": "2700 DEKALB AVENUE, SYCAMORE, IL, 60178",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9588605,
    "lng": -88.7185698
  },
  {
    "id": "16813",
    "name": "LOMAR",
    "address": "7620 STATELINE ROAD, PRAIRIE VILLAGE, KS, 66208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.989934,
    "lng": -94.6097437
  },
  {
    "id": "16812",
    "name": "LOMAR",
    "address": "8501 WEST 95TH STREET, OVERLAND PARK, KS, 66212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9556909,
    "lng": -94.6836318
  },
  {
    "id": "16811",
    "name": "LOMAR",
    "address": "601 THIRD PLACE, MANHATTAN, KS, 66502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1850971,
    "lng": -96.5606573
  },
  {
    "id": "16810",
    "name": "LOMAR",
    "address": "3504 CLINTON PARKWAY, LAWRENCE, KS, 66047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9445756,
    "lng": -95.2803618
  },
  {
    "id": "16809",
    "name": "LOMAR",
    "address": "5330 NW 64TH STREET, KANSAS CITY, MO, 64151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2113835,
    "lng": -94.6413221
  },
  {
    "id": "16808",
    "name": "LOMAR",
    "address": "207 NE ENGLEWOOD ROAD, KANSAS CITY, MO, 64118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1948951,
    "lng": -94.5799759
  },
  {
    "id": "16807",
    "name": "LOMAR",
    "address": "8301 NORTH ST CLAIR AVE, KANSAS CITY, MO, 64151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2457244,
    "lng": -94.6456807
  },
  {
    "id": "16806",
    "name": "LOMAR",
    "address": "2850 EAST 23RD STREET, FREMONT, NE, 68025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4514851,
    "lng": -96.4638812
  },
  {
    "id": "16805",
    "name": "LOMA LINDA UNIVERSITY",
    "address": "11550 PIERCE ST, RIVERSIDE, CA, 92505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9144752,
    "lng": -117.4964604
  },
  {
    "id": "16804",
    "name": "LOGISTICAFORCE",
    "address": "4555 SOUTH RACINE, CHICAGO, IL, 60609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8105789,
    "lng": -87.6533283
  },
  {
    "id": "16803",
    "name": "LOGISTICA FORCE",
    "address": "550 S PATTERSON AVE, SANTA BARBARA, CA, 93111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4302317,
    "lng": -119.8101803
  },
  {
    "id": "16802",
    "name": "LOGISTICA FORCE",
    "address": "74 HOBRON AVE, KAHULUI MAUI, HI, 96732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 20.8930712,
    "lng": -156.4604451
  },
  {
    "id": "16801",
    "name": "LOGISTICA FORCE",
    "address": "9715 BURNET RD STE #B 100, AUSTIN, TX, 78758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.381376,
    "lng": -97.7227455
  },
  {
    "id": "16800",
    "name": "LOCH LOMOND & WOODLANDS MARKETS",
    "address": "735 COLLEGE AVE, KENTFIELD, CA, 94904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9523066,
    "lng": -122.5500898
  },
  {
    "id": "16799",
    "name": "LINDO'S FAMILY MARKET",
    "address": "225 CROSS FARM LN, YORK, PA, 17406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0697573,
    "lng": -76.7740617
  },
  {
    "id": "16798",
    "name": "LEGACY FOODSERVICE",
    "address": "1400 N 30TH ST, QUINCY, IL, 62301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9481931,
    "lng": -91.365613
  },
  {
    "id": "16797",
    "name": "LAZY ACRES",
    "address": "302 MEIGS RD, SANTA BARBARA, CA, 93109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.400241,
    "lng": -119.7216702
  },
  {
    "id": "16796",
    "name": "LAZY ACRES",
    "address": "2080 BELLFLOWER BLVD, LONG BEACH, CA, 90815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7939527,
    "lng": -118.1235146
  },
  {
    "id": "16795",
    "name": "LAZY ACRES",
    "address": "422 W WASHINGTON ST, SAN DIEGO, CA, 92103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.750502,
    "lng": -117.167742
  },
  {
    "id": "16794",
    "name": "LAZY ACRES",
    "address": "2510 PACIFIC COAST HWY, HERMOSA BEACH, CA, 90254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.872144,
    "lng": -118.394444
  },
  {
    "id": "16793",
    "name": "LAZY ACRES",
    "address": "150 ENCINITAS BLVD, ENCINITAS, CA, 92024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0502158,
    "lng": -117.2890124
  },
  {
    "id": "16792",
    "name": "LASSENS",
    "address": "4071 E. MAIN ST 644-6990, VENTURA, CA, 93003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2640533,
    "lng": -119.2370682
  },
  {
    "id": "16791",
    "name": "LASSENS",
    "address": "4071 E. MAIN ST  644-6990, VENTURA, CA, 93003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2640533,
    "lng": -119.2370682
  },
  {
    "id": "16790",
    "name": "LASSENS",
    "address": "2150 E THOUSAND OAKS BLVD, THOUSAND OAKS, CA, 91362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1743788,
    "lng": -118.8469935
  },
  {
    "id": "16789",
    "name": "LASSENS",
    "address": "2955-A4 COCHRAN ST, SIMI VALLEY, CA, 93065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2816393,
    "lng": -118.7389467
  },
  {
    "id": "16788",
    "name": "LASSENS",
    "address": "5154 HOLLISTER AVE, SANTA BARBARA, CA, 93111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4367585,
    "lng": -119.8033605
  },
  {
    "id": "16787",
    "name": "LASSENS",
    "address": "896 FOOTHILL BLVD, SAN LUIS OBISPO, CA, 93405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2948506,
    "lng": -120.6700036
  },
  {
    "id": "16786",
    "name": "LASSENS",
    "address": "1790 SOUTH BROADWAY, SANTA MARIA, CA, 93454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.927676,
    "lng": -120.4356731
  },
  {
    "id": "16785",
    "name": "LASSENS",
    "address": "2080 HILLHURST AVE, LOS ANGELES, CA, 90027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1097388,
    "lng": -118.2870907
  },
  {
    "id": "16784",
    "name": "LASSENS",
    "address": "4308 CALIFORNIA AVE, BAKERSFIELD, CA, 93309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.369272,
    "lng": -119.0502658
  },
  {
    "id": "16783",
    "name": "LASSENS",
    "address": "710 S LA BREA AVE, LOS ANGELES, CA, 90036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0616576,
    "lng": -118.3439832
  },
  {
    "id": "16782",
    "name": "LASSENS",
    "address": "1631 W SUNSET BLVD, LOS ANGELES, CA, 90026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0776812,
    "lng": -118.25788
  },
  {
    "id": "16781",
    "name": "LASSENS",
    "address": "3471 SAVIERS RD, OXNARD, CA, 93033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1681833,
    "lng": -119.1789475
  },
  {
    "id": "16780",
    "name": "LAGREES MARKET",
    "address": "27050 E HWY 50, PUEBLO, CO, 81006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.274208,
    "lng": -104.53085
  },
  {
    "id": "16779",
    "name": "LAGREES MARKET",
    "address": "10100 W HWY 50, PONCHA SPRINGS, CO, 81242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.515134,
    "lng": -106.075584
  },
  {
    "id": "16778",
    "name": "LAGREES MARKET",
    "address": "415 N US HIGHWAY 24, BUENA VISTA, CO, 81211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8454291,
    "lng": -106.1335598
  },
  {
    "id": "16777",
    "name": "KIRK MARKET",
    "address": "3740 WEST 104TH ST, STE 1, HIALEAH, FL, 33018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9150506,
    "lng": -80.3593963
  },
  {
    "id": "16776",
    "name": "KIMBERTON",
    "address": "1208 HORSESHOE PIKE, DOWNINGTOWN, PA, 19335",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0335495,
    "lng": -75.765629
  },
  {
    "id": "16775",
    "name": "KEY MARKETS",
    "address": "1063 UPTON ST, REDWOOD CITY, CA, 94061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4668937,
    "lng": -122.2417693
  },
  {
    "id": "16774",
    "name": "KANSAS SINGLE STORE",
    "address": "1919 S RANGE, COLBY, KS, 67701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3692112,
    "lng": -101.0527019
  },
  {
    "id": "16773",
    "name": "KANSAS SINGLE STORE",
    "address": "1307 N MAIN ST, HUTCHINSON, KS, 67501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0677619,
    "lng": -97.9322607
  },
  {
    "id": "16772",
    "name": "JUBILEE",
    "address": "180 RIVERSIDE BLVD, NEW YORK, NY, 10069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7784952,
    "lng": -73.9882729
  },
  {
    "id": "16771",
    "name": "JUBILEE",
    "address": "99 JOHN STREET, NEW YORK, NY, 10038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7083595,
    "lng": -74.0060041
  },
  {
    "id": "16770",
    "name": "JIMBOS",
    "address": "1633 S. CENTRE CITY PARKWAY, ESCONDIDO, CA, 92025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1042101,
    "lng": -117.0775493
  },
  {
    "id": "16769",
    "name": "JIMBOS",
    "address": "12841 EL CAMINO REAL, SAN DIEGO, CA, 92130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9499304,
    "lng": -117.2337335
  },
  {
    "id": "16768",
    "name": "JIMBOS",
    "address": "1923 CALLE BARCELONA STE 149, CARLSBAD, CA, 92009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0726342,
    "lng": -117.2661879
  },
  {
    "id": "16767",
    "name": "JIMBOS",
    "address": "10511 4-S COMMONS DRIVE#155, SAN DIEGO, CA, 92127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0189222,
    "lng": -117.1138822
  },
  {
    "id": "16766",
    "name": "JENSENS FINEST FOODS",
    "address": "27264 HWY 189, BLUE JAY, CA, 92317",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2475819,
    "lng": -117.2089333
  },
  {
    "id": "16765",
    "name": "JANIE FONG ACCOUNTS",
    "address": "315 MAGNOLIA STREET, OAKLAND, CA, 94607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8014919,
    "lng": -122.2903554
  },
  {
    "id": "16764",
    "name": "ISLAND NATURALS",
    "address": "74-5487 KAIWI STREET, KAILUA-KONA,HAWAII, HI, 96740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 19.6468116,
    "lng": -155.999285
  },
  {
    "id": "16763",
    "name": "INTERNET ACCOUNTS",
    "address": "20042 HWY 69 S, UNIT K3, TYLER, TX, 75703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.1896812,
    "lng": -95.3205992
  },
  {
    "id": "16762",
    "name": "INTERNET ACCOUNTS",
    "address": "885 ELKTON DR, COLORADO SPRINGS, CO, 80907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9010976,
    "lng": -104.8428169
  },
  {
    "id": "16761",
    "name": "INTERNET ACCOUNTS",
    "address": "1288 ODDSTAD DR STE B, REDWOOD CITY, CA, 94063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4903355,
    "lng": -122.2192811
  },
  {
    "id": "16760",
    "name": "INTERNET ACCOUNTS",
    "address": "4160 PATTERSON AVE, PERRIS, CA, 92570",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8468944,
    "lng": -117.2513872
  },
  {
    "id": "16759",
    "name": "INTERNET ACCOUNTS",
    "address": "4160  PATTERSON AVE, PERRIS, CA, 92570",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8468944,
    "lng": -117.2513872
  },
  {
    "id": "16758",
    "name": "INTERNET ACCOUNTS",
    "address": "10990 DONNER PASS RD, TRUCKEE, CA, 96161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3262527,
    "lng": -120.2033286
  },
  {
    "id": "16757",
    "name": "INTERNET ACCOUNTS",
    "address": "1071 GAYLEY AVE, LOS ANGELES, CA, 90024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0606424,
    "lng": -118.4472251
  },
  {
    "id": "16756",
    "name": "INTERNET ACCOUNTS",
    "address": "7325 S RAINBOW BLVD STE 110, LAS VEGAS, NV, 89139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0552694,
    "lng": -115.2434376
  },
  {
    "id": "16755",
    "name": "INTERNET ACCOUNTS",
    "address": "2233 EAST GRAND AVE, EL SEGUNDO, CA, 90245",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9204501,
    "lng": -118.386182
  },
  {
    "id": "16754",
    "name": "INTERNATIONAL-G2 PRICING",
    "address": "1065 EDWARD STREET, LINDEN, NJ, 7036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6112844,
    "lng": -74.2539717
  },
  {
    "id": "16753",
    "name": "INTERNATIONAL OCEANIA DIV",
    "address": "2815 W EL SEGUNDO BLVD, HAWTHORNE, CA, 90250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9181342,
    "lng": -118.3248257
  },
  {
    "id": "16752",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "7818 NW 71ST STREET, MIAMI, FL, 33166",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.837359,
    "lng": -80.3240919
  },
  {
    "id": "16751",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "TROPICAL SHIPPING, MEDLEY, FL, 33178",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8600777,
    "lng": -80.372665
  },
  {
    "id": "16750",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "7185 NW 87TH AVE, MIAMI, FL, 33178",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8384017,
    "lng": -80.3378464
  },
  {
    "id": "16749",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "10100 NW 25TH STREET, MIAMI, FL, 33172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7955645,
    "lng": -80.360471
  },
  {
    "id": "16748",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "10900 NW 21ST ST #130, MIAMI, FL, 33170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.793262,
    "lng": -80.3730782
  },
  {
    "id": "16747",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "10900 NW 21ST ST # 130, MIAMI, FL, 33170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.793262,
    "lng": -80.3730782
  },
  {
    "id": "16746",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "11760 MIRAMAR PKY STE 100, MIRAMAR, FL, 33025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9719464,
    "lng": -80.3051317
  },
  {
    "id": "16745",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "9400 BUSCH DR NORTH, JACKSONVILLE, FL, 32218",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4110054,
    "lng": -81.6442453
  },
  {
    "id": "16744",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "10000NW 17ST STE103, MIAMI, FL, 33172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.789517,
    "lng": -80.3590398
  },
  {
    "id": "16743",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "416-428 STANLEY AVE, BROOKLYN, NY, 11207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6554866,
    "lng": -73.892295
  },
  {
    "id": "16742",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "2401 NW 69TH STREET, MIAMI, FL, 33147",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8375398,
    "lng": -80.2385791
  },
  {
    "id": "16741",
    "name": "INTERNATIONAL ACCOUNTS",
    "address": "11000 NW29TH ST SUITE 201, DORAL, FL, 33172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7999169,
    "lng": -80.3749992
  },
  {
    "id": "16740",
    "name": "INTEGRAL YOGA, VA",
    "address": "923 PRESTON AVE, CHARLOTTESVILLE, VA, 22903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.038848,
    "lng": -78.4899786
  },
  {
    "id": "16739",
    "name": "INFRA PACIFIC-NW CONTRACT",
    "address": "125 E WOODIN AVE, CHELAN, WA, 98816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.8401226,
    "lng": -120.01797
  },
  {
    "id": "16738",
    "name": "INFRA PACIFIC-ALL OTHER SW",
    "address": "10367 SAN PABLO AVENUE, EL CERRITO, CA, 94530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9073284,
    "lng": -122.3062782
  },
  {
    "id": "16737",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "806 S MAIN ST, FOND DU LAC, WI, 54935",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.7566307,
    "lng": -88.4497383
  },
  {
    "id": "16736",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "80 GROVE ST, WATERVILLE, ME, 4901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.538699,
    "lng": -69.6471964
  },
  {
    "id": "16735",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "75 MILL HILL ROAD, WOODSTOCK, NY, 12498",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0391122,
    "lng": -74.1134256
  },
  {
    "id": "16734",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "24 GARDEN ST, RHINEBECK, NY, 12572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9280031,
    "lng": -73.9140051
  },
  {
    "id": "16733",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "11083 SPRING HILL ROAD, SPRING HILL, FL, 34609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.462335,
    "lng": -82.5413053
  },
  {
    "id": "16732",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "42 FOREST AVENUE, GLEN COVE, NY, 11542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8708353,
    "lng": -73.6261288
  },
  {
    "id": "16731",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "640 MAIN ST, DENNIS PORT, MA, 2639",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6678277,
    "lng": -70.1245794
  },
  {
    "id": "16730",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "32 MARKET ST, MASHPEE, MA, 2649",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.615972,
    "lng": -70.4914192
  },
  {
    "id": "16729",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "10471 SE FEDERAL HWY, HOBE SOUND, FL, 33455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0769574,
    "lng": -80.1436074
  },
  {
    "id": "16728",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "1297 CENTENNIAL AVE, #4, PISCATAWAY, NJ, 8854",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5534748,
    "lng": -74.4421375
  },
  {
    "id": "16727",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "4301 COMMUTER DRIVE, VIRGINIA BEACH, VA, 23462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8210573,
    "lng": -76.1236826
  },
  {
    "id": "16726",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "1545 ROUTE 52, SUITE 20, FISHKILL, NY, 12524",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5446466,
    "lng": -73.8742414
  },
  {
    "id": "16725",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "537 RAILROAD ST, ST JOHNSBURY, VT, 5819",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4204112,
    "lng": -72.0156386
  },
  {
    "id": "16724",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "129 MAIN STREET NORTH, WOODBURY, CT, 6798",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5549147,
    "lng": -73.2038419
  },
  {
    "id": "16723",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "175 LOCUST AVE, WEST LONG BRANCH, NJ, 7764",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2867849,
    "lng": -74.0181692
  },
  {
    "id": "16722",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "3211 PEOPLES ST., JOHNSON CITY, TN, 37604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3465578,
    "lng": -82.3996755
  },
  {
    "id": "16721",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "60 MAIN STREET, BRUNSWICK, ME, 4011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.917295,
    "lng": -69.9666194
  },
  {
    "id": "16720",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "275 S CENTRAL AVE, HARTSDALE, NY, 10530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0122483,
    "lng": -73.8068691
  },
  {
    "id": "16719",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "900 JEFFERSON RD, ROCHESTER, NY, 14623",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0901748,
    "lng": -77.6129652
  },
  {
    "id": "16718",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "327 RTE 21 C, GHENT, NY, 12075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2699027,
    "lng": -73.5942881
  },
  {
    "id": "16717",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "265 RT 94, VERNON, NJ, 7462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1960701,
    "lng": -74.4934539
  },
  {
    "id": "16716",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "3156 RTE 9 SOUTH, RIO GRANDE, NJ, 8242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0207002,
    "lng": -74.8696275
  },
  {
    "id": "16715",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "4 MARKET STREET, ONEONTA, NY, 13820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.451243,
    "lng": -75.0633505
  },
  {
    "id": "16714",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "2205 SILVERNAIL RD, PEWAUKEE, WI, 53072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0434634,
    "lng": -88.2632277
  },
  {
    "id": "16713",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "4 NORTH THOMPSON STREET, RICHMOND, VA, 23221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5574138,
    "lng": -77.4884332
  },
  {
    "id": "16712",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "607 THIRD ST, WAUSAU, WI, 54403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.961749,
    "lng": -89.6274082
  },
  {
    "id": "16711",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "98 COMMONWEALTH AVE, WEST CONCORD, MA, 1742",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4573422,
    "lng": -71.3953564
  },
  {
    "id": "16710",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "862 SAXON BLVD, ORANGE CITY, FL, 32763",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.909465,
    "lng": -81.293007
  },
  {
    "id": "16709",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "829 FLEMING STREET, KEY WEST, FL, 33040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 24.5589854,
    "lng": -81.798501
  },
  {
    "id": "16708",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "2749 100TH ST, URBANDALE, IA, 50322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.61963,
    "lng": -93.7546512
  },
  {
    "id": "16707",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "4040 UNIVERSITY AVE, DES MOINES, IA, 50311",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6000096,
    "lng": -93.6726768
  },
  {
    "id": "16706",
    "name": "INFRA ATLANTIC- ALL OTHER",
    "address": "1478 FIRST AVE, NEW YORK, NY, 10021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.770612,
    "lng": -73.953289
  },
  {
    "id": "16705",
    "name": "INDEPENDENT SPRMRKT MW1",
    "address": "510 5TH STREET, ALGOMA, WI, 54201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.6084536,
    "lng": -87.4394945
  },
  {
    "id": "16704",
    "name": "INDEPENDENT SMK NORTHEAST",
    "address": "485 RTE 134-HARNEYS PLAZA, SOUTH DENNIS, MA, 2660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6932084,
    "lng": -70.1545285
  },
  {
    "id": "16703",
    "name": "HY-VEE",
    "address": "2920 FITCHRONA ROAD, FITCHBURG, WI, 53719",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0133009,
    "lng": -89.4796819
  },
  {
    "id": "16702",
    "name": "HONEST GREEN-WHOLESALE",
    "address": "2194 HIGHWAY A1A, INDIAN HAR BEACH, FL, 32937",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1422452,
    "lng": -80.5822367
  },
  {
    "id": "16701",
    "name": "HONEST GREEN-WHOLESALE",
    "address": "3138 HIGHWAY H, STURTEVANT, WI, 53177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.696262,
    "lng": -87.9165116
  },
  {
    "id": "16700",
    "name": "HONEST GREEN-WHOLESALE",
    "address": "525 NEELYTOWN ROAD, MONTGOMERY, NY, 12549",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4938337,
    "lng": -74.2359072
  },
  {
    "id": "16699",
    "name": "HONEST GREEN-WHOLESALE",
    "address": "6912 LAKE TERRACE E, WOODBURY, MN, 55125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.907822,
    "lng": -92.965822
  },
  {
    "id": "16698",
    "name": "HONEST GREEN-WHLS LESS 5",
    "address": "3370 COMMERCIAL AVE, NORTHBROOK, IL, 60062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1469424,
    "lng": -87.8618557
  },
  {
    "id": "16697",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "7567 IMPERIAL DRIVE, BOCA RATON, FL, 33433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3341167,
    "lng": -80.1614293
  },
  {
    "id": "16696",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "320 1ST ST N, JACKSONVILLE BEAC, FL, 32250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2918842,
    "lng": -81.3905494
  },
  {
    "id": "16695",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "8520 ALLISON POINTE BLVD, INDIANAPOLIS, IN, 46250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.90952,
    "lng": -86.0851054
  },
  {
    "id": "16694",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "15 LINCOLN ST STE 322, WAKEFIELD, MA, 1880",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5030932,
    "lng": -71.0696013
  },
  {
    "id": "16693",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "1736 DUTCH MILL RD, FRANKLINVILLE, NJ, 8322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5792628,
    "lng": -74.9956218
  },
  {
    "id": "16692",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "1466 MAIN ST, GARDNERVILLE, NV, 89410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9427279,
    "lng": -119.7515591
  },
  {
    "id": "16691",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "16 JESSIE STREET UNIT 108, SAN FRANCISCO, CA, 94105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7899062,
    "lng": -122.3989561
  },
  {
    "id": "16690",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "600 LA TERRAZA BLVD, ESCONDIO, CA, 92026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1117412,
    "lng": -117.0955428
  },
  {
    "id": "16689",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "625 S PALM ST, LA HABRA, CA, 90631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9257025,
    "lng": -117.9249459
  },
  {
    "id": "16688",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "42-06A BELL BLVD, BAYSIDE, NY, 11361",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7624688,
    "lng": -73.770711
  },
  {
    "id": "16687",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "994 SHADYBROOK DR, CONCORD, CA, 94521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9333046,
    "lng": -121.9704617
  },
  {
    "id": "16686",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "5008 STATE HIGHWAY 140, MARIPOSA, CA, 95338",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.483644,
    "lng": -119.9638168
  },
  {
    "id": "16685",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "3138 CO HWY H, STURTEVANT, WI, 53177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.696262,
    "lng": -87.9165116
  },
  {
    "id": "16684",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "UNFI, STURTEVANT, WI, 53177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6968688,
    "lng": -87.9164428
  },
  {
    "id": "16683",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "525 NEELYTOWN RD, MONTGOMERY, NY, 12549",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4938337,
    "lng": -74.2359072
  },
  {
    "id": "16682",
    "name": "HONEST GREEN-WHLS LESS 15",
    "address": "977 SERMIROLE TRAIL #35, CHAROLETTESVILLE, VA, 22901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0631052,
    "lng": -78.4897774
  },
  {
    "id": "16681",
    "name": "HONEST GREEN-WHLS LESS 10",
    "address": "554 GRAND AVENUE, ENGLEWOOD, NJ, 7631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.876295,
    "lng": -73.9841278
  },
  {
    "id": "16680",
    "name": "HONEST GREEN-WHLS LESS 10",
    "address": "337 RESERVOIR ST, NEEDHAM HEIGHTS, MA, 2494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3063688,
    "lng": -71.2259866
  },
  {
    "id": "16679",
    "name": "HONEST GREEN-WHLS LESS 10",
    "address": "7643 GATE PKWY, JACKSONVILLE, FL, 32256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2415132,
    "lng": -81.5192261
  },
  {
    "id": "16678",
    "name": "HONEST GREEN - ETAILZ",
    "address": "2818 N SULLLIVAN RD, SPOKANE VALLEY, WA, 99216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.683193,
    "lng": -117.194393
  },
  {
    "id": "16677",
    "name": "HOLIDAY QUALITY FOODS",
    "address": "9350 DESCHUTES ROAD, PALO CEDRO, CA, 96022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5595843,
    "lng": -122.2401772
  },
  {
    "id": "16676",
    "name": "HITCHCOCK",
    "address": "6765 22ND AVE N, ST.PETERSBURG, FL, 33710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7924166,
    "lng": -82.730236
  },
  {
    "id": "16675",
    "name": "HIGH FALLS COOP",
    "address": "1398 STATE ROUTE 213, HIGH FALLS, NY, 12440",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8296831,
    "lng": -74.1348133
  },
  {
    "id": "16674",
    "name": "HH 55 PRICING",
    "address": "803 SUWANNEE AVENUE, BRANFORD, FL, 32008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9642514,
    "lng": -82.9309121
  },
  {
    "id": "16673",
    "name": "HG - NATURAL COMMERCE",
    "address": "520 FOLLY RD, CHARLESTON, SC, 29412",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.75362,
    "lng": -79.9709387
  },
  {
    "id": "16672",
    "name": "HERITAGE STORE",
    "address": "984 LASKIN RD, VIRGINIA BEACH, VA, 23451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8577957,
    "lng": -75.9902323
  },
  {
    "id": "16671",
    "name": "HENRY`S INDEPENDENTS",
    "address": "878 EASTLAKE PARKWAY ST 1410, CHULA VISTA, CA, 91914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.65149,
    "lng": -116.9705123
  },
  {
    "id": "16670",
    "name": "HENNINGS SUPERMARKET",
    "address": "290 MAIN STREET, HARLEYSVILLE, PA, 19438",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2664075,
    "lng": -75.3780522
  },
  {
    "id": "16669",
    "name": "HEAVENS PEAK ORGANICS",
    "address": "355 HWY 93, EUREKA, MT, 59917",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.8882739,
    "lng": -115.0568728
  },
  {
    "id": "16668",
    "name": "HEALTHY SNACK SOLUTIONS",
    "address": "33 E MIDLAND AVE BOX 1544, PARAMUS, NJ, 7652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.948954,
    "lng": -74.0694475
  },
  {
    "id": "16667",
    "name": "HEALTHSMART OF LEWISBURG",
    "address": "4144 ST RT 34, HURRICANE, WV, 25526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4526047,
    "lng": -81.9389468
  },
  {
    "id": "16666",
    "name": "HEALTHSMART OF LEWISBURG",
    "address": "302 GALLERIA PLZ, BECKLEY, WV, 25801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.801885,
    "lng": -81.177066
  },
  {
    "id": "16665",
    "name": "HEALTH WAY",
    "address": "1116 CHAMPLAIN ST, OGDENSBURG, NY, 13669",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.6990684,
    "lng": -75.4606086
  },
  {
    "id": "16664",
    "name": "HEALTH NUT NUTRITION",
    "address": "1701 ENTERPRISE DR, LYNCHBURG, VA, 24502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3598008,
    "lng": -79.2409519
  },
  {
    "id": "16663",
    "name": "HEALTH HUT",
    "address": "19035 W BLUEMOUND ROAD, BROOKFIELD, WI, 53045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0351508,
    "lng": -88.1487332
  },
  {
    "id": "16662",
    "name": "HEALTH BASKET CLER/MTDORA",
    "address": "18040 US HWY 441, MT DORA, FL, 32757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4109642,
    "lng": -82.2134592
  },
  {
    "id": "16661",
    "name": "HARRIS TEETER",
    "address": "3565 MLKING JR BLVD, NEW BERN, NC, 28562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0970912,
    "lng": -77.1012801
  },
  {
    "id": "16660",
    "name": "HARRIS TEETER",
    "address": "4701 SMITH FARM RD, CHARLOTTE, NC, 28216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3278703,
    "lng": -80.9405101
  },
  {
    "id": "16659",
    "name": "HARRIS TEETER",
    "address": "3333 PINEVILLE-MATTHEWS R, CHARLOTTE, NC, 28226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.096321,
    "lng": -80.78463
  },
  {
    "id": "16658",
    "name": "HARMON`S",
    "address": "5370 SOUTH 1900 WEST, ROY, UT, 84067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1660407,
    "lng": -112.0243492
  },
  {
    "id": "16657",
    "name": "HARMON`S",
    "address": "870 EAST 800 NORTH, OREM, UT, 84097",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3106728,
    "lng": -111.675202
  },
  {
    "id": "16656",
    "name": "HARMON`S",
    "address": "10507 SOUTH REDWOOD RD, S JORDAN, UT, 84095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5603309,
    "lng": -111.936413
  },
  {
    "id": "16655",
    "name": "HARMON`S",
    "address": "11453 S PARKWAY PLAZA, S JORDAN, UT, 84095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5433103,
    "lng": -111.9777731
  },
  {
    "id": "16654",
    "name": "HARMON`S",
    "address": "13330 S KESTREL RANGE RD, RIVERTON, UT, 84096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5092141,
    "lng": -112.0023366
  },
  {
    "id": "16653",
    "name": "HARMON`S",
    "address": "5454 SOUTH REDWOOD RD, TAYLORSVILLE, UT, 84123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.652193,
    "lng": -111.9407793
  },
  {
    "id": "16652",
    "name": "HARMON`S",
    "address": "3520 PIONEER PARKWAY, SANTA CLARA, UT, 84120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.1484154,
    "lng": -113.659706
  },
  {
    "id": "16651",
    "name": "HARMON`S",
    "address": "1189 EAST 700 SOUTH, ST GEORGE, UT, 84790",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0975871,
    "lng": -113.5581558
  },
  {
    "id": "16650",
    "name": "HARMON`S",
    "address": "4874 WEST 6200 SOUTH, KEARNS, UT, 84118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6396982,
    "lng": -112.0070724
  },
  {
    "id": "16649",
    "name": "HARMON`S",
    "address": "135 EAST 100 SOUTH, SALT LAKE CITY, UT, 84111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7676832,
    "lng": -111.887105
  },
  {
    "id": "16648",
    "name": "HARMON`S",
    "address": "3270 SOUTH 1300 EAST, SALT LAKE CITY, UT, 84106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.701349,
    "lng": -111.8555544
  },
  {
    "id": "16647",
    "name": "HARMON`S",
    "address": "1750 TRAVERSE PARKWAY, LEHI, UT, 84043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4334294,
    "lng": -111.8780049
  },
  {
    "id": "16646",
    "name": "HARMON`S",
    "address": "125 EAST 13800 SOUTH, DRAPER, UT, 84020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5018427,
    "lng": -111.8875999
  },
  {
    "id": "16645",
    "name": "HARMON`S",
    "address": "672 EAST 11400 SOUTH, DRAPER, UT, 84020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5420852,
    "lng": -111.872695
  },
  {
    "id": "16644",
    "name": "HARMON`S",
    "address": "200 N STATION WAY, FARMINGTON, UT, 84025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9838808,
    "lng": -111.9033897
  },
  {
    "id": "16643",
    "name": "HARMON`S",
    "address": "7755 SOUTH 700 EAST, MIDVALE, UT, 84047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6106751,
    "lng": -111.8704593
  },
  {
    "id": "16642",
    "name": "HARMON`S",
    "address": "3955 WEST 3500 SOUTH, W VALLEY CITY, UT, 84120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6955979,
    "lng": -111.985716
  },
  {
    "id": "16641",
    "name": "HAGGEN",
    "address": "3711 88TH ST NW, MARYSVILLE, WA, 98270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.0768906,
    "lng": -122.1804238
  },
  {
    "id": "16640",
    "name": "Haggen",
    "address": "8915 Market Place NE, Lake Stevens, WA, 98258",
    "phone": "(425) 377-7100",
    "hours": "Call for hours",
    "lat": 47.9990157,
    "lng": -122.1106682
  },
  {
    "id": "16639",
    "name": "HAGGEN",
    "address": "17641 GARDEN WAY NE, WOODINVILLE, WA, 98072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7557478,
    "lng": -122.1572866
  },
  {
    "id": "16638",
    "name": "HAGGEN",
    "address": "1815 MAIN ST, FERNDALE, WA, 98248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.8429963,
    "lng": -122.5806146
  },
  {
    "id": "16637",
    "name": "HAGGEN",
    "address": "1301 AVE D, SNOHOMISH, WA, 98290",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.9277274,
    "lng": -122.0963967
  },
  {
    "id": "16636",
    "name": "HAGGEN",
    "address": "26603 72ND AVE NW, STANWOOD, WA, 98292",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.2377706,
    "lng": -122.3289258
  },
  {
    "id": "16635",
    "name": "HAGGEN",
    "address": "2900 WOBURN ST, BELLINGHAM, WA, 98226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.7691442,
    "lng": -122.4445932
  },
  {
    "id": "16634",
    "name": "Haggen",
    "address": "2601 East Division, Mount Vernon, WA, 98274",
    "phone": "360-848-6999",
    "hours": "Call for hours",
    "lat": 48.4222267,
    "lng": -122.3077475
  },
  {
    "id": "16633",
    "name": "HAGGEN",
    "address": "210 36TH ST, BELLINGHAM, WA, 98225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.7321393,
    "lng": -122.4713893
  },
  {
    "id": "16632",
    "name": "HAGGEN",
    "address": "1313 COOPER PT RD SW, OLYMPIA, WA, 98502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.034113,
    "lng": -122.9410404
  },
  {
    "id": "16631",
    "name": "HAGGEN",
    "address": "1406 LAKE TAPPS PKWY E, AUBURN, WA, 98092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2429989,
    "lng": -122.2096035
  },
  {
    "id": "16630",
    "name": "HAGGEN",
    "address": "757 HAGGEN DR, BURLINGTON, WA, 98233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.4692798,
    "lng": -122.3388153
  },
  {
    "id": "16629",
    "name": "GUIDO'S FRUIT & PRODUCE",
    "address": "760 SOUTH MAIN STREET, GREAT BARRINGTON, MA, 1230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1794909,
    "lng": -73.3648829
  },
  {
    "id": "16628",
    "name": "GROW THE PRODUCE",
    "address": "300 S SANTA FE AVE STE C, LOS ANGELES, CA, 90013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0458388,
    "lng": -118.2323104
  },
  {
    "id": "16627",
    "name": "GREENBAY MARKETPLACE",
    "address": "31 10 30TH AVE, ASTORIA, NY, 11103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.766433,
    "lng": -73.921057
  },
  {
    "id": "16626",
    "name": "GREEN ZEBRA GROCERY",
    "address": "3011 N LOMBARD ST, PORTLAND, OR, 97217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5773743,
    "lng": -122.6976545
  },
  {
    "id": "16625",
    "name": "GREEN ACRES SN",
    "address": "14 NW SHERIDAN RD, LAWTON, OK, 73505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6091719,
    "lng": -98.4228545
  },
  {
    "id": "16624",
    "name": "GREEN ACRES SN",
    "address": "10555 W 21ST ST, WICHITA, KS, 67205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7221114,
    "lng": -97.465113
  },
  {
    "id": "16623",
    "name": "GREEN ACRES SN",
    "address": "7301 S PENNSYLVANIA AVE, OKLAHOMA CITY, OK, 73159",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.39341,
    "lng": -97.5491017
  },
  {
    "id": "16622",
    "name": "GREEN ACRES OF WICHITA",
    "address": "8141 EAST 21ST, WICHITA, KS, 67206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7222311,
    "lng": -97.2424025
  },
  {
    "id": "16621",
    "name": "GREEN ACRES OF WICHITA",
    "address": "4175 NO MULBERRY DR., KANSAS CITY, MO, 64116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1699102,
    "lng": -94.5967417
  },
  {
    "id": "16620",
    "name": "GREEN ACRES OF WICHITA",
    "address": "6574 E CENTRAL, WICHITA, KS, 67206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.694602,
    "lng": -97.260695
  },
  {
    "id": "16619",
    "name": "GREEN ACRES OF WICHITA",
    "address": "2315 W 21ST, WICHITA, KS, 67203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7225522,
    "lng": -97.3690021
  },
  {
    "id": "16618",
    "name": "GREEN ACRES OF WICHITA",
    "address": "10555 W 21ST N, WICHITA, KS, 67205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7221114,
    "lng": -97.465113
  },
  {
    "id": "16617",
    "name": "GREEN ACRES",
    "address": "7301 S PENN AVE STE D, OKLAHOMA CITY, OK, 73159",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.39341,
    "lng": -97.5491017
  },
  {
    "id": "16616",
    "name": "GREEN ACRES",
    "address": "14 NW SHERIDAN, LAWTON, OK, 73505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6091719,
    "lng": -98.4228545
  },
  {
    "id": "16615",
    "name": "GRACEFULLY",
    "address": "101 WEST END AVENUE, NEW YORK, NY, 10003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7750725,
    "lng": -73.9886498
  },
  {
    "id": "16614",
    "name": "GOODWINS ORGANICS",
    "address": "191 WEST BIG SPRING ROAD, RIVERSIDE, CA, 92507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9759616,
    "lng": -117.3154157
  },
  {
    "id": "16613",
    "name": "GOOD TO GO",
    "address": "779 MONTAUK HWY, MONTAUK, NY, 11954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0356244,
    "lng": -71.9431211
  },
  {
    "id": "16612",
    "name": "GOOD EARTH UTAH",
    "address": "336 W MAIN ST, AMERICAN FORK, UT, 84003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3773486,
    "lng": -111.807346
  },
  {
    "id": "16611",
    "name": "GOOD EARTH MARKET LLC",
    "address": "31806 GOOD EARTH LANE, OCEAN VIEW, DE, 19970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5519776,
    "lng": -75.1377095
  },
  {
    "id": "16610",
    "name": "GOOD EARTH FAIRFAX",
    "address": "720 CENTER BLVD, FAIRFAX, CA, 94930",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9862744,
    "lng": -122.5831381
  },
  {
    "id": "16609",
    "name": "GOLDEN HARVEST",
    "address": "3215 HWY G, RHINELANDER, WI, 54501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6211182,
    "lng": -89.4103323
  },
  {
    "id": "16608",
    "name": "GNC FRANCHISE STORES",
    "address": "4680 MONTICELLO AVE #18B, WILLIAMSBURG, VA, 23188",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2722362,
    "lng": -76.7589008
  },
  {
    "id": "16607",
    "name": "GMD - SMKT CARIBBEAN",
    "address": "2230 SW 2ND STREET, POMPANO BEACH, FL, 33069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2282886,
    "lng": -80.1510572
  },
  {
    "id": "16606",
    "name": "GLOBAL MARKET DEV",
    "address": "1800 ELMWOOD AVE, BUFFALO, NY, 14207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9461433,
    "lng": -78.8794866
  },
  {
    "id": "16605",
    "name": "GLOBAL MARKET DEV",
    "address": "750 FRELINGHUYSEN AVE, NEWARK, NJ, 7114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6953127,
    "lng": -74.1979383
  },
  {
    "id": "16604",
    "name": "GLOBAL MARKET DEV",
    "address": "8535 POSEY ROAD, JACKSONVILLE, FL, 32220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3187046,
    "lng": -81.7946555
  },
  {
    "id": "16603",
    "name": "GENERIC EDI",
    "address": "6569 S VERMONT AVE, LOS ANGELES, CA, 90044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9793978,
    "lng": -118.2921339
  },
  {
    "id": "16602",
    "name": "GENERIC EDI",
    "address": "3030 E 29TH ST STE 100, BRYAN, TX, 77802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6550583,
    "lng": -96.3419994
  },
  {
    "id": "16601",
    "name": "GENERIC EDI",
    "address": "401 ALHAMBRA AVE, EL GRANADA, CA, 94018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.504506,
    "lng": -122.4771076
  },
  {
    "id": "16600",
    "name": "GENERIC EDI",
    "address": "1351 N HWY 99 W, MCMINNVILLE, OR, 97128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.2267795,
    "lng": -123.1853918
  },
  {
    "id": "16599",
    "name": "GENERIC EDI",
    "address": "111 N MUSKOGEE AVE, TAHLEQUAH, OK, 74464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.913784,
    "lng": -94.9709497
  },
  {
    "id": "16598",
    "name": "GENERIC EDI",
    "address": "3051 S WHITE MOUNTAIN RD, SHOW LOW, AZ, 85901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2216237,
    "lng": -110.0287285
  },
  {
    "id": "16597",
    "name": "GENERIC EDI",
    "address": "PO BOX 161, NEDERLAND, CO, 80466",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9640857,
    "lng": -105.504874
  },
  {
    "id": "16596",
    "name": "GENERIC EDI",
    "address": "39 EAST 100 NORTH, MOAB, UT, 84532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5751055,
    "lng": -109.5499983
  },
  {
    "id": "16595",
    "name": "GENERIC EDI",
    "address": "3100 W. LINE ST, BISHOP, CA, 93514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.360755,
    "lng": -118.4367094
  },
  {
    "id": "16594",
    "name": "GENERIC EDI",
    "address": "73910 HWY 111 STE D, PALM DESERT, CA, 92660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7217734,
    "lng": -116.3764137
  },
  {
    "id": "16593",
    "name": "GENERIC EDI",
    "address": "4825 EL CAMINO REAL, ATASCADERO, CA, 93422",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.496229,
    "lng": -120.679493
  },
  {
    "id": "16592",
    "name": "GENERIC EDI",
    "address": "PO BOX 343, ALPINE, TX, 79830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3584919,
    "lng": -103.6610115
  },
  {
    "id": "16591",
    "name": "GENERIC EDI",
    "address": "112 S 2ND STREET, LARAMIE, WY, 82070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3126065,
    "lng": -105.594966
  },
  {
    "id": "16590",
    "name": "GENERIC EDI",
    "address": "1020 7TH STREET, ANACORTES, WA, 98221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.5168095,
    "lng": -122.6138205
  },
  {
    "id": "16589",
    "name": "GELSONS MARKETS",
    "address": "2734 TOWNSGATE RD, WESTLAKE VILLAGE, CA, 91361",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1525706,
    "lng": -118.825081
  },
  {
    "id": "16588",
    "name": "GELSONS MARKETS",
    "address": "15424 SUNSET BLVD, PACIFIC PALISADES, CA, 90272",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0478815,
    "lng": -118.5280391
  },
  {
    "id": "16587",
    "name": "GELSONS MARKETS",
    "address": "1660 SAN MIGUEL DR, NEWPORT BEACH, CA, 92660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6114245,
    "lng": -117.8632858
  },
  {
    "id": "16586",
    "name": "GELSONS MARKETS",
    "address": "5500 RESEDA BLVD, TARZANA, CA, 91356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1702569,
    "lng": -118.5347457
  },
  {
    "id": "16585",
    "name": "GELSONS MARKETS",
    "address": "10250 SANTA MONICA BLVD, LOS ANGELES, CA, 90067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0590031,
    "lng": -118.418866
  },
  {
    "id": "16584",
    "name": "GELSONS MARKETS",
    "address": "30922 PACIFIC COAST HWY, LAGUNA BEACH, CA, 92651",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.514763,
    "lng": -117.7550333
  },
  {
    "id": "16583",
    "name": "GELSONS MARKETS",
    "address": "1736 AVENIDA DE LOS ARBOLES, THOUSAND OAKS, CA, 91362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2104707,
    "lng": -118.847027
  },
  {
    "id": "16582",
    "name": "GELSONS MARKETS",
    "address": "730 TURQUOISE ST, PACIFIC BEACH, CA, 92109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8087643,
    "lng": -117.260355
  },
  {
    "id": "16581",
    "name": "GELSONS MARKETS",
    "address": "4738 LAUREL CANYON BLVD, VALLEY VILLAGE, CA, 91607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1562727,
    "lng": -118.3959542
  },
  {
    "id": "16580",
    "name": "GELSONS MARKETS",
    "address": "2627 LINCOLN BLVD, SANTA MONICA, CA, 90405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0070072,
    "lng": -118.4746659
  },
  {
    "id": "16579",
    "name": "GELSONS MARKETS",
    "address": "36-101 BOB HOPE DR, RANCHO MIRAGE, CA, 92270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7860947,
    "lng": -116.4063174
  },
  {
    "id": "16578",
    "name": "GELSONS MARKETS",
    "address": "2707 VIA DE LA VALLE, DEL MAR, CA, 92014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9788941,
    "lng": -117.2489571
  },
  {
    "id": "16577",
    "name": "GELSONS MARKETS",
    "address": "7660 EL CAMINO REAL, LA COSTA, CA, 92009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4792616,
    "lng": -120.6578047
  },
  {
    "id": "16576",
    "name": "GELSONS MARKETS",
    "address": "30731 GATEWAY PLZA BLDG B, RANCHO MISSION VIE, CA, 92694",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5217909,
    "lng": -117.6184806
  },
  {
    "id": "16575",
    "name": "GELSONS MARKETS",
    "address": "635 FOOTHILL BLVD, LA CANADA FLNTRDGE, CA, 91011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2027405,
    "lng": -118.1922306
  },
  {
    "id": "16574",
    "name": "GELSONS MARKETS",
    "address": "2725 HYPERION AVE, LOS ANGELES, CA, 90027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1080033,
    "lng": -118.2726704
  },
  {
    "id": "16573",
    "name": "GELSONS MARKETS",
    "address": "6255 E 2ND ST, LONG BEACH, CA, 90803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7586098,
    "lng": -118.1123364
  },
  {
    "id": "16572",
    "name": "GELSONS MARKETS",
    "address": "16450 VENTURA BLVD, ENCINO, CA, 91436",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1570747,
    "lng": -118.4917793
  },
  {
    "id": "16571",
    "name": "GELSONS MARKETS",
    "address": "24 MONARCH BAY PLAZA, DANA POINT, CA, 92629",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4846349,
    "lng": -117.7233165
  },
  {
    "id": "16570",
    "name": "GELSONS MARKETS",
    "address": "5521 ALTON PRKWY, IRVINE, CA, 92618",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6703614,
    "lng": -117.7867194
  },
  {
    "id": "16569",
    "name": "GELSONS MARKETS",
    "address": "3305 STATE ST, SANTA BARBARA, CA, 93105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.439052,
    "lng": -119.7350935
  },
  {
    "id": "16568",
    "name": "GELSONS MARKETS",
    "address": "4520 VAN NUYS BLVD, SHERMAN OAKS, CA, 91403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1538528,
    "lng": -118.4476241
  },
  {
    "id": "16567",
    "name": "GELSONS MARKETS",
    "address": "5877 FRANKLIN AVE, HOLLYWOOD, CA, 90028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1058984,
    "lng": -118.3176116
  },
  {
    "id": "16566",
    "name": "GELSONS MARKETS",
    "address": "22277 MULHOLLAND HWY, CALABASAS, CA, 91302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1481372,
    "lng": -118.6133349
  },
  {
    "id": "16565",
    "name": "GELSONS MARKETS",
    "address": "8330 W SANTA MONICA BLVD, WEST HOLLYWOOD, CA, 90069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0902513,
    "lng": -118.371122
  },
  {
    "id": "16564",
    "name": "GELSONS MARKETS",
    "address": "13455 MAXELLA AVE, MARINA DEL RAY, CA, 90292",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9867942,
    "lng": -118.4420484
  },
  {
    "id": "16563",
    "name": "GEISSLERS",
    "address": "95 SOUTH RD, SOMERS, CT, 6071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9801148,
    "lng": -72.4445751
  },
  {
    "id": "16562",
    "name": "GEISSLERS",
    "address": "9-J BANK ST, GRANBY, CT, 6035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9530781,
    "lng": -72.783874
  },
  {
    "id": "16561",
    "name": "G2 PRICING MODEL",
    "address": "136 SOUTH MAIN STREET, NAPLES, NY, 14512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6141324,
    "lng": -77.4028201
  },
  {
    "id": "16560",
    "name": "G2 PRICING MODEL",
    "address": "420 CLAREMORE DRIVE, WEST PALM BEACH, FL, 33401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6943395,
    "lng": -80.0551077
  },
  {
    "id": "16559",
    "name": "G&E WHLS MINUS 10",
    "address": "319 KENT AVE, BROOKLYN, NY, 11249",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7137361,
    "lng": -73.9670544
  },
  {
    "id": "16558",
    "name": "G&E KATHERINE BRABBIT ZON",
    "address": "310 FRAZEE ST EAST, DETROIT LAKES, MN, 56501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8167104,
    "lng": -95.8404813
  },
  {
    "id": "16557",
    "name": "FRESHMART",
    "address": "11084 CABOT COMMERCE CIRC, JACKSONVILLE, FL, 32228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4328622,
    "lng": -81.5761877
  },
  {
    "id": "16556",
    "name": "FRESH HEALTH FD EMPORIUM",
    "address": "1276 FULTON STREET, BROOKLYN, NY, 11216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6802198,
    "lng": -73.9497912
  },
  {
    "id": "16555",
    "name": "FRAZIER FARMS MARKET",
    "address": "1820 OCEANSIDE BLVD, OCEANSIDE, CA, 92054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1937726,
    "lng": -117.3587493
  },
  {
    "id": "16554",
    "name": "FRAZIER FARMS MARKET",
    "address": "8401 FLETCHER PARKWAY, LA MESA, CA, 91940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7783817,
    "lng": -117.016421
  },
  {
    "id": "16553",
    "name": "FRAZIER FARMS MARKET",
    "address": "225 VISTA VILLAGE DRIVE, VISTA, CA, 92083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1977626,
    "lng": -117.2458411
  },
  {
    "id": "16552",
    "name": "FOSTER'S",
    "address": "C/O AMERICAN CONSOLIDATED, POMPANO BEACH, FL, 33069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2211377,
    "lng": -80.1391972
  },
  {
    "id": "16551",
    "name": "FOR GOODNESS SAKE",
    "address": "13040 LIVINGSTON RD, NAPLES, FL, 34105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2102143,
    "lng": -81.749902
  },
  {
    "id": "16550",
    "name": "FOODTOWN",
    "address": "781 METROPOLITAN AVE, BROOKLYN, NY, 11211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7147549,
    "lng": -73.943345
  },
  {
    "id": "16549",
    "name": "FOODTOWN",
    "address": "409 5TH AVE, BROOKLYN, NY, 11215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6700014,
    "lng": -73.9852297
  },
  {
    "id": "16548",
    "name": "FOODTOWN",
    "address": "31 EAST PROSPECT AVENUE, MOUNT VERNON, NY, 10550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9129745,
    "lng": -73.8359332
  },
  {
    "id": "16547",
    "name": "FOODTOWN",
    "address": "435 NO BEVERWYCK RD, LAKE HIAWATHA, NJ, 7034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8762785,
    "lng": -74.3813811
  },
  {
    "id": "16546",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "727 EAST AVE, PAWTUCKET, RI, 2860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8582465,
    "lng": -71.3915052
  },
  {
    "id": "16545",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "3139 POPLAR AVE, MEMPHIS, TN, 38111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1308457,
    "lng": -89.9571553
  },
  {
    "id": "16544",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "158 BRIDGE ST, HOT SPRINGS, NC, 28743",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.892874,
    "lng": -82.8267542
  },
  {
    "id": "16543",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "893 WEST STREET, AMHERST, MA, 1002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3267995,
    "lng": -72.5322876
  },
  {
    "id": "16542",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "2939 W GRAND AVE, CHICAGO, IL, 60622",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8958909,
    "lng": -87.7011351
  },
  {
    "id": "16541",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "9689 VILLAGE PLACE BLVD, BRIGHTON, MI, 48116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5071254,
    "lng": -83.7556642
  },
  {
    "id": "16540",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "201 AINSLEY DRIVE, SYRACUSE, NY, 13244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.012295,
    "lng": -76.128321
  },
  {
    "id": "16539",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "888 FOREST HILLS DR, GRAND RAPIDS, MI, 49546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9466976,
    "lng": -85.5553439
  },
  {
    "id": "16538",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "5500 BEACH BLVD SUITE 2, JAX, FL, 32207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2940516,
    "lng": -81.6082494
  },
  {
    "id": "16537",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "4505 HABERSHAM ST, SAVANNAH, GA, 31405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.036648,
    "lng": -81.1030788
  },
  {
    "id": "16536",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "4470 CHOUTEAU AVE, ST LOUIS, MO, 63110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6302312,
    "lng": -90.2604288
  },
  {
    "id": "16535",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "68 LONG ST, EAST ORANGE, NJ, 7017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7845611,
    "lng": -74.2191477
  },
  {
    "id": "16534",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "100 TITICUS RD, NORTH SALEM, NY, 10560",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3283097,
    "lng": -73.6556215
  },
  {
    "id": "16533",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1968 HAWKS LANE, BROOKHAVEN, GA, 30324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.827197,
    "lng": -84.3346487
  },
  {
    "id": "16532",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "3557 EAST COUNT HWY 30A, SANTA ROSA BEACH, FL, 32459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3141879,
    "lng": -86.1173468
  },
  {
    "id": "16531",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "334 S WATER ST, PROVIDENCE, RI, 2903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8207935,
    "lng": -71.404162
  },
  {
    "id": "16530",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "225 ELM STREET, OLD SAYBROOK, CT, 6475",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2988203,
    "lng": -72.3911839
  },
  {
    "id": "16529",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "307 SW 4TH AVE, GAINESVILLE, FL, 32601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6479983,
    "lng": -82.3285493
  },
  {
    "id": "16528",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "7061-7011 NW 87TH AVE, MIAMI, FL, 33178",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8376316,
    "lng": -80.3378057
  },
  {
    "id": "16527",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1308 HANOVER ST, CHATTANOOGA, TN, 37405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0678899,
    "lng": -85.2888776
  },
  {
    "id": "16526",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1421 ORCHARD LAKE DR, CHARLOTTE, NC, 28270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1417741,
    "lng": -80.7423584
  },
  {
    "id": "16525",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "570 FISCHER BLVD, TOMS RIVER, NJ, 8753",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.955189,
    "lng": -74.1244089
  },
  {
    "id": "16524",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "100 CHURCH ST, NEW YORK, NY, 10007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7130756,
    "lng": -74.0096116
  },
  {
    "id": "16523",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "64 DOUBLE HILL ROAD, BETHLEHEM, CT, 6751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6506532,
    "lng": -73.2255294
  },
  {
    "id": "16522",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "W 4745 BLUMER ROAD, MONROE, WI, 53566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5611516,
    "lng": -89.5943016
  },
  {
    "id": "16521",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "271 GREAT RD, STOW, MA, 1775",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4355117,
    "lng": -71.4967444
  },
  {
    "id": "16520",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "100 HANOVER ST, BOSTON, MA, 2108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3617273,
    "lng": -71.0563696
  },
  {
    "id": "16519",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "3200 CHICAGO AVE S, MINNEAPOLIS, MN, 55407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9445972,
    "lng": -93.262891
  },
  {
    "id": "16518",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "28 S 9TH STREET, COLUMBIA, MO, 65201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9506498,
    "lng": -92.3273141
  },
  {
    "id": "16517",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1000 BROAD STREET, LYNDONVILLE, VT, 5851",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.533477,
    "lng": -72.0025914
  },
  {
    "id": "16516",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "2000 SOUTH BLVD #300, CHARLOTTE, NC, 28203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2090555,
    "lng": -80.8609786
  },
  {
    "id": "16515",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "4075 PACES FERRY RD NW, ATLANTA, GA, 30327",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8585729,
    "lng": -84.4534491
  },
  {
    "id": "16514",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "PICK UP AT IOWA CITY, IOWA CITY, IA, 52240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.659109,
    "lng": -91.5349478
  },
  {
    "id": "16513",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "232 TROOPER LESLIE, COLEBROOK, NH, 3576",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9011972,
    "lng": -71.4933004
  },
  {
    "id": "16512",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "316 NORTH BROADWAY, WIND GAP, PA, 18091",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8530509,
    "lng": -75.2935518
  },
  {
    "id": "16511",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "2101 NW 33RD ST STE 900, POMPANO BEACH, FL, 33069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2715953,
    "lng": -80.1526189
  },
  {
    "id": "16510",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "371 MERRIMON AVE, ASHEVILLE, NC, 28801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6117024,
    "lng": -82.554829
  },
  {
    "id": "16509",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "952 BETHANY TURNPIKE, HONESDALE, PA, 18436",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.647182,
    "lng": -75.303705
  },
  {
    "id": "16508",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1601 NORTH ST, BEAUFORT, SC, 29902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4340123,
    "lng": -80.6798738
  },
  {
    "id": "16507",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "10073 MANCHESTER RD, WARSON WOODS, MO, 63122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6032546,
    "lng": -90.3877112
  },
  {
    "id": "16506",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "243 N. SYCAMORE ST, NEWTOWN, PA, 18940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2348866,
    "lng": -74.9372947
  },
  {
    "id": "16505",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "186 S WEST STREET, CROWN POINT, IN, 46307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4157686,
    "lng": -87.3664752
  },
  {
    "id": "16504",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1614 MAIN ST, COLUMBIA, SC, 29021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0072054,
    "lng": -81.0356638
  },
  {
    "id": "16503",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "724 S COLORADO AVE, STUART, FL, 34994",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.1929653,
    "lng": -80.2533678
  },
  {
    "id": "16502",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1037 AQUIDNECK AVE, MIDDLETOWN, RI, 2842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.516624,
    "lng": -71.2821776
  },
  {
    "id": "16501",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "2403 3RD STREET SUITE A, JACKSONVILLE BEAC, FL, 32250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2678721,
    "lng": -81.3879664
  },
  {
    "id": "16500",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "6017A HIGHWAY 100, NASHVILLE, TN, 37205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0982163,
    "lng": -86.8718764
  },
  {
    "id": "16499",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "6017A  HIGHWAY 100, NASHVILLE, TN, 37205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0982163,
    "lng": -86.8718764
  },
  {
    "id": "16498",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "637 FLORIDA AVE, WASHINGTON, DC, 20001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9161844,
    "lng": -77.0212834
  },
  {
    "id": "16497",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "8 HIGHLAND ROAD, NORTH TRURO, MA, 2652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.034831,
    "lng": -70.0838061
  },
  {
    "id": "16496",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1501 N ALBANY AVE, ATLANTIC CITY, NJ, 8401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3706559,
    "lng": -74.4765125
  },
  {
    "id": "16495",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "150 DORSET ST STE 304, SOUTH BURLINGTON, VT, 5403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4119436,
    "lng": -73.2139332
  },
  {
    "id": "16494",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "5335 LIMESTONE RD, WILMINGTON, DE, 19808",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7468607,
    "lng": -75.6988539
  },
  {
    "id": "16493",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "901 N 12TH AVE, PENSACOLA, FL, 32501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4249061,
    "lng": -87.2032469
  },
  {
    "id": "16492",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "6215 S WESTERN AVE, SIOUX FALLS, SD, 57108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4882156,
    "lng": -96.7480375
  },
  {
    "id": "16491",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "7 GREEN STREET, VERGENNES, VT, 5491",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1676524,
    "lng": -73.2513755
  },
  {
    "id": "16490",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "8485 NW 54TH STREET, DORAL, FL, 33166",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.823056,
    "lng": -80.335628
  },
  {
    "id": "16489",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "75 WEST HURON STREET, BUFFALO, NY, 14202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.889239,
    "lng": -78.876174
  },
  {
    "id": "16488",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "3608 E 1ST ST, BLUE RIDGE, GA, 30513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8692553,
    "lng": -84.3192374
  },
  {
    "id": "16487",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "31826 GOOD EARTH LANE, OCEAN VIEW, DE, 19970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5496437,
    "lng": -75.138022
  },
  {
    "id": "16486",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "135 N KEDZIE, CHICAGO, IL, 60608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.883888,
    "lng": -87.705833
  },
  {
    "id": "16485",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1432 W 29TH ST, CLEVELAND, OH, 44113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4894136,
    "lng": -81.7109332
  },
  {
    "id": "16484",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "603 N 3RD, MARQUETTE, MI, 49855",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.548337,
    "lng": -87.3949
  },
  {
    "id": "16483",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "106 S MAIN STREET, MOUNT AIRY, MD, 21771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3766153,
    "lng": -77.1548282
  },
  {
    "id": "16482",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "210 KINGS HWY E, HADDONFIELD, NJ, 8033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8977465,
    "lng": -75.0315714
  },
  {
    "id": "16481",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "RT 9, VALENTINE HALL, AMHERST, MA, 1002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3728999,
    "lng": -72.5156544
  },
  {
    "id": "16480",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "712 SERENOA ROAD, SANTA ROSA BEACH, FL, 32459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3488704,
    "lng": -86.0677288
  },
  {
    "id": "16479",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "7 GURNEY STREET UNIT 4, CAPE MAY, NJ, 8204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9309291,
    "lng": -74.918206
  },
  {
    "id": "16478",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "12 CAVILEAR DR, AMBLER, PA, 19002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1539382,
    "lng": -75.2220622
  },
  {
    "id": "16477",
    "name": "FOODSERVICE ACCOUNTS",
    "address": "1259 INDIAN CREEK, MINERAL, VA, 23117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8982444,
    "lng": -77.9326614
  },
  {
    "id": "16476",
    "name": "FOODLAND/S&S",
    "address": "2555 ALA NAMAHANA PKWY, HANALEI, KAUAI, HI, 96714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 22.2121587,
    "lng": -159.4086321
  },
  {
    "id": "16475",
    "name": "FOODLAND/S&S",
    "address": "345 KEAWE ST., LAHAINA, MAUI, HI, 96761",
    "phone": "",
    "hours": "Call for hours",
    "lat": 20.8853597,
    "lng": -156.680025
  },
  {
    "id": "16474",
    "name": "FOOD SERVICE",
    "address": "420 E 20TH, HOUSTON, TX, 77008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8036936,
    "lng": -95.3936688
  },
  {
    "id": "16473",
    "name": "FOOD SERVICE",
    "address": "760 S MAIN ST, LOS ANGELES, CA, 90014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0427132,
    "lng": -118.2529025
  },
  {
    "id": "16472",
    "name": "FOOD SERVICE",
    "address": "1611 RALEIGH ST, DENVER, CO, 80204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7430045,
    "lng": -105.0419134
  },
  {
    "id": "16471",
    "name": "FOOD SERVICE",
    "address": "3605 WALNUT ST, DENVER, CO, 80205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7689782,
    "lng": -104.9739603
  },
  {
    "id": "16470",
    "name": "FOOD SERVICE",
    "address": "1420 PEARL ST, BOULDER, CO, 80302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0182044,
    "lng": -105.2766922
  },
  {
    "id": "16469",
    "name": "FOOD SERVICE",
    "address": "1735 CHESTNUT PL, DENVER, CO, 80202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.755454,
    "lng": -105.0018839
  },
  {
    "id": "16468",
    "name": "FOOD SERVICE",
    "address": "1810 29TH ST #1087, BOULDER, CO, 80301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0185523,
    "lng": -105.2554575
  },
  {
    "id": "16467",
    "name": "FOOD SERVICE",
    "address": "20601 WEST PAOLI LANE, WEIMAR, CA, 95736",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0408653,
    "lng": -120.9777126
  },
  {
    "id": "16466",
    "name": "FOOD SERVICE",
    "address": "135 A LOPEZ RD, LOPEZ, WA, 98261",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.5227063,
    "lng": -122.9132406
  },
  {
    "id": "16465",
    "name": "FOOD SERVICE",
    "address": "3915 TENNYSON ST, DENVER, CO, 80211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7714113,
    "lng": -105.0443032
  },
  {
    "id": "16464",
    "name": "FOOD SERVICE",
    "address": "1000 BRISTOL ST N STE 28, NEWPORT BEACH, CA, 92660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6578047,
    "lng": -117.8669027
  },
  {
    "id": "16463",
    "name": "FOOD SERVICE",
    "address": "841 SUTTON WAY, GRASS VALLEY, CA, 95945",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2347908,
    "lng": -121.0334876
  },
  {
    "id": "16462",
    "name": "FOOD SERVICE",
    "address": "10201 WEST PICO BLVD BLDG 57, LOS ANGELES, CA, 90035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0519248,
    "lng": -118.4126591
  },
  {
    "id": "16461",
    "name": "FOOD SERVICE",
    "address": "689 MAIN ST, CARBONDALE, CO, 81623",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4008562,
    "lng": -107.2138637
  },
  {
    "id": "16460",
    "name": "FOOD SERVICE",
    "address": "771 EUBANKS DRIVE, VACAVILLE, CA, 95688",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4001398,
    "lng": -121.9585093
  },
  {
    "id": "16459",
    "name": "FOOD SERVICE",
    "address": "162 COFFEE POT DR #162-C, SEDONA, AZ, 86336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8660033,
    "lng": -111.7943676
  },
  {
    "id": "16458",
    "name": "FOOD SERVICE",
    "address": "32954 RD. 222, NORTH FORK, CA, 93643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2264567,
    "lng": -119.5100684
  },
  {
    "id": "16457",
    "name": "FOOD SERVICE",
    "address": "100 W COLORADO AVE, TELLURIDE, CO, 81435",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9370668,
    "lng": -107.8112313
  },
  {
    "id": "16456",
    "name": "FOOD SERVICE",
    "address": "2923 LAKE FOREST ROAD, TAHOE CITY, CA, 96145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1858166,
    "lng": -120.1109054
  },
  {
    "id": "16455",
    "name": "FOOD SERVICE",
    "address": "36 STUMER RD STE 123, RAPID CITY, SD, 57701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0334139,
    "lng": -103.2148641
  },
  {
    "id": "16454",
    "name": "FOOD SERVICE",
    "address": "119 S SPRING ST, ASPEN, CO, 81611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1893375,
    "lng": -106.8161324
  },
  {
    "id": "16453",
    "name": "FOOD SERVICE",
    "address": "102 SE 28TH STREET, BENTONVILLE, AR, 72758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3423587,
    "lng": -94.209511
  },
  {
    "id": "16452",
    "name": "FOOD SERVICE",
    "address": "4580 HELLABACKBONE RD, BOULDER, UT, 84716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.923182,
    "lng": -111.5183426
  },
  {
    "id": "16451",
    "name": "FOOD SERVICE",
    "address": "16708 PICADILLY CT SUITE 100, ROUND ROCK, TX, 78664",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4666195,
    "lng": -97.6579476
  },
  {
    "id": "16450",
    "name": "FOOD SERVICE",
    "address": "521 SW 6TH ST, REDMOND, OR, 97756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.2722779,
    "lng": -121.1745485
  },
  {
    "id": "16449",
    "name": "FOOD SERVICE",
    "address": "10 FRONT ST SUITE 103, FRIDAY HARBOR, WA, 98250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.5357545,
    "lng": -123.0154204
  },
  {
    "id": "16448",
    "name": "FOOD SERVICE",
    "address": "1 EASTGATE ROAD, GARDINER, MT, 59030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.1126316,
    "lng": -110.7914887
  },
  {
    "id": "16447",
    "name": "FOOD SERVICE",
    "address": "40 DEPOT ST, DRIGGS, ID, 83422",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.7240772,
    "lng": -111.111862
  },
  {
    "id": "16446",
    "name": "FOOD SERVICE",
    "address": "2 CHAMBERS LANE, CARMEL, CA, 93924",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.478792,
    "lng": -121.731858
  },
  {
    "id": "16445",
    "name": "FOOD SERVICE",
    "address": "2180 POST ST, SAN FRANCISCO, CA, 94115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7847953,
    "lng": -122.4376599
  },
  {
    "id": "16444",
    "name": "FOOD SERVICE",
    "address": "5846 WORTH PRKY #109, SAN ANTONIO, TX, 78257",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6111816,
    "lng": -98.5993968
  },
  {
    "id": "16443",
    "name": "FOOD SERVICE",
    "address": "4528 MAGAZINE ST, NEW ORLEANS, LA, 70115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.920412,
    "lng": -90.1033937
  },
  {
    "id": "16442",
    "name": "FOOD SERVICE",
    "address": "303 E 3RD AVENUE, BOULDER, MT, 59632",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.2348847,
    "lng": -112.1162998
  },
  {
    "id": "16441",
    "name": "FOOD SERVICE",
    "address": "16252 CONSTRUCTION CIR STE D, IRVINE, CA, 92606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.694487,
    "lng": -117.8205801
  },
  {
    "id": "16440",
    "name": "FOOD SERVICE",
    "address": "36507 CALLES ST STE 100, AUSTIN, TX, 78702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2596126,
    "lng": -97.7120742
  },
  {
    "id": "16439",
    "name": "FOOD SERVICE",
    "address": "550 2ND ST, OAKLAND, CA, 94607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7972975,
    "lng": -122.2788407
  },
  {
    "id": "16438",
    "name": "FOOD SERVICE",
    "address": "3804 HASTINGS AVE W, PORT TOWNSEND, WA, 98368",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.1101733,
    "lng": -122.8605575
  },
  {
    "id": "16437",
    "name": "FOOD SERVICE",
    "address": "203 LEMON CREEK STE A, WALNUT, CA, 91789",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0114103,
    "lng": -117.8642879
  },
  {
    "id": "16436",
    "name": "FOOD SERVICE",
    "address": "502 LINCOLN STREET, LANDER, WY, 82520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8354895,
    "lng": -108.7351769
  },
  {
    "id": "16435",
    "name": "FOOD SERVICE",
    "address": "12085 SHENANDOAH RD, MIDDLETOWN, CA, 95461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8688356,
    "lng": -122.6839506
  },
  {
    "id": "16434",
    "name": "FOOD SERVICE",
    "address": "120 COUNTRY CLUB DRIVE #28, INCLINE VILLAGE, NV, 89451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2403845,
    "lng": -119.9403999
  },
  {
    "id": "16433",
    "name": "FOOD SERVICE",
    "address": "18275 HWY 108, JAMESTOWN, CA, 95327",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.954186,
    "lng": -120.424015
  },
  {
    "id": "16432",
    "name": "FOOD SERVICE",
    "address": "10825 PIONEER TR STE 100, TRUCKEE, CA, 96161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3354884,
    "lng": -120.1809847
  },
  {
    "id": "16431",
    "name": "FOOD SERVICE",
    "address": "1130 BURNETT AVE, CONCORD, CA, 94520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9776713,
    "lng": -122.0560009
  },
  {
    "id": "16430",
    "name": "FOOD SERVICE",
    "address": "15523 SW HWY 97, CULVER, OR, 97734",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4117691,
    "lng": -121.1976224
  },
  {
    "id": "16429",
    "name": "FOOD SERVICE",
    "address": "472 LANEDA, MANZANITA, OR, 97130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.7187513,
    "lng": -123.9335819
  },
  {
    "id": "16428",
    "name": "FOOD SERVICE",
    "address": "2424 DUNSTAN #100, HOUSTON, TX, 77005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7195555,
    "lng": -95.4163497
  },
  {
    "id": "16427",
    "name": "FOOD SERVICE",
    "address": "16641 LA CANTERA PKWY, SAN ANTONIO, TX, 78256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6028112,
    "lng": -98.6226126
  },
  {
    "id": "16426",
    "name": "FOOD SERVICE",
    "address": "1518 MONTANA AVE, SANTA MONICA, CA, 90403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0332569,
    "lng": -118.4935413
  },
  {
    "id": "16425",
    "name": "FOOD SERVICE",
    "address": "3333 W CAMP WISDOM RD ST118, DALLAS, TX, 75237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.663092,
    "lng": -96.8751401
  },
  {
    "id": "16424",
    "name": "FOOD SERVICE",
    "address": "TIN CITY/VILLAGE LANE, CAMBRIA, CA, 93428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5639264,
    "lng": -121.0800646
  },
  {
    "id": "16423",
    "name": "FOOD SERVICE",
    "address": "108 S DETROIT AVE, TULSA, OK, 74120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1560326,
    "lng": -95.9885887
  },
  {
    "id": "16422",
    "name": "FOOD SERVICE",
    "address": "209 SOUTH BROADWAY, RED LODGE, MT, 59068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.184481,
    "lng": -109.247383
  },
  {
    "id": "16421",
    "name": "FOOD SERVICE",
    "address": "2020 TUNNEL RD, REDWAY, CA, 95560",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1188758,
    "lng": -123.8001435
  },
  {
    "id": "16420",
    "name": "FOOD SERVICE",
    "address": "3708 EAGLE ROCK BLVD, LOS ANGELES, CA, 90065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1176538,
    "lng": -118.2333874
  },
  {
    "id": "16419",
    "name": "FOOD SERVICE",
    "address": "175 W PLATA ST, TUCSON, AZ, 85705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.244539,
    "lng": -110.9745539
  },
  {
    "id": "16418",
    "name": "FOOD SERVICE",
    "address": "3146 AKAHI ST, LIHUE KAUAI, HI, 96766",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.9783153,
    "lng": -159.3670686
  },
  {
    "id": "16417",
    "name": "FOOD SERVICE",
    "address": "13039 NE 70TH PL, KIRKLAND, WA, 98033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6670201,
    "lng": -122.1652281
  },
  {
    "id": "16416",
    "name": "FOOD SERVICE",
    "address": "2074 PENDLETON DR, RIO RICO, AZ, 85648",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5771737,
    "lng": -111.0376033
  },
  {
    "id": "16415",
    "name": "FOOD SERVICE",
    "address": "216 E STREET, EUREKA, CA, 95501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8039033,
    "lng": -124.1678954
  },
  {
    "id": "16414",
    "name": "FOOD SERVICE",
    "address": "350 N SEPULVEDA BLVD, MANHATTAN BEACH, CA, 90266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.881456,
    "lng": -118.3954522
  },
  {
    "id": "16413",
    "name": "FOOD SERVICE",
    "address": "1563 FILLMORE ST STE 1B, TWIN FALLS, ID, 83301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5892951,
    "lng": -114.4658252
  },
  {
    "id": "16412",
    "name": "FOOD SERVICE",
    "address": "3975 LANDMARK ST STE 300, CULVER CITY, CA, 90232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0263081,
    "lng": -118.3857915
  },
  {
    "id": "16411",
    "name": "FOOD SERVICE",
    "address": "810 WA-20, SEDRO WOOLLEY, WA, 98284",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.5109965,
    "lng": -122.2275585
  },
  {
    "id": "16410",
    "name": "FOOD SERVICE",
    "address": "34255 PACIFIC COAST HWY S105, DANA POINT, CA, 92629",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4658448,
    "lng": -117.691856
  },
  {
    "id": "16409",
    "name": "FOOD SERVICE",
    "address": "CALL TO MEET IN EASTSOUND, OLGA, WA, 98279",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.6955179,
    "lng": -122.9065274
  },
  {
    "id": "16408",
    "name": "FOOD SERVICE",
    "address": "13655 BRONCO PARKWAY, ENGLEWOOD, CO, 80112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5791257,
    "lng": -104.8300487
  },
  {
    "id": "16407",
    "name": "FOOD SERVICE",
    "address": "203 S SCHOOL ST, LODI, CA, 95240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1313474,
    "lng": -121.2741786
  },
  {
    "id": "16406",
    "name": "FOOD SERVICE",
    "address": "552 EAST 25TH STREET, OGDEN, UT, 84401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2207665,
    "lng": -111.9657614
  },
  {
    "id": "16405",
    "name": "FOOD SERVICE",
    "address": "135 W DELONEY AVE, JACKSON, WY, 83001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4804183,
    "lng": -110.764127
  },
  {
    "id": "16404",
    "name": "FOOD SERVICE",
    "address": "1021 MAIN AVE, DURANGO, CO, 81301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.274906,
    "lng": -107.8806715
  },
  {
    "id": "16403",
    "name": "FOOD SERVICE",
    "address": "2337 EAST CESAR CHAVEZ, AUSTIN, TX, 78702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2545306,
    "lng": -97.7179302
  },
  {
    "id": "16402",
    "name": "FOOD SERVICE",
    "address": "2531-C VILLAGE LANE, CAMBRIA, CA, 93428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5634717,
    "lng": -121.0790925
  },
  {
    "id": "16401",
    "name": "FOOD SERVICE",
    "address": "10336 LOCH LOMOND RD, MIDDLETOWN, CA, 95461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.863707,
    "lng": -122.7181816
  },
  {
    "id": "16400",
    "name": "FOOD SERVICE",
    "address": "1436 SKYWAY DR, LONGMONT, CO, 80504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1574201,
    "lng": -105.0331853
  },
  {
    "id": "16399",
    "name": "FOOD SERVICE",
    "address": "212 N MAIN ST, TULSA, OK, 74103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1585971,
    "lng": -95.9941063
  },
  {
    "id": "16398",
    "name": "FOOD SERVICE",
    "address": "385 E SWINFORD AVE, SAN PEDRO, CA, 90731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7496684,
    "lng": -118.2787267
  },
  {
    "id": "16397",
    "name": "FOOD SERVICE",
    "address": "509 HIGHWAY 567, CARSON, NM, 87517",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.364917,
    "lng": -105.8080007
  },
  {
    "id": "16396",
    "name": "FOOD SERVICE",
    "address": "1360 G ST, ARCATA, CA, 95521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8723874,
    "lng": -124.0841994
  },
  {
    "id": "16395",
    "name": "FOOD SERVICE",
    "address": "1791 S 8TH ST #H, COLORADO SPRINGS, CO, 80905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8038842,
    "lng": -104.8400064
  },
  {
    "id": "16394",
    "name": "FOOD SERVICE",
    "address": "PO BOX 2012, HOTCHKISS, CO, 81419",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.799707,
    "lng": -107.7195032
  },
  {
    "id": "16393",
    "name": "FOOD SERVICE",
    "address": "3110 WINDSOR ROAD, AUSTIN, TX, 78703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2966658,
    "lng": -97.7676046
  },
  {
    "id": "16392",
    "name": "FOOD SERVICE",
    "address": "13308 E WHITTIER BLVD, WHITTIER, CA, 90602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9633074,
    "lng": -118.0334978
  },
  {
    "id": "16391",
    "name": "FOOD SERVICE",
    "address": "8701 S HARDY, TEMPE, AZ, 85284",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3354715,
    "lng": -111.9532738
  },
  {
    "id": "16390",
    "name": "FOOD SERVICE",
    "address": "*** WILL CALL PICK UP ***, AURORA, CO, 80011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7290042,
    "lng": -104.8310102
  },
  {
    "id": "16389",
    "name": "FOOD SERVICE",
    "address": "9543 CULVER BLVD, CULVER CITY, CA, 90232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0230091,
    "lng": -118.3955206
  },
  {
    "id": "16388",
    "name": "FOOD SERVICE",
    "address": "25 TOWN CENTER, BIG SKY, MT, 59716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.2604551,
    "lng": -111.3079565
  },
  {
    "id": "16387",
    "name": "FOOD SERVICE",
    "address": "364 MCCARTHY LOOP, HAMILTON, MT, 59840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.178851,
    "lng": -114.162135
  },
  {
    "id": "16386",
    "name": "FOOD BAZAAR",
    "address": "480 VAN BRUNT ST, BROOKLYN, NY, 11231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6740803,
    "lng": -74.0171543
  },
  {
    "id": "16385",
    "name": "FOOD BAZAAR",
    "address": "242-02 61ST AVE, DOUGLASTON, NY, 11362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7545072,
    "lng": -73.738408
  },
  {
    "id": "16384",
    "name": "FOOD BAZAAR",
    "address": "1258 CORPORATE DR, WESTBURY, NY, 11590",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.739944,
    "lng": -73.5895049
  },
  {
    "id": "16383",
    "name": "FISHER'S FOODS",
    "address": "5215 FULTON ROAD NW, CANTON, OH, 44718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8513496,
    "lng": -81.4458397
  },
  {
    "id": "16382",
    "name": "FESTIVAL FOODS",
    "address": "1405 ONEIDA ST, MENASHA, WI, 54952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.249152,
    "lng": -88.404886
  },
  {
    "id": "16381",
    "name": "FESTIVAL FOODS",
    "address": "1001 MAIN AVENUE, DePERE, WI, 54115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4501412,
    "lng": -88.0871756
  },
  {
    "id": "16380",
    "name": "FAIRHOPE NATURAL",
    "address": "3055 A DAUPHIN ST, MOBILE, AL, 36606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6884919,
    "lng": -88.1164334
  },
  {
    "id": "16379",
    "name": "EXPORTERS",
    "address": "4002 GALVIN ROAD, CENTRALIA, WA, 98531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.7355617,
    "lng": -123.0120298
  },
  {
    "id": "16378",
    "name": "ELM CITY COMMUNITY MKT",
    "address": "777 CHAPEL ST, NEW HAVEN, CT, 6510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3053699,
    "lng": -72.9235268
  },
  {
    "id": "16377",
    "name": "ELLIOTTS NATURAL FOODS",
    "address": "641 E BIDWELL STREET, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6716374,
    "lng": -121.163231
  },
  {
    "id": "16376",
    "name": "EL RANCHO/ CALI FRESH",
    "address": "771 FOOTHILL BLVD, SAN LUIS OBISPO, CA, 93405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2931029,
    "lng": -120.6729785
  },
  {
    "id": "16375",
    "name": "EL RANCHO/ CALI FRESH",
    "address": "555 FIVE CITIES DR, PISMO BEACH, CA, 93444",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1348681,
    "lng": -120.6256861
  },
  {
    "id": "16374",
    "name": "ECRS EDI GENERIC",
    "address": "169 WINSLOW WAY E., BAINBRIDGE ISLAND, WA, 98110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.624511,
    "lng": -122.5202214
  },
  {
    "id": "16373",
    "name": "EAT N'PARK",
    "address": "8000 CRANBERRY DRIVE, CRANBERRY, PA, 16066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6899603,
    "lng": -80.1055488
  },
  {
    "id": "16372",
    "name": "EAT N'PARK",
    "address": "1700 MOORE ST, HUNTINGDON, PA, 16652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5005139,
    "lng": -78.0173291
  },
  {
    "id": "16371",
    "name": "EAT N'PARK",
    "address": "501 EAST 38TH ST, ERIE, PA, 16546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1050088,
    "lng": -80.0537349
  },
  {
    "id": "16370",
    "name": "EARTH FARE MANAGEMENT INC",
    "address": "1101 N MAIN ST, SUMMERVILLE, SC, 29483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.031895,
    "lng": -80.1628055
  },
  {
    "id": "16369",
    "name": "EARTH FARE MANAGEMENT INC",
    "address": "8885 CHRISTENBURY PRKWY, CONCORD, NC, 28027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.374554,
    "lng": -80.7341743
  },
  {
    "id": "16368",
    "name": "DRAEGERS",
    "address": "222 E. 4TH AVE, SAN MATEO, CA, 94401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5642876,
    "lng": -122.3214694
  },
  {
    "id": "16367",
    "name": "DOWN TO EARTH HAWAII",
    "address": "98-211 PALI MOMI ST, AIEA, OAHU, HI, 96701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.3823124,
    "lng": -157.9375986
  },
  {
    "id": "16366",
    "name": "DOWN TO EARTH HAWAII",
    "address": "2525 SOUTH KING STREET, HONOLULU, OAHU, HI, 96826",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.2921746,
    "lng": -157.823213
  },
  {
    "id": "16365",
    "name": "DISTRIBUTER",
    "address": "6100 SHEILA ST, COMMERCE, CA, 90040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9947677,
    "lng": -118.1498455
  },
  {
    "id": "16364",
    "name": "DETWILER'S FARM MARKET",
    "address": "6100 N LOCKWOOD RIDGE RD, SARASOTA, FL, 34243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3865838,
    "lng": -82.5042071
  },
  {
    "id": "16363",
    "name": "DETWILER'S FARM MARKET",
    "address": "1800 US 301, PALMETTO, FL, 34211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.5228858,
    "lng": -82.5470518
  },
  {
    "id": "16362",
    "name": "DETWILER'S FARM MARKET",
    "address": "2881 CLARK RD, SARASOTA, FL, 34231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2697758,
    "lng": -82.5128546
  },
  {
    "id": "16361",
    "name": "DEANS NATURAL FOOD MARKET",
    "address": "490 BROAD ST, SHREWSBURY, NJ, 7702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3350573,
    "lng": -74.0637012
  },
  {
    "id": "16360",
    "name": "DAVES-LUCKY MARKET SN",
    "address": "7596 FREDLE DR, PAINESVILLE, OH, 44077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6642217,
    "lng": -81.2412163
  },
  {
    "id": "16359",
    "name": "DAVES-LUCKY MARKET",
    "address": "11620 CLIFTON BLVD, CLEVELAND, OH, 44102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4876632,
    "lng": -81.76785
  },
  {
    "id": "16358",
    "name": "DAVES-LUCKY MARKET",
    "address": "2770 NORTH HIGHT ST, COLUMBUS, OH, 43202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0189102,
    "lng": -83.0114968
  },
  {
    "id": "16357",
    "name": "DAVES-LUCKY MARKET",
    "address": "7596 FREDLE DRIVE, PAINESVILLE, OH, 44077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6642217,
    "lng": -81.2412163
  },
  {
    "id": "16356",
    "name": "DASH'S MARKET",
    "address": "1770 HERTEL AVENUE, BUFFALO, NY, 14216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9478804,
    "lng": -78.8427555
  },
  {
    "id": "16355",
    "name": "DAN & BECKY'S",
    "address": "5636 OLIVER AVE SW, COKATO, MN, 55321",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0704212,
    "lng": -94.1730434
  },
  {
    "id": "16354",
    "name": "CUPBOARD NATURAL FOODS",
    "address": "1909 TEXOMA PKWY SUITE 2, SHERMAN, TX, 75090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6568552,
    "lng": -96.6018658
  },
  {
    "id": "16353",
    "name": "CRONIG'S MARTHA'S VINEYAR",
    "address": "31 COLONIAL DRIVE, VINEYARD HAVEN, MA, 2568",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4479695,
    "lng": -70.6163117
  },
  {
    "id": "16352",
    "name": "CRONIG'S MARTHA'S VINEYAR",
    "address": "PO BOX 698, VINEYARD HAVEN, MA, 2568",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4542786,
    "lng": -70.6036395
  },
  {
    "id": "16351",
    "name": "COX FARMS MARKET",
    "address": "778 FORT WORTH AVE, DALLAS, TX, 75208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7700349,
    "lng": -96.8352307
  },
  {
    "id": "16350",
    "name": "COUNTRY VILLAGE NUTRITION",
    "address": "1052 WASHINGTON WAY, LONGVIEW, WA, 98632",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.1432027,
    "lng": -122.9307375
  },
  {
    "id": "16349",
    "name": "COOPER RIIS",
    "address": "101 HEALING FARM LANE, MILL SPRING, NC, 28756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3035288,
    "lng": -82.1558526
  },
  {
    "id": "16348",
    "name": "COOP GROC ASSC W SN ACCT",
    "address": "8770 WASHINGTION BLVD, CULVER CITY, CA, 90232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0282885,
    "lng": -118.3857678
  },
  {
    "id": "16347",
    "name": "COOP GROC ASSC NE SN ACCT",
    "address": "8426 GERMANTOWN AVE, PHILADELPHIA, PA, 19119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0754591,
    "lng": -75.2057821
  },
  {
    "id": "16346",
    "name": "COOP GROC ASSC NE SN ACCT",
    "address": "34 CYPRESS STREET, KEENE, NH, 3431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9319764,
    "lng": -72.2763026
  },
  {
    "id": "16345",
    "name": "COOP GROC ASSC NE SN ACCT",
    "address": "13 BROAD ST, NEW LONDON, CT, 6320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.355894,
    "lng": -72.099779
  },
  {
    "id": "16344",
    "name": "COOP GROC ASSC MW SN ACCT",
    "address": "814 MAIN ST EAST, MENOMONIE, WI, 54751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8761798,
    "lng": -91.9199239
  },
  {
    "id": "16343",
    "name": "COOP GROC ASSC MW SN ACCT",
    "address": "700 MAIN ST W, ASHLAND, WI, 54806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.5878852,
    "lng": -90.8907571
  },
  {
    "id": "16342",
    "name": "COMMODITIES",
    "address": "512 MOUNTAIN RD, STOWE, VT, 5672",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4728434,
    "lng": -72.6890398
  },
  {
    "id": "16341",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "5329 OLEANDER DRIVE, WILMINGTON, NC, 28403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2090913,
    "lng": -77.8608021
  },
  {
    "id": "16340",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "467 MORELAND AVENUE, ATLANTA, GA, 30307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7670353,
    "lng": -84.3485359
  },
  {
    "id": "16339",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "323 MAIN STREET, DAMARISCOTTA, ME, 4543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0311453,
    "lng": -69.5240686
  },
  {
    "id": "16338",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "230 E MAIN ST, NEWARK, DE, 19711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6851407,
    "lng": -75.743327
  },
  {
    "id": "16337",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "700 CASCADILLA ST, ITHACA, NY, 14850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4444951,
    "lng": -76.5090338
  },
  {
    "id": "16336",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "770 CASCADILLA ST, ITHACA, NY, 14850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4454433,
    "lng": -76.5097113
  },
  {
    "id": "16335",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "90 BILTMORE AVE, ASHEVILLE, NC, 28801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5917175,
    "lng": -82.5504764
  },
  {
    "id": "16334",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "320 JEFFERSON DAVIS HWY, FREDERICKSBURG, VA, 22401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3170093,
    "lng": -77.472167
  },
  {
    "id": "16333",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "1235 APALACHEE PARKWAY, TALLAHASSEE, FL, 32301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4361715,
    "lng": -84.2626952
  },
  {
    "id": "16332",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "927 W 7TH ST, FREDERICK, MD, 21701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4274689,
    "lng": -77.4152406
  },
  {
    "id": "16331",
    "name": "CO-OP GROC. ASSOC. OF N.E",
    "address": "5728 BUCKEYSTOWN PIKE, FREDERICK, MD, 21704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3928638,
    "lng": -77.4121916
  },
  {
    "id": "16330",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "610 EAST 4TH STREET, DULUTH, MN, 55805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.7955713,
    "lng": -92.094083
  },
  {
    "id": "16329",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "413 NORTHWESTERN, AMES, IA, 50010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0251983,
    "lng": -93.6215032
  },
  {
    "id": "16328",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "812 W MADISON STREET, OAK PARK, IL, 60302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8798619,
    "lng": -87.7954195
  },
  {
    "id": "16327",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "228 W MULBERRY, ST PETER, MN, 56082",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3226252,
    "lng": -93.9599039
  },
  {
    "id": "16326",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "1477 W SYLVANIA AVE, TOLEDO, OH, 43612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6921423,
    "lng": -83.578474
  },
  {
    "id": "16325",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "1447 W SYLVANIA AVE, TOLEDO, OH, 43612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6921958,
    "lng": -83.5773507
  },
  {
    "id": "16324",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "622 SELBY AVE, ST PAUL, MN, 55014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9463219,
    "lng": -93.1266099
  },
  {
    "id": "16323",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "1500 WEST 7TH, ST PAUL, MN, 55116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9183988,
    "lng": -93.1400905
  },
  {
    "id": "16322",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "740 EAST 7TH STREET, ST PAUL, MN, 55106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9595661,
    "lng": -93.0703657
  },
  {
    "id": "16321",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "502 WEST WASHINGTON, MARQUETTE, MI, 49855",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.545034,
    "lng": -87.402735
  },
  {
    "id": "16320",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "3815 SUNNYSIDE AVE, MINNEAPOLIS, MN, 55410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9219679,
    "lng": -93.3285822
  },
  {
    "id": "16319",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "17501 MINNETONKA BLVD., MINNETONKA, MN, 55345",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9411747,
    "lng": -93.5007402
  },
  {
    "id": "16318",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "435 POND PROMENADE, CHANHASSEN, MN, 55317",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8572298,
    "lng": -93.5317036
  },
  {
    "id": "16317",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "6420 LYNDALE AVE SOUTH, RICHFIELD, MN, 55423",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8865159,
    "lng": -93.2884669
  },
  {
    "id": "16316",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "6420  LYNDALE AVE SOUTH, RICHFIELD, MN, 55423",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8865159,
    "lng": -93.2884669
  },
  {
    "id": "16315",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "2380 W. WAYZATA BLVD, LONG LAKE, MN, 55356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9898486,
    "lng": -93.5834027
  },
  {
    "id": "16314",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "455D SOUTHLAND DRIVE, LEXINGTON, KY, 40503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0197136,
    "lng": -84.5268882
  },
  {
    "id": "16313",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "2551 CENTRAL AVE NE, MINNEAPOLIS, MN, 55418",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0148163,
    "lng": -93.2468128
  },
  {
    "id": "16312",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "2746 N MILWAUKEE AVE, CHICAGO, IL, 60647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9309316,
    "lng": -87.7110269
  },
  {
    "id": "16311",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "20 E 1ST STREET, GRAND MARAIS, MN, 55604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.750409,
    "lng": -90.3321641
  },
  {
    "id": "16310",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "901 IOWA STREET, LAWRENCE, KS, 66044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9675621,
    "lng": -95.2612618
  },
  {
    "id": "16309",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "746 VANDALIA STREET, ST PAUL, MN, 55114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9639315,
    "lng": -93.1879493
  },
  {
    "id": "16308",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "410 W 18TH STREET, SIOUX FALLS, SD, 57104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.5370937,
    "lng": -96.7323094
  },
  {
    "id": "16307",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "122 N BUCHANAN ST., CAMBRIDGE, MN, 55008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5741509,
    "lng": -93.2207052
  },
  {
    "id": "16306",
    "name": "CO-OP GROC. ASSOC. OF M.W",
    "address": "3220 E THIRD, BLOOMINGTON, IN, 47401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1638651,
    "lng": -86.4910469
  },
  {
    "id": "16305",
    "name": "CO-OP EDI CHAIN",
    "address": "515 NW 23RD AVENUE, GAINESVILLE, FL, 32609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6735304,
    "lng": -82.3298468
  },
  {
    "id": "16304",
    "name": "CO-OP EDI CHAIN",
    "address": "318 BUSH ST, RED WING, MN, 55066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5646909,
    "lng": -92.533554
  },
  {
    "id": "16303",
    "name": "CO-OP EDI CHAIN",
    "address": "77 WALES STREET, RUTLAND, VT, 5701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6059363,
    "lng": -72.9777102
  },
  {
    "id": "16302",
    "name": "CO-OP EDI CHAIN",
    "address": "157 ROWAYTON AVENUE, ROWAYTON, CT, 6853",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0683306,
    "lng": -73.4437727
  },
  {
    "id": "16301",
    "name": "CO-OP EDI CHAIN",
    "address": "123 N HILL STREET, SOUTH BEND, IN, 46617",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6772226,
    "lng": -86.2431195
  },
  {
    "id": "16300",
    "name": "CO-OP EDI CHAIN",
    "address": "111 S BROAD ST, ROME, GA, 30161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2507772,
    "lng": -85.1771254
  },
  {
    "id": "16299",
    "name": "CO-OP EDI CHAIN",
    "address": "21 MAIN STREET, CANTON, NY, 13617",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5957046,
    "lng": -75.1718198
  },
  {
    "id": "16298",
    "name": "CO-OP EDI CHAIN",
    "address": "5 DIAGONAL STREET, WARRENTON, VA, 20186",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7142258,
    "lng": -77.7968986
  },
  {
    "id": "16297",
    "name": "CO-OP EDI CHAIN",
    "address": "101 S BROADWAY, LAKE ORION, MI, 48362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7837311,
    "lng": -83.2394336
  },
  {
    "id": "16296",
    "name": "CO-OP EDI CHAIN",
    "address": "14715 EDGEWOOD DRIVE, BAXTER, MN, 56401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.3653648,
    "lng": -94.2452922
  },
  {
    "id": "16295",
    "name": "CO-OP EDI CHAIN",
    "address": "451 UNIVERSITY BLVD, HARRISONBURG, VA, 22801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4294139,
    "lng": -78.8544324
  },
  {
    "id": "16294",
    "name": "CO-OP EDI CHAIN",
    "address": "7150 HAMILTON BLVD., TREXLERTOWN, PA, 18087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5474818,
    "lng": -75.5972899
  },
  {
    "id": "16293",
    "name": "CO-OP EDI CHAIN",
    "address": "9138 CARL LEGETT RD STE A, GULFPORT, MS, 39503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4145819,
    "lng": -89.0305154
  },
  {
    "id": "16292",
    "name": "CO-OP EDI CHAIN",
    "address": "4617 ST. HWY 29 S, ALEXANDRIA, MN, 56308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.8484157,
    "lng": -95.3859714
  },
  {
    "id": "16291",
    "name": "CO-OP EDI CHAIN",
    "address": "495 COMMERCIAL ST, ROCKPORT, ME, 4856",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1682683,
    "lng": -69.0823053
  },
  {
    "id": "16290",
    "name": "CO-OP EDI CHAIN",
    "address": "1701 WARD AVE SUITE 200, HUDSON, WI, 54016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9646611,
    "lng": -92.7346695
  },
  {
    "id": "16289",
    "name": "CO-OP EDI CHAIN",
    "address": "64-14 108 STREET, FOREST HILLS, NY, 11375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7325323,
    "lng": -73.8499006
  },
  {
    "id": "16288",
    "name": "CO-OP EDI CHAIN",
    "address": "933 N WOODLAND BLVD, DELAND, FL, 32720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.0439242,
    "lng": -81.3027182
  },
  {
    "id": "16287",
    "name": "CLARKS NUTRITION CENTER",
    "address": "4225 MARKET ST, RIVERSIDE, CA, 92501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9784428,
    "lng": -117.3786184
  },
  {
    "id": "16286",
    "name": "CLARKS NUTRITION CENTER",
    "address": "34175 MONTEREY, RANCHO MIRAGE, CA, 92270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8008589,
    "lng": -116.3901556
  },
  {
    "id": "16285",
    "name": "CLARKS NUTRITION CENTER",
    "address": "11235 MT. VIEW AVENUE, LOMA LINDA, CA, 92354",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0500477,
    "lng": -117.2422094
  },
  {
    "id": "16284",
    "name": "CLARKS NUTRITION CENTER",
    "address": "12835 MOUNTAIN AVE, CHINO, CA, 91710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0206348,
    "lng": -117.666402
  },
  {
    "id": "16283",
    "name": "CLARKS MARKETS",
    "address": "16 KEARNS RD, SNOWMASS VILLAGE, CO, 81615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2115964,
    "lng": -106.9455447
  },
  {
    "id": "16282",
    "name": "CLARKS MARKETS",
    "address": "300 PUPPYSMITH ST, ASPEN, CO, 81611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1928291,
    "lng": -106.8190151
  },
  {
    "id": "16281",
    "name": "CHURCH OF SCIENTOLOGY",
    "address": "1301 AMBLE LANE, CLEARWATER, FL, 33755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9793044,
    "lng": -82.7639993
  },
  {
    "id": "16280",
    "name": "CHURCH OF SCIENTOLOGY",
    "address": "200 N. OSCEOLA AVENUE, CLEARWATER, FL, 33755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9687681,
    "lng": -82.801693
  },
  {
    "id": "16279",
    "name": "CHURCH OF SCIENTOLOGY",
    "address": "CHURCH OF SCIENTOLOGY, CLEARWATER, FL, 33756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9634385,
    "lng": -82.7992659
  },
  {
    "id": "16278",
    "name": "CHURCH OF SCIENTOLOGY",
    "address": "215 S. FORT HARRISON AVE, CLERWATER, FL, 33756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9634324,
    "lng": -82.7993
  },
  {
    "id": "16277",
    "name": "CHUCKS PRODUCE",
    "address": "13215 SE MILL PLAIN BL #B2, VANCOUVER, WA, 98684",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6181916,
    "lng": -122.5367474
  },
  {
    "id": "16276",
    "name": "CHUCKS PRODUCE",
    "address": "2302 NE 117TH ST, VANCOUVER, WA, 98684",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.7063426,
    "lng": -122.648732
  },
  {
    "id": "16275",
    "name": "CENTRAL MARKET",
    "address": "4477 S LAMAR BLVD, AUSTIN, TX, 78745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2306155,
    "lng": -97.7990697
  },
  {
    "id": "16274",
    "name": "CENTRAL AMERICA",
    "address": "C/O SIGMA TRADE, MEDLEY, FL, 33178",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8209274,
    "lng": -80.3192195
  },
  {
    "id": "16273",
    "name": "CENTRAL AMERICA",
    "address": "2775 NW 82ND AVE, DORAL, FL, 33122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7994798,
    "lng": -80.3274078
  },
  {
    "id": "16272",
    "name": "CARALUZZI'S",
    "address": "98 GREENWOOD AVENUE, BETHEL, CT, 6801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3709256,
    "lng": -73.4100097
  },
  {
    "id": "16271",
    "name": "CALIFORNIA ORGANICS",
    "address": "135-A ARGALL WAY, NEVADA CITY, CA, 95959",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2522996,
    "lng": -121.0253124
  },
  {
    "id": "16270",
    "name": "CAL STATE UNIVERSITIES",
    "address": "1 HARPST ST, ARCATA, CA, 95521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8744392,
    "lng": -124.0790979
  },
  {
    "id": "16269",
    "name": "CAFE GRATITUDE",
    "address": "103 LINCOLN ST, SANTA CRUZ, CA, 95060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9724983,
    "lng": -122.0260743
  },
  {
    "id": "16268",
    "name": "BUYING CLUBS",
    "address": "90 WASHINGTON RD, WOODBURY, CT, 6798",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5565275,
    "lng": -73.2098611
  },
  {
    "id": "16267",
    "name": "BUYING CLUBS",
    "address": "50 SUNDERLAND ROAD, WORCESTER, MA, 1604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2465309,
    "lng": -71.7706918
  },
  {
    "id": "16266",
    "name": "BUYING CLUBS",
    "address": "RT 133, MIDDLETOWN SPRING, VT, 5757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4854365,
    "lng": -73.1181208
  },
  {
    "id": "16265",
    "name": "BUYING CLUBS",
    "address": "481 SHELDON ROAD, DELANSON, NY, 12053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.721625,
    "lng": -74.2401025
  },
  {
    "id": "16264",
    "name": "BUYING CLUBS",
    "address": "56 WARWICK STREET, MIDDLETOWN, CT, 6457",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5491593,
    "lng": -72.6526628
  },
  {
    "id": "16263",
    "name": "BUYING CLUBS",
    "address": "9067 WOODGROVE, PLYMOUTH, MI, 48170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3536301,
    "lng": -83.5235744
  },
  {
    "id": "16262",
    "name": "BUYING CLUBS",
    "address": "700 E 4TH STREET, DAYTON, OH, 45403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.759185,
    "lng": -84.1816743
  },
  {
    "id": "16261",
    "name": "BUYING CLUBS",
    "address": "80 BAY STREET, SAG HARBOR, NY, 11963",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0002172,
    "lng": -72.2892659
  },
  {
    "id": "16260",
    "name": "BUYING CLUBS",
    "address": "5885 FRANKFORT HWY, BENZONIA, MI, 49616",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.6307845,
    "lng": -86.1213844
  },
  {
    "id": "16259",
    "name": "BUYING CLUBS",
    "address": "24222 W 9 MILE RD, SOUTHFIELD, MI, 48034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4578393,
    "lng": -83.2812463
  },
  {
    "id": "16258",
    "name": "BUYING CLUBS",
    "address": "E HYW 20, O'NEILL, NE, 68763",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4576687,
    "lng": -98.648076
  },
  {
    "id": "16257",
    "name": "BUYING CLUBS",
    "address": "RTE 29 & HIGH ROCK AVE, SARATOGA SPRING, NY, 12866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0828774,
    "lng": -73.783041
  },
  {
    "id": "16256",
    "name": "BUYING CLUBS",
    "address": "4103 MAIN STREET (RT 100), WAITSFIELD, VT, 5673",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1931185,
    "lng": -72.8203101
  },
  {
    "id": "16255",
    "name": "BUYING CLUBS",
    "address": "21 N STONINGTON RD, MYSTIC, CT, 6355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3932872,
    "lng": -71.9595336
  },
  {
    "id": "16254",
    "name": "BUYING CLUBS",
    "address": "STATE ROUTE 103, ELIOT, ME, 3903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1455635,
    "lng": -70.8080544
  },
  {
    "id": "16253",
    "name": "BUYING CLUBS",
    "address": "Main St 121, SAXTONS RIVER, VT, 5154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.138037,
    "lng": -72.5148363
  },
  {
    "id": "16252",
    "name": "BUYING CLUBS",
    "address": "1602 SE 5TH AVE, GRAND RAPIDS, MN, 55744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2146354,
    "lng": -93.5205895
  },
  {
    "id": "16251",
    "name": "BUYING CLUBS",
    "address": "1600 RTE 32, HYANNIS, MA, 2601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4156491,
    "lng": -72.0970441
  },
  {
    "id": "16250",
    "name": "BUYING CLUBS",
    "address": "34240 HWY 12, ROSCOE, SD, 57471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.4513704,
    "lng": -99.325546
  },
  {
    "id": "16249",
    "name": "BUYING CLUBS",
    "address": "206 KASAN AVE, VOLGA, SD, 57071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3233398,
    "lng": -96.9264273
  },
  {
    "id": "16248",
    "name": "BUYING CLUBS",
    "address": "205 NORTH PLAIN ROAD, GREAT BARRINGTON, MA, 1230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2210276,
    "lng": -73.356974
  },
  {
    "id": "16247",
    "name": "BUYING CLUBS",
    "address": "301 SOUTH GRAND AVE WEST, SPRINGFIELD, IL, 62704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7874077,
    "lng": -89.6580705
  },
  {
    "id": "16246",
    "name": "BUYING CLUBS",
    "address": "200 BOURNEDALE ROAD, BUZZARDS BAY, MA, 2542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.769116,
    "lng": -70.5958164
  },
  {
    "id": "16245",
    "name": "BUYING CLUBS",
    "address": "20 GROVE AVENUE, GROTON, CT, 6340",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3678153,
    "lng": -72.0817208
  },
  {
    "id": "16244",
    "name": "BUYING CLUBS",
    "address": "FIREHOUSE RD & SECOND ST, HIGH FALLS, NY, 12440",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8262749,
    "lng": -74.1272879
  },
  {
    "id": "16243",
    "name": "BUYING CLUBS",
    "address": "1865 CELINA RD, BURKESVILLE, KY, 42717",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7563955,
    "lng": -85.3785195
  },
  {
    "id": "16242",
    "name": "BUYING CLUBS",
    "address": "14029 LARSEN ST, OVERLAND PARK, KS, 66221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8718011,
    "lng": -94.7041727
  },
  {
    "id": "16241",
    "name": "BUYING CLUBS",
    "address": "1600 OAK HILLS RD SW, BEMIDJI, MN, 56601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.4241899,
    "lng": -94.9018774
  },
  {
    "id": "16240",
    "name": "BUYING CLUBS",
    "address": "2611 UNIVERSITY DR., HUNTSVILLE, AL, 35816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7364497,
    "lng": -86.6069914
  },
  {
    "id": "16239",
    "name": "BUYING CLUBS",
    "address": "35 BROOK ST, MANCHESTER, MA, 1944",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5777989,
    "lng": -70.7669556
  },
  {
    "id": "16238",
    "name": "BUYING CLUBS",
    "address": "2340 HEINZ RD, IOWA CITY, IA, 52240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6351418,
    "lng": -91.4880024
  },
  {
    "id": "16237",
    "name": "BUYING CLUBS",
    "address": "5885 HOPKINS RD, MENTOR, OH, 44060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7108237,
    "lng": -81.3405001
  },
  {
    "id": "16236",
    "name": "BUYING CLUBS",
    "address": "1600 RT. 132, HYANNIS, MA, 2601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6784753,
    "lng": -70.3175721
  },
  {
    "id": "16235",
    "name": "BUYING CLUBS",
    "address": "207 DALE ADAMS ROAD, SUGAR GROVE, NC, 28679",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.263095,
    "lng": -81.785136
  },
  {
    "id": "16234",
    "name": "BUYING CLUBS",
    "address": "38413 DELAFIELD RD, OCONOMOWOC, WI, 53066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0606425,
    "lng": -88.5095468
  },
  {
    "id": "16233",
    "name": "BUYING CLUBS",
    "address": "3580 MAIN ST, HARTFORD, CT, 6120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7998155,
    "lng": -72.6597321
  },
  {
    "id": "16232",
    "name": "BUYING CLUBS",
    "address": "48 LUCILLE ST., FAIRFIELD, CT, 6432",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1909281,
    "lng": -73.2469334
  },
  {
    "id": "16231",
    "name": "BUYING CLUBS",
    "address": "N 3481 OUNTY HWY M, SARONA, WI, 54870",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.7599237,
    "lng": -91.7244888
  },
  {
    "id": "16230",
    "name": "BUYING CLUBS",
    "address": "4888 GEORGE WASHINGTN HWY, WHITE MARSH, VA, 23061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3547925,
    "lng": -76.5121126
  },
  {
    "id": "16229",
    "name": "BUYING CLUBS",
    "address": "1505 S CALUMET AVE, CHESTERTON, IN, 46304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5984544,
    "lng": -87.0460508
  },
  {
    "id": "16228",
    "name": "BUYING CLUBS",
    "address": "2470 HWY 196, HINESVILLE, GA, 31313",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.81332,
    "lng": -81.6490398
  },
  {
    "id": "16227",
    "name": "BUYING CLUBS",
    "address": "700 N SHERIDAN, LAKE FOREST, IL, 60045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2524231,
    "lng": -87.8323338
  },
  {
    "id": "16226",
    "name": "BUYING CLUBS",
    "address": "1660 EAGLEVILLE RD, TIVERTON, RI, 2878",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.656996,
    "lng": -71.158683
  },
  {
    "id": "16225",
    "name": "BUYING CLUBS",
    "address": "E 1870 PINE GROVE RD, KEWAUNEE, WI, 54216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4144532,
    "lng": -87.6755972
  },
  {
    "id": "16224",
    "name": "BUYING CLUBS",
    "address": "1890 RT 9, WINDSOR, MA, 1270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5089409,
    "lng": -73.055098
  },
  {
    "id": "16223",
    "name": "BUYING CLUBS",
    "address": "14 FRENCHMAN BLUFF, TROY, MO, 63379",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9876726,
    "lng": -90.9625418
  },
  {
    "id": "16222",
    "name": "BUYING CLUBS",
    "address": "1327 Summer Street, GRINNELL, IA, 50112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7500936,
    "lng": -92.7149708
  },
  {
    "id": "16221",
    "name": "BUYING CLUBS",
    "address": "2211 Q STREET, AURORA, NE, 68818",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8749132,
    "lng": -97.9908362
  },
  {
    "id": "16220",
    "name": "BUYING CLUBS",
    "address": "RT 202, WINTHROP, ME, 4364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3018728,
    "lng": -69.9748368
  },
  {
    "id": "16219",
    "name": "BUYING CLUBS",
    "address": "1610 NYS ROUTE 22, WHALLONSBURG, NY, 12936",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.2650017,
    "lng": -73.402059
  },
  {
    "id": "16218",
    "name": "BUYING CLUBS",
    "address": "23024 STATE RD 57, KIEL, WI, 53042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.9098907,
    "lng": -88.0174751
  },
  {
    "id": "16217",
    "name": "BUYING CLUBS",
    "address": "RTE 110, CHELSEA, VT, 5038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.9897897,
    "lng": -72.4475766
  },
  {
    "id": "16216",
    "name": "BUYING CLUBS",
    "address": "1410 W STOCKTON ST, EDMONTON, KY, 42129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9884239,
    "lng": -85.6367122
  },
  {
    "id": "16215",
    "name": "BUYING CLUBS",
    "address": "SARANAC LAKE UNION DEPOT, SARANAC LAKE, NY, 12983",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3293861,
    "lng": -74.1312942
  },
  {
    "id": "16214",
    "name": "BUYING CLUBS",
    "address": "900 W JEFFERSON STREET, PLYMOUTH, IN, 46563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3433747,
    "lng": -86.3192148
  },
  {
    "id": "16213",
    "name": "BUYING CLUBS",
    "address": "4999 MCKINLEY PKWY, HAMBURG, NY, 14075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7518634,
    "lng": -78.8108413
  },
  {
    "id": "16212",
    "name": "BUYING CLUBS",
    "address": "4147 WEST PINE, ST LOUIS, MO, 63108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6391425,
    "lng": -90.2478682
  },
  {
    "id": "16211",
    "name": "BUYING CLUBS",
    "address": "722 N. SUMMER ST, RENSSELAER, IN, 47978",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9415547,
    "lng": -87.1620939
  },
  {
    "id": "16210",
    "name": "BUYING CLUBS",
    "address": "200 RICHLAND SQUARE, RICHLAND CENTER, WI, 53581",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3172769,
    "lng": -90.3612293
  },
  {
    "id": "16209",
    "name": "BUYING CLUBS",
    "address": "1306 HOWARD AVE, ST.PAUL, NE, 68873",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2137257,
    "lng": -98.4656848
  },
  {
    "id": "16208",
    "name": "BUYING CLUBS",
    "address": "PEACEFUL VALLEY ROAD & RT, NORTH CREEK, NY, 12853",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.663914,
    "lng": -73.9963169
  },
  {
    "id": "16207",
    "name": "BUYING CLUBS",
    "address": "7027 N SENECA AVE, GLENDALE, WI, 53217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1446713,
    "lng": -87.9095371
  },
  {
    "id": "16206",
    "name": "BUYING CLUBS",
    "address": "3440 W 61ST AVE, HOBART, IN, 46342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5082371,
    "lng": -87.3002541
  },
  {
    "id": "16205",
    "name": "BUYING CLUBS",
    "address": "421 CHURCH HILL RD., CHARLOTTE, VT, 5445",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3147939,
    "lng": -73.2401794
  },
  {
    "id": "16204",
    "name": "BUYING CLUBS",
    "address": "3886 26TH ST, DORR, MI, 49323",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7025848,
    "lng": -85.8013342
  },
  {
    "id": "16203",
    "name": "BUYING CLUBS",
    "address": "18793 HWY 9, OSAGE, IA, 50461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2839284,
    "lng": -92.8554801
  },
  {
    "id": "16202",
    "name": "BUYING CLUBS",
    "address": "32 N MAIN ST, NEWMARKET, NH, 3857",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0844465,
    "lng": -70.9350589
  },
  {
    "id": "16201",
    "name": "BUYING CLUBS",
    "address": "1501 WOODLAWN ROAD, LINCOLN, IL, 62656",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1563348,
    "lng": -89.3948289
  },
  {
    "id": "16200",
    "name": "BUYING CLUBS",
    "address": "MUNICIPAL PARKING, NEW MILFORD, CT, 6776",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5764883,
    "lng": -73.412852
  },
  {
    "id": "16199",
    "name": "BUYING CLUBS",
    "address": "389 OLD COLCHESTER RD, AMSTON, CT, 6231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6162104,
    "lng": -72.3566644
  },
  {
    "id": "16198",
    "name": "BUYING CLUBS",
    "address": "5100 N ILLINOIS (HWY), FAIRVIEW HGTS, IL, 62208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5767096,
    "lng": -89.981964
  },
  {
    "id": "16197",
    "name": "BUYING CLUBS",
    "address": "FIRST PARISH CHURCH, STOW, MA, 1775",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4369006,
    "lng": -71.503695
  },
  {
    "id": "16196",
    "name": "BUYING CLUBS",
    "address": "2013 CHAPEL HILL RD, DURHAM, NC, 27707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9864851,
    "lng": -78.9273878
  },
  {
    "id": "16195",
    "name": "BUYING CLUBS",
    "address": "42 STATE HWY 35, NEGAUMEE, MI, 49866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.5273869,
    "lng": -87.5431818
  },
  {
    "id": "16194",
    "name": "BUYING CLUB WASHINGTON",
    "address": "2548 WALNUT AVE NW, OLYMPIA, WA, 98502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.0559516,
    "lng": -122.9332925
  },
  {
    "id": "16193",
    "name": "BUYING CLUB NEVADA",
    "address": "*NEW* 2073 MEADOW RIDGE, ELKO, NV, 89801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8397211,
    "lng": -115.7830127
  },
  {
    "id": "16192",
    "name": "BUYING CLUB CA",
    "address": "2870 ARDELL DR, MERCED, CA, 95348",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3147597,
    "lng": -120.4819796
  },
  {
    "id": "16191",
    "name": "BUYING CLUB CA",
    "address": "1024 ROBIN HOOD BLVD., BIG BEAR CITY, CA, 92314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.258912,
    "lng": -116.8633573
  },
  {
    "id": "16190",
    "name": "BURNT FORK & PATTEE CREEK",
    "address": "704 S.W. HIGGINS, MISSOULA, MT, 59803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8370274,
    "lng": -114.0110841
  },
  {
    "id": "16189",
    "name": "BULKMORE SRP DUMMY CHAIN",
    "address": "12741 OCEAN GATEWAY, OCEAN CITY, MD, 21842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3380422,
    "lng": -75.1066309
  },
  {
    "id": "16188",
    "name": "BUFFALO MTN COOP",
    "address": "30 SOUTH MAIN ST, HARDWICK, VT, 5843",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.50409,
    "lng": -72.3667059
  },
  {
    "id": "16187",
    "name": "BROULIMS SUPERMARKET",
    "address": "124 W MAIN ST /DENNIS JORDAN, REXBURG, ID, 83440",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.8272945,
    "lng": -111.7874711
  },
  {
    "id": "16186",
    "name": "BROULIMS SUPERMARKET",
    "address": "150 N STATE ST, RIGBY, ID, 83442",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6734227,
    "lng": -111.9132421
  },
  {
    "id": "16185",
    "name": "BRISTOL FARMS",
    "address": "3105 WILSHIRE BLVD, SANTA MONICA, CA, 90403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.040251,
    "lng": -118.4728012
  },
  {
    "id": "16184",
    "name": "BRISTOL FARMS",
    "address": "73101 COUNTRY CLUB, PALM DESERT, CA, 92260",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7571144,
    "lng": -116.3892859
  },
  {
    "id": "16183",
    "name": "BRISTOL FARMS",
    "address": "3855 STATE ST, SANTA BARBARA, CA, 93105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4381445,
    "lng": -119.7494594
  },
  {
    "id": "16182",
    "name": "BRISTOL FARMS",
    "address": "1515 WESTWOOD BLVD, LOS ANGELES, CA, 90024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0534386,
    "lng": -118.4405426
  },
  {
    "id": "16181",
    "name": "BRISTOL FARMS",
    "address": "23381 MULHOLLAND DR, WOODLAND HILLS, CA, 91364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.159128,
    "lng": -118.6345348
  },
  {
    "id": "16180",
    "name": "BRISTOL FARMS",
    "address": "8510 GENESEE AVE, SAN DIEGO, CA, 92122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8675795,
    "lng": -117.2153401
  },
  {
    "id": "16179",
    "name": "BRISTOL FARMS",
    "address": "18421 YORBA LINDA BLVD, YORBA LINDA, CA, 92886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8891843,
    "lng": -117.8122474
  },
  {
    "id": "16178",
    "name": "BRISTOL FARMS",
    "address": "9039 BEVERLY BLVD, WEST HOLLYWOOD, CA, 90048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0773655,
    "lng": -118.3892673
  },
  {
    "id": "16177",
    "name": "BRISTOL FARMS",
    "address": "810 AVOCADO AVE, NEWPORT BEACH, CA, 92660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6062289,
    "lng": -117.8733579
  },
  {
    "id": "16176",
    "name": "BRISTOL FARMS",
    "address": "8448 LINCOLN BLVD, WESTCHESTER, CA, 90045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9610911,
    "lng": -118.4191398
  },
  {
    "id": "16175",
    "name": "BRISTOL FARMS",
    "address": "1570 ROSECRANS AVE, MANHATTAN BEACH, CA, 90266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9003509,
    "lng": -118.3848828
  },
  {
    "id": "16174",
    "name": "BRISTOL FARMS",
    "address": "606 FAIR OAKS AVE, SOUTH PASADENA, CA, 91030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1186407,
    "lng": -118.1496626
  },
  {
    "id": "16173",
    "name": "BREAD GARDEN ON CAMPUS",
    "address": "225 S LINN ST, IOWA CITY, IA, 52240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6586069,
    "lng": -91.5322071
  },
  {
    "id": "16172",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "401 BRIDGEPORT AVE, SHELTON, CT, 6484",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.294565,
    "lng": -73.1111715
  },
  {
    "id": "16171",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "533 SOUTH BROAD STREET, MERIDEN, CT, 6450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5085468,
    "lng": -72.8079267
  },
  {
    "id": "16170",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1289 FOXON ROAD, NORTH BRANFORD, CT, 6471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3256773,
    "lng": -72.7808269
  },
  {
    "id": "16169",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "2035 BOSTON ROAD, WILBRAHAM, MA, 1095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1484045,
    "lng": -72.4715405
  },
  {
    "id": "16168",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "355 HAWLEY LANE, STRATFORD, CT, 6614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2323771,
    "lng": -73.1484993
  },
  {
    "id": "16167",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "83 STONY HILL ROAD, BETHEL, CT, 6801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4125797,
    "lng": -73.3789658
  },
  {
    "id": "16166",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "33 FIELDSTONE COMMONS, TOLLAND, CT, 6084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8589846,
    "lng": -72.3579361
  },
  {
    "id": "16165",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "345 WASHINGTON AVENUE, NORTH HAVEN, CT, 6473",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4077629,
    "lng": -72.8458245
  },
  {
    "id": "16164",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "135 WEST ROAD, ELLINGTON, CT, 6029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8872557,
    "lng": -72.4611658
  },
  {
    "id": "16163",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "475 EAST MAIN STREET, WESTFIELD, MA, 1085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1116811,
    "lng": -72.7231548
  },
  {
    "id": "16162",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "300 COOLEY STREET, SPRINGFIELD, MA, 1128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.096278,
    "lng": -72.4986215
  },
  {
    "id": "16161",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1111 PROVIDENCE HIGHWAY, WALPOLE, MA, 2081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.139435,
    "lng": -71.2206077
  },
  {
    "id": "16160",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "995 POQUONNOCK ROAD, GROTON, CT, 6340",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3448792,
    "lng": -72.0491369
  },
  {
    "id": "16159",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "67 PROSPECT HILL ROAD, EAST WINDSOR, CT, 6088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9223463,
    "lng": -72.6082157
  },
  {
    "id": "16158",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "504 WINSTED ROAD, TORRINGTON, CT, 6790",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8255398,
    "lng": -73.1103417
  },
  {
    "id": "16157",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "22 SPENCER PLAIN ROAD, OLD SAYBROOK, CT, 6475",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2881008,
    "lng": -72.4156431
  },
  {
    "id": "16156",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1 KENT ROAD, NEW MILFORD, CT, 6776",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5737922,
    "lng": -73.4200469
  },
  {
    "id": "16155",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "830 BOSTON POST ROAD, GUILFORD, CT, 6437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2871201,
    "lng": -72.6788644
  },
  {
    "id": "16154",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "255 WEST MAIN STREET, AVON, CT, 6001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8104198,
    "lng": -72.8535788
  },
  {
    "id": "16153",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "650 MEMORIAL DRIVE, CHICOPEE, MA, 1020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1752009,
    "lng": -72.5793558
  },
  {
    "id": "16152",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "44 WILLIMANSETT STREET, SOUTH HADLEY, MA, 1075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2225797,
    "lng": -72.5702069
  },
  {
    "id": "16151",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "6 QUEEN STREET, NEWTOWN, CT, 6470",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4116518,
    "lng": -73.3049647
  },
  {
    "id": "16150",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "65 PALOMBA DRIVE, ENFIELD, CT, 6082",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9905037,
    "lng": -72.5696062
  },
  {
    "id": "16149",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "175 UNIVERSITY DRIVE, AMHERST, MA, 1002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3674616,
    "lng": -72.5341162
  },
  {
    "id": "16148",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "234 TOLLAND TURNPIKE, MANCHESTER, CT, 6042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8099221,
    "lng": -72.5132857
  },
  {
    "id": "16147",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1040 ELM STREET, ROCKY HILL, CT, 6067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6585233,
    "lng": -72.6758047
  },
  {
    "id": "16146",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "100 MAYFIELD STREET, WORCESTER, MA, 1602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2593638,
    "lng": -71.8261874
  },
  {
    "id": "16145",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "348 EAST CENTRAL STREET, FRANKLIN, MA, 2038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0788232,
    "lng": -71.3811385
  },
  {
    "id": "16144",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "10 PLEASANT STREET, LEE, MA, 1238",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2958486,
    "lng": -73.2405977
  },
  {
    "id": "16143",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "275 NEW BRITAIN AVENUE, PLAINVILLE, CT, 6062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6770838,
    "lng": -72.8395496
  },
  {
    "id": "16142",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "535 MONROE TURNPIKE, MONROE, CT, 6468",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3185971,
    "lng": -73.2167146
  },
  {
    "id": "16141",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "141B STORRS ROAD, MANSFIELD, CT, 6250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7379328,
    "lng": -72.1999209
  },
  {
    "id": "16140",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "85 BRIDGE STREET, NAUGATUCK, CT, 6770",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5002565,
    "lng": -73.053147
  },
  {
    "id": "16139",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "70 WAUREGAN ROAD, DANIELSON, CT, 6239",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.793185,
    "lng": -71.8836291
  },
  {
    "id": "16138",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "224 SALEM TURNPIKE, NORWICH, CT, 6360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.505279,
    "lng": -72.1236897
  },
  {
    "id": "16137",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "160 RESEVOIR STREET, HOLDEN, MA, 1520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3439367,
    "lng": -71.8620812
  },
  {
    "id": "16136",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "62 WEST MAIN STREET, SPENCER, MA, 1562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2337027,
    "lng": -72.0141262
  },
  {
    "id": "16135",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "505 EAST MAIN STREET, SOUTHBRIDGE, MA, 1550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0694895,
    "lng": -72.0090374
  },
  {
    "id": "16134",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "200 WEST STREET, PITTSFIELD, MA, 1201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4485452,
    "lng": -73.259397
  },
  {
    "id": "16133",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "700 SOUTH MAIN STREET, GREAT BARRINGTON, MA, 1230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.180524,
    "lng": -73.3659187
  },
  {
    "id": "16132",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1180 THORNDIKE STREET, PALMER, MA, 1069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1742319,
    "lng": -72.3238981
  },
  {
    "id": "16131",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "433 CENTER STREET, LUDLOW, MA, 1056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1687145,
    "lng": -72.4833651
  },
  {
    "id": "16130",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "441 NORTH MAIN STREET, EAST LONGMEADOW, MA, 1028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0800892,
    "lng": -72.5288478
  },
  {
    "id": "16129",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "802 WILLIAMS STREET, LONGMEADOW, MA, 1106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0559659,
    "lng": -72.5556763
  },
  {
    "id": "16128",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "150 BOSTON POST RD, MILFORD, CT, 6460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.220259,
    "lng": -73.075867
  },
  {
    "id": "16127",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "656 NEW HAVEN AVE, DERBY, CT, 6418",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3118395,
    "lng": -73.0531377
  },
  {
    "id": "16126",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "10 COLLEGE HWAY RTE10, SOUTHAMPTON, MA, 1073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2535805,
    "lng": -72.6987245
  },
  {
    "id": "16125",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "7 E HAMPTON RD, MARLBOROUGH, CT, 6447",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6303,
    "lng": -72.4603
  },
  {
    "id": "16124",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "25 ROBERT DRIVE, EASTON, MA, 2375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0252118,
    "lng": -71.1413238
  },
  {
    "id": "16123",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "357 BROADWAY, SAUGUS, MA, 1906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4881873,
    "lng": -71.0190398
  },
  {
    "id": "16122",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "637 LOWELL STREET, WEST PEABODY, MA, 1960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5495594,
    "lng": -71.0013604
  },
  {
    "id": "16121",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "7 MEDWAY ROAD, MILFORD, MA, 1757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1484372,
    "lng": -71.5028425
  },
  {
    "id": "16120",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "10 WASHINGTON STREET, NORWELL, MA, 2061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1727521,
    "lng": -70.8836756
  },
  {
    "id": "16119",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "182 SUMMER STREET, KINGSTON, MA, 2364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0102736,
    "lng": -70.734538
  },
  {
    "id": "16118",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1 EAST SILVER STREET, WESTFIELD, MA, 1085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1124024,
    "lng": -72.746921
  },
  {
    "id": "16117",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "195 COLLEGE HIGHWAY, SOUTHWICK, MA, 1077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.025421,
    "lng": -72.7882138
  },
  {
    "id": "16116",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "503 MEMORIAL DRIVE, WEST SPRINGFIELD, MA, 1089",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0945216,
    "lng": -72.6042321
  },
  {
    "id": "16115",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1090 ST JAMES AVENUE, SPRINGFIELD, MA, 1104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1370225,
    "lng": -72.5717299
  },
  {
    "id": "16114",
    "name": "BIGY GROCERY FULL SERVICE",
    "address": "1313 HOPMEADOW ST, SIMSBURY, CT, 6070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9020351,
    "lng": -72.7868534
  },
  {
    "id": "16113",
    "name": "BEXLEY CO-OP",
    "address": "4398 INDIANOLA AVE, COLUMBUS, OH, 43214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0545211,
    "lng": -83.0000631
  },
  {
    "id": "16112",
    "name": "BEXLEY CO-OP",
    "address": "508 N. CASSADY, BEXLEY, OH, 43209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9809567,
    "lng": -82.9316895
  },
  {
    "id": "16111",
    "name": "BERRYVALE GROCERY",
    "address": "305 S. MOUNT SHASTA BLVD., MT. SHASTA, CA, 96067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3115806,
    "lng": -122.3113923
  },
  {
    "id": "16110",
    "name": "BERMUDA ACCOUNTS -INT",
    "address": "110 NEWFIELD AVE, EDISON, NJ, 8837",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5004433,
    "lng": -74.3538445
  },
  {
    "id": "16109",
    "name": "BERMUDA ACCOUNTS -INT",
    "address": "C/O CTS, JAMAICA, NY, 11434",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6594703,
    "lng": -73.7718256
  },
  {
    "id": "16108",
    "name": "BERMUDA ACCOUNTS -INT",
    "address": "825 FRELINGHUYSEN AVE, NEWARK, NJ, 7114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6937962,
    "lng": -74.2017447
  },
  {
    "id": "16107",
    "name": "BERKELEY BOWL",
    "address": "920 HEINZ AVE, BERKELEY, CA, 94703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8535336,
    "lng": -122.2903762
  },
  {
    "id": "16106",
    "name": "BERKELEY BOWL",
    "address": "2020 OREGON STREET, BERKELEY, CA, 94703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.857113,
    "lng": -122.2672497
  },
  {
    "id": "16105",
    "name": "BEN E KEITH",
    "address": "1697 COUNTY RD 404, ELBA, AL, 36323",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3894495,
    "lng": -86.1288427
  },
  {
    "id": "16104",
    "name": "BASICS MARKET",
    "address": "938 NW 14TH AVE, PORTLAND, OR, 97209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5298164,
    "lng": -122.6850294
  },
  {
    "id": "16103",
    "name": "BASICS MARKET",
    "address": "930 NW 14TH AVE, PORTLAND, OR, 97209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5298111,
    "lng": -122.6848797
  },
  {
    "id": "16102",
    "name": "BARONS",
    "address": "32310 CLINTON KEITH BLVD, WILDOMAR, CA, 92595",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5908612,
    "lng": -117.2497731
  },
  {
    "id": "16101",
    "name": "BARONS",
    "address": "31939 RANCHO CALIFORNIA #100, TEMECULA, CA, 92592",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5142982,
    "lng": -117.1022996
  },
  {
    "id": "16100",
    "name": "BARONS",
    "address": "11828 RANCHO BERNARDO RD., SAN DIEGO, CA, 92128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0238455,
    "lng": -117.0757763
  },
  {
    "id": "16099",
    "name": "BARONS",
    "address": "2015 BIRCH RD, CHULA VISTA, CA, 91915",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6238096,
    "lng": -116.9669426
  },
  {
    "id": "16098",
    "name": "BARONS",
    "address": "3231 UNIVERSITY AVE, SAN DIEGO, CA, 92104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7483525,
    "lng": -117.1243504
  },
  {
    "id": "16097",
    "name": "BARONS",
    "address": "40545 CALIFORNIA OAKS RD C1, MURRIETA, CA, 92562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5750691,
    "lng": -117.2025155
  },
  {
    "id": "16096",
    "name": "BARONS",
    "address": "29787 ANTELOPE RD, MENIFEE, CA, 92584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6856505,
    "lng": -117.1687989
  },
  {
    "id": "16095",
    "name": "BARONS",
    "address": "1347 TAVERN RD, ALPINE, CA, 91901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8370046,
    "lng": -116.7776816
  },
  {
    "id": "16094",
    "name": "BARONS",
    "address": "4001 W. POINT LOMA BLVD., SAN DIEGO, CA, 92110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7534096,
    "lng": -117.2223227
  },
  {
    "id": "16093",
    "name": "BARBUR WORLD FOODS",
    "address": "9845 SW BARBUR BLVD, PORTLAND, OR, 97219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.4544514,
    "lng": -122.7200061
  },
  {
    "id": "16092",
    "name": "BAKERIES AND CAFES FDSVC",
    "address": "759 NICHOLS AVE, FAIRHOPE, AL, 36532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5165992,
    "lng": -87.8887632
  },
  {
    "id": "16091",
    "name": "BAKERIES AND CAFES FDSVC",
    "address": "13896 HWY C, RAYVILLE, MO, 64084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5513937,
    "lng": -91.8084772
  },
  {
    "id": "16090",
    "name": "AVI FOOD SYSTEMS",
    "address": "155 NORTH PROFESSOR ST, OBERLIN, OH, 44074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2957617,
    "lng": -82.2193609
  },
  {
    "id": "16089",
    "name": "AVENDRA",
    "address": "35 LATIN WAY, MEDFORD, MA, 2155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4048643,
    "lng": -71.1212273
  },
  {
    "id": "16088",
    "name": "AVENDRA",
    "address": "1 OLD GOLF COURSE ROAD, MONTEREY, CA, 93940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5923555,
    "lng": -121.8765404
  },
  {
    "id": "16087",
    "name": "AVENDRA",
    "address": "5001 COCONUT ROAD, BONITA SPRINGS, FL, 34134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3975131,
    "lng": -81.8380813
  },
  {
    "id": "16086",
    "name": "AVENDRA",
    "address": "37220 MULE TRAIN RD, CAREFREE, AZ, 85377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8229329,
    "lng": -111.909331
  },
  {
    "id": "16085",
    "name": "AVENDRA",
    "address": "RESTAURANT) 165 KEMBLE ST, LENOX, MA, 1240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3547222,
    "lng": -73.2827778
  },
  {
    "id": "16084",
    "name": "AVENDRA",
    "address": "55 LEE RD, LENOX, MA, 1240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3417067,
    "lng": -73.2627692
  },
  {
    "id": "16083",
    "name": "ASSOCIATED GROCERS FL EXP",
    "address": "C/O ASSOCIATED GROCERS, POMPANO BEACH, FL, 33069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2158041,
    "lng": -80.1449368
  },
  {
    "id": "16082",
    "name": "ASSOCIATED GROCERS FL EXP",
    "address": "C/O MERCHANTS EXPORT, RIVIERA BEACH, FL, 33404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7694848,
    "lng": -80.0591636
  },
  {
    "id": "16081",
    "name": "ASSOCIATED GROCERS FL EXP",
    "address": "1141 SW 12TH AVE, POMPANO BEACH, FL, 33069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2158786,
    "lng": -80.139282
  },
  {
    "id": "16080",
    "name": "ASSOC GROC FL DIRECT",
    "address": "141 9TH ST NORTH, NAPLES, FL, 34102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1487968,
    "lng": -81.7967712
  },
  {
    "id": "16079",
    "name": "ASPEN/PEARL",
    "address": "4015 N LAKE CREEK DR, WILSON, WY, 83014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.5318742,
    "lng": -110.8424103
  },
  {
    "id": "16078",
    "name": "ARLANS MARKET",
    "address": "513 MARKET ST, GALVESTON, TX, 77550-2705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.310112,
    "lng": -94.7734465
  },
  {
    "id": "16077",
    "name": "ARAMARK",
    "address": "6351 TONSMEIRE DR, MOBILE, AL, 36688",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6933233,
    "lng": -88.1896638
  },
  {
    "id": "16076",
    "name": "ARAMARK",
    "address": "6565 FANNIN ST, HOUSTON, TX, 77030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7099079,
    "lng": -95.3997225
  },
  {
    "id": "16075",
    "name": "ANNS HEALTH FOOD",
    "address": "2305 N HWY 77, WAXAHACHIE, TX, 75165",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4407861,
    "lng": -96.8381986
  },
  {
    "id": "16074",
    "name": "ANDYS LOCAL MARKET",
    "address": "2202 5TH AVE, SAN RAFAEL, CA, 94901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9822222,
    "lng": -122.5477477
  },
  {
    "id": "16073",
    "name": "ANDYS LOCAL MARKET",
    "address": "75 LOCH LOMOND DRIVE, SAN RAFAEL, CA, 94901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9732001,
    "lng": -122.4842821
  },
  {
    "id": "16072",
    "name": "ANDYS LOCAL MARKET",
    "address": "195 TAMAL VISTA BLVD, CORTE MADERA, CA, 94925",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.935421,
    "lng": -122.5179864
  },
  {
    "id": "16071",
    "name": "AMERICA RX SN",
    "address": "1935 HAZEN ST, EAST ELMHURST, NY, 11370",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.772908,
    "lng": -73.8936233
  },
  {
    "id": "16070",
    "name": "ALFRED GARCIA, INTERNATIONAL",
    "address": "1605 PACIFIC RIM CT-STE A, SAN DIEGO, CA, 92154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.567718,
    "lng": -116.992073
  },
  {
    "id": "16069",
    "name": "ALFRED GARCIA, INTERNATIONAL",
    "address": "9163 SIEMPRE VIVA RD.-STE G, SAN DIEGO, CA, 92154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5525844,
    "lng": -116.9476192
  },
  {
    "id": "16068",
    "name": "ALFRED GARCIA, INTERNATIONAL",
    "address": "7577 AIRWAY ROAD, SAN DIEGO, CA, 92154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5592299,
    "lng": -116.9780677
  },
  {
    "id": "16067",
    "name": "ALFRED GARCIA, INTERNATIONAL",
    "address": "1605 PACIFIC RIM-STE A, SAN DIEGO, CA, 92154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.567718,
    "lng": -116.992073
  },
  {
    "id": "16066",
    "name": "AKINS",
    "address": "4019 W WALNUT, ROGERS, AR, 72756",
    "phone": "AKN",
    "hours": "Call for hours",
    "lat": 36.3363816,
    "lng": -94.1762548
  },
  {
    "id": "16065",
    "name": "AKINS",
    "address": "3321 E 31ST ST, TULSA, OK, 74135",
    "phone": "AKN",
    "hours": "Call for hours",
    "lat": 36.1195734,
    "lng": -95.9388657
  },
  {
    "id": "16064",
    "name": "AKINS",
    "address": "2924 NW 63RD ST, OKLAHOMA CITY, OK, 73116",
    "phone": "AKN",
    "hours": "Call for hours",
    "lat": 35.535457,
    "lng": -97.566759
  },
  {
    "id": "16063",
    "name": "AKINS",
    "address": "7807 E 51ST ST, TULSA, OK, 74145",
    "phone": "AKN",
    "hours": "Call for hours",
    "lat": 36.0913213,
    "lng": -95.8897794
  },
  {
    "id": "16062",
    "name": "A-MARKET",
    "address": "181 BELLEVUE AVE, NEWPORT, RI, 2840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4822774,
    "lng": -71.3097854
  },
  {
    "id": "16061",
    "name": "A-MARKET",
    "address": "125 LORING STREET, MANCHESTER, NH, 3103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9668043,
    "lng": -71.4516892
  },
  {
    "id": "16060",
    "name": "3 BEARS ALASKA",
    "address": "3815 WEST VALLEY HIGHWAY N, AUBURN, WA, 98001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.342343,
    "lng": -122.2514224
  },
  {
    "id": "16059",
    "name": "Vitamin Shoppe",
    "address": "1502 Highway 17 N Unit 4, North Myrtle Bch, SC, 29582",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8419942,
    "lng": -78.661055
  },
  {
    "id": "16058",
    "name": "Vitamin Shoppe",
    "address": "23 Leopard Rd (Rt. 252) B-14, Paoli, PA, 19301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0404442,
    "lng": -75.4780524
  },
  {
    "id": "16057",
    "name": "Vitamin Shoppe",
    "address": "320 NE 78th Street, Vancouver, WA, 98665",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6789754,
    "lng": -122.6685897
  },
  {
    "id": "16056",
    "name": "Vitamin Shoppe",
    "address": "26710 Maple Valley-Black Diamond Rd Suite F-100, Maple Valley, WA, 98038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.3620802,
    "lng": -122.0207221
  },
  {
    "id": "16055",
    "name": "Vitamin Shoppe",
    "address": "15870 1st Avenue South Suite 103, Seattle, WA, 98148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.4599519,
    "lng": -122.3328609
  },
  {
    "id": "16054",
    "name": "Vitamin Shoppe",
    "address": "2612 SW Cedar Hills Boulevard, Beaverton, OR, 97005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.500688,
    "lng": -122.8056443
  },
  {
    "id": "16053",
    "name": "Vitamin Shoppe",
    "address": "305 SE Chkalov Drive Suite 130, Vancouver, WA, 98683",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6187965,
    "lng": -122.5543273
  },
  {
    "id": "16052",
    "name": "Vitamin Shoppe",
    "address": "391 Coburg Road, Eugene, OR, 97401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0666374,
    "lng": -123.0724271
  },
  {
    "id": "16051",
    "name": "Vitamin Shoppe",
    "address": "17980 Redmond Way, Redmond, WA, 98052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6669763,
    "lng": -122.1005602
  },
  {
    "id": "16050",
    "name": "Vitamin Shoppe",
    "address": "403 W Neider Avenue, Coeur D Alene, ID, 83815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7075994,
    "lng": -116.792565
  },
  {
    "id": "16049",
    "name": "Vitamin Shoppe",
    "address": "5902 6th Avenue Suite A, Tacoma, WA, 98406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2550987,
    "lng": -122.5162551
  },
  {
    "id": "16048",
    "name": "Vitamin Shoppe",
    "address": "1154 Elliott Avenue West, Seattle, WA, 98119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6301738,
    "lng": -122.3724144
  },
  {
    "id": "16047",
    "name": "Vitamin Shoppe",
    "address": "5200 W Clearwater Avenue, Kennewick, WA, 99336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.2127821,
    "lng": -119.192243
  },
  {
    "id": "16046",
    "name": "Vitamin Shoppe",
    "address": "3324 Wheaton Way, Bremerton, WA, 98310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5953099,
    "lng": -122.628796
  },
  {
    "id": "16045",
    "name": "Vitamin Shoppe",
    "address": "6451 Fauntleroy Way SW, Seattle, WA, 98136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.5454036,
    "lng": -122.3862246
  },
  {
    "id": "16044",
    "name": "Vitamin Shoppe",
    "address": "1401 S 348th Street Suite M102, Federal Way, WA, 98003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.289374,
    "lng": -122.3159764
  },
  {
    "id": "16043",
    "name": "Vitamin Shoppe",
    "address": "2513 N Ruby Street, Spokane, WA, 99207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6815524,
    "lng": -117.4103046
  },
  {
    "id": "16042",
    "name": "Vitamin Shoppe",
    "address": "6630 E Sprague Avenue Suite C, Spokane, WA, 99212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6565279,
    "lng": -117.315477
  },
  {
    "id": "16041",
    "name": "Vitamin Shoppe",
    "address": "4307 S Meridian Street, Puyallup, WA, 98373",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.1508453,
    "lng": -122.2925133
  },
  {
    "id": "16040",
    "name": "Vitamin Shoppe",
    "address": "4031 Colby Avenue, Everett, WA, 98201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.9637416,
    "lng": -122.2074382
  },
  {
    "id": "16039",
    "name": "Vitamin Shoppe",
    "address": "707 Rainer Avenue S, Renton, WA, 98057",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.473446,
    "lng": -122.2172701
  },
  {
    "id": "16038",
    "name": "Vitamin Shoppe",
    "address": "10011 Bridgeport Way SW Suite 1600, Lakewood, WA, 98499",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.1660657,
    "lng": -122.5082957
  },
  {
    "id": "16037",
    "name": "Vitamin Shoppe",
    "address": "14733 NE 8th Street, Bellevue, WA, 98007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6165894,
    "lng": -122.1436658
  },
  {
    "id": "16036",
    "name": "Vitamin Shoppe",
    "address": "1761 S Burlington Blvd, Burlington, WA, 98233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.4528582,
    "lng": -122.3358184
  },
  {
    "id": "16035",
    "name": "Vitamin Shoppe",
    "address": "4104 Martin Way E Suite 101, Olympia, WA, 98516",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.0482069,
    "lng": -122.8331749
  },
  {
    "id": "16034",
    "name": "Vitamin Shoppe",
    "address": "6806 NE 175th Street, Kenmore, WA, 98028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7579967,
    "lng": -122.2493378
  },
  {
    "id": "16033",
    "name": "Vitamin Shoppe",
    "address": "19925 44th Ave West, Lynnwood, WA, 98036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.8176941,
    "lng": -122.2917074
  },
  {
    "id": "16032",
    "name": "Vitamin Shoppe",
    "address": "13500 Aurora Avenue N, Seattle, WA, 98133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7270224,
    "lng": -122.3444988
  },
  {
    "id": "16031",
    "name": "Vitamin Shoppe",
    "address": "312 Washington St 1FL, Hoboken, NJ, 7030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7405487,
    "lng": -74.0303015
  },
  {
    "id": "16030",
    "name": "Vitamin Shoppe",
    "address": "92 State Rt 23 North Suite B1-B2, Riverdale, NJ, 7457",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9889688,
    "lng": -74.3240122
  },
  {
    "id": "16029",
    "name": "Vitamin Shoppe",
    "address": "1001 W 49th Street Suite 2B, Hialeah, FL, 33012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.867167,
    "lng": -80.3041505
  },
  {
    "id": "16028",
    "name": "Vitamin Shoppe",
    "address": "12679 Tamiami Trail East, Naples, FL, 34113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0672302,
    "lng": -81.7009113
  },
  {
    "id": "16027",
    "name": "Vitamin Shoppe",
    "address": "4910 Hadley Center Drive, South Plainfield, NJ, 7080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5488794,
    "lng": -74.4292543
  },
  {
    "id": "16026",
    "name": "Vitamin Shoppe",
    "address": "542 Shoppes Blvd, North Brunswick, NJ, 8902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4611367,
    "lng": -74.4567072
  },
  {
    "id": "16025",
    "name": "Vitamin Shoppe",
    "address": "243 N Cattlemen Rd. Unit # 71, Sarasota, FL, 34243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3843512,
    "lng": -82.45687
  },
  {
    "id": "16024",
    "name": "Vitamin Shoppe",
    "address": "10950 Parkside Drive, Knoxville, TN, 37934",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9025179,
    "lng": -84.1484528
  },
  {
    "id": "16023",
    "name": "Vitamin Shoppe",
    "address": "2180 MacArthur Road, Whitehall, PA, 18052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6364922,
    "lng": -75.4919444
  },
  {
    "id": "16022",
    "name": "Vitamin Shoppe",
    "address": "1450 Ala Moana Blvd. Space 1305, Honolulu, HI, 96814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.2918195,
    "lng": -157.8460375
  },
  {
    "id": "16021",
    "name": "Vitamin Shoppe",
    "address": "1969 Canterbury Glen Lane STE 110, Rock Hill, SC, 29730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9401335,
    "lng": -80.9757858
  },
  {
    "id": "16020",
    "name": "Vitamin Shoppe",
    "address": "4301 13th Street, Saint Cloud, FL, 34769",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.2519385,
    "lng": -81.3157983
  },
  {
    "id": "16019",
    "name": "Vitamin Shoppe",
    "address": "601 Cypress Gardens Blvd SE., Winter Haven, FL, 33880",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0042228,
    "lng": -81.7181939
  },
  {
    "id": "16018",
    "name": "Vitamin Shoppe",
    "address": "1320 McFarland Blvd East Suite 580, Tuscaloosa, AL, 35404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1994281,
    "lng": -87.526487
  },
  {
    "id": "16017",
    "name": "Vitamin Shoppe",
    "address": "6705 N. Grand Parkway W Suite 400, Spring, TX, 77389",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0883002,
    "lng": -95.5222194
  },
  {
    "id": "16016",
    "name": "Vitamin Shoppe",
    "address": "1102 Bowman Rd Suite 103, Mount Pleasant, SC, 29464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8129106,
    "lng": -79.8534383
  },
  {
    "id": "16015",
    "name": "Vitamin Shoppe",
    "address": "1605 East-West Connector Suite 140, Austell, GA, 30106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8545934,
    "lng": -84.5982118
  },
  {
    "id": "16014",
    "name": "Vitamin Shoppe",
    "address": "2601 Mt. Holly Road, Burlington, NJ, 8016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0363911,
    "lng": -74.825178
  },
  {
    "id": "16013",
    "name": "Vitamin Shoppe",
    "address": "3220 Morrow Rd, Birmingham, AL, 35235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5956711,
    "lng": -86.6472546
  },
  {
    "id": "16012",
    "name": "Vitamin Shoppe",
    "address": "7300 North Point Pkwy Suite 127, Apharetta, GA, 30022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0420619,
    "lng": -84.3018076
  },
  {
    "id": "16011",
    "name": "Vitamin Shoppe",
    "address": "15128 Max Legget Parkway, Jacksonville, FL, 32218",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4830126,
    "lng": -81.6372388
  },
  {
    "id": "16010",
    "name": "Vitamin Shoppe",
    "address": "2460 Market St NE Suite 701, Washington, DC, 20018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9213581,
    "lng": -76.9524685
  },
  {
    "id": "16009",
    "name": "Vitamin Shoppe",
    "address": "91 Middlesex Tpk Suite 210/220, Burlington, MA, 1803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4851014,
    "lng": -71.2192058
  },
  {
    "id": "16008",
    "name": "Vitamin Shoppe",
    "address": "1273 Ulster Avenue, Kingston, NY, 12401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9688706,
    "lng": -73.9893848
  },
  {
    "id": "16007",
    "name": "Vitamin Shoppe",
    "address": "10402 Sepulveda Blvd, Mission Hills, CA, 91345",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2595975,
    "lng": -118.4665804
  },
  {
    "id": "16006",
    "name": "Vitamin Shoppe",
    "address": "8533 West Grand River Ave, Brighton, MI, 48116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.542802,
    "lng": -83.7868954
  },
  {
    "id": "16005",
    "name": "Vitamin Shoppe",
    "address": "1523 Manhattan Blvd, Harvey, LA, 70058",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8933485,
    "lng": -90.0588395
  },
  {
    "id": "16004",
    "name": "Vitamin Shoppe",
    "address": "1851 Tamiami Trail Suite 101, Port Charlotte, FL, 33948",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0052798,
    "lng": -82.1317587
  },
  {
    "id": "16003",
    "name": "Vitamin Shoppe",
    "address": "11200 San Jose Blvd, Jacksonville, FL, 32223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1715698,
    "lng": -81.6298598
  },
  {
    "id": "16002",
    "name": "Vitamin Shoppe",
    "address": "17887 Southpark Center, Strongsville, OH, 44136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3125174,
    "lng": -81.8262741
  },
  {
    "id": "16001",
    "name": "Vitamin Shoppe",
    "address": "1690 Marketplace Blvd, Cumming, GA, 30041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1879073,
    "lng": -84.1320112
  },
  {
    "id": "16000",
    "name": "Vitamin Shoppe",
    "address": "23 Mystic View Rd, Everett, MA, 2149",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4009332,
    "lng": -71.070321
  },
  {
    "id": "15999",
    "name": "Vitamin Shoppe",
    "address": "10 West University Blvd, Silver Spring, MD, 20901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.020365,
    "lng": -77.0134892
  },
  {
    "id": "15998",
    "name": "Vitamin Shoppe",
    "address": "3100 South Horner Blvd, Sanford, NC, 27332",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4502018,
    "lng": -79.1345282
  },
  {
    "id": "15997",
    "name": "Vitamin Shoppe",
    "address": "3535 E Foothill Blvd., Pasadena, CA, 91107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1507531,
    "lng": -118.0769457
  },
  {
    "id": "15996",
    "name": "Vitamin Shoppe",
    "address": "28152 Willet Way, Wesley Chapel, FL, 33543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1864669,
    "lng": -82.3509108
  },
  {
    "id": "15995",
    "name": "Vitamin Shoppe",
    "address": "1177 Broad Street Suite C, Sumter, SC, 29150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9564017,
    "lng": -80.38161
  },
  {
    "id": "15994",
    "name": "Vitamin Shoppe",
    "address": "12616 Capital Blvd Suite 200, Wake Forest, NC, 27587",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9892004,
    "lng": -78.5305961
  },
  {
    "id": "15993",
    "name": "Vitamin Shoppe",
    "address": "5546 Highway 153 Suite 114, Hixson, TN, 37343",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1467209,
    "lng": -85.2486772
  },
  {
    "id": "15992",
    "name": "Vitamin Shoppe",
    "address": "2545 Vestal Parkway, Vestal, NY, 13850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0956236,
    "lng": -76.006078
  },
  {
    "id": "15991",
    "name": "Vitamin Shoppe",
    "address": "8046 Concord Mills Blvd, Concord, NC, 28027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3722469,
    "lng": -80.71802
  },
  {
    "id": "15990",
    "name": "Vitamin Shoppe",
    "address": "2911 Chapel Hill Rd Suite 100, Douglasville, GA, 30135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.726507,
    "lng": -84.7369024
  },
  {
    "id": "15989",
    "name": "Vitamin Shoppe",
    "address": "12741 Ventura Blvd., Studio City, CA, 91604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1452575,
    "lng": -118.4107794
  },
  {
    "id": "15988",
    "name": "Vitamin Shoppe",
    "address": "16375 N. Merchant Way Suite 110, Nampa, ID, 83687",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6110065,
    "lng": -116.5944933
  },
  {
    "id": "15987",
    "name": "Vitamin Shoppe",
    "address": "6455 Carlisle Pk, Mechanicsburg, PA, 17050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2459876,
    "lng": -77.0144098
  },
  {
    "id": "15986",
    "name": "Vitamin Shoppe",
    "address": "192 East Street Road, Feasterville Trevose, PA, 19053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1486022,
    "lng": -74.9972879
  },
  {
    "id": "15985",
    "name": "Vitamin Shoppe",
    "address": "1650 Mineral Spring Ave, Providence, RI, 2904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8631059,
    "lng": -71.4518979
  },
  {
    "id": "15984",
    "name": "Vitamin Shoppe",
    "address": "10251 South Eastern Ave Suite 130, Henderson, NV, 89052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0033695,
    "lng": -115.1104493
  },
  {
    "id": "15983",
    "name": "Vitamin Shoppe",
    "address": "2313 N Main Street Suite 109, High Point, NC, 27262",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9855835,
    "lng": -80.0252408
  },
  {
    "id": "15982",
    "name": "Vitamin Shoppe",
    "address": "652 Lafayette Road, Seabrook, NH, 3874",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8944223,
    "lng": -70.870843
  },
  {
    "id": "15981",
    "name": "Vitamin Shoppe",
    "address": "2317 North Tarrant Pkwy  Suite 437, Fort Worth, TX, 76177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8991443,
    "lng": -97.3241894
  },
  {
    "id": "15980",
    "name": "Vitamin Shoppe",
    "address": "5505 Capital Blvd Suite 100, Raleigh, NC, 27616",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8608457,
    "lng": -78.5828076
  },
  {
    "id": "15979",
    "name": "Vitamin Shoppe",
    "address": "6501 Southwest 3rd Street Suite A, Oklahoma City, OK, 73128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4620084,
    "lng": -97.6289862
  },
  {
    "id": "15978",
    "name": "Vitamin Shoppe",
    "address": "239 Whiting Farms Rd, Holyoke, MA, 1040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1752606,
    "lng": -72.6408505
  },
  {
    "id": "15977",
    "name": "Vitamin Shoppe",
    "address": "1418 S Yuma Palms Pkwy, Yuma, AZ, 85365",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7019419,
    "lng": -114.6037477
  },
  {
    "id": "15976",
    "name": "Vitamin Shoppe",
    "address": "675 Dawsonville Highway, Gainesville, GA, 30501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.296009,
    "lng": -83.8548196
  },
  {
    "id": "15975",
    "name": "Vitamin Shoppe",
    "address": "6447 Grand Ave Suite A, Gurnee, IL, 60031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3846294,
    "lng": -87.9626671
  },
  {
    "id": "15974",
    "name": "Vitamin Shoppe",
    "address": "1731 Wilmington Pike Suite C, Glen Mills, PA, 19342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8763498,
    "lng": -75.5443647
  },
  {
    "id": "15973",
    "name": "Vitamin Shoppe",
    "address": "5449 Sunset Blvd, Lexington, SC, 29072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9984773,
    "lng": -81.2163677
  },
  {
    "id": "15972",
    "name": "Vitamin Shoppe",
    "address": "423 Lakeside Ave Route 20 West, Boston Post Rd., Marlborough, MA, 1752",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3416401,
    "lng": -71.5795798
  },
  {
    "id": "15971",
    "name": "Vitamin Shoppe",
    "address": "2183 Black Rock Tpke, Fairfield, CT, 6825",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1813285,
    "lng": -73.2529003
  },
  {
    "id": "15970",
    "name": "Vitamin Shoppe",
    "address": "5510 Broadway, Bronx, NY, 10463",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8771398,
    "lng": -73.9056926
  },
  {
    "id": "15969",
    "name": "Vitamin Shoppe",
    "address": "339 West Prien Lake Rd  Suite 300, Lake Charles, LA, 70601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1976627,
    "lng": -93.2253321
  },
  {
    "id": "15968",
    "name": "Vitamin Shoppe",
    "address": "6400 Ridge Rd Suite F2, Sykesville, MD, 21784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.397832,
    "lng": -76.9353565
  },
  {
    "id": "15967",
    "name": "Vitamin Shoppe",
    "address": "230 N Nellis Blvd, Las Vegas, NV, 89110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1635245,
    "lng": -115.061751
  },
  {
    "id": "15966",
    "name": "Vitamin Shoppe",
    "address": "2125 US Hwy 1 South Suite C, St Augustine, FL, 32086",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.860437,
    "lng": -81.323548
  },
  {
    "id": "15965",
    "name": "Vitamin Shoppe",
    "address": "2692 Canyon Springs Pkwy Suite A, Riverside, CA, 92507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9413565,
    "lng": -117.2825905
  },
  {
    "id": "15964",
    "name": "Vitamin Shoppe",
    "address": "2931 Cochran St, Simi Valley, CA, 93065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2792995,
    "lng": -118.7397518
  },
  {
    "id": "15963",
    "name": "Vitamin Shoppe",
    "address": "7040 S. Rainbow Blvd Suite 100, Las Vegas, NV, 89113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0606156,
    "lng": -115.2416896
  },
  {
    "id": "15962",
    "name": "Vitamin Shoppe",
    "address": "21901 Eureka Rd, Taylor, MI, 48180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1976063,
    "lng": -83.2476525
  },
  {
    "id": "15961",
    "name": "Vitamin Shoppe",
    "address": "1190 Main Street, Cuyahoga Falls, OH, 44221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1189241,
    "lng": -81.4851429
  },
  {
    "id": "15960",
    "name": "Vitamin Shoppe",
    "address": "1963 Whiskey Rd, Aiken, SC, 29803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5203625,
    "lng": -81.7185656
  },
  {
    "id": "15959",
    "name": "Vitamin Shoppe",
    "address": "501 N. Berkley Drive Suite J, Goldsboro, NC, 27534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3750807,
    "lng": -77.9452645
  },
  {
    "id": "15958",
    "name": "Vitamin Shoppe",
    "address": "569 A Stillwater Ave, Bangor, ME, 4401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8289117,
    "lng": -68.7538293
  },
  {
    "id": "15957",
    "name": "Vitamin Shoppe",
    "address": "498 Lancaster Drive NE, Salem, OR, 97301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9362618,
    "lng": -122.9826412
  },
  {
    "id": "15956",
    "name": "Vitamin Shoppe",
    "address": "280 Mundy Street Suite 6, Wilkes Barre, PA, 18702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2434957,
    "lng": -75.8429099
  },
  {
    "id": "15955",
    "name": "Vitamin Shoppe",
    "address": "1241 North Main Street, Fuquay Varina, NC, 27526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5922666,
    "lng": -78.7795728
  },
  {
    "id": "15954",
    "name": "Vitamin Shoppe",
    "address": "12687 Middlebelt Rd, Livonia, MI, 48150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3786474,
    "lng": -83.334413
  },
  {
    "id": "15953",
    "name": "Vitamin Shoppe",
    "address": "2298 Foothill Blvd, La Verne, CA, 91750",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.112022,
    "lng": -117.7621512
  },
  {
    "id": "15952",
    "name": "Vitamin Shoppe",
    "address": "4910 East Ray Road Suite 15, Phoenix, AZ, 85044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3204782,
    "lng": -111.9775
  },
  {
    "id": "15951",
    "name": "Vitamin Shoppe",
    "address": "19270 South Dixie Hwy Suite A, Miami, FL, 33157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.588349,
    "lng": -80.3607755
  },
  {
    "id": "15950",
    "name": "Vitamin Shoppe",
    "address": "1516 Rinehart Rd, Sanford, FL, 32771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.8011831,
    "lng": -81.3317118
  },
  {
    "id": "15949",
    "name": "Vitamin Shoppe",
    "address": "1811 S Federal Hwy Suite 102, Delray Beach, FL, 33483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.439342,
    "lng": -80.0709658
  },
  {
    "id": "15948",
    "name": "Vitamin Shoppe",
    "address": "1806 NE 8th Street, Homestead, FL, 33033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.4767604,
    "lng": -80.4524842
  },
  {
    "id": "15947",
    "name": "Vitamin Shoppe",
    "address": "1721 Laskin Road, Virginia Beach, VA, 23454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.849922,
    "lng": -76.0233245
  },
  {
    "id": "15946",
    "name": "Vitamin Shoppe",
    "address": "1285 B Hwy 138, Conyers, GA, 30013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6544726,
    "lng": -84.0038575
  },
  {
    "id": "15945",
    "name": "Vitamin Shoppe",
    "address": "2319 West Roosevelt Blvd. Suite E, Monroe, NC, 28110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0093051,
    "lng": -80.5637875
  },
  {
    "id": "15944",
    "name": "Vitamin Shoppe",
    "address": "9101 Alaking Court Suite 100, Capitol Heights, MD, 20743",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8696925,
    "lng": -76.8495283
  },
  {
    "id": "15943",
    "name": "Vitamin Shoppe",
    "address": "4115 South Grand Canyon Drive Suite 104, Las Vegas, NV, 89147",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1147043,
    "lng": -115.3098123
  },
  {
    "id": "15942",
    "name": "Vitamin Shoppe",
    "address": "108 Chambers Street, New York, NY, 10007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.714854,
    "lng": -74.0082473
  },
  {
    "id": "15941",
    "name": "Vitamin Shoppe",
    "address": "905 NW Chipman Rd., Lee's Summit, MO, 64063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9253056,
    "lng": -94.4005929
  },
  {
    "id": "15940",
    "name": "Vitamin Shoppe",
    "address": "17355 US 441, Mt. Dora, FL, 32757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.8212355,
    "lng": -81.6702586
  },
  {
    "id": "15939",
    "name": "Vitamin Shoppe",
    "address": "435 Winthrop Ave, Lawrence, MA, 1843",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6795287,
    "lng": -71.134245
  },
  {
    "id": "15938",
    "name": "Vitamin Shoppe",
    "address": "103 Elm Street, Enfield, CT, 6082",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9982836,
    "lng": -72.582983
  },
  {
    "id": "15937",
    "name": "Vitamin Shoppe",
    "address": "3660 Central Ave, Riverside, CA, 92506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9533067,
    "lng": -117.3932048
  },
  {
    "id": "15936",
    "name": "Vitamin Shoppe",
    "address": "2350 Jericho Tpke, New Hyde Park, NY, 11040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7417483,
    "lng": -73.6606618
  },
  {
    "id": "15935",
    "name": "Vitamin Shoppe",
    "address": "1063 Montauk Hwy, West Babylon, NY, 11704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6846573,
    "lng": -73.3513094
  },
  {
    "id": "15934",
    "name": "Vitamin Shoppe",
    "address": "4117 Lemmon Ave, Dallas, TX, 75219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8150137,
    "lng": -96.8098429
  },
  {
    "id": "15933",
    "name": "Vitamin Shoppe",
    "address": "19723 Highway 59 N, Humble, TX, 77338",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0040253,
    "lng": -95.2698442
  },
  {
    "id": "15932",
    "name": "Vitamin Shoppe",
    "address": "3325 N Ashland Ave, Chicago, IL, 60657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9422737,
    "lng": -87.6684742
  },
  {
    "id": "15931",
    "name": "Vitamin Shoppe",
    "address": "3303 Alpine Ave, Grand Rapids, MI, 49544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0234552,
    "lng": -85.6899929
  },
  {
    "id": "15930",
    "name": "Vitamin Shoppe",
    "address": "170 Needham St, Newton Upper Falls, MA, 2464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3118555,
    "lng": -71.2127549
  },
  {
    "id": "15929",
    "name": "Vitamin Shoppe",
    "address": "5790 Wade Hampton Rd Suite A, Taylors, SC, 29687",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9346309,
    "lng": -82.2783152
  },
  {
    "id": "15928",
    "name": "Vitamin Shoppe",
    "address": "7670 Winchester Road Suite 103, Memphis, TN, 38125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0506794,
    "lng": -89.8084649
  },
  {
    "id": "15927",
    "name": "Vitamin Shoppe",
    "address": "67 US Highway 9, Morganville, NJ, 7751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3539378,
    "lng": -74.3078796
  },
  {
    "id": "15926",
    "name": "Vitamin Shoppe",
    "address": "4839 C Calhoun Memorial Highway US 123, Easley, SC, 29640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8254831,
    "lng": -82.5445415
  },
  {
    "id": "15925",
    "name": "Vitamin Shoppe",
    "address": "620 Commerce Drive, Fairless Hills, PA, 19030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1861257,
    "lng": -74.8677544
  },
  {
    "id": "15924",
    "name": "Vitamin Shoppe",
    "address": "551 Southpark Blvd, Colonial Heights, VA, 23834",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2431443,
    "lng": -77.3906884
  },
  {
    "id": "15923",
    "name": "Vitamin Shoppe",
    "address": "1220 E Northside Drive Suite 400, Jackson, MS, 39211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3562488,
    "lng": -90.1509434
  },
  {
    "id": "15922",
    "name": "Vitamin Shoppe",
    "address": "116 W Township Line Road Suite 510, Havertown, PA, 19083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9672304,
    "lng": -75.2980367
  },
  {
    "id": "15921",
    "name": "Vitamin Shoppe",
    "address": "610 Cross Keys Road, Sicklerville, NJ, 8081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7349482,
    "lng": -75.0048654
  },
  {
    "id": "15920",
    "name": "Vitamin Shoppe",
    "address": "2700 4th Street North, St. Petersburg, FL, 33704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7968745,
    "lng": -82.6387642
  },
  {
    "id": "15919",
    "name": "Vitamin Shoppe",
    "address": "12136 Lakewood Blvd, Downey, CA, 90242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9256178,
    "lng": -118.1306596
  },
  {
    "id": "15918",
    "name": "Vitamin Shoppe",
    "address": "2229 North 2nd Street, Millville, NJ, 8332",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4255281,
    "lng": -75.0392562
  },
  {
    "id": "15917",
    "name": "Vitamin Shoppe",
    "address": "303 Makaala St, Hilo, HI, 96720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 19.6995055,
    "lng": -155.0640262
  },
  {
    "id": "15916",
    "name": "Vitamin Shoppe",
    "address": "2286 N. Germantown Pkwy Suite 102, Cordova, TN, 38016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1878544,
    "lng": -89.791927
  },
  {
    "id": "15915",
    "name": "Vitamin Shoppe",
    "address": "4875 Bay Road, Saginaw, MI, 48604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4782368,
    "lng": -83.9759557
  },
  {
    "id": "15914",
    "name": "Vitamin Shoppe",
    "address": "489 River Highway Suite D, Mooresville, NC, 28117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5942,
    "lng": -80.865
  },
  {
    "id": "15913",
    "name": "Vitamin Shoppe",
    "address": "5924 W Saginaw Highway Suite A, Lansing, MI, 48917",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.74177,
    "lng": -84.634296
  },
  {
    "id": "15912",
    "name": "Vitamin Shoppe",
    "address": "1628 Shore Parkway, Brooklyn, NY, 11214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5951787,
    "lng": -74.0002082
  },
  {
    "id": "15911",
    "name": "Vitamin Shoppe",
    "address": "1751 Old Country Road, Riverhead, NY, 11901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9238743,
    "lng": -72.7029041
  },
  {
    "id": "15910",
    "name": "Vitamin Shoppe",
    "address": "729 W 21st Street, Norfolk, VA, 23517",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8701332,
    "lng": -76.2950198
  },
  {
    "id": "15909",
    "name": "Vitamin Shoppe",
    "address": "5095 Transit Road Suite 100, Buffalo, NY, 14221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9857704,
    "lng": -78.6961586
  },
  {
    "id": "15908",
    "name": "Vitamin Shoppe",
    "address": "13100 Seminole Blvd, Largo, FL, 33778",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8921375,
    "lng": -82.787692
  },
  {
    "id": "15907",
    "name": "Vitamin Shoppe",
    "address": "300 Commerce Blvd, Stroudsburg, PA, 18360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9984056,
    "lng": -75.26331
  },
  {
    "id": "15906",
    "name": "Vitamin Shoppe",
    "address": "3329 Cobb Pkwy, Acworth, GA, 30101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0347432,
    "lng": -84.6818726
  },
  {
    "id": "15905",
    "name": "Vitamin Shoppe",
    "address": "148 Route 73, Voorhees, NJ, 8043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8349607,
    "lng": -74.9251701
  },
  {
    "id": "15904",
    "name": "Vitamin Shoppe",
    "address": "463 E Aurora Road, Macedonia, OH, 44056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3144468,
    "lng": -81.5220127
  },
  {
    "id": "15903",
    "name": "Vitamin Shoppe",
    "address": "414 Randall Road, South Elgin, IL, 60177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9830687,
    "lng": -88.3416341
  },
  {
    "id": "15902",
    "name": "Vitamin Shoppe",
    "address": "661 W 181st St, New York, NY, 10033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8501834,
    "lng": -73.9354343
  },
  {
    "id": "15901",
    "name": "Vitamin Shoppe",
    "address": "2315 Forest Dr, Annapolis, MD, 21401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9781171,
    "lng": -76.5439574
  },
  {
    "id": "15900",
    "name": "Vitamin Shoppe",
    "address": "1936 South Rd, Poughkeepsie, NY, 12601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6214919,
    "lng": -73.9166011
  },
  {
    "id": "15899",
    "name": "Vitamin Shoppe",
    "address": "3725-B Richmond Hwy, Alexandria, VA, 22305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8382023,
    "lng": -77.0515442
  },
  {
    "id": "15898",
    "name": "Vitamin Shoppe",
    "address": "1817 Old York Rd, Abington, PA, 19001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1351856,
    "lng": -75.1143563
  },
  {
    "id": "15897",
    "name": "Vitamin Shoppe",
    "address": "1320 Stony Brook Rd, Stony Brook, NY, 11790",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8772318,
    "lng": -73.119332
  },
  {
    "id": "15896",
    "name": "Vitamin Shoppe",
    "address": "2130 Pleasant Hill Rd, Duluth, GA, 30096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9579605,
    "lng": -84.1332481
  },
  {
    "id": "15895",
    "name": "Vitamin Shoppe",
    "address": "3261 Peachtree Rd, Atlanta, GA, 30305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8440658,
    "lng": -84.3698535
  },
  {
    "id": "15894",
    "name": "Vitamin Shoppe",
    "address": "1490 Nixon Dr, Mount Laurel, NJ, 8054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9432622,
    "lng": -74.9573634
  },
  {
    "id": "15893",
    "name": "Vitamin Shoppe",
    "address": "1313 York Rd, Lutherville Timonium, MD, 21093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4184836,
    "lng": -76.6148707
  },
  {
    "id": "15892",
    "name": "Vitamin Shoppe",
    "address": "1003 High Ridge Rd, Stamford, CT, 6905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1058146,
    "lng": -73.5477718
  },
  {
    "id": "15891",
    "name": "Vitamin Shoppe",
    "address": "10800 Pines Blvd, Hollywood, FL, 33026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0072328,
    "lng": -80.2912466
  },
  {
    "id": "15890",
    "name": "Vitamin Shoppe",
    "address": "8707 S W 124th Ave, Miami, FL, 33183",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6872291,
    "lng": -80.3928702
  },
  {
    "id": "15889",
    "name": "Vitamin Shoppe",
    "address": "20600 Lyons Rd, Boca Raton, FL, 33434",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3694417,
    "lng": -80.186068
  },
  {
    "id": "15888",
    "name": "Vitamin Shoppe",
    "address": "102 North Dale Mabry Highway, Tampa, FL, 33609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9451286,
    "lng": -82.5060883
  },
  {
    "id": "15887",
    "name": "Vitamin Shoppe",
    "address": "2408 West Memorial Rd, Oklahoma City, OK, 73134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6081565,
    "lng": -97.5569268
  },
  {
    "id": "15886",
    "name": "Vitamin Shoppe",
    "address": "1815 Palm Beach Lakes Blvd, West Palm Beach, FL, 33401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7218689,
    "lng": -80.0877047
  },
  {
    "id": "15885",
    "name": "Vitamin Shoppe",
    "address": "1490 S. Hanley Rd, St Louis, MO, 63144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6266764,
    "lng": -90.3346351
  },
  {
    "id": "15884",
    "name": "Vitamin Shoppe",
    "address": "6310 West 95th Street, Oak Lawn, IL, 60453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7198193,
    "lng": -87.7788686
  },
  {
    "id": "15883",
    "name": "Vitamin Shoppe",
    "address": "440 South Rand Rd, Lake Zurich, IL, 60047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1910383,
    "lng": -88.1069032
  },
  {
    "id": "15882",
    "name": "Vitamin Shoppe",
    "address": "12970 Cortez Blvd, Brooksville, FL, 34613",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5328462,
    "lng": -82.5138144
  },
  {
    "id": "15881",
    "name": "Vitamin Shoppe",
    "address": "2383 Cottman Ave, Philadelphia, PA, 19149",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0468454,
    "lng": -75.0554792
  },
  {
    "id": "15880",
    "name": "Vitamin Shoppe",
    "address": "4015 Veterans Memorial Blvd, Metairie, LA, 70002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0051215,
    "lng": -90.1752342
  },
  {
    "id": "15879",
    "name": "Vitamin Shoppe",
    "address": "3025 East Main Street, Cortlandt Manor, NY, 10567",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3077309,
    "lng": -73.8753066
  },
  {
    "id": "15878",
    "name": "Vitamin Shoppe",
    "address": "40 Orchard Hill Park Drive, Leominster, MA, 1453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5248792,
    "lng": -71.7133584
  },
  {
    "id": "15877",
    "name": "Vitamin Shoppe",
    "address": "103 A Commerce Way, Woburn, MA, 1801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5175345,
    "lng": -71.1371462
  },
  {
    "id": "15876",
    "name": "Vitamin Shoppe",
    "address": "4302 East McCain Blvd, North Little Rock, AR, 72117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7889436,
    "lng": -92.2194277
  },
  {
    "id": "15875",
    "name": "Vitamin Shoppe",
    "address": "10000 US-20, Perrysburg, OH, 43551",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5445854,
    "lng": -83.5878966
  },
  {
    "id": "15874",
    "name": "Vitamin Shoppe",
    "address": "1428 Route 23 North, Wayne, NJ, 7470",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9324931,
    "lng": -74.2682408
  },
  {
    "id": "15873",
    "name": "Vitamin Shoppe",
    "address": "4005 Grand Ave, Chino, CA, 91710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9967759,
    "lng": -117.7166506
  },
  {
    "id": "15872",
    "name": "Vitamin Shoppe",
    "address": "3901 Phoenix Ave, Fort Smith, AR, 72903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.339008,
    "lng": -94.3898826
  },
  {
    "id": "15871",
    "name": "Vitamin Shoppe",
    "address": "1478 Harrisburg Pike, Lancaster, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0638862,
    "lng": -76.3417377
  },
  {
    "id": "15870",
    "name": "Vitamin Shoppe",
    "address": "2602 Hylan Blvd, Staten Island, NY, 10306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5679078,
    "lng": -74.1114706
  },
  {
    "id": "15869",
    "name": "Vitamin Shoppe",
    "address": "1255 Raritan Rd., Clark, NJ, 7066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6309349,
    "lng": -74.3070088
  },
  {
    "id": "15868",
    "name": "Vitamin Shoppe",
    "address": "10266 Two Notch Road, Columbia, SC, 29229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1224304,
    "lng": -80.8743159
  },
  {
    "id": "15867",
    "name": "Vitamin Shoppe",
    "address": "238 Robert C. Daniel JR Parkway, Augusta, GA, 30909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4894286,
    "lng": -82.0793125
  },
  {
    "id": "15866",
    "name": "Vitamin Shoppe",
    "address": "2350 Southwest Military Drive, San Antonio, TX, 78224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.3562773,
    "lng": -98.532537
  },
  {
    "id": "15865",
    "name": "Vitamin Shoppe",
    "address": "2820 Loop 250 Frontage Road, Midland, TX, 79705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0363341,
    "lng": -102.1233897
  },
  {
    "id": "15864",
    "name": "Vitamin Shoppe",
    "address": "1974 N. Main Street, Salinas, CA, 93906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7201806,
    "lng": -121.6555369
  },
  {
    "id": "15863",
    "name": "Vitamin Shoppe",
    "address": "13662 Jamboree Road, Irvine, CA, 92602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.721232,
    "lng": -117.7927195
  },
  {
    "id": "15862",
    "name": "Vitamin Shoppe",
    "address": "1345 Western Blvd, Jacksonville, NC, 28546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7862974,
    "lng": -77.4025511
  },
  {
    "id": "15861",
    "name": "Vitamin Shoppe",
    "address": "2807 Wilma Rudolph Blvd, Clarksville, TN, 37040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5877541,
    "lng": -87.2911275
  },
  {
    "id": "15860",
    "name": "Vitamin Shoppe",
    "address": "5702 Johnston Street, Lafayette, LA, 70503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.176014,
    "lng": -92.077459
  },
  {
    "id": "15859",
    "name": "Vitamin Shoppe",
    "address": "30 Worcester Road, Framingham, MA, 1702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2981951,
    "lng": -71.3943591
  },
  {
    "id": "15858",
    "name": "Vitamin Shoppe",
    "address": "601 West Roosevelt Blvd, Chicago, IL, 60607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8670188,
    "lng": -87.6423401
  },
  {
    "id": "15857",
    "name": "Vitamin Shoppe",
    "address": "1303 North Milwaukee Ave, Chicago, IL, 60622",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.90548,
    "lng": -87.6695578
  },
  {
    "id": "15856",
    "name": "Vitamin Shoppe",
    "address": "4254 Tamiami Trail S., Venice, FL, 34293",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0491268,
    "lng": -82.3928518
  },
  {
    "id": "15855",
    "name": "Vitamin Shoppe",
    "address": "5575 Balboa Ave, San Diego, CA, 92111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8195072,
    "lng": -117.1805615
  },
  {
    "id": "15854",
    "name": "Vitamin Shoppe",
    "address": "8922 S Broadway Ave, Tyler, TX, 75703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2508158,
    "lng": -95.3077183
  },
  {
    "id": "15853",
    "name": "Vitamin Shoppe",
    "address": "123 North Weber Road, Bolingbrook, IL, 60490",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6970425,
    "lng": -88.123762
  },
  {
    "id": "15852",
    "name": "Vitamin Shoppe",
    "address": "10343 Indianapolis Blvd, Highland, IN, 46322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5253251,
    "lng": -87.4705351
  },
  {
    "id": "15851",
    "name": "Vitamin Shoppe",
    "address": "17143 Mercantile Blvd, Noblesville, IN, 46060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0376467,
    "lng": -85.9941563
  },
  {
    "id": "15850",
    "name": "Vitamin Shoppe",
    "address": "3719 Boston Street, Baltimore, MD, 21224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2767074,
    "lng": -76.5645971
  },
  {
    "id": "15849",
    "name": "Vitamin Shoppe",
    "address": "1789 Oconee Connector, Athens, GA, 30606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9175945,
    "lng": -83.4554143
  },
  {
    "id": "15848",
    "name": "Vitamin Shoppe",
    "address": "4741 Firestone Blvd, South Gate, CA, 90280",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9525102,
    "lng": -118.1851476
  },
  {
    "id": "15847",
    "name": "Vitamin Shoppe",
    "address": "500 E. Danenberg Drive, El Centro, CA, 92243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7680774,
    "lng": -115.5345228
  },
  {
    "id": "15846",
    "name": "Vitamin Shoppe",
    "address": "7713 Fordson Road, Alexandria, VA, 22306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7488007,
    "lng": -77.082514
  },
  {
    "id": "15845",
    "name": "Vitamin Shoppe",
    "address": "1803 N. Loop 1604 E., San Antonio, TX, 78232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6093318,
    "lng": -98.464796
  },
  {
    "id": "15844",
    "name": "Vitamin Shoppe",
    "address": "4207 W. 41st Street, Sioux Falls, SD, 57106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.5143655,
    "lng": -96.7776328
  },
  {
    "id": "15843",
    "name": "Vitamin Shoppe",
    "address": "1615 E Monte Vista Ave, Vacaville, CA, 95688",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3670003,
    "lng": -121.9638858
  },
  {
    "id": "15842",
    "name": "Vitamin Shoppe",
    "address": "167 Gateway Drive, Macon, GA, 31210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9279745,
    "lng": -83.7124828
  },
  {
    "id": "15841",
    "name": "Vitamin Shoppe",
    "address": "3831 Edwards Road, Cincinnati, OH, 45209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1501979,
    "lng": -84.4426199
  },
  {
    "id": "15840",
    "name": "Vitamin Shoppe",
    "address": "2300 16th Street, San Francisco, CA, 94103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.766469,
    "lng": -122.4095835
  },
  {
    "id": "15839",
    "name": "Vitamin Shoppe",
    "address": "6005 S. LaGrange Road, La Grange, IL, 60525",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7809848,
    "lng": -87.8672126
  },
  {
    "id": "15838",
    "name": "Vitamin Shoppe",
    "address": "6640 N. Durango Drive, Las Vegas, NV, 89149",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2811498,
    "lng": -115.2863977
  },
  {
    "id": "15837",
    "name": "Vitamin Shoppe",
    "address": "1326 Kings Highway, Brooklyn, NY, 11229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6081631,
    "lng": -73.9592516
  },
  {
    "id": "15836",
    "name": "Vitamin Shoppe",
    "address": "2152 Contra Costa Blvd, Pleasant Hill, CA, 94523",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9477147,
    "lng": -122.059841
  },
  {
    "id": "15835",
    "name": "Vitamin Shoppe",
    "address": "950 County Road 64, Elmira, NY, 14903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1528948,
    "lng": -76.8722762
  },
  {
    "id": "15834",
    "name": "Vitamin Shoppe",
    "address": "5400 Brodie Lane, Austin, TX, 78745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2296693,
    "lng": -97.8224335
  },
  {
    "id": "15833",
    "name": "Vitamin Shoppe",
    "address": "3975 Camino De La Plaza, San Ysidro, CA, 92173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5443647,
    "lng": -117.0460779
  },
  {
    "id": "15832",
    "name": "Vitamin Shoppe",
    "address": "4329 N Oracle Road, Tucson, AZ, 85705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2852739,
    "lng": -110.9788384
  },
  {
    "id": "15831",
    "name": "Vitamin Shoppe",
    "address": "20580 Haggerty Road, Northville, MI, 48167",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4376292,
    "lng": -83.4348811
  },
  {
    "id": "15830",
    "name": "Vitamin Shoppe",
    "address": "3734 Fallon Road, Dublin, CA, 94568",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7037504,
    "lng": -121.8512351
  },
  {
    "id": "15829",
    "name": "Vitamin Shoppe",
    "address": "27820 Chagrin Blvd, Beachwood, OH, 44122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.461892,
    "lng": -81.482398
  },
  {
    "id": "15828",
    "name": "Vitamin Shoppe",
    "address": "1315 Battlefield Road, Springfield, MO, 65804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.1599556,
    "lng": -93.2738054
  },
  {
    "id": "15827",
    "name": "Vitamin Shoppe",
    "address": "2104 Maple Grove Road, Duluth, MN, 55811",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8067827,
    "lng": -92.1639772
  },
  {
    "id": "15826",
    "name": "Vitamin Shoppe",
    "address": "1400 South Washington St, North Attleboro, MA, 2760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9348637,
    "lng": -71.3503813
  },
  {
    "id": "15825",
    "name": "Vitamin Shoppe",
    "address": "1205 Herndon Ave, Clovis, CA, 93612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8380305,
    "lng": -119.6941858
  },
  {
    "id": "15824",
    "name": "Vitamin Shoppe",
    "address": "5226 Monticello Ave, Williamsburg, VA, 23188",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2771232,
    "lng": -76.7465927
  },
  {
    "id": "15823",
    "name": "Vitamin Shoppe",
    "address": "3862 Dryland Way, Easton, PA, 18045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7128272,
    "lng": -75.2840967
  },
  {
    "id": "15822",
    "name": "Vitamin Shoppe",
    "address": "4041 Division Street, St. Cloud, MN, 56301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5537511,
    "lng": -94.2082964
  },
  {
    "id": "15821",
    "name": "Vitamin Shoppe",
    "address": "4567 Garth Road, Baytown, TX, 77521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7752232,
    "lng": -94.9785014
  },
  {
    "id": "15820",
    "name": "Vitamin Shoppe",
    "address": "6900 Hollister Ave, Goleta, CA, 93117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4304273,
    "lng": -119.8700849
  },
  {
    "id": "15819",
    "name": "Vitamin Shoppe",
    "address": "5946 East State Street, Rockford, IL, 61108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2674262,
    "lng": -89.0004543
  },
  {
    "id": "15818",
    "name": "Vitamin Shoppe",
    "address": "880 N Federal Highway, Boca Raton, FL, 33432",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3582509,
    "lng": -80.0846806
  },
  {
    "id": "15817",
    "name": "Vitamin Shoppe",
    "address": "1200 El Camino Real, Redwood City, CA, 94063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4823232,
    "lng": -122.2304895
  },
  {
    "id": "15816",
    "name": "Vitamin Shoppe",
    "address": "8889 Gateway, El Paso, TX, 79925",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7715049,
    "lng": -106.3751015
  },
  {
    "id": "15815",
    "name": "Vitamin Shoppe",
    "address": "7601 Andrea Drive, Baton Rouge, LA, 70809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3787928,
    "lng": -91.0659754
  },
  {
    "id": "15814",
    "name": "Vitamin Shoppe",
    "address": "1438 Highway 20 West, McDonough, GA, 30253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4231171,
    "lng": -84.1868687
  },
  {
    "id": "15813",
    "name": "Vitamin Shoppe",
    "address": "1300 N. Tustin Ave, Orange, CA, 92867",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8095042,
    "lng": -117.836134
  },
  {
    "id": "15812",
    "name": "Vitamin Shoppe",
    "address": "7000 Peach Street, Erie, PA, 16509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0547597,
    "lng": -80.0884774
  },
  {
    "id": "15811",
    "name": "Vitamin Shoppe",
    "address": "Rafael Cordero Ave Lot A-1, Caguas, PR, 725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.2410648,
    "lng": -66.0271603
  },
  {
    "id": "15810",
    "name": "Vitamin Shoppe",
    "address": "78-692 Highway 111, La Quinta, CA, 92253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.713894,
    "lng": -116.2927004
  },
  {
    "id": "15809",
    "name": "Vitamin Shoppe",
    "address": "24280 Valencia Blvd, Valencia, CA, 91355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4128936,
    "lng": -118.5588597
  },
  {
    "id": "15808",
    "name": "Vitamin Shoppe",
    "address": "30 Forbes Road, Braintree, MA, 2184",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2199611,
    "lng": -71.0300905
  },
  {
    "id": "15807",
    "name": "Vitamin Shoppe",
    "address": "4327 Candlewood Street, Lakewood, CA, 90712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8542706,
    "lng": -118.1414804
  },
  {
    "id": "15806",
    "name": "Vitamin Shoppe",
    "address": "1987 County Road D, St. Paul, MN, 55109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.036166,
    "lng": -93.0171748
  },
  {
    "id": "15805",
    "name": "Vitamin Shoppe",
    "address": "7305 San Dario Ave, Laredo, TX, 78045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.5684685,
    "lng": -99.5016131
  },
  {
    "id": "15804",
    "name": "Vitamin Shoppe",
    "address": "61 Rossanley Drive, Medford, OR, 97501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3434877,
    "lng": -122.8828375
  },
  {
    "id": "15803",
    "name": "Vitamin Shoppe",
    "address": "2802 SW Plaza Drive, Springfield, IL, 62704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7586287,
    "lng": -89.7072676
  },
  {
    "id": "15802",
    "name": "Vitamin Shoppe",
    "address": "8247 E. 71st Street, Tulsa, OK, 74133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0614391,
    "lng": -95.8837412
  },
  {
    "id": "15801",
    "name": "Vitamin Shoppe",
    "address": "3691 28th Street Southeast, Grand Rapids, MI, 49512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9128234,
    "lng": -85.5772495
  },
  {
    "id": "15800",
    "name": "Vitamin Shoppe",
    "address": "5545 E. Broadway Blvd, Tucson, AZ, 85711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2219749,
    "lng": -110.8748507
  },
  {
    "id": "15799",
    "name": "Vitamin Shoppe",
    "address": "13714 W. Bell Road, Surprise, AZ, 85374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6390268,
    "lng": -112.3531146
  },
  {
    "id": "15798",
    "name": "Vitamin Shoppe",
    "address": "1995 W Jefferson Ave, Naperville, IL, 60540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7705767,
    "lng": -88.2049141
  },
  {
    "id": "15797",
    "name": "Vitamin Shoppe",
    "address": "115 Colma Blvd, Daly City, CA, 94014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6770402,
    "lng": -122.4672239
  },
  {
    "id": "15796",
    "name": "Vitamin Shoppe",
    "address": "18199 Biscayne Blvd, North Miami Beach, FL, 33160",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9434017,
    "lng": -80.1476557
  },
  {
    "id": "15795",
    "name": "Vitamin Shoppe",
    "address": "2501 W 95th Street, Evergreen Park, IL, 60805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7208397,
    "lng": -87.6847482
  },
  {
    "id": "15794",
    "name": "Vitamin Shoppe",
    "address": "7140 Mc Cormick Blvd, Lincolnwood, IL, 60712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.010429,
    "lng": -87.7120787
  },
  {
    "id": "15793",
    "name": "Vitamin Shoppe",
    "address": "4000 Towne Center Drive, Louisville, KY, 40241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2974018,
    "lng": -85.554817
  },
  {
    "id": "15792",
    "name": "Vitamin Shoppe",
    "address": "6996 France Ave, Minneapolis, MN, 55435",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8765775,
    "lng": -93.3293691
  },
  {
    "id": "15791",
    "name": "Vitamin Shoppe",
    "address": "61-35 Junction Boulevard, Rego Park, NY, 11374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7332336,
    "lng": -73.8638164
  },
  {
    "id": "15790",
    "name": "Vitamin Shoppe",
    "address": "10515 S. State Street, Sandy, UT, 84070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.560218,
    "lng": -111.8904637
  },
  {
    "id": "15789",
    "name": "Vitamin Shoppe",
    "address": "291 South Broadway, Salem, NH, 3079",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7583317,
    "lng": -71.2118964
  },
  {
    "id": "15788",
    "name": "Vitamin Shoppe",
    "address": "901A W. Anthony Drive, Champaign, IL, 61820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1378238,
    "lng": -88.2585356
  },
  {
    "id": "15787",
    "name": "Vitamin Shoppe",
    "address": "201 East Central Texas Expressway, Harker Heights, TX, 76548",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.072017,
    "lng": -97.665831
  },
  {
    "id": "15786",
    "name": "Vitamin Shoppe",
    "address": "3404/06 South 144th Street, Omaha, NE, 68144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2275871,
    "lng": -96.1394234
  },
  {
    "id": "15785",
    "name": "Vitamin Shoppe",
    "address": "3538 Zafarano Drive, Santa Fe, NM, 87507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6413589,
    "lng": -106.0134159
  },
  {
    "id": "15784",
    "name": "Vitamin Shoppe",
    "address": "16624 Ventura Blvd, Encino, CA, 91436",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.157695,
    "lng": -118.4954903
  },
  {
    "id": "15783",
    "name": "Vitamin Shoppe",
    "address": "437 Balltown Road, Schenectady, NY, 12304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7725268,
    "lng": -73.8939568
  },
  {
    "id": "15782",
    "name": "Vitamin Shoppe",
    "address": "130 Rte 17 North, East Rutherford, NJ, 7073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8305634,
    "lng": -74.0895606
  },
  {
    "id": "15781",
    "name": "Vitamin Shoppe",
    "address": "2555 Prado Lane, Marietta, GA, 30066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0146506,
    "lng": -84.5530924
  },
  {
    "id": "15780",
    "name": "Vitamin Shoppe",
    "address": "148 Tunnel Road, Asheville, NC, 28805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5905254,
    "lng": -82.5298296
  },
  {
    "id": "15779",
    "name": "Vitamin Shoppe",
    "address": "1777 West County Road B2, St Paul, MN, 55113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0153982,
    "lng": -93.1753538
  },
  {
    "id": "15778",
    "name": "Vitamin Shoppe",
    "address": "15811 N. Frank Lloyd Wright, Scottsdale, AZ, 85260",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6301782,
    "lng": -111.8892301
  },
  {
    "id": "15777",
    "name": "Vitamin Shoppe",
    "address": "Ave. San Patricio, Guaynabo, PR, 968",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.3993379,
    "lng": -66.097285
  },
  {
    "id": "15776",
    "name": "Vitamin Shoppe",
    "address": "1031 North Green River Rd, Evansville, IN, 47715",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9863231,
    "lng": -87.4920783
  },
  {
    "id": "15775",
    "name": "Vitamin Shoppe",
    "address": "2210 N. Rock Road, Wichita, KS, 67226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7235493,
    "lng": -97.2440627
  },
  {
    "id": "15774",
    "name": "Vitamin Shoppe",
    "address": "19510 Hawthorne Blvd, Torrance, CA, 90503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8539875,
    "lng": -118.3533629
  },
  {
    "id": "15773",
    "name": "Vitamin Shoppe",
    "address": "7749 Day Drive, Cleveland, OH, 44129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3797218,
    "lng": -81.7378915
  },
  {
    "id": "15772",
    "name": "Vitamin Shoppe",
    "address": "1730 Massey Boulevard, Hagerstown, MD, 21740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6275075,
    "lng": -77.7670088
  },
  {
    "id": "15771",
    "name": "Vitamin Shoppe",
    "address": "7180 W Cermak Road, Berwyn, IL, 60402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8507447,
    "lng": -87.8033436
  },
  {
    "id": "15770",
    "name": "Vitamin Shoppe",
    "address": "243 S. Kings Drive, Charlotte, NC, 28204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2135534,
    "lng": -80.8335836
  },
  {
    "id": "15769",
    "name": "Vitamin Shoppe",
    "address": "2838 Wilshire Blvd, Santa Monica, CA, 90403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0380594,
    "lng": -118.474619
  },
  {
    "id": "15768",
    "name": "Vitamin Shoppe",
    "address": "5270 Elmore Ave, Davenport, IA, 52807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5732239,
    "lng": -90.5293994
  },
  {
    "id": "15767",
    "name": "Vitamin Shoppe",
    "address": "1315  Churn Creek Rd, Redding, CA, 96003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5882479,
    "lng": -122.3503207
  },
  {
    "id": "15766",
    "name": "Vitamin Shoppe",
    "address": "7929 Abercorn St, Savannah, GA, 31406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0024514,
    "lng": -81.1257699
  },
  {
    "id": "15765",
    "name": "Vitamin Shoppe",
    "address": "7025 S. Lindbergh Blvd, St. Louis, MO, 63125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5090095,
    "lng": -90.3305046
  },
  {
    "id": "15764",
    "name": "Vitamin Shoppe",
    "address": "8929 Avenue D, Brooklyn, NY, 11236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.645974,
    "lng": -73.9130453
  },
  {
    "id": "15763",
    "name": "Vitamin Shoppe",
    "address": "3312 Greenwald Way North, Kissimmee, FL, 34741",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3468021,
    "lng": -81.4189913
  },
  {
    "id": "15762",
    "name": "Vitamin Shoppe",
    "address": "3815 Metro Drive, Council Bluffs, IA, 51501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2209073,
    "lng": -95.8361291
  },
  {
    "id": "15761",
    "name": "Vitamin Shoppe",
    "address": "205-04 Northern Blvd, Bayside, NY, 11361",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7577827,
    "lng": -73.778119
  },
  {
    "id": "15760",
    "name": "Vitamin Shoppe",
    "address": "6105 O Street, Lincoln, NE, 68510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8130209,
    "lng": -96.637966
  },
  {
    "id": "15759",
    "name": "Vitamin Shoppe",
    "address": "338 Mid Rivers Center Dr, St Peters, MO, 63376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7953225,
    "lng": -90.6212677
  },
  {
    "id": "15758",
    "name": "Vitamin Shoppe",
    "address": "77A Boston Turnpike, Shrewsbury, MA, 1545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2750921,
    "lng": -71.7511501
  },
  {
    "id": "15757",
    "name": "Vitamin Shoppe",
    "address": "1505 Hilliard Rome Road, Columbus, OH, 43228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9822658,
    "lng": -83.1515752
  },
  {
    "id": "15756",
    "name": "Vitamin Shoppe",
    "address": "984 Route 17 North, Ramsey, NJ, 7446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0661237,
    "lng": -74.1311071
  },
  {
    "id": "15755",
    "name": "Vitamin Shoppe",
    "address": "1141 N. Dupont Hwy, Dover, DE, 19901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1868196,
    "lng": -75.5366317
  },
  {
    "id": "15754",
    "name": "Vitamin Shoppe",
    "address": "9 W 62nd Terrace, Kansas City, MO, 64113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0145514,
    "lng": -94.588844
  },
  {
    "id": "15753",
    "name": "Vitamin Shoppe",
    "address": "409 Cox Rd, Gastonia, NC, 28054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2628384,
    "lng": -81.1340431
  },
  {
    "id": "15752",
    "name": "Vitamin Shoppe",
    "address": "1035 IH-30, Rockwall, TX, 75087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9052003,
    "lng": -96.4523805
  },
  {
    "id": "15751",
    "name": "Vitamin Shoppe",
    "address": "2971 Watson Blvd, Warner Robins, GA, 31093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6176298,
    "lng": -83.6871535
  },
  {
    "id": "15750",
    "name": "Vitamin Shoppe",
    "address": "1740 Arden Way, Sacramento, CA, 95815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5983564,
    "lng": -121.4257676
  },
  {
    "id": "15749",
    "name": "Vitamin Shoppe",
    "address": "1350 Winston Plaza, Melrose Park, IL, 60160",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9076159,
    "lng": -87.8501795
  },
  {
    "id": "15748",
    "name": "Vitamin Shoppe",
    "address": "335 Maine Mall Rd, South Portland, ME, 4106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6354302,
    "lng": -70.3376223
  },
  {
    "id": "15747",
    "name": "Vitamin Shoppe",
    "address": "1511 East Vernon Ave, Bloomington, IL, 61701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5024128,
    "lng": -88.9538612
  },
  {
    "id": "15746",
    "name": "Vitamin Shoppe",
    "address": "4145 William Penn Hwy, Monroeville, PA, 15146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4393825,
    "lng": -79.7658542
  },
  {
    "id": "15745",
    "name": "Vitamin Shoppe",
    "address": "8655 Coral Way, Miami, FL, 33155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7481957,
    "lng": -80.3342007
  },
  {
    "id": "15744",
    "name": "Vitamin Shoppe",
    "address": "1540 Olentangy River Rd, Columbus, OH, 43212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9924567,
    "lng": -83.0252491
  },
  {
    "id": "15743",
    "name": "Vitamin Shoppe",
    "address": "625 Baltimore Blvd, Westminster, MD, 21157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.562399,
    "lng": -76.9720696
  },
  {
    "id": "15742",
    "name": "Vitamin Shoppe",
    "address": "4053 Morse Crossing, Columbus, OH, 43219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0530523,
    "lng": -82.9206998
  },
  {
    "id": "15741",
    "name": "Vitamin Shoppe",
    "address": "655 Sunland Park Dr, El Paso, TX, 79912",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8213126,
    "lng": -106.5410061
  },
  {
    "id": "15740",
    "name": "Vitamin Shoppe",
    "address": "5525 Urbana Pike, Frederick, MD, 21704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3841959,
    "lng": -77.4011161
  },
  {
    "id": "15739",
    "name": "Vitamin Shoppe",
    "address": "3904 Hillsboro Pike, Nashville, TN, 37215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.105305,
    "lng": -86.813613
  },
  {
    "id": "15738",
    "name": "Vitamin Shoppe",
    "address": "126 East El Camino Real, Sunnyvale, CA, 94087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3666995,
    "lng": -122.0314918
  },
  {
    "id": "15737",
    "name": "Vitamin Shoppe",
    "address": "9950 Waterstone Blvd, Cincinnati, OH, 45249",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2920976,
    "lng": -84.3058367
  },
  {
    "id": "15736",
    "name": "Vitamin Shoppe",
    "address": "1501 W.O Ezell Blvd, Spartanburg, SC, 29301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9362685,
    "lng": -81.9881229
  },
  {
    "id": "15735",
    "name": "Vitamin Shoppe",
    "address": "10110 East Washington St, Indianapolis, IN, 46229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7754997,
    "lng": -85.9880003
  },
  {
    "id": "15734",
    "name": "Vitamin Shoppe",
    "address": "5704 Youngstown Warren Rd, Niles, OH, 44446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2095196,
    "lng": -80.7494593
  },
  {
    "id": "15733",
    "name": "Vitamin Shoppe",
    "address": "10201-A Katy Freeway, Houston, TX, 77024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7833551,
    "lng": -95.5480314
  },
  {
    "id": "15732",
    "name": "Vitamin Shoppe",
    "address": "2385 Brandermill Blvd, Gambrills, MD, 21054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.032698,
    "lng": -76.683637
  },
  {
    "id": "15731",
    "name": "Vitamin Shoppe",
    "address": "6026 Baltimore National Pike, Catonsville, MD, 21228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2854151,
    "lng": -76.7453995
  },
  {
    "id": "15730",
    "name": "Vitamin Shoppe",
    "address": "311 East Fordham Rd, Bronx, NY, 10458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8624298,
    "lng": -73.894327
  },
  {
    "id": "15729",
    "name": "Vitamin Shoppe",
    "address": "35825 Detroit Rd, Avon, OH, 44011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4581837,
    "lng": -82.0166699
  },
  {
    "id": "15728",
    "name": "Vitamin Shoppe",
    "address": "14065 Shoppers Best Way, Woodbridge, VA, 22192",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6510818,
    "lng": -77.2985617
  },
  {
    "id": "15727",
    "name": "Vitamin Shoppe",
    "address": "4750 Valley View Blvd. NW, Roanoke, VA, 24012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3017722,
    "lng": -79.9564148
  },
  {
    "id": "15726",
    "name": "Vitamin Shoppe",
    "address": "3659 Airport Blvd, Mobile, AL, 36608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6755451,
    "lng": -88.1316552
  },
  {
    "id": "15725",
    "name": "Vitamin Shoppe",
    "address": "510 N. Thompson Lane, Murfreesboro, TN, 37129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8561308,
    "lng": -86.4297207
  },
  {
    "id": "15724",
    "name": "Vitamin Shoppe",
    "address": "31 East City Ave, Bala Cynwyd, PA, 19004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0024678,
    "lng": -75.2251233
  },
  {
    "id": "15723",
    "name": "Vitamin Shoppe",
    "address": "1590 North Clybourn Ave, Chicago, IL, 60642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9104343,
    "lng": -87.6492881
  },
  {
    "id": "15722",
    "name": "Vitamin Shoppe",
    "address": "417 Universal Drive North, North Haven, CT, 6473",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3572746,
    "lng": -72.8715326
  },
  {
    "id": "15721",
    "name": "Vitamin Shoppe",
    "address": "4012 Eastgate Dr, Orlando, FL, 32839",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4860654,
    "lng": -81.4260626
  },
  {
    "id": "15720",
    "name": "Vitamin Shoppe",
    "address": "1510 SE Everett Mall Way, Everett, WA, 98208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.9122354,
    "lng": -122.2125816
  },
  {
    "id": "15719",
    "name": "Vitamin Shoppe",
    "address": "1165 Perimeter Center West, Atlanta, GA, 30338",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9290295,
    "lng": -84.3494397
  },
  {
    "id": "15718",
    "name": "Vitamin Shoppe",
    "address": "7508 Mall Rd, Florence, KY, 41042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0018141,
    "lng": -84.65264
  },
  {
    "id": "15717",
    "name": "Vitamin Shoppe",
    "address": "34737 Emerald Parkway, Destin, FL, 32541",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.387505,
    "lng": -86.4387579
  },
  {
    "id": "15716",
    "name": "Vitamin Shoppe",
    "address": "1713 Montgomery Hwy, Birmingham, AL, 35244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3819167,
    "lng": -86.8044979
  },
  {
    "id": "15715",
    "name": "Vitamin Shoppe",
    "address": "6434 Naples Blvd, Naples, FL, 34109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2184557,
    "lng": -81.7690681
  },
  {
    "id": "15714",
    "name": "Vitamin Shoppe",
    "address": "701 SE Greenville Blvd., Greenville, NC, 27858",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5863571,
    "lng": -77.3707092
  },
  {
    "id": "15713",
    "name": "Vitamin Shoppe",
    "address": "20273 Route 19, Cranberry Township, PA, 16066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6897414,
    "lng": -80.1033794
  },
  {
    "id": "15712",
    "name": "Vitamin Shoppe",
    "address": "681 East Golf Road, Schaumburg, IL, 60173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0493079,
    "lng": -88.0628378
  },
  {
    "id": "15711",
    "name": "Vitamin Shoppe",
    "address": "2423 Katy Freeway, Houston, TX, 77007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7763158,
    "lng": -95.3824319
  },
  {
    "id": "15710",
    "name": "Vitamin Shoppe",
    "address": "210 Settlers Ridge Center Dr., Pittsburgh, PA, 15205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4404025,
    "lng": -80.1504031
  },
  {
    "id": "15709",
    "name": "Vitamin Shoppe",
    "address": "14130 Bear Valley Rd, Victorville, CA, 92392",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4708006,
    "lng": -117.3540272
  },
  {
    "id": "15708",
    "name": "Vitamin Shoppe",
    "address": "3301 SW 22nd St, Miami, FL, 33145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.750417,
    "lng": -80.2496863
  },
  {
    "id": "15707",
    "name": "Vitamin Shoppe",
    "address": "3912 Oleander Dr., Wilmington, NC, 28403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2128132,
    "lng": -77.8989343
  },
  {
    "id": "15706",
    "name": "Vitamin Shoppe",
    "address": "23210 Via Villagio, Estero, FL, 33928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4013652,
    "lng": -81.8097644
  },
  {
    "id": "15705",
    "name": "Vitamin Shoppe",
    "address": "383 W. Army Trail Rd., Bloomingdale, IL, 60108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9399843,
    "lng": -88.1144562
  },
  {
    "id": "15704",
    "name": "Vitamin Shoppe",
    "address": "4480 Kapolei Pkway, Kapolei, HI, 96707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.3294068,
    "lng": -158.0929082
  },
  {
    "id": "15703",
    "name": "Vitamin Shoppe",
    "address": "2705 N. Elston Ave., Chicago, IL, 60647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9307698,
    "lng": -87.6854268
  },
  {
    "id": "15702",
    "name": "Vitamin Shoppe",
    "address": "4803 Lincoln Highway, Matteson, IL, 60443",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5056338,
    "lng": -87.7328858
  },
  {
    "id": "15701",
    "name": "Vitamin Shoppe",
    "address": "5 East Kemper Rd, Cincinnati, OH, 45246",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.287463,
    "lng": -84.4664454
  },
  {
    "id": "15700",
    "name": "Vitamin Shoppe",
    "address": "1101 5th St, Miami Beach, FL, 33139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7752524,
    "lng": -80.1402415
  },
  {
    "id": "15699",
    "name": "Vitamin Shoppe",
    "address": "13341 Westheimer Road, Houston, TX, 77077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7353531,
    "lng": -95.6257844
  },
  {
    "id": "15698",
    "name": "Vitamin Shoppe",
    "address": "1740 S. Val Vista Drive, Mesa, AZ, 85204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3831191,
    "lng": -111.754619
  },
  {
    "id": "15697",
    "name": "Vitamin Shoppe",
    "address": "10979 East US Hwy 36, Avon, IN, 46123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7630487,
    "lng": -86.3274162
  },
  {
    "id": "15696",
    "name": "Vitamin Shoppe",
    "address": "237 Stafford Park Blvd, Manahawkin, NJ, 8050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.709825,
    "lng": -74.2862909
  },
  {
    "id": "15695",
    "name": "Vitamin Shoppe",
    "address": "33470 US Hwy 19, Palm Harbor, FL, 34684",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0766148,
    "lng": -82.7398222
  },
  {
    "id": "15694",
    "name": "Vitamin Shoppe",
    "address": "6010 Menaul Blvd NE, Albuquerque, NM, 87110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1086526,
    "lng": -106.5760526
  },
  {
    "id": "15693",
    "name": "Vitamin Shoppe",
    "address": "8948 NW Skyview Ave, Kansas City, MO, 64154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2578407,
    "lng": -94.6520781
  },
  {
    "id": "15692",
    "name": "Vitamin Shoppe",
    "address": "1753 South Willow St, Manchester, NH, 3103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9504597,
    "lng": -71.4352703
  },
  {
    "id": "15691",
    "name": "Vitamin Shoppe",
    "address": "1133 Vann Drive, Jackson, TN, 38305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6657878,
    "lng": -88.8595299
  },
  {
    "id": "15690",
    "name": "Vitamin Shoppe",
    "address": "9935 Coors Blvd, Albuquerque, NM, 87114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1921949,
    "lng": -106.6568987
  },
  {
    "id": "15689",
    "name": "Vitamin Shoppe",
    "address": "11821 Metcalf, Overland Park, KS, 66210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9136676,
    "lng": -94.6669543
  },
  {
    "id": "15688",
    "name": "Vitamin Shoppe",
    "address": "8960 Hudson Rd, St. Paul, MN, 55125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9459232,
    "lng": -92.9223942
  },
  {
    "id": "15687",
    "name": "Vitamin Shoppe",
    "address": "564 N US Highway 441, Lady Lake, FL, 32159",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9327881,
    "lng": -81.9347905
  },
  {
    "id": "15686",
    "name": "Vitamin Shoppe",
    "address": "4005 Nicholasville Rd., Lexington, KY, 40503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.981161,
    "lng": -84.528755
  },
  {
    "id": "15685",
    "name": "Vitamin Shoppe",
    "address": "2405 Miamisburg - Centerville, Dayton, OH, 45459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6353151,
    "lng": -84.215094
  },
  {
    "id": "15684",
    "name": "Vitamin Shoppe",
    "address": "1500 Oakley Seaver Drive, Clermont, FL, 34711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5454466,
    "lng": -81.7281876
  },
  {
    "id": "15683",
    "name": "Vitamin Shoppe",
    "address": "5899 Eastex Freeway, Beaumont, TX, 77706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1250653,
    "lng": -94.1557753
  },
  {
    "id": "15682",
    "name": "Vitamin Shoppe",
    "address": "2590 David H. McLeod Blvd., Florence, SC, 29501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1883768,
    "lng": -79.8322348
  },
  {
    "id": "15681",
    "name": "Vitamin Shoppe",
    "address": "1 Sagamore Parkway S, Lafayette, IN, 47905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4171088,
    "lng": -86.8572497
  },
  {
    "id": "15680",
    "name": "Vitamin Shoppe",
    "address": "1921 Zaragosa Rd, El Paso, TX, 79938",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7637713,
    "lng": -106.2667867
  },
  {
    "id": "15679",
    "name": "Vitamin Shoppe",
    "address": "903 W. Indiantown RD, Jupiter, FL, 33458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.9344267,
    "lng": -80.1103605
  },
  {
    "id": "15678",
    "name": "Vitamin Shoppe",
    "address": "6731 Ritchie Hwy., Glen Burnie, MD, 21061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1896173,
    "lng": -76.6130318
  },
  {
    "id": "15677",
    "name": "Vitamin Shoppe",
    "address": "1003 West University, Georgetown, TX, 78628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6323902,
    "lng": -97.6930546
  },
  {
    "id": "15676",
    "name": "Vitamin Shoppe",
    "address": "6275 University Dr. NW, Huntsville, AL, 35806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7411366,
    "lng": -86.6815456
  },
  {
    "id": "15675",
    "name": "Vitamin Shoppe",
    "address": "190 E. Stacy Road, Allen, TX, 75002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1292231,
    "lng": -96.6543653
  },
  {
    "id": "15674",
    "name": "Vitamin Shoppe",
    "address": "11741 S. Cleveland Ave, Fort Myers, FL, 33907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5700824,
    "lng": -81.8713755
  },
  {
    "id": "15673",
    "name": "Vitamin Shoppe",
    "address": "6921 West Newberry Rd, Gainesville, FL, 32605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6592446,
    "lng": -82.416756
  },
  {
    "id": "15672",
    "name": "Vitamin Shoppe",
    "address": "11414 Broadway St., Pearland, TX, 77584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5551051,
    "lng": -95.3967774
  },
  {
    "id": "15671",
    "name": "Vitamin Shoppe",
    "address": "9390 6 Mile Cypress Pkwy, Fort Myers, FL, 33966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6059526,
    "lng": -81.8119748
  },
  {
    "id": "15670",
    "name": "Vitamin Shoppe",
    "address": "1579 US Highway 22 W, Watchung, NJ, 7069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6419046,
    "lng": -74.4159678
  },
  {
    "id": "15669",
    "name": "Vitamin Shoppe",
    "address": "4600 Shelbyville Road, Lousiville, KY, 40207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2473498,
    "lng": -85.6291138
  },
  {
    "id": "15668",
    "name": "Vitamin Shoppe",
    "address": "655 6th Ave, New York, NY, 10010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7414467,
    "lng": -73.9942813
  },
  {
    "id": "15667",
    "name": "Vitamin Shoppe",
    "address": "3388 River Rapids Drive, Coon Rapids, MN, 55448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.198077,
    "lng": -93.3532115
  },
  {
    "id": "15666",
    "name": "Vitamin Shoppe",
    "address": "818 Pelham Parkway, Pelham, NY, 10803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8930104,
    "lng": -73.8193453
  },
  {
    "id": "15665",
    "name": "Vitamin Shoppe",
    "address": "1780 Stirling Rd, Dania, FL, 33004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.048741,
    "lng": -80.1594026
  },
  {
    "id": "15664",
    "name": "Vitamin Shoppe",
    "address": "800 E. Merritt Island Causeway, Merritt Island, FL, 32952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.358004,
    "lng": -80.6829288
  },
  {
    "id": "15663",
    "name": "Vitamin Shoppe",
    "address": "335 Newnan Crossing Bypass, Newnan, GA, 30265",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3887307,
    "lng": -84.7619531
  },
  {
    "id": "15662",
    "name": "Vitamin Shoppe",
    "address": "1756 SW St. Lucie West Blvd, Port St. Lucie, FL, 34986",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3107025,
    "lng": -80.4064827
  },
  {
    "id": "15661",
    "name": "Vitamin Shoppe",
    "address": "1070 Iyannough Road, Hyannis, MA, 2601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.675351,
    "lng": -70.3046632
  },
  {
    "id": "15660",
    "name": "Vitamin Shoppe",
    "address": "5116 North Big Hollow Rd, Peoria, IL, 61615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7508769,
    "lng": -89.6347635
  },
  {
    "id": "15659",
    "name": "Vitamin Shoppe",
    "address": "6230 Long Prairie Rd, Flower Mound, TX, 75028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0711707,
    "lng": -97.0825729
  },
  {
    "id": "15658",
    "name": "Vitamin Shoppe",
    "address": "2118 Scenic Highway, Snellville, GA, 30078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8648097,
    "lng": -84.0164532
  },
  {
    "id": "15657",
    "name": "Vitamin Shoppe",
    "address": "3425 Erie Blvd., Syracuse, NY, 13214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0469876,
    "lng": -76.0691496
  },
  {
    "id": "15656",
    "name": "Vitamin Shoppe",
    "address": "1217 Route 300, Newburgh, NY, 12550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4998387,
    "lng": -74.0715489
  },
  {
    "id": "15655",
    "name": "Vitamin Shoppe",
    "address": "5463 Lyons Rd, Pompano Beach, FL, 33073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2986889,
    "lng": -80.1881168
  },
  {
    "id": "15654",
    "name": "Vitamin Shoppe",
    "address": "35 South Federal Highway, Deerfield Beach, FL, 33441",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.316938,
    "lng": -80.0913826
  },
  {
    "id": "15653",
    "name": "Vitamin Shoppe",
    "address": "1723 N. University Drive, Fort Lauderdale, FL, 33322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1475611,
    "lng": -80.2575749
  },
  {
    "id": "15652",
    "name": "Vitamin Shoppe",
    "address": "409 N. Federal Hwy, Pompano Beach, FL, 33062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2360805,
    "lng": -80.1036459
  },
  {
    "id": "15651",
    "name": "Vitamin Shoppe",
    "address": "74-5452 Makala Blvd., Kailua-Kona, HI, 96740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 19.6491162,
    "lng": -156.0052057
  },
  {
    "id": "15650",
    "name": "Vitamin Shoppe",
    "address": "3334 N. Main St., Anderson, SC, 29621",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5450408,
    "lng": -82.6687196
  },
  {
    "id": "15649",
    "name": "Vitamin Shoppe",
    "address": "305 Keawe Street, Lahaina, HI, 96761",
    "phone": "",
    "hours": "Call for hours",
    "lat": 20.8852267,
    "lng": -156.6816569
  },
  {
    "id": "15648",
    "name": "Vitamin Shoppe",
    "address": "30120 Haun Road, Menifee, CA, 92584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6830379,
    "lng": -117.1750479
  },
  {
    "id": "15647",
    "name": "Vitamin Shoppe",
    "address": "8820 W. Charleston Blvd #102 Pad J, Las Vegas, NV, 89117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1593423,
    "lng": -115.2881572
  },
  {
    "id": "15646",
    "name": "Vitamin Shoppe",
    "address": "1348 Java Lane, Burlington, NC, 27215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0682978,
    "lng": -79.5160876
  },
  {
    "id": "15645",
    "name": "Vitamin Shoppe",
    "address": "2100 88th Street, North Bergen, NJ, 7047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8128108,
    "lng": -74.0160083
  },
  {
    "id": "15644",
    "name": "Vitamin Shoppe",
    "address": "2800 Scottsville Rd, Bowling Green, KY, 42104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9473644,
    "lng": -86.4224084
  },
  {
    "id": "15643",
    "name": "Vitamin Shoppe",
    "address": "5425 South Padre Island Drive, Corpus Christi, TX, 78411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7079428,
    "lng": -97.374612
  },
  {
    "id": "15642",
    "name": "Vitamin Shoppe",
    "address": "31753 Woodward Ave., Royal Oak, MI, 48073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5235355,
    "lng": -83.1925727
  },
  {
    "id": "15641",
    "name": "Vitamin Shoppe",
    "address": "5531 N W Loop 1604, San Antonio, TX, 78253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4909191,
    "lng": -98.7076439
  },
  {
    "id": "15640",
    "name": "Vitamin Shoppe",
    "address": "10225 Research Blvd., Austin, TX, 78759",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3944546,
    "lng": -97.7438587
  },
  {
    "id": "15639",
    "name": "Vitamin Shoppe",
    "address": "5234 State Road 100, Palm Coast, FL, 32164",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4761654,
    "lng": -81.2158657
  },
  {
    "id": "15638",
    "name": "Vitamin Shoppe",
    "address": "5090 N. 9th Ave Suite A, Pensacola, FL, 32504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4734434,
    "lng": -87.2113985
  },
  {
    "id": "15637",
    "name": "Vitamin Shoppe",
    "address": "4620 East Washington Ave, Madison, WI, 53704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.130349,
    "lng": -89.306047
  },
  {
    "id": "15636",
    "name": "Vitamin Shoppe",
    "address": "5300 Stockdale Highway, Bakersfield, CA, 93309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3547051,
    "lng": -119.0607706
  },
  {
    "id": "15635",
    "name": "Vitamin Shoppe",
    "address": "9815 Northlake Center Pkwy, Charlotte, NC, 28216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3486274,
    "lng": -80.8579736
  },
  {
    "id": "15634",
    "name": "Vitamin Shoppe",
    "address": "5392 S Wadsworth Blvd, Littleton, CO, 80123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6187189,
    "lng": -105.090495
  },
  {
    "id": "15633",
    "name": "Vitamin Shoppe",
    "address": "3919 Wards Rd Suite A, Lynchburg, VA, 24502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3502497,
    "lng": -79.1843917
  },
  {
    "id": "15632",
    "name": "Vitamin Shoppe",
    "address": "1315 Oak Forest Lane, Myrtle Beach, SC, 29577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7047451,
    "lng": -78.9197853
  },
  {
    "id": "15631",
    "name": "Vitamin Shoppe",
    "address": "101 East Morrison Rd, Brownsville, TX, 78526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9677339,
    "lng": -97.5111164
  },
  {
    "id": "15630",
    "name": "Vitamin Shoppe",
    "address": "4601-4605 Illinois Rd, Fort Wayne, IN, 46804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0738839,
    "lng": -85.2016614
  },
  {
    "id": "15629",
    "name": "Vitamin Shoppe",
    "address": "1650 Rio Road East, Charlottesville, VA, 22901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.080908,
    "lng": -78.4739956
  },
  {
    "id": "15628",
    "name": "Vitamin Shoppe",
    "address": "385 South Colorado Blvd, Denver, CO, 80246",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7095278,
    "lng": -104.9411212
  },
  {
    "id": "15627",
    "name": "Vitamin Shoppe",
    "address": "235 N. Citrus St, West Covina, CA, 91791",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0747703,
    "lng": -117.890525
  },
  {
    "id": "15626",
    "name": "Vitamin Shoppe",
    "address": "46-047 Kamehameha Highway, Kaneohe, HI, 96744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.4209381,
    "lng": -157.8033499
  },
  {
    "id": "15625",
    "name": "Vitamin Shoppe",
    "address": "1230 Roseville Pkwy, Roseville, CA, 95678",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7669657,
    "lng": -121.2636649
  },
  {
    "id": "15624",
    "name": "Vitamin Shoppe",
    "address": "4001 N. 10th St, McAllen, TX, 78504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2406274,
    "lng": -98.2246303
  },
  {
    "id": "15623",
    "name": "Vitamin Shoppe",
    "address": "98-199 Kamehameha Highway, Aiea, HI, 96701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.3806566,
    "lng": -157.9426567
  },
  {
    "id": "15622",
    "name": "Vitamin Shoppe",
    "address": "28211 Marguerite Parkway, Mission Viejo, CA, 92692",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5536894,
    "lng": -117.6708876
  },
  {
    "id": "15621",
    "name": "Vitamin Shoppe",
    "address": "11301 West Broad St, Glen Allen, VA, 23060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6493832,
    "lng": -77.6048089
  },
  {
    "id": "15620",
    "name": "Vitamin Shoppe",
    "address": "6135 S Virginia St, Reno, NV, 89502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4697068,
    "lng": -119.7860755
  },
  {
    "id": "15619",
    "name": "Vitamin Shoppe",
    "address": "4022 14th St, Bradenton, FL, 34205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4641909,
    "lng": -82.5759334
  },
  {
    "id": "15618",
    "name": "Vitamin Shoppe",
    "address": "12301 NE Biscayne Blvd, Miami, FL, 33181",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8898273,
    "lng": -80.1632233
  },
  {
    "id": "15617",
    "name": "Vitamin Shoppe",
    "address": "4199 East Jericho Turnpike, East Northport, NY, 11731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8283632,
    "lng": -73.4094719
  },
  {
    "id": "15616",
    "name": "Vitamin Shoppe",
    "address": "1111 Cooper Point Road SW, Olympia, WA, 98502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.0375614,
    "lng": -122.9399724
  },
  {
    "id": "15615",
    "name": "Vitamin Shoppe",
    "address": "6280 20th Street, Vero Beach, FL, 32966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.6396118,
    "lng": -80.4566806
  },
  {
    "id": "15614",
    "name": "Vitamin Shoppe",
    "address": "931 8th Ave, New York, NY, 10019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7656442,
    "lng": -73.984036
  },
  {
    "id": "15613",
    "name": "Vitamin Shoppe",
    "address": "16383 SW 88th St, Miami, FL, 33196",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6844098,
    "lng": -80.4579007
  },
  {
    "id": "15612",
    "name": "Vitamin Shoppe",
    "address": "4104 S Tamiami Trail (US 41), Sarasota, FL, 34231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.294989,
    "lng": -82.530999
  },
  {
    "id": "15611",
    "name": "Vitamin Shoppe",
    "address": "9620 Pineville-Matthew Rd, Pineville, NC, 28134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0861548,
    "lng": -80.8806271
  },
  {
    "id": "15610",
    "name": "Vitamin Shoppe",
    "address": "455 Central Ave, White Plains, NY, 10606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0303632,
    "lng": -73.7882796
  },
  {
    "id": "15609",
    "name": "Vitamin Shoppe",
    "address": "7833 Kingston Pike, Knoxville, TN, 37919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.926469,
    "lng": -84.0443742
  },
  {
    "id": "15608",
    "name": "Vitamin Shoppe",
    "address": "5701 W Broad St, Richmond, VA, 23230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5891727,
    "lng": -77.5034901
  },
  {
    "id": "15607",
    "name": "Vitamin Shoppe",
    "address": "274 Daniel Webster Hghwy, Nashua, NH, 3060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7065705,
    "lng": -71.4406042
  },
  {
    "id": "15606",
    "name": "Vitamin Shoppe",
    "address": "771 N Lexington Springmill Rd, Mansfield, OH, 44906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7735913,
    "lng": -82.5909707
  },
  {
    "id": "15605",
    "name": "Vitamin Shoppe",
    "address": "1188 Hurffville Rd, Woodbury, NJ, 8096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8327785,
    "lng": -75.0891748
  },
  {
    "id": "15604",
    "name": "Vitamin Shoppe",
    "address": "4359 West Wisconsin Ave, Appleton, WI, 54913",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.2724792,
    "lng": -88.4717423
  },
  {
    "id": "15603",
    "name": "Vitamin Shoppe",
    "address": "699 Baltimore Pike, Bel Air, MD, 21014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5237502,
    "lng": -76.3562632
  },
  {
    "id": "15602",
    "name": "Vitamin Shoppe",
    "address": "1376 Bald Hill Rd, Warwick, RI, 2886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7018035,
    "lng": -71.4941706
  },
  {
    "id": "15601",
    "name": "Vitamin Shoppe",
    "address": "2010 Marlton Pike West, Cherry Hill, NJ, 8002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9205396,
    "lng": -75.0352173
  },
  {
    "id": "15600",
    "name": "Vitamin Shoppe",
    "address": "464 N. Alafaya Trail, Orlando, FL, 32828",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5532693,
    "lng": -81.206482
  },
  {
    "id": "15599",
    "name": "Vitamin Shoppe",
    "address": "1600 S East Rd, Farmington, CT, 6032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7167379,
    "lng": -72.7649442
  },
  {
    "id": "15598",
    "name": "Vitamin Shoppe",
    "address": "473 Route 211 East, Middletown, NY, 10940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4568483,
    "lng": -74.3807856
  },
  {
    "id": "15597",
    "name": "Vitamin Shoppe",
    "address": "108 Wolf Rd, Albany, NY, 12205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7172231,
    "lng": -73.8097866
  },
  {
    "id": "15596",
    "name": "Vitamin Shoppe",
    "address": "11440 Midlothian Turnpike, Richmond, VA, 23235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5060122,
    "lng": -77.6071151
  },
  {
    "id": "15595",
    "name": "Vitamin Shoppe",
    "address": "1250 Niagara Falls Blvd, Tonawanda, NY, 14150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9884062,
    "lng": -78.8232661
  },
  {
    "id": "15594",
    "name": "Vitamin Shoppe",
    "address": "438 NW Loop 410, San Antonio, TX, 78216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5196156,
    "lng": -98.500926
  },
  {
    "id": "15593",
    "name": "Vitamin Shoppe",
    "address": "370 Route 3 West, Clifton, NJ, 7014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8295796,
    "lng": -74.1377314
  },
  {
    "id": "15592",
    "name": "Vitamin Shoppe",
    "address": "445B W Dekalb Pike, King of Prussia, PA, 19406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0904604,
    "lng": -75.3745102
  },
  {
    "id": "15591",
    "name": "Vitamin Shoppe",
    "address": "502 Old Country Rd, Garden City, NY, 11530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7424008,
    "lng": -73.617792
  },
  {
    "id": "15590",
    "name": "Vitamin Shoppe",
    "address": "13376 Washington Blvd, Los Angeles, CA, 90066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9921074,
    "lng": -118.4444064
  },
  {
    "id": "15589",
    "name": "Vitamin Shoppe",
    "address": "5600 E 7th St, Long Beach, CA, 90804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7750972,
    "lng": -118.1228517
  },
  {
    "id": "15588",
    "name": "Vitamin Shoppe",
    "address": "2002 Southgate Rd, Colorado Springs, CO, 80906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8040977,
    "lng": -104.8192326
  },
  {
    "id": "15587",
    "name": "Vitamin Shoppe",
    "address": "1234 Hwy 31 North, Greenwood, IN, 46142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6324095,
    "lng": -86.1260306
  },
  {
    "id": "15586",
    "name": "Vitamin Shoppe",
    "address": "2600 S College Ave, Fort Collins, CO, 80525",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.552322,
    "lng": -105.0767023
  },
  {
    "id": "15585",
    "name": "Vitamin Shoppe",
    "address": "12 Promenade, Edgewater, NJ, 7020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8067657,
    "lng": -73.990034
  },
  {
    "id": "15584",
    "name": "Vitamin Shoppe",
    "address": "3365 Washtenaw Ave, Ann Arbor, MI, 48104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2566417,
    "lng": -83.6920956
  },
  {
    "id": "15583",
    "name": "Vitamin Shoppe",
    "address": "17602 La Cantera Parkway, San Antonio, TX, 78257",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6084095,
    "lng": -98.5962711
  },
  {
    "id": "15582",
    "name": "Vitamin Shoppe",
    "address": "7708 W Bell Rd, Glendale, AZ, 85308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6387943,
    "lng": -112.225222
  },
  {
    "id": "15581",
    "name": "Vitamin Shoppe",
    "address": "114 Hanes Mall Blvd, Winston Salem, NC, 27103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0696523,
    "lng": -80.2973184
  },
  {
    "id": "15580",
    "name": "Vitamin Shoppe",
    "address": "11985 Washington St, Denver, CO, 80233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.913613,
    "lng": -104.9781779
  },
  {
    "id": "15579",
    "name": "Vitamin Shoppe",
    "address": "8255 Laguna Blvd, Elk Grove, CA, 95758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4226106,
    "lng": -121.4033559
  },
  {
    "id": "15578",
    "name": "Vitamin Shoppe",
    "address": "1001 North Central Expressway, Plano, TX, 75075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0151842,
    "lng": -96.7093497
  },
  {
    "id": "15577",
    "name": "Vitamin Shoppe",
    "address": "1129 Woodruff Rd, Greenville, SC, 29607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8263241,
    "lng": -82.2972346
  },
  {
    "id": "15576",
    "name": "Vitamin Shoppe",
    "address": "14771 Hall Rd, Utica, MI, 48315",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6279996,
    "lng": -82.9789268
  },
  {
    "id": "15575",
    "name": "Vitamin Shoppe",
    "address": "4801 S. Hulen St., Ft Worth, TX, 76132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6770024,
    "lng": -97.3949242
  },
  {
    "id": "15574",
    "name": "Vitamin Shoppe",
    "address": "588 Route 70, Brick, NJ, 8723",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0583168,
    "lng": -74.1477139
  },
  {
    "id": "15573",
    "name": "Vitamin Shoppe",
    "address": "3801 Pelandale Ave, Modesto, CA, 95356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7024321,
    "lng": -121.0667158
  },
  {
    "id": "15572",
    "name": "Vitamin Shoppe",
    "address": "2266 International Speedway Blvd, Daytona Bch, FL, 32114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.185494,
    "lng": -81.0780743
  },
  {
    "id": "15571",
    "name": "Vitamin Shoppe",
    "address": "1775 Walden Ave, Buffalo, NY, 14225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9082056,
    "lng": -78.7706096
  },
  {
    "id": "15570",
    "name": "Vitamin Shoppe",
    "address": "397 Rt 28, Raritan, NJ, 8869",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5755649,
    "lng": -74.6307564
  },
  {
    "id": "15569",
    "name": "Vitamin Shoppe",
    "address": "2657 N. Salisbury Blvd, Salisbury, MD, 21801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4145756,
    "lng": -75.565833
  },
  {
    "id": "15568",
    "name": "Vitamin Shoppe",
    "address": "5055 Monroe St, Toledo, OH, 43623",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6982496,
    "lng": -83.6436753
  },
  {
    "id": "15567",
    "name": "Vitamin Shoppe",
    "address": "4701 S Cooper St, Arlington, TX, 76017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6698737,
    "lng": -97.1336662
  },
  {
    "id": "15566",
    "name": "Vitamin Shoppe",
    "address": "411 E. Six Forks Rd., Raleigh, NC, 27609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8202663,
    "lng": -78.6242388
  },
  {
    "id": "15565",
    "name": "Vitamin Shoppe",
    "address": "347 N. Milwaukee St, Boise, ID, 83704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6079189,
    "lng": -116.2840021
  },
  {
    "id": "15564",
    "name": "Vitamin Shoppe",
    "address": "195 Dorset St, South Burlington, VT, 5403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4641417,
    "lng": -73.1811835
  },
  {
    "id": "15563",
    "name": "Vitamin Shoppe",
    "address": "11320 Legacy Ave, Palm Beach Gardens, FL, 33410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.8432241,
    "lng": -80.0889793
  },
  {
    "id": "15562",
    "name": "Vitamin Shoppe",
    "address": "7504 FM 1960 W, Houston, TX, 77070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9657696,
    "lng": -95.5405249
  },
  {
    "id": "15561",
    "name": "Vitamin Shoppe",
    "address": "179 Northshore Blvd., Slidell, LA, 70460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3087496,
    "lng": -89.8262836
  },
  {
    "id": "15560",
    "name": "Vitamin Shoppe",
    "address": "4009 S. Mooney Blvd, Visalia, CA, 93277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2942108,
    "lng": -119.3141146
  },
  {
    "id": "15559",
    "name": "Vitamin Shoppe",
    "address": "5683 Fairmont Pkwy, Pasadena, TX, 77505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6504396,
    "lng": -95.1533701
  },
  {
    "id": "15558",
    "name": "Vitamin Shoppe",
    "address": "1800-G Rosecrans Ave, Manhattan Bch, CA, 90266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9015791,
    "lng": -118.3800237
  },
  {
    "id": "15557",
    "name": "Vitamin Shoppe",
    "address": "3240 Monroe Avenue, Rochester, NY, 14618",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1050637,
    "lng": -77.5398188
  },
  {
    "id": "15556",
    "name": "Vitamin Shoppe",
    "address": "1496 S Randall Rd, Algonquin, IL, 60102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1544648,
    "lng": -88.3365555
  },
  {
    "id": "15555",
    "name": "Vitamin Shoppe",
    "address": "4275 N. Harlem Ave, Harwood Heights, IL, 60706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9580237,
    "lng": -87.8067812
  },
  {
    "id": "15554",
    "name": "Vitamin Shoppe",
    "address": "17W700 22nd St, Villa Park, IL, 60181",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8462817,
    "lng": -87.9749194
  },
  {
    "id": "15553",
    "name": "Vitamin Shoppe",
    "address": "23051 Outer Dr, Allen Park, MI, 48101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2782431,
    "lng": -83.2142504
  },
  {
    "id": "15552",
    "name": "Vitamin Shoppe",
    "address": "3970 Baldwin Rd, Auburn Hills, MI, 48326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7026186,
    "lng": -83.3060699
  },
  {
    "id": "15551",
    "name": "Vitamin Shoppe",
    "address": "233 Independence Blvd, Virginia Bch, VA, 23462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8430021,
    "lng": -76.1373972
  },
  {
    "id": "15550",
    "name": "Vitamin Shoppe",
    "address": "5724 Grape Avenue, Mishawaka, IN, 46545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7122276,
    "lng": -86.1870557
  },
  {
    "id": "15549",
    "name": "Vitamin Shoppe",
    "address": "3391 Berlin Turnpike, Newington, CT, 6111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6552779,
    "lng": -72.7265721
  },
  {
    "id": "15548",
    "name": "Vitamin Shoppe",
    "address": "2603 S. Rochester Rd, Rochester, MI, 48307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6421487,
    "lng": -83.1311412
  },
  {
    "id": "15547",
    "name": "Vitamin Shoppe",
    "address": "2130 North Beltline Blvd, Columbia, SC, 29204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0169357,
    "lng": -80.9877308
  },
  {
    "id": "15546",
    "name": "Vitamin Shoppe",
    "address": "7345 Eastchase Parkway, Montgomery, AL, 36117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3613656,
    "lng": -86.1639339
  },
  {
    "id": "15545",
    "name": "Vitamin Shoppe",
    "address": "2500 S Pleasant Valley Rd, Winchester, VA, 22601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1542418,
    "lng": -78.1751914
  },
  {
    "id": "15544",
    "name": "Vitamin Shoppe",
    "address": "4610 Commercial Dr, New Hartford, NY, 13413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.086393,
    "lng": -75.3142052
  },
  {
    "id": "15543",
    "name": "Vitamin Shoppe",
    "address": "2121 Walnut Street, Cary, NC, 27518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7562277,
    "lng": -78.7407572
  },
  {
    "id": "15542",
    "name": "Vitamin Shoppe",
    "address": "30730 Orchard Lake Rd, Farmington Hills, MI, 48334",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.522795,
    "lng": -83.3592787
  },
  {
    "id": "15541",
    "name": "Vitamin Shoppe",
    "address": "10097 Brook Rd, Glen Allen, VA, 23059",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6738375,
    "lng": -77.4600237
  },
  {
    "id": "15540",
    "name": "Vitamin Shoppe",
    "address": "3120 Peoples St, Johnson City, TN, 37604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3511773,
    "lng": -82.3988708
  },
  {
    "id": "15539",
    "name": "Vitamin Shoppe",
    "address": "4668 Town Crossing Dr., Jacksonville, FL, 32246",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2587099,
    "lng": -81.52767
  },
  {
    "id": "15538",
    "name": "Vitamin Shoppe",
    "address": "2711 NW Towne Ctr Dr, Beaverton, OR, 97006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5391088,
    "lng": -122.8668291
  },
  {
    "id": "15537",
    "name": "Vitamin Shoppe",
    "address": "1209 Caroline St, Atlanta, GA, 30307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7566543,
    "lng": -84.3489057
  },
  {
    "id": "15536",
    "name": "Vitamin Shoppe",
    "address": "3151 South IH 35, Round Rock, TX, 78664",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4765584,
    "lng": -97.671978
  },
  {
    "id": "15535",
    "name": "Vitamin Shoppe",
    "address": "2456 W Loop 340, Waco, TX, 76711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.497872,
    "lng": -97.1597927
  },
  {
    "id": "15534",
    "name": "Vitamin Shoppe",
    "address": "3813 US Highway 98 North, Lakeland, FL, 33809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0914407,
    "lng": -81.9730413
  },
  {
    "id": "15533",
    "name": "Vitamin Shoppe",
    "address": "1313 Apalachee Pkwy, Tallahassee, FL, 32301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4361567,
    "lng": -84.2613375
  },
  {
    "id": "15532",
    "name": "Vitamin Shoppe",
    "address": "7325 N Academy Blvd, Colorado Springs, CO, 80920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.937398,
    "lng": -104.796993
  },
  {
    "id": "15531",
    "name": "Vitamin Shoppe",
    "address": "1205 West Sunset Rd, Henderson, NV, 89014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0630833,
    "lng": -115.0382036
  },
  {
    "id": "15530",
    "name": "Vitamin Shoppe",
    "address": "12 4th Ave, Brooklyn, NY, 11217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6810127,
    "lng": -73.9809084
  },
  {
    "id": "15529",
    "name": "Vitamin Shoppe",
    "address": "1962 Del Monte Blvd, Seaside, CA, 93955",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.6188919,
    "lng": -121.8420722
  },
  {
    "id": "15528",
    "name": "Vitamin Shoppe",
    "address": "300 John R Road, Troy, MI, 48083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5365694,
    "lng": -83.1063345
  },
  {
    "id": "15527",
    "name": "Vitamin Shoppe",
    "address": "5592-A Santa Teresa Blvd, San Jose, CA, 95123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2511155,
    "lng": -121.8583514
  },
  {
    "id": "15526",
    "name": "Vitamin Shoppe",
    "address": "3730 East 82nd St, Indianapolis, IN, 46240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9097145,
    "lng": -86.1022978
  },
  {
    "id": "15525",
    "name": "Vitamin Shoppe",
    "address": "60 Blanding Blvd, Orange Park, FL, 32073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1853556,
    "lng": -81.7398463
  },
  {
    "id": "15524",
    "name": "Vitamin Shoppe",
    "address": "5829 Kirby Dr, Houston, TX, 77005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7191727,
    "lng": -95.4181327
  },
  {
    "id": "15523",
    "name": "Vitamin Shoppe",
    "address": "275 E. Altamonte Dr, Altamonte Springs, FL, 32701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.6626881,
    "lng": -81.383169
  },
  {
    "id": "15522",
    "name": "Vitamin Shoppe",
    "address": "719 US Highway 67 N, Cedar Hill, TX, 75104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6004994,
    "lng": -96.9363031
  },
  {
    "id": "15521",
    "name": "Vitamin Shoppe",
    "address": "10020 W McDowell Rd, Avondale, AZ, 85392",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.465314,
    "lng": -112.2756117
  },
  {
    "id": "15520",
    "name": "Vitamin Shoppe",
    "address": "8283 S. Akron Street, Centennial, CO, 80112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.566872,
    "lng": -104.8831805
  },
  {
    "id": "15519",
    "name": "Vitamin Shoppe",
    "address": "2296 Martin Luther King Blvd, Panama City, FL, 32405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1890512,
    "lng": -85.6494681
  },
  {
    "id": "15518",
    "name": "Vitamin Shoppe",
    "address": "2397 B South Stemmons Freeway, Lewisville, TX, 75067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0063597,
    "lng": -96.9733871
  },
  {
    "id": "15517",
    "name": "Vitamin Shoppe",
    "address": "1653 West New Haven Ave, Melbourne, FL, 32904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0784136,
    "lng": -80.648776
  },
  {
    "id": "15516",
    "name": "Vitamin Shoppe",
    "address": "2415 75th St, Darien, IL, 60561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7504429,
    "lng": -88.0038179
  },
  {
    "id": "15515",
    "name": "Vitamin Shoppe",
    "address": "415 Loucks Rd, York, PA, 17404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9830506,
    "lng": -76.7421967
  },
  {
    "id": "15514",
    "name": "Vitamin Shoppe",
    "address": "2543 Mayfair Rd, Milwaukee, WI, 53226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.065191,
    "lng": -88.048494
  },
  {
    "id": "15513",
    "name": "Vitamin Shoppe",
    "address": "3226 Buford Dr., Buford, GA, 30519",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0646253,
    "lng": -83.9904222
  },
  {
    "id": "15512",
    "name": "Vitamin Shoppe",
    "address": "1495 West Pipeline Rd, Hurst, TX, 76053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8231022,
    "lng": -97.2045808
  },
  {
    "id": "15511",
    "name": "Vitamin Shoppe",
    "address": "439 Boardman Poland Rd, Boardman, OH, 44512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0237634,
    "lng": -80.6456114
  },
  {
    "id": "15510",
    "name": "Vitamin Shoppe",
    "address": "401 North Glendale Ave, Glendale, CA, 91206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1519988,
    "lng": -118.2449417
  },
  {
    "id": "15509",
    "name": "Vitamin Shoppe",
    "address": "7515  West Layton Ave, Milwaukee, WI, 53220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9588116,
    "lng": -88.0078328
  },
  {
    "id": "15508",
    "name": "Vitamin Shoppe",
    "address": "12266 Jefferson Ave, Newport News, VA, 23602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.11105,
    "lng": -76.4979337
  },
  {
    "id": "15507",
    "name": "Vitamin Shoppe",
    "address": "1908 Matthews Township Pkwy, Matthews, NC, 28105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1240039,
    "lng": -80.7076459
  },
  {
    "id": "15506",
    "name": "Vitamin Shoppe",
    "address": "31945 Gratiot Avenue, Roseville, MI, 48066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5319337,
    "lng": -82.914906
  },
  {
    "id": "15505",
    "name": "Vitamin Shoppe",
    "address": "3033 W. Peoria Ave, Phoenix, AZ, 85029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5813322,
    "lng": -112.1246249
  },
  {
    "id": "15504",
    "name": "Vitamin Shoppe",
    "address": "5425 Greenville Ave., Dallas, TX, 75206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8527638,
    "lng": -96.7700036
  },
  {
    "id": "15503",
    "name": "Vitamin Shoppe",
    "address": "19411 Gulf Freeway, Webster, TX, 77598",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5423934,
    "lng": -95.1403156
  },
  {
    "id": "15502",
    "name": "Vitamin Shoppe",
    "address": "5555 Whittlesey Blvd, Columbus, GA, 31909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5474821,
    "lng": -84.9458904
  },
  {
    "id": "15501",
    "name": "Vitamin Shoppe",
    "address": "19712 Katy Freeway, Houston, TX, 77094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7860241,
    "lng": -95.7144168
  },
  {
    "id": "15500",
    "name": "Vitamin Shoppe",
    "address": "4502 West Wendover Ave, Greensboro, NC, 27409",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0549918,
    "lng": -79.9050746
  },
  {
    "id": "15499",
    "name": "Vitamin Shoppe",
    "address": "257 8th Ave, New York, NY, 10011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7452517,
    "lng": -73.9988707
  },
  {
    "id": "15498",
    "name": "Vitamin Shoppe",
    "address": "7782 S. Cicero Ave, Burbank, IL, 60459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7515004,
    "lng": -87.7420188
  },
  {
    "id": "15497",
    "name": "Vitamin Shoppe",
    "address": "2369 Highway 70 SE, Hickory, NC, 28602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7029212,
    "lng": -81.2923346
  },
  {
    "id": "15496",
    "name": "Vitamin Shoppe",
    "address": "2701 SW College Rd, Ocala, FL, 34474",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.1664119,
    "lng": -82.1692624
  },
  {
    "id": "15495",
    "name": "Vitamin Shoppe",
    "address": "7837 Mentor Ave., Mentor, OH, 44060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6616129,
    "lng": -81.3602647
  },
  {
    "id": "15494",
    "name": "Vitamin Shoppe",
    "address": "3440 Camp Creek Pkwy, Atlanta, GA, 30344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.656293,
    "lng": -84.5022679
  },
  {
    "id": "15493",
    "name": "Vitamin Shoppe",
    "address": "8421 Brier Creek Pkwy, Raleigh, NC, 27617",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9060482,
    "lng": -78.7842335
  },
  {
    "id": "15492",
    "name": "Vitamin Shoppe",
    "address": "385 Fifth Ave., New York, NY, 10016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7494643,
    "lng": -73.9833968
  },
  {
    "id": "15491",
    "name": "Vitamin Shoppe",
    "address": "12181 Foothill Blvd, Rancho Cucamonga, CA, 91739",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1059271,
    "lng": -117.5396711
  },
  {
    "id": "15490",
    "name": "Vitamin Shoppe",
    "address": "101 North Fairfax Ave, Los Angeles, CA, 90036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0745072,
    "lng": -118.3616734
  },
  {
    "id": "15489",
    "name": "Vitamin Shoppe",
    "address": "19075 Interstate 45 North, Conroe, TX, 77385",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1845768,
    "lng": -95.4512245
  },
  {
    "id": "15488",
    "name": "Vitamin Shoppe",
    "address": "800 Market Place Blvd, Irving, TX, 75063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9169413,
    "lng": -96.9591215
  },
  {
    "id": "15487",
    "name": "Vitamin Shoppe",
    "address": "6965 Camino Arroyo Circle, Gilroy, CA, 95020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.003075,
    "lng": -121.55133
  },
  {
    "id": "15486",
    "name": "Vitamin Shoppe",
    "address": "6917 Fayetteville Rd, Durham, NC, 27713",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9035445,
    "lng": -78.9381496
  },
  {
    "id": "15485",
    "name": "Vitamin Shoppe",
    "address": "302 N. Congress Ave, Boynton Beach, FL, 33426",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5281461,
    "lng": -80.0900485
  },
  {
    "id": "15484",
    "name": "Vitamin Shoppe",
    "address": "1770 Galleria Boulevard, Franklin, TN, 37067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9616263,
    "lng": -86.8105794
  },
  {
    "id": "15483",
    "name": "Vitamin Shoppe",
    "address": "780 Truse Parkway, Memphis, TN, 38117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1105491,
    "lng": -89.8927228
  },
  {
    "id": "15482",
    "name": "Vitamin Shoppe",
    "address": "7501 Westheimer Rd, Houston, TX, 77063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.737219,
    "lng": -95.501338
  },
  {
    "id": "15481",
    "name": "Vitamin Shoppe",
    "address": "2600 East Southlake Blvd, Southlake, TX, 76092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9401336,
    "lng": -97.112007
  },
  {
    "id": "15480",
    "name": "Vitamin Shoppe",
    "address": "5500 Grossmont Center Dr, La Mesa, CA, 91942",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7779979,
    "lng": -117.0113848
  },
  {
    "id": "15479",
    "name": "Vitamin Shoppe",
    "address": "6147 Sunrise Blvd., Citrus Heights, CA, 95610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6749699,
    "lng": -121.272052
  },
  {
    "id": "15478",
    "name": "Vitamin Shoppe",
    "address": "75 E Thousand Oaks Blvd, Thousand Oaks, CA, 91360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1792231,
    "lng": -118.8751724
  },
  {
    "id": "15477",
    "name": "Vitamin Shoppe",
    "address": "27310 Lugonia Ave, Redlands, CA, 92374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0713118,
    "lng": -117.2083114
  },
  {
    "id": "15476",
    "name": "Vitamin Shoppe",
    "address": "3150 Stevens Creek Blvd, San Jose, CA, 95117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3229425,
    "lng": -121.9525992
  },
  {
    "id": "15475",
    "name": "Vitamin Shoppe",
    "address": "7672 Edinger Ave, Huntington Beach, CA, 92647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7297731,
    "lng": -117.9942255
  },
  {
    "id": "15474",
    "name": "Vitamin Shoppe",
    "address": "181 South Lake Ave. Suite 5, Pasadena, CA, 91101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1427894,
    "lng": -118.1325685
  },
  {
    "id": "15473",
    "name": "Vitamin Shoppe",
    "address": "9410 North Skokie Blvd, Skokie, IL, 60077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0527338,
    "lng": -87.7472795
  },
  {
    "id": "15472",
    "name": "Vitamin Shoppe",
    "address": "7009 Highway 6 North, Houston, TX, 77095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8796169,
    "lng": -95.6460416
  },
  {
    "id": "15471",
    "name": "Vitamin Shoppe",
    "address": "325 North Milwaukee Ave Suite W 3 Broadcasting Square, Vernon Hills, IL, 60061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2320997,
    "lng": -87.9419818
  },
  {
    "id": "15470",
    "name": "Vitamin Shoppe",
    "address": "2719 N Meridian Blvd, Reading, PA, 19610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3571079,
    "lng": -75.9821994
  },
  {
    "id": "15469",
    "name": "Vitamin Shoppe",
    "address": "2115 Ashley Phosphate Rd, North Charleston, SC, 29406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9363663,
    "lng": -80.0400104
  },
  {
    "id": "15468",
    "name": "Vitamin Shoppe",
    "address": "18661 LBJ Freeway Suite 100, Mesquite, TX, 75150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8025614,
    "lng": -96.6280521
  },
  {
    "id": "15467",
    "name": "Vitamin Shoppe",
    "address": "7641 N. Blackstone Ave, Fresno, CA, 93720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8464629,
    "lng": -119.7917742
  },
  {
    "id": "15466",
    "name": "Vitamin Shoppe",
    "address": "5779 Lone Tree Way Suite A, Antioch, CA, 94531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9619938,
    "lng": -121.738648
  },
  {
    "id": "15465",
    "name": "Vitamin Shoppe",
    "address": "40758 Winchester Rd Suite B, Temecula, CA, 92591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5259888,
    "lng": -117.1576789
  },
  {
    "id": "15464",
    "name": "Vitamin Shoppe",
    "address": "2225 Gallatin Pike North, Madison, TN, 37115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3050462,
    "lng": -86.6874565
  },
  {
    "id": "15463",
    "name": "Vitamin Shoppe",
    "address": "1507 S Loop 288, Denton, TX, 76205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.193233,
    "lng": -97.0947991
  },
  {
    "id": "15462",
    "name": "Vitamin Shoppe",
    "address": "299 South Randolph Street, Brea, CA, 92821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9131883,
    "lng": -117.8901588
  },
  {
    "id": "15461",
    "name": "Vitamin Shoppe",
    "address": "2062 Redwood Highway, Greenbrae, CA, 94904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9384134,
    "lng": -122.5158824
  },
  {
    "id": "15460",
    "name": "Vitamin Shoppe",
    "address": "5075 Morganton Rd. Suite 2, Fayetteville, NC, 28314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0692201,
    "lng": -78.9615695
  },
  {
    "id": "15459",
    "name": "Vitamin Shoppe",
    "address": "195 Harbison Blvd, Columbia, SC, 29212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0703038,
    "lng": -81.1635737
  },
  {
    "id": "15458",
    "name": "Vitamin Shoppe",
    "address": "2995 Preston Rd. Suite 1540, Frisco, TX, 75034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1040003,
    "lng": -96.8079889
  },
  {
    "id": "15457",
    "name": "Vitamin Shoppe",
    "address": "434 Southbridge Street, Auburn, MA, 1501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2014412,
    "lng": -71.839576
  },
  {
    "id": "15456",
    "name": "Vitamin Shoppe",
    "address": "3111 Sports Arena Blvd, San Diego, CA, 92110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7514316,
    "lng": -117.2059038
  },
  {
    "id": "15455",
    "name": "Vitamin Shoppe",
    "address": "5930 W. Park Blvd Suite 900, Plano, TX, 75093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0274812,
    "lng": -96.8266029
  },
  {
    "id": "15454",
    "name": "Vitamin Shoppe",
    "address": "1471 Fitzgerald Dr. Suite 100, Pinole, CA, 94564",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9913918,
    "lng": -122.3071357
  },
  {
    "id": "15453",
    "name": "Vitamin Shoppe",
    "address": "2719 Gulf to Bay Blvd Suite 1170, Clearwater, FL, 33759",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9600421,
    "lng": -82.7248935
  },
  {
    "id": "15452",
    "name": "Vitamin Shoppe",
    "address": "655 S. Main St Suite 250, Orange, CA, 92868",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.777713,
    "lng": -117.8670795
  },
  {
    "id": "15451",
    "name": "Vitamin Shoppe",
    "address": "2641-A  Vista Way, Oceanside, CA, 92054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1827559,
    "lng": -117.3304755
  },
  {
    "id": "15450",
    "name": "Vitamin Shoppe",
    "address": "4860 Telephone Rd Suite 100 A, Ventura, CA, 93003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2629452,
    "lng": -119.2272538
  },
  {
    "id": "15449",
    "name": "Vitamin Shoppe",
    "address": "4333 Everhard Road Unit 2, Canton, OH, 44718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8595894,
    "lng": -81.4291431
  },
  {
    "id": "15448",
    "name": "Vitamin Shoppe",
    "address": "8600 West Golf Road Suite 100, Niles, IL, 60714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.054995,
    "lng": -87.8414239
  },
  {
    "id": "15447",
    "name": "Vitamin Shoppe",
    "address": "1243 Torrence Ave., Calumet City, IL, 60409",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6006413,
    "lng": -87.5583959
  },
  {
    "id": "15446",
    "name": "Vitamin Shoppe",
    "address": "2301 Tyrone Blvd, St Petersburg, FL, 33710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7932401,
    "lng": -82.7287924
  },
  {
    "id": "15445",
    "name": "Vitamin Shoppe",
    "address": "7069 -B Arundel Mills Boulevard, Hanover, MD, 21076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1531179,
    "lng": -76.7314284
  },
  {
    "id": "15444",
    "name": "Vitamin Shoppe",
    "address": "2021 Gun Barrel Rd, Chattanooga, TN, 37421",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0320977,
    "lng": -85.1551065
  },
  {
    "id": "15443",
    "name": "Vitamin Shoppe",
    "address": "9100 Tampa Ave, Northridge, CA, 91324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2357519,
    "lng": -118.553215
  },
  {
    "id": "15442",
    "name": "Vitamin Shoppe",
    "address": "39256 10th Street West Suite A, Palmdale, CA, 93551",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5969098,
    "lng": -118.1472843
  },
  {
    "id": "15441",
    "name": "Vitamin Shoppe",
    "address": "6701-A Loisdale Road Suite #6695, Springfield, VA, 22150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7726651,
    "lng": -77.1784418
  },
  {
    "id": "15440",
    "name": "Vitamin Shoppe",
    "address": "21 Federal Road, Brookfield, CT, 6804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4319245,
    "lng": -73.4137594
  },
  {
    "id": "15439",
    "name": "Vitamin Shoppe",
    "address": "2300 Wrangleboro Rd Suite 720, Mays Landing, NJ, 8330",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4503979,
    "lng": -74.6367037
  },
  {
    "id": "15438",
    "name": "Vitamin Shoppe",
    "address": "26831 Aliso Creek Rd, Aliso Viejo, CA, 92656",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5750755,
    "lng": -117.723913
  },
  {
    "id": "15437",
    "name": "Vitamin Shoppe",
    "address": "3929 S. Bristol St Bdlg C, Santa Ana, CA, 92704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6947943,
    "lng": -117.8849352
  },
  {
    "id": "15436",
    "name": "Vitamin Shoppe",
    "address": "1951 Mount Zion Road, Morrow, GA, 30260",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5645817,
    "lng": -84.3270351
  },
  {
    "id": "15435",
    "name": "Vitamin Shoppe",
    "address": "1034 Commons Drive, Geneva, IL, 60134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8956958,
    "lng": -88.3414651
  },
  {
    "id": "15434",
    "name": "Vitamin Shoppe",
    "address": "6255 Mayfield Rd, Cleveland, OH, 44124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5204713,
    "lng": -81.4534332
  },
  {
    "id": "15433",
    "name": "Vitamin Shoppe",
    "address": "1 West Rand Rd, Arlington Heights, IL, 60004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1124283,
    "lng": -87.9817126
  },
  {
    "id": "15432",
    "name": "Vitamin Shoppe",
    "address": "2217 East 80th Avenue, Merrillville, IN, 46410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4717699,
    "lng": -87.3101787
  },
  {
    "id": "15431",
    "name": "Vitamin Shoppe",
    "address": "450 Rt 10 West Suite 1, Ledgewood, NJ, 7852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8752857,
    "lng": -74.6485062
  },
  {
    "id": "15430",
    "name": "Vitamin Shoppe",
    "address": "21436 West Victory Blvd, Woodland Hills, CA, 91367",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.186624,
    "lng": -118.5654856
  },
  {
    "id": "15429",
    "name": "Vitamin Shoppe",
    "address": "2201 East Fowler Avenue Suite A, Tampa, FL, 33612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0539518,
    "lng": -82.4342206
  },
  {
    "id": "15428",
    "name": "Vitamin Shoppe",
    "address": "815 Cog Circle Suite 4, Crystal Lake, IL, 60014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2265565,
    "lng": -88.2905889
  },
  {
    "id": "15427",
    "name": "Vitamin Shoppe",
    "address": "1412 Greenbrier Parkway Suite 125, Chesapeake, VA, 23320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7764232,
    "lng": -76.230899
  },
  {
    "id": "15426",
    "name": "Vitamin Shoppe",
    "address": "1675 Sunrise Highway, Bayshore, NY, 11706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7368089,
    "lng": -73.247878
  },
  {
    "id": "15425",
    "name": "Vitamin Shoppe",
    "address": "15131 South LaGrange Rd, Orland Park, IL, 60462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6149455,
    "lng": -87.8527254
  },
  {
    "id": "15424",
    "name": "Vitamin Shoppe",
    "address": "5125 Jonestown Rd Suite 145, Harrisburg, PA, 17112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3093794,
    "lng": -76.7985573
  },
  {
    "id": "15423",
    "name": "Vitamin Shoppe",
    "address": "10590 Forest Hill Blvd Suite 200, Wellington, FL, 33414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6506966,
    "lng": -80.2122187
  },
  {
    "id": "15422",
    "name": "Vitamin Shoppe",
    "address": "26532 Lorain Rd, North Olmsted, OH, 44070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4191121,
    "lng": -81.9164357
  },
  {
    "id": "15421",
    "name": "Vitamin Shoppe",
    "address": "101 Brandon Town Center Drive Plaza at Brandon Town Center, Brandon, FL, 33511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9387961,
    "lng": -82.3237811
  },
  {
    "id": "15420",
    "name": "Vitamin Shoppe",
    "address": "2960 North Federal Hwy, Jensen Beach, FL, 34957",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2409649,
    "lng": -80.2712677
  },
  {
    "id": "15419",
    "name": "Vitamin Shoppe",
    "address": "45450 Dulles Crossing Plaza Suite 185, Sterling, VA, 20166",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0263077,
    "lng": -77.4260457
  },
  {
    "id": "15418",
    "name": "Vitamin Shoppe",
    "address": "105 Buckland Hills Dr, Manchester, CT, 6042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8092487,
    "lng": -72.5506507
  },
  {
    "id": "15417",
    "name": "Vitamin Shoppe",
    "address": "2205 N Federal Hwy, Ft Lauderdale, FL, 33305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1554042,
    "lng": -80.1186497
  },
  {
    "id": "15416",
    "name": "Vitamin Shoppe",
    "address": "3807 E Colonial Dr, Orlando, FL, 32803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5538315,
    "lng": -81.3373201
  },
  {
    "id": "15415",
    "name": "Vitamin Shoppe",
    "address": "1400 University Dr, Coral Springs, FL, 33071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2481922,
    "lng": -80.2539776
  },
  {
    "id": "15414",
    "name": "Vitamin Shoppe",
    "address": "1233 Sand Lake Road Suite 4, Orlando, FL, 32809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4513059,
    "lng": -81.3946258
  },
  {
    "id": "15413",
    "name": "Vitamin Shoppe",
    "address": "9693 W Colonial Dr, Ocoee, FL, 34761",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5523863,
    "lng": -81.5200621
  },
  {
    "id": "15412",
    "name": "Vitamin Shoppe",
    "address": "1260-1270 Boston Post Rd, Milford, CT, 6460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2376105,
    "lng": -73.0380875
  },
  {
    "id": "15411",
    "name": "Vitamin Shoppe",
    "address": "31-26 Steinway St, Astoria, NY, 11103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7607056,
    "lng": -73.917846
  },
  {
    "id": "15410",
    "name": "Vitamin Shoppe",
    "address": "219 Pottstown Pike, Exton, PA, 19341",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0320711,
    "lng": -75.6304694
  },
  {
    "id": "15409",
    "name": "Vitamin Shoppe",
    "address": "3847 Kirkwood Hwy, Wilmington, DE, 19808",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7313331,
    "lng": -75.6447661
  },
  {
    "id": "15408",
    "name": "Vitamin Shoppe",
    "address": "2128 State Route 35 Suite 35, Holmdel, NJ, 7733",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4116343,
    "lng": -74.1432183
  },
  {
    "id": "15407",
    "name": "Vitamin Shoppe",
    "address": "8303 S Dixie Hwy, Miami, FL, 33143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6935057,
    "lng": -80.3021154
  },
  {
    "id": "15406",
    "name": "Vitamin Shoppe",
    "address": "4587 Okeechobee Blvd Suite 135, West Palm Beach, FL, 33417",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7073974,
    "lng": -80.1125297
  },
  {
    "id": "15405",
    "name": "Vitamin Shoppe",
    "address": "268 S University Dr, Fort Lauderdale, FL, 33324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1182867,
    "lng": -80.251217
  },
  {
    "id": "15404",
    "name": "Vitamin Shoppe",
    "address": "565 Connecticut Avenue, Norwalk, CT, 6854",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0970661,
    "lng": -73.4449765
  },
  {
    "id": "15403",
    "name": "Vitamin Shoppe",
    "address": "41 Hwy Rt 36, Eatontown, NJ, 7724",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2915448,
    "lng": -74.0494572
  },
  {
    "id": "15402",
    "name": "Vitamin Shoppe",
    "address": "735 Broadway Hillside Plaza, Saugus, MA, 1906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4779701,
    "lng": -71.0235311
  },
  {
    "id": "15401",
    "name": "Vitamin Shoppe",
    "address": "14815 Baltimore Ave, Laurel, MD, 20707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0943195,
    "lng": -76.8534025
  },
  {
    "id": "15400",
    "name": "Vitamin Shoppe",
    "address": "1058 Baltimore Pk, Springfield, PA, 19064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.914484,
    "lng": -75.3440191
  },
  {
    "id": "15399",
    "name": "Vitamin Shoppe",
    "address": "300 Andover St (Route 114), Peabody, MA, 1960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5489164,
    "lng": -70.9535422
  },
  {
    "id": "15398",
    "name": "Vitamin Shoppe",
    "address": "6250 Columbia Crossing Circle Suite L, Columbia, MD, 21045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1977049,
    "lng": -76.8141144
  },
  {
    "id": "15397",
    "name": "Vitamin Shoppe",
    "address": "1471 Carl D. Silver Pkwy, Fredericksburg, VA, 22401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3017181,
    "lng": -77.5069622
  },
  {
    "id": "15396",
    "name": "Vitamin Shoppe",
    "address": "10944 Bulloch Dr, Manassas, VA, 20109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.803725,
    "lng": -77.5239428
  },
  {
    "id": "15395",
    "name": "Vitamin Shoppe",
    "address": "1701 Chestnut St, Philadelphia, PA, 19103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9517287,
    "lng": -75.1689025
  },
  {
    "id": "15394",
    "name": "Vitamin Shoppe",
    "address": "9404 Reisterstown Rd., Owings Mills, MD, 21117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4003977,
    "lng": -76.7539448
  },
  {
    "id": "15393",
    "name": "Vitamin Shoppe",
    "address": "3144 Crain Hwy, Waldorf, MD, 20603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6248596,
    "lng": -76.9114108
  },
  {
    "id": "15392",
    "name": "Vitamin Shoppe",
    "address": "672 W Sunrise Hwy, Valley Stream, NY, 11581",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6650951,
    "lng": -73.7244095
  },
  {
    "id": "15391",
    "name": "Vitamin Shoppe",
    "address": "327 Rt 10, East Hanover, NJ, 7936",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8038189,
    "lng": -74.3659181
  },
  {
    "id": "15390",
    "name": "Vitamin Shoppe",
    "address": "1927 Old Gallows Rd, Vienna, VA, 22182",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9118804,
    "lng": -77.221497
  },
  {
    "id": "15389",
    "name": "Vitamin Shoppe",
    "address": "757 Bethlehem Pike, Montgomeryville, PA, 18936",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2436077,
    "lng": -75.2428686
  },
  {
    "id": "15388",
    "name": "Vitamin Shoppe",
    "address": "300 N Frederick Ave, Gaithersburg, MD, 20877",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1448676,
    "lng": -77.203192
  },
  {
    "id": "15387",
    "name": "Vitamin Shoppe",
    "address": "11015-B Fairfax Blvd, Fairfax, VA, 22030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8529779,
    "lng": -77.3253566
  },
  {
    "id": "15386",
    "name": "Vitamin Shoppe",
    "address": "715 W Lancaster Ave, Bryn Mawr, PA, 19010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0198798,
    "lng": -75.3138758
  },
  {
    "id": "15385",
    "name": "Vitamin Shoppe",
    "address": "1803 Rockville Pike, Rockville, MD, 20852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0593597,
    "lng": -77.1226513
  },
  {
    "id": "15384",
    "name": "Vitamin Shoppe",
    "address": "5524 Leesburg Pike, Falls Church, VA, 22041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8485355,
    "lng": -77.1236694
  },
  {
    "id": "15383",
    "name": "Vitamin Shoppe",
    "address": "4609 Concord Pike, Wilmington, DE, 19803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8180285,
    "lng": -75.5478444
  },
  {
    "id": "15382",
    "name": "Vitamin Shoppe",
    "address": "1050 Sunrise Hwy, Massapequa, NY, 11758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6780574,
    "lng": -73.4377719
  },
  {
    "id": "15381",
    "name": "Vitamin Shoppe",
    "address": "721 Nassau Park Blvd, Princeton, NJ, 8540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3022973,
    "lng": -74.6756991
  },
  {
    "id": "15380",
    "name": "Vitamin Shoppe",
    "address": "5171 Sunrise Hwy, Bohemia, NY, 11716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7636063,
    "lng": -73.0922216
  },
  {
    "id": "15379",
    "name": "Vitamin Shoppe",
    "address": "3145 Hempstead Tpke, Levittown, NY, 11756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7258608,
    "lng": -73.519702
  },
  {
    "id": "15378",
    "name": "Vitamin Shoppe",
    "address": "535 Boston Post Rd, Port Chester, NY, 10573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9919109,
    "lng": -73.6746463
  },
  {
    "id": "15377",
    "name": "Vitamin Shoppe",
    "address": "2100 Merrick Rd, Merrick, NY, 11566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6579732,
    "lng": -73.5456552
  },
  {
    "id": "15376",
    "name": "Vitamin Shoppe",
    "address": "137 E State Rt 4, Paramus, NJ, 7652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9180812,
    "lng": -74.0604226
  },
  {
    "id": "15375",
    "name": "Vitamin Shoppe",
    "address": "32 Court St, Brooklyn, NY, 11201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6929538,
    "lng": -73.9910393
  },
  {
    "id": "15374",
    "name": "Vitamin Shoppe",
    "address": "185 Rt 1 S, Metuchen, NJ, 8840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5503443,
    "lng": -74.3224909
  },
  {
    "id": "15373",
    "name": "Vitamin Shoppe",
    "address": "1232 Hooper Ave, Toms River, NJ, 8753",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9808782,
    "lng": -74.1830788
  },
  {
    "id": "15372",
    "name": "Vitamin Shoppe",
    "address": "190 Jericho Tpke, Syosset, NY, 11791",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8096674,
    "lng": -73.5100377
  },
  {
    "id": "15371",
    "name": "Vitamin Shoppe",
    "address": "3681 Rt 9 N, Freehold, NJ, 7728",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2463797,
    "lng": -74.2812937
  },
  {
    "id": "15370",
    "name": "Vitamin Shoppe",
    "address": "469 86th St, Brooklyn, NY, 11209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6219722,
    "lng": -74.0265375
  },
  {
    "id": "15369",
    "name": "Vitamin Shoppe",
    "address": "49 E Rt 59, Nanuet, NY, 10954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.092937,
    "lng": -74.0043284
  },
  {
    "id": "15368",
    "name": "Vitamin Shoppe",
    "address": "3463 Long Beach Rd, Oceanside, NY, 11572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6268214,
    "lng": -73.6399616
  },
  {
    "id": "15367",
    "name": "Vitamin Shoppe",
    "address": "2535 Richmond Ave, Staten Island, NY, 10314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5859182,
    "lng": -74.1666586
  },
  {
    "id": "15366",
    "name": "Vitamin Shoppe",
    "address": "2702 Route 22 E, Union, NJ, 7083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.688746,
    "lng": -74.3075588
  },
  {
    "id": "15365",
    "name": "Vitamin Shoppe",
    "address": "81-27 37th Ave, Jackson Heights, NY, 11372",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7499736,
    "lng": -73.8845582
  },
  {
    "id": "15364",
    "name": "Vitamin Shoppe",
    "address": "107-60 Queens Blvd, Forest Hills, NY, 11375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7211698,
    "lng": -73.8444711
  },
  {
    "id": "15363",
    "name": "Vitamin Shoppe",
    "address": "2363 Central Park Ave, Yonkers, NY, 10710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9787848,
    "lng": -73.8312924
  },
  {
    "id": "15362",
    "name": "Vitamin Shoppe",
    "address": "415 Hwy 18 South, East Brunswick, NJ, 8816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4467678,
    "lng": -74.3978736
  },
  {
    "id": "15361",
    "name": "Vitamin Shoppe",
    "address": "556 Route 17 North, Paramus, NJ, 7652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9585303,
    "lng": -74.0737976
  },
  {
    "id": "15360",
    "name": "Vitamin Shoppe",
    "address": "191 Walt Whitman Rd (Rt 110), Huntington Station, NY, 11746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.822987,
    "lng": -73.4129227
  },
  {
    "id": "15359",
    "name": "Vitamin Shoppe",
    "address": "2841 Broadway, New York, NY, 10025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8044374,
    "lng": -73.966874
  },
  {
    "id": "15358",
    "name": "Vitamin Shoppe",
    "address": "740 Broadway, New York, NY, 10003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.729798,
    "lng": -73.9926904
  },
  {
    "id": "15357",
    "name": "Vitamin Shoppe",
    "address": "100 E 23rd St (on Park South), New York, NY, 10010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7399004,
    "lng": -73.9862269
  },
  {
    "id": "15356",
    "name": "Vitamin Shoppe",
    "address": "244 E 86th Street, New York, NY, 10028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7777024,
    "lng": -73.9522846
  },
  {
    "id": "15355",
    "name": "Vitamin Shoppe",
    "address": "2086-A Broadway, New York, NY, 10023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7782423,
    "lng": -73.9816213
  },
  {
    "id": "15354",
    "name": "Vitamin Shoppe",
    "address": "139 E 57th St, New York, NY, 10022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.761057,
    "lng": -73.9687578
  },
  {
    "id": "15353",
    "name": "CVS",
    "address": "500 U.S. HIGHWAY 50 W., UNION, MO, 63084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4386837,
    "lng": -91.0137073
  },
  {
    "id": "15352",
    "name": "CVS",
    "address": "45 EAST MAIN ST, NEWARK, DE, 19711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6828943,
    "lng": -75.7516615
  },
  {
    "id": "15351",
    "name": "CVS",
    "address": "630 CROSSWATER PKWY, PONTE VEDRA BEACH, FL, 32081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1075163,
    "lng": -81.4161598
  },
  {
    "id": "15350",
    "name": "CVS",
    "address": "2870 CHERRY ROAD, ROCK HILL, SC, 29730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9784508,
    "lng": -80.9810167
  },
  {
    "id": "15349",
    "name": "CVS",
    "address": "2564 BARATARIA BLVD, MARRERO, LA, 70072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8563924,
    "lng": -90.1042886
  },
  {
    "id": "15348",
    "name": "CVS",
    "address": "25 EAST OHIO ST, CHICAGO, IL, 60611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8921904,
    "lng": -87.6270447
  },
  {
    "id": "15347",
    "name": "CVS",
    "address": "12301 KNIGHTS ROAD, PHILADELPHIA, PA, 19154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0885023,
    "lng": -74.9698052
  },
  {
    "id": "15346",
    "name": "CVS",
    "address": "495 GRAND UNION BLVD, SOMERVILLE, MA, 2145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3938387,
    "lng": -71.0804816
  },
  {
    "id": "15345",
    "name": "CVS",
    "address": "884 MAIN ST., MELROSE, MA, 2176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.465125,
    "lng": -71.062539
  },
  {
    "id": "15344",
    "name": "CVS",
    "address": "1821 NE 33RD AVE, PORTLAND, OR, 97212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5360006,
    "lng": -122.6316701
  },
  {
    "id": "15343",
    "name": "CVS",
    "address": "8700 NORTH BELT LINE ROAD, IRVING, TX, 75063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9253433,
    "lng": -96.9928558
  },
  {
    "id": "15342",
    "name": "CVS",
    "address": "7190 UNIVERSITY PARKWAY, SARASOTA, FL, 34240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3861415,
    "lng": -82.399311
  },
  {
    "id": "15341",
    "name": "CVS",
    "address": "1034 WEST LAKE STREET, CHICAGO, IL, 60607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8857936,
    "lng": -87.6536028
  },
  {
    "id": "15340",
    "name": "CVS",
    "address": "4900 OAK ST., BERLIN, OH, 44610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5608647,
    "lng": -81.7991203
  },
  {
    "id": "15339",
    "name": "CVS",
    "address": "1717 NORTH 12TH STREET, UNIT F, PHILADELPHIA, PA, 19122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9785807,
    "lng": -75.1534052
  },
  {
    "id": "15338",
    "name": "CVS",
    "address": "1204 PARK AVENUE, PLAINFIELD, NJ, 7060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.606409,
    "lng": -74.40568
  },
  {
    "id": "15337",
    "name": "CVS",
    "address": "1120 E. KENNEDY BLVD, UNIT 126, TAMPA, FL, 33602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.951152,
    "lng": -82.44794
  },
  {
    "id": "15336",
    "name": "CVS",
    "address": "3232 MERIDIANA PARKWAY, ROSHARON, TX, 77583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4384958,
    "lng": -95.4316394
  },
  {
    "id": "15335",
    "name": "CVS",
    "address": "110 E. RICHEY ROAD, HOUSTON, TX, 77090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9975904,
    "lng": -95.4246601
  },
  {
    "id": "15334",
    "name": "CVS",
    "address": "150 BAILEY RANCH ROAD, ALEDO, TX, 76008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7092948,
    "lng": -97.603436
  },
  {
    "id": "15333",
    "name": "CVS",
    "address": "1115 8TH AVENUE, FORT WORTH, TX, 76104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7325487,
    "lng": -97.3434713
  },
  {
    "id": "15332",
    "name": "CVS",
    "address": "301B SOUTH MAIN ST, STUART, VA, 24171",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.6339175,
    "lng": -80.2671864
  },
  {
    "id": "15331",
    "name": "CVS",
    "address": "1003 N. U.S. HIGHWAY 65, CARROLLTON, MO, 64633",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3708682,
    "lng": -93.4853841
  },
  {
    "id": "15330",
    "name": "CVS",
    "address": "7101 E. WILLIAM CANNON DRIVE, AUSTIN, TX, 78744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1626231,
    "lng": -97.7255625
  },
  {
    "id": "15329",
    "name": "CVS",
    "address": "6125 LEGACY DRIVE, PLANO, TX, 75024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0784272,
    "lng": -96.8295949
  },
  {
    "id": "15328",
    "name": "CVS",
    "address": "345 SW HARRISON ST, PORTLAND, OR, 97201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5108532,
    "lng": -122.6803706
  },
  {
    "id": "15327",
    "name": "CVS",
    "address": "4025 MERCANTILE DRIVE, STE 110, LAKE OSWEGO, OR, 97035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.4149929,
    "lng": -122.718813
  },
  {
    "id": "15326",
    "name": "CVS",
    "address": "105 NW 13TH AVE, PORTLAND, OR, 97209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5238118,
    "lng": -122.6844882
  },
  {
    "id": "15325",
    "name": "CVS",
    "address": "1802 W. MOUNT HOUSTON ROAD, HOUSTON, TX, 77038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8983178,
    "lng": -95.4300207
  },
  {
    "id": "15324",
    "name": "CVS",
    "address": "6225 ELDORADO PARKWAY, FRISCO, TX, 75033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1734876,
    "lng": -96.6976744
  },
  {
    "id": "15323",
    "name": "CVS",
    "address": "160 E. WASHINGTON AVENUE, WASHINGTON, NJ, 7882",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.759576,
    "lng": -74.9756948
  },
  {
    "id": "15322",
    "name": "CVS",
    "address": "705 BRIDGEPORT AVE., SHELTON, CT, 6484",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2759448,
    "lng": -73.1247243
  },
  {
    "id": "15321",
    "name": "CVS",
    "address": "40 D. MARK CUMMINGS RD., HARDEEVILLE, SC, 29927",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3083668,
    "lng": -80.9754543
  },
  {
    "id": "15320",
    "name": "CVS",
    "address": "6510 TELEGRAPH RD, BLOOMFIELD HILLS, MI, 48301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5443966,
    "lng": -83.2868053
  },
  {
    "id": "15319",
    "name": "CVS",
    "address": "36567 GODDARD RD., ROMULUS, MI, 48174",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2216921,
    "lng": -83.397202
  },
  {
    "id": "15318",
    "name": "CVS",
    "address": "225 E STATE ST., MONTROSE, MI, 48457",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.17681,
    "lng": -83.8882982
  },
  {
    "id": "15317",
    "name": "CVS",
    "address": "8900 MACOMB, GROSSE ILE, MI, 48138",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1309461,
    "lng": -83.155771
  },
  {
    "id": "15316",
    "name": "CVS",
    "address": "33877 WOODWARD AVE., BIRMINGHAM, MI, 48009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5379618,
    "lng": -83.2061744
  },
  {
    "id": "15315",
    "name": "CVS",
    "address": "444 MAIN ST., BELLEVILLE, MI, 48111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2089034,
    "lng": -83.4910659
  },
  {
    "id": "15314",
    "name": "CVS",
    "address": "11521 SR 70 E, BRADENTON, FL, 34202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4338956,
    "lng": -82.4277049
  },
  {
    "id": "15313",
    "name": "CVS",
    "address": "358 5TH AVENUE, NEW YORK, NY, 10001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7487274,
    "lng": -73.9847307
  },
  {
    "id": "15312",
    "name": "CVS",
    "address": "15996 PRESERVE MARKETPLACE BLVD, ODESSA, FL, 33556",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1883727,
    "lng": -82.550199
  },
  {
    "id": "15311",
    "name": "CVS",
    "address": "1550 CRYSTAL DR, SUITE C, ARLINGTON, VA, 22202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8594935,
    "lng": -77.0497901
  },
  {
    "id": "15310",
    "name": "CVS",
    "address": "7030 HOLLISTER AVENUE, GOLETA, CA, 93117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4306769,
    "lng": -119.8729099
  },
  {
    "id": "15309",
    "name": "CVS",
    "address": "555 NORTH BROADWAY, LOS ANGELES, CA, 90012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0582683,
    "lng": -118.2412886
  },
  {
    "id": "15308",
    "name": "CVS",
    "address": "2213 AIRPORT BLVD, AUSTIN, TX, 78722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2859567,
    "lng": -97.7054694
  },
  {
    "id": "15307",
    "name": "CVS",
    "address": "3122 UNDERWOOD ROAD, LA PORTE, TX, 77571",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6636897,
    "lng": -95.0872209
  },
  {
    "id": "15306",
    "name": "CVS",
    "address": "88 E. MAIN ST., MENDHAM, NJ, 7945",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.782402,
    "lng": -74.5892764
  },
  {
    "id": "15305",
    "name": "CVS",
    "address": "18-40 GOLDSBOROUGH DRIVE, BAYONNE, NJ, 7002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6723311,
    "lng": -74.1059571
  },
  {
    "id": "15304",
    "name": "CVS",
    "address": "2113 WELLS BRANCH PARKWAY, AUSTIN, TX, 78728",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4356335,
    "lng": -97.6847263
  },
  {
    "id": "15303",
    "name": "CVS",
    "address": "4005 EAST 8TH PLACE, DENVER, CO, 80220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7302806,
    "lng": -104.9402587
  },
  {
    "id": "15302",
    "name": "CVS",
    "address": "4060 CAMPBELL AVE, ARLINGTON, VA, 22206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8406529,
    "lng": -77.0884625
  },
  {
    "id": "15301",
    "name": "CVS",
    "address": "8145 SE 17TH AVE, PORTLAND, OR, 97202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.4637341,
    "lng": -122.6471631
  },
  {
    "id": "15300",
    "name": "CVS",
    "address": "6010 PLANK ROAD, FREDERICKSBURG, VA, 22407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.292599,
    "lng": -77.5851575
  },
  {
    "id": "15299",
    "name": "CVS",
    "address": "500 WILSHIRE BLVD, SANTA MONICA, CA, 90401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0198491,
    "lng": -118.4968428
  },
  {
    "id": "15298",
    "name": "CVS",
    "address": "490 NORTH BROAD ST, SUITE 100, PHILADELPHIA, PA, 19130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.962312,
    "lng": -75.1622899
  },
  {
    "id": "15297",
    "name": "CVS",
    "address": "652 SOUTH STREET, WRENTHAM, MA, 2093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0510373,
    "lng": -71.3459044
  },
  {
    "id": "15296",
    "name": "CVS",
    "address": "1201 WALNUT ST, PHILADELPHIA, PA, 19107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.949275,
    "lng": -75.1606066
  },
  {
    "id": "15295",
    "name": "CVS",
    "address": "7402 WEST FAIRVIEW AVE, BOISE, ID, 83704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.619976,
    "lng": -116.2749614
  },
  {
    "id": "15294",
    "name": "CVS",
    "address": "45 PEARL STREET, METUCHEN, NJ, 8840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5414864,
    "lng": -74.3633751
  },
  {
    "id": "15293",
    "name": "CVS",
    "address": "2702 VALWOOD PKWY, FARMERS BRANCH, TX, 75234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9377021,
    "lng": -96.8900403
  },
  {
    "id": "15292",
    "name": "CVS",
    "address": "515 HOUSTON ST., FORT WORTH, TX, 76102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7538214,
    "lng": -97.3314452
  },
  {
    "id": "15291",
    "name": "CVS",
    "address": "9060 DYER ST., EL PASO, TX, 79904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.86939,
    "lng": -106.4276126
  },
  {
    "id": "15290",
    "name": "CVS",
    "address": "2104 S. BYRNE RD, TOLEDO, OH, 43614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6016579,
    "lng": -83.6262381
  },
  {
    "id": "15289",
    "name": "CVS",
    "address": "12555 NW CORNELL RD, PORTLAND, OR, 97229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5258386,
    "lng": -122.8055811
  },
  {
    "id": "15288",
    "name": "CVS",
    "address": "739 ROOSEVELT RD, GLEN ELLYN, IL, 60137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8588054,
    "lng": -88.0554861
  },
  {
    "id": "15287",
    "name": "CVS",
    "address": "2201 CUMBERLAND AVENUE, KNOXVILLE, TN, 37916",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9536632,
    "lng": -83.93913
  },
  {
    "id": "15286",
    "name": "CVS",
    "address": "314 SOUTH 5TH STREET, PHILADELPHIA, PA, 19106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9445319,
    "lng": -75.1504031
  },
  {
    "id": "15285",
    "name": "CVS",
    "address": "129 SHAHAN PRAIRIE ROAD, OAK POINT, TX, 75068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1863,
    "lng": -96.9764
  },
  {
    "id": "15284",
    "name": "CVS",
    "address": "132 BRADFORD ST, PROVINCETOWN, MA, 2657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0533197,
    "lng": -70.1866505
  },
  {
    "id": "15283",
    "name": "CVS",
    "address": "2121 WEST BASELINE RD, UPLAND, CA, 91784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1225474,
    "lng": -117.6923389
  },
  {
    "id": "15282",
    "name": "CVS",
    "address": "390 N. BREA BLVD, BREA, CA, 92821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9243613,
    "lng": -117.8953773
  },
  {
    "id": "15281",
    "name": "CVS",
    "address": "1401 BERRYESSA ROAD, SAN JOSE, CA, 95133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3688131,
    "lng": -121.880655
  },
  {
    "id": "15280",
    "name": "CVS",
    "address": "4050 FUTURE ST, CASTLE ROCK, CO, 80109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4033943,
    "lng": -104.886556
  },
  {
    "id": "15279",
    "name": "CVS",
    "address": "8041 N. MESA STREET A, EL PASO, TX, 79932",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7973255,
    "lng": -106.5119156
  },
  {
    "id": "15278",
    "name": "CVS",
    "address": "3050 W. UNIVERSITY BLVD., ODESSA, TX, 79764",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8617943,
    "lng": -102.4142828
  },
  {
    "id": "15277",
    "name": "CVS",
    "address": "322 CANE ISLAND PKWY, KATY, TX, 77494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.779494,
    "lng": -95.8495799
  },
  {
    "id": "15276",
    "name": "CVS",
    "address": "20125 EVA STREET, MONTGOMERY, TX, 77356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3869258,
    "lng": -95.677269
  },
  {
    "id": "15275",
    "name": "CVS",
    "address": "4110 WILLIAMS WAY BLVD., RICHMOND, TX, 77469",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5595083,
    "lng": -95.7164087
  },
  {
    "id": "15274",
    "name": "CVS",
    "address": "300 MILAM STREET, STE A,, HOUSTON, TX, 77002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7633623,
    "lng": -95.3630013
  },
  {
    "id": "15273",
    "name": "CVS",
    "address": "101 EAST MAIN STREET, RUSSELLVILLE, AR, 72801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.278471,
    "lng": -93.1332346
  },
  {
    "id": "15272",
    "name": "CVS",
    "address": "15103 NO MACARTHUR BLVD, OKLAHOMA CITY, OK, 73013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6241625,
    "lng": -97.6216734
  },
  {
    "id": "15271",
    "name": "CVS",
    "address": "111 FM 407 W, ARGYLE, TX, 76226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1018382,
    "lng": -97.1893815
  },
  {
    "id": "15270",
    "name": "CVS",
    "address": "670 - 678 NORTH WELLS STREET, CHICAGO, IL, 60654",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8943898,
    "lng": -87.6344495
  },
  {
    "id": "15269",
    "name": "CVS",
    "address": "210 E. EMMITT AVE.,, WAVERLY, OH, 45690",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.128718,
    "lng": -82.9822861
  },
  {
    "id": "15268",
    "name": "CVS",
    "address": "1225 THIRD STREET, WHITEHALL, PA, 18052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6418205,
    "lng": -75.4729555
  },
  {
    "id": "15267",
    "name": "CVS",
    "address": "2511 ANDERSON HIGHWAY, POWHATAN, VA, 23139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.521579,
    "lng": -77.8220362
  },
  {
    "id": "15266",
    "name": "CVS",
    "address": "341 HARRISON AVE, BOSTON, MA, 2118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3450395,
    "lng": -71.0640036
  },
  {
    "id": "15265",
    "name": "CVS",
    "address": "1245 DIXWELL AVE, HAMDEN, CT, 6514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3472084,
    "lng": -72.9314499
  },
  {
    "id": "15264",
    "name": "CVS",
    "address": "377 SUMMERHILL ROAD, EAST BRUNSWICK, NJ, 8816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4078121,
    "lng": -74.3881616
  },
  {
    "id": "15263",
    "name": "CVS",
    "address": "503 WESTLAKE AVE N, SEATTLE, WA, 98109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6233698,
    "lng": -122.338793
  },
  {
    "id": "15262",
    "name": "CVS",
    "address": "344 N MAIN ST, WEST HARTFORD, CT, 6117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7853086,
    "lng": -72.7460969
  },
  {
    "id": "15261",
    "name": "CVS",
    "address": "4400 OAK GROVE PARKWAY, BROOKLYN PARK, MN, 55443",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.1310383,
    "lng": -93.3368062
  },
  {
    "id": "15260",
    "name": "CVS",
    "address": "2735 SIENNA PARKWAY, MISSOURI CITY, TX, 77459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4864312,
    "lng": -95.521625
  },
  {
    "id": "15259",
    "name": "CVS",
    "address": "5602 LYONS AVE.,, HOUSTON, TX, 77020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7760585,
    "lng": -95.3147928
  },
  {
    "id": "15258",
    "name": "CVS",
    "address": "9215 MIDWAY RD., DALLAS, TX, 75220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8645907,
    "lng": -96.8373398
  },
  {
    "id": "15257",
    "name": "CVS",
    "address": "1-50 50TH AVE, LONG ISLAND CITY, NY, 11101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7435117,
    "lng": -73.9590968
  },
  {
    "id": "15256",
    "name": "CVS",
    "address": "1619 BROADWAY, NEW YORK, NY, 10019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.761134,
    "lng": -73.9847476
  },
  {
    "id": "15255",
    "name": "CVS",
    "address": "2775 GODWIN BLVD., SUFFOLK, VA, 23434",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7747919,
    "lng": -76.5839504
  },
  {
    "id": "15254",
    "name": "CVS",
    "address": "22701 GOSNELL FARM DRIVE, BOYDS, MD, 20871",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2295,
    "lng": -77.2891
  },
  {
    "id": "15253",
    "name": "CVS",
    "address": "17435 COUNTY ROAD 6, PLYMOUTH, MN, 55447",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9949514,
    "lng": -93.5012757
  },
  {
    "id": "15252",
    "name": "CVS",
    "address": "5334 FM 1103, SCHERTZ, TX, 78108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6171426,
    "lng": -98.2342483
  },
  {
    "id": "15251",
    "name": "CVS",
    "address": "1780  LEE TREVINO, EL PASO, TX, 79936",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7647932,
    "lng": -106.3185573
  },
  {
    "id": "15250",
    "name": "CVS",
    "address": "131 EAST MAIN STREET, HUMMELSTOWN, PA, 17036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2653165,
    "lng": -76.7047453
  },
  {
    "id": "15249",
    "name": "CVS",
    "address": "153-01 10TH AVENUE, WHITESTONE, NY, 11357",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7942408,
    "lng": -73.8080893
  },
  {
    "id": "15248",
    "name": "CVS",
    "address": "35 CHURCH ST, BURLINGTON, VT, 5401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4795166,
    "lng": -73.2128901
  },
  {
    "id": "15247",
    "name": "CVS",
    "address": "16049 BASELINE AVENUE #1, FONTANA, CA, 92336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1207493,
    "lng": -117.4544115
  },
  {
    "id": "15246",
    "name": "CVS",
    "address": "11900 BALBOA BLVD, GRANADA HILLS, CA, 91344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2865326,
    "lng": -118.5010851
  },
  {
    "id": "15245",
    "name": "CVS",
    "address": "2260 E. THOMPSON BLVD., VENTURA, CA, 93001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2734751,
    "lng": -119.2671355
  },
  {
    "id": "15244",
    "name": "CVS",
    "address": "1026 S. BROADWAY, SPACE A, LOS ANGELES, CA, 90015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0403075,
    "lng": -118.2573447
  },
  {
    "id": "15243",
    "name": "CVS",
    "address": "7353 RANGEWOOD DRIVE, COLORADO SPRINGS, CO, 80918",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9372382,
    "lng": -104.7558312
  },
  {
    "id": "15242",
    "name": "CVS",
    "address": "9400 GRAVELLY LAKE DR SW, LAKEWOOD, WA, 98499",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.1719814,
    "lng": -122.5190975
  },
  {
    "id": "15241",
    "name": "CVS",
    "address": "680 E. REDD RD., EL PASO, TX, 79912",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8590314,
    "lng": -106.5587293
  },
  {
    "id": "15240",
    "name": "CVS",
    "address": "1023 FOURTH AVE, SAN DIEGO, CA, 92101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7159178,
    "lng": -117.1608036
  },
  {
    "id": "15239",
    "name": "CVS",
    "address": "500 POOLER HWY., POOLER, GA, 31322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.1352501,
    "lng": -81.2556261
  },
  {
    "id": "15238",
    "name": "CVS",
    "address": "4645 AIRPORT BLVD, MOBILE, AL, 36608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6759008,
    "lng": -88.1703285
  },
  {
    "id": "15237",
    "name": "CVS",
    "address": "18081 PRESTON ROAD,, DALLAS, TX, 75252",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9979548,
    "lng": -96.7985392
  },
  {
    "id": "15236",
    "name": "CVS",
    "address": "969 SECOND AVENUE, NEW YORK, NY, 10022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7559074,
    "lng": -73.9681935
  },
  {
    "id": "15235",
    "name": "CVS",
    "address": "1200 HIGHWAY 35, MIDDLETOWN, NJ, 7748",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3979491,
    "lng": -74.1135859
  },
  {
    "id": "15234",
    "name": "CVS",
    "address": "1570 ROUTE 38, LUMBERTON, NJ, 8048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.981839,
    "lng": -74.7987789
  },
  {
    "id": "15233",
    "name": "CVS",
    "address": "1506 RT 23, BUTLER, NJ, 7405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0034502,
    "lng": -74.356273
  },
  {
    "id": "15232",
    "name": "CVS",
    "address": "225 FAISON ROAD, MOUNT PLEASANT, SC, 29466",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8754518,
    "lng": -79.7713422
  },
  {
    "id": "15231",
    "name": "CVS",
    "address": "455 NORTH CIRCLE DR, COLORADO SPRINGS, CO, 80909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8386688,
    "lng": -104.7756001
  },
  {
    "id": "15230",
    "name": "CVS",
    "address": "3475 NORTH ACADEMY BLVD., COLORADO SPRINGS, CO, 80917",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8819962,
    "lng": -104.7565011
  },
  {
    "id": "15229",
    "name": "CVS",
    "address": "2400 RIVER ROAD, NORCO, CA, 92860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9148059,
    "lng": -117.5891125
  },
  {
    "id": "15228",
    "name": "CVS",
    "address": "9663 W. FM 1097 RD., WILLIS, TX, 77318",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4190287,
    "lng": -95.4982238
  },
  {
    "id": "15227",
    "name": "CVS",
    "address": "12051 TIERRA ESTE ROAD, EL PASO, TX, 79938",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7749618,
    "lng": -106.25272
  },
  {
    "id": "15226",
    "name": "CVS",
    "address": "17307 HULL STREET ROAD, MOSELEY, VA, 23120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3911023,
    "lng": -77.7311695
  },
  {
    "id": "15225",
    "name": "CVS",
    "address": "12410 W BROAD ST., RICHMOND, VA, 23233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6626754,
    "lng": -77.645648
  },
  {
    "id": "15224",
    "name": "CVS",
    "address": "1230 E. 8TH ST, ODESSA, TX, 79761",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8567326,
    "lng": -102.3597601
  },
  {
    "id": "15223",
    "name": "CVS",
    "address": "3200 N. BIG SPRING ST., MIDLAND, TX, 79705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0288313,
    "lng": -102.082808
  },
  {
    "id": "15222",
    "name": "CVS",
    "address": "1447 SOUTH WATERLEAF DR, WESTFIELD, IN, 46074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0008182,
    "lng": -86.1845926
  },
  {
    "id": "15221",
    "name": "CVS",
    "address": "110 EAST NORRIS DR, OTTAWA, IL, 61350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3566225,
    "lng": -88.8403287
  },
  {
    "id": "15220",
    "name": "CVS",
    "address": "10833 GLEANNLOCH FOREST DR., SPRING, TX, 77379",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0528381,
    "lng": -95.5785071
  },
  {
    "id": "15219",
    "name": "CVS",
    "address": "17900 WEST LAKE HOUSTON PARKWAY, HUMBLE, TX, 77346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9790832,
    "lng": -95.1655678
  },
  {
    "id": "15218",
    "name": "CVS",
    "address": "7979 BELT LINE ROAD, DALLAS, TX, 75254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9511627,
    "lng": -96.770019
  },
  {
    "id": "15217",
    "name": "CVS",
    "address": "1701 E. 15TH ST., TULSA, OK, 74104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1407788,
    "lng": -95.9668495
  },
  {
    "id": "15216",
    "name": "CVS",
    "address": "2501 MCCAIN BLVD., NORTH LITTLE ROCK, AR, 72116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.797678,
    "lng": -92.237715
  },
  {
    "id": "15215",
    "name": "CVS",
    "address": "400 CLEMATIS STREET, WEST PALM BEACH, FL, 33401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7131661,
    "lng": -80.0539289
  },
  {
    "id": "15214",
    "name": "CVS",
    "address": "305 EAST 86TH ST., NEW YORK, NY, 10028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7779784,
    "lng": -73.9512449
  },
  {
    "id": "15213",
    "name": "CVS",
    "address": "4313 UNIVERSITY WAY NE, SEATTLE, WA, 98105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6602853,
    "lng": -122.3133455
  },
  {
    "id": "15212",
    "name": "CVS",
    "address": "402 5TH AVENUE, SAN DIEGO, CA, 92101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7095369,
    "lng": -117.1603012
  },
  {
    "id": "15211",
    "name": "CVS",
    "address": "3950 W. GRAND PARKWAY, KATY, TX, 77449",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8309721,
    "lng": -95.7598762
  },
  {
    "id": "15210",
    "name": "CVS",
    "address": "3319 NAMEOKI RD., GRANITE CITY, IL, 62040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7239073,
    "lng": -90.1233969
  },
  {
    "id": "15209",
    "name": "CVS",
    "address": "1473 KENTUCKY ST., BOWLING GREEN, KY, 42101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9895422,
    "lng": -86.4548624
  },
  {
    "id": "15208",
    "name": "CVS",
    "address": "11563 OLD NASHVILLE HWY., SMYRNA, TN, 37167",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9585538,
    "lng": -86.5201414
  },
  {
    "id": "15207",
    "name": "CVS",
    "address": "108 W. DAVIS ST., DALLAS, TX, 75208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7491739,
    "lng": -96.8233299
  },
  {
    "id": "15206",
    "name": "CVS",
    "address": "1910 STATE HIGHWAY 46 W, NEW BRAUNFELS, TX, 78132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7206497,
    "lng": -98.1666771
  },
  {
    "id": "15205",
    "name": "CVS",
    "address": "105 ALTON BLVD. N., ALTON, TX, 78573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2878193,
    "lng": -98.3142641
  },
  {
    "id": "15204",
    "name": "CVS",
    "address": "10460 NORRIS FERRY ROAD, SHREVEPORT, LA, 71106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3556784,
    "lng": -93.7147146
  },
  {
    "id": "15203",
    "name": "CVS",
    "address": "452 WYTHE CREEK ROAD, POQUOSON, VA, 23662",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.124185,
    "lng": -76.3913646
  },
  {
    "id": "15202",
    "name": "CVS",
    "address": "161 AVENUE OF THE AMERICAS, NEW YORK, NY, 10013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7259683,
    "lng": -74.0043514
  },
  {
    "id": "15201",
    "name": "CVS",
    "address": "330 COURT ST., PLYMOUTH, MA, 2360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.97458,
    "lng": -70.6862262
  },
  {
    "id": "15200",
    "name": "CVS",
    "address": "1982 WEST 1700 SOUTH, SYRACUSE, UT, 84075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0896353,
    "lng": -112.0641246
  },
  {
    "id": "15199",
    "name": "CVS",
    "address": "3010 BERNAL AVENUE, PLEASANTON, CA, 94566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6699146,
    "lng": -121.8567503
  },
  {
    "id": "15198",
    "name": "CVS",
    "address": "6601 STINE ROAD, BAKERSFIELD, CA, 93313",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.295162,
    "lng": -119.057357
  },
  {
    "id": "15197",
    "name": "CVS",
    "address": "3933 E. CAMELBACK RD., PHOENIX, AZ, 85018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5093087,
    "lng": -111.9962989
  },
  {
    "id": "15196",
    "name": "CVS",
    "address": "9665 CAMPO RD., SPRING VALLEY, CA, 91977",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7469697,
    "lng": -116.9877256
  },
  {
    "id": "15195",
    "name": "CVS",
    "address": "632 LINDERO CANYON RD., OAK PARK, CA, 91377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1832538,
    "lng": -118.7846657
  },
  {
    "id": "15194",
    "name": "CVS",
    "address": "7500 MELROSE AVE., LOS ANGELES, CA, 90046",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0835041,
    "lng": -118.3533798
  },
  {
    "id": "15193",
    "name": "CVS",
    "address": "8956 FOOTHILL BLVD, RANCHO CUCAMONGA, CA, 91730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1076745,
    "lng": -117.609882
  },
  {
    "id": "15192",
    "name": "CVS",
    "address": "336 N. MILPAS ST, SANTA BARBARA, CA, 93103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4253949,
    "lng": -119.6836734
  },
  {
    "id": "15191",
    "name": "CVS",
    "address": "22614 SPRINGWOODS VILLAGE PKWY, SPRING, TX, 77389",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0958883,
    "lng": -95.4496892
  },
  {
    "id": "15190",
    "name": "CVS",
    "address": "150 EAST ILLINOIS AVE., DALLAS, TX, 75216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7198656,
    "lng": -96.8222879
  },
  {
    "id": "15189",
    "name": "CVS",
    "address": "3030 SYLVAN AVE, DALLAS, TX, 75212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7792152,
    "lng": -96.8352129
  },
  {
    "id": "15188",
    "name": "CVS",
    "address": "6474 E. NORTHWEST HWY, DALLAS, TX, 75214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8567371,
    "lng": -96.7504499
  },
  {
    "id": "15187",
    "name": "CVS",
    "address": "7110 MAGNOLIA ROAD, PEARLAND, TX, 77584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5428036,
    "lng": -95.3301551
  },
  {
    "id": "15186",
    "name": "CVS",
    "address": "22125 CUMBERLAND RIDGE DR., CYPRESS, TX, 77433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0146041,
    "lng": -95.7679423
  },
  {
    "id": "15185",
    "name": "CVS",
    "address": "13343 CULEBRA ROAD, SAN ANTONIO, TX, 78253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5156857,
    "lng": -98.7589805
  },
  {
    "id": "15184",
    "name": "CVS",
    "address": "336 SOUTH DELAWARE ST, INDIANAPOLIS, IN, 46204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6534032,
    "lng": -86.1540505
  },
  {
    "id": "15183",
    "name": "CVS",
    "address": "30 FAIRVIEW AVE S, SAINT PAUL, MN, 55105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9404351,
    "lng": -93.1763185
  },
  {
    "id": "15182",
    "name": "CVS",
    "address": "8030 CALLE TARTAK, CAROLINA, PR, 979",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4421259,
    "lng": -66.0215092
  },
  {
    "id": "15181",
    "name": "CVS",
    "address": "9917-A SPANISH FORT BLVD., SPANISH FORT, AL, 36527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6775858,
    "lng": -87.8527118
  },
  {
    "id": "15180",
    "name": "CVS",
    "address": "629 WEST LANCASTER AVE, WAYNE, PA, 19087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0466087,
    "lng": -75.4052457
  },
  {
    "id": "15179",
    "name": "CVS",
    "address": "5812 RIDGE RD., PARMA, OH, 44129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4043705,
    "lng": -81.7351985
  },
  {
    "id": "15178",
    "name": "CVS",
    "address": "10201 REISTERSTOWN RD, OWINGS MILLS, MD, 21117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4157612,
    "lng": -76.7741377
  },
  {
    "id": "15177",
    "name": "CVS",
    "address": "225 CAMBRIDGE ST, CAMBRIDGE, MA, 2141",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3712518,
    "lng": -71.0796525
  },
  {
    "id": "15176",
    "name": "CVS",
    "address": "115 EAST MAPLE ST, NEW LENOX, IL, 60451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5140755,
    "lng": -87.9652952
  },
  {
    "id": "15175",
    "name": "CVS",
    "address": "500 CONGRESS AVE, AUSTIN, TX, 78701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2673804,
    "lng": -97.7434102
  },
  {
    "id": "15174",
    "name": "CVS",
    "address": "8516 PARKER ROAD EAST, WYLIE, TX, 75098",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0541885,
    "lng": -96.5686812
  },
  {
    "id": "15173",
    "name": "CVS",
    "address": "7220 BLUE MOUND ROAD, FORT WORTH, TX, 76131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8718327,
    "lng": -97.3417396
  },
  {
    "id": "15172",
    "name": "CVS",
    "address": "1420 ST. CHARLES STREET, HOUMA, LA, 70360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5834129,
    "lng": -90.746579
  },
  {
    "id": "15171",
    "name": "CVS",
    "address": "311 SW 13TH ST., UNIT 101, GAINESVILLE, FL, 32601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.649095,
    "lng": -82.3388724
  },
  {
    "id": "15170",
    "name": "CVS",
    "address": "35 ARTA DRIVE, WESTLAKE, TX, 76262",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9864028,
    "lng": -97.1821199
  },
  {
    "id": "15169",
    "name": "CVS",
    "address": "8580 N. MACARTHUR BLVD, IRVING, TX, 75063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9228517,
    "lng": -96.955262
  },
  {
    "id": "15168",
    "name": "CVS",
    "address": "1933 HERITAGE TRACE PKWY, FORT WORTH, TX, 76177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9151503,
    "lng": -97.3323133
  },
  {
    "id": "15167",
    "name": "CVS",
    "address": "7615 WEST IRLO BRONSON MEM HWY, KISSIMMEE, FL, 34747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3358361,
    "lng": -81.590701
  },
  {
    "id": "15166",
    "name": "CVS",
    "address": "3000 RM 1431, ROUND ROCK, TX, 78681",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5506839,
    "lng": -97.7393786
  },
  {
    "id": "15165",
    "name": "CVS",
    "address": "5305 MONTANA AVENUE, EL PASO, TX, 79903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7841664,
    "lng": -106.4260024
  },
  {
    "id": "15164",
    "name": "CVS",
    "address": "170 WEST BROAD ST., ATHENS, GA, 30601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9573978,
    "lng": -83.3776024
  },
  {
    "id": "15163",
    "name": "CVS",
    "address": "2411 LANDMARK DR., RALEIGH, NC, 27607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8159491,
    "lng": -78.6985022
  },
  {
    "id": "15162",
    "name": "CVS",
    "address": "110 WEST MAIN ST., GARDNER, KS, 66030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8115474,
    "lng": -94.9280744
  },
  {
    "id": "15161",
    "name": "CVS",
    "address": "8491 FARM RD., LAS VEGAS, NV, 89131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3003321,
    "lng": -115.2826009
  },
  {
    "id": "15160",
    "name": "CVS",
    "address": "286 E. 7TH STREET, DOUGLAS, AZ, 85607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3420157,
    "lng": -109.558622
  },
  {
    "id": "15159",
    "name": "CVS",
    "address": "3033 HUNTINGTON DR., PASADENA, CA, 91107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1279929,
    "lng": -118.0896934
  },
  {
    "id": "15158",
    "name": "CVS",
    "address": "3905 TAYLORSVILLE RD, LOUISVILLE, KY, 40220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2204186,
    "lng": -85.6299691
  },
  {
    "id": "15157",
    "name": "CVS",
    "address": "370 RT 306, MONSEY, NY, 10952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.148074,
    "lng": -74.070374
  },
  {
    "id": "15156",
    "name": "CVS",
    "address": "411 BARNSTABLE RD, HYANNIS, MA, 2601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6640217,
    "lng": -70.2876622
  },
  {
    "id": "15155",
    "name": "CVS",
    "address": "744 US HWY 181 NORTH, FLORESVILLE, TX, 78114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.204226,
    "lng": -98.2139732
  },
  {
    "id": "15154",
    "name": "CVS",
    "address": "1101 NEW YORK AVE, NW, WASHINGTON, DC, 20005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9017151,
    "lng": -77.0275701
  },
  {
    "id": "15153",
    "name": "CVS",
    "address": "7950 E. HAMPDEN AVENUE, DENVER, CO, 80237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6529297,
    "lng": -104.8958067
  },
  {
    "id": "15152",
    "name": "CVS",
    "address": "1440 BROADWAY, FLOORS 1 & 2, NEW YORK, NY, 10018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7543953,
    "lng": -73.986453
  },
  {
    "id": "15151",
    "name": "CVS",
    "address": "2400 BUTLER PIKE, PLYMOUTH MEETING, PA, 19462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1096601,
    "lng": -75.2727887
  },
  {
    "id": "15150",
    "name": "CVS",
    "address": "709 GUADALUPE ST, LAREDO, TX, 78040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.5063891,
    "lng": -99.4890847
  },
  {
    "id": "15149",
    "name": "CVS",
    "address": "1850 5TH AVENUE, SAN DIEGO, CA, 92101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7248813,
    "lng": -117.1605279
  },
  {
    "id": "15148",
    "name": "CVS",
    "address": "820 S 5TH ST., WACO, TX, 76706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5508795,
    "lng": -97.1243708
  },
  {
    "id": "15147",
    "name": "CVS",
    "address": "1749 W. WALNUT ST., ROGERS, AR, 72756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3342732,
    "lng": -94.1432595
  },
  {
    "id": "15146",
    "name": "CVS",
    "address": "157 SOUTH BUCKMAN STREET, SHEPHERDSVILLE, KY, 40165",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9904158,
    "lng": -85.716578
  },
  {
    "id": "15145",
    "name": "CVS",
    "address": "15180 KENSINGTON PARK DR.,, TUSTIN, CA, 92782",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7106948,
    "lng": -117.8168094
  },
  {
    "id": "15144",
    "name": "CVS",
    "address": "7170 DAY CREEK BLVD., RANCHO CUCAMONGA, CA, 91739",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1233659,
    "lng": -117.5373853
  },
  {
    "id": "15143",
    "name": "CVS",
    "address": "6720 N. FRESNO ST., FRESNO, CA, 93710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8366769,
    "lng": -119.7803313
  },
  {
    "id": "15142",
    "name": "CVS",
    "address": "2115 ARTESIA BLVD, REDONDO BEACH, CA, 90278",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8734335,
    "lng": -118.3738611
  },
  {
    "id": "15141",
    "name": "CVS",
    "address": "2438 32ND AVE WEST, SEATTLE, WA, 98199",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6408405,
    "lng": -122.398
  },
  {
    "id": "15140",
    "name": "CVS",
    "address": "1010 N. PEPPER AVENUE, COLTON, CA, 92324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0780797,
    "lng": -117.3528156
  },
  {
    "id": "15139",
    "name": "CVS",
    "address": "8000 WEST SUNSET BLVD., #D1A-D1H, LOS ANGELES, CA, 90046",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0976043,
    "lng": -118.365233
  },
  {
    "id": "15138",
    "name": "CVS",
    "address": "111 NORTH MAIN ST., FRANKENMUTH, MI, 48734",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3361261,
    "lng": -83.7378848
  },
  {
    "id": "15137",
    "name": "CVS",
    "address": "1919 SPRINGFIELD PARKWAY, FORT MILL, SC, 29715",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0558784,
    "lng": -80.9385733
  },
  {
    "id": "15136",
    "name": "CVS",
    "address": "16920 LINCOLN AVENUE, PARKER, CO, 80134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5332907,
    "lng": -104.7927304
  },
  {
    "id": "15135",
    "name": "CVS",
    "address": "3770 SHERIDAN BLVD, DENVER, CO, 80212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7688401,
    "lng": -105.0528637
  },
  {
    "id": "15134",
    "name": "CVS",
    "address": "9936 WEST BOWLES AVENUE, LITTLETON, CO, 80123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6091488,
    "lng": -105.1091307
  },
  {
    "id": "15133",
    "name": "CVS",
    "address": "1122 S. UNIVERSITY AVENUE, LITTLE ROCK, AR, 72204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7420716,
    "lng": -92.3421182
  },
  {
    "id": "15132",
    "name": "CVS",
    "address": "13901 SENDERA RANCH BLVD., HASLET, TX, 76052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9831155,
    "lng": -97.3828063
  },
  {
    "id": "15131",
    "name": "CVS",
    "address": "506 EAST MAIN ST., STAUNTON, IL, 62088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0118357,
    "lng": -89.7823484
  },
  {
    "id": "15130",
    "name": "CVS",
    "address": "2120 WEST OSAGE ST., PACIFIC, MO, 63069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4839157,
    "lng": -90.7689911
  },
  {
    "id": "15129",
    "name": "CVS",
    "address": "535 E. DIVISION AVE., BARRON, WI, 54812",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.401809,
    "lng": -91.8504263
  },
  {
    "id": "15128",
    "name": "CVS",
    "address": "740 RAILROAD AVE. P.O. BOX 550, ALBANY, MN, 56307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.630151,
    "lng": -94.5735983
  },
  {
    "id": "15127",
    "name": "CVS",
    "address": "16641 MOUNTAIN RD, MONTPELIER, VA, 23192",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8138437,
    "lng": -77.6624264
  },
  {
    "id": "15126",
    "name": "CVS",
    "address": "18048 JEFFERSON DAVIS HIGHWAY, RUTHER GLEN, VA, 22546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0178514,
    "lng": -77.5156756
  },
  {
    "id": "15125",
    "name": "CVS",
    "address": "4664 BROWNS HILL RD., PITTSBURGH, PA, 15217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4145805,
    "lng": -79.922637
  },
  {
    "id": "15124",
    "name": "CVS",
    "address": "750 MEMORIAL PARKWAY, PHILLIPSBURG, NJ, 8865",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6968264,
    "lng": -75.1776018
  },
  {
    "id": "15123",
    "name": "CVS",
    "address": "1404 BLACKISTON MILL RD., CLARKSVILLE, IN, 47129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3114991,
    "lng": -85.768667
  },
  {
    "id": "15122",
    "name": "CVS",
    "address": "2312 BEMIDJI AVE. N, BEMIDJI, MN, 56601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.4914396,
    "lng": -94.8789865
  },
  {
    "id": "15121",
    "name": "CVS",
    "address": "4422 KALANI DR., DIAMONDHEAD, MS, 39525",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3766949,
    "lng": -89.3748089
  },
  {
    "id": "15120",
    "name": "CVS",
    "address": "25151 FULSHEAR GASTON RD., RICHMOND, TX, 77406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.685206,
    "lng": -95.8135882
  },
  {
    "id": "15119",
    "name": "CVS",
    "address": "934 NORTH CHARLES ST., BALTIMORE, MD, 21201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3008334,
    "lng": -76.6162248
  },
  {
    "id": "15118",
    "name": "CVS",
    "address": "9050 FM 1560 N, SAN ANTONIO, TX, 78254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.526051,
    "lng": -98.7176203
  },
  {
    "id": "15117",
    "name": "CVS",
    "address": "11918 AIRPORT RD., EVERETT, WA, 98204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.8895728,
    "lng": -122.2591782
  },
  {
    "id": "15116",
    "name": "CVS",
    "address": "1700 SEMINOLE TRAIL, CHARLOTTESVILLE, VA, 22901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0829466,
    "lng": -78.4739956
  },
  {
    "id": "15115",
    "name": "CVS",
    "address": "2650 GATEWAY ROAD, CARLSBAD, CA, 92009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.127573,
    "lng": -117.2542589
  },
  {
    "id": "15114",
    "name": "CVS",
    "address": "2385 N. SILVERBELL ROAD, TUCSON, AZ, 85745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2501458,
    "lng": -111.0142788
  },
  {
    "id": "15113",
    "name": "CVS",
    "address": "4082 SOUTH REDWOOD ROAD, WEST VALLEY CITY, UT, 84123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6825126,
    "lng": -111.9394172
  },
  {
    "id": "15112",
    "name": "CVS",
    "address": "429 L. ENFANT PLAXA CENTER, SUITE 465, WASHINGTON, DC, 20024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8838557,
    "lng": -77.0242219
  },
  {
    "id": "15111",
    "name": "CVS",
    "address": "16801 NW 67 AVE, MIAMI, FL, 33015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9262675,
    "lng": -80.3078179
  },
  {
    "id": "15110",
    "name": "CVS",
    "address": "141 WEST LINCOLN HWY, EXTON, PA, 19341",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0307403,
    "lng": -75.630956
  },
  {
    "id": "15109",
    "name": "CVS",
    "address": "13505 UNIVERSITY BLVD, SUGAR LAND, TX, 77479",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5846685,
    "lng": -95.647356
  },
  {
    "id": "15108",
    "name": "CVS",
    "address": "302 GATEWAY NORTH, MARBLE FALLS, TX, 78654",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5627417,
    "lng": -98.2747195
  },
  {
    "id": "15107",
    "name": "CVS",
    "address": "1 DORSET STREET, SOUTH BURLINGTON, VT, 5403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4687825,
    "lng": -73.1821463
  },
  {
    "id": "15106",
    "name": "CVS",
    "address": "1064 WILMOT RD, SCARSDALE, NY, 10583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9842831,
    "lng": -73.7776168
  },
  {
    "id": "15105",
    "name": "CVS",
    "address": "203 SOUTH PLANK RD., NEWBURGH, NY, 12550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5258348,
    "lng": -74.0708605
  },
  {
    "id": "15104",
    "name": "CVS",
    "address": "1227 US HWY 127 S, FRANKFORT, KY, 40601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1714035,
    "lng": -84.8984181
  },
  {
    "id": "15103",
    "name": "CVS",
    "address": "1020 SENECA ROAD, GREAT FALLS, VA, 22066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0018699,
    "lng": -77.344466
  },
  {
    "id": "15102",
    "name": "CVS",
    "address": "3001 HILLSBOROUGH ST., SUITE 100, RALEIGH, NC, 27607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7893855,
    "lng": -78.6763252
  },
  {
    "id": "15101",
    "name": "CVS",
    "address": "61 MAIN STREET, HOPKINTON, MA, 1748",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2278237,
    "lng": -71.522226
  },
  {
    "id": "15100",
    "name": "CVS",
    "address": "1501 WEST KINGS HIGHWAY, PARAGOULD, AR, 72450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0533005,
    "lng": -90.505683
  },
  {
    "id": "15099",
    "name": "CVS",
    "address": "2000 S. NAPERVILLE ROAD, WHEATON, IL, 60189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8338386,
    "lng": -88.1032789
  },
  {
    "id": "15098",
    "name": "CVS",
    "address": "6161 W. UNIVERSITY DR., MCKINNEY, TX, 75071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2174274,
    "lng": -96.696646
  },
  {
    "id": "15097",
    "name": "CVS",
    "address": "2600 SAM RAYBURN HWY,, MELISSA, TX, 75454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2830341,
    "lng": -96.5607407
  },
  {
    "id": "15096",
    "name": "CVS",
    "address": "10420 FM 1464, RICHMOND, TX, 77407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6619126,
    "lng": -95.6869282
  },
  {
    "id": "15095",
    "name": "CVS",
    "address": "4930 MAPLE AVE., DALLAS, TX, 75235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8153394,
    "lng": -96.8283557
  },
  {
    "id": "15094",
    "name": "CVS",
    "address": "8200 STATE HIGHWAY 45, AUSTIN, TX, 78739",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1933328,
    "lng": -97.9231126
  },
  {
    "id": "15093",
    "name": "CVS",
    "address": "9200 N. TARRANT PKWY., NORTH RICHLAND HILLS, TX, 76180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9031325,
    "lng": -97.1868556
  },
  {
    "id": "15092",
    "name": "CVS",
    "address": "111 E. HIDALGO ST., RAYMONDVILLE, TX, 78580",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4824913,
    "lng": -97.7819979
  },
  {
    "id": "15091",
    "name": "CVS",
    "address": "110 SOUTHWEST DR., JONESBORO, AR, 72401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8207299,
    "lng": -90.7065949
  },
  {
    "id": "15090",
    "name": "CVS",
    "address": "1555 EAST RENNER RD., RICHARDSON, TX, 75082",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9977271,
    "lng": -96.6960193
  },
  {
    "id": "15089",
    "name": "CVS",
    "address": "2180 WOODFOREST PARKWAY N., MONTGOMERY, TX, 77316",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2808402,
    "lng": -95.5714913
  },
  {
    "id": "15088",
    "name": "CVS",
    "address": "1919 SOUTH HOOVER ST., LOS ANGELES, CA, 90007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0392195,
    "lng": -118.2845537
  },
  {
    "id": "15087",
    "name": "CVS",
    "address": "50 SOUTH FORT LANE, LAYTON, UT, 84041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.059634,
    "lng": -111.9582982
  },
  {
    "id": "15086",
    "name": "CVS",
    "address": "1801 W. PARMER LANE, AUSTIN, TX, 78727",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4130779,
    "lng": -97.6913144
  },
  {
    "id": "15085",
    "name": "CVS",
    "address": "1500 LINCOLN HWY., SAINT CHARLES, IL, 60174",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8990905,
    "lng": -88.3322434
  },
  {
    "id": "15084",
    "name": "CVS",
    "address": "33520 21ST AVE. SW, FEDERAL WAY, WA, 98023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.3012813,
    "lng": -122.3602532
  },
  {
    "id": "15083",
    "name": "CVS",
    "address": "1950 STATE STREET, NEW ALBANY, IN, 47150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3020885,
    "lng": -85.8359603
  },
  {
    "id": "15082",
    "name": "CVS",
    "address": "165 MAIN ST., FORT LEE, NJ, 7024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8513788,
    "lng": -73.9685857
  },
  {
    "id": "15081",
    "name": "CVS",
    "address": "757 3RD AVE., NEW YORK, NY, 10017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7539115,
    "lng": -73.971662
  },
  {
    "id": "15080",
    "name": "CVS",
    "address": "711 GLEN COVE RD., GLEN HEAD, NY, 11545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8372998,
    "lng": -73.6154921
  },
  {
    "id": "15079",
    "name": "CVS",
    "address": "362 MAIN ST, STURBRIDGE, MA, 1566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1126011,
    "lng": -72.0886178
  },
  {
    "id": "15078",
    "name": "CVS",
    "address": "6383 TEN OAKS ROAD, CLARKSVILLE, MD, 21029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2071146,
    "lng": -76.944096
  },
  {
    "id": "15077",
    "name": "CVS",
    "address": "2962 AVENTURA BLVD., AVENTURA, FL, 33180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9609478,
    "lng": -80.1410536
  },
  {
    "id": "15076",
    "name": "CVS",
    "address": "2300 LAKE ROAD, DYERSBURG, TN, 38024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0591894,
    "lng": -89.3941629
  },
  {
    "id": "15075",
    "name": "CVS",
    "address": "9701 SW 72ND ST., MIAMI, FL, 33173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.702056,
    "lng": -80.3507696
  },
  {
    "id": "15074",
    "name": "CVS",
    "address": "4401 ANDREWS HWY, MIDLAND, TX, 79703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0011938,
    "lng": -102.1375902
  },
  {
    "id": "15073",
    "name": "CVS",
    "address": "1101 FM 2181, CORINTH, TX, 76210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1327704,
    "lng": -97.0951471
  },
  {
    "id": "15072",
    "name": "CVS",
    "address": "2451 E. UNIVERSITY DRIVE, PROSPER, TX, 75078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2193955,
    "lng": -96.7668817
  },
  {
    "id": "15071",
    "name": "CVS",
    "address": "9188 INTERNATIONAL DR., ORLANDO, FL, 32819",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4314299,
    "lng": -81.4714526
  },
  {
    "id": "15070",
    "name": "CVS",
    "address": "9410 FUQUA ST., HOUSTON, TX, 77075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6105429,
    "lng": -95.2491139
  },
  {
    "id": "15069",
    "name": "CVS",
    "address": "6750 READING ROAD, ROSENBERG, TX, 77471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5400767,
    "lng": -95.7524467
  },
  {
    "id": "15068",
    "name": "CVS",
    "address": "476 W. 1-30, ROYSE CITY, TX, 75189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9655192,
    "lng": -96.3399184
  },
  {
    "id": "15067",
    "name": "CVS",
    "address": "2350 N. FITZHUGH AVENUE, DALLAS, TX, 75204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8116245,
    "lng": -96.7812776
  },
  {
    "id": "15066",
    "name": "CVS",
    "address": "3502 SE MILITARY DR., SAN ANTONIO, TX, 78223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.3522332,
    "lng": -98.4263914
  },
  {
    "id": "15065",
    "name": "CVS",
    "address": "3711 W. DAVIS ST., CONROE, TX, 77304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3249273,
    "lng": -95.496339
  },
  {
    "id": "15064",
    "name": "CVS",
    "address": "177 WEST VIRGINIA STREET, CRYSTAL LAKE, IL, 60014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2258681,
    "lng": -88.3276509
  },
  {
    "id": "15063",
    "name": "CVS",
    "address": "107 BELLEVUE WAY, SE, BELLEVUE, WA, 98004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6095885,
    "lng": -122.2017093
  },
  {
    "id": "15062",
    "name": "CVS",
    "address": "5326 WEST 11000 NORTH, HIGHLAND, UT, 84003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4324647,
    "lng": -111.7859273
  },
  {
    "id": "15061",
    "name": "CVS",
    "address": "7547 E. SOUTHERN AVE., MESA, AZ, 85209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3927751,
    "lng": -111.6685412
  },
  {
    "id": "15060",
    "name": "CVS",
    "address": "5450 WEST HAPPY VALLEY ROAD, PHOENIX, AZ, 85053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7130203,
    "lng": -112.1778276
  },
  {
    "id": "15059",
    "name": "CVS",
    "address": "812 S GRAND AVE, LOS ANGELES, CA, 90017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0447879,
    "lng": -118.257596
  },
  {
    "id": "15058",
    "name": "CVS",
    "address": "1000 WEST ST. GEORGE'S AVE., LINDEN, NJ, 7036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6280663,
    "lng": -74.272447
  },
  {
    "id": "15057",
    "name": "CVS",
    "address": "143 RT 303, VALLEY COTTAGE, NY, 10989",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1223904,
    "lng": -73.9425721
  },
  {
    "id": "15056",
    "name": "CVS",
    "address": "4020 CONCORD PIKE, WILMINGTON, DE, 19803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8097265,
    "lng": -75.5511876
  },
  {
    "id": "15055",
    "name": "CVS",
    "address": "1357 LAKEWOOD ROAD, TOMS RIVER, NJ, 8755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9930977,
    "lng": -74.2106872
  },
  {
    "id": "15054",
    "name": "CVS",
    "address": "37 WEST MAIN ST., STAFFORD SPRINGS, CT, 6076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9544952,
    "lng": -72.3090051
  },
  {
    "id": "15053",
    "name": "CVS",
    "address": "4489 COUNTY ROAD 94, MANVEL, TX, 77578",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5275651,
    "lng": -95.3819315
  },
  {
    "id": "15052",
    "name": "CVS",
    "address": "15027 STATE HWY 6, ROSHARON, TX, 77583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4964091,
    "lng": -95.4382679
  },
  {
    "id": "15051",
    "name": "CVS",
    "address": "10515 FRY RD., BUILDING A1, CYPRESS, TX, 77433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9395676,
    "lng": -95.7240999
  },
  {
    "id": "15050",
    "name": "CVS",
    "address": "655 MOUNT AUBURN STREET, WATERTOWN, MA, 2472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3717189,
    "lng": -71.1568272
  },
  {
    "id": "15049",
    "name": "CVS",
    "address": "8731 POTEET JOURDANTON FREEWAY, SAN ANTONIO, TX, 78224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.3368427,
    "lng": -98.5519145
  },
  {
    "id": "15048",
    "name": "CVS",
    "address": "720 BOSTON TURNPIKE, SHREWSBURY, MA, 1545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2766993,
    "lng": -71.6959788
  },
  {
    "id": "15047",
    "name": "CVS",
    "address": "200 CIBOLO VALLEY DR., CIBOLO, TX, 78108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5715962,
    "lng": -98.2328604
  },
  {
    "id": "15046",
    "name": "CVS",
    "address": "500 N. CARROLLTON AVE., NEW ORLEANS, LA, 70119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9777246,
    "lng": -90.0964784
  },
  {
    "id": "15045",
    "name": "CVS",
    "address": "2506 NILES AVENUE, SAINT JOSEPH, MI, 49085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0901494,
    "lng": -86.4856367
  },
  {
    "id": "15044",
    "name": "CVS",
    "address": "16088 SPRING MILL STATION DR., WESTFIELD, IN, 46074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0204914,
    "lng": -86.1641996
  },
  {
    "id": "15043",
    "name": "CVS",
    "address": "4701 WILKENS AVE, CATONSVILLE, MD, 21228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2638219,
    "lng": -76.7001496
  },
  {
    "id": "15042",
    "name": "CVS",
    "address": "23684 STRICKLAND DRIVE, ASHBURN, VA, 20148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9636587,
    "lng": -77.5437153
  },
  {
    "id": "15041",
    "name": "CVS",
    "address": "12740 ELDORADO PKWY., FRISCO, TX, 75035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1751513,
    "lng": -96.7672163
  },
  {
    "id": "15040",
    "name": "CVS",
    "address": "4600 BROADWAY ST., ALAMO HEIGHTS, TX, 78209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4684869,
    "lng": -98.4633716
  },
  {
    "id": "15039",
    "name": "CVS",
    "address": "11506 S 4000 W, SOUTH JORDAN, UT, 84009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.543379,
    "lng": -111.986848
  },
  {
    "id": "15038",
    "name": "CVS",
    "address": "475 EAST STATE RD., AMERICAN FORK, UT, 84003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3748524,
    "lng": -111.7861062
  },
  {
    "id": "15037",
    "name": "CVS",
    "address": "3802 EAST BROAD ST., MANSFIELD, TX, 76063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5793529,
    "lng": -97.0743409
  },
  {
    "id": "15036",
    "name": "CVS",
    "address": "4908 HOUSTON FIELD COURT, CHARLOTTE, NC, 28277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0505118,
    "lng": -80.7689836
  },
  {
    "id": "15035",
    "name": "CVS",
    "address": "309 NASHUA ST., MILFORD, NH, 3055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8329395,
    "lng": -71.6446689
  },
  {
    "id": "15034",
    "name": "CVS",
    "address": "3200 ST. PAUL ST, BALTIMORE, MD, 21218",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.327239,
    "lng": -76.6162771
  },
  {
    "id": "15033",
    "name": "CVS",
    "address": "7706 MILESTONE PARKWAY, HANOVER, MD, 21076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1543004,
    "lng": -76.7440227
  },
  {
    "id": "15032",
    "name": "CVS",
    "address": "44835 RUSSEL BRANCH PARKWAY, ASHBURN, VA, 20147",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0494066,
    "lng": -77.4500285
  },
  {
    "id": "15031",
    "name": "CVS",
    "address": "939 GIROD ST., SUITE 160, NEW ORLEANS, LA, 70113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9483598,
    "lng": -90.0745226
  },
  {
    "id": "15030",
    "name": "CVS",
    "address": "304 SOUTH 5TH STREET, LEESVILLE, LA, 71446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.1415173,
    "lng": -93.2643741
  },
  {
    "id": "15029",
    "name": "CVS",
    "address": "667 EAST 9000 SOUTH, SANDY, UT, 84070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5884905,
    "lng": -111.8727882
  },
  {
    "id": "15028",
    "name": "CVS",
    "address": "14290 SOUTH LA GRANGE RD., ORLAND PARK, IL, 60462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6308805,
    "lng": -87.8545918
  },
  {
    "id": "15027",
    "name": "CVS",
    "address": "2111 W. ALABAMA ST., HOUSTON, TX, 77098",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7382087,
    "lng": -95.4115106
  },
  {
    "id": "15026",
    "name": "CVS",
    "address": "85 MAIN ST., HACKETTSTOWN, NJ, 7840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8559117,
    "lng": -74.8336152
  },
  {
    "id": "15025",
    "name": "CVS",
    "address": "2200 BRACKET AVE., EAU CLAIRE, WI, 54701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8006863,
    "lng": -91.4696794
  },
  {
    "id": "15024",
    "name": "CVS",
    "address": "1108 N. 14TH ST., SHEBOYGAN, WI, 53081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.7569927,
    "lng": -87.7235435
  },
  {
    "id": "15023",
    "name": "CVS",
    "address": "2600 W. MICHIGAN AVE., KALAMAZOO, MI, 49006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2821377,
    "lng": -85.6222068
  },
  {
    "id": "15022",
    "name": "CVS",
    "address": "10 EAST COLUMBIA AVE., BATTLE CREEK, MI, 49015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2977985,
    "lng": -85.1988762
  },
  {
    "id": "15021",
    "name": "CVS",
    "address": "1580 BRYAN RD., O FALLON, MO, 63366",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7738482,
    "lng": -90.7367231
  },
  {
    "id": "15020",
    "name": "CVS",
    "address": "5902 FM 1463 RD., KATY, TX, 77494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7058408,
    "lng": -95.8468821
  },
  {
    "id": "15019",
    "name": "CVS",
    "address": "9089 FAIR OAKS PARKWAY, FAIR OAKS RANCH, TX, 78015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7204557,
    "lng": -98.6652429
  },
  {
    "id": "15018",
    "name": "CVS",
    "address": "3630 CENTRAL AVE., HOT SPRINGS, AR, 71913",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4671607,
    "lng": -93.0602023
  },
  {
    "id": "15017",
    "name": "CVS",
    "address": "220 SOUTH FM 1626, BUDA, TX, 78610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.096699,
    "lng": -97.8757051
  },
  {
    "id": "15016",
    "name": "CVS",
    "address": "3915 DURAND AVE., RACINE, WI, 53405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6961466,
    "lng": -87.8264989
  },
  {
    "id": "15015",
    "name": "CVS",
    "address": "7111 EAST BELL RD., SCOTTSDALE, AZ, 85254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6381168,
    "lng": -111.927377
  },
  {
    "id": "15014",
    "name": "CVS",
    "address": "7650 PORT CAPITAL DRIVE, JESSUP, MD, 20794",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.174216,
    "lng": -76.777879
  },
  {
    "id": "15013",
    "name": "CVS",
    "address": "331-347 FERRY STREET, NEWARK, NJ, 7105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.729201,
    "lng": -74.1486432
  },
  {
    "id": "15012",
    "name": "CVS",
    "address": "259 MARKET ST., PHILADELPHIA, PA, 19106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9503413,
    "lng": -75.1453259
  },
  {
    "id": "15011",
    "name": "CVS",
    "address": "1177 US HWY 380, FRISCO, TX, 75068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2190679,
    "lng": -96.8808647
  },
  {
    "id": "15010",
    "name": "CVS",
    "address": "270 STONEBROOK PKWY., FRISCO, TX, 75036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1453295,
    "lng": -96.8901451
  },
  {
    "id": "15009",
    "name": "CVS",
    "address": "1401 UNIVERSITY AVENUE, LUBBOCK, TX, 79401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5824003,
    "lng": -101.8702999
  },
  {
    "id": "15008",
    "name": "CVS",
    "address": "2107 NW CACHE ROAD, LAWTON, OK, 73505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6240132,
    "lng": -98.4227917
  },
  {
    "id": "15007",
    "name": "CVS",
    "address": "2001 S.THOMPSON ST, SPRINGDALE, AR, 72764",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1666966,
    "lng": -94.1410606
  },
  {
    "id": "15006",
    "name": "CVS",
    "address": "825 OAK ST., CONWAY, AR, 72032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0915186,
    "lng": -92.4364103
  },
  {
    "id": "15005",
    "name": "CVS",
    "address": "91 SEAPORT BLVD, BOSTON, MA, 2210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3515607,
    "lng": -71.0461298
  },
  {
    "id": "15004",
    "name": "CVS",
    "address": "1119 MINERAL WELLS AVE., PARIS, TN, 38242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2840454,
    "lng": -88.3071302
  },
  {
    "id": "15003",
    "name": "CVS",
    "address": "1720 CENTRAL AVENUE, MCKINLEYVILLE, CA, 95519",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.936428,
    "lng": -124.1015436
  },
  {
    "id": "15002",
    "name": "CVS",
    "address": "3627 EAST CESAR EAST CHAVEZ AVE., LOS ANGELES, CA, 90063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0406816,
    "lng": -118.1862039
  },
  {
    "id": "15001",
    "name": "CVS",
    "address": "4949 SANTA MONICA AVE., SAN DIEGO, CA, 92107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7469982,
    "lng": -117.2496994
  },
  {
    "id": "15000",
    "name": "CVS",
    "address": "3320 NORTH BELT HIGHWAY, SAINT JOSEPH, MO, 64506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8004217,
    "lng": -94.8155344
  },
  {
    "id": "14999",
    "name": "CVS",
    "address": "4191 W INDIANTOWN RD., JUPITER, FL, 33478",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.9358247,
    "lng": -80.1607379
  },
  {
    "id": "14998",
    "name": "CVS",
    "address": "20 TARRYTOWN ROAD, WHITE PLAINS, NY, 10607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0377906,
    "lng": -73.7804204
  },
  {
    "id": "14997",
    "name": "CVS",
    "address": "75 STOREY AVE., NEWBURYPORT, MA, 1950",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8194127,
    "lng": -70.909678
  },
  {
    "id": "14996",
    "name": "CVS",
    "address": "1788 N. PIERCE STREET, ARLINGTON, VA, 22209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8946203,
    "lng": -77.076668
  },
  {
    "id": "14995",
    "name": "CVS",
    "address": "901 SUMNEYTOWN PIKE, SPRING HOUSE, PA, 19477",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1871332,
    "lng": -75.2288085
  },
  {
    "id": "14994",
    "name": "CVS",
    "address": "8601 BOAT CLUB RD., FORT WORTH, TX, 76179",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8802329,
    "lng": -97.4264324
  },
  {
    "id": "14993",
    "name": "CVS",
    "address": "1305 N. HWY 377, ROANOKE, TX, 76262",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0159194,
    "lng": -97.2200362
  },
  {
    "id": "14992",
    "name": "CVS",
    "address": "301 CHRIS KELLEY BLVD., HUTTO, TX, 78634",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5345731,
    "lng": -97.5629486
  },
  {
    "id": "14991",
    "name": "CVS",
    "address": "919 WURZBACH PARKWAY, SAN ANTONIO, TX, 78231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5587413,
    "lng": -98.5181346
  },
  {
    "id": "14990",
    "name": "CVS",
    "address": "1600 ELYSIAN FIELDS AVE., NEW ORLEANS, LA, 70117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9743119,
    "lng": -90.057672
  },
  {
    "id": "14989",
    "name": "CVS",
    "address": "14201 HICKMAN RD., URBANDALE, IA, 50323",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6157514,
    "lng": -93.8150499
  },
  {
    "id": "14988",
    "name": "CVS",
    "address": "4000 W. SPRING CREEK PKWY, PLANO, TX, 75024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0559268,
    "lng": -96.7710848
  },
  {
    "id": "14987",
    "name": "CVS",
    "address": "657 US HIGHWAY 101 N., CRESCENT CITY, CA, 95531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7622242,
    "lng": -124.1963882
  },
  {
    "id": "14986",
    "name": "CVS",
    "address": "18820 STATE HWY 305 NE, POULSBO, WA, 98370",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.733949,
    "lng": -122.6361431
  },
  {
    "id": "14985",
    "name": "CVS",
    "address": "101 WEST KARSCH BLVD., FARMINGTON, MO, 63640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7874515,
    "lng": -90.420637
  },
  {
    "id": "14984",
    "name": "CVS",
    "address": "3900 W. ELM ST., MCHENRY, IL, 60050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.345005,
    "lng": -88.2741678
  },
  {
    "id": "14983",
    "name": "CVS",
    "address": "3780 WILLOW RD., NORTHBROOK, IL, 60062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1093364,
    "lng": -87.8732723
  },
  {
    "id": "14982",
    "name": "CVS",
    "address": "50 STERLING WAY, DOVER, NH, 3820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1888659,
    "lng": -70.8873175
  },
  {
    "id": "14981",
    "name": "CVS",
    "address": "720 BRANCHVILLE RD, RIDGEFIELD, CT, 6877",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2672323,
    "lng": -73.4436939
  },
  {
    "id": "14980",
    "name": "CVS",
    "address": "12806 BROADWAY ST., PEARLAND, TX, 77584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5545991,
    "lng": -95.4181327
  },
  {
    "id": "14979",
    "name": "CVS",
    "address": "1919 MARKET ST. SUITE 150, PHILADELPHIA, PA, 19103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9539045,
    "lng": -75.1727064
  },
  {
    "id": "14978",
    "name": "CVS",
    "address": "300 ATLANTIC CITY BLVD., BEACHWOOD, NJ, 8722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9400435,
    "lng": -74.1902794
  },
  {
    "id": "14977",
    "name": "CVS",
    "address": "12755 JEFFERSON AVE, NEWPORT NEWS, VA, 23602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.137652,
    "lng": -76.5200098
  },
  {
    "id": "14976",
    "name": "CVS",
    "address": "2420 LINCOLN WAY, #104, AMES, IA, 50014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0225329,
    "lng": -93.6496109
  },
  {
    "id": "14975",
    "name": "CVS",
    "address": "19507 HIGHWAY 99, LYNNWOOD, WA, 98036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.821678,
    "lng": -122.3141658
  },
  {
    "id": "14974",
    "name": "CVS",
    "address": "610 SILVER HEIGHTS BLVD., SILVER CITY, NM, 88061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7823608,
    "lng": -108.2690312
  },
  {
    "id": "14973",
    "name": "CVS",
    "address": "801 N. CANAL ST., CARLSBAD, NM, 88220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4289198,
    "lng": -104.2293398
  },
  {
    "id": "14972",
    "name": "CVS",
    "address": "1019 EAST CALTON RD., LAREDO, TX, 78041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.5404804,
    "lng": -99.4845037
  },
  {
    "id": "14971",
    "name": "CVS",
    "address": "125 N. CENTRAL AVENUE, GLENDALE, CA, 91203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1476006,
    "lng": -118.2582355
  },
  {
    "id": "14970",
    "name": "CVS",
    "address": "1015 S. SAGINAW RD., MIDLAND, MI, 48640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.619119,
    "lng": -84.2179579
  },
  {
    "id": "14969",
    "name": "CVS",
    "address": "2307 23RD ST., COLUMBUS, NE, 68601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4379954,
    "lng": -97.3561502
  },
  {
    "id": "14968",
    "name": "CVS",
    "address": "5201 GOLDEN TRIANGLE BLVD., FORT WORTH, TX, 76244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9323888,
    "lng": -97.271608
  },
  {
    "id": "14967",
    "name": "CVS",
    "address": "29171 NEWPORT ROAD, MENIFEE, CA, 92584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6846187,
    "lng": -117.1510387
  },
  {
    "id": "14966",
    "name": "CVS",
    "address": "6201 HOLLYWOOD BLVD., SUITE 126, LOS ANGELES, CA, 90028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1018822,
    "lng": -118.3249023
  },
  {
    "id": "14965",
    "name": "CVS",
    "address": "3220 N. REYNOLDS RD., BRYANT, AR, 72022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6244733,
    "lng": -92.4986772
  },
  {
    "id": "14964",
    "name": "CVS",
    "address": "19995 HIGHWAY 46 WEST, SPRING BRANCH, TX, 78070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7967966,
    "lng": -98.4184623
  },
  {
    "id": "14963",
    "name": "CVS",
    "address": "20 AIRPORT ROAD, SEDONA, AZ, 86336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8622653,
    "lng": -111.7796783
  },
  {
    "id": "14962",
    "name": "CVS",
    "address": "5557 WEST 4100 SOUTH, WEST VALLEY CITY, UT, 84120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.681504,
    "lng": -112.0238835
  },
  {
    "id": "14961",
    "name": "CVS",
    "address": "1269 E 2100 S, SALT LAKE CITY, UT, 84106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7256706,
    "lng": -111.8541956
  },
  {
    "id": "14960",
    "name": "CVS",
    "address": "1407 EGG HARBOR RD., STURGEON BAY, WI, 54235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8481817,
    "lng": -87.3613369
  },
  {
    "id": "14959",
    "name": "CVS",
    "address": "200 JUNGERMANN RD., SAINT PETERS, MO, 63376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7907666,
    "lng": -90.57699
  },
  {
    "id": "14958",
    "name": "CVS",
    "address": "1153 ELM ST., SPRINGFIELD, MO, 65806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2054511,
    "lng": -93.2763994
  },
  {
    "id": "14957",
    "name": "CVS",
    "address": "804 MAINE AVENUE SW, WASHINGTON, DC, 20024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8796413,
    "lng": -77.0244045
  },
  {
    "id": "14956",
    "name": "CVS",
    "address": "310 SO. PRESTON RD.,, CELINA, TX, 75009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.320312,
    "lng": -96.7765451
  },
  {
    "id": "14955",
    "name": "CVS",
    "address": "618 NORTH MAIN ST., #5, DONNA, TX, 78537",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1808322,
    "lng": -98.0519953
  },
  {
    "id": "14954",
    "name": "CVS",
    "address": "8049 FM 2673, CANYON LAKE, TX, 78133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8430969,
    "lng": -98.2674091
  },
  {
    "id": "14953",
    "name": "CVS",
    "address": "3373 E. LINCOLN HWY., PARKESBURG, PA, 19365",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9841606,
    "lng": -75.9318592
  },
  {
    "id": "14952",
    "name": "CVS",
    "address": "20 UPPER ROCK CIRCLE, ROCKVILLE, MD, 20850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1136609,
    "lng": -77.1854503
  },
  {
    "id": "14951",
    "name": "CVS",
    "address": "1 JEFFERSON ST., SAN FRANCISCO, CA, 94133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8084725,
    "lng": -122.412724
  },
  {
    "id": "14950",
    "name": "CVS",
    "address": "3503 ROUTE 46, PARSIPPANY, NJ, 7054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8743351,
    "lng": -74.4368539
  },
  {
    "id": "14949",
    "name": "CVS",
    "address": "501 NORTH 22ND ST., PHILADELPHIA, PA, 19130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9630446,
    "lng": -75.1737505
  },
  {
    "id": "14948",
    "name": "CVS",
    "address": "339 E. LANCASTER AVE., WYNNEWOOD, PA, 19096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0019361,
    "lng": -75.2771272
  },
  {
    "id": "14947",
    "name": "CVS",
    "address": "604 CORNER KETCH RD, NEWARK, DE, 19711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7402164,
    "lng": -75.7250194
  },
  {
    "id": "14946",
    "name": "CVS",
    "address": "674 MIDDLETOWN ODESSA RD., MIDDLETOWN, DE, 19709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4527776,
    "lng": -75.6818081
  },
  {
    "id": "14945",
    "name": "CVS",
    "address": "117 SW 160TH STREET, BURIEN, WA, 98166",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.4593282,
    "lng": -122.3352448
  },
  {
    "id": "14944",
    "name": "CVS",
    "address": "1040 WEST CHESTER PIKE, WEST CHESTER, PA, 19382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9673868,
    "lng": -75.5772482
  },
  {
    "id": "14943",
    "name": "CVS",
    "address": "7777 S. REDWOOD RD., WEST JORDAN, UT, 84084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6099964,
    "lng": -111.9380432
  },
  {
    "id": "14942",
    "name": "CVS",
    "address": "965 WHITE PLAINS RD, TRUMBULL, CT, 6611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2454525,
    "lng": -73.1992152
  },
  {
    "id": "14941",
    "name": "CVS",
    "address": "496 HIGH ST., MORGANTOWN, WV, 26505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6318834,
    "lng": -79.9537157
  },
  {
    "id": "14940",
    "name": "CVS",
    "address": "4251 U.S. HWY 9, HOWELL, NJ, 7731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1500665,
    "lng": -74.2257279
  },
  {
    "id": "14939",
    "name": "CVS",
    "address": "12027 TOWN SQUARE STREET, RESTON, VA, 20190",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.958032,
    "lng": -77.361396
  },
  {
    "id": "14938",
    "name": "CVS",
    "address": "474 WINTON PKWY, LIVINGSTON, CA, 95334",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.386381,
    "lng": -120.7367013
  },
  {
    "id": "14937",
    "name": "CVS",
    "address": "1544 BASS RD., MACON, GA, 31210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9270319,
    "lng": -83.7356439
  },
  {
    "id": "14936",
    "name": "CVS",
    "address": "1550 SOUTH NEW FLORISSANT RD, FLORISSANT, MO, 63031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7745733,
    "lng": -90.317299
  },
  {
    "id": "14935",
    "name": "CVS",
    "address": "717 UNIVERSITY DR. SUITE 101, COLLEGE STATION, TX, 77840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6212545,
    "lng": -96.342544
  },
  {
    "id": "14934",
    "name": "CVS",
    "address": "4523 L J PARKWAY, SUGAR LAND, TX, 77479",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5480707,
    "lng": -95.5859342
  },
  {
    "id": "14933",
    "name": "CVS",
    "address": "210 EAST BROAD ST., MINEOLA, TX, 75773",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6625989,
    "lng": -95.4878992
  },
  {
    "id": "14932",
    "name": "CVS",
    "address": "10820 MANCHESTER RD., KIRKWOOD, MO, 63122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5996192,
    "lng": -90.4069062
  },
  {
    "id": "14931",
    "name": "CVS",
    "address": "3148 WEST 3500 SOUTH, WEST VALLEY CITY, UT, 84119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6972892,
    "lng": -111.9664746
  },
  {
    "id": "14930",
    "name": "CVS",
    "address": "531 QUEEN ANNE AVENUE, NORTH, SEATTLE, WA, 98109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6241424,
    "lng": -122.3569815
  },
  {
    "id": "14929",
    "name": "CVS",
    "address": "8101 CLAYTON RD., CLAYTON, MO, 63117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6387923,
    "lng": -90.3459355
  },
  {
    "id": "14928",
    "name": "CVS",
    "address": "302 ROUTE 94, VERNON, NJ, 7462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.198715,
    "lng": -74.485075
  },
  {
    "id": "14927",
    "name": "CVS",
    "address": "3401 CHARLES STREET, BAILEYS CROSSROADS, VA, 22041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8531272,
    "lng": -77.1353486
  },
  {
    "id": "14926",
    "name": "CVS",
    "address": "72 WASHINGTON STREET, FOXBOROUGH, MA, 2035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0905477,
    "lng": -71.2700667
  },
  {
    "id": "14925",
    "name": "CVS",
    "address": "8 ROYCE CIRCLE, (TS-3), STORRS MANSFIELD, CT, 6268",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8041096,
    "lng": -72.2431741
  },
  {
    "id": "14924",
    "name": "CVS",
    "address": "1221 MAIN STREET, MANCHESTER, CT, 6040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7651723,
    "lng": -72.5200206
  },
  {
    "id": "14923",
    "name": "CVS",
    "address": "1901 AVE REXACH, SAN JUAN, PR, 915",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.436647,
    "lng": -66.0595966
  },
  {
    "id": "14922",
    "name": "CVS",
    "address": "2502 MARSHALL RD., SAN ANTONIO, TX, 78259",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.660425,
    "lng": -98.449356
  },
  {
    "id": "14921",
    "name": "CVS",
    "address": "1795 E. LUGONIA AVE., REDLANDS, CA, 92374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0705221,
    "lng": -117.1394352
  },
  {
    "id": "14920",
    "name": "CVS",
    "address": "210 WEST 7TH STREET,, LOS ANGELES, CA, 90014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0446725,
    "lng": -118.2527975
  },
  {
    "id": "14919",
    "name": "CVS",
    "address": "6310 E. BROADWAY BLVD., TUCSON, AZ, 85710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2205133,
    "lng": -110.8572477
  },
  {
    "id": "14918",
    "name": "CVS",
    "address": "241 WEST 57TH ST., NEW YORK, NY, 10019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7667995,
    "lng": -73.9825793
  },
  {
    "id": "14917",
    "name": "CVS",
    "address": "841 BISHOP ST., SUITE 105, HONOLULU, HI, 96813",
    "phone": "",
    "hours": "Call for hours",
    "lat": 21.3073327,
    "lng": -157.8619153
  },
  {
    "id": "14916",
    "name": "CVS",
    "address": "4030 SOUTH WESTERN AVE., LOS ANGELES, CA, 90062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.009847,
    "lng": -118.3081121
  },
  {
    "id": "14915",
    "name": "CVS",
    "address": "1601 KINGS HWY, BROOKLYN, NY, 11229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6095009,
    "lng": -73.9571521
  },
  {
    "id": "14914",
    "name": "CVS",
    "address": "215 BERGEN BLVD., FAIRVIEW, NJ, 7022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8191783,
    "lng": -74.0023773
  },
  {
    "id": "14913",
    "name": "CVS",
    "address": "10712 SE CARR ROAD, RENTON, WA, 98055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.4455864,
    "lng": -122.1977389
  },
  {
    "id": "14912",
    "name": "CVS",
    "address": "20 WELCHER AVE., PEEKSKILL, NY, 10566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2705782,
    "lng": -73.936648
  },
  {
    "id": "14911",
    "name": "CVS",
    "address": "137 E. FRANKLIN ST., CHAPEL HILL, NC, 27514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.913954,
    "lng": -79.0544862
  },
  {
    "id": "14910",
    "name": "CVS",
    "address": "1510 W. HICKORY ST., DENTON, TX, 76201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2148802,
    "lng": -97.1488171
  },
  {
    "id": "14909",
    "name": "CVS",
    "address": "710 HIGHWAY 361, PORT ARANSAS, TX, 78373",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8280367,
    "lng": -97.0681214
  },
  {
    "id": "14908",
    "name": "CVS",
    "address": "8789 WEST FM 1960 BYPASS RD.,, HUMBLE, TX, 77338",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0055876,
    "lng": -95.2919608
  },
  {
    "id": "14907",
    "name": "CVS",
    "address": "2421 SAM HOUSTON AVE., HUNTSVILLE, TX, 77340",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.7075391,
    "lng": -95.547209
  },
  {
    "id": "14906",
    "name": "CVS",
    "address": "1118 S WW WHITE RD., SAN ANTONIO, TX, 78220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4130157,
    "lng": -98.4049734
  },
  {
    "id": "14905",
    "name": "CVS",
    "address": "7798 SO. PADRE ISLAND DR., CORPUS CHRISTI, TX, 78412",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.6895355,
    "lng": -97.3306858
  },
  {
    "id": "14904",
    "name": "CVS",
    "address": "12380 ST. CHARLES ROCK RD., BRIDGETON, MO, 63044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7536382,
    "lng": -90.430031
  },
  {
    "id": "14903",
    "name": "CVS",
    "address": "720 NORTHWESTERN AVE,  STE #6, WEST LAFAYETTE, IN, 47906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4326562,
    "lng": -86.9147827
  },
  {
    "id": "14902",
    "name": "CVS",
    "address": "2161 WILLIAM ST., CAPE GIRARDEAU, MO, 63703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3027917,
    "lng": -89.551311
  },
  {
    "id": "14901",
    "name": "CVS",
    "address": "2704 OAKLAWN BLVD., HOPEWELL, VA, 23860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2842084,
    "lng": -77.3017931
  },
  {
    "id": "14900",
    "name": "CVS",
    "address": "212 E. WOOSTER ST., BOWLING GREEN, OH, 43402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3744348,
    "lng": -83.6481871
  },
  {
    "id": "14899",
    "name": "CVS",
    "address": "4121 MONROE, TOLEDO, OH, 43606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6799827,
    "lng": -83.6041071
  },
  {
    "id": "14898",
    "name": "CVS",
    "address": "700 EL CAMINO REAL, MENLO PARK, CA, 94025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4516279,
    "lng": -122.1784631
  },
  {
    "id": "14897",
    "name": "CVS",
    "address": "702 NAAMANS RD., CLAYMONT, DE, 19703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8170079,
    "lng": -75.4603717
  },
  {
    "id": "14896",
    "name": "CVS",
    "address": "457 ROUTE 46, ROCKAWAY, NJ, 7866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8859856,
    "lng": -74.5300785
  },
  {
    "id": "14895",
    "name": "CVS",
    "address": "4240 HARRISON BLVD., OGDEN, UT, 84403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1856499,
    "lng": -111.9484298
  },
  {
    "id": "14894",
    "name": "CVS",
    "address": "1273 N. UNIVERSITY AVE., PROVO, UT, 84604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2512646,
    "lng": -111.659272
  },
  {
    "id": "14893",
    "name": "CVS",
    "address": "280 N. AVONDALE BLVD., AVONDALE, AZ, 85323",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4490438,
    "lng": -112.3074189
  },
  {
    "id": "14892",
    "name": "CVS",
    "address": "1803 SOUTH HARBOR BLVD, ANAHEIM, CA, 92802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8029242,
    "lng": -117.9160853
  },
  {
    "id": "14891",
    "name": "CVS",
    "address": "1151 SOUTH HARBOR BLVD, LA HABRA, CA, 90631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9179457,
    "lng": -117.9336417
  },
  {
    "id": "14890",
    "name": "CVS",
    "address": "2502 TRIMMIER RD., KILLEEN, TX, 76542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.0933389,
    "lng": -97.7323909
  },
  {
    "id": "14889",
    "name": "CVS",
    "address": "101 DAVID DR., METAIRIE, LA, 70003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9785144,
    "lng": -90.2107729
  },
  {
    "id": "14888",
    "name": "CVS",
    "address": "10715 BANDERA RD., SAN ANTONIO, TX, 78250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5421659,
    "lng": -98.6569216
  },
  {
    "id": "14887",
    "name": "CVS",
    "address": "69 MOUNTAIN VIEW DR., COLCHESTER, VT, 5446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5069967,
    "lng": -73.1814498
  },
  {
    "id": "14886",
    "name": "CVS",
    "address": "1212 MCRAE BLVD., EL PASO, TX, 79925",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7618929,
    "lng": -106.3541974
  },
  {
    "id": "14885",
    "name": "CVS",
    "address": "453 VALLEY STREET, MAPLEWOOD, NJ, 7040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7375993,
    "lng": -74.266625
  },
  {
    "id": "14884",
    "name": "CVS",
    "address": "330 ROUTE 304,, BARDONIA, NY, 10954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1097265,
    "lng": -73.9954082
  },
  {
    "id": "14883",
    "name": "CVS",
    "address": "3761 MASSILLON RD., UNIONTOWN, OH, 44685",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9594976,
    "lng": -81.4645028
  },
  {
    "id": "14882",
    "name": "CVS",
    "address": "333 S COLLEGE ST, AUBURN, AL, 36830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6003233,
    "lng": -85.4813029
  },
  {
    "id": "14881",
    "name": "CVS",
    "address": "4155 ELVIS PRESLEY BLVD., MEMPHIS, TN, 38116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0350708,
    "lng": -90.0257506
  },
  {
    "id": "14880",
    "name": "CVS",
    "address": "3350 WORTHINGTON BLVD., FREDERICK, MD, 21704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3262778,
    "lng": -77.3447271
  },
  {
    "id": "14879",
    "name": "CVS",
    "address": "13 VERMONT 15 EAST, MORRISVILLE, VT, 5661",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5759798,
    "lng": -72.592125
  },
  {
    "id": "14878",
    "name": "CVS",
    "address": "87 SUNSET AVE., WESTHAMPTON BEACH, NY, 11978",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8121172,
    "lng": -72.6453112
  },
  {
    "id": "14877",
    "name": "CVS",
    "address": "770 E. DUPONT RD., FORT WAYNE, IN, 46825",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.177679,
    "lng": -85.1319727
  },
  {
    "id": "14876",
    "name": "CVS",
    "address": "11385 SOUTH 700 EAST, SANDY, UT, 84070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.544795,
    "lng": -111.8710648
  },
  {
    "id": "14875",
    "name": "CVS",
    "address": "866 EASTLAKE PARKWAY, CHULA VISTA, CA, 91914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6526321,
    "lng": -116.9691911
  },
  {
    "id": "14874",
    "name": "CVS",
    "address": "5400 HWY 280, HOOVER, AL, 35242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.418357,
    "lng": -86.6714763
  },
  {
    "id": "14873",
    "name": "CVS",
    "address": "10200 CULLEN BLVD., HOUSTON, TX, 77047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.646711,
    "lng": -95.3569211
  },
  {
    "id": "14872",
    "name": "CVS",
    "address": "10 EAST 81ST AVENUE, MERRILLVILLE, IN, 46410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4718436,
    "lng": -87.3353227
  },
  {
    "id": "14871",
    "name": "CVS",
    "address": "9122 S YALE AVE., TULSA, OK, 74137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0313237,
    "lng": -95.9235529
  },
  {
    "id": "14870",
    "name": "CVS",
    "address": "700 ATLANTIC AVE., BOSTON, MA, 2111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3525089,
    "lng": -71.0557428
  },
  {
    "id": "14869",
    "name": "CVS",
    "address": "367 W. 116TH STREET, CARMEL, IN, 46032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9555325,
    "lng": -86.1641678
  },
  {
    "id": "14868",
    "name": "CVS",
    "address": "696-698 NORTH HWY 67 STREET, FLORISSANT, MO, 63031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7988977,
    "lng": -90.3359395
  },
  {
    "id": "14867",
    "name": "CVS",
    "address": "8117 LEESBURG PIKE, VIENNA, VA, 22182",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9147399,
    "lng": -77.2263798
  },
  {
    "id": "14866",
    "name": "CVS",
    "address": "8319 BALTIMORE AVE., COLLEGE PARK, MD, 20740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.992656,
    "lng": -76.9325266
  },
  {
    "id": "14865",
    "name": "CVS",
    "address": "1703 CENTRAL PARK AVENUE, YONKERS, NY, 10710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9578683,
    "lng": -73.8432847
  },
  {
    "id": "14864",
    "name": "CVS",
    "address": "135 PIERCE ST., DALY CITY, CA, 94015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6853394,
    "lng": -122.4726412
  },
  {
    "id": "14863",
    "name": "CVS",
    "address": "2410 SOUTH 8TH ST., WISCONSIN RAPIDS, WI, 54494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.3724944,
    "lng": -89.817794
  },
  {
    "id": "14862",
    "name": "CVS",
    "address": "112 EAST 32ND ST., JOPLIN, MO, 64804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0547561,
    "lng": -94.5139863
  },
  {
    "id": "14861",
    "name": "CVS",
    "address": "28635 N. NORTH VALLEY PARKWAY, PHOENIX, AZ, 85085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7417945,
    "lng": -112.1066473
  },
  {
    "id": "14860",
    "name": "CVS",
    "address": "940 N. MAIN ST., LAS CRUCES, NM, 88001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3169817,
    "lng": -106.7799849
  },
  {
    "id": "14859",
    "name": "CVS",
    "address": "715 WEST BENDER BLVD., HOBBS, NM, 88240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7248792,
    "lng": -103.1441649
  },
  {
    "id": "14858",
    "name": "CVS",
    "address": "901 WILLOW LAKE RD, PRESCOTT, AZ, 86301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5982179,
    "lng": -112.4569458
  },
  {
    "id": "14857",
    "name": "CVS",
    "address": "12746 W. JEFFERSON BLVD., SUITE 3160, PLAYA VISTA, CA, 90094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9771391,
    "lng": -118.4175837
  },
  {
    "id": "14856",
    "name": "CVS",
    "address": "1401 VETERANS BLVD., METAIRIE, LA, 70005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0024345,
    "lng": -90.1383234
  },
  {
    "id": "14855",
    "name": "CVS",
    "address": "1700 MILTON AVE., JANESVILLE, WI, 53545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7047621,
    "lng": -89.005758
  },
  {
    "id": "14854",
    "name": "CVS",
    "address": "1301 SOUTH CAGE BLVD., PHARR, TX, 78577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1801312,
    "lng": -98.1857726
  },
  {
    "id": "14853",
    "name": "CVS",
    "address": "3705 FM 1488, THE WOODLANDS, TX, 77384",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2269097,
    "lng": -95.5219119
  },
  {
    "id": "14852",
    "name": "CVS",
    "address": "7300 N. FM 620, AUSTIN, TX, 78726",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4048791,
    "lng": -97.854433
  },
  {
    "id": "14851",
    "name": "CVS",
    "address": "11101 US 380, CROSSROADS, TX, 76227",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2253384,
    "lng": -96.9886152
  },
  {
    "id": "14850",
    "name": "CVS",
    "address": "132 DOUGLAS AVE., HOLLAND, MI, 49424",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8016271,
    "lng": -86.1135904
  },
  {
    "id": "14849",
    "name": "CVS",
    "address": "9433 MANCHESTER RD,, SAINT LOUIS, MO, 63119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6098878,
    "lng": -90.3643172
  },
  {
    "id": "14848",
    "name": "CVS",
    "address": "801 HIGHWAY K, O FALLON, MO, 63366",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7992962,
    "lng": -90.700957
  },
  {
    "id": "14847",
    "name": "CVS",
    "address": "1201 BRICKELL AVE, MIAMI, FL, 33131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7619059,
    "lng": -80.1911514
  },
  {
    "id": "14846",
    "name": "CVS",
    "address": "2393 SW 67TH AVE., WEST MIAMI, FL, 33155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.748777,
    "lng": -80.3032472
  },
  {
    "id": "14845",
    "name": "CVS",
    "address": "110 MAIN STREET, HEBRON, CT, 6248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6601114,
    "lng": -72.3559939
  },
  {
    "id": "14844",
    "name": "CVS",
    "address": "1000 PINEVIEW DRIVE, MORGANTOWN, WV, 26505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6583819,
    "lng": -79.9536319
  },
  {
    "id": "14843",
    "name": "CVS",
    "address": "5610 OVERSEAS HIGHWAY, STOCK ISLAND, FL, 33040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 24.5740419,
    "lng": -81.7365236
  },
  {
    "id": "14842",
    "name": "CVS",
    "address": "2655 TELEGRAPH AVE., BERKELEY, CA, 94704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.862057,
    "lng": -122.2583876
  },
  {
    "id": "14841",
    "name": "CVS",
    "address": "6750 BERNAL AVE., PLEASANTON, CA, 94566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6565793,
    "lng": -121.897972
  },
  {
    "id": "14840",
    "name": "CVS",
    "address": "1220 EAST REPUBLIC RD., SPRINGFIELD, MO, 65804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.1372633,
    "lng": -93.2776654
  },
  {
    "id": "14839",
    "name": "CVS",
    "address": "104 E. FIRST ST., ANKENY, IA, 50021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7323423,
    "lng": -93.5995426
  },
  {
    "id": "14838",
    "name": "CVS",
    "address": "5748 SW 40TH ST., MIAMI, FL, 33155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.733559,
    "lng": -80.2874985
  },
  {
    "id": "14837",
    "name": "CVS",
    "address": "2511 PONCE BYP, PONCE, PR, 717",
    "phone": "",
    "hours": "Call for hours",
    "lat": 17.9970233,
    "lng": -66.6313676
  },
  {
    "id": "14836",
    "name": "CVS",
    "address": "5902 READ BLVD., NEW ORLEANS, LA, 70127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.035374,
    "lng": -89.9761689
  },
  {
    "id": "14835",
    "name": "CVS",
    "address": "2300 NORTH CONWAY AVE., MISSION, TX, 78574",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2300089,
    "lng": -98.3225967
  },
  {
    "id": "14834",
    "name": "CVS",
    "address": "2013 KELLY LN., PFLUGERVILLE, TX, 78660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4687183,
    "lng": -97.5886323
  },
  {
    "id": "14833",
    "name": "CVS",
    "address": "201 NORTH MESA ST., EL PASO, TX, 79901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7588105,
    "lng": -106.4874843
  },
  {
    "id": "14832",
    "name": "CVS",
    "address": "366 E. CHESTNUT HILL RD., NEWARK, DE, 19713",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6630142,
    "lng": -75.727288
  },
  {
    "id": "14831",
    "name": "CVS",
    "address": "101 E. HALL OF FAME AVE., STILLWATER, OK, 74075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1263383,
    "lng": -97.0577847
  },
  {
    "id": "14830",
    "name": "CVS",
    "address": "1306 S MISSION ST., MOUNT PLEASANT, MI, 48858",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.5894677,
    "lng": -84.7681937
  },
  {
    "id": "14829",
    "name": "CVS",
    "address": "8915 ST CHARLES ROCK RD., SAINT JOHN, MO, 63114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7116626,
    "lng": -90.3509345
  },
  {
    "id": "14828",
    "name": "CVS",
    "address": "2100 1ST CAPITOL DR., SAINT CHARLES, MO, 63301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7826013,
    "lng": -90.5038563
  },
  {
    "id": "14827",
    "name": "CVS",
    "address": "5405 LYNX LANE, COLUMBIA, MD, 21044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2205555,
    "lng": -76.8748689
  },
  {
    "id": "14826",
    "name": "CVS",
    "address": "1801 STATE ROUTE 71, WALL, NJ, 7719",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1693061,
    "lng": -74.0336155
  },
  {
    "id": "14825",
    "name": "CVS",
    "address": "265 PROSPECT AVE., WEST ORANGE, NJ, 7052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8027312,
    "lng": -74.2487909
  },
  {
    "id": "14824",
    "name": "CVS",
    "address": "30 FLATBUSH AVE., BROOKLYN, NY, 11217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6880486,
    "lng": -73.9805705
  },
  {
    "id": "14823",
    "name": "CVS",
    "address": "891 MAIN ST., WOBURN, MA, 1801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5078798,
    "lng": -71.1596122
  },
  {
    "id": "14822",
    "name": "CVS",
    "address": "1059 HYDE ST., SAN FRANCISCO, CA, 94109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7905484,
    "lng": -122.4180481
  },
  {
    "id": "14821",
    "name": "CVS",
    "address": "2101 E. HALLANDALE BEACH BLVD., HALLANDALE BEACH, FL, 33009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9867655,
    "lng": -80.12672
  },
  {
    "id": "14820",
    "name": "CVS",
    "address": "5995 EAST KINGS CANYON RD, FRESNO, CA, 93727",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7375692,
    "lng": -119.6827652
  },
  {
    "id": "14819",
    "name": "CVS",
    "address": "855 WAYNE RD., SAVANNAH, TN, 38372",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2281683,
    "lng": -88.231589
  },
  {
    "id": "14818",
    "name": "CVS",
    "address": "2120 LONE STAR DR., ARNOLD, MO, 63010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4435623,
    "lng": -90.3750561
  },
  {
    "id": "14817",
    "name": "CVS",
    "address": "8626 LAKEVIEW PKWY., ROWLETT, TX, 75088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9168815,
    "lng": -96.5170587
  },
  {
    "id": "14816",
    "name": "CVS",
    "address": "483 STATE ROUTE 79, MORGANVILLE, NJ, 7751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3856987,
    "lng": -74.2409507
  },
  {
    "id": "14815",
    "name": "CVS",
    "address": "5050 S. LANCASTER RD, DALLAS, TX, 75216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6870593,
    "lng": -96.7891389
  },
  {
    "id": "14814",
    "name": "CVS",
    "address": "400 MID RIVERS MALL DR.,, SAINT PETERS, MO, 63376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7893344,
    "lng": -90.6251911
  },
  {
    "id": "14813",
    "name": "CVS",
    "address": "1515 SHERIDAN RD., WILMETTE, IL, 60091",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0873267,
    "lng": -87.7011243
  },
  {
    "id": "14812",
    "name": "CVS",
    "address": "2920 EAST SOUTHCROSS BLVD., SAN ANTONIO, TX, 78223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.3759089,
    "lng": -98.4478133
  },
  {
    "id": "14811",
    "name": "CVS",
    "address": "380 ROUTE 18, EAST BRUNSWICK, NJ, 8816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.450443,
    "lng": -74.3966367
  },
  {
    "id": "14810",
    "name": "CVS",
    "address": "71 S. BROADWAY, LONG BRANCH, NJ, 7740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3054928,
    "lng": -73.9818551
  },
  {
    "id": "14809",
    "name": "CVS",
    "address": "235 PEACHTREE ST. NE, SUITE C24, ATLANTA, GA, 30303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7605323,
    "lng": -84.3872341
  },
  {
    "id": "14808",
    "name": "CVS",
    "address": "1217 NEPPERHAN AVE., YONKERS, NY, 10703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9656703,
    "lng": -73.8730556
  },
  {
    "id": "14807",
    "name": "CVS",
    "address": "150 MAIN ST., WAYLAND, MA, 1778",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3216771,
    "lng": -71.3647164
  },
  {
    "id": "14806",
    "name": "CVS",
    "address": "1905 RT 6, CARMEL, NY, 10512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4130236,
    "lng": -73.6691648
  },
  {
    "id": "14805",
    "name": "CVS",
    "address": "11030 SOUTH MEMORIAL PKWY., HUNTSVILLE, AL, 35803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6300729,
    "lng": -86.5676385
  },
  {
    "id": "14804",
    "name": "CVS",
    "address": "611 DUNCAN AVE., PITTSBURGH, PA, 15237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5678543,
    "lng": -80.0232318
  },
  {
    "id": "14803",
    "name": "CVS",
    "address": "911 HIGHWAY 35, OCEAN, NJ, 7712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2344608,
    "lng": -74.0376777
  },
  {
    "id": "14802",
    "name": "CVS",
    "address": "11464 SOUTH FORTUNA RD., YUMA, AZ, 85367",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6636435,
    "lng": -114.4449032
  },
  {
    "id": "14801",
    "name": "CVS",
    "address": "750 E. FM 544, MURPHY, TX, 75094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0106487,
    "lng": -96.5965815
  },
  {
    "id": "14800",
    "name": "CVS",
    "address": "591 COUNTRY CLUB DR., SUITE C, SIMI VALLEY, CA, 93065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2538187,
    "lng": -118.8110069
  },
  {
    "id": "14799",
    "name": "CVS",
    "address": "400 S. TRUMAN BLVD., CRYSTAL CITY, MO, 63019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2158223,
    "lng": -90.3859451
  },
  {
    "id": "14798",
    "name": "CVS",
    "address": "1303 SEPULVEDA BLVD., TORRANCE, CA, 90501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8138984,
    "lng": -118.2987977
  },
  {
    "id": "14797",
    "name": "CVS",
    "address": "3717 HAMPTON BLVD., NORFOLK, VA, 23508",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8793319,
    "lng": -76.302446
  },
  {
    "id": "14796",
    "name": "CVS",
    "address": "3908 N. STATELINE AVE., TEXARKANA, AR, 71854",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4609834,
    "lng": -94.04311
  },
  {
    "id": "14795",
    "name": "CVS",
    "address": "2089 SALEM RD., VIRGINIA BEACH, VA, 23456",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7689876,
    "lng": -76.1239318
  },
  {
    "id": "14794",
    "name": "CVS",
    "address": "114 CENTRAL ST, IPSWICH, MA, 1938",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6833496,
    "lng": -70.8440941
  },
  {
    "id": "14793",
    "name": "CVS",
    "address": "2981 SOUTH MILITARY HIGHWAY, CHESAPEAKE, VA, 23323",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7733098,
    "lng": -76.3236565
  },
  {
    "id": "14792",
    "name": "CVS",
    "address": "11223 EAST 31ST ST. SOUTH, TULSA, OK, 74146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1194817,
    "lng": -95.8521169
  },
  {
    "id": "14791",
    "name": "CVS",
    "address": "399 ROUTE 211E, MIDDLETOWN, NY, 10940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4564982,
    "lng": -74.3939448
  },
  {
    "id": "14790",
    "name": "CVS",
    "address": "6265 EAST 2ND ST., LONG BEACH, CA, 90803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7582838,
    "lng": -118.1119478
  },
  {
    "id": "14789",
    "name": "CVS",
    "address": "6045 NORTH SCOTTSDALE ROAD, SCOTTSDALE, AZ, 85250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5251926,
    "lng": -111.9251413
  },
  {
    "id": "14788",
    "name": "CVS",
    "address": "10650 NORTH ORACLE RD, ORO VALLEY, AZ, 85737",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3989834,
    "lng": -110.955274
  },
  {
    "id": "14787",
    "name": "CVS",
    "address": "117 SPEEDWELL AVE, MORRISTOWN, NJ, 7960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.801801,
    "lng": -74.4813661
  },
  {
    "id": "14786",
    "name": "CVS",
    "address": "728 W SHAW AVE, FRESNO, CA, 93704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8099783,
    "lng": -119.8065625
  },
  {
    "id": "14785",
    "name": "CVS",
    "address": "9280 SIERRA COLLEGE BLVD, ROSEVILLE, CA, 95661",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7298464,
    "lng": -121.2274995
  },
  {
    "id": "14784",
    "name": "CVS",
    "address": "3158 DANVILLE BLVD, ALAMO, CA, 94507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8518148,
    "lng": -122.0321579
  },
  {
    "id": "14783",
    "name": "CVS",
    "address": "1798 MIRAMONTE AVE, MOUNTAIN VIEW, CA, 94040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3716464,
    "lng": -122.087564
  },
  {
    "id": "14782",
    "name": "CVS",
    "address": "1400 HOWARD RD.,, MADERA, CA, 93637",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9518804,
    "lng": -120.0747381
  },
  {
    "id": "14781",
    "name": "CVS",
    "address": "8900 SEPULVEDA WESTWAY, LOS ANGELES, CA, 90045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9557172,
    "lng": -118.39778
  },
  {
    "id": "14780",
    "name": "CVS",
    "address": "2701 MIDDLEFIELD RD, PALO ALTO, CA, 94306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4336772,
    "lng": -122.1290956
  },
  {
    "id": "14779",
    "name": "CVS",
    "address": "929 SIERRA ST, KINGSBURG, CA, 93631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5196413,
    "lng": -119.5581643
  },
  {
    "id": "14778",
    "name": "CVS",
    "address": "750 BLOSSOM HILL RD, LOS GATOS, CA, 95032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2343643,
    "lng": -121.9619751
  },
  {
    "id": "14777",
    "name": "CVS",
    "address": "3240 US HIGHWAY 50 E, CARSON CITY, NV, 89701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1784772,
    "lng": -119.7319872
  },
  {
    "id": "14776",
    "name": "CVS",
    "address": "9479 MADISON AVE, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6772869,
    "lng": -121.1978068
  },
  {
    "id": "14775",
    "name": "CVS",
    "address": "3375 PLACER ST, REDDING, CA, 96001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5735452,
    "lng": -122.4155157
  },
  {
    "id": "14774",
    "name": "CVS",
    "address": "18020 CHATSWORTH ST, GRANADA HILLS, CA, 91344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.263314,
    "lng": -118.5248033
  },
  {
    "id": "14773",
    "name": "CVS",
    "address": "950 N. LAKE BLVD. SUITE #100, TAHOE CITY, CA, 96145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1746711,
    "lng": -120.1370601
  },
  {
    "id": "14772",
    "name": "CVS",
    "address": "4400 COFFEE RD, BAKERSFIELD, CA, 93308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3993788,
    "lng": -119.0904451
  },
  {
    "id": "14771",
    "name": "CVS",
    "address": "3360 S MCCARRAN BLVD, RENO, NV, 89502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4851157,
    "lng": -119.7463138
  },
  {
    "id": "14770",
    "name": "CVS",
    "address": "1595 MAIN ST., WEAVERVILLE, CA, 96096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7220964,
    "lng": -122.9274328
  },
  {
    "id": "14769",
    "name": "CVS",
    "address": "7465 RUSH RIVER DR STE 500, SACRAMENTO, CA, 95831",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.486492,
    "lng": -121.5349486
  },
  {
    "id": "14768",
    "name": "CVS",
    "address": "4077 W CLINTON AVE, FRESNO, CA, 93722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7707255,
    "lng": -119.8644346
  },
  {
    "id": "14767",
    "name": "CVS",
    "address": "218 E HIGHWAY 246 BLDG 3, BUELLTON, CA, 93427",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6097762,
    "lng": -120.1891471
  },
  {
    "id": "14766",
    "name": "CVS",
    "address": "7850 TELEGRAPH RD, VENTURA, CA, 93004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2806189,
    "lng": -119.1907705
  },
  {
    "id": "14765",
    "name": "CVS",
    "address": "1950 VILLAGE CENTER CIR, LAS VEGAS, NV, 89134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.192863,
    "lng": -115.3062344
  },
  {
    "id": "14764",
    "name": "CVS",
    "address": "170 LEMMON DR, RENO, NV, 89506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6121094,
    "lng": -119.8479797
  },
  {
    "id": "14763",
    "name": "CVS",
    "address": "5644 MISSION CENTER RD.,  #201, SAN DIEGO, CA, 92108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7745868,
    "lng": -117.1569999
  },
  {
    "id": "14762",
    "name": "CVS",
    "address": "150 DONAHUE ST, SAUSALITO, CA, 94965",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8726928,
    "lng": -122.5114397
  },
  {
    "id": "14761",
    "name": "CVS",
    "address": "191 WOODLAND PKWY, SAN MARCOS, CA, 92069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1405193,
    "lng": -117.1381485
  },
  {
    "id": "14760",
    "name": "CVS",
    "address": "809 BAY AVE, CAPITOLA, CA, 95010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9802496,
    "lng": -121.9559932
  },
  {
    "id": "14759",
    "name": "CVS",
    "address": "1560 W VALLEY PKWY, ESCONDIDO, CA, 92029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1085345,
    "lng": -117.1052413
  },
  {
    "id": "14758",
    "name": "CVS",
    "address": "5090 FOOTHILLS BLVD, ROSEVILLE, CA, 95747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7608623,
    "lng": -121.3112667
  },
  {
    "id": "14757",
    "name": "CVS",
    "address": "8063 SAN MIGUEL CANYON RD, SALINAS, CA, 93907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8012753,
    "lng": -121.6642696
  },
  {
    "id": "14756",
    "name": "CVS",
    "address": "1201 W MAIN ST STE 14, RIPON, CA, 95366",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7398676,
    "lng": -121.1362167
  },
  {
    "id": "14755",
    "name": "CVS",
    "address": "2700 YULUPA AVE, SANTA ROSA, CA, 95405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4281811,
    "lng": -122.6674342
  },
  {
    "id": "14754",
    "name": "CVS",
    "address": "2035 NOVATO BLVD, NOVATO, CA, 94947",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1108745,
    "lng": -122.5926796
  },
  {
    "id": "14753",
    "name": "CVS",
    "address": "463 STONY POINT RD, SANTA ROSA, CA, 95401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4331391,
    "lng": -122.7439869
  },
  {
    "id": "14752",
    "name": "CVS",
    "address": "800 FIRST ST., GILROY, CA, 95020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0132153,
    "lng": -121.587078
  },
  {
    "id": "14751",
    "name": "CVS",
    "address": "3081 STEVENS CREEK BLVD, SANTA CLARA, CA, 95050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3243433,
    "lng": -121.9494774
  },
  {
    "id": "14750",
    "name": "CVS",
    "address": "949 11TH ST, LAKEPORT, CA, 95453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0481594,
    "lng": -122.9237801
  },
  {
    "id": "14749",
    "name": "CVS",
    "address": "1401 WASHINGTON AVE, SAN LEANDRO, CA, 94577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7236562,
    "lng": -122.1564213
  },
  {
    "id": "14748",
    "name": "CVS",
    "address": "1451 SHATTUCK AVE, BERKELEY, CA, 94709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8812815,
    "lng": -122.269022
  },
  {
    "id": "14747",
    "name": "CVS",
    "address": "872 N DELAWARE ST, SAN MATEO, CA, 94401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.580781,
    "lng": -122.3331918
  },
  {
    "id": "14746",
    "name": "CVS",
    "address": "50 MORAGA WAY, ORINDA, CA, 94563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8784348,
    "lng": -122.1814785
  },
  {
    "id": "14745",
    "name": "CVS",
    "address": "3625 MT DIABLO BLVD, LAFAYETTE, CA, 94549",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8906844,
    "lng": -122.1250139
  },
  {
    "id": "14744",
    "name": "CVS",
    "address": "4445 MISSION BLVD, SAN DIEGO, CA, 92109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7955104,
    "lng": -117.2542924
  },
  {
    "id": "14743",
    "name": "CVS",
    "address": "40044 ST HWY 49, OAKHURST, CA, 93644",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3305612,
    "lng": -119.659242
  },
  {
    "id": "14742",
    "name": "CVS",
    "address": "1405 HERNDON AVE.,, CLOVIS, CA, 93611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8381859,
    "lng": -119.6904512
  },
  {
    "id": "14741",
    "name": "CVS",
    "address": "1274 STABLER LN, YUBA CITY, CA, 95993",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1465851,
    "lng": -121.6462243
  },
  {
    "id": "14740",
    "name": "CVS",
    "address": "9030 BROOKS RD S, WINDSOR, CA, 95492",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5507046,
    "lng": -122.805389
  },
  {
    "id": "14739",
    "name": "CVS",
    "address": "6378 COMMERCE BLVD, ROHNERT PARK, CA, 94928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3463399,
    "lng": -122.708343
  },
  {
    "id": "14738",
    "name": "CVS",
    "address": "1193 ADMIRAL CALLAGHAN LANE, VALLEJO, CA, 94591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1368388,
    "lng": -122.2142437
  },
  {
    "id": "14737",
    "name": "CVS",
    "address": "7525 EADS AVE, LA JOLLA, CA, 92037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8406134,
    "lng": -117.2746842
  },
  {
    "id": "14736",
    "name": "CVS",
    "address": "187 NIBLICK RD, PASO ROBLES, CA, 93446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6168663,
    "lng": -120.6819079
  },
  {
    "id": "14735",
    "name": "CVS",
    "address": "27251 LA PAZ RD, LAGUNA NIGUEL, CA, 92677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5685799,
    "lng": -117.7095713
  },
  {
    "id": "14734",
    "name": "CVS",
    "address": "1005 E BIDWELL ST, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6685909,
    "lng": -121.1563997
  },
  {
    "id": "14733",
    "name": "CVS",
    "address": "3950 W POINT LOMA BLVD, SAN DIEGO, CA, 92110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7554296,
    "lng": -117.2220528
  },
  {
    "id": "14732",
    "name": "CVS",
    "address": "2069 CAMDEN AVE, SAN JOSE, CA, 95124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2630517,
    "lng": -121.9346006
  },
  {
    "id": "14731",
    "name": "CVS",
    "address": "30640 RANCHO CALIFORNIA RD, TEMECULA, CA, 92591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5094799,
    "lng": -117.1272106
  },
  {
    "id": "14730",
    "name": "CVS",
    "address": "1621 LANDER AVE, TURLOCK, CA, 95380",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4775248,
    "lng": -120.8507916
  },
  {
    "id": "14729",
    "name": "CVS",
    "address": "31021 TEMECULA PARKWAY, TEMECULA, CA, 92592",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4755196,
    "lng": -117.1217872
  },
  {
    "id": "14728",
    "name": "CVS",
    "address": "625 ELMIRA RD, VACAVILLE, CA, 95687",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3519283,
    "lng": -121.9517852
  },
  {
    "id": "14727",
    "name": "CVS",
    "address": "5070 WEST LN, STOCKTON, CA, 95210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0011244,
    "lng": -121.2884751
  },
  {
    "id": "14726",
    "name": "CVS",
    "address": "352 UNIVERSITY AVE, PALO ALTO, CA, 94301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4464306,
    "lng": -122.1605461
  },
  {
    "id": "14725",
    "name": "CVS",
    "address": "2140 GRASS VALLEY HWY, AUBURN, CA, 95603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9339788,
    "lng": -121.0902061
  },
  {
    "id": "14724",
    "name": "CVS",
    "address": "759 E BLITHEDALE AVE, MILL VALLEY, CA, 94941",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9031729,
    "lng": -122.5246336
  },
  {
    "id": "14723",
    "name": "CVS",
    "address": "32575 GOLDEN LANTERN ST, DANA POINT, CA, 92629",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4895804,
    "lng": -117.6996735
  },
  {
    "id": "14722",
    "name": "CVS",
    "address": "3440 LA SIERRA AVE, RIVERSIDE, CA, 92503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8977487,
    "lng": -117.4734371
  },
  {
    "id": "14721",
    "name": "CVS",
    "address": "8320 EL CAMINO REAL, ATASCADERO, CA, 93422",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4740907,
    "lng": -120.6563894
  },
  {
    "id": "14720",
    "name": "CVS",
    "address": "20475 YORBA LINDA BLVD, YORBA LINDA, CA, 92886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8928482,
    "lng": -117.7738166
  },
  {
    "id": "14719",
    "name": "CVS",
    "address": "3667 CASTRO VALLEY BLVD, CASTRO VALLEY, CA, 94546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6940134,
    "lng": -122.0715826
  },
  {
    "id": "14718",
    "name": "CVS",
    "address": "1125 BRANHAM LN, SAN JOSE, CA, 95118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2636062,
    "lng": -121.8785859
  },
  {
    "id": "14717",
    "name": "CVS",
    "address": "4550 MERIDIAN AVE, SAN JOSE, CA, 95124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2571878,
    "lng": -121.8990013
  },
  {
    "id": "14716",
    "name": "CVS",
    "address": "148 NORTH SAN TOMAS AQUINO RD., CAMPBELL, CA, 95008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2859938,
    "lng": -121.9765105
  },
  {
    "id": "14715",
    "name": "CVS",
    "address": "10455 S DE ANZA BLVD, CUPERTINO, CA, 95014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3164664,
    "lng": -122.0337921
  },
  {
    "id": "14714",
    "name": "CVS",
    "address": "2539 N 11TH AVE, HANFORD, CA, 93230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3580597,
    "lng": -119.6540526
  },
  {
    "id": "14713",
    "name": "CVS",
    "address": "827 OAK PARK BLVD, PISMO BEACH, CA, 93449",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1329399,
    "lng": -120.6076741
  },
  {
    "id": "14712",
    "name": "CVS",
    "address": "2601 OAKDALE RD STE E, MODESTO, CA, 95355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.678455,
    "lng": -120.958098
  },
  {
    "id": "14711",
    "name": "CVS",
    "address": "987 E HILLSDALE BLVD, FOSTER CITY, CA, 94404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5576515,
    "lng": -122.2746932
  },
  {
    "id": "14710",
    "name": "CVS",
    "address": "8200 STOCKDALE HWY STE G, BAKERSFIELD, CA, 93311",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3554389,
    "lng": -119.0946484
  },
  {
    "id": "14709",
    "name": "CVS",
    "address": "699 LEWELLING BLVD, SAN LEANDRO, CA, 94579",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6878718,
    "lng": -122.1351291
  },
  {
    "id": "14708",
    "name": "CVS",
    "address": "2075 EAST HATCH RD., MODESTO, CA, 95351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6097539,
    "lng": -120.9579635
  },
  {
    "id": "14707",
    "name": "CVS",
    "address": "1300 MADONNA RD, SAN LUIS OBISPO, CA, 93405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.257827,
    "lng": -120.6894996
  },
  {
    "id": "14706",
    "name": "CVS",
    "address": "6877 SEBASTOPOL AVE.,, SEBASTOPOL, CA, 95472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4021113,
    "lng": -122.8222891
  },
  {
    "id": "14705",
    "name": "CVS",
    "address": "1190 N MAIN ST, MANTECA, CA, 95336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8138485,
    "lng": -121.215147
  },
  {
    "id": "14704",
    "name": "CVS",
    "address": "7096 N WEST AVE, FRESNO, CA, 93711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8387219,
    "lng": -119.8253736
  },
  {
    "id": "14703",
    "name": "CVS",
    "address": "175 E 17TH ST, COSTA MESA, CA, 92627",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6356767,
    "lng": -117.9204148
  },
  {
    "id": "14702",
    "name": "CVS",
    "address": "257 MOUNT HERMON RD, SCOTTS VALLEY, CA, 95066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0465794,
    "lng": -122.0320214
  },
  {
    "id": "14701",
    "name": "CVS",
    "address": "222 W. CARRILLO ST., SANTA BARBARA, CA, 93101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4190039,
    "lng": -119.7051941
  },
  {
    "id": "14700",
    "name": "CVS",
    "address": "3935 COCHRAN ST, SIMI VALLEY, CA, 93063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2802059,
    "lng": -118.7193449
  },
  {
    "id": "14699",
    "name": "CVS",
    "address": "25880 MCBEAN PKWY., SANTA CLARITA, CA, 91355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4038722,
    "lng": -118.5505245
  },
  {
    "id": "14698",
    "name": "CVS",
    "address": "1165 W EL CAMINO REAL, SUNNYVALE, CA, 94087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.373664,
    "lng": -122.054097
  },
  {
    "id": "14697",
    "name": "CVS",
    "address": "3320 N TRACY BLVD, TRACY, CA, 95376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7608884,
    "lng": -121.4330293
  },
  {
    "id": "14696",
    "name": "CVS",
    "address": "6247 GRAHAM HILL RD, FELTON, CA, 95018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0528502,
    "lng": -122.0682089
  },
  {
    "id": "14695",
    "name": "CVS",
    "address": "11426 WASHINGTON BLVD., WHITTIER, CA, 90606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9704726,
    "lng": -118.067914
  },
  {
    "id": "14694",
    "name": "CVS",
    "address": "130 N GRAND AVE, GLENDORA, CA, 91741",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1369535,
    "lng": -117.870611
  },
  {
    "id": "14693",
    "name": "CVS",
    "address": "5969 LANKERSHIM BLVD., NORTH HOLLYWOOD, CA, 91601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1791501,
    "lng": -118.3842233
  },
  {
    "id": "14692",
    "name": "CVS",
    "address": "8280 MAGNOLIA AVE., RIVERSIDE, CA, 92504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.932741,
    "lng": -117.4232426
  },
  {
    "id": "14691",
    "name": "CVS",
    "address": "29985 CANYON HILLS RD, LAKE ELSINORE, CA, 92532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6668915,
    "lng": -117.2640293
  },
  {
    "id": "14690",
    "name": "CVS",
    "address": "6800 N MILBURN AVE, FRESNO, CA, 93722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8365568,
    "lng": -119.8783564
  },
  {
    "id": "14689",
    "name": "CVS",
    "address": "760 ARNEILL RD, CAMARILLO, CA, 93010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2243241,
    "lng": -119.0369916
  },
  {
    "id": "14688",
    "name": "CVS",
    "address": "461 W WILLIAMS AVE, FALLON, NV, 89406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4743006,
    "lng": -118.7823792
  },
  {
    "id": "14687",
    "name": "CVS",
    "address": "8005 S VIRGINIA ST, RENO, NV, 89511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4554646,
    "lng": -119.7795999
  },
  {
    "id": "14686",
    "name": "CVS",
    "address": "5485 SUN VALLEY BLVD, SUN VALLEY, NV, 89433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5921604,
    "lng": -119.7811907
  },
  {
    "id": "14685",
    "name": "CVS",
    "address": "12940 SARATOGA SUNNYVALE RD, SARATOGA, CA, 95070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2801555,
    "lng": -122.0310478
  },
  {
    "id": "14684",
    "name": "CVS",
    "address": "4242 S EL CAMINO REAL, SAN MATEO, CA, 94403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5297011,
    "lng": -122.28887
  },
  {
    "id": "14683",
    "name": "CVS",
    "address": "1387 W WHITTIER BLVD, LA HABRA, CA, 90631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9404606,
    "lng": -117.9617855
  },
  {
    "id": "14682",
    "name": "CVS",
    "address": "5407 CAMDEN AVE, SAN JOSE, CA, 95124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2399987,
    "lng": -121.9056188
  },
  {
    "id": "14681",
    "name": "CVS",
    "address": "5408 YGNACIO VALLEY RD, CONCORD, CA, 94521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9493504,
    "lng": -121.9596646
  },
  {
    "id": "14680",
    "name": "CVS",
    "address": "5333 ELKHORN BLVD, SACRAMENTO, CA, 95842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6869543,
    "lng": -121.3401349
  },
  {
    "id": "14679",
    "name": "CVS",
    "address": "2973 STATE ST, SANTA BARBARA, CA, 93105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4395651,
    "lng": -119.7278683
  },
  {
    "id": "14678",
    "name": "CVS",
    "address": "1350 FLORIN RD., SACRAMENTO, CA, 95822",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4950448,
    "lng": -121.5053281
  },
  {
    "id": "14677",
    "name": "CVS",
    "address": "155 S ORCHARD AVE, UKIAH, CA, 95482",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.149583,
    "lng": -123.1975555
  },
  {
    "id": "14676",
    "name": "CVS",
    "address": "572 FLETCHER PKWY, EL CAJON, CA, 92020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8084559,
    "lng": -116.9691451
  },
  {
    "id": "14675",
    "name": "CVS",
    "address": "31771 RANCHO CALIFORNIA RD., TEMECULA, CA, 92591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5139003,
    "lng": -117.1038164
  },
  {
    "id": "14674",
    "name": "CVS",
    "address": "3290 CHINO HILLS PARKWAY, CHINO HILLS, CA, 91709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9830779,
    "lng": -117.7332139
  },
  {
    "id": "14673",
    "name": "CVS",
    "address": "738 BANCROFT RD, WALNUT CREEK, CA, 94598",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9295342,
    "lng": -122.0401044
  },
  {
    "id": "14672",
    "name": "CVS",
    "address": "8101 GREENBACK LN., FAIR OAKS, CA, 95628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6792816,
    "lng": -121.261653
  },
  {
    "id": "14671",
    "name": "CVS",
    "address": "1871 EL CAMINO REAL, BURLINGAME, CA, 94010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5952813,
    "lng": -122.3861069
  },
  {
    "id": "14670",
    "name": "CVS",
    "address": "4959 MARCONI AVE, CARMICHAEL, CA, 95608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6185183,
    "lng": -121.3477022
  },
  {
    "id": "14669",
    "name": "CVS",
    "address": "470 BLOSSOM HILL RD, SAN JOSE, CA, 95123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2498671,
    "lng": -121.8317074
  },
  {
    "id": "14668",
    "name": "CVS",
    "address": "10 BAYHILL SHOPPING CTR, SAN BRUNO, CA, 94066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6264922,
    "lng": -122.426289
  },
  {
    "id": "14667",
    "name": "CVS",
    "address": "1720 S BASCOM AVE, CAMPBELL, CA, 95008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2924798,
    "lng": -121.9303693
  },
  {
    "id": "14666",
    "name": "CVS",
    "address": "425 S. SUNRISE WAY, PALM SPRINGS, CA, 92262",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8163212,
    "lng": -116.5297408
  },
  {
    "id": "14665",
    "name": "CVS",
    "address": "10 SHAW AVENUE, CLOVIS, CA, 93612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8081595,
    "lng": -119.7093661
  },
  {
    "id": "14664",
    "name": "CVS",
    "address": "650 SAN RAMON VALLEY BLVD, DANVILLE, CA, 94526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8135379,
    "lng": -121.9944958
  },
  {
    "id": "14663",
    "name": "CVS",
    "address": "6215 RIVERSIDE AVE., RIVERSIDE, CA, 92506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9560561,
    "lng": -117.3885461
  },
  {
    "id": "14662",
    "name": "CVS",
    "address": "313 SOUTH GARFIELD AVENUE, MONTEREY PARK, CA, 91754",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0594823,
    "lng": -118.1235162
  },
  {
    "id": "14661",
    "name": "CVS",
    "address": "2700 HOMESTEAD RD, SANTA CLARA, CA, 95051",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3382381,
    "lng": -121.9740604
  },
  {
    "id": "14660",
    "name": "CVS",
    "address": "2532 W. VALLEY BLVD., ALHAMBRA, CA, 91803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0766458,
    "lng": -118.1511254
  },
  {
    "id": "14659",
    "name": "CVS",
    "address": "4440 ALAMO STREET, SIMI VALLEY, CA, 93063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2853843,
    "lng": -118.7084145
  },
  {
    "id": "14658",
    "name": "CVS",
    "address": "9900 SEPULVEDA BLVD, MISSION HILLS, CA, 91345",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2505061,
    "lng": -118.4667103
  },
  {
    "id": "14657",
    "name": "CVS",
    "address": "2315 HUNTINGTON DR, DUARTE, CA, 91010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1403327,
    "lng": -117.9550428
  },
  {
    "id": "14656",
    "name": "CVS",
    "address": "3943 SAN FERNANDO RD., GLENDALE, CA, 91204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1279847,
    "lng": -118.2593385
  },
  {
    "id": "14655",
    "name": "CVS",
    "address": "6588 FOOTHILL BLVD, TUJUNGA, CA, 91042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2458336,
    "lng": -118.2757762
  },
  {
    "id": "14654",
    "name": "CVS",
    "address": "1030 COLORADO BLVD., EAGLE ROCK, CA, 90041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.13724,
    "lng": -118.188786
  },
  {
    "id": "14653",
    "name": "CVS",
    "address": "610 WEST TEFFT STREET, NIPOMO, CA, 93444",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0359803,
    "lng": -120.4876936
  },
  {
    "id": "14652",
    "name": "CVS",
    "address": "5985 WEST PICO BOULEVARD, LOS ANGELES, CA, 90035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0525271,
    "lng": -118.3705199
  },
  {
    "id": "14651",
    "name": "CVS",
    "address": "74955 US HIGHWAY 111, INDIAN WELLS, CA, 92210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7203978,
    "lng": -116.3574019
  },
  {
    "id": "14650",
    "name": "CVS",
    "address": "12101 CENTRAL AVE., CHINO, CA, 91710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0332439,
    "lng": -117.6887211
  },
  {
    "id": "14649",
    "name": "CVS",
    "address": "1240 EAST YORBA LINDA BOULEVARD, PLACENTIA, CA, 92870",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8874361,
    "lng": -117.8404367
  },
  {
    "id": "14648",
    "name": "CVS",
    "address": "864 SWARTHMORE AVENUE, PACIFIC PALISADES, CA, 90272",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0464279,
    "lng": -118.525722
  },
  {
    "id": "14647",
    "name": "CVS",
    "address": "731 SOUTH WEIR CANYON ROAD, ANAHEIM HILLS, CA, 92808",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.861516,
    "lng": -117.7400862
  },
  {
    "id": "14646",
    "name": "CVS",
    "address": "2830 BICENTENNIAL PKWY., HENDERSON, NV, 89044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9423339,
    "lng": -115.1156806
  },
  {
    "id": "14645",
    "name": "CVS",
    "address": "9045 WILSHIRE BOULEVARD, BEVERLY HILLS, CA, 90211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0673271,
    "lng": -118.3891988
  },
  {
    "id": "14644",
    "name": "CVS",
    "address": "12015 WILSHIRE BOULEVARD, LOS ANGELES, CA, 90025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0458616,
    "lng": -118.465912
  },
  {
    "id": "14643",
    "name": "CVS",
    "address": "351 CARMEN DR., SUITE B, CAMARILLO, CA, 93010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.219242,
    "lng": -119.0531296
  },
  {
    "id": "14642",
    "name": "CVS",
    "address": "1080 SPERRY AVE, PATTERSON, CA, 95363",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4638309,
    "lng": -121.1439217
  },
  {
    "id": "14641",
    "name": "CVS",
    "address": "2100 COLUMBUS PKWY, BENICIA, CA, 94510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0812111,
    "lng": -122.1927856
  },
  {
    "id": "14640",
    "name": "CVS",
    "address": "460 SOUTH ANAHEIM HILLS ROAD, ANAHEIM, CA, 92807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8448015,
    "lng": -117.7753599
  },
  {
    "id": "14639",
    "name": "CVS",
    "address": "270 WEST LINCOLN AVENUE, ANAHEIM, CA, 92805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8346308,
    "lng": -117.9163871
  },
  {
    "id": "14638",
    "name": "CVS",
    "address": "2101 W. IMPERIAL HIGHWAY #C, LA HABRA, CA, 90631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9186903,
    "lng": -117.9690152
  },
  {
    "id": "14637",
    "name": "CVS",
    "address": "1823 WEST ORANGETHORPE AVENUE, FULLERTON, CA, 92833",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8602071,
    "lng": -117.9608703
  },
  {
    "id": "14636",
    "name": "CVS",
    "address": "5735 E. LA PALMA AVENUE, ANAHEIM, CA, 92807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.860759,
    "lng": -117.7891011
  },
  {
    "id": "14635",
    "name": "CVS",
    "address": "375 GELLERT BLVD., DALY CITY, CA, 94015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6654412,
    "lng": -122.468042
  },
  {
    "id": "14634",
    "name": "CVS",
    "address": "5623 KANAN RD., AGOURA HILLS, CA, 91301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.152352,
    "lng": -118.7588354
  },
  {
    "id": "14633",
    "name": "CVS",
    "address": "1830 NORTH BROADWAY, SANTA MARIA, CA, 93454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9732039,
    "lng": -120.4338727
  },
  {
    "id": "14632",
    "name": "CVS",
    "address": "2138 N. TUSTIN ST., ORANGE, CA, 92865",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8234704,
    "lng": -117.8364469
  },
  {
    "id": "14631",
    "name": "CVS",
    "address": "3670 S. NOGALES ST., WEST COVINA, CA, 91792",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0105287,
    "lng": -117.8864522
  },
  {
    "id": "14630",
    "name": "CVS",
    "address": "150 EAST YORBA LINDA BOULEVARD, PLACENTIA, CA, 92870",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8860395,
    "lng": -117.8640183
  },
  {
    "id": "14629",
    "name": "CVS",
    "address": "6840 LINCOLN AVENUE, RIVERSIDE, CA, 92506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9355741,
    "lng": -117.3871233
  },
  {
    "id": "14628",
    "name": "CVS",
    "address": "4535 HOLT BLVD, MONTCLAIR, CA, 91763",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0625397,
    "lng": -117.7064554
  },
  {
    "id": "14627",
    "name": "CVS",
    "address": "1535 EAST KATELLA AVENUE, ORANGE, CA, 92867",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8102304,
    "lng": -117.8372788
  },
  {
    "id": "14626",
    "name": "CVS",
    "address": "15210 ROSECRANS AVENUE, LA MIRADA, CA, 90638",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8970611,
    "lng": -118.0069894
  },
  {
    "id": "14625",
    "name": "CVS",
    "address": "11735 WHITTIER BOULEVARD, WHITTIER, CA, 90601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9823299,
    "lng": -118.0510841
  },
  {
    "id": "14624",
    "name": "CVS",
    "address": "189 SOUTH TURNPIKE ROAD, GOLETA, CA, 93111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4377833,
    "lng": -119.7913671
  },
  {
    "id": "14623",
    "name": "CVS",
    "address": "2500 W. VICTORY BLVD, BURBANK, CA, 91505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1832374,
    "lng": -118.3387981
  },
  {
    "id": "14622",
    "name": "CVS",
    "address": "435 EAST ARROW HWY, GLENDORA, CA, 91740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1078816,
    "lng": -117.8557816
  },
  {
    "id": "14621",
    "name": "CVS",
    "address": "861 NORTH VINE STREET, HOLLYWOOD, CA, 90038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.086765,
    "lng": -118.3269262
  },
  {
    "id": "14620",
    "name": "CVS",
    "address": "2141 SOUTH HACIENDA BOULEVARD, HACIENDA HEIGHTS, CA, 91745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9950017,
    "lng": -117.9691067
  },
  {
    "id": "14619",
    "name": "CVS",
    "address": "2456 S GROVE AVE, ONTARIO, CA, 91761",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0287087,
    "lng": -117.6301908
  },
  {
    "id": "14618",
    "name": "CVS",
    "address": "1411 LINCOLN BOULEVARD, SANTA MONICA, CA, 90401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0193583,
    "lng": -118.4906837
  },
  {
    "id": "14617",
    "name": "CVS",
    "address": "480 SOUTH MAIN STREET, ORANGE, CA, 92868",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7809534,
    "lng": -117.8682679
  },
  {
    "id": "14616",
    "name": "CVS",
    "address": "7911 HAVEN AVE., RANCHO CUCAMONGA, CA, 91730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1100257,
    "lng": -117.5750357
  },
  {
    "id": "14615",
    "name": "CVS",
    "address": "11428 KENYON WAY, RANCHO CUCAMONGA, CA, 91701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1356295,
    "lng": -117.5557299
  },
  {
    "id": "14614",
    "name": "CVS",
    "address": "26550 BOUQUET CANYON RD, SAUGUS, CA, 91350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4277965,
    "lng": -118.5346544
  },
  {
    "id": "14613",
    "name": "CVS",
    "address": "1401 S.  BALDWIN AVE., ARCADIA, CA, 91007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1236115,
    "lng": -118.0565165
  },
  {
    "id": "14612",
    "name": "CVS",
    "address": "5259 MISSION OAKS BLVD., CAMARILLO, CA, 93012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2294707,
    "lng": -118.9991628
  },
  {
    "id": "14611",
    "name": "CVS",
    "address": "1101 HIDDEN VALLEY PARKWAY, NORCO, CA, 92860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8988771,
    "lng": -117.5439523
  },
  {
    "id": "14610",
    "name": "CVS",
    "address": "13021 VICTORY BLVD., NORTH HOLLYWOOD, CA, 91606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1880349,
    "lng": -118.4164015
  },
  {
    "id": "14609",
    "name": "CVS",
    "address": "5585 N ROSEMEAD BLVD, TEMPLE CITY, CA, 91780",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1007606,
    "lng": -118.0750265
  },
  {
    "id": "14608",
    "name": "CVS",
    "address": "26861 SIERRA HWY, SANTA CLARITA, CA, 91321",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4051253,
    "lng": -118.4669613
  },
  {
    "id": "14607",
    "name": "CVS",
    "address": "1043 EMERALD BAY RD, SOUTH LAKE TAHOE, CA, 96150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9120388,
    "lng": -120.0026411
  },
  {
    "id": "14606",
    "name": "CVS",
    "address": "3340 N TEXAS ST, FAIRFIELD, CA, 94533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2914374,
    "lng": -122.0332466
  },
  {
    "id": "14605",
    "name": "CVS",
    "address": "1479 FOOTHILL BOULEVARD, LA VERNE, CA, 91750",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.117681,
    "lng": -117.7751767
  },
  {
    "id": "14604",
    "name": "CVS",
    "address": "14735 VENTURA BLVD., SHERMAN OAKS, CA, 91403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1526571,
    "lng": -118.4542171
  },
  {
    "id": "14603",
    "name": "CVS",
    "address": "9038 BALBOA BLVD., NORTHRIDGE, CA, 91325",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2348379,
    "lng": -118.5006745
  },
  {
    "id": "14602",
    "name": "CVS",
    "address": "13181 PEYTON DRIVE, CHINO HILLS, CA, 91709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.013075,
    "lng": -117.7432621
  },
  {
    "id": "14601",
    "name": "CVS",
    "address": "576 E EL CAMINO REAL, SUNNYVALE, CA, 94087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3617844,
    "lng": -122.0270068
  },
  {
    "id": "14600",
    "name": "CVS",
    "address": "27983 SECO CANYON ROAD, SANTA CLARITA, CA, 91350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.459376,
    "lng": -118.5350193
  },
  {
    "id": "14599",
    "name": "CVS",
    "address": "100 W. FOOTHILL BLVD., UPLAND, CA, 91786",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1054883,
    "lng": -117.6527434
  },
  {
    "id": "14598",
    "name": "CVS",
    "address": "23841 MALIBU ROAD, MALIBU, CA, 90265",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.033972,
    "lng": -118.6949261
  },
  {
    "id": "14597",
    "name": "CVS",
    "address": "551 S. VENTURA RD., OXNARD, CA, 93030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1967689,
    "lng": -119.196342
  },
  {
    "id": "14596",
    "name": "CVS",
    "address": "900 N. LAKE AVE., PASADENA, CA, 91104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1606553,
    "lng": -118.1318798
  },
  {
    "id": "14595",
    "name": "CVS",
    "address": "1820 W. VERDUGO AVE., BURBANK, CA, 91506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1669443,
    "lng": -118.3247344
  },
  {
    "id": "14594",
    "name": "CVS",
    "address": "906 E ST., MARYSVILLE, CA, 95901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1449971,
    "lng": -121.5923017
  },
  {
    "id": "14593",
    "name": "CVS",
    "address": "1301 BROADWAY ST, REDWOOD CITY, CA, 94063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4859357,
    "lng": -122.2154849
  },
  {
    "id": "14592",
    "name": "CVS",
    "address": "950 WEST FOOTHILL BLVD, MONROVIA, CA, 91016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1503107,
    "lng": -118.0204263
  },
  {
    "id": "14591",
    "name": "CVS",
    "address": "451 S SIERRA MADRE BLVD, PASADENA, CA, 91107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1381283,
    "lng": -118.1021178
  },
  {
    "id": "14590",
    "name": "CVS",
    "address": "702 NORTH AZUSA AVE, WEST COVINA, CA, 91791",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0832688,
    "lng": -117.9071178
  },
  {
    "id": "14589",
    "name": "CVS",
    "address": "4707 VENICE BLVD, LOS ANGELES, CA, 90019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0473388,
    "lng": -118.339346
  },
  {
    "id": "14588",
    "name": "CVS",
    "address": "2240 FAIR PARK AVE., LOS ANGELES, CA, 90041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1360498,
    "lng": -118.2165312
  },
  {
    "id": "14587",
    "name": "CVS",
    "address": "2630 W EL CAMINO REAL, MOUNTAIN VIEW, CA, 94040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4025517,
    "lng": -122.1145427
  },
  {
    "id": "14586",
    "name": "CVS",
    "address": "5900 TELEGRAPH RD., VENTURA, CA, 93003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2766404,
    "lng": -119.2140069
  },
  {
    "id": "14585",
    "name": "CVS",
    "address": "22968 VICTORY BLVD, WOODLAND HILLS, CA, 91367",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1861094,
    "lng": -118.6275152
  },
  {
    "id": "14584",
    "name": "CVS",
    "address": "1105 MYRTLE AVE, EUREKA, CA, 95501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8001359,
    "lng": -124.1472555
  },
  {
    "id": "14583",
    "name": "CVS",
    "address": "188 LAS TUNAS DR., ARCADIA, CA, 91007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1069877,
    "lng": -118.0377288
  },
  {
    "id": "14582",
    "name": "CVS",
    "address": "1485 E. VALLEY BLVD., ALHAMBRA, CA, 91801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0805595,
    "lng": -118.1088846
  },
  {
    "id": "14581",
    "name": "CVS",
    "address": "1500 1ST ST, LIVERMORE, CA, 94550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6801208,
    "lng": -121.7782222
  },
  {
    "id": "14580",
    "name": "CVS",
    "address": "17320 VENTURA BLVD., ENCINO, CA, 91316",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1602884,
    "lng": -118.5108822
  },
  {
    "id": "14579",
    "name": "CVS",
    "address": "12143 VENTURA BLVD, STUDIO CITY, CA, 91604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.143781,
    "lng": -118.3966795
  },
  {
    "id": "14578",
    "name": "CVS",
    "address": "1050 W. SUNSET BOULEVARD, LOS ANGELES, CA, 90012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0643397,
    "lng": -118.2493274
  },
  {
    "id": "14577",
    "name": "CVS",
    "address": "14503 RAMONA BLVD, BALDWIN PARK, CA, 91706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0886061,
    "lng": -117.9583078
  },
  {
    "id": "14576",
    "name": "CVS",
    "address": "18441 VENTURA BLVD, TARZANA, CA, 91356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1694542,
    "lng": -118.5342387
  },
  {
    "id": "14575",
    "name": "CVS",
    "address": "2530 GLENDALE BOULEVARD, LOS ANGELES, CA, 90039",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1034035,
    "lng": -118.2584182
  },
  {
    "id": "14574",
    "name": "CVS",
    "address": "727 S. ARROYO PARKWAY, PASADENA, CA, 91105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1335018,
    "lng": -118.1478342
  },
  {
    "id": "14573",
    "name": "CVS",
    "address": "300 SOUTH DIAMOND BAR BOULEVARD, DIAMOND BAR, CA, 91765",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0205517,
    "lng": -117.808709
  },
  {
    "id": "14572",
    "name": "CVS",
    "address": "5944 NORTH FIGUEROA AVENUE, LOS ANGELES, CA, 90042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1110626,
    "lng": -118.1891516
  },
  {
    "id": "14571",
    "name": "CVS",
    "address": "3960 BROAD STREET, SAN LUIS OBISPO, CA, 93401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2498021,
    "lng": -120.6426539
  },
  {
    "id": "14570",
    "name": "CVS",
    "address": "6360 WEST THIRD STREET, LOS ANGELES, CA, 90036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0702166,
    "lng": -118.3610785
  },
  {
    "id": "14569",
    "name": "CVS",
    "address": "3751 WILSHIRE BOULEVARD, LOS ANGELES, CA, 90010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0620302,
    "lng": -118.3081121
  },
  {
    "id": "14568",
    "name": "CVS",
    "address": "44430 CHALLENGER WAY, LANCASTER, CA, 93535",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6904668,
    "lng": -118.1121764
  },
  {
    "id": "14567",
    "name": "CVS",
    "address": "2771 4TH ST, SANTA ROSA, CA, 95405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4506762,
    "lng": -122.6898328
  },
  {
    "id": "14566",
    "name": "CVS",
    "address": "10208 BALBOA BLVD., GRANADA HILLS, CA, 91344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2559498,
    "lng": -118.5014224
  },
  {
    "id": "14565",
    "name": "CVS",
    "address": "2091 E LAKESHORE DR, LAKE ELSINORE, CA, 92530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6611638,
    "lng": -117.3016885
  },
  {
    "id": "14564",
    "name": "CVS",
    "address": "12717 GLENOAKS BLVD., SYLMAR, CA, 91342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3000909,
    "lng": -118.4423222
  },
  {
    "id": "14563",
    "name": "CVS",
    "address": "13650 BEAR VALLEY RD., VICTORVILLE, CA, 92392",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4718919,
    "lng": -117.3659067
  },
  {
    "id": "14562",
    "name": "CVS",
    "address": "33499 YUCAIPA BLVD, YUCAIPA, CA, 92399",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0331336,
    "lng": -117.073662
  },
  {
    "id": "14561",
    "name": "CVS",
    "address": "2037 VERDUGO BLVD., MONTROSE, CA, 91020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2057614,
    "lng": -118.2210926
  },
  {
    "id": "14560",
    "name": "CVS",
    "address": "42155 WASHINGTON ST., PALM DESERT, CA, 92211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.742298,
    "lng": -116.3054783
  },
  {
    "id": "14559",
    "name": "CVS",
    "address": "8225 GARVEY AVE, ROSEMEAD, CA, 91770",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0633226,
    "lng": -118.0898719
  },
  {
    "id": "14558",
    "name": "CVS",
    "address": "16975 BEAR VALLEY RD., HESPERIA, CA, 92345",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4702947,
    "lng": -117.2934667
  },
  {
    "id": "14557",
    "name": "CVS",
    "address": "8425 LAUREL CANYON BLVD., SUN VALLEY, CA, 91352",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2241519,
    "lng": -118.3985103
  },
  {
    "id": "14556",
    "name": "CVS",
    "address": "8530 RESEDA BLVD., NORTHRIDGE, CA, 91324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2254127,
    "lng": -118.5353873
  },
  {
    "id": "14555",
    "name": "CVS",
    "address": "206 N. AZUSA AVENUE, COVINA, CA, 91722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.087335,
    "lng": -117.9061343
  },
  {
    "id": "14554",
    "name": "CVS",
    "address": "11940 GARVEY AVENUE, EL MONTE, CA, 91732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0618316,
    "lng": -118.020713
  },
  {
    "id": "14553",
    "name": "CVS",
    "address": "24840 ORCHARD VILLAGE RD., SANTA CLARITA, CA, 91355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3808719,
    "lng": -118.5401271
  },
  {
    "id": "14552",
    "name": "CVS",
    "address": "1382 N. MOORPARK RD., THOUSAND OAKS, CA, 91360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1967842,
    "lng": -118.8682822
  },
  {
    "id": "14551",
    "name": "CVS",
    "address": "691 3RD AVE., CHULA VISTA, CA, 91910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6279871,
    "lng": -117.0743516
  },
  {
    "id": "14550",
    "name": "CVS",
    "address": "2825 COCHRAN ST., SIMI VALLEY, CA, 93065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2807819,
    "lng": -118.7411182
  },
  {
    "id": "14549",
    "name": "CVS",
    "address": "6201 SEPULVEDA BLVD., VAN NUYS, CA, 91411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1833779,
    "lng": -118.4665883
  },
  {
    "id": "14548",
    "name": "CVS",
    "address": "25080 HANCOCK AVE., MURRIETA, CA, 92562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5701933,
    "lng": -117.181894
  },
  {
    "id": "14547",
    "name": "CVS",
    "address": "22050 VENTURA BLVD., WOODLAND HILLS, CA, 91364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1683147,
    "lng": -118.6075525
  },
  {
    "id": "14546",
    "name": "CVS",
    "address": "1747 NORTH CAHUENGA BOULEVARD, HOLLYWOOD, CA, 90028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1032184,
    "lng": -118.3302178
  },
  {
    "id": "14545",
    "name": "CVS",
    "address": "649 W. OLIVE AVE., MERCED, CA, 95348",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3196315,
    "lng": -120.4803346
  },
  {
    "id": "14544",
    "name": "CVS",
    "address": "243 W JACKSON ST, HAYWARD, CA, 94544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.652072,
    "lng": -122.091112
  },
  {
    "id": "14543",
    "name": "CVS",
    "address": "4105 W AVENUE L, LANCASTER, CA, 93536",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6616492,
    "lng": -118.2037935
  },
  {
    "id": "14542",
    "name": "CVS",
    "address": "31575 DATE PALM DR., CATHEDRAL CITY, CA, 92234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8190441,
    "lng": -116.4591407
  },
  {
    "id": "14541",
    "name": "CVS",
    "address": "19353 VICTORY BLVD., RESEDA, CA, 91335",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1882441,
    "lng": -118.5554494
  },
  {
    "id": "14540",
    "name": "CVS",
    "address": "1122 EAST BROADWAY, GLENDALE, CA, 91205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1456959,
    "lng": -118.2408758
  },
  {
    "id": "14539",
    "name": "CVS",
    "address": "23357 MULHOLLAND DRIVE, WOODLAND HILLS, CA, 91364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1580303,
    "lng": -118.6344098
  },
  {
    "id": "14538",
    "name": "CVS",
    "address": "6 THE CROSSROADS, CARMEL, CA, 93923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5369974,
    "lng": -121.9098263
  },
  {
    "id": "14537",
    "name": "CVS",
    "address": "19424 SOLEDAD CANYON RD., CANYON COUNTRY, CA, 91351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4152924,
    "lng": -118.4746261
  },
  {
    "id": "14536",
    "name": "CVS",
    "address": "12280 PERRIS BLVD, MORENO VALLEY, CA, 92557",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9420509,
    "lng": -117.2247114
  },
  {
    "id": "14535",
    "name": "CVS",
    "address": "2505 SANTA MONICA BOULEVARD, SANTA MONICA, CA, 90404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0333179,
    "lng": -118.4755181
  },
  {
    "id": "14534",
    "name": "CVS",
    "address": "901 SILVER SPUR RD., ROLLING HILLS ESTATES, CA, 90274",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7693247,
    "lng": -118.3669221
  },
  {
    "id": "14533",
    "name": "CVS",
    "address": "29610 RANCHO CALIFORNIA RD, TEMECULA, CA, 92591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5057844,
    "lng": -117.1473395
  },
  {
    "id": "14532",
    "name": "CVS",
    "address": "10181 RESEDA BLVD., NORTHRIDGE, CA, 91324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2555053,
    "lng": -118.5373908
  },
  {
    "id": "14531",
    "name": "CVS",
    "address": "1183 MAGNOLIA AVE., CORONA, CA, 92879",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8645692,
    "lng": -117.5471081
  },
  {
    "id": "14530",
    "name": "CVS",
    "address": "1015 N. SAN FERNANDO BOULEVARD, BURBANK, CA, 91504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1871755,
    "lng": -118.3192547
  },
  {
    "id": "14529",
    "name": "CVS",
    "address": "35720 FREMONT BLVD, FREMONT, CA, 94536",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5680085,
    "lng": -122.0243423
  },
  {
    "id": "14528",
    "name": "CVS",
    "address": "801 EAST AVE, CHICO, CA, 95926",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7593327,
    "lng": -121.8465736
  },
  {
    "id": "14527",
    "name": "CVS",
    "address": "455 NORTH STATE COLLEGE BOULEVARD, FULLERTON, CA, 92831",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8737522,
    "lng": -117.8905708
  },
  {
    "id": "14526",
    "name": "CVS",
    "address": "1750 41ST AVE, CAPITOLA, CA, 95010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9745759,
    "lng": -121.9635532
  },
  {
    "id": "14525",
    "name": "CVS",
    "address": "1435 E GRAND AVE, ARROYO GRANDE, CA, 93420",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1203532,
    "lng": -120.6064155
  },
  {
    "id": "14524",
    "name": "CVS",
    "address": "30842 S PACIFIC COAST, LAGUNA BEACH, CA, 92651",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5156509,
    "lng": -117.7557093
  },
  {
    "id": "14523",
    "name": "CVS",
    "address": "12221 CARSON STREET, HAWAIIAN GARDENS, CA, 90716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8320162,
    "lng": -118.0708408
  },
  {
    "id": "14522",
    "name": "CVS",
    "address": "21761 LAKE FOREST DRIVE, LAKE FOREST, CA, 92630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6472453,
    "lng": -117.6880795
  },
  {
    "id": "14521",
    "name": "CVS",
    "address": "3925 N. RIVER RD., OCEANSIDE, CA, 92058",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.244718,
    "lng": -117.323359
  },
  {
    "id": "14520",
    "name": "CVS",
    "address": "4345 WEST CENTURY BOULEVARD, INGLEWOOD, CA, 90304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9458001,
    "lng": -118.3518106
  },
  {
    "id": "14519",
    "name": "CVS",
    "address": "3741 CRENSHAW BOULEVARD, LOS ANGELES, CA, 90016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0187108,
    "lng": -118.3359255
  },
  {
    "id": "14518",
    "name": "CVS",
    "address": "32900 PACIFIC COAST HIGHWAY, DANA POINT, CA, 92629",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4860988,
    "lng": -117.7233389
  },
  {
    "id": "14517",
    "name": "CVS",
    "address": "4570 ATLANTIC AVENUE, LONG BEACH, CA, 90807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8424079,
    "lng": -118.1840332
  },
  {
    "id": "14516",
    "name": "CVS",
    "address": "3120 W. IMPERIAL HWY., INGLEWOOD, CA, 90303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9296697,
    "lng": -118.3272973
  },
  {
    "id": "14515",
    "name": "CVS",
    "address": "7191 WARNER AVENUE, HUNTINGTON BEACH, CA, 92647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7169594,
    "lng": -118.0033296
  },
  {
    "id": "14514",
    "name": "CVS",
    "address": "10889 WELLWORTH AVENUE, LOS ANGELES, CA, 90024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0573042,
    "lng": -118.4425197
  },
  {
    "id": "14513",
    "name": "CVS",
    "address": "5501 BALL ROAD, CYPRESS, CA, 90630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8173297,
    "lng": -118.0358992
  },
  {
    "id": "14512",
    "name": "CVS",
    "address": "5117 LAKEWOOD BOULEVARD, LAKEWOOD, CA, 90712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.851089,
    "lng": -118.1433088
  },
  {
    "id": "14511",
    "name": "CVS",
    "address": "950 NORTH WESTERN AVENUE, SAN PEDRO, CA, 90732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.751916,
    "lng": -118.3071531
  },
  {
    "id": "14510",
    "name": "CVS",
    "address": "17136 MAGNOLIA ST., FOUNTAIN VALLEY, CA, 92708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7138041,
    "lng": -117.970937
  },
  {
    "id": "14509",
    "name": "CVS",
    "address": "4625 TORRANCE BOULEVARD, TORRANCE, CA, 90503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8393449,
    "lng": -118.3627221
  },
  {
    "id": "14508",
    "name": "CVS",
    "address": "596 LONG BEACH BOULEVARD, LONG BEACH, CA, 90802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7737462,
    "lng": -118.1889688
  },
  {
    "id": "14507",
    "name": "CVS",
    "address": "14830 HIGHWAY 4, DISCOVERY BAY, CA, 94505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8900213,
    "lng": -121.6225439
  },
  {
    "id": "14506",
    "name": "CVS",
    "address": "15700 SOUTH WESTERN AVENUE, GARDENA, CA, 90247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8878313,
    "lng": -118.3084775
  },
  {
    "id": "14505",
    "name": "CVS",
    "address": "3458 S SEPULVEDA BLVD, LOS ANGELES, CA, 90034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0203547,
    "lng": -118.4222888
  },
  {
    "id": "14504",
    "name": "CVS",
    "address": "3981 IRVINE BOULEVARD, IRVINE, CA, 92602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7229487,
    "lng": -117.7705961
  },
  {
    "id": "14503",
    "name": "CVS",
    "address": "17625 HARVARD AVENUE, IRVINE, CA, 92614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.676699,
    "lng": -117.8332769
  },
  {
    "id": "14502",
    "name": "CVS",
    "address": "611 S. BROOKHURST ST., ANAHEIM, CA, 92804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8245884,
    "lng": -117.9599551
  },
  {
    "id": "14501",
    "name": "CVS",
    "address": "1285 LINCOLN AVE, SAN JOSE, CA, 95125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3050147,
    "lng": -121.899039
  },
  {
    "id": "14500",
    "name": "CVS",
    "address": "320 S TWIN OAKS VALLEY RD, SAN MARCOS, CA, 92078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1294061,
    "lng": -117.1660879
  },
  {
    "id": "14499",
    "name": "CVS",
    "address": "510 SOUTH BEACH BOULEVARD, ANAHEIM, CA, 92804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8255429,
    "lng": -117.9927157
  },
  {
    "id": "14498",
    "name": "CVS",
    "address": "77 BOVET RD, SAN MATEO, CA, 94402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5500684,
    "lng": -122.3142062
  },
  {
    "id": "14497",
    "name": "CVS",
    "address": "27702 CROWN VALLEY PRKWY STE I, LADERA RANCH, CA, 92694",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5632981,
    "lng": -117.6469909
  },
  {
    "id": "14496",
    "name": "CVS",
    "address": "12490 SEAL BEACH BOULEVARD, SEAL BEACH, CA, 90740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7805937,
    "lng": -118.0713439
  },
  {
    "id": "14495",
    "name": "CVS",
    "address": "40365 WINCHESTER RD, TEMECULA, CA, 92591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5328513,
    "lng": -117.1521186
  },
  {
    "id": "14494",
    "name": "CVS",
    "address": "1980 COLLEGE BLVD, OCEANSIDE, CA, 92056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2085107,
    "lng": -117.2842585
  },
  {
    "id": "14493",
    "name": "CVS",
    "address": "2501 ANTHEM VILLAGE DR, HENDERSON, NV, 89052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9785557,
    "lng": -115.0985854
  },
  {
    "id": "14492",
    "name": "CVS",
    "address": "3251 STANFORD RANCH RD, ROCKLIN, CA, 95765",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8152753,
    "lng": -121.2557514
  },
  {
    "id": "14491",
    "name": "CVS",
    "address": "1123 S CALIFORNIA BLVD, WALNUT CREEK, CA, 94596",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8965708,
    "lng": -122.0644801
  },
  {
    "id": "14490",
    "name": "CVS",
    "address": "1880 S PACIFIC COAST HWY, REDONDO BEACH, CA, 90277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8169586,
    "lng": -118.3778782
  },
  {
    "id": "14489",
    "name": "CVS",
    "address": "2001 PACIFIC COAST HIGHWAY, LOMITA, CA, 90717",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.789943,
    "lng": -118.3148881
  },
  {
    "id": "14488",
    "name": "CVS",
    "address": "2521 EASTBLUFF DRIVE, NEWPORT BEACH, CA, 92660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6405544,
    "lng": -117.8765168
  },
  {
    "id": "14487",
    "name": "CVS",
    "address": "41 N MAIN ST, ANGELS CAMP, CA, 95222",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0825829,
    "lng": -120.5609186
  },
  {
    "id": "14486",
    "name": "CVS",
    "address": "1792 GARNET AVE, SAN DIEGO, CA, 92109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8010613,
    "lng": -117.2375732
  },
  {
    "id": "14485",
    "name": "CVS",
    "address": "490 MARKET PL, SAN RAMON, CA, 94583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7639134,
    "lng": -121.9505551
  },
  {
    "id": "14484",
    "name": "CVS",
    "address": "63 LINCOLN BLVD., LINCOLN, CA, 95648",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8774486,
    "lng": -121.2947327
  },
  {
    "id": "14483",
    "name": "CVS",
    "address": "4850 SAN FELIPE RD, SAN JOSE, CA, 95135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3006144,
    "lng": -121.7711724
  },
  {
    "id": "14482",
    "name": "CVS",
    "address": "19783 RINALDI ST, PORTER RANCH, CA, 91326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2766194,
    "lng": -118.5642044
  },
  {
    "id": "14481",
    "name": "CVS",
    "address": "4615 FRAZEE ROAD, OCEANSIDE, CA, 92057",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2380805,
    "lng": -117.2984261
  },
  {
    "id": "14480",
    "name": "CVS",
    "address": "155 W LOS ANGELES AVE, MOORPARK, CA, 93021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2833595,
    "lng": -118.8038012
  },
  {
    "id": "14479",
    "name": "CVS",
    "address": "12100 VENTURA BLVD, STUDIO CITY, CA, 91604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1431475,
    "lng": -118.395405
  },
  {
    "id": "14478",
    "name": "CVS",
    "address": "8455 AUBURN FOLSOM RD, GRANITE BAY, CA, 95746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7443442,
    "lng": -121.1698756
  },
  {
    "id": "14477",
    "name": "CVS",
    "address": "1570 ROSECRANS AVE, MANHATTAN BEACH, CA, 90266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9003509,
    "lng": -118.3848828
  },
  {
    "id": "14476",
    "name": "CVS",
    "address": "15466 WHITTIER BLVD., WHITTIER, CA, 90603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9427521,
    "lng": -117.9939052
  },
  {
    "id": "14475",
    "name": "CVS",
    "address": "1175 2ND ST, BRENTWOOD, CA, 94513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.935882,
    "lng": -121.6991382
  },
  {
    "id": "14474",
    "name": "CVS",
    "address": "15421 BROOKHURST STREET, WESTMINSTER, CA, 92683",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7387963,
    "lng": -117.9562944
  },
  {
    "id": "14473",
    "name": "CVS",
    "address": "4424 TREAT BLVD, CONCORD, CA, 94521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.962584,
    "lng": -121.992719
  },
  {
    "id": "14472",
    "name": "CVS",
    "address": "1835 NEWPORT BOULEVARD #C, COSTA MESA, CA, 92627",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6430216,
    "lng": -117.9193157
  },
  {
    "id": "14471",
    "name": "CVS",
    "address": "1140 S MAIN ST, SALINAS, CA, 93901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.6599445,
    "lng": -121.6601737
  },
  {
    "id": "14470",
    "name": "CVS",
    "address": "4400 EAST LOS COYOTES DIAGONAL, LONG BEACH, CA, 90815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7901101,
    "lng": -118.1410389
  },
  {
    "id": "14469",
    "name": "CVS",
    "address": "8008 FIRESTONE BOULEVARD, DOWNEY, CA, 90241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9417535,
    "lng": -118.1379605
  },
  {
    "id": "14468",
    "name": "CVS",
    "address": "8490 BEVERLY BLVD, LOS ANGELES, CA, 90048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0755018,
    "lng": -118.3759341
  },
  {
    "id": "14467",
    "name": "CVS",
    "address": "43418 STATE HIGHWAY 74, HEMET, CA, 92544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.749027,
    "lng": -116.9030885
  },
  {
    "id": "14466",
    "name": "CVS",
    "address": "1800 SARATOGA AVE., SAN JOSE, CA, 95129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.288696,
    "lng": -121.994873
  },
  {
    "id": "14465",
    "name": "CVS",
    "address": "14330 CULVER DRIVE, IRVINE, CA, 92604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7055813,
    "lng": -117.7843732
  },
  {
    "id": "14464",
    "name": "CVS",
    "address": "2900 N. SEPULVEDA BLVD., MANHATTAN BEACH, CA, 90266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.896683,
    "lng": -118.394311
  },
  {
    "id": "14463",
    "name": "CVS",
    "address": "35080 NEWARK BLVD, NEWARK, CA, 94560",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5510479,
    "lng": -122.0472546
  },
  {
    "id": "14462",
    "name": "CVS",
    "address": "12315 VENICE BOULEVARD, MAR VISTA, CA, 90066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0046635,
    "lng": -118.4330131
  },
  {
    "id": "14461",
    "name": "CVS",
    "address": "5822 EDINGER AVENUE, HUNTINGTON BEACH, CA, 92649",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7293392,
    "lng": -118.026934
  },
  {
    "id": "14460",
    "name": "CVS",
    "address": "6450 PONY EXPRESS TRL, POLLOCK PINES, CA, 95726",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7618674,
    "lng": -120.5796229
  },
  {
    "id": "14459",
    "name": "CVS",
    "address": "13303 EAST SOUTH STREET, CERRITOS, CA, 90703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.86,
    "lng": -118.0485
  },
  {
    "id": "14458",
    "name": "CVS",
    "address": "11851 ARTESIA BOULEVARD, ARTESIA, CA, 90701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8737897,
    "lng": -118.0805354
  },
  {
    "id": "14457",
    "name": "CVS",
    "address": "8861 GREENBACK LN, ORANGEVALE, CA, 95662",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6797039,
    "lng": -121.227938
  },
  {
    "id": "14456",
    "name": "CVS",
    "address": "5385 ALTON PARKWAY, IRVINE, CA, 92604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6710888,
    "lng": -117.7883683
  },
  {
    "id": "14455",
    "name": "CVS",
    "address": "10011 ADAMS AVENUE, HUNTINGTON BEACH, CA, 92646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6741633,
    "lng": -117.9533657
  },
  {
    "id": "14454",
    "name": "CVS",
    "address": "600 F ST, ARCATA, CA, 95521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8657223,
    "lng": -124.0852373
  },
  {
    "id": "14453",
    "name": "CVS",
    "address": "12444 BEACH BOULEVARD, STANTON, CA, 90680",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7815122,
    "lng": -117.9919837
  },
  {
    "id": "14452",
    "name": "CVS",
    "address": "365 E WASHINGTON ST, PETALUMA, CA, 94952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2386131,
    "lng": -122.6379009
  },
  {
    "id": "14451",
    "name": "CVS",
    "address": "2510 EL CAMINO REAL, CARLSBAD, CA, 92008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.179748,
    "lng": -117.3248282
  },
  {
    "id": "14450",
    "name": "CVS",
    "address": "3020 SEPULVEDA BOULEVARD, TORRANCE, CA, 90505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8230494,
    "lng": -118.3406245
  },
  {
    "id": "14449",
    "name": "CVS",
    "address": "5399 WEST CENTINELA AVENUE, LOS ANGELES, CA, 90045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9777631,
    "lng": -118.3736785
  },
  {
    "id": "14448",
    "name": "CVS",
    "address": "711 PIER AVENUE, HERMOSA BEACH, CA, 90254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8656796,
    "lng": -118.394941
  },
  {
    "id": "14447",
    "name": "CVS",
    "address": "4320 REDONDO BEACH BOULEVARD, TORRANCE, CA, 90504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8741554,
    "lng": -118.3507605
  },
  {
    "id": "14446",
    "name": "CVS",
    "address": "29412 AUBERRY RD, PRATHER, CA, 93651",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0381364,
    "lng": -119.5170244
  },
  {
    "id": "14445",
    "name": "CVS",
    "address": "9618 W PICO BLVD STE 501, LOS ANGELES, CA, 90035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0548859,
    "lng": -118.398162
  },
  {
    "id": "14444",
    "name": "CVS",
    "address": "4405 1ST ST, LIVERMORE, CA, 94551",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6967264,
    "lng": -121.7425075
  },
  {
    "id": "14443",
    "name": "CVS",
    "address": "525 W CAPITOL EXPY, SAN JOSE, CA, 95136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2760079,
    "lng": -121.8522581
  },
  {
    "id": "14442",
    "name": "CVS",
    "address": "4852 S BRADLEY RD, SANTA MARIA, CA, 93455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8662881,
    "lng": -120.4180093
  },
  {
    "id": "14441",
    "name": "CVS",
    "address": "2075 MENDOCINO AVE, SANTA ROSA, CA, 95401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4601224,
    "lng": -122.7186669
  },
  {
    "id": "14440",
    "name": "CVS",
    "address": "1113 E CHAMPLAIN DR, FRESNO, CA, 93720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8700502,
    "lng": -119.7644093
  },
  {
    "id": "14439",
    "name": "CVS",
    "address": "200 E HIGHWAY 12 STE D, VALLEY SPRINGS, CA, 95252",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1915194,
    "lng": -120.8266182
  },
  {
    "id": "14438",
    "name": "CVS",
    "address": "3471 LAKE TAHOE BLVD, SOUTH LAKE TAHOE, CA, 96150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9466753,
    "lng": -119.9649294
  },
  {
    "id": "14437",
    "name": "CVS",
    "address": "16922 BOLSA CHICA STREET, HUNTINGTON BEACH, CA, 92649",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7158808,
    "lng": -118.0408129
  },
  {
    "id": "14436",
    "name": "CVS",
    "address": "880 SIR FRANCIS DRAKE BLVD, SAN ANSELMO, CA, 94960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9811828,
    "lng": -122.5651131
  },
  {
    "id": "14435",
    "name": "CVS",
    "address": "9120 ALCOSTA BLVD, SAN RAMON, CA, 94583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7286967,
    "lng": -121.9306894
  },
  {
    "id": "14434",
    "name": "CVS",
    "address": "1525 NORTH CENTRAL AVENUE, PHOENIX, AZ, 85004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4653138,
    "lng": -112.0734396
  },
  {
    "id": "14433",
    "name": "CVS",
    "address": "1041 EL MONTE AVE, MOUNTAIN VIEW, CA, 94040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3900289,
    "lng": -122.0945746
  },
  {
    "id": "14432",
    "name": "CVS",
    "address": "506 NORTH MILLER VALLEY ROAD, PRESCOTT, AZ, 86301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5489968,
    "lng": -112.4789707
  },
  {
    "id": "14431",
    "name": "CVS",
    "address": "16995 WALNUT GROVE DR., MORGAN HILL, CA, 95037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.1291292,
    "lng": -121.6385881
  },
  {
    "id": "14430",
    "name": "CVS",
    "address": "1540 E HIGHLAND AVE, SAN BERNARDINO, CA, 92404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.137013,
    "lng": -117.2535575
  },
  {
    "id": "14429",
    "name": "CVS",
    "address": "3610 W. ANTHEM WAY, ANTHEM, AZ, 85086",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8662783,
    "lng": -112.1358957
  },
  {
    "id": "14428",
    "name": "CVS",
    "address": "21001 N TATUM BLVD  STE 82, PHOENIX, AZ, 85050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6794925,
    "lng": -111.9758169
  },
  {
    "id": "14427",
    "name": "CVS",
    "address": "7901 E. GOLF LINKS ROAD, TUCSON, AZ, 85730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.1925185,
    "lng": -110.8231147
  },
  {
    "id": "14426",
    "name": "CVS",
    "address": "3939 STATE ST, SANTA BARBARA, CA, 93105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4394331,
    "lng": -119.7531416
  },
  {
    "id": "14425",
    "name": "CVS",
    "address": "2800 S 4TH AVE, YUMA, AZ, 85364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6760927,
    "lng": -114.6256458
  },
  {
    "id": "14424",
    "name": "CVS",
    "address": "1700 MISSION ST, SANTA CRUZ, CA, 95060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9655286,
    "lng": -122.042637
  },
  {
    "id": "14423",
    "name": "CVS",
    "address": "325 SHARON PARK DR, MENLO PARK, CA, 94025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4233487,
    "lng": -122.1969534
  },
  {
    "id": "14422",
    "name": "CVS",
    "address": "1039 EL CAMINO REAL, REDWOOD CITY, CA, 94063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4853241,
    "lng": -122.2312652
  },
  {
    "id": "14421",
    "name": "CVS",
    "address": "7901 E THOMAS ROAD, SCOTTSDALE, AZ, 85251",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4792477,
    "lng": -111.9101434
  },
  {
    "id": "14420",
    "name": "CVS",
    "address": "6021 S CENTRAL AVE, PHOENIX, AZ, 85042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3913106,
    "lng": -112.0725547
  },
  {
    "id": "14419",
    "name": "CVS",
    "address": "11941 SAN VICENTE BLVD, LOS ANGELES, CA, 90049",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0531817,
    "lng": -118.4709763
  },
  {
    "id": "14418",
    "name": "CVS",
    "address": "1960 TICE VALLEY BLVD, WALNUT CREEK, CA, 94595",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8780239,
    "lng": -122.0735357
  },
  {
    "id": "14417",
    "name": "CVS",
    "address": "1179 SOUTH STATE ROUTE 260, COTTONWOOD, AZ, 86326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7189108,
    "lng": -112.0009216
  },
  {
    "id": "14416",
    "name": "CVS",
    "address": "1707 GRANT AVE, NOVATO, CA, 94945",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1079921,
    "lng": -122.5790739
  },
  {
    "id": "14415",
    "name": "CVS",
    "address": "7241 BOULDER AVE, HIGHLAND, CA, 92346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1225876,
    "lng": -117.1940234
  },
  {
    "id": "14414",
    "name": "CVS",
    "address": "4323 EAST BELL ROAD, PHOENIX, AZ, 85032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6399673,
    "lng": -111.9874144
  },
  {
    "id": "14413",
    "name": "CVS",
    "address": "20180 US HIGHWAY 18, APPLE VALLEY, CA, 92307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5285402,
    "lng": -117.2222397
  },
  {
    "id": "14412",
    "name": "CVS",
    "address": "4744 S. HWY 95, FORT MOHAVE, AZ, 86426",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0191051,
    "lng": -114.5972987
  },
  {
    "id": "14411",
    "name": "CVS",
    "address": "901 N CARPENTER RD STE 30, MODESTO, CA, 95351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6486466,
    "lng": -121.0310757
  },
  {
    "id": "14410",
    "name": "CVS",
    "address": "19505 N SUNRISE BLVD, SURPRISE, AZ, 85374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6550293,
    "lng": -112.4035676
  },
  {
    "id": "14409",
    "name": "CVS",
    "address": "1617 CANYON DRIVE, PINOLE, CA, 94564",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9951434,
    "lng": -122.3017968
  },
  {
    "id": "14408",
    "name": "CVS",
    "address": "6002 NORTH 7TH STREET, PHOENIX, AZ, 85014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5243366,
    "lng": -112.0658013
  },
  {
    "id": "14407",
    "name": "CVS",
    "address": "3420 CAMINO TASSAJARA, DANVILLE, CA, 94506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7977917,
    "lng": -121.9210885
  },
  {
    "id": "14406",
    "name": "CVS",
    "address": "325 W APACHE TRAIL, APACHE JUNCTION, AZ, 85120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4142849,
    "lng": -111.5496969
  },
  {
    "id": "14405",
    "name": "CVS",
    "address": "581 W CHANNEL ISLANDS BLVD, PORT HUENEME, CA, 93041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1771233,
    "lng": -119.2149151
  },
  {
    "id": "14404",
    "name": "CVS",
    "address": "1471 W COVELL BLVD, DAVIS, CA, 95616",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5616008,
    "lng": -121.7665036
  },
  {
    "id": "14403",
    "name": "CVS",
    "address": "16545 EAST PALISADES BLVD, FOUNTAIN HILLS, AZ, 85268",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6090969,
    "lng": -111.7237839
  },
  {
    "id": "14402",
    "name": "CVS",
    "address": "1555 S AVENUE B, YUMA, AZ, 85364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6992516,
    "lng": -114.6494445
  },
  {
    "id": "14401",
    "name": "CVS",
    "address": "3785 WEST INA RD., TUCSON, AZ, 85741",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.336935,
    "lng": -111.0462736
  },
  {
    "id": "14400",
    "name": "CVS",
    "address": "7499 E. BROADWAY, TUCSON, AZ, 85710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.221654,
    "lng": -110.832847
  },
  {
    "id": "14399",
    "name": "CVS",
    "address": "3619 W. CALDWELL AVE, VISALIA, CA, 93277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2978023,
    "lng": -119.3307437
  },
  {
    "id": "14398",
    "name": "CVS",
    "address": "2033 W WICKENBURG WAY, WICKENBURG, AZ, 85390",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9609831,
    "lng": -112.7737761
  },
  {
    "id": "14397",
    "name": "CVS",
    "address": "195 PASEO DE PERALTA, SANTA FE, NM, 87501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.692485,
    "lng": -105.9499676
  },
  {
    "id": "14396",
    "name": "CVS",
    "address": "5495 LA JOLLA BLVD, LA JOLLA, CA, 92037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8123088,
    "lng": -117.2676575
  },
  {
    "id": "14395",
    "name": "CVS",
    "address": "522 FINNEY FLAT SUITE A, CAMP VERDE, AZ, 86322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.567133,
    "lng": -111.864228
  },
  {
    "id": "14394",
    "name": "CVS",
    "address": "23215 NO PIMA RD., SCOTTSDALE, AZ, 85255",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6972233,
    "lng": -111.8889041
  },
  {
    "id": "14393",
    "name": "CVS",
    "address": "511 W. CORDOVA RD., SANTA FE, NM, 87505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6732775,
    "lng": -105.9498838
  },
  {
    "id": "14392",
    "name": "CVS",
    "address": "222 SARATOGA AVE, SANTA CLARA, CA, 95050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3286137,
    "lng": -121.9665961
  },
  {
    "id": "14391",
    "name": "CVS",
    "address": "100 W LODI AVE, LODI, CA, 95240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1294875,
    "lng": -121.2743322
  },
  {
    "id": "14390",
    "name": "CVS",
    "address": "5170 MOORPARK AVE, SAN JOSE, CA, 95129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3088898,
    "lng": -121.9946735
  },
  {
    "id": "14389",
    "name": "CVS",
    "address": "3560 WEST PEORIA AVENUE, PHOENIX, AZ, 85029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5824449,
    "lng": -112.1359889
  },
  {
    "id": "14388",
    "name": "CVS",
    "address": "931 MARINA VILLAGE PKWY, ALAMEDA, CA, 94501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7841018,
    "lng": -122.2720302
  },
  {
    "id": "14387",
    "name": "CVS",
    "address": "240 W CONTINENTAL RD, GREEN VALLEY, AZ, 85622",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8534457,
    "lng": -110.9957054
  },
  {
    "id": "14386",
    "name": "CVS",
    "address": "560 CENTER AVE, MARTINEZ, CA, 94553",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9920961,
    "lng": -122.1195122
  },
  {
    "id": "14385",
    "name": "CVS",
    "address": "14672 N FRANK LLOYD WRIGHT, SCOTTSDALE, AZ, 85260",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6190753,
    "lng": -111.8773062
  },
  {
    "id": "14384",
    "name": "CVS",
    "address": "3999 SANTA RITA ROAD, PLEASANTON, CA, 94588",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6971875,
    "lng": -121.8759178
  },
  {
    "id": "14383",
    "name": "CVS",
    "address": "885 ISLAND DR STE A, ALAMEDA, CA, 94502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7369797,
    "lng": -122.240617
  },
  {
    "id": "14382",
    "name": "CVS",
    "address": "1700 MCHENRY AVE., MODESTO, CA, 95350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6685375,
    "lng": -120.9936146
  },
  {
    "id": "14381",
    "name": "CVS",
    "address": "2662 DEL MAR HEIGHTS RD, DEL MAR, CA, 92014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9501088,
    "lng": -117.2462086
  },
  {
    "id": "14380",
    "name": "CVS",
    "address": "24167 PASEO DE VALENCIA, LAGUNA WOODS, CA, 92637",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6115295,
    "lng": -117.7141534
  },
  {
    "id": "14379",
    "name": "CVS",
    "address": "12409 N. TATUM BLVD., PHOENIX, AZ, 85032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5990204,
    "lng": -111.9784252
  },
  {
    "id": "14378",
    "name": "CVS",
    "address": "1000 W KETTLEMAN LN, LODI, CA, 95240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1138845,
    "lng": -121.2847203
  },
  {
    "id": "14377",
    "name": "CVS",
    "address": "27750 SANTA MARGARITA PKWY, MISSION VIEJO, CA, 92691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6508539,
    "lng": -117.6458638
  },
  {
    "id": "14376",
    "name": "CVS",
    "address": "380 E H ST, CHULA VISTA, CA, 91910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6386451,
    "lng": -117.0502617
  },
  {
    "id": "14375",
    "name": "CVS",
    "address": "2677 CLAYTON RD, CONCORD, CA, 94519",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9760974,
    "lng": -122.0277173
  },
  {
    "id": "14374",
    "name": "CVS",
    "address": "9856 W. PEORIA AVE., PEORIA, AZ, 85345",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5808214,
    "lng": -112.2716532
  },
  {
    "id": "14373",
    "name": "CVS",
    "address": "50 N ASHWOOD AVE, VENTURA, CA, 93003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2754445,
    "lng": -119.2387319
  },
  {
    "id": "14372",
    "name": "CVS",
    "address": "1036 CASITAS PASS RD, CARPINTERIA, CA, 93013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3951138,
    "lng": -119.5115412
  },
  {
    "id": "14371",
    "name": "CVS",
    "address": "46445 MISSION BLVD, FREMONT, CA, 94539",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4920461,
    "lng": -121.9276648
  },
  {
    "id": "14370",
    "name": "CVS",
    "address": "515 S STATE HIGHWAY 49, JACKSON, CA, 95642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3437641,
    "lng": -120.770284
  },
  {
    "id": "14369",
    "name": "CVS",
    "address": "4748 E. SUNRISE, TUCSON, AZ, 85718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3069223,
    "lng": -110.8917541
  },
  {
    "id": "14368",
    "name": "CVS",
    "address": "3506 EAST ROUTE 66, FLAGSTAFF, AZ, 86004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2157936,
    "lng": -111.5981868
  },
  {
    "id": "14367",
    "name": "CVS",
    "address": "19602 R H JOHNSON BLVD., SUN CITY WEST, AZ, 85375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6610152,
    "lng": -112.3586734
  },
  {
    "id": "14366",
    "name": "CVS",
    "address": "3220 S WHITE RD, SAN JOSE, CA, 95148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3156369,
    "lng": -121.7912176
  },
  {
    "id": "14365",
    "name": "CVS",
    "address": "3320 FRUITVALE AVE, OAKLAND, CA, 94602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7988896,
    "lng": -122.2154849
  },
  {
    "id": "14364",
    "name": "CVS",
    "address": "4275 W. THOMAS RD., PHOENIX, AZ, 85019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4797582,
    "lng": -112.1511252
  },
  {
    "id": "14363",
    "name": "CVS",
    "address": "2120 NEWBURY RD, NEWBURY PARK, CA, 91320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1819423,
    "lng": -118.9236705
  },
  {
    "id": "14362",
    "name": "CVS",
    "address": "330 BON AIR SHOPPING CTR, GREENBRAE, CA, 94904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9453938,
    "lng": -122.5225628
  },
  {
    "id": "14361",
    "name": "CVS",
    "address": "1137 S. DOBSON RD #10, MESA, AZ, 85202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3937681,
    "lng": -111.8729495
  },
  {
    "id": "14360",
    "name": "CVS",
    "address": "10720 WEST BELL RD., SUN CITY, AZ, 85351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6393491,
    "lng": -112.2908305
  },
  {
    "id": "14359",
    "name": "CVS",
    "address": "1558 TRANCAS ST, NAPA, CA, 94558",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.323104,
    "lng": -122.3037536
  },
  {
    "id": "14358",
    "name": "CVS",
    "address": "305 E. BROWN RD., MESA, AZ, 85201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4342592,
    "lng": -111.8247197
  },
  {
    "id": "14357",
    "name": "CVS",
    "address": "1843 S LA CIENEGA BLVD, LOS ANGELES, CA, 90035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0430934,
    "lng": -118.3773966
  },
  {
    "id": "14356",
    "name": "CVS",
    "address": "6488 N. ORACLE ROAD, TUCSON, AZ, 85704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3242311,
    "lng": -110.974381
  },
  {
    "id": "14355",
    "name": "CVS",
    "address": "10653 N. SCOTTSDALE RD., SCOTTSDALE, AZ, 85254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5831333,
    "lng": -111.9242098
  },
  {
    "id": "14354",
    "name": "CVS",
    "address": "13763 MONO WAY, SONORA, CA, 95370",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9741218,
    "lng": -120.3429201
  },
  {
    "id": "14353",
    "name": "CVS",
    "address": "865  E. GRANT, TUCSON, AZ, 85719",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.250847,
    "lng": -110.9583941
  },
  {
    "id": "14352",
    "name": "CVS",
    "address": "3500 STINE RD, BAKERSFIELD, CA, 93309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3228111,
    "lng": -119.055266
  },
  {
    "id": "14351",
    "name": "CVS",
    "address": "580 MORAGA RD, MORAGA, CA, 94556",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8565982,
    "lng": -122.125635
  },
  {
    "id": "14350",
    "name": "CVS",
    "address": "4742 E. INDIAN SCHOOL, PHOENIX, AZ, 85018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4959544,
    "lng": -111.9786115
  },
  {
    "id": "14349",
    "name": "CVS",
    "address": "5420 DEWEY DR, FAIR OAKS, CA, 95628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6644326,
    "lng": -121.3072468
  },
  {
    "id": "14348",
    "name": "CVS",
    "address": "1675 HOLLENBECK AVE, SUNNYVALE, CA, 94087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3384473,
    "lng": -122.042637
  },
  {
    "id": "14347",
    "name": "CVS",
    "address": "9225 TWIN TRAILS DRIVE, SAN DIEGO, CA, 92129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9562584,
    "lng": -117.128957
  },
  {
    "id": "14346",
    "name": "CVS",
    "address": "8831 VILLA LA JOLLA DR., LA JOLLA, CA, 92037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8692862,
    "lng": -117.2306593
  },
  {
    "id": "14345",
    "name": "CVS",
    "address": "1810 MAIN ST., RAMONA, CA, 92065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0345995,
    "lng": -116.8806356
  },
  {
    "id": "14344",
    "name": "CVS",
    "address": "14589 CAMINO DEL NORTE, SAN DIEGO, CA, 92128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9909115,
    "lng": -117.0708812
  },
  {
    "id": "14343",
    "name": "CVS",
    "address": "5019 S MCCARRAN BLVD, RENO, NV, 89502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4781506,
    "lng": -119.7837688
  },
  {
    "id": "14342",
    "name": "CVS",
    "address": "1299 E ONTARIO AVE, CORONA, CA, 92881",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.84724,
    "lng": -117.53959
  },
  {
    "id": "14341",
    "name": "CVS",
    "address": "869 NEWVILLE RD, ORLAND, CA, 95963",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7485435,
    "lng": -122.2018371
  },
  {
    "id": "14340",
    "name": "CVS",
    "address": "683 LOMAS SANTA FE DR., SOLANA BEACH, CA, 92075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9945067,
    "lng": -117.2595697
  },
  {
    "id": "14339",
    "name": "CVS",
    "address": "3964 MISSOURI FLAT RD STE A, PLACERVILLE, CA, 95667",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7123459,
    "lng": -120.843165
  },
  {
    "id": "14338",
    "name": "CVS",
    "address": "3055 W FLORIDA AVE, HEMET, CA, 92545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7456078,
    "lng": -117.0044651
  },
  {
    "id": "14337",
    "name": "CVS",
    "address": "455 ENCINITAS BLVD., ENCINITAS, CA, 92024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0463966,
    "lng": -117.2831343
  },
  {
    "id": "14336",
    "name": "CVS",
    "address": "7 W MAIN ST, WOODLAND, CA, 95695",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6760064,
    "lng": -121.7846311
  },
  {
    "id": "14335",
    "name": "CVS",
    "address": "8260 MIRA MESA BLVD., SAN DIEGO, CA, 92126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.914159,
    "lng": -117.146002
  },
  {
    "id": "14334",
    "name": "CVS",
    "address": "1395 E PROSPERITY AVE, TULARE, CA, 93274",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2254859,
    "lng": -119.3269454
  },
  {
    "id": "14333",
    "name": "CVS",
    "address": "11411 DEERFIELD DR, TRUCKEE, CA, 96161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3196779,
    "lng": -120.2093479
  },
  {
    "id": "14332",
    "name": "CVS",
    "address": "2760 FLETCHER PKY, EL CAJON, CA, 92020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8005642,
    "lng": -117.0031775
  },
  {
    "id": "14331",
    "name": "CVS",
    "address": "11 EL CAMINO REAL, SAN CARLOS, CA, 94070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5136598,
    "lng": -122.2674269
  },
  {
    "id": "14330",
    "name": "CVS",
    "address": "2900 STANDIFORD AVE, MODESTO, CA, 95350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6845532,
    "lng": -121.0497662
  },
  {
    "id": "14329",
    "name": "CVS",
    "address": "5500 GROSSMONT CENTER DR BLDG P, LA MESA, CA, 91942",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7779979,
    "lng": -117.0113848
  },
  {
    "id": "14328",
    "name": "CVS",
    "address": "1119 CALIFORNIA AVE, RENO, NV, 89509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5151762,
    "lng": -119.8280865
  },
  {
    "id": "14327",
    "name": "CVS",
    "address": "790 JAMACHA RD, EL CAJON, CA, 92019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.785805,
    "lng": -116.9286672
  },
  {
    "id": "14326",
    "name": "CVS",
    "address": "734 S. RANCHO SANTA FE RD., SAN MARCOS, CA, 92078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1326743,
    "lng": -117.2089086
  },
  {
    "id": "14325",
    "name": "CVS",
    "address": "3327 ROSECRANS ST., SAN DIEGO, CA, 92110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7471183,
    "lng": -117.2059684
  },
  {
    "id": "14324",
    "name": "CVS",
    "address": "291 N MCDOWELL BLVD, PETALUMA, CA, 94954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2511338,
    "lng": -122.6313662
  },
  {
    "id": "14323",
    "name": "CVS",
    "address": "3749 AVOCADO BLVD, LA MESA, CA, 91941",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7476323,
    "lng": -116.9601167
  },
  {
    "id": "14322",
    "name": "CVS",
    "address": "45 N MILPITAS BLVD, MILPITAS, CA, 95035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4336538,
    "lng": -121.9017932
  },
  {
    "id": "14321",
    "name": "CVS",
    "address": "102 N SAN GABRIEL BLVD, SAN GABRIEL, CA, 91775",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1037188,
    "lng": -118.0904124
  },
  {
    "id": "14320",
    "name": "CVS",
    "address": "1109 COUNTRY CLUB DR, MADERA, CA, 93638",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9754229,
    "lng": -120.0725717
  },
  {
    "id": "14319",
    "name": "CVS",
    "address": "850 OROVILLE DAM BLVD., OROVILLE, CA, 95965",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5001371,
    "lng": -121.565889
  },
  {
    "id": "14318",
    "name": "CVS",
    "address": "23791 WASHINGTON AVE, MURRIETA, CA, 92562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5708899,
    "lng": -117.2350009
  },
  {
    "id": "14317",
    "name": "CVS",
    "address": "5875 CALLE REAL, GOLETA, CA, 93117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4405281,
    "lng": -119.8271822
  },
  {
    "id": "14316",
    "name": "CVS",
    "address": "1005 SUTTON WAY, GRASS VALLEY, CA, 95945",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2365404,
    "lng": -121.0328972
  },
  {
    "id": "14315",
    "name": "CVS",
    "address": "10350 FRIARS RD, SAN DIEGO, CA, 92120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7922779,
    "lng": -117.0999095
  },
  {
    "id": "14314",
    "name": "CVS",
    "address": "42520 BOB HOPE DR., RANCHO MIRAGE, CA, 92270",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7372575,
    "lng": -116.4084154
  },
  {
    "id": "14313",
    "name": "CVS",
    "address": "201 W NAPA ST STE 35, SONOMA, CA, 95476",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2899739,
    "lng": -122.4622572
  },
  {
    "id": "14312",
    "name": "CVS",
    "address": "388 ELM ST., AUBURN, CA, 95603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9047332,
    "lng": -121.0740867
  },
  {
    "id": "14311",
    "name": "CVS",
    "address": "6750 N CEDAR AVE, FRESNO, CA, 93710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8365456,
    "lng": -119.7522856
  },
  {
    "id": "14310",
    "name": "CVS",
    "address": "313 WASHINGTON ST., SAN DIEGO, CA, 92103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7496245,
    "lng": -117.1624118
  },
  {
    "id": "14309",
    "name": "CVS",
    "address": "2605 WEST MARCH LANE, STOCKTON, CA, 95207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9852713,
    "lng": -121.340671
  },
  {
    "id": "14308",
    "name": "CVS",
    "address": "575 S. CITRUS AVE., COVINA, CA, 91723",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0795214,
    "lng": -117.890937
  },
  {
    "id": "14307",
    "name": "CVS",
    "address": "9730 MISSION GORGE RD., SANTEE, CA, 92071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8397346,
    "lng": -116.9849663
  },
  {
    "id": "14306",
    "name": "CVS",
    "address": "5800 SANTA ROSA RD, CAMARILLO, CA, 93012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2252745,
    "lng": -118.9885051
  },
  {
    "id": "14305",
    "name": "CVS",
    "address": "1550 E COVELL BLVD, DAVIS, CA, 95616",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5609727,
    "lng": -121.7319248
  },
  {
    "id": "14304",
    "name": "CVS",
    "address": "3151 UNIVERSITY AVE., SAN DIEGO, CA, 92104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7481984,
    "lng": -117.1258319
  },
  {
    "id": "14303",
    "name": "CVS",
    "address": "7393 JACKSON DR., SAN DIEGO, CA, 92119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8031648,
    "lng": -117.044009
  },
  {
    "id": "14302",
    "name": "CVS",
    "address": "129 N EL CAMINO REAL, ENCINITAS, CA, 92024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0483361,
    "lng": -117.2583342
  },
  {
    "id": "14301",
    "name": "CVS",
    "address": "49980 JEFFERSON ST, INDIO, CA, 92201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6857152,
    "lng": -116.2670963
  },
  {
    "id": "14300",
    "name": "CVS",
    "address": "9285 ELK GROVE BLVD, ELK GROVE, CA, 95624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4095456,
    "lng": -121.3540306
  },
  {
    "id": "14299",
    "name": "CVS",
    "address": "10560-4S COMMONS DR., SAN DIEGO, CA, 92127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0190019,
    "lng": -117.1107568
  },
  {
    "id": "14298",
    "name": "CVS",
    "address": "1302 FULTON MALL, FRESNO, CA, 93721",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7373611,
    "lng": -119.7934101
  },
  {
    "id": "14297",
    "name": "CVS",
    "address": "800 PALM AVE., IMPERIAL BEACH, CA, 91932",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5843669,
    "lng": -117.1157207
  },
  {
    "id": "14296",
    "name": "CVS",
    "address": "4040 E. CHAPMAN AVE., ORANGE, CA, 92869",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7872745,
    "lng": -117.8104895
  },
  {
    "id": "14295",
    "name": "CVS",
    "address": "1299 BROADWAY, EL CAJON, CA, 92021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8073393,
    "lng": -116.9365794
  },
  {
    "id": "14294",
    "name": "CVS",
    "address": "645 E. PALOMAR ST., CHULA VISTA, CA, 91911",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6158569,
    "lng": -117.0258013
  },
  {
    "id": "14293",
    "name": "CVS",
    "address": "7100 BROADWAY, LEMON GROVE, CA, 91945",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.743873,
    "lng": -117.0447446
  },
  {
    "id": "14292",
    "name": "CVS",
    "address": "16773 BERNARDO CENTER DR, RANCHO BERNARDO, CA, 92128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0180851,
    "lng": -117.0733862
  },
  {
    "id": "14291",
    "name": "CVS",
    "address": "1101 S. MISSION RD., FALLBROOK, CA, 92028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.372772,
    "lng": -117.2546598
  },
  {
    "id": "14290",
    "name": "CVS",
    "address": "6265 EL CAJON BLVD, SAN DIEGO, CA, 92115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7631039,
    "lng": -117.0637322
  },
  {
    "id": "14289",
    "name": "CVS",
    "address": "12358 POWAY ROAD, POWAY, CA, 92064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9529639,
    "lng": -117.0635023
  },
  {
    "id": "14288",
    "name": "CVS",
    "address": "318 W EL NORTE PARKWAY, ESCONDIDO, CA, 92026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1422107,
    "lng": -117.0941131
  },
  {
    "id": "14287",
    "name": "CVS",
    "address": "10575 SCRIPPS POWAY PRKY, SAN DIEGO, CA, 92131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9356479,
    "lng": -117.1000703
  },
  {
    "id": "14286",
    "name": "CVS",
    "address": "155 PACIFIC COAST HIGHWAY, HERMOSA BEACH, CA, 90254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8559994,
    "lng": -118.3910246
  },
  {
    "id": "14285",
    "name": "CVS",
    "address": "4020 FREMONT HUB, FREMONT, CA, 94538",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5470532,
    "lng": -121.988099
  },
  {
    "id": "14284",
    "name": "CVS",
    "address": "670 EL CERRITO PLZ, EL CERRITO, CA, 94530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8993588,
    "lng": -122.3003642
  },
  {
    "id": "14283",
    "name": "CVS",
    "address": "2105 CLEARY AVE., METAIRIE, LA, 70001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9937872,
    "lng": -90.1709096
  },
  {
    "id": "14282",
    "name": "CVS",
    "address": "365 COLE RD., HATTIESBURG, MS, 39402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3164194,
    "lng": -89.4445947
  },
  {
    "id": "14281",
    "name": "CVS",
    "address": "12980 BANDERA RD, HELOTES, TX, 78023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5642728,
    "lng": -98.6858894
  },
  {
    "id": "14280",
    "name": "CVS",
    "address": "7041 S. YALE AVE., TULSA, OK, 74136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0614419,
    "lng": -95.9215389
  },
  {
    "id": "14279",
    "name": "CVS",
    "address": "6701 RIDGE AVE., PHILADELPHIA, PA, 19128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0410645,
    "lng": -75.2237488
  },
  {
    "id": "14278",
    "name": "CVS",
    "address": "5125 W. OLIVE AVE, GLENDALE, AZ, 85302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.566592,
    "lng": -112.1697545
  },
  {
    "id": "14277",
    "name": "CVS",
    "address": "6510 NORTH SHERIDAN RD., CHICAGO, IL, 60626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0006873,
    "lng": -87.6611185
  },
  {
    "id": "14276",
    "name": "CVS",
    "address": "550 NORTH PROGRESS AVE., HARRISBURG, PA, 17109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2984826,
    "lng": -76.8467352
  },
  {
    "id": "14275",
    "name": "CVS",
    "address": "20203 STONE OAK PKWY., SAN ANTONIO, TX, 78258",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6438569,
    "lng": -98.4805478
  },
  {
    "id": "14274",
    "name": "CVS",
    "address": "3501 STOCKTON HILL RD., KINGMAN, AZ, 86409",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2253628,
    "lng": -114.0371398
  },
  {
    "id": "14273",
    "name": "CVS",
    "address": "965 JOE FRANK HARRIS PKWY SE, CARTERSVILLE, GA, 30120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1987598,
    "lng": -84.7947798
  },
  {
    "id": "14272",
    "name": "CVS",
    "address": "8310 EASTON RD, OTTSVILLE, PA, 18942",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4919242,
    "lng": -75.1754231
  },
  {
    "id": "14271",
    "name": "CVS",
    "address": "15250 WASHINGTON ST., HAYMARKET, VA, 20169",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8158058,
    "lng": -77.6418892
  },
  {
    "id": "14270",
    "name": "CVS",
    "address": "5044 AMBASSADOR CAFFERY PKWY., LAFAYETTE, LA, 70508",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1455083,
    "lng": -92.0335184
  },
  {
    "id": "14269",
    "name": "CVS",
    "address": "1326 W. PINHOOK RD., LAFAYETTE, LA, 70503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2000444,
    "lng": -92.0166826
  },
  {
    "id": "14268",
    "name": "CVS",
    "address": "HWY 18 & STONEBRIDGE (SWC), BRANDON, MS",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2437944,
    "lng": -89.9677608
  },
  {
    "id": "14267",
    "name": "CVS",
    "address": "24865 N. LAKE PLEASANT PARKWAY, PEORIA, AZ, 85383",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7096638,
    "lng": -112.2715135
  },
  {
    "id": "14266",
    "name": "CVS",
    "address": "1101 NW WOODS CHAPEL RD., BLUE SPRINGS, MO, 64015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0300093,
    "lng": -94.3053949
  },
  {
    "id": "14265",
    "name": "CVS",
    "address": "4186 IL ROUTE 83 BLDG D, LONG GROVE, IL, 60047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1803265,
    "lng": -87.9888068
  },
  {
    "id": "14264",
    "name": "CVS",
    "address": "416 WASHINGTON AVE., KINGSTON, NY, 12401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9361433,
    "lng": -74.0245992
  },
  {
    "id": "14263",
    "name": "CVS",
    "address": "102 S. SANDERSON AVE., SAN JACINTO, CA, 92582",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7867415,
    "lng": -117.0075648
  },
  {
    "id": "14262",
    "name": "CVS",
    "address": "880 WASHINGTON AVE. SE, MINNEAPOLIS, MN, 55414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9734211,
    "lng": -93.2258775
  },
  {
    "id": "14261",
    "name": "CVS",
    "address": "1688 WESTCHESTER AVE., BRONX, NY, 10472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8301912,
    "lng": -73.8710802
  },
  {
    "id": "14260",
    "name": "CVS",
    "address": "596 RIVER AVE, LAKEWOOD, NJ, 8701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0744971,
    "lng": -74.2180243
  },
  {
    "id": "14259",
    "name": "CVS",
    "address": "101 FOUNDERS BAY RD., MURRELLS INLET, SC, 29576",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5863296,
    "lng": -79.052544
  },
  {
    "id": "14258",
    "name": "CVS",
    "address": "8831 IMMOKALEE RD., NAPLES, FL, 34120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2744506,
    "lng": -81.688351
  },
  {
    "id": "14257",
    "name": "CVS",
    "address": "65 RIVER RD., EDGEWATER, NJ, 7020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8043594,
    "lng": -73.9922313
  },
  {
    "id": "14256",
    "name": "CVS",
    "address": "1850 N. HIGHWAY 190, COVINGTON, LA, 70433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4581508,
    "lng": -90.081174
  },
  {
    "id": "14255",
    "name": "CVS",
    "address": "4300 RAINBOW BLVD., KANSAS CITY, KS, 66103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0499894,
    "lng": -94.6125154
  },
  {
    "id": "14254",
    "name": "CVS",
    "address": "50 W. JEFFERSON ST., SUITE 140, PHOENIX, AZ, 85003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4474646,
    "lng": -112.0745381
  },
  {
    "id": "14253",
    "name": "CVS",
    "address": "395 JACKSON ST., NEWNAN, GA, 30263",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3982545,
    "lng": -84.7962474
  },
  {
    "id": "14252",
    "name": "CVS",
    "address": "575 BROADWAY, MALDEN, MA, 2148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4404057,
    "lng": -71.0313601
  },
  {
    "id": "14251",
    "name": "CVS",
    "address": "14575 MUNDY DRIVE, NOBLESVILLE, IN, 46060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0001249,
    "lng": -86.0031539
  },
  {
    "id": "14250",
    "name": "CVS",
    "address": "18290 COLLINS AVE., SUNNY ISLES BEACH, FL, 33160",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9454999,
    "lng": -80.1215289
  },
  {
    "id": "14249",
    "name": "CVS",
    "address": "4893 TOWN CENTER PARKWAY, JACKSONVILLE, FL, 32246",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2541482,
    "lng": -81.5353868
  },
  {
    "id": "14248",
    "name": "CVS",
    "address": "33205 TEMECULA PARKWAY, TEMECULA, CA, 92592",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4854676,
    "lng": -117.0787647
  },
  {
    "id": "14247",
    "name": "CVS",
    "address": "775 E. FOOTHILL BOULEVARD, POMONA, CA, 91767",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1086443,
    "lng": -117.7377172
  },
  {
    "id": "14246",
    "name": "CVS",
    "address": "101 REDLANDS MALL, REDLANDS, CA, 92373",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0564174,
    "lng": -117.184467
  },
  {
    "id": "14245",
    "name": "CVS",
    "address": "602 N. EL CAMINO REAL, SAN CLEMENTE, CA, 92672",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4299226,
    "lng": -117.617905
  },
  {
    "id": "14244",
    "name": "CVS",
    "address": "26851 TRABUCO RD, MISSION VIEJO, CA, 92691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6220172,
    "lng": -117.6587937
  },
  {
    "id": "14243",
    "name": "CVS",
    "address": "17642 EAST 17TH ST., TUSTIN, CA, 92780",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7587684,
    "lng": -117.8239076
  },
  {
    "id": "14242",
    "name": "CVS",
    "address": "8601 SOUTH SEPULVEDA BOULEVARD, LOS ANGELES, CA, 90045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9595141,
    "lng": -118.3966845
  },
  {
    "id": "14241",
    "name": "CVS",
    "address": "15520 GOLDENWEST ST., HUNTINGTON BEACH, CA, 92647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7368329,
    "lng": -118.0062574
  },
  {
    "id": "14240",
    "name": "CVS",
    "address": "24372 ROCKFIELD BLVD, LAKE FOREST, CA, 92630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6151775,
    "lng": -117.7044471
  },
  {
    "id": "14239",
    "name": "CVS",
    "address": "3911 SOUTH BRISTOL STREET, SANTA ANA, CA, 92704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6955958,
    "lng": -117.884162
  },
  {
    "id": "14238",
    "name": "CVS",
    "address": "638 CAMINO DE LOS MARES, SAN CLEMENTE, CA, 92673",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4592597,
    "lng": -117.6526509
  },
  {
    "id": "14237",
    "name": "CVS",
    "address": "1020 IRVINE AVENUE, NEWPORT BEACH, CA, 92660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6278493,
    "lng": -117.9069456
  },
  {
    "id": "14236",
    "name": "CVS",
    "address": "29995 ALICIA PKWY, LAGUNA NIGUEL, CA, 92677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.527351,
    "lng": -117.717819
  },
  {
    "id": "14235",
    "name": "CVS",
    "address": "8985 VENICE BOULEVARD, LOS ANGELES, CA, 90034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0271101,
    "lng": -118.3928048
  },
  {
    "id": "14234",
    "name": "CVS",
    "address": "5505 CARSON ST., LAKEWOOD, CA, 90713",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8328271,
    "lng": -118.1247795
  },
  {
    "id": "14233",
    "name": "CVS",
    "address": "671 EAST 1ST STREET, TUSTIN, CA, 92780",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7464436,
    "lng": -117.8154988
  },
  {
    "id": "14232",
    "name": "CVS",
    "address": "233 EAST WILLOW STREET, LONG BEACH, CA, 90806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.804725,
    "lng": -118.1909796
  },
  {
    "id": "14231",
    "name": "CVS",
    "address": "1676 WEST KATELLA AVENUE, ANAHEIM, CA, 92802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8028182,
    "lng": -117.9405522
  },
  {
    "id": "14230",
    "name": "CVS",
    "address": "26891 ALISO CREEK RD, ALISO VIEJO, CA, 92656",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5721451,
    "lng": -117.7255166
  },
  {
    "id": "14229",
    "name": "CVS",
    "address": "13171 MINDANAO WAY, MARINA DEL REY, CA, 90292",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9844756,
    "lng": -118.4388542
  },
  {
    "id": "14228",
    "name": "CVS",
    "address": "6775 QUAIL HILL PARKWAY, IRVINE, CA, 92603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6545097,
    "lng": -117.7781541
  },
  {
    "id": "14227",
    "name": "CVS",
    "address": "5020 WEST 190TH STREET, TORRANCE, CA, 90503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8575852,
    "lng": -118.3643046
  },
  {
    "id": "14226",
    "name": "CVS",
    "address": "7915 FLORENCE AVENUE, DOWNEY, CA, 90240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9551132,
    "lng": -118.1306462
  },
  {
    "id": "14225",
    "name": "CVS",
    "address": "1706 OCEANSIDE BLVD, OCEANSIDE, CA, 92054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1926697,
    "lng": -117.3600868
  },
  {
    "id": "14224",
    "name": "CVS",
    "address": "11011 ALONDRA BOULEVARD, NORWALK, CA, 90650",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8880957,
    "lng": -118.0993989
  },
  {
    "id": "14223",
    "name": "CVS",
    "address": "3575 ATLANTIC AVENUE, LONG BEACH, CA, 90807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8216827,
    "lng": -118.186044
  },
  {
    "id": "14222",
    "name": "CVS",
    "address": "28221 CROWN VALLEY PKY, LAGUNA NIGUEL, CA, 92677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.553352,
    "lng": -117.6872547
  },
  {
    "id": "14221",
    "name": "CVS",
    "address": "12031 BROOKHURST STREET, GARDEN GROVE, CA, 92840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7879277,
    "lng": -117.9599551
  },
  {
    "id": "14220",
    "name": "CVS",
    "address": "1441 N SANTA FE, VISTA, CA, 92084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2198426,
    "lng": -117.2433149
  },
  {
    "id": "14219",
    "name": "CVS",
    "address": "1545 WEST 17TH STREET, SANTA ANA, CA, 92706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.761226,
    "lng": -117.8896553
  },
  {
    "id": "14218",
    "name": "CVS",
    "address": "30736 BENTON RD., WINCHESTER, CA, 92596",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5915041,
    "lng": -117.1223849
  },
  {
    "id": "14217",
    "name": "CVS",
    "address": "3010 SOUTH SEPULVEDA BOULEVARD, LOS ANGELES, CA, 90034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0270132,
    "lng": -118.427309
  },
  {
    "id": "14216",
    "name": "CVS",
    "address": "21572 PLANO TRABUCO RD., TRABUCO CANYON, CA, 92679",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6479576,
    "lng": -117.5763655
  },
  {
    "id": "14215",
    "name": "CVS",
    "address": "6510 SOUTH ST., LAKEWOOD, CA, 90713",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8579467,
    "lng": -118.1063242
  },
  {
    "id": "14214",
    "name": "CVS",
    "address": "426 EAST CHASE AVENUE, EL CAJON, CA, 92020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7812522,
    "lng": -116.9568186
  },
  {
    "id": "14213",
    "name": "CVS",
    "address": "150 WEST CARSON STREET, CARSON, CA, 90745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8309718,
    "lng": -118.2795216
  },
  {
    "id": "14212",
    "name": "CVS",
    "address": "2130 N. BELLFLOWER BLVD., LONG BEACH, CA, 90815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7957701,
    "lng": -118.1246118
  },
  {
    "id": "14211",
    "name": "CVS",
    "address": "222 N. MARKET ST., INGLEWOOD, CA, 90301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.964899,
    "lng": -118.3508518
  },
  {
    "id": "14210",
    "name": "CVS",
    "address": "1631 S MELROSE DR, VISTA, CA, 92081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1647242,
    "lng": -117.247059
  },
  {
    "id": "14209",
    "name": "CVS",
    "address": "3710 TWEEDY BOULEVARD, SOUTH GATE, CA, 90280",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.943229,
    "lng": -118.2050805
  },
  {
    "id": "14208",
    "name": "CVS",
    "address": "26686 PORTOLA PKWY, FOOTHILL RANCH, CA, 92610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6800543,
    "lng": -117.6668145
  },
  {
    "id": "14207",
    "name": "CVS",
    "address": "3332 SANDROCK ROAD, SAN DIEGO, CA, 92123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8031696,
    "lng": -117.1399867
  },
  {
    "id": "14206",
    "name": "CVS",
    "address": "2701 HARBOR BLVD., BLDG B, COSTA MESA, CA, 92626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6719287,
    "lng": -117.9216964
  },
  {
    "id": "14205",
    "name": "CVS",
    "address": "2090 EAST FRY BLVD., SIERRA VISTA, AZ, 85635",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5529638,
    "lng": -110.276799
  },
  {
    "id": "14204",
    "name": "CVS",
    "address": "6100 SPRING MOUNTAIN ROAD, LAS VEGAS, NV, 89146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1257247,
    "lng": -115.2253189
  },
  {
    "id": "14203",
    "name": "CVS",
    "address": "2350 MIRACLE MILE, BULLHEAD CITY, AZ, 86442",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.101422,
    "lng": -114.5946541
  },
  {
    "id": "14202",
    "name": "CVS",
    "address": "12071 MT. VERNON AVE,, GRAND TERRACE, CA, 92313",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0343687,
    "lng": -117.3126607
  },
  {
    "id": "14201",
    "name": "CVS",
    "address": "2594 WIGWAM PKWY, HENDERSON, NV, 89074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0347634,
    "lng": -115.0997436
  },
  {
    "id": "14200",
    "name": "CVS",
    "address": "8320 W CHEYENNE AVE, LAS VEGAS, NV, 89129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2199869,
    "lng": -115.2747756
  },
  {
    "id": "14199",
    "name": "CVS",
    "address": "123 N. REINO ROAD, NEWBURY PARK, CA, 91320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1800288,
    "lng": -118.9538655
  },
  {
    "id": "14198",
    "name": "CVS",
    "address": "4800 W. CHARLESTON BLVD, LAS VEGAS, NV, 89146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1597007,
    "lng": -115.2064232
  },
  {
    "id": "14197",
    "name": "CVS",
    "address": "997 WOODLAND PKWY., SAN MARCOS, CA, 92069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1563301,
    "lng": -117.1288192
  },
  {
    "id": "14196",
    "name": "CVS",
    "address": "11950 DE PALMA RD., CORONA, CA, 92883",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7466597,
    "lng": -117.4513755
  },
  {
    "id": "14195",
    "name": "CVS",
    "address": "2525 S BUFFALO DR, LAS VEGAS, NV, 89117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1430155,
    "lng": -115.261625
  },
  {
    "id": "14194",
    "name": "CVS",
    "address": "1017 NEVADA WAY,, BOULDER CITY, NV, 89005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9738713,
    "lng": -114.8451572
  },
  {
    "id": "14193",
    "name": "CVS",
    "address": "2100 WEST CHARLESTON BLVD., LAS VEGAS, NV, 89102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1593438,
    "lng": -115.1706493
  },
  {
    "id": "14192",
    "name": "CVS",
    "address": "5681 BOULDER HIGHWAY, LAS VEGAS, NV, 89122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1008328,
    "lng": -115.0496573
  },
  {
    "id": "14191",
    "name": "CVS",
    "address": "1250 WEST 7TH ST, RENO, NV, 89503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.530187,
    "lng": -119.8324436
  },
  {
    "id": "14190",
    "name": "CVS",
    "address": "3810 E. SUNSET RD, LAS VEGAS, NV, 89120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0718401,
    "lng": -115.0911725
  },
  {
    "id": "14189",
    "name": "CVS",
    "address": "131 W. RIVERSIDE DR., PARKER, AZ, 85344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1543651,
    "lng": -114.2764768
  },
  {
    "id": "14188",
    "name": "CVS",
    "address": "550 W. IDAHO ST, ELKO, NV, 89801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8280147,
    "lng": -115.7738835
  },
  {
    "id": "14187",
    "name": "CVS",
    "address": "6705 E. LAKE MEAD BLVD, LAS VEGAS, NV, 89156",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1952105,
    "lng": -115.025412
  },
  {
    "id": "14186",
    "name": "CVS",
    "address": "1600 N. BUFFALO DRIVE, LAS VEGAS, NV, 89128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1892982,
    "lng": -115.2586614
  },
  {
    "id": "14185",
    "name": "CVS",
    "address": "680 N. MCCARRAN BLVD., SPARKS, NV, 89431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.540738,
    "lng": -119.7318358
  },
  {
    "id": "14184",
    "name": "CVS",
    "address": "3550 W. SAHARA AVE, LAS VEGAS, NV, 89102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1459524,
    "lng": -115.1890086
  },
  {
    "id": "14183",
    "name": "CVS",
    "address": "1551 W. SUNSET BLVD, HENDERSON, NV, 89014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0625483,
    "lng": -115.052103
  },
  {
    "id": "14182",
    "name": "CVS",
    "address": "7007 WEST ANN ROAD, LAS VEGAS, NV, 89130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2623592,
    "lng": -115.2473624
  },
  {
    "id": "14181",
    "name": "CVS",
    "address": "10400 WEST CHARLESTON BLVD, LAS VEGAS, NV, 89135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1601774,
    "lng": -115.3223726
  },
  {
    "id": "14180",
    "name": "CVS",
    "address": "220 FAIRVIEW LANE, CARSON CITY, NV, 89701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.150391,
    "lng": -119.7663996
  },
  {
    "id": "14179",
    "name": "CVS",
    "address": "3726 NORTH 22ND, KENOSHA, WI, 53140",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6023317,
    "lng": -87.8364793
  },
  {
    "id": "14178",
    "name": "CVS",
    "address": "W63-N152 WASHINGTON AVE, CEDARBURG, WI, 53012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2809863,
    "lng": -87.9868141
  },
  {
    "id": "14177",
    "name": "CVS",
    "address": "2207 80TH STREET, KENOSHA, WI, 53143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5571657,
    "lng": -87.8357116
  },
  {
    "id": "14176",
    "name": "CVS",
    "address": "5740 S PACKARD AVE, CUDAHY, WI, 53110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9400719,
    "lng": -87.8591964
  },
  {
    "id": "14175",
    "name": "CVS",
    "address": "7520 W BLUE MOUND RD, WAUWATOSA, WI, 53213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0353427,
    "lng": -88.0065132
  },
  {
    "id": "14174",
    "name": "CVS",
    "address": "2607 N. DOWNER AVE., MILWAUKEE, WI, 53211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0662953,
    "lng": -87.8785439
  },
  {
    "id": "14173",
    "name": "CVS",
    "address": "9220 W GREENFIELD, WEST ALLIS, WI, 53214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0172063,
    "lng": -88.0276894
  },
  {
    "id": "14172",
    "name": "CVS",
    "address": "2135 SILVERNAIL RD, PEWAUKEE, WI, 53072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.042976,
    "lng": -88.2610989
  },
  {
    "id": "14171",
    "name": "CVS",
    "address": "1650 FARWELL, MILWAUKEE, WI, 53202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0524219,
    "lng": -87.8923284
  },
  {
    "id": "14170",
    "name": "CVS",
    "address": "10 SOUTH LEWIS AVE., WAUKEGAN, IL, 60085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3591908,
    "lng": -87.8564334
  },
  {
    "id": "14169",
    "name": "CVS",
    "address": "3333 CENTRAL STREET, EVANSTON, IL, 60201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0652518,
    "lng": -87.7268814
  },
  {
    "id": "14168",
    "name": "CVS",
    "address": "4001 MAIN ST., SKOKIE, IL, 60076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0332835,
    "lng": -87.7282689
  },
  {
    "id": "14167",
    "name": "CVS",
    "address": "6200 W HIGGINS, CHICAGO, IL, 60630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9753314,
    "lng": -87.783262
  },
  {
    "id": "14166",
    "name": "CVS",
    "address": "5945 W DEMPSTER ST, MORTON GROVE, IL, 60053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0405882,
    "lng": -87.7759874
  },
  {
    "id": "14165",
    "name": "CVS",
    "address": "4051 N LINCOLN, CHICAGO, IL, 60618",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9555525,
    "lng": -87.6793122
  },
  {
    "id": "14164",
    "name": "CVS",
    "address": "300 NORTH EOLA RD, AURORA, IL, 60502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7579281,
    "lng": -88.2440647
  },
  {
    "id": "14163",
    "name": "CVS",
    "address": "771 N OGDEN AVE., CHICAGO, IL, 60642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8959987,
    "lng": -87.6540281
  },
  {
    "id": "14162",
    "name": "CVS",
    "address": "5524 W CERMAK RD, CICERO, IL, 60804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8513901,
    "lng": -87.7625061
  },
  {
    "id": "14161",
    "name": "CVS",
    "address": "2634 S PULASKI, CHICAGO, IL, 60623",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8434348,
    "lng": -87.7248765
  },
  {
    "id": "14160",
    "name": "CVS",
    "address": "2427 W CHICAGO AVE, CHICAGO, IL, 60622",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.895437,
    "lng": -87.6876198
  },
  {
    "id": "14159",
    "name": "CVS",
    "address": "1819 N. HARLEM AVENUE, CHICAGO, IL, 60707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9132444,
    "lng": -87.8054561
  },
  {
    "id": "14158",
    "name": "CVS",
    "address": "741 W 31ST, CHICAGO, IL, 60616",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8376549,
    "lng": -87.6453953
  },
  {
    "id": "14157",
    "name": "CVS",
    "address": "3940 WEST FULLERTON, CHICAGO, IL, 60647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9247308,
    "lng": -87.7259667
  },
  {
    "id": "14156",
    "name": "CVS",
    "address": "400 W MADISON ST, CHICAGO, IL, 60606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8820553,
    "lng": -87.6393834
  },
  {
    "id": "14155",
    "name": "CVS",
    "address": "3101 N. CLARK, CHICAGO, IL, 60657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.938192,
    "lng": -87.648633
  },
  {
    "id": "14154",
    "name": "CVS",
    "address": "1400  W LAKE STREET, ADDISON, IL, 60101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9472417,
    "lng": -88.022933
  },
  {
    "id": "14153",
    "name": "CVS",
    "address": "920 N. GRAND AVE., EAST, SPRINGFIELD, IL, 62702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8156367,
    "lng": -89.6424482
  },
  {
    "id": "14152",
    "name": "CVS",
    "address": "5920 MADISON AVENUE, INDIANAPOLIS, IN, 46227",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6805309,
    "lng": -86.1329409
  },
  {
    "id": "14151",
    "name": "CVS",
    "address": "243 S. MATTIS, CHAMPAIGN, IL, 61821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1144333,
    "lng": -88.2790461
  },
  {
    "id": "14150",
    "name": "CVS",
    "address": "5208 W. WASHINGTON STREET, INDIANAPOLIS, IN, 46241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7538231,
    "lng": -86.2486352
  },
  {
    "id": "14149",
    "name": "CVS",
    "address": "6509 N. KEYSTONE AVE., INDIANAPOLIS, IN, 46220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8768599,
    "lng": -86.1213299
  },
  {
    "id": "14148",
    "name": "CVS",
    "address": "107 W GREEN ST, CHAMPAIGN, IL, 61820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.109522,
    "lng": -88.2442549
  },
  {
    "id": "14147",
    "name": "CVS",
    "address": "2806 U.S. 231 SOUTH, LAFAYETTE, IN, 47905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.386345,
    "lng": -86.917732
  },
  {
    "id": "14146",
    "name": "CVS",
    "address": "2021 FORT HARRISON ROAD, TERRE HAUTE, IN, 47804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5060587,
    "lng": -87.385957
  },
  {
    "id": "14145",
    "name": "CVS",
    "address": "119 W. 56TH STREET, INDIANAPOLIS, IN, 46208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.853637,
    "lng": -86.1601931
  },
  {
    "id": "14144",
    "name": "CVS",
    "address": "11627 FOX ROAD, INDIANAPOLIS, IN, 46236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9007193,
    "lng": -85.9599111
  },
  {
    "id": "14143",
    "name": "CVS",
    "address": "510 COLLEGE MALL, BLOOMINGTON, IN, 47401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1619078,
    "lng": -86.498865
  },
  {
    "id": "14142",
    "name": "CVS",
    "address": "7240 EAST 82ND ST., INDIANAPOLIS, IN, 46256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9059375,
    "lng": -86.0401804
  },
  {
    "id": "14141",
    "name": "CVS",
    "address": "1818 SOUTH PHILO RD, URBANA, IL, 61802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0950952,
    "lng": -88.1897238
  },
  {
    "id": "14140",
    "name": "CVS",
    "address": "3910 WEST 3RD ST., BLOOMINGTON, IN, 47404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1649539,
    "lng": -86.5825758
  },
  {
    "id": "14139",
    "name": "CVS",
    "address": "2301 N. LOCUST ST., STERLING, IL, 61081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8092199,
    "lng": -89.7008621
  },
  {
    "id": "14138",
    "name": "CVS",
    "address": "1655 WEST KIMBERLY ROAD, DAVENPORT, IA, 52806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.559293,
    "lng": -90.599918
  },
  {
    "id": "14137",
    "name": "CVS",
    "address": "1725 SALEM ST., LAFAYETTE, IN, 47904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4251369,
    "lng": -86.8780918
  },
  {
    "id": "14136",
    "name": "CVS",
    "address": "2617 18TH AVE, ROCK ISLAND, IL, 61201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4939313,
    "lng": -90.562759
  },
  {
    "id": "14135",
    "name": "CVS",
    "address": "1004 SHOOTING PARK RD., PERU, IL, 61354",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3379375,
    "lng": -89.1193024
  },
  {
    "id": "14134",
    "name": "CVS",
    "address": "327 EAST JACKSON ST., MACOMB, IL, 61455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4584267,
    "lng": -90.6675471
  },
  {
    "id": "14133",
    "name": "CVS",
    "address": "50 SAGAMORE PKWY S, LAFAYETTE, IN, 47905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.416658,
    "lng": -86.8586553
  },
  {
    "id": "14132",
    "name": "CVS",
    "address": "512 SAGAMORE PKWY WEST, WEST LAFAYETTE, IN, 47906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4539453,
    "lng": -86.9145827
  },
  {
    "id": "14131",
    "name": "CVS",
    "address": "2440 WABASH AVE, TERRE HAUTE, IN, 47807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4711753,
    "lng": -87.3797547
  },
  {
    "id": "14130",
    "name": "CVS",
    "address": "8295 E. 116 ST, FISHERS, IN, 46038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9563516,
    "lng": -86.0205506
  },
  {
    "id": "14129",
    "name": "CVS",
    "address": "2990 N. MONROE STREET, DECATUR, IL, 62526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8759603,
    "lng": -88.9636774
  },
  {
    "id": "14128",
    "name": "CVS",
    "address": "51467 STATE ROAD 933, SOUTH BEND, IN, 46637",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7454621,
    "lng": -86.2516507
  },
  {
    "id": "14127",
    "name": "CVS",
    "address": "4501 LINCOLNWAY EAST, MISHAWAKA, IN, 46544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6625792,
    "lng": -86.1100464
  },
  {
    "id": "14126",
    "name": "CVS",
    "address": "2051 SOUTH BEND AVENUE, SOUTH BEND, IN, 46637",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.700722,
    "lng": -86.2187877
  },
  {
    "id": "14125",
    "name": "CVS",
    "address": "1616 EAST 86TH STREET, INDIANAPOLIS, IN, 46240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9129987,
    "lng": -86.1322014
  },
  {
    "id": "14124",
    "name": "CVS",
    "address": "670 MARGARET AVE, TERRE HAUTE, IN, 47802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4341235,
    "lng": -87.4076583
  },
  {
    "id": "14123",
    "name": "CVS",
    "address": "501 W. LINCOLN, CHARLESTON, IL, 61920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4850563,
    "lng": -88.1871344
  },
  {
    "id": "14122",
    "name": "CVS",
    "address": "3350 NORTH HIGH SCHOOL, INDIANAPOLIS, IN, 46224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.815765,
    "lng": -86.2708932
  },
  {
    "id": "14121",
    "name": "CVS",
    "address": "436 NORTH 30TH STREET, QUINCY, IL, 62301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9367791,
    "lng": -91.3672712
  },
  {
    "id": "14120",
    "name": "CVS",
    "address": "3100 S. MAC ARTHUR BLVD., SPRINGFIELD, IL, 62704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7645389,
    "lng": -89.6674409
  },
  {
    "id": "14119",
    "name": "CVS",
    "address": "910 W. 4TH ST., MILAN, IL, 61264",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4431319,
    "lng": -90.5733116
  },
  {
    "id": "14118",
    "name": "CVS",
    "address": "2002 SPRUCE HILLS DRIVE, BETTENDORF, IA, 52722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5507588,
    "lng": -90.5033262
  },
  {
    "id": "14117",
    "name": "CVS",
    "address": "1595 E CANTRELL ST, DECATUR, IL, 62521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8329574,
    "lng": -88.9361486
  },
  {
    "id": "14116",
    "name": "CVS",
    "address": "4403 W. WESTERN AVE., SOUTH BEND, IN, 46619",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6731266,
    "lng": -86.3088719
  },
  {
    "id": "14115",
    "name": "CVS",
    "address": "525 SOUTH 3RD ST., BISMARCK, ND, 58504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8005976,
    "lng": -100.7871719
  },
  {
    "id": "14114",
    "name": "CVS",
    "address": "1275 HARRISON ST., BUTTE, MT, 59701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.0009035,
    "lng": -112.5224167
  },
  {
    "id": "14113",
    "name": "CVS",
    "address": "7002 O STREET, LINCOLN, NE, 68510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8138179,
    "lng": -96.6241078
  },
  {
    "id": "14112",
    "name": "CVS",
    "address": "2001 10TH AVENUE SOUTH, GREAT FALLS, MT, 59405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.494803,
    "lng": -111.2722894
  },
  {
    "id": "14111",
    "name": "CVS",
    "address": "2402 GRAND AVE., BILLINGS, MT, 59102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.7837152,
    "lng": -108.577419
  },
  {
    "id": "14110",
    "name": "CVS",
    "address": "1902 BROOKS ST, MISSOULA, MT, 59801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8519117,
    "lng": -114.0121665
  },
  {
    "id": "14109",
    "name": "CVS",
    "address": "115 NORTH 19TH AVE., BOZEMAN, MT, 59718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.6805512,
    "lng": -111.0627913
  },
  {
    "id": "14108",
    "name": "CVS",
    "address": "1950 32ND AVE. S, GRAND FORKS, ND, 58201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.8906705,
    "lng": -97.0546353
  },
  {
    "id": "14107",
    "name": "CVS",
    "address": "1300 E. PARK AVE., ANACONDA, MT, 59711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.126885,
    "lng": -112.9353025
  },
  {
    "id": "14106",
    "name": "CVS",
    "address": "603 N. MONTANA, HELENA, MT, 59601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.5899853,
    "lng": -112.019249
  },
  {
    "id": "14105",
    "name": "CVS",
    "address": "5566 SOUTH 56TH ST, LINCOLN, NE, 68516",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7567381,
    "lng": -96.6433515
  },
  {
    "id": "14104",
    "name": "CVS",
    "address": "1225 E. CALGARY AVE, BISMARCK, ND, 58503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.84465,
    "lng": -100.7713636
  },
  {
    "id": "14103",
    "name": "CVS",
    "address": "1321 19TH AVE NORTH, FARGO, ND, 58102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.9063159,
    "lng": -96.7998773
  },
  {
    "id": "14102",
    "name": "CVS",
    "address": "2425 13TH AVE SOUTH, FARGO, ND, 58103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8620434,
    "lng": -96.8186867
  },
  {
    "id": "14101",
    "name": "CVS",
    "address": "1520 20TH AVE SW, MINOT, ND, 58701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 48.2122701,
    "lng": -101.3164604
  },
  {
    "id": "14100",
    "name": "CVS",
    "address": "2755 SOUTH 48TH ST., LINCOLN, NE, 68506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7848172,
    "lng": -96.6544996
  },
  {
    "id": "14099",
    "name": "CVS",
    "address": "7003 BANISTER RD., KANSAS CITY, MO, 64134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.950979,
    "lng": -94.507424
  },
  {
    "id": "14098",
    "name": "CVS",
    "address": "4645 SHAWNEE DR., KANSAS CITY, KS, 66106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0495235,
    "lng": -94.6854897
  },
  {
    "id": "14097",
    "name": "CVS",
    "address": "12000 S. 71 HWY., GRANDVIEW, MO, 64030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9065021,
    "lng": -94.5249788
  },
  {
    "id": "14096",
    "name": "CVS",
    "address": "9521 MISSION RD., OVERLAND PARK, KS, 66206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.955964,
    "lng": -94.6297814
  },
  {
    "id": "14095",
    "name": "CVS",
    "address": "2835 SW WANAMAKER RD., TOPEKA, KS, 66614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0153097,
    "lng": -95.7643819
  },
  {
    "id": "14094",
    "name": "CVS",
    "address": "3750 STATE AVENUE, KANSAS CITY, KS, 66102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1179197,
    "lng": -94.6727283
  },
  {
    "id": "14093",
    "name": "CVS",
    "address": "8101 STATE AVE., KANSAS CITY, KS, 66112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1153895,
    "lng": -94.7674597
  },
  {
    "id": "14092",
    "name": "CVS",
    "address": "9005 EAST 350 HIGHWAY, RAYTOWN, MO, 64133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9969324,
    "lng": -94.4783892
  },
  {
    "id": "14091",
    "name": "CVS",
    "address": "601 S. JEFFERSON ST., KEARNEY, MO, 64060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3673416,
    "lng": -94.3610895
  },
  {
    "id": "14090",
    "name": "CVS",
    "address": "5901 INDEPENDENCE, KANSAS CITY, MO, 64125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1044134,
    "lng": -94.5124362
  },
  {
    "id": "14089",
    "name": "CVS",
    "address": "921 MAIN STREET, KANSAS CITY, MO, 64105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1027951,
    "lng": -94.5823943
  },
  {
    "id": "14088",
    "name": "CVS",
    "address": "315 W 75TH STREET, KANSAS CITY, MO, 64114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9917558,
    "lng": -94.5926743
  },
  {
    "id": "14087",
    "name": "CVS",
    "address": "15286 SUMMIT AVE., FONTANA, CA, 92336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1519178,
    "lng": -117.4711467
  },
  {
    "id": "14086",
    "name": "CVS",
    "address": "11729 ROE AVE., LEAWOOD, KS, 66211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9156115,
    "lng": -94.6375287
  },
  {
    "id": "14085",
    "name": "CVS",
    "address": "7100 W. 151ST STREET, OVERLAND PARK, KS, 66223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8552418,
    "lng": -94.668529
  },
  {
    "id": "14084",
    "name": "CVS",
    "address": "12691 ANTIOCH, OVERLAND PARK, KS, 66213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8989063,
    "lng": -94.6848435
  },
  {
    "id": "14083",
    "name": "CVS",
    "address": "950 MINNESOTA AVE., KANSAS CITY, KS, 66101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1161979,
    "lng": -94.634462
  },
  {
    "id": "14082",
    "name": "CVS",
    "address": "8800 W. 95TH STREET, OVERLAND PARK, KS, 66212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9574166,
    "lng": -94.6872668
  },
  {
    "id": "14081",
    "name": "CVS",
    "address": "3201 SOUTH 7 HIGHWAY, BLUE SPRINGS, MO, 64014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9867468,
    "lng": -94.2742827
  },
  {
    "id": "14080",
    "name": "CVS",
    "address": "6510 NIEMAN RD., SHAWNEE, KS, 66203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0101332,
    "lng": -94.7152025
  },
  {
    "id": "14079",
    "name": "CVS",
    "address": "6300 PROSPECT AVE, KANSAS CITY, MO, 64132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0120088,
    "lng": -94.5572042
  },
  {
    "id": "14078",
    "name": "CVS",
    "address": "4400 NW BARRY ROAD, KANSAS CITY, MO, 64154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2473261,
    "lng": -94.6318796
  },
  {
    "id": "14077",
    "name": "CVS",
    "address": "11900 W 135TH STREET, OVERLAND PARK, KS, 66221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8867264,
    "lng": -94.7244384
  },
  {
    "id": "14076",
    "name": "CVS",
    "address": "4750 LEES SUMMIT RD, KANSAS CITY, MO, 64136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0327639,
    "lng": -94.3887177
  },
  {
    "id": "14075",
    "name": "CVS",
    "address": "1616 N. 7TH HWY., BLUE SPRINGS, MO, 64015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0370056,
    "lng": -94.2697937
  },
  {
    "id": "14074",
    "name": "CVS",
    "address": "5011 MAIN ST., KANSAS CITY, MO, 64112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0360471,
    "lng": -94.5868685
  },
  {
    "id": "14073",
    "name": "CVS",
    "address": "5310 BLUERIDGE BLVD., RAYTOWN, MO, 64133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0256591,
    "lng": -94.4433736
  },
  {
    "id": "14072",
    "name": "CVS",
    "address": "330 N.E. BARRY RD., KANSAS CITY, MO, 64155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2473254,
    "lng": -94.576468
  },
  {
    "id": "14071",
    "name": "CVS",
    "address": "17301 E US 24TH HWY., INDEPENDENCE, MO, 64056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1190512,
    "lng": -94.3738625
  },
  {
    "id": "14070",
    "name": "CVS",
    "address": "1900 N.E. LANGSFORD RD., LEES SUMMIT, MO, 64063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9173555,
    "lng": -94.3373279
  },
  {
    "id": "14069",
    "name": "CVS",
    "address": "5440 NW 64TH ST., KANSAS CITY, MO, 64151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.211203,
    "lng": -94.6438242
  },
  {
    "id": "14068",
    "name": "CVS",
    "address": "4990 NE VIVION RD., KANSAS CITY, MO, 64119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1885905,
    "lng": -94.5219184
  },
  {
    "id": "14067",
    "name": "CVS",
    "address": "6129 N. ANTIOCH RD., GLADSTONE, MO, 64119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2131307,
    "lng": -94.5351516
  },
  {
    "id": "14066",
    "name": "CVS",
    "address": "10205 STATE LINE RD., KANSAS CITY, MO, 64114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.943504,
    "lng": -94.6073528
  },
  {
    "id": "14065",
    "name": "CVS",
    "address": "2454 S. ALPINE RD., ROCKFORD, IL, 61108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2406861,
    "lng": -89.0271182
  },
  {
    "id": "14064",
    "name": "CVS",
    "address": "2425 MUSCATINE AVENUE, IOWA CITY, IA, 52240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.649089,
    "lng": -91.4998394
  },
  {
    "id": "14063",
    "name": "CVS",
    "address": "701 E. REED AVE., MANITOWOC, WI, 54220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1132258,
    "lng": -87.6386255
  },
  {
    "id": "14062",
    "name": "CVS",
    "address": "2400 VELP AVENUE, GREEN BAY, WI, 54303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5627383,
    "lng": -88.0725936
  },
  {
    "id": "14061",
    "name": "CVS",
    "address": "1561 W. MASON ST., GREEN BAY, WI, 54303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5231516,
    "lng": -88.063755
  },
  {
    "id": "14060",
    "name": "CVS",
    "address": "1535 W. GALENA, FREEPORT, IL, 61032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3043055,
    "lng": -89.6525921
  },
  {
    "id": "14059",
    "name": "CVS",
    "address": "2302 W. FIRST ST., CEDAR FALLS, IA, 50613",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5389188,
    "lng": -92.4729334
  },
  {
    "id": "14058",
    "name": "CVS",
    "address": "2222 S WEBSTER AVE., GREEN BAY, WI, 54301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4809873,
    "lng": -88.0250734
  },
  {
    "id": "14057",
    "name": "CVS",
    "address": "721 W. SOUTH ST., FREEPORT, IL, 61032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2793251,
    "lng": -89.6295046
  },
  {
    "id": "14056",
    "name": "CVS",
    "address": "2711 MOUNT VERNON ROAD SE, CEDAR RAPIDS, IA, 52403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9760998,
    "lng": -91.6272795
  },
  {
    "id": "14055",
    "name": "CVS",
    "address": "110 S. ALPINE RD., ROCKFORD, IL, 61108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2633441,
    "lng": -89.0283039
  },
  {
    "id": "14054",
    "name": "CVS",
    "address": "6506 ALPINE RD., LOVES PARK, IL, 61111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.318955,
    "lng": -89.0300557
  },
  {
    "id": "14053",
    "name": "CVS",
    "address": "3134 11TH STREET, ROCKFORD, IL, 61109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2280054,
    "lng": -89.0685373
  },
  {
    "id": "14052",
    "name": "CVS",
    "address": "8001 N 2ND ST, MACHESNEY PARK, IL, 61115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3401949,
    "lng": -89.0517508
  },
  {
    "id": "14051",
    "name": "CVS",
    "address": "822 30TH AVE. SOUTH, MOORHEAD, MN, 56560",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8450832,
    "lng": -96.7662041
  },
  {
    "id": "14050",
    "name": "CVS",
    "address": "4116 CENTER POINT RD N.E., CEDAR RAPIDS, IA, 52402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0208423,
    "lng": -91.6643789
  },
  {
    "id": "14049",
    "name": "CVS",
    "address": "4843 BLUE STEM ROAD, ROSCOE, IL, 61073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4329277,
    "lng": -89.0227873
  },
  {
    "id": "14048",
    "name": "CVS",
    "address": "11055 S. WESTERN AVENUE, CHICAGO, IL, 60643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6926029,
    "lng": -87.680842
  },
  {
    "id": "14047",
    "name": "CVS",
    "address": "3835 45TH STREET, HIGHLAND, IN, 46322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5379211,
    "lng": -87.4367068
  },
  {
    "id": "14046",
    "name": "CVS",
    "address": "1 MAIN STREET, PARK FOREST, IL, 60466",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4838803,
    "lng": -87.6751415
  },
  {
    "id": "14045",
    "name": "CVS",
    "address": "3156 WEST 103RD STREET, CHICAGO, IL, 60655",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7068488,
    "lng": -87.7007109
  },
  {
    "id": "14044",
    "name": "CVS",
    "address": "6748 W 111TH ST, WORTH, IL, 60482",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.690805,
    "lng": -87.7873238
  },
  {
    "id": "14043",
    "name": "CVS",
    "address": "6315 SOUTH PULASKI RD,, CHICAGO, IL, 60629",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7783344,
    "lng": -87.722447
  },
  {
    "id": "14042",
    "name": "CVS",
    "address": "8325 LEMONT RD, DARIEN, IL, 60561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7358061,
    "lng": -88.0116179
  },
  {
    "id": "14041",
    "name": "CVS",
    "address": "11201 143RD. STREET, ORLAND PARK, IL, 60467",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6291767,
    "lng": -87.8931718
  },
  {
    "id": "14040",
    "name": "CVS",
    "address": "272 E. BUTLER AVE., AMBLER, PA, 19002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1566683,
    "lng": -75.216273
  },
  {
    "id": "14039",
    "name": "CVS",
    "address": "13000 WARWICK BLVD., NEWPORT NEWS, VA, 23602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.1047618,
    "lng": -76.5119247
  },
  {
    "id": "14038",
    "name": "CVS",
    "address": "2363 OREGON PIKE, LANCASTER, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0898018,
    "lng": -76.2801788
  },
  {
    "id": "14037",
    "name": "CVS",
    "address": "6220 SIENNA PKWY, MISSOURI CITY, TX, 77459",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5374033,
    "lng": -95.5342516
  },
  {
    "id": "14036",
    "name": "CVS",
    "address": "3419 16TH AVE SW, CEDAR RAPIDS, IA, 52404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9630674,
    "lng": -91.7169717
  },
  {
    "id": "14035",
    "name": "CVS",
    "address": "4205 N. JOSEY LN., CARROLLTON, TX, 75010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0255559,
    "lng": -96.8854514
  },
  {
    "id": "14034",
    "name": "CVS",
    "address": "188 LINDEN ST., WELLESLEY, MA, 2482",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3011894,
    "lng": -71.2930369
  },
  {
    "id": "14033",
    "name": "CVS",
    "address": "7200 BANCROFT AVE., OAKLAND, CA, 94605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7672087,
    "lng": -122.1779309
  },
  {
    "id": "14032",
    "name": "CVS",
    "address": "3825 S. NOLAND RD., INDEPENDENCE, MO, 64055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0506595,
    "lng": -94.4144328
  },
  {
    "id": "14031",
    "name": "CVS",
    "address": "6201 LAKE OCONEE PKWY., GREENSBORO, GA, 30642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4591249,
    "lng": -83.2439931
  },
  {
    "id": "14030",
    "name": "CVS",
    "address": "4192 SALEM RD., COVINGTON, GA, 30016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5790528,
    "lng": -83.9634291
  },
  {
    "id": "14029",
    "name": "CVS",
    "address": "1929 BRUCE B. DOWNS BLVD., WESLEY CHAPEL, FL, 33544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.18505,
    "lng": -82.3545468
  },
  {
    "id": "14028",
    "name": "CVS",
    "address": "1210 N. ALMA DRIVE, ALLEN, TX, 75013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1161195,
    "lng": -96.6976488
  },
  {
    "id": "14027",
    "name": "CVS",
    "address": "750 ROUTE 25A, KINGS PARK, NY, 11754",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8816851,
    "lng": -73.2217046
  },
  {
    "id": "14026",
    "name": "CVS",
    "address": "8602 HUEBNER RD, SAN ANTONIO, TX, 78240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5188922,
    "lng": -98.6036166
  },
  {
    "id": "14025",
    "name": "CVS",
    "address": "3500 W SLAUGHTER LN, AUSTIN, TX, 78749",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1843006,
    "lng": -97.8499844
  },
  {
    "id": "14024",
    "name": "CVS",
    "address": "4100 DE ZAVALA RD, SAN ANTONIO, TX, 78249",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5761988,
    "lng": -98.564848
  },
  {
    "id": "14023",
    "name": "CVS",
    "address": "5151 BELLE TERRE PKWY, PALM COAST, FL, 32137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5527834,
    "lng": -81.2378214
  },
  {
    "id": "14022",
    "name": "CVS",
    "address": "6042 SW HWY 200, OCALA, FL, 34476",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.1158058,
    "lng": -82.2190212
  },
  {
    "id": "14021",
    "name": "CVS",
    "address": "2077 COMMERCIAL WAY, SPRING HILL, FL, 34606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4605891,
    "lng": -82.6278321
  },
  {
    "id": "14020",
    "name": "CVS",
    "address": "1301 N DIXIE HWY, WEST PALM BEACH, FL, 33401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7249402,
    "lng": -80.0535483
  },
  {
    "id": "14019",
    "name": "CVS",
    "address": "9940 LAKE WORTH RD, LAKE WORTH, FL, 33467",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6163784,
    "lng": -80.2038513
  },
  {
    "id": "14018",
    "name": "CVS",
    "address": "1610 E CAMELBACK RD, PHOENIX, AZ, 85016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5095709,
    "lng": -112.0470315
  },
  {
    "id": "14017",
    "name": "CVS",
    "address": "20601 FM 1431, LAGO VISTA, TX, 78645",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4746197,
    "lng": -97.9753625
  },
  {
    "id": "14016",
    "name": "CVS",
    "address": "2950 DOWLEN RD., BEAUMONT, TX, 77706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1052349,
    "lng": -94.167614
  },
  {
    "id": "14015",
    "name": "CVS",
    "address": "3801 19TH ST., LUBBOCK, TX, 79410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5772796,
    "lng": -101.8969223
  },
  {
    "id": "14014",
    "name": "CVS",
    "address": "2882 N FM 157, MANSFIELD, TX, 76063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6110874,
    "lng": -97.1417429
  },
  {
    "id": "14013",
    "name": "CVS",
    "address": "6420 19TH STREET, LUBBOCK, TX, 79407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.578387,
    "lng": -101.9564725
  },
  {
    "id": "14012",
    "name": "CVS",
    "address": "2004 NORTH GOLIAD, ROCKWALL, TX, 75087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9507783,
    "lng": -96.4619156
  },
  {
    "id": "14011",
    "name": "CVS",
    "address": "2591 FM 423, LITTLE ELM, TX, 75068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1778236,
    "lng": -96.8866667
  },
  {
    "id": "14010",
    "name": "CVS",
    "address": "19202 BLANCO RD, SAN ANTONIO, TX, 78258",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6221425,
    "lng": -98.5131056
  },
  {
    "id": "14009",
    "name": "CVS",
    "address": "11725 NORTH FM 620, AUSTIN, TX, 78750",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4572793,
    "lng": -97.8228956
  },
  {
    "id": "14008",
    "name": "CVS",
    "address": "1187 MAIN ST., PO BOX 58, WYOMING, RI, 2898",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5136073,
    "lng": -71.6979611
  },
  {
    "id": "14007",
    "name": "CVS",
    "address": "ONE DAVIS SQUARE, SOMERVILLE, MA, 2144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3962301,
    "lng": -71.1228526
  },
  {
    "id": "14006",
    "name": "CVS",
    "address": "4464 N. TARRANT PKWY, KELLER, TX, 76248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8936318,
    "lng": -97.2903172
  },
  {
    "id": "14005",
    "name": "CVS",
    "address": "270 HALSTEAD AVENUE #278, HARRISON, NY, 10528",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9688909,
    "lng": -73.7134624
  },
  {
    "id": "14004",
    "name": "CVS",
    "address": "201 S. MUSTANG RD., YUKON, OK, 73099",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.463856,
    "lng": -97.7254787
  },
  {
    "id": "14003",
    "name": "CVS",
    "address": "4899 LAKELAND DR., FLOWOOD, MS, 39232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3384573,
    "lng": -90.0645314
  },
  {
    "id": "14002",
    "name": "CVS",
    "address": "110 COLONY CROSSING, MADISON, MS, 39110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4731011,
    "lng": -90.141895
  },
  {
    "id": "14001",
    "name": "CVS",
    "address": "5360 HIGHLAND RD., BATON ROUGE, LA, 70808",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3931128,
    "lng": -91.1595176
  },
  {
    "id": "14000",
    "name": "CVS",
    "address": "1037 WOODWARD AVE., DETROIT, MI, 48226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3323065,
    "lng": -83.0477014
  },
  {
    "id": "13999",
    "name": "CVS",
    "address": "2232 GENERAL BOOTH BLVD., VIRGINIA BEACH, VA, 23456",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7628352,
    "lng": -76.0149372
  },
  {
    "id": "13998",
    "name": "CVS",
    "address": "43611 SCHOENHERR RD., STERLING HEIGHTS, MI, 48313",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6159823,
    "lng": -82.9934126
  },
  {
    "id": "13997",
    "name": "CVS",
    "address": "10073 E. HIGHLAND RD.,, HOWELL, MI, 48843",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6336737,
    "lng": -83.7543574
  },
  {
    "id": "13996",
    "name": "CVS",
    "address": "727 28TH ST. SE, GRAND RAPIDS, MI, 49548",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9130984,
    "lng": -85.6479619
  },
  {
    "id": "13995",
    "name": "CVS",
    "address": "1016 S. SALISBURY BLVD, SALISBURY, MD, 21801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3502813,
    "lng": -75.6022585
  },
  {
    "id": "13994",
    "name": "CVS",
    "address": "750 CITY AVE SOUTH, RIPLEY, MS, 38663",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7242348,
    "lng": -88.9483444
  },
  {
    "id": "13993",
    "name": "CVS",
    "address": "605 NORTH WEST AVE., JACKSON, MI, 49202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2551598,
    "lng": -84.42297
  },
  {
    "id": "13992",
    "name": "CVS",
    "address": "2585 LEON C, SIMON DR., NEW ORLEANS, LA, 70122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0266971,
    "lng": -90.0531486
  },
  {
    "id": "13991",
    "name": "CVS",
    "address": "2110 S. HARVARD AVE., TULSA, OK, 74114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.132559,
    "lng": -95.9409053
  },
  {
    "id": "13990",
    "name": "CVS",
    "address": "39350 NINE MILE RD, NORTHVILLE, MI, 48167",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4541112,
    "lng": -83.4336073
  },
  {
    "id": "13989",
    "name": "CVS",
    "address": "1130 LINCOLN WAY EAST, MASSILLON, OH, 44646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8003936,
    "lng": -81.5105017
  },
  {
    "id": "13988",
    "name": "CVS",
    "address": "1545 FRED MOORE HWY., SAINT CLAIR, MI, 48079",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8165766,
    "lng": -82.5049683
  },
  {
    "id": "13987",
    "name": "CVS",
    "address": "42191 W 14 MILE ROAD, NOVI, MI, 48377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5257727,
    "lng": -83.4661056
  },
  {
    "id": "13986",
    "name": "CVS",
    "address": "1325 E COMMERCE RD., COMMERCE TOWNSHIP, MI, 48382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5972837,
    "lng": -83.492274
  },
  {
    "id": "13985",
    "name": "CVS",
    "address": "6070 WEST MAPLE ROAD, WEST BLOOMFIELD, MI, 48322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5430435,
    "lng": -83.3788555
  },
  {
    "id": "13984",
    "name": "CVS",
    "address": "5001 W. 135TH ST., LEAWOOD, KS, 66224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8832236,
    "lng": -94.6451157
  },
  {
    "id": "13983",
    "name": "CVS",
    "address": "1301 S. BELT HWY, SAINT JOSEPH, MO, 64507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7548171,
    "lng": -94.8028642
  },
  {
    "id": "13982",
    "name": "CVS",
    "address": "1791 S. HAGGERTY RD., CANTON, MI, 48188",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2943853,
    "lng": -83.4468058
  },
  {
    "id": "13981",
    "name": "CVS",
    "address": "1700 SOUTH INDUSTRIAL HIGHWAY, ANN ARBOR, MI, 48104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2602194,
    "lng": -83.7384658
  },
  {
    "id": "13980",
    "name": "CVS",
    "address": "31501 JOY ROAD, WESTLAND, MI, 48185",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3534036,
    "lng": -83.3534755
  },
  {
    "id": "13979",
    "name": "CVS",
    "address": "3200 E. JEFFERSON, DETROIT, MI, 48207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.340826,
    "lng": -83.0153661
  },
  {
    "id": "13978",
    "name": "CVS",
    "address": "4025 18 MILE RD., STERLING HEIGHTS, MI, 48314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5942994,
    "lng": -83.0701132
  },
  {
    "id": "13977",
    "name": "CVS",
    "address": "45300 CHERRY HILL RD., CANTON, MI, 48187",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3080169,
    "lng": -83.4862527
  },
  {
    "id": "13976",
    "name": "CVS",
    "address": "13500 22 MILE RD., SHELBY TOWNSHIP, MI, 48315",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6550682,
    "lng": -82.9952598
  },
  {
    "id": "13975",
    "name": "CVS",
    "address": "18500 GRAND RIVER, DETROIT, MI, 48223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4028402,
    "lng": -83.222911
  },
  {
    "id": "13974",
    "name": "CVS",
    "address": "22515 GREATER MACK AVE, SAINT CLAIR SHORES, MI, 48080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4597303,
    "lng": -82.9011954
  },
  {
    "id": "13973",
    "name": "CVS",
    "address": "18600 LIVERNOIS, DETROIT, MI, 48221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4289971,
    "lng": -83.1408602
  },
  {
    "id": "13972",
    "name": "CVS",
    "address": "1402 WEST 14 MILE ROAD, CLAWSON, MI, 48017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5336889,
    "lng": -83.1651513
  },
  {
    "id": "13971",
    "name": "CVS",
    "address": "15255 17 MILE RD., CLINTON TOWNSHIP, MI, 48038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5836815,
    "lng": -82.9708827
  },
  {
    "id": "13970",
    "name": "CVS",
    "address": "18640 NINE MILE RD., EASTPOINTE, MI, 48021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4651322,
    "lng": -82.9280125
  },
  {
    "id": "13969",
    "name": "CVS",
    "address": "16855 HAGGERTY RD., NORTHVILLE, MI, 48168",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4094324,
    "lng": -83.4332549
  },
  {
    "id": "13968",
    "name": "CVS",
    "address": "47200 W 10  MILE RD., NOVI, MI, 48374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4665545,
    "lng": -83.5126013
  },
  {
    "id": "13967",
    "name": "CVS",
    "address": "15121 24 MILE RD., SHELBY TOWNSHIP, MI, 48315",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6867856,
    "lng": -82.9766172
  },
  {
    "id": "13966",
    "name": "CVS",
    "address": "5529 SASHABAW RD., CLARKSTON, MI, 48346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7196577,
    "lng": -83.380024
  },
  {
    "id": "13965",
    "name": "CVS",
    "address": "22060 OUTER DRIVE, DEARBORN, MI, 48124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.28462,
    "lng": -83.2332856
  },
  {
    "id": "13964",
    "name": "CVS",
    "address": "1229 S PARKER ST., MARINE CITY, MI, 48039",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7088929,
    "lng": -82.4995975
  },
  {
    "id": "13963",
    "name": "CVS",
    "address": "6862 MICHIGAN AVE., DETROIT, MI, 48210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3316883,
    "lng": -83.1288369
  },
  {
    "id": "13962",
    "name": "CVS",
    "address": "9300 JOSEPH CAMPAU, HAMTRAMCK, MI, 48212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3939943,
    "lng": -83.0554765
  },
  {
    "id": "13961",
    "name": "CVS",
    "address": "444 S. OLD WOODWARD ROAD, BIRMINGHAM, MI, 48009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5434665,
    "lng": -83.2115306
  },
  {
    "id": "13960",
    "name": "CVS",
    "address": "4101 TELEGRAPH RD., BLOOMFIELD HILLS, MI, 48302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5801406,
    "lng": -83.2793236
  },
  {
    "id": "13959",
    "name": "CVS",
    "address": "2400 FORT ST., LINCOLN PARK, MI, 48146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2449175,
    "lng": -83.1810269
  },
  {
    "id": "13958",
    "name": "CVS",
    "address": "31240 HARPER, SAINT CLAIR SHORES, MI, 48082",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.525269,
    "lng": -82.895982
  },
  {
    "id": "13957",
    "name": "CVS",
    "address": "295 S. BROADWAY, LAKE ORION, MI, 48362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7802403,
    "lng": -83.2388069
  },
  {
    "id": "13956",
    "name": "CVS",
    "address": "209 E. 12 MILE RD., ROYAL OAK, MI, 48073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5048563,
    "lng": -83.1424794
  },
  {
    "id": "13955",
    "name": "CVS",
    "address": "37340 FIVE MILE RD., LIVONIA, MI, 48154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3975058,
    "lng": -83.412068
  },
  {
    "id": "13954",
    "name": "CVS",
    "address": "15300 EUREKA RD., SOUTHGATE, MI, 48195",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2002058,
    "lng": -83.2088107
  },
  {
    "id": "13953",
    "name": "CVS",
    "address": "110 N ROCHESTER RD., CLAWSON, MI, 48017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5346306,
    "lng": -83.1349955
  },
  {
    "id": "13952",
    "name": "CVS",
    "address": "33920 23 MILE RD, NEW BALTIMORE, MI, 48047",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6748707,
    "lng": -82.7683383
  },
  {
    "id": "13951",
    "name": "CVS",
    "address": "20460 MACK AVE., GROSSE POINTE WOODS, MI, 48236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4395079,
    "lng": -82.9070389
  },
  {
    "id": "13950",
    "name": "CVS",
    "address": "23001 COOLIDGE HWY., OAK PARK, MI, 48237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4602299,
    "lng": -83.1827358
  },
  {
    "id": "13949",
    "name": "CVS",
    "address": "33 WEST NINE MILE RD., HAZEL PARK, MI, 48030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4607113,
    "lng": -83.104669
  },
  {
    "id": "13948",
    "name": "CVS",
    "address": "24001 HARPER, SAINT CLAIR SHORES, MI, 48080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4719903,
    "lng": -82.9061981
  },
  {
    "id": "13947",
    "name": "CVS",
    "address": "2228 S. MAIN, ANN ARBOR, MI, 48103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2533801,
    "lng": -83.7515131
  },
  {
    "id": "13946",
    "name": "CVS",
    "address": "26220 CROCKER, HARRISON TOWNSHIP, MI, 48045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5705304,
    "lng": -82.8515679
  },
  {
    "id": "13945",
    "name": "CVS",
    "address": "37050 S GRATIOT AVE, CLINTON TOWNSHIP, MI, 48036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5701194,
    "lng": -82.891111
  },
  {
    "id": "13944",
    "name": "CVS",
    "address": "935 S. MAIN ST., CHELSEA, MI, 48118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3070254,
    "lng": -84.0203362
  },
  {
    "id": "13943",
    "name": "CVS",
    "address": "2100 W. STADIUM BLVD., ANN ARBOR, MI, 48103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2733106,
    "lng": -83.7752633
  },
  {
    "id": "13942",
    "name": "CVS",
    "address": "301 SOUTH COCHRAN AVE., CHARLOTTE, MI, 48813",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5605298,
    "lng": -84.8353691
  },
  {
    "id": "13941",
    "name": "CVS",
    "address": "1400 S SHELDON ROAD, PLYMOUTH, MI, 48170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3596172,
    "lng": -83.4802746
  },
  {
    "id": "13940",
    "name": "CVS",
    "address": "7498 HAGGERTY ROAD, WEST BLOOMFIELD, MI, 48322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5265011,
    "lng": -83.4367992
  },
  {
    "id": "13939",
    "name": "CVS",
    "address": "17120 KERCHEVAL AVE, GROSSE POINTE, MI, 48230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.390316,
    "lng": -82.9146263
  },
  {
    "id": "13938",
    "name": "CVS",
    "address": "13475 FIFTEEN MILE RD., STERLING HEIGHTS, MI, 48312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5527549,
    "lng": -82.9905157
  },
  {
    "id": "13937",
    "name": "CVS",
    "address": "15142 HALL RD.,, STERLING HEIGHTS, MI, 48313",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6265277,
    "lng": -82.9741994
  },
  {
    "id": "13936",
    "name": "CVS",
    "address": "40900 ANN ARBOR RD., EAST, PLYMOUTH, MI, 48170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3600889,
    "lng": -83.4455967
  },
  {
    "id": "13935",
    "name": "CVS",
    "address": "3010 WALTON BLVD., ROCHESTER HILLS, MI, 48309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.681261,
    "lng": -83.194791
  },
  {
    "id": "13934",
    "name": "CVS",
    "address": "27435 FORD RD., GARDEN CITY, MI, 48135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.325586,
    "lng": -83.3123787
  },
  {
    "id": "13933",
    "name": "CVS",
    "address": "1715 COOLIDGE HWY., BERKLEY, MI, 48072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4891588,
    "lng": -83.1837405
  },
  {
    "id": "13932",
    "name": "CVS",
    "address": "18585 EAST WARREN AVE, DETROIT, MI, 48236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4125876,
    "lng": -82.9134704
  },
  {
    "id": "13931",
    "name": "CVS",
    "address": "27000 TELEGRAPH RD., FLAT ROCK, MI, 48134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1097709,
    "lng": -83.2859276
  },
  {
    "id": "13930",
    "name": "CVS",
    "address": "3475 S. BALDWIN RD., LAKE ORION, MI, 48359",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7293903,
    "lng": -83.3068638
  },
  {
    "id": "13929",
    "name": "CVS",
    "address": "525 EAST 4TH STREET, ROYAL OAK, MI, 48067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4878246,
    "lng": -83.1389455
  },
  {
    "id": "13928",
    "name": "CVS",
    "address": "31250 BECK RD., NOVI, MI, 48377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.524315,
    "lng": -83.5156071
  },
  {
    "id": "13927",
    "name": "CVS",
    "address": "22421 PONTIAC TRAIL, SOUTH LYON, MI, 48178",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4466402,
    "lng": -83.6510519
  },
  {
    "id": "13926",
    "name": "CVS",
    "address": "6501 N. WAYNE RD., WESTLAND, MI, 48185",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3322246,
    "lng": -83.3868787
  },
  {
    "id": "13925",
    "name": "CVS",
    "address": "28774 GRATIOT, ROSEVILLE, MI, 48066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5082894,
    "lng": -82.9285168
  },
  {
    "id": "13924",
    "name": "CVS",
    "address": "1750 S. WAYNE RD., WESTLAND, MI, 48186",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2959925,
    "lng": -83.3887042
  },
  {
    "id": "13923",
    "name": "CVS",
    "address": "18130 WEST 10 MILE RD., SOUTHFIELD, MI, 48075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4738705,
    "lng": -83.2220743
  },
  {
    "id": "13922",
    "name": "CVS",
    "address": "8710 N. BEECH DALY, DEARBORN HEIGHTS, MI, 48127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3557265,
    "lng": -83.2934922
  },
  {
    "id": "13921",
    "name": "CVS",
    "address": "2240 CEDAR ST, HOLT, MI, 48842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6478177,
    "lng": -84.5228845
  },
  {
    "id": "13920",
    "name": "CVS",
    "address": "19818 KELLY ROAD, HARPER WOODS, MI, 48225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4415743,
    "lng": -82.9470915
  },
  {
    "id": "13919",
    "name": "CVS",
    "address": "31111 SCHOENHERR RD, WARREN, MI, 48088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5225695,
    "lng": -82.9888782
  },
  {
    "id": "13918",
    "name": "CVS",
    "address": "23391 FARMINGTON RD., FARMINGTON, MI, 48336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4638565,
    "lng": -83.3770309
  },
  {
    "id": "13917",
    "name": "CVS",
    "address": "2235 EAST GRAND RIVER AVE., HOWELL, MI, 48843",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5998883,
    "lng": -83.9083311
  },
  {
    "id": "13916",
    "name": "CVS",
    "address": "25109 RYAN RD., WARREN, MI, 48091",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.477512,
    "lng": -83.0660874
  },
  {
    "id": "13915",
    "name": "CVS",
    "address": "29425 ORCHARD LAKE RD., FARMINGTON HILLS, MI, 48334",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5132668,
    "lng": -83.3601554
  },
  {
    "id": "13914",
    "name": "CVS",
    "address": "10915 BELLEVILLE ROAD, VAN BUREN TOWNSHIP, MI, 48111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2230626,
    "lng": -83.4839189
  },
  {
    "id": "13913",
    "name": "CVS",
    "address": "414 S. MAIN ST., BROOKLYN, MI, 49230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0978496,
    "lng": -84.2487056
  },
  {
    "id": "13912",
    "name": "CVS",
    "address": "7960 COOLEY LAKE RD., WATERFORD, MI, 48327",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6155492,
    "lng": -83.4410939
  },
  {
    "id": "13911",
    "name": "CVS",
    "address": "981 E. AUBURN RD., ROCHESTER HILLS, MI, 48307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6371987,
    "lng": -83.1127466
  },
  {
    "id": "13910",
    "name": "CVS",
    "address": "21911 WEST ELEVEN MILE RD., SOUTHFIELD, MI, 48076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4865282,
    "lng": -83.2605527
  },
  {
    "id": "13909",
    "name": "CVS",
    "address": "27050 JOHN R RD., MADISON HEIGHTS, MI, 48071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4914367,
    "lng": -83.1044904
  },
  {
    "id": "13908",
    "name": "CVS",
    "address": "19120 MIDDLEBELT RD, LIVONIA, MI, 48152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4276333,
    "lng": -83.3352692
  },
  {
    "id": "13907",
    "name": "CVS",
    "address": "1980 E. BIG BEAVER ROAD, TROY, MI, 48083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5628104,
    "lng": -83.1090167
  },
  {
    "id": "13906",
    "name": "CVS",
    "address": "11125 ALLEN ROAD, SOUTHGATE, MI, 48195",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2265045,
    "lng": -83.2284332
  },
  {
    "id": "13905",
    "name": "CVS",
    "address": "807 WEST CHICAGO BLVD., TECUMSEH, MI, 49286",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0056961,
    "lng": -83.9588395
  },
  {
    "id": "13904",
    "name": "CVS",
    "address": "4295 ORCHARD LAKE RD., WEST BLOOMFIELD, MI, 48323",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5767965,
    "lng": -83.3611573
  },
  {
    "id": "13903",
    "name": "CVS",
    "address": "40925 GARFIELD ROAD, CLINTON TOWNSHIP, MI, 48038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5972187,
    "lng": -82.9532645
  },
  {
    "id": "13902",
    "name": "CVS",
    "address": "29500 FIVE MILE RD., LIVONIA, MI, 48154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3987635,
    "lng": -83.3359374
  },
  {
    "id": "13901",
    "name": "CVS",
    "address": "1003 N. MAIN ST., ADRIAN, MI, 49221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9077723,
    "lng": -84.0318603
  },
  {
    "id": "13900",
    "name": "CVS",
    "address": "31411 CHERRY HILL, WESTLAND, MI, 48186",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3101716,
    "lng": -83.3503023
  },
  {
    "id": "13899",
    "name": "CVS",
    "address": "133 EAST DUNLAP, NORTHVILLE, MI, 48167",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4325555,
    "lng": -83.4820862
  },
  {
    "id": "13898",
    "name": "CVS",
    "address": "7291 N. MIDDLEBELT ROAD, WESTLAND, MI, 48185",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3407531,
    "lng": -83.332251
  },
  {
    "id": "13897",
    "name": "CVS",
    "address": "3535 PLYMOUTH RD.,, ANN ARBOR, MI, 48105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3060027,
    "lng": -83.6921371
  },
  {
    "id": "13896",
    "name": "CVS",
    "address": "23115 MICHIGAN AVE, DEARBORN, MI, 48124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3013077,
    "lng": -83.2595911
  },
  {
    "id": "13895",
    "name": "CVS",
    "address": "413 EAST MICHIGAN, SALINE, MI, 48176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1711804,
    "lng": -83.772609
  },
  {
    "id": "13894",
    "name": "CVS",
    "address": "100 W. MAPLE RD., WALLED LAKE, MI, 48390",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5378551,
    "lng": -83.4826146
  },
  {
    "id": "13893",
    "name": "CVS",
    "address": "15325 MICHIGAN AVE, DEARBORN, MI, 48126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3150182,
    "lng": -83.1927819
  },
  {
    "id": "13892",
    "name": "CVS",
    "address": "520 S. FEDERAL HWY., BOCA RATON, FL, 33432",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3447414,
    "lng": -80.0857555
  },
  {
    "id": "13891",
    "name": "CVS",
    "address": "1 CARR. 696, DORADO, PR, 646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4625952,
    "lng": -66.273255
  },
  {
    "id": "13890",
    "name": "CVS",
    "address": "7355 ROSWELL RD, NE, SANDY SPRINGS, GA, 30328",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9560635,
    "lng": -84.3640737
  },
  {
    "id": "13889",
    "name": "CVS",
    "address": "4500 PLEASANT HILL RD.,, KISSIMMEE, FL, 34746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1551724,
    "lng": -81.4406883
  },
  {
    "id": "13888",
    "name": "CVS",
    "address": "4107 S HARVARD AVE, TULSA, OK, 74135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1038108,
    "lng": -95.9393775
  },
  {
    "id": "13887",
    "name": "CVS",
    "address": "191 CALLE GAUTIER BENITEZ, CAGUAS, PR, 725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.2226487,
    "lng": -66.0387925
  },
  {
    "id": "13886",
    "name": "CVS",
    "address": "88 CARR. 2, MANATI, PR, 674",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4333598,
    "lng": -66.4855006
  },
  {
    "id": "13885",
    "name": "CVS",
    "address": "2301 MOODY BLVD., FLAGLER BEACH, FL, 32136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4758265,
    "lng": -81.1460811
  },
  {
    "id": "13884",
    "name": "CVS",
    "address": "5685 BALBOA AVE, SAN DIEGO, CA, 92111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8196023,
    "lng": -117.1785858
  },
  {
    "id": "13883",
    "name": "CVS",
    "address": "524 MULLICA HILL RD, MULLICA HILL, NJ, 8062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7224445,
    "lng": -75.1679905
  },
  {
    "id": "13882",
    "name": "CVS",
    "address": "4000 BATTLEGROUND AVE., GREENSBORO, NC, 27410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1468169,
    "lng": -79.8684462
  },
  {
    "id": "13881",
    "name": "CVS",
    "address": "10000 JEFFERSON DAVIS HWY., FREDERICKSBURG, VA, 22407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2221227,
    "lng": -77.5079254
  },
  {
    "id": "13880",
    "name": "CVS",
    "address": "1151 PORT REPUBLIC RD.,, HARRISONBURG, VA, 22801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.417969,
    "lng": -78.8690942
  },
  {
    "id": "13879",
    "name": "CVS",
    "address": "8700 US HIGHWAY, 301 NORTH, PARRISH, FL, 34219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.543596,
    "lng": -82.4771718
  },
  {
    "id": "13878",
    "name": "CVS",
    "address": "2873 SW PORT ST. LUCIE BLVD., PORT SAINT LUCIE, FL, 34953",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2586324,
    "lng": -80.3741293
  },
  {
    "id": "13877",
    "name": "CVS",
    "address": "4801 NEW BROAD ST., ORLANDO, FL, 32814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5668094,
    "lng": -81.3279974
  },
  {
    "id": "13876",
    "name": "CVS",
    "address": "12080 SOUTH JOG RD., BOYNTON BEACH, FL, 33437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4973384,
    "lng": -80.1464346
  },
  {
    "id": "13875",
    "name": "CVS",
    "address": "292 SPIELMAN HWY., BURLINGTON, CT, 6013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7706283,
    "lng": -72.9696819
  },
  {
    "id": "13874",
    "name": "CVS",
    "address": "115 SKYLINE DRIVE, RINGWOOD, NJ, 7456",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0845691,
    "lng": -74.2629575
  },
  {
    "id": "13873",
    "name": "CVS",
    "address": "1794 ASHLAN AVE, CLOVIS, CA, 93611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7932051,
    "lng": -119.6827974
  },
  {
    "id": "13872",
    "name": "CVS",
    "address": "1611 PINE ISLAND RD NE, CAPE CORAL, FL, 33909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6682725,
    "lng": -81.9402533
  },
  {
    "id": "13871",
    "name": "CVS",
    "address": "8495 US HWY 1, VERO BEACH, FL, 32967",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7478334,
    "lng": -80.4356909
  },
  {
    "id": "13870",
    "name": "CVS",
    "address": "1520 LAKEWOOD RANCH BLVD., BRADENTON, FL, 34211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4848047,
    "lng": -82.4349507
  },
  {
    "id": "13869",
    "name": "CVS",
    "address": "8954 LANTANA RD, LAKE WORTH, FL, 33467",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5893167,
    "lng": -80.1880514
  },
  {
    "id": "13868",
    "name": "CVS",
    "address": "8025 LEE VISTA BLVD, ORLANDO, FL, 32829",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4665511,
    "lng": -81.2754632
  },
  {
    "id": "13867",
    "name": "CVS",
    "address": "6120 HICKORY FLAT HWY., CANTON, GA, 30115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1758621,
    "lng": -84.4200158
  },
  {
    "id": "13866",
    "name": "CVS",
    "address": "12401 MIRAMAR PKWY., MIRAMAR, FL, 33027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9796179,
    "lng": -80.3123447
  },
  {
    "id": "13865",
    "name": "CVS",
    "address": "260 SOUTH US HWY 1, TEQUESTA, FL, 33469",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.9583944,
    "lng": -80.0855316
  },
  {
    "id": "13864",
    "name": "CVS",
    "address": "4825 BATTLEFIELD PARKWAY, RINGGOLD, GA, 30736",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9329706,
    "lng": -85.1832106
  },
  {
    "id": "13863",
    "name": "CVS",
    "address": "4215 SW 9TH ST, VERO BEACH, FL, 32968",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.5867761,
    "lng": -80.4299573
  },
  {
    "id": "13862",
    "name": "CVS",
    "address": "160 S. MAIN ST., DOYLESTOWN, PA, 18901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3061025,
    "lng": -75.1296822
  },
  {
    "id": "13861",
    "name": "CVS",
    "address": "10160 BELL ROAD EAST, SCOTTSDALE, AZ, 85260",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6409219,
    "lng": -111.8619821
  },
  {
    "id": "13860",
    "name": "CVS",
    "address": "6370 N. CAMPBELL AVE., #120, TUCSON, AZ, 85718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3219639,
    "lng": -110.9281706
  },
  {
    "id": "13859",
    "name": "CVS",
    "address": "281 CONNECTICUT AVE., NORWALK, CT, 6854",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1024335,
    "lng": -73.4349146
  },
  {
    "id": "13858",
    "name": "CVS",
    "address": "2601 S. HOUGHTON RD., TUCSON, AZ, 85730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.1910989,
    "lng": -110.7717538
  },
  {
    "id": "13857",
    "name": "CVS",
    "address": "28138 N. TATUM BLVD., CAVE CREEK, AZ, 85331",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7405517,
    "lng": -111.9789841
  },
  {
    "id": "13856",
    "name": "CVS",
    "address": "4365 N ORACLE RD, TUCSON, AZ, 85705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2859005,
    "lng": -110.978885
  },
  {
    "id": "13855",
    "name": "CVS",
    "address": "1149 BEN FRANKLIN HWY. WEST, DOUGLASSVILLE, PA, 19518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2617796,
    "lng": -75.7293807
  },
  {
    "id": "13854",
    "name": "CVS",
    "address": "1151 E. MCKELLIPS RD., MESA, AZ, 85203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4506209,
    "lng": -111.805521
  },
  {
    "id": "13853",
    "name": "CVS",
    "address": "9838 POTRANCO RD, SAN ANTONIO, TX, 78251",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.435899,
    "lng": -98.6845568
  },
  {
    "id": "13852",
    "name": "CVS",
    "address": "6539 DE ZAVALA RD, SAN ANTONIO, TX, 78249",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5576675,
    "lng": -98.6156379
  },
  {
    "id": "13851",
    "name": "CVS",
    "address": "1855 GATTIS SCHOOL RD, ROUND ROCK, TX, 78664",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4955904,
    "lng": -97.6572831
  },
  {
    "id": "13850",
    "name": "CVS",
    "address": "1800 ROCK PRAIRIE RD, COLLEGE STATION, TX, 77845",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5835006,
    "lng": -96.2864793
  },
  {
    "id": "13849",
    "name": "CVS",
    "address": "5702 LAVON DR, GARLAND, TX, 75040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9677654,
    "lng": -96.6071504
  },
  {
    "id": "13848",
    "name": "CVS",
    "address": "5002 W MAIN ST, LEAGUE CITY, TX, 77573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4903518,
    "lng": -95.1539178
  },
  {
    "id": "13847",
    "name": "CVS",
    "address": "6700 WOODLANDS PKWY STE 500, THE WOODLANDS, TX, 77382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1824366,
    "lng": -95.5352356
  },
  {
    "id": "13846",
    "name": "CVS",
    "address": "2693 FM 3009, SCHERTZ, TX, 78154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.58059,
    "lng": -98.26498
  },
  {
    "id": "13845",
    "name": "CVS",
    "address": "5805 82ND ST, LUBBOCK, TX, 79424",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5190826,
    "lng": -101.940426
  },
  {
    "id": "13844",
    "name": "CVS",
    "address": "5757 NEW TERRITORY BLVD, SUGAR LAND, TX, 77479",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5909858,
    "lng": -95.6771046
  },
  {
    "id": "13843",
    "name": "CVS",
    "address": "6401 W PARKER RD, PLANO, TX, 75093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0459016,
    "lng": -96.8402087
  },
  {
    "id": "13842",
    "name": "CVS",
    "address": "6000 BRYANT IRVIN RD, FORT WORTH, TX, 76132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6618783,
    "lng": -97.4234682
  },
  {
    "id": "13841",
    "name": "CVS",
    "address": "6820 NORTH PEAR TREE LANE, PEORIA, IL, 61615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7708139,
    "lng": -89.657703
  },
  {
    "id": "13840",
    "name": "CVS",
    "address": "650 JOHNNIE DODDS BLVD., MOUNT PLEASANT, SC, 29464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8089801,
    "lng": -79.8778449
  },
  {
    "id": "13839",
    "name": "CVS",
    "address": "8330 CRAWFORDSVILLE ROAD, INDIANAPOLIS, IN, 46234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8112337,
    "lng": -86.3083507
  },
  {
    "id": "13838",
    "name": "CVS",
    "address": "2075 S. LAKE ST., MUNDELEIN, IL, 60060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2373032,
    "lng": -87.9948789
  },
  {
    "id": "13837",
    "name": "CVS",
    "address": "2220 CROSS TIMBERS RD, FLOWER MOUND, TX, 75028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0350781,
    "lng": -97.0627007
  },
  {
    "id": "13836",
    "name": "CVS",
    "address": "27749 CLINTON KEITH ROAD, MURRIETA, CA, 92562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5982441,
    "lng": -117.1769317
  },
  {
    "id": "13835",
    "name": "CVS",
    "address": "110 S KING ST, SEGUIN, TX, 78155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5686391,
    "lng": -97.9505179
  },
  {
    "id": "13834",
    "name": "CVS",
    "address": "824 S. JACKSON ST., JACKSONVILLE, TX, 75766",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.9569636,
    "lng": -95.2662399
  },
  {
    "id": "13833",
    "name": "CVS",
    "address": "2812 SCIOTO TRAIL, PORTSMOUTH, OH, 45662",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7575227,
    "lng": -82.9904692
  },
  {
    "id": "13832",
    "name": "CVS",
    "address": "850 CALIFORNIA ST, MOUNTAIN VIEW, CA, 94041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3918559,
    "lng": -122.0813783
  },
  {
    "id": "13831",
    "name": "CVS",
    "address": "2012 S WASHINGTON ST, AMARILLO, TX, 79109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1931499,
    "lng": -101.8493022
  },
  {
    "id": "13830",
    "name": "CVS",
    "address": "19900 S LA GRANGE RD, MOKENA, IL, 60448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.52787,
    "lng": -87.8508592
  },
  {
    "id": "13829",
    "name": "CVS",
    "address": "3340 S. WESTERN ST, AMARILLO, TX, 79109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1768545,
    "lng": -101.8847612
  },
  {
    "id": "13828",
    "name": "CVS",
    "address": "2425 AVENUE J, GALVESTON, TX, 77550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4542758,
    "lng": -94.628876
  },
  {
    "id": "13827",
    "name": "CVS",
    "address": "7230 PRESTON RD, FRISCO, TX, 75034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1384097,
    "lng": -96.8036604
  },
  {
    "id": "13826",
    "name": "CVS",
    "address": "6945 NASHVILLE STREET, RINGGOLD, GA, 30736",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9188086,
    "lng": -85.1232595
  },
  {
    "id": "13825",
    "name": "CVS",
    "address": "5659 LEMMON AVE, DALLAS, TX, 75209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8291259,
    "lng": -96.8264301
  },
  {
    "id": "13824",
    "name": "CVS",
    "address": "10455 N CENTRAL EXPY, DALLAS, TX, 75231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8890914,
    "lng": -96.7711485
  },
  {
    "id": "13823",
    "name": "CVS",
    "address": "10306 FERGUSON RD, DALLAS, TX, 75228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8352764,
    "lng": -96.6721178
  },
  {
    "id": "13822",
    "name": "CVS",
    "address": "601 HOWARD SIMMONS RD., EAST ELLIJAY, GA, 30540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.657895,
    "lng": -84.4931709
  },
  {
    "id": "13821",
    "name": "CVS",
    "address": "1301 W. PFLUGERVILLE PARKWAY, PFLUGERVILLE, TX, 78660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4717169,
    "lng": -97.6419694
  },
  {
    "id": "13820",
    "name": "CVS",
    "address": "112 MAIN ST, KERRVILLE, TX, 78028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0527493,
    "lng": -99.145745
  },
  {
    "id": "13819",
    "name": "CVS",
    "address": "1836 PAT BOOKER RD, UNIVERSAL CITY, TX, 78148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5539296,
    "lng": -98.3086302
  },
  {
    "id": "13818",
    "name": "CVS",
    "address": "410 W ROCHELLE RD, IRVING, TX, 75062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8439472,
    "lng": -96.9507276
  },
  {
    "id": "13817",
    "name": "CVS",
    "address": "4377 ATLANTA HWY., LOGANVILLE, GA, 30052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.837617,
    "lng": -83.9020405
  },
  {
    "id": "13816",
    "name": "CVS",
    "address": "1710 W GENTRY PKWY, TYLER, TX, 75702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3617832,
    "lng": -95.3196718
  },
  {
    "id": "13815",
    "name": "CVS",
    "address": "100 E. MAIN ST., P.O. BOX #1266, WHITEHOUSE, TX, 75791",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.22615,
    "lng": -95.2254524
  },
  {
    "id": "13814",
    "name": "CVS",
    "address": "603 S CEDAR RIDGE DR, DUNCANVILLE, TX, 75137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6469388,
    "lng": -96.9260709
  },
  {
    "id": "13813",
    "name": "CVS",
    "address": "30 ORVIN LANCE CONNECTOR, BLUE RIDGE, GA, 30513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8754768,
    "lng": -84.2997519
  },
  {
    "id": "13812",
    "name": "CVS",
    "address": "1520 AVENUE PLACE, SUITE B-100, ATLANTA, GA, 30329",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8010902,
    "lng": -84.3284118
  },
  {
    "id": "13811",
    "name": "CVS",
    "address": "20641 FAIRMOUNT BLVD., SHAKER HEIGHTS, OH, 44118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4867867,
    "lng": -81.5346721
  },
  {
    "id": "13810",
    "name": "CVS",
    "address": "7301 LAKESHORE BOULEVARD, MENTOR, OH, 44060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.700962,
    "lng": -81.3791304
  },
  {
    "id": "13809",
    "name": "CVS",
    "address": "1830 TEXOMA PKWY, SHERMAN, TX, 75090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6573563,
    "lng": -96.6045629
  },
  {
    "id": "13808",
    "name": "CVS",
    "address": "1870 W MOORE AVE. P.O. BOX 1268, TERRELL, TX, 75160",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7376723,
    "lng": -96.3040839
  },
  {
    "id": "13807",
    "name": "CVS",
    "address": "3798 FOREST LANE, DALLAS, TX, 75244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.909017,
    "lng": -96.8519737
  },
  {
    "id": "13806",
    "name": "CVS",
    "address": "1401 HILLCREST RD., MOBILE, AL, 36695",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6606842,
    "lng": -88.1899919
  },
  {
    "id": "13805",
    "name": "CVS",
    "address": "101 N. RUFE SNOW DR., KELLER, TX, 76248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9348473,
    "lng": -97.2285024
  },
  {
    "id": "13804",
    "name": "CVS",
    "address": "2996 E. HWY 501, CONWAY, SC, 29526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7753376,
    "lng": -78.9843237
  },
  {
    "id": "13803",
    "name": "CVS",
    "address": "8559 US 42 HWY., FLORENCE, KY, 41042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9729021,
    "lng": -84.6612349
  },
  {
    "id": "13802",
    "name": "CVS",
    "address": "6832 SNIDER PLAZA, DALLAS, TX, 75205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.849139,
    "lng": -96.7875131
  },
  {
    "id": "13801",
    "name": "CVS",
    "address": "5848 HWY 124 WEST, HOSCHTON, GA, 30548",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1083325,
    "lng": -83.6994042
  },
  {
    "id": "13800",
    "name": "CVS",
    "address": "2603 W BERRY ST, FORT WORTH, TX, 76109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7055375,
    "lng": -97.3551163
  },
  {
    "id": "13799",
    "name": "CVS",
    "address": "7200 BOULEVARD 26, RICHLAND HILLS, TX, 76180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8241272,
    "lng": -97.2263494
  },
  {
    "id": "13798",
    "name": "CVS",
    "address": "4747 RESEARCH FOREST DR STE 450, THE WOODLANDS, TX, 77381",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.185213,
    "lng": -95.4904802
  },
  {
    "id": "13797",
    "name": "CVS",
    "address": "1800 BROWN BLVD, ARLINGTON, TX, 76006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7729043,
    "lng": -97.0824616
  },
  {
    "id": "13796",
    "name": "CVS",
    "address": "930 MONTAUK HWY, COPIAGUE, NY, 11726",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6682903,
    "lng": -73.3922594
  },
  {
    "id": "13795",
    "name": "CVS",
    "address": "3605 WALDEN DRIVE, LEXINGTON, KY, 40517",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9827239,
    "lng": -84.496859
  },
  {
    "id": "13794",
    "name": "CVS",
    "address": "312 FAYETTE STREET, MANLIUS, NY, 13104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0050044,
    "lng": -75.9829251
  },
  {
    "id": "13793",
    "name": "CVS",
    "address": "300 MORGAN ST., LA GRANGE, GA, 30241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0403441,
    "lng": -85.0289488
  },
  {
    "id": "13792",
    "name": "CVS",
    "address": "4849 WILLIAM FLYNN HWY., ALLISON PARK, PA, 15101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5993494,
    "lng": -79.9480807
  },
  {
    "id": "13791",
    "name": "CVS",
    "address": "3306 WEST PALMETTO ST., FLORENCE, SC, 29501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1676519,
    "lng": -79.8453864
  },
  {
    "id": "13790",
    "name": "CVS",
    "address": "426 21ST AVE SOUTH, NASHVILLE, TN, 37203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.145697,
    "lng": -86.7993069
  },
  {
    "id": "13789",
    "name": "CVS",
    "address": "13510 W. HIGHWAY 290, AUSTIN, TX, 78737",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1973162,
    "lng": -97.9983318
  },
  {
    "id": "13788",
    "name": "CVS",
    "address": "2323 MURDOCH AVE., PARKERSBURG, WV, 26101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2822103,
    "lng": -81.5490585
  },
  {
    "id": "13787",
    "name": "CVS",
    "address": "9620 WHITE SETTLEMENT RD, FORT WORTH, TX, 76108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7629622,
    "lng": -97.484545
  },
  {
    "id": "13786",
    "name": "CVS",
    "address": "36115 GOODWIN DRIVE, LOCUST GROVE, VA, 22508",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3491609,
    "lng": -77.7465493
  },
  {
    "id": "13785",
    "name": "CVS",
    "address": "4203 PLANK RD., FREDERICKSBURG, VA, 22407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2892629,
    "lng": -77.5325611
  },
  {
    "id": "13784",
    "name": "CVS",
    "address": "612 MERRIMON AVE., ASHEVILLE, NC, 28804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6197639,
    "lng": -82.5548552
  },
  {
    "id": "13783",
    "name": "CVS",
    "address": "855 HANES MALL BLVD., WINSTON SALEM, NC, 27103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0618824,
    "lng": -80.3088601
  },
  {
    "id": "13782",
    "name": "CVS",
    "address": "1180 N. BRIGHT LEAF BLVD., SMITHFIELD, NC, 27577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5180806,
    "lng": -78.3159856
  },
  {
    "id": "13781",
    "name": "CVS",
    "address": "31-01 DITMARS BLVD., ASTORIA, NY, 11105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7760652,
    "lng": -73.9103317
  },
  {
    "id": "13780",
    "name": "CVS",
    "address": "1888 BOILING SPRINGS ROAD, BOILING SPRINGS, SC, 29316",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0165437,
    "lng": -81.9601725
  },
  {
    "id": "13779",
    "name": "CVS",
    "address": "625 E. ROOSEVELT BOULEVARD, MONROE, NC, 28112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9757654,
    "lng": -80.5192304
  },
  {
    "id": "13778",
    "name": "CVS",
    "address": "9075 LEGACY DR., FRISCO, TX, 75033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1539077,
    "lng": -96.8487522
  },
  {
    "id": "13777",
    "name": "CVS",
    "address": "720 ROUND HILL DRIVE, ORANGE, VA, 22960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2602174,
    "lng": -78.117912
  },
  {
    "id": "13776",
    "name": "CVS",
    "address": "23743 JACKSON AVE., MURRIETA, CA, 92562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.584909,
    "lng": -117.2195664
  },
  {
    "id": "13775",
    "name": "CVS",
    "address": "3011 E SHIELDS AVE, FRESNO, CA, 93726",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7804274,
    "lng": -119.7743788
  },
  {
    "id": "13774",
    "name": "CVS",
    "address": "1309 HIGHWAY 210, SNEADS FERRY, NC, 28460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5256545,
    "lng": -77.4344692
  },
  {
    "id": "13773",
    "name": "CVS",
    "address": "605 N. MAIN STREET, FUQUAY-VARINA, NC, 27526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.59185,
    "lng": -78.7937054
  },
  {
    "id": "13772",
    "name": "CVS",
    "address": "1924 STATESVILLE BLVD., SALISBURY, NC, 28144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6941268,
    "lng": -80.5119358
  },
  {
    "id": "13771",
    "name": "CVS",
    "address": "4307 WILGROVE-MINT HILL RD., MINT HILL, NC, 28227",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1801731,
    "lng": -80.6483425
  },
  {
    "id": "13770",
    "name": "CVS",
    "address": "1040 ALAMANCE CHURCH RD, GREENSBORO, NC, 27406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0410157,
    "lng": -79.7712843
  },
  {
    "id": "13769",
    "name": "CVS",
    "address": "4420 KINGWOOD DR, KINGWOOD, TX, 77339",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0491189,
    "lng": -95.1846366
  },
  {
    "id": "13768",
    "name": "CVS",
    "address": "800 JOHN MARSHALL HWY, FRONT ROYAL, VA, 22630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9110282,
    "lng": -78.1839186
  },
  {
    "id": "13767",
    "name": "CVS",
    "address": "100 E SOUTHLAKE BLVD, SOUTHLAKE, TX, 76092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9419771,
    "lng": -97.1502834
  },
  {
    "id": "13766",
    "name": "CVS",
    "address": "1496 EAST AVE, CHICO, CA, 95926",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7616016,
    "lng": -121.8156722
  },
  {
    "id": "13765",
    "name": "CVS",
    "address": "101 LOCUST STREET, LYMAN, SC, 29365",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9549872,
    "lng": -82.1275423
  },
  {
    "id": "13764",
    "name": "CVS",
    "address": "1496 FM 407, LEWISVILLE, TX, 75077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0707321,
    "lng": -97.0350131
  },
  {
    "id": "13763",
    "name": "CVS",
    "address": "385 E BELT LINE RD, CEDAR HILL, TX, 75104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5906946,
    "lng": -96.9367235
  },
  {
    "id": "13762",
    "name": "CVS",
    "address": "100 SW WILSHIRE BLVD, BURLESON, TX, 76028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5450085,
    "lng": -97.3284921
  },
  {
    "id": "13761",
    "name": "CVS",
    "address": "100 E. MAIN ST., WOODVILLE, OH, 43469",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4506927,
    "lng": -83.3626602
  },
  {
    "id": "13760",
    "name": "CVS",
    "address": "6532 SAN FELIPE RD., HOUSTON, TX, 77057",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7509403,
    "lng": -95.4999858
  },
  {
    "id": "13759",
    "name": "CVS",
    "address": "31013 FM 2920 RD., WALLER, TX, 77484",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0624279,
    "lng": -95.9114622
  },
  {
    "id": "13758",
    "name": "CVS",
    "address": "6011 KIRBY DR, HOUSTON, TX, 77005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7179129,
    "lng": -95.4180509
  },
  {
    "id": "13757",
    "name": "CVS",
    "address": "2712 HIGHWAY 365, NEDERLAND, TX, 77627",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9543671,
    "lng": -93.9872448
  },
  {
    "id": "13756",
    "name": "CVS",
    "address": "5401 WASHINGTON AVE, HOUSTON, TX, 77007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7702359,
    "lng": -95.4169522
  },
  {
    "id": "13755",
    "name": "CVS",
    "address": "1350 KINGWOOD DR, KINGWOOD, TX, 77339",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0487958,
    "lng": -95.2348921
  },
  {
    "id": "13754",
    "name": "CVS",
    "address": "6850 EASTEX FWY., BEAUMONT, TX, 77708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1329095,
    "lng": -94.1654941
  },
  {
    "id": "13753",
    "name": "CVS",
    "address": "14525 S. PADRE ISLAND DR., CORPUS CHRISTI, TX, 78418",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.6184018,
    "lng": -97.2227318
  },
  {
    "id": "13752",
    "name": "CVS",
    "address": "290 N DENTON TAP RD, COPPELL, TX, 75019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.976112,
    "lng": -96.9931211
  },
  {
    "id": "13751",
    "name": "CVS",
    "address": "460 NORTHWEST PARKWAY, AZLE, TX, 76020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8998258,
    "lng": -97.5433531
  },
  {
    "id": "13750",
    "name": "CVS",
    "address": "1215 S TRADE DAYS BLVD, CANTON, TX, 75103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5453429,
    "lng": -95.8641956
  },
  {
    "id": "13749",
    "name": "CVS",
    "address": "2242 REPSDORPH RD, SEABROOK, TX, 77586",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.577903,
    "lng": -95.0320742
  },
  {
    "id": "13748",
    "name": "CVS",
    "address": "1220 HORIZON RD, ROCKWALL, TX, 75032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8919819,
    "lng": -96.4721992
  },
  {
    "id": "13747",
    "name": "CVS",
    "address": "801 W. PANOLA ST., CARTHAGE, TX, 75633",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.1570857,
    "lng": -94.3515756
  },
  {
    "id": "13746",
    "name": "CVS",
    "address": "1100 N WALNUT CREEK DR, MANSFIELD, TX, 76063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5837907,
    "lng": -97.1311004
  },
  {
    "id": "13745",
    "name": "CVS",
    "address": "14900 JONES MALTSBERGER RD, SAN ANTONIO, TX, 78247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5775235,
    "lng": -98.4419427
  },
  {
    "id": "13744",
    "name": "CVS",
    "address": "2102 ELDRIDGE RD., SUGAR LAND, TX, 77478",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6514806,
    "lng": -95.6182384
  },
  {
    "id": "13743",
    "name": "CVS",
    "address": "3601 N. BELT LINE RD., SUNNYVALE, TX, 75182",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8146431,
    "lng": -96.596609
  },
  {
    "id": "13742",
    "name": "CVS",
    "address": "700 W. SEMINARY DR., FORT WORTH, TX, 76115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6854372,
    "lng": -97.3326989
  },
  {
    "id": "13741",
    "name": "CVS",
    "address": "2200 COIT RD., PLANO, TX, 75075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0273533,
    "lng": -96.7693915
  },
  {
    "id": "13740",
    "name": "CVS",
    "address": "2900 CENTRAL DR, BEDFORD, TX, 76021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8525996,
    "lng": -97.1314067
  },
  {
    "id": "13739",
    "name": "CVS",
    "address": "815 W. MAIN ST., TOMBALL, TX, 77375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0932627,
    "lng": -95.6233709
  },
  {
    "id": "13738",
    "name": "CVS",
    "address": "2626 EAST 5TH ST., TYLER, TX, 75701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3330896,
    "lng": -95.2667449
  },
  {
    "id": "13737",
    "name": "CVS",
    "address": "965 NORTH JUDGE ELY BLVD., ABILENE, TX, 79601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4593225,
    "lng": -99.7053723
  },
  {
    "id": "13736",
    "name": "CVS",
    "address": "2102 AIRLINE RD, CORPUS CHRISTI, TX, 78414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.691301,
    "lng": -97.3629011
  },
  {
    "id": "13735",
    "name": "CVS",
    "address": "601 S JEFFERSON AVE, MOUNT PLEASANT, TX, 75455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1502711,
    "lng": -94.9673163
  },
  {
    "id": "13734",
    "name": "CVS",
    "address": "23865 FM 1314 RD., PORTER, TX, 77365",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1052519,
    "lng": -95.2502445
  },
  {
    "id": "13733",
    "name": "CVS",
    "address": "3430 LAKEVIEW PKWY, ROWLETT, TX, 75088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9070725,
    "lng": -96.5702171
  },
  {
    "id": "13732",
    "name": "CVS",
    "address": "8555 FERGUSON RD., DALLAS, TX, 75228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8118977,
    "lng": -96.7023841
  },
  {
    "id": "13731",
    "name": "CVS",
    "address": "8317 LOUETTA RD, SPRING, TX, 77379",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0118728,
    "lng": -95.5393358
  },
  {
    "id": "13730",
    "name": "CVS",
    "address": "4775 W PANTHER CREEK DR STE A-100, THE WOODLANDS, TX, 77381",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1679385,
    "lng": -95.5039847
  },
  {
    "id": "13729",
    "name": "CVS",
    "address": "1279 W. MAIN ST., GUN BARREL CITY, TX, 75156",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3302733,
    "lng": -96.1353855
  },
  {
    "id": "13728",
    "name": "CVS",
    "address": "20030 W. LAKE HOUSTON PKWY, HUMBLE, TX, 77346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0087558,
    "lng": -95.1714938
  },
  {
    "id": "13727",
    "name": "CVS",
    "address": "10014 GARLAND RD, DALLAS, TX, 75218",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8381247,
    "lng": -96.6956014
  },
  {
    "id": "13726",
    "name": "CVS",
    "address": "48 PORTLAND RD., KENNEBUNK, ME, 4043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3938404,
    "lng": -70.5339193
  },
  {
    "id": "13725",
    "name": "CVS",
    "address": "102 E. MULBERRY ST., KAUFMAN, TX, 75142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5886392,
    "lng": -96.3085273
  },
  {
    "id": "13724",
    "name": "CVS",
    "address": "103 S.W. MILITARY DR., SAN ANTONIO, TX, 78221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.3572567,
    "lng": -98.4918783
  },
  {
    "id": "13723",
    "name": "CVS",
    "address": "7900 S MAIN, HOUSTON, TX, 77025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6946563,
    "lng": -95.4152685
  },
  {
    "id": "13722",
    "name": "CVS",
    "address": "4700 BERGENLINE AVE, UNION CITY, NJ, 7087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7811677,
    "lng": -74.0217165
  },
  {
    "id": "13721",
    "name": "CVS",
    "address": "3901 PELHAM RD., GREENVILLE, SC, 29615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8603354,
    "lng": -82.2652044
  },
  {
    "id": "13720",
    "name": "CVS",
    "address": "1010 HWY 17 NORTH, NORTH MYRTLE BEACH, SC, 29582",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8371458,
    "lng": -78.6676634
  },
  {
    "id": "13719",
    "name": "CVS",
    "address": "1942 MONTAGUE AVENUE EXT., GREENWOOD, SC, 29649",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2267907,
    "lng": -82.1954086
  },
  {
    "id": "13718",
    "name": "CVS",
    "address": "63 NEWPORT AVE, RUMFORD, RI, 2916",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8580672,
    "lng": -71.3554845
  },
  {
    "id": "13717",
    "name": "CVS",
    "address": "5006 SOUTHPORT CROSSING WAY, SOUTHPORT, NC, 28461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9539325,
    "lng": -78.0517048
  },
  {
    "id": "13716",
    "name": "CVS",
    "address": "3011 NORTH MAIN STREET, LAS CRUCES, NM, 88001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3417507,
    "lng": -106.7757609
  },
  {
    "id": "13715",
    "name": "CVS",
    "address": "4460 MAYFIELD RD., SOUTH EUCLID, OH, 44121",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5195183,
    "lng": -81.5188831
  },
  {
    "id": "13714",
    "name": "CVS",
    "address": "1101 S. CROATAN HWY, KILL DEVIL HILLS, NC, 27948",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0052722,
    "lng": -75.6552206
  },
  {
    "id": "13713",
    "name": "CVS",
    "address": "600 S. MAIN ST., PO BOX 150, KING, NC, 27021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.267507,
    "lng": -80.3615585
  },
  {
    "id": "13712",
    "name": "CVS",
    "address": "5712 CASTLE HAYNE RD., CASTLE HAYNE, NC, 28429",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.354049,
    "lng": -77.8994701
  },
  {
    "id": "13711",
    "name": "CVS",
    "address": "2100 AUGUSTA ST., GREENVILLE, SC, 29605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.824258,
    "lng": -82.3944236
  },
  {
    "id": "13710",
    "name": "CVS",
    "address": "901 DOW RD., CAROLINA BEACH, NC, 28428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0465887,
    "lng": -77.9001843
  },
  {
    "id": "13709",
    "name": "CVS",
    "address": "103 CATAWBA RD, HAVELOCK, NC, 28532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.911134,
    "lng": -76.9364433
  },
  {
    "id": "13708",
    "name": "CVS",
    "address": "2908 EMANUEL CHURCH ROAD, WEST COLUMBIA, SC, 29170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9455612,
    "lng": -81.1689426
  },
  {
    "id": "13707",
    "name": "CVS",
    "address": "520 BOULEVARD SE, ATLANTA, GA, 30312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7407548,
    "lng": -84.3675947
  },
  {
    "id": "13706",
    "name": "CVS",
    "address": "85 MATHEWS DR, HILTON HEAD ISLAND, SC, 29926",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2135606,
    "lng": -80.7017128
  },
  {
    "id": "13705",
    "name": "CVS",
    "address": "726 EAST MAIN ST., COBLESKILL, NY, 12043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6791634,
    "lng": -74.476604
  },
  {
    "id": "13704",
    "name": "CVS",
    "address": "36 NORTH WEST BLVD, NEWTON, NC, 28658",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6655323,
    "lng": -81.2311544
  },
  {
    "id": "13703",
    "name": "CVS",
    "address": "11314 US 15 501 NORTH, CHAPEL HILL, NC, 27517",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8457874,
    "lng": -79.0901451
  },
  {
    "id": "13702",
    "name": "CVS",
    "address": "1123 KILDAIRE FARM RD., CARY, NC, 27511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7689843,
    "lng": -78.7812269
  },
  {
    "id": "13701",
    "name": "CVS",
    "address": "6470 N NEW BRAUNFELS AVE, SAN ANTONIO, TX, 78209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4896567,
    "lng": -98.4587414
  },
  {
    "id": "13700",
    "name": "CVS",
    "address": "915 W. STUART DR., HILLSVILLE, VA, 24343",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7551739,
    "lng": -80.7429646
  },
  {
    "id": "13699",
    "name": "CVS",
    "address": "C1 CALLE PARKSIDE 4, GUAYNABO, PR, 968",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4089282,
    "lng": -66.1034292
  },
  {
    "id": "13698",
    "name": "CVS",
    "address": "2501 SECOND LOOP RD., FLORENCE, SC, 29501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1768867,
    "lng": -79.8107197
  },
  {
    "id": "13697",
    "name": "CVS",
    "address": "7202 SAN PEDRO, SAN ANTONIO, TX, 78216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5140238,
    "lng": -98.4983534
  },
  {
    "id": "13696",
    "name": "CVS",
    "address": "400 E END BLVD NORTH, MARSHALL, TX, 75670",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5490126,
    "lng": -94.3491654
  },
  {
    "id": "13695",
    "name": "CVS",
    "address": "1101 EAST HIGHWAY 377, GRANBURY, TX, 76048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4343115,
    "lng": -97.7722747
  },
  {
    "id": "13694",
    "name": "CVS",
    "address": "1616 S MASON RD, KATY, TX, 77450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.758127,
    "lng": -95.7524055
  },
  {
    "id": "13693",
    "name": "CVS",
    "address": "796 RIDGEWAY AVE., SIGNAL MOUNTAIN, TN, 37377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1218325,
    "lng": -85.3433807
  },
  {
    "id": "13692",
    "name": "CVS",
    "address": "11661 PRESTON RD. STE 218, DALLAS, TX, 75230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9091348,
    "lng": -96.8048323
  },
  {
    "id": "13691",
    "name": "CVS",
    "address": "2469 BAY AREA BLVD, HOUSTON, TX, 77058",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5746382,
    "lng": -95.108929
  },
  {
    "id": "13690",
    "name": "CVS",
    "address": "13829 SOUTHWEST FWY, SUGAR LAND, TX, 77478",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6213776,
    "lng": -95.5986967
  },
  {
    "id": "13689",
    "name": "CVS",
    "address": "4333 WESTERN CENTER BLVD, FORT WORTH, TX, 76137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.861858,
    "lng": -97.291337
  },
  {
    "id": "13688",
    "name": "CVS",
    "address": "3402 50TH ST., LUBBOCK, TX, 79413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5492819,
    "lng": -101.8887428
  },
  {
    "id": "13687",
    "name": "CVS",
    "address": "723 LOMBARD ROAD, RED LION, PA, 17356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9169927,
    "lng": -76.6288614
  },
  {
    "id": "13686",
    "name": "CVS",
    "address": "3403 82ND ST., LUBBOCK, TX, 79423",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5193277,
    "lng": -101.8884656
  },
  {
    "id": "13685",
    "name": "CVS",
    "address": "3402 SLIDE RD., LUBBOCK, TX, 79414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5626762,
    "lng": -101.9231472
  },
  {
    "id": "13684",
    "name": "CVS",
    "address": "4580 BUFFALO GAP RD, ABILENE, TX, 79606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3950915,
    "lng": -99.7630263
  },
  {
    "id": "13683",
    "name": "CVS",
    "address": "208 HWY 515 E, BLAIRSVILLE, GA, 30512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8792282,
    "lng": -83.9559841
  },
  {
    "id": "13682",
    "name": "CVS",
    "address": "18460 N. 7TH ST., PHOENIX, AZ, 85022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6541544,
    "lng": -112.0661739
  },
  {
    "id": "13681",
    "name": "CVS",
    "address": "1206 N. GRAVEL PIKE, ZIEGLERSVILLE, PA, 19492",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2762234,
    "lng": -75.4798954
  },
  {
    "id": "13680",
    "name": "CVS",
    "address": "1678 SUSQUEHANNA RD., DRESHER, PA, 19025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1432046,
    "lng": -75.1694041
  },
  {
    "id": "13679",
    "name": "CVS",
    "address": "7285 ALIANTE PKWY., NORTH LAS VEGAS, NV, 89084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2927344,
    "lng": -115.1849327
  },
  {
    "id": "13678",
    "name": "CVS",
    "address": "520 E MAIN ST, ALLEN, TX, 75002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.099899,
    "lng": -96.6601107
  },
  {
    "id": "13677",
    "name": "CVS",
    "address": "900 N. HAMILTON RD., GAHANNA, OH, 43230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0405304,
    "lng": -82.8641465
  },
  {
    "id": "13676",
    "name": "CVS",
    "address": "3201 BEE CAVES RD #132, AUSTIN, TX, 78746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2730619,
    "lng": -97.8005191
  },
  {
    "id": "13675",
    "name": "CVS",
    "address": "4201 MONTANO RD., NW, ALBUQUERQUE, NM, 87120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1504158,
    "lng": -106.6865108
  },
  {
    "id": "13674",
    "name": "CVS",
    "address": "3 S. PENNELL RD., MEDIA, PA, 19063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9114768,
    "lng": -75.4397369
  },
  {
    "id": "13673",
    "name": "CVS",
    "address": "306 APPLEGARTH RD., MONROE TOWNSHIP, NJ, 8831",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3153785,
    "lng": -74.4728492
  },
  {
    "id": "13672",
    "name": "CVS",
    "address": "3614 CAMP BOWIE BLVD., FORT WORTH, TX, 76107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7475372,
    "lng": -97.3719991
  },
  {
    "id": "13671",
    "name": "CVS",
    "address": "689 DEPOT ST., NORTH EASTON, MA, 2356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0249382,
    "lng": -71.1192746
  },
  {
    "id": "13670",
    "name": "CVS",
    "address": "1500 W CHURCH ST, LIVINGSTON, TX, 77351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.7115109,
    "lng": -94.9501075
  },
  {
    "id": "13669",
    "name": "CVS",
    "address": "5905 US HWY. 301 S., RIVERVIEW, FL, 33578",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8945042,
    "lng": -82.3395091
  },
  {
    "id": "13668",
    "name": "CVS",
    "address": "4131 ALDINE MAIL RTE., HOUSTON, TX, 77039",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9030991,
    "lng": -95.3330447
  },
  {
    "id": "13667",
    "name": "CVS",
    "address": "277 W. SR 436, ALTAMONTE SPRINGS, FL, 32714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.6619854,
    "lng": -81.3935793
  },
  {
    "id": "13666",
    "name": "CVS",
    "address": "400 MASSACHUSETTS AVE., NW, WASHINGTON, DC, 20001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9000581,
    "lng": -77.0171333
  },
  {
    "id": "13665",
    "name": "CVS",
    "address": "4715 RICE MINE RD. NE, TUSCALOOSA, AL, 35406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2608185,
    "lng": -87.5144671
  },
  {
    "id": "13664",
    "name": "CVS",
    "address": "4736 EASTERN VALLEY RD., MCCALLA, AL, 35111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3303472,
    "lng": -86.9989626
  },
  {
    "id": "13663",
    "name": "CVS",
    "address": "3310 SISKEY PKWY., MATTHEWS, NC, 28105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0822771,
    "lng": -80.7272452
  },
  {
    "id": "13662",
    "name": "CVS",
    "address": "1950 W. WILLIAM CANNON DR., AUSTIN, TX, 78745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.203289,
    "lng": -97.8061842
  },
  {
    "id": "13661",
    "name": "CVS",
    "address": "230 EAST AVENUE NORTH, GLENDALE HEIGHTS, IL, 60139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9034481,
    "lng": -88.0808316
  },
  {
    "id": "13660",
    "name": "CVS",
    "address": "210 NORTH BUSINESS IH 35, NEW BRAUNFELS, TX, 78130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6933024,
    "lng": -98.1100921
  },
  {
    "id": "13659",
    "name": "CVS",
    "address": "1970 YOSEMITE PARKWAY, MERCED, CA, 95341",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2938493,
    "lng": -120.4522355
  },
  {
    "id": "13658",
    "name": "CVS",
    "address": "3811 OLD SPANISH TRAIL, HOUSTON, TX, 77021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.702719,
    "lng": -95.3601917
  },
  {
    "id": "13657",
    "name": "CVS",
    "address": "6300 WEDGEWOOD RD., NORTH, MAPLE GROVE, MN, 55311",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0694906,
    "lng": -93.4502794
  },
  {
    "id": "13656",
    "name": "CVS",
    "address": "4100 STATE HWY 121,, CARROLLTON, TX, 75010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0223868,
    "lng": -96.9328544
  },
  {
    "id": "13655",
    "name": "CVS",
    "address": "2314 EAST EXPRESSWAY 83, MISSION, TX, 78572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1952444,
    "lng": -98.2889272
  },
  {
    "id": "13654",
    "name": "CVS",
    "address": "800 BROWNSWITCH RD., SLIDELL, LA, 70458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3109442,
    "lng": -89.7465985
  },
  {
    "id": "13653",
    "name": "CVS",
    "address": "452 ROUTE 9, WARETOWN, NJ, 8758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7908809,
    "lng": -74.194728
  },
  {
    "id": "13652",
    "name": "CVS",
    "address": "755 DURHAM RD, NEWTOWN, PA, 18940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2787478,
    "lng": -74.9932936
  },
  {
    "id": "13651",
    "name": "CVS",
    "address": "102 E US HIGHWAY 20, MIDDLEBURY, IN, 46540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6546163,
    "lng": -85.7041543
  },
  {
    "id": "13650",
    "name": "CVS",
    "address": "17307 BULVERDE RD., SAN ANTONIO, TX, 78247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5987292,
    "lng": -98.4188509
  },
  {
    "id": "13649",
    "name": "CVS",
    "address": "2250 SEAMANS NECK ROAD, SEAFORD, NY, 11783",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6658152,
    "lng": -73.490575
  },
  {
    "id": "13648",
    "name": "CVS",
    "address": "246 NORWOOD AVE., OAKHURST, NJ, 7755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.26018,
    "lng": -74.0011837
  },
  {
    "id": "13647",
    "name": "CVS",
    "address": "101 S. NORTHWEST HWY., BARRINGTON, IL, 60010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1533959,
    "lng": -88.1279948
  },
  {
    "id": "13646",
    "name": "CVS",
    "address": "5730 W. MAIN ST., DOTHAN, AL, 36305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.2407928,
    "lng": -85.4802158
  },
  {
    "id": "13645",
    "name": "CVS",
    "address": "1621 SW 13TH ST., GAINESVILLE, FL, 32608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6357778,
    "lng": -82.338986
  },
  {
    "id": "13644",
    "name": "CVS",
    "address": "4800 HWY. 61, WHITE BEAR LAKE, MN, 55110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.086751,
    "lng": -93.007845
  },
  {
    "id": "13643",
    "name": "CVS",
    "address": "6651 N. MILITARY TRAIL, SUITE 100, BOCA RATON, FL, 33496",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4089928,
    "lng": -80.1221975
  },
  {
    "id": "13642",
    "name": "CVS",
    "address": "221 MAIN ST., LODI, NJ, 7644",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8818351,
    "lng": -74.0842028
  },
  {
    "id": "13641",
    "name": "CVS",
    "address": "1229 W. IL ROUTE 134, ROUND LAKE, IL, 60073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3630641,
    "lng": -88.1125871
  },
  {
    "id": "13640",
    "name": "CVS",
    "address": "350 PRINCETON HIGHTSTOWN RD, WEST WINDSOR, NJ, 8550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2900307,
    "lng": -74.5819349
  },
  {
    "id": "13639",
    "name": "CVS",
    "address": "2884 HWY 17 NORTH, MOUNT PLEASANT, SC, 29466",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8591619,
    "lng": -79.7962713
  },
  {
    "id": "13638",
    "name": "CVS",
    "address": "13845 CONLAN CIRCLE, CHARLOTTE, NC, 28277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0559115,
    "lng": -80.8511849
  },
  {
    "id": "13637",
    "name": "CVS",
    "address": "605 W. CAMPBELL RD., RICHARDSON, TX, 75080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9775774,
    "lng": -96.7411292
  },
  {
    "id": "13636",
    "name": "CVS",
    "address": "8470 HWY 72 WEST, MADISON, AL, 35758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7494183,
    "lng": -86.7682242
  },
  {
    "id": "13635",
    "name": "CVS",
    "address": "5603 FM1960 W, HOUSTON, TX, 77069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9788701,
    "lng": -95.5135961
  },
  {
    "id": "13634",
    "name": "CVS",
    "address": "8000 N. SAM HOUSTON PKWY EAST., HUMBLE, TX, 77396",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9377711,
    "lng": -95.2695353
  },
  {
    "id": "13633",
    "name": "CVS",
    "address": "6701 MINERAL POINT RD, MADISON, WI, 53705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0602004,
    "lng": -89.4976197
  },
  {
    "id": "13632",
    "name": "CVS",
    "address": "6670 STAGE RD, BARTLETT, TN, 38134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2053261,
    "lng": -89.8414407
  },
  {
    "id": "13631",
    "name": "CVS",
    "address": "1855 W. IRVING PARK RD., SCHAUMBURG, IL, 60193",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0023459,
    "lng": -88.1266732
  },
  {
    "id": "13630",
    "name": "CVS",
    "address": "16760 W. DIVISION ST., LOCKPORT, IL, 60441",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5838926,
    "lng": -88.0252263
  },
  {
    "id": "13629",
    "name": "CVS",
    "address": "291 S. COOMBS ST, NAPA, CA, 94559",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2821988,
    "lng": -122.2896225
  },
  {
    "id": "13628",
    "name": "CVS",
    "address": "599 STATE RD., WESTPORT, MA, 2790",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6600115,
    "lng": -71.0838274
  },
  {
    "id": "13627",
    "name": "CVS",
    "address": "8197 WESTSIDE BLVD., FULTON, MD, 20759",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1481085,
    "lng": -76.9089343
  },
  {
    "id": "13626",
    "name": "CVS",
    "address": "5449 JACKSON RD., ANN ARBOR, MI, 48103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2875718,
    "lng": -83.8376073
  },
  {
    "id": "13625",
    "name": "CVS",
    "address": "1400 E. ROOSEVELT RD., WHEATON, IL, 60187",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8585485,
    "lng": -88.0864886
  },
  {
    "id": "13624",
    "name": "CVS",
    "address": "3015 E. LINCOLN HIGHWAY, THORNDALE, PA, 19372",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9935833,
    "lng": -75.7639578
  },
  {
    "id": "13623",
    "name": "CVS",
    "address": "350 SOUTH BROADWAY, TARRYTOWN, NY, 10591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0645819,
    "lng": -73.861111
  },
  {
    "id": "13622",
    "name": "CVS",
    "address": "9509 SAN JOSE BLVD., JACKSONVILLE, FL, 32257",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2050104,
    "lng": -81.6165562
  },
  {
    "id": "13621",
    "name": "CVS",
    "address": "2780 ESPLANADE, CHICO, CA, 95973",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7610553,
    "lng": -121.8647285
  },
  {
    "id": "13620",
    "name": "CVS",
    "address": "2910 WESTHEIMER RD, HOUSTON, TX, 77098",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7425109,
    "lng": -95.4217266
  },
  {
    "id": "13619",
    "name": "CVS",
    "address": "157 LOUDON RD., CONCORD, NH, 3301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2169188,
    "lng": -71.5066451
  },
  {
    "id": "13618",
    "name": "CVS",
    "address": "11600 SHADOW CREEK PKWY., PEARLAND, TX, 77584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5785529,
    "lng": -95.3987817
  },
  {
    "id": "13617",
    "name": "CVS",
    "address": "60 S. HOLIDAY RD., MIRAMAR BEACH, FL, 32550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3843033,
    "lng": -86.3809541
  },
  {
    "id": "13616",
    "name": "CVS",
    "address": "70 WEST STATE ST, GRANBY, MA, 1033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2459805,
    "lng": -72.5440145
  },
  {
    "id": "13615",
    "name": "CVS",
    "address": "3633 BUNKER LAKE BLVD., NW, ANDOVER, MN, 55304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.2203266,
    "lng": -93.3582571
  },
  {
    "id": "13614",
    "name": "CVS",
    "address": "300 CANAL STREET, SALEM, MA, 1970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5010408,
    "lng": -70.896627
  },
  {
    "id": "13613",
    "name": "CVS",
    "address": "150 ROCHELLE AVE., ROCHELLE PARK, NJ, 7662",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9001811,
    "lng": -74.0778819
  },
  {
    "id": "13612",
    "name": "CVS",
    "address": "49 WRIGHT AVENUE, WILLISTON, VT, 5495",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4468281,
    "lng": -73.1116822
  },
  {
    "id": "13611",
    "name": "CVS",
    "address": "1100 NEW JERSEY AVE., S.E., WASHINGTON, DC, 20003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8770439,
    "lng": -77.0038162
  },
  {
    "id": "13610",
    "name": "CVS",
    "address": "9101 CAROTHERS PARKWAY, FRANKLIN, TN, 37067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9591215,
    "lng": -86.8026537
  },
  {
    "id": "13609",
    "name": "CVS",
    "address": "3313 BRIGANTINE BLVD, BRIGANTINE, NJ, 8203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3952912,
    "lng": -74.3885519
  },
  {
    "id": "13608",
    "name": "CVS",
    "address": "3013 MARINA BAY DR., LEAGUE CITY, TX, 77573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5405956,
    "lng": -95.0621866
  },
  {
    "id": "13607",
    "name": "CVS",
    "address": "47 LAKE AVENUE EXTENSION, DANBURY, CT, 6811",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3871924,
    "lng": -73.4889791
  },
  {
    "id": "13606",
    "name": "CVS",
    "address": "110 W. 20TH ST., HOUSTON, TX, 77008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8036639,
    "lng": -95.3988226
  },
  {
    "id": "13605",
    "name": "CVS",
    "address": "231 N. GRAHAM STREET, CHARLOTTE, NC, 28202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.23261,
    "lng": -80.8450929
  },
  {
    "id": "13604",
    "name": "CVS",
    "address": "16961 BEACH BOULEVARD, HUNTINGTON BEACH, CA, 92647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7159839,
    "lng": -117.9896046
  },
  {
    "id": "13603",
    "name": "CVS",
    "address": "132 BRONX RIVER ROAD, YONKERS, NY, 10704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9050552,
    "lng": -73.8579869
  },
  {
    "id": "13602",
    "name": "CVS",
    "address": "3303 S. RURAL, TEMPE, AZ, 85282",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3922429,
    "lng": -111.9258865
  },
  {
    "id": "13601",
    "name": "CVS",
    "address": "1204 DR. MLK EXPRESSWAY, ANDALUSIA, AL, 36420",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3181664,
    "lng": -86.4607106
  },
  {
    "id": "13600",
    "name": "CVS",
    "address": "100 CARRIAGE OAKS DR., TYRONE, GA, 30290",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.490682,
    "lng": -84.5853043
  },
  {
    "id": "13599",
    "name": "CVS",
    "address": "5095 MOUNT ZION PKWY., STOCKBRIDGE, GA, 30281",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5433727,
    "lng": -84.2837147
  },
  {
    "id": "13598",
    "name": "CVS",
    "address": "55 RAY THORINGTON RD., MONTGOMERY, AL, 36117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.338189,
    "lng": -86.1614253
  },
  {
    "id": "13597",
    "name": "CVS",
    "address": "6310 BURLINGTON RD., WHITSETT, NC, 27377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0626449,
    "lng": -79.609808
  },
  {
    "id": "13596",
    "name": "CVS",
    "address": "5895 REIDVILLE RD., MOORE, SC, 29369",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8864267,
    "lng": -82.0661223
  },
  {
    "id": "13595",
    "name": "CVS",
    "address": "105 EAST COLLEGE AVE., SHELBY, NC, 28152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2509666,
    "lng": -81.6659159
  },
  {
    "id": "13594",
    "name": "CVS",
    "address": "4300 NC HIGHWAY 49 S, HARRISBURG, NC, 28075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3225811,
    "lng": -80.6489061
  },
  {
    "id": "13593",
    "name": "CVS",
    "address": "904 SOUTH 5TH ST., MEBANE, NC, 27302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0771721,
    "lng": -79.2763426
  },
  {
    "id": "13592",
    "name": "CVS",
    "address": "10100 SOUTH MAIN ST, ARCHDALE, NC, 27263",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9017776,
    "lng": -79.951053
  },
  {
    "id": "13591",
    "name": "CVS",
    "address": "7295 BEACH DRIVE, OCEAN ISLE BEACH, NC, 28469",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8965322,
    "lng": -78.4866349
  },
  {
    "id": "13590",
    "name": "CVS",
    "address": "3573 HILLSBOROUGH RD., DURHAM, NC, 27705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0217277,
    "lng": -78.9534836
  },
  {
    "id": "13589",
    "name": "CVS",
    "address": "14636 US HWY 17 N, HAMPSTEAD, NC, 28443",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3663544,
    "lng": -77.7111816
  },
  {
    "id": "13588",
    "name": "CVS",
    "address": "801 NORTH FIRST AVE., EVANSVILLE, IN, 47710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9853922,
    "lng": -87.5742649
  },
  {
    "id": "13587",
    "name": "CVS",
    "address": "687 JOHNSON FERRY RD., MARIETTA, GA, 30068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9653756,
    "lng": -84.4123833
  },
  {
    "id": "13586",
    "name": "CVS",
    "address": "2492 HWY 9 EAST, LITTLE RIVER, SC, 29566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8839236,
    "lng": -78.6879619
  },
  {
    "id": "13585",
    "name": "CVS",
    "address": "6504 W LITTLE YORK, HOUSTON, TX, 77040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8668824,
    "lng": -95.488063
  },
  {
    "id": "13584",
    "name": "CVS",
    "address": "450 MAIN STREET, ARMONK, NY, 10504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.127538,
    "lng": -73.712753
  },
  {
    "id": "13583",
    "name": "CVS",
    "address": "2210 FLEMING RD., GREENSBORO, NC, 27410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.126491,
    "lng": -79.9056755
  },
  {
    "id": "13582",
    "name": "CVS",
    "address": "5001 COUNTRY CLUB RD., WINSTON SALEM, NC, 27104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0849974,
    "lng": -80.3482017
  },
  {
    "id": "13581",
    "name": "CVS",
    "address": "2042 RANKIN MILL ROAD, GREENSBORO, NC, 27405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1523147,
    "lng": -79.7098755
  },
  {
    "id": "13580",
    "name": "CVS",
    "address": "18665 FOREST ROAD, LYNCHBURG, VA, 24502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3851419,
    "lng": -79.2421634
  },
  {
    "id": "13579",
    "name": "CVS",
    "address": "2770 LEWISVILLE CLEMMONS RD., CLEMMONS, NC, 27012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0225198,
    "lng": -80.3826676
  },
  {
    "id": "13578",
    "name": "CVS",
    "address": "300 MAN GROVE RD., EMERALD ISLE, NC, 28594",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6639287,
    "lng": -77.0417564
  },
  {
    "id": "13577",
    "name": "CVS",
    "address": "75 N. LAKE HAVASU AVE., LAKE HAVASU CITY, AZ, 86403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.475678,
    "lng": -114.346539
  },
  {
    "id": "13576",
    "name": "CVS",
    "address": "2203 WAYNE MEMORIAL DR., GOLDSBORO, NC, 27534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3987297,
    "lng": -77.9629343
  },
  {
    "id": "13575",
    "name": "CVS",
    "address": "1701 FORT JESSE RD., NORMAL, IL, 61761",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.517119,
    "lng": -88.9517855
  },
  {
    "id": "13574",
    "name": "CVS",
    "address": "150 EAST 42ND ST., NEW YORK, NY, 10017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7509681,
    "lng": -73.9754542
  },
  {
    "id": "13573",
    "name": "CVS",
    "address": "1130 S. VETERANS PKWY, BLOOMINGTON, IL, 61704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4605942,
    "lng": -88.9618079
  },
  {
    "id": "13572",
    "name": "CVS",
    "address": "10317  OCEAN HIGHWAY 17 SOUTH, PAWLEYS ISLAND, SC, 29585",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4378137,
    "lng": -79.1301915
  },
  {
    "id": "13571",
    "name": "CVS",
    "address": "121 MONTICELLO RD., WEAVERVILLE, NC, 28787",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7093598,
    "lng": -82.5785102
  },
  {
    "id": "13570",
    "name": "CVS",
    "address": "4711-5 FOREST DRIVE, COLUMBIA, SC, 29206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0209225,
    "lng": -80.9685493
  },
  {
    "id": "13569",
    "name": "CVS",
    "address": "333 W MILLS ST., COLUMBUS, NC, 28722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2478581,
    "lng": -82.2034361
  },
  {
    "id": "13568",
    "name": "CVS",
    "address": "333 HWY 9 BYPASS, LANCASTER, SC, 29720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7338911,
    "lng": -80.7681612
  },
  {
    "id": "13567",
    "name": "CVS",
    "address": "6601 EVERHART RD STE E, CORPUS CHRISTI, TX, 78413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.6915262,
    "lng": -97.3994848
  },
  {
    "id": "13566",
    "name": "CVS",
    "address": "112 S. MAIN ST. / P.O. BOX 1017, AMHERST, VA, 24521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5884917,
    "lng": -79.05069
  },
  {
    "id": "13565",
    "name": "CVS",
    "address": "550 LANCASTER AVENUE, BERWYN, PA, 19312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0471503,
    "lng": -75.4373405
  },
  {
    "id": "13564",
    "name": "CVS",
    "address": "9805 GEIST CROSSING DR., INDIANAPOLIS, IN, 46256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8997997,
    "lng": -85.9935781
  },
  {
    "id": "13563",
    "name": "CVS",
    "address": "26 E MAIN ST, PAWLING, NY, 12564",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5621189,
    "lng": -73.5996221
  },
  {
    "id": "13562",
    "name": "CVS",
    "address": "4801 S ALAMEDA ST, CORPUS CHRISTI, TX, 78412",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7236345,
    "lng": -97.3612358
  },
  {
    "id": "13561",
    "name": "CVS",
    "address": "4166 S STAPLES ST, CORPUS CHRISTI, TX, 78411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7256552,
    "lng": -97.3780357
  },
  {
    "id": "13560",
    "name": "CVS",
    "address": "11000 CREEDMOOR RD., RALEIGH, NC, 27614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9432067,
    "lng": -78.6857599
  },
  {
    "id": "13559",
    "name": "CVS",
    "address": "2910 FM 120 W, DENISON, TX, 75020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7616785,
    "lng": -96.5815919
  },
  {
    "id": "13558",
    "name": "CVS",
    "address": "3065 N JOSEY LN STE 64, CARROLLTON, TX, 75007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9996492,
    "lng": -96.8878179
  },
  {
    "id": "13557",
    "name": "CVS",
    "address": "6749 MAIN ST, THE COLONY, TX, 75056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0959663,
    "lng": -96.8932045
  },
  {
    "id": "13556",
    "name": "CVS",
    "address": "8660 US HWY 377 S, BENBROOK, TX, 76126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.514187,
    "lng": -97.6325593
  },
  {
    "id": "13555",
    "name": "CVS",
    "address": "4414 YORK BLVD, LOS ANGELES, CA, 90041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1234888,
    "lng": -118.2202245
  },
  {
    "id": "13554",
    "name": "CVS",
    "address": "506 FIELDER NORTH PLAZA, ARLINGTON, TX, 76012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7515205,
    "lng": -97.1336254
  },
  {
    "id": "13553",
    "name": "CVS",
    "address": "901 E. PIONEER PARKWAY, ARLINGTON, TX, 76010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7087261,
    "lng": -97.0965344
  },
  {
    "id": "13552",
    "name": "CVS",
    "address": "1425 E BUCKINGHAM RD, RICHARDSON, TX, 75081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9313396,
    "lng": -96.7087157
  },
  {
    "id": "13551",
    "name": "CVS",
    "address": "7203 SKILLMAN ST., DALLAS, TX, 75231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8791099,
    "lng": -96.7357274
  },
  {
    "id": "13550",
    "name": "CVS",
    "address": "2610 LAKE AUSTIN BLVD, AUSTIN, TX, 78703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2815344,
    "lng": -97.7750769
  },
  {
    "id": "13549",
    "name": "CVS",
    "address": "7102 CAMPBELL RD, DALLAS, TX, 75248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9786841,
    "lng": -96.785122
  },
  {
    "id": "13548",
    "name": "CVS",
    "address": "9001 WOODWAY DR, WOODWAY, TX, 76712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.4983917,
    "lng": -97.2205694
  },
  {
    "id": "13547",
    "name": "CVS",
    "address": "407 S MAIN ST, WEATHERFORD, TX, 76086",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7542689,
    "lng": -97.7964365
  },
  {
    "id": "13546",
    "name": "CVS",
    "address": "1501 INDEPENDENCE PKWY, PLANO, TX, 75075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.019746,
    "lng": -96.750612
  },
  {
    "id": "13545",
    "name": "CVS",
    "address": "114 EAST GENERAL SCREVEN WAY, HINESVILLE, GA, 31313",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8409799,
    "lng": -81.5969112
  },
  {
    "id": "13544",
    "name": "CVS",
    "address": "8027 KITTY HAWK, CONVERSE, TX, 78109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5357535,
    "lng": -98.3316453
  },
  {
    "id": "13543",
    "name": "CVS",
    "address": "4801 W. BROAD ST., COLUMBUS, OH, 43228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9515788,
    "lng": -83.1298005
  },
  {
    "id": "13542",
    "name": "CVS",
    "address": "819 BARNEGAT AVENUE, SHIP BOTTOM, NJ, 8008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6520043,
    "lng": -74.1807397
  },
  {
    "id": "13541",
    "name": "CVS",
    "address": "4548 E. MAIN ST., WHITEHALL, OH, 43213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9560108,
    "lng": -82.8773115
  },
  {
    "id": "13540",
    "name": "CVS",
    "address": "4405 E RIVERSIDE DR, AUSTIN, TX, 78741",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2328979,
    "lng": -97.7235516
  },
  {
    "id": "13539",
    "name": "CVS",
    "address": "3710 LAMAR AVE, PARIS, TX, 75462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.661172,
    "lng": -95.5085094
  },
  {
    "id": "13538",
    "name": "CVS",
    "address": "3097 TODDS RD., LEXINGTON, KY, 40509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0099281,
    "lng": -84.4240779
  },
  {
    "id": "13537",
    "name": "CVS",
    "address": "2000 HARRODSBURG RD, LEXINGTON, KY, 40503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0258584,
    "lng": -84.5349152
  },
  {
    "id": "13536",
    "name": "CVS",
    "address": "820 N. VERMILION, DANVILLE, IL, 61832",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1381225,
    "lng": -87.630939
  },
  {
    "id": "13535",
    "name": "CVS",
    "address": "401 E. HARRIS, GREENVILLE, IL, 62246",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8869552,
    "lng": -89.4073686
  },
  {
    "id": "13534",
    "name": "CVS",
    "address": "805 S. DIXIE RD., HOOPESTON, IL, 60942",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4592644,
    "lng": -87.6881205
  },
  {
    "id": "13533",
    "name": "CVS",
    "address": "102 SOUTH STATE STREET, WESTVILLE, IL, 61883",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0421471,
    "lng": -87.6390736
  },
  {
    "id": "13532",
    "name": "CVS",
    "address": "225 N. POPLAR ST., CENTRALIA, IL, 62801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.52916,
    "lng": -89.1318163
  },
  {
    "id": "13531",
    "name": "CVS",
    "address": "5300 SOUTH COLONY, THE COLONY, TX, 75056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0836083,
    "lng": -96.8761909
  },
  {
    "id": "13530",
    "name": "CVS",
    "address": "1919 S. LOOP 256, PALESTINE, TX, 75801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.7364134,
    "lng": -95.6092138
  },
  {
    "id": "13529",
    "name": "CVS",
    "address": "5301 BROADWAY, MERRILLVILLE, IN, 46410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.521818,
    "lng": -87.3355397
  },
  {
    "id": "13528",
    "name": "CVS",
    "address": "5765 EAST STATE ROAD 10, DEMOTTE, IN, 46310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1439042,
    "lng": -87.2804064
  },
  {
    "id": "13527",
    "name": "CVS",
    "address": "1615 SOUTH LAKE PARK AVE., HOBART, IN, 46342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5101525,
    "lng": -87.2581977
  },
  {
    "id": "13526",
    "name": "CVS",
    "address": "11115 WEST 133RD STREET, CEDAR LAKE, IN, 46303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3768323,
    "lng": -87.4694517
  },
  {
    "id": "13525",
    "name": "CVS",
    "address": "310 N. HALLECK ST., DEMOTTE, IN, 46310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.204827,
    "lng": -87.1994917
  },
  {
    "id": "13524",
    "name": "CVS",
    "address": "4922 S BROADWAY AVE, TYLER, TX, 75703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2951885,
    "lng": -95.2999184
  },
  {
    "id": "13523",
    "name": "CVS",
    "address": "1520 N GRAND AVE, GAINESVILLE, TX, 76240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6436529,
    "lng": -97.1323202
  },
  {
    "id": "13522",
    "name": "CVS",
    "address": "1320 PARKWAY AVE., EWING, NJ, 8628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2651152,
    "lng": -74.8037834
  },
  {
    "id": "13521",
    "name": "CVS",
    "address": "1212 13TH AVE., MENDOTA, IL, 61342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.554791,
    "lng": -89.1284275
  },
  {
    "id": "13520",
    "name": "CVS",
    "address": "11950 MASON RD., RICHMOND, TX, 77406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.627216,
    "lng": -95.7445872
  },
  {
    "id": "13519",
    "name": "CVS",
    "address": "1102 S. AUSTIN AVE., GEORGETOWN, TX, 78626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6338327,
    "lng": -97.6782965
  },
  {
    "id": "13518",
    "name": "CVS",
    "address": "3569 FAR WEST BLVD., AUSTIN, TX, 78731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3531321,
    "lng": -97.7545301
  },
  {
    "id": "13517",
    "name": "CVS",
    "address": "2402 GUADALUPE ST, AUSTIN, TX, 78705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2878874,
    "lng": -97.7419673
  },
  {
    "id": "13516",
    "name": "CVS",
    "address": "915 N. MARKET ST., MOUNT CARMEL, IL, 62863",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4162994,
    "lng": -87.7642253
  },
  {
    "id": "13515",
    "name": "CVS",
    "address": "8321 W SR 56, WEST BADEN SPRINGS, IN, 47469",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5629339,
    "lng": -86.6131529
  },
  {
    "id": "13514",
    "name": "CVS",
    "address": "402 W. BROADWAY ST., LOOGOOTEE, IN, 47553",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6726352,
    "lng": -86.9153753
  },
  {
    "id": "13513",
    "name": "CVS",
    "address": "610 N. MAIN ST., HUNTINGBURG, IN, 47542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2993618,
    "lng": -86.9559159
  },
  {
    "id": "13512",
    "name": "CVS",
    "address": "1500 HART ST., VINCENNES, IN, 47591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6721386,
    "lng": -87.5171342
  },
  {
    "id": "13511",
    "name": "CVS",
    "address": "200 W. MAIN ST., PETERSBURG, IN, 47567",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4864305,
    "lng": -87.2861557
  },
  {
    "id": "13510",
    "name": "CVS",
    "address": "6103 W. JERSEY AVE., EGG HARBOR TOWNSHIP, NJ, 8234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4191927,
    "lng": -74.6178088
  },
  {
    "id": "13509",
    "name": "CVS",
    "address": "1000 WEST BROADWAY, PRINCETON, IN, 47670",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3558944,
    "lng": -87.5783181
  },
  {
    "id": "13508",
    "name": "CVS",
    "address": "307 E. NATIONAL HWY., WASHINGTON, IN, 47501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6519135,
    "lng": -87.171347
  },
  {
    "id": "13507",
    "name": "CVS",
    "address": "1 CHERRY ST., LAMBERTVILLE, NJ, 8530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3767765,
    "lng": -74.9473636
  },
  {
    "id": "13506",
    "name": "CVS",
    "address": "725 STATE ROUTE 10, RANDOLPH, NJ, 7869",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8593292,
    "lng": -74.590538
  },
  {
    "id": "13505",
    "name": "CVS",
    "address": "20 INDUSTRIAL PARK DR., FERDINAND, IN, 47532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2100175,
    "lng": -86.8662192
  },
  {
    "id": "13504",
    "name": "CVS",
    "address": "8 LANDERS LANE, NEW CASTLE, DE, 19720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6875828,
    "lng": -75.5576463
  },
  {
    "id": "13503",
    "name": "CVS",
    "address": "4490 PARADISE RD., LAS VEGAS, NV, 89169",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1084733,
    "lng": -115.1510265
  },
  {
    "id": "13502",
    "name": "CVS",
    "address": "1099 W. MAIN ST, LEWISVILLE, TX, 75067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0427481,
    "lng": -97.0201209
  },
  {
    "id": "13501",
    "name": "CVS",
    "address": "701 FERRIS AVE, WAXAHACHIE, TX, 75165",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3942776,
    "lng": -96.8472863
  },
  {
    "id": "13500",
    "name": "CVS",
    "address": "1850 W. DUNLAP AVE., PHOENIX, AZ, 85021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5681016,
    "lng": -112.098916
  },
  {
    "id": "13499",
    "name": "CVS",
    "address": "9820 BELAIR ROAD, PERRY HALL, MD, 21128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.419343,
    "lng": -76.4568996
  },
  {
    "id": "13498",
    "name": "CVS",
    "address": "601 W 7TH AVE, CORSICANA, TX, 75110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0885678,
    "lng": -96.4682022
  },
  {
    "id": "13497",
    "name": "CVS",
    "address": "49581 US HIGHWAY 27, DAVENPORT, FL, 33897",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3097234,
    "lng": -81.6666004
  },
  {
    "id": "13496",
    "name": "CVS",
    "address": "16712 JEFFERSON DAVIS HWY., DUMFRIES, VA, 22026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5891602,
    "lng": -77.3057874
  },
  {
    "id": "13495",
    "name": "CVS",
    "address": "1424 N ST, NACOGDOCHES, TX, 75961",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.6154398,
    "lng": -94.6520983
  },
  {
    "id": "13494",
    "name": "CVS",
    "address": "626 WEST FRONT ST., TRAVERSE CITY, MI, 49684",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.7643101,
    "lng": -85.6342532
  },
  {
    "id": "13493",
    "name": "CVS",
    "address": "3601 JACKSBORO HWY, WICHITA FALLS, TX, 76302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8777756,
    "lng": -98.4934648
  },
  {
    "id": "13492",
    "name": "CVS",
    "address": "2674 SOUTH 31ST ST., TEMPLE, TX, 76504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.0749967,
    "lng": -97.3682845
  },
  {
    "id": "13491",
    "name": "CVS",
    "address": "4609 W. MAIN ST., BELLEVILLE, IL, 62226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5422108,
    "lng": -90.0248518
  },
  {
    "id": "13490",
    "name": "CVS",
    "address": "923 W FRANK ST, LUFKIN, TX, 75904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3379429,
    "lng": -94.7389146
  },
  {
    "id": "13489",
    "name": "CVS",
    "address": "601 N VALLEY MILLS DR, WACO, TX, 76710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5297303,
    "lng": -97.1749012
  },
  {
    "id": "13488",
    "name": "CVS",
    "address": "5256 BURNET RD STE B, AUSTIN, TX, 78756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3254142,
    "lng": -97.7403547
  },
  {
    "id": "13487",
    "name": "CVS",
    "address": "159 S CENTRAL EXPY, MCKINNEY, TX, 75070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1972806,
    "lng": -96.6384333
  },
  {
    "id": "13486",
    "name": "CVS",
    "address": "6548 MEADOWBROOK DR, FORT WORTH, TX, 76112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7453438,
    "lng": -97.2168353
  },
  {
    "id": "13485",
    "name": "CVS",
    "address": "221 S. HIGH ST., VERSAILLES, IN, 47042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0702641,
    "lng": -85.2545747
  },
  {
    "id": "13484",
    "name": "CVS",
    "address": "4140 COUNTY ROAD 101 N, PLYMOUTH, MN, 55446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0303999,
    "lng": -93.5065782
  },
  {
    "id": "13483",
    "name": "CVS",
    "address": "1714 CENTER AVE WEST, DILWORTH, MN, 56529",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.8757076,
    "lng": -96.724163
  },
  {
    "id": "13482",
    "name": "CVS",
    "address": "23208 S.R. 30 (FRONT BEACH HWY), PANAMA CITY BEACH, FL, 32413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2639762,
    "lng": -85.9744337
  },
  {
    "id": "13481",
    "name": "CVS",
    "address": "10 N. STATE ST., NORTH VERNON, IN, 47265",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0044351,
    "lng": -85.6268954
  },
  {
    "id": "13480",
    "name": "CVS",
    "address": "153 BROAD ST, MERIDEN, CT, 6450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5253759,
    "lng": -72.7992015
  },
  {
    "id": "13479",
    "name": "CVS",
    "address": "5010 WESLEY ST, GREENVILLE, TX, 75402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.119344,
    "lng": -96.1100459
  },
  {
    "id": "13478",
    "name": "CVS",
    "address": "615 S COCKRELL HILL RD, DUNCANVILLE, TX, 75137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6468192,
    "lng": -96.8920082
  },
  {
    "id": "13477",
    "name": "CVS",
    "address": "2010 EAST APPLE AVE., MUSKEGON, MI, 49442",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2348437,
    "lng": -86.1935308
  },
  {
    "id": "13476",
    "name": "CVS",
    "address": "237 PIPELINE RD, BEDFORD, TX, 76022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8241537,
    "lng": -97.1641271
  },
  {
    "id": "13475",
    "name": "CVS",
    "address": "15270 HWY 105 WEST, MONTGOMERY, TX, 77356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.372802,
    "lng": -95.6339303
  },
  {
    "id": "13474",
    "name": "CVS",
    "address": "110 E. LA GRANGE RD., HANOVER, IN, 47243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7166987,
    "lng": -85.4729769
  },
  {
    "id": "13473",
    "name": "CVS",
    "address": "3020 GREEN VALLEY RD STE B, CAMERON PARK, CA, 95682",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6975543,
    "lng": -121.0029693
  },
  {
    "id": "13472",
    "name": "CVS",
    "address": "4495 WEST STATE ROAD 46, COLUMBUS, IN, 47201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1989614,
    "lng": -85.9741145
  },
  {
    "id": "13471",
    "name": "CVS",
    "address": "509 DAVIS STREET, SCRANTON, PA, 18505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3783107,
    "lng": -75.6932768
  },
  {
    "id": "13470",
    "name": "CVS",
    "address": "31 METAMORA ROAD, BROOKVILLE, IN, 47012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4273142,
    "lng": -85.0137225
  },
  {
    "id": "13469",
    "name": "CVS",
    "address": "701 E MAIN ST, GRAND PRAIRIE, TX, 75050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7455699,
    "lng": -96.9956626
  },
  {
    "id": "13468",
    "name": "CVS",
    "address": "15411 WALLISVILLE RD.,, HOUSTON, TX, 77049",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8091565,
    "lng": -95.1649568
  },
  {
    "id": "13467",
    "name": "CVS",
    "address": "22361 ANTONIO PKWY., RANCHO SANTA MARGARITA, CA, 92688",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6381563,
    "lng": -117.5905798
  },
  {
    "id": "13466",
    "name": "CVS",
    "address": "15333 CULVER BLVD., SUITE #300, IRVINE, CA, 92604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6961631,
    "lng": -117.799404
  },
  {
    "id": "13465",
    "name": "CVS",
    "address": "2003 DAVIDSONVILLE RD., CROFTON, MD, 21114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0186234,
    "lng": -76.6936948
  },
  {
    "id": "13464",
    "name": "CVS",
    "address": "1321 ALLEGHENY ST., JERSEY SHORE, PA, 17740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2015259,
    "lng": -77.2738742
  },
  {
    "id": "13463",
    "name": "CVS",
    "address": "402 RT 313, PERKASIE, PA, 18944",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3823302,
    "lng": -75.2207698
  },
  {
    "id": "13462",
    "name": "CVS",
    "address": "798 US HWY 202, FLEMINGTON, NJ, 8822",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5320002,
    "lng": -74.77846
  },
  {
    "id": "13461",
    "name": "CVS",
    "address": "1512 N LINCOLN AVE, GREENSBURG, IN, 47240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3517908,
    "lng": -85.4796863
  },
  {
    "id": "13460",
    "name": "CVS",
    "address": "2423 N. NATIONAL RD., COLUMBUS, IN, 47201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2227811,
    "lng": -85.8897499
  },
  {
    "id": "13459",
    "name": "CVS",
    "address": "12502 MEMORIAL DR., HOUSTON, TX, 77024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7669956,
    "lng": -95.5505538
  },
  {
    "id": "13458",
    "name": "CVS",
    "address": "602 W. GRAND PKWY SOUTH, KATY, TX, 77494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7715526,
    "lng": -95.7784584
  },
  {
    "id": "13457",
    "name": "CVS",
    "address": "6999 PARKER RD., FLORISSANT, MO, 63033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7965356,
    "lng": -90.2309888
  },
  {
    "id": "13456",
    "name": "CVS",
    "address": "2411 TEXAS AVE S, COLLEGE STATION, TX, 77840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6080171,
    "lng": -96.3092688
  },
  {
    "id": "13455",
    "name": "CVS",
    "address": "860 WEST MORGAN STREET, SPENCER, IN, 47460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2863069,
    "lng": -86.7717005
  },
  {
    "id": "13454",
    "name": "CVS",
    "address": "4225 HOBSON RD., FORT WAYNE, IN, 46815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1183239,
    "lng": -85.1005302
  },
  {
    "id": "13453",
    "name": "CVS",
    "address": "2326 61ST ST, GALVESTON, TX, 77551",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.2762064,
    "lng": -94.8307695
  },
  {
    "id": "13452",
    "name": "CVS",
    "address": "11540 WESTHEIMER RD, HOUSTON, TX, 77077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7372492,
    "lng": -95.5816743
  },
  {
    "id": "13451",
    "name": "CVS",
    "address": "1600 SOUTH BYPASS 35, ALVIN, TX, 77511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4009351,
    "lng": -95.2444518
  },
  {
    "id": "13450",
    "name": "CVS",
    "address": "8201 KATY FREEWAY, HOUSTON, TX, 77024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7829222,
    "lng": -95.4854023
  },
  {
    "id": "13449",
    "name": "CVS",
    "address": "1206 16TH ST., BEDFORD, IN, 47421",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8606324,
    "lng": -86.4880062
  },
  {
    "id": "13448",
    "name": "CVS",
    "address": "44274 WEST-SMITH ENKE RD., MARICOPA, AZ, 85138",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.073035,
    "lng": -112.0427803
  },
  {
    "id": "13447",
    "name": "CVS",
    "address": "8830 STATE ROAD 60 WEST, MITCHELL, IN, 47446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.730815,
    "lng": -86.490039
  },
  {
    "id": "13446",
    "name": "CVS",
    "address": "4444 STATE RD. WEST 46, BLOOMINGTON, IN, 47404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2150459,
    "lng": -86.5917194
  },
  {
    "id": "13445",
    "name": "CVS",
    "address": "292 VAN BUREN ST., SOUTH, PO BOX 451, NASHVILLE, IN, 47448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2025022,
    "lng": -86.2476539
  },
  {
    "id": "13444",
    "name": "CVS",
    "address": "9292 WESTHEIMER RD, HOUSTON, TX, 77063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7379709,
    "lng": -95.5255603
  },
  {
    "id": "13443",
    "name": "CVS",
    "address": "25622 CROWN VALLEY PKWY., LADERA RANCH, CA, 92694",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5637483,
    "lng": -117.630145
  },
  {
    "id": "13442",
    "name": "CVS",
    "address": "15622 NORTH STATE RD 79 / P.O. BOX 207, EDINBURGH, IN, 46124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3411275,
    "lng": -85.9727627
  },
  {
    "id": "13441",
    "name": "CVS",
    "address": "1709 E STATE HWY 54, LINTON, IN, 47441",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0349243,
    "lng": -87.1658385
  },
  {
    "id": "13440",
    "name": "CVS",
    "address": "316 SOUTH PACIFIC COAST HWY., REDONDO BEACH, CA, 90277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8376489,
    "lng": -118.3850124
  },
  {
    "id": "13439",
    "name": "CVS",
    "address": "117 OYSTER CREEK DR, LAKE JACKSON, TX, 77566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.0444717,
    "lng": -95.4488295
  },
  {
    "id": "13438",
    "name": "CVS",
    "address": "789 STATE ROAD 39 BY-PASS, MARTINSVILLE, IN, 46151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.41943,
    "lng": -86.4341512
  },
  {
    "id": "13437",
    "name": "CVS",
    "address": "644 W. PUTNAM AVE., GREENWICH, CT, 6830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0168923,
    "lng": -73.6476422
  },
  {
    "id": "13436",
    "name": "CVS",
    "address": "2650 S. WALNUT ST., BLOOMINGTON, IN, 47401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1340733,
    "lng": -86.5320979
  },
  {
    "id": "13435",
    "name": "CVS",
    "address": "2701 EAST 3RD ST., BLOOMINGTON, IN, 47401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1647135,
    "lng": -86.4976805
  },
  {
    "id": "13434",
    "name": "CVS",
    "address": "415 S. MAIN ST., BROWNSTOWN, IN, 47220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8757413,
    "lng": -86.0428966
  },
  {
    "id": "13433",
    "name": "CVS",
    "address": "1215 E. SUPERIOR ST., DULUTH, MN, 55802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.7992369,
    "lng": -92.082863
  },
  {
    "id": "13432",
    "name": "CVS",
    "address": "501 UNIVERSITY BLVD., ROUND ROCK, TX, 78665",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5613418,
    "lng": -97.6794413
  },
  {
    "id": "13431",
    "name": "CVS",
    "address": "924 WESTERN AVE., CLINTON, IN, 47842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6584121,
    "lng": -87.4090531
  },
  {
    "id": "13430",
    "name": "CVS",
    "address": "1010 INDIANAPOLIS RD., GREENCASTLE, IN, 46135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6457927,
    "lng": -86.840505
  },
  {
    "id": "13429",
    "name": "CVS",
    "address": "4528 GRAND AVE., DULUTH, MN, 55807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.7457751,
    "lng": -92.1580684
  },
  {
    "id": "13428",
    "name": "CVS",
    "address": "905 POPLAR ST., TERRE HAUTE, IN, 47807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4625383,
    "lng": -87.4036914
  },
  {
    "id": "13427",
    "name": "CVS",
    "address": "307 E. NATIONAL AVE., BRAZIL, IN, 47834",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5233664,
    "lng": -87.1244801
  },
  {
    "id": "13426",
    "name": "CVS",
    "address": "300 E. WALNUT ST., WATSEKA, IL, 60970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7767731,
    "lng": -87.7304594
  },
  {
    "id": "13425",
    "name": "CVS",
    "address": "3630 S. 18TH ST., LAFAYETTE, IN, 47909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3663689,
    "lng": -86.8765246
  },
  {
    "id": "13424",
    "name": "CVS",
    "address": "505 WEST MAIN STREET, DELPHI, IN, 46923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5847275,
    "lng": -86.6794657
  },
  {
    "id": "13423",
    "name": "CVS",
    "address": "200 WEST JACKSON STREET, ATTICA, IN, 47918",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2939623,
    "lng": -87.2518047
  },
  {
    "id": "13422",
    "name": "CVS",
    "address": "511 THIRD ST., COVINGTON, IN, 47932",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1386309,
    "lng": -87.398669
  },
  {
    "id": "13421",
    "name": "CVS",
    "address": "201 S. JACKSON ST., FRANKFORT, IN, 46041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.278971,
    "lng": -86.5101556
  },
  {
    "id": "13420",
    "name": "CVS",
    "address": "11 NORTH MORTON STREET, FRANKLIN, IN, 46131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4805416,
    "lng": -86.0633896
  },
  {
    "id": "13419",
    "name": "CVS",
    "address": "620 E. STATE ST., PENDLETON, IN, 46064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9996139,
    "lng": -85.736165
  },
  {
    "id": "13418",
    "name": "CVS",
    "address": "3824 MAIN STREET, ANDERSON, IN, 46013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.075842,
    "lng": -85.6772369
  },
  {
    "id": "13417",
    "name": "CVS",
    "address": "1569 11TH ST, HUNTSVILLE, TX, 77340",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.7223619,
    "lng": -95.5575851
  },
  {
    "id": "13416",
    "name": "CVS",
    "address": "8970 S. MERIDIAN ST., INDIANAPOLIS, IN, 46217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6356716,
    "lng": -86.1591994
  },
  {
    "id": "13415",
    "name": "CVS",
    "address": "39 SOUTH U.S. 31, WHITELAND, IN, 46184",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5493679,
    "lng": -86.086061
  },
  {
    "id": "13414",
    "name": "CVS",
    "address": "2003 BROADWAY, ANDERSON, IN, 46012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1356447,
    "lng": -85.6783602
  },
  {
    "id": "13413",
    "name": "CVS",
    "address": "655 S. US HIGHWAY 31, GREENWOOD, IN, 46142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6063593,
    "lng": -86.1085102
  },
  {
    "id": "13412",
    "name": "CVS",
    "address": "1515 EAST MAIN STREET, RICHMOND, IN, 47374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8290129,
    "lng": -84.8809209
  },
  {
    "id": "13411",
    "name": "CVS",
    "address": "640 SOUTH STATE ROAD 135, GREENWOOD, IN, 46142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6067255,
    "lng": -86.1597161
  },
  {
    "id": "13410",
    "name": "CVS",
    "address": "220 S. MEMORIAL DR., NEW CASTLE, IN, 47362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.929322,
    "lng": -85.3810307
  },
  {
    "id": "13409",
    "name": "CVS",
    "address": "200 S. HARRISON ST., SHELBYVILLE, IN, 46176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5225068,
    "lng": -85.7763958
  },
  {
    "id": "13408",
    "name": "CVS",
    "address": "298 SOUTH WEST 18TH ST.,, RICHMOND, IN, 47374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8250807,
    "lng": -84.9276464
  },
  {
    "id": "13407",
    "name": "CVS",
    "address": "1610 MONKS AVENUE, MANKATO, MN, 56001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1455994,
    "lng": -93.9899953
  },
  {
    "id": "13406",
    "name": "CVS",
    "address": "7496 ROCKFISH RD., FAYETTEVILLE, NC, 28306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.982094,
    "lng": -79.0155463
  },
  {
    "id": "13405",
    "name": "CVS",
    "address": "786 N. GERMANTOWN PKWY., CORDOVA, TN, 38018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.146351,
    "lng": -89.7946579
  },
  {
    "id": "13404",
    "name": "CVS",
    "address": "301 E. MAIN ST., GAS CITY, IN, 46933",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.488573,
    "lng": -85.6104388
  },
  {
    "id": "13403",
    "name": "CVS",
    "address": "201 SOUTH TILLOTSON AVE., MUNCIE, IN, 47304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1925855,
    "lng": -85.4199485
  },
  {
    "id": "13402",
    "name": "CVS",
    "address": "1700 N. WALNUT ST, PO BOX 109, HARTFORD CITY, IN, 47348",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4653628,
    "lng": -85.369452
  },
  {
    "id": "13401",
    "name": "CVS",
    "address": "415 W. 3RD ST., MARION, IN, 46952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5582238,
    "lng": -85.6641167
  },
  {
    "id": "13400",
    "name": "CVS",
    "address": "105 NORTH PARK AVE, ALEXANDRIA, IN, 46001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2637165,
    "lng": -85.6677091
  },
  {
    "id": "13399",
    "name": "CVS",
    "address": "100 N ANDERSON ST., ELWOOD, IN, 46036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2776809,
    "lng": -85.8424651
  },
  {
    "id": "13398",
    "name": "CVS",
    "address": "5925 E. 71ST ST., INDIANAPOLIS, IN, 46220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8827234,
    "lng": -86.0665808
  },
  {
    "id": "13397",
    "name": "CVS",
    "address": "8405 SOUTHEASTERN AVE., INDIANAPOLIS, IN, 46239",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7079993,
    "lng": -86.0170426
  },
  {
    "id": "13396",
    "name": "CVS",
    "address": "9550 ALLISONVILLE RD., INDIANAPOLIS, IN, 46250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9264181,
    "lng": -86.0677024
  },
  {
    "id": "13395",
    "name": "CVS",
    "address": "5005 EAST 56TH ST., INDIANAPOLIS, IN, 46226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8546683,
    "lng": -86.0860173
  },
  {
    "id": "13394",
    "name": "CVS",
    "address": "11588 ALLISONVILLE RD., FISHERS, IN, 46038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9559677,
    "lng": -86.0409699
  },
  {
    "id": "13393",
    "name": "CVS",
    "address": "5605 NORTH POST RD., INDIANAPOLIS, IN, 46216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8558558,
    "lng": -86.0096718
  },
  {
    "id": "13392",
    "name": "CVS",
    "address": "1715 MAIN ST., BEECH GROVE, IN, 46107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7211622,
    "lng": -86.1024567
  },
  {
    "id": "13391",
    "name": "CVS",
    "address": "5611 GEORGETOWN RD., INDIANAPOLIS, IN, 46254",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8541377,
    "lng": -86.239217
  },
  {
    "id": "13390",
    "name": "CVS",
    "address": "1375 WEST 86TH ST., INDIANAPOLIS, IN, 46260",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9117883,
    "lng": -86.1830431
  },
  {
    "id": "13389",
    "name": "CVS",
    "address": "6290-92 N. COLLEGE AVE., INDIANAPOLIS, IN, 46220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8701258,
    "lng": -86.1467731
  },
  {
    "id": "13388",
    "name": "CVS",
    "address": "2550 CONNER ST., NOBLESVILLE, IN, 46060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0465659,
    "lng": -85.9963676
  },
  {
    "id": "13387",
    "name": "CVS",
    "address": "651 EAST MAIN STREET, DANVILLE, IN, 46122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7593234,
    "lng": -86.5120898
  },
  {
    "id": "13386",
    "name": "CVS",
    "address": "7325 W. 10TH ST., INDIANAPOLIS, IN, 46214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7777031,
    "lng": -86.2914705
  },
  {
    "id": "13385",
    "name": "CVS",
    "address": "2320 CUNNINGHAM RD., INDIANAPOLIS, IN, 46224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7982492,
    "lng": -86.2660867
  },
  {
    "id": "13384",
    "name": "CVS",
    "address": "523 SOUTH STATE ROAD 67, MOORESVILLE, IN, 46158",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6022455,
    "lng": -86.3732327
  },
  {
    "id": "13383",
    "name": "CVS",
    "address": "1700 E. MAIN ST., PLAINFIELD, IN, 46168",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7107336,
    "lng": -86.3779842
  },
  {
    "id": "13382",
    "name": "CVS",
    "address": "3705 KENTUCKY AVE, INDIANAPOLIS, IN, 46221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7119269,
    "lng": -86.2416207
  },
  {
    "id": "13381",
    "name": "CVS",
    "address": "2920 RT 73 NORTH, STORE 1, MAPLE SHADE, NJ, 8052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9495449,
    "lng": -74.9853048
  },
  {
    "id": "13380",
    "name": "CVS",
    "address": "4026 SOUTH 00 EAST WEST, KOKOMO, IN, 46902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4181645,
    "lng": -86.1265229
  },
  {
    "id": "13379",
    "name": "CVS",
    "address": "907 S. HEATON ST., KNOX, IN, 46534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2887258,
    "lng": -86.6210306
  },
  {
    "id": "13378",
    "name": "CVS",
    "address": "850 N. PLYMOUTH RD., WINAMAC, IN, 46996",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0597615,
    "lng": -86.6021221
  },
  {
    "id": "13377",
    "name": "CVS",
    "address": "6490 CLAYTON RD, CLAYTON, CA, 94517",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9423971,
    "lng": -121.9314005
  },
  {
    "id": "13376",
    "name": "CVS",
    "address": "302 E. MAIN ST., NORTH MANCHESTER, IN, 46962",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9996328,
    "lng": -85.7663648
  },
  {
    "id": "13375",
    "name": "CVS",
    "address": "1325 FM 1960 ROAD WEST, HOUSTON, TX, 77090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0140077,
    "lng": -95.4496358
  },
  {
    "id": "13374",
    "name": "CVS",
    "address": "486 N. CASS ST.,, WABASH, IN, 46992",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8032123,
    "lng": -85.8273057
  },
  {
    "id": "13373",
    "name": "CVS",
    "address": "2802 EAST STATE BOULEVARD, FORT WAYNE, IN, 46805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0967862,
    "lng": -85.1028904
  },
  {
    "id": "13372",
    "name": "CVS",
    "address": "2420 DIVISION ST., SAINT CLOUD, MN, 56301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5527309,
    "lng": -94.1871279
  },
  {
    "id": "13371",
    "name": "CVS",
    "address": "978 BOYLSTON ST., NEWTON, MA, 2461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3181167,
    "lng": -71.211237
  },
  {
    "id": "13370",
    "name": "CVS",
    "address": "618 S. MAIN ST., PO BOX 241, NORTH WEBSTER, IN, 46555",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3209212,
    "lng": -85.6974926
  },
  {
    "id": "13369",
    "name": "CVS",
    "address": "286 W. WALKER WAY, COLUMBIA CITY, IN, 46725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1684127,
    "lng": -85.4904826
  },
  {
    "id": "13368",
    "name": "CVS",
    "address": "308 S. HUNTINGTON ST., SYRACUSE, IN, 46567",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4193286,
    "lng": -85.7467569
  },
  {
    "id": "13367",
    "name": "CVS",
    "address": "934 W. 7TH ST., AUBURN, IN, 46706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3671655,
    "lng": -85.0707897
  },
  {
    "id": "13366",
    "name": "CVS",
    "address": "700 N. WAYNE ST., ANGOLA, IN, 46703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6429644,
    "lng": -84.9988576
  },
  {
    "id": "13365",
    "name": "CVS",
    "address": "2101 EAST IRELAND RD., SOUTH BEND, IN, 46614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6299584,
    "lng": -86.2144997
  },
  {
    "id": "13364",
    "name": "CVS",
    "address": "3253 FRANKLIN ST., MICHIGAN CITY, IN, 46360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6933515,
    "lng": -86.8944264
  },
  {
    "id": "13363",
    "name": "CVS",
    "address": "1407 LINCOLNWAY, LA PORTE, IN, 46350",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6084576,
    "lng": -86.7277273
  },
  {
    "id": "13362",
    "name": "CVS",
    "address": "901 N. KARWICK RD., MICHIGAN CITY, IN, 46360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7333629,
    "lng": -86.8547357
  },
  {
    "id": "13361",
    "name": "CVS",
    "address": "12544 ST RD 23, GRANGER, IN, 46530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.752948,
    "lng": -86.1123888
  },
  {
    "id": "13360",
    "name": "CVS",
    "address": "410 S MAIN ST., GOSHEN, IN, 46526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.581789,
    "lng": -85.833826
  },
  {
    "id": "13359",
    "name": "CVS",
    "address": "900 E. BRISTOL ST., ELKHART, IN, 46514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7030087,
    "lng": -85.9654972
  },
  {
    "id": "13358",
    "name": "CVS",
    "address": "1150 W. PLYMOUTH ST., BREMEN, IN, 46506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4457861,
    "lng": -86.1604098
  },
  {
    "id": "13357",
    "name": "CVS",
    "address": "1654 E. MARKET ST., NAPPANEE, IN, 46550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.443287,
    "lng": -85.9827304
  },
  {
    "id": "13356",
    "name": "CVS",
    "address": "2340 GAR HIGHWAY, SWANSEA, MA, 2777",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7684964,
    "lng": -71.2649767
  },
  {
    "id": "13355",
    "name": "CVS",
    "address": "2210 E. EDISON, SOUTH BEND, IN, 46615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6939807,
    "lng": -86.2158894
  },
  {
    "id": "13354",
    "name": "CVS",
    "address": "100 NORTH DETROIT ST, WARSAW, IN, 46580",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2387092,
    "lng": -85.8524223
  },
  {
    "id": "13353",
    "name": "CVS",
    "address": "3600 CASSOPOLIS ST., ELKHART, IN, 46514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7393224,
    "lng": -85.9731571
  },
  {
    "id": "13352",
    "name": "CVS",
    "address": "8325 BAYMEADOWS RD., JACKSONVILLE, FL, 32256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2213765,
    "lng": -81.5854201
  },
  {
    "id": "13351",
    "name": "CVS",
    "address": "9315 N. LINDBERGH DR., PEORIA, IL, 61615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8009691,
    "lng": -89.6112954
  },
  {
    "id": "13350",
    "name": "CVS",
    "address": "903 MEMORIAL BLVD., SPRINGFIELD, TN, 37172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5047189,
    "lng": -86.882004
  },
  {
    "id": "13349",
    "name": "CVS",
    "address": "3801 HILLSBORO RPIKE, NASHVILLE, TN, 37215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1090329,
    "lng": -86.8124743
  },
  {
    "id": "13348",
    "name": "CVS",
    "address": "2788 MURFREESBORO PIKE, ANTIOCH, TN, 37013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0681317,
    "lng": -86.6312302
  },
  {
    "id": "13347",
    "name": "CVS",
    "address": "1228 W. MAIN ST.,, LEBANON, TN, 37087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2127157,
    "lng": -86.3214733
  },
  {
    "id": "13346",
    "name": "CVS",
    "address": "1122 LOVERS LANE, BOWLING GREEN, KY, 42103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9542591,
    "lng": -86.4258089
  },
  {
    "id": "13345",
    "name": "CVS",
    "address": "1154 LIBERTY PIKE, FRANKLIN, TN, 37067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9270598,
    "lng": -86.8249176
  },
  {
    "id": "13344",
    "name": "CVS",
    "address": "1300 TROTWOOD AVE., COLUMBIA, TN, 38401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6045577,
    "lng": -87.0680849
  },
  {
    "id": "13343",
    "name": "CVS",
    "address": "3282 TREMONT RD, UPPER ARLINGTON, OH, 43221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0236977,
    "lng": -83.0574898
  },
  {
    "id": "13342",
    "name": "CVS",
    "address": "102 ROCKBARN RD., CONOVER, NC, 28613",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7037682,
    "lng": -81.2114492
  },
  {
    "id": "13341",
    "name": "CVS",
    "address": "6678 EAST VIRGINIA BEACH BLVD., NORFOLK, VA, 23502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.854987,
    "lng": -76.1784645
  },
  {
    "id": "13340",
    "name": "CVS",
    "address": "200 N. GREEN ST., MORGANTON, NC, 28655",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.747706,
    "lng": -81.6888034
  },
  {
    "id": "13339",
    "name": "CVS",
    "address": "7112 HIGHWAY 70 SOUTH, NASHVILLE, TN, 37221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.075596,
    "lng": -86.9221974
  },
  {
    "id": "13338",
    "name": "CVS",
    "address": "800 EAST 15TH ST., YAZOO CITY, MS, 39194",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8634037,
    "lng": -90.3926051
  },
  {
    "id": "13337",
    "name": "CVS",
    "address": "330 FRANKLIN ROAD, SUITE 302, BRENTWOOD, TN, 37027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0255863,
    "lng": -86.7882925
  },
  {
    "id": "13336",
    "name": "CVS",
    "address": "801 W. MAIN ST., MARION, IL, 62959",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7303407,
    "lng": -88.9333798
  },
  {
    "id": "13335",
    "name": "CVS",
    "address": "2425 N. 16TH ST., ORANGE, TX, 77630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1158419,
    "lng": -93.7483493
  },
  {
    "id": "13334",
    "name": "CVS",
    "address": "538 LONE OAK RD., PADUCAH, KY, 42003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0632262,
    "lng": -88.6378163
  },
  {
    "id": "13333",
    "name": "CVS",
    "address": "290 STRICKLAND DR., ORANGE, TX, 77630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0985373,
    "lng": -93.7658498
  },
  {
    "id": "13332",
    "name": "CVS",
    "address": "635 S MELROSE DR, VISTA, CA, 92081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1868754,
    "lng": -117.2541239
  },
  {
    "id": "13331",
    "name": "CVS",
    "address": "6005 KINGSTON PIKE, KNOXVILLE, TN, 37919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9336108,
    "lng": -84.0017243
  },
  {
    "id": "13330",
    "name": "CVS",
    "address": "1695 HIGHWAY 59, MANDEVILLE, LA, 70448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3731284,
    "lng": -90.0542793
  },
  {
    "id": "13329",
    "name": "CVS",
    "address": "1405 OAK ST., KENOVA, WV, 25530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4016031,
    "lng": -82.5776654
  },
  {
    "id": "13328",
    "name": "CVS",
    "address": "1221 LEXINGTON AVENUE, ASHLAND, KY, 41101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4763917,
    "lng": -82.6467828
  },
  {
    "id": "13327",
    "name": "CVS",
    "address": "409 EAST MAIN STREET, RICHMOND, KY, 40475",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7463264,
    "lng": -84.2907259
  },
  {
    "id": "13326",
    "name": "CVS",
    "address": "24 WEST LEXINGTON AVE., WINCHESTER, KY, 40391",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.991933,
    "lng": -84.1789964
  },
  {
    "id": "13325",
    "name": "CVS",
    "address": "234 NJ STATE HWY RT 202, FLEMINGTON, NJ, 8822",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4912413,
    "lng": -74.8611233
  },
  {
    "id": "13324",
    "name": "CVS",
    "address": "231 SOUTH SECOND ST., DANVILLE, KY, 40422",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6439783,
    "lng": -84.7717827
  },
  {
    "id": "13323",
    "name": "CVS",
    "address": "645 MARKET ST, SAN DIEGO, CA, 92101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7111897,
    "lng": -117.1587587
  },
  {
    "id": "13322",
    "name": "CVS",
    "address": "506 EAST NELSON STREET, LEXINGTON, VA, 24450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7797428,
    "lng": -79.435885
  },
  {
    "id": "13321",
    "name": "CVS",
    "address": "13821 LEO RD., LEO-CEDARVILLE, IN, 46765",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2141977,
    "lng": -85.0182299
  },
  {
    "id": "13320",
    "name": "CVS",
    "address": "2902 PALMER HWY, TEXAS CITY, TX, 77590",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.3959729,
    "lng": -94.937649
  },
  {
    "id": "13319",
    "name": "CVS",
    "address": "2907 STATE STREET, GASSAWAY, WV, 26624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6590925,
    "lng": -80.7483769
  },
  {
    "id": "13318",
    "name": "CVS",
    "address": "201 MACCORKLE AVENUE, SAINT ALBANS, WV, 25177",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3894319,
    "lng": -81.834596
  },
  {
    "id": "13317",
    "name": "CVS",
    "address": "6116 QUINCE RD, MEMPHIS, TN, 38119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0864754,
    "lng": -89.85935
  },
  {
    "id": "13316",
    "name": "CVS",
    "address": "5212 ANTOINE DR, HOUSTON, TX, 77092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.840575,
    "lng": -95.4723995
  },
  {
    "id": "13315",
    "name": "CVS",
    "address": "817 W. MAIN ST., DANVILLE, VA, 24541",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5702995,
    "lng": -79.4224318
  },
  {
    "id": "13314",
    "name": "CVS",
    "address": "1749 WOODSTONE DR., SAINT PETERS, MO, 63376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7493731,
    "lng": -90.5848603
  },
  {
    "id": "13313",
    "name": "CVS",
    "address": "842 NATIONAL RD., WHEELING, WV, 26003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0758668,
    "lng": -80.6953641
  },
  {
    "id": "13312",
    "name": "CVS",
    "address": "777 SOUTH OYSTER BAY RD, BETHPAGE, NY, 11714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7643118,
    "lng": -73.4998668
  },
  {
    "id": "13311",
    "name": "CVS",
    "address": "68501 ADDIE WAY, SAINT CLAIRSVILLE, OH, 43950",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0778205,
    "lng": -80.8718225
  },
  {
    "id": "13310",
    "name": "CVS",
    "address": "404 AETNA ST., MARTINS FERRY, OH, 43935",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.085704,
    "lng": -80.7346939
  },
  {
    "id": "13309",
    "name": "CVS",
    "address": "905 W. MAIN ST., BOONVILLE, IN, 47601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0491999,
    "lng": -87.2858449
  },
  {
    "id": "13308",
    "name": "CVS",
    "address": "700 E. 4TH ST., MOUNT VERNON, IN, 47620",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9335045,
    "lng": -87.8878814
  },
  {
    "id": "13307",
    "name": "CVS",
    "address": "4700 LINCOLN AVE., EVANSVILLE, IN, 47714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9701335,
    "lng": -87.4931251
  },
  {
    "id": "13306",
    "name": "CVS",
    "address": "4480 FIRST AVE., EVANSVILLE, IN, 47710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0189843,
    "lng": -87.5755002
  },
  {
    "id": "13305",
    "name": "CVS",
    "address": "609 NORTH ST JOSEPH AVE, EVANSVILLE, IN, 47712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9837253,
    "lng": -87.5999293
  },
  {
    "id": "13304",
    "name": "CVS",
    "address": "1610 NASA RD 1, NASSAU BAY, TX, 77058",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5485261,
    "lng": -95.0954778
  },
  {
    "id": "13303",
    "name": "CVS",
    "address": "6161 TELEPHONE RD, HOUSTON, TX, 77087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.676476,
    "lng": -95.2897516
  },
  {
    "id": "13302",
    "name": "CVS",
    "address": "806 S 75TH ST, HOUSTON, TX, 77023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7167306,
    "lng": -95.2953452
  },
  {
    "id": "13301",
    "name": "CVS",
    "address": "4451 W FUQUA ST, HOUSTON, TX, 77045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6128224,
    "lng": -95.4453087
  },
  {
    "id": "13300",
    "name": "CVS",
    "address": "399 JERUSALEM AVE., HICKSVILLE, NY, 11801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7511131,
    "lng": -73.5184134
  },
  {
    "id": "13299",
    "name": "CVS",
    "address": "2100 SW 119TH ST, OKLAHOMA CITY, OK, 73170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3482017,
    "lng": -97.5482097
  },
  {
    "id": "13298",
    "name": "CVS",
    "address": "106 W STATE HIGHWAY 152, MUSTANG, OK, 73064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3909748,
    "lng": -97.7251365
  },
  {
    "id": "13297",
    "name": "CVS",
    "address": "3200 S. SANTA FE AVE., EDMOND, OK, 73013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6242048,
    "lng": -97.5129642
  },
  {
    "id": "13296",
    "name": "CVS",
    "address": "1308 NORTH BRYANT AVE., EDMOND, OK, 73034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6677664,
    "lng": -97.459857
  },
  {
    "id": "13295",
    "name": "CVS",
    "address": "715 NW 50TH ST., OKLAHOMA CITY, OK, 73118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5228326,
    "lng": -97.5246496
  },
  {
    "id": "13294",
    "name": "CVS",
    "address": "1520 S. BRYANT AVE., EDMOND, OK, 73013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6377118,
    "lng": -97.4597023
  },
  {
    "id": "13293",
    "name": "CVS",
    "address": "2222 BARDSTOWN RD., LOUISVILLE, KY, 40205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2240329,
    "lng": -85.6930009
  },
  {
    "id": "13292",
    "name": "CVS",
    "address": "205 EAST MAIN ST, CIRCLEVILLE, OH, 43113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6004365,
    "lng": -82.9423833
  },
  {
    "id": "13291",
    "name": "CVS",
    "address": "111 SOUTH MEMORIAL DRIVE, LANCASTER, OH, 43130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.713114,
    "lng": -82.6067552
  },
  {
    "id": "13290",
    "name": "CVS",
    "address": "2565 EAST MAIN ST., SPRINGFIELD, OH, 45503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9227049,
    "lng": -83.7701106
  },
  {
    "id": "13289",
    "name": "CVS",
    "address": "700 BROAD ST., RIVERTON, NJ, 8077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.01158,
    "lng": -75.010457
  },
  {
    "id": "13288",
    "name": "CVS",
    "address": "418 EAST MAIN STREET, ASHLAND, OH, 44805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8681913,
    "lng": -82.3069045
  },
  {
    "id": "13287",
    "name": "CVS",
    "address": "3651 W ROBINSON ST, NORMAN, OK, 73072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2333988,
    "lng": -97.4950974
  },
  {
    "id": "13286",
    "name": "CVS",
    "address": "1202 COUNTY LINE ROAD, WESTERVILLE, OH, 43081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1325714,
    "lng": -82.8865212
  },
  {
    "id": "13285",
    "name": "CVS",
    "address": "1211 MORSE RD., COLUMBUS, OH, 43229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0606076,
    "lng": -82.986527
  },
  {
    "id": "13284",
    "name": "CVS",
    "address": "1885 WEST HENDERSON ROAD, UPPER ARLINGTON, OH, 43220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0544185,
    "lng": -83.0697358
  },
  {
    "id": "13283",
    "name": "CVS",
    "address": "1495 WEST 5TH AVE., COLUMBUS, OH, 43212",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9881253,
    "lng": -83.046458
  },
  {
    "id": "13282",
    "name": "CVS",
    "address": "4261 E. LITTLE CREEK RD., NORFOLK, VA, 23518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9175767,
    "lng": -76.1931059
  },
  {
    "id": "13281",
    "name": "CVS",
    "address": "4500 N. KICKAPOO AVE., SHAWNEE, OK, 74804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3768552,
    "lng": -96.9305577
  },
  {
    "id": "13280",
    "name": "CVS",
    "address": "2424 N. VERITY PARKWAY, MIDDLETOWN, OH, 45042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5268624,
    "lng": -84.3813921
  },
  {
    "id": "13279",
    "name": "CVS",
    "address": "371 LUDLOW AVE., CINCINNATI, OH, 45220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.143634,
    "lng": -84.5223418
  },
  {
    "id": "13278",
    "name": "CVS",
    "address": "7500 BEECHMONT AVE, CINCINNATI, OH, 45255",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0731742,
    "lng": -84.3489226
  },
  {
    "id": "13277",
    "name": "CVS",
    "address": "3516 DIXIE HWY, ERLANGER, KY, 41018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0166211,
    "lng": -84.6016061
  },
  {
    "id": "13276",
    "name": "CVS",
    "address": "2350 N. HARPER ST., POBOX1009, CHOCTAW, OK, 73020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4936671,
    "lng": -97.2728304
  },
  {
    "id": "13275",
    "name": "CVS",
    "address": "1301 N SANTA FE AVE, EDMOND, OK, 73003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6680699,
    "lng": -97.5148186
  },
  {
    "id": "13274",
    "name": "CVS",
    "address": "10534 HARRISON AVE., HARRISON, OH, 45030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2521383,
    "lng": -84.7920484
  },
  {
    "id": "13273",
    "name": "CVS",
    "address": "123 W. SPRING ST., OXFORD, OH, 45056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5069571,
    "lng": -84.7450334
  },
  {
    "id": "13272",
    "name": "CVS",
    "address": "28 N. BROOKWOOD AVE., HAMILTON, OH, 45013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4208895,
    "lng": -84.5895524
  },
  {
    "id": "13271",
    "name": "CVS",
    "address": "77 ROUTE 206, STANHOPE, NJ, 7874",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9324291,
    "lng": -74.7195789
  },
  {
    "id": "13270",
    "name": "CVS",
    "address": "1144 SOUTH AVENUE W., WESTFIELD, NJ, 7090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6467239,
    "lng": -74.3638104
  },
  {
    "id": "13269",
    "name": "CVS",
    "address": "343 WEST  MT. PLEASANT AVE., LIVINGSTON, NJ, 7039",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7953264,
    "lng": -74.3395934
  },
  {
    "id": "13268",
    "name": "CVS",
    "address": "10800 N ROCKWELL AVE, OKLAHOMA CITY, OK, 73162",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5787967,
    "lng": -97.6377663
  },
  {
    "id": "13267",
    "name": "CVS",
    "address": "410 ROUTE 10, WHIPPANY, NJ, 7981",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8212618,
    "lng": -74.4076134
  },
  {
    "id": "13266",
    "name": "CVS",
    "address": "515 ALLWOOD RD., CLIFTON, NJ, 7012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8421597,
    "lng": -74.1593375
  },
  {
    "id": "13265",
    "name": "CVS",
    "address": "1646 MAIN AVE., CLIFTON, NJ, 7011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8893238,
    "lng": -74.1534021
  },
  {
    "id": "13264",
    "name": "CVS",
    "address": "414 ROUTE 206 NORTH, BEDMINSTER, NJ, 7921",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6497944,
    "lng": -74.6418273
  },
  {
    "id": "13263",
    "name": "CVS",
    "address": "183 ROUTE 206 SOUTH, CHESTER, NJ, 7930",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7812701,
    "lng": -74.6952507
  },
  {
    "id": "13262",
    "name": "CVS",
    "address": "1125 BAY STREET, STATEN ISLAND, NY, 10305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6158843,
    "lng": -74.0670056
  },
  {
    "id": "13261",
    "name": "CVS",
    "address": "2465 RICHMOND AVE., STATEN ISLAND, NY, 10314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.587616,
    "lng": -74.1663375
  },
  {
    "id": "13260",
    "name": "CVS",
    "address": "2045 FOREST AVE., STATEN ISLAND, NY, 10303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6267079,
    "lng": -74.1574388
  },
  {
    "id": "13259",
    "name": "CVS",
    "address": "1933 VICTORY BLVD., STATEN ISLAND, NY, 10314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6128465,
    "lng": -74.1287215
  },
  {
    "id": "13258",
    "name": "CVS",
    "address": "2690 HYLAN BOULEVARD, STATEN ISLAND, NY, 10306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5666037,
    "lng": -74.1132141
  },
  {
    "id": "13257",
    "name": "CVS",
    "address": "1571 FOREST AVE., STATEN ISLAND, NY, 10302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6251199,
    "lng": -74.1402446
  },
  {
    "id": "13256",
    "name": "CVS",
    "address": "735 HARDING PL., NASHVILLE, TN, 37211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0805806,
    "lng": -86.7591569
  },
  {
    "id": "13255",
    "name": "CVS",
    "address": "302 W. BRIDGE STREET, NEW HOPE, PA, 18938",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3649521,
    "lng": -74.9648514
  },
  {
    "id": "13254",
    "name": "CVS",
    "address": "3210 CARLISLE RD, DOVER, PA, 17315",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9838538,
    "lng": -76.8253344
  },
  {
    "id": "13253",
    "name": "CVS",
    "address": "228 CHURCH ST., THURMONT, MD, 21788",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6283142,
    "lng": -77.4103533
  },
  {
    "id": "13252",
    "name": "CVS",
    "address": "200 RTE 33, HAMILTON, NJ, 8619",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2342692,
    "lng": -74.6882539
  },
  {
    "id": "13251",
    "name": "CVS",
    "address": "1 SUNNYBRAE BLVD, TRENTON, NJ, 8620",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1847773,
    "lng": -74.6779402
  },
  {
    "id": "13250",
    "name": "CVS",
    "address": "1618 NORTH OLDEN AVENUE, EWING, NJ, 8638",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.244722,
    "lng": -74.7588061
  },
  {
    "id": "13249",
    "name": "CVS",
    "address": "2257 US HWY 1, NORTH BRUNSWICK, NJ, 8902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4456487,
    "lng": -74.5003351
  },
  {
    "id": "13248",
    "name": "CVS",
    "address": "2300 HIGHWAY 150, OAK RIDGE, NC, 27310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1736298,
    "lng": -79.9882859
  },
  {
    "id": "13247",
    "name": "CVS",
    "address": "3560 ROUTE 27, KENDALL PARK, NJ, 8824",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4214119,
    "lng": -74.5758942
  },
  {
    "id": "13246",
    "name": "CVS",
    "address": "1912 JACKSON AVE. W, OXFORD, MS, 38655",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.363113,
    "lng": -89.5576488
  },
  {
    "id": "13245",
    "name": "CVS",
    "address": "1140 OLD COUNTRY RD., RIVERHEAD, NY, 11901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9322992,
    "lng": -72.6775093
  },
  {
    "id": "13244",
    "name": "CVS",
    "address": "2315 MIDDLE COUNTRY RD., CENTEREACH, NY, 11720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8585504,
    "lng": -73.0939276
  },
  {
    "id": "13243",
    "name": "CVS",
    "address": "1100 E. LINDSEY ST., NORMAN, OK, 73071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2033089,
    "lng": -97.4243624
  },
  {
    "id": "13242",
    "name": "CVS",
    "address": "12301 NORTH MAY AVE., OKLAHOMA CITY, OK, 73120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5952478,
    "lng": -97.5676016
  },
  {
    "id": "13241",
    "name": "CVS",
    "address": "800 SE 4TH ST, MOORE, OK, 73160",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3337352,
    "lng": -97.4762744
  },
  {
    "id": "13240",
    "name": "CVS",
    "address": "9001 S WESTERN AVE, OKLAHOMA CITY, OK, 73139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3766743,
    "lng": -97.5307808
  },
  {
    "id": "13239",
    "name": "CVS",
    "address": "5025 N. MAY AVE., OKLAHOMA CITY, OK, 73112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5214509,
    "lng": -97.5664085
  },
  {
    "id": "13238",
    "name": "CVS",
    "address": "6206 COMMERCE PALMS DR., TAMPA, FL, 33647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1159503,
    "lng": -82.3790312
  },
  {
    "id": "13237",
    "name": "CVS",
    "address": "7710 GESSNER RD., HOUSTON, TX, 77040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8864655,
    "lng": -95.5403199
  },
  {
    "id": "13236",
    "name": "CVS",
    "address": "4026 N MACARTHUR BLVD, WARR ACRES, OK, 73122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5121755,
    "lng": -97.6184732
  },
  {
    "id": "13235",
    "name": "CVS",
    "address": "499 SNELLING AVE. N., SAINT PAUL, MN, 55104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9559881,
    "lng": -93.1675349
  },
  {
    "id": "13234",
    "name": "CVS",
    "address": "1202 N. RIVERSIDE DR., ESPANOLA, NM, 87532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0087829,
    "lng": -106.0661304
  },
  {
    "id": "13233",
    "name": "CVS",
    "address": "904 EAST CARTWRIGHT RD., MESQUITE, TX, 75149",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7449549,
    "lng": -96.5829266
  },
  {
    "id": "13232",
    "name": "CVS",
    "address": "4800 NORTH DAMEN, CHICAGO, IL, 60625",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9689816,
    "lng": -87.6794939
  },
  {
    "id": "13231",
    "name": "CVS",
    "address": "1205 N. LABURNUM AVE, RICHMOND, VA, 23223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5611673,
    "lng": -77.3742974
  },
  {
    "id": "13230",
    "name": "CVS",
    "address": "1000 KRESSON RD., VOORHEES, NJ, 8043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8670138,
    "lng": -74.942569
  },
  {
    "id": "13229",
    "name": "CVS",
    "address": "3025 N. WINDSONG DR., PRESCOTT VALLEY, AZ, 86314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5866652,
    "lng": -112.3260465
  },
  {
    "id": "13228",
    "name": "CVS",
    "address": "2828 SPEARS RD., HOUSTON, TX, 77067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9654258,
    "lng": -95.4643931
  },
  {
    "id": "13227",
    "name": "CVS",
    "address": "949 LIVINGSTON AVE., NORTH BRUNSWICK, NJ, 8902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4704515,
    "lng": -74.4703765
  },
  {
    "id": "13226",
    "name": "CVS",
    "address": "24802 ALDINE WESTFIELD, SPRING, TX, 77373",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.065505,
    "lng": -95.4041404
  },
  {
    "id": "13225",
    "name": "CVS",
    "address": "8560 S. HULEN ST., FORT WORTH, TX, 76123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6177169,
    "lng": -97.3893414
  },
  {
    "id": "13224",
    "name": "CVS",
    "address": "5305 AVENUE I, ROSENBERG, TX, 77471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.55877,
    "lng": -95.7729142
  },
  {
    "id": "13223",
    "name": "CVS",
    "address": "5725 N. ELDRIDGE PKWY., HOUSTON, TX, 77041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8510828,
    "lng": -95.6070996
  },
  {
    "id": "13222",
    "name": "CVS",
    "address": "2078 ROUTE 9, OCEAN VIEW, NJ, 8230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2099373,
    "lng": -74.7039852
  },
  {
    "id": "13221",
    "name": "CVS",
    "address": "1600 S. FEDERAL HWY, HOLLYWOOD, FL, 33020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9972249,
    "lng": -80.1432945
  },
  {
    "id": "13220",
    "name": "CVS",
    "address": "6761 PRESTON RD., PLANO, TX, 75024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0638529,
    "lng": -96.7970205
  },
  {
    "id": "13219",
    "name": "CVS",
    "address": "15105 PRESTON RD., DALLAS, TX, 75248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9547027,
    "lng": -96.8050991
  },
  {
    "id": "13218",
    "name": "CVS",
    "address": "3200 TEASLEY LN., DENTON, TX, 76210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1752398,
    "lng": -97.113647
  },
  {
    "id": "13217",
    "name": "CVS",
    "address": "2000 SKOKIE VALLEY RD., HIGHLAND PARK, IL, 60035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1897556,
    "lng": -87.8269596
  },
  {
    "id": "13216",
    "name": "CVS",
    "address": "14220 SCHLEISMAN RD, EASTVALE, CA, 92880",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9601314,
    "lng": -117.5938352
  },
  {
    "id": "13215",
    "name": "CVS",
    "address": "2313 W. UNIVERSITY AVE., MCKINNEY, TX, 75071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2161832,
    "lng": -96.6448545
  },
  {
    "id": "13214",
    "name": "CVS",
    "address": "855 E. ELLIOT ROAD, TEMPE, AZ, 85284",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3487375,
    "lng": -111.929311
  },
  {
    "id": "13213",
    "name": "CVS",
    "address": "759 NEIL AVE, COLUMBUS, OH, 43215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9763257,
    "lng": -83.0122184
  },
  {
    "id": "13212",
    "name": "CVS",
    "address": "7285 S. DURANGO DR., LAS VEGAS, NV, 89113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0561803,
    "lng": -115.2799616
  },
  {
    "id": "13211",
    "name": "CVS",
    "address": "1890 N RIDGE RD, PAINESVILLE, OH, 44077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7488351,
    "lng": -81.2075582
  },
  {
    "id": "13210",
    "name": "CVS",
    "address": "242 CAMBRIDGE ST., BURLINGTON, MA, 1803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5131851,
    "lng": -71.2019877
  },
  {
    "id": "13209",
    "name": "CVS",
    "address": "901 S. GREEN BAY RD., NEENAH, WI, 54956",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1760375,
    "lng": -88.4857184
  },
  {
    "id": "13208",
    "name": "CVS",
    "address": "5701 CORAL RIDGE DR., CORAL SPRINGS, FL, 33076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2979854,
    "lng": -80.2782252
  },
  {
    "id": "13207",
    "name": "CVS",
    "address": "14380 MCGRAWS CORNER DR., GAINESVILLE, VA, 20155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7951652,
    "lng": -77.6186629
  },
  {
    "id": "13206",
    "name": "CVS",
    "address": "8765 S. DIXIE HWY., PINECREST, FL, 33156",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6893512,
    "lng": -80.3070779
  },
  {
    "id": "13205",
    "name": "CVS",
    "address": "10255 SW 86 CIRCLE, OCALA, FL, 34481",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.0740736,
    "lng": -82.2633797
  },
  {
    "id": "13204",
    "name": "CVS",
    "address": "933 BETHEL ROAD, COLUMBUS, OH, 43214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0627749,
    "lng": -83.0442346
  },
  {
    "id": "13203",
    "name": "CVS",
    "address": "445 WEST STREET RD., WARMINSTER, PA, 18974",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2033037,
    "lng": -75.0938003
  },
  {
    "id": "13202",
    "name": "CVS",
    "address": "200 W. NORTHWEST HWY., PALATINE, IL, 60067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1230684,
    "lng": -88.0492219
  },
  {
    "id": "13201",
    "name": "CVS",
    "address": "918 W. MERCURY BLVD., HAMPTON, VA, 23666",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0447114,
    "lng": -76.3758924
  },
  {
    "id": "13200",
    "name": "CVS",
    "address": "4150 N. SHEPHERD, HOUSTON, TX, 77018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8269261,
    "lng": -95.4098678
  },
  {
    "id": "13199",
    "name": "CVS",
    "address": "1611 N. PHILADELPHIA AVE., OCEAN CITY, MD, 21842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.347036,
    "lng": -75.0802326
  },
  {
    "id": "13198",
    "name": "CVS",
    "address": "24203 TOMBALL PKWY., TOMBALL, TX, 77375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0353309,
    "lng": -95.6051011
  },
  {
    "id": "13197",
    "name": "CVS",
    "address": "2801 EGYPT RD., AUDUBON, PA, 19407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1288453,
    "lng": -75.431787
  },
  {
    "id": "13196",
    "name": "CVS",
    "address": "2106 RAYFORD RD., SPRING, TX, 77386",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1228397,
    "lng": -95.410277
  },
  {
    "id": "13195",
    "name": "CVS",
    "address": "13033 COIT RD., DALLAS, TX, 75240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9265521,
    "lng": -96.769768
  },
  {
    "id": "13194",
    "name": "CVS",
    "address": "300 LASKIN RD. A 300, VIRGINIA BEACH, VA, 23451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8592462,
    "lng": -75.9795216
  },
  {
    "id": "13193",
    "name": "CVS",
    "address": "3170 S. HIGLEY RD., GILBERT, AZ, 85295",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2930708,
    "lng": -111.7220139
  },
  {
    "id": "13192",
    "name": "CVS",
    "address": "3893 WILLIAM PENN HWY, MONROEVILLE, PA, 15146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4377755,
    "lng": -79.778967
  },
  {
    "id": "13191",
    "name": "CVS",
    "address": "1111 N. DUNLAP ST., SAVOY, IL, 61874",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0684817,
    "lng": -88.249997
  },
  {
    "id": "13190",
    "name": "CVS",
    "address": "4082 JANDY BLVD., NAZARETH, PA, 18064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7311684,
    "lng": -75.3125213
  },
  {
    "id": "13189",
    "name": "CVS",
    "address": "959 BAY AREA BLVD., HOUSTON, TX, 77058",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5550734,
    "lng": -95.1211016
  },
  {
    "id": "13188",
    "name": "CVS",
    "address": "855 S. BROADWAY, WIND GAP, PA, 18091",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.838467,
    "lng": -75.2960132
  },
  {
    "id": "13187",
    "name": "CVS",
    "address": "2900 BROADWAY ST., PEARLAND, TX, 77581",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5557906,
    "lng": -95.2646634
  },
  {
    "id": "13186",
    "name": "CVS",
    "address": "6001 HIGH BRIDGE RD., BOWIE, MD, 20720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9729017,
    "lng": -76.77256
  },
  {
    "id": "13185",
    "name": "CVS",
    "address": "22135 IH-10 W, SAN ANTONIO, TX, 78257",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.64772,
    "lng": -98.6233577
  },
  {
    "id": "13184",
    "name": "CVS",
    "address": "881 STATE HWY 206, PRINCETON, NJ, 8540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3904113,
    "lng": -74.6537973
  },
  {
    "id": "13183",
    "name": "CVS",
    "address": "1413 OATS DR., MESQUITE, TX, 75150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8422894,
    "lng": -96.6246509
  },
  {
    "id": "13182",
    "name": "CVS",
    "address": "1776 BROAD ST., CRANSTON, RI, 2905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7778968,
    "lng": -71.3994444
  },
  {
    "id": "13181",
    "name": "CVS",
    "address": "401 SPRING GARDEN ST., PHILADELPHIA, PA, 19123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9613568,
    "lng": -75.1455083
  },
  {
    "id": "13180",
    "name": "CVS",
    "address": "112 STRIBLING LN, BRANDON, MS, 39042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2830169,
    "lng": -90.0369555
  },
  {
    "id": "13179",
    "name": "CVS",
    "address": "1820 CHENEY HIGHWAY, TITUSVILLE, FL, 32780",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5582614,
    "lng": -80.8233324
  },
  {
    "id": "13178",
    "name": "CVS",
    "address": "14460 WEST MAPLE ROAD, OMAHA, NE, 68116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2928517,
    "lng": -96.1398604
  },
  {
    "id": "13177",
    "name": "CVS",
    "address": "5 HAMPSTEAD RD., SALEM, NH, 3079",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7918827,
    "lng": -71.1863409
  },
  {
    "id": "13176",
    "name": "CVS",
    "address": "24 WEST GRAND STREET, MOUNT VERNON, NY, 10552",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9250594,
    "lng": -73.8375873
  },
  {
    "id": "13175",
    "name": "CVS",
    "address": "3813 MANATEE AVE. WEST, BRADENTON, FL, 34205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4950877,
    "lng": -82.5992701
  },
  {
    "id": "13174",
    "name": "CVS",
    "address": "15038 NACOGDOCHES RD., SAN ANTONIO, TX, 78247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.57714,
    "lng": -98.3729111
  },
  {
    "id": "13173",
    "name": "CVS",
    "address": "7603 CULEBRA, SAN ANTONIO, TX, 78251",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4597861,
    "lng": -98.6383176
  },
  {
    "id": "13172",
    "name": "CVS",
    "address": "1163 E. CHESTNUT AVE., VINELAND, NJ, 8360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4772526,
    "lng": -75.0026059
  },
  {
    "id": "13171",
    "name": "CVS",
    "address": "2187 HOWLAND BLVD., DELTONA, FL, 32738",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9248091,
    "lng": -81.1911557
  },
  {
    "id": "13170",
    "name": "CVS",
    "address": "119 S. MAIN ST., COLCHESTER, CT, 6415",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5729092,
    "lng": -72.3304656
  },
  {
    "id": "13169",
    "name": "CVS",
    "address": "640 LONG POINT RD., MOUNT PLEASANT, SC, 29464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8411179,
    "lng": -79.8554949
  },
  {
    "id": "13168",
    "name": "CVS",
    "address": "9390 FOREST LN., DALLAS, TX, 75243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9082616,
    "lng": -96.7361285
  },
  {
    "id": "13167",
    "name": "CVS",
    "address": "2700 W. MAIN ST., LEAGUE CITY, TX, 77573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5011195,
    "lng": -95.1268128
  },
  {
    "id": "13166",
    "name": "CVS",
    "address": "1001 WAUGH DR., HOUSTON, TX, 77019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7569225,
    "lng": -95.3974384
  },
  {
    "id": "13165",
    "name": "CVS",
    "address": "8960 BARKER CYPRESS RD., CYPRESS, TX, 77433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9080618,
    "lng": -95.6851606
  },
  {
    "id": "13164",
    "name": "CVS",
    "address": "7065 LA PALMA AVE., BUENA PARK, CA, 90620",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.847147,
    "lng": -118.0102374
  },
  {
    "id": "13163",
    "name": "CVS",
    "address": "1228 E. 53RD ST., CHICAGO, IL, 60615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7997748,
    "lng": -87.594681
  },
  {
    "id": "13162",
    "name": "CVS",
    "address": "2266 W. HOLCOMBE BLVD., HOUSTON, TX, 77030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7069316,
    "lng": -95.4118726
  },
  {
    "id": "13161",
    "name": "CVS",
    "address": "1600 RT 35 N., SEASIDE HEIGHTS, NJ, 8751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9484991,
    "lng": -74.0719619
  },
  {
    "id": "13160",
    "name": "CVS",
    "address": "1001 WESTWOOD BLVD., LOS ANGELES, CA, 90024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0623879,
    "lng": -118.4456533
  },
  {
    "id": "13159",
    "name": "CVS",
    "address": "5310 45TH ST., EAST, BRADENTON, FL, 34203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4452918,
    "lng": -82.5061028
  },
  {
    "id": "13158",
    "name": "CVS",
    "address": "11200 LINCOLN HWY, MOKENA, IL, 60448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5042674,
    "lng": -87.8898375
  },
  {
    "id": "13157",
    "name": "CVS",
    "address": "200 LIBERTY STREET, LITTLE FERRY, NJ, 7643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8503141,
    "lng": -74.042589
  },
  {
    "id": "13156",
    "name": "CVS",
    "address": "1800 E. HWY 50, CLERMONT, FL, 34711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.555428,
    "lng": -81.7826267
  },
  {
    "id": "13155",
    "name": "CVS",
    "address": "102 S. DALE MABRY HIGHWAY, TAMPA, FL, 33609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9442462,
    "lng": -82.5051714
  },
  {
    "id": "13154",
    "name": "CVS",
    "address": "4775 W. ROSECRANS AVE., HAWTHORNE, CA, 90250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9024755,
    "lng": -118.3608959
  },
  {
    "id": "13153",
    "name": "CVS",
    "address": "9522 BROADWAY ST., PEARLAND, TX, 77584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5557696,
    "lng": -95.3680352
  },
  {
    "id": "13152",
    "name": "CVS",
    "address": "6099 INDIAN RIVER RD., VIRGINIA BEACH, VA, 23464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8119515,
    "lng": -76.206224
  },
  {
    "id": "13151",
    "name": "CVS",
    "address": "2550 AVE. DE DIEGO, CAROLINA, PR, 987",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.3813212,
    "lng": -65.9622885
  },
  {
    "id": "13150",
    "name": "CVS",
    "address": "6301 EL DORADO PKWY., MCKINNEY, TX, 75070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1734201,
    "lng": -96.698986
  },
  {
    "id": "13149",
    "name": "CVS",
    "address": "26W212 GENEVA ROAD, CAROL STREAM, IL, 60188",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8883819,
    "lng": -88.1368403
  },
  {
    "id": "13148",
    "name": "CVS",
    "address": "2315 W. MERCURY BLVD, HAMPTON, VA, 23666",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0368298,
    "lng": -76.4082407
  },
  {
    "id": "13147",
    "name": "CVS",
    "address": "11271 NUCKOLS RD., GLEN ALLEN, VA, 23059",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6815574,
    "lng": -77.5895448
  },
  {
    "id": "13146",
    "name": "CVS",
    "address": "485 PEACHTREE INDUSTRIAL BLVD., SUWANEE, GA, 30024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0640715,
    "lng": -84.0746313
  },
  {
    "id": "13145",
    "name": "CVS",
    "address": "11500 BONITA BEACH RD. SE, BONITA SPRINGS, FL, 34135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3316261,
    "lng": -81.7619034
  },
  {
    "id": "13144",
    "name": "CVS",
    "address": "4302 CORTEZ RD. WEST, BRADENTON, FL, 34210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4630737,
    "lng": -82.6046535
  },
  {
    "id": "13143",
    "name": "CVS",
    "address": "4040 N. 19TH AVE., PHOENIX, AZ, 85015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4945647,
    "lng": -112.1004529
  },
  {
    "id": "13142",
    "name": "CVS",
    "address": "501 NORTH 16TH AVE., LAUREL, MS, 39440",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.6948781,
    "lng": -89.1459643
  },
  {
    "id": "13141",
    "name": "CVS",
    "address": "105 WONDERWORLD DRIVE, SAN MARCOS, TX, 78666",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8658669,
    "lng": -97.9624364
  },
  {
    "id": "13140",
    "name": "CVS",
    "address": "69-80 GRAND AVE., MASPETH, NY, 11378",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7272002,
    "lng": -73.8927475
  },
  {
    "id": "13139",
    "name": "CVS",
    "address": "178 MORRIS AVE., SPRINGFIELD, NJ, 7081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7110951,
    "lng": -74.3086588
  },
  {
    "id": "13138",
    "name": "CVS",
    "address": "25 PEMBERTON BROWNS MILL RD, BROWNS MILLS, NJ, 8015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9717693,
    "lng": -74.5849095
  },
  {
    "id": "13137",
    "name": "CVS",
    "address": "1530 COWPATH RD., HATFIELD, PA, 19440",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2719475,
    "lng": -75.2889648
  },
  {
    "id": "13136",
    "name": "CVS",
    "address": "7655 NORTHSHORE DR, KNOXVILLE, TN, 37919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9040286,
    "lng": -84.0209255
  },
  {
    "id": "13135",
    "name": "CVS",
    "address": "1420 CANTON MART RD., JACKSON, MS, 39211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3676094,
    "lng": -90.1488459
  },
  {
    "id": "13134",
    "name": "CVS",
    "address": "516 MONTAUK HWY, CENTER MORICHES, NY, 11934",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7991996,
    "lng": -72.7990169
  },
  {
    "id": "13133",
    "name": "CVS",
    "address": "6085 W. IRLO BRONSON MEMORIAL HWY, KISSIMMEE, FL, 34747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3338667,
    "lng": -81.5282285
  },
  {
    "id": "13132",
    "name": "CVS",
    "address": "3910 HARDY ST, HATTIESBURG, MS, 39402",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3245444,
    "lng": -89.3475198
  },
  {
    "id": "13131",
    "name": "CVS",
    "address": "29 WEST 21ST STREET, NORTHAMPTON, PA, 18067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6908728,
    "lng": -75.5014186
  },
  {
    "id": "13130",
    "name": "CVS",
    "address": "7488 VILLAGE CENTER DR., WHITMORE LAKE, MI, 48189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.439479,
    "lng": -83.7438303
  },
  {
    "id": "13129",
    "name": "CVS",
    "address": "2190 BIENVILLE BLVD, OCEAN SPRINGS, MS, 39564",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4155149,
    "lng": -88.8052495
  },
  {
    "id": "13128",
    "name": "CVS",
    "address": "2001 NORTH 11TH STREET, READING, PA, 19604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3656331,
    "lng": -75.9148404
  },
  {
    "id": "13127",
    "name": "CVS",
    "address": "8124 VETERANS HWY, MILLERSVILLE, MD, 21108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1171706,
    "lng": -76.63508
  },
  {
    "id": "13126",
    "name": "CVS",
    "address": "3221 PEACHTREE ROAD NE, ATLANTA, GA, 30305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8416415,
    "lng": -84.3729334
  },
  {
    "id": "13125",
    "name": "CVS",
    "address": "1202 NATIONAL HWY, LAVALE, MD, 21502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6382236,
    "lng": -78.8309646
  },
  {
    "id": "13124",
    "name": "CVS",
    "address": "606 SOUTH MAIN ST., SHREWSBURY, PA, 17361",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7530729,
    "lng": -76.6779971
  },
  {
    "id": "13123",
    "name": "CVS",
    "address": "440 N. READING RD., EPHRATA, PA, 17522",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1957763,
    "lng": -76.1715359
  },
  {
    "id": "13122",
    "name": "CVS",
    "address": "110 SOUTH PLEASANT AVENUE, SOMERSET, PA, 15501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.007906,
    "lng": -79.0747887
  },
  {
    "id": "13121",
    "name": "CVS",
    "address": "621 SW 3RD ST., LEES SUMMIT, MO, 64063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9106198,
    "lng": -94.3913006
  },
  {
    "id": "13120",
    "name": "CVS",
    "address": "3401 S. COLLINS ST., ARLINGTON, TX, 76014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6911045,
    "lng": -97.097016
  },
  {
    "id": "13119",
    "name": "CVS",
    "address": "120 5TH STREET, ELLWOOD CITY, PA, 16117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8608643,
    "lng": -80.2876617
  },
  {
    "id": "13118",
    "name": "CVS",
    "address": "405 W. DUBOIS AVE., DUBOIS, PA, 15801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1285896,
    "lng": -78.7632946
  },
  {
    "id": "13117",
    "name": "CVS",
    "address": "6040 SYKESVILLE RD, ELDERSBURG, MD, 21784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4092484,
    "lng": -76.9507578
  },
  {
    "id": "13116",
    "name": "CVS",
    "address": "7095 BALTIMORE ANNAPOLIS RD., GLEN BURNIE, MD, 21061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1984412,
    "lng": -76.641181
  },
  {
    "id": "13115",
    "name": "CVS",
    "address": "795 OGLETHORPE AVE., ATHENS, GA, 30606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9617711,
    "lng": -83.4140744
  },
  {
    "id": "13114",
    "name": "CVS",
    "address": "60 MIDDLE ST., BRISTOL, CT, 6010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6670938,
    "lng": -72.9230852
  },
  {
    "id": "13113",
    "name": "CVS",
    "address": "7107 N OAK TRAFFIC WAY, GLADSTONE, MO, 64118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2241151,
    "lng": -94.57542
  },
  {
    "id": "13112",
    "name": "CVS",
    "address": "3902 MAIN ST, KANSAS CITY, MO, 64111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0560131,
    "lng": -94.5864199
  },
  {
    "id": "13111",
    "name": "CVS",
    "address": "10170 ILLINOIS RD, FORT WAYNE, IN, 46804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0748567,
    "lng": -85.2741504
  },
  {
    "id": "13110",
    "name": "CVS",
    "address": "8421 NW PRAIRIE VIEW RD., KANSAS CITY, MO, 64153",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2476555,
    "lng": -94.6598812
  },
  {
    "id": "13109",
    "name": "CVS",
    "address": "11115 E US HWY 24 HWY, INDEPENDENCE, MO, 64054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1019733,
    "lng": -94.4459068
  },
  {
    "id": "13108",
    "name": "CVS",
    "address": "3050 W. GRAND PKWY., KATY, TX, 77494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7340373,
    "lng": -95.7745081
  },
  {
    "id": "13107",
    "name": "CVS",
    "address": "15846 MANCHESTER RD., ELLISVILLE, MO, 63011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5920195,
    "lng": -90.5851452
  },
  {
    "id": "13106",
    "name": "CVS",
    "address": "2 N. ZACK HINTON PARKWAY, MCDONOUGH, GA, 30253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4473,
    "lng": -84.1393499
  },
  {
    "id": "13105",
    "name": "CVS",
    "address": "3311 N. PULASKI RD., CHICAGO, IL, 60641",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9414036,
    "lng": -87.727069
  },
  {
    "id": "13104",
    "name": "CVS",
    "address": "1746 HECKLE BLVD, ROCK HILL, SC, 29732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9530515,
    "lng": -81.0630894
  },
  {
    "id": "13103",
    "name": "CVS",
    "address": "7907 STATE LINE RD, KANSAS CITY, MO, 64114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9848219,
    "lng": -94.6076754
  },
  {
    "id": "13102",
    "name": "CVS",
    "address": "7552 W. OKLAHOMA AVE., WEST ALLIS, WI, 53219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9893699,
    "lng": -88.0071828
  },
  {
    "id": "13101",
    "name": "CVS",
    "address": "955 WEST BAY AVE., BARNEGAT, NJ, 8005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7595767,
    "lng": -74.2550758
  },
  {
    "id": "13100",
    "name": "CVS",
    "address": "3700 NEWARK ST.,, N.W., WASHINGTON, DC, 20016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9345067,
    "lng": -77.0731153
  },
  {
    "id": "13099",
    "name": "CVS",
    "address": "103 FOOTHILLS MALL DR., MARYVILLE, TN, 37801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.737182,
    "lng": -83.9930579
  },
  {
    "id": "13098",
    "name": "CVS",
    "address": "9141 OLIVE BLVD., OLIVETTE, MO, 63132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6746075,
    "lng": -90.366228
  },
  {
    "id": "13097",
    "name": "CVS",
    "address": "19715 TOMBALL PARKWAY, HOUSTON, TX, 77070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9811434,
    "lng": -95.568921
  },
  {
    "id": "13096",
    "name": "CVS",
    "address": "4106 FT. HENRY DR., KINGSPORT, TN, 37663",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.4842688,
    "lng": -82.5034882
  },
  {
    "id": "13095",
    "name": "CVS",
    "address": "4343 CYPRESSWOOD RD.., SPRING, TX, 77388",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0298423,
    "lng": -95.4798292
  },
  {
    "id": "13094",
    "name": "CVS",
    "address": "409 E NORTH AVE, BELTON, MO, 64012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8135394,
    "lng": -94.5264285
  },
  {
    "id": "13093",
    "name": "CVS",
    "address": "1950 BUFORD HWY., BUFORD, GA, 30518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1073561,
    "lng": -84.0029019
  },
  {
    "id": "13092",
    "name": "CVS",
    "address": "4101 EAST 42ND ST., ODESSA, TX, 79762",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.8956426,
    "lng": -102.3387479
  },
  {
    "id": "13091",
    "name": "CVS",
    "address": "1500 PADRE BLVD, SOUTH PADRE ISLAND, TX, 78597",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0956845,
    "lng": -97.1651371
  },
  {
    "id": "13090",
    "name": "CVS",
    "address": "6327 HWY. 53 EAST, DAWSONVILLE, GA, 30534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3655511,
    "lng": -84.0380318
  },
  {
    "id": "13089",
    "name": "CVS",
    "address": "11124 HOLMES RD, KANSAS CITY, MO, 64131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9246759,
    "lng": -94.5841674
  },
  {
    "id": "13088",
    "name": "CVS",
    "address": "8315 WEST CENTER RD., OMAHA, NE, 68124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2337662,
    "lng": -96.0421942
  },
  {
    "id": "13087",
    "name": "CVS",
    "address": "805 RUSSELL PKWY., WARNER ROBINS, GA, 31088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5935345,
    "lng": -83.6375863
  },
  {
    "id": "13086",
    "name": "CVS",
    "address": "1400 PARK HILL DR., GAINESVILLE, GA, 30501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3202287,
    "lng": -83.8177586
  },
  {
    "id": "13085",
    "name": "CVS",
    "address": "495 CHARLES HARDY PKWY., DALLAS, GA, 30157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9100091,
    "lng": -84.7794485
  },
  {
    "id": "13084",
    "name": "CVS",
    "address": "329 FRAZEE STREET EAST, DETROIT LAKES, MN, 56501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.815164,
    "lng": -95.8395448
  },
  {
    "id": "13083",
    "name": "CVS",
    "address": "627 W 21ST AVE, COVINGTON, LA, 70433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4778819,
    "lng": -90.1063996
  },
  {
    "id": "13082",
    "name": "CVS",
    "address": "9407 E PARK AVE, HOUMA, LA, 70363",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5928207,
    "lng": -90.6767487
  },
  {
    "id": "13081",
    "name": "CVS",
    "address": "3590 PLAINFIELD AVE. NE, GRAND RAPIDS, MI, 49525",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0279863,
    "lng": -85.6305593
  },
  {
    "id": "13080",
    "name": "CVS",
    "address": "4443 JACKSON ST, ALEXANDRIA, LA, 71303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.2782858,
    "lng": -92.4796192
  },
  {
    "id": "13079",
    "name": "CVS",
    "address": "570 HIGHWAY 321 NORTH, LENOIR CITY, TN, 37771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.809901,
    "lng": -84.263806
  },
  {
    "id": "13078",
    "name": "CVS",
    "address": "3341 RANDLEMAN RD., GREENSBORO, NC, 27406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0037638,
    "lng": -79.8057725
  },
  {
    "id": "13077",
    "name": "CVS",
    "address": "178 TURNERSBURG HWY, STATESVILLE, NC, 28625",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8122707,
    "lng": -80.8752277
  },
  {
    "id": "13076",
    "name": "CVS",
    "address": "303 EAST RUTHERFORD STREET, LANDRUM, SC, 29356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1760259,
    "lng": -82.1866156
  },
  {
    "id": "13075",
    "name": "CVS",
    "address": "320 NEW LEICESTER HWY., ASHEVILLE, NC, 28806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5992825,
    "lng": -82.6225975
  },
  {
    "id": "13074",
    "name": "CVS",
    "address": "400 WESTERN BLVD., JACKSONVILLE, NC, 28546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7680553,
    "lng": -77.3840749
  },
  {
    "id": "13073",
    "name": "CVS",
    "address": "1941 N. MAIN ST., SUMMERVILLE, SC, 29483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.043343,
    "lng": -80.1204244
  },
  {
    "id": "13072",
    "name": "CVS",
    "address": "3312 DEVINE STREET, COLUMBIA, SC, 29205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9969036,
    "lng": -80.9941002
  },
  {
    "id": "13071",
    "name": "CVS",
    "address": "101 EDGEFIELD RD., NORTH AUGUSTA, SC, 29841",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5216771,
    "lng": -81.9537799
  },
  {
    "id": "13070",
    "name": "CVS",
    "address": "401 HWY 12 EAST, STARKVILLE, MS, 39759",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.455001,
    "lng": -88.8098659
  },
  {
    "id": "13069",
    "name": "CVS",
    "address": "7501 AUGUSTA ROAD, PIEDMONT, SC, 29673",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7264985,
    "lng": -82.3880144
  },
  {
    "id": "13068",
    "name": "CVS",
    "address": "801 NORTH BROAD ST, EDENTON, NC, 27932",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0698678,
    "lng": -76.6051441
  },
  {
    "id": "13067",
    "name": "CVS",
    "address": "1895 E. FIRETOWER RD, GREENVILLE, NC, 27858",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5661987,
    "lng": -77.3567139
  },
  {
    "id": "13066",
    "name": "CVS",
    "address": "10 POPE AVENUE, HILTON HEAD ISLAND, SC, 29928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.1532891,
    "lng": -80.7618941
  },
  {
    "id": "13065",
    "name": "CVS",
    "address": "117A VILLAGE RD., LELAND, NC, 28451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2337599,
    "lng": -77.9997648
  },
  {
    "id": "13064",
    "name": "CVS",
    "address": "325 PINEOLA STREET/PO BOX 552, NEWLAND, NC, 28657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0856421,
    "lng": -81.927601
  },
  {
    "id": "13063",
    "name": "CVS",
    "address": "6901 MARKET ST, WILMINGTON, NC, 28411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2629969,
    "lng": -77.8293248
  },
  {
    "id": "13062",
    "name": "CVS",
    "address": "8910 OLD HIGHWAY 6,  P.O. BOX 411, SANTEE, SC, 29142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4872122,
    "lng": -80.4760746
  },
  {
    "id": "13061",
    "name": "CVS",
    "address": "111 WESTGATE RD., LAFAYETTE, LA, 70506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2317643,
    "lng": -92.0865162
  },
  {
    "id": "13060",
    "name": "CVS",
    "address": "1401 BEN SAWYER BLVD., MOUNT PLEASANT, SC, 29464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7931619,
    "lng": -79.8562388
  },
  {
    "id": "13059",
    "name": "CVS",
    "address": "6160 WADE HAMPTON BLVD., TAYLORS, SC, 29687",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9362307,
    "lng": -82.2731815
  },
  {
    "id": "13058",
    "name": "CVS",
    "address": "1115 US HWY 64, PO BOX 1877, MANTEO, NC, 27954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8904805,
    "lng": -75.6604022
  },
  {
    "id": "13057",
    "name": "CVS",
    "address": "100 EDGEWOOD DR., PINEVILLE, LA, 71360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.3334192,
    "lng": -92.3983731
  },
  {
    "id": "13056",
    "name": "CVS",
    "address": "2850 HIGHWAY 90 WEST, AVONDALE, LA, 70094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9107418,
    "lng": -90.2018289
  },
  {
    "id": "13055",
    "name": "CVS",
    "address": "3111 TAYLORSVILLE HIGHWAY, STATESVILLE, NC, 28625",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.795296,
    "lng": -80.9384774
  },
  {
    "id": "13054",
    "name": "CVS",
    "address": "15300 N. COTTON LANE, SURPRISE, AZ, 85388",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.623347,
    "lng": -112.4275632
  },
  {
    "id": "13053",
    "name": "CVS",
    "address": "1370 HWY 17, LITTLE RIVER, SC, 29566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8726347,
    "lng": -78.6216533
  },
  {
    "id": "13052",
    "name": "CVS",
    "address": "5900 WATSON BOULEVARD, WARNER ROBINS, GA, 31093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.61534,
    "lng": -83.7099088
  },
  {
    "id": "13051",
    "name": "CVS",
    "address": "3423 CYPRESS ST, WEST MONROE, LA, 71291",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5167658,
    "lng": -92.1607573
  },
  {
    "id": "13050",
    "name": "CVS",
    "address": "5401 ABERCORN ST.,, SAVANNAH, GA, 31405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.02804,
    "lng": -81.109127
  },
  {
    "id": "13049",
    "name": "CVS",
    "address": "1295 EAST LEAGUE CITY PKWY., LEAGUE CITY, TX, 77573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.494131,
    "lng": -95.0635286
  },
  {
    "id": "13048",
    "name": "CVS",
    "address": "1303 38TH AVE. N., MYRTLE BEACH, SC, 29577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7274122,
    "lng": -78.8698903
  },
  {
    "id": "13047",
    "name": "CVS",
    "address": "601 HWY 17 NORTH, SURFSIDE BEACH, SC, 29575",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6162354,
    "lng": -78.9764541
  },
  {
    "id": "13046",
    "name": "CVS",
    "address": "1710 LOUISVILLE AVE., MONROE, LA, 71201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5166598,
    "lng": -92.1068666
  },
  {
    "id": "13045",
    "name": "CVS",
    "address": "7208 FM 78, SAN ANTONIO, TX, 78244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4851492,
    "lng": -98.3464496
  },
  {
    "id": "13044",
    "name": "CVS",
    "address": "807 E. ATLANTIC ST., SOUTH HILL, VA, 23970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7193377,
    "lng": -78.1171967
  },
  {
    "id": "13043",
    "name": "CVS",
    "address": "801 E. MAIN ST., ABINGDON, VA, 24210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7187615,
    "lng": -81.951521
  },
  {
    "id": "13042",
    "name": "CVS",
    "address": "3555 AIRLINE BLVD, PORTSMOUTH, VA, 23701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8042129,
    "lng": -76.383353
  },
  {
    "id": "13041",
    "name": "CVS",
    "address": "5184 STOCKDALE HWY., BAKERSFIELD, CA, 93309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3546715,
    "lng": -119.0591829
  },
  {
    "id": "13040",
    "name": "CVS",
    "address": "1500 TRAMWAY BLVD., NE, ALBUQUERQUE, NM, 87112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0953893,
    "lng": -106.4966583
  },
  {
    "id": "13039",
    "name": "CVS",
    "address": "336 BRIDGE ST., LOWELL, MA, 1850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.649711,
    "lng": -71.3044032
  },
  {
    "id": "13038",
    "name": "CVS",
    "address": "45 FRANKLIN TURNPIKE, MAHWAH, NJ, 7430",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1047533,
    "lng": -74.1475305
  },
  {
    "id": "13037",
    "name": "CVS",
    "address": "101 OXFORD VALLEY RD, YARDLEY, PA, 19067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2324959,
    "lng": -74.8350693
  },
  {
    "id": "13036",
    "name": "CVS",
    "address": "5601 N. VAN.NUYS BLVD., SHERMAN OAKS, CA, 91401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1726434,
    "lng": -118.4494896
  },
  {
    "id": "13035",
    "name": "CVS",
    "address": "1869 GREAT FALLS HWY., LANCASTER, SC, 29720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6914418,
    "lng": -80.7876377
  },
  {
    "id": "13034",
    "name": "CVS",
    "address": "1200 EAST BUTLER ROAD, GREENVILLE, SC, 29607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8147723,
    "lng": -82.2733088
  },
  {
    "id": "13033",
    "name": "CVS",
    "address": "1071 S. LAKE DR., LEXINGTON, SC, 29073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9533387,
    "lng": -81.2326707
  },
  {
    "id": "13032",
    "name": "CVS",
    "address": "12734 SHOPPES LANE, FAIRFAX, VA, 22033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8607756,
    "lng": -77.3883354
  },
  {
    "id": "13031",
    "name": "CVS",
    "address": "1230 WEST 29TH ST.,, HIALEAH, FL, 33012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8475237,
    "lng": -80.3067732
  },
  {
    "id": "13030",
    "name": "CVS",
    "address": "9805 ROCKY RIVER RD., CHARLOTTE, NC, 28215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2841213,
    "lng": -80.6709683
  },
  {
    "id": "13029",
    "name": "CVS",
    "address": "1991 SPROUL RD., BROOMALL, PA, 19008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9599164,
    "lng": -75.3554056
  },
  {
    "id": "13028",
    "name": "CVS",
    "address": "120 WOODWARD RD., MANALAPAN, NJ, 7726",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.252875,
    "lng": -74.3676363
  },
  {
    "id": "13027",
    "name": "CVS",
    "address": "19901 FREDERICK RD.,, GERMANTOWN, MD, 20876",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1820436,
    "lng": -77.2379108
  },
  {
    "id": "13026",
    "name": "CVS",
    "address": "116 WEST COLLEGE AVE, STATE COLLEGE, PA, 16801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7939559,
    "lng": -77.8617846
  },
  {
    "id": "13025",
    "name": "CVS",
    "address": "2565 LONDON GROVEPORT RD., GROVE CITY, OH, 43123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8382679,
    "lng": -83.0743065
  },
  {
    "id": "13024",
    "name": "CVS",
    "address": "2027 DOUBLEDAY AVE., BALLSTON SPA, NY, 12020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0142358,
    "lng": -73.8470174
  },
  {
    "id": "13023",
    "name": "CVS",
    "address": "1269 SAM HOUSTON JONES PARKWAY, LAKE CHARLES, LA, 70611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3003636,
    "lng": -93.2199143
  },
  {
    "id": "13022",
    "name": "CVS",
    "address": "1296 NORTH AVE., NEW ROCHELLE, NY, 10804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9457279,
    "lng": -73.7962303
  },
  {
    "id": "13021",
    "name": "CVS",
    "address": "18915 US HWY 441, MOUNT DORA, FL, 32757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4237986,
    "lng": -82.2179663
  },
  {
    "id": "13020",
    "name": "CVS",
    "address": "766 NEW LONDON TURNPIKE, GLASTONBURY, CT, 6033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7050343,
    "lng": -72.5945221
  },
  {
    "id": "13019",
    "name": "CVS",
    "address": "200 S. LINCOLN AVE, NEWTOWN, PA, 18940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.225846,
    "lng": -74.9322943
  },
  {
    "id": "13018",
    "name": "CVS",
    "address": "2000 JERICHO TURNPIKE, EAST NORTHPORT, NY, 11731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8379255,
    "lng": -73.3285904
  },
  {
    "id": "13017",
    "name": "CVS",
    "address": "1920 KALISTE SALOOM, LAFAYETTE, LA, 70508",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1680089,
    "lng": -92.0362739
  },
  {
    "id": "13016",
    "name": "CVS",
    "address": "4301 AIRLINE DR., METAIRIE, LA, 70001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9758796,
    "lng": -90.1752159
  },
  {
    "id": "13015",
    "name": "CVS",
    "address": "15 E. NEW HAVEN AVENUE, MELBOURNE, FL, 32901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0781745,
    "lng": -80.6208105
  },
  {
    "id": "13014",
    "name": "CVS",
    "address": "2100 EAST DUBLIN-GRANVILLE ROAD, COLUMBUS, OH, 43229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0872597,
    "lng": -82.9608256
  },
  {
    "id": "13013",
    "name": "CVS",
    "address": "2915 HWY 190, MANDEVILLE, LA, 70471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3893116,
    "lng": -90.0802882
  },
  {
    "id": "13012",
    "name": "CVS",
    "address": "1950 HARD ROAD, COLUMBUS, OH, 43235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1177942,
    "lng": -83.0681003
  },
  {
    "id": "13011",
    "name": "CVS",
    "address": "16804 W. MAIN ST, CUT OFF, LA, 70345",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4713228,
    "lng": -90.3153645
  },
  {
    "id": "13010",
    "name": "CVS",
    "address": "521 EAST STATE STREET, GEORGETOWN, OH, 45121",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8642441,
    "lng": -83.8970737
  },
  {
    "id": "13009",
    "name": "CVS",
    "address": "29-00 BROADWAY (RT. 4), FAIRLAWN, NJ, 7410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9233793,
    "lng": -74.1062275
  },
  {
    "id": "13008",
    "name": "CVS",
    "address": "8910 E. BROAD ST., PATASKALA, OH, 43062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0050777,
    "lng": -82.6593996
  },
  {
    "id": "13007",
    "name": "CVS",
    "address": "5180 E. KINGS CANYON ROAD, FRESNO, CA, 93727",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7348429,
    "lng": -119.7191194
  },
  {
    "id": "13006",
    "name": "CVS",
    "address": "1201 TURNER MCCALL BLVD., ROME, GA, 30161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2557055,
    "lng": -85.1643593
  },
  {
    "id": "13005",
    "name": "CVS",
    "address": "4600 ROSWELL RD., SUITE F100, SANDY SPRINGS, GA, 30342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8809416,
    "lng": -84.3808173
  },
  {
    "id": "13004",
    "name": "CVS",
    "address": "1950 BARATARIA BLVD., MARRERO, LA, 70072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8758847,
    "lng": -90.0988063
  },
  {
    "id": "13003",
    "name": "CVS",
    "address": "5020 N. STATE RD 135, BARGERSVILLE, IN, 46106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.559465,
    "lng": -86.1587589
  },
  {
    "id": "13002",
    "name": "CVS",
    "address": "1175 W. LATHROP RD., MANTECA, CA, 95336",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8269276,
    "lng": -121.2350356
  },
  {
    "id": "13001",
    "name": "CVS",
    "address": "700 NE 6TH AVENUE (US1), DELRAY BEACH, FL, 33483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4735456,
    "lng": -80.0677561
  },
  {
    "id": "13000",
    "name": "CVS",
    "address": "6790 CENTRAL FLORIDA PARKWAY, ORLANDO, FL, 32821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4083661,
    "lng": -81.4711944
  },
  {
    "id": "12999",
    "name": "CVS",
    "address": "4890 BARKSDALE BLVD., BOSSIER CITY, LA, 71112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4603995,
    "lng": -93.6633538
  },
  {
    "id": "12998",
    "name": "CVS",
    "address": "1200 N. ASHLAND, UNIT C-1, CHICAGO, IL, 60622",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9035648,
    "lng": -87.6679007
  },
  {
    "id": "12997",
    "name": "CVS",
    "address": "2535 ROUTE 9, MALTA, NY, 12020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9733571,
    "lng": -73.7912417
  },
  {
    "id": "12996",
    "name": "CVS",
    "address": "3923 GARTH RD., BAYTOWN, TX, 77521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7661031,
    "lng": -94.9780751
  },
  {
    "id": "12995",
    "name": "CVS",
    "address": "241 MOHAWK AVE, SCOTIA, NY, 12302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8270037,
    "lng": -73.9665653
  },
  {
    "id": "12994",
    "name": "CVS",
    "address": "4950 W. ESPLANADE AVE, METAIRIE, LA, 70006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0166263,
    "lng": -90.1980207
  },
  {
    "id": "12993",
    "name": "CVS",
    "address": "181 BRIGHTON AVE, ALLSTON, MA, 2134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3538454,
    "lng": -71.133804
  },
  {
    "id": "12992",
    "name": "CVS",
    "address": "1000 S. CHARLES ST., BALTIMORE, MD, 21230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2776827,
    "lng": -76.6146407
  },
  {
    "id": "12991",
    "name": "CVS",
    "address": "8953 VIRGINIA PKWY., MCKINNEY, TX, 75071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.20293,
    "lng": -96.7320888
  },
  {
    "id": "12990",
    "name": "CVS",
    "address": "2910 BUFORD HWY NE, BROOKHAVEN, GA, 30329",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8335356,
    "lng": -84.3410997
  },
  {
    "id": "12989",
    "name": "CVS",
    "address": "503 E. MAIN ST., PATCHOGUE, NY, 11772",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7676457,
    "lng": -72.9957878
  },
  {
    "id": "12988",
    "name": "CVS",
    "address": "6279 E. STATE BLVD., FORT WAYNE, IN, 46815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1010779,
    "lng": -85.0607855
  },
  {
    "id": "12987",
    "name": "CVS",
    "address": "1220 PENINSULA BLVD., HEWLETT, NY, 11557",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6430366,
    "lng": -73.7068699
  },
  {
    "id": "12986",
    "name": "CVS",
    "address": "116 WASHINGTON AVE., #128, CEDARHURST, NY, 11516",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6203216,
    "lng": -73.7269298
  },
  {
    "id": "12985",
    "name": "CVS",
    "address": "2375 BEECHWOOD DR.,, GERMANTOWN, OH, 45327",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6379372,
    "lng": -84.3494389
  },
  {
    "id": "12984",
    "name": "CVS",
    "address": "7568 NORTH BROADWAY, RED HOOK, NY, 12571",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9978657,
    "lng": -73.8732224
  },
  {
    "id": "12983",
    "name": "CVS",
    "address": "3916 CARMAN RD., SCHENECTADY, NY, 12303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.715467,
    "lng": -73.9327893
  },
  {
    "id": "12982",
    "name": "CVS",
    "address": "413 RTE 376, SUITE 1, HOPEWELL JUNCTION, NY, 12533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5788902,
    "lng": -73.8094802
  },
  {
    "id": "12981",
    "name": "CVS",
    "address": "1624 N. BURNSIDE, GONZALES, LA, 70737",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.246931,
    "lng": -90.9200891
  },
  {
    "id": "12980",
    "name": "CVS",
    "address": "301 E MONTGOMERY CROSS ROAD, SAVANNAH, GA, 31406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.9956255,
    "lng": -81.1148716
  },
  {
    "id": "12979",
    "name": "CVS",
    "address": "182 SOUTH RIDGE ST, RYE BROOK, NY, 10573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0017893,
    "lng": -73.6819025
  },
  {
    "id": "12978",
    "name": "CVS",
    "address": "820 W. ESPLANADE AVE., KENNER, LA, 70065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0217634,
    "lng": -90.2565032
  },
  {
    "id": "12977",
    "name": "CVS",
    "address": "260 ROCK HILL RD., BALA CYNWYD, PA, 19004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0213355,
    "lng": -75.2321815
  },
  {
    "id": "12976",
    "name": "CVS",
    "address": "1142 N. BROOME ST., WAXHAW, NC, 28173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9338826,
    "lng": -80.7479627
  },
  {
    "id": "12975",
    "name": "CVS",
    "address": "7015 PARK AVE., HOUMA, LA, 70364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.606542,
    "lng": -90.7419602
  },
  {
    "id": "12974",
    "name": "CVS",
    "address": "640 SOUTH RANGE AVE, DENHAM SPRINGS, LA, 70726",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4764355,
    "lng": -90.9543313
  },
  {
    "id": "12973",
    "name": "CVS",
    "address": "7004 YOUREE DR, SHREVEPORT, LA, 71105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4428834,
    "lng": -93.7191832
  },
  {
    "id": "12972",
    "name": "CVS",
    "address": "1305 GAUSE BLVD., SLIDELL, LA, 70458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2841836,
    "lng": -89.7650124
  },
  {
    "id": "12971",
    "name": "CVS",
    "address": "5440 ATASCOCITA RD., HUMBLE, TX, 77346",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9879652,
    "lng": -95.1917279
  },
  {
    "id": "12970",
    "name": "CVS",
    "address": "9194 MANSFIELD RD, SHREVEPORT, LA, 71118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4028534,
    "lng": -93.8048804
  },
  {
    "id": "12969",
    "name": "CVS",
    "address": "3384 GOVERNMENT ST, BATON ROUGE, LA, 70806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4435132,
    "lng": -91.154655
  },
  {
    "id": "12968",
    "name": "CVS",
    "address": "3001 E. TEXAS ST., BOSSIER CITY, LA, 71111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5293639,
    "lng": -93.7021931
  },
  {
    "id": "12967",
    "name": "CVS",
    "address": "9608 JEFFERSON HWY, BATON ROUGE, LA, 70809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4105382,
    "lng": -91.0781417
  },
  {
    "id": "12966",
    "name": "CVS",
    "address": "8550 WEST AIRPORT BLVD., HOUSTON, TX, 77071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6422606,
    "lng": -95.5272094
  },
  {
    "id": "12965",
    "name": "CVS",
    "address": "2005 N. DOBSON RD., CHANDLER, AZ, 85224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3358384,
    "lng": -111.8756294
  },
  {
    "id": "12964",
    "name": "CVS",
    "address": "13304 LEESVILLE CHURCH ROAD, RALEIGH, NC, 27617",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.908916,
    "lng": -78.7291544
  },
  {
    "id": "12963",
    "name": "CVS",
    "address": "1314 BABCOCK BLVD., E, DELANO, MN, 55328",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0370394,
    "lng": -93.7705408
  },
  {
    "id": "12962",
    "name": "CVS",
    "address": "1000 BERGEN TOWN CENTER, PARAMUS, NJ, 7652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9168558,
    "lng": -74.0623703
  },
  {
    "id": "12961",
    "name": "CVS",
    "address": "185 N. LEWIS ST.., NEW IBERIA, LA, 70563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.00104,
    "lng": -91.8007959
  },
  {
    "id": "12960",
    "name": "CVS",
    "address": "285 WEST PINE, PONCHATOULA, LA, 70454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4376103,
    "lng": -90.4438626
  },
  {
    "id": "12959",
    "name": "CVS",
    "address": "1500 W AIRLINE HWY, LA PLACE, LA, 70068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0732215,
    "lng": -90.4957018
  },
  {
    "id": "12958",
    "name": "CVS",
    "address": "4406 JOHNSTON ST, LAFAYETTE, LA, 70503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1936552,
    "lng": -92.0596648
  },
  {
    "id": "12957",
    "name": "CVS",
    "address": "1100 VETERANS MEMORIAL DR., ABBEVILLE, LA, 70510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9811288,
    "lng": -92.1236214
  },
  {
    "id": "12956",
    "name": "CVS",
    "address": "1075 W. SANTA FE STREET, OLATHE, KS, 66061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8829421,
    "lng": -94.8330265
  },
  {
    "id": "12955",
    "name": "CVS",
    "address": "5430 BISSONNET ST., BELLAIRE, TX, 77401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7043121,
    "lng": -95.4757331
  },
  {
    "id": "12954",
    "name": "CVS",
    "address": "6300 JOHNSON DR, MISSION, KS, 66202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0227117,
    "lng": -94.658882
  },
  {
    "id": "12953",
    "name": "CVS",
    "address": "9501 NALL AVE., OVERLAND PARK, KS, 66207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9560348,
    "lng": -94.648506
  },
  {
    "id": "12952",
    "name": "CVS",
    "address": "26973 NEWPORT RD., MENIFEE, CA, 92584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6843048,
    "lng": -117.1879588
  },
  {
    "id": "12951",
    "name": "CVS",
    "address": "13502 WEST 87TH STREET PARKWAY, LENEXA, KS, 66215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9717631,
    "lng": -94.7430337
  },
  {
    "id": "12950",
    "name": "CVS",
    "address": "6428 REA ROAD, CHARLOTTE, NC, 28277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0781114,
    "lng": -80.8177954
  },
  {
    "id": "12949",
    "name": "CVS",
    "address": "8200 MISSION RD, PRAIRIE VILLAGE, KS, 66208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9806895,
    "lng": -94.6309515
  },
  {
    "id": "12948",
    "name": "CVS",
    "address": "2129 E. BELT LINE RD., RICHARDSON, TX, 75081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9459771,
    "lng": -96.6834923
  },
  {
    "id": "12947",
    "name": "CVS",
    "address": "1785 S MUR LEN RD, OLATHE, KS, 66062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.855239,
    "lng": -94.7806073
  },
  {
    "id": "12946",
    "name": "CVS",
    "address": "8801 W LINEBAUGH AVE, TAMPA, FL, 33626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0450968,
    "lng": -82.5834525
  },
  {
    "id": "12945",
    "name": "CVS",
    "address": "8809 NEW TAMPA BLVD, TAMPA, FL, 33647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1433213,
    "lng": -82.3543013
  },
  {
    "id": "12944",
    "name": "CVS",
    "address": "3888 HWY 90, PACE, FL, 32571",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5996443,
    "lng": -87.1620397
  },
  {
    "id": "12943",
    "name": "CVS",
    "address": "8422 NAVARRE PKWY, NAVARRE, FL, 32566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4023025,
    "lng": -86.8707256
  },
  {
    "id": "12942",
    "name": "CVS",
    "address": "2353 UNIVERSITY DR, CORAL SPRINGS, FL, 33065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2597702,
    "lng": -80.2492952
  },
  {
    "id": "12941",
    "name": "CVS",
    "address": "110 HIGHWAY 98, PORT SAINT JOE, FL, 32456",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8161986,
    "lng": -85.304291
  },
  {
    "id": "12940",
    "name": "CVS",
    "address": "3265 COUNTY LINE RD., CHALFONT, PA, 18914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2439324,
    "lng": -75.1909254
  },
  {
    "id": "12939",
    "name": "CVS",
    "address": "7496 UNIVERSITY BLVD, WINTER PARK, FL, 32792",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5969112,
    "lng": -81.2872077
  },
  {
    "id": "12938",
    "name": "CVS",
    "address": "4100 MILITARY TRL, JUPITER, FL, 33458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.8968161,
    "lng": -80.1038158
  },
  {
    "id": "12937",
    "name": "CVS",
    "address": "909 E LUMSDEN RD, BRANDON, FL, 33511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9226641,
    "lng": -82.2702933
  },
  {
    "id": "12936",
    "name": "CVS",
    "address": "9170 DANIELS PKWY, FORT MYERS, FL, 33912",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5464628,
    "lng": -81.8036901
  },
  {
    "id": "12935",
    "name": "CVS",
    "address": "301 3RD ST S, SAINT PETERSBURG, FL, 33701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7680821,
    "lng": -82.6374777
  },
  {
    "id": "12934",
    "name": "CVS",
    "address": "4650 W HILLSBORO BLVD., COCONUT CREEK, FL, 33073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3168361,
    "lng": -80.1871142
  },
  {
    "id": "12933",
    "name": "CVS",
    "address": "5403 UNIVERSITY PKWY, UNIVERSITY PARK, FL, 34201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3890711,
    "lng": -82.463153
  },
  {
    "id": "12932",
    "name": "CVS",
    "address": "17817 SE 109TH AVE, SUMMERFIELD, FL, 34491",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9624936,
    "lng": -81.9687377
  },
  {
    "id": "12931",
    "name": "CVS",
    "address": "202 YAMATO RD., BOCA RATON, FL, 33431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3938711,
    "lng": -80.0840914
  },
  {
    "id": "12930",
    "name": "CVS",
    "address": "15174 NW US HIGHWAY 441/PO BOX 1385, ALACHUA, FL, 32615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7936606,
    "lng": -82.495326
  },
  {
    "id": "12929",
    "name": "CVS",
    "address": "12280 LAKE UNDERHILL RD, ORLANDO, FL, 32825",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5460954,
    "lng": -81.2045113
  },
  {
    "id": "12928",
    "name": "CVS",
    "address": "8911 OGDEN AVE., BROOKFIELD, IL, 60513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8164081,
    "lng": -87.844769
  },
  {
    "id": "12927",
    "name": "CVS",
    "address": "5250 CLARK RD, SARASOTA, FL, 34233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.268685,
    "lng": -82.4655003
  },
  {
    "id": "12926",
    "name": "CVS",
    "address": "301 N FEDERAL HWY, BOYNTON BEACH, FL, 33435",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5293959,
    "lng": -80.0586875
  },
  {
    "id": "12925",
    "name": "CVS",
    "address": "955 W 23RD ST, PANAMA CITY, FL, 32405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1893142,
    "lng": -85.6751909
  },
  {
    "id": "12924",
    "name": "CVS",
    "address": "6460 S DIXIE HWY, SOUTH MIAMI, FL, 33143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6969857,
    "lng": -80.2980234
  },
  {
    "id": "12923",
    "name": "CVS",
    "address": "14705 SW 42ND ST, MIAMI, FL, 33185",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7293734,
    "lng": -80.4322175
  },
  {
    "id": "12922",
    "name": "CVS",
    "address": "11670 COUNTRYWAY BLVD, TAMPA, FL, 33626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0694106,
    "lng": -82.6313356
  },
  {
    "id": "12921",
    "name": "CVS",
    "address": "4639 W 1ST ST, SANFORD, FL, 32771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.8109215,
    "lng": -81.3317762
  },
  {
    "id": "12920",
    "name": "CVS",
    "address": "1081 BEAL PKWY NW, FORT WALTON BEACH, FL, 32547",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4553434,
    "lng": -86.637727
  },
  {
    "id": "12919",
    "name": "CVS",
    "address": "1 ROUTE 70 EAST, CHERRY HILL, NJ, 8034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9125694,
    "lng": -75.0110293
  },
  {
    "id": "12918",
    "name": "CVS",
    "address": "964 MONTAUK HWY., SHIRLEY, NY, 11967",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.801948,
    "lng": -72.8612405
  },
  {
    "id": "12917",
    "name": "CVS",
    "address": "430 SR 13, JACKSONVILLE, FL, 32259",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1207232,
    "lng": -81.6260704
  },
  {
    "id": "12916",
    "name": "CVS",
    "address": "2375 VANDERBILT BEACH RD, NAPLES, FL, 34109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2443961,
    "lng": -81.7699453
  },
  {
    "id": "12915",
    "name": "CVS",
    "address": "12255 S CLEVELAND AVE., FORT MYERS, FL, 33907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5639609,
    "lng": -81.8709796
  },
  {
    "id": "12914",
    "name": "CVS",
    "address": "660 EAST HWY 98, PANAMA CITY, FL, 32401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1572637,
    "lng": -85.6511397
  },
  {
    "id": "12913",
    "name": "CVS",
    "address": "1096 JOHN SIMS PARKWAY, NICEVILLE, FL, 32578",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5167917,
    "lng": -86.4678618
  },
  {
    "id": "12912",
    "name": "CVS",
    "address": "225 GULF BREEZE PKWY., GULF BREEZE, FL, 32561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3657586,
    "lng": -87.1711913
  },
  {
    "id": "12911",
    "name": "CVS",
    "address": "13430 INNERARITY POINT RD, PENSACOLA, FL, 32507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3194432,
    "lng": -87.4248185
  },
  {
    "id": "12910",
    "name": "CVS",
    "address": "1150 NE 26TH ST, WILTON MANORS, FL, 33305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1590401,
    "lng": -80.1316491
  },
  {
    "id": "12909",
    "name": "CVS",
    "address": "1040 GRAND AVE., SAINT PAUL, MN, 55105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9397968,
    "lng": -93.1442715
  },
  {
    "id": "12908",
    "name": "CVS",
    "address": "2021 FRANCIS LEWIS BLVD., WHITESTONE, NY, 11357",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7798804,
    "lng": -73.8017989
  },
  {
    "id": "12907",
    "name": "CVS",
    "address": "1300 SW ST LUCIE BLVD, PORT SAINT LUCIE, FL, 34986",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3158636,
    "lng": -80.3868847
  },
  {
    "id": "12906",
    "name": "CVS",
    "address": "18351 W. 119TH ST., OLATHE, KS, 66061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9121034,
    "lng": -94.7981692
  },
  {
    "id": "12905",
    "name": "CVS",
    "address": "4974 NORTH ALAFAYA TRL, ORLANDO, FL, 32826",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.6114528,
    "lng": -81.2082899
  },
  {
    "id": "12904",
    "name": "CVS",
    "address": "4780 NORTH KINGS HWY, FORT PIERCE, FL, 34951",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.520556,
    "lng": -80.3977433
  },
  {
    "id": "12903",
    "name": "CVS",
    "address": "5502 E FOWLER AVE, TEMPLE TERRACE, FL, 33617",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0551362,
    "lng": -82.3943991
  },
  {
    "id": "12902",
    "name": "CVS",
    "address": "1904 W LUMSDEN RD, BRANDON, FL, 33511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9239553,
    "lng": -82.3153857
  },
  {
    "id": "12901",
    "name": "CVS",
    "address": "3400 HOLLYWOOD BLVD, HOLLYWOOD, FL, 33021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0102528,
    "lng": -80.1760851
  },
  {
    "id": "12900",
    "name": "CVS",
    "address": "818 SOUTHERN BLVD, WEST PALM BEACH, FL, 33405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6745064,
    "lng": -80.0614378
  },
  {
    "id": "12899",
    "name": "CVS",
    "address": "2284 SE FEDERAL HWY, STUART, FL, 34994",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.177106,
    "lng": -80.2369672
  },
  {
    "id": "12898",
    "name": "CVS",
    "address": "11398 QUAIL ROOST DR., MIAMI, FL, 33157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.5924384,
    "lng": -80.3776088
  },
  {
    "id": "12897",
    "name": "CVS",
    "address": "1900 19TH AVENUE, SAN FRANCISCO, CA, 94116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7520789,
    "lng": -122.4760021
  },
  {
    "id": "12896",
    "name": "CVS",
    "address": "238 FORSGATE DR., JAMESBURG, NJ, 8831",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3462304,
    "lng": -74.4395103
  },
  {
    "id": "12895",
    "name": "CVS",
    "address": "735 NW 119TH ST, NORTH MIAMI, FL, 33168",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8842798,
    "lng": -80.2114778
  },
  {
    "id": "12894",
    "name": "CVS",
    "address": "11721 S DIXIE HWY, PINECREST, FL, 33156",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6619702,
    "lng": -80.3248358
  },
  {
    "id": "12893",
    "name": "CVS",
    "address": "860 AVENIDA CENTRAL, LADY LAKE, FL, 32159",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9365066,
    "lng": -81.9414192
  },
  {
    "id": "12892",
    "name": "CVS",
    "address": "900 SOUTH SR 7, HOLLYWOOD, FL, 33023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0022244,
    "lng": -80.2078608
  },
  {
    "id": "12891",
    "name": "CVS",
    "address": "2920 DAVIE RD, DAVIE, FL, 33314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0851664,
    "lng": -80.228693
  },
  {
    "id": "12890",
    "name": "CVS",
    "address": "7295 S. RAINBOW BLVD., LAS VEGAS, NV, 89118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0563237,
    "lng": -115.243704
  },
  {
    "id": "12889",
    "name": "CVS",
    "address": "101 SOUTH MAIN STREET, BELLE GLADE, FL, 33430",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6854832,
    "lng": -80.6674361
  },
  {
    "id": "12888",
    "name": "CVS",
    "address": "105 S PEBBLE BEACH BLVD., SUN CITY CENTER, FL, 33573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.711646,
    "lng": -82.352366
  },
  {
    "id": "12887",
    "name": "CVS",
    "address": "14000 US HWY 1, JUNO BEACH, FL, 33408",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.8821572,
    "lng": -80.056049
  },
  {
    "id": "12886",
    "name": "CVS",
    "address": "1285 S. COUNTY TRAIL, EAST GREENWICH, RI, 2818",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6614031,
    "lng": -71.4983213
  },
  {
    "id": "12885",
    "name": "CVS",
    "address": "496 COUNTY ROAD 111, BUILDING C, MANORVILLE, NY, 11949",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8694785,
    "lng": -72.7974212
  },
  {
    "id": "12884",
    "name": "CVS",
    "address": "1003 CALIFORNIA AVE., NATRONA HEIGHTS, PA, 15065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6182951,
    "lng": -79.7330646
  },
  {
    "id": "12883",
    "name": "CVS",
    "address": "392 NORTH ST.,, MEADVILLE, PA, 16335",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6399115,
    "lng": -80.1476085
  },
  {
    "id": "12882",
    "name": "CVS",
    "address": "328 COCHRAN RD., MOUNT LEBANON, PA, 15228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3824755,
    "lng": -80.0519749
  },
  {
    "id": "12881",
    "name": "CVS",
    "address": "100 MARKET ST.,, WARREN, PA, 16365",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8442561,
    "lng": -79.1444386
  },
  {
    "id": "12880",
    "name": "CVS",
    "address": "1771 PLEASANT GROVE BLVD STE #100, ROSEVILLE, CA, 95747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7656383,
    "lng": -121.3576623
  },
  {
    "id": "12879",
    "name": "CVS",
    "address": "551 HARRISBURG AVE., LANCASTER, PA, 17604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0498038,
    "lng": -76.3170068
  },
  {
    "id": "12878",
    "name": "CVS",
    "address": "19 S. MAIN ST., JAMESTOWN, NY, 14701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0936055,
    "lng": -79.2385069
  },
  {
    "id": "12877",
    "name": "CVS",
    "address": "3401 CORAL SPRINGS DR., CORAL SPRINGS, FL, 33065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2730529,
    "lng": -80.2652797
  },
  {
    "id": "12876",
    "name": "CVS",
    "address": "324 INDIAN TRACE RD, WESTON, FL, 33326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1183066,
    "lng": -80.3932211
  },
  {
    "id": "12875",
    "name": "CVS",
    "address": "101 W CITY AVENUE, BALA CYNWYD, PA, 19004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9989836,
    "lng": -75.2319536
  },
  {
    "id": "12874",
    "name": "CVS",
    "address": "10241 W BROWARD BLVD, PLANTATION, FL, 33324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1211959,
    "lng": -80.2860508
  },
  {
    "id": "12873",
    "name": "CVS",
    "address": "100 E. NAPLES ST., WAYLAND, NY, 14572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5681973,
    "lng": -77.5892539
  },
  {
    "id": "12872",
    "name": "CVS",
    "address": "225 MAIN ST.,, DANSVILLE, NY, 14437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5616368,
    "lng": -77.6974965
  },
  {
    "id": "12871",
    "name": "CVS",
    "address": "2668 CRAWFORDVILLE HWY, CRAWFORDVILLE, FL, 32327",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1921974,
    "lng": -84.3728513
  },
  {
    "id": "12870",
    "name": "CVS",
    "address": "9405 W. RUSSELL RD., LAS VEGAS, NV, 89148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0845573,
    "lng": -115.298112
  },
  {
    "id": "12869",
    "name": "CVS",
    "address": "1102 W. MAIN ST., PLAINFIELD, IN, 46168",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6979204,
    "lng": -86.419408
  },
  {
    "id": "12868",
    "name": "CVS",
    "address": "470 W. MAIN STREET, PATCHOGUE, NY, 11772",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7600876,
    "lng": -73.0302891
  },
  {
    "id": "12867",
    "name": "CVS",
    "address": "335 LANCASTER AVE., FRAZER, PA, 19355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0396505,
    "lng": -75.5512331
  },
  {
    "id": "12866",
    "name": "CVS",
    "address": "111 MAIN ST, SOUTHAMPTON, NY, 11968",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8870877,
    "lng": -72.3908621
  },
  {
    "id": "12865",
    "name": "CVS",
    "address": "341 COMMACK RD., COMMACK, NY, 11725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8347703,
    "lng": -73.2948717
  },
  {
    "id": "12864",
    "name": "CVS",
    "address": "109 CLOWES AVE, GOSHEN, NY, 10924",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.39719,
    "lng": -74.332138
  },
  {
    "id": "12863",
    "name": "CVS",
    "address": "53 MAPLE STREET, CROTON ON HUDSON, NY, 10520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2029221,
    "lng": -73.8847154
  },
  {
    "id": "12862",
    "name": "CVS",
    "address": "108 RT 44, MILLERTON, NY, 12546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9524057,
    "lng": -73.5049753
  },
  {
    "id": "12861",
    "name": "CVS",
    "address": "11100 W OAKLAND PARK BLVD, SUNRISE, FL, 33351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1675663,
    "lng": -80.2967173
  },
  {
    "id": "12860",
    "name": "CVS",
    "address": "3081 ROUTE 22,, DOVER PLAINS, NY, 12522",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7352596,
    "lng": -73.5813127
  },
  {
    "id": "12859",
    "name": "CVS",
    "address": "65 QUAKER AVE., CORNWALL, NY, 12518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4333741,
    "lng": -74.0404042
  },
  {
    "id": "12858",
    "name": "CVS",
    "address": "4246 ALBANY POST RD., SUITE 2, HYDE PARK, NY, 12538",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7816986,
    "lng": -73.9309304
  },
  {
    "id": "12857",
    "name": "CVS",
    "address": "4250 ROSWELL RD., N.E., MARIETTA, GA, 30062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9831411,
    "lng": -84.4260471
  },
  {
    "id": "12856",
    "name": "CVS",
    "address": "2 WEST RD., P.O. BOX 514, PLEASANT VALLEY, NY, 12569",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7445251,
    "lng": -73.8269732
  },
  {
    "id": "12855",
    "name": "CVS",
    "address": "1827 MAIN ST., PEEKSKILL, NY, 10566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2958284,
    "lng": -73.8949214
  },
  {
    "id": "12854",
    "name": "CVS",
    "address": "839 RTE 146, CLIFTON PARK, NY, 12065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.864499,
    "lng": -73.7853179
  },
  {
    "id": "12853",
    "name": "CVS",
    "address": "1630 CHRISLER AVENUE, SCHENECTADY, NY, 12303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7903459,
    "lng": -73.9383986
  },
  {
    "id": "12852",
    "name": "CVS",
    "address": "9695 S. MARYLAND PKWY., LAS VEGAS, NV, 89123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.013748,
    "lng": -115.137334
  },
  {
    "id": "12851",
    "name": "CVS",
    "address": "1990 NW CARY PKWY., MORRISVILLE, NC, 27560",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8080861,
    "lng": -78.8122925
  },
  {
    "id": "12850",
    "name": "CVS",
    "address": "2010 S. DOBSON RD., CHANDLER, AZ, 85286",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2754844,
    "lng": -111.8770268
  },
  {
    "id": "12849",
    "name": "CVS",
    "address": "7600 ROUTE 32, PO BOX 140, CAIRO, NY, 12413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2938828,
    "lng": -73.988742
  },
  {
    "id": "12848",
    "name": "CVS",
    "address": "1204 EASTERN AVE, SCHENECTADY, NY, 12308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8072603,
    "lng": -73.9147156
  },
  {
    "id": "12847",
    "name": "CVS",
    "address": "95 BEAVER ST.,, COOPERSTOWN, NY, 13326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6941993,
    "lng": -74.9338013
  },
  {
    "id": "12846",
    "name": "CVS",
    "address": "1875 CAPITAL CIR NE, TALLAHASSEE, FL, 32308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4705873,
    "lng": -84.2304729
  },
  {
    "id": "12845",
    "name": "CVS",
    "address": "4909 PARAMOUNT BLVD., LAKEWOOD, CA, 90712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8476246,
    "lng": -118.1605061
  },
  {
    "id": "12844",
    "name": "CVS",
    "address": "23806 MAIN STREET, CARSON, CA, 90745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8124179,
    "lng": -118.2753635
  },
  {
    "id": "12843",
    "name": "CVS",
    "address": "306 LINCOLN ROAD, MIAMI BEACH, FL, 33139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7904551,
    "lng": -80.1310627
  },
  {
    "id": "12842",
    "name": "CVS",
    "address": "7000 JUSTIN RD., LANTANA, TX, 76226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0726675,
    "lng": -97.109442
  },
  {
    "id": "12841",
    "name": "CVS",
    "address": "3215 GRAND AVE., COCONUT GROVE, FL, 33133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7281666,
    "lng": -80.2463332
  },
  {
    "id": "12840",
    "name": "CVS",
    "address": "1014 HIGHWAY 51 NORTH, MADISON, MS, 39110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4609178,
    "lng": -90.1103891
  },
  {
    "id": "12839",
    "name": "CVS",
    "address": "2115 UNION AVE., MEMPHIS, TN, 38104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1334958,
    "lng": -89.9907462
  },
  {
    "id": "12838",
    "name": "CVS",
    "address": "4500 DONALD ROSS RD.,, PALM BEACH GARDENS, FL, 33418",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.881785,
    "lng": -80.104383
  },
  {
    "id": "12837",
    "name": "CVS",
    "address": "8335 WESTCHESTER DR., SUITE 140, DALLAS, TX, 75225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8644744,
    "lng": -96.8071056
  },
  {
    "id": "12836",
    "name": "CVS",
    "address": "863 BALTIMORE PIKE, GLEN MILLS, PA, 19342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8857992,
    "lng": -75.5290253
  },
  {
    "id": "12835",
    "name": "CVS",
    "address": "13098 PUBLISHERS DR., FISHERS, IN, 46038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9782588,
    "lng": -86.0030027
  },
  {
    "id": "12834",
    "name": "CVS",
    "address": "57 MESSENGER ST., PLAINVILLE, MA, 2762",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0097262,
    "lng": -71.3063983
  },
  {
    "id": "12833",
    "name": "CVS",
    "address": "2050 NELSON RD., NEW LENOX, IL, 60451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4821733,
    "lng": -87.9830114
  },
  {
    "id": "12832",
    "name": "CVS",
    "address": "2828 MOODY PARKWAY, MOODY, AL, 35004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5904207,
    "lng": -86.4953115
  },
  {
    "id": "12831",
    "name": "CVS",
    "address": "2901 MORGAN RD., BESSEMER, AL, 35022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3365077,
    "lng": -86.9166052
  },
  {
    "id": "12830",
    "name": "CVS",
    "address": "27040 HWY 98, DAPHNE, AL, 36526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6189056,
    "lng": -87.9044527
  },
  {
    "id": "12829",
    "name": "CVS",
    "address": "909 GRAND ST., SAN RAFAEL, CA, 94901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9712596,
    "lng": -122.5190586
  },
  {
    "id": "12828",
    "name": "CVS",
    "address": "3303 CLAIRMONT AVENUE S, BIRMINGHAM, AL, 35222",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5131612,
    "lng": -86.7808709
  },
  {
    "id": "12827",
    "name": "CVS",
    "address": "3301 ZINFANDEL DR., RANCHO CORDOVA, CA, 95670",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5816423,
    "lng": -121.2834854
  },
  {
    "id": "12826",
    "name": "CVS",
    "address": "1997 PEPPERELL PKWY., OPELIKA, AL, 36801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6375178,
    "lng": -85.4034549
  },
  {
    "id": "12825",
    "name": "CVS",
    "address": "1204 N. BRINDLEE MOUNTAIN PKWY., ARAB, AL, 35016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3382026,
    "lng": -86.5025367
  },
  {
    "id": "12824",
    "name": "CVS",
    "address": "5920 W. PARK BLVD., PLANO, TX, 75093",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0273169,
    "lng": -96.8255116
  },
  {
    "id": "12823",
    "name": "CVS",
    "address": "2201 TYLER RD., HOOVER, AL, 35226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4164388,
    "lng": -86.8418618
  },
  {
    "id": "12822",
    "name": "CVS",
    "address": "3030 INDEPENDENCE DR., HOMEWOOD, AL, 35209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4775586,
    "lng": -86.7877369
  },
  {
    "id": "12821",
    "name": "CVS",
    "address": "2550 DAUPHIN ST., MOBILE, AL, 36606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6882372,
    "lng": -88.1008436
  },
  {
    "id": "12820",
    "name": "CVS",
    "address": "2212 WHITESBURG DR, HUNTSVILLE, AL, 35801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7166305,
    "lng": -86.5779445
  },
  {
    "id": "12819",
    "name": "CVS",
    "address": "1853 S. ASPEN AVE., BROKEN ARROW, OK, 74012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0325809,
    "lng": -95.8146878
  },
  {
    "id": "12818",
    "name": "CVS",
    "address": "3465 ATLANTA HWY., MONTGOMERY, AL, 36109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3859597,
    "lng": -86.2568877
  },
  {
    "id": "12817",
    "name": "CVS",
    "address": "315 MAIN ST., TRUSSVILLE, AL, 35173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6181061,
    "lng": -86.6117292
  },
  {
    "id": "12816",
    "name": "CVS",
    "address": "1881 CHACE RD., HOOVER, AL, 35244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3697092,
    "lng": -86.8001593
  },
  {
    "id": "12815",
    "name": "CVS",
    "address": "4453 OLD SHELL RD., MOBILE, AL, 36608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6961961,
    "lng": -88.1447704
  },
  {
    "id": "12814",
    "name": "CVS",
    "address": "8503 OLD MADISON PIKE, MADISON, AL, 35758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7062405,
    "lng": -86.7413931
  },
  {
    "id": "12813",
    "name": "CVS",
    "address": "805 W. BUSINESS HWY 380, DECATUR, TX, 76234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.231427,
    "lng": -97.5940137
  },
  {
    "id": "12812",
    "name": "CVS",
    "address": "2480 ROCKY RIDGE ROAD, VESTAVIA, AL, 35243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4225394,
    "lng": -86.7728541
  },
  {
    "id": "12811",
    "name": "CVS",
    "address": "520 HIGHWAY 119, ALABASTER, AL, 35007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2388243,
    "lng": -86.817837
  },
  {
    "id": "12810",
    "name": "CVS",
    "address": "763 WILSON ST., WETUMPKA, AL, 36092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5277404,
    "lng": -86.2052768
  },
  {
    "id": "12809",
    "name": "CVS",
    "address": "105 INVERNESS PLAZA HWY 280, BIRMINGHAM, AL, 35242",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4193498,
    "lng": -86.695604
  },
  {
    "id": "12808",
    "name": "CVS",
    "address": "3190 ZELDA RD., MONTGOMERY, AL, 36106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3527775,
    "lng": -86.2641691
  },
  {
    "id": "12807",
    "name": "CVS",
    "address": "602 1ST AVENUE EAST, ONEONTA, AL, 35121",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.948345,
    "lng": -86.4713383
  },
  {
    "id": "12806",
    "name": "CVS",
    "address": "4197 CROSSHAVEN DR., VESTAVIA HILLS, AL, 35243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4545256,
    "lng": -86.7302558
  },
  {
    "id": "12805",
    "name": "CVS",
    "address": "812 BELTLINE RD, DECATUR, AL, 35601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5607683,
    "lng": -86.9990324
  },
  {
    "id": "12804",
    "name": "CVS",
    "address": "434 HWY 31, WARRIOR, AL, 35180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.806046,
    "lng": -86.8118199
  },
  {
    "id": "12803",
    "name": "CVS",
    "address": "1 ROUTE US 9 SOUTH, MARMORA, NJ, 8223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2639784,
    "lng": -74.6469433
  },
  {
    "id": "12802",
    "name": "CVS",
    "address": "118 COMER AVENUE, PELL CITY, AL, 35125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5891364,
    "lng": -86.2815185
  },
  {
    "id": "12801",
    "name": "CVS",
    "address": "708 E. MAIN ST., PRATTVILLE, AL, 36067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.4595656,
    "lng": -86.4545067
  },
  {
    "id": "12800",
    "name": "CVS",
    "address": "1910 MCFARLAND BOULEVARD, NORTHPORT, AL, 35476",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.239902,
    "lng": -87.5770829
  },
  {
    "id": "12799",
    "name": "CVS",
    "address": "101 N AIRPORT RD., JASPER, AL, 35504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8488473,
    "lng": -87.2670015
  },
  {
    "id": "12798",
    "name": "CVS",
    "address": "100 E FM 495, SAN JUAN, TX, 78589",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2076929,
    "lng": -98.152392
  },
  {
    "id": "12797",
    "name": "CVS",
    "address": "220 GADSDEN HIGHWAY, BIRMINGHAM, AL, 35235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5893039,
    "lng": -86.6967533
  },
  {
    "id": "12796",
    "name": "CVS",
    "address": "3403 RAINBOW DR., RAINBOW CITY, AL, 35906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9571891,
    "lng": -86.0400137
  },
  {
    "id": "12795",
    "name": "CVS",
    "address": "1901 11TH AVE., HALEYVILLE, AL, 35565",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2261712,
    "lng": -87.6207018
  },
  {
    "id": "12794",
    "name": "CVS",
    "address": "2820 W. UNIVERSITY DR., EDINBURG, TX, 78539",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3052399,
    "lng": -98.1937048
  },
  {
    "id": "12793",
    "name": "CVS",
    "address": "100 NORTH DUMAS AVENUE, DUMAS, TX, 79029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8658073,
    "lng": -101.9723455
  },
  {
    "id": "12792",
    "name": "CVS",
    "address": "808 VETERANS MEMORIAL DRIVE, TUSCALOOSA, AL, 35404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.197687,
    "lng": -87.5249798
  },
  {
    "id": "12791",
    "name": "CVS",
    "address": "545 W. WASHINGTON ST., COUNCIL BLUFFS, IA, 51503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2628436,
    "lng": -95.8510809
  },
  {
    "id": "12790",
    "name": "CVS",
    "address": "215 HWY 31 SOUTH, ATHENS, AL, 35611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7973333,
    "lng": -86.953238
  },
  {
    "id": "12789",
    "name": "CVS",
    "address": "11375 W ATLANTIC BLVD, CORAL SPRINGS, FL, 33071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2403887,
    "lng": -80.2779084
  },
  {
    "id": "12788",
    "name": "CVS",
    "address": "16801 CHILLICOTHE RD., CHAGRIN FALLS, OH, 44023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4121534,
    "lng": -81.337449
  },
  {
    "id": "12787",
    "name": "CVS",
    "address": "6170 LAKELAND HIGHLANDS RD, LAKELAND, FL, 33813",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9534674,
    "lng": -81.9229692
  },
  {
    "id": "12786",
    "name": "CVS",
    "address": "590 EAST MARKET STREET, AKRON, OH, 44304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0771628,
    "lng": -81.498774
  },
  {
    "id": "12785",
    "name": "CVS",
    "address": "2105 13TH ST., SAINT CLOUD, FL, 34769",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.2454503,
    "lng": -81.2931301
  },
  {
    "id": "12784",
    "name": "CVS",
    "address": "4550 LYONS RD., COCONUT CREEK, FL, 33073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2866017,
    "lng": -80.1856321
  },
  {
    "id": "12783",
    "name": "CVS",
    "address": "5900 W. PLEASANT RIDGE RD., ARLINGTON, TX, 76016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6810459,
    "lng": -97.1971667
  },
  {
    "id": "12782",
    "name": "CVS",
    "address": "12750 S. MILITARY TRAIL, BOYNTON BEACH, FL, 33436",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4872648,
    "lng": -80.1220684
  },
  {
    "id": "12781",
    "name": "CVS",
    "address": "2311 LIME KILN RD., LOUISVILLE, KY, 40222",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2846357,
    "lng": -85.6276854
  },
  {
    "id": "12780",
    "name": "CVS",
    "address": "101 ASBURY AVE., EVANSTON, IL, 60202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.020295,
    "lng": -87.6899249
  },
  {
    "id": "12779",
    "name": "CVS",
    "address": "2000 SWAMP PIKE, GILBERTSVILLE, PA, 19525",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2986991,
    "lng": -75.585252
  },
  {
    "id": "12778",
    "name": "CVS",
    "address": "3425 SCHUYLKILL RD., SPRING CITY, PA, 19475",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1823143,
    "lng": -75.5661059
  },
  {
    "id": "12777",
    "name": "CVS",
    "address": "510 C STREET, SAN DIEGO, CA, 92101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7168986,
    "lng": -117.1599789
  },
  {
    "id": "12776",
    "name": "CVS",
    "address": "3200 HIGHLAND ROAD, BATON ROUGE, LA, 70802",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4190495,
    "lng": -91.1772413
  },
  {
    "id": "12775",
    "name": "CVS",
    "address": "480 NORTH GLYNN ST.,, FAYETTEVILLE, GA, 30214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4578806,
    "lng": -84.4542673
  },
  {
    "id": "12774",
    "name": "CVS",
    "address": "1544 PIEDMONT AVE NE, ATLANTA, GA, 30324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7969393,
    "lng": -84.3694882
  },
  {
    "id": "12773",
    "name": "CVS",
    "address": "24 MAMARONECK AVE, WHITE PLAINS, NY, 10601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.03187,
    "lng": -73.7667697
  },
  {
    "id": "12772",
    "name": "CVS",
    "address": "9510 ELLERBE RD., SHREVEPORT, LA, 71106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.393546,
    "lng": -93.7256531
  },
  {
    "id": "12771",
    "name": "CVS",
    "address": "13400 IMMOKALEE RD., NAPLES, FL, 34120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2780125,
    "lng": -81.5978962
  },
  {
    "id": "12770",
    "name": "CVS",
    "address": "6370 POWERS FERRY RD., ATLANTA, GA, 30339",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9043087,
    "lng": -84.4304779
  },
  {
    "id": "12769",
    "name": "CVS",
    "address": "6511 WHITESTOWN PARKWAY, ZIONSVILLE, IN, 46077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9487084,
    "lng": -86.3439406
  },
  {
    "id": "12768",
    "name": "CVS",
    "address": "24200 VETERANS BLVD, PORT CHARLOTTE, FL, 33954",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0175711,
    "lng": -82.0518025
  },
  {
    "id": "12767",
    "name": "CVS",
    "address": "1554 N DECATUR ROAD NE, ATLANTA, GA, 30307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7881534,
    "lng": -84.3271696
  },
  {
    "id": "12766",
    "name": "CVS",
    "address": "2080 HOG MOUNTAIN RD., WATKINSVILLE, GA, 30677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8744149,
    "lng": -83.4410939
  },
  {
    "id": "12765",
    "name": "CVS",
    "address": "2429 MARTIN LUTHER KING JR. DR., ATLANTA, GA, 30311",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7523715,
    "lng": -84.4668032
  },
  {
    "id": "12764",
    "name": "CVS",
    "address": "5315 BRIARWOOD AVE., MIDLAND, TX, 79707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0257061,
    "lng": -102.1617278
  },
  {
    "id": "12763",
    "name": "CVS",
    "address": "39820 HICKMAN PLAZA RD., BETHANY BEACH, DE, 19930",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5287065,
    "lng": -75.0566884
  },
  {
    "id": "12762",
    "name": "CVS",
    "address": "12601 TOMBALL PKWY., HOUSTON, TX, 77086",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9107434,
    "lng": -95.4808039
  },
  {
    "id": "12761",
    "name": "CVS",
    "address": "5590 NORTH WICKHAM RD., MELBOURNE, FL, 32940",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.2000283,
    "lng": -80.6726584
  },
  {
    "id": "12760",
    "name": "CVS",
    "address": "107 MORRISTOWN RD., BERNARDSVILLE, NJ, 7924",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7190824,
    "lng": -74.5606999
  },
  {
    "id": "12759",
    "name": "CVS",
    "address": "4895 POST RD., CUMMING, GA, 30040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2087026,
    "lng": -84.2189249
  },
  {
    "id": "12758",
    "name": "CVS",
    "address": "3724 NORTH OCEAN BLVD., FORT LAUDERDALE, FL, 33308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1738773,
    "lng": -80.0991033
  },
  {
    "id": "12757",
    "name": "CVS",
    "address": "4561 RIVER RD., COLUMBUS, GA, 31904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.508162,
    "lng": -84.982548
  },
  {
    "id": "12756",
    "name": "CVS",
    "address": "320 E 20TH ST., TIFTON, GA, 31794",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.472106,
    "lng": -83.5019386
  },
  {
    "id": "12755",
    "name": "CVS",
    "address": "377 32ND AVE., SAN FRANCISCO, CA, 94121",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7820741,
    "lng": -122.4928931
  },
  {
    "id": "12754",
    "name": "CVS",
    "address": "7042 MOON RD., COLUMBUS, GA, 31909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5499801,
    "lng": -84.9260044
  },
  {
    "id": "12753",
    "name": "CVS",
    "address": "2091 LOST MOUNTAIN RD., POWDER SPRINGS, GA, 30127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9030285,
    "lng": -84.6720624
  },
  {
    "id": "12752",
    "name": "CVS",
    "address": "3401 NORTHSIDE PKWY NW, ATLANTA, GA, 30327",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.847349,
    "lng": -84.4278523
  },
  {
    "id": "12751",
    "name": "CVS",
    "address": "765 EAST COUNTY LINE RD.,, HATBORO, PA, 19040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1725681,
    "lng": -75.0724762
  },
  {
    "id": "12750",
    "name": "CVS",
    "address": "17201 PINES BLVD, PEMBROKE PINES, FL, 33029",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.008429,
    "lng": -80.3772173
  },
  {
    "id": "12749",
    "name": "CVS",
    "address": "7932 27TH AVENUE NORTH, NEW HOPE, MN, 55427",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0077339,
    "lng": -93.3818157
  },
  {
    "id": "12748",
    "name": "CVS",
    "address": "401 S. MAIN ST, GRAHAM, NC, 27253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0631035,
    "lng": -79.4010168
  },
  {
    "id": "12747",
    "name": "CVS",
    "address": "300 BALLENGER CENTER DR., FREDERICK, MD, 21703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3952526,
    "lng": -77.4369395
  },
  {
    "id": "12746",
    "name": "CVS",
    "address": "10580 EAST 96TH ST, FISHERS, IN, 46037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9282752,
    "lng": -85.9824114
  },
  {
    "id": "12745",
    "name": "CVS",
    "address": "80 PIERMONT RD., CRESSKILL, NJ, 7626",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9403422,
    "lng": -73.9617899
  },
  {
    "id": "12744",
    "name": "CVS",
    "address": "4721 E 126TH ST, CARMEL, IN, 46033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9699177,
    "lng": -86.090985
  },
  {
    "id": "12743",
    "name": "CVS",
    "address": "111 LAKEVIEW DR., NOBLESVILLE, IN, 46060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0478447,
    "lng": -86.02436
  },
  {
    "id": "12742",
    "name": "CVS",
    "address": "8546 S TAMIAMI TRL, SARASOTA, FL, 34238",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2260494,
    "lng": -82.4939302
  },
  {
    "id": "12741",
    "name": "CVS",
    "address": "6025 SE US HWY 301, HAWTHORNE, FL, 32640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7114397,
    "lng": -82.1375956
  },
  {
    "id": "12740",
    "name": "CVS",
    "address": "120 WEST WALKER DR., KEYSTONE HEIGHTS, FL, 32656",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7868022,
    "lng": -82.0314332
  },
  {
    "id": "12739",
    "name": "CVS",
    "address": "187 MILLBURN AVE, MILLBURN, NJ, 7041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7230026,
    "lng": -74.2961459
  },
  {
    "id": "12738",
    "name": "CVS",
    "address": "3625 S. COLLEGE RD., WILMINGTON, NC, 28412",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1759518,
    "lng": -77.8902285
  },
  {
    "id": "12737",
    "name": "CVS",
    "address": "7409 WEBBS RD.,, DENVER, NC, 28037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5185019,
    "lng": -81.0041137
  },
  {
    "id": "12736",
    "name": "CVS",
    "address": "7195 SR 70, BRADENTON, FL, 34203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.4452287,
    "lng": -82.4692455
  },
  {
    "id": "12735",
    "name": "CVS",
    "address": "200 BISCAYNE BLVD, MIAMI, FL, 33132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7721896,
    "lng": -80.1881168
  },
  {
    "id": "12734",
    "name": "CVS",
    "address": "951 ATLANTIC AVE, BALDWIN, NY, 11510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6402075,
    "lng": -73.6071203
  },
  {
    "id": "12733",
    "name": "CVS",
    "address": "2801 GUILDERLAND AVE., ROTTERDAM, NY, 12306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7862865,
    "lng": -73.971662
  },
  {
    "id": "12732",
    "name": "CVS",
    "address": "601 N BROADWAY, WHITE PLAINS, NY, 10603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0540936,
    "lng": -73.7695964
  },
  {
    "id": "12731",
    "name": "CVS",
    "address": "24800 S TAMIAMI TRL, BONITA SPRINGS, FL, 34134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3798812,
    "lng": -81.8087419
  },
  {
    "id": "12730",
    "name": "CVS",
    "address": "415 N. MAIN ST., ORRVILLE, OH, 44667",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8440614,
    "lng": -81.7646297
  },
  {
    "id": "12729",
    "name": "CVS",
    "address": "900 EDMONDSON AVE, BALTIMORE, MD, 21228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2765521,
    "lng": -76.7401829
  },
  {
    "id": "12728",
    "name": "CVS",
    "address": "1099 JOHNSON FERRY ROAD, MARIETTA, GA, 30068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.974611,
    "lng": -84.4150097
  },
  {
    "id": "12727",
    "name": "CVS",
    "address": "869 HORIZON SOUTH PARKWAY, GROVETOWN, GA, 30813",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4589749,
    "lng": -82.1943467
  },
  {
    "id": "12726",
    "name": "CVS",
    "address": "6109 CARR 694, VEGA ALTA, PR, 692",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4132986,
    "lng": -66.3071067
  },
  {
    "id": "12725",
    "name": "CVS",
    "address": "2703 WASHINGTON RD., AUGUSTA, GA, 30909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5088307,
    "lng": -82.0218961
  },
  {
    "id": "12724",
    "name": "CVS",
    "address": "9849 ROME BLVD., SUMMERVILLE, GA, 30747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.4771992,
    "lng": -85.3492741
  },
  {
    "id": "12723",
    "name": "CVS",
    "address": "1605 FREDERICA ROAD, SAINT SIMONS ISLAND, GA, 31522",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.1601778,
    "lng": -81.3891291
  },
  {
    "id": "12722",
    "name": "CVS",
    "address": "609 N. WESTOVER BLVD., ALBANY, GA, 31707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.6102713,
    "lng": -84.2238041
  },
  {
    "id": "12721",
    "name": "CVS",
    "address": "960 N COLUMBIA ST, MILLEDGEVILLE, GA, 31061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.091858,
    "lng": -83.2378449
  },
  {
    "id": "12720",
    "name": "CVS",
    "address": "912 W. WARD ST., DOUGLAS, GA, 31533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.5087507,
    "lng": -82.8609065
  },
  {
    "id": "12719",
    "name": "CVS",
    "address": "8139 TARA BLVD., JONESBORO, GA, 30236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5318668,
    "lng": -84.3643708
  },
  {
    "id": "12718",
    "name": "CVS",
    "address": "1615 FOREST HILL RD., MACON, GA, 31210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.899724,
    "lng": -83.702726
  },
  {
    "id": "12717",
    "name": "CVS",
    "address": "4255 QUAKER LANE, NORTH KINGSTOWN, RI, 2852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5830839,
    "lng": -71.5001728
  },
  {
    "id": "12716",
    "name": "CVS",
    "address": "3481 GEORGIA HWY 20, CONYERS, GA, 30013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7362976,
    "lng": -83.9924266
  },
  {
    "id": "12715",
    "name": "CVS",
    "address": "1802 ROANOKE RD, LAGRANGE, GA, 30240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0328006,
    "lng": -85.068883
  },
  {
    "id": "12714",
    "name": "CVS",
    "address": "25-43 PROSPECT ST., YONKERS, NY, 10701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9330398,
    "lng": -73.9010507
  },
  {
    "id": "12713",
    "name": "CVS",
    "address": "1610 MT. VERNON RD, STE #100, ATLANTA, GA, 30338",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9470698,
    "lng": -84.3344684
  },
  {
    "id": "12712",
    "name": "CVS",
    "address": "2205 N ASHLEY ST, VALDOSTA, GA, 31602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.8607309,
    "lng": -83.2816225
  },
  {
    "id": "12711",
    "name": "CVS",
    "address": "506 EAST 3RD STREET, JACKSON, GA, 30233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2939632,
    "lng": -83.9612377
  },
  {
    "id": "12710",
    "name": "CVS",
    "address": "5176 E. WHITTIER BLVD., LOS ANGELES, CA, 90022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0198923,
    "lng": -118.1579305
  },
  {
    "id": "12709",
    "name": "CVS",
    "address": "800 E WEST CONNECTOR, AUSTELL, GA, 30106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8571197,
    "lng": -84.5769978
  },
  {
    "id": "12708",
    "name": "CVS",
    "address": "1800 FREDERICK BLVD., PORTSMOUTH, VA, 23707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8242137,
    "lng": -76.3394101
  },
  {
    "id": "12707",
    "name": "CVS",
    "address": "920 E. ROBERT TOOMBS AVE., WASHINGTON, GA, 30673",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.727998,
    "lng": -82.7188233
  },
  {
    "id": "12706",
    "name": "CVS",
    "address": "14857 US HWY 19 S., THOMASVILLE, GA, 31792",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.8523469,
    "lng": -83.9463507
  },
  {
    "id": "12705",
    "name": "CVS",
    "address": "111 E. 8TH ST., TIFTON, GA, 31794",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.4602896,
    "lng": -83.5072702
  },
  {
    "id": "12704",
    "name": "CVS",
    "address": "2830 N. DRUID HILLS RD. NE, ATLANTA, GA, 30329",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8184268,
    "lng": -84.3122086
  },
  {
    "id": "12703",
    "name": "CVS",
    "address": "103 JESSE JEWEL PARKWAY SW, GAINESVILLE, GA, 30501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2966938,
    "lng": -83.8250897
  },
  {
    "id": "12702",
    "name": "CVS",
    "address": "402 N. WALL ST., CALHOUN, GA, 30701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5062708,
    "lng": -84.9512309
  },
  {
    "id": "12701",
    "name": "CVS",
    "address": "6330 ROSWELL RD, SANDY SPRINGS, GA, 30328",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.927503,
    "lng": -84.3797087
  },
  {
    "id": "12700",
    "name": "CVS",
    "address": "302 N TYNDALL PKWY, PANAMA CITY, FL, 32404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1534129,
    "lng": -85.5902705
  },
  {
    "id": "12699",
    "name": "CVS",
    "address": "1443 RICHMOND RD., LYNDHURST, OH, 44124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5202737,
    "lng": -81.496115
  },
  {
    "id": "12698",
    "name": "CVS",
    "address": "8981 CONROY WINDERMERE RD, ORLANDO, FL, 32835",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4952517,
    "lng": -81.5079502
  },
  {
    "id": "12697",
    "name": "CVS",
    "address": "9306 NARCOOSSEE RD., ORLANDO, FL, 32827",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4317351,
    "lng": -81.257648
  },
  {
    "id": "12696",
    "name": "CVS",
    "address": "1006 FORDING ISLAND ROAD, BLUFFTON, SC, 29910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.2570449,
    "lng": -80.8506012
  },
  {
    "id": "12695",
    "name": "CVS",
    "address": "19225 NW US HIGHWAY 441, HIGH SPRINGS, FL, 32643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8314387,
    "lng": -82.5957657
  },
  {
    "id": "12694",
    "name": "CVS",
    "address": "4777 SAWMILL RD, GALLERIA TOWN CENTRE, COLUMBUS, OH, 43220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0644439,
    "lng": -83.0941056
  },
  {
    "id": "12693",
    "name": "CVS",
    "address": "3831 N MONROE ST, TALLAHASSEE, FL, 32303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5029474,
    "lng": -84.3284532
  },
  {
    "id": "12692",
    "name": "CVS",
    "address": "15 CHESTERFIELD RD., EAST LYME, CT, 6333",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3674617,
    "lng": -72.2087114
  },
  {
    "id": "12691",
    "name": "CVS",
    "address": "1819 W TENNESSEE ST, TALLAHASSEE, FL, 32304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4484255,
    "lng": -84.3131951
  },
  {
    "id": "12690",
    "name": "CVS",
    "address": "7935 S. EMERSON AVE., SUITE B, INDIANAPOLIS, IN, 46237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6515871,
    "lng": -86.0821483
  },
  {
    "id": "12689",
    "name": "CVS",
    "address": "520 LARKFIELD ROAD, EAST NORTHPORT, NY, 11731",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8626974,
    "lng": -73.3214049
  },
  {
    "id": "12688",
    "name": "CVS",
    "address": "1280 DEERPARK AVE, NORTH BABYLON, NY, 11703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7400007,
    "lng": -73.3215623
  },
  {
    "id": "12687",
    "name": "CVS",
    "address": "3496 LONG BEACH RD, OCEANSIDE, NY, 11572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6260061,
    "lng": -73.6404675
  },
  {
    "id": "12686",
    "name": "CVS",
    "address": "3737 N. ROXBORO ST., DURHAM, NC, 27704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0395573,
    "lng": -78.8997272
  },
  {
    "id": "12685",
    "name": "CVS",
    "address": "1119 EASTCHESTER DR, HIGH POINT, NC, 27265",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9926086,
    "lng": -79.9994758
  },
  {
    "id": "12684",
    "name": "CVS",
    "address": "434 RACETRACK RD NE, FORT WALTON BEACH, FL, 32547",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4421078,
    "lng": -86.5986548
  },
  {
    "id": "12683",
    "name": "CVS",
    "address": "6635-37 BELAIR RD, BALTIMORE, MD, 21206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3545463,
    "lng": -76.5302855
  },
  {
    "id": "12682",
    "name": "CVS",
    "address": "1615 SPRING GARDEN ST, GREENSBORO, NC, 27403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0638783,
    "lng": -79.816937
  },
  {
    "id": "12681",
    "name": "CVS",
    "address": "7845 WISE AVE., BALTIMORE, MD, 21222",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2664687,
    "lng": -76.4957093
  },
  {
    "id": "12680",
    "name": "CVS",
    "address": "8600 HIXSON PIKE, HIXSON, TN, 37343",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.200555,
    "lng": -85.1578608
  },
  {
    "id": "12679",
    "name": "CVS",
    "address": "2907 MAIN STREET, EAST POINT, GA, 30344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6758503,
    "lng": -84.4417996
  },
  {
    "id": "12678",
    "name": "CVS",
    "address": "340 WEST MAIN ST., MONTEAGLE, TN, 37356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2400207,
    "lng": -85.8408253
  },
  {
    "id": "12677",
    "name": "CVS",
    "address": "505 TWENTIETH ST., HUNTINGTON, WV, 25703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4226449,
    "lng": -82.4226232
  },
  {
    "id": "12676",
    "name": "CVS",
    "address": "8501 FORT SMALLWOOD RD., PASADENA, MD, 21122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1566217,
    "lng": -76.5158995
  },
  {
    "id": "12675",
    "name": "CVS",
    "address": "50 DUVAL STATION RD., JACKSONVILLE, FL, 32218",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4894652,
    "lng": -81.624742
  },
  {
    "id": "12674",
    "name": "CVS",
    "address": "7470 MANCHESTER RD., MAPLEWOOD, MO, 63143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6118132,
    "lng": -90.3225665
  },
  {
    "id": "12673",
    "name": "CVS",
    "address": "1400 EAST 9TH ST, CLEVELAND, OH, 44114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5031428,
    "lng": -81.6897837
  },
  {
    "id": "12672",
    "name": "CVS",
    "address": "3066 STATE RT. 160, GALLIPOLIS, OH, 45631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8447123,
    "lng": -82.2340935
  },
  {
    "id": "12671",
    "name": "CVS",
    "address": "921 SOUTH STATE STREET, YADKINVILLE, NC, 27055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1172076,
    "lng": -80.659006
  },
  {
    "id": "12670",
    "name": "CVS",
    "address": "12550 LOUETTA RD., CYPRESS, TX, 77429",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9970278,
    "lng": -95.6135367
  },
  {
    "id": "12669",
    "name": "CVS",
    "address": "2648 DEMPSTER STREET, PARK RIDGE, IL, 60068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0399389,
    "lng": -87.8579679
  },
  {
    "id": "12668",
    "name": "CVS",
    "address": "10599 DORCHESTER RD., SUMMERVILLE, SC, 29485",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9670028,
    "lng": -80.2009987
  },
  {
    "id": "12667",
    "name": "CVS",
    "address": "1845 MARTIN LUTHER KING PKWY., DURHAM, NC, 27707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9605596,
    "lng": -78.9599116
  },
  {
    "id": "12666",
    "name": "CVS",
    "address": "1736 W. 9TH AVE., OSHKOSH, WI, 54902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0113481,
    "lng": -88.5788197
  },
  {
    "id": "12665",
    "name": "CVS",
    "address": "4400 BRAMBLETON AVE, ROANOKE, VA, 24018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2248786,
    "lng": -80.0114391
  },
  {
    "id": "12664",
    "name": "CVS",
    "address": "12510 OCEAN GATEWAY HWY., OCEAN CITY, MD, 21842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3384025,
    "lng": -75.1184841
  },
  {
    "id": "12663",
    "name": "CVS",
    "address": "4610 CENTRE AVE., PITTSBURGH, PA, 15213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4516718,
    "lng": -79.9515338
  },
  {
    "id": "12662",
    "name": "CVS",
    "address": "801 MAIN ST., MUNSTER, IN, 46321",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.523294,
    "lng": -87.5080887
  },
  {
    "id": "12661",
    "name": "CVS",
    "address": "1920 A1A SOUTH, SAINT AUGUSTINE, FL, 32080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8597541,
    "lng": -81.2807235
  },
  {
    "id": "12660",
    "name": "CVS",
    "address": "401 S ELMWOOD AVE, MEDINA, OH, 44256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1352095,
    "lng": -81.8664002
  },
  {
    "id": "12659",
    "name": "CVS",
    "address": "283 SW BAYA DR, LAKE CITY, FL, 32025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1844354,
    "lng": -82.6398615
  },
  {
    "id": "12658",
    "name": "CVS",
    "address": "301 ANDREWS HIGHWAY, MIDLAND, TX, 79701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.9955328,
    "lng": -102.1010456
  },
  {
    "id": "12657",
    "name": "CVS",
    "address": "13215 SHAKER SQUARE, CLEVELAND, OH, 44120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4844943,
    "lng": -81.5895136
  },
  {
    "id": "12656",
    "name": "CVS",
    "address": "11223 GRANGER RD., GARFIELD HEIGHTS, OH, 44125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4175404,
    "lng": -81.6069962
  },
  {
    "id": "12655",
    "name": "CVS",
    "address": "30 MARKET ST., SAINT SIMONS ISLAND, GA, 31522",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.1848563,
    "lng": -81.3804108
  },
  {
    "id": "12654",
    "name": "CVS",
    "address": "1 MCWHIRT LOOP, FREDERICKSBURG, VA, 22406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3537142,
    "lng": -77.5101206
  },
  {
    "id": "12653",
    "name": "CVS",
    "address": "380 STATE ST., CONNEAUT, OH, 44030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9442964,
    "lng": -80.560945
  },
  {
    "id": "12652",
    "name": "CVS",
    "address": "4028 LONE TREE WAY, ANTIOCH, CA, 94531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9773713,
    "lng": -121.8039001
  },
  {
    "id": "12651",
    "name": "CVS",
    "address": "10050 WOODLAND RD., LENEXA, KS, 66220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9461299,
    "lng": -94.8168299
  },
  {
    "id": "12650",
    "name": "CVS",
    "address": "1009 W. ROSEMEADE PKWY., CARROLLTON, TX, 75007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0105156,
    "lng": -96.9114826
  },
  {
    "id": "12649",
    "name": "CVS",
    "address": "840 EUCLID AVE, CLEVELAND, OH, 44114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4998716,
    "lng": -81.6871405
  },
  {
    "id": "12648",
    "name": "CVS",
    "address": "1305 MATTHEWS TOWNSHIP PKWY, MATTHEWS, NC, 28105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1224296,
    "lng": -80.7168073
  },
  {
    "id": "12647",
    "name": "CVS",
    "address": "2062 WHISKEY ROAD, AIKEN, SC, 29803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5184141,
    "lng": -81.7161634
  },
  {
    "id": "12646",
    "name": "CVS",
    "address": "309 EAST CENTER ST., LEXINGTON, NC, 27292",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8197001,
    "lng": -80.2491645
  },
  {
    "id": "12645",
    "name": "CVS",
    "address": "840 BERRYVILLE AVE., WINCHESTER, VA, 22601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1864715,
    "lng": -78.1456202
  },
  {
    "id": "12644",
    "name": "CVS",
    "address": "5311 ROXBORO RD., DURHAM, NC, 27712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0781818,
    "lng": -78.9111876
  },
  {
    "id": "12643",
    "name": "CVS",
    "address": "2707 CELANESE RD., ROCK HILL, SC, 29732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9753725,
    "lng": -81.0270707
  },
  {
    "id": "12642",
    "name": "CVS",
    "address": "21550 TIMBERLAKE RD., LYNCHBURG, VA, 24502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3283926,
    "lng": -79.2466127
  },
  {
    "id": "12641",
    "name": "CVS",
    "address": "3171 BALFOUR RD, BRENTWOOD, CA, 94513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.92628,
    "lng": -121.7212381
  },
  {
    "id": "12640",
    "name": "CVS",
    "address": "2324 SR 524, COCOA, FL, 32926",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3976397,
    "lng": -80.7665163
  },
  {
    "id": "12639",
    "name": "CVS",
    "address": "3095 N. MONTANA AVE., HELENA, MT, 59601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 46.6160623,
    "lng": -112.0200778
  },
  {
    "id": "12638",
    "name": "CVS",
    "address": "4140 JOPPA ROAD, BALTIMORE, MD, 21236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3992404,
    "lng": -76.4808551
  },
  {
    "id": "12637",
    "name": "CVS",
    "address": "765 E. STATE ST., GENEVA, IL, 60134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8878118,
    "lng": -88.290133
  },
  {
    "id": "12636",
    "name": "CVS",
    "address": "100 US HIGHWAY 41 BYP N, VENICE, FL, 34285",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.1003304,
    "lng": -82.4329942
  },
  {
    "id": "12635",
    "name": "CVS",
    "address": "1676 NORTH HIGHWAY 17, MOUNT PLEASANT, SC, 29464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.824371,
    "lng": -79.8399597
  },
  {
    "id": "12634",
    "name": "CVS",
    "address": "2211 S. EOLA RD., AURORA, IL, 60503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7145469,
    "lng": -88.2552063
  },
  {
    "id": "12633",
    "name": "CVS",
    "address": "4725 WATERS AVE, SAVANNAH, GA, 31404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0316175,
    "lng": -81.0926253
  },
  {
    "id": "12632",
    "name": "CVS",
    "address": "1319 MAGIE AVENUE, UNION, NJ, 7083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6711898,
    "lng": -74.2531006
  },
  {
    "id": "12631",
    "name": "CVS",
    "address": "712 STEPHENSON AVE., SAVANNAH, GA, 31405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.010615,
    "lng": -81.1002554
  },
  {
    "id": "12630",
    "name": "CVS",
    "address": "11890 BISCAYNE BLVD, MIAMI, FL, 33181",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8856038,
    "lng": -80.165665
  },
  {
    "id": "12629",
    "name": "CVS",
    "address": "175 W. BEAU STREET, WASHINGTON, PA, 15301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1713383,
    "lng": -80.2500755
  },
  {
    "id": "12628",
    "name": "CVS",
    "address": "121 10TH ST., DUNBAR, WV, 25064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3580445,
    "lng": -81.7381612
  },
  {
    "id": "12627",
    "name": "CVS",
    "address": "5801 TILGHMAN ST., ALLENTOWN, PA, 18104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5924344,
    "lng": -75.59007
  },
  {
    "id": "12626",
    "name": "CVS",
    "address": "150 JOHNNY MERCER BLVD, SAVANNAH, GA, 31410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.0160625,
    "lng": -80.9868915
  },
  {
    "id": "12625",
    "name": "CVS",
    "address": "5070 AIRPORT RD N, NAPLES, FL, 34105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2084749,
    "lng": -81.767552
  },
  {
    "id": "12624",
    "name": "CVS",
    "address": "8863-H TAMIAMI TRL NORTH, NAPLES, FL, 34108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2498591,
    "lng": -81.8030068
  },
  {
    "id": "12623",
    "name": "CVS",
    "address": "975 BAY RIDGE RD., ANNAPOLIS, MD, 21403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9465212,
    "lng": -76.4873048
  },
  {
    "id": "12622",
    "name": "CVS",
    "address": "4400 HOLLYWOOD BLVD, HOLLYWOOD, FL, 33021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0100013,
    "lng": -80.1878117
  },
  {
    "id": "12621",
    "name": "CVS",
    "address": "11300 MING AVE, BAKERSFIELD, CA, 93311",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.3403803,
    "lng": -119.1286147
  },
  {
    "id": "12620",
    "name": "CVS",
    "address": "2311 HANOVER PIKE, HAMPSTEAD, MD, 21074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6383631,
    "lng": -76.866633
  },
  {
    "id": "12619",
    "name": "CVS",
    "address": "1101 NE MALABAR RD, PALM BAY, FL, 32907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.999213,
    "lng": -80.6383714
  },
  {
    "id": "12618",
    "name": "CVS",
    "address": "2401 E NORTH ST, GREENVILLE, SC, 29615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8693253,
    "lng": -82.3577764
  },
  {
    "id": "12617",
    "name": "CVS",
    "address": "1027 S. MAIN ST., MOULTRIE, GA, 31768",
    "phone": "",
    "hours": "Call for hours",
    "lat": 31.1687284,
    "lng": -83.7885333
  },
  {
    "id": "12616",
    "name": "CVS",
    "address": "1830 WEST DIXON BOULEVARD, SHELBY, NC, 28152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2956181,
    "lng": -81.573664
  },
  {
    "id": "12615",
    "name": "CVS",
    "address": "3914 CAPITAL BLVD, RALEIGH, NC, 27604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8342917,
    "lng": -78.582098
  },
  {
    "id": "12614",
    "name": "CVS",
    "address": "3450 HENDERSONVILLE RD., FLETCHER, NC, 28732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4347956,
    "lng": -82.5012892
  },
  {
    "id": "12613",
    "name": "CVS",
    "address": "115 RESERVOIR RD., BURNSVILLE, NC, 28714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9152941,
    "lng": -82.2988039
  },
  {
    "id": "12612",
    "name": "CVS",
    "address": "2207 VALLEY AVE., WINCHESTER, VA, 22601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.162079,
    "lng": -78.1855661
  },
  {
    "id": "12611",
    "name": "CVS",
    "address": "959 BIG A ROAD, TOCCOA, GA, 30577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5719452,
    "lng": -83.3079203
  },
  {
    "id": "12610",
    "name": "CVS",
    "address": "800 SOUTH STATE RD 7, WELLINGTON, FL, 33414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6661516,
    "lng": -80.2018577
  },
  {
    "id": "12609",
    "name": "CVS",
    "address": "1080 ALICE DRIVE, SUMTER, SC, 29150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9387088,
    "lng": -80.3843498
  },
  {
    "id": "12608",
    "name": "CVS",
    "address": "9578 HARDING AVE, SURFSIDE, FL, 33154",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.886734,
    "lng": -80.1239282
  },
  {
    "id": "12607",
    "name": "CVS",
    "address": "895 RALPH ABERNATHY BLVD., SW, ATLANTA, GA, 30310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7383137,
    "lng": -84.4174698
  },
  {
    "id": "12606",
    "name": "CVS",
    "address": "11 RIVER RIDGE DR., ASHEVILLE, NC, 28803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5704822,
    "lng": -82.5054814
  },
  {
    "id": "12605",
    "name": "CVS",
    "address": "12935 BOOKER T. WASHINGTON HWY., HARDY, VA, 24101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.1203721,
    "lng": -79.7189361
  },
  {
    "id": "12604",
    "name": "CVS",
    "address": "315 W BUTLER ROAD, MAULDIN, SC, 29662",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7756148,
    "lng": -82.3158945
  },
  {
    "id": "12603",
    "name": "CVS",
    "address": "1101 SCENIC HIGHWAY, PENSACOLA, FL, 32503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4309589,
    "lng": -87.1761363
  },
  {
    "id": "12602",
    "name": "CVS",
    "address": "371 ASHEVILLE HIGHWAY, BREVARD, NC, 28712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2474243,
    "lng": -82.723376
  },
  {
    "id": "12601",
    "name": "CVS",
    "address": "106 CHESTNUT RIDGE RD., MONTVALE, NJ, 7645",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0564616,
    "lng": -74.0686118
  },
  {
    "id": "12600",
    "name": "CVS",
    "address": "1022 HARDY ROAD, VINTON, VA, 24179",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.273654,
    "lng": -79.8829287
  },
  {
    "id": "12599",
    "name": "CVS",
    "address": "6381 ZEBULON RD., MACON, GA, 31220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8807526,
    "lng": -83.7732975
  },
  {
    "id": "12598",
    "name": "CVS",
    "address": "3359 GULF BREEZE PARKWAY, GULF BREEZE, FL, 32563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3867567,
    "lng": -87.083436
  },
  {
    "id": "12597",
    "name": "CVS",
    "address": "5600 WILKINS AVE, PITTSBURGH, PA, 15217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4437859,
    "lng": -79.9276214
  },
  {
    "id": "12596",
    "name": "CVS",
    "address": "2050 CLUB CENTER DR, SACRAMENTO, CA, 95835",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6701561,
    "lng": -121.5062204
  },
  {
    "id": "12595",
    "name": "CVS",
    "address": "54 EAST HIGH ST., EAST HAMPTON, CT, 6424",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5842955,
    "lng": -72.4970962
  },
  {
    "id": "12594",
    "name": "CVS",
    "address": "5815 CAMPBELLTON RD. SW, ATLANTA, GA, 30331",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.699833,
    "lng": -84.5779799
  },
  {
    "id": "12593",
    "name": "CVS",
    "address": "3075 W. LIBERTY AVE., PITTSBURGH, PA, 15216",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3914344,
    "lng": -80.0383852
  },
  {
    "id": "12592",
    "name": "CVS",
    "address": "4145 NW 53RD AVENUE, GAINESVILLE, FL, 32653",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7027515,
    "lng": -82.387699
  },
  {
    "id": "12591",
    "name": "CVS",
    "address": "2720 LOGANVILLE HWY, LOGANVILLE, GA, 30052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8815873,
    "lng": -83.9373416
  },
  {
    "id": "12590",
    "name": "CVS",
    "address": "3521 MONONGAHELA BLVD, STAR CITY, WV, 26505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6567958,
    "lng": -79.9905141
  },
  {
    "id": "12589",
    "name": "CVS",
    "address": "315 NORTH AVE., GARWOOD, NJ, 7027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6531003,
    "lng": -74.3239227
  },
  {
    "id": "12588",
    "name": "CVS",
    "address": "128 W. STONE DR., KINGSPORT, TN, 37660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.5599212,
    "lng": -82.5527795
  },
  {
    "id": "12587",
    "name": "CVS",
    "address": "20 MERRICK RD., AMITYVILLE, NY, 11701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6720331,
    "lng": -73.4226027
  },
  {
    "id": "12586",
    "name": "CVS",
    "address": "2902 PEACH ORCHARD ROAD, AUGUSTA, GA, 30906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4179789,
    "lng": -82.0222793
  },
  {
    "id": "12585",
    "name": "CVS",
    "address": "806 EAST PITTSBURGH ST, GREENSBURG, PA, 15601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3016591,
    "lng": -79.5240738
  },
  {
    "id": "12584",
    "name": "CVS",
    "address": "1816 DUNLAWTON AVE, PORT ORANGE, FL, 32127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.1082516,
    "lng": -81.0256606
  },
  {
    "id": "12583",
    "name": "CVS",
    "address": "2814 N MAIN ST., ANDERSON, SC, 29621",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5323407,
    "lng": -82.6632391
  },
  {
    "id": "12582",
    "name": "CVS",
    "address": "12835 POTRANCO RD, SAN ANTONIO, TX, 78253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4299916,
    "lng": -98.7471702
  },
  {
    "id": "12581",
    "name": "CVS",
    "address": "1080 HENDERSONVILLE ROAD, ASHEVILLE, NC, 28803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5362039,
    "lng": -82.528269
  },
  {
    "id": "12580",
    "name": "CVS",
    "address": "34 SHOPPING PLAZA DR, CHAGRIN FALLS, OH, 44022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4315807,
    "lng": -81.3896444
  },
  {
    "id": "12579",
    "name": "CVS",
    "address": "2801 E OAKLAND PARK BLVD, FORT LAUDERDALE, FL, 33306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1678862,
    "lng": -80.108524
  },
  {
    "id": "12578",
    "name": "CVS",
    "address": "3351 SW 3RD ST., LEES SUMMIT, MO, 64081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9124923,
    "lng": -94.4494857
  },
  {
    "id": "12577",
    "name": "CVS",
    "address": "300 KESTREL LANE, LAKE OZARK, MO, 65049",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1747597,
    "lng": -92.6143531
  },
  {
    "id": "12576",
    "name": "CVS",
    "address": "5603 BALTIMORE NATIONAL PIKE, BALTIMORE, MD, 21228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2892407,
    "lng": -76.7252821
  },
  {
    "id": "12575",
    "name": "CVS",
    "address": "2901 CLINT MOORE RD, BOCA RATON, FL, 33496",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4089397,
    "lng": -80.1453879
  },
  {
    "id": "12574",
    "name": "CVS",
    "address": "733 S. IRBY ST., FLORENCE, SC, 29501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1840811,
    "lng": -79.7677615
  },
  {
    "id": "12573",
    "name": "CVS",
    "address": "4725 N. OCEAN DR., LAUDERDALE BY THE SEA, FL, 33308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.198273,
    "lng": -80.0967473
  },
  {
    "id": "12572",
    "name": "CVS",
    "address": "998 HWY 80, HAUGHTON, LA, 71037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5558252,
    "lng": -93.6136418
  },
  {
    "id": "12571",
    "name": "CVS",
    "address": "1109 BENN'S CHURCH ROAD, SMITHFIELD, VA, 23430",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.95957,
    "lng": -76.60306
  },
  {
    "id": "12570",
    "name": "CVS",
    "address": "2110 SPRING VALLEY RD., LANCASTER, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0629771,
    "lng": -76.3585813
  },
  {
    "id": "12569",
    "name": "CVS",
    "address": "1160 S DIXIE HWY, CORAL GABLES, FL, 33146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7154086,
    "lng": -80.2751216
  },
  {
    "id": "12568",
    "name": "CVS",
    "address": "9 WEST 130TH STREET, HINCKLEY, OH, 44233",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2760157,
    "lng": -81.7843986
  },
  {
    "id": "12567",
    "name": "CVS",
    "address": "2719 BRODHEAD RD, ALIQUIPPA, PA, 15001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6092005,
    "lng": -80.2839742
  },
  {
    "id": "12566",
    "name": "CVS",
    "address": "1740 WASHINGTON RD, PITTSBURGH, PA, 15241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3475486,
    "lng": -80.0550313
  },
  {
    "id": "12565",
    "name": "CVS",
    "address": "1775 GOLDEN MILE HWY, MONROEVILLE, PA, 15146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4445587,
    "lng": -79.7140983
  },
  {
    "id": "12564",
    "name": "CVS",
    "address": "9801 US HWY 1, PORT SAINT LUCIE, FL, 34952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2862474,
    "lng": -80.2980907
  },
  {
    "id": "12563",
    "name": "CVS",
    "address": "300 8TH ST.., AMBRIDGE, PA, 15003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5888602,
    "lng": -80.2281666
  },
  {
    "id": "12562",
    "name": "CVS",
    "address": "19305 RUBY DR., LEESBURG, VA, 20176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0818836,
    "lng": -77.4966351
  },
  {
    "id": "12561",
    "name": "CVS",
    "address": "779 SOM CENTER ROAD, MAYFIELD VLG, OH, 44143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5398684,
    "lng": -81.4380704
  },
  {
    "id": "12560",
    "name": "CVS",
    "address": "5611 SOUTH 27TH ST., LINCOLN, NE, 68512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7559982,
    "lng": -96.6834436
  },
  {
    "id": "12559",
    "name": "CVS",
    "address": "1181 FREEDOM RD., CRANBERRY TOWNSHIP, PA, 16066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6826471,
    "lng": -80.1244517
  },
  {
    "id": "12558",
    "name": "CVS",
    "address": "1300 TIGER BLVD., CLEMSON, SC, 29631",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.6890368,
    "lng": -82.8261511
  },
  {
    "id": "12557",
    "name": "CVS",
    "address": "210 E. TRADE ST., STE. E-186, CHARLOTTE, NC, 28202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2258476,
    "lng": -80.8418874
  },
  {
    "id": "12556",
    "name": "CVS",
    "address": "242-250 FIFTH AVE, PITTSBURGH, PA, 15222",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4407261,
    "lng": -80.0010646
  },
  {
    "id": "12555",
    "name": "CVS",
    "address": "3925 WALNUT ST., PHILADELPHIA, PA, 19104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9542356,
    "lng": -75.2011919
  },
  {
    "id": "12554",
    "name": "CVS",
    "address": "2501 WARREN RD, INDIANA, PA, 15701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6096397,
    "lng": -79.1893727
  },
  {
    "id": "12553",
    "name": "CVS",
    "address": "443 CLEVELAND ST, ELYRIA, OH, 44035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3746666,
    "lng": -82.0850861
  },
  {
    "id": "12552",
    "name": "CVS",
    "address": "300 NORTH MAIN STREET, NICHOLASVILLE, KY, 40356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8826145,
    "lng": -84.5715959
  },
  {
    "id": "12551",
    "name": "CVS",
    "address": "620 S. CLEVELAND AVE., WESTERVILLE, OH, 43081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.111367,
    "lng": -82.9485593
  },
  {
    "id": "12550",
    "name": "CVS",
    "address": "8400 FIRESTONE BLVD., DOWNEY, CA, 90241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9383662,
    "lng": -118.1315605
  },
  {
    "id": "12549",
    "name": "CVS",
    "address": "11299 S DIXIE HWY, PINECREST, FL, 33156",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6652594,
    "lng": -80.3233561
  },
  {
    "id": "12548",
    "name": "CVS",
    "address": "4599 SHERIDAN ST., HOLLYWOOD, FL, 33021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0335335,
    "lng": -80.1897296
  },
  {
    "id": "12547",
    "name": "CVS",
    "address": "1002 SPRING ST., JEFFERSONVILLE, IN, 47130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2800441,
    "lng": -85.7457141
  },
  {
    "id": "12546",
    "name": "CVS",
    "address": "816 E. MAIN STREET, ALHAMBRA, CA, 91801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0987651,
    "lng": -118.1179827
  },
  {
    "id": "12545",
    "name": "CVS",
    "address": "5975 W. CHANDLER BLVD., CHANDLER, AZ, 85226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3047029,
    "lng": -111.9448434
  },
  {
    "id": "12544",
    "name": "CVS",
    "address": "101 N DIXIE HWY, LAKE WORTH, FL, 33460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6169674,
    "lng": -80.0579017
  },
  {
    "id": "12543",
    "name": "CVS",
    "address": "6710 HWY 311, SELLERSBURG, IN, 47172",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3682404,
    "lng": -85.7756748
  },
  {
    "id": "12542",
    "name": "CVS",
    "address": "2 S. FEDERAL HWY, DEERFIELD BEACH, FL, 33441",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3169095,
    "lng": -80.0903758
  },
  {
    "id": "12541",
    "name": "CVS",
    "address": "1231 BENEVA RD S, SARASOTA, FL, 34232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3221056,
    "lng": -82.4965948
  },
  {
    "id": "12540",
    "name": "CVS",
    "address": "305 S HIGHWAY 101, SOLANA BEACH, CA, 92075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9883862,
    "lng": -117.271745
  },
  {
    "id": "12539",
    "name": "CVS",
    "address": "2790 E BIDWELL ST, FOLSOM, CA, 95630",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6561668,
    "lng": -121.1208998
  },
  {
    "id": "12538",
    "name": "CVS",
    "address": "2878 VISTA BLVD, SPARKS, NV, 89434",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5565753,
    "lng": -119.7037803
  },
  {
    "id": "12537",
    "name": "CVS",
    "address": "10045 COMBIE RD, AUBURN, CA, 95602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0419048,
    "lng": -121.0927134
  },
  {
    "id": "12536",
    "name": "CVS",
    "address": "1520 E F ST, OAKDALE, CA, 95361",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7739463,
    "lng": -120.8314997
  },
  {
    "id": "12535",
    "name": "CVS",
    "address": "5039 FOLSOM BLVD, SACRAMENTO, CA, 95819",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5615551,
    "lng": -121.4444824
  },
  {
    "id": "12534",
    "name": "CVS",
    "address": "2403 CLEVELAND AVE, FORT MYERS, FL, 33901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6330296,
    "lng": -81.8717094
  },
  {
    "id": "12533",
    "name": "CVS",
    "address": "1107 N WILLOW AVE, CLOVIS, CA, 93611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8500063,
    "lng": -119.7279519
  },
  {
    "id": "12532",
    "name": "CVS",
    "address": "800 W HARRIS ST STE 20, EUREKA, CA, 95503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7817656,
    "lng": -124.1788374
  },
  {
    "id": "12531",
    "name": "CVS",
    "address": "1496 POLLARD RD, LOS GATOS, CA, 95032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2638161,
    "lng": -121.9839676
  },
  {
    "id": "12530",
    "name": "CVS",
    "address": "455 S. MAIN ST., RED BLUFF, CA, 96080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1660963,
    "lng": -122.229315
  },
  {
    "id": "12529",
    "name": "CVS",
    "address": "855 EL CAMINO REAL, PALO ALTO, CA, 94301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4389939,
    "lng": -122.1588204
  },
  {
    "id": "12528",
    "name": "CVS",
    "address": "60 N MOORPARK RD, THOUSAND OAKS, CA, 91360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1798303,
    "lng": -118.8752275
  },
  {
    "id": "12527",
    "name": "CVS",
    "address": "150 S MAIN ST, FORT BRAGG, CA, 95437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4408526,
    "lng": -123.8052743
  },
  {
    "id": "12526",
    "name": "CVS",
    "address": "650 N BELLFLOWER BLVD, LONG BEACH, CA, 90814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7748534,
    "lng": -118.1207487
  },
  {
    "id": "12525",
    "name": "CVS",
    "address": "611 S HOWARD AVE, TAMPA, FL, 33606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9377092,
    "lng": -82.4836294
  },
  {
    "id": "12524",
    "name": "CVS",
    "address": "700 E LAKE RD, PALM HARBOR, FL, 34685",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0626155,
    "lng": -82.7084521
  },
  {
    "id": "12523",
    "name": "CVS",
    "address": "2133 SHAW AVE, CLOVIS, CA, 93611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8094934,
    "lng": -119.6755382
  },
  {
    "id": "12522",
    "name": "CVS",
    "address": "2077 NORTH MILITARY TRAIL, WEST PALM BEACH, FL, 33409",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7077447,
    "lng": -80.111713
  },
  {
    "id": "12521",
    "name": "CVS",
    "address": "8151 WILES RD, CORAL SPRINGS, FL, 33067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2873212,
    "lng": -80.2347889
  },
  {
    "id": "12520",
    "name": "CVS",
    "address": "11655 DUENDA RD, SAN DIEGO, CA, 92127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0323358,
    "lng": -117.0795002
  },
  {
    "id": "12519",
    "name": "CVS",
    "address": "1060 E CYPRESS AVE, REDDING, CA, 96002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5726887,
    "lng": -122.352084
  },
  {
    "id": "12518",
    "name": "CVS",
    "address": "3479 THOMASVILLE RD, TALLAHASSEE, FL, 32309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5070576,
    "lng": -84.2481706
  },
  {
    "id": "12517",
    "name": "CVS",
    "address": "4330 LATROBE RD, EL DORADO HILLS, CA, 95762",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6457884,
    "lng": -121.0686962
  },
  {
    "id": "12516",
    "name": "CVS",
    "address": "1885 W 11TH ST, TRACY, CA, 95376",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7409525,
    "lng": -121.4512421
  },
  {
    "id": "12515",
    "name": "CVS",
    "address": "3 S POMPANO PKWY, POMPANO BEACH, FL, 33069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2305219,
    "lng": -80.158296
  },
  {
    "id": "12514",
    "name": "CVS",
    "address": "3202 WILSHIRE BLVD, SANTA MONICA, CA, 90403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.040598,
    "lng": -118.4712934
  },
  {
    "id": "12513",
    "name": "CVS",
    "address": "54 ATLANTIC AVE., OCEAN VIEW, DE, 19970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5438343,
    "lng": -75.0897223
  },
  {
    "id": "12512",
    "name": "CVS",
    "address": "1718 N FORDHAM BLVD.,, CHAPEL HILL, NC, 27514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9363689,
    "lng": -79.0225672
  },
  {
    "id": "12511",
    "name": "CVS",
    "address": "3030 SOUTH CAMPBELL AVE, SPRINGFIELD, MO, 65807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.159335,
    "lng": -93.2947573
  },
  {
    "id": "12510",
    "name": "CVS",
    "address": "120 E. SONTERRA BLVD., SAN ANTONIO, TX, 78258",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6157918,
    "lng": -98.493036
  },
  {
    "id": "12509",
    "name": "CVS",
    "address": "105 FOOTHILLS CENTER DRIVE, WEST UNION, SC, 29696",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7557225,
    "lng": -83.0471102
  },
  {
    "id": "12508",
    "name": "CVS",
    "address": "207 MARKET STREET, BRIGHTON, MA, 2135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3557327,
    "lng": -71.1501432
  },
  {
    "id": "12507",
    "name": "CVS",
    "address": "7929 NORTH AVE., RIVER FOREST, IL, 60305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9080632,
    "lng": -87.8235832
  },
  {
    "id": "12506",
    "name": "CVS",
    "address": "520 W. SLAUGHTER LN., AUSTIN, TX, 78748",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1728043,
    "lng": -97.7985176
  },
  {
    "id": "12505",
    "name": "CVS",
    "address": "680 PONCE DE LEON AVENUE NE, ATLANTA, GA, 30308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7737263,
    "lng": -84.3652857
  },
  {
    "id": "12504",
    "name": "CVS",
    "address": "1450 POTTSTOWN PIKE, WEST CHESTER, PA, 19380",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0105637,
    "lng": -75.616717
  },
  {
    "id": "12503",
    "name": "CVS",
    "address": "3595 ATLANTA HWY, ATHENS, GA, 30606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9384909,
    "lng": -83.4547682
  },
  {
    "id": "12502",
    "name": "CVS",
    "address": "11586 US HWY 1, PALM BEACH GARDENS, FL, 33408",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.8455155,
    "lng": -80.0594733
  },
  {
    "id": "12501",
    "name": "CVS",
    "address": "1030 PLEASANT GROVE BLVD, ROSEVILLE, CA, 95678",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7783103,
    "lng": -121.2901959
  },
  {
    "id": "12500",
    "name": "CVS",
    "address": "425 WEST STATE ST.,, BLACK MOUNTAIN, NC, 28711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6134464,
    "lng": -82.3266641
  },
  {
    "id": "12499",
    "name": "CVS",
    "address": "44 BRANCHVIEW DRIVE, NE, CONCORD, NC, 28025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4203472,
    "lng": -80.572184
  },
  {
    "id": "12498",
    "name": "CVS",
    "address": "2344 S CHURCH ST, BURLINGTON, NC, 27215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0807838,
    "lng": -79.4748269
  },
  {
    "id": "12497",
    "name": "CVS",
    "address": "3000 BATTLEGROUND AVE., GREENSBORO, NC, 27408",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1159307,
    "lng": -79.8356956
  },
  {
    "id": "12496",
    "name": "CVS",
    "address": "505 SMOKEY PARK HWY., ASHEVILLE, NC, 28806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5542416,
    "lng": -82.6427829
  },
  {
    "id": "12495",
    "name": "CVS",
    "address": "1405 EAST GREENVILLE STREET, ANDERSON, SC, 29621",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5271294,
    "lng": -82.6381733
  },
  {
    "id": "12494",
    "name": "CVS",
    "address": "2302 S. 17TH ST., WILMINGTON, NC, 28401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2017056,
    "lng": -77.9236194
  },
  {
    "id": "12493",
    "name": "CVS",
    "address": "72 BERLIN RD., CROMWELL, CT, 6416",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6024966,
    "lng": -72.6889332
  },
  {
    "id": "12492",
    "name": "CVS",
    "address": "1105 SOUTH MAIN STREET, KERNERSVILLE, NC, 27284",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1069969,
    "lng": -80.0989287
  },
  {
    "id": "12491",
    "name": "CVS",
    "address": "1500 RIBAUT ROAD, PORT ROYAL, SC, 29935",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3940977,
    "lng": -80.6865686
  },
  {
    "id": "12490",
    "name": "CVS",
    "address": "1712 EASTWOOD RD., WILMINGTON, NC, 28403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.2265405,
    "lng": -77.8290199
  },
  {
    "id": "12489",
    "name": "CVS",
    "address": "2310 W.BOBO NEWSON HWY., HARTSVILLE, SC, 29550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.3661164,
    "lng": -80.1289739
  },
  {
    "id": "12488",
    "name": "CVS",
    "address": "6846 OKEECHOBEE BLVD, WEST PALM BEACH, FL, 33411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7070796,
    "lng": -80.1524006
  },
  {
    "id": "12487",
    "name": "CVS",
    "address": "21140 ST. ANDREWS BLVD., BOCA RATON, FL, 33433",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3628572,
    "lng": -80.1368907
  },
  {
    "id": "12486",
    "name": "CVS",
    "address": "7412 STATE ROAD, PARMA, OH, 44134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.364428,
    "lng": -81.7178409
  },
  {
    "id": "12485",
    "name": "CVS",
    "address": "4120 HENDERSON BLVD, TAMPA, FL, 33629",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9270219,
    "lng": -82.5129756
  },
  {
    "id": "12484",
    "name": "CVS",
    "address": "5471 UNIVERSITY PKWY., WINSTON SALEM, NC, 27105",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1707859,
    "lng": -80.2768346
  },
  {
    "id": "12483",
    "name": "CVS",
    "address": "2502 W HILLSBOROUGH AVE, TAMPA, FL, 33614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9957494,
    "lng": -82.4851389
  },
  {
    "id": "12482",
    "name": "CVS",
    "address": "609 CHERRY RD., ROCK HILL, SC, 29732",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9442451,
    "lng": -81.0294527
  },
  {
    "id": "12481",
    "name": "CVS",
    "address": "559 RIVER HWY, MOORESVILLE, NC, 28117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5944689,
    "lng": -80.869647
  },
  {
    "id": "12480",
    "name": "CVS",
    "address": "2152 SAVANNAH HWY., CHARLESTON, SC, 29414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7915293,
    "lng": -80.0370597
  },
  {
    "id": "12479",
    "name": "CVS",
    "address": "929 DEKALB PIKE, BLUE BELL, PA, 19422",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1663948,
    "lng": -75.2921542
  },
  {
    "id": "12478",
    "name": "CVS",
    "address": "549 N MAIN ST, CORNELIA, GA, 30531",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5177246,
    "lng": -83.5299346
  },
  {
    "id": "12477",
    "name": "CVS",
    "address": "93 OLD RIDGEFIELD RD., WILTON, CT, 6897",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1937836,
    "lng": -73.4324387
  },
  {
    "id": "12476",
    "name": "CVS",
    "address": "1531 PINEY FOREST ROAD, DANVILLE, VA, 24540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.6343694,
    "lng": -79.3935842
  },
  {
    "id": "12475",
    "name": "CVS",
    "address": "1305 RANDALL RD., CRYSTAL LAKE, IL, 60014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2051746,
    "lng": -88.335697
  },
  {
    "id": "12474",
    "name": "CVS",
    "address": "200 STUART RD., NE, CLEVELAND, TN, 37312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1992959,
    "lng": -84.8445344
  },
  {
    "id": "12473",
    "name": "CVS",
    "address": "6802 LEE HWY., CHATTANOOGA, TN, 37421",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0406097,
    "lng": -85.1683909
  },
  {
    "id": "12472",
    "name": "CVS",
    "address": "530 TRUMAN AVE, KEY WEST, FL, 33040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 24.5512499,
    "lng": -81.798138
  },
  {
    "id": "12471",
    "name": "CVS",
    "address": "3027 JIM MOORE ROAD, DACULA, GA, 30019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0363142,
    "lng": -83.9101106
  },
  {
    "id": "12470",
    "name": "CVS",
    "address": "19198 S DIXIE HWY, CUTLER BAY, FL, 33157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.5897511,
    "lng": -80.3598185
  },
  {
    "id": "12469",
    "name": "CVS",
    "address": "20345 OLD CUTLER RD, CUTLER BAY, FL, 33189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.5781342,
    "lng": -80.3358456
  },
  {
    "id": "12468",
    "name": "CVS",
    "address": "9175 KINGSTON PIKE, KNOXVILLE, TN, 37923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.9124604,
    "lng": -84.0861859
  },
  {
    "id": "12467",
    "name": "CVS",
    "address": "121 CENTER SQUARE RD., SWEDESBORO, NJ, 8085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7388812,
    "lng": -75.3254117
  },
  {
    "id": "12466",
    "name": "CVS",
    "address": "9204 CORTEZ BLVD, WEEKI WACHEE, FL, 34613",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5178558,
    "lng": -82.5708638
  },
  {
    "id": "12465",
    "name": "CVS",
    "address": "630 LEXINGTON AVENUE, NEW YORK, NY, 10022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7588595,
    "lng": -73.9712746
  },
  {
    "id": "12464",
    "name": "CVS",
    "address": "2840 N. DYSART RD., GOODYEAR, AZ, 85395",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4781773,
    "lng": -112.3418333
  },
  {
    "id": "12463",
    "name": "CVS",
    "address": "121 W. KINZIE ST., CHICAGO, IL, 60654",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8889032,
    "lng": -87.6317574
  },
  {
    "id": "12462",
    "name": "CVS",
    "address": "19869 SEA BLOSSOM BLVD., REHOBOTH BEACH, DE, 19971",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7156826,
    "lng": -75.1068753
  },
  {
    "id": "12461",
    "name": "CVS",
    "address": "5011-A STATE STREET, CHATTANOOGA, TN, 37407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9855693,
    "lng": -85.2889689
  },
  {
    "id": "12460",
    "name": "CVS",
    "address": "8940 COIT RD., PLANO, TX, 75025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1002641,
    "lng": -96.7708975
  },
  {
    "id": "12459",
    "name": "CVS",
    "address": "11 FOREST ST., STAMFORD, CT, 6901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0568282,
    "lng": -73.5373987
  },
  {
    "id": "12458",
    "name": "CVS",
    "address": "1550 STACY RD., ALLEN, TX, 75002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1287045,
    "lng": -96.6292438
  },
  {
    "id": "12457",
    "name": "CVS",
    "address": "4700 PIEDMONT PKWY., JAMESTOWN, NC, 27282",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0442775,
    "lng": -79.9266672
  },
  {
    "id": "12456",
    "name": "CVS",
    "address": "1185 FAY BLVD, COCOA, FL, 32927",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4771751,
    "lng": -80.7696329
  },
  {
    "id": "12455",
    "name": "CVS",
    "address": "10925 SR 54, NEW PORT RICHEY, FL, 34655",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1936551,
    "lng": -82.634212
  },
  {
    "id": "12454",
    "name": "CVS",
    "address": "3103 N. FRY RD., KATY, TX, 77449",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8152751,
    "lng": -95.721303
  },
  {
    "id": "12453",
    "name": "CVS",
    "address": "7790 BLANDING BLVD, JACKSONVILLE, FL, 32244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2048233,
    "lng": -81.7402267
  },
  {
    "id": "12452",
    "name": "CVS",
    "address": "130 SCENIC GULF DRIVE, MIRAMAR BEACH, FL, 32550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3769042,
    "lng": -86.3508247
  },
  {
    "id": "12451",
    "name": "CVS",
    "address": "10701 INTERNATIONAL DRIVE, ORLANDO, FL, 32821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4077351,
    "lng": -81.4554499
  },
  {
    "id": "12450",
    "name": "CVS",
    "address": "1317 OHIO AVE, LYNN HAVEN, FL, 32444",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2380044,
    "lng": -85.6481239
  },
  {
    "id": "12449",
    "name": "CVS",
    "address": "1299 EAST OGDEN AVE., NAPERVILLE, IL, 60563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7962696,
    "lng": -88.1229612
  },
  {
    "id": "12448",
    "name": "CVS",
    "address": "5357 EHRLICH RD, TAMPA, FL, 33625",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0840603,
    "lng": -82.5414955
  },
  {
    "id": "12447",
    "name": "CVS",
    "address": "11900 MCCORMICK RD., JACKSONVILLE, FL, 32225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.359973,
    "lng": -81.5038676
  },
  {
    "id": "12446",
    "name": "CVS",
    "address": "1250 PROVIDENCE BLVD, DELTONA, FL, 32725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.8845884,
    "lng": -81.2400514
  },
  {
    "id": "12445",
    "name": "CVS",
    "address": "353 GULF BLVD, INDIAN ROCKS BEACH, FL, 33785",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8822053,
    "lng": -82.8500532
  },
  {
    "id": "12444",
    "name": "CVS",
    "address": "3634 ROGERO RD, JACKSONVILLE, FL, 32277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3656301,
    "lng": -81.5883655
  },
  {
    "id": "12443",
    "name": "CVS",
    "address": "4090 S TAMIAMI TRL, VENICE, FL, 34293",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0491421,
    "lng": -82.3982702
  },
  {
    "id": "12442",
    "name": "CVS",
    "address": "7710 CHIPPEWA RD, BRECKSVILLE, OH, 44141",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3191457,
    "lng": -81.6235874
  },
  {
    "id": "12441",
    "name": "CVS",
    "address": "1398 UNION CROSS RD, KERNERSVILLE, NC, 27284",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0869301,
    "lng": -80.1005016
  },
  {
    "id": "12440",
    "name": "CVS",
    "address": "7030 JOG RD, LAKE WORTH, FL, 33467",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5717396,
    "lng": -80.1453443
  },
  {
    "id": "12439",
    "name": "CVS",
    "address": "11 E MERRITT ISLAND CSWY, MERRITT ISLAND, FL, 32952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3561218,
    "lng": -80.6996965
  },
  {
    "id": "12438",
    "name": "CVS",
    "address": "420 N MAIN ST, BUSHNELL, FL, 33513",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.6681358,
    "lng": -82.1128302
  },
  {
    "id": "12437",
    "name": "CVS",
    "address": "10623 GIBSONTON DR, RIVERVIEW, FL, 33578",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8565135,
    "lng": -82.3273204
  },
  {
    "id": "12436",
    "name": "CVS",
    "address": "542325 US HIGHWAY 1, CALLAHAN, FL, 32011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5627795,
    "lng": -81.8299217
  },
  {
    "id": "12435",
    "name": "CVS",
    "address": "1719 SELAKE WEIR AVE, OCALA, FL, 34471",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.1710855,
    "lng": -82.127612
  },
  {
    "id": "12434",
    "name": "CVS",
    "address": "17172 FRONT BEACH RD, PANAMA CITY BEACH, FL, 32413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2250484,
    "lng": -85.8913931
  },
  {
    "id": "12433",
    "name": "CVS",
    "address": "1 N FEDERAL HWY, FORT LAUDERDALE, FL, 33301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1226842,
    "lng": -80.1383661
  },
  {
    "id": "12432",
    "name": "CVS",
    "address": "30401 OVERSEAS HWY, BIG PINE KEY, FL, 33043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 24.6705375,
    "lng": -81.3571715
  },
  {
    "id": "12431",
    "name": "CVS",
    "address": "101 W. EHRINGHAUS ST., ELIZABETH CITY, NC, 27909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2958767,
    "lng": -76.2241028
  },
  {
    "id": "12430",
    "name": "CVS",
    "address": "400 KINGS HWY., HADDON HEIGHTS, NJ, 8035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8865691,
    "lng": -75.0590156
  },
  {
    "id": "12429",
    "name": "CVS",
    "address": "215 TOWN CENTER BLVD., EASTON, PA, 18040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7133066,
    "lng": -75.2195487
  },
  {
    "id": "12428",
    "name": "CVS",
    "address": "7001 ESTERO BLVD, FORT MYERS BEACH, FL, 33931",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4156644,
    "lng": -81.9003111
  },
  {
    "id": "12427",
    "name": "CVS",
    "address": "1120 WESTON RD, WESTON, FL, 33326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1054914,
    "lng": -80.3629505
  },
  {
    "id": "12426",
    "name": "CVS",
    "address": "850 IVES DAIRY ROAD, UNIT T-8, MIAMI, FL, 33179",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9609041,
    "lng": -80.1874411
  },
  {
    "id": "12425",
    "name": "CVS",
    "address": "11100 PINES BLVD, PEMBROKE PINES, FL, 33026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0071419,
    "lng": -80.2945936
  },
  {
    "id": "12424",
    "name": "CVS",
    "address": "1806 S RIDGEWOOD AVE, EDGEWATER, FL, 32132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9729779,
    "lng": -80.8968098
  },
  {
    "id": "12423",
    "name": "CVS",
    "address": "16701 S. HARLEM AVE., TINLEY PARK, IL, 60477",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5870125,
    "lng": -87.7930101
  },
  {
    "id": "12422",
    "name": "CVS",
    "address": "11878 FOREST HILL BLVD, WELLINGTON, FL, 33414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6520193,
    "lng": -80.2340047
  },
  {
    "id": "12421",
    "name": "CVS",
    "address": "599 BELL TAVERN BLVD., DOWNINGTOWN, PA, 19335",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0287547,
    "lng": -75.6834895
  },
  {
    "id": "12420",
    "name": "CVS",
    "address": "412 SPRINGFIELD AVE., BERKELEY HEIGHTS, NJ, 7922",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6850843,
    "lng": -74.4376096
  },
  {
    "id": "12419",
    "name": "CVS",
    "address": "2703 N. PONCE DELEON BLVD., SAINT AUGUSTINE, FL, 32084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.916137,
    "lng": -81.3250315
  },
  {
    "id": "12418",
    "name": "CVS",
    "address": "6131 SIX FORKS RD., RALEIGH, NC, 27609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.8645044,
    "lng": -78.6381571
  },
  {
    "id": "12417",
    "name": "CVS",
    "address": "2397 REIDVILLE ROAD,, SPARTANBURG, SC, 29301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9195412,
    "lng": -81.9926349
  },
  {
    "id": "12416",
    "name": "CVS",
    "address": "209 S STATE ST, ANN ARBOR, MI, 48104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2798929,
    "lng": -83.7404577
  },
  {
    "id": "12415",
    "name": "CVS",
    "address": "12015 LITTLE RD, HUDSON, FL, 34667",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3316142,
    "lng": -82.6669222
  },
  {
    "id": "12414",
    "name": "CVS",
    "address": "3186 PETERS CREEK PKWY., WINSTON SALEM, NC, 27127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0433384,
    "lng": -80.2605955
  },
  {
    "id": "12413",
    "name": "CVS",
    "address": "110 WESTGREEN BLVD., KATY, TX, 77450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7842035,
    "lng": -95.7363174
  },
  {
    "id": "12412",
    "name": "CVS",
    "address": "6617 NORTH KINGS HWY., MYRTLE BEACH, SC, 29572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7398188,
    "lng": -78.8280328
  },
  {
    "id": "12411",
    "name": "CVS",
    "address": "1504 NE 2ND ST., HICKORY, NC, 28601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7530663,
    "lng": -81.3361168
  },
  {
    "id": "12410",
    "name": "CVS",
    "address": "8251 COLUMBINE RD., EDEN PRAIRIE, MN, 55344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8544198,
    "lng": -93.4357559
  },
  {
    "id": "12409",
    "name": "CVS",
    "address": "21590 EAST VALLEY BLVD., CITY OF INDUSTRY, CA, 91789",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0258656,
    "lng": -117.8348977
  },
  {
    "id": "12408",
    "name": "CVS",
    "address": "27841 CROWN LAKE BLVD., PO 2327, BONITA SPRINGS, FL, 34135",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3329558,
    "lng": -81.8053475
  },
  {
    "id": "12407",
    "name": "CVS",
    "address": "23530 WILDERNESS OAK, SAN ANTONIO, TX, 78258",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.660092,
    "lng": -98.4994259
  },
  {
    "id": "12406",
    "name": "CVS",
    "address": "11801 PANAMA CITY BEACH PKWY., PANAMA CITY BEACH, FL, 32407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2005084,
    "lng": -85.8210247
  },
  {
    "id": "12405",
    "name": "CVS",
    "address": "355 CAMPBELL AVE., WEST HAVEN, CT, 6516",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2679423,
    "lng": -72.9478098
  },
  {
    "id": "12404",
    "name": "CVS",
    "address": "2100 66TH ST N, SAINT PETERSBURG, FL, 33710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7901574,
    "lng": -82.7291539
  },
  {
    "id": "12403",
    "name": "CVS",
    "address": "210 INGLES PLACE, SENECA, SC, 29678",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.700444,
    "lng": -82.9375094
  },
  {
    "id": "12402",
    "name": "CVS",
    "address": "555 N. MAIN STREET, MARION, NC, 28752",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6885448,
    "lng": -82.0165509
  },
  {
    "id": "12401",
    "name": "CVS",
    "address": "1063 SOUTH PENDLETON STREET, EASLEY, SC, 29642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.81442,
    "lng": -82.6011909
  },
  {
    "id": "12400",
    "name": "CVS",
    "address": "5361 FRUITVILLE RD, SARASOTA, FL, 34232",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3394122,
    "lng": -82.4628789
  },
  {
    "id": "12399",
    "name": "CVS",
    "address": "900 N MADISON BLVD, ROXBORO, NC, 27573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.4072494,
    "lng": -78.9760605
  },
  {
    "id": "12398",
    "name": "CVS",
    "address": "520 N. CANNON BLVD., KANNAPOLIS, NC, 28083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5014872,
    "lng": -80.6086636
  },
  {
    "id": "12397",
    "name": "CVS",
    "address": "440 EAST DIXIE DR., ASHEBORO, NC, 27203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6881765,
    "lng": -79.8105008
  },
  {
    "id": "12396",
    "name": "CVS",
    "address": "274 NORTH MAIN STREET, MOORESVILLE, NC, 28115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5846015,
    "lng": -80.8103111
  },
  {
    "id": "12395",
    "name": "CVS",
    "address": "471 N. MILITARY HWY., NORFOLK, VA, 23502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8483996,
    "lng": -76.2108145
  },
  {
    "id": "12394",
    "name": "CVS",
    "address": "6202 US HWY 41 N, APOLLO BEACH, FL, 33572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7696758,
    "lng": -82.3922717
  },
  {
    "id": "12393",
    "name": "CVS",
    "address": "238 US HIGHWAY 17, EAST PALATKA, FL, 32131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6472045,
    "lng": -81.5963544
  },
  {
    "id": "12392",
    "name": "CVS",
    "address": "3325 ROBINHOOD RD., WINSTON SALEM, NC, 27106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1163706,
    "lng": -80.3122141
  },
  {
    "id": "12391",
    "name": "CVS",
    "address": "4861 AMHERST HWY, PO BOX 570, MADISON HEIGHTS, VA, 24572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4388608,
    "lng": -79.1209388
  },
  {
    "id": "12390",
    "name": "CVS",
    "address": "762 E. CHURCH ST., MARTINSVILLE, VA, 24112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.6895901,
    "lng": -79.8542826
  },
  {
    "id": "12389",
    "name": "CVS",
    "address": "102 NORTH US 81, KYLE, TX, 78640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9888147,
    "lng": -97.8736056
  },
  {
    "id": "12388",
    "name": "CVS",
    "address": "9546 E. RIGGS RD., SUN LAKES, AZ, 85248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2185951,
    "lng": -111.8766541
  },
  {
    "id": "12387",
    "name": "CVS",
    "address": "5650 RED BUG LAKE RD, WINTER SPRINGS, FL, 32708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.6483812,
    "lng": -81.2695202
  },
  {
    "id": "12386",
    "name": "CVS",
    "address": "591 E. LIVINGSTON AVE., COLUMBUS, OH, 43215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9518729,
    "lng": -82.982832
  },
  {
    "id": "12385",
    "name": "CVS",
    "address": "914 W. MAIN ST., OLNEY, IL, 62450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.731094,
    "lng": -88.0950372
  },
  {
    "id": "12384",
    "name": "CVS",
    "address": "300 FAIRMONT AVE,, FAIRMONT, WV, 26554",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4804712,
    "lng": -80.1478301
  },
  {
    "id": "12383",
    "name": "CVS",
    "address": "1493 UPPER VALLEY PIKE, SPRINGFIELD, OH, 45504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9464252,
    "lng": -83.8534813
  },
  {
    "id": "12382",
    "name": "CVS",
    "address": "600 UNIVERSITY CITY BLVD, BLACKSBURG, VA, 24060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2321532,
    "lng": -80.4324857
  },
  {
    "id": "12381",
    "name": "CVS",
    "address": "201 SOUTH MAIN ST., NEW CARLISLE, OH, 45344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9356952,
    "lng": -84.0257686
  },
  {
    "id": "12380",
    "name": "CVS",
    "address": "511 E. BOONVILLE NEW HARMONY RD., EVANSVILLE, IN, 47725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0932405,
    "lng": -87.5549589
  },
  {
    "id": "12379",
    "name": "CVS",
    "address": "2331 PALM RIDGE RD, SANIBEL, FL, 33957",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4370008,
    "lng": -82.0778659
  },
  {
    "id": "12378",
    "name": "CVS",
    "address": "575 W INDIANTOWN RD, JUPITER, FL, 33458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.9346776,
    "lng": -80.102252
  },
  {
    "id": "12377",
    "name": "CVS",
    "address": "14411 PALM BEACH BLVD, FORT MYERS, FL, 33905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7089464,
    "lng": -81.7223379
  },
  {
    "id": "12376",
    "name": "CVS",
    "address": "1300 N. HOBART ST., PAMPA, TX, 79065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5482123,
    "lng": -100.9712071
  },
  {
    "id": "12375",
    "name": "CVS",
    "address": "5052 N A1A, VERO BEACH, FL, 32963",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.67599,
    "lng": -80.3636496
  },
  {
    "id": "12374",
    "name": "CVS",
    "address": "131 3RD ST., MARIETTA, OH, 45750",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4136226,
    "lng": -81.4515452
  },
  {
    "id": "12373",
    "name": "CVS",
    "address": "14705 S DIXIE HWY, PALMETTO BAY, FL, 33176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6335424,
    "lng": -80.3365853
  },
  {
    "id": "12372",
    "name": "CVS",
    "address": "1101 ROYAL PALM BEACH BLVD., ROYAL PALM BEACH, FL, 33411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.7067996,
    "lng": -80.2298222
  },
  {
    "id": "12371",
    "name": "CVS",
    "address": "6800 S DIXIE HWY, WEST PALM BEACH, FL, 33405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6546323,
    "lng": -80.0555442
  },
  {
    "id": "12370",
    "name": "CVS",
    "address": "6105 US HWY 98 N, LAKELAND, FL, 33809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1213262,
    "lng": -81.9731265
  },
  {
    "id": "12369",
    "name": "CVS",
    "address": "100 EAST STATE RD 231, CROWN POINT, IN, 46307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4036995,
    "lng": -87.3380112
  },
  {
    "id": "12368",
    "name": "CVS",
    "address": "9767 COURTHOUSE RD., SPOTSYLVANIA, VA, 22553",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2326436,
    "lng": -77.5589865
  },
  {
    "id": "12367",
    "name": "CVS",
    "address": "902 GARRISONVILLE RD., STAFFORD, VA, 22556",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4696344,
    "lng": -77.4602478
  },
  {
    "id": "12366",
    "name": "CVS",
    "address": "3860 S. 27TH ST., MILWAUKEE, WI, 53221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9745415,
    "lng": -87.947614
  },
  {
    "id": "12365",
    "name": "CVS",
    "address": "704 SO MEMORIAL DR, GREENVILLE, NC, 27834",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6118684,
    "lng": -77.39282
  },
  {
    "id": "12364",
    "name": "CVS",
    "address": "29 HAVENWOOD DR., SHIRLEY, NY, 11967",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7609806,
    "lng": -72.8708403
  },
  {
    "id": "12363",
    "name": "CVS",
    "address": "653 RTE. 9, WILTON, NY, 12831",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1238134,
    "lng": -73.7695083
  },
  {
    "id": "12362",
    "name": "CVS",
    "address": "1520 WALTON WAY, AUGUSTA, GA, 30904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.475087,
    "lng": -81.9889749
  },
  {
    "id": "12361",
    "name": "CVS",
    "address": "961 BLACK ROCK TPKE., FAIRFIELD, CT, 6825",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1718306,
    "lng": -73.236168
  },
  {
    "id": "12360",
    "name": "CVS",
    "address": "676 BALD EAGLE DR, MARCO ISLAND, FL, 34145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9545108,
    "lng": -81.7259218
  },
  {
    "id": "12359",
    "name": "CVS",
    "address": "111 W CHERRY ST, SUNBURY, OH, 43074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2446381,
    "lng": -82.8646512
  },
  {
    "id": "12358",
    "name": "CVS",
    "address": "3352 KENT ROAD, STOW, OH, 44224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1588727,
    "lng": -81.4408915
  },
  {
    "id": "12357",
    "name": "CVS",
    "address": "33840 AURORA RD., SOLON, OH, 44139",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3847505,
    "lng": -81.4381368
  },
  {
    "id": "12356",
    "name": "CVS",
    "address": "4195 S CLEVELAND MASSILLON RD, NORTON, OH, 44203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0242182,
    "lng": -81.6377138
  },
  {
    "id": "12355",
    "name": "CVS",
    "address": "19070 S TAMIAMI TRAIL, FORT MYERS, FL, 33908",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4631046,
    "lng": -81.831103
  },
  {
    "id": "12354",
    "name": "CVS",
    "address": "17120 CHAGRIN BLVD., SHAKER HEIGHTS, OH, 44120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4642765,
    "lng": -81.5593856
  },
  {
    "id": "12353",
    "name": "CVS",
    "address": "1491 SOM CENTER RD, MAYFIELD HEIGHTS, OH, 44124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5205428,
    "lng": -81.437255
  },
  {
    "id": "12352",
    "name": "CVS",
    "address": "44-075 JEFFERSON ST., LA QUINTA, CA, 92253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7286912,
    "lng": -116.2696799
  },
  {
    "id": "12351",
    "name": "CVS",
    "address": "22001 LAKESHORE BLVD, EUCLID, OH, 44123",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6094461,
    "lng": -81.5278304
  },
  {
    "id": "12350",
    "name": "CVS",
    "address": "14000 RIDGE ROAD, NORTH ROYALTON, OH, 44133",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3132348,
    "lng": -81.7353429
  },
  {
    "id": "12349",
    "name": "CVS",
    "address": "2300 N FLAMINGO RD, PEMBROKE PINES, FL, 33028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0287673,
    "lng": -80.313694
  },
  {
    "id": "12348",
    "name": "CVS",
    "address": "11706 CLIFTON BOULEVARD, LAKEWOOD, OH, 44107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4881263,
    "lng": -81.7693625
  },
  {
    "id": "12347",
    "name": "CVS",
    "address": "9040 MENTOR AVE, MENTOR, OH, 44060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6751858,
    "lng": -81.3158107
  },
  {
    "id": "12346",
    "name": "CVS",
    "address": "2007 BROOKPARK ROAD, CLEVELAND, OH, 44109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4188513,
    "lng": -81.6941072
  },
  {
    "id": "12345",
    "name": "CVS",
    "address": "2284 BACK ORRVILLE RD., WOOSTER, OH, 44691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8291155,
    "lng": -81.9077913
  },
  {
    "id": "12344",
    "name": "CVS",
    "address": "9915 PARK CEDAR DR, CHARLOTTE, NC, 28210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0945223,
    "lng": -80.8655399
  },
  {
    "id": "12343",
    "name": "CVS",
    "address": "1111 N TAMIAMI TRL, NOKOMIS, FL, 34275",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.1387931,
    "lng": -82.459409
  },
  {
    "id": "12342",
    "name": "CVS",
    "address": "703 W ERVIN ST, VAN WERT, OH, 45891",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8592457,
    "lng": -84.5930797
  },
  {
    "id": "12341",
    "name": "CVS",
    "address": "4935 S. ARLINGTON, INDIANAPOLIS, IN, 46237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6956073,
    "lng": -86.0626832
  },
  {
    "id": "12340",
    "name": "CVS",
    "address": "1241 LEXINGTON AVE,, NEW YORK, NY, 10028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7782493,
    "lng": -73.9562245
  },
  {
    "id": "12339",
    "name": "CVS",
    "address": "1599 PALM BAY RD NE, PALM BAY, FL, 32905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0360641,
    "lng": -80.622545
  },
  {
    "id": "12338",
    "name": "CVS",
    "address": "750 W. FM 544, WYLIE, TX, 75098",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0106487,
    "lng": -96.5965815
  },
  {
    "id": "12337",
    "name": "CVS",
    "address": "850 W SAMPLE RD, POMPANO BEACH, FL, 33064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2741761,
    "lng": -80.1351385
  },
  {
    "id": "12336",
    "name": "CVS",
    "address": "6888 N 9TH AVE, PENSACOLA, FL, 32504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4944141,
    "lng": -87.1892557
  },
  {
    "id": "12335",
    "name": "CVS",
    "address": "11241 MIROMAR SQUARE BLVD, ESTERO, FL, 33928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4352822,
    "lng": -81.7706154
  },
  {
    "id": "12334",
    "name": "CVS",
    "address": "3501 N. PINE AVE., OCALA, FL, 34475",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.2236169,
    "lng": -82.1467167
  },
  {
    "id": "12333",
    "name": "CVS",
    "address": "5990 S POINTE BLVD, FORT MYERS, FL, 33919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5573246,
    "lng": -81.9035921
  },
  {
    "id": "12332",
    "name": "CVS",
    "address": "9852 STRINGFELLOW RD, SAINT JAMES CITY, FL, 33956",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6046961,
    "lng": -82.1134255
  },
  {
    "id": "12331",
    "name": "CVS",
    "address": "505 BAY ISLES PKWY, LONGBOAT KEY, FL, 34228",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3662244,
    "lng": -82.6239484
  },
  {
    "id": "12330",
    "name": "CVS",
    "address": "4890 TAMIAMI TR, NAPLES, FL, 34112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1083197,
    "lng": -81.7500723
  },
  {
    "id": "12329",
    "name": "CVS",
    "address": "1806 W. HILLSBORO BLVD., DEERFIELD BEACH, FL, 33442",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3172114,
    "lng": -80.1287978
  },
  {
    "id": "12328",
    "name": "CVS",
    "address": "7155 W BROWARD BLVD, PLANTATION, FL, 33317",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1215783,
    "lng": -80.2438502
  },
  {
    "id": "12327",
    "name": "CVS",
    "address": "2701 STIRLING RD, FORT LAUDERDALE, FL, 33312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.048289,
    "lng": -80.1769134
  },
  {
    "id": "12326",
    "name": "CVS",
    "address": "14998 S. TAMIAMI TRAIL, NORTH PORT, FL, 34287",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.0466793,
    "lng": -82.2554881
  },
  {
    "id": "12325",
    "name": "CVS",
    "address": "704 W MARTIN LUTHER KING JR BLVD, SEFFNER, FL, 33584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9811904,
    "lng": -82.2866302
  },
  {
    "id": "12324",
    "name": "CVS",
    "address": "3404 SW ARCHER RD, GAINESVILLE, FL, 32608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6271293,
    "lng": -82.3732699
  },
  {
    "id": "12323",
    "name": "CVS",
    "address": "1098 MONTGOMERY RD, ALTAMONTE SPRINGS, FL, 32714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.6868093,
    "lng": -81.4041583
  },
  {
    "id": "12322",
    "name": "CVS",
    "address": "613 FAYETTE ST., CONSHOHOCKEN, PA, 19428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0782542,
    "lng": -75.3014032
  },
  {
    "id": "12321",
    "name": "CVS",
    "address": "1 OLD KINGS ROAD SOUTH, PALM COAST, FL, 32137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.4749692,
    "lng": -81.1782399
  },
  {
    "id": "12320",
    "name": "CVS",
    "address": "1102 N 15TH ST, IMMOKALEE, FL, 34142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4336751,
    "lng": -81.4331348
  },
  {
    "id": "12319",
    "name": "CVS",
    "address": "65 FOREST AVE, GLEN COVE, NY, 11542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8722291,
    "lng": -73.6251974
  },
  {
    "id": "12318",
    "name": "CVS",
    "address": "4684 HIGHWAY 90, MARIANNA, FL, 32446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.7690694,
    "lng": -85.2040971
  },
  {
    "id": "12317",
    "name": "CVS",
    "address": "230 N. CEDAR, BORGER, TX, 79007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6674731,
    "lng": -101.3965644
  },
  {
    "id": "12316",
    "name": "CVS",
    "address": "1303 LANCASTER AVE., READING, PA, 19607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3127692,
    "lng": -75.9485547
  },
  {
    "id": "12315",
    "name": "CVS",
    "address": "106 N PARROTT AVE, OKEECHOBEE, FL, 34972",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2441702,
    "lng": -80.8293881
  },
  {
    "id": "12314",
    "name": "CVS",
    "address": "726 CRANDON BOULEVARD, KEY BISCAYNE, FL, 33149",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6876775,
    "lng": -80.1644005
  },
  {
    "id": "12313",
    "name": "CVS",
    "address": "870 SADLER RD, FERNANDINA BEACH, FL, 32034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6388115,
    "lng": -81.4564367
  },
  {
    "id": "12312",
    "name": "CVS",
    "address": "13802 HWY 6, SANTA FE, TX, 77517",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.381704,
    "lng": -95.1126326
  },
  {
    "id": "12311",
    "name": "CVS",
    "address": "36252 LIGHTHOUSE RD., SELBYVILLE, DE, 19975",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4687429,
    "lng": -75.1166827
  },
  {
    "id": "12310",
    "name": "CVS",
    "address": "414 ATLANTIC BLVD, NEPTUNE BEACH, FL, 32266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3240347,
    "lng": -81.3997951
  },
  {
    "id": "12309",
    "name": "CVS",
    "address": "795 W. GRANADA BLVD., ORMOND BEACH, FL, 32174",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.2795985,
    "lng": -81.0831405
  },
  {
    "id": "12308",
    "name": "CVS",
    "address": "130 LENOX AVE., NEW YORK, NY, 10026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8022674,
    "lng": -73.9491291
  },
  {
    "id": "12307",
    "name": "CVS",
    "address": "4511 LANTANA RD, LAKE WORTH, FL, 33463",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5892812,
    "lng": -80.1150287
  },
  {
    "id": "12306",
    "name": "CVS",
    "address": "5825 20TH ST, VERO BEACH, FL, 32966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.638266,
    "lng": -80.4471808
  },
  {
    "id": "12305",
    "name": "CVS",
    "address": "35 SOUTH MAIN STREET, GREENVILLE, SC, 29601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8497167,
    "lng": -82.3991094
  },
  {
    "id": "12304",
    "name": "CVS",
    "address": "2140 HEDGCOXE RD., PLANO, TX, 75025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0855334,
    "lng": -96.7359351
  },
  {
    "id": "12303",
    "name": "CVS",
    "address": "175 STATE RD 312, SAINT AUGUSTINE, FL, 32086",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8659758,
    "lng": -81.3262227
  },
  {
    "id": "12302",
    "name": "CVS",
    "address": "775 E. US HWY 80, FORNEY, TX, 75126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.742146,
    "lng": -96.4502185
  },
  {
    "id": "12301",
    "name": "CVS",
    "address": "1000 N. COLLEGE AVE., BLOOMINGTON, IN, 47404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1763946,
    "lng": -86.534189
  },
  {
    "id": "12300",
    "name": "CVS",
    "address": "2006 ROUTE 322, SWEDESBORO, NJ, 8085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7612765,
    "lng": -75.3060835
  },
  {
    "id": "12299",
    "name": "CVS",
    "address": "9101 HWY 6 NORTH, HOUSTON, TX, 77095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9100885,
    "lng": -95.6294496
  },
  {
    "id": "12298",
    "name": "CVS",
    "address": "510 BROOKLINE BLVD., PITTSBURGH, PA, 15226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.395995,
    "lng": -80.023518
  },
  {
    "id": "12297",
    "name": "CVS",
    "address": "1000 E. SANDY LAKE RD., COPPELL, TX, 75019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9699733,
    "lng": -96.9592289
  },
  {
    "id": "12296",
    "name": "CVS",
    "address": "1533 SOUTH BLVD, CHARLOTTE, NC, 28203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2137413,
    "lng": -80.8551198
  },
  {
    "id": "12295",
    "name": "CVS",
    "address": "2200 MATLOCK RD., MANSFIELD, TX, 76063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5952612,
    "lng": -97.1070453
  },
  {
    "id": "12294",
    "name": "CVS",
    "address": "6079 HWY 6 N., HOUSTON, TX, 77084",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8671767,
    "lng": -95.6459183
  },
  {
    "id": "12293",
    "name": "CVS",
    "address": "7102 BEECHNUT ST., HOUSTON, TX, 77074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6926248,
    "lng": -95.5107746
  },
  {
    "id": "12292",
    "name": "CVS",
    "address": "1370 WEST MAIN STREET, NEWARK, OH, 43055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0468149,
    "lng": -82.4526382
  },
  {
    "id": "12291",
    "name": "CVS",
    "address": "3800 PINE AVE, ERIE, PA, 16504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1079664,
    "lng": -80.0496066
  },
  {
    "id": "12290",
    "name": "CVS",
    "address": "629 ABBINGTON DR., EAST WINDSOR, NJ, 8520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2662642,
    "lng": -74.49002
  },
  {
    "id": "12289",
    "name": "CVS",
    "address": "1895 N CONGRESS AVE, BOYNTON BEACH, FL, 33426",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.5451283,
    "lng": -80.0912922
  },
  {
    "id": "12288",
    "name": "CVS",
    "address": "9125 HILLCROFT ST., HOUSTON, TX, 77096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6790849,
    "lng": -95.4922839
  },
  {
    "id": "12287",
    "name": "CVS",
    "address": "59 MAIN STREET, WARWICK, NY, 10990",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2583612,
    "lng": -74.3597554
  },
  {
    "id": "12286",
    "name": "CVS",
    "address": "733 E MAIN ST, SANTA MARIA, CA, 93454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.9536009,
    "lng": -120.4255905
  },
  {
    "id": "12285",
    "name": "CVS",
    "address": "21 CHATSWORTH AVENUE, LARCHMONT, NY, 10538",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9302245,
    "lng": -73.7515549
  },
  {
    "id": "12284",
    "name": "CVS",
    "address": "30-97 STEINWAY ST., ASTORIA, NY, 11103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7613619,
    "lng": -73.916647
  },
  {
    "id": "12283",
    "name": "CVS",
    "address": "5190 S CONWAY RD, ORLANDO, FL, 32812",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4813592,
    "lng": -81.3312605
  },
  {
    "id": "12282",
    "name": "CVS",
    "address": "440 BELLEVILLE TPKE., NORTH ARLINGTON, NJ, 7031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7776096,
    "lng": -74.1297767
  },
  {
    "id": "12281",
    "name": "CVS",
    "address": "801 N. TARRANT PKWY., KELLER, TX, 76248",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.899693,
    "lng": -97.2379256
  },
  {
    "id": "12280",
    "name": "CVS",
    "address": "99 MAGNOLIA AVE, AUBURNDALE, FL, 33823",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0580364,
    "lng": -81.7836273
  },
  {
    "id": "12279",
    "name": "CVS",
    "address": "895 HOLCOMB BRIDGE ROAD, ROSWELL, GA, 30076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0281226,
    "lng": -84.3362512
  },
  {
    "id": "12278",
    "name": "CVS",
    "address": "2480 TAMIAMI TRL, PORT CHARLOTTE, FL, 33952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.9956314,
    "lng": -82.1164872
  },
  {
    "id": "12277",
    "name": "CVS",
    "address": "615 E 3RD AVE, NEW SMYRNA BEACH, FL, 32169",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.0281837,
    "lng": -80.8972291
  },
  {
    "id": "12276",
    "name": "CVS",
    "address": "2400 ENTERPRISE RD., ORANGE CITY, FL, 32763",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.9220846,
    "lng": -81.2988917
  },
  {
    "id": "12275",
    "name": "CVS",
    "address": "1602 CENTRAL AVE., SUMMERVILLE, SC, 29483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0121285,
    "lng": -80.238693
  },
  {
    "id": "12274",
    "name": "CVS",
    "address": "1002 S. BUSSE RD., MOUNT PROSPECT, IL, 60056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0477198,
    "lng": -87.960779
  },
  {
    "id": "12273",
    "name": "CVS",
    "address": "4 S. BREVARD AVE., ARCADIA, FL, 34266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.2144655,
    "lng": -81.8598253
  },
  {
    "id": "12272",
    "name": "CVS",
    "address": "1625 FOURAKER ROAD, JACKSONVILLE, FL, 32221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2922441,
    "lng": -81.7809988
  },
  {
    "id": "12271",
    "name": "CVS",
    "address": "9870 MAIN ROAD, MATTITUCK, NY, 11952",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9839779,
    "lng": -72.5385274
  },
  {
    "id": "12270",
    "name": "CVS",
    "address": "310 HILLSIDE AVENUE, NEW HYDE PARK, NY, 11040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7404798,
    "lng": -73.6976282
  },
  {
    "id": "12269",
    "name": "CVS",
    "address": "60 MILL HILL RD., WOODSTOCK, NY, 12498",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0388419,
    "lng": -74.1149117
  },
  {
    "id": "12268",
    "name": "CVS",
    "address": "1710 ROUTE 112, CORAM, NY, 11727",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8914506,
    "lng": -73.0155308
  },
  {
    "id": "12267",
    "name": "CVS",
    "address": "480 MONTAUK HWY., BAY SHORE, NY, 11706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7277499,
    "lng": -73.2277045
  },
  {
    "id": "12266",
    "name": "CVS",
    "address": "123 WINDERMERE AVE. PO BOX 1837, GREENWOOD LAKE, NY, 10925",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2262743,
    "lng": -74.2921123
  },
  {
    "id": "12265",
    "name": "CVS",
    "address": "375 QUEEN ANNE ROAD, TEANECK, NJ, 7666",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8759611,
    "lng": -74.020189
  },
  {
    "id": "12264",
    "name": "CVS",
    "address": "3775 E. TREMONT AVE., BRONX, NY, 10465",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8255689,
    "lng": -73.8205401
  },
  {
    "id": "12263",
    "name": "CVS",
    "address": "6891 VAUGHN ROAD, MONTGOMERY, AL, 36116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3401717,
    "lng": -86.196351
  },
  {
    "id": "12262",
    "name": "CVS",
    "address": "11560 OLIVE BLVD., CREVE COEUR, MO, 63141",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6705981,
    "lng": -90.4377827
  },
  {
    "id": "12261",
    "name": "CVS",
    "address": "1162 WEST AVE., CARTERSVILLE, GA, 30120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1502281,
    "lng": -84.8254366
  },
  {
    "id": "12260",
    "name": "CVS",
    "address": "1701 GALVIN ROAD S., BELLEVUE, NE, 68005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.142827,
    "lng": -95.9095642
  },
  {
    "id": "12259",
    "name": "CVS",
    "address": "1597 HOGANSVILLE RD., LA GRANGE, GA, 30241",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0576315,
    "lng": -84.987361
  },
  {
    "id": "12258",
    "name": "CVS",
    "address": "2224 PATTERSON RD, RIVERBANK, CA, 95367",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7315495,
    "lng": -120.9576049
  },
  {
    "id": "12257",
    "name": "CVS",
    "address": "2151 MEEKER AVE, RICHMOND, CA, 94804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9205685,
    "lng": -122.3485929
  },
  {
    "id": "12256",
    "name": "CVS",
    "address": "801 OAKDALE RD STE F, MODESTO, CA, 95355",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6547467,
    "lng": -120.9592185
  },
  {
    "id": "12255",
    "name": "CVS",
    "address": "5059 BUSINESS CENTER DR, FAIRFIELD, CA, 94534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2157814,
    "lng": -122.1413398
  },
  {
    "id": "12254",
    "name": "CVS",
    "address": "451 S REINO RD, NEWBURY PARK, CA, 91320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1711892,
    "lng": -118.9560486
  },
  {
    "id": "12253",
    "name": "CVS",
    "address": "10776 WESTVIEW PKWY, SAN DIEGO, CA, 92126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.9165693,
    "lng": -117.122339
  },
  {
    "id": "12252",
    "name": "CVS",
    "address": "1856 PLEASANTVILLE RD., BRIARCLIFF MANOR, NY, 10510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1636072,
    "lng": -73.8457428
  },
  {
    "id": "12251",
    "name": "CVS",
    "address": "8351 ELK GROVE FLORIN RD, SACRAMENTO, CA, 95829",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4543544,
    "lng": -121.3700657
  },
  {
    "id": "12250",
    "name": "CVS",
    "address": "125 DUBLIN RD., PETERBOROUGH, NH, 3458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8756903,
    "lng": -71.9606029
  },
  {
    "id": "12249",
    "name": "CVS",
    "address": "3192 ROUTE 115, EFFORT, PA, 18330",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9774179,
    "lng": -75.44476
  },
  {
    "id": "12248",
    "name": "CVS",
    "address": "3475 MCKEE RD, SAN JOSE, CA, 95127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3814686,
    "lng": -121.8282564
  },
  {
    "id": "12247",
    "name": "CVS",
    "address": "8936 LYNDALE AVE., BLOOMINGTON, MN, 55420",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.8412313,
    "lng": -93.2894104
  },
  {
    "id": "12246",
    "name": "CVS",
    "address": "30261 GOLDEN LANTERN, LAGUNA NIGUEL, CA, 92677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5229459,
    "lng": -117.6879421
  },
  {
    "id": "12245",
    "name": "CVS",
    "address": "38012 47TH STREET EAST, PALMDALE, CA, 93552",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.5733844,
    "lng": -118.0440864
  },
  {
    "id": "12244",
    "name": "CVS",
    "address": "1175 MADISON AVE., MANKATO, MN, 56001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1663434,
    "lng": -93.9770809
  },
  {
    "id": "12243",
    "name": "CVS",
    "address": "10650 SAN PABLO AVE, EL CERRITO, CA, 94530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.9125312,
    "lng": -122.3075235
  },
  {
    "id": "12242",
    "name": "CVS",
    "address": "310 SOUTH ROSEMONT RD., VIRGINIA BEACH, VA, 23452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8294541,
    "lng": -76.0948232
  },
  {
    "id": "12241",
    "name": "CVS",
    "address": "17579 VIERRA CANYON RD, SALINAS, CA, 93907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7932131,
    "lng": -121.664225
  },
  {
    "id": "12240",
    "name": "CVS",
    "address": "268 RESERVATION RD, MARINA, CA, 93933",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.6839126,
    "lng": -121.7960238
  },
  {
    "id": "12239",
    "name": "CVS",
    "address": "3200 LAFAYETTE BLVD.,, NORFOLK, VA, 23509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8756225,
    "lng": -76.2514422
  },
  {
    "id": "12238",
    "name": "CVS",
    "address": "8601 MARTIN LUTHER KING JR. HWY., LANHAM, MD, 20706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9372531,
    "lng": -76.8580875
  },
  {
    "id": "12237",
    "name": "CVS",
    "address": "157 RITCHIE HIGHWAY, SEVERNA PARK, MD, 21146",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0996138,
    "lng": -76.5650109
  },
  {
    "id": "12236",
    "name": "CVS",
    "address": "1500 RITCHIE HIGHWAY, SWC, ARNOLD, MD, 21012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0282368,
    "lng": -76.5042907
  },
  {
    "id": "12235",
    "name": "CVS",
    "address": "1545 PULASKI HIGHWAY, BEAR, DE, 19701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6229511,
    "lng": -75.6852619
  },
  {
    "id": "12234",
    "name": "CVS",
    "address": "1966 MAIN ST, WATSONVILLE, CA, 95076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9195025,
    "lng": -121.7817827
  },
  {
    "id": "12233",
    "name": "CVS",
    "address": "1605 TELEGRAPH RD., WILMINGTON, DE, 19804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7113078,
    "lng": -75.6512207
  },
  {
    "id": "12232",
    "name": "CVS",
    "address": "212 WEST BAGLEY ROAD, BEREA, OH, 44017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3735844,
    "lng": -81.8610646
  },
  {
    "id": "12231",
    "name": "CVS",
    "address": "333 ACADEMY AVE, SANGER, CA, 93657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7114237,
    "lng": -119.5575712
  },
  {
    "id": "12230",
    "name": "CVS",
    "address": "4961 MONTICELLO BLVD,, RICHMOND HEIGHTS, OH, 44143",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5392681,
    "lng": -81.4983282
  },
  {
    "id": "12229",
    "name": "CVS",
    "address": "440 UNION AVE., BRIDGEWATER, NJ, 8807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5690853,
    "lng": -74.5768553
  },
  {
    "id": "12228",
    "name": "CVS",
    "address": "1097 LEIGH AVE, SAN JOSE, CA, 95126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3045322,
    "lng": -121.9226887
  },
  {
    "id": "12227",
    "name": "CVS",
    "address": "1385 TAVERN RD, ALPINE, CA, 91901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8362745,
    "lng": -116.7757021
  },
  {
    "id": "12226",
    "name": "CVS",
    "address": "7201 REGIONAL ST, DUBLIN, CA, 94568",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7051762,
    "lng": -121.9328228
  },
  {
    "id": "12225",
    "name": "CVS",
    "address": "1063 C ST, GALT, CA, 95632",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2544692,
    "lng": -121.2966993
  },
  {
    "id": "12224",
    "name": "CVS",
    "address": "1799 DEKALB PIKE, BLUE BELL, PA, 19422",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1492296,
    "lng": -75.307736
  },
  {
    "id": "12223",
    "name": "CVS",
    "address": "682 RTE 25A, SETAUKET, NY, 11733",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9301191,
    "lng": -73.1141684
  },
  {
    "id": "12222",
    "name": "CVS",
    "address": "3500 PALMER DR, CAMERON PARK, CA, 95682",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6604156,
    "lng": -120.966569
  },
  {
    "id": "12221",
    "name": "CVS",
    "address": "6010 SOUTH EMERSON AVENUE, INDIANAPOLIS, IN, 46237",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6800137,
    "lng": -86.0836211
  },
  {
    "id": "12220",
    "name": "CVS",
    "address": "71 MARY ESTHER BLVD, MARY ESTHER, FL, 32569",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4097916,
    "lng": -86.6547875
  },
  {
    "id": "12219",
    "name": "CVS",
    "address": "15129 MADEIRA WAY, MADEIRA BEACH, FL, 33708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8023751,
    "lng": -82.8019036
  },
  {
    "id": "12218",
    "name": "CVS",
    "address": "3100 GEER RD., TURLOCK, CA, 95382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5213068,
    "lng": -120.8480102
  },
  {
    "id": "12217",
    "name": "CVS",
    "address": "15 BOONTON TPKE, LINCOLN PARK, NJ, 7035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9222115,
    "lng": -74.3032504
  },
  {
    "id": "12216",
    "name": "CVS",
    "address": "7065 LINCOLN DRIVE, PHILADELPHIA, PA, 19119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0540732,
    "lng": -75.1932506
  },
  {
    "id": "12215",
    "name": "CVS",
    "address": "97-10 63RD RD., REGO PARK, NY, 11374",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7308088,
    "lng": -73.8605138
  },
  {
    "id": "12214",
    "name": "CVS",
    "address": "1201 N. STATE ST., CHICAGO, IL, 60610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9041521,
    "lng": -87.6282766
  },
  {
    "id": "12213",
    "name": "CVS",
    "address": "6120 E. MOCKINGBIRD LN., DALLAS, TX, 75214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8360751,
    "lng": -96.7606853
  },
  {
    "id": "12212",
    "name": "CVS",
    "address": "100 W. CORPORATE DRIVE, LEWISVILLE, TX, 75067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0114339,
    "lng": -96.9937838
  },
  {
    "id": "12211",
    "name": "CVS",
    "address": "2400 E. MAIN ST., RICHMOND, VA, 23223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5293797,
    "lng": -77.4214727
  },
  {
    "id": "12210",
    "name": "CVS",
    "address": "700 MAIN ST., LANOKA HARBOR, NJ, 8734",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8624163,
    "lng": -74.173753
  },
  {
    "id": "12209",
    "name": "CVS",
    "address": "11 THEATRE CTR., SPARTA, NJ, 7871",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0315262,
    "lng": -74.635743
  },
  {
    "id": "12208",
    "name": "CVS",
    "address": "1104 RINGWOOD AVE, HASKELL, NJ, 7420",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0281016,
    "lng": -74.2964668
  },
  {
    "id": "12207",
    "name": "CVS",
    "address": "6464 W. ATLANTIC AVE., DELRAY BEACH, FL, 33484",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4531753,
    "lng": -80.1463067
  },
  {
    "id": "12206",
    "name": "CVS",
    "address": "1380 WOODSTOCK RD, ROSWELL, GA, 30075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0615044,
    "lng": -84.4022873
  },
  {
    "id": "12205",
    "name": "CVS",
    "address": "711 E. INDIAN SCHOOL RD., PHOENIX, AZ, 85014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4942882,
    "lng": -112.0645146
  },
  {
    "id": "12204",
    "name": "CVS",
    "address": "2 E. JERICHO TPKE, HUNTINGTON STATION, NY, 11746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8279227,
    "lng": -73.4085381
  },
  {
    "id": "12203",
    "name": "CVS",
    "address": "139 ENDICOTT ST., DANVERS, MA, 1923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5500123,
    "lng": -70.933596
  },
  {
    "id": "12202",
    "name": "CVS",
    "address": "16461 VENTURA BLVD., ENCINO, CA, 91436",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1578646,
    "lng": -118.4917337
  },
  {
    "id": "12201",
    "name": "CVS",
    "address": "572 PATERSON AVE., EAST RUTHERFORD, NJ, 7073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8423212,
    "lng": -74.1061023
  },
  {
    "id": "12200",
    "name": "CVS",
    "address": "5414 ROTARY AVE., NEW MARKET, MD, 21774",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3825097,
    "lng": -77.256051
  },
  {
    "id": "12199",
    "name": "CVS",
    "address": "104 N. POTTSTOWN PIKE, CHESTER SPRINGS, PA, 19425",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0288039,
    "lng": -75.6294693
  },
  {
    "id": "12198",
    "name": "CVS",
    "address": "1367 DOUBLE CHURCHES RD., COLUMBUS, GA, 31904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5567209,
    "lng": -84.9727525
  },
  {
    "id": "12197",
    "name": "CVS",
    "address": "842 PEACHTREE STREET, NE, ATLANTA, GA, 30308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7774986,
    "lng": -84.3845652
  },
  {
    "id": "12196",
    "name": "CVS",
    "address": "401 W. ARMITAGE AVE., CHICAGO, IL, 60614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9181363,
    "lng": -87.6391832
  },
  {
    "id": "12195",
    "name": "CVS",
    "address": "809 PLAINFIELD RD., JOLIET, IL, 60435",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5387772,
    "lng": -88.1019245
  },
  {
    "id": "12194",
    "name": "CVS",
    "address": "8712 SOUTH STONY ISLAND AVE., CHICAGO, IL, 60617",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7363893,
    "lng": -87.585982
  },
  {
    "id": "12193",
    "name": "CVS",
    "address": "3710 57TH AVE., KENOSHA, WI, 53144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6040265,
    "lng": -87.8774491
  },
  {
    "id": "12192",
    "name": "CVS",
    "address": "14303 U STREET, OMAHA, NE, 68137",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2020278,
    "lng": -96.1379526
  },
  {
    "id": "12191",
    "name": "CVS",
    "address": "7190 W. CRAIG RD., LAS VEGAS, NV, 89129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.2411266,
    "lng": -115.2506965
  },
  {
    "id": "12190",
    "name": "CVS",
    "address": "488 ROUTE 17M, MONROE, NY, 10950",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3192062,
    "lng": -74.175878
  },
  {
    "id": "12189",
    "name": "CVS",
    "address": "10204 FLATLANDS AVE., BROOKLYN, NY, 11236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6460233,
    "lng": -73.8964372
  },
  {
    "id": "12188",
    "name": "CVS",
    "address": "400 OGDEN AVE., DOWNERS GROVE, IL, 60515",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8100191,
    "lng": -87.995913
  },
  {
    "id": "12187",
    "name": "CVS",
    "address": "520 N. WESTERN AVE., LAKE FOREST, IL, 60045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2487965,
    "lng": -87.8397536
  },
  {
    "id": "12186",
    "name": "CVS",
    "address": "34344 N. US HWY 45, THIRD LAKE, IL, 60030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.361332,
    "lng": -88.0012548
  },
  {
    "id": "12185",
    "name": "CVS",
    "address": "25761 PERDIDO BEACH BLVD., ORANGE BEACH, AL, 36561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2696346,
    "lng": -87.5883146
  },
  {
    "id": "12184",
    "name": "CVS",
    "address": "813 W. BEARSS AVE., TAMPA, FL, 33613",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0886004,
    "lng": -82.4670644
  },
  {
    "id": "12183",
    "name": "CVS",
    "address": "15395 NW 82ND AVE., MIAMI LAKES, FL, 33016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9127291,
    "lng": -80.3323644
  },
  {
    "id": "12182",
    "name": "CVS",
    "address": "675 WASHINGTON STREET, MIDDLETOWN, CT, 6457",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5543342,
    "lng": -72.6745594
  },
  {
    "id": "12181",
    "name": "CVS",
    "address": "7851 TELEGRAPH RD., SEVERN, MD, 21144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1360534,
    "lng": -76.68535
  },
  {
    "id": "12180",
    "name": "CVS",
    "address": "1120 FOREST AVE., CHICO, CA, 95928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7387713,
    "lng": -121.8054575
  },
  {
    "id": "12179",
    "name": "CVS",
    "address": "901 BRISTOL PIKE, CROYDON, PA, 19021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0948233,
    "lng": -74.9054497
  },
  {
    "id": "12178",
    "name": "CVS",
    "address": "700 RTE 113, SOUDERTON, PA, 18964",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3155425,
    "lng": -75.3113806
  },
  {
    "id": "12177",
    "name": "CVS",
    "address": "550 PLEASANT ST., FALL RIVER, MA, 2721",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.699399,
    "lng": -71.1465575
  },
  {
    "id": "12176",
    "name": "CVS",
    "address": "14600 LAWYERS RD., MATTHEWS, NC, 28104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1423003,
    "lng": -80.6243611
  },
  {
    "id": "12175",
    "name": "CVS",
    "address": "4000 EAST BAY DRIVE, CLEARWATER, FL, 33764",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9168674,
    "lng": -82.7450297
  },
  {
    "id": "12174",
    "name": "CVS",
    "address": "2200 34TH STREET NORTH, SAINT PETERSBURG, FL, 33713",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7924281,
    "lng": -82.6801968
  },
  {
    "id": "12173",
    "name": "CVS",
    "address": "4000 ASBURY AVE., NEPTUNE, NJ, 7753",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2341908,
    "lng": -74.0783408
  },
  {
    "id": "12172",
    "name": "CVS",
    "address": "1046 MARKET ST., PHILADELPHIA, PA, 19107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9515417,
    "lng": -75.1581618
  },
  {
    "id": "12171",
    "name": "CVS",
    "address": "500 EASTERN AVE., ESSEX, MD, 21221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2851296,
    "lng": -76.6039323
  },
  {
    "id": "12170",
    "name": "CVS",
    "address": "2045 PLUM GROVE RD., ROLLING MEADOWS, IL, 60008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0879273,
    "lng": -88.0444849
  },
  {
    "id": "12169",
    "name": "CVS",
    "address": "110 W. NORTH AVE., ELMHURST, IL, 60126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9058331,
    "lng": -87.9406237
  },
  {
    "id": "12168",
    "name": "CVS",
    "address": "230 MILLTOWN RD., BRIDGEWATER, NJ, 8807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5703281,
    "lng": -74.6733894
  },
  {
    "id": "12167",
    "name": "CVS",
    "address": "327 S. PITNEY RD., GALLOWAY, NJ, 8205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4646822,
    "lng": -74.4942781
  },
  {
    "id": "12166",
    "name": "CVS",
    "address": "2036 E. ATLANTIC BLVD., POMPANO BEACH, FL, 33060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2314434,
    "lng": -80.1034667
  },
  {
    "id": "12165",
    "name": "CVS",
    "address": "1930 W. 103RD ST., CHICAGO, IL, 60643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7068556,
    "lng": -87.6700568
  },
  {
    "id": "12164",
    "name": "CVS",
    "address": "975 TAMPA RD., PALM HARBOR, FL, 34683",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0683763,
    "lng": -82.7679472
  },
  {
    "id": "12163",
    "name": "CVS",
    "address": "5710 SUGARLOAF PKWY, LAWRENCEVILLE, GA, 30043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9766075,
    "lng": -84.0749177
  },
  {
    "id": "12162",
    "name": "CVS",
    "address": "2005 NORWICH - NEW LONDON TPKE, UNCASVILLE, CT, 6382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4790943,
    "lng": -72.0987548
  },
  {
    "id": "12161",
    "name": "CVS",
    "address": "48 E. MARKET ST., RHINEBECK, NY, 12572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.926448,
    "lng": -73.9109517
  },
  {
    "id": "12160",
    "name": "CVS",
    "address": "1795 HOOPER AVE., TOMS RIVER, NJ, 8753",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0092458,
    "lng": -74.1470258
  },
  {
    "id": "12159",
    "name": "CVS",
    "address": "1401-09 5TH AVENUE, NORTH BAY SHORE, NY, 11706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7426277,
    "lng": -73.2631751
  },
  {
    "id": "12158",
    "name": "CVS",
    "address": "1762 RATZER RD., WAYNE, NJ, 7470",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9434008,
    "lng": -74.2037167
  },
  {
    "id": "12157",
    "name": "CVS",
    "address": "3031 14TH ST., NW, WASHINGTON, DC, 20009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9284012,
    "lng": -77.0322483
  },
  {
    "id": "12156",
    "name": "CVS",
    "address": "3502 EDGEWATER DR., ORLANDO, FL, 32804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5839171,
    "lng": -81.3924816
  },
  {
    "id": "12155",
    "name": "CVS",
    "address": "1701 N. UNIVERSITY DR., PEMBROKE PINES, FL, 33024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.024383,
    "lng": -80.2474222
  },
  {
    "id": "12154",
    "name": "CVS",
    "address": "715 W. BRANDON BLVD., BRANDON, FL, 33511",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9371157,
    "lng": -82.2944108
  },
  {
    "id": "12153",
    "name": "CVS",
    "address": "7500 MAPLE AVE., PENNSAUKEN, NJ, 8109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9517671,
    "lng": -75.0316347
  },
  {
    "id": "12152",
    "name": "CVS",
    "address": "2147 HAMILTON AVE, HAMILTON, NJ, 8619",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2286198,
    "lng": -74.7075978
  },
  {
    "id": "12151",
    "name": "CVS",
    "address": "330 RUES LANE, EAST BRUNSWICK, NJ, 8816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4178405,
    "lng": -74.4115838
  },
  {
    "id": "12150",
    "name": "CVS",
    "address": "217 MAIN STREET, WEST ORANGE, NJ, 7052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7847238,
    "lng": -74.2323307
  },
  {
    "id": "12149",
    "name": "CVS",
    "address": "7996 CONROY WINDERMERE RD., ORLANDO, FL, 32835",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4931333,
    "lng": -81.4914834
  },
  {
    "id": "12148",
    "name": "CVS",
    "address": "3102 W. GANDY BLVD., TAMPA, FL, 33611",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8932041,
    "lng": -82.4943294
  },
  {
    "id": "12147",
    "name": "CVS",
    "address": "3951 W. 103RD ST., CHICAGO, IL, 60655",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7053701,
    "lng": -87.7202632
  },
  {
    "id": "12146",
    "name": "CVS",
    "address": "9640 N. MILWAUKEE AVE., NILES, IL, 60714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0554056,
    "lng": -87.8396648
  },
  {
    "id": "12145",
    "name": "CVS",
    "address": "241 WESTFIELD AVENUE, CLARK, NJ, 7066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6218271,
    "lng": -74.3049921
  },
  {
    "id": "12144",
    "name": "CVS",
    "address": "1005 E. ROOSEVELT RD, LOMBARD, IL, 60148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8600447,
    "lng": -87.992039
  },
  {
    "id": "12143",
    "name": "CVS",
    "address": "1306 MACDADE BLVD., WOODLYN, PA, 19094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8768789,
    "lng": -75.3449528
  },
  {
    "id": "12142",
    "name": "CVS",
    "address": "857 W BALTIMORE PIKE, WEST GROVE, PA, 19390",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8229054,
    "lng": -75.8715957
  },
  {
    "id": "12141",
    "name": "CVS",
    "address": "518 PORT ROYAL AVENUE, PHILADELPHIA, PA, 19128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0611974,
    "lng": -75.2371953
  },
  {
    "id": "12140",
    "name": "CVS",
    "address": "1456 FERRY RD., DOYLESTOWN, PA, 18901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3410751,
    "lng": -75.1518475
  },
  {
    "id": "12139",
    "name": "CVS",
    "address": "814 HEMPSTEAD AVE., WEST HEMPSTEAD, NY, 11552",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6880986,
    "lng": -73.6588177
  },
  {
    "id": "12138",
    "name": "CVS",
    "address": "503 S. CHERRY GROVE AVE., ANNAPOLIS, MD, 21401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9682575,
    "lng": -76.5193323
  },
  {
    "id": "12137",
    "name": "CVS",
    "address": "11100 BALTIMORE AVE., BELTSVILLE, MD, 20705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0354115,
    "lng": -76.9073584
  },
  {
    "id": "12136",
    "name": "CVS",
    "address": "1280 NORTH GREAT NECK, VIRGINIA BEACH, VA, 23454",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.8737123,
    "lng": -76.0389189
  },
  {
    "id": "12135",
    "name": "CVS",
    "address": "2601 RIVA RD., ANNAPOLIS, MD, 21401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9755925,
    "lng": -76.5560029
  },
  {
    "id": "12134",
    "name": "CVS",
    "address": "10730 PROVIDENCE RD., CHARLOTTE, NC, 28277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0633324,
    "lng": -80.7710181
  },
  {
    "id": "12133",
    "name": "CVS",
    "address": "11911 US 70 BUS HWY WEST, CLAYTON, NC, 27520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.656762,
    "lng": -78.4797676
  },
  {
    "id": "12132",
    "name": "CVS",
    "address": "7101 PARK BLVD., PINELLAS PARK, FL, 33781",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8398009,
    "lng": -82.7373693
  },
  {
    "id": "12131",
    "name": "CVS",
    "address": "462 ELIZABETH AVE., SOMERSET, NJ, 8873",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5290168,
    "lng": -74.5411102
  },
  {
    "id": "12130",
    "name": "CVS",
    "address": "5308 W. IRLO BRONSON MEMORIAL HWY, KISSIMMEE, FL, 34746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3319527,
    "lng": -81.4960722
  },
  {
    "id": "12129",
    "name": "CVS",
    "address": "2911 E. FOWLER AVE., TAMPA, FL, 33612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0539426,
    "lng": -82.4267854
  },
  {
    "id": "12128",
    "name": "CVS",
    "address": "845 4TH ST. NORTH, SAINT PETERSBURG, FL, 33701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7809084,
    "lng": -82.6382577
  },
  {
    "id": "12127",
    "name": "CVS",
    "address": "255 S. STATE RD. #7, MARGATE, FL, 33068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2276863,
    "lng": -80.2054811
  },
  {
    "id": "12126",
    "name": "CVS",
    "address": "2507 W. CHESTER PIKE, BROOMALL, PA, 19008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9818149,
    "lng": -75.3578877
  },
  {
    "id": "12125",
    "name": "CVS",
    "address": "4314 LOCUST STREET, PHILADELPHIA, PA, 19104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9535456,
    "lng": -75.2097085
  },
  {
    "id": "12124",
    "name": "CVS",
    "address": "560 AVENUE C, BAYONNE, NJ, 7002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6664153,
    "lng": -74.1189951
  },
  {
    "id": "12123",
    "name": "CVS",
    "address": "5225 POPLAR TENT RD, CONCORD, NC, 28027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4123186,
    "lng": -80.6650717
  },
  {
    "id": "12122",
    "name": "CVS",
    "address": "1802 N. UNIVERSITY DR., PLANTATION, FL, 33322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1495063,
    "lng": -80.2561113
  },
  {
    "id": "12121",
    "name": "CVS",
    "address": "410 BROAD AVE., LEONIA, NJ, 7605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8650618,
    "lng": -73.9859873
  },
  {
    "id": "12120",
    "name": "CVS",
    "address": "188 CEDAR LANE, TEANECK, NJ, 7666",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8857304,
    "lng": -74.0130076
  },
  {
    "id": "12119",
    "name": "CVS",
    "address": "3710 HIGHWAY 17 BYPASS, MURRELLS INLET, SC, 29576",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5688011,
    "lng": -79.0347487
  },
  {
    "id": "12118",
    "name": "CVS",
    "address": "4280 MORSE RD, COLUMBUS, OH, 43230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0569262,
    "lng": -82.8870259
  },
  {
    "id": "12117",
    "name": "CVS",
    "address": "1299 WEST SOUTHPORT RD, INDIANAPOLIS, IN, 46217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6633446,
    "lng": -86.1816213
  },
  {
    "id": "12116",
    "name": "CVS",
    "address": "901 N. FEDERAL HWY., HOLLYWOOD, FL, 33020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0195353,
    "lng": -80.1427275
  },
  {
    "id": "12115",
    "name": "CVS",
    "address": "2200 GULF TO BAY BLVD., CLEARWATER, FL, 33765",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.9612233,
    "lng": -82.7455448
  },
  {
    "id": "12114",
    "name": "CVS",
    "address": "342 N. LEWIS RD., ROYERSFORD, PA, 19468",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1972558,
    "lng": -75.535176
  },
  {
    "id": "12113",
    "name": "CVS",
    "address": "351 KENNEDY BLVD, PITTSTON, PA, 18640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3210241,
    "lng": -75.7926957
  },
  {
    "id": "12112",
    "name": "CVS",
    "address": "6221 ROUTE 25A, WADING RIVER, NY, 11792",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9438144,
    "lng": -72.8374238
  },
  {
    "id": "12111",
    "name": "CVS",
    "address": "111 DEPOT ROAD, HUNTINGTON STATION, NY, 11746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8481703,
    "lng": -73.4085824
  },
  {
    "id": "12110",
    "name": "CVS",
    "address": "394 BROADWAY, PASSAIC, NJ, 7055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.853176,
    "lng": -74.1404103
  },
  {
    "id": "12109",
    "name": "CVS",
    "address": "505 ROUTE 530, WHITING, NJ, 8759",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9472576,
    "lng": -74.3533405
  },
  {
    "id": "12108",
    "name": "CVS",
    "address": "935 HORSEBLOCK RD., FARMINGVILLE, NY, 11738",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8312646,
    "lng": -73.0240165
  },
  {
    "id": "12107",
    "name": "CVS",
    "address": "97-01 LIBERTY AVE., OZONE PARK, NY, 11417",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6814267,
    "lng": -73.8418573
  },
  {
    "id": "12106",
    "name": "CVS",
    "address": "17 WILLIAM H. TAFT RD., CINCINNATI, OH, 45219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1276104,
    "lng": -84.5108718
  },
  {
    "id": "12105",
    "name": "CVS",
    "address": "753 W HWY 50, O FALLON, IL, 62269",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5881004,
    "lng": -89.9281065
  },
  {
    "id": "12104",
    "name": "CVS",
    "address": "465 SAND CREEK RD., COLONIE, NY, 12205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7163996,
    "lng": -73.8118091
  },
  {
    "id": "12103",
    "name": "CVS",
    "address": "790 ALTON GLOOR BLVD.,, BROWNSVILLE, TX, 78526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9788295,
    "lng": -97.5053085
  },
  {
    "id": "12102",
    "name": "CVS",
    "address": "1402 SHEEPSHEAD BAY ROAD, BROOKLYN, NY, 11235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5875012,
    "lng": -73.955076
  },
  {
    "id": "12101",
    "name": "CVS",
    "address": "4331 NESCONSET HWY., PORT JEFFERSON STATION, NY, 11776",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9080264,
    "lng": -73.065523
  },
  {
    "id": "12100",
    "name": "CVS",
    "address": "9498 CHARTER GATE DR, MECHANICSVILLE, VA, 23116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6903615,
    "lng": -77.4379705
  },
  {
    "id": "12099",
    "name": "CVS",
    "address": "5 KUGLER ROAD, BUILDING 100, LIMERICK, PA, 19468",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2378033,
    "lng": -75.5370865
  },
  {
    "id": "12098",
    "name": "CVS",
    "address": "7350 OXFORD AVENUE, SUITE C, PHILADELPHIA, PA, 19111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0626011,
    "lng": -75.085046
  },
  {
    "id": "12097",
    "name": "CVS",
    "address": "105 E. UWCHLAN AVE., EXTON, PA, 19341",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0609307,
    "lng": -75.6540388
  },
  {
    "id": "12096",
    "name": "CVS",
    "address": "2037 WEST BLVD., MALAGA, NJ, 8328",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5711614,
    "lng": -75.0535855
  },
  {
    "id": "12095",
    "name": "CVS",
    "address": "1 WEST WHITE HORSE PIKE, BERLIN, NJ, 8009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7973548,
    "lng": -74.934258
  },
  {
    "id": "12094",
    "name": "CVS",
    "address": "47 MAIN ST., WINSTED, CT, 6098",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9202989,
    "lng": -73.0596664
  },
  {
    "id": "12093",
    "name": "CVS",
    "address": "106 BOSTON ROAD ROUTE 119, GROTON, MA, 1450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5966812,
    "lng": -71.5609432
  },
  {
    "id": "12092",
    "name": "CVS",
    "address": "175 W MAIN ST, NEW ALBANY, OH, 43054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0798963,
    "lng": -82.8131865
  },
  {
    "id": "12091",
    "name": "CVS",
    "address": "150 COURT STREET, BROOKLYN, NY, 11201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6889791,
    "lng": -73.9929629
  },
  {
    "id": "12090",
    "name": "CVS",
    "address": "750 AVENUE OF AMERICAS, NEW YORK, NY, 10010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7437079,
    "lng": -73.9919839
  },
  {
    "id": "12089",
    "name": "CVS",
    "address": "9962 BAY MEADOWS RD., JACKSONVILLE, FL, 32256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2192416,
    "lng": -81.5531587
  },
  {
    "id": "12088",
    "name": "CVS",
    "address": "2272 N MAIN ST, CROWN POINT, IN, 46307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.448949,
    "lng": -87.3638964
  },
  {
    "id": "12087",
    "name": "CVS",
    "address": "4785 GRANITE DR, ROCKLIN, CA, 95677",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.79079,
    "lng": -121.2213191
  },
  {
    "id": "12086",
    "name": "CVS",
    "address": "1515 COMMERCIAL ST., WEYMOUTH, MA, 2189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2157449,
    "lng": -70.9209638
  },
  {
    "id": "12085",
    "name": "CVS",
    "address": "2600 PARIS RD, CHALMETTE, LA, 70043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9433993,
    "lng": -89.9638649
  },
  {
    "id": "12084",
    "name": "CVS",
    "address": "722 DUTCHESS TURNPIKE, POUGHKEEPSIE, NY, 12603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6987742,
    "lng": -73.8790735
  },
  {
    "id": "12083",
    "name": "CVS",
    "address": "558 PITTSBURGH ST., MARS, PA, 16046",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6921521,
    "lng": -80.0189578
  },
  {
    "id": "12082",
    "name": "CVS",
    "address": "3001 LONE OAK ROAD, PADUCAH, KY, 42003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0362955,
    "lng": -88.6657681
  },
  {
    "id": "12081",
    "name": "CVS",
    "address": "795 BALTIMORE PIKE, SPRINGFIELD, PA, 19064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9164874,
    "lng": -75.3325634
  },
  {
    "id": "12080",
    "name": "CVS",
    "address": "7442 S. STAPLES ST., CORPUS CHRISTI, TX, 78413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.6667617,
    "lng": -97.3947975
  },
  {
    "id": "12079",
    "name": "CVS",
    "address": "7-11 EAST MAIN STREET, ELMSFORD, NY, 10523",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0549995,
    "lng": -73.8195412
  },
  {
    "id": "12078",
    "name": "CVS",
    "address": "16 WEYMAN AVE., NEW ROCHELLE, NY, 10805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9009753,
    "lng": -73.7917724
  },
  {
    "id": "12077",
    "name": "CVS",
    "address": "190 HWY 31, FLEMINGTON, NJ, 8822",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5321677,
    "lng": -74.8551906
  },
  {
    "id": "12076",
    "name": "CVS",
    "address": "6702 FT. HAMILTON PARKWAY, BROOKLYN, NY, 11219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6296656,
    "lng": -74.0111837
  },
  {
    "id": "12075",
    "name": "CVS",
    "address": "1425 BARNUM AVENUE, STRATFORD, CT, 6614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1958556,
    "lng": -73.1386024
  },
  {
    "id": "12074",
    "name": "CVS",
    "address": "1235 PECAN AVE.,, CHARLOTTE, NC, 28205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.2199894,
    "lng": -80.8141182
  },
  {
    "id": "12073",
    "name": "CVS",
    "address": "590 W TRENTON AVE.,, MORRISVILLE, PA, 19067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2083742,
    "lng": -74.8021381
  },
  {
    "id": "12072",
    "name": "CVS",
    "address": "1990 BOSTON RD., WILBRAHAM, MA, 1095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1496013,
    "lng": -72.4768835
  },
  {
    "id": "12071",
    "name": "CVS",
    "address": "9931 GILEAD RD, HUNTERSVILLE, NC, 28078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4078226,
    "lng": -80.8625999
  },
  {
    "id": "12070",
    "name": "CVS",
    "address": "229 WEST BUFORD ST., GAFFNEY, SC, 29341",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0729186,
    "lng": -81.6523939
  },
  {
    "id": "12069",
    "name": "CVS",
    "address": "3125 BAINBRIDGE AVENUE, BRONX, NY, 10467",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8743967,
    "lng": -73.8796248
  },
  {
    "id": "12068",
    "name": "CVS",
    "address": "1775 E. MAIN ST., MOHEGAN LAKE, NY, 10547",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3227622,
    "lng": -73.8527953
  },
  {
    "id": "12067",
    "name": "CVS",
    "address": "4008 RTE 9, MORGANVILLE, NJ, 7751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3627794,
    "lng": -74.3057254
  },
  {
    "id": "12066",
    "name": "CVS",
    "address": "35 PADANARAM RD., DANBURY, CT, 6811",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4176494,
    "lng": -73.4626481
  },
  {
    "id": "12065",
    "name": "CVS",
    "address": "101 LEXINGTON CIRCLE, PEACHTREE CITY, GA, 30269",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.4220151,
    "lng": -84.5594807
  },
  {
    "id": "12064",
    "name": "CVS",
    "address": "601 EAST MAIN STREET, CANFIELD, OH, 44406",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0241827,
    "lng": -80.7412759
  },
  {
    "id": "12063",
    "name": "CVS",
    "address": "3405 RIDGE RD, HIGHLAND, IN, 46322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5536625,
    "lng": -87.4465405
  },
  {
    "id": "12062",
    "name": "CVS",
    "address": "1102 N.  DEMAREE ST., VISALIA, CA, 93291",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.3393333,
    "lng": -119.3313211
  },
  {
    "id": "12061",
    "name": "CVS",
    "address": "1187 JAMESTOWN ROAD, WILLIAMSBURG, VA, 23185",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.2551081,
    "lng": -76.7317583
  },
  {
    "id": "12060",
    "name": "CVS",
    "address": "49 CLAREMONT AVE., MONTCLAIR, NJ, 7042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8131663,
    "lng": -74.207202
  },
  {
    "id": "12059",
    "name": "CVS",
    "address": "79 LYNNFIELD STREET, PEABODY, MA, 1960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5174872,
    "lng": -70.9508719
  },
  {
    "id": "12058",
    "name": "CVS",
    "address": "8290 OCEAN GATEWAY, EASTON, MD, 21601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7766576,
    "lng": -76.0609022
  },
  {
    "id": "12057",
    "name": "CVS",
    "address": "2801 FAR HILLS AVE., OAKWOOD, OH, 45419",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7054857,
    "lng": -84.1709288
  },
  {
    "id": "12056",
    "name": "CVS",
    "address": "3615 CLAIRMONT ROAD, ATLANTA, GA, 30319",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.865082,
    "lng": -84.3088178
  },
  {
    "id": "12055",
    "name": "CVS",
    "address": "323 CROMWELL AVENUE, ROCKY HILL, CT, 6067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6615275,
    "lng": -72.6793736
  },
  {
    "id": "12054",
    "name": "CVS",
    "address": "298 EAST STREET ROAD, FEASTERVILLE, PA, 19053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1471167,
    "lng": -74.995074
  },
  {
    "id": "12053",
    "name": "CVS",
    "address": "791-799 SUMNEYTOWN PIKE, LANSDALE, PA, 19446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2216648,
    "lng": -75.3018397
  },
  {
    "id": "12052",
    "name": "CVS",
    "address": "3300 BELAIR RD., BALTIMORE, MD, 21213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3221211,
    "lng": -76.5738307
  },
  {
    "id": "12051",
    "name": "CVS",
    "address": "2701 SOUTH NC HIGHWAY 127, HICKORY, NC, 28602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6911021,
    "lng": -81.358804
  },
  {
    "id": "12050",
    "name": "CVS",
    "address": "2338 US HIGHWAY 41, SCHERERVILLE, IN, 46375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4794025,
    "lng": -87.4715024
  },
  {
    "id": "12049",
    "name": "CVS",
    "address": "1351 WILMINGTON PIKE, WEST CHESTER, PA, 19382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9019739,
    "lng": -75.5633771
  },
  {
    "id": "12048",
    "name": "CVS",
    "address": "557 SOUTH ATLANTIC AVENUE, ABERDEEN, NJ, 7747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4027251,
    "lng": -74.2284332
  },
  {
    "id": "12047",
    "name": "CVS",
    "address": "1800 VANDALIA ST., COLLINSVILLE, IL, 62234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6914317,
    "lng": -89.971029
  },
  {
    "id": "12046",
    "name": "CVS",
    "address": "3943 ROUTE 309, SCHNECKSVILLE, PA, 18078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6551125,
    "lng": -75.5996225
  },
  {
    "id": "12045",
    "name": "CVS",
    "address": "2125 DIAMOND HILL ROAD, CUMBERLAND, RI, 2864",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9467918,
    "lng": -71.4028015
  },
  {
    "id": "12044",
    "name": "CVS",
    "address": "93 EUCLID AVENUE, MOUNTAIN BROOK, AL, 35213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5026915,
    "lng": -86.7571775
  },
  {
    "id": "12043",
    "name": "CVS",
    "address": "2586 LAWRENCEVILLE HWY., DECATUR, GA, 30033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8225752,
    "lng": -84.2637237
  },
  {
    "id": "12042",
    "name": "CVS",
    "address": "581 HIGHLAND AVE., CHESHIRE, CT, 6410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5133952,
    "lng": -72.8992778
  },
  {
    "id": "12041",
    "name": "CVS",
    "address": "2709 CHILI AVENUE, ROCHESTER, NY, 14624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1223542,
    "lng": -77.7091029
  },
  {
    "id": "12040",
    "name": "CVS",
    "address": "1075 BROADWAY ST., SAUGUS, MA, 1906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4031449,
    "lng": -71.0177454
  },
  {
    "id": "12039",
    "name": "CVS",
    "address": "1221 E. CHURCHVILLE RD., BEL AIR, MD, 21014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5434268,
    "lng": -76.3255299
  },
  {
    "id": "12038",
    "name": "CVS",
    "address": "341 9TH STREET, BROOKLYN, NY, 11215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6688043,
    "lng": -73.9848391
  },
  {
    "id": "12037",
    "name": "CVS",
    "address": "2373 AUGUSTA HWY, LEXINGTON, SC, 29072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9792482,
    "lng": -81.3023887
  },
  {
    "id": "12036",
    "name": "CVS",
    "address": "890 WELSH ROAD, MAPLE GLEN, PA, 19002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1808831,
    "lng": -75.1821394
  },
  {
    "id": "12035",
    "name": "CVS",
    "address": "751 WEST LANCASTER AVENUE, DOWNINGTOWN, PA, 19335",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9996538,
    "lng": -75.7236111
  },
  {
    "id": "12034",
    "name": "CVS",
    "address": "525 WEST MAIN STREET, MOUNT JOY, PA, 17552",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1133768,
    "lng": -76.5161706
  },
  {
    "id": "12033",
    "name": "CVS",
    "address": "1041 POMPTON AVE, CEDAR GROVE, NJ, 7009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8679129,
    "lng": -74.2343941
  },
  {
    "id": "12032",
    "name": "CVS",
    "address": "1331 YOUNGSTOWN-WARREN RD, NILES, OH, 44446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2055312,
    "lng": -80.7396342
  },
  {
    "id": "12031",
    "name": "CVS",
    "address": "1021 NECK ROAD, BURLINGTON TOWNSHIP, NJ, 8016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0815671,
    "lng": -74.8197784
  },
  {
    "id": "12030",
    "name": "CVS",
    "address": "409 HARLEYSVILLE PIKE, SOUDERTON, PA, 18964",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3113803,
    "lng": -75.3547452
  },
  {
    "id": "12029",
    "name": "CVS",
    "address": "6342 EAST ADMIRAL PL N., TULSA, OK, 74115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1601833,
    "lng": -95.9052321
  },
  {
    "id": "12028",
    "name": "CVS",
    "address": "163 SILVER STREET, AGAWAM, MA, 1001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0616518,
    "lng": -72.6314263
  },
  {
    "id": "12027",
    "name": "CVS",
    "address": "122 E. PUTNAM AVENUE, COS COB, CT, 6807",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0375409,
    "lng": -73.601034
  },
  {
    "id": "12026",
    "name": "CVS",
    "address": "3785 SIXES RD, CANTON, GA, 30114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.178534,
    "lng": -84.5510068
  },
  {
    "id": "12025",
    "name": "CVS",
    "address": "625 DOVER CENTER ROAD, BAY VILLAGE, OH, 44140",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4776686,
    "lng": -81.9204439
  },
  {
    "id": "12024",
    "name": "CVS",
    "address": "989 BURNT TAVERN RD, STE #2, BRICK, NJ, 8724",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0935106,
    "lng": -74.1256935
  },
  {
    "id": "12023",
    "name": "CVS",
    "address": "191 NEW RD.,, SOMERS POINT, NJ, 8244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3317706,
    "lng": -74.5929633
  },
  {
    "id": "12022",
    "name": "CVS",
    "address": "305 WEST FOURTH STREET, BETHLEHEM, PA, 18015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.610779,
    "lng": -75.3827822
  },
  {
    "id": "12021",
    "name": "CVS",
    "address": "8 EDEN AVENUE, EDISON, NJ, 8817",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5085988,
    "lng": -74.3923763
  },
  {
    "id": "12020",
    "name": "CVS",
    "address": "11003 LEE HWY, FAIRFAX, VA, 22030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8520656,
    "lng": -77.324994
  },
  {
    "id": "12019",
    "name": "CVS",
    "address": "11240 PERRY HIGHWAY, WEXFORD, PA, 15090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6213692,
    "lng": -80.0537979
  },
  {
    "id": "12018",
    "name": "CVS",
    "address": "820 N. MAIN ST., WOODRUFF, SC, 29388",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7507113,
    "lng": -82.0467581
  },
  {
    "id": "12017",
    "name": "CVS",
    "address": "530 BURNSIDE AVENUE, INWOOD, NY, 11096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6219687,
    "lng": -73.7451195
  },
  {
    "id": "12016",
    "name": "CVS",
    "address": "778 MANOR ROAD, STATEN ISLAND, NY, 10314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.608066,
    "lng": -74.121672
  },
  {
    "id": "12015",
    "name": "CVS",
    "address": "1346 PENNSYLVANIA AVENUE, BROOKLYN, NY, 11239",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6470688,
    "lng": -73.8823845
  },
  {
    "id": "12014",
    "name": "CVS",
    "address": "375 WHITE PLAINS ROAD, EASTCHESTER, NY, 10709",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9541609,
    "lng": -73.8142446
  },
  {
    "id": "12013",
    "name": "CVS",
    "address": "224 EAST 161ST STREET, BRONX, NY, 10451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8243842,
    "lng": -73.9197242
  },
  {
    "id": "12012",
    "name": "CVS",
    "address": "532 NEPTUNE AVENUE, UNIT 1, BROOKLYN, NY, 11224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5791011,
    "lng": -73.9743022
  },
  {
    "id": "12011",
    "name": "CVS",
    "address": "215 PARK AVENUE SOUTH, NEW YORK, NY, 10003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7368375,
    "lng": -73.9883799
  },
  {
    "id": "12010",
    "name": "CVS",
    "address": "5120 HIGHWAY 153, HIXSON, TN, 37343",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1229092,
    "lng": -85.2384052
  },
  {
    "id": "12009",
    "name": "CVS",
    "address": "177 MAMMOTH ROAD, LONDONDERRY, NH, 3053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.847315,
    "lng": -71.3626752
  },
  {
    "id": "12008",
    "name": "CVS",
    "address": "2121 15TH ST. N., ARLINGTON, VA, 22201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8910064,
    "lng": -77.0850922
  },
  {
    "id": "12007",
    "name": "CVS",
    "address": "276 E. MAIN ST., DENVILLE, NJ, 7834",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8837964,
    "lng": -74.4792598
  },
  {
    "id": "12006",
    "name": "CVS",
    "address": "35-26 FRANCIS LEWIS BLVD., AUBURNDALE, NY, 11358",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7637086,
    "lng": -73.7880911
  },
  {
    "id": "12005",
    "name": "CVS",
    "address": "60 E DEUCE OF CLUBS DR., SHOW LOW, AZ, 85901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.251382,
    "lng": -110.0419419
  },
  {
    "id": "12004",
    "name": "CVS",
    "address": "219 WEST MAIN STREET, MOORESTOWN, NJ, 8057",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9623058,
    "lng": -74.9512449
  },
  {
    "id": "12003",
    "name": "CVS",
    "address": "802 LANSDOWNE AVENUE, DREXEL HILL, PA, 19026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9594903,
    "lng": -75.2882701
  },
  {
    "id": "12002",
    "name": "CVS",
    "address": "4385 HEREFORD FARM ROAD, EVANS, GA, 30809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.534118,
    "lng": -82.1308585
  },
  {
    "id": "12001",
    "name": "CVS",
    "address": "417 E EMORY ROAD, POWELL, TN, 37849",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0500963,
    "lng": -83.9982955
  },
  {
    "id": "12000",
    "name": "CVS",
    "address": "373 WILLIS AVENUE, ROSLYN HEIGHTS, NY, 11577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7800299,
    "lng": -73.6504936
  },
  {
    "id": "11999",
    "name": "CVS",
    "address": "770 EAST GLENN AVENUE, AUBURN, AL, 36830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.6082181,
    "lng": -85.4655167
  },
  {
    "id": "11998",
    "name": "CVS",
    "address": "1880 OCEAN STREET, MARSHFIELD, MA, 2050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0925023,
    "lng": -70.7044874
  },
  {
    "id": "11997",
    "name": "CVS",
    "address": "3300-10 SOUTH BROAD STREET, PHILADELPHIA, PA, 19145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9091913,
    "lng": -75.1740095
  },
  {
    "id": "11996",
    "name": "CVS",
    "address": "3335 S. FIGUEROA ST., UNIT Q, LOS ANGELES, CA, 90007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0227992,
    "lng": -118.2798382
  },
  {
    "id": "11995",
    "name": "CVS",
    "address": "15607 CHASE HILL BLVD., SAN ANTONIO, TX, 78256",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5894108,
    "lng": -98.6244427
  },
  {
    "id": "11994",
    "name": "CVS",
    "address": "451 CEDAR ROAD, MULLICA HILL, NJ, 8062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.752125,
    "lng": -75.2120335
  },
  {
    "id": "11993",
    "name": "CVS",
    "address": "130 EAST CLEVELAND ROAD, GRANGER, IN, 46530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7245566,
    "lng": -86.1752108
  },
  {
    "id": "11992",
    "name": "CVS",
    "address": "1405 N. HIGHLAND AVE., JACKSON, TN, 38301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.6368902,
    "lng": -88.8236745
  },
  {
    "id": "11991",
    "name": "CVS",
    "address": "834 PROVIDENCE STREET, WEST WARWICK, RI, 2893",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.724003,
    "lng": -71.4918556
  },
  {
    "id": "11990",
    "name": "CVS",
    "address": "410 JERICHO TURNPIKE, MINEOLA, NY, 11501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7458628,
    "lng": -73.6522757
  },
  {
    "id": "11989",
    "name": "CVS",
    "address": "8 UNION STREET, AUBURN, ME, 4210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0985128,
    "lng": -70.231841
  },
  {
    "id": "11988",
    "name": "CVS",
    "address": "2253 STATE RD., PLYMOUTH, MA, 2360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8214857,
    "lng": -70.5516859
  },
  {
    "id": "11987",
    "name": "CVS",
    "address": "3925 LINDELL BLVD., SAINT LOUIS, MO, 63108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6395131,
    "lng": -90.2420371
  },
  {
    "id": "11986",
    "name": "CVS",
    "address": "1022 W LINCOLN HWY., DEKALB, IL, 60115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9302392,
    "lng": -88.7724698
  },
  {
    "id": "11985",
    "name": "CVS",
    "address": "6150 FRANCONIA ROAD, ALEXANDRIA, VA, 22310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7817479,
    "lng": -77.1505386
  },
  {
    "id": "11984",
    "name": "CVS",
    "address": "3605 EAST WEST HIGHWAY, HYATTSVILLE, MD, 20782",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9659303,
    "lng": -76.9526936
  },
  {
    "id": "11983",
    "name": "CVS",
    "address": "3975 E. THUNDERBIRD RD., PHOENIX, AZ, 85032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6114091,
    "lng": -111.9965434
  },
  {
    "id": "11982",
    "name": "CVS",
    "address": "2020 COLUMBIA AVENUE #1, LANCASTER, PA, 17603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0385087,
    "lng": -76.3596585
  },
  {
    "id": "11981",
    "name": "CVS",
    "address": "3865 DERRY STREET, HARRISBURG, PA, 17111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2573802,
    "lng": -76.8206482
  },
  {
    "id": "11980",
    "name": "CVS",
    "address": "225 WEST PONCE DELEON AVENUE, DECATUR, GA, 30030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7758741,
    "lng": -84.2991928
  },
  {
    "id": "11979",
    "name": "CVS",
    "address": "640 FRANKLIN AVENUE, FRANKLIN SQUARE, NY, 11010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.69108,
    "lng": -73.6855352
  },
  {
    "id": "11978",
    "name": "CVS",
    "address": "4065 AMBOY ROAD, STATEN ISLAND, NY, 10308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5496668,
    "lng": -74.1523471
  },
  {
    "id": "11977",
    "name": "CVS",
    "address": "8021 WATSON RD., WEBSTER GROVES, MO, 63119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.568342,
    "lng": -90.3410475
  },
  {
    "id": "11976",
    "name": "CVS",
    "address": "10 TURNPIKE AVE., PORTSMOUTH, RI, 2871",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6012196,
    "lng": -71.2508984
  },
  {
    "id": "11975",
    "name": "CVS",
    "address": "7920 SAM FURR ROAD, HUNTERSVILLE, NC, 28078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4440492,
    "lng": -80.894026
  },
  {
    "id": "11974",
    "name": "CVS",
    "address": "800 PAMPLICO HIGHWAY, FLORENCE, SC, 29505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1581851,
    "lng": -79.7542699
  },
  {
    "id": "11973",
    "name": "CVS",
    "address": "4290 TOWNSHIP LINE RD., SCHWENKSVILLE, PA, 19473",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2339909,
    "lng": -75.4013756
  },
  {
    "id": "11972",
    "name": "CVS",
    "address": "3422 FORBES AVENUE, PITTSBURGH, PA, 15213",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4388909,
    "lng": -79.9602677
  },
  {
    "id": "11971",
    "name": "CVS",
    "address": "640 WARREN AVENUE, EAST PROVIDENCE, RI, 2914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8111639,
    "lng": -71.3574794
  },
  {
    "id": "11970",
    "name": "CVS",
    "address": "3750 STERRETTANIA ROAD, ERIE, PA, 16506",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0741477,
    "lng": -80.1445156
  },
  {
    "id": "11969",
    "name": "CVS",
    "address": "5101 DUKE STREET, ALEXANDRIA, VA, 22304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8126551,
    "lng": -77.1190778
  },
  {
    "id": "11968",
    "name": "CVS",
    "address": "14400 CLAYTON RD., BALLWIN, MO, 63011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6212523,
    "lng": -90.5237885
  },
  {
    "id": "11967",
    "name": "CVS",
    "address": "2037 STATE STREET, SCHENECTADY, NY, 12304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7745519,
    "lng": -73.8967535
  },
  {
    "id": "11966",
    "name": "CVS",
    "address": "1176 GRANBY ROAD, CHICOPEE, MA, 1020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1746336,
    "lng": -72.5875264
  },
  {
    "id": "11965",
    "name": "CVS",
    "address": "8032 C LIBERTY ROAD, FREDERICK, MD, 21701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.449291,
    "lng": -77.3864967
  },
  {
    "id": "11964",
    "name": "CVS",
    "address": "5242 CLAIRTON BOULEVARD, PITTSBURGH, PA, 15236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3431158,
    "lng": -79.9705287
  },
  {
    "id": "11963",
    "name": "CVS",
    "address": "101 WEST SHOWALTER DRIVE, GEORGETOWN, KY, 40324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1921746,
    "lng": -84.5625916
  },
  {
    "id": "11962",
    "name": "CVS",
    "address": "718 MILLS AVENUE, GREENVILLE, SC, 29605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8220357,
    "lng": -82.4158099
  },
  {
    "id": "11961",
    "name": "CVS",
    "address": "110 CARROLL STREET NW, WASHINGTON, DC, 20012",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9744876,
    "lng": -77.014569
  },
  {
    "id": "11960",
    "name": "CVS",
    "address": "3205 S. ALAMEDA ST., CORPUS CHRISTI, TX, 78404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7560662,
    "lng": -97.3903416
  },
  {
    "id": "11959",
    "name": "CVS",
    "address": "1025 CENTRAL STREET, STOUGHTON, MA, 2072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1359117,
    "lng": -71.1027949
  },
  {
    "id": "11958",
    "name": "CVS",
    "address": "1734 MAIN STREET, WEST WARWICK, RI, 2893",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6831399,
    "lng": -71.5247018
  },
  {
    "id": "11957",
    "name": "CVS",
    "address": "176 NORTH STREET, HYANNIS, MA, 2601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6525498,
    "lng": -70.2888864
  },
  {
    "id": "11956",
    "name": "CVS",
    "address": "524 STOKES ROAD, MEDFORD, NJ, 8055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8744697,
    "lng": -74.8142946
  },
  {
    "id": "11955",
    "name": "CVS",
    "address": "1760 5TH AVENUE, BAY SHORE, NY, 11706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.768712,
    "lng": -73.2614911
  },
  {
    "id": "11954",
    "name": "CVS",
    "address": "6637 ARLINGTON BLVD., FALLS CHURCH, VA, 22042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8692826,
    "lng": -77.1729156
  },
  {
    "id": "11953",
    "name": "CVS",
    "address": "401 EAST MERCURY BLVD., HAMPTON, VA, 23663",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.0266799,
    "lng": -76.3225891
  },
  {
    "id": "11952",
    "name": "CVS",
    "address": "19305 W. CATAWBA AVE. PO BOX 1364, CORNELIUS, NC, 28031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4756031,
    "lng": -80.8919947
  },
  {
    "id": "11951",
    "name": "CVS",
    "address": "2215 SOUTH SHELBY STREET, INDIANAPOLIS, IN, 46203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7370376,
    "lng": -86.1389937
  },
  {
    "id": "11950",
    "name": "CVS",
    "address": "3020 WINDWARD PLAZA, ALPHARETTA, GA, 30005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0926576,
    "lng": -84.2421211
  },
  {
    "id": "11949",
    "name": "CVS",
    "address": "159-18 ROUTE 25A, MILLER PLACE, NY, 11764",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9410944,
    "lng": -72.9987158
  },
  {
    "id": "11948",
    "name": "CVS",
    "address": "2305 GLASSBORO CROSSKEYS ROAD, WILLIAMSTOWN, NJ, 8094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7108269,
    "lng": -75.0522621
  },
  {
    "id": "11947",
    "name": "CVS",
    "address": "3 JACOBSTOWN RD, NEW EGYPT, NJ, 8533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0684179,
    "lng": -74.5351138
  },
  {
    "id": "11946",
    "name": "CVS",
    "address": "15500 BUSTLETON AVENUE, PHILADELPHIA, PA, 19116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1344628,
    "lng": -75.0100462
  },
  {
    "id": "11945",
    "name": "CVS",
    "address": "385 NORTH BROAD ST., LITITZ, PA, 17543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.165886,
    "lng": -76.3074162
  },
  {
    "id": "11944",
    "name": "CVS",
    "address": "3295 PA ROUTE 100, MACUNGIE, PA, 18062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5194314,
    "lng": -75.5666706
  },
  {
    "id": "11943",
    "name": "CVS",
    "address": "821 THE ALAMEDA, SAN JOSE, CA, 95126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3319875,
    "lng": -121.9068635
  },
  {
    "id": "11942",
    "name": "CVS",
    "address": "986 MAIN STREET, FISHKILL, NY, 12524",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5305642,
    "lng": -73.9074646
  },
  {
    "id": "11941",
    "name": "CVS",
    "address": "19701 VANOWEN ST., WINNETKA, CA, 91306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1942168,
    "lng": -118.5627453
  },
  {
    "id": "11940",
    "name": "CVS",
    "address": "729 PORTION ROAD, RONKONKOMA, NY, 11779",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8325938,
    "lng": -73.0825385
  },
  {
    "id": "11939",
    "name": "CVS",
    "address": "111 TERRY ROAD, SMITHTOWN, NY, 11787",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8508092,
    "lng": -73.1711464
  },
  {
    "id": "11938",
    "name": "CVS",
    "address": "2545 HOOPER AVE, BRICK, NJ, 8723",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0450923,
    "lng": -74.1272075
  },
  {
    "id": "11937",
    "name": "CVS",
    "address": "715 MORRISSEY BOULEVARD, DORCHESTER, MA, 2122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2973666,
    "lng": -71.0498232
  },
  {
    "id": "11936",
    "name": "CVS",
    "address": "703 GALLIVAN BOULEVARD, DORCHESTER, MA, 2124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.283249,
    "lng": -71.0474553
  },
  {
    "id": "11935",
    "name": "CVS",
    "address": "329-339 WYCKOFF AVE, RIDGEWOOD, NY, 11385",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6998307,
    "lng": -73.9110888
  },
  {
    "id": "11934",
    "name": "CVS",
    "address": "6400 LANDSDOWNE CENTER, ALEXANDRIA, VA, 22315",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7412507,
    "lng": -77.1653886
  },
  {
    "id": "11933",
    "name": "CVS",
    "address": "4310 HARDSCRABBLE ROAD, COLUMBIA, SC, 29229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1413359,
    "lng": -80.9125723
  },
  {
    "id": "11932",
    "name": "CVS",
    "address": "6900 LINDBERGH BLVD., PHILADELPHIA, PA, 19142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9108978,
    "lng": -75.2294466
  },
  {
    "id": "11931",
    "name": "CVS",
    "address": "475 FAIRLAWN PARKWAY, SADDLE BROOK, NJ, 7663",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.916027,
    "lng": -74.0998621
  },
  {
    "id": "11930",
    "name": "CVS",
    "address": "589 BERLIN CROSS KEYS ROAD, SICKLERVILLE, NJ, 8081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.73762,
    "lng": -75.0034732
  },
  {
    "id": "11929",
    "name": "CVS",
    "address": "22202 BULVERDE RD., SAN ANTONIO, TX, 78261",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6481699,
    "lng": -98.4245053
  },
  {
    "id": "11928",
    "name": "CVS",
    "address": "5674 ROUTE 115, BLAKESLEE, PA, 18610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0936041,
    "lng": -75.592175
  },
  {
    "id": "11927",
    "name": "CVS",
    "address": "250 MAMMOTH ROAD, MANCHESTER, NH, 3109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.981665,
    "lng": -71.4323108
  },
  {
    "id": "11926",
    "name": "CVS",
    "address": "137 SOUTH MAIN STREET, MILFORD, MA, 1757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1266743,
    "lng": -71.5185627
  },
  {
    "id": "11925",
    "name": "CVS",
    "address": "111 ALBANY TURNPIKE, CANTON, CT, 6019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.824759,
    "lng": -72.8856086
  },
  {
    "id": "11924",
    "name": "CVS",
    "address": "10522 SPRING GREEN BLVD., KATY, TX, 77494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7141223,
    "lng": -95.8133823
  },
  {
    "id": "11923",
    "name": "CVS",
    "address": "60 AVE LOS DOMINICOS, TOA BAJA, PR, 949",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4389251,
    "lng": -66.1771511
  },
  {
    "id": "11922",
    "name": "CVS",
    "address": "2210 LAURENS ROAD, GREENVILLE, SC, 29607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8346348,
    "lng": -82.3527756
  },
  {
    "id": "11921",
    "name": "CVS",
    "address": "2566 ASHELY RIVER ROAD RTE 21, CHARLESTON, SC, 29414",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8338193,
    "lng": -80.0443711
  },
  {
    "id": "11920",
    "name": "CVS",
    "address": "1509 ROPER MOUNTAIN ROAD, GREENVILLE, SC, 29615",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.836671,
    "lng": -82.2792486
  },
  {
    "id": "11919",
    "name": "CVS",
    "address": "8201 OXON HILL ROAD, FORT WASHINGTON, MD, 20744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7769794,
    "lng": -77.0067407
  },
  {
    "id": "11918",
    "name": "CVS",
    "address": "26 PUTNAM PIKE, JOHNSTON, RI, 2919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.859828,
    "lng": -71.489765
  },
  {
    "id": "11917",
    "name": "CVS",
    "address": "930 MAIN ST., GREEN BAY, WI, 54301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5128651,
    "lng": -88.0038179
  },
  {
    "id": "11916",
    "name": "CVS",
    "address": "1600 TOWNE LAKE PKWY, WOODSTOCK, GA, 30189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1063929,
    "lng": -84.544456
  },
  {
    "id": "11915",
    "name": "CVS",
    "address": "89 BROADWAY, GREENLAWN, NY, 11740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8673341,
    "lng": -73.3649289
  },
  {
    "id": "11914",
    "name": "CVS",
    "address": "1300 WOODLANE ROAD, EASTAMPTON, NJ, 8060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0047989,
    "lng": -74.7646575
  },
  {
    "id": "11913",
    "name": "CVS",
    "address": "2040 ROSEMONT AVE, FREDERICK, MD, 21702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4385542,
    "lng": -77.4379876
  },
  {
    "id": "11912",
    "name": "CVS",
    "address": "5304 NORTH BUFORD HIGHWAY, NORCROSS, GA, 30071",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9485346,
    "lng": -84.1981703
  },
  {
    "id": "11911",
    "name": "CVS",
    "address": "232 SMITHTOWN BOULEVARD, NESCONSET, NY, 11767",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8333745,
    "lng": -73.1486519
  },
  {
    "id": "11910",
    "name": "CVS",
    "address": "1675 YARDLEY-LANGHORNE ROAD, YARDLEY, PA, 19067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2265349,
    "lng": -74.8678368
  },
  {
    "id": "11909",
    "name": "CVS",
    "address": "7520 CITY LINE AVE., PHILADELPHIA, PA, 19151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.979683,
    "lng": -75.2697307
  },
  {
    "id": "11908",
    "name": "CVS",
    "address": "3715 UNIVERSITY BOULEVARD WEST, KENSINGTON, MD, 20895",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0336966,
    "lng": -77.07358
  },
  {
    "id": "11907",
    "name": "CVS",
    "address": "3514 MAIN ST., COVENTRY, CT, 6238",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7978456,
    "lng": -72.3688034
  },
  {
    "id": "11906",
    "name": "CVS",
    "address": "2427 MAIN STREET, ROCKY HILL, CT, 6067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6623265,
    "lng": -72.6396708
  },
  {
    "id": "11905",
    "name": "CVS",
    "address": "878 LONG POND ROAD, GREECE, NY, 14612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2388962,
    "lng": -77.6958609
  },
  {
    "id": "11904",
    "name": "CVS",
    "address": "1001 YORK RD., TOWSON, MD, 21204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4104051,
    "lng": -76.6086873
  },
  {
    "id": "11903",
    "name": "CVS",
    "address": "800 MAIN AVE, DE PERE, WI, 54115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.4504272,
    "lng": -88.0814732
  },
  {
    "id": "11902",
    "name": "CVS",
    "address": "701 WELLWOOD AVENUE, LINDENHURST, NY, 11757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7047717,
    "lng": -73.3876777
  },
  {
    "id": "11901",
    "name": "CVS",
    "address": "1239 EAST PUTNAM AVE., RIVERSIDE, CT, 6878",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0425333,
    "lng": -73.5777932
  },
  {
    "id": "11900",
    "name": "CVS",
    "address": "366 WASHINGTON STREET, SOUTH ATTLEBORO, MA, 2703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9192847,
    "lng": -71.3582143
  },
  {
    "id": "11899",
    "name": "CVS",
    "address": "4859 MACARTHUR BOULEVARD, NW, WASHINGTON, DC, 20007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9167134,
    "lng": -77.0953869
  },
  {
    "id": "11898",
    "name": "CVS",
    "address": "220 TRIANGLE ROAD, HILLSBOROUGH, NJ, 8844",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5139991,
    "lng": -74.6624577
  },
  {
    "id": "11897",
    "name": "CVS",
    "address": "1030 PUTNAM AVENUE, MARSTONS MILLS, MA, 2648",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6475767,
    "lng": -70.4241614
  },
  {
    "id": "11896",
    "name": "CVS",
    "address": "301 NORTH MAIN ST., ROCHESTER, NH, 3867",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3127424,
    "lng": -70.9935478
  },
  {
    "id": "11895",
    "name": "CVS",
    "address": "224 EAST BUTLER ROAD, MAULDIN, SC, 29662",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7840582,
    "lng": -82.2961318
  },
  {
    "id": "11894",
    "name": "CVS",
    "address": "698 FAIRVIEW ROAD, SIMPSONVILLE, SC, 29680",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.7052896,
    "lng": -82.2585419
  },
  {
    "id": "11893",
    "name": "CVS",
    "address": "821 S. BATESVILLE ROAD, GREER, SC, 29650",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.8728804,
    "lng": -82.254298
  },
  {
    "id": "11892",
    "name": "CVS",
    "address": "209 S TEMPLE ST, STARKE, FL, 32091",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.9436326,
    "lng": -82.1124993
  },
  {
    "id": "11891",
    "name": "CVS",
    "address": "2350 CHESHIRE BRIDGE ROAD, ATLANTA, GA, 30324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8191255,
    "lng": -84.3525413
  },
  {
    "id": "11890",
    "name": "CVS",
    "address": "163 ROBINSON STREET, BINGHAMTON, NY, 13904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1078881,
    "lng": -75.8892492
  },
  {
    "id": "11889",
    "name": "CVS",
    "address": "2738 N. DECATUR RD., DECATUR, GA, 30033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7931706,
    "lng": -84.2812881
  },
  {
    "id": "11888",
    "name": "CVS",
    "address": "4555 WISCONSIN AVENUE, NW, WASHINGTON, DC, 20016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9494434,
    "lng": -77.0800242
  },
  {
    "id": "11887",
    "name": "CVS",
    "address": "306 EAST BALTIMORE AVE., MEDIA, PA, 19063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.915777,
    "lng": -75.383767
  },
  {
    "id": "11886",
    "name": "CVS",
    "address": "63 CANAL STREET, MILLBURY, MA, 1527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1934227,
    "lng": -71.7548877
  },
  {
    "id": "11885",
    "name": "CVS",
    "address": "3331 GRANT AVE., PHILADELPHIA, PA, 19114",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.069241,
    "lng": -75.0060221
  },
  {
    "id": "11884",
    "name": "CVS",
    "address": "211 EAST SANDFORD BLVD., MOUNT VERNON, NY, 10550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9014566,
    "lng": -73.8262003
  },
  {
    "id": "11883",
    "name": "CVS",
    "address": "302 MAIN STREET, OXFORD, MA, 1540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1164834,
    "lng": -71.8643673
  },
  {
    "id": "11882",
    "name": "CVS",
    "address": "2320-26 FAIRMOUNT AVENUE, PHILADELPHIA, PA, 19130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9670123,
    "lng": -75.1762477
  },
  {
    "id": "11881",
    "name": "CVS",
    "address": "3071 CENTREVILLE ROAD, HERNDON, VA, 20171",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9215291,
    "lng": -77.4171102
  },
  {
    "id": "11880",
    "name": "CVS",
    "address": "2145 BELLMORE AVENUE, BELLMORE, NY, 11710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6707477,
    "lng": -73.5248561
  },
  {
    "id": "11879",
    "name": "CVS",
    "address": "150 SOUTH MAIN STREET, WEST HARTFORD, CT, 6107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7520274,
    "lng": -72.743427
  },
  {
    "id": "11878",
    "name": "CVS",
    "address": "6540 PENN AVENUE SOUTH, RICHFIELD, MN, 55423",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.884016,
    "lng": -93.3093857
  },
  {
    "id": "11877",
    "name": "CVS",
    "address": "330 GRASMERE AVE., FAIRFIELD, CT, 6824",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1569264,
    "lng": -73.2410124
  },
  {
    "id": "11876",
    "name": "CVS",
    "address": "2782 COBB PKWY NW, KENNESAW, GA, 30152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0231035,
    "lng": -84.6260829
  },
  {
    "id": "11875",
    "name": "CVS",
    "address": "929 BROADWAY, WOODMERE, NY, 11598",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6293207,
    "lng": -73.7084791
  },
  {
    "id": "11874",
    "name": "CVS",
    "address": "1396 SECOND AVENUE, NEW YORK, NY, 10021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7690179,
    "lng": -73.9579526
  },
  {
    "id": "11873",
    "name": "CVS",
    "address": "3710 MAIN STREET, BRIDGEPORT, CT, 6606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2121006,
    "lng": -73.2097691
  },
  {
    "id": "11872",
    "name": "CVS",
    "address": "2601 COLUMBIA TURNPIKE, ARLINGTON, VA, 22204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8633636,
    "lng": -77.0853607
  },
  {
    "id": "11871",
    "name": "CVS",
    "address": "8 PILGRIM HILL ROAD, PLYMOUTH, MA, 2360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9509009,
    "lng": -70.687899
  },
  {
    "id": "11870",
    "name": "CVS",
    "address": "20 BROADWAY, MASSAPEQUA, NY, 11758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6777426,
    "lng": -73.4700414
  },
  {
    "id": "11869",
    "name": "CVS",
    "address": "2660 JERUSALEM AVENUE, NORTH BELLMORE, NY, 11710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6911884,
    "lng": -73.5344736
  },
  {
    "id": "11868",
    "name": "CVS",
    "address": "620 MARKET STREET, KINGSTON, PA, 18704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2608334,
    "lng": -75.8970541
  },
  {
    "id": "11867",
    "name": "CVS",
    "address": "198 NEW HAMPSHIRE AVENUE, LAKEWOOD, NJ, 8701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0863387,
    "lng": -74.1771622
  },
  {
    "id": "11866",
    "name": "CVS",
    "address": "2614 JEFFERSON DAVIS HWY, RT1, BOX 100, STAFFORD, VA, 22554",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4490202,
    "lng": -77.4016204
  },
  {
    "id": "11865",
    "name": "CVS",
    "address": "936 HIGHLAND AVENUE, NEEDHAM, MA, 2494",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2928407,
    "lng": -71.2348453
  },
  {
    "id": "11864",
    "name": "CVS",
    "address": "137 WEST CENTRAL STREET, NATICK, MA, 1760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2830978,
    "lng": -71.3751079
  },
  {
    "id": "11863",
    "name": "CVS",
    "address": "8585 ELK GROVE BLVD, ELK GROVE, CA, 95624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4102944,
    "lng": -121.3854748
  },
  {
    "id": "11862",
    "name": "CVS",
    "address": "401 TAUNTON LAKE RD-KINGS GRANT, MARLTON, NJ, 8053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8601148,
    "lng": -74.8730994
  },
  {
    "id": "11861",
    "name": "CVS",
    "address": "1055 FARMINGTON AVENUE, KENSINGTON, CT, 6037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6310815,
    "lng": -72.7595762
  },
  {
    "id": "11860",
    "name": "CVS",
    "address": "13390 H.G. TRUEMAN RD, PO BOX 1487, SOLOMONS, MD, 20688",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3469814,
    "lng": -76.4600617
  },
  {
    "id": "11859",
    "name": "CVS",
    "address": "2281 ROUTE 33, ROBBINSVILLE, NJ, 8691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2206595,
    "lng": -74.6367876
  },
  {
    "id": "11858",
    "name": "CVS",
    "address": "1332 MAIN STREET, HELLERTOWN, PA, 18055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5884607,
    "lng": -75.3415655
  },
  {
    "id": "11857",
    "name": "CVS",
    "address": "19 EASTERN AVENUE, DEDHAM, MA, 2026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2474452,
    "lng": -71.1728405
  },
  {
    "id": "11856",
    "name": "CVS",
    "address": "43930 FARMWELL HUNT PLAZA, UNIT 140, ASHBURN, VA, 20147",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0242303,
    "lng": -77.480525
  },
  {
    "id": "11855",
    "name": "CVS",
    "address": "670 WELSH RD., HUNTINGDON VALLEY, PA, 19006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1198309,
    "lng": -75.0689172
  },
  {
    "id": "11854",
    "name": "CVS",
    "address": "5095 PEACHTREE PKWY, NORCROSS, GA, 30092",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9841807,
    "lng": -84.21417
  },
  {
    "id": "11853",
    "name": "CVS",
    "address": "479 BLUE HILLS AVE., HARTFORD, CT, 6112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7988982,
    "lng": -72.6959522
  },
  {
    "id": "11852",
    "name": "CVS",
    "address": "279 BOSTON POST RD., ORANGE, CT, 6477",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2674301,
    "lng": -73.0016906
  },
  {
    "id": "11851",
    "name": "CVS",
    "address": "1740 BROADWAY, HEWLETT, NY, 11557",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.647971,
    "lng": -73.6888919
  },
  {
    "id": "11850",
    "name": "CVS",
    "address": "71 SPRINGSIDE ROAD, WESTAMPTON, NJ, 8060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0232441,
    "lng": -74.8572009
  },
  {
    "id": "11849",
    "name": "CVS",
    "address": "18-35 RIVER RD, FAIR LAWN, NJ, 7410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9404217,
    "lng": -74.141888
  },
  {
    "id": "11848",
    "name": "CVS",
    "address": "255 US HIGHWAY 46, BUDD LAKE, NJ, 7828",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8678914,
    "lng": -74.7393828
  },
  {
    "id": "11847",
    "name": "CVS",
    "address": "2014 POWERS FERRY RD. SE STE 100, ATLANTA, GA, 30339",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9032691,
    "lng": -84.4604592
  },
  {
    "id": "11846",
    "name": "CVS",
    "address": "3439 ASHFORD DUNWOODY ROAD, NE, BROOKHAVEN, GA, 30319",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8908675,
    "lng": -84.3242928
  },
  {
    "id": "11845",
    "name": "CVS",
    "address": "1943 PEACHTREE RD NE, ATLANTA, GA, 30309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.807866,
    "lng": -84.3932259
  },
  {
    "id": "11844",
    "name": "CVS",
    "address": "8430 HOLCOMB BRIDGE RD,, ALPHARETTA, GA, 30022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.9851602,
    "lng": -84.2701875
  },
  {
    "id": "11843",
    "name": "CVS",
    "address": "202 S. HIGHLAND AVE., OSSINING, NY, 10562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1452106,
    "lng": -73.8618461
  },
  {
    "id": "11842",
    "name": "CVS",
    "address": "1901 WEST OREGON AVENUE, PHILADELPHIA, PA, 19145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9182896,
    "lng": -75.1807023
  },
  {
    "id": "11841",
    "name": "CVS",
    "address": "4133 G ST., PHILADELPHIA, PA, 19124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0115579,
    "lng": -75.1117563
  },
  {
    "id": "11840",
    "name": "CVS",
    "address": "944 MERRICK ROAD, BALDWIN, NY, 11510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6509303,
    "lng": -73.6070283
  },
  {
    "id": "11839",
    "name": "CVS",
    "address": "120 LAKEHILL RD., BURNT HILLS, NY, 12027",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9106577,
    "lng": -73.8988313
  },
  {
    "id": "11838",
    "name": "CVS",
    "address": "400 BEECH ST., HOLYOKE, MA, 1040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2023731,
    "lng": -72.6196444
  },
  {
    "id": "11837",
    "name": "CVS",
    "address": "4625 FALLS ROAD, BALTIMORE, MD, 21209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3452049,
    "lng": -76.6402031
  },
  {
    "id": "11836",
    "name": "CVS",
    "address": "11 MAIN ST., LAKEVILLE, MA, 2347",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8781934,
    "lng": -70.9245399
  },
  {
    "id": "11835",
    "name": "CVS",
    "address": "107 EAST FIRST AVENUE, ROSELLE, NJ, 7203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6604791,
    "lng": -74.263691
  },
  {
    "id": "11834",
    "name": "CVS",
    "address": "7292 FULTON DR, NW, CANTON, OH, 44718",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8599817,
    "lng": -81.4844389
  },
  {
    "id": "11833",
    "name": "CVS",
    "address": "85-29 126TH STREET, KEW GARDENS, NY, 11415",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7034473,
    "lng": -73.8245129
  },
  {
    "id": "11832",
    "name": "CVS",
    "address": "1797 DUTCH BROADWAY, ELMONT, NY, 11003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6895959,
    "lng": -73.7094446
  },
  {
    "id": "11831",
    "name": "CVS",
    "address": "1012 LITTLE EAST NECK ROAD, WEST BABYLON, NY, 11704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.723515,
    "lng": -73.3590341
  },
  {
    "id": "11830",
    "name": "CVS",
    "address": "100-02 QUEENS BOULEVARD, FOREST HILLS, NY, 11375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7265616,
    "lng": -73.8537602
  },
  {
    "id": "11829",
    "name": "CVS",
    "address": "136 NAHATAN ST., NORWOOD, MA, 2062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1914705,
    "lng": -71.1962327
  },
  {
    "id": "11828",
    "name": "CVS",
    "address": "3491 MERRICK RD, PARK PLAZA, WANTAGH, NY, 11793",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6654322,
    "lng": -73.5018918
  },
  {
    "id": "11827",
    "name": "CVS",
    "address": "250 GLENWOOD AVENUE, BLOOMFIELD, NJ, 7003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7913592,
    "lng": -74.2005524
  },
  {
    "id": "11826",
    "name": "CVS",
    "address": "PROV. PLACE MALL #1010, 39 PROVIDENCE PL, PROVIDENCE, RI, 2903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8284894,
    "lng": -71.4154379
  },
  {
    "id": "11825",
    "name": "CVS",
    "address": "1068 PUTNAM PIKE, PO BOX H, GLOCESTER, RI, 2814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.907291,
    "lng": -71.6665473
  },
  {
    "id": "11824",
    "name": "CVS",
    "address": "660 COLUMBUS AVE, ROSE HILL S/C, THORNWOOD, NY, 10594",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1143991,
    "lng": -73.7698952
  },
  {
    "id": "11823",
    "name": "CVS",
    "address": "2911 EAST JOPPA RD, PARKVILLE, MD, 21234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3949147,
    "lng": -76.5248218
  },
  {
    "id": "11822",
    "name": "CVS",
    "address": "254 HILLSIDE AVENUE, WILLISTON PARK, NY, 11596",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7550289,
    "lng": -73.6495278
  },
  {
    "id": "11821",
    "name": "CVS",
    "address": "3300A CENTENNIAL LANE, ELLICOTT CITY, MD, 21042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2787271,
    "lng": -76.8616544
  },
  {
    "id": "11820",
    "name": "CVS",
    "address": "977 JERICHO TURNPIKE, SMITHTOWN, NY, 11787",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8489293,
    "lng": -73.2486613
  },
  {
    "id": "11819",
    "name": "CVS",
    "address": "1200 WEST MAIN STREET, NORRISTOWN, PA, 19401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1216139,
    "lng": -75.3602104
  },
  {
    "id": "11818",
    "name": "CVS",
    "address": "14 HIGHWAY 36 W, HAZLET TOWNSHIP, NJ, 7734",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4351235,
    "lng": -74.1318411
  },
  {
    "id": "11817",
    "name": "CVS",
    "address": "216 HENRY STREET, HEMPSTEAD, NY, 11550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7003859,
    "lng": -73.6145261
  },
  {
    "id": "11816",
    "name": "CVS",
    "address": "251-21 JAMAICA AVE., BELLEROSE, NY, 11426",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7276444,
    "lng": -73.713621
  },
  {
    "id": "11815",
    "name": "CVS",
    "address": "1011 MORRIS AVENUE, UNION, NJ, 7083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6828358,
    "lng": -74.2363301
  },
  {
    "id": "11814",
    "name": "CVS",
    "address": "281 MIDLAND AVENUE, GARFIELD, NJ, 7026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8746159,
    "lng": -74.1044505
  },
  {
    "id": "11813",
    "name": "CVS",
    "address": "6110 LANDIS AVE, ACME S/C, SEA ISLE CITY, NJ, 8243",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1418919,
    "lng": -74.7024761
  },
  {
    "id": "11812",
    "name": "CVS",
    "address": "163 MOUNTAIN RD,, SUFFIELD, CT, 6078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9829175,
    "lng": -72.6567855
  },
  {
    "id": "11811",
    "name": "CVS",
    "address": "205 ATWOOD AVENUE, CRANSTON, RI, 2920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7816075,
    "lng": -71.4719441
  },
  {
    "id": "11810",
    "name": "CVS",
    "address": "5515 ASHLAND COMMUNITY SQUARE, MANASSAS, VA, 20112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6123324,
    "lng": -77.3714698
  },
  {
    "id": "11809",
    "name": "CVS",
    "address": "540 WEST MAIN STREET, MERIDEN, CT, 6451",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5402515,
    "lng": -72.8222372
  },
  {
    "id": "11808",
    "name": "CVS",
    "address": "1252 BOUND BROOK RD, CVS PLAZA, MIDDLESEX, NJ, 8846",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5796537,
    "lng": -74.501512
  },
  {
    "id": "11807",
    "name": "CVS",
    "address": "5910 GREENBELT ROAD, GREENBELT, MD, 20770",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9985941,
    "lng": -76.9132119
  },
  {
    "id": "11806",
    "name": "CVS",
    "address": "7 WEST MAIN STREET, FREEHOLD, NJ, 7728",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2600547,
    "lng": -74.2751059
  },
  {
    "id": "11805",
    "name": "CVS",
    "address": "139 MYRTLE AVENUE, WEST CAPE MAY, NJ, 8204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.935286,
    "lng": -74.9285952
  },
  {
    "id": "11804",
    "name": "CVS",
    "address": "1102 ANNAPOLIS RD., ODENTON, MD, 21113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0791661,
    "lng": -76.6841772
  },
  {
    "id": "11803",
    "name": "CVS",
    "address": "12890 TOUCHSTONE CIRCLE, WOODBRIDGE, VA, 22192",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.675123,
    "lng": -77.3317694
  },
  {
    "id": "11802",
    "name": "CVS",
    "address": "3120 DUKE ST,, ALEXANDRIA, VA, 22314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8073166,
    "lng": -77.0842816
  },
  {
    "id": "11801",
    "name": "CVS",
    "address": "2525 CENTREVILLE RD, MCNAIR FARMS S/C, HERNDON, VA, 20171",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9492972,
    "lng": -77.4108586
  },
  {
    "id": "11800",
    "name": "CVS",
    "address": "5870 SILVER HILL RD, SILVER HILL PLAZA, DISTRICT HEIGHTS, MD, 20747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8573056,
    "lng": -76.9060525
  },
  {
    "id": "11799",
    "name": "CVS",
    "address": "3117 LOCKHEED BLVD., ALEXANDRIA, VA, 22306",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7586989,
    "lng": -77.084956
  },
  {
    "id": "11798",
    "name": "CVS",
    "address": "2328 PLAINFIELD AVENUE, SOUTH PLAINFIELD, NJ, 7080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5867994,
    "lng": -74.4194948
  },
  {
    "id": "11797",
    "name": "CVS",
    "address": "10 S. BEDFORD RD., MOUNT KISCO, NY, 10549",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1962682,
    "lng": -73.7239728
  },
  {
    "id": "11796",
    "name": "CVS",
    "address": "24950 FRANZ RD., KATY, TX, 77493",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8022826,
    "lng": -95.8013549
  },
  {
    "id": "11795",
    "name": "CVS",
    "address": "24795 PINEBROOK RD, SOUTH RIDING, VA, 20152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9322245,
    "lng": -77.5285765
  },
  {
    "id": "11794",
    "name": "CVS",
    "address": "11120 PATTERSON AVENUE, RICHMOND, VA, 23238",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5978394,
    "lng": -77.6166294
  },
  {
    "id": "11793",
    "name": "CVS",
    "address": "3514 WEST CARY STREET, RICHMOND, VA, 23221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5562297,
    "lng": -77.486548
  },
  {
    "id": "11792",
    "name": "CVS",
    "address": "1938 WEST MAIN STREET, STAMFORD, CT, 6902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0484099,
    "lng": -73.5624955
  },
  {
    "id": "11791",
    "name": "CVS",
    "address": "701 PORTOLA DR., SAN FRANCISCO, CA, 94127",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.7441654,
    "lng": -122.4532259
  },
  {
    "id": "11790",
    "name": "CVS",
    "address": "5100 S LABURNUM AVE, RICHMOND, VA, 23231",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5167864,
    "lng": -77.3505035
  },
  {
    "id": "11789",
    "name": "CVS",
    "address": "7023 THREE CHOPT ROAD, RICHMOND, VA, 23226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5905037,
    "lng": -77.5327866
  },
  {
    "id": "11788",
    "name": "CVS",
    "address": "8900 PATTERSON AVENUE, RICHMOND, VA, 23229",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5956058,
    "lng": -77.5736976
  },
  {
    "id": "11787",
    "name": "CVS",
    "address": "369 MAIN STREET, EAST HAVEN, CT, 6512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2802694,
    "lng": -72.8754093
  },
  {
    "id": "11786",
    "name": "CVS",
    "address": "1057 BOSTON POST ROAD,, GUILFORD, CT, 6437",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2877831,
    "lng": -72.6842314
  },
  {
    "id": "11785",
    "name": "CVS",
    "address": "7200 W. CERMAK RD., NORTH RIVERSIDE, IL, 60546",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8508232,
    "lng": -87.804374
  },
  {
    "id": "11784",
    "name": "CVS",
    "address": "510 MIDDLE NECK ROAD, GREAT NECK, NY, 11023",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8002981,
    "lng": -73.7346384
  },
  {
    "id": "11783",
    "name": "CVS",
    "address": "11680 PLAZA AMERICA DR., RESTON, VA, 20190",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9524053,
    "lng": -77.3491123
  },
  {
    "id": "11782",
    "name": "CVS",
    "address": "1279 WEST MAIN STREET, WATERBURY, CT, 6708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5514607,
    "lng": -73.063891
  },
  {
    "id": "11781",
    "name": "CVS",
    "address": "4760 BOSTON POST ROAD, PELHAM MANOR, NY, 10803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8960222,
    "lng": -73.8046862
  },
  {
    "id": "11780",
    "name": "CVS",
    "address": "55 COLD SPRING ROAD, SYOSSET, NY, 11791",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8266731,
    "lng": -73.5007872
  },
  {
    "id": "11779",
    "name": "CVS",
    "address": "514 PARK AVE, SCOTCH PLAINS CENTER, SCOTCH PLAINS, NJ, 7076",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6490598,
    "lng": -74.3965451
  },
  {
    "id": "11778",
    "name": "CVS",
    "address": "132-22 14TH AVENUE, COLLEGE POINT, NY, 11356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7857528,
    "lng": -73.8357264
  },
  {
    "id": "11777",
    "name": "CVS",
    "address": "86 SOUTH STREET, HINGHAM, MA, 2043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2411556,
    "lng": -70.8908213
  },
  {
    "id": "11776",
    "name": "CVS",
    "address": "17 EAST JERICHO TURNPIKE, MINEOLA, NY, 11501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7509168,
    "lng": -73.6342124
  },
  {
    "id": "11775",
    "name": "CVS",
    "address": "1103 NORTH ST,, ENDICOTT, NY, 13760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1046791,
    "lng": -76.0502963
  },
  {
    "id": "11774",
    "name": "CVS",
    "address": "825 CONNETQUOT AVE, TERRRACE PLAZA, ISLIP TERRACE, NY, 11752",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7640273,
    "lng": -73.1725291
  },
  {
    "id": "11773",
    "name": "CVS",
    "address": "1310 BOSTON POST RD, FERNDALE S/C, LARCHMONT, NY, 10538",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9370623,
    "lng": -73.7475559
  },
  {
    "id": "11772",
    "name": "CVS",
    "address": "16 EAST AFTON AVE., CRAMER CENTER, YARDLEY, PA, 19067",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.243135,
    "lng": -74.8384222
  },
  {
    "id": "11771",
    "name": "CVS",
    "address": "610 WEST MAIN ST., FREEHOLD, NJ, 7728",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2381996,
    "lng": -74.3065963
  },
  {
    "id": "11770",
    "name": "CVS",
    "address": "413 RR 1, RTE 611, TANNERSVILLE, PA, 18372",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.039943,
    "lng": -75.3065187
  },
  {
    "id": "11769",
    "name": "CVS",
    "address": "511 MONROE TURNPIKE, MONROE, CT, 6468",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.317145,
    "lng": -73.2163705
  },
  {
    "id": "11768",
    "name": "CVS",
    "address": "585 YONKERS AVENUE, YONKERS, NY, 10704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9275852,
    "lng": -73.8699776
  },
  {
    "id": "11767",
    "name": "CVS",
    "address": "419 S OYSTER BAY RD, WOODBURY PLZ S/C, PLAINVIEW, NY, 11803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7818439,
    "lng": -73.5014776
  },
  {
    "id": "11766",
    "name": "CVS",
    "address": "2419 HEMPSTEAD TPKE., EAST MEADOW, NY, 11554",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7254078,
    "lng": -73.5458853
  },
  {
    "id": "11765",
    "name": "CVS",
    "address": "ONE GUSSACK PLAZA CENTER, GREAT NECK, NY, 11021",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7880536,
    "lng": -73.7299355
  },
  {
    "id": "11764",
    "name": "CVS",
    "address": "2151 JOHNSTON PLACE, MERRICK MALL S/C, MERRICK, NY, 11566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6660572,
    "lng": -73.5515032
  },
  {
    "id": "11763",
    "name": "CVS",
    "address": "635 LEXINGTON AVE., CLIFTON, NJ, 7011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8827469,
    "lng": -74.1342472
  },
  {
    "id": "11762",
    "name": "CVS",
    "address": "137 ROUTE 22 EAST, GREEN BROOK, NJ, 8812",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6033683,
    "lng": -74.4743145
  },
  {
    "id": "11761",
    "name": "CVS",
    "address": "1259 ROUTE 332, FARMINGTON, NY, 14425",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9751554,
    "lng": -77.3548728
  },
  {
    "id": "11760",
    "name": "CVS",
    "address": "3100 SHILLINGTON RD, SINKING SPRING, PA, 19608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3209963,
    "lng": -76.01063
  },
  {
    "id": "11759",
    "name": "CVS",
    "address": "1310 YORK RD., GETTYSBURG, PA, 17325",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8422656,
    "lng": -77.2011729
  },
  {
    "id": "11758",
    "name": "CVS",
    "address": "815 N. FRONT ST., PHILIPSBURG, PA, 16866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9020953,
    "lng": -78.2293688
  },
  {
    "id": "11757",
    "name": "CVS",
    "address": "1760 QUENTIN RD, CEDAR CREST SQUARE, LEBANON, PA, 17042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3112679,
    "lng": -76.4231356
  },
  {
    "id": "11756",
    "name": "CVS",
    "address": "1968 BLACK ROCK TURNPIKE, FAIRWAY PLAZA, FAIRFIELD, CT, 6825",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1812962,
    "lng": -73.2493524
  },
  {
    "id": "11755",
    "name": "CVS",
    "address": "260 NORTH MAIN STREET, MANCHESTER, CT, 6042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7944693,
    "lng": -72.5267219
  },
  {
    "id": "11754",
    "name": "CVS",
    "address": "6480 OLD WATERLOO RD, ELKRIDGE, MD, 21075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1924631,
    "lng": -76.7941952
  },
  {
    "id": "11753",
    "name": "CVS",
    "address": "327 WOODLAWN AVENUE, BETHLEHEM, PA, 18018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6335275,
    "lng": -75.3678787
  },
  {
    "id": "11752",
    "name": "CVS",
    "address": "105 WEST MAIN ST,, WEST SAYVILLE, NY, 11796",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7281265,
    "lng": -73.0964051
  },
  {
    "id": "11751",
    "name": "CVS",
    "address": "824 PARK AVE, BLOOMFIELD, CT, 6002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8299523,
    "lng": -72.7341454
  },
  {
    "id": "11750",
    "name": "CVS",
    "address": "35 N. MAIN ST., BANGOR, PA, 18013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8678337,
    "lng": -75.2038732
  },
  {
    "id": "11749",
    "name": "CVS",
    "address": "218 HANOVER STREET, BOSTON, MA, 2113",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3630915,
    "lng": -71.0555571
  },
  {
    "id": "11748",
    "name": "CVS",
    "address": "65 BOSTON ST.,, LYNN, MA, 1904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4774659,
    "lng": -70.9576373
  },
  {
    "id": "11747",
    "name": "CVS",
    "address": "486 PLEASANT STREET, ATTLEBORO, MA, 2703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9524719,
    "lng": -71.2716847
  },
  {
    "id": "11746",
    "name": "CVS",
    "address": "2040 WESTERN AVENUE, ROUTE 155, ALBANY, NY, 12203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6970358,
    "lng": -73.8876178
  },
  {
    "id": "11745",
    "name": "CVS",
    "address": "64 SOUTH LOCUST ST.,, HAZLETON, PA, 18201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9538309,
    "lng": -75.9812471
  },
  {
    "id": "11744",
    "name": "CVS",
    "address": "299 WASHINGTON STREET, WESTWOOD, MA, 2090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2191219,
    "lng": -71.1883774
  },
  {
    "id": "11743",
    "name": "CVS",
    "address": "425 LOWELL AVE., HAVERHILL, MA, 1832",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7736733,
    "lng": -71.1165358
  },
  {
    "id": "11742",
    "name": "CVS",
    "address": "10 MEETING HOUSE ROAD, LITTLETON, MA, 1460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5465948,
    "lng": -71.4709827
  },
  {
    "id": "11741",
    "name": "CVS",
    "address": "10095 WARD RD, DUNKIRK MARKETPLACE, DUNKIRK, MD, 20754",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7184251,
    "lng": -76.659455
  },
  {
    "id": "11740",
    "name": "CVS",
    "address": "12825 WISTERIA DR, GERMANTOWN, MD, 20874",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1771248,
    "lng": -77.268936
  },
  {
    "id": "11739",
    "name": "CVS",
    "address": "12 QUEEN ANNE RD., CHATHAM, MA, 2633",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6846929,
    "lng": -69.9680147
  },
  {
    "id": "11738",
    "name": "CVS",
    "address": "35 W. MAIN ST., NORTON, MA, 2766",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9651588,
    "lng": -71.1908259
  },
  {
    "id": "11737",
    "name": "CVS",
    "address": "900 COMMONWEALTH AVENUE, BOSTON, MA, 2215",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3508882,
    "lng": -71.1160043
  },
  {
    "id": "11736",
    "name": "CVS",
    "address": "414 UNION ST., ASHLAND, MA, 1721",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2546618,
    "lng": -71.4661594
  },
  {
    "id": "11735",
    "name": "CVS",
    "address": "325 BOSTON POST RD. RTE 20, WAYLAND, MA, 1778",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3628851,
    "lng": -71.3664307
  },
  {
    "id": "11734",
    "name": "CVS",
    "address": "435 WEST CENTRAL STREET, FRANKLIN, MA, 2038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0886619,
    "lng": -71.41514
  },
  {
    "id": "11733",
    "name": "CVS",
    "address": "1280 WORCESTER RD., FRAMINGHAM, MA, 1702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2972503,
    "lng": -71.4496485
  },
  {
    "id": "11732",
    "name": "CVS",
    "address": "419 EAST FALMOUTH HWY., EAST FALMOUTH, MA, 2536",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5777558,
    "lng": -70.5585649
  },
  {
    "id": "11731",
    "name": "CVS",
    "address": "1080 FALMOUTH RD., HYANNIS, MA, 2601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6596928,
    "lng": -70.3270019
  },
  {
    "id": "11730",
    "name": "CVS",
    "address": "67 CENTRAL ST., FOXBOROUGH, MA, 2035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0625547,
    "lng": -71.2486744
  },
  {
    "id": "11729",
    "name": "CVS",
    "address": "517 STATE RD., PLYMOUTH, MA, 2360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9233316,
    "lng": -70.5694873
  },
  {
    "id": "11728",
    "name": "CVS",
    "address": "261 CHAUNCY STREET, MANSFIELD, MA, 2048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0310169,
    "lng": -71.2307151
  },
  {
    "id": "11727",
    "name": "CVS",
    "address": "155 CENTER ST., PEMBROKE, MA, 2359",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0678793,
    "lng": -70.8108681
  },
  {
    "id": "11726",
    "name": "CVS",
    "address": "191 N. MAIN ST., ATTLEBORO, MA, 2703",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9495088,
    "lng": -71.2887541
  },
  {
    "id": "11725",
    "name": "CVS",
    "address": "3800 TAMIAMI TRL SOUTH, SARASOTA, FL, 34239",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.3002942,
    "lng": -82.5321145
  },
  {
    "id": "11724",
    "name": "CVS",
    "address": "101 CENTRAL STREET, HOLLISTON, MA, 1746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1997366,
    "lng": -71.4259938
  },
  {
    "id": "11723",
    "name": "CVS",
    "address": "148 ROUTE 137, HARWICH, MA, 2645",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.708258,
    "lng": -70.0238435
  },
  {
    "id": "11722",
    "name": "CVS",
    "address": "7430 SW ARCHER RD., GAINESVILLE, FL, 32608",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5994278,
    "lng": -82.4217075
  },
  {
    "id": "11721",
    "name": "CVS",
    "address": "100 FRONT ST, HARBOR MALL, SCITUATE, MA, 2066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1946114,
    "lng": -70.7249316
  },
  {
    "id": "11720",
    "name": "CVS",
    "address": "67D MAIN ST., MEDWAY, MA, 2053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1520614,
    "lng": -71.4070456
  },
  {
    "id": "11719",
    "name": "CVS",
    "address": "774 WATER STREET, FRAMINGHAM, MA, 1701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3290287,
    "lng": -71.4335046
  },
  {
    "id": "11718",
    "name": "CVS",
    "address": "264 TRAPELO RD., BELMONT, MA, 2478",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3831554,
    "lng": -71.1813343
  },
  {
    "id": "11717",
    "name": "CVS",
    "address": "264 CEDAR LANE, SE, CEDAR PARK & SHOP, VIENNA, VA, 22180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8880023,
    "lng": -77.2438259
  },
  {
    "id": "11716",
    "name": "CVS",
    "address": "454 ELECTRIC AVE., LUNENBURG, MA, 1462",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5752954,
    "lng": -71.7488994
  },
  {
    "id": "11715",
    "name": "CVS",
    "address": "2000 M STREET NW, WASHINGTON, DC, 20036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9051637,
    "lng": -77.0453824
  },
  {
    "id": "11714",
    "name": "CVS",
    "address": "1990 K STREET NW, WASHINGTON, DC, 20006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.902316,
    "lng": -77.0444673
  },
  {
    "id": "11713",
    "name": "CVS",
    "address": "503 NORTHWEST DRIVE, FARMINGDALE, NY, 11735",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7186816,
    "lng": -73.4575669
  },
  {
    "id": "11712",
    "name": "CVS",
    "address": "13620 GENITO ROAD, MIDLOTHIAN, VA, 23112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4507471,
    "lng": -77.6507771
  },
  {
    "id": "11711",
    "name": "CVS",
    "address": "4238 WILSON BLVD/BALLSTON COMMONS #1831, ARLINGTON, VA, 22203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8788499,
    "lng": -77.1104986
  },
  {
    "id": "11710",
    "name": "CVS",
    "address": "4338 DALE BLVD., DALE CITY, VA, 22193",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.647764,
    "lng": -77.3388585
  },
  {
    "id": "11709",
    "name": "CVS",
    "address": "972 E. LITTLE CREEK RD., NORFOLK, VA, 23518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.9152892,
    "lng": -76.2423901
  },
  {
    "id": "11708",
    "name": "CVS",
    "address": "5040 LAGUNA BLVD, ELK GROVE, CA, 95758",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4220128,
    "lng": -121.4468678
  },
  {
    "id": "11707",
    "name": "CVS",
    "address": "5405 SUMMERVILLE RD, PHENIX CITY, AL, 36867",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.519959,
    "lng": -85.0293142
  },
  {
    "id": "11706",
    "name": "CVS",
    "address": "1690 S FEDERAL HWY, DELRAY BEACH, FL, 33483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4416596,
    "lng": -80.0706484
  },
  {
    "id": "11705",
    "name": "CVS",
    "address": "13697 W. COLONIAL DR., WINTER GARDEN, FL, 34787",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5516285,
    "lng": -81.5866749
  },
  {
    "id": "11704",
    "name": "CVS",
    "address": "5296 TAMIAMI TRL N, NAPLES, FL, 34103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2105071,
    "lng": -81.7998036
  },
  {
    "id": "11703",
    "name": "CVS",
    "address": "4354 NW 23RD AVE, GAINESVILLE, FL, 32606",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.6744538,
    "lng": -82.3895102
  },
  {
    "id": "11702",
    "name": "CVS",
    "address": "3932 COTTAGE HILL RD., MOBILE, AL, 36609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.6537389,
    "lng": -88.1394326
  },
  {
    "id": "11701",
    "name": "CVS",
    "address": "1504 S 3RD ST, JACKSONVILLE BEACH, FL, 32250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2737945,
    "lng": -81.3893636
  },
  {
    "id": "11700",
    "name": "CVS",
    "address": "1350 LEE BLVD, LEHIGH ACRES, FL, 33936",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6150424,
    "lng": -81.6538061
  },
  {
    "id": "11699",
    "name": "CVS",
    "address": "1300 SOUTH MCKENZIE ST, FOLEY, AL, 36535",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3917879,
    "lng": -87.6841926
  },
  {
    "id": "11698",
    "name": "CVS",
    "address": "675 TRANCAS ST, NAPA, CA, 94558",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3238335,
    "lng": -122.287536
  },
  {
    "id": "11697",
    "name": "CVS",
    "address": "2 W. CENTER ST., WEST BRIDGEWATER, MA, 2379",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0187737,
    "lng": -71.0083835
  },
  {
    "id": "11696",
    "name": "CVS",
    "address": "9972 LIBERIA AVE, DAVIS FORD CROSSING, MANASSAS, VA, 20110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7415659,
    "lng": -77.4533006
  },
  {
    "id": "11695",
    "name": "CVS",
    "address": "19594 FISHER AVE., POOLESVILLE, MD, 20837",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1435086,
    "lng": -77.4090349
  },
  {
    "id": "11694",
    "name": "CVS",
    "address": "4200 ALTAMONT PL., WHITE PLAINS, MD, 20695",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5964918,
    "lng": -76.9388292
  },
  {
    "id": "11693",
    "name": "CVS",
    "address": "5100 BROWN STATION ROAD, UPPER MARLBORO, MD, 20772",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8198074,
    "lng": -76.7637332
  },
  {
    "id": "11692",
    "name": "CVS",
    "address": "4201 E. PARK AVE., PLANO, TX, 75074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0321703,
    "lng": -96.6471925
  },
  {
    "id": "11691",
    "name": "CVS",
    "address": "156 HENRY STREET, BROOKLYN, NY, 11201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6960392,
    "lng": -73.9939159
  },
  {
    "id": "11690",
    "name": "CVS",
    "address": "4950 FREEMANSBURG AVE., EASTON, PA, 18045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6489231,
    "lng": -75.299579
  },
  {
    "id": "11689",
    "name": "CVS",
    "address": "266 BROADWAY, LAWRENCE, MA, 1841",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7085339,
    "lng": -71.1719122
  },
  {
    "id": "11688",
    "name": "CVS",
    "address": "2 DON CONNOR BLVD., JACKSON, NJ, 8527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1114793,
    "lng": -74.3534997
  },
  {
    "id": "11687",
    "name": "CVS",
    "address": "633 MERRICK RD., LYNBROOK, NY, 11563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6612954,
    "lng": -73.6846155
  },
  {
    "id": "11686",
    "name": "CVS",
    "address": "1103 ROUTE 46, LEDGEWOOD, NJ, 7852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8799849,
    "lng": -74.6436114
  },
  {
    "id": "11685",
    "name": "CVS",
    "address": "3883 E. FOOTHILL BLVD (NWC), PASADENA, CA, 91107",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1506003,
    "lng": -118.0683924
  },
  {
    "id": "11684",
    "name": "CVS",
    "address": "2730 COUNTY ROAD E, WHITE BEAR LAKE, MN, 55110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0496896,
    "lng": -92.985744
  },
  {
    "id": "11683",
    "name": "CVS",
    "address": "1058 HOPE STREET, STAMFORD, CT, 6907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.094548,
    "lng": -73.519748
  },
  {
    "id": "11682",
    "name": "CVS",
    "address": "9551 W. 171ST ST., TINLEY PARK, IL, 60487",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5794419,
    "lng": -87.8509471
  },
  {
    "id": "11681",
    "name": "CVS",
    "address": "906 W. LEESPORT RD., LEESPORT, PA, 19533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3897727,
    "lng": -75.9966996
  },
  {
    "id": "11680",
    "name": "CVS",
    "address": "25511 MUIRLANDS BLVD., MISSION VIEJO, CA, 92691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6093622,
    "lng": -117.6856049
  },
  {
    "id": "11679",
    "name": "CVS",
    "address": "54-06 31ST AVENUE, WOODSIDE, NY, 11377",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7568225,
    "lng": -73.9070017
  },
  {
    "id": "11678",
    "name": "CVS",
    "address": "5408 WHITTAKER RD., YPSILANTI, MI, 48197",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.20918,
    "lng": -83.6196277
  },
  {
    "id": "11677",
    "name": "CVS",
    "address": "8467 E. MAIN ST., REYNOLDSBURG, OH, 43068",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9552165,
    "lng": -82.7723822
  },
  {
    "id": "11676",
    "name": "CVS",
    "address": "15010 MEMORIAL DR., HOUSTON, TX, 77079",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.7787789,
    "lng": -95.6187768
  },
  {
    "id": "11675",
    "name": "CVS",
    "address": "7575 OSCEOLA POLK LINE RD., DAVENPORT, FL, 33896",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.2604112,
    "lng": -81.5900586
  },
  {
    "id": "11674",
    "name": "CVS",
    "address": "2150 EAGLE CREEK LN., WOODBURY, MN, 55129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.917959,
    "lng": -92.9025392
  },
  {
    "id": "11673",
    "name": "CVS",
    "address": "2901 WESLEY CHAPEL STOUTS RD., MONROE, NC, 28110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0483422,
    "lng": -80.645438
  },
  {
    "id": "11672",
    "name": "CVS",
    "address": "6360 HOADLY RD., MANASSAS, VA, 20112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6732461,
    "lng": -77.3960489
  },
  {
    "id": "11671",
    "name": "CVS",
    "address": "3811 NESHAMINY BLVD., BENSALEM, PA, 19020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1353972,
    "lng": -74.9547983
  },
  {
    "id": "11670",
    "name": "CVS",
    "address": "21201 EAST OCOTILLO RD.,, QUEEN CREEK, AZ, 85142",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.2479347,
    "lng": -111.6255789
  },
  {
    "id": "11669",
    "name": "CVS",
    "address": "1630 SOUTH ATHERTON ST., STATE COLLEGE, PA, 16801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.784647,
    "lng": -77.8358794
  },
  {
    "id": "11668",
    "name": "CVS",
    "address": "404 N. LOGAN BLVD., BURNHAM, PA, 17009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6324025,
    "lng": -77.5712108
  },
  {
    "id": "11667",
    "name": "CVS",
    "address": "3035 PARK PLACE, CLEARFIELD, PA, 16830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0269414,
    "lng": -78.4365591
  },
  {
    "id": "11666",
    "name": "CVS",
    "address": "311 BELLEFONTE AVE,, LOCK HAVEN, PA, 17745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1354368,
    "lng": -77.4523593
  },
  {
    "id": "11665",
    "name": "CVS",
    "address": "700 MAIN STREET, CLARION, PA, 16214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.213148,
    "lng": -79.3820791
  },
  {
    "id": "11664",
    "name": "CVS",
    "address": "33 E MARKET STREET, LEWISTOWN, PA, 17044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5984254,
    "lng": -77.5738534
  },
  {
    "id": "11663",
    "name": "CVS",
    "address": "1278 MILLERSVILLE PIKE, LANCASTER, PA, 17603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0264119,
    "lng": -76.3257101
  },
  {
    "id": "11662",
    "name": "CVS",
    "address": "16715 OLD STATESVILLE RD., HUNTERSVILLE, NC, 28078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.4404772,
    "lng": -80.8453038
  },
  {
    "id": "11661",
    "name": "CVS",
    "address": "1575 SOUTH MARKET STREET, ELIZABETHTOWN, PA, 17022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1396532,
    "lng": -76.5866801
  },
  {
    "id": "11660",
    "name": "CVS",
    "address": "1507 LITITZ PIKE, LANCASTER, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0647242,
    "lng": -76.3060138
  },
  {
    "id": "11659",
    "name": "CVS",
    "address": "2410 WILLOW STREET PIKE, LANCASTER, PA, 17602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9915817,
    "lng": -76.2862421
  },
  {
    "id": "11658",
    "name": "CVS",
    "address": "630 CENTERVILLE ROAD, LANCASTER, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0567326,
    "lng": -76.3991861
  },
  {
    "id": "11657",
    "name": "CVS",
    "address": "1052 LITITZ PIKE, LITITZ, PA, 17543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1293689,
    "lng": -76.3057423
  },
  {
    "id": "11656",
    "name": "CVS",
    "address": "129 DOE RUN ROAD, PO BOX 158, MANHEIM, PA, 17545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1716304,
    "lng": -76.383579
  },
  {
    "id": "11655",
    "name": "CVS",
    "address": "706 WEST MAIN STREET, NEW HOLLAND, PA, 17557",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0935418,
    "lng": -76.1134213
  },
  {
    "id": "11654",
    "name": "CVS",
    "address": "1624 LINCOLN HWY EAST, LANCASTER, PA, 17602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0372986,
    "lng": -76.2695447
  },
  {
    "id": "11653",
    "name": "CVS",
    "address": "17122 AIRLINE HWY., PRAIRIEVILLE, LA, 70769",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3198248,
    "lng": -90.9773636
  },
  {
    "id": "11652",
    "name": "CVS",
    "address": "2080 S. QUEEN ST., YORK, PA, 17403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9359153,
    "lng": -76.693334
  },
  {
    "id": "11651",
    "name": "CVS",
    "address": "221 E. HUNDRED RD., CHESTER, VA, 23836",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3478709,
    "lng": -77.3573552
  },
  {
    "id": "11650",
    "name": "CVS",
    "address": "1700 NORTH GEORGE STREET, YORK, PA, 17404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9845818,
    "lng": -76.7358616
  },
  {
    "id": "11649",
    "name": "CVS",
    "address": "635 CARLISLE ST., HANOVER, PA, 17331",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8099786,
    "lng": -76.9897776
  },
  {
    "id": "11648",
    "name": "CVS",
    "address": "406 E. MAIN ST., WAYNESBORO, PA, 17268",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7517896,
    "lng": -77.5715243
  },
  {
    "id": "11647",
    "name": "CVS",
    "address": "105 S. SPORTING HILL RD., MECHANICSBURG, PA, 17050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2367071,
    "lng": -76.971597
  },
  {
    "id": "11646",
    "name": "CVS",
    "address": "9628 REA RD., CHARLOTTE, NC, 28277",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0378637,
    "lng": -80.8061577
  },
  {
    "id": "11645",
    "name": "CVS",
    "address": "2200 WEST CUMBERLAND ST., LEBANON, PA, 17042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3387888,
    "lng": -76.4516993
  },
  {
    "id": "11644",
    "name": "CVS",
    "address": "1116 CARLISLE RD., CAMP HILL, PA, 17011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2308512,
    "lng": -76.8928195
  },
  {
    "id": "11643",
    "name": "CVS",
    "address": "5001 JONESTOWN ROAD, HARRISBURG, PA, 17112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3071032,
    "lng": -76.8049915
  },
  {
    "id": "11642",
    "name": "CVS",
    "address": "1200 MARKET STREET, LEMOYNE, PA, 17043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2405632,
    "lng": -76.9068743
  },
  {
    "id": "11641",
    "name": "CVS",
    "address": "3855 LEONARDTOWN RD., WALDORF, MD, 20601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6146291,
    "lng": -76.8830406
  },
  {
    "id": "11640",
    "name": "CVS",
    "address": "50 BRIDGEST., TUNKHANNOCK, PA, 18657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5372785,
    "lng": -75.9465784
  },
  {
    "id": "11639",
    "name": "CVS",
    "address": "960 WYOMING AVE., EXETER, PA, 18643",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3256265,
    "lng": -75.8100865
  },
  {
    "id": "11638",
    "name": "CVS",
    "address": "702 SANS SOUCI PKWY., WILKES BARRE, PA, 18706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2328481,
    "lng": -75.9198765
  },
  {
    "id": "11637",
    "name": "CVS",
    "address": "347-349 BLAKELY STREET, DUNMORE, PA, 18512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4180575,
    "lng": -75.6339959
  },
  {
    "id": "11636",
    "name": "CVS",
    "address": "1101 MOOSIC ST., SCRANTON, PA, 18505",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3969584,
    "lng": -75.6489025
  },
  {
    "id": "11635",
    "name": "CVS",
    "address": "37 MAHONING ST., MILTON, PA, 17847",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0164603,
    "lng": -76.8553846
  },
  {
    "id": "11634",
    "name": "CVS",
    "address": "350 NORTH 10TH ST., LEWISBURG, PA, 17837",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9623801,
    "lng": -76.8932186
  },
  {
    "id": "11633",
    "name": "CVS",
    "address": "88 BROOKLYN STREET, CARBONDALE, PA, 18407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5669471,
    "lng": -75.5120975
  },
  {
    "id": "11632",
    "name": "CVS",
    "address": "700 WEST FRONT ST., BERWICK, PA, 18603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0503812,
    "lng": -76.2446079
  },
  {
    "id": "11631",
    "name": "CVS",
    "address": "101 NORTH STATE STREET, CLARKS SUMMIT, PA, 18411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4957016,
    "lng": -75.7059826
  },
  {
    "id": "11630",
    "name": "CVS",
    "address": "5 CHURCH STREET, DALLAS, PA, 18612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3374374,
    "lng": -75.9627435
  },
  {
    "id": "11629",
    "name": "CVS",
    "address": "110 GREEN RIDGE STREET, SCRANTON, PA, 18509",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4319233,
    "lng": -75.6588568
  },
  {
    "id": "11628",
    "name": "CVS",
    "address": "405 N. FOURTH ST., SUNBURY, PA, 17801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8663511,
    "lng": -76.7890572
  },
  {
    "id": "11627",
    "name": "CVS",
    "address": "351 S. MAIN ST., WILKES BARRE, PA, 18701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2403913,
    "lng": -75.8926525
  },
  {
    "id": "11626",
    "name": "CVS",
    "address": "823 NEW BERWICK HIGHWAY, BLOOMSBURG, PA, 17815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0303885,
    "lng": -76.3458103
  },
  {
    "id": "11625",
    "name": "CVS",
    "address": "1096 WYOMING AVE, MIDWAY S/C, WYOMING, PA, 18644",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3015825,
    "lng": -75.8501977
  },
  {
    "id": "11624",
    "name": "CVS",
    "address": "3001 RICHARD B. RUSSELL PARKWAY, WARNER ROBINS, GA, 31088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.5805934,
    "lng": -83.6950856
  },
  {
    "id": "11623",
    "name": "CVS",
    "address": "555 EAST MAIN STREET, NANTICOKE, PA, 18634",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.20546,
    "lng": -75.9928336
  },
  {
    "id": "11622",
    "name": "CVS",
    "address": "1101 MILL ST., DANVILLE, PA, 17821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9654594,
    "lng": -76.6165684
  },
  {
    "id": "11621",
    "name": "CVS",
    "address": "6800 JOHNSTON ST., LAFAYETTE, LA, 70503",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1507233,
    "lng": -92.0949848
  },
  {
    "id": "11620",
    "name": "CVS",
    "address": "1000 NORTH MARKET STREET, SELINSGROVE, PA, 17870",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8113431,
    "lng": -76.8569162
  },
  {
    "id": "11619",
    "name": "CVS",
    "address": "6 HEAD OF THE BAY RD., BOURNE, MA, 2532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7529694,
    "lng": -70.5974198
  },
  {
    "id": "11618",
    "name": "CVS",
    "address": "4744 LANKERSHIM BLVD., NORTH HOLLYWOOD, CA, 91602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1570523,
    "lng": -118.369296
  },
  {
    "id": "11617",
    "name": "CVS",
    "address": "1185 N CHURCH ST., HAZLE TOWNSHIP, PA, 18202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9804183,
    "lng": -75.9794784
  },
  {
    "id": "11616",
    "name": "CVS",
    "address": "1740 HWY 160 WEST, FORT MILL, SC, 29708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0339291,
    "lng": -80.9701406
  },
  {
    "id": "11615",
    "name": "CVS",
    "address": "450 CHATHAM HEIGHTS RD., FREDERICKSBURG, VA, 22405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3151484,
    "lng": -77.4509698
  },
  {
    "id": "11614",
    "name": "CVS",
    "address": "5832 HARRISON ROAD, FREDERICKSBURG, VA, 22407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2693054,
    "lng": -77.5379825
  },
  {
    "id": "11613",
    "name": "CVS",
    "address": "150 MADISON ROAD, CULPEPER, VA, 22701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4648238,
    "lng": -78.0004955
  },
  {
    "id": "11612",
    "name": "CVS",
    "address": "591 JEFFERSON DAVIS HIGHWAY, FREDERICKSBURG, VA, 22401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3109959,
    "lng": -77.4776352
  },
  {
    "id": "11611",
    "name": "CVS",
    "address": "4501 LAFAYETTE BLVD., FREDERICKSBURG, VA, 22408",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2572052,
    "lng": -77.4941708
  },
  {
    "id": "11610",
    "name": "CVS",
    "address": "1170 EMMETT STREET N., CHARLOTTESVILLE, VA, 22903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0522269,
    "lng": -78.499006
  },
  {
    "id": "11609",
    "name": "CVS",
    "address": "1133 5TH STREET SW, CHARLOTTESVILLE, VA, 22902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0132127,
    "lng": -78.5031183
  },
  {
    "id": "11608",
    "name": "CVS",
    "address": "3420 SEMINOLE TRAIL, CHARLOTTESVILLE, VA, 22911",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.1307385,
    "lng": -78.4385134
  },
  {
    "id": "11607",
    "name": "CVS",
    "address": "780 MARTIN LUTHER KING JR. WAY, HARRISONBURG, VA, 22801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4411017,
    "lng": -78.8578664
  },
  {
    "id": "11606",
    "name": "CVS",
    "address": "1341 LONG STREET, CHARLOTTESVILLE, VA, 22901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.0356067,
    "lng": -78.4596976
  },
  {
    "id": "11605",
    "name": "CVS",
    "address": "6400 CENTRALIA ROAD, CHESTERFIELD, VA, 23832",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.3742763,
    "lng": -77.5009363
  },
  {
    "id": "11604",
    "name": "CVS",
    "address": "8811 FOREST HILL ROAD, RICHMOND, VA, 23235",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5343446,
    "lng": -77.5607816
  },
  {
    "id": "11603",
    "name": "CVS",
    "address": "151 FRANKLIN ST., WESTERLY, RI, 2891",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3569963,
    "lng": -71.8086285
  },
  {
    "id": "11602",
    "name": "CVS",
    "address": "7301 HILLSIDE RD., AMARILLO, TX, 79119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1462404,
    "lng": -101.9209682
  },
  {
    "id": "11601",
    "name": "CVS",
    "address": "5001 W. BROAD ST.,, RICHMOND, VA, 23230",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5841573,
    "lng": -77.4977074
  },
  {
    "id": "11600",
    "name": "CVS",
    "address": "8820 WEST BROAD STREET, RICHMOND, VA, 23294",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.6347975,
    "lng": -77.5440736
  },
  {
    "id": "11599",
    "name": "CVS",
    "address": "1301 E. NINE MILE RD., HIGHLAND SPRINGS, VA, 23075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5366415,
    "lng": -77.3199916
  },
  {
    "id": "11598",
    "name": "CVS",
    "address": "1801 WEST 5TH ST., PLAINVIEW, TX, 79072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1835379,
    "lng": -101.7250672
  },
  {
    "id": "11597",
    "name": "CVS",
    "address": "947 PROVIDENCE HWY., DEDHAM, MA, 2026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2331535,
    "lng": -71.1807309
  },
  {
    "id": "11596",
    "name": "CVS",
    "address": "2738 WEST BROAD STREET, RICHMOND, VA, 23220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5624942,
    "lng": -77.469443
  },
  {
    "id": "11595",
    "name": "CVS",
    "address": "5606 POST OAK BLVD., WESLEY CHAPEL, FL, 33544",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.2382767,
    "lng": -82.367454
  },
  {
    "id": "11594",
    "name": "CVS",
    "address": "328 W. WHITE HORSE PIKE, PO 278, POMONA, NJ, 8240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4823317,
    "lng": -74.582118
  },
  {
    "id": "11593",
    "name": "CVS",
    "address": "18700 NORTH VILLAGE, HAGERSTOWN, MD, 21742",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6866709,
    "lng": -77.720304
  },
  {
    "id": "11592",
    "name": "CVS",
    "address": "22565 THREE NOTCH RD., CALIFORNIA, MD, 20619",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2864575,
    "lng": -76.4792176
  },
  {
    "id": "11591",
    "name": "CVS",
    "address": "9140 ROTHBURY DRIVE, GAITHERSBURG, MD, 20886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1846222,
    "lng": -77.1895384
  },
  {
    "id": "11590",
    "name": "CVS",
    "address": "68-010 VISTA CHINO, CATHEDRAL CITY, CA, 92234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8456404,
    "lng": -116.4753097
  },
  {
    "id": "11589",
    "name": "CVS",
    "address": "901 WEST 7TH STREET, FREDERICK, MD, 21701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4262279,
    "lng": -77.4159131
  },
  {
    "id": "11588",
    "name": "CVS",
    "address": "8640 GUILFORD ROAD, COLUMBIA, MD, 21046",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1698829,
    "lng": -76.8644388
  },
  {
    "id": "11587",
    "name": "CVS",
    "address": "9420 LANHAM-SEVERN ROAD, SEABROOK, MD, 20706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9733096,
    "lng": -76.8467352
  },
  {
    "id": "11586",
    "name": "CVS",
    "address": "26020 POINT LOOKOUT RD., LEONARDTOWN, MD, 20650",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3054032,
    "lng": -76.6576503
  },
  {
    "id": "11585",
    "name": "CVS",
    "address": "3611 BLADENSBURG ROAD, COLMAR MANOR, MD, 20722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9340897,
    "lng": -76.9512279
  },
  {
    "id": "11584",
    "name": "CVS",
    "address": "9920 KEY WEST AVE, ROCKVILLE, MD, 20850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1002251,
    "lng": -77.2125368
  },
  {
    "id": "11583",
    "name": "CVS",
    "address": "6221 OXON HILL ROAD, OXON HILL, MD, 20745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8051374,
    "lng": -76.9856684
  },
  {
    "id": "11582",
    "name": "CVS",
    "address": "2600 ANNAPOLIS RD., SEVERN, MD, 21144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.128734,
    "lng": -76.7346892
  },
  {
    "id": "11581",
    "name": "CVS",
    "address": "28 WATKINS PARK DRIVE, UPPER MARLBORO, MD, 20774",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9000212,
    "lng": -76.7895893
  },
  {
    "id": "11580",
    "name": "CVS",
    "address": "17651 REDLAND ROAD, DERWOOD, MD, 20855",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1451373,
    "lng": -77.1439621
  },
  {
    "id": "11579",
    "name": "CVS",
    "address": "400 MIDDLETOWN PARKWAY, MIDDLETOWN, MD, 21769",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4373898,
    "lng": -77.5281734
  },
  {
    "id": "11578",
    "name": "CVS",
    "address": "5560 NORBECK ROAD, ROCKVILLE, MD, 20853",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0948884,
    "lng": -77.1112341
  },
  {
    "id": "11577",
    "name": "CVS",
    "address": "19100 MONTGOMERY VILLAGE AVE., GAITHERSBURG, MD, 20886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1702167,
    "lng": -77.2048562
  },
  {
    "id": "11576",
    "name": "CVS",
    "address": "9950 LEWIS DRIVE, DAMASCUS, MD, 20872",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2898414,
    "lng": -77.2062486
  },
  {
    "id": "11575",
    "name": "CVS",
    "address": "2271 BEL PRE ROAD, SILVER SPRING, MD, 20906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0914207,
    "lng": -77.048261
  },
  {
    "id": "11574",
    "name": "CVS",
    "address": "13320 LAUREL-BOWIE ROAD, LAUREL, MD, 20708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0739706,
    "lng": -76.8498117
  },
  {
    "id": "11573",
    "name": "CVS",
    "address": "21676 GREAT MILLS ROAD, LEXINGTON PARK, MD, 20653",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2628,
    "lng": -76.4588844
  },
  {
    "id": "11572",
    "name": "CVS",
    "address": "7050 ALLENTOWN ROAD, CAMP SPRINGS, MD, 20748",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7930404,
    "lng": -76.9258636
  },
  {
    "id": "11571",
    "name": "CVS",
    "address": "11729 BELTSVILLE DR/CALVERTON S/C, BELTSVILLE, MD, 20705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0482505,
    "lng": -76.9368484
  },
  {
    "id": "11570",
    "name": "CVS",
    "address": "4601-A SANGAMORE RD., BETHESDA, MD, 20816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9494837,
    "lng": -77.1180445
  },
  {
    "id": "11569",
    "name": "CVS",
    "address": "5205 N. BROADWAY ST., CHICAGO, IL, 60640",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9768351,
    "lng": -87.6594058
  },
  {
    "id": "11568",
    "name": "CVS",
    "address": "9520 GEORGIA AVENUE, SILVER SPRING, MD, 20910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0108148,
    "lng": -77.042144
  },
  {
    "id": "11567",
    "name": "CVS",
    "address": "8859 BRANCH AVENUE, CLINTON, MD, 20735",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7671263,
    "lng": -76.8902013
  },
  {
    "id": "11566",
    "name": "CVS",
    "address": "546 NORTH FREDERICK AVENUE, GAITHERSBURG, MD, 20877",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.147938,
    "lng": -77.2098419
  },
  {
    "id": "11565",
    "name": "CVS",
    "address": "6516 LANDOVER ROAD, LANDOVER, MD, 20785",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9326004,
    "lng": -76.9006489
  },
  {
    "id": "11564",
    "name": "CVS",
    "address": "6260 CRAIN HWY., LA PLATA, MD, 20646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5400724,
    "lng": -76.9834777
  },
  {
    "id": "11563",
    "name": "CVS",
    "address": "13729 CONNECTICUT AVE., WHEATON, MD, 20906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0789157,
    "lng": -77.0790658
  },
  {
    "id": "11562",
    "name": "CVS",
    "address": "402 SO. JEFFERSON STREET, FREDERICK, MD, 21701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4065601,
    "lng": -77.4299019
  },
  {
    "id": "11561",
    "name": "CVS",
    "address": "1599 TIBURON BLVD, TIBURON, CA, 94920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.8761529,
    "lng": -122.4589757
  },
  {
    "id": "11560",
    "name": "CVS",
    "address": "3061 TECHNOLOGY PLACE, WALDORF, MD, 20601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6300138,
    "lng": -76.9163637
  },
  {
    "id": "11559",
    "name": "CVS",
    "address": "1290 EAST-WEST HIGHWAY, SILVER SPRING, MD, 20910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9914385,
    "lng": -77.0316186
  },
  {
    "id": "11558",
    "name": "CVS",
    "address": "10233 OLD GEORGETOWN ROAD, BETHESDA, MD, 20814",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.023986,
    "lng": -77.1234828
  },
  {
    "id": "11557",
    "name": "CVS",
    "address": "7600 SE CRAIN HIGHWAY, UPPER MARLBORO, MD, 20772",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7843955,
    "lng": -76.7925727
  },
  {
    "id": "11556",
    "name": "CVS",
    "address": "2210 VIERS MILL ROAD, ROCKVILLE, MD, 20851",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0754771,
    "lng": -77.1144479
  },
  {
    "id": "11555",
    "name": "CVS",
    "address": "1301 LAMBERTON DRIVE, SILVER SPRING, MD, 20902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0412675,
    "lng": -77.0308327
  },
  {
    "id": "11554",
    "name": "CVS",
    "address": "15600 COLUMBIA PIKE, BURTONSVILLE, MD, 20866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1115955,
    "lng": -76.9348226
  },
  {
    "id": "11553",
    "name": "CVS",
    "address": "12359 GEORGIA AVENUE, SILVER SPRING, MD, 20906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0610498,
    "lng": -77.0497452
  },
  {
    "id": "11552",
    "name": "CVS",
    "address": "11906 LIVINGSTON RD., FORT WASHINGTON, MD, 20744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7263747,
    "lng": -76.9891991
  },
  {
    "id": "11551",
    "name": "CVS",
    "address": "10692 CAMPUS WAY S, KETTERING S/C, UPPER MARLBORO, MD, 20774",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.898017,
    "lng": -76.8238925
  },
  {
    "id": "11550",
    "name": "CVS",
    "address": "1910 CRAIN HIGHWAY, BOWIE, MD, 20716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9168605,
    "lng": -76.7184096
  },
  {
    "id": "11549",
    "name": "CVS",
    "address": "5707 RIVERDALE ROAD, RIVERDALE, MD, 20737",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.95774,
    "lng": -76.91866
  },
  {
    "id": "11548",
    "name": "CVS",
    "address": "12215 DARNESTOWN ROAD, GAITHERSBURG, MD, 20878",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1186996,
    "lng": -77.2538959
  },
  {
    "id": "11547",
    "name": "CVS",
    "address": "6920 LAUREL-BOWIE ROAD, BOWIE, MD, 20715",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9851393,
    "lng": -76.7588106
  },
  {
    "id": "11546",
    "name": "CVS",
    "address": "8201 ANNAPOLIS RD., NEW CARROLLTON, MD, 20784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9550364,
    "lng": -76.8723663
  },
  {
    "id": "11545",
    "name": "CVS",
    "address": "1001 TWIN ARCH ROAD #18, MOUNT AIRY, MD, 21771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3679616,
    "lng": -77.1457942
  },
  {
    "id": "11544",
    "name": "CVS",
    "address": "360 HUNGERFORD DR., SPACE 410, ROCKVILLE, MD, 20850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0871688,
    "lng": -77.1503452
  },
  {
    "id": "11543",
    "name": "CVS",
    "address": "7300 BALTIMORE BLVD, COLLEGE PARK, MD, 20740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9798471,
    "lng": -76.938289
  },
  {
    "id": "11542",
    "name": "CVS",
    "address": "7401 ANNAPOLIS RD., LANDOVER HILLS, MD, 20784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9480388,
    "lng": -76.8874483
  },
  {
    "id": "11541",
    "name": "CVS",
    "address": "10 EAST WILSON BOULEVARD, HAGERSTOWN, MD, 21740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6244242,
    "lng": -77.727369
  },
  {
    "id": "11540",
    "name": "CVS",
    "address": "1580 ROCKVILLE PIKE, ROCKVILLE, MD, 20852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0643185,
    "lng": -77.1252807
  },
  {
    "id": "11539",
    "name": "CVS",
    "address": "12209 VIERS MILL ROAD, WHEATON, MD, 20906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0574419,
    "lng": -77.0824831
  },
  {
    "id": "11538",
    "name": "CVS",
    "address": "1460B W PATRICK ST., FREDERICK, MD, 21702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4206769,
    "lng": -77.4664775
  },
  {
    "id": "11537",
    "name": "CVS",
    "address": "3130 QUEENS CHAPEL ROAD, HYATTSVILLE, MD, 20782",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9513322,
    "lng": -76.9678616
  },
  {
    "id": "11536",
    "name": "CVS",
    "address": "1503 POTOMAC AVE., HAGERSTOWN, MD, 21742",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6629375,
    "lng": -77.7018795
  },
  {
    "id": "11535",
    "name": "CVS",
    "address": "7939 NEW HAMPSHIRE AVENUE, HYATTSVILLE, MD, 20783",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9894419,
    "lng": -76.9858627
  },
  {
    "id": "11534",
    "name": "CVS",
    "address": "3110 OLNEY SANDY SPRING RD., OLNEY, MD, 20832",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1507007,
    "lng": -77.0635969
  },
  {
    "id": "11533",
    "name": "CVS",
    "address": "1200 EDWIN MILLER BLVD., MARTINSBURG, WV, 25404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4758237,
    "lng": -77.958651
  },
  {
    "id": "11532",
    "name": "CVS",
    "address": "110 EDDS LANE, STERLING, VA, 20165",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0405751,
    "lng": -77.4120571
  },
  {
    "id": "11531",
    "name": "CVS",
    "address": "388 GARRISONVILLE RD., STAFFORD, VA, 22554",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4766329,
    "lng": -77.4263881
  },
  {
    "id": "11530",
    "name": "CVS",
    "address": "3919 CENTREVILLE RD., CHANTILLY, VA, 20151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.894947,
    "lng": -77.4300805
  },
  {
    "id": "11529",
    "name": "CVS",
    "address": "13031 LEE-JACKSON HIGHWAY, FAIRFAX, VA, 22033",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.878796,
    "lng": -77.397865
  },
  {
    "id": "11528",
    "name": "CVS",
    "address": "5652 PICKWICK RD., CENTREVILLE, VA, 20120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8396019,
    "lng": -77.423804
  },
  {
    "id": "11527",
    "name": "CVS",
    "address": "616 E. MARKET ST., LEESBURG, VA, 20176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1077046,
    "lng": -77.549
  },
  {
    "id": "11526",
    "name": "CVS",
    "address": "1195 OAKLAWN AVENUE, CRANSTON, RI, 2920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7367091,
    "lng": -71.478774
  },
  {
    "id": "11525",
    "name": "CVS",
    "address": "7859 HERITAGE DRIVE, ANNANDALE, VA, 22003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8250473,
    "lng": -77.2141987
  },
  {
    "id": "11524",
    "name": "CVS",
    "address": "8124 ARLINGTON BLVD, YORKTOWN CTR, FALLS CHURCH, VA, 22042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8669325,
    "lng": -77.2263939
  },
  {
    "id": "11523",
    "name": "CVS",
    "address": "401 STERLING PARK SHOP MALL, STERLING, VA, 20164",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9987152,
    "lng": -77.4058338
  },
  {
    "id": "11522",
    "name": "CVS",
    "address": "4606 KENMORE AVENUE, ALEXANDRIA, VA, 22304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8289971,
    "lng": -77.109593
  },
  {
    "id": "11521",
    "name": "CVS",
    "address": "3133 LEE HIGHWAY, ARLINGTON, VA, 22201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8964614,
    "lng": -77.0969605
  },
  {
    "id": "11520",
    "name": "CVS",
    "address": "9200 CENTREVILLE RD., MANASSAS, VA, 20110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7552418,
    "lng": -77.4668808
  },
  {
    "id": "11519",
    "name": "CVS",
    "address": "13600 JEFFERSON DAVIS HIGHWAY, WOODBRIDGE, VA, 22191",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6582761,
    "lng": -77.2504386
  },
  {
    "id": "11518",
    "name": "CVS",
    "address": "1062 ELDEN ST., HERNDON, VA, 20170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9673151,
    "lng": -77.3974839
  },
  {
    "id": "11517",
    "name": "CVS",
    "address": "130 SCHUYLKILL RD., PHOENIXVILLE, PA, 19460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1323757,
    "lng": -75.5377689
  },
  {
    "id": "11516",
    "name": "CVS",
    "address": "1150 WEST BROAD STREET, FALLS CHURCH, VA, 22046",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8984549,
    "lng": -77.1855276
  },
  {
    "id": "11515",
    "name": "CVS",
    "address": "3053 NUTLEY STREET, FAIRFAX, VA, 22031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8706372,
    "lng": -77.2609133
  },
  {
    "id": "11514",
    "name": "CVS",
    "address": "6436 SPRINGFIELD PLAZA, SPRINGFIELD, VA, 22150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7795517,
    "lng": -77.1897144
  },
  {
    "id": "11513",
    "name": "CVS",
    "address": "1452 CHAIN BRIDGE ROAD, MCLEAN, VA, 22101",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9331108,
    "lng": -77.1801041
  },
  {
    "id": "11512",
    "name": "CVS",
    "address": "8041 SUDLEY ROAD, MANASSAS, VA, 20109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7825955,
    "lng": -77.5105238
  },
  {
    "id": "11511",
    "name": "CVS",
    "address": "2200 TACKETTS MILL, WOODBRIDGE, VA, 22192",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6761001,
    "lng": -77.2779592
  },
  {
    "id": "11510",
    "name": "CVS",
    "address": "9582 OLD KEENE MILL ROAD, BURKE, VA, 22015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7788172,
    "lng": -77.2747271
  },
  {
    "id": "11509",
    "name": "CVS",
    "address": "2912 CHAIN BRIDGE ROAD, OAKTON, VA, 22124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8826411,
    "lng": -77.2997735
  },
  {
    "id": "11508",
    "name": "CVS",
    "address": "6164 ARLINGTON BOULEVARD, FALLS CHURCH, VA, 22044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8699096,
    "lng": -77.1464491
  },
  {
    "id": "11507",
    "name": "CVS",
    "address": "8330 OLD KEENE MILL RD/CARDINAL FOREST, SPRINGFIELD, VA, 22152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7805908,
    "lng": -77.2331638
  },
  {
    "id": "11506",
    "name": "CVS",
    "address": "3535 SOUTH JEFFERSON STREET, BAILEYS CROSSROADS, VA, 22041",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.847382,
    "lng": -77.117517
  },
  {
    "id": "11505",
    "name": "CVS",
    "address": "1462 BEAUREGARD STREET, ALEXANDRIA, VA, 22311",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8306436,
    "lng": -77.1257714
  },
  {
    "id": "11504",
    "name": "CVS",
    "address": "259 SOUTH VAN DORN STREET, ALEXANDRIA, VA, 22304",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8114669,
    "lng": -77.1336407
  },
  {
    "id": "11503",
    "name": "CVS",
    "address": "1521-1523 NORTH QUAKER LANE, ALEXANDRIA, VA, 22302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8291443,
    "lng": -77.08553
  },
  {
    "id": "11502",
    "name": "CVS",
    "address": "510 BLACKWELL RD., WARRENTON, VA, 20186",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7271535,
    "lng": -77.7916032
  },
  {
    "id": "11501",
    "name": "CVS",
    "address": "4709-A LEE HIGHWAY, ARLINGTON, VA, 22207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8984942,
    "lng": -77.1223142
  },
  {
    "id": "11500",
    "name": "CVS",
    "address": "840 VALLEY FORGE RD., LANSDALE, PA, 19446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2412433,
    "lng": -75.3035446
  },
  {
    "id": "11499",
    "name": "CVS",
    "address": "5711 BURKE CENTER PARKWAY, BURKE, VA, 22015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7998502,
    "lng": -77.3222822
  },
  {
    "id": "11498",
    "name": "CVS",
    "address": "9871 GEORGETOWN PIKE, GREAT FALLS, VA, 22066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9960796,
    "lng": -77.2872754
  },
  {
    "id": "11497",
    "name": "CVS",
    "address": "1201 N. FIFTH ST., PERKASIE, PA, 18944",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3830808,
    "lng": -75.2764341
  },
  {
    "id": "11496",
    "name": "CVS",
    "address": "5017 COLUMBIA PIKE, ARLINGTON, VA, 22204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.85598,
    "lng": -77.113414
  },
  {
    "id": "11495",
    "name": "CVS",
    "address": "800 HWY 96, WARNER ROBINS, GA, 31088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.553637,
    "lng": -83.6630188
  },
  {
    "id": "11494",
    "name": "CVS",
    "address": "6404 WILLIAMSBURG BOULEVARD, ARLINGTON, VA, 22207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9001777,
    "lng": -77.1561108
  },
  {
    "id": "11493",
    "name": "CVS",
    "address": "4309 CONNECTICUT AVENUE NW, WASHINGTON, DC, 20008",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9449211,
    "lng": -77.0618174
  },
  {
    "id": "11492",
    "name": "CVS",
    "address": "1755 COLUMBIA ROAD NW, WASHINGTON, DC, 20009",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9238626,
    "lng": -77.0414693
  },
  {
    "id": "11491",
    "name": "CVS",
    "address": "1901 PENNSYLVANIA AVENUE NW, WASHINGTON, DC, 20006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.900686,
    "lng": -77.0437495
  },
  {
    "id": "11490",
    "name": "CVS",
    "address": "1403 WISCONSIN AVENUE NW, WASHINGTON, DC, 20007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9086145,
    "lng": -77.0635969
  },
  {
    "id": "11489",
    "name": "CVS",
    "address": "2550 VIRGINIA AVENUE NW, WASHINGTON, DC, 20037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8990783,
    "lng": -77.0544791
  },
  {
    "id": "11488",
    "name": "CVS",
    "address": "275 BALTIMORE BLVD, WESTMINSTER, MD, 21157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5790571,
    "lng": -76.9871027
  },
  {
    "id": "11487",
    "name": "CVS",
    "address": "2513 US HWY 19, HOLIDAY, FL, 34691",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1956281,
    "lng": -82.7408413
  },
  {
    "id": "11486",
    "name": "CVS",
    "address": "20 EAST LOCUST STREET, NESQUEHONING, PA, 18240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8678874,
    "lng": -75.8127653
  },
  {
    "id": "11485",
    "name": "CVS",
    "address": "28 NORTH CLAUDE A LORD BLVD, POTTSVILLE, PA, 17901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6868103,
    "lng": -76.1938148
  },
  {
    "id": "11484",
    "name": "CVS",
    "address": "212 POTTSVILLE ST., POTTSVILLE, PA, 17901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6372705,
    "lng": -76.1827717
  },
  {
    "id": "11483",
    "name": "CVS",
    "address": "3498 N. 5TH STREET HWY., READING, PA, 19605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3857583,
    "lng": -75.9284509
  },
  {
    "id": "11482",
    "name": "CVS",
    "address": "RT. 115 AND 209, HC2, BOX 1120, BRODHEADSVILLE, PA, 18322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9243129,
    "lng": -75.3980245
  },
  {
    "id": "11481",
    "name": "CVS",
    "address": "1596 HWY A1A, SATELLITE BEACH, FL, 32937",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1652477,
    "lng": -80.5881935
  },
  {
    "id": "11480",
    "name": "CVS",
    "address": "1101 SOUTHWEST END BLVD., QUAKERTOWN, PA, 18951",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4167492,
    "lng": -75.3429032
  },
  {
    "id": "11479",
    "name": "CVS",
    "address": "1201 E COLONIAL DR, ORLANDO, FL, 32803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5533722,
    "lng": -81.3641311
  },
  {
    "id": "11478",
    "name": "CVS",
    "address": "1111 NORTH 9TH ST., STROUDSBURG, PA, 18360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9886409,
    "lng": -75.2183243
  },
  {
    "id": "11477",
    "name": "CVS",
    "address": "2651 EASTON AVENUE, BETHLEHEM, PA, 18017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6460579,
    "lng": -75.3454538
  },
  {
    "id": "11476",
    "name": "CVS",
    "address": "801 E. PHILADELPHIA AVE., UNIT 1, BOYERTOWN, PA, 19512",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3282549,
    "lng": -75.6239591
  },
  {
    "id": "11475",
    "name": "CVS",
    "address": "250 S. COURTLAND ST., EAST STROUDSBURG, PA, 18301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9951261,
    "lng": -75.1820801
  },
  {
    "id": "11474",
    "name": "CVS",
    "address": "46 MIDDLEWAY PIKE, INWOOD, WV, 25428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.357012,
    "lng": -78.0392028
  },
  {
    "id": "11473",
    "name": "CVS",
    "address": "220 MAPLE ST., MIDDLETON, MA, 1949",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5963047,
    "lng": -70.9937336
  },
  {
    "id": "11472",
    "name": "CVS",
    "address": "3519 NAZARETH RD, EASTON, PA, 18045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7084551,
    "lng": -75.2772088
  },
  {
    "id": "11471",
    "name": "CVS",
    "address": "45 CONSTITUTION BLVD, VILLAGE SQUARE S/C, KUTZTOWN, PA, 19530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5174995,
    "lng": -75.7755307
  },
  {
    "id": "11470",
    "name": "CVS",
    "address": "662 E BORONDA RD, SALINAS, CA, 93906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7143531,
    "lng": -121.6250118
  },
  {
    "id": "11469",
    "name": "CVS",
    "address": "25 WASHINGTON STREET STE 1, WELLESLEY, MA, 2481",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3252879,
    "lng": -71.2600923
  },
  {
    "id": "11468",
    "name": "CVS",
    "address": "5001 TOWNSHIP LINE ROAD, DREXEL HILL, PA, 19026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9564795,
    "lng": -75.3218585
  },
  {
    "id": "11467",
    "name": "CVS",
    "address": "12804 US HWY 301, DADE CITY, FL, 33525",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.3435713,
    "lng": -82.1866156
  },
  {
    "id": "11466",
    "name": "CVS",
    "address": "1330 BALLTOWN ROAD, NISKAYUNA, NY, 12309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.810881,
    "lng": -73.892155
  },
  {
    "id": "11465",
    "name": "CVS",
    "address": "610 OLD COUNTRY RD, SALISBURY PLAZA, WESTBURY, NY, 11590",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7497194,
    "lng": -73.5732615
  },
  {
    "id": "11464",
    "name": "CVS",
    "address": "17 WEST MAIN STREET, CLINTON, CT, 6413",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2788379,
    "lng": -72.5285051
  },
  {
    "id": "11463",
    "name": "CVS",
    "address": "317 W. LANCASTER AVE., ARDMORE, PA, 19003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0111133,
    "lng": -75.2967549
  },
  {
    "id": "11462",
    "name": "CVS",
    "address": "2250 BRISTOL RD., BENSALEM, PA, 19020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1298127,
    "lng": -74.9234804
  },
  {
    "id": "11461",
    "name": "CVS",
    "address": "6690 EAGLE NEST LN, MIAMI LAKES, FL, 33014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.9098631,
    "lng": -80.3080355
  },
  {
    "id": "11460",
    "name": "CVS",
    "address": "81 NORTH ST., BRISTOL, CT, 6010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6815654,
    "lng": -72.9461594
  },
  {
    "id": "11459",
    "name": "CVS",
    "address": "107-113 MAIN ST, THE OSTROWER BLDG, WOODBRIDGE, NJ, 7095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5535835,
    "lng": -74.2811568
  },
  {
    "id": "11458",
    "name": "CVS",
    "address": "2790 N ROOSEVELT BLVD, KEY WEST, FL, 33040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 24.5652581,
    "lng": -81.7712254
  },
  {
    "id": "11457",
    "name": "CVS",
    "address": "135 KINDERKAMAC RD., RIVER EDGE, NJ, 7661",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9129121,
    "lng": -74.0366679
  },
  {
    "id": "11456",
    "name": "CVS",
    "address": "626 ROUTE 25A, ROCKY POINT, NY, 11778",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9470214,
    "lng": -72.9238172
  },
  {
    "id": "11455",
    "name": "CVS",
    "address": "958 ROUTE 390, CRESCO, PA, 18326",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1699027,
    "lng": -75.2715127
  },
  {
    "id": "11454",
    "name": "CVS",
    "address": "106 BOSTON POST ROAD, WATERFORD, CT, 6385",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3413033,
    "lng": -72.1237486
  },
  {
    "id": "11453",
    "name": "CVS",
    "address": "210 BORDER STREET, EAST BOSTON, MA, 2128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3752392,
    "lng": -71.0407695
  },
  {
    "id": "11452",
    "name": "CVS",
    "address": "231 MASSACHUSETTS AVENUE, BOSTON, MA, 2115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3442765,
    "lng": -71.086612
  },
  {
    "id": "11451",
    "name": "CVS",
    "address": "119 BEDFORD ST., EAST BRIDGEWATER, MA, 2333",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.030642,
    "lng": -70.959231
  },
  {
    "id": "11450",
    "name": "CVS",
    "address": "1300 APALACHEE PKWY, TALLAHASSEE, FL, 32301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4377121,
    "lng": -84.2611524
  },
  {
    "id": "11449",
    "name": "CVS",
    "address": "984 WORCESTER STREET, WELLESLEY, MA, 2482",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3038767,
    "lng": -71.3251568
  },
  {
    "id": "11448",
    "name": "CVS",
    "address": "8 GREENE STREET, MASHPEE, MA, 2649",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.61696,
    "lng": -70.4888019
  },
  {
    "id": "11447",
    "name": "CVS",
    "address": "555 BELMONT STREET, BROCKTON, MA, 2301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0742363,
    "lng": -71.0420695
  },
  {
    "id": "11446",
    "name": "CVS",
    "address": "471 LIBERTY STREET, HANSON, MA, 2341",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.066506,
    "lng": -70.869084
  },
  {
    "id": "11445",
    "name": "CVS",
    "address": "2992 CRANBERRY HWY, EAST WAREHAM, MA, 2538",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7600886,
    "lng": -70.6645722
  },
  {
    "id": "11444",
    "name": "CVS",
    "address": "26 WATERBURY RD., PROSPECT, CT, 6712",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5076627,
    "lng": -72.9802883
  },
  {
    "id": "11443",
    "name": "CVS",
    "address": "714 HOPMEADOW ST, DRACUT MALL, SIMSBURY, CT, 6070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8716755,
    "lng": -72.801833
  },
  {
    "id": "11442",
    "name": "CVS",
    "address": "734 BRIDGEPORT AVE., MILFORD, CT, 6460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2110781,
    "lng": -73.0821033
  },
  {
    "id": "11441",
    "name": "CVS",
    "address": "233 EAST MAIN STREET, MANASQUAN, NJ, 8736",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1205619,
    "lng": -74.0473624
  },
  {
    "id": "11440",
    "name": "CVS",
    "address": "110 TURNPIKE ST., NORTH ANDOVER, MA, 1845",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6757741,
    "lng": -71.1285586
  },
  {
    "id": "11439",
    "name": "CVS",
    "address": "1829 GRAND AVE., NORTH BALDWIN, NY, 11510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6662253,
    "lng": -73.6067983
  },
  {
    "id": "11438",
    "name": "CVS",
    "address": "208 ELM ST., WESTFIELD, MA, 1085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1246078,
    "lng": -72.7485287
  },
  {
    "id": "11437",
    "name": "CVS",
    "address": "807 WHITE PLAINS RD., SCARSDALE, NY, 10583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9760743,
    "lng": -73.8034495
  },
  {
    "id": "11436",
    "name": "CVS",
    "address": "151 N MAIN ST, CRYSTAL SPRINGS PLAZA, BELCHERTOWN, MA, 1007",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2884488,
    "lng": -72.4074132
  },
  {
    "id": "11435",
    "name": "CVS",
    "address": "151 PINE HOLLOW RD, OYSTER BAY PLAZA, OYSTER BAY, NY, 11771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.86033,
    "lng": -73.5348878
  },
  {
    "id": "11434",
    "name": "CVS",
    "address": "753 FORT SALONGA ROAD, NORTHPORT, NY, 11768",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8966732,
    "lng": -73.3359599
  },
  {
    "id": "11433",
    "name": "CVS",
    "address": "22 MAIN STREET, BLACKSTONE, MA, 1504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0171893,
    "lng": -71.5291351
  },
  {
    "id": "11432",
    "name": "CVS",
    "address": "216 OLD TAPPAN RD/34E BI-STATE PLZ S/C, OLD TAPPAN, NJ, 7675",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0141205,
    "lng": -73.9826356
  },
  {
    "id": "11431",
    "name": "CVS",
    "address": "1944 DEER PARK AVE, DEER PARK S/C, DEER PARK, NY, 11729",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7633731,
    "lng": -73.331354
  },
  {
    "id": "11430",
    "name": "CVS",
    "address": "50 MEDWAY RD,, MILFORD, MA, 1757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1501233,
    "lng": -71.4999674
  },
  {
    "id": "11429",
    "name": "CVS",
    "address": "519 WASHINGTON AVENUE, BELLEVILLE, NJ, 7109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7983968,
    "lng": -74.1483562
  },
  {
    "id": "11428",
    "name": "CVS",
    "address": "229 HOPE STREET, STAMFORD, CT, 6906",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0686738,
    "lng": -73.5259605
  },
  {
    "id": "11427",
    "name": "CVS",
    "address": "94 PARK STREET, NEW CANAAN, CT, 6840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1461847,
    "lng": -73.4951905
  },
  {
    "id": "11426",
    "name": "CVS",
    "address": "294 HARVARD STREET, BROOKLINE, MA, 2446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3429522,
    "lng": -71.1230347
  },
  {
    "id": "11425",
    "name": "CVS",
    "address": "240 NEWBURY STREET, BOSTON, MA, 2116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3494871,
    "lng": -71.0818577
  },
  {
    "id": "11424",
    "name": "CVS",
    "address": "509 EASTERN AVENUE, LYNN, MA, 1902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.48178,
    "lng": -70.9362432
  },
  {
    "id": "11423",
    "name": "CVS",
    "address": "20 BANK ST., GRANBY, CT, 6035",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9522237,
    "lng": -72.7860883
  },
  {
    "id": "11422",
    "name": "CVS",
    "address": "9 NELSON STREET, LEOMINSTER, MA, 1453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5429265,
    "lng": -71.7608958
  },
  {
    "id": "11421",
    "name": "CVS",
    "address": "305 MAIN ST., HOLBROOK, NY, 11741",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8117728,
    "lng": -73.0790341
  },
  {
    "id": "11420",
    "name": "CVS",
    "address": "101 EASTON RD., SUITE B, HORSHAM, PA, 19044",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1712886,
    "lng": -75.1293459
  },
  {
    "id": "11419",
    "name": "CVS",
    "address": "311 MAIN ST, CVS PLAZA, CENTER MORICHES, NY, 11934",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8011413,
    "lng": -72.7916302
  },
  {
    "id": "11418",
    "name": "CVS",
    "address": "405 LINCOLN ST., HINGHAM, MA, 2043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2489264,
    "lng": -70.9244934
  },
  {
    "id": "11417",
    "name": "CVS",
    "address": "822 MIDDLE COUNTRY RD., SELDEN, NY, 11784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8646953,
    "lng": -73.0419113
  },
  {
    "id": "11416",
    "name": "CVS",
    "address": "2000 COMMERCE STREET, YORKTOWN HEIGHTS, NY, 10598",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2769093,
    "lng": -73.7813397
  },
  {
    "id": "11415",
    "name": "CVS",
    "address": "777 MAIN STREET, HARTFORD, CT, 6103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.766219,
    "lng": -72.6738298
  },
  {
    "id": "11414",
    "name": "CVS",
    "address": "790 CHIEF JUSTICE CUSHING HWY, COHASSET, MA, 2025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2215996,
    "lng": -70.8023094
  },
  {
    "id": "11413",
    "name": "CVS",
    "address": "1 MAPLE STREET, DANVERS, MA, 1923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.565868,
    "lng": -70.9353144
  },
  {
    "id": "11412",
    "name": "CVS",
    "address": "358 W. MAIN ST., AVON, CT, 6001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.816035,
    "lng": -72.8609106
  },
  {
    "id": "11411",
    "name": "CVS",
    "address": "702 CHESTNUT ST., EMMAUS, PA, 18049",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.531659,
    "lng": -75.4988706
  },
  {
    "id": "11410",
    "name": "CVS",
    "address": "11190 VIERS MILL ROAD, WHEATON, MD, 20902",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0389684,
    "lng": -77.0545575
  },
  {
    "id": "11409",
    "name": "CVS",
    "address": "46 MORGAN RD., HUDSON, NH, 3051",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7799617,
    "lng": -71.4455247
  },
  {
    "id": "11408",
    "name": "CVS",
    "address": "68 MAIN STREET, ANDOVER, MA, 1810",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6551054,
    "lng": -71.1391886
  },
  {
    "id": "11407",
    "name": "CVS",
    "address": "455 CENTER ST, HEALDSBURG, CA, 95448",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6140218,
    "lng": -122.8709133
  },
  {
    "id": "11406",
    "name": "CVS",
    "address": "15 WALNUT RD, HAMILTON PLAZA, SOUTH HAMILTON, MA, 1982",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.609699,
    "lng": -70.8735895
  },
  {
    "id": "11405",
    "name": "CVS",
    "address": "449 MARKET STREET, ELMWOOD PARK, NJ, 7407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8993273,
    "lng": -74.1114247
  },
  {
    "id": "11404",
    "name": "CVS",
    "address": "219 BROAD STREET, WINDSOR, CT, 6095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8517824,
    "lng": -72.6431422
  },
  {
    "id": "11403",
    "name": "CVS",
    "address": "1098 MANTUA PIKE, WENONAH, NJ, 8090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8034721,
    "lng": -75.1681273
  },
  {
    "id": "11402",
    "name": "CVS",
    "address": "760 MILES RD., WEST CHESTER, PA, 19380",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9638072,
    "lng": -75.6285374
  },
  {
    "id": "11401",
    "name": "CVS",
    "address": "213-217 HARRISON ST., NUTLEY, NJ, 7110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8119853,
    "lng": -74.1667223
  },
  {
    "id": "11400",
    "name": "CVS",
    "address": "1242 PARKER ST, SPRINGFIELD, MA, 1129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1149807,
    "lng": -72.4988882
  },
  {
    "id": "11399",
    "name": "CVS",
    "address": "6 WILLARD RD., NORWALK, CT, 6851",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1275514,
    "lng": -73.3880922
  },
  {
    "id": "11398",
    "name": "CVS",
    "address": "1875 BOSTON AVE, CVS PLAZA, BRIDGEPORT, CT, 6610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1936397,
    "lng": -73.159208
  },
  {
    "id": "11397",
    "name": "CVS",
    "address": "58 PENNSYLVANIA AVE., NIANTIC, CT, 6357",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3256948,
    "lng": -72.1936735
  },
  {
    "id": "11396",
    "name": "CVS",
    "address": "30900 WOODWARD, ROYAL OAK, MI, 48073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5174413,
    "lng": -83.1844103
  },
  {
    "id": "11395",
    "name": "CVS",
    "address": "696 WEST AVE., NORWALK, CT, 6850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1151002,
    "lng": -73.4154888
  },
  {
    "id": "11394",
    "name": "CVS",
    "address": "905 SOUTH MAIN ST., CHESHIRE, CT, 6410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4804578,
    "lng": -72.9065179
  },
  {
    "id": "11393",
    "name": "CVS",
    "address": "70 N UNIVERSITY DR, PEMBROKE PINES, FL, 33024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.0097448,
    "lng": -80.2492952
  },
  {
    "id": "11392",
    "name": "CVS",
    "address": "18 MAIN STREET, NORTH READING, MA, 1864",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5661106,
    "lng": -71.1093404
  },
  {
    "id": "11391",
    "name": "CVS",
    "address": "2610 E MAIN ST, BRIARWOODS S/C, BRIDGEPORT, CT, 6610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2109416,
    "lng": -73.1786286
  },
  {
    "id": "11390",
    "name": "CVS",
    "address": "909 N HOMESTEAD BLVD, HOMESTEAD, FL, 33030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.4792088,
    "lng": -80.4621588
  },
  {
    "id": "11389",
    "name": "CVS",
    "address": "715 BEDFORD RD, BEDFORD HILLS, NY, 10507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2258825,
    "lng": -73.7152836
  },
  {
    "id": "11388",
    "name": "CVS",
    "address": "13-1/2 POND STREET, NEWBURYPORT, MA, 1950",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8067443,
    "lng": -70.8735895
  },
  {
    "id": "11387",
    "name": "CVS",
    "address": "55 VETERANS MEMORIAL DR, NORTH ADAMS, MA, 1247",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7012371,
    "lng": -73.110941
  },
  {
    "id": "11386",
    "name": "CVS",
    "address": "615-621 BELMONT AVENUE, SPRINGFIELD, MA, 1108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0860574,
    "lng": -72.555126
  },
  {
    "id": "11385",
    "name": "CVS",
    "address": "72 BROOKSIDE AVE., CHESTER, NY, 10918",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3563389,
    "lng": -74.2818507
  },
  {
    "id": "11384",
    "name": "CVS",
    "address": "22 DEPOT HILL RD., SOUTHBURY, CT, 6488",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4752869,
    "lng": -73.2177876
  },
  {
    "id": "11383",
    "name": "CVS",
    "address": "174 LITTLETON RD, WESTFORD MARKETPLACE, WESTFORD, MA, 1886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5669232,
    "lng": -71.4214225
  },
  {
    "id": "11382",
    "name": "CVS",
    "address": "970 MONTAUK HIGHWAY, BAYPORT, NY, 11705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7485463,
    "lng": -73.0456008
  },
  {
    "id": "11381",
    "name": "CVS",
    "address": "7777 BLUEBONNET BLVD., SUITE 100, BATON ROUGE, LA, 70810",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3793755,
    "lng": -91.0968593
  },
  {
    "id": "11380",
    "name": "CVS",
    "address": "20 EAST MONTAUK HWY,, LINDENHURST, NY, 11757",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6789907,
    "lng": -73.3640079
  },
  {
    "id": "11379",
    "name": "CVS",
    "address": "3890 PHELAN BLVD., BEAUMONT, TX, 77707",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0849401,
    "lng": -94.1426598
  },
  {
    "id": "11378",
    "name": "CVS",
    "address": "1540 E. MAIN ST., ALLEN, TX, 75002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.0996804,
    "lng": -96.6295338
  },
  {
    "id": "11377",
    "name": "CVS",
    "address": "341 COTTAGE GROVE RD., BLOOMFIELD, CT, 6002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8171963,
    "lng": -72.7148201
  },
  {
    "id": "11376",
    "name": "CVS",
    "address": "16 MAIN ST., EAST HARTFORD, CT, 6118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7283206,
    "lng": -72.6159946
  },
  {
    "id": "11375",
    "name": "CVS",
    "address": "4828 NELSON RD., LAKE CHARLES, LA, 70605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1692631,
    "lng": -93.2499556
  },
  {
    "id": "11374",
    "name": "CVS",
    "address": "661 MAIN STREET, TORRINGTON, CT, 6790",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8137189,
    "lng": -73.1221452
  },
  {
    "id": "11373",
    "name": "CVS",
    "address": "137 FEDERAL STREET, GREENFIELD, MA, 1301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5921381,
    "lng": -72.5972832
  },
  {
    "id": "11372",
    "name": "CVS",
    "address": "7001 NORTH HIGHWAY 309, COOPERSBURG, PA, 18036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5178028,
    "lng": -75.387818
  },
  {
    "id": "11371",
    "name": "CVS",
    "address": "416 ROUTE 9W, GLENMONT, NY, 12077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.601219,
    "lng": -73.7916345
  },
  {
    "id": "11370",
    "name": "CVS",
    "address": "27 MORRISTOWN RD., MATAWAN, NJ, 7747",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4283943,
    "lng": -74.2506707
  },
  {
    "id": "11369",
    "name": "CVS",
    "address": "20 FILORS LN., STONY POINT, NY, 10980",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2183076,
    "lng": -73.9875024
  },
  {
    "id": "11368",
    "name": "CVS",
    "address": "500 MAIN ROAD, TIVERTON, RI, 2878",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6591819,
    "lng": -71.1904312
  },
  {
    "id": "11367",
    "name": "CVS",
    "address": "76 SWAN STREET, METHUEN, MA, 1844",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.723234,
    "lng": -71.1579412
  },
  {
    "id": "11366",
    "name": "CVS",
    "address": "114 S. LONG BEACH RD., FREEPORT, NY, 11520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6529953,
    "lng": -73.5902592
  },
  {
    "id": "11365",
    "name": "CVS",
    "address": "14835 SUNNY DELL LANE, NOBLESVILLE, IN, 46062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0033554,
    "lng": -86.0697663
  },
  {
    "id": "11364",
    "name": "CVS",
    "address": "6005 ST. AUGUSTINE ROAD, JACKSONVILLE, FL, 32217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2607038,
    "lng": -81.6255222
  },
  {
    "id": "11363",
    "name": "CVS",
    "address": "20 HIGH STREET, PASCOAG, RI, 2859",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9551453,
    "lng": -71.7041244
  },
  {
    "id": "11362",
    "name": "CVS",
    "address": "450 MAIN ST., FARMINGDALE, NY, 11735",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7291178,
    "lng": -73.4459213
  },
  {
    "id": "11361",
    "name": "CVS",
    "address": "175 ROCK ROAD, GLEN ROCK, NJ, 7452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9630668,
    "lng": -74.1332633
  },
  {
    "id": "11360",
    "name": "CVS",
    "address": "90 MAIN STREET, WINDSOR LOCKS, CT, 6096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.93108,
    "lng": -72.6281448
  },
  {
    "id": "11359",
    "name": "CVS",
    "address": "1653 MAIN ST., ATHOL, MA, 1331",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5879274,
    "lng": -72.2152819
  },
  {
    "id": "11358",
    "name": "CVS",
    "address": "1826-30 CHESTNUT STREET, PHILADELPHIA, PA, 19103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9515505,
    "lng": -75.1717186
  },
  {
    "id": "11357",
    "name": "CVS",
    "address": "35 INTERSTATE SHOP CTR, RAMSEY, NJ, 7446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0667901,
    "lng": -74.1368123
  },
  {
    "id": "11356",
    "name": "CVS",
    "address": "9140 GUILBEAU, SAN ANTONIO, TX, 78250",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.5185678,
    "lng": -98.6631215
  },
  {
    "id": "11355",
    "name": "CVS",
    "address": "25 WOOD STREET, LOWELL, MA, 1851",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6332139,
    "lng": -71.3565414
  },
  {
    "id": "11354",
    "name": "CVS",
    "address": "2090 S HIGHWAY 29, CANTONMENT, FL, 32533",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5707405,
    "lng": -87.2902342
  },
  {
    "id": "11353",
    "name": "CVS",
    "address": "101 N. CLINTON ST., CHICAGO, IL, 60661",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8834779,
    "lng": -87.6409314
  },
  {
    "id": "11352",
    "name": "CVS",
    "address": "7 ESSEX WAY, ESSEX, VT, 5452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.509289,
    "lng": -73.0791051
  },
  {
    "id": "11351",
    "name": "CVS",
    "address": "160 RESERVOIR ROAD, HOLDEN, MA, 1520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3439367,
    "lng": -71.8620812
  },
  {
    "id": "11350",
    "name": "CVS",
    "address": "942A HYDE PARK AVENUE, HYDE PARK, MA, 2136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2675083,
    "lng": -71.1197752
  },
  {
    "id": "11349",
    "name": "CVS",
    "address": "351 W. SCHUYLKILL RD., BLDG 4, POTTSTOWN, PA, 19465",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2361783,
    "lng": -75.6616066
  },
  {
    "id": "11348",
    "name": "CVS",
    "address": "6204 14TH ST WEST, BRADENTON, FL, 34207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.430808,
    "lng": -82.5761023
  },
  {
    "id": "11347",
    "name": "CVS",
    "address": "927 PROVIDENCE ROAD, SECANE, PA, 19018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9180789,
    "lng": -75.3025422
  },
  {
    "id": "11346",
    "name": "CVS",
    "address": "656 NEW HAVEN AVE., DERBY, CT, 6418",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3118395,
    "lng": -73.0531377
  },
  {
    "id": "11345",
    "name": "CVS",
    "address": "835 NEWPORT AVE., PAWTUCKET, RI, 2861",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8786961,
    "lng": -71.3539535
  },
  {
    "id": "11344",
    "name": "CVS",
    "address": "675 COUNTY STREET, TAUNTON, MA, 2780",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8840776,
    "lng": -71.0673816
  },
  {
    "id": "11343",
    "name": "CVS",
    "address": "59 GEORGE ST., CHARLESTON, SC, 29401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7835113,
    "lng": -79.93634
  },
  {
    "id": "11342",
    "name": "CVS",
    "address": "1044 BOULEVARD, WEST HARTFORD, CT, 6119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7607938,
    "lng": -72.7160892
  },
  {
    "id": "11341",
    "name": "CVS",
    "address": "1671 HIGHWAY 71 EAST, BASTROP, TX, 78602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.1041695,
    "lng": -97.3082462
  },
  {
    "id": "11340",
    "name": "CVS",
    "address": "2434 CATASAUQUA ROAD, BETHLEHEM, PA, 18018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.643516,
    "lng": -75.4272803
  },
  {
    "id": "11339",
    "name": "CVS",
    "address": "638 CHANDLER STREET, WORCESTER, MA, 1602",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2769671,
    "lng": -71.8540863
  },
  {
    "id": "11338",
    "name": "CVS",
    "address": "492 CONCORD STREET, FRAMINGHAM, MA, 1702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2892415,
    "lng": -71.4099913
  },
  {
    "id": "11337",
    "name": "CVS",
    "address": "1 S NEW YORK RD, GALLOWAY, NJ, 8205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4936419,
    "lng": -74.4585161
  },
  {
    "id": "11336",
    "name": "CVS",
    "address": "4600 WASHINGTON STREET, ROSLINDALE, MA, 2131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2755097,
    "lng": -71.1390029
  },
  {
    "id": "11335",
    "name": "CVS",
    "address": "280 SOUTH MAIN STREET, NEW CITY, NY, 10956",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1377089,
    "lng": -73.9897061
  },
  {
    "id": "11334",
    "name": "CVS",
    "address": "372 WEST MAIN STREET, NORWICH, CT, 6360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5206303,
    "lng": -72.0917654
  },
  {
    "id": "11333",
    "name": "CVS",
    "address": "991 MAIN ST., SPRINGFIELD, MA, 1103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0990879,
    "lng": -72.5841462
  },
  {
    "id": "11332",
    "name": "CVS",
    "address": "272 HIGHLAND AVE., SALEM, MA, 1970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5038247,
    "lng": -70.9239361
  },
  {
    "id": "11331",
    "name": "CVS",
    "address": "34 CAMBRIDGE STREET, SPACE 160, BURLINGTON, MA, 1803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4833679,
    "lng": -71.1863784
  },
  {
    "id": "11330",
    "name": "CVS",
    "address": "215 ALEWIFE BROOK PARKWAY, CAMBRIDGE, MA, 2138",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3898516,
    "lng": -71.1437623
  },
  {
    "id": "11329",
    "name": "CVS",
    "address": "500 ROUTE 134, SOUTH DENNIS, MA, 2660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6948936,
    "lng": -70.1503056
  },
  {
    "id": "11328",
    "name": "CVS",
    "address": "189 WATERTOWN STREET, WATERTOWN, MA, 2472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3637788,
    "lng": -71.1943201
  },
  {
    "id": "11327",
    "name": "CVS",
    "address": "5300 VETERANS MEMORIAL BLVD., METAIRIE, LA, 70003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.0054202,
    "lng": -90.2001621
  },
  {
    "id": "11326",
    "name": "CVS",
    "address": "42 BEALE STREET, WOLLASTON, MA, 2170",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2665048,
    "lng": -71.0173683
  },
  {
    "id": "11325",
    "name": "CVS",
    "address": "1760 S MCCALL RD, ENGLEWOOD, FL, 34223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.9390339,
    "lng": -82.3380584
  },
  {
    "id": "11324",
    "name": "CVS",
    "address": "27 MAIN ST #43, WATERTOWN, MA, 2472",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3661596,
    "lng": -71.1849364
  },
  {
    "id": "11323",
    "name": "CVS",
    "address": "311 NEWBURY ST., DANVERS, MA, 1923",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5868978,
    "lng": -70.9649894
  },
  {
    "id": "11322",
    "name": "CVS",
    "address": "85 HIGH STREET, MEDFORD, MA, 2155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4190463,
    "lng": -71.112265
  },
  {
    "id": "11321",
    "name": "CVS",
    "address": "21 AUSTIN ST., BUNKER HILL MALL, CHARLESTOWN, MA, 2129",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.375964,
    "lng": -71.0654772
  },
  {
    "id": "11320",
    "name": "CVS",
    "address": "1267 MAIN ST.,, BROCKTON, MA, 2301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0604035,
    "lng": -71.0149923
  },
  {
    "id": "11319",
    "name": "CVS",
    "address": "316 NORTH PEARL STREET, BROCKTON, MA, 2301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0997511,
    "lng": -71.0671872
  },
  {
    "id": "11318",
    "name": "CVS",
    "address": "512 SOUTH BROADWAY, SALEM, NH, 3079",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7428447,
    "lng": -71.2004562
  },
  {
    "id": "11317",
    "name": "CVS",
    "address": "214 DANIEL WEBSTER HIGHWAY, NASHUA, NH, 3060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7139059,
    "lng": -71.4418565
  },
  {
    "id": "11316",
    "name": "CVS",
    "address": "1080 EASTERN AVE., MALDEN, MA, 2148",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4306398,
    "lng": -71.0394907
  },
  {
    "id": "11315",
    "name": "CVS",
    "address": "206 GLEN COVE AVENUE, GLEN COVE, NY, 11542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8486531,
    "lng": -73.6348104
  },
  {
    "id": "11314",
    "name": "CVS",
    "address": "1544 CRESCENT ROAD, CLIFTON PARK, NY, 12065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.818482,
    "lng": -73.7731835
  },
  {
    "id": "11313",
    "name": "CVS",
    "address": "2 MILLISTON RD, MILLIS, MA, 2054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.167929,
    "lng": -71.3540927
  },
  {
    "id": "11312",
    "name": "CVS",
    "address": "131 WEBSTER AVENUE, PROVIDENCE, RI, 2909",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8123285,
    "lng": -71.4505214
  },
  {
    "id": "11311",
    "name": "CVS",
    "address": "403 ATLANTIC AVENUE, FREEPORT, NY, 11520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6437379,
    "lng": -73.5936878
  },
  {
    "id": "11310",
    "name": "CVS",
    "address": "30 MALL DRIVE W., JERSEY CITY, NJ, 7310",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7268406,
    "lng": -74.0379931
  },
  {
    "id": "11309",
    "name": "CVS",
    "address": "3915 W COMMERCIAL BLVD, TAMARAC, FL, 33309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1873634,
    "lng": -80.2029361
  },
  {
    "id": "11308",
    "name": "CVS",
    "address": "1702 S. BROADWAY AVE., TYLER, TX, 75701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.3304757,
    "lng": -95.2998776
  },
  {
    "id": "11307",
    "name": "CVS",
    "address": "548 DOYLESTOWN RD., LANSDALE, PA, 19446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2655761,
    "lng": -75.2296289
  },
  {
    "id": "11306",
    "name": "CVS",
    "address": "201 GLEN ST., GLEN COVE, NY, 11542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8619968,
    "lng": -73.6222997
  },
  {
    "id": "11305",
    "name": "CVS",
    "address": "2019 LAKEVIEW AVENUE, DRACUT, MA, 1826",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6834656,
    "lng": -71.3528249
  },
  {
    "id": "11304",
    "name": "CVS",
    "address": "3501 W DAVIE BLVD, FORT LAUDERDALE, FL, 33312",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1050046,
    "lng": -80.1937397
  },
  {
    "id": "11303",
    "name": "CVS",
    "address": "198 MAIN STREET, RIDGEFIELD PARK, NJ, 7660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8564837,
    "lng": -74.0254679
  },
  {
    "id": "11302",
    "name": "CVS",
    "address": "1601 W. LIBERTY STREET, ALLENTOWN, PA, 18102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6042477,
    "lng": -75.4940513
  },
  {
    "id": "11301",
    "name": "CVS",
    "address": "105 MAIN ST., MAYNARD, MA, 1754",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4322103,
    "lng": -71.4543792
  },
  {
    "id": "11300",
    "name": "CVS",
    "address": "555 WASHINGTON STREET, SOUTH EASTON, MA, 2375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0490202,
    "lng": -71.0843647
  },
  {
    "id": "11299",
    "name": "CVS",
    "address": "1001 THORNDIKE ST., PALMER, MA, 1069",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1574604,
    "lng": -72.3292409
  },
  {
    "id": "11298",
    "name": "CVS",
    "address": "187 COLUMBIA TURNPIKE, FLORHAM PARK, NJ, 7932",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7879654,
    "lng": -74.3921472
  },
  {
    "id": "11297",
    "name": "CVS",
    "address": "421 GLEN COVE ROAD, EAST HILLS, NY, 11577",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7852012,
    "lng": -73.6232196
  },
  {
    "id": "11296",
    "name": "CVS",
    "address": "3401 SIMPSON AVENUE, OCEAN CITY, NJ, 8226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2522486,
    "lng": -74.61362
  },
  {
    "id": "11295",
    "name": "CVS",
    "address": "1520 NORTHAMPTON STREET, EASTON, PA, 18042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6893032,
    "lng": -75.2325461
  },
  {
    "id": "11294",
    "name": "CVS",
    "address": "11 STEEPLE WAY, PO BOX 130, WELLS, ME, 4090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3014273,
    "lng": -70.5872937
  },
  {
    "id": "11293",
    "name": "CVS",
    "address": "4361 SWAMP ROAD, DOYLESTOWN, PA, 18901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3330885,
    "lng": -75.1331486
  },
  {
    "id": "11292",
    "name": "CVS",
    "address": "430 WESTFIELD AVENUE, ELIZABETH, NJ, 7208",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6657023,
    "lng": -74.2312303
  },
  {
    "id": "11291",
    "name": "CVS",
    "address": "45 SOUTH MAIN ST, FARMINGTON PLAZA, UNIONVILLE, CT, 6085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7563873,
    "lng": -72.8861162
  },
  {
    "id": "11290",
    "name": "CVS",
    "address": "2291 MERRICK RD., MERRICK, NY, 11566",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6608393,
    "lng": -73.5409618
  },
  {
    "id": "11289",
    "name": "CVS",
    "address": "1501 PAOLI PIKE, WEST CHESTER, PA, 19380",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9901211,
    "lng": -75.5510966
  },
  {
    "id": "11288",
    "name": "CVS",
    "address": "28 ABBY RD., PALMYRA, VA, 22963",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.898966,
    "lng": -78.3124725
  },
  {
    "id": "11287",
    "name": "CVS",
    "address": "323 N. MAIN ST., UXBRIDGE, MA, 1569",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0907816,
    "lng": -71.6422231
  },
  {
    "id": "11286",
    "name": "CVS",
    "address": "465 STATION AVENUE, SOUTH YARMOUTH, MA, 2664",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6851114,
    "lng": -70.209254
  },
  {
    "id": "11285",
    "name": "CVS",
    "address": "1200 MAIN STREET, WILLIMANTIC, CT, 6226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7136238,
    "lng": -72.225229
  },
  {
    "id": "11284",
    "name": "CVS",
    "address": "844 JONES HILL ROAD, WEST HAVEN, CT, 6516",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2597392,
    "lng": -72.9653058
  },
  {
    "id": "11283",
    "name": "CVS",
    "address": "8 EAST WASHINGTON STREET, NORTH ATTLEBORO, MA, 2760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9673276,
    "lng": -71.3383654
  },
  {
    "id": "11282",
    "name": "CVS",
    "address": "3211 RTE 27 SOUTH, FRANKLIN PARK, NJ, 8823",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4339701,
    "lng": -74.5473
  },
  {
    "id": "11281",
    "name": "CVS",
    "address": "891 NORTH COLONY RD., WALLINGFORD, CT, 6492",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.481111,
    "lng": -72.811389
  },
  {
    "id": "11280",
    "name": "CVS",
    "address": "101 HIALEAH DR, HIALEAH, FL, 33010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8232573,
    "lng": -80.278518
  },
  {
    "id": "11279",
    "name": "CVS",
    "address": "272 EAST CENTRAL STREET, ROUTE 140, FRANKLIN, MA, 2038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0796946,
    "lng": -71.3849472
  },
  {
    "id": "11278",
    "name": "CVS",
    "address": "800 WEST OLD SETTLERS BLVD, ROUND ROCK, TX, 78681",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.538531,
    "lng": -97.679258
  },
  {
    "id": "11277",
    "name": "CVS",
    "address": "830 CARR 857, CAROLINA, PR, 987",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.3747621,
    "lng": -65.9338084
  },
  {
    "id": "11276",
    "name": "CVS",
    "address": "499 MONTAUK HIGHWAY, WEST ISLIP, NY, 11795",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6973936,
    "lng": -73.3083229
  },
  {
    "id": "11275",
    "name": "CVS",
    "address": "792 MAIN ST., CLINTON, MA, 1510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4258865,
    "lng": -71.6881925
  },
  {
    "id": "11274",
    "name": "CVS",
    "address": "964 POST ROAD, DARIEN, CT, 6820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0762787,
    "lng": -73.4707246
  },
  {
    "id": "11273",
    "name": "CVS",
    "address": "26 DAVIS ST., OAKVILLE, CT, 6779",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5881873,
    "lng": -73.0893881
  },
  {
    "id": "11272",
    "name": "CVS",
    "address": "19 DODGE ST., BEVERLY, MA, 1915",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5774649,
    "lng": -70.8894279
  },
  {
    "id": "11271",
    "name": "CVS",
    "address": "19 SUMMER ST., BRIDGEWATER, MA, 2324",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9890603,
    "lng": -70.9740562
  },
  {
    "id": "11270",
    "name": "CVS",
    "address": "2175 E. BARDSLEY AVE., TULARE, CA, 93274",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.1961325,
    "lng": -119.3141852
  },
  {
    "id": "11269",
    "name": "CVS",
    "address": "890 SAINT GEORGE'S AVENUE, RAHWAY, NJ, 7065",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6057268,
    "lng": -74.2897287
  },
  {
    "id": "11268",
    "name": "CVS",
    "address": "3298 EDGEMONT AVE., BROOKHAVEN, PA, 19015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9314477,
    "lng": -75.2889567
  },
  {
    "id": "11267",
    "name": "CVS",
    "address": "456 DANIEL WEBSTER HIGHWAY, MERRIMACK, NH, 3054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8637241,
    "lng": -71.4940315
  },
  {
    "id": "11266",
    "name": "CVS",
    "address": "1000 S ELMORA AVE, COLOR PLZ, SPACE D, ELIZABETH, NJ, 7202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6523873,
    "lng": -74.2250859
  },
  {
    "id": "11265",
    "name": "CVS",
    "address": "9031 SW 107TH AVE, MIAMI, FL, 33176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.6845091,
    "lng": -80.3650385
  },
  {
    "id": "11264",
    "name": "CVS",
    "address": "839 EAST MAIN STREET, MERIDEN, CT, 6450",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5277275,
    "lng": -72.7752182
  },
  {
    "id": "11263",
    "name": "CVS",
    "address": "1371 LAKE SHORE RD., GILFORD, NH, 3249",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.5622044,
    "lng": -71.4479942
  },
  {
    "id": "11262",
    "name": "CVS",
    "address": "4 RYAN RD., MARLBORO, NJ, 7746",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3037352,
    "lng": -74.2537425
  },
  {
    "id": "11261",
    "name": "CVS",
    "address": "6 POST OFFICE SQ, HARWICHPORT, MA, 2646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6677857,
    "lng": -70.0811097
  },
  {
    "id": "11260",
    "name": "CVS",
    "address": "315 WEST EMAUS AVENUE, ALLENTOWN, PA, 18103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5785799,
    "lng": -75.4542274
  },
  {
    "id": "11259",
    "name": "CVS",
    "address": "1060 NORTH DELSEA DRIVE BLDG. 3, GLASSBORO, NJ, 8028",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6717856,
    "lng": -75.0959746
  },
  {
    "id": "11258",
    "name": "CVS",
    "address": "327 MAIN AVENUE, NORWALK, CT, 6851",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1365648,
    "lng": -73.4252955
  },
  {
    "id": "11257",
    "name": "CVS",
    "address": "2250 NEW LONDON TURNPIKE, EAST GREENWICH, RI, 2818",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6623057,
    "lng": -71.542701
  },
  {
    "id": "11256",
    "name": "CVS",
    "address": "5999 NORMANDY BLVD, JACKSONVILLE, FL, 32205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3068452,
    "lng": -81.7514165
  },
  {
    "id": "11255",
    "name": "CVS",
    "address": "20 KINDERKAMACK ROAD, MONTVALE, NJ, 7645",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0388522,
    "lng": -74.0286852
  },
  {
    "id": "11254",
    "name": "CVS",
    "address": "674 ISLINGTON STREET, PORTSMOUTH, NH, 3801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0701555,
    "lng": -70.7711677
  },
  {
    "id": "11253",
    "name": "CVS",
    "address": "929 MAIN STREET, WALPOLE, MA, 2081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1480465,
    "lng": -71.2526188
  },
  {
    "id": "11252",
    "name": "CVS",
    "address": "235 CENTER ST., CHICOPEE, MA, 1013",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1418458,
    "lng": -72.6109481
  },
  {
    "id": "11251",
    "name": "CVS",
    "address": "14 FARMINGTON AVENUE, PLAINVILLE, CT, 6062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6753686,
    "lng": -72.8573877
  },
  {
    "id": "11250",
    "name": "CVS",
    "address": "427 EAST MAIN ST, WESTFIELD SHOPS, WESTFIELD, MA, 1085",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1131994,
    "lng": -72.7247249
  },
  {
    "id": "11249",
    "name": "CVS",
    "address": "360 RTE 73 SOUTH, MARLTON, NJ, 8053",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.888003,
    "lng": -74.9230012
  },
  {
    "id": "11248",
    "name": "CVS",
    "address": "824 BLACK HORSE PIKE, RUNNEMEDE, NJ, 8078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8565804,
    "lng": -75.074575
  },
  {
    "id": "11247",
    "name": "CVS",
    "address": "103 W. EDINBURG AVE., ELSA, TX, 78543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2939961,
    "lng": -97.9937747
  },
  {
    "id": "11246",
    "name": "CVS",
    "address": "644 NORTH ROUTE 59, NAPERVILLE, IL, 60563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7818941,
    "lng": -88.2048072
  },
  {
    "id": "11245",
    "name": "CVS",
    "address": "VILLA CAPARRA 178 CARR 2, GUAYNABO, PR, 966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 18.4029836,
    "lng": -66.1182426
  },
  {
    "id": "11244",
    "name": "CVS",
    "address": "935 RIDGE ROAD, WEBSTER, NY, 14580",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.2072147,
    "lng": -77.4644793
  },
  {
    "id": "11243",
    "name": "CVS",
    "address": "5020 PENNELL RD., ASTON, PA, 19014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8665577,
    "lng": -75.4273258
  },
  {
    "id": "11242",
    "name": "CVS",
    "address": "2721 BRUNSWICK PIKE, LAWRENCEVILLE, NJ, 8648",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2651756,
    "lng": -74.7192785
  },
  {
    "id": "11241",
    "name": "CVS",
    "address": "40 EAST ST., NEW MILFORD, CT, 6776",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5793489,
    "lng": -73.4077831
  },
  {
    "id": "11240",
    "name": "CVS",
    "address": "1457 8TH AVENUE, BETHLEHEM, PA, 18018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6328631,
    "lng": -75.396094
  },
  {
    "id": "11239",
    "name": "CVS",
    "address": "1201-1203 RICHMOND AVENUE, POINT PLEASANT BEACH, NJ, 8742",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.085055,
    "lng": -74.0493686
  },
  {
    "id": "11238",
    "name": "CVS",
    "address": "50 WEST MADISON AVE., DUMONT, NJ, 7628",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9414288,
    "lng": -73.9965009
  },
  {
    "id": "11237",
    "name": "CVS",
    "address": "1150 WHALLEY AVE., NEW HAVEN, CT, 6515",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.32897,
    "lng": -72.9684147
  },
  {
    "id": "11236",
    "name": "CVS",
    "address": "188 CENTRAL ST., LEOMINSTER, MA, 1453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5188193,
    "lng": -71.757773
  },
  {
    "id": "11235",
    "name": "CVS",
    "address": "1024 BROADWAY, THORNWOOD CENTER, THORNWOOD, NY, 10594",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1265448,
    "lng": -73.7791795
  },
  {
    "id": "11234",
    "name": "CVS",
    "address": "51 MARKET ST., SOUTH PORTLAND, ME, 4106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6361823,
    "lng": -70.2550544
  },
  {
    "id": "11233",
    "name": "CVS",
    "address": "1364 CONGRESS ST, PORTLAND, ME, 4102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6578153,
    "lng": -70.297176
  },
  {
    "id": "11232",
    "name": "CVS",
    "address": "2320 RALPH AVE., BROOKLYN, NY, 11234",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6213139,
    "lng": -73.9178411
  },
  {
    "id": "11231",
    "name": "CVS",
    "address": "131 COURT ST., BATH, ME, 4530",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.9094905,
    "lng": -69.8280032
  },
  {
    "id": "11230",
    "name": "CVS",
    "address": "786 ASHLEY BLVD., NEW BEDFORD, MA, 2745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.681496,
    "lng": -70.9332871
  },
  {
    "id": "11229",
    "name": "CVS",
    "address": "10250 BRISTOW CENTER DR., BRISTOW, VA, 20136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7343457,
    "lng": -77.549627
  },
  {
    "id": "11228",
    "name": "CVS",
    "address": "920 BETHLEHEM PIKE, ERDENHEIM, PA, 19038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0974408,
    "lng": -75.2124437
  },
  {
    "id": "11227",
    "name": "CVS",
    "address": "510 PROSPECT AVENUE, LITTLE SILVER, NJ, 7739",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3383726,
    "lng": -74.0417169
  },
  {
    "id": "11226",
    "name": "CVS",
    "address": "632 MIDDLE TURNPIKE, STORRS MANSFIELD, CT, 6268",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8266642,
    "lng": -72.2667739
  },
  {
    "id": "11225",
    "name": "CVS",
    "address": "2982 ROUTE 9, VALATIE, NY, 12184",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4289414,
    "lng": -73.6877423
  },
  {
    "id": "11224",
    "name": "CVS",
    "address": "1276 UPPER FRONT ST., BINGHAMTON, NY, 13901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1585519,
    "lng": -75.8946945
  },
  {
    "id": "11223",
    "name": "CVS",
    "address": "1301 RHAWN ST., PHILADELPHIA, PA, 19111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0689852,
    "lng": -75.0666815
  },
  {
    "id": "11222",
    "name": "CVS",
    "address": "1170 WESTERN AVENUE, ALBANY, NY, 12203",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6763514,
    "lng": -73.8237567
  },
  {
    "id": "11221",
    "name": "CVS",
    "address": "307 POST AVENUE, WESTBURY, NY, 11590",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.759899,
    "lng": -73.5885067
  },
  {
    "id": "11220",
    "name": "CVS",
    "address": "850 BRONX RIVER RD, 18 FLEETWOOD PLAZA, YONKERS, NY, 10708",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9277183,
    "lng": -73.842182
  },
  {
    "id": "11219",
    "name": "CVS",
    "address": "2045 DIXWELL AVE., HAMDEN, CT, 6514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3672067,
    "lng": -72.9191568
  },
  {
    "id": "11218",
    "name": "CVS",
    "address": "6150 N 5TH STREET, PHILADELPHIA, PA, 19120",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0453238,
    "lng": -75.1289069
  },
  {
    "id": "11217",
    "name": "CVS",
    "address": "2390 N. FEDERAL HWY, BOCA RATON, FL, 33431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3701805,
    "lng": -80.0761044
  },
  {
    "id": "11216",
    "name": "CVS",
    "address": "410 EAST CHESTER PIKE, RIDLEY PARK, PA, 19078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8777464,
    "lng": -75.3165741
  },
  {
    "id": "11215",
    "name": "CVS",
    "address": "399 MAIN STREET, SOUTHBRIDGE, MA, 1550",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.076291,
    "lng": -72.0362639
  },
  {
    "id": "11214",
    "name": "CVS",
    "address": "560 PASSIAC AVE, WEST CALDWELL S/C, WEST CALDWELL, NJ, 7006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8490924,
    "lng": -74.2965058
  },
  {
    "id": "11213",
    "name": "CVS",
    "address": "1252 STELTON RD., PISCATAWAY, NJ, 8854",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.541418,
    "lng": -74.4244416
  },
  {
    "id": "11212",
    "name": "CVS",
    "address": "185 WINTON RD NORTH, ROCHESTER, NY, 14610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.149177,
    "lng": -77.5541501
  },
  {
    "id": "11211",
    "name": "CVS",
    "address": "434 RANTOUL ST., BEVERLY, MA, 1915",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.555267,
    "lng": -70.8817642
  },
  {
    "id": "11210",
    "name": "CVS",
    "address": "875 ENFIELD ST, ENFIELD PLAZA SHOPPES, ENFIELD, CT, 6082",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9980094,
    "lng": -72.5936633
  },
  {
    "id": "11209",
    "name": "CVS",
    "address": "17-19 WASHINGTON STREET, TENAFLY, NJ, 7670",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9256012,
    "lng": -73.9655156
  },
  {
    "id": "11208",
    "name": "CVS",
    "address": "171 NORTH MAIN STREET, RANDOLPH, MA, 2368",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1654955,
    "lng": -71.042066
  },
  {
    "id": "11207",
    "name": "CVS",
    "address": "594 ATLANTIC AVE., EAST ROCKAWAY, NY, 11518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6411694,
    "lng": -73.6637303
  },
  {
    "id": "11206",
    "name": "CVS",
    "address": "755 S. CHESTER RD., SWARTHMORE, PA, 19081",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8882337,
    "lng": -75.3546541
  },
  {
    "id": "11205",
    "name": "CVS",
    "address": "7 POPHAM RD., SCARSDALE, NY, 10583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9890504,
    "lng": -73.8091438
  },
  {
    "id": "11204",
    "name": "CVS",
    "address": "66 SOUTH RIVER RD., BEDFORD, NH, 3110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9594979,
    "lng": -71.4800715
  },
  {
    "id": "11203",
    "name": "CVS",
    "address": "10901C BUSTLETON AVENUE, PHILADELPHIA, PA, 19116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1122896,
    "lng": -75.0229175
  },
  {
    "id": "11202",
    "name": "CVS",
    "address": "727 MAIN ST., EAST AURORA, NY, 14052",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7674921,
    "lng": -78.6076009
  },
  {
    "id": "11201",
    "name": "CVS",
    "address": "199 GREAT ROAD, BEDFORD, MA, 1730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4890462,
    "lng": -71.2725406
  },
  {
    "id": "11200",
    "name": "CVS",
    "address": "976 ROUTE 28, SOUTH YARMOUTH, MA, 2664",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6565962,
    "lng": -70.2060914
  },
  {
    "id": "11199",
    "name": "CVS",
    "address": "2400 WARWICK AVE, MEADOWBROOK PLAZA, WARWICK, RI, 2889",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7121262,
    "lng": -71.3981683
  },
  {
    "id": "11198",
    "name": "CVS",
    "address": "34 CONGRESS ST., SARATOGA SPRINGS, NY, 12866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0785019,
    "lng": -73.78866
  },
  {
    "id": "11197",
    "name": "CVS",
    "address": "501 BOSTON POST RD, RTE 20, SUDBURY PLZ, SUDBURY, MA, 1776",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3594354,
    "lng": -71.428313
  },
  {
    "id": "11196",
    "name": "CVS",
    "address": "315 BROAD ST,, CUMBERLAND, RI, 2864",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9079016,
    "lng": -71.392888
  },
  {
    "id": "11195",
    "name": "CVS",
    "address": "392 KENMORE AVENUE, BUFFALO, NY, 14223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9577466,
    "lng": -78.8323274
  },
  {
    "id": "11194",
    "name": "CVS",
    "address": "560 N. GREENBUSH RD., RENSSELAER, NY, 12144",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6495945,
    "lng": -73.6976741
  },
  {
    "id": "11193",
    "name": "CVS",
    "address": "633 AMHERST ST., NASHUA, NH, 3063",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8039004,
    "lng": -71.541191
  },
  {
    "id": "11192",
    "name": "CVS",
    "address": "334 BALTIMORE PIKE, THE SPARNS CENTER, SPRINGFIELD, PA, 19064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9220633,
    "lng": -75.3204794
  },
  {
    "id": "11191",
    "name": "CVS",
    "address": "2235 DORCHESTER AVENUE, BOSTON, MA, 2124",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2739749,
    "lng": -71.0686728
  },
  {
    "id": "11190",
    "name": "CVS",
    "address": "24 PERSHING DRIVE # 36, ANSONIA, CT, 6401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3337536,
    "lng": -73.0833875
  },
  {
    "id": "11189",
    "name": "CVS",
    "address": "36 WHITE STREET, CAMBRIDGE, MA, 2140",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3888772,
    "lng": -71.1189443
  },
  {
    "id": "11188",
    "name": "CVS",
    "address": "269 LIVINGSTON ST STE A, NORTHVALE, NJ, 7647",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0154053,
    "lng": -73.9459265
  },
  {
    "id": "11187",
    "name": "CVS",
    "address": "2440 HAMBURG TURNPIKE, WAYNE, NJ, 7470",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9907211,
    "lng": -74.279094
  },
  {
    "id": "11186",
    "name": "CVS",
    "address": "532 MEDFORD ST., SOMERVILLE, MA, 2145",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3969161,
    "lng": -71.1042804
  },
  {
    "id": "11185",
    "name": "CVS",
    "address": "294 9TH ST S, NAPLES, FL, 34102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.1442339,
    "lng": -81.7954961
  },
  {
    "id": "11184",
    "name": "CVS",
    "address": "1708 N MONROE ST, TALLAHASSEE, FL, 32303",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.4632085,
    "lng": -84.2829744
  },
  {
    "id": "11183",
    "name": "CVS",
    "address": "1000 EAST TARPON AVE., TARPON SPRINGS, FL, 34689",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.1456497,
    "lng": -82.7393993
  },
  {
    "id": "11182",
    "name": "CVS",
    "address": "676 SOUTHBRIDGE STREET, AUBURN, MA, 1501",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1853277,
    "lng": -71.8577707
  },
  {
    "id": "11181",
    "name": "CVS",
    "address": "500 GRAFTON STREET, WORCESTER, MA, 1604",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2502605,
    "lng": -71.7795235
  },
  {
    "id": "11180",
    "name": "CVS",
    "address": "400 MASSACHUSETTS AVE., ACTON, MA, 1720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4741341,
    "lng": -71.4504624
  },
  {
    "id": "11179",
    "name": "CVS",
    "address": "264 W. BOYLSTON ST., WEST BOYLSTON, MA, 1583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.345355,
    "lng": -71.7875265
  },
  {
    "id": "11178",
    "name": "CVS",
    "address": "24 WEST MAIN STREET, NORTHBOROUGH, MA, 1532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3203617,
    "lng": -71.6430002
  },
  {
    "id": "11177",
    "name": "CVS",
    "address": "1100 EAST BOSTON POST ROAD, MAMARONECK, NY, 10543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9540753,
    "lng": -73.7208465
  },
  {
    "id": "11176",
    "name": "CVS",
    "address": "14 CANDLEWOOD LAKE RD., BROOKFIELD, CT, 6804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4346751,
    "lng": -73.4130486
  },
  {
    "id": "11175",
    "name": "CVS",
    "address": "1616 MEMORIAL DR., CHICOPEE, MA, 1020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2023286,
    "lng": -72.5725635
  },
  {
    "id": "11174",
    "name": "CVS",
    "address": "1181 MAIN STREET, NEWINGTON, CT, 6111",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6957031,
    "lng": -72.723115
  },
  {
    "id": "11173",
    "name": "CVS",
    "address": "2790 POST ROAD, WARWICK, RI, 2886",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7083465,
    "lng": -71.4500667
  },
  {
    "id": "11172",
    "name": "CVS",
    "address": "514 BLOOMFIELD AVENUE, MONTCLAIR, NJ, 7042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8147551,
    "lng": -74.21895
  },
  {
    "id": "11171",
    "name": "CVS",
    "address": "1145 KEMPTON STREET, NEW BEDFORD, MA, 2740",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6370016,
    "lng": -70.956584
  },
  {
    "id": "11170",
    "name": "CVS",
    "address": "7930 MADISON AVE., INDIANAPOLIS, IN, 46227",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6507486,
    "lng": -86.123254
  },
  {
    "id": "11169",
    "name": "CVS",
    "address": "1008 UNION CENTER MAINE HWY, ENDICOTT, NY, 13760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1102486,
    "lng": -76.0706012
  },
  {
    "id": "11168",
    "name": "CVS",
    "address": "2655 RICHMOND AVE, STATEN ISLAND MALL, STATEN ISLAND, NY, 10314",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5818451,
    "lng": -74.1658599
  },
  {
    "id": "11167",
    "name": "CVS",
    "address": "2300 IOWA ST., LAWRENCE, KS, 66046",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9420104,
    "lng": -95.2597107
  },
  {
    "id": "11166",
    "name": "CVS",
    "address": "159 N. MACDADE BLVD., GLENOLDEN, PA, 19036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9070035,
    "lng": -75.2867777
  },
  {
    "id": "11165",
    "name": "CVS",
    "address": "980-986 GREAT PLAIN AVENUE, NEEDHAM, MA, 2492",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2799556,
    "lng": -71.2362839
  },
  {
    "id": "11164",
    "name": "CVS",
    "address": "31-33 MAIN STREET, RUTLAND, VT, 5701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6104884,
    "lng": -72.9736223
  },
  {
    "id": "11163",
    "name": "CVS",
    "address": "1099 NEW BRITAIN AVENUE, WEST HARTFORD, CT, 6110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.731543,
    "lng": -72.7301279
  },
  {
    "id": "11162",
    "name": "CVS",
    "address": "601 SMITHFIELD AVENUE, PAWTUCKET, RI, 2860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8790619,
    "lng": -71.4143128
  },
  {
    "id": "11161",
    "name": "CVS",
    "address": "413 PARADISE ROAD, SWAMPSCOTT, MA, 1907",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4808664,
    "lng": -70.902154
  },
  {
    "id": "11160",
    "name": "CVS",
    "address": "3110 ROUTE 38, MOUNT LAUREL, NJ, 8054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9701968,
    "lng": -74.8732822
  },
  {
    "id": "11159",
    "name": "CVS",
    "address": "2287 MORRIS AVENUE, UNION, NJ, 7083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.699795,
    "lng": -74.2824404
  },
  {
    "id": "11158",
    "name": "CVS",
    "address": "175 MAIN STREET, WOBURN, MA, 1801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4720694,
    "lng": -71.1494005
  },
  {
    "id": "11157",
    "name": "CVS",
    "address": "9875 BUSTLETON AVENUE, PHILADELPHIA, PA, 19115",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0929012,
    "lng": -75.0308589
  },
  {
    "id": "11156",
    "name": "CVS",
    "address": "7 YORK ROAD, WARMINSTER, PA, 18974",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1902824,
    "lng": -75.1022679
  },
  {
    "id": "11155",
    "name": "CVS",
    "address": "400 PARK AVE., WORCESTER, MA, 1610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2576266,
    "lng": -71.823315
  },
  {
    "id": "11154",
    "name": "CVS",
    "address": "54 HAMBURG TURNPIKE, PREAKNESS S/C, WAYNE, NJ, 7470",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9622494,
    "lng": -74.2460921
  },
  {
    "id": "11153",
    "name": "CVS",
    "address": "344 GREAT ROAD, ACTON, MA, 1720",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5024228,
    "lng": -71.4204278
  },
  {
    "id": "11152",
    "name": "CVS",
    "address": "37943 EILAND BLVD, ZEPHYRHILLS, FL, 33542",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.2525235,
    "lng": -82.1889987
  },
  {
    "id": "11151",
    "name": "CVS",
    "address": "1351 WHITE MOUNTAIN HWY/NORTHWAY SHPGPLZ, NORTH CONWAY, NH, 3860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.0161088,
    "lng": -71.1132664
  },
  {
    "id": "11150",
    "name": "CVS",
    "address": "250 PLAINFIELD RD., WEST LEBANON, NH, 3784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.6301797,
    "lng": -72.3238253
  },
  {
    "id": "11149",
    "name": "CVS",
    "address": "400 METACOM AVENUE, BRISTOL, RI, 2809",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6801188,
    "lng": -71.2598597
  },
  {
    "id": "11148",
    "name": "CVS",
    "address": "767 WARWICK AVENUE, WARWICK, RI, 2888",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7552512,
    "lng": -71.4051208
  },
  {
    "id": "11147",
    "name": "CVS",
    "address": "1 ORANGETOWN SHOPPING CENTER, ORANGEBURG, NY, 10962",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0455021,
    "lng": -73.9529547
  },
  {
    "id": "11146",
    "name": "CVS",
    "address": "268 WEST ST., KEENE, NH, 3431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9319603,
    "lng": -72.2884682
  },
  {
    "id": "11145",
    "name": "CVS",
    "address": "74 SOUTH LAKEVIEW DR., GIBBSBORO, NJ, 8026",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8379326,
    "lng": -74.9595094
  },
  {
    "id": "11144",
    "name": "CVS",
    "address": "65 ROUTE 6A, SANDWICH, MA, 2563",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7662042,
    "lng": -70.5095321
  },
  {
    "id": "11143",
    "name": "CVS",
    "address": "351 BEDFORD STREET, WHITMAN, MA, 2382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0698286,
    "lng": -70.9475283
  },
  {
    "id": "11142",
    "name": "CVS",
    "address": "189 SUMMER STREET, KINGSTON, MA, 2364",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0122893,
    "lng": -70.7319939
  },
  {
    "id": "11141",
    "name": "CVS",
    "address": "4 BROADWAY ROAD, DRACUT, MA, 1826",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6714139,
    "lng": -71.2964225
  },
  {
    "id": "11140",
    "name": "CVS",
    "address": "75 N. MIDDLETOWN RD., PEARL RIVER, NY, 10965",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0605059,
    "lng": -74.013395
  },
  {
    "id": "11139",
    "name": "CVS",
    "address": "600 NE 128TH ST, NORTH MIAMI, FL, 33161",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.8926369,
    "lng": -80.1863732
  },
  {
    "id": "11138",
    "name": "CVS",
    "address": "397 POST ROAD EAST, WESTPORT, CT, 6880",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1406735,
    "lng": -73.3516193
  },
  {
    "id": "11137",
    "name": "CVS",
    "address": "763 TIOGUE AVENUE, COVENTRY, RI, 2816",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6834712,
    "lng": -71.56133
  },
  {
    "id": "11136",
    "name": "CVS",
    "address": "1 KENNEDY MEMORIAL DR., WATERVILLE, ME, 4901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.5409212,
    "lng": -69.6496637
  },
  {
    "id": "11135",
    "name": "CVS",
    "address": "1150 SARATOGA STREET, EAST BOSTON, MA, 2128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3845852,
    "lng": -70.9991664
  },
  {
    "id": "11134",
    "name": "CVS",
    "address": "805 MAMARONECK AVENUE, MAMARONECK, NY, 10543",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9566943,
    "lng": -73.736845
  },
  {
    "id": "11133",
    "name": "CVS",
    "address": "233 BROADWAY, METHUEN, MA, 1844",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7257127,
    "lng": -71.184676
  },
  {
    "id": "11132",
    "name": "CVS",
    "address": "9202 N FLORIDA AVE, TAMPA, FL, 33612",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0333903,
    "lng": -82.46034
  },
  {
    "id": "11131",
    "name": "CVS",
    "address": "10 SARAH'S WAY, ROUTE 6, FAIRHAVEN, MA, 2719",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6458003,
    "lng": -70.897045
  },
  {
    "id": "11130",
    "name": "CVS",
    "address": "364 RIVER ROAD, NEW MILFORD, NJ, 7646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9406999,
    "lng": -74.0217474
  },
  {
    "id": "11129",
    "name": "CVS",
    "address": "6495 POST ROAD, NORTH KINGSTOWN, RI, 2852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6208365,
    "lng": -71.4590124
  },
  {
    "id": "11128",
    "name": "CVS",
    "address": "48 E. BROADWAY, DERRY, NH, 3038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8825283,
    "lng": -71.3237509
  },
  {
    "id": "11127",
    "name": "CVS",
    "address": "2100 MONROE AVENUE, ROCHESTER, NY, 14618",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1238494,
    "lng": -77.5609233
  },
  {
    "id": "11126",
    "name": "CVS",
    "address": "1054 CASS AVENUE, WOONSOCKET, RI, 2895",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0045972,
    "lng": -71.4799798
  },
  {
    "id": "11125",
    "name": "CVS",
    "address": "1706 US HWY 1, VERO BEACH, FL, 32960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.6328537,
    "lng": -80.3881087
  },
  {
    "id": "11124",
    "name": "CVS",
    "address": "245 S MILITARY TRL, WEST PALM BEACH, FL, 33415",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.6741667,
    "lng": -80.1131527
  },
  {
    "id": "11123",
    "name": "CVS",
    "address": "131 MAIN ST., RTE 9, SPENCER, MA, 1562",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2443906,
    "lng": -71.9938504
  },
  {
    "id": "11122",
    "name": "CVS",
    "address": "7182 BOSTON STATE RD., HAMBURG, NY, 14075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6858073,
    "lng": -78.7778876
  },
  {
    "id": "11121",
    "name": "CVS",
    "address": "242-24 NORTHERN BOULEVARD, DOUGLASTON, NY, 11362",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7651133,
    "lng": -73.7432348
  },
  {
    "id": "11120",
    "name": "CVS",
    "address": "308 BROADWAY, BETHPAGE, NY, 11714",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7404089,
    "lng": -73.4790171
  },
  {
    "id": "11119",
    "name": "CVS",
    "address": "355 BROADWAY, AMITYVILLE, NY, 11701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6836818,
    "lng": -73.4170082
  },
  {
    "id": "11118",
    "name": "CVS",
    "address": "2030 HILLSIDE AVENUE, NEW HYDE PARK, NY, 11040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7508597,
    "lng": -73.6755568
  },
  {
    "id": "11117",
    "name": "CVS",
    "address": "1324 SAN CARLOS AVE, SAN CARLOS, CA, 94070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5058853,
    "lng": -122.262996
  },
  {
    "id": "11116",
    "name": "CVS",
    "address": "184 S LIVINGSTON AVE, CEDAR MALL, LIVINGSTON, NJ, 7039",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7896535,
    "lng": -74.3142961
  },
  {
    "id": "11115",
    "name": "CVS",
    "address": "1431 MT HOPE AVE., ROCHESTER, NY, 14620",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.1221418,
    "lng": -77.6191552
  },
  {
    "id": "11114",
    "name": "CVS",
    "address": "155 SUNRISE HIGHWAY, ROCKVILLE CENTRE, NY, 11570",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6577592,
    "lng": -73.6498038
  },
  {
    "id": "11113",
    "name": "CVS",
    "address": "400 EAST PRATT ST., BALTIMORE, MD, 21202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2871081,
    "lng": -76.6092275
  },
  {
    "id": "11112",
    "name": "CVS",
    "address": "3187 S CONGRESS AVE, PALM SPRINGS, FL, 33461",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.629053,
    "lng": -80.0891975
  },
  {
    "id": "11111",
    "name": "CVS",
    "address": "4685 GULF BLVD, SAINT PETE BEACH, FL, 33706",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7230148,
    "lng": -82.7391394
  },
  {
    "id": "11110",
    "name": "CVS",
    "address": "2290 CENTRAL PARK AVE., YONKERS, NY, 10710",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.97614,
    "lng": -73.8313384
  },
  {
    "id": "11109",
    "name": "CVS",
    "address": "3098 ORCHARD PARK ROAD, WEST SENECA, NY, 14224",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8004748,
    "lng": -78.7530228
  },
  {
    "id": "11108",
    "name": "CVS",
    "address": "325 ROUTES 100, SOMERS, NY, 10589",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3262694,
    "lng": -73.688478
  },
  {
    "id": "11107",
    "name": "CVS",
    "address": "309 MAIN ST., NEW ROCHELLE, NY, 10801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.91336,
    "lng": -73.7754566
  },
  {
    "id": "11106",
    "name": "CVS",
    "address": "3575 MAYBANK HWY., SUITE K, JOHNS ISLAND, SC, 29455",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.7210133,
    "lng": -80.0785486
  },
  {
    "id": "11105",
    "name": "CVS",
    "address": "577 NORTH AVE, NEW ROCHELLE, NY, 10801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9216707,
    "lng": -73.7877581
  },
  {
    "id": "11104",
    "name": "CVS",
    "address": "2201 EDGEWATER DR, ORLANDO, FL, 32804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.5713473,
    "lng": -81.389215
  },
  {
    "id": "11103",
    "name": "CVS",
    "address": "80 GOODWIN AVENUE, MIDLAND PARK, NJ, 7432",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9855092,
    "lng": -74.1374839
  },
  {
    "id": "11102",
    "name": "CVS",
    "address": "746 BLISS ROAD, LONGMEADOW, MA, 1106",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0568187,
    "lng": -72.5524362
  },
  {
    "id": "11101",
    "name": "CVS",
    "address": "252 BROADWAY, RAYNHAM, MA, 2767",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9359039,
    "lng": -71.0823078
  },
  {
    "id": "11100",
    "name": "CVS",
    "address": "2 EAST SUFFOLK AVE., CENTRAL ISLIP, NY, 11722",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7911636,
    "lng": -73.2014274
  },
  {
    "id": "11099",
    "name": "CVS",
    "address": "1133 INMAN AVENUE, EDISON, NJ, 8820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5964649,
    "lng": -74.3659868
  },
  {
    "id": "11098",
    "name": "CVS",
    "address": "161 MAIN STREET, FITCHBURG, MA, 1420",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5823589,
    "lng": -71.794034
  },
  {
    "id": "11097",
    "name": "CVS",
    "address": "628 LAFAYETTE RD., SEABROOK, NH, 3874",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8936627,
    "lng": -70.87136
  },
  {
    "id": "11096",
    "name": "CVS",
    "address": "250 E GRANADA BLVD, ORMOND BEACH, FL, 32176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.2909692,
    "lng": -81.0399703
  },
  {
    "id": "11095",
    "name": "CVS",
    "address": "ONE WEST ROAD, STRATHAM, NH, 3885",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9944045,
    "lng": -70.9271891
  },
  {
    "id": "11094",
    "name": "CVS",
    "address": "99 EAST MAIN ROAD, MIDDLETOWN, RI, 2842",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5169903,
    "lng": -71.2967009
  },
  {
    "id": "11093",
    "name": "CVS",
    "address": "72-09 NORTHERN BOULEVARD, JACKSON HEIGHTS, NY, 11372",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7549039,
    "lng": -73.8943747
  },
  {
    "id": "11092",
    "name": "CVS",
    "address": "1121 BOSTON POST ROAD, RYE, NY, 10580",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.984061,
    "lng": -73.6827762
  },
  {
    "id": "11091",
    "name": "CVS",
    "address": "970 ST. JAMES AVE., SPRINGFIELD, MA, 1104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1348013,
    "lng": -72.5689593
  },
  {
    "id": "11090",
    "name": "CVS",
    "address": "983 CENTRAL PARK AVE., SCARSDALE, NY, 10583",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9906604,
    "lng": -73.8230214
  },
  {
    "id": "11089",
    "name": "CVS",
    "address": "1475 BERGEN BOULEVARD, FORT LEE, NJ, 7024",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8513682,
    "lng": -73.9869514
  },
  {
    "id": "11088",
    "name": "CVS",
    "address": "265 LONG AVE, HILLSIDE, NJ, 7205",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.69878,
    "lng": -74.2310469
  },
  {
    "id": "11087",
    "name": "CVS",
    "address": "24 S. BLACK HORSE PIKE, MOUNT EPHRAIM, NJ, 8059",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8805143,
    "lng": -75.0847494
  },
  {
    "id": "11086",
    "name": "CVS",
    "address": "2454 E. IRLO BRONSON MEMORIAL HWY, KISSIMMEE, FL, 34744",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.279312,
    "lng": -81.3452269
  },
  {
    "id": "11085",
    "name": "CVS",
    "address": "1550 SOUTH ST., LINCOLN, NE, 68502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7921767,
    "lng": -96.6990069
  },
  {
    "id": "11084",
    "name": "CVS",
    "address": "NEW YORK+ATLANTIC AVS/10 RENAISSANCEPLZ, ATLANTIC CITY, NJ, 8401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3618095,
    "lng": -74.4306828
  },
  {
    "id": "11083",
    "name": "CVS",
    "address": "778 DUDLEY ST., DORCHESTER, MA, 2125",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.317493,
    "lng": -71.0654229
  },
  {
    "id": "11082",
    "name": "CVS",
    "address": "1188 PONTIAC AVENUE, CRANSTON, RI, 2920",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7518341,
    "lng": -71.4508679
  },
  {
    "id": "11081",
    "name": "CVS",
    "address": "137 ROUTE 70, MEDFORD, NJ, 8055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9012063,
    "lng": -74.8451846
  },
  {
    "id": "11080",
    "name": "CVS",
    "address": "780 ROUTE 22 EAST, NORTH PLAINFIELD, NJ, 7060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.624718,
    "lng": -74.440304
  },
  {
    "id": "11079",
    "name": "CVS",
    "address": "331 BROAD STREET, BLOOMFIELD, NJ, 7003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8050993,
    "lng": -74.1933981
  },
  {
    "id": "11078",
    "name": "CVS",
    "address": "3010 TILGHMAN STREET, ALLENTOWN, PA, 18104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5979969,
    "lng": -75.5246325
  },
  {
    "id": "11077",
    "name": "CVS",
    "address": "50 PENNSYLVANIA AVENUE, BINGHAMTON, NY, 13903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0861318,
    "lng": -75.9171089
  },
  {
    "id": "11076",
    "name": "CVS",
    "address": "426B ESSEX ST, SALEM, MA, 1970",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5166532,
    "lng": -70.9064309
  },
  {
    "id": "11075",
    "name": "CVS",
    "address": "250 CLOSTER DOCK ROAD, CLOSTER, NJ, 7624",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9719869,
    "lng": -73.9610781
  },
  {
    "id": "11074",
    "name": "CVS",
    "address": "7607 GREENBELT ROAD, GREENBELT, MD, 20770",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9935167,
    "lng": -76.8756543
  },
  {
    "id": "11073",
    "name": "CVS",
    "address": "366 KING ST., NORTHAMPTON, MA, 1060",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3364742,
    "lng": -72.6375689
  },
  {
    "id": "11072",
    "name": "CVS",
    "address": "74 EAST MAIN STREET, WESTBOROUGH, MA, 1581",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2751665,
    "lng": -71.6101798
  },
  {
    "id": "11071",
    "name": "CVS",
    "address": "259 SARATOGA RD., GLENVILLE, NY, 12302",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8702909,
    "lng": -73.9325293
  },
  {
    "id": "11070",
    "name": "CVS",
    "address": "8100 EAST RIDGE RD., HOBART, IN, 46342",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5512011,
    "lng": -87.2397914
  },
  {
    "id": "11069",
    "name": "CVS",
    "address": "481 PITTSFIELD RD., LENOX, MA, 1240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4042484,
    "lng": -73.2661539
  },
  {
    "id": "11068",
    "name": "CVS",
    "address": "350 RTE 130,, EAST WINDSOR, NJ, 8520",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.276693,
    "lng": -74.5354555
  },
  {
    "id": "11067",
    "name": "CVS",
    "address": "130 HWY 35, EATONTOWN, NJ, 7724",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3073714,
    "lng": -74.063606
  },
  {
    "id": "11066",
    "name": "CVS",
    "address": "11 COURT HOUSE SOUTH DENNIS RD. STE 9, CAPE MAY COURT HOUSE, NJ, 8210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.089435,
    "lng": -74.8220176
  },
  {
    "id": "11065",
    "name": "CVS",
    "address": "1301 ULSTER AVE., KINGSTON, NY, 12401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9697124,
    "lng": -73.9897061
  },
  {
    "id": "11064",
    "name": "CVS",
    "address": "13440 NC 210 HIGHWAY, BENSON, NC, 27504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.5171855,
    "lng": -78.5782835
  },
  {
    "id": "11063",
    "name": "CVS",
    "address": "150 W CAMINO REAL, BOCA RATON, FL, 33432",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.3399072,
    "lng": -80.0903074
  },
  {
    "id": "11062",
    "name": "CVS",
    "address": "160 FAIRVIEW AVE, SUITE 20, HUDSON, NY, 12534",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2568061,
    "lng": -73.766071
  },
  {
    "id": "11061",
    "name": "CVS",
    "address": "4110 N. 1ST  STREET, SAN JOSE, CA, 95134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.415771,
    "lng": -121.9539768
  },
  {
    "id": "11060",
    "name": "CVS",
    "address": "216 QUAKER ROAD, QUEENSBURY, NY, 12804",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3313611,
    "lng": -73.6540808
  },
  {
    "id": "11059",
    "name": "CVS",
    "address": "2503 SOUTH RD., POUGHKEEPSIE, NY, 12601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6586956,
    "lng": -73.9312978
  },
  {
    "id": "11058",
    "name": "CVS",
    "address": "750 LOUDON RD., LATHAM, NY, 12110",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7427635,
    "lng": -73.7626336
  },
  {
    "id": "11057",
    "name": "CVS",
    "address": "500 S 11TH ST, LAKE WALES, FL, 33853",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8934745,
    "lng": -81.5652555
  },
  {
    "id": "11056",
    "name": "CVS",
    "address": "1123 BOSTON NECK RD., NARRAGANSETT, RI, 2882",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4874799,
    "lng": -71.4363835
  },
  {
    "id": "11055",
    "name": "CVS",
    "address": "170 SE 3RD AVE, MIAMI, FL, 33131",
    "phone": "",
    "hours": "Call for hours",
    "lat": 25.7728245,
    "lng": -80.1892589
  },
  {
    "id": "11054",
    "name": "CVS",
    "address": "16 BOSTON ROAD, CHELMSFORD, MA, 1824",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5951838,
    "lng": -71.35117
  },
  {
    "id": "11053",
    "name": "CVS",
    "address": "1270 MAIN ST., WEST WARWICK, RI, 2893",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.703798,
    "lng": -71.5238489
  },
  {
    "id": "11052",
    "name": "CVS",
    "address": "11458 KINGS HIGHWAY, KING GEORGE, VA, 22485",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2381258,
    "lng": -77.149505
  },
  {
    "id": "11051",
    "name": "CVS",
    "address": "220 SCHUYLER AVE, KEARNY, NJ, 7032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.75605,
    "lng": -74.1440281
  },
  {
    "id": "11050",
    "name": "CVS",
    "address": "1504 MAIN ST., SOUTH WEYMOUTH, MA, 2190",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1526471,
    "lng": -70.9540298
  },
  {
    "id": "11049",
    "name": "CVS",
    "address": "915 POQUONNOCK RD., GROTON, CT, 6340",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3459427,
    "lng": -72.0513533
  },
  {
    "id": "11048",
    "name": "CVS",
    "address": "260 DELAWARE AVENUE, DELMAR, NY, 12054",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6255994,
    "lng": -73.8219695
  },
  {
    "id": "11047",
    "name": "CVS",
    "address": "6501 HARBISON AVENUE, PHILADELPHIA, PA, 19149",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0345493,
    "lng": -75.0634012
  },
  {
    "id": "11046",
    "name": "CVS",
    "address": "621 HEMPSTEAD TURNPIKE, WEST HEMPSTEAD, NY, 11552",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7060229,
    "lng": -73.6629
  },
  {
    "id": "11045",
    "name": "CVS",
    "address": "3580 N FEDERAL HWY, LIGHTHOUSE POINT, FL, 33064",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.2750332,
    "lng": -80.0967033
  },
  {
    "id": "11044",
    "name": "CVS",
    "address": "51 NORTH BROADWAY, TARRYTOWN, NY, 10591",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0779725,
    "lng": -73.8581707
  },
  {
    "id": "11043",
    "name": "CVS",
    "address": "259 MAIN ST., HAVERHILL, MA, 1830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7807814,
    "lng": -71.0768438
  },
  {
    "id": "11042",
    "name": "CVS",
    "address": "308 MAIN STREET EXTENSION, MIDDLETOWN, CT, 6457",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5496053,
    "lng": -72.6402083
  },
  {
    "id": "11041",
    "name": "CVS",
    "address": "307 EGG HARBOR RD, SEWELL, NJ, 8080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7636685,
    "lng": -75.0863918
  },
  {
    "id": "11040",
    "name": "CVS",
    "address": "585 RIDGE RD., NORTH ARLINGTON, NJ, 7031",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7972186,
    "lng": -74.1273451
  },
  {
    "id": "11039",
    "name": "CVS",
    "address": "1701 E. PARMER LN., AUSTIN, TX, 78754",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.3859914,
    "lng": -97.6483303
  },
  {
    "id": "11038",
    "name": "CVS",
    "address": "51 BANANIER DR., TOMS RIVER, NJ, 8755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9765621,
    "lng": -74.247316
  },
  {
    "id": "11037",
    "name": "CVS",
    "address": "181 BELLEVUE AVENUE, NEWPORT, RI, 2840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4822774,
    "lng": -71.3097854
  },
  {
    "id": "11036",
    "name": "CVS",
    "address": "700 SOUTH CROUSE AVENUE, SYRACUSE, NY, 13210",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0424823,
    "lng": -76.1370235
  },
  {
    "id": "11035",
    "name": "CVS",
    "address": "1519 ROCK SPRING RD., FOREST HILL, MD, 21050",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5603397,
    "lng": -76.3706856
  },
  {
    "id": "11034",
    "name": "CVS",
    "address": "1919 MINERAL SPRING AVENUE, NORTH PROVIDENCE, RI, 2904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8610477,
    "lng": -71.4682464
  },
  {
    "id": "11033",
    "name": "CVS",
    "address": "484 WINDSOR AVENUE, WINDSOR, CT, 6095",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8194354,
    "lng": -72.6562398
  },
  {
    "id": "11032",
    "name": "CVS",
    "address": "1078 SILAS DEANE HIGHWAY, WETHERSFIELD, CT, 6109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6930553,
    "lng": -72.6551275
  },
  {
    "id": "11031",
    "name": "CVS",
    "address": "5 INDIAN ROCK PLAZA, SUFFERN, NY, 10901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1137338,
    "lng": -74.1295684
  },
  {
    "id": "11030",
    "name": "CVS",
    "address": "1111 S CLOVERDALE BLVD, CLOVERDALE, CA, 95425",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7849906,
    "lng": -123.0142889
  },
  {
    "id": "11029",
    "name": "CVS",
    "address": "66 HIGH RIDGE ROAD, STAMFORD, CT, 6905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0736669,
    "lng": -73.5499114
  },
  {
    "id": "11028",
    "name": "CVS",
    "address": "1239 S. BLACKHORSE PIKE, WILLIAMSTOWN, NJ, 8094",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6725823,
    "lng": -74.9787308
  },
  {
    "id": "11027",
    "name": "CVS",
    "address": "2333 WELSH RD.., LANSDALE, PA, 19446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2611084,
    "lng": -75.3151163
  },
  {
    "id": "11026",
    "name": "CVS",
    "address": "266 NEW STATE HWY, RAYNHAM, MA, 2767",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9057581,
    "lng": -71.0559982
  },
  {
    "id": "11025",
    "name": "CVS",
    "address": "8995 STACY RD., MCKINNEY, TX, 75070",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.1515059,
    "lng": -96.7324232
  },
  {
    "id": "11024",
    "name": "CVS",
    "address": "417 N. BROADWAY, JERICHO, NY, 11753",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7883382,
    "lng": -73.5347894
  },
  {
    "id": "11023",
    "name": "CVS",
    "address": "2000 DRISCOLL RD, FREMONT, CA, 94539",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5411628,
    "lng": -121.9465111
  },
  {
    "id": "11022",
    "name": "CVS",
    "address": "445 PUTNAM PIKE, APPLE VALLEY MALL, GREENVILLE, RI, 2828",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8710602,
    "lng": -71.528754
  },
  {
    "id": "11021",
    "name": "CVS",
    "address": "111 AUBURN ST., PORTLAND, ME, 4103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.7040175,
    "lng": -70.2886339
  },
  {
    "id": "11020",
    "name": "CVS",
    "address": "1 GRAND UNION PLAZA, SAUGERTIES, NY, 12477",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.083571,
    "lng": -73.9678051
  },
  {
    "id": "11019",
    "name": "CVS",
    "address": "637 LOWELL ST., PEABODY, MA, 1960",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5495594,
    "lng": -71.0013604
  },
  {
    "id": "11018",
    "name": "CVS",
    "address": "5859 TRYON ROAD, CARY, NC, 27518",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.7453723,
    "lng": -78.7402411
  },
  {
    "id": "11017",
    "name": "CVS",
    "address": "370 PULASKI BLVD, BELLINGHAM, MA, 2019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0254248,
    "lng": -71.4906925
  },
  {
    "id": "11016",
    "name": "CVS",
    "address": "451 CENTER STREET, LUDLOW, MA, 1056",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1695791,
    "lng": -72.4808415
  },
  {
    "id": "11015",
    "name": "CVS",
    "address": "45 ATLANTIC AVENUE, MARBLEHEAD, MA, 1945",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4989316,
    "lng": -70.8563569
  },
  {
    "id": "11014",
    "name": "CVS",
    "address": "507 MAIN STREET, EAST GREENWICH, RI, 2818",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6576084,
    "lng": -71.4529878
  },
  {
    "id": "11013",
    "name": "CVS",
    "address": "1833 EAST HIGH STREET, POTTSTOWN, PA, 19464",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2444704,
    "lng": -75.6087604
  },
  {
    "id": "11012",
    "name": "CVS",
    "address": "1163 PROVIDENCE RD, WHITINSVILLE PLZ, WHITINSVILLE, MA, 1588",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1252348,
    "lng": -71.6480509
  },
  {
    "id": "11011",
    "name": "CVS",
    "address": "107 MAIN ST, STONEHAM, MA, 2180",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4939386,
    "lng": -71.101235
  },
  {
    "id": "11010",
    "name": "CVS",
    "address": "725 SAW MILL RIVER RD, ARDSLEY S/C, ARDSLEY, NY, 10502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0128468,
    "lng": -73.846043
  },
  {
    "id": "11009",
    "name": "CVS",
    "address": "44 W. BOYLSTON ST., WORCESTER, MA, 1605",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2897018,
    "lng": -71.8060803
  },
  {
    "id": "11008",
    "name": "CVS",
    "address": "565 VALLEY ROAD, UPPER MONTCLAIR, NJ, 7043",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8394669,
    "lng": -74.2074313
  },
  {
    "id": "11007",
    "name": "CVS",
    "address": "177 COLUMBUS BLVD., NEW BRITAIN, CT, 6051",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6664485,
    "lng": -72.7766858
  },
  {
    "id": "11006",
    "name": "CVS",
    "address": "800 LEXINGTON ST., WALTHAM, MA, 2452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4028426,
    "lng": -71.2351577
  },
  {
    "id": "11005",
    "name": "CVS",
    "address": "839 FARMINGTON AVE, BRISTOL, CT, 6010",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6935429,
    "lng": -72.9158706
  },
  {
    "id": "11004",
    "name": "CVS",
    "address": "2011 S. ROCHESTER RD, ROCHESTER HILLS, MI, 48307",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6520136,
    "lng": -83.1306385
  },
  {
    "id": "11003",
    "name": "CVS",
    "address": "80 MARKET STREET, ROCKLAND, MA, 2370",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1209301,
    "lng": -70.917109
  },
  {
    "id": "11002",
    "name": "CVS",
    "address": "833 MASSACHUSETTS AVENUE, ARLINGTON, MA, 2476",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4171424,
    "lng": -71.160361
  },
  {
    "id": "11001",
    "name": "CVS",
    "address": "1200 WILMINGTON PIKE, WEST CHESTER, PA, 19382",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9189631,
    "lng": -75.5770208
  },
  {
    "id": "11000",
    "name": "CVS",
    "address": "446 SABATTUS ST., LEWISTON, ME, 4240",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.1017185,
    "lng": -70.1927676
  },
  {
    "id": "10999",
    "name": "CVS",
    "address": "401 GLOUCESTER CROSSING ROAD,, GLOUCESTER, MA, 1930",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6225432,
    "lng": -70.6567931
  },
  {
    "id": "10998",
    "name": "CVS",
    "address": "913 OAK TREE AVE, GOLDEN ACRES S/C, SOUTH PLAINFIELD, NJ, 7080",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5776555,
    "lng": -74.3871947
  },
  {
    "id": "10997",
    "name": "CVS",
    "address": "583 TAUNTON AVENUE, EAST PROVIDENCE, RI, 2914",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8204153,
    "lng": -71.3580361
  },
  {
    "id": "10996",
    "name": "CVS",
    "address": "615 METACOM AVENUE, ROUTE 136, WARREN, RI, 2885",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7180552,
    "lng": -71.2689927
  },
  {
    "id": "10995",
    "name": "CVS",
    "address": "400 6TH ST NW, WINTER HAVEN, FL, 33881",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0263603,
    "lng": -81.7322897
  },
  {
    "id": "10994",
    "name": "CVS",
    "address": "5703 STEUBENVILLE PIKE, MCKEES ROCKS, PA, 15136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4514298,
    "lng": -80.1342225
  },
  {
    "id": "10993",
    "name": "CVS",
    "address": "107 WEST ST., PITTSFIELD, MA, 1201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4474058,
    "lng": -73.2585215
  },
  {
    "id": "10992",
    "name": "CVS",
    "address": "1329 KEMPSVILLE RD., CHESAPEAKE, VA, 23320",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.7625536,
    "lng": -76.2045787
  },
  {
    "id": "10991",
    "name": "CVS",
    "address": "24-12 FAIR LAWN AVENUE, FAIR LAWN, NJ, 7410",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9393874,
    "lng": -74.1186366
  },
  {
    "id": "10990",
    "name": "CVS",
    "address": "444 WILLETT AVENUE, RIVERSIDE, RI, 2915",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7713075,
    "lng": -71.3533504
  },
  {
    "id": "10989",
    "name": "CVS",
    "address": "115 S. PINEY RD., CHESTER, MD, 21619",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.973757,
    "lng": -76.2699067
  },
  {
    "id": "10988",
    "name": "CVS",
    "address": "6 JFK STREET, CAMBRIDGE, MA, 2138",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3732123,
    "lng": -71.119384
  },
  {
    "id": "10987",
    "name": "CVS",
    "address": "1587 BRAYTON POINT RD., SOMERSET, MA, 2725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7316646,
    "lng": -71.1729334
  },
  {
    "id": "10986",
    "name": "CVS",
    "address": "3930 WEST CHESTER PIKE, NEWTOWN SQUARE, PA, 19073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9849174,
    "lng": -75.4150196
  },
  {
    "id": "10985",
    "name": "CVS",
    "address": "142 TALCOTTVILLE ROAD, VERNON, CT, 6066",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8308815,
    "lng": -72.4939135
  },
  {
    "id": "10984",
    "name": "CVS",
    "address": "70 ATLANTIC AVE, GREAT LINCOLN S/C, OCEANSIDE, NY, 11572",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6395624,
    "lng": -73.6423072
  },
  {
    "id": "10983",
    "name": "CVS",
    "address": "25 EAST RED BANK AVENUE, WOODBURY, NJ, 8096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8425365,
    "lng": -75.1478798
  },
  {
    "id": "10982",
    "name": "CVS",
    "address": "5600 NORTH 23RD., MCALLEN, TX, 78504",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.254985,
    "lng": -98.236252
  },
  {
    "id": "10981",
    "name": "CVS",
    "address": "650 MAIN STREET, READING, MA, 1867",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5244486,
    "lng": -71.1032127
  },
  {
    "id": "10980",
    "name": "CVS",
    "address": "101 KNOLLWOOD RD, GREENBURGH S/C, WHITE PLAINS, NY, 10607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0383768,
    "lng": -73.806892
  },
  {
    "id": "10979",
    "name": "CVS",
    "address": "264 EAST MAIN STREET, MARLBOROUGH, MA, 1752",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3519084,
    "lng": -71.5344963
  },
  {
    "id": "10978",
    "name": "CVS",
    "address": "3798 ORLANDO DR, SANFORD, FL, 32773",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.7572628,
    "lng": -81.2877981
  },
  {
    "id": "10977",
    "name": "CVS",
    "address": "1900 MAIN ST,, TEWKSBURY, MA, 1876",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5909623,
    "lng": -71.2022198
  },
  {
    "id": "10976",
    "name": "CVS",
    "address": "5526 S. CONGRESS AVE., AUSTIN, TX, 78745",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2057814,
    "lng": -97.7753915
  },
  {
    "id": "10975",
    "name": "CVS",
    "address": "681 RESERVOIR AVENUE, CRANSTON, RI, 2910",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7810178,
    "lng": -71.4430547
  },
  {
    "id": "10974",
    "name": "CVS",
    "address": "109 MAIN STREET, NORTH ANDOVER, MA, 1845",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.7024985,
    "lng": -71.1323186
  },
  {
    "id": "10973",
    "name": "CVS",
    "address": "5899 ORANGE BLOSSOM TRL, ORLANDO, FL, 32839",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.4729792,
    "lng": -81.3958711
  },
  {
    "id": "10972",
    "name": "CVS",
    "address": "641 SHUNPIKE RD, HICKORY SQUARE S/C, CHATHAM, NJ, 7928",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7452524,
    "lng": -74.4312204
  },
  {
    "id": "10971",
    "name": "CVS",
    "address": "475 PARK EAST DR, WOONSOCKET, RI, 2895",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9951769,
    "lng": -71.4762233
  },
  {
    "id": "10970",
    "name": "CVS",
    "address": "788 S. WILLOW ST., MANCHESTER, NH, 3103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9647076,
    "lng": -71.44443
  },
  {
    "id": "10969",
    "name": "CVS",
    "address": "13998 WALSINGHAM RD, LARGO, FL, 33774",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8798478,
    "lng": -82.8318328
  },
  {
    "id": "10968",
    "name": "CVS",
    "address": "14125 STEELE CREEK RD., CHARLOTTE, NC, 28273",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.1023628,
    "lng": -80.9874959
  },
  {
    "id": "10967",
    "name": "CVS",
    "address": "215 WEST ST., SEYMOUR, CT, 6483",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3974095,
    "lng": -73.0872418
  },
  {
    "id": "10966",
    "name": "CVS",
    "address": "700 BOSTON RD, RT 3A, TOWNE PLZ, BILLERICA, MA, 1821",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5403578,
    "lng": -71.244173
  },
  {
    "id": "10965",
    "name": "CVS",
    "address": "4 PLAISTOW RD,, PLAISTOW, NH, 3865",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8155174,
    "lng": -71.1034912
  },
  {
    "id": "10964",
    "name": "CVS",
    "address": "1178 WANTAGH AVENUE, WANTAGH, NY, 11793",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.694218,
    "lng": -73.5090253
  },
  {
    "id": "10963",
    "name": "CVS",
    "address": "578 INTERNATIONAL DR, MYRTLE BEACH, SC, 29579",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.759188,
    "lng": -78.8571527
  },
  {
    "id": "10962",
    "name": "CVS",
    "address": "2-6 SHORT BEACH RD,, BRANFORD, CT, 6405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.274957,
    "lng": -72.8291384
  },
  {
    "id": "10961",
    "name": "CVS",
    "address": "799 ROCKVILLE PIKE, ROCKVILLE, MD, 20852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0764459,
    "lng": -77.1406518
  },
  {
    "id": "10960",
    "name": "CVS",
    "address": "115 STAFFORD ST., WORCESTER, MA, 1603",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1556451,
    "lng": -71.9748424
  },
  {
    "id": "10959",
    "name": "CVS",
    "address": "1 WALL ST., CLAREMONT, NH, 3743",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.3730539,
    "lng": -72.3356454
  },
  {
    "id": "10958",
    "name": "CVS",
    "address": "1635 BARTOW RD, LAKELAND, FL, 33801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 28.0232331,
    "lng": -81.9254766
  },
  {
    "id": "10957",
    "name": "CVS",
    "address": "10012 WEISS WAY, WAXHAW, NC, 28173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 35.0167619,
    "lng": -80.8024367
  },
  {
    "id": "10956",
    "name": "CVS",
    "address": "4260 6TH ST S, SAINT PETERSBURG, FL, 33705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.7298226,
    "lng": -82.6394817
  },
  {
    "id": "10955",
    "name": "CVS",
    "address": "516-522 MAIN STREET, MELROSE, MA, 2176",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4552049,
    "lng": -71.065617
  },
  {
    "id": "10954",
    "name": "CVS",
    "address": "6031 FAIRBURN RD., DOUGLASVILLE, GA, 30134",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7518068,
    "lng": -84.7298829
  },
  {
    "id": "10953",
    "name": "CVS",
    "address": "294 37TH AVE N, SAINT PETERSBURG, FL, 33704",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.8054231,
    "lng": -82.6368227
  },
  {
    "id": "10952",
    "name": "CVS",
    "address": "51 LINDEN STREET, WALTHAM, MA, 2452",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3786217,
    "lng": -71.2229185
  },
  {
    "id": "10951",
    "name": "CVS",
    "address": "1109 WEST CHESTER PIKE/PEP BOYS BLDG, HAVERTOWN, PA, 19083",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9726062,
    "lng": -75.3147519
  },
  {
    "id": "10950",
    "name": "CVS",
    "address": "15 WEST MAIN STREET, EAST ISLIP, NY, 11730",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7317876,
    "lng": -73.1914724
  },
  {
    "id": "10949",
    "name": "CVS",
    "address": "330 MAIN ST., FARMINGTON, CT, 6032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.704587,
    "lng": -72.8440242
  },
  {
    "id": "10948",
    "name": "CVS",
    "address": "219-39 89TH AVENUE, QUEENS VILLAGE, NY, 11427",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7294008,
    "lng": -73.7437864
  },
  {
    "id": "10947",
    "name": "CVS",
    "address": "305 W. BALTIMORE ST., GREENCASTLE, PA, 17225",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7917133,
    "lng": -77.7313931
  },
  {
    "id": "10946",
    "name": "CVS",
    "address": "3 WOODSIDE AVENUE, WINTHROP, MA, 2152",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3756236,
    "lng": -70.9877898
  },
  {
    "id": "10945",
    "name": "CVS",
    "address": "626 SOUTHERN ARTERY, RTE 3A, QUINCY, MA, 2169",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2528193,
    "lng": -70.9878363
  },
  {
    "id": "10944",
    "name": "CVS",
    "address": "266 WEST STREET, ROUTE 202, LITCHFIELD, CT, 6759",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7462365,
    "lng": -73.2015246
  },
  {
    "id": "10943",
    "name": "CVS",
    "address": "698 POST RD., FAIRFIELD, CT, 6824",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1492163,
    "lng": -73.2475094
  },
  {
    "id": "10942",
    "name": "CVS",
    "address": "210 BOSTON RD., NORTH BILLERICA, MA, 1862",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5811179,
    "lng": -71.2876529
  },
  {
    "id": "10941",
    "name": "CVS",
    "address": "101 POLIFLY RD, POLIFLY PLZ, HACKENSACK, NJ, 7601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8783656,
    "lng": -74.0570465
  },
  {
    "id": "10940",
    "name": "CVS",
    "address": "1260 SPRINGFIELD AVENUE, NEW PROVIDENCE, NJ, 7974",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7052967,
    "lng": -74.4039205
  },
  {
    "id": "10939",
    "name": "CVS",
    "address": "98 BRIDGE ST., NAUGATUCK, CT, 6770",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5016471,
    "lng": -73.0530068
  },
  {
    "id": "10938",
    "name": "CVS",
    "address": "519 BOSTON POST RD., OLD SAYBROOK, CT, 6475",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2996394,
    "lng": -72.3763408
  },
  {
    "id": "10937",
    "name": "CVS",
    "address": "310 WEST PARK AVENUE, LONG BEACH, NY, 11561",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5880801,
    "lng": -73.6732115
  },
  {
    "id": "10936",
    "name": "CVS",
    "address": "451 MAIN STREET, WAKEFIELD, MA, 1880",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5017479,
    "lng": -71.0698841
  },
  {
    "id": "10935",
    "name": "CVS",
    "address": "1921-1943 CENTRE STREET, WEST ROXBURY, MA, 2132",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2840154,
    "lng": -71.1572946
  },
  {
    "id": "10934",
    "name": "CVS",
    "address": "12 HARVARD ST., WALTHAM, MA, 2453",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3758388,
    "lng": -71.2433377
  },
  {
    "id": "10933",
    "name": "CVS",
    "address": "1891 N. US HWY 1, FORT PIERCE, FL, 34946",
    "phone": "",
    "hours": "Call for hours",
    "lat": 27.469985,
    "lng": -80.3338912
  },
  {
    "id": "10932",
    "name": "CVS",
    "address": "1010 REVERE BEACH PKWY, CHELSEA, MA, 2150",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4029947,
    "lng": -71.0234973
  },
  {
    "id": "10931",
    "name": "CVS",
    "address": "839 WASHINGTON ST, NEWTON, MA, 2460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3517294,
    "lng": -71.2077427
  },
  {
    "id": "10930",
    "name": "CVS",
    "address": "10010 N SCOTTSDALE RD, SCOTTSDALE, AZ, 85253",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.5771572,
    "lng": -111.9268181
  },
  {
    "id": "10929",
    "name": "CVS",
    "address": "1005 DELAWARE AVE., WILMINGTON, DE, 19806",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.752497,
    "lng": -75.5555541
  },
  {
    "id": "10928",
    "name": "CVS",
    "address": "1686 E FLORENCE BLVD, CASA GRANDE, AZ, 85122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.880118,
    "lng": -111.7149804
  },
  {
    "id": "10927",
    "name": "CVS",
    "address": "972 SILVER LN., EAST HARTFORD, CT, 6118",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7662442,
    "lng": -72.601349
  },
  {
    "id": "10926",
    "name": "CVS",
    "address": "215 COLLEGE HWY., SOUTHWICK, MA, 1077",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0264854,
    "lng": -72.7868288
  },
  {
    "id": "10925",
    "name": "CVS",
    "address": "1993 PLAINFIELD PIKE, JOHNSTON, RI, 2919",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7892316,
    "lng": -71.5159195
  },
  {
    "id": "10924",
    "name": "CVS",
    "address": "200 SOUTH COMMON ST., LYNN, MA, 1905",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4620465,
    "lng": -70.9627139
  },
  {
    "id": "10923",
    "name": "CVS",
    "address": "5 MACY STREET, AMESBURY, MA, 1913",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.8472363,
    "lng": -70.9285107
  },
  {
    "id": "10922",
    "name": "CVS",
    "address": "989 BOSTON POST ROAD, MILFORD, CT, 6460",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2312773,
    "lng": -73.046846
  },
  {
    "id": "10921",
    "name": "CVS",
    "address": "705 WEST TRAFALGAR POINT  WAY, TRAFALGAR, IN, 46181",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4116742,
    "lng": -86.1573584
  },
  {
    "id": "10920",
    "name": "CVS",
    "address": "6 THATCHER RD, E GLOUCESTER S/C, GLOUCESTER, MA, 1930",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6181131,
    "lng": -70.6430101
  },
  {
    "id": "10919",
    "name": "CVS",
    "address": "4001 W. WILLIAM CANNON DR., AUSTIN, TX, 78749",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.2185749,
    "lng": -97.8364129
  },
  {
    "id": "10918",
    "name": "CVS",
    "address": "590 PALMYRA TWNSHP/RTE 6/LAKE REGION CTR, HAWLEY, PA, 18428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4641889,
    "lng": -75.1805105
  },
  {
    "id": "10917",
    "name": "CVS",
    "address": "4657 E CHANDLER BLVD, PHOENIX, AZ, 85048",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3045061,
    "lng": -111.9808472
  },
  {
    "id": "10916",
    "name": "CVS",
    "address": "333 WASHINGTON STREET, BOSTON, MA, 2108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.3570839,
    "lng": -71.0593874
  },
  {
    "id": "10915",
    "name": "CVS",
    "address": "3900 OAK HILL RD., EVANSVILLE, IN, 47711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.014006,
    "lng": -87.5110654
  },
  {
    "id": "10914",
    "name": "CVS",
    "address": "474 WASHINGTON ST., WEYMOUTH, MA, 2188",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2077091,
    "lng": -70.9564447
  },
  {
    "id": "10913",
    "name": "CVS",
    "address": "1424 W BASELINE RD, TEMPE, AZ, 85283",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.3788281,
    "lng": -111.9624123
  },
  {
    "id": "10912",
    "name": "CVS",
    "address": "142 WORCESTER RD., CHARLTON, MA, 1507",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1450395,
    "lng": -71.9685678
  },
  {
    "id": "10911",
    "name": "CVS",
    "address": "1998 MENDON ROAD, CUMBERLAND, RI, 2864",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9492732,
    "lng": -71.4408518
  },
  {
    "id": "10910",
    "name": "CVS",
    "address": "800 N. WESTWOOD ST., PORTERVILLE, CA, 93257",
    "phone": "",
    "hours": "Call for hours",
    "lat": 36.0806644,
    "lng": -119.069675
  },
  {
    "id": "10909",
    "name": "CVS",
    "address": "1249 DEXTER ST., MILAN, MI, 48160",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0975182,
    "lng": -83.6774758
  },
  {
    "id": "10908",
    "name": "CVS",
    "address": "590 FELLSWAY, MEDFORD, MA, 2155",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.405665,
    "lng": -71.0831576
  },
  {
    "id": "10907",
    "name": "CVS",
    "address": "211 LINCOLN AVENUE, HAVERHILL, MA, 1830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.762841,
    "lng": -71.0402124
  },
  {
    "id": "10906",
    "name": "CVS",
    "address": "245 WILLIAM S. CANNING BLVD., FALL RIVER, MA, 2721",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6741632,
    "lng": -71.1622588
  },
  {
    "id": "10905",
    "name": "CVS",
    "address": "18591 N 59TH AVE, GLENDALE, AZ, 85308",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6537246,
    "lng": -112.1854029
  },
  {
    "id": "10904",
    "name": "CVS",
    "address": "5500 N. MACARTHUR, IRVING, TX, 75038",
    "phone": "",
    "hours": "Call for hours",
    "lat": 32.8855969,
    "lng": -96.9633148
  },
  {
    "id": "10903",
    "name": "CVS",
    "address": "13800 HULL STREET RD., MIDLOTHIAN, VA, 23112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.4080633,
    "lng": -77.6578281
  },
  {
    "id": "10902",
    "name": "CVS",
    "address": "63 NEW YORK AVE., HUNTINGTON, NY, 11743",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8801199,
    "lng": -73.4216123
  },
  {
    "id": "10901",
    "name": "CVS",
    "address": "339 SQUIRE ROAD, REVERE, MA, 2151",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.4268623,
    "lng": -71.0127482
  },
  {
    "id": "10900",
    "name": "CVS",
    "address": "197 BOSTON TURNPIKE RTE 9, SHREWSBURY, MA, 1545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2755673,
    "lng": -71.745379
  },
  {
    "id": "10899",
    "name": "CVS",
    "address": "9901B W THUNDERBIRD BLVD, SUN CITY, AZ, 85351",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.6087314,
    "lng": -112.2692209
  },
  {
    "id": "10898",
    "name": "CVS",
    "address": "1497 ROUTE 206, TABERNACLE, NJ, 8088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.8485984,
    "lng": -74.7349959
  },
  {
    "id": "10897",
    "name": "Weis Market",
    "address": "2425 Schoenersville Road, Bethelehem, PA, 18017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6429749,
    "lng": -75.4051618
  },
  {
    "id": "10896",
    "name": "Weis Market",
    "address": "2612 Jefferson Davis Highway, Stafford, VA, 22554",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4488395,
    "lng": -77.4002193
  },
  {
    "id": "10895",
    "name": "Weis Market",
    "address": "905 Garrisonville Road, Stafford, VA, 22554",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4677452,
    "lng": -77.4622198
  },
  {
    "id": "10894",
    "name": "Weis Market",
    "address": "505 Meadowbrook Shopping Ctr, Culpeper, VA, 22701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.4730272,
    "lng": -77.9965375
  },
  {
    "id": "10893",
    "name": "Weis Market",
    "address": "9801 Courthouse Road, Spotsylvania, VA, 22553",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2329221,
    "lng": -77.5574191
  },
  {
    "id": "10892",
    "name": "Weis Market",
    "address": "7100 Salem Fields Boulevard, Fredericksburg, VA, 22407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2630364,
    "lng": -77.5812849
  },
  {
    "id": "10891",
    "name": "Weis Market",
    "address": "10601 Spotsylvania Avenue, Fredericksburg, VA, 22405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2462414,
    "lng": -77.4929611
  },
  {
    "id": "10890",
    "name": "Weis Market",
    "address": "4153 Plank Road, Fredericksburg, VA, 22401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2911685,
    "lng": -77.5334588
  },
  {
    "id": "10889",
    "name": "Weis Market",
    "address": "282 Deacon Road, Fredericksburg, VA, 22405",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3270558,
    "lng": -77.4385533
  },
  {
    "id": "10888",
    "name": "Weis Market",
    "address": "10871 Tidewater Trail, Fredericksburg, VA, 22408",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2560754,
    "lng": -77.4270768
  },
  {
    "id": "10887",
    "name": "Weis Market",
    "address": "10 Village Center Road, Reisterstown, MD, 21136",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4688532,
    "lng": -76.8311918
  },
  {
    "id": "10886",
    "name": "Weis Market",
    "address": "9251 Lakeside Boulevard, Owings Mills, MD, 21117",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3973007,
    "lng": -76.7907248
  },
  {
    "id": "10885",
    "name": "Weis Market",
    "address": "17600 Old National Sq Pike, Frostburg, MD, 21532",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6516156,
    "lng": -78.908933
  },
  {
    "id": "10884",
    "name": "Weis Market",
    "address": "6375 Monroe Avenue, Eldersburg, MD, 21784",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3981029,
    "lng": -76.9240837
  },
  {
    "id": "10883",
    "name": "Weis Market",
    "address": "15300 Mcmullen Hwy SW, Cumberland, MD, 21502",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.586469,
    "lng": -78.8385298
  },
  {
    "id": "10882",
    "name": "Weis Market",
    "address": "12100 Central Avenue, Mitchellville, MD, 20721",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9001034,
    "lng": -76.7965839
  },
  {
    "id": "10881",
    "name": "Weis Market",
    "address": "883 Russell Avenue, Gaithersburg, MD, 20879",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1578006,
    "lng": -77.2125818
  },
  {
    "id": "10880",
    "name": "Weis Market",
    "address": "6551 Waterloo Road, Elkridge, MD, 21075",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1907619,
    "lng": -76.7943304
  },
  {
    "id": "10879",
    "name": "Weis Market",
    "address": "13300 H G Trueman Road, Solomons, MD, 20688",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3480082,
    "lng": -76.4591225
  },
  {
    "id": "10878",
    "name": "Weis Market",
    "address": "210 H G Trueman Road, Lusby, MD, 20657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.3735066,
    "lng": -76.4366951
  },
  {
    "id": "10877",
    "name": "Weis Market",
    "address": "19 St. Mary's Square, Lexington Park, MD, 20653",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2585868,
    "lng": -76.4647136
  },
  {
    "id": "10876",
    "name": "Weis Market",
    "address": "20995 Point Lookout Road, Callaway, MD, 20620",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.2365441,
    "lng": -76.5247974
  },
  {
    "id": "10875",
    "name": "Weis Market",
    "address": "5715 Crain Highway, Upper Marlboro, MD, 20772",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8109684,
    "lng": -76.7423996
  },
  {
    "id": "10874",
    "name": "Weis Market",
    "address": "750 Prince Frederick Blvd, Prince Frederick, MD, 20678",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.5527565,
    "lng": -76.5970413
  },
  {
    "id": "10873",
    "name": "Weis Market",
    "address": "100 Drury Drive, La Plata, MD, 20646",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.547667,
    "lng": -76.9828477
  },
  {
    "id": "10872",
    "name": "Weis Market",
    "address": "3261 Solomons Island Road, Edgewater, MD, 21037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9281255,
    "lng": -76.5655301
  },
  {
    "id": "10871",
    "name": "Weis Market",
    "address": "15789 Livingston Road, Accokeek, MD, 20607",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6712727,
    "lng": -77.0088553
  },
  {
    "id": "10870",
    "name": "Weis Market",
    "address": "219 Marlboro Avenue, Easton, MD, 21601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7822128,
    "lng": -76.0816925
  },
  {
    "id": "10869",
    "name": "Weis Market",
    "address": "19287 Miller Road, Rehoboth Beach, DE, 19971",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7222212,
    "lng": -75.1245717
  },
  {
    "id": "10868",
    "name": "Weis Market",
    "address": "36731 Old Mill Road, Millville, DE, 19967",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.548147,
    "lng": -75.1071946
  },
  {
    "id": "10867",
    "name": "Weis Market",
    "address": "24832 John J Williams Hwy, Millsboro, DE, 19966",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6370962,
    "lng": -75.1952111
  },
  {
    "id": "10866",
    "name": "Weis Market",
    "address": "17232 N Village Main Blvd, Lewes, DE, 19958",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.7525946,
    "lng": -75.1672153
  },
  {
    "id": "10865",
    "name": "Weis Market",
    "address": "1424 Baltimore Street, Hanover, PA, 17331",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7724272,
    "lng": -76.9573747
  },
  {
    "id": "10864",
    "name": "Weis Market",
    "address": "1201 Dutchmanâs Creek Drive, Brunswick, MD, 21716",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.334504,
    "lng": -77.637857
  },
  {
    "id": "10863",
    "name": "Weis Market",
    "address": "400 Enterprise Circle, Martinsburg, WV, 25403",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4441633,
    "lng": -77.9927543
  },
  {
    "id": "10862",
    "name": "Weis Market",
    "address": "2100 County Line Road, Huntingdon Valley, PA, 19006",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.169333,
    "lng": -75.0730195
  },
  {
    "id": "10861",
    "name": "Weis Market",
    "address": "293 U.S. Highway 206, Flanders, NJ, 7836",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8320916,
    "lng": -74.7086953
  },
  {
    "id": "10860",
    "name": "Weis Market",
    "address": "25 W. Germantown Pike, Norristown, PA, 19401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.144073,
    "lng": -75.3129751
  },
  {
    "id": "10859",
    "name": "Weis Market",
    "address": "73 Old Dublin Pike, Doylestown, PA, 18901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3245214,
    "lng": -75.1323732
  },
  {
    "id": "10858",
    "name": "Weis Market",
    "address": "200 West Ridge Pike, Suite 110, Conshohocken, PA, 19428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.096106,
    "lng": -75.2877598
  },
  {
    "id": "10857",
    "name": "Weis Market",
    "address": "315 Route 206, Hillsborough, NJ, 8844",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5155728,
    "lng": -74.6260318
  },
  {
    "id": "10856",
    "name": "Weis Market",
    "address": "7005 Security Blvd., Windsor Mill, MD, 21244",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3117457,
    "lng": -76.7542572
  },
  {
    "id": "10855",
    "name": "Weis Market",
    "address": "1238 Putty Hill Avenue, Towson, MD, 21286",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.393422,
    "lng": -76.5828218
  },
  {
    "id": "10854",
    "name": "Weis Market",
    "address": "431 Dublin Pike, Perkasie, PA, 18944",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.381989,
    "lng": -75.2186458
  },
  {
    "id": "10853",
    "name": "Weis Market",
    "address": "719 Route 522, Selinsgrove, PA, 17870",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8102879,
    "lng": -76.866128
  },
  {
    "id": "10852",
    "name": "Weis Market",
    "address": "4525 Valley Road, Enola, PA, 17025",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2896771,
    "lng": -76.9743198
  },
  {
    "id": "10851",
    "name": "Weis Market",
    "address": "3440 Grandview Drive, Macungie, PA, 18062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5176764,
    "lng": -75.5670072
  },
  {
    "id": "10850",
    "name": "Weis Market",
    "address": "100 Rano Boulevard, Vestal, NY, 13850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.093718,
    "lng": -76.0049172
  },
  {
    "id": "10849",
    "name": "Weis Market",
    "address": "50 Pennsylvania Avenue, Binghamton, NY, 13903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0861318,
    "lng": -75.9171089
  },
  {
    "id": "10848",
    "name": "Weis Market",
    "address": "160 Robinson Street, Binghamton, NY, 13904",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1065887,
    "lng": -75.8891584
  },
  {
    "id": "10847",
    "name": "Weis Market",
    "address": "925 Main Street, Vestal, NY, 13850",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0719671,
    "lng": -76.046488
  },
  {
    "id": "10846",
    "name": "Weis Market",
    "address": "800 Hooper Road, Endwell, NY, 13760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1295297,
    "lng": -76.0280142
  },
  {
    "id": "10845",
    "name": "Weis Market",
    "address": "412 Day Hollow Road, Endicott, NY, 13760",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1114489,
    "lng": -76.0720163
  },
  {
    "id": "10844",
    "name": "Weis Market",
    "address": "1290 Front Street, Binghamton, NY, 13901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1608701,
    "lng": -75.8935601
  },
  {
    "id": "10843",
    "name": "Weis Market",
    "address": "307 Conklin Avenue, Binghamton, NY, 13903",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0972343,
    "lng": -75.8888861
  },
  {
    "id": "10842",
    "name": "Weis Market",
    "address": "7927 Belair Road Suite S, Baltimore, MD, 21236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3737438,
    "lng": -76.5086724
  },
  {
    "id": "10841",
    "name": "Weis Market",
    "address": "6 Millbrook Plaza, Mill Hall, PA, 17751",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1172606,
    "lng": -77.4790325
  },
  {
    "id": "10840",
    "name": "Weis Market",
    "address": "30 Primrose Lane, East Berlin, PA, 17316",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9256617,
    "lng": -76.9792476
  },
  {
    "id": "10839",
    "name": "Weis Market",
    "address": "2150 Bumble Bee Hollow Road, Mechanicsburg, PA, 17055",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1764385,
    "lng": -76.9868077
  },
  {
    "id": "10838",
    "name": "Weis Market",
    "address": "11798 Route 6, Wellsboro, PA, 16901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7429972,
    "lng": -77.2675443
  },
  {
    "id": "10837",
    "name": "Weis Market",
    "address": "65 Meadow Green Drive, Mifflinburg, PA, 17844",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9239522,
    "lng": -77.0328781
  },
  {
    "id": "10836",
    "name": "Weis Market",
    "address": "498 Pottstown Avenue, Pennsburg, PA, 18073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3924387,
    "lng": -75.5001835
  },
  {
    "id": "10835",
    "name": "Weis Market",
    "address": "365 S. Cedar Crest Blvd., Allentown, PA, 18103",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.582982,
    "lng": -75.518594
  },
  {
    "id": "10834",
    "name": "Weis Market",
    "address": "943 Pulaski Highway, HavreDeGrace, MD, 21078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5481459,
    "lng": -76.106716
  },
  {
    "id": "10833",
    "name": "Weis Market",
    "address": "725 Columbia Blvd., Bloomsburg, PA, 17815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0031855,
    "lng": -76.4441974
  },
  {
    "id": "10832",
    "name": "Weis Market",
    "address": "5360 Lincoln Highway, Gap, PA, 17527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9901249,
    "lng": -76.019646
  },
  {
    "id": "10831",
    "name": "Weis Market",
    "address": "1020 Northern Boulevard, Clarks Summit, PA, 18411",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4852804,
    "lng": -75.6908059
  },
  {
    "id": "10830",
    "name": "Weis Market",
    "address": "2759 Paper Mill Road, Wyomissing, PA, 19610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3585597,
    "lng": -75.980975
  },
  {
    "id": "10829",
    "name": "Weis Market",
    "address": "7801 Glenlivet West Drive, Fogelsville, PA, 18051",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5897947,
    "lng": -75.6314991
  },
  {
    "id": "10828",
    "name": "Weis Market",
    "address": "170 Buckaroo Lane, Bellefonte, PA, 16823",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9126305,
    "lng": -77.7389491
  },
  {
    "id": "10827",
    "name": "Weis Market",
    "address": "61 King's Plaza, Oley, PA, 19547",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3881327,
    "lng": -75.7942998
  },
  {
    "id": "10826",
    "name": "Weis Market",
    "address": "217 Oak Lee Drive, Suite 15, Ranson, WV, 25438",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3213416,
    "lng": -77.8492347
  },
  {
    "id": "10825",
    "name": "Weis Market",
    "address": "5020 Rt 873, Schnecksville, PA, 18078",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6769887,
    "lng": -75.6159047
  },
  {
    "id": "10824",
    "name": "Weis Market",
    "address": "552 State St, Hamburg, PA, 19526",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5551865,
    "lng": -75.9799773
  },
  {
    "id": "10823",
    "name": "Weis Market",
    "address": "9400 Scott Moore Way, Perry Hall, MD, 21128",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4057306,
    "lng": -76.4423897
  },
  {
    "id": "10822",
    "name": "Weis Market",
    "address": "2 Thurmont Blvd., Thurmont, MD, 21788",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.612247,
    "lng": -77.417034
  },
  {
    "id": "10821",
    "name": "Weis Market",
    "address": "700 Chase Six Blvd., Boonsboro, MD, 21713",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5189918,
    "lng": -77.6569234
  },
  {
    "id": "10820",
    "name": "Weis Market",
    "address": "1272 East Penn Street, Muncy, PA, 17756",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.209566,
    "lng": -76.7598024
  },
  {
    "id": "10819",
    "name": "Weis Market",
    "address": "4521 William Penn Highway, Mifflintown, PA, 17059",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5621763,
    "lng": -77.3895911
  },
  {
    "id": "10818",
    "name": "Weis Market",
    "address": "1112 West Wyomissing Blvd., West Lawn, PA, 19609",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3143395,
    "lng": -75.9946697
  },
  {
    "id": "10817",
    "name": "Weis Market",
    "address": "693 Lombard Road, Red Lion, PA, 17356",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9165441,
    "lng": -76.6314337
  },
  {
    "id": "10816",
    "name": "Weis Market",
    "address": "550 West MacPhail Road, Bel Air, MD, 21014",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5230087,
    "lng": -76.3457903
  },
  {
    "id": "10815",
    "name": "Weis Market",
    "address": "Carbondale Plaza, 97 Brooklyn St., Carbondale, PA, 18407",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5707575,
    "lng": -75.5095629
  },
  {
    "id": "10814",
    "name": "Weis Market",
    "address": "1199 Texas Palmyra Hwy.-Suite N, Honesdale, PA, 18431",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5518123,
    "lng": -75.2277196
  },
  {
    "id": "10813",
    "name": "Weis Market",
    "address": "3011 William Penn Highway, Easton, PA, 18045",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6778637,
    "lng": -75.262368
  },
  {
    "id": "10812",
    "name": "Weis Market",
    "address": "3825 Sullivan Trail, Easton, PA, 18040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.745185,
    "lng": -75.2416164
  },
  {
    "id": "10811",
    "name": "Weis Market",
    "address": "12817 Shank Farm Way, Hagerstown, MD, 21742",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6654418,
    "lng": -77.6974518
  },
  {
    "id": "10810",
    "name": "Weis Market",
    "address": "2836 Route 611, Suite 100, Tannersville, PA, 18372",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0409611,
    "lng": -75.3072308
  },
  {
    "id": "10809",
    "name": "Weis Market",
    "address": "578 Carbondale Road, Scott Township, PA, 18447",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5305503,
    "lng": -75.6493676
  },
  {
    "id": "10808",
    "name": "Weis Market",
    "address": "1321 Blue Valley Drive, Pen Argyl, PA, 18072",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8744956,
    "lng": -75.2356316
  },
  {
    "id": "10807",
    "name": "Weis Market",
    "address": "5 N. River Street, Plains, PA, 18705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.278953,
    "lng": -75.8572989
  },
  {
    "id": "10806",
    "name": "Weis Market",
    "address": "1070 N. 9th Street, Stroudsburg, PA, 18360",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9903774,
    "lng": -75.2189169
  },
  {
    "id": "10805",
    "name": "Weis Market",
    "address": "695 N. Courtland St, E. Stroudsburg, PA, 18301",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.01796,
    "lng": -75.1837999
  },
  {
    "id": "10804",
    "name": "Weis Market",
    "address": "123 Villiage Center Road, Hawley, PA, 18428",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3475271,
    "lng": -75.0431353
  },
  {
    "id": "10803",
    "name": "Weis Market",
    "address": "70 Phoenix Street, Duryea, PA, 18642",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.3478642,
    "lng": -75.7693987
  },
  {
    "id": "10802",
    "name": "Weis Market",
    "address": "3236 ROUTE 940 STE 116, Mt. Pocono, PA, 18344",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1218201,
    "lng": -75.3725521
  },
  {
    "id": "10801",
    "name": "Weis Market",
    "address": "600 Hunter Highway Suite #11, Tunkhannock, PA, 18657",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5293856,
    "lng": -75.9472312
  },
  {
    "id": "10800",
    "name": "Weis Market",
    "address": "1 Weis Plaza (Walnut & Lower Brdwy), Nanticoke, PA, 18634",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2067298,
    "lng": -76.0033756
  },
  {
    "id": "10799",
    "name": "Weis Market",
    "address": "924 Weir Lake Road, Brodheadsville, PA, 18322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9163705,
    "lng": -75.4200535
  },
  {
    "id": "10798",
    "name": "Weis Market",
    "address": "6093 Spring Ridge Pkwy, Frederick, MD, 21701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3990752,
    "lng": -77.3458366
  },
  {
    "id": "10797",
    "name": "Weis Market",
    "address": "1651 E Cumberland St, Lebanon, PA, 17042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.3523612,
    "lng": -76.3829913
  },
  {
    "id": "10796",
    "name": "Weis Market",
    "address": "140 State Route 23, Franklin, NJ, 7416",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1119244,
    "lng": -74.5772671
  },
  {
    "id": "10795",
    "name": "Weis Market",
    "address": "2045 Mansfield Vilg. Sq., State Rte 57, Hackettstown, NJ, 7840",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8275046,
    "lng": -74.8327105
  },
  {
    "id": "10794",
    "name": "Weis Market",
    "address": "5580 Crawford Drive, Bethlehem, PA, 18017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6740624,
    "lng": -75.389469
  },
  {
    "id": "10793",
    "name": "Weis Market",
    "address": "121 Water St, Newton, NJ, 7860",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0635669,
    "lng": -74.7460512
  },
  {
    "id": "10792",
    "name": "Weis Market",
    "address": "1500 N. Cedar Crest Boulevard, Allentown, PA, 18104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6116703,
    "lng": -75.5351572
  },
  {
    "id": "10791",
    "name": "Weis Market",
    "address": "16 Bedford Square, Everett, PA, 15537",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0189551,
    "lng": -78.4636801
  },
  {
    "id": "10790",
    "name": "Weis Market",
    "address": "720 Hanover Pike, Hampstead, MD, 21074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5941686,
    "lng": -76.8434465
  },
  {
    "id": "10789",
    "name": "Weis Market",
    "address": "1400 Stoney Battery Road, Lancaster, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0635122,
    "lng": -76.4116541
  },
  {
    "id": "10788",
    "name": "Weis Market",
    "address": "110 Rolling Ridge Drive, State College, PA, 16801",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7853261,
    "lng": -77.8272579
  },
  {
    "id": "10787",
    "name": "Weis Market",
    "address": "146 Center Grove Road, Randolph, NJ, 7869",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8640518,
    "lng": -74.5714093
  },
  {
    "id": "10786",
    "name": "Weis Market",
    "address": "112 Atlantic Avenue, Dingman's Ferry, PA, 18328",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.2756945,
    "lng": -74.9219619
  },
  {
    "id": "10785",
    "name": "Weis Market",
    "address": "2600 Willow St Pike Suite 5, Willow St, PA, 17584",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9853316,
    "lng": -76.2841833
  },
  {
    "id": "10784",
    "name": "Weis Market",
    "address": "3885 Union Deposit Road, Harrisburg, PA, 17109",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2765674,
    "lng": -76.8237123
  },
  {
    "id": "10783",
    "name": "Weis Market",
    "address": "26075 Ridge Road, Damascus, MD, 20872",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.285108,
    "lng": -77.2085394
  },
  {
    "id": "10782",
    "name": "Weis Market",
    "address": "2205 Hanover Pike, Hampstead, MD, 21074",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6361885,
    "lng": -76.8639854
  },
  {
    "id": "10781",
    "name": "Weis Market",
    "address": "4300 Linglestown Road, Linglestown, PA, 17112",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.338043,
    "lng": -76.8243431
  },
  {
    "id": "10780",
    "name": "Weis Market",
    "address": "1195 Lowther Road, Camp Hill, PA, 17011",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2346281,
    "lng": -76.8957855
  },
  {
    "id": "10779",
    "name": "Weis Market",
    "address": "4126 East Joppa Road, Baltimore, MD, 21236",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3992627,
    "lng": -76.4838895
  },
  {
    "id": "10778",
    "name": "Weis Market",
    "address": "9270 All Saints Road, Laurel, MD, 20723",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.120509,
    "lng": -76.852006
  },
  {
    "id": "10777",
    "name": "Weis Market",
    "address": "735 Old Harrisburg Road, Gettysburg, PA, 17325",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.841125,
    "lng": -77.224259
  },
  {
    "id": "10776",
    "name": "Weis Market",
    "address": "1001 Twin Arch Road, Mount Airy, MD, 21771",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3679616,
    "lng": -77.1457942
  },
  {
    "id": "10775",
    "name": "Weis Market",
    "address": "501 North Centre Street, Philipsburg, PA, 16866",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9009444,
    "lng": -78.2250072
  },
  {
    "id": "10774",
    "name": "Weis Market",
    "address": "401 North Main St, Elmira, NY, 14901",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0921581,
    "lng": -76.8103741
  },
  {
    "id": "10773",
    "name": "Weis Market",
    "address": "1551 S. Valley Forge Road, Lansdale, PA, 19446",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.2293815,
    "lng": -75.3118818
  },
  {
    "id": "10772",
    "name": "Weis Market",
    "address": "630 Baltimore Boulevard, Westminster, MD, 21157",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.5643497,
    "lng": -76.971686
  },
  {
    "id": "10771",
    "name": "Weis Market",
    "address": "199 Thomas Johnson Drive, Frederick, MD, 21702",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4414098,
    "lng": -77.4094116
  },
  {
    "id": "10770",
    "name": "Weis Market",
    "address": "1102 North Queen St, Martinsburg, WV, 25401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4698333,
    "lng": -77.9566431
  },
  {
    "id": "10769",
    "name": "Weis Market",
    "address": "589 Hamlin Highway, Hamlin, PA, 18427",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4044811,
    "lng": -75.4040619
  },
  {
    "id": "10768",
    "name": "Weis Market",
    "address": "2065 Springwood Road, York, PA, 17403",
    "phone": "(703) 330-8898",
    "hours": "Call for hours",
    "lat": 39.9412714,
    "lng": -76.692179
  },
  {
    "id": "10767",
    "name": "Weis Market",
    "address": "2 Old Camp Road & Rt 40, Frederick, MD, 21702",
    "phone": "(610) 683-8830",
    "hours": "Call for hours",
    "lat": 39.4212188,
    "lng": -77.468338
  },
  {
    "id": "10766",
    "name": "Weis Market",
    "address": "1786J Columbia Avenue, Columbia, PA, 17512",
    "phone": "(610) 683-5263",
    "hours": "Call for hours",
    "lat": 40.0307165,
    "lng": -76.4753771
  },
  {
    "id": "10765",
    "name": "Weis Market",
    "address": "351 East High St, Carlisle, PA, 17013",
    "phone": "(276) 322-0228",
    "hours": "Call for hours",
    "lat": 40.2013548,
    "lng": -77.1821474
  },
  {
    "id": "10764",
    "name": "Weis Market",
    "address": "901 East Main St, Palmyra, PA, 17078",
    "phone": "(717) 442-8784",
    "hours": "Call for hours",
    "lat": 40.3144317,
    "lng": -76.5823478
  },
  {
    "id": "10763",
    "name": "Weis Market",
    "address": "2850 Carlisle Road, Dover, PA, 17315",
    "phone": "(570) 735-3944",
    "hours": "Call for hours",
    "lat": 39.9812769,
    "lng": -76.8146101
  },
  {
    "id": "10762",
    "name": "Weis Market",
    "address": "237 S. Mountain Blvd., Mountain Top, PA, 18707",
    "phone": "(570) 675-4111",
    "hours": "Call for hours",
    "lat": 41.1453974,
    "lng": -75.9001069
  },
  {
    "id": "10761",
    "name": "Weis Market",
    "address": "1080 Maiden Choice Lane, Arbutus, MD, 21229",
    "phone": "(570) 253-7154",
    "hours": "Call for hours",
    "lat": 39.2608466,
    "lng": -76.6959952
  },
  {
    "id": "10760",
    "name": "Weis Market",
    "address": "1643 Manheim Pike, Lancaster, PA, 17601",
    "phone": "(570) 689-5230",
    "hours": "Call for hours",
    "lat": 40.0836261,
    "lng": -76.3403923
  },
  {
    "id": "10759",
    "name": "Weis Market",
    "address": "9613M Harford Road, Carney, MD, 21234",
    "phone": "(570) 281-3300",
    "hours": "Call for hours",
    "lat": 39.3955825,
    "lng": -76.5213668
  },
  {
    "id": "10758",
    "name": "Weis Market",
    "address": "165 Orville Road, Middle River, MD, 21221",
    "phone": "(570) 992-8009",
    "hours": "Call for hours",
    "lat": 39.3249458,
    "lng": -76.4490418
  },
  {
    "id": "10757",
    "name": "Weis Market",
    "address": "7848 Wise Avenue, Dundalk, MD, 21222",
    "phone": "(303) 258-9470",
    "hours": "Call for hours",
    "lat": 39.2688101,
    "lng": -76.4962498
  },
  {
    "id": "10756",
    "name": "Weis Market",
    "address": "7200 Holabird Avenue, Dundalk, MD, 21222",
    "phone": "(610) 863-6689",
    "hours": "Call for hours",
    "lat": 39.2733944,
    "lng": -76.5169384
  },
  {
    "id": "10755",
    "name": "Weis Market",
    "address": "1050 E Philadelphia Ave, Gilbertsville, PA, 19525",
    "phone": "(484) 232-6072",
    "hours": "Call for hours",
    "lat": 40.3238871,
    "lng": -75.6199904
  },
  {
    "id": "10754",
    "name": "Weis Market",
    "address": "31 Eastern Boulevard North, Hagerstown, MD, 21740",
    "phone": "(570) 648-7669",
    "hours": "Call for hours",
    "lat": 39.633863,
    "lng": -77.700871
  },
  {
    "id": "10753",
    "name": "Weis Market",
    "address": "1629 South Market St, Elizabethtown, PA, 17022",
    "phone": "(570) 374-8913",
    "hours": "Call for hours",
    "lat": 40.1385434,
    "lng": -76.5833184
  },
  {
    "id": "10752",
    "name": "Weis Market",
    "address": "331 North Reading Road, Ephrata, PA, 17522",
    "phone": "(570) 374-7703",
    "hours": "Call for hours",
    "lat": 40.1919511,
    "lng": -76.1757248
  },
  {
    "id": "10751",
    "name": "Weis Market",
    "address": "15260 Kutztown Road, Suite 1, Kutztown, PA, 19530",
    "phone": "(570) 374-1210",
    "hours": "Call for hours",
    "lat": 40.5273507,
    "lng": -75.7648569
  },
  {
    "id": "10750",
    "name": "Weis Market",
    "address": "75 Doe Run Road, Manheim, PA, 17545",
    "phone": "(570) 742-9184",
    "hours": "Call for hours",
    "lat": 40.1709626,
    "lng": -76.3848903
  },
  {
    "id": "10749",
    "name": "Weis Market",
    "address": "1220 Chestnut St, Emmaus, PA, 18049",
    "phone": "(570) 966-6500",
    "hours": "Call for hours",
    "lat": 40.5270543,
    "lng": -75.508835
  },
  {
    "id": "10748",
    "name": "Weis Market",
    "address": "2859 SR 309 Suite 75, Dallas, PA, 18612",
    "phone": "(570) 966-1994",
    "hours": "Call for hours",
    "lat": 41.3476067,
    "lng": -75.9602376
  },
  {
    "id": "10747",
    "name": "Weis Market",
    "address": "2525 Memorial Highway, Dallas, PA, 18612",
    "phone": "(570) 524-5757",
    "hours": "Call for hours",
    "lat": 41.3335753,
    "lng": -75.9570179
  },
  {
    "id": "10746",
    "name": "Weis Market",
    "address": "500 Pottsville Park Plaza, Pottsville, PA, 17901",
    "phone": "(570) 275-0999",
    "hours": "Call for hours",
    "lat": 40.69843,
    "lng": -76.1854384
  },
  {
    "id": "10745",
    "name": "Weis Market",
    "address": "1800 Roosevelt Ave., York, PA, 17404",
    "phone": "(570) 356-2082",
    "hours": "Call for hours",
    "lat": 39.9793336,
    "lng": -76.762327
  },
  {
    "id": "10744",
    "name": "Weis Market",
    "address": "2294 Blue Water Blvd., Odenton, MD, 21113",
    "phone": "(570) 387-6183",
    "hours": "Call for hours",
    "lat": 39.1019767,
    "lng": -76.7185907
  },
  {
    "id": "10743",
    "name": "Weis Market",
    "address": "100 Weis Lane, West Hazleton, PA, 18202",
    "phone": "(570) 398-4168",
    "hours": "Call for hours",
    "lat": 40.9661815,
    "lng": -76.0041917
  },
  {
    "id": "10742",
    "name": "Weis Market",
    "address": "1130 Mae St, Hummelstown, PA, 17036",
    "phone": "(570) 326-5144",
    "hours": "Call for hours",
    "lat": 40.2701446,
    "lng": -76.6860778
  },
  {
    "id": "10741",
    "name": "Weis Market",
    "address": "601 Pleasant Valley Blvd, Altoona, PA, 16602",
    "phone": "(717) 392-7905",
    "hours": "Call for hours",
    "lat": 40.5108849,
    "lng": -78.3802231
  },
  {
    "id": "10740",
    "name": "Weis Market",
    "address": "441 West Main St, Mount Joy, PA, 17552",
    "phone": "(717) 392-6511",
    "hours": "Call for hours",
    "lat": 40.1134079,
    "lng": -76.5147703
  },
  {
    "id": "10739",
    "name": "Weis Market",
    "address": "10825 Birmingham Way, Woodstock, MD, 21163",
    "phone": "(717) 396-0468",
    "hours": "Call for hours",
    "lat": 39.30797,
    "lng": -76.8904716
  },
  {
    "id": "10738",
    "name": "Weis Market",
    "address": "448 Prospect Boulevard, Frederick, MD, 21701",
    "phone": "(717) 684-0016",
    "hours": "Call for hours",
    "lat": 39.4037267,
    "lng": -77.4291391
  },
  {
    "id": "10737",
    "name": "Weis Market",
    "address": "5140 Simpson Ferry Road, Mechanicsburg, PA, 17055",
    "phone": "(717) 397-8142",
    "hours": "Call for hours",
    "lat": 40.2179714,
    "lng": -76.9744136
  },
  {
    "id": "10736",
    "name": "Weis Market",
    "address": "1056 Wayne Avenue, Chambersburg, PA, 17201",
    "phone": "(717) 285-7771",
    "hours": "Call for hours",
    "lat": 39.9108408,
    "lng": -77.6530755
  },
  {
    "id": "10735",
    "name": "Weis Market",
    "address": "1603 Lincoln Highway East, Lancaster, PA, 17602",
    "phone": "(717) 285-7720",
    "hours": "Call for hours",
    "lat": 40.039046,
    "lng": -76.2709928
  },
  {
    "id": "10734",
    "name": "Weis Market",
    "address": "1916 Lycoming Creek Road, Williamsport, PA, 17701",
    "phone": "(717) 665-9555",
    "hours": "Call for hours",
    "lat": 41.2547546,
    "lng": -77.0425038
  },
  {
    "id": "10733",
    "name": "Weis Market",
    "address": "1471 Martin St, State College, PA, 16803",
    "phone": "(717) 665-2315",
    "hours": "Call for hours",
    "lat": 40.8051165,
    "lng": -77.8901392
  },
  {
    "id": "10732",
    "name": "Weis Market",
    "address": "2020 North 13th St, Reading, PA, 19604",
    "phone": "(717) 626-9984",
    "hours": "Call for hours",
    "lat": 40.3658323,
    "lng": -75.9126626
  },
  {
    "id": "10731",
    "name": "Weis Market",
    "address": "740 South Broad St, Lititz, PA, 17543",
    "phone": "(717) 442-9448",
    "hours": "Call for hours",
    "lat": 40.1416883,
    "lng": -76.3056519
  },
  {
    "id": "10730",
    "name": "Weis Market",
    "address": "62 East Shirley St, Mount Union, PA, 17066",
    "phone": "(717) 733-9089",
    "hours": "Call for hours",
    "lat": 40.3830823,
    "lng": -77.8807629
  },
  {
    "id": "10729",
    "name": "Weis Market",
    "address": "9250 Washington Boulevard, Laurel, MD, 20723",
    "phone": "(717) 767-1575",
    "hours": "Call for hours",
    "lat": 39.1302925,
    "lng": -76.8215494
  },
  {
    "id": "10728",
    "name": "Weis Market",
    "address": "8115 Ritchie Highway, Pasadena, MD, 21122",
    "phone": "(717) 848-2257",
    "hours": "Call for hours",
    "lat": 39.1249097,
    "lng": -76.588358
  },
  {
    "id": "10727",
    "name": "Weis Market",
    "address": "2160 White Street, York, PA, 17404",
    "phone": "(717) 843-2846",
    "hours": "Call for hours",
    "lat": 39.9619593,
    "lng": -76.770261
  },
  {
    "id": "10726",
    "name": "Weis Market",
    "address": "1204 Millersville Pike, Lancaster, PA, 17603",
    "phone": "(717) 848-6060",
    "hours": "Call for hours",
    "lat": 40.0279247,
    "lng": -76.3244708
  },
  {
    "id": "10725",
    "name": "Weis Market",
    "address": "275 Park Hill Plaza, Altoona, PA, 16602",
    "phone": "(717) 848-2257",
    "hours": "Call for hours",
    "lat": 40.4717647,
    "lng": -78.4053737
  },
  {
    "id": "10724",
    "name": "Weis Market",
    "address": "3644 MacArthur Road, Whitehall, PA, 18052",
    "phone": "(717) 767-5152",
    "hours": "Call for hours",
    "lat": 40.6636851,
    "lng": -75.5118151
  },
  {
    "id": "10723",
    "name": "Weis Market",
    "address": "1075 West King Street, Shippensburg, PA, 17257",
    "phone": "(717) 532-2161",
    "hours": "Call for hours",
    "lat": 40.0383902,
    "lng": -77.5438497
  },
  {
    "id": "10722",
    "name": "Weis Market",
    "address": "801 Loyalsock Avenue, Montoursville, PA, 17754",
    "phone": "(978) 838-2900",
    "hours": "Call for hours",
    "lat": 41.2601354,
    "lng": -76.9191102
  },
  {
    "id": "10721",
    "name": "Weis Market",
    "address": "1100 North Fourth St, Sunbury, PA, 17801",
    "phone": "(717) 261-5757",
    "hours": "Call for hours",
    "lat": 40.8728779,
    "lng": -76.7845725
  },
  {
    "id": "10720",
    "name": "Weis Market",
    "address": "224 North Logan Boulevard, Burnham, PA, 17009",
    "phone": "(717) 412-2051",
    "hours": "Call for hours",
    "lat": 40.6306688,
    "lng": -77.5714347
  },
  {
    "id": "10719",
    "name": "Weis Market",
    "address": "560 Westerly Parkway, State College, PA, 16801",
    "phone": "(717) 436-8858",
    "hours": "Call for hours",
    "lat": 40.7815935,
    "lng": -77.853701
  },
  {
    "id": "10718",
    "name": "Weis Market",
    "address": "6901 Westbranch Highway, Lewisburg, PA, 17837",
    "phone": "(717) 697-1230",
    "hours": "Call for hours",
    "lat": 40.9753893,
    "lng": -76.8913722
  },
  {
    "id": "10717",
    "name": "Weis Market",
    "address": "611 Fifteenth St, Huntingdon, PA, 16652",
    "phone": "(717) 248-9917",
    "hours": "Call for hours",
    "lat": 40.4971182,
    "lng": -78.0142766
  },
  {
    "id": "10716",
    "name": "Weis Market",
    "address": "800 South 12th St, Lebanon, PA, 17042",
    "phone": "(717) 270-1919",
    "hours": "Call for hours",
    "lat": 40.3280434,
    "lng": -76.4277711
  },
  {
    "id": "10715",
    "name": "Weis Market",
    "address": "235 Main St, Catawissa, PA, 17820",
    "phone": "(717) 533-2963",
    "hours": "Call for hours",
    "lat": 40.9520388,
    "lng": -76.4600379
  },
  {
    "id": "10714",
    "name": "Weis Market",
    "address": "2186 State Route 54, Montgomery, PA, 17752",
    "phone": "(717) 975-0618",
    "hours": "Call for hours",
    "lat": 41.1789783,
    "lng": -76.8771856
  },
  {
    "id": "10713",
    "name": "Weis Market",
    "address": "313-327 W Bald Eagle St, Lock Haven, PA, 17745",
    "phone": "(814) 342-6451",
    "hours": "Call for hours",
    "lat": 41.1338997,
    "lng": -77.4531661
  },
  {
    "id": "10712",
    "name": "Weis Market",
    "address": "135 -147 Market St, Sunbury, PA, 17801",
    "phone": "(814) 342-1752",
    "hours": "Call for hours",
    "lat": 40.8621453,
    "lng": -76.7953953
  },
  {
    "id": "10711",
    "name": "Weis Market",
    "address": "316 Walnut St, Newport, PA, 17074",
    "phone": "(814) 355-0376",
    "hours": "Call for hours",
    "lat": 40.4788869,
    "lng": -77.1340452
  },
  {
    "id": "10710",
    "name": "Weis Market",
    "address": "1571 Rt 209, Millersburg, PA, 17061",
    "phone": "(814) 231-8398",
    "hours": "Call for hours",
    "lat": 40.5407469,
    "lng": -76.9237926
  },
  {
    "id": "10709",
    "name": "Weis Market",
    "address": "1700A Fruitville Pike, Lancaster, PA, 17601",
    "phone": "(732) 563-4001",
    "hours": "Call for hours",
    "lat": 40.0680034,
    "lng": -76.3169616
  },
  {
    "id": "10708",
    "name": "Weis Market",
    "address": "860 Carlisle St, Hanover, PA, 17331",
    "phone": "(570) 326-5802",
    "hours": "Call for hours",
    "lat": 39.8124313,
    "lng": -76.9925674
  },
  {
    "id": "10707",
    "name": "Weis Market",
    "address": "1440 Allegheny St, Jersey Shore, PA, 17740",
    "phone": "(732) 499-3000",
    "hours": "Call for hours",
    "lat": 41.201629,
    "lng": -77.2765227
  },
  {
    "id": "10706",
    "name": "Weis Market",
    "address": "140 Continental Boulevard, Danville, PA, 17821",
    "phone": "(410) 374-1745",
    "hours": "Call for hours",
    "lat": 40.9666656,
    "lng": -76.615638
  },
  {
    "id": "10705",
    "name": "Weis Market",
    "address": "305 River Ave, Williamsport, PA, 17701",
    "phone": "(410) 374-1440",
    "hours": "Call for hours",
    "lat": 41.2497399,
    "lng": -76.9817677
  },
  {
    "id": "10704",
    "name": "Weis Market",
    "address": "1105 Chestnut St, Berwick, PA, 18603",
    "phone": "(410) 590-5675",
    "hours": "Call for hours",
    "lat": 41.0630551,
    "lng": -76.2357329
  },
  {
    "id": "10703",
    "name": "Weis Market",
    "address": "555 Mahoning St, Milton, PA, 17847",
    "phone": "(410) 638-5800",
    "hours": "Call for hours",
    "lat": 41.0124122,
    "lng": -76.8441673
  },
  {
    "id": "10702",
    "name": "Weis Market",
    "address": "2400 East Market St, York, PA, 17402",
    "phone": "(734) 529-3242",
    "hours": "Call for hours",
    "lat": 39.9737915,
    "lng": -76.6793504
  },
  {
    "id": "10701",
    "name": "Weis Market",
    "address": "339 W. Walnut St., Shamokin, PA, 17872",
    "phone": "(732) 244-8410",
    "hours": "Call for hours",
    "lat": 40.7903306,
    "lng": -76.5616471
  },
  {
    "id": "10700",
    "name": "Whole Foods Market",
    "address": "1155 S US-89, Jackson, WY, 83001",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.4636345,
    "lng": -110.7941099
  },
  {
    "id": "10699",
    "name": "Whole Foods Market",
    "address": "695 S Broadway, Boulder, CO, 80305",
    "phone": "(303) 376-6980",
    "hours": "Call for hours",
    "lat": 39.9829363,
    "lng": -105.2484627
  },
  {
    "id": "10698",
    "name": "Whole Foods Market",
    "address": "660 Linton Ave, Delray Beach, FL, 33444",
    "phone": "",
    "hours": "Call for hours",
    "lat": 26.4388875,
    "lng": -80.0796191
  },
  {
    "id": "10697",
    "name": "Whole Foods Market",
    "address": "9600 South Western Ave, Evergreen Park, IL, 60805",
    "phone": "708.931.3030",
    "hours": "Call for hours",
    "lat": 41.7182424,
    "lng": -87.6821984
  },
  {
    "id": "10696",
    "name": "Whole Foods Market",
    "address": "1400 Waterfront Terrace, Weehawken, NJ, 7086",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7609578,
    "lng": -74.0241632
  },
  {
    "id": "10695",
    "name": "Whole Foods Market",
    "address": "292 Ashland Place, Brooklyn, NY, 11217",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6864068,
    "lng": -73.9783928
  },
  {
    "id": "10694",
    "name": "Whole Foods Market",
    "address": "3490 SW Archer Road, Gainesville, FL, 32608",
    "phone": "352.244.8302",
    "hours": "Call for hours",
    "lat": 29.6253219,
    "lng": -82.3759986
  },
  {
    "id": "10693",
    "name": "Whole Foods Market",
    "address": "6400 E. Pacific Coast Highway Suite A-100, Long Beach, CA, 90803",
    "phone": "5625988687",
    "hours": "Call for hours",
    "lat": 33.7559577,
    "lng": -118.1099255
  },
  {
    "id": "10692",
    "name": "Whole Foods Market",
    "address": "6400 E. Pacific Coast Highway Suite A-100, Long Beach, CA, 90803",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.7559577,
    "lng": -118.1099255
  },
  {
    "id": "10691",
    "name": "Whole Foods Market",
    "address": "1127 Savannah Highway, Charleston, SC, 29407",
    "phone": "203.272.4714",
    "hours": "Call for hours",
    "lat": 32.7834479,
    "lng": -79.9961499
  },
  {
    "id": "10690",
    "name": "Whole Foods Market",
    "address": "20209 W. Rinaldi Street, Porter Ranch, CA, 91326",
    "phone": "8183633933",
    "hours": "Call for hours",
    "lat": 34.2758387,
    "lng": -118.5744408
  },
  {
    "id": "10689",
    "name": "Whole Foods Market",
    "address": "536 Boston Post Road, Sudbury, MA, 1776",
    "phone": "508.358.7700",
    "hours": "Call for hours",
    "lat": 42.3613336,
    "lng": -71.4318844
  },
  {
    "id": "10688",
    "name": "Whole Foods Market",
    "address": "3881 Lakewood Blvd, Los Angeles, CA, 90808",
    "phone": "",
    "hours": "Call for hours",
    "lat": 33.8297557,
    "lng": -118.1443602
  },
  {
    "id": "10687",
    "name": "Whole Foods Market",
    "address": "1202 Broadway, Nashville, TN, 37203-3118",
    "phone": "TBD",
    "hours": "Call for hours",
    "lat": 36.1567496,
    "lng": -86.7880596
  },
  {
    "id": "10686",
    "name": "Whole Foods Market",
    "address": "120 Veterans Memorial Highway, Unit 34, Commack, NY, 11725",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8380142,
    "lng": -73.2840917
  },
  {
    "id": "10685",
    "name": "Whole Foods Market",
    "address": "7930 SW 104th St, Miami, FL, 33156",
    "phone": "305.971.0900",
    "hours": "Call for hours",
    "lat": 25.6733129,
    "lng": -80.323317
  },
  {
    "id": "10684",
    "name": "Whole Foods Market",
    "address": "851 N. Milwaukee Ave, Vernon Hills, IL, 60061",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.241144,
    "lng": -87.9437432
  },
  {
    "id": "10683",
    "name": "Whole Foods Market",
    "address": "2085 Diamond Blvd, Suite 125, Concord, CA, 94520",
    "phone": "925.695.3180",
    "hours": "Call for hours",
    "lat": 37.9741051,
    "lng": -122.0587978
  },
  {
    "id": "10682",
    "name": "Whole Foods Market",
    "address": "Baseline and Hwy 210, Upland, CA, 91711",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.1229416,
    "lng": -117.6925009
  },
  {
    "id": "10681",
    "name": "Whole Foods Market",
    "address": "1745 W Market Street, Akron, OH, 44313",
    "phone": "551.574.1485",
    "hours": "Call for hours",
    "lat": 41.1109674,
    "lng": -81.5713821
  },
  {
    "id": "10680",
    "name": "Whole Foods Market",
    "address": "3420 Secor Rd, Toledo, OH, 43606",
    "phone": "704.367.6798",
    "hours": "Call for hours",
    "lat": 41.6829151,
    "lng": -83.6212908
  },
  {
    "id": "10679",
    "name": "Whole Foods Market",
    "address": "6891 Daniels Parkway, Ste 100, Fort Myers, FL, 33912",
    "phone": "239.935.6550",
    "hours": "Call for hours",
    "lat": 26.5479289,
    "lng": -81.8416758
  },
  {
    "id": "10678",
    "name": "Whole Foods Market",
    "address": "1600 Jackson St, San Francisco, CA, 94109",
    "phone": "703.914.8803",
    "hours": "Call for hours",
    "lat": 37.7943514,
    "lng": -122.4218618
  },
  {
    "id": "10677",
    "name": "Whole Foods Market",
    "address": "5901 E Galbraith Road, Kenwood, OH, 45236",
    "phone": "408.207.1126",
    "hours": "Call for hours",
    "lat": 39.2043025,
    "lng": -84.3736758
  },
  {
    "id": "10676",
    "name": "Whole Foods Market",
    "address": "5001 183A Toll Road, #16, Cedar Park, TX, 78613",
    "phone": "",
    "hours": "Call for hours",
    "lat": 30.5336984,
    "lng": -97.8184866
  },
  {
    "id": "10675",
    "name": "Whole Foods Market",
    "address": "50 Wall Street, Orange Village, OH, 44122",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.449988,
    "lng": -81.4850716
  },
  {
    "id": "10674",
    "name": "Whole Foods Market",
    "address": "89 Danada Square East, Wheaton, IL, 60189",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8303931,
    "lng": -88.1014475
  },
  {
    "id": "10673",
    "name": "Whole Foods Market",
    "address": "175 N Pottstown Pike, Exton, PA, 19341",
    "phone": "512.499.3803",
    "hours": "Call for hours",
    "lat": 40.0300506,
    "lng": -75.6279918
  },
  {
    "id": "10672",
    "name": "Whole Foods Market",
    "address": "2520 Gendale Blvd, Los Angeles, CA, 90039",
    "phone": "410.573.1801",
    "hours": "Call for hours",
    "lat": 34.1029214,
    "lng": -118.2584117
  },
  {
    "id": "10671",
    "name": "Whole Foods Market",
    "address": "Totem Lake Blvd, Kirkland, WA, 98034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.7130983,
    "lng": -122.1832621
  },
  {
    "id": "10670",
    "name": "Whole Foods Market",
    "address": "11 S State St, Lake Oswego, OR, 97034",
    "phone": "5037824672",
    "hours": "Call for hours",
    "lat": 45.4157405,
    "lng": -122.6620293
  },
  {
    "id": "10669",
    "name": "Whole Foods Market",
    "address": "2121 Cloverfield Blvd, Santa Monica, CA, 90404",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0221303,
    "lng": -118.4655725
  },
  {
    "id": "10668",
    "name": "Whole Foods Market",
    "address": "101 N Loop E, Houston, TX, 77018",
    "phone": "",
    "hours": "Call for hours",
    "lat": 29.8141206,
    "lng": -95.3697859
  },
  {
    "id": "10667",
    "name": "Whole Foods Market",
    "address": "22 14th Street NW, Suite C, Atlanta, GA, 30309",
    "phone": "470.552.4201",
    "hours": "Call for hours",
    "lat": 33.7858512,
    "lng": -84.3880767
  },
  {
    "id": "10666",
    "name": "Whole Foods Market",
    "address": "5001 Peachtree Blvd, Chamblee, GA, 30341",
    "phone": "919.467.0062",
    "hours": "Call for hours",
    "lat": 33.883908,
    "lng": -84.3160931
  },
  {
    "id": "10665",
    "name": "Whole Foods Market",
    "address": "1822 3rd Street South, Jacksonville Beach, FL, 32250",
    "phone": "TBD",
    "hours": "Call for hours",
    "lat": 30.271781,
    "lng": -81.3895693
  },
  {
    "id": "10664",
    "name": "Whole Foods Market",
    "address": "1635 Boro Place, McLean, VA, 22102",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9246913,
    "lng": -77.2333798
  },
  {
    "id": "10663",
    "name": "Whole Foods Market",
    "address": "6598 N Landmark Dr, Park City, UT, 84098",
    "phone": "435.575.0200",
    "hours": "Call for hours",
    "lat": 40.7272836,
    "lng": -111.5470165
  },
  {
    "id": "10662",
    "name": "Whole Foods Market",
    "address": "515 Elgin Street, Houston, TX, 77006",
    "phone": "3463537501",
    "hours": "Call for hours",
    "lat": 29.7439133,
    "lng": -95.3805744
  },
  {
    "id": "10661",
    "name": "Whole Foods Market",
    "address": "300 East Stonewall St, Suite A, Charlotte, NC, 28202",
    "phone": "805.777.4740",
    "hours": "Call for hours",
    "lat": 35.2211207,
    "lng": -80.8469039
  },
  {
    "id": "10660",
    "name": "Whole Foods Market",
    "address": "3201 N Ashland Ave, Chicago, IL, 60657",
    "phone": "954.753.9504",
    "hours": "Call for hours",
    "lat": 41.9399847,
    "lng": -87.668204
  },
  {
    "id": "10659",
    "name": "Whole Foods Market",
    "address": "5928 University Parkway, Sarasota, FL, 34243",
    "phone": "941.806.6130",
    "hours": "Call for hours",
    "lat": 27.3884438,
    "lng": -82.4419097
  },
  {
    "id": "10658",
    "name": "Whole Foods Market",
    "address": "2100 E Maple Rd, Birmingham, MI, 48009",
    "phone": "203.662.0430",
    "hours": "Call for hours",
    "lat": 42.5467853,
    "lng": -83.194205
  },
  {
    "id": "10657",
    "name": "Whole Foods Market",
    "address": "319 Chimney Rock Rd, Bound Brook, NJ, 8805",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.5779912,
    "lng": -74.5585488
  },
  {
    "id": "10656",
    "name": "Whole Foods Market",
    "address": "711 South Central Ave, Baltimore, MD, 21202",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.2825112,
    "lng": -76.5987055
  },
  {
    "id": "10655",
    "name": "Whole Foods Market",
    "address": "1030 Lakeway Dr, Bellingham, WA, 98229",
    "phone": "773.244.4074",
    "hours": "Call for hours",
    "lat": 48.7435936,
    "lng": -122.4612952
  },
  {
    "id": "10654",
    "name": "Whole Foods Market",
    "address": "2732 Augustine Dr Ste 1600, Santa Clara, CA, 95054",
    "phone": "408.562.9162",
    "hours": "Call for hours",
    "lat": 37.3808426,
    "lng": -121.9761941
  },
  {
    "id": "10653",
    "name": "Whole Foods Market",
    "address": "3450 Hwy 190 Ste 8, Mandeville, LA, 70471",
    "phone": "305.938.2801",
    "hours": "Call for hours",
    "lat": 30.3901778,
    "lng": -90.0850437
  },
  {
    "id": "10652",
    "name": "Whole Foods Market",
    "address": "1001 Broadway Ave, Seattle, WA, 98104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6113759,
    "lng": -122.3211805
  },
  {
    "id": "10651",
    "name": "Whole Foods Market",
    "address": "305 Radio Drive, Woodbury, MN, 55125",
    "phone": "504.947.7901",
    "hours": "Call for hours",
    "lat": 44.9431433,
    "lng": -92.9299249
  },
  {
    "id": "10650",
    "name": "Whole Foods Market",
    "address": "6741 N MacArthur Blvd, Irving, TX, 75039",
    "phone": "469-845-8001",
    "hours": "Call for hours",
    "lat": 32.9013187,
    "lng": -96.9603382
  },
  {
    "id": "10649",
    "name": "Whole Foods Market",
    "address": "1701 Wewatta St, Denver, CO, 80202",
    "phone": "720.572.8800",
    "hours": "Call for hours",
    "lat": 39.7545752,
    "lng": -105.0013537
  },
  {
    "id": "10648",
    "name": "Whole Foods Market",
    "address": "3737 West Chester Pike, Newtown Square, PA, 19073",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9880239,
    "lng": -75.4037887
  },
  {
    "id": "10647",
    "name": "Whole Foods Market",
    "address": "1573 Fruitville Pike, Lancaster, PA, 17601",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0647286,
    "lng": -76.3144057
  },
  {
    "id": "10646",
    "name": "Whole Foods Market",
    "address": "100 Pitt St, El Paso, TX, 79912",
    "phone": "915.236.1420",
    "hours": "Call for hours",
    "lat": 31.8340454,
    "lng": -106.5480032
  },
  {
    "id": "10645",
    "name": "Whole Foods Market",
    "address": "4402 Legendary Dr, Destin, FL, 32541",
    "phone": "850.269.7400",
    "hours": "Call for hours",
    "lat": 30.3902387,
    "lng": -86.4202335
  },
  {
    "id": "10644",
    "name": "Whole Foods Market",
    "address": "160 Littleton Rd, Westford, MA, 1886",
    "phone": "978.303.2900",
    "hours": "Call for hours",
    "lat": 42.5682691,
    "lng": -71.4201251
  },
  {
    "id": "10643",
    "name": "Whole Foods Market",
    "address": "193 Boston Turnpike, Shrewsbury, MA, 1545",
    "phone": "508.749.5520",
    "hours": "Call for hours",
    "lat": 42.2760711,
    "lng": -71.7467593
  },
  {
    "id": "10642",
    "name": "Whole Foods Market",
    "address": "150 Brimbal Ave, Beverly, MA, 1915",
    "phone": "978.529.9151",
    "hours": "Call for hours",
    "lat": 42.5733876,
    "lng": -70.8797205
  },
  {
    "id": "10641",
    "name": "Whole Foods Market",
    "address": "121 South River Rd, Bedford, NH, 3110",
    "phone": "603.218.1900",
    "hours": "Call for hours",
    "lat": 42.9542672,
    "lng": -71.4778449
  },
  {
    "id": "10640",
    "name": "Whole Foods Market",
    "address": "388 Kamakee, Honolulu, HI, 96814",
    "phone": "808.738.0820",
    "hours": "Call for hours",
    "lat": 21.294647,
    "lng": -157.8521
  },
  {
    "id": "10639",
    "name": "Whole Foods Market",
    "address": "8525 Irvine Center Dr, Irvine, CA, 92618",
    "phone": "949.777.8500",
    "hours": "Call for hours",
    "lat": 33.6463008,
    "lng": -117.7443927
  },
  {
    "id": "10638",
    "name": "Whole Foods Market",
    "address": "1411 E Renner Rd, Richardson, TX, 75082",
    "phone": "303.938.8963",
    "hours": "Call for hours",
    "lat": 32.9987065,
    "lng": -96.6987674
  },
  {
    "id": "10637",
    "name": "Whole Foods Market",
    "address": "11041 Westheimer Rd, Houston, TX, 77042",
    "phone": "707.829.8074",
    "hours": "Call for hours",
    "lat": 29.7353304,
    "lng": -95.5692759
  },
  {
    "id": "10636",
    "name": "Whole Foods Market",
    "address": "5055 Arco St, Cary, NC, 27519",
    "phone": "(984) 228-0300",
    "hours": "Call for hours",
    "lat": 35.8336487,
    "lng": -78.8826704
  },
  {
    "id": "10635",
    "name": "Whole Foods Market",
    "address": "1450 Taylor Rd, Montgomery, AL, 36117",
    "phone": "(334) 523-2940",
    "hours": "Call for hours",
    "lat": 32.3586036,
    "lng": -86.1727917
  },
  {
    "id": "10634",
    "name": "Whole Foods Market",
    "address": "645 Middlesex Ave, Metuchen, NJ, 8840",
    "phone": "949.376.7889",
    "hours": "Call for hours",
    "lat": 40.5398554,
    "lng": -74.366445
  },
  {
    "id": "10633",
    "name": "Whole Foods Market",
    "address": "3139 Sheridan Drive, Amherst, NY, 14226",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.9791144,
    "lng": -78.8168738
  },
  {
    "id": "10632",
    "name": "Whole Foods Market",
    "address": "480 N Bedford Rd, Chappaqua, NY, 10514",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.1791639,
    "lng": -73.7545787
  },
  {
    "id": "10631",
    "name": "Whole Foods Market",
    "address": "1111 North Bethlehem Pike, Springhouse, PA, 19477",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1881634,
    "lng": -75.2272517
  },
  {
    "id": "10630",
    "name": "Whole Foods Market",
    "address": "2024 West Broad Street, Richmond, VA, 23220",
    "phone": "",
    "hours": "Call for hours",
    "lat": 37.5581958,
    "lng": -77.4612166
  },
  {
    "id": "10629",
    "name": "Whole Foods Market",
    "address": "320 E Market Street, Indianapolis, IN, 46204",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.7686604,
    "lng": -86.1512708
  },
  {
    "id": "10628",
    "name": "Whole Foods Market",
    "address": "3425 N College Ave, Fayetteville, AR, 72703",
    "phone": "916.781.5424",
    "hours": "Call for hours",
    "lat": 36.1137251,
    "lng": -94.1464182
  },
  {
    "id": "10627",
    "name": "Whole Foods Market",
    "address": "3301 Imperial Hwy, Brea, CA, 92823",
    "phone": "714.528.7400",
    "hours": "Call for hours",
    "lat": 33.9103489,
    "lng": -117.8513816
  },
  {
    "id": "10626",
    "name": "Whole Foods Market",
    "address": "7221 Waverly Walk Ave, Charlotte, NC, 28277",
    "phone": "(704) 949-1860",
    "hours": "Call for hours",
    "lat": 35.0531552,
    "lng": -80.7673253
  },
  {
    "id": "10625",
    "name": "Whole Foods Market",
    "address": "2501 Memorial Pkwy SW, Huntsville, AL, 35801",
    "phone": "415.878.0466",
    "hours": "Call for hours",
    "lat": 34.7122884,
    "lng": -86.5898277
  },
  {
    "id": "10624",
    "name": "Whole Foods Market",
    "address": "1300 Ernest Barrett Parkway, Kennesaw, GA, 30144",
    "phone": "236.521.2700",
    "hours": "Call for hours",
    "lat": 33.9982204,
    "lng": -84.5901231
  },
  {
    "id": "10623",
    "name": "Whole Foods Market",
    "address": "3515 Bridgeport Way W, University Place, WA, 98466",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.2271495,
    "lng": -122.5360339
  },
  {
    "id": "10622",
    "name": "Whole Foods Market",
    "address": "1933 State Rd 35, Wall, NJ, 7719",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.1557334,
    "lng": -74.0547518
  },
  {
    "id": "10621",
    "name": "Whole Foods Market",
    "address": "11100 W Burleigh St, Wauwatosa, WI, 53222",
    "phone": "201.941.4085",
    "hours": "Call for hours",
    "lat": 43.0759298,
    "lng": -88.0514374
  },
  {
    "id": "10620",
    "name": "Whole Foods Market",
    "address": "199 US Hwy 41, Schererville, IN, 46375",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5192379,
    "lng": -87.4705351
  },
  {
    "id": "10619",
    "name": "Whole Foods Market",
    "address": "1531 Froom Ranch Way, San Luis Obispo, CA, 93405",
    "phone": "805.785.0194",
    "hours": "Call for hours",
    "lat": 35.250754,
    "lng": -120.6871188
  },
  {
    "id": "10618",
    "name": "Whole Foods Market",
    "address": "1420 W Hwy 89A, Sedona, AZ, 86336",
    "phone": "928.282.6311",
    "hours": "Call for hours",
    "lat": 34.8636016,
    "lng": -111.7850075
  },
  {
    "id": "10617",
    "name": "Whole Foods Market",
    "address": "320 S Cambridge Ln, Flagstaff, AZ, 86001",
    "phone": "512.499.7112",
    "hours": "Call for hours",
    "lat": 35.1915936,
    "lng": -111.6411993
  },
  {
    "id": "10616",
    "name": "Whole Foods Market",
    "address": "1030 N Orlando Ave, Winter Park, FL, 32789",
    "phone": "407.377.6040",
    "hours": "Call for hours",
    "lat": 28.6067993,
    "lng": -81.3633855
  },
  {
    "id": "10615",
    "name": "Whole Foods Market",
    "address": "4059 Finn Way, Lexington, KY, 50517",
    "phone": "8599718600",
    "hours": "Call for hours",
    "lat": 37.9776328,
    "lng": -84.5286723
  },
  {
    "id": "10614",
    "name": "Whole Foods Market",
    "address": "1255 Raritan Rd Unit 150, Clark, NJ, 7066",
    "phone": "604.739.6694",
    "hours": "Call for hours",
    "lat": 40.6314763,
    "lng": -74.3039379
  },
  {
    "id": "10613",
    "name": "Whole Foods Market",
    "address": "1380 E 70th St, Shreveport, LA, 71105",
    "phone": "818.990.7089",
    "hours": "Call for hours",
    "lat": 32.4442296,
    "lng": -93.7269284
  },
  {
    "id": "10612",
    "name": "Whole Foods Market",
    "address": "1925 Hughes Landing Blvd Ste 100, The Woodlands, TX, 77380",
    "phone": "832-246-5600",
    "hours": "Call for hours",
    "lat": 30.1694154,
    "lng": -95.4704087
  },
  {
    "id": "10611",
    "name": "Whole Foods Market",
    "address": "6300 Kingery Hwy, Willowbrook, IL, 60527",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7716897,
    "lng": -87.9479549
  },
  {
    "id": "10610",
    "name": "Whole Foods Market",
    "address": "1 N Halsted St, Chicago, IL, 60661",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8821688,
    "lng": -87.6469767
  },
  {
    "id": "10609",
    "name": "Whole Foods Market",
    "address": "255 E Grand Ave, Chicago, IL, 60611",
    "phone": "922.452.2226",
    "hours": "Call for hours",
    "lat": 41.8912314,
    "lng": -87.620641
  },
  {
    "id": "10608",
    "name": "Whole Foods Market",
    "address": "2748 Green Bay Rd, Evanston, IL, 60201",
    "phone": "303.832.3498",
    "hours": "Call for hours",
    "lat": 42.0678534,
    "lng": -87.7022461
  },
  {
    "id": "10607",
    "name": "Whole Foods Market",
    "address": "215 S IL Rte 83, Elmhurst, IL, 60126",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8939983,
    "lng": -87.9604952
  },
  {
    "id": "10606",
    "name": "Whole Foods Market",
    "address": "6009 N Broadway, Chicago, IL, 60660",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9911446,
    "lng": -87.6598109
  },
  {
    "id": "10605",
    "name": "Whole Foods Market",
    "address": "959 West Fullerton Ave, Chicago, IL, 60614",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.9252019,
    "lng": -87.6533791
  },
  {
    "id": "10604",
    "name": "Whole Foods Market",
    "address": "750 N Krocks Rd Ste 301, Allentown, PA, 18106",
    "phone": "512.499.3802",
    "hours": "Call for hours",
    "lat": 40.564525,
    "lng": -75.564696
  },
  {
    "id": "10603",
    "name": "Whole Foods Market",
    "address": "600-A H Street, NE, Washington, DC, 20002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9009253,
    "lng": -76.9970671
  },
  {
    "id": "10602",
    "name": "Whole Foods Market",
    "address": "101 H ST SE, Washington, DC, 20003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8802819,
    "lng": -77.005121
  },
  {
    "id": "10601",
    "name": "Whole Foods Market",
    "address": "7825 Hwy 72, Memphis, TN, 38138",
    "phone": "(901) 896-3245",
    "hours": "Call for hours",
    "lat": 35.0888037,
    "lng": -89.8021257
  },
  {
    "id": "10600",
    "name": "Whole Foods Market",
    "address": "50 Shelter Cove Ln, Hilton Head Island, SC, 29928",
    "phone": "(843) 842-0700",
    "hours": "Call for hours",
    "lat": 32.1869521,
    "lng": -80.7169372
  },
  {
    "id": "10599",
    "name": "Whole Foods Market",
    "address": "633 Broad St, Newark, NJ, 7102",
    "phone": "562.598.8680",
    "hours": "Call for hours",
    "lat": 40.7400078,
    "lng": -74.1699916
  },
  {
    "id": "10598",
    "name": "Whole Foods Market",
    "address": "1050 Miamisburg Centerville Rd, Dayton, OH, 45458",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.6269159,
    "lng": -84.1900779
  },
  {
    "id": "10597",
    "name": "Whole Foods Market",
    "address": "832 W 63rd St, Chicago, IL, 60621",
    "phone": "770.509.8707",
    "hours": "Call for hours",
    "lat": 41.7806896,
    "lng": -87.6464745
  },
  {
    "id": "10596",
    "name": "Whole Foods Market",
    "address": "4451 Main St, Westminster, CO, 80031",
    "phone": "303.439.7000",
    "hours": "Call for hours",
    "lat": 39.913434,
    "lng": -105.0446913
  },
  {
    "id": "10595",
    "name": "Whole Foods Market",
    "address": "4100 Easton Gateway Dr, Columbus, OH, 43219",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0570337,
    "lng": -82.9095611
  },
  {
    "id": "10594",
    "name": "Whole Foods Market",
    "address": "1250 S Hover Rd Ste 300, Longmont, CO, 80501",
    "phone": "720.438.2550",
    "hours": "Call for hours",
    "lat": 40.1451799,
    "lng": -105.1294157
  },
  {
    "id": "10593",
    "name": "Whole Foods Market",
    "address": "1407 S Voss Rd, Houston, TX, 75057",
    "phone": "404.236.0339",
    "hours": "Call for hours",
    "lat": 29.7523834,
    "lng": -95.4999858
  },
  {
    "id": "10592",
    "name": "Whole Foods Market",
    "address": "501 Bowman Rd, Little Rock, AR, 72211",
    "phone": "301.816.1897",
    "hours": "Call for hours",
    "lat": 34.7498999,
    "lng": -92.4055883
  },
  {
    "id": "10591",
    "name": "Whole Foods Market",
    "address": "1903 University Dr, Davie, FL, 33324",
    "phone": "954.916.3000",
    "hours": "Call for hours",
    "lat": 26.0965814,
    "lng": -80.2519087
  },
  {
    "id": "10590",
    "name": "Whole Foods Market",
    "address": "2941 Ygnacio Valley Rd, Walnut Creek, CA, 94598",
    "phone": "925.269.9010",
    "hours": "Call for hours",
    "lat": 37.9256149,
    "lng": -122.0168814
  },
  {
    "id": "10589",
    "name": "Whole Foods Market",
    "address": "5200 Dublin Blvd, Dublin, CA, 94568",
    "phone": "925.452.2226",
    "hours": "Call for hours",
    "lat": 37.7057284,
    "lng": -121.8897911
  },
  {
    "id": "10588",
    "name": "Whole Foods Market",
    "address": "788 S Grand Ave, Los Angeles, CA, 90017",
    "phone": "213.873.4745",
    "hours": "Call for hours",
    "lat": 34.0456943,
    "lng": -118.2572291
  },
  {
    "id": "10587",
    "name": "Whole Foods Market",
    "address": "3401 West Olive Avenue, Burbank, CA, 91505",
    "phone": "818.239.5380",
    "hours": "Call for hours",
    "lat": 34.154388,
    "lng": -118.3371784
  },
  {
    "id": "10586",
    "name": "Whole Foods Market",
    "address": "9129 Sam Furr Rd, Huntersville, NC, 28078",
    "phone": "(704) 765-3735",
    "hours": "Call for hours",
    "lat": 35.4440527,
    "lng": -80.8718073
  },
  {
    "id": "10585",
    "name": "Whole Foods Market",
    "address": "1575 Selby Ave, St Paul, MN, 55104",
    "phone": "678.514.2410",
    "hours": "Call for hours",
    "lat": 44.9469848,
    "lng": -93.1661218
  },
  {
    "id": "10584",
    "name": "Whole Foods Market",
    "address": "2750 E Grand River Ave, East Lansing, MI, 48823",
    "phone": "602.954.7435",
    "hours": "Call for hours",
    "lat": 42.7282705,
    "lng": -84.4529551
  },
  {
    "id": "10583",
    "name": "Whole Foods Market",
    "address": "14615 W 119th St, Olathe, KS, 66062",
    "phone": "913.764.5656",
    "hours": "Call for hours",
    "lat": 38.9114088,
    "lng": -94.7563777
  },
  {
    "id": "10582",
    "name": "Whole Foods Market",
    "address": "12220 SW Scholls Ferry Rd, Tigard, OR, 97223",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.4425075,
    "lng": -122.8024394
  },
  {
    "id": "10581",
    "name": "Whole Foods Market",
    "address": "12746 Jefferson Blvd, Playa Vista, CA, 90094",
    "phone": "310.862.9900",
    "hours": "Call for hours",
    "lat": 33.9771716,
    "lng": -118.4173993
  },
  {
    "id": "10580",
    "name": "Whole Foods Market",
    "address": "4577 W Pine Blvd, St Louis, MO, 63108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6419244,
    "lng": -90.2615092
  },
  {
    "id": "10579",
    "name": "Whole Foods Market",
    "address": "19800 Belmont Chase Dr, Ashburn, VA, 20147",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0686101,
    "lng": -77.4843579
  },
  {
    "id": "10578",
    "name": "Whole Foods Market",
    "address": "520 12th St South Ste 100, Arlington, VA, 22202",
    "phone": "720.941.8999",
    "hours": "Call for hours",
    "lat": 38.8628102,
    "lng": -77.0545096
  },
  {
    "id": "10577",
    "name": "Whole Foods Market",
    "address": "1025 Gilman St, Berkeley, CA, 94710",
    "phone": "510.809.8293",
    "hours": "Call for hours",
    "lat": 37.8806582,
    "lng": -122.2974496
  },
  {
    "id": "10576",
    "name": "Whole Foods Market",
    "address": "1845 Palm Beach Lakes Blvd Bldg. C, West Palm Beach, FL, 33401",
    "phone": "561.471.3800",
    "hours": "Call for hours",
    "lat": 26.7206634,
    "lng": -80.0892848
  },
  {
    "id": "10575",
    "name": "Whole Foods Market",
    "address": "4247 Ambassador Caffery Pkwy, Lafayette, LA, 70508",
    "phone": "310.376.7651",
    "hours": "Call for hours",
    "lat": 30.1610967,
    "lng": -92.0517389
  },
  {
    "id": "10574",
    "name": "Whole Foods Market",
    "address": "1558 N Kings Hwy, Cherry Hill, NJ, 8034",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9158337,
    "lng": -75.0115525
  },
  {
    "id": "10573",
    "name": "Whole Foods Market",
    "address": "12090 Jefferson Ave, Newport News, VA, 23606",
    "phone": "617.492.5953",
    "hours": "Call for hours",
    "lat": 37.1031232,
    "lng": -76.4913256
  },
  {
    "id": "10572",
    "name": "Whole Foods Market",
    "address": "4755 Fauntleroy Way SW Suite 190, Seattle, WA, 98116",
    "phone": "2063385060",
    "hours": "Call for hours",
    "lat": 47.5600788,
    "lng": -122.3820134
  },
  {
    "id": "10571",
    "name": "Whole Foods Market",
    "address": "4801 Colleyville Blvd, Colleyville, TX, 76034",
    "phone": "817.918.3821",
    "hours": "Call for hours",
    "lat": 32.8791874,
    "lng": -97.1552062
  },
  {
    "id": "10570",
    "name": "Whole Foods Market",
    "address": "300 N Broad St Ste 103, New Orleans, LA, 70119",
    "phone": "425.881.2660",
    "hours": "Call for hours",
    "lat": 29.9671931,
    "lng": -90.0848478
  },
  {
    "id": "10569",
    "name": "Whole Foods Market",
    "address": "3968 Airport Blvd, Mobile, AL, 36608",
    "phone": "630.579.7799",
    "hours": "Call for hours",
    "lat": 30.677167,
    "lng": -88.1509437
  },
  {
    "id": "10568",
    "name": "Whole Foods Market",
    "address": "4 S Tunnel Rd, Asheville, NC, 28805",
    "phone": "707.224.6311",
    "hours": "Call for hours",
    "lat": 35.583219,
    "lng": -82.5244392
  },
  {
    "id": "10567",
    "name": "Whole Foods Market",
    "address": "110 Washington St, Morristown, NJ, 7960",
    "phone": "650.559.0301",
    "hours": "Call for hours",
    "lat": 40.7992015,
    "lng": -74.4888753
  },
  {
    "id": "10566",
    "name": "Whole Foods Market",
    "address": "1551 3rd Ave, New York, NY, 10128",
    "phone": "859.971.9020",
    "hours": "Call for hours",
    "lat": 40.7796679,
    "lng": -73.9529504
  },
  {
    "id": "10565",
    "name": "Whole Foods Market",
    "address": "100 W 125th Street, New York, NY, 10027",
    "phone": "816.931.7734",
    "hours": "Call for hours",
    "lat": 40.8076461,
    "lng": -73.9461771
  },
  {
    "id": "10564",
    "name": "Whole Foods Market",
    "address": "305 E Altamonte Dr Ste 1000, Altamonte Springs, FL, 32701",
    "phone": "407.767.2100",
    "hours": "Call for hours",
    "lat": 28.6642475,
    "lng": -81.3814416
  },
  {
    "id": "10563",
    "name": "Whole Foods Market",
    "address": "27001 US 19 N, Ste8520, Clearwater, FL, 33761",
    "phone": "727.724.7100",
    "hours": "Call for hours",
    "lat": 28.0170595,
    "lng": -82.7355688
  },
  {
    "id": "10562",
    "name": "Whole Foods Market",
    "address": "2101 Pennsylvania Ave, Philadelphia, PA, 19130",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9629749,
    "lng": -75.1742142
  },
  {
    "id": "10561",
    "name": "Whole Foods Market",
    "address": "348 Harrison Ave, Boston, MA, 2118",
    "phone": "617.904.1000",
    "hours": "Call for hours",
    "lat": 42.345449,
    "lng": -71.0627816
  },
  {
    "id": "10560",
    "name": "Whole Foods Market",
    "address": "990 Iyannough Rd, Hyannis, MA, 2601",
    "phone": "508.418.5900",
    "hours": "Call for hours",
    "lat": 41.6724873,
    "lng": -70.3017523
  },
  {
    "id": "10559",
    "name": "Whole Foods Market",
    "address": "45 Beacon Street, Somerville, MA, 2143",
    "phone": "617.902.9300",
    "hours": "Call for hours",
    "lat": 42.3760203,
    "lng": -71.1029342
  },
  {
    "id": "10558",
    "name": "Whole Foods Market",
    "address": "880 Main St, Melrose, MA, 2176",
    "phone": "781.606.3400",
    "hours": "Call for hours",
    "lat": 42.4646967,
    "lng": -71.0626837
  },
  {
    "id": "10557",
    "name": "Whole Foods Market",
    "address": "51 Austin Street, Charlestown, MA, 2129",
    "phone": "617.337.9700",
    "hours": "Call for hours",
    "lat": 42.3759791,
    "lng": -71.0658594
  },
  {
    "id": "10556",
    "name": "Whole Foods Market",
    "address": "808 Massachusetts Ave, Arlington, MA, 2476",
    "phone": "781.777.7200",
    "hours": "Call for hours",
    "lat": 42.4163899,
    "lng": -71.1594265
  },
  {
    "id": "10555",
    "name": "Whole Foods Market",
    "address": "35 Pleasant Street, South Weymouth, MA, 2190",
    "phone": "781.277.5200",
    "hours": "Call for hours",
    "lat": 42.1716235,
    "lng": -70.9530406
  },
  {
    "id": "10554",
    "name": "Whole Foods Market",
    "address": "2510 McKinney Ave, Dallas, TX, 75201",
    "phone": "512.442.5525",
    "hours": "Call for hours",
    "lat": 32.7957855,
    "lng": -96.8014571
  },
  {
    "id": "10553",
    "name": "Whole Foods Market",
    "address": "1423 N Webb Rd Ste 101, Wichita, KS, 67206",
    "phone": "316.630.8484",
    "hours": "Call for hours",
    "lat": 37.7090874,
    "lng": -97.2280306
  },
  {
    "id": "10552",
    "name": "Whole Foods Market",
    "address": "60 Waterview Blvd, Parsippany, NJ, 7054",
    "phone": "8622862777",
    "hours": "Call for hours",
    "lat": 40.8754074,
    "lng": -74.431437
  },
  {
    "id": "10551",
    "name": "Whole Foods Market",
    "address": "10275 Little Patuxent Pkwy, Columbia, MD, 8034",
    "phone": "503.674.3609",
    "hours": "Call for hours",
    "lat": 39.2139367,
    "lng": -76.8557901
  },
  {
    "id": "10550",
    "name": "Whole Foods Market",
    "address": "4041 Waller Creek, Highland Village, TX, 75077",
    "phone": "708.366.1044",
    "hours": "Call for hours",
    "lat": 33.0728917,
    "lng": -97.0847642
  },
  {
    "id": "10549",
    "name": "Whole Foods Market",
    "address": "10133 Louetta Rd, Houston, TX, 77070",
    "phone": "303.691.0204",
    "hours": "Call for hours",
    "lat": 29.9984967,
    "lng": -95.561974
  },
  {
    "id": "10548",
    "name": "Whole Foods Market",
    "address": "15 E Wynnewood Rd, Wynnewood, PA, 19096",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0020857,
    "lng": -75.2755683
  },
  {
    "id": "10547",
    "name": "Whole Foods Market",
    "address": "225 W Touhy Ave, Park Ridge, IL, 60068",
    "phone": "n/a",
    "hours": "Call for hours",
    "lat": 42.0110155,
    "lng": -87.8249633
  },
  {
    "id": "10546",
    "name": "Whole Foods Market",
    "address": "6055 O St, Lincoln, NE, 68510",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8130693,
    "lng": -96.6391766
  },
  {
    "id": "10545",
    "name": "Whole Foods Market",
    "address": "1425 Central Ave, Albany, NY, 12205",
    "phone": "516.932.1730",
    "hours": "Call for hours",
    "lat": 42.7102729,
    "lng": -73.8165423
  },
  {
    "id": "10544",
    "name": "Whole Foods Market",
    "address": "12201 Elm Creek Blvd N, Maple Grove, MN, 55369",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.0913339,
    "lng": -93.4358162
  },
  {
    "id": "10543",
    "name": "Whole Foods Market",
    "address": "1815 E Victory Dr Ste 101, Savannah, GA, 31404",
    "phone": "415.333.7410",
    "hours": "Call for hours",
    "lat": 32.0431816,
    "lng": -81.0716309
  },
  {
    "id": "10542",
    "name": "Whole Foods Market",
    "address": "2800 Old Milton Pkwy, Alpharetta, GA, 30009",
    "phone": "(678) 534-3138",
    "hours": "Call for hours",
    "lat": 34.0694669,
    "lng": -84.2784091
  },
  {
    "id": "10541",
    "name": "Whole Foods Market",
    "address": "238 Bedford Ave, Brooklyn, NY, 11249",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7161409,
    "lng": -73.9597096
  },
  {
    "id": "10540",
    "name": "Whole Foods Market",
    "address": "4500 I-55 N, Jackson, MS, 39221",
    "phone": "510.428.7410",
    "hours": "Call for hours",
    "lat": 32.35512,
    "lng": -90.1508154
  },
  {
    "id": "10539",
    "name": "Whole Foods Market",
    "address": "19607 Detroit Rd, Rocky River, OH, 44116",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.4787484,
    "lng": -81.8396406
  },
  {
    "id": "10538",
    "name": "Whole Foods Market",
    "address": "575 Boston Post Rd, Port Chester, NY, 10573",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9923702,
    "lng": -73.6754376
  },
  {
    "id": "10537",
    "name": "Whole Foods Market",
    "address": "4230 Grape Rd, Mishawaka, IN, 46545",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.6990055,
    "lng": -86.1855858
  },
  {
    "id": "10536",
    "name": "Whole Foods Market",
    "address": "15260 S LaGrange Rd, Orland Park, IL, 60462",
    "phone": "610.688.9401",
    "hours": "Call for hours",
    "lat": 41.6126573,
    "lng": -87.8550522
  },
  {
    "id": "10535",
    "name": "Whole Foods Market",
    "address": "5014 Poplar Avenue, Memphis, TN, 38117",
    "phone": "215.542.2190",
    "hours": "Call for hours",
    "lat": 35.1134223,
    "lng": -89.8940677
  },
  {
    "id": "10534",
    "name": "Whole Foods Market",
    "address": "1817 Thomasville Rd, Tallahassee, FL, 32303",
    "phone": "850.513.4200",
    "hours": "Call for hours",
    "lat": 30.4638233,
    "lng": -84.2703881
  },
  {
    "id": "10533",
    "name": "Whole Foods Market",
    "address": "12150 Biscayne Blvd, North Miami, FL, 33181",
    "phone": "305.892.5500",
    "hours": "Call for hours",
    "lat": 25.8881039,
    "lng": -80.165447
  },
  {
    "id": "10532",
    "name": "Whole Foods Market",
    "address": "4701 N 20th St, Phoenix, AZ, 85016",
    "phone": "805.981.7523",
    "hours": "Call for hours",
    "lat": 33.506346,
    "lng": -112.037763
  },
  {
    "id": "10531",
    "name": "Whole Foods Market",
    "address": "5555 E River Rd, Tucson, AZ, 85750",
    "phone": "520-461-1300",
    "hours": "Call for hours",
    "lat": 32.2749924,
    "lng": -110.8743844
  },
  {
    "id": "10530",
    "name": "Whole Foods Market",
    "address": "6601 S Fry Rd, Katy, TX, 77494",
    "phone": "512.499.3819",
    "hours": "Call for hours",
    "lat": 29.7123275,
    "lng": -95.7718734
  },
  {
    "id": "10529",
    "name": "Whole Foods Market",
    "address": "5100 Belt Line Rd Ste 1012, Addison, TX, 75254",
    "phone": "248.652.3273",
    "hours": "Call for hours",
    "lat": 32.9512817,
    "lng": -96.8209767
  },
  {
    "id": "10528",
    "name": "Whole Foods Market",
    "address": "9136 S Yale Ave, Tulsa, OK, 74137",
    "phone": "303.996.6457",
    "hours": "Call for hours",
    "lat": 36.030638,
    "lng": -95.9237179
  },
  {
    "id": "10527",
    "name": "Whole Foods Market",
    "address": "5155 S Wadsworth Blvd, Lakewood, CO, 80123",
    "phone": "303.586.5220",
    "hours": "Call for hours",
    "lat": 39.623031,
    "lng": -105.0921849
  },
  {
    "id": "10526",
    "name": "Whole Foods Market",
    "address": "261 Lusher Ct, Frisco, CO, 80443",
    "phone": "970.668.9400",
    "hours": "Call for hours",
    "lat": 39.5887456,
    "lng": -106.1003496
  },
  {
    "id": "10525",
    "name": "Whole Foods Market",
    "address": "7133 N Oracle Rd, Tucson, AZ, 85704",
    "phone": "604.739.6649",
    "hours": "Call for hours",
    "lat": 32.3364568,
    "lng": -110.9781399
  },
  {
    "id": "10524",
    "name": "Whole Foods Market",
    "address": "415 Newport Center Dr, Newport Beach, CA, 92660",
    "phone": "949.999.8572",
    "hours": "Call for hours",
    "lat": 33.6167339,
    "lng": -117.8739073
  },
  {
    "id": "10523",
    "name": "Whole Foods Market",
    "address": "3111 Mowry Ave, Fremont, CA, 94538",
    "phone": "510.401.5880",
    "hours": "Call for hours",
    "lat": 37.5549521,
    "lng": -121.9852559
  },
  {
    "id": "10522",
    "name": "Whole Foods Market",
    "address": "1800 Laskin Rd, Virginia Beach, VA, 23454",
    "phone": "513.531.1354",
    "hours": "Call for hours",
    "lat": 36.8509319,
    "lng": -76.0281576
  },
  {
    "id": "10521",
    "name": "Whole Foods Market",
    "address": "115 Mack Ave, Detroit, MI, 48201",
    "phone": "530.750.2277",
    "hours": "Call for hours",
    "lat": 42.3484144,
    "lng": -83.0566403
  },
  {
    "id": "10520",
    "name": "Whole Foods Market",
    "address": "702 Cross Hill Rd Ste 300, Columbia, SC, 29205",
    "phone": "617.394.0788",
    "hours": "Call for hours",
    "lat": 33.9934931,
    "lng": -80.9753216
  },
  {
    "id": "10519",
    "name": "Whole Foods Market",
    "address": "6621-B Balitmore Ave, Riverdale Park, MD, 20737",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9691877,
    "lng": -76.9366106
  },
  {
    "id": "10518",
    "name": "Whole Foods Market",
    "address": "255 Amherst St, Nashua, NH, 3063",
    "phone": "603.318.7550Â ",
    "hours": "Call for hours",
    "lat": 42.7803079,
    "lng": -71.4954227
  },
  {
    "id": "10517",
    "name": "Whole Foods Market",
    "address": "6730 Papermill Dr, Knoxville, TN, 37919",
    "phone": "239.552.5101",
    "hours": "Call for hours",
    "lat": 35.9330472,
    "lng": -84.015503
  },
  {
    "id": "10516",
    "name": "Whole Foods Market",
    "address": "4100 University Ave, West Des Moines, IA, 50266",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.5991281,
    "lng": -93.7593806
  },
  {
    "id": "10515",
    "name": "Whole Foods Market",
    "address": "6384 Promenade Parkway, Castle Rock, CO, 80108",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.4230822,
    "lng": -104.8776382
  },
  {
    "id": "10514",
    "name": "Whole Foods Market",
    "address": "5118 S Lake Park Ave, Chicago, IL, 60615",
    "phone": "317.569.7382",
    "hours": "Call for hours",
    "lat": 41.8017018,
    "lng": -87.5882026
  },
  {
    "id": "10513",
    "name": "Whole Foods Market",
    "address": "301 E. 51st Street, Kansas City, MO, 64112",
    "phone": "816.708.3700",
    "hours": "Call for hours",
    "lat": 39.0345298,
    "lng": -94.5830169
  },
  {
    "id": "10512",
    "name": "Whole Foods Market",
    "address": "5C Sugar Hollow Rd, Danbury, CT, 6810",
    "phone": "808.738.0830",
    "hours": "Call for hours",
    "lat": 41.377727,
    "lng": -73.4755249
  },
  {
    "id": "10511",
    "name": "Whole Foods Market",
    "address": "3804 Oleander Dr, Wilmington, NC, 28401",
    "phone": "913.663.2968",
    "hours": "Call for hours",
    "lat": 34.2136375,
    "lng": -77.9007647
  },
  {
    "id": "10510",
    "name": "Whole Foods Market",
    "address": "100 Market St, Lynnfield, MA, 1940",
    "phone": "781.776.4300",
    "hours": "Call for hours",
    "lat": 42.5151204,
    "lng": -71.0297633
  },
  {
    "id": "10509",
    "name": "Whole Foods Market",
    "address": "113 Route 9 S, Marlboro, NJ, 7746",
    "phone": "925.284.5315",
    "hours": "Call for hours",
    "lat": 40.3519882,
    "lng": -74.3095296
  },
  {
    "id": "10508",
    "name": "Whole Foods Market",
    "address": "270 Palladio Parkway, Folsom, CA, 95630",
    "phone": "916.984.8500",
    "hours": "Call for hours",
    "lat": 38.6488674,
    "lng": -121.1181412
  },
  {
    "id": "10507",
    "name": "Whole Foods Market",
    "address": "303 Marshall Rd, Superior, CO, 80027",
    "phone": "720.274.1415",
    "hours": "Call for hours",
    "lat": 39.9565842,
    "lng": -105.1676551
  },
  {
    "id": "10506",
    "name": "Whole Foods Market",
    "address": "18403 Blanco Rd, San Antonio, TX, 78258",
    "phone": "713.266.8717",
    "hours": "Call for hours",
    "lat": 29.6140371,
    "lng": -98.5112614
  },
  {
    "id": "10505",
    "name": "Whole Foods Market",
    "address": "6610 Fairview Rd, Charlotte, NC, 28210",
    "phone": "405.879.3530",
    "hours": "Call for hours",
    "lat": 35.1472366,
    "lng": -80.8300802
  },
  {
    "id": "10504",
    "name": "Whole Foods Market",
    "address": "23401 Civic Center Way, Malibu, CA, 90265",
    "phone": "",
    "hours": "Call for hours",
    "lat": 34.0373346,
    "lng": -118.6864472
  },
  {
    "id": "10503",
    "name": "Whole Foods Market",
    "address": "3360 E Speedway Blvd, Tucson, AZ, 85716",
    "phone": "520.795.9844",
    "hours": "Call for hours",
    "lat": 32.235741,
    "lng": -110.9215464
  },
  {
    "id": "10502",
    "name": "Whole Foods Market",
    "address": "415 Centre St, Jamaica Plain, MA, 2130",
    "phone": "617.553.5400Â ",
    "hours": "Call for hours",
    "lat": 42.3212018,
    "lng": -71.1105127
  },
  {
    "id": "10501",
    "name": "Whole Foods Market",
    "address": "23932 Aliso Creek Rd, Laguna Niguel, CA, 92677",
    "phone": "817.461.1688",
    "hours": "Call for hours",
    "lat": 33.5543089,
    "lng": -117.7125199
  },
  {
    "id": "10500",
    "name": "Whole Foods Market",
    "address": "2800 196th St SW, Lynwood, WA, 98036",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.819888,
    "lng": -122.2722334
  },
  {
    "id": "10499",
    "name": "Whole Foods Market",
    "address": "2600 Via de la Valle Ste 100, Del Mar, CA, 92014",
    "phone": "858.436.9800",
    "hours": "Call for hours",
    "lat": 32.9811507,
    "lng": -117.2519665
  },
  {
    "id": "10498",
    "name": "Whole Foods Market",
    "address": "1150 Ocean Ave, San Francisco, CA, 94112",
    "phone": "415.333.7400",
    "hours": "Call for hours",
    "lat": 37.7237668,
    "lng": -122.455053
  },
  {
    "id": "10497",
    "name": "Whole Foods Market",
    "address": "6930 S Highland Dr, Cottonwood Heights, UT, 84121",
    "phone": "801.733.9455",
    "hours": "Call for hours",
    "lat": 40.6251672,
    "lng": -111.8358984
  },
  {
    "id": "10496",
    "name": "Whole Foods Market",
    "address": "3202 West Friendly Ave, Greensboro, NC, 27408",
    "phone": "415.282.4710",
    "hours": "Call for hours",
    "lat": 36.0857454,
    "lng": -79.8341387
  },
  {
    "id": "10495",
    "name": "Whole Foods Market",
    "address": "7250 W Lake Mead Blvd, Las Vegas, NV, 89128",
    "phone": "702.942.1500",
    "hours": "Call for hours",
    "lat": 36.1975693,
    "lng": -115.2501409
  },
  {
    "id": "10494",
    "name": "Whole Foods Market",
    "address": "1275 Alpine Ave, Boulder, CO, 80304",
    "phone": "303.443.1354",
    "hours": "Call for hours",
    "lat": 40.0260075,
    "lng": -105.2808471
  },
  {
    "id": "10493",
    "name": "Whole Foods Market",
    "address": "1001 Plymouth Rd, Minnetonka, MN, 55305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9741924,
    "lng": -93.4453034
  },
  {
    "id": "10492",
    "name": "Whole Foods Market",
    "address": "2103 Carlisle Blvd NE, Albuquerque, NM, 87110",
    "phone": "505.260.1366",
    "hours": "Call for hours",
    "lat": 35.1028721,
    "lng": -106.6050929
  },
  {
    "id": "10491",
    "name": "Whole Foods Market",
    "address": "7401 France Ave S, Edina, MN, 55435",
    "phone": "949.574.3810",
    "hours": "Call for hours",
    "lat": 44.8677857,
    "lng": -93.3280314
  },
  {
    "id": "10490",
    "name": "Whole Foods Market",
    "address": "1131 E Wilmington Ave, Salt Lake City, UT, 84106",
    "phone": "801.359.7913",
    "hours": "Call for hours",
    "lat": 40.723629,
    "lng": -111.858869
  },
  {
    "id": "10489",
    "name": "Whole Foods Market",
    "address": "2201 Eye St NW, Washington, DC, 20037",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9010776,
    "lng": -77.0490824
  },
  {
    "id": "10488",
    "name": "Whole Foods Market",
    "address": "442 Washington St, Wellesley, MA, 2482",
    "phone": "781.235.7262",
    "hours": "Call for hours",
    "lat": 42.3024723,
    "lng": -71.2856975
  },
  {
    "id": "10487",
    "name": "Whole Foods Market",
    "address": "6621 W 119th St, Overland Park, KS, 66209",
    "phone": "913.663.2951",
    "hours": "Call for hours",
    "lat": 38.911542,
    "lng": -94.6620691
  },
  {
    "id": "10486",
    "name": "Whole Foods Market",
    "address": "301 Manufacturer's Rd, Chattanooga, TN, 37405",
    "phone": "(423) 702-7300",
    "hours": "Call for hours",
    "lat": 35.0633405,
    "lng": -85.3149546
  },
  {
    "id": "10485",
    "name": "Whole Foods Market",
    "address": "226 East 57th St, New York, NY, 10022",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7593039,
    "lng": -73.9663868
  },
  {
    "id": "10484",
    "name": "Whole Foods Market",
    "address": "2610 NE Hwy 20, Bend, OR, 97701",
    "phone": "214.824.2730",
    "hours": "Call for hours",
    "lat": 44.0563568,
    "lng": -121.2659588
  },
  {
    "id": "10483",
    "name": "Whole Foods Market",
    "address": "283 Broadway St, Laguna Beach, CA, 92651",
    "phone": "949.376.7888",
    "hours": "Call for hours",
    "lat": 33.5438792,
    "lng": -117.7838368
  },
  {
    "id": "10482",
    "name": "Whole Foods Market",
    "address": "14598 Clay Terrace Blvd, Carmel, IN, 46032",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.9990076,
    "lng": -86.1310496
  },
  {
    "id": "10481",
    "name": "Whole Foods Market",
    "address": "2825 East Burnside St, Portland, OR, 97214",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5232766,
    "lng": -122.6367853
  },
  {
    "id": "10480",
    "name": "Whole Foods Market",
    "address": "7881 Edinger Ave, Huntington Beach, CA, 92647",
    "phone": "657.200.4200",
    "hours": "Call for hours",
    "lat": 33.7313927,
    "lng": -117.9910687
  },
  {
    "id": "10479",
    "name": "Whole Foods Market",
    "address": "1425 Montana Ave, Santa Monica, CA, 90403",
    "phone": "310.576.4707",
    "hours": "Call for hours",
    "lat": 34.0329471,
    "lng": -118.4947929
  },
  {
    "id": "10478",
    "name": "Whole Foods Market",
    "address": "2001 Market Street, San Francisco, CA, 94114",
    "phone": "415.626.1430",
    "hours": "Call for hours",
    "lat": 37.7687595,
    "lng": -122.4270525
  },
  {
    "id": "10477",
    "name": "Whole Foods Market",
    "address": "12601 Hill Country Blvd, Bee Cave, TX, 78738",
    "phone": "402.393.1221",
    "hours": "Call for hours",
    "lat": 30.3076183,
    "lng": -97.9377502
  },
  {
    "id": "10476",
    "name": "Whole Foods Market",
    "address": "1686 Boston Post Rd, Milford, CT, 6460",
    "phone": "626.792.4293",
    "hours": "Call for hours",
    "lat": 41.2482781,
    "lng": -73.0253079
  },
  {
    "id": "10475",
    "name": "Whole Foods Market",
    "address": "1555 W Lane Ave, Upper Arlington, OH, 43221",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0065342,
    "lng": -83.0526662
  },
  {
    "id": "10474",
    "name": "Whole Foods Market",
    "address": "4301 W William Cannon, Austin, TX, 78749",
    "phone": "650.367.1414",
    "hours": "Call for hours",
    "lat": 30.2215037,
    "lng": -97.8411819
  },
  {
    "id": "10473",
    "name": "Whole Foods Market",
    "address": "33 Vervalen St, Closter, NJ, 7624",
    "phone": "818.990.7089",
    "hours": "Call for hours",
    "lat": 40.9705098,
    "lng": -73.9580474
  },
  {
    "id": "10472",
    "name": "Whole Foods Market",
    "address": "2151 Mystic Valley Pkwy, Medford, MA, 2155",
    "phone": "781.395.4998",
    "hours": "Call for hours",
    "lat": 42.4171747,
    "lng": -71.1260984
  },
  {
    "id": "10471",
    "name": "Whole Foods Market",
    "address": "3950 24th St, San Francisco, CA, 94114",
    "phone": "415.282.4700",
    "hours": "Call for hours",
    "lat": 37.7519697,
    "lng": -122.4308871
  },
  {
    "id": "10470",
    "name": "Whole Foods Market",
    "address": "1300 E 86th St, Indianapolis, IN, 46240",
    "phone": "303.488.2008",
    "hours": "Call for hours",
    "lat": 39.9145104,
    "lng": -86.1370626
  },
  {
    "id": "10469",
    "name": "Whole Foods Market",
    "address": "10576 Perry Hwy, Wexford, PA, 15090",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.6144847,
    "lng": -80.0527938
  },
  {
    "id": "10468",
    "name": "Whole Foods Market",
    "address": "3535 NE 15th Ave, Portland, OR, 97212",
    "phone": "502.899.9695",
    "hours": "Call for hours",
    "lat": 45.548893,
    "lng": -122.6513864
  },
  {
    "id": "10467",
    "name": "Whole Foods Market",
    "address": "70 E Kaahumanu Ave Unit B, Kahului, HI, 96732",
    "phone": "808.872.3310",
    "hours": "Call for hours",
    "lat": 20.8914659,
    "lng": -156.4644443
  },
  {
    "id": "10466",
    "name": "Whole Foods Market",
    "address": "1111 S Washington St, Denver, CO, 80210",
    "phone": "303.733.6201",
    "hours": "Call for hours",
    "lat": 39.696046,
    "lng": -104.9798666
  },
  {
    "id": "10465",
    "name": "Whole Foods Market",
    "address": "40 Railroad St, Andover, MA, 1810",
    "phone": "978.749.6664",
    "hours": "Call for hours",
    "lat": 42.660895,
    "lng": -71.1445731
  },
  {
    "id": "10464",
    "name": "Whole Foods Market",
    "address": "390 Coddingtown Mall, Santa Rosa, CA, 95401",
    "phone": "707.542.7411",
    "hours": "Call for hours",
    "lat": 38.4578846,
    "lng": -122.7313879
  },
  {
    "id": "10463",
    "name": "Whole Foods Market",
    "address": "629 Kailua Rd, Kailua, HI, 96734",
    "phone": "808.263.6800",
    "hours": "Call for hours",
    "lat": 21.3938515,
    "lng": -157.7429669
  },
  {
    "id": "10462",
    "name": "Whole Foods Market",
    "address": "340 N Main St, West Hartford, CT, 6117",
    "phone": "860.523.7174",
    "hours": "Call for hours",
    "lat": 41.7846872,
    "lng": -72.7454126
  },
  {
    "id": "10461",
    "name": "Whole Foods Market",
    "address": "1710 41st Ave, Capitola, CA, 95010",
    "phone": "831.464.2900",
    "hours": "Call for hours",
    "lat": 36.9743246,
    "lng": -121.9635747
  },
  {
    "id": "10460",
    "name": "Whole Foods Market",
    "address": "500 E Ogden Ave, Hinsdale, IL, 60521",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8175049,
    "lng": -87.9170854
  },
  {
    "id": "10459",
    "name": "Whole Foods Market",
    "address": "4211 Waialae Ave, Honolulu, HI, 96816",
    "phone": "808.738.0820",
    "hours": "Call for hours",
    "lat": 21.2769457,
    "lng": -157.7859118
  },
  {
    "id": "10458",
    "name": "Whole Foods Market",
    "address": "690 Stanyan St, San Francisco, CA, 94117",
    "phone": "415.876.6740",
    "hours": "Call for hours",
    "lat": 37.769638,
    "lng": -122.4528278
  },
  {
    "id": "10457",
    "name": "Whole Foods Market",
    "address": "44-459 Town Center Way, Palm Desert, CA, 92260",
    "phone": "760.797.8200",
    "hours": "Call for hours",
    "lat": 33.7256099,
    "lng": -116.400254
  },
  {
    "id": "10456",
    "name": "Whole Foods Market",
    "address": "105 Stacy Rd, Fairview, TX, 75069",
    "phone": "972-549-4090",
    "hours": "Call for hours",
    "lat": 33.1310936,
    "lng": -96.6565457
  },
  {
    "id": "10455",
    "name": "Whole Foods Market",
    "address": "399 Post Rd West, Westport, CT, 6880",
    "phone": "408.358.4433",
    "hours": "Call for hours",
    "lat": 41.1280605,
    "lng": -73.3801367
  },
  {
    "id": "10454",
    "name": "Whole Foods Market",
    "address": "475 Wilmington West Chester Pike, Glen Mills, PA, 19342",
    "phone": "310.826.6653",
    "hours": "Call for hours",
    "lat": 39.863379,
    "lng": -75.5428154
  },
  {
    "id": "10453",
    "name": "Whole Foods Market",
    "address": "2411 N Federal Hwy, Pompano Beach, FL, 33062",
    "phone": "954.786.3500",
    "hours": "Call for hours",
    "lat": 26.261326,
    "lng": -80.1012923
  },
  {
    "id": "10452",
    "name": "Whole Foods Market",
    "address": "70 Merrimon Ave, Asheville, NC, 28801",
    "phone": "847.776.8661",
    "hours": "Call for hours",
    "lat": 35.6018998,
    "lng": -82.5546811
  },
  {
    "id": "10451",
    "name": "Whole Foods Market",
    "address": "14357 W Colfax Ave, Lakewood, CO, 80401",
    "phone": "303.277.1339",
    "hours": "Call for hours",
    "lat": 39.7364247,
    "lng": -105.1612751
  },
  {
    "id": "10450",
    "name": "Whole Foods Market",
    "address": "3502 Mt Diablo Blvd, Lafayette, CA, 94549",
    "phone": "925.284.5305",
    "hours": "Call for hours",
    "lat": 37.8933586,
    "lng": -122.117205
  },
  {
    "id": "10449",
    "name": "Whole Foods Market",
    "address": "750 S Ash Ave Suite 101, Tempe, AZ, 85281",
    "phone": "4804561400",
    "hours": "Call for hours",
    "lat": 33.4223669,
    "lng": -111.9432648
  },
  {
    "id": "10448",
    "name": "Whole Foods Market",
    "address": "701 Waugh Dr, Houston, TX, 77019",
    "phone": "713-284-1260",
    "hours": "Call for hours",
    "lat": 29.7578561,
    "lng": -95.3976416
  },
  {
    "id": "10447",
    "name": "Whole Foods Market",
    "address": "222 Hennepin Ave, Minneapolis, MN, 55401",
    "phone": "",
    "hours": "Call for hours",
    "lat": 44.9832932,
    "lng": -93.269237
  },
  {
    "id": "10446",
    "name": "Whole Foods Market",
    "address": "One Ridge Hill Blvd, Yonkers, NY, 10701",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9630875,
    "lng": -73.8558561
  },
  {
    "id": "10445",
    "name": "Whole Foods Market",
    "address": "1311 Johnson Ferry Rd NE Ste 580, Marietta, GA, 30068",
    "phone": "(678) 996-9700",
    "hours": "Call for hours",
    "lat": 33.9809639,
    "lng": -84.4278519
  },
  {
    "id": "10444",
    "name": "Whole Foods Market",
    "address": "5805 Deerfield Blvd, Mason, OH, 45040",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.3076297,
    "lng": -84.3168124
  },
  {
    "id": "10443",
    "name": "Whole Foods Market",
    "address": "3802 Northdale Blvd, Tampa, FL, 33624",
    "phone": "813.264.3600",
    "hours": "Call for hours",
    "lat": 28.093028,
    "lng": -82.5042071
  },
  {
    "id": "10442",
    "name": "Whole Foods Market",
    "address": "8710 Six Forks Rd, Raleigh, NC, 27615",
    "phone": "(919) 354-0350",
    "hours": "Call for hours",
    "lat": 35.8994612,
    "lng": -78.6504232
  },
  {
    "id": "10441",
    "name": "Whole Foods Market",
    "address": "731 East Blithedale Ave, Mill Valley, CA, 94941",
    "phone": "415.381.3900",
    "hours": "Call for hours",
    "lat": 37.9025872,
    "lng": -122.526048
  },
  {
    "id": "10440",
    "name": "Whole Foods Market",
    "address": "55 Welles St, Glastonbury, CT, 6033",
    "phone": "860.652.9800",
    "hours": "Call for hours",
    "lat": 41.7144364,
    "lng": -72.606616
  },
  {
    "id": "10439",
    "name": "Whole Foods Market",
    "address": "225 Lincoln Blvd, Venice, CA, 90291",
    "phone": "310.566.9480",
    "hours": "Call for hours",
    "lat": 34.0011613,
    "lng": -118.4698813
  },
  {
    "id": "10438",
    "name": "Whole Foods Market",
    "address": "3720 Vision Dr, Fort Worth, TX, 76109",
    "phone": "682-316-8040",
    "hours": "Call for hours",
    "lat": 32.700038,
    "lng": -97.4129749
  },
  {
    "id": "10437",
    "name": "Whole Foods Market",
    "address": "870 S Colorado Blvd, Glendale, CO, 80246",
    "phone": "303.691.0101",
    "hours": "Call for hours",
    "lat": 39.7005315,
    "lng": -104.9397067
  },
  {
    "id": "10436",
    "name": "Whole Foods Market",
    "address": "2918 Walton Blvd, Rochester Hills, MI, 48309",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.6822016,
    "lng": -83.1917101
  },
  {
    "id": "10435",
    "name": "Whole Foods Market",
    "address": "911 Soquel Ave, Santa Cruz, CA, 95062",
    "phone": "831.426.9901",
    "hours": "Call for hours",
    "lat": 36.978945,
    "lng": -122.014572
  },
  {
    "id": "10434",
    "name": "Whole Foods Market",
    "address": "808 Columbus Ave, New York, NY, 10025",
    "phone": "215.481.0808",
    "hours": "Call for hours",
    "lat": 40.7939667,
    "lng": -73.9671163
  },
  {
    "id": "10433",
    "name": "Whole Foods Market",
    "address": "19440 NW Cornell Rd, Beaverton, OR, 97124",
    "phone": "908.688.1075",
    "hours": "Call for hours",
    "lat": 45.533788,
    "lng": -122.877364
  },
  {
    "id": "10432",
    "name": "Whole Foods Market",
    "address": "1566 West Mc Ewen Dr, Franklin, TN, 37067",
    "phone": "239.593.8734",
    "hours": "Call for hours",
    "lat": 35.934211,
    "lng": -86.8249366
  },
  {
    "id": "10431",
    "name": "Whole Foods Market",
    "address": "1140 Blossom Hill Rd, San Jose, CA, 95115",
    "phone": "408.266.3700",
    "hours": "Call for hours",
    "lat": 37.2505955,
    "lng": -121.8770555
  },
  {
    "id": "10430",
    "name": "Whole Foods Market",
    "address": "300 Legacy Place, Dedham, MA, 2026",
    "phone": "781.329.7100",
    "hours": "Call for hours",
    "lat": 42.2328164,
    "lng": -71.1780853
  },
  {
    "id": "10429",
    "name": "Whole Foods Market",
    "address": "650 Town Center Dr, Oxnard, CA, 93036",
    "phone": "805.751.4300",
    "hours": "Call for hours",
    "lat": 34.2400813,
    "lng": -119.1793108
  },
  {
    "id": "10428",
    "name": "Whole Foods Market",
    "address": "350 Grasmere Ave, Fairfield, CT, 6824",
    "phone": "865.291.6400",
    "hours": "Call for hours",
    "lat": 41.1583602,
    "lng": -73.2401552
  },
  {
    "id": "10427",
    "name": "Whole Foods Market",
    "address": "11920 Domain Dr, Austin, TX, 78758",
    "phone": "480.368.1463",
    "hours": "Call for hours",
    "lat": 30.4063209,
    "lng": -97.7201151
  },
  {
    "id": "10426",
    "name": "Whole Foods Market",
    "address": "990 West Eisenhower Pkwy, Ann Arbor, MI, 48103",
    "phone": "778.370.4821",
    "hours": "Call for hours",
    "lat": 42.2484296,
    "lng": -83.7580081
  },
  {
    "id": "10425",
    "name": "Whole Foods Market",
    "address": "2245 Springfield Ave, Union, NJ, 7088",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.71678,
    "lng": -74.2869784
  },
  {
    "id": "10424",
    "name": "Whole Foods Market",
    "address": "1401 E 41st St, Tulsa, OK, 74105",
    "phone": "512.499.7109",
    "hours": "Call for hours",
    "lat": 36.104878,
    "lng": -95.9732615
  },
  {
    "id": "10423",
    "name": "Whole Foods Market",
    "address": "1160 Town and Country Crossing Drive, Chesterfield, MO, 63017",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.6221901,
    "lng": -90.515593
  },
  {
    "id": "10422",
    "name": "Whole Foods Market",
    "address": "150 Ledge Rd, Darien, CT, 6820",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0732798,
    "lng": -73.4761173
  },
  {
    "id": "10421",
    "name": "Whole Foods Market",
    "address": "1548 North Dale Mabry Blvd, Tampa, FL, 33607",
    "phone": "813.348.1200",
    "hours": "Call for hours",
    "lat": 27.9528728,
    "lng": -82.5048529
  },
  {
    "id": "10420",
    "name": "Whole Foods Market",
    "address": "340 Reed St, Basalt, CO, 81621",
    "phone": "970.927.1500",
    "hours": "Call for hours",
    "lat": 39.3869354,
    "lng": -107.0826428
  },
  {
    "id": "10419",
    "name": "Whole Foods Market",
    "address": "353 E Broadway, Eugene, OR, 97401",
    "phone": "425.775.1329",
    "hours": "Call for hours",
    "lat": 44.0503376,
    "lng": -123.0878329
  },
  {
    "id": "10418",
    "name": "Whole Foods Market",
    "address": "6139 South Virginia St, Reno, NV, 89502",
    "phone": "775.852.8023",
    "hours": "Call for hours",
    "lat": 39.4690739,
    "lng": -119.7868638
  },
  {
    "id": "10417",
    "name": "Whole Foods Market",
    "address": "20281 N Rand Rd, Kildeer, IL, 60074",
    "phone": "401.942.7660",
    "hours": "Call for hours",
    "lat": 42.1595608,
    "lng": -88.0440265
  },
  {
    "id": "10416",
    "name": "Whole Foods Market",
    "address": "2 Somerset St, Portland, ME, 4101",
    "phone": "207.774.7711",
    "hours": "Call for hours",
    "lat": 43.6634486,
    "lng": -70.2584734
  },
  {
    "id": "10415",
    "name": "Whole Foods Market",
    "address": "3682 Bel Aire Plaza, Napa, CA, 94558",
    "phone": "707.224.6300",
    "hours": "Call for hours",
    "lat": 38.3231349,
    "lng": -122.3060568
  },
  {
    "id": "10414",
    "name": "Whole Foods Market",
    "address": "2693 Edmondson Rd, Cincinnati, OH, 45209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1455459,
    "lng": -84.4470495
  },
  {
    "id": "10413",
    "name": "Whole Foods Market",
    "address": "6689 Las Vegas Blvd, Las Vegas, NV, 89119",
    "phone": "702.589.7711",
    "hours": "Call for hours",
    "lat": 36.0676289,
    "lng": -115.1742472
  },
  {
    "id": "10412",
    "name": "Whole Foods Market",
    "address": "1020 Alton Rd, Miami, FL, 33139",
    "phone": "305.938.2800",
    "hours": "Call for hours",
    "lat": 25.7810931,
    "lng": -80.1413755
  },
  {
    "id": "10411",
    "name": "Whole Foods Market",
    "address": "401 S Broadway St, Boise, ID, 83702",
    "phone": "208.287.4600",
    "hours": "Call for hours",
    "lat": 43.6078975,
    "lng": -116.1946675
  },
  {
    "id": "10410",
    "name": "Whole Foods Market",
    "address": "2118 Abrams Rd, Dallas, TX, 75214",
    "phone": "941.955.8530",
    "hours": "Call for hours",
    "lat": 32.8158235,
    "lng": -96.7523218
  },
  {
    "id": "10409",
    "name": "Whole Foods Market",
    "address": "18700 W Ventura Blvd, Tarzana, CA, 91356",
    "phone": "818 578-7840",
    "hours": "Call for hours",
    "lat": 34.1703355,
    "lng": -118.5410493
  },
  {
    "id": "10408",
    "name": "Whole Foods Market",
    "address": "201 W Napa St, Sonoma, CA, 95476",
    "phone": "707.938.8500",
    "hours": "Call for hours",
    "lat": 38.2920295,
    "lng": -122.4616293
  },
  {
    "id": "10407",
    "name": "Whole Foods Market",
    "address": "544 South 700 East, Salt Lake City, UT, 84102",
    "phone": "801.924.9060",
    "hours": "Call for hours",
    "lat": 40.7579544,
    "lng": -111.8718955
  },
  {
    "id": "10406",
    "name": "Whole Foods Market",
    "address": "2701 Bergen Town Center, Paramus, NJ, 7652",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.9151144,
    "lng": -74.0596572
  },
  {
    "id": "10405",
    "name": "Whole Foods Market",
    "address": "750 N Martingale Rd, Schaumburg, IL, 60173",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.0424301,
    "lng": -88.0367672
  },
  {
    "id": "10404",
    "name": "Whole Foods Market",
    "address": "2001 W 15th Ave, Seattle, WA, 98119",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6372353,
    "lng": -122.376988
  },
  {
    "id": "10403",
    "name": "Whole Foods Market",
    "address": "6853 York Street Ste 119, Centennial, CO, 80122",
    "phone": "303.996.3660",
    "hours": "Call for hours",
    "lat": 39.5918115,
    "lng": -104.9620672
  },
  {
    "id": "10402",
    "name": "Whole Foods Market",
    "address": "2955 West Ray Rd, Chandler, AZ, 85224",
    "phone": "480.821.9447",
    "hours": "Call for hours",
    "lat": 33.3183793,
    "lng": -111.8927755
  },
  {
    "id": "10401",
    "name": "Whole Foods Market",
    "address": "20955 Stevens Creek Blvd, Cupertino, CA, 95014",
    "phone": "408.257.7000",
    "hours": "Call for hours",
    "lat": 37.3235879,
    "lng": -122.0396177
  },
  {
    "id": "10400",
    "name": "Whole Foods Market",
    "address": "7380 SW Bridgeport Rd, Tigard, OR, 97224",
    "phone": "503.232.6763",
    "hours": "Call for hours",
    "lat": 45.3944787,
    "lng": -122.7515006
  },
  {
    "id": "10399",
    "name": "Whole Foods Market",
    "address": "235 Prospect St, West Orange, NJ, 7052",
    "phone": "512.499.7145",
    "hours": "Call for hours",
    "lat": 40.8067849,
    "lng": -74.2468653
  },
  {
    "id": "10398",
    "name": "Whole Foods Market",
    "address": "17991 NE Redmond Way, Redmond, WA, 98052",
    "phone": "301.386.0872",
    "hours": "Call for hours",
    "lat": 47.6661677,
    "lng": -122.101574
  },
  {
    "id": "10397",
    "name": "Whole Foods Market",
    "address": "777 The Alameda, San Jose, CA, 95126",
    "phone": "408.207.1126",
    "hours": "Call for hours",
    "lat": 37.3321237,
    "lng": -121.9049074
  },
  {
    "id": "10396",
    "name": "Whole Foods Market",
    "address": "15900 Southwest Freeway, Sugar Land, TX, 77479",
    "phone": "281.491.5577",
    "hours": "Call for hours",
    "lat": 29.6001299,
    "lng": -95.6233709
  },
  {
    "id": "10395",
    "name": "Whole Foods Market",
    "address": "11173 West Broad St, Glen Allen, VA, 23060",
    "phone": "212.924.9923",
    "hours": "Call for hours",
    "lat": 37.6475665,
    "lng": -77.5997292
  },
  {
    "id": "10394",
    "name": "Whole Foods Market",
    "address": "3761 State St, Santa Barbara, CA, 93105",
    "phone": "805-837-6959",
    "hours": "Call for hours",
    "lat": 34.4393044,
    "lng": -119.745409
  },
  {
    "id": "10393",
    "name": "Whole Foods Market",
    "address": "151 Sockanosset Cross Rd, Cranston, RI, 2920",
    "phone": "401.942.7660",
    "hours": "Call for hours",
    "lat": 41.7559067,
    "lng": -71.4561004
  },
  {
    "id": "10392",
    "name": "Whole Foods Market",
    "address": "10601 San Jose Blvd, Jacksonville, FL, 32257",
    "phone": "904.288.1100",
    "hours": "Call for hours",
    "lat": 30.185219,
    "lng": -81.6256165
  },
  {
    "id": "10391",
    "name": "Whole Foods Market",
    "address": "1550 N Kingsbury St, Chicago, IL, 60642",
    "phone": "434.973.4650",
    "hours": "Call for hours",
    "lat": 41.9086787,
    "lng": -87.6526412
  },
  {
    "id": "10390",
    "name": "Whole Foods Market",
    "address": "1700 Post Oak Blvd Ste 100, Houston, TX, 77056",
    "phone": "816.834.451",
    "hours": "Call for hours",
    "lat": 29.7498983,
    "lng": -95.4625156
  },
  {
    "id": "10389",
    "name": "Whole Foods Market",
    "address": "500 W Germantown Pike, Plymouth Meeting, PA, 19462",
    "phone": "512.482.7000",
    "hours": "Call for hours",
    "lat": 40.1159439,
    "lng": -75.2819933
  },
  {
    "id": "10388",
    "name": "Whole Foods Market",
    "address": "7111 East Mayo Blvd, Phoenix, AZ, 85054",
    "phone": "480.515.3777",
    "hours": "Call for hours",
    "lat": 33.6537196,
    "lng": -111.9270975
  },
  {
    "id": "10387",
    "name": "Whole Foods Market",
    "address": "270 Greenwich St, New York, NY, 10007",
    "phone": "314.721.8011",
    "hours": "Call for hours",
    "lat": 40.7155341,
    "lng": -74.0120518
  },
  {
    "id": "10386",
    "name": "Whole Foods Market",
    "address": "840 Willow Rd, Northbrook, IL, 60062",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1061831,
    "lng": -87.8019992
  },
  {
    "id": "10385",
    "name": "Whole Foods Market",
    "address": "4301 NE Sandy Blvd, Portland, OR, 97213",
    "phone": "501.221.9726",
    "hours": "Call for hours",
    "lat": 45.5375704,
    "lng": -122.6184447
  },
  {
    "id": "10384",
    "name": "Whole Foods Market",
    "address": "111 Siena Drive, Upper St. Clair, PA, 15241",
    "phone": "612.927.7996",
    "hours": "Call for hours",
    "lat": 40.3460935,
    "lng": -80.0579454
  },
  {
    "id": "10383",
    "name": "Whole Foods Market",
    "address": "4039 Hillsboro Rd, Nashville, TN, 37215",
    "phone": "(615) 440-5100",
    "hours": "Call for hours",
    "lat": 36.0451884,
    "lng": -86.8645134
  },
  {
    "id": "10382",
    "name": "Whole Foods Market",
    "address": "120 New Moriches Rd, Lake Grove, NY, 11755",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8697967,
    "lng": -73.1258325
  },
  {
    "id": "10381",
    "name": "Whole Foods Market",
    "address": "8190 Park Lane Ste 351, Dallas, TX, 75231",
    "phone": "214-342-4850",
    "hours": "Call for hours",
    "lat": 32.8716049,
    "lng": -96.7657953
  },
  {
    "id": "10380",
    "name": "Whole Foods Market",
    "address": "450 Rhode Island St, San Francisco, CA, 94107",
    "phone": "415.552.1155",
    "hours": "Call for hours",
    "lat": 37.7644788,
    "lng": -122.4032778
  },
  {
    "id": "10379",
    "name": "Whole Foods Market",
    "address": "465 S Arroyo Pkwy, Pasadena, CA, 91105",
    "phone": "626.204.2266",
    "hours": "Call for hours",
    "lat": 34.1378234,
    "lng": -118.1478342
  },
  {
    "id": "10378",
    "name": "Whole Foods Market",
    "address": "95 East Houston St, New York, NY, 10002",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7238246,
    "lng": -73.9923102
  },
  {
    "id": "10377",
    "name": "Whole Foods Market",
    "address": "11355 Woodglen Dr, Rockville, MD, 20852",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.0429686,
    "lng": -77.1131056
  },
  {
    "id": "10376",
    "name": "Whole Foods Market",
    "address": "790 Delong Ave, Novato, CA, 94945",
    "phone": "415.878.0455",
    "hours": "Call for hours",
    "lat": 38.1059406,
    "lng": -122.5656433
  },
  {
    "id": "10375",
    "name": "Whole Foods Market",
    "address": "400 Cambridge Rd, Woburn, MA, 1801",
    "phone": "781.376.9600",
    "hours": "Call for hours",
    "lat": 42.4603871,
    "lng": -71.1635111
  },
  {
    "id": "10374",
    "name": "Whole Foods Market",
    "address": "2847 Park Ave, Tustin, CA, 92782",
    "phone": "714.566.7650",
    "hours": "Call for hours",
    "lat": 33.696361,
    "lng": -117.8255561
  },
  {
    "id": "10373",
    "name": "Whole Foods Market",
    "address": "1001 Galleria Blvd, Roseville, CA, 95678",
    "phone": "916.781.5300",
    "hours": "Call for hours",
    "lat": 38.7673558,
    "lng": -121.267465
  },
  {
    "id": "10372",
    "name": "Whole Foods Market",
    "address": "200 Harker Place Ste 100, Annapolis, MD, 21401",
    "phone": "408.266.3710",
    "hours": "Call for hours",
    "lat": 38.981646,
    "lng": -76.5403334
  },
  {
    "id": "10371",
    "name": "Whole Foods Market",
    "address": "11700 Preston Rd, Dallas, TX, 75230",
    "phone": "214-361-8887",
    "hours": "Call for hours",
    "lat": 32.9084228,
    "lng": -96.8026141
  },
  {
    "id": "10370",
    "name": "Whole Foods Market",
    "address": "760 S Sepulveda Blvd, El Segundo, CA, 90245",
    "phone": "310.333.1900",
    "hours": "Call for hours",
    "lat": 33.9067803,
    "lng": -118.3906138
  },
  {
    "id": "10369",
    "name": "Whole Foods Market",
    "address": "1140 Woodruff Rd Ste 200, Greenville, SC, 29607",
    "phone": "303.797.3856",
    "hours": "Call for hours",
    "lat": 34.8255774,
    "lng": -82.3010094
  },
  {
    "id": "10368",
    "name": "Whole Foods Market",
    "address": "4501 Market Commons Dr, Fairfax, VA, 22033",
    "phone": "510.649.1474",
    "hours": "Call for hours",
    "lat": 38.8578497,
    "lng": -77.377751
  },
  {
    "id": "10367",
    "name": "Whole Foods Market",
    "address": "331 Paradise Rd, Swampscott, MA, 1907",
    "phone": "781.592.2200",
    "hours": "Call for hours",
    "lat": 42.4793098,
    "lng": -70.9055454
  },
  {
    "id": "10366",
    "name": "Whole Foods Market",
    "address": "230 Bay Place, Oakland, CA, 94612",
    "phone": "510.834.9800",
    "hours": "Call for hours",
    "lat": 37.8127687,
    "lng": -122.2609981
  },
  {
    "id": "10365",
    "name": "Whole Foods Market",
    "address": "214 3rd St, Brooklyn, NY, 11215",
    "phone": "505.275.7102",
    "hours": "Call for hours",
    "lat": 40.6748928,
    "lng": -73.9887879
  },
  {
    "id": "10364",
    "name": "Whole Foods Market",
    "address": "100 S Green Valley Pkwy, Henderson, NV, 89012",
    "phone": "702.361.8183",
    "hours": "Call for hours",
    "lat": 36.0234338,
    "lng": -115.0824622
  },
  {
    "id": "10363",
    "name": "Whole Foods Market",
    "address": "444 S Wadsworth Blvd, Lakewood, CO, 80226",
    "phone": "303.935.5000",
    "hours": "Call for hours",
    "lat": 39.7086541,
    "lng": -105.0807669
  },
  {
    "id": "10362",
    "name": "Whole Foods Market",
    "address": "50 Raymond Rd, West Hartford, CT, 6107",
    "phone": "860.523.8500",
    "hours": "Call for hours",
    "lat": 41.7608586,
    "lng": -72.738994
  },
  {
    "id": "10361",
    "name": "Whole Foods Market",
    "address": "2200 Westlake Ave, Seattle, WA, 98121",
    "phone": "205.912.8410",
    "hours": "Call for hours",
    "lat": 47.617852,
    "lng": -122.3379859
  },
  {
    "id": "10360",
    "name": "Whole Foods Market",
    "address": "5945 State Bridge Rd, Duluth, GA, 30097",
    "phone": "201.567.2067",
    "hours": "Call for hours",
    "lat": 34.0129889,
    "lng": -84.183562
  },
  {
    "id": "10359",
    "name": "Whole Foods Market",
    "address": "3670 W Dublin-Grandville Rd, Columbus, OH, 43235",
    "phone": "503.639.6100",
    "hours": "Call for hours",
    "lat": 40.0986537,
    "lng": -83.0863817
  },
  {
    "id": "10358",
    "name": "Whole Foods Market",
    "address": "471 Route 35 North, Middletown, NJ, 7701",
    "phone": "512.499.7106",
    "hours": "Call for hours",
    "lat": 40.3751624,
    "lng": -74.0874042
  },
  {
    "id": "10357",
    "name": "Whole Foods Market",
    "address": "4420 Willard Ave, Chevy Chase, MD, 20815",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9613149,
    "lng": -77.0867545
  },
  {
    "id": "10356",
    "name": "Whole Foods Market",
    "address": "3100 Cahaba Village Plaza, Mountain Brook, AL, 35243",
    "phone": "512.499.3816",
    "hours": "Call for hours",
    "lat": 33.4599949,
    "lng": -86.7525584
  },
  {
    "id": "10355",
    "name": "Whole Foods Market",
    "address": "7400 East Hampden, Denver, CO, 80231",
    "phone": "303.488.2000",
    "hours": "Call for hours",
    "lat": 39.6518466,
    "lng": -104.9001955
  },
  {
    "id": "10354",
    "name": "Whole Foods Market",
    "address": "43 West Paces Ferry Rd NW, Atlanta, GA, 30305",
    "phone": "604.909.2999",
    "hours": "Call for hours",
    "lat": 33.8408965,
    "lng": -84.3813921
  },
  {
    "id": "10353",
    "name": "Whole Foods Market",
    "address": "1797 Hydraulic Rd, Charlottesville, VA, 22901",
    "phone": "303.953.5206",
    "hours": "Call for hours",
    "lat": 38.059773,
    "lng": -78.4891351
  },
  {
    "id": "10352",
    "name": "Whole Foods Market",
    "address": "740 N Moorpark Rd, Thousand Oaks, CA, 91360",
    "phone": "805.777.4730",
    "hours": "Call for hours",
    "lat": 34.187726,
    "lng": -118.8733339
  },
  {
    "id": "10351",
    "name": "Whole Foods Market",
    "address": "3640 N Halsted, Chicago, IL, 60613",
    "phone": "408.257.1475",
    "hours": "Call for hours",
    "lat": 41.9482889,
    "lng": -87.6498662
  },
  {
    "id": "10350",
    "name": "Whole Foods Market",
    "address": "3420 Veterans Blvd, Metairie, LA, 70002",
    "phone": "214.369.0494",
    "hours": "Call for hours",
    "lat": 30.0018573,
    "lng": -90.1589229
  },
  {
    "id": "10349",
    "name": "Whole Foods Market",
    "address": "923 Houston Northcutt Blvd, Mount Pleasant, SC, 29464",
    "phone": "919.467.2278",
    "hours": "Call for hours",
    "lat": 32.8023194,
    "lng": -79.8889193
  },
  {
    "id": "10348",
    "name": "Whole Foods Market",
    "address": "13998 Cedar Rd, University Heights, OH, 44118",
    "phone": "360.671.3755",
    "hours": "Call for hours",
    "lat": 41.5008897,
    "lng": -81.5368155
  },
  {
    "id": "10347",
    "name": "Whole Foods Market",
    "address": "7529 Corporate Blvd, Baton Rouge, LA, 70809",
    "phone": "703.736.0674",
    "hours": "Call for hours",
    "lat": 30.4322277,
    "lng": -91.1110969
  },
  {
    "id": "10346",
    "name": "Whole Foods Market",
    "address": "2305 N Prospect Ave, Milwaukee, WI, 53211",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0604306,
    "lng": -87.883781
  },
  {
    "id": "10345",
    "name": "Whole Foods Market",
    "address": "650 Ponce De Leon Ave NE, Atlanta, GA, 30308",
    "phone": "(404) 853-1681",
    "hours": "Call for hours",
    "lat": 33.7736107,
    "lng": -84.3658288
  },
  {
    "id": "10344",
    "name": "Whole Foods Market",
    "address": "2635 State Rd 7, Wellington, FL, 33414",
    "phone": "561.904.4000",
    "hours": "Call for hours",
    "lat": 26.64156,
    "lng": -80.2039643
  },
  {
    "id": "10343",
    "name": "Whole Foods Market",
    "address": "8003 Turkey Lake Rd, Orlando, FL, 32819",
    "phone": "407.355.7100",
    "hours": "Call for hours",
    "lat": 28.449094,
    "lng": -81.4765573
  },
  {
    "id": "10342",
    "name": "Whole Foods Market",
    "address": "14956 Pines Blvd, Pembroke Pines, FL, 33027",
    "phone": "954.392.3500",
    "hours": "Call for hours",
    "lat": 26.0063579,
    "lng": -80.349682
  },
  {
    "id": "10341",
    "name": "Whole Foods Market",
    "address": "9101 Strada Place, Naples, FL, 34108",
    "phone": "239.552.5100",
    "hours": "Call for hours",
    "lat": 26.2545901,
    "lng": -81.79995
  },
  {
    "id": "10340",
    "name": "Whole Foods Market",
    "address": "299 SE 3rd St, Miami, FL, 33131",
    "phone": "305.995.0600",
    "hours": "Call for hours",
    "lat": 25.7721164,
    "lng": -80.189164
  },
  {
    "id": "10339",
    "name": "Whole Foods Market",
    "address": "6701 Red Rd, Coral Gables, FL, 33143",
    "phone": "305.421.9421",
    "hours": "Call for hours",
    "lat": 25.7064348,
    "lng": -80.2853361
  },
  {
    "id": "10338",
    "name": "Whole Foods Market",
    "address": "1451 1st St, Sarasota, FL, 34236",
    "phone": "941.316.4700",
    "hours": "Call for hours",
    "lat": 27.3377195,
    "lng": -82.5409834
  },
  {
    "id": "10337",
    "name": "Whole Foods Market",
    "address": "11701 Lake Victoria Gardens Drive, Palm Beach Gardens, FL, 33410",
    "phone": "561.691.8540",
    "hours": "Call for hours",
    "lat": 26.8477578,
    "lng": -80.0938669
  },
  {
    "id": "10336",
    "name": "Whole Foods Market",
    "address": "3495 US Rt 1 South, Princeton, NJ, 8540",
    "phone": "505.992.2988",
    "hours": "Call for hours",
    "lat": 40.3099508,
    "lng": -74.6673061
  },
  {
    "id": "10335",
    "name": "Whole Foods Market",
    "address": "4944 Shelbyville Rd, Louisville, KY, 40207",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.248632,
    "lng": -85.6259816
  },
  {
    "id": "10334",
    "name": "Whole Foods Market",
    "address": "1700 Duke St, Alexandria, VA, 22314",
    "phone": "415.206.9727",
    "hours": "Call for hours",
    "lat": 38.8041416,
    "lng": -77.0600615
  },
  {
    "id": "10333",
    "name": "Whole Foods Market",
    "address": "5880 Centre Ave, Pittsburgh, PA, 15206",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.4585426,
    "lng": -79.9289902
  },
  {
    "id": "10332",
    "name": "Whole Foods Market",
    "address": "316 Kentlands Blvd, Gaithersburg, MD, 20878",
    "phone": "",
    "hours": "Call for hours",
    "lat": 39.1226007,
    "lng": -77.237821
  },
  {
    "id": "10331",
    "name": "Whole Foods Market",
    "address": "331 North Glendale Ave, Glendale, CA, 91206",
    "phone": "818.548.3695",
    "hours": "Call for hours",
    "lat": 34.1510829,
    "lng": -118.2459665
  },
  {
    "id": "10330",
    "name": "Whole Foods Market",
    "address": "21430 Valencia Blvd, Valencia, CA, 91355",
    "phone": "661.260.2377",
    "hours": "Call for hours",
    "lat": 34.4226251,
    "lng": -118.5411299
  },
  {
    "id": "10329",
    "name": "Whole Foods Market",
    "address": "6350 West Third St, Los Angeles, CA, 90036",
    "phone": "323.964.6800",
    "hours": "Call for hours",
    "lat": 34.0703081,
    "lng": -118.3607133
  },
  {
    "id": "10328",
    "name": "Whole Foods Market",
    "address": "1050 Gayley Ave, Los Angeles, CA, 90024",
    "phone": "310.824.0858",
    "hours": "Call for hours",
    "lat": 34.0611873,
    "lng": -118.4469309
  },
  {
    "id": "10327",
    "name": "Whole Foods Market",
    "address": "8825 W Charleston, Las Vegas, NV, 89117",
    "phone": "702.254.8655",
    "hours": "Call for hours",
    "lat": 36.1577809,
    "lng": -115.2877396
  },
  {
    "id": "10326",
    "name": "Whole Foods Market",
    "address": "2201 Wilshire Blvd, Santa Monica, CA, 90403",
    "phone": "310.315.0662",
    "hours": "Call for hours",
    "lat": 34.033297,
    "lng": -118.4813822
  },
  {
    "id": "10325",
    "name": "Whole Foods Market",
    "address": "10810 N Tatum Blvd, Paradise Valley, AZ, 85028",
    "phone": "602.569.7600",
    "hours": "Call for hours",
    "lat": 33.5841627,
    "lng": -111.9795489
  },
  {
    "id": "10324",
    "name": "Whole Foods Market",
    "address": "1101 South Canal St, Chicago, IL, 60607",
    "phone": "847.444.1231",
    "hours": "Call for hours",
    "lat": 41.8675233,
    "lng": -87.6388767
  },
  {
    "id": "10323",
    "name": "Whole Foods Market",
    "address": "6020 N Cicero Ave, Chicago, IL, 60646",
    "phone": "214.824.2730",
    "hours": "Call for hours",
    "lat": 41.9904418,
    "lng": -87.7487948
  },
  {
    "id": "10322",
    "name": "Whole Foods Market",
    "address": "10020 Regency Cir, Omaha, NE, 68114",
    "phone": "512.499.3808",
    "hours": "Call for hours",
    "lat": 41.2620238,
    "lng": -96.0684158
  },
  {
    "id": "10321",
    "name": "Whole Foods Market",
    "address": "3135 Washtenaw, Ann Arbor, MI, 48104",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.2579727,
    "lng": -83.6981585
  },
  {
    "id": "10320",
    "name": "Whole Foods Market",
    "address": "1601 South Brentwood Blvd, St Louis, MO, 63144",
    "phone": "303.691.0204",
    "hours": "Call for hours",
    "lat": 38.6276827,
    "lng": -90.3476018
  },
  {
    "id": "10319",
    "name": "Whole Foods Market",
    "address": "110 Bloomingdale Rd, White Plains, NY, 10605",
    "phone": "631.588.2577",
    "hours": "Call for hours",
    "lat": 41.0285208,
    "lng": -73.7587531
  },
  {
    "id": "10318",
    "name": "Whole Foods Market",
    "address": "4 Union Square South, New York, NY, 10003",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7348175,
    "lng": -73.9911863
  },
  {
    "id": "10317",
    "name": "Whole Foods Market",
    "address": "429 Birchwood Plaza Shopping Center, Jericho, NY, 11753",
    "phone": "301.670.3920",
    "hours": "Call for hours",
    "lat": 40.789028,
    "lng": -73.5346026
  },
  {
    "id": "10316",
    "name": "Whole Foods Market",
    "address": "10 Columbus Cr Ste SC 101, New York, NY, 10019",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7685526,
    "lng": -73.9831866
  },
  {
    "id": "10315",
    "name": "Whole Foods Market",
    "address": "94 Derby Street Ste 200, Hingham, MA, 2043",
    "phone": "781.741.8050",
    "hours": "Call for hours",
    "lat": 42.1786956,
    "lng": -70.9078674
  },
  {
    "id": "10314",
    "name": "Whole Foods Market",
    "address": "181 Cambridge St, Boston, MA, 2114",
    "phone": "617.723.0004",
    "hours": "Call for hours",
    "lat": 42.3620381,
    "lng": -71.0655752
  },
  {
    "id": "10313",
    "name": "Whole Foods Market",
    "address": "222 Main St, Madison, NJ, 7940",
    "phone": "312.587.0606",
    "hours": "Call for hours",
    "lat": 40.7534396,
    "lng": -74.4053863
  },
  {
    "id": "10312",
    "name": "Whole Foods Market",
    "address": "575 Worcester Rd, Framingham, MA, 1701",
    "phone": "508.628.9525",
    "hours": "Call for hours",
    "lat": 42.2985158,
    "lng": -71.420938
  },
  {
    "id": "10311",
    "name": "Whole Foods Market",
    "address": "4800 El Camino Real, Los Altos, CA, 94022",
    "phone": "650.559.0300",
    "hours": "Call for hours",
    "lat": 37.3989341,
    "lng": -122.1106483
  },
  {
    "id": "10310",
    "name": "Whole Foods Market",
    "address": "1250 Jefferson Ave, Redwood City, CA, 94063",
    "phone": "650.367.1400",
    "hours": "Call for hours",
    "lat": 37.4822223,
    "lng": -122.2316198
  },
  {
    "id": "10309",
    "name": "Whole Foods Market",
    "address": "888 116th Ave NE, Bellevue, WA, 98004",
    "phone": "",
    "hours": "Call for hours",
    "lat": 47.6182941,
    "lng": -122.1845899
  },
  {
    "id": "10308",
    "name": "Whole Foods Market",
    "address": "4315 Arden Way, Sacramento, CA, 95864",
    "phone": "916.488.2800",
    "hours": "Call for hours",
    "lat": 38.5966181,
    "lng": -121.363738
  },
  {
    "id": "10307",
    "name": "Whole Foods Market",
    "address": "399 4th Street, San Francisco, CA, 94107",
    "phone": "415.618.0066",
    "hours": "Call for hours",
    "lat": 37.7812623,
    "lng": -122.3997825
  },
  {
    "id": "10306",
    "name": "Whole Foods Market",
    "address": "1010 Park Place, San Mateo, CA, 94403",
    "phone": "650.358.6900",
    "hours": "Call for hours",
    "lat": 37.5439214,
    "lng": -122.2918256
  },
  {
    "id": "10305",
    "name": "Whole Foods Market",
    "address": "1210 NW Couch St, Portland, OR, 97209",
    "phone": "",
    "hours": "Call for hours",
    "lat": 45.5235316,
    "lng": -122.6833332
  },
  {
    "id": "10304",
    "name": "Whole Foods Market",
    "address": "2201 S College Ave, Fort Collins, CO, 80525",
    "phone": "970.267.9200",
    "hours": "Call for hours",
    "lat": 40.5591025,
    "lng": -105.0785748
  },
  {
    "id": "10303",
    "name": "Whole Foods Market",
    "address": "7635 N Academy Blvd, Colorado Springs, CO, 80920",
    "phone": "719.531.9999",
    "hours": "Call for hours",
    "lat": 38.942002,
    "lng": -104.7974944
  },
  {
    "id": "10302",
    "name": "Whole Foods Market",
    "address": "525 N Lamar, Austin, TX, 78703",
    "phone": "512-542-2200",
    "hours": "Call for hours",
    "lat": 30.2705019,
    "lng": -97.753469
  },
  {
    "id": "10301",
    "name": "Whole Foods Market",
    "address": "5815 Wyoming Blvd NE, Albuquerque, NM, 87109",
    "phone": "505.856.0474",
    "hours": "Call for hours",
    "lat": 35.1463717,
    "lng": -106.5559212
  },
  {
    "id": "10300",
    "name": "Whole Foods Market",
    "address": "5600 Magazine St, New Orleans, LA, 70115",
    "phone": "201.670.3884",
    "hours": "Call for hours",
    "lat": 29.920694,
    "lng": -90.1177695
  },
  {
    "id": "10299",
    "name": "Whole Foods Market",
    "address": "9366 South Colorado Blvd, Highlands Ranch, CO, 80126",
    "phone": "303.470.6003",
    "hours": "Call for hours",
    "lat": 39.5452444,
    "lng": -104.9425358
  },
  {
    "id": "10298",
    "name": "Whole Foods Market",
    "address": "4100 Lomo Alto Dr, Highland Park, TX, 75219",
    "phone": "206.985.8500",
    "hours": "Call for hours",
    "lat": 32.8205285,
    "lng": -96.8144154
  },
  {
    "id": "10297",
    "name": "Whole Foods Market",
    "address": "1181 Yulupa Ave, Santa Rosa, CA, 95405",
    "phone": "707.575.7915",
    "hours": "Call for hours",
    "lat": 38.4423164,
    "lng": -122.6746286
  },
  {
    "id": "10296",
    "name": "Whole Foods Market",
    "address": "621 E Washington, Petaluma, CA, 94952",
    "phone": "707.762.9352",
    "hours": "Call for hours",
    "lat": 38.2412795,
    "lng": -122.6345586
  },
  {
    "id": "10295",
    "name": "Whole Foods Market",
    "address": "6910 McKinley St, Sebastopol, CA, 95472",
    "phone": "707.829.9801",
    "hours": "Call for hours",
    "lat": 38.4038252,
    "lng": -122.8240147
  },
  {
    "id": "10294",
    "name": "Whole Foods Market",
    "address": "5930 Roswell Rd, Atlanta, GA, 30328",
    "phone": "905.815.0794",
    "hours": "Call for hours",
    "lat": 33.9178195,
    "lng": -84.3797497
  },
  {
    "id": "10293",
    "name": "Whole Foods Market",
    "address": "1440 P St NW, Washington, DC, 20005",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9092854,
    "lng": -77.0335078
  },
  {
    "id": "10292",
    "name": "Whole Foods Market",
    "address": "4004 Bellaire Blvd, Houston, TX, 77025",
    "phone": "972.699.9419",
    "hours": "Call for hours",
    "lat": 29.7069766,
    "lng": -95.4416654
  },
  {
    "id": "10291",
    "name": "Whole Foods Market",
    "address": "B 102 New Waverly Place, Cary, NC, 27518",
    "phone": "847.205.9435",
    "hours": "Call for hours",
    "lat": 35.7375865,
    "lng": -78.7773286
  },
  {
    "id": "10290",
    "name": "Whole Foods Market",
    "address": "250 7th Ave, New York, NY, 10001",
    "phone": "713.520.0265",
    "hours": "Call for hours",
    "lat": 40.7449529,
    "lng": -73.9952959
  },
  {
    "id": "10289",
    "name": "Whole Foods Market",
    "address": "1400 Glades Rd, Ste 110, Boca Raton, FL, 33431",
    "phone": "561.447.0001",
    "hours": "Call for hours",
    "lat": 26.3654155,
    "lng": -80.1097946
  },
  {
    "id": "10288",
    "name": "Whole Foods Market",
    "address": "2607 West 75th St, Naperville, IL, 60540",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.7489072,
    "lng": -88.1997473
  },
  {
    "id": "10287",
    "name": "Whole Foods Market",
    "address": "100 Sunset Dr, San Ramon, CA, 94583",
    "phone": "925.355.9000",
    "hours": "Call for hours",
    "lat": 37.7617624,
    "lng": -121.9612642
  },
  {
    "id": "10286",
    "name": "Whole Foods Market",
    "address": "650 West Shaw Ave, Fresno, CA, 93704",
    "phone": "559.241.0300",
    "hours": "Call for hours",
    "lat": 36.8093036,
    "lng": -119.8053868
  },
  {
    "id": "10285",
    "name": "Whole Foods Market",
    "address": "7350 West Orchard Lake Rd, West Bloomfield, MI, 48322",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.5293162,
    "lng": -83.3631611
  },
  {
    "id": "10284",
    "name": "Whole Foods Market",
    "address": "3060 Excelsior Blvd, Minneapolis, MN, 55416",
    "phone": "617.723.0404",
    "hours": "Call for hours",
    "lat": 44.9475843,
    "lng": -93.3223662
  },
  {
    "id": "10283",
    "name": "Whole Foods Market",
    "address": "833 Wayne Ave, Silver Spring, MD, 20910",
    "phone": "216.464.9319",
    "hours": "Call for hours",
    "lat": 38.9961273,
    "lng": -77.0241512
  },
  {
    "id": "10282",
    "name": "Whole Foods Market",
    "address": "2000 N Federal Hwy, Ft Lauderdale, FL, 33305",
    "phone": "954.398.2000",
    "hours": "Call for hours",
    "lat": 26.1528102,
    "lng": -80.1181262
  },
  {
    "id": "10281",
    "name": "Whole Foods Market",
    "address": "760 Waukegan Rd, Deerfield, IL, 60015",
    "phone": "",
    "hours": "Call for hours",
    "lat": 42.1663238,
    "lng": -87.8480691
  },
  {
    "id": "10280",
    "name": "Whole Foods Market",
    "address": "2955 Kirby Dr, Houston, TX, 77098",
    "phone": "713-520-1937",
    "hours": "Call for hours",
    "lat": 29.7395184,
    "lng": -95.4180918
  },
  {
    "id": "10279",
    "name": "Whole Foods Market",
    "address": "340 River St, Cambridge, MA, 2139",
    "phone": "617.876.6990",
    "hours": "Call for hours",
    "lat": 42.3610071,
    "lng": -71.1139362
  },
  {
    "id": "10278",
    "name": "Whole Foods Market",
    "address": "929 South St, Philadelphia, PA, 19147",
    "phone": "919.967.0228",
    "hours": "Call for hours",
    "lat": 39.9428511,
    "lng": -75.1577303
  },
  {
    "id": "10277",
    "name": "Whole Foods Market",
    "address": "601 North Main St, Providence, RI, 2904",
    "phone": "401.621.5991",
    "hours": "Call for hours",
    "lat": 41.8372393,
    "lng": -71.4083214
  },
  {
    "id": "10276",
    "name": "Whole Foods Market",
    "address": "41 Miller St, Winston-Salem, NC, 27104",
    "phone": "520.742.1761",
    "hours": "Call for hours",
    "lat": 36.09432,
    "lng": -80.27382
  },
  {
    "id": "10275",
    "name": "Whole Foods Market",
    "address": "7871 Santa Monica Blvd, Los Angeles, CA, 90046",
    "phone": "323.848.4200",
    "hours": "Call for hours",
    "lat": 34.0915208,
    "lng": -118.3607656
  },
  {
    "id": "10274",
    "name": "Whole Foods Market",
    "address": "3751 E Foothill Blvd, Pasadena, CA, 91107",
    "phone": "626.351.5994",
    "hours": "Call for hours",
    "lat": 34.1512089,
    "lng": -118.0724414
  },
  {
    "id": "10273",
    "name": "Whole Foods Market",
    "address": "30 W Huron St, Chicago, IL, 60610",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.8949894,
    "lng": -87.629197
  },
  {
    "id": "10272",
    "name": "Whole Foods Market",
    "address": "44 Godwin Ave, Ridgewood, NJ, 7450",
    "phone": "512.542.2209",
    "hours": "Call for hours",
    "lat": 40.9783145,
    "lng": -74.1224361
  },
  {
    "id": "10271",
    "name": "Whole Foods Market",
    "address": "2655 Pacific Coast Hwy, Torrance, CA, 90505",
    "phone": "310.257.8700",
    "hours": "Call for hours",
    "lat": 33.7925761,
    "lng": -118.3309445
  },
  {
    "id": "10270",
    "name": "Whole Foods Market",
    "address": "753 Cerillos Rd, Santa Fe, NM, 87505",
    "phone": "505.992.1700",
    "hours": "Call for hours",
    "lat": 35.679077,
    "lng": -105.9500674
  },
  {
    "id": "10269",
    "name": "Whole Foods Market",
    "address": "1026 NE 64th St, Seattle, WA, 98115",
    "phone": "773.404.1558",
    "hours": "Call for hours",
    "lat": 47.6751401,
    "lng": -122.3159059
  },
  {
    "id": "10268",
    "name": "Whole Foods Market",
    "address": "905 River Rd, Edgewater, NJ, 7020",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.82507,
    "lng": -73.9738201
  },
  {
    "id": "10267",
    "name": "Whole Foods Market",
    "address": "1333 East Newell Ave, Walnut Creek, CA, 94596",
    "phone": "925.274.9700",
    "hours": "Call for hours",
    "lat": 37.892668,
    "lng": -122.0552461
  },
  {
    "id": "10266",
    "name": "Whole Foods Market",
    "address": "1575 The Fairway, Jenkintown, PA, 19046",
    "phone": "303.499.1467",
    "hours": "Call for hours",
    "lat": 40.1078996,
    "lng": -75.1161353
  },
  {
    "id": "10265",
    "name": "Whole Foods Market",
    "address": "21347 Ventura Blvd, Woodland Hills, CA, 91364",
    "phone": "818.610.0000",
    "hours": "Call for hours",
    "lat": 34.1681631,
    "lng": -118.5969671
  },
  {
    "id": "10264",
    "name": "Whole Foods Market",
    "address": "801 E Lamar Blvd, Arlington, TX, 76011",
    "phone": "817-461-9362",
    "hours": "Call for hours",
    "lat": 32.7668998,
    "lng": -97.0990989
  },
  {
    "id": "10263",
    "name": "Whole Foods Market",
    "address": "21105 Biscayne Blvd, Aventura, FL, 33180",
    "phone": "305.682.4400",
    "hours": "Call for hours",
    "lat": 25.9712665,
    "lng": -80.1406777
  },
  {
    "id": "10262",
    "name": "Whole Foods Market",
    "address": "2375 East First Ave, Denver, CO, 80206",
    "phone": "720.941.4100",
    "hours": "Call for hours",
    "lat": 39.7185829,
    "lng": -104.9576861
  },
  {
    "id": "10261",
    "name": "Whole Foods Market",
    "address": "647 Washington St, Newtonville, MA, 2458",
    "phone": "617.965.2070",
    "hours": "Call for hours",
    "lat": 42.3541087,
    "lng": -71.2000849
  },
  {
    "id": "10260",
    "name": "Whole Foods Market",
    "address": "255 Hartford Ave, Bellingham, MA, 2019",
    "phone": "508.966.3331",
    "hours": "Call for hours",
    "lat": 42.1113191,
    "lng": -71.461568
  },
  {
    "id": "10259",
    "name": "Whole Foods Market",
    "address": "170 Great Rd, Bedford, MA, 1730",
    "phone": "781.275.8264",
    "hours": "Call for hours",
    "lat": 42.490913,
    "lng": -71.2728508
  },
  {
    "id": "10258",
    "name": "Whole Foods Market",
    "address": "810 University Dr, Coral Springs, FL, 33071",
    "phone": "954.796.5800",
    "hours": "Call for hours",
    "lat": 26.2425603,
    "lng": -80.256787
  },
  {
    "id": "10257",
    "name": "Whole Foods Market",
    "address": "800 Del Monte Center, Monterey, CA, 93940",
    "phone": "831.333.1600",
    "hours": "Call for hours",
    "lat": 36.5834225,
    "lng": -121.9003622
  },
  {
    "id": "10256",
    "name": "Whole Foods Market",
    "address": "940 Route 73 North, Marlton, NJ, 8053",
    "phone": "310.274.8149",
    "hours": "Call for hours",
    "lat": 39.8577076,
    "lng": -74.920581
  },
  {
    "id": "10255",
    "name": "Whole Foods Market",
    "address": "5120 S Rural, Tempe, AZ, 85282",
    "phone": "480.456.1400",
    "hours": "Call for hours",
    "lat": 33.3796448,
    "lng": -111.9299853
  },
  {
    "id": "10254",
    "name": "Whole Foods Market",
    "address": "1640 Chicago Ave, Evanston, IL, 60201",
    "phone": "707.542.7412",
    "hours": "Call for hours",
    "lat": 42.0475377,
    "lng": -87.6795313
  },
  {
    "id": "10253",
    "name": "Whole Foods Market",
    "address": "255 E Basse Rd, San Antonio, TX, 78209",
    "phone": "210-826-4676",
    "hours": "Call for hours",
    "lat": 29.4960263,
    "lng": -98.4801737
  },
  {
    "id": "10252",
    "name": "Whole Foods Market",
    "address": "11737 San Vincente Blvd, Los Angeles, CA, 90049",
    "phone": "310.826.4433",
    "hours": "Call for hours",
    "lat": 34.0536286,
    "lng": -118.4673459
  },
  {
    "id": "10251",
    "name": "Whole Foods Market",
    "address": "711 University Ave, San Diego, CA, 92103",
    "phone": "619.294.2800",
    "hours": "Call for hours",
    "lat": 32.747879,
    "lng": -117.1580005
  },
  {
    "id": "10250",
    "name": "Whole Foods Market",
    "address": "340 3rd St, San Rafael, CA, 94901",
    "phone": "415.451.6333",
    "hours": "Call for hours",
    "lat": 37.9713437,
    "lng": -122.5168364
  },
  {
    "id": "10249",
    "name": "Whole Foods Market",
    "address": "8825 Via La Jolla Dr, LaJolla, CA, 92037",
    "phone": "858.642.6700",
    "hours": "Call for hours",
    "lat": 32.8687404,
    "lng": -117.2306258
  },
  {
    "id": "10248",
    "name": "Whole Foods Market",
    "address": "143 Maple Ave East, Vienna, VA, 22180",
    "phone": "773.205.1746",
    "hours": "Call for hours",
    "lat": 38.9022469,
    "lng": -77.2626957
  },
  {
    "id": "10247",
    "name": "Whole Foods Market",
    "address": "1330 Smith Ave, Baltimore, MD, 21209",
    "phone": "617.492.5500",
    "hours": "Call for hours",
    "lat": 39.3684185,
    "lng": -76.6498445
  },
  {
    "id": "10246",
    "name": "Whole Foods Market",
    "address": "2101 Northern Blvd, Munsey Park, NY, 11030",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.7974205,
    "lng": -73.6707047
  },
  {
    "id": "10245",
    "name": "Whole Foods Market",
    "address": "4530 40th St NW Tenley Cir, Washington, DC, 20016",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.9490789,
    "lng": -77.0792007
  },
  {
    "id": "10244",
    "name": "Whole Foods Market",
    "address": "11660 Plaza America Dr, Reston, VA, 20190",
    "phone": "303.277.1327",
    "hours": "Call for hours",
    "lat": 38.9517757,
    "lng": -77.3494016
  },
  {
    "id": "10243",
    "name": "Whole Foods Market",
    "address": "701 Bloomfield Ave, Montclair, NJ, 7042",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.8184587,
    "lng": -74.2229766
  },
  {
    "id": "10242",
    "name": "Whole Foods Market",
    "address": "90 E Putnam Ave, Greenwich, CT, 6830",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.0331186,
    "lng": -73.6238635
  },
  {
    "id": "10241",
    "name": "Whole Foods Market",
    "address": "8402 Old Keene Mill Rd, Springfield, VA, 22152",
    "phone": "512.499.7102",
    "hours": "Call for hours",
    "lat": 38.779075,
    "lng": -77.2341919
  },
  {
    "id": "10240",
    "name": "Whole Foods Market",
    "address": "821 Lancaster Ave, Wayne, PA, 19087",
    "phone": "",
    "hours": "Call for hours",
    "lat": 40.0482274,
    "lng": -75.4121205
  },
  {
    "id": "10239",
    "name": "Whole Foods Market",
    "address": "7511 Leesburg Pike, Falls Church, VA, 22043",
    "phone": "434.973.4650",
    "hours": "Call for hours",
    "lat": 38.9026076,
    "lng": -77.2050359
  },
  {
    "id": "10238",
    "name": "Whole Foods Market",
    "address": "5269 River Rd, Bethesda, MD, 20816",
    "phone": "425.451.8423",
    "hours": "Call for hours",
    "lat": 38.9663166,
    "lng": -77.1041985
  },
  {
    "id": "10237",
    "name": "Whole Foods Market",
    "address": "11666 National Blvd, Los Angeles, CA, 90064",
    "phone": "310.996.8840",
    "hours": "Call for hours",
    "lat": 34.0219801,
    "lng": -118.4372107
  },
  {
    "id": "10236",
    "name": "Whole Foods Market",
    "address": "1765 California St, San Francisco, CA, 94109",
    "phone": "415.674.0500",
    "hours": "Call for hours",
    "lat": 37.7899512,
    "lng": -122.4231006
  },
  {
    "id": "10235",
    "name": "Whole Foods Market",
    "address": "3313 University Ave, Madison, WI, 53705",
    "phone": "",
    "hours": "Call for hours",
    "lat": 43.0747426,
    "lng": -89.4442252
  },
  {
    "id": "10234",
    "name": "Whole Foods Market",
    "address": "2700 Wilson Blvd, Arlington, VA, 22201",
    "phone": "",
    "hours": "Call for hours",
    "lat": 38.8890982,
    "lng": -77.0910708
  },
  {
    "id": "10233",
    "name": "Whole Foods Market",
    "address": "621 Broad St, Durham, NC, 27705",
    "phone": "512.499.3815",
    "hours": "Call for hours",
    "lat": 36.0072498,
    "lng": -78.920603
  },
  {
    "id": "10232",
    "name": "Whole Foods Market",
    "address": "4520 N Sepulveda Blvd, Sherman Oaks, CA, 91403",
    "phone": "818.382.3700",
    "hours": "Call for hours",
    "lat": 34.1256372,
    "lng": -118.4788748
  },
  {
    "id": "10231",
    "name": "Whole Foods Market",
    "address": "9607 Research Blvd #300, Austin, TX, 78759",
    "phone": "512-345-5003",
    "hours": "Call for hours",
    "lat": 30.388946,
    "lng": -97.7415005
  },
  {
    "id": "10230",
    "name": "Whole Foods Market",
    "address": "1690 S Bascom Ave, Campbell, CA, 95008",
    "phone": "408.371.5000",
    "hours": "Call for hours",
    "lat": 37.2924563,
    "lng": -121.9306005
  },
  {
    "id": "10229",
    "name": "Whole Foods Market",
    "address": "15 Westland Ave, Boston, MA, 2115",
    "phone": "617.375.1010",
    "hours": "Call for hours",
    "lat": 42.3435358,
    "lng": -71.0863043
  },
  {
    "id": "10228",
    "name": "Whole Foods Market",
    "address": "2201 Preston Rd, Plano, TX, 75093",
    "phone": "972-612-6729",
    "hours": "Call for hours",
    "lat": 33.0292895,
    "lng": -96.7965876
  },
  {
    "id": "10227",
    "name": "Whole Foods Market",
    "address": "7245 West Lake St, River Forest, IL, 60305",
    "phone": "",
    "hours": "Call for hours",
    "lat": 41.887377,
    "lng": -87.8062641
  },
  {
    "id": "10226",
    "name": "Whole Foods Market",
    "address": "15980 Los Gatos Blvd, Los Gatos, CA, 95032",
    "phone": "408.358.4434",
    "hours": "Call for hours",
    "lat": 37.2364807,
    "lng": -121.9614419
  },
  {
    "id": "10225",
    "name": "Whole Foods Market",
    "address": "200 Alewife Brook Pkwy, Cambridge, MA, 2138",
    "phone": "617.491.0040",
    "hours": "Call for hours",
    "lat": 42.3891989,
    "lng": -71.1413238
  },
  {
    "id": "10224",
    "name": "Whole Foods Market",
    "address": "405 N Pacific Coast Hwy, Redondo Beach, CA, 90277",
    "phone": "310.376.6931",
    "hours": "Call for hours",
    "lat": 33.8473733,
    "lng": -118.3895084
  },
  {
    "id": "10223",
    "name": "Whole Foods Market",
    "address": "239 N Crescent Dr, Beverly Hills, CA, 90210",
    "phone": "310.274.3360",
    "hours": "Call for hours",
    "lat": 34.0693674,
    "lng": -118.398218
  },
  {
    "id": "10222",
    "name": "Whole Foods Market",
    "address": "3540  Wade Ave, Raleigh, NC, 27607",
    "phone": "(919) 828-5805",
    "hours": "Call for hours",
    "lat": 35.8024745,
    "lng": -78.6864071
  },
  {
    "id": "10221",
    "name": "Whole Foods Market",
    "address": "15 Washington St, Brighton, MA, 2135",
    "phone": "617.738.8187",
    "hours": "Call for hours",
    "lat": 42.3427707,
    "lng": -71.1403026
  },
  {
    "id": "10220",
    "name": "Whole Foods Market",
    "address": "261 Waterman St, Providence, RI, 2906",
    "phone": "401.272.1690",
    "hours": "Call for hours",
    "lat": 41.8277244,
    "lng": -71.3864091
  },
  {
    "id": "10219",
    "name": "Whole Foods Market",
    "address": "916 Walnut St, Newton, MA, 2461",
    "phone": "617.969.1141",
    "hours": "Call for hours",
    "lat": 42.3300663,
    "lng": -71.2063967
  },
  {
    "id": "10218",
    "name": "Whole Foods Market",
    "address": "327 Russell St, Hadley, MA, 1035",
    "phone": "413.586.9932",
    "hours": "Call for hours",
    "lat": 42.3530868,
    "lng": -72.5555125
  },
  {
    "id": "10217",
    "name": "Whole Foods Market",
    "address": "115 Prospect St, Cambridge, MA, 2139",
    "phone": "617.492.0070",
    "hours": "Call for hours",
    "lat": 42.3680634,
    "lng": -71.1023775
  },
  {
    "id": "10216",
    "name": "Whole Foods Market",
    "address": "414 Miller Ave, Mill Valley, CA, 94941",
    "phone": "415.381.1200",
    "hours": "Call for hours",
    "lat": 37.8960009,
    "lng": -122.5363018
  },
  {
    "id": "10215",
    "name": "Whole Foods Market",
    "address": "81 South Elliott, Chapel Hill, NC, 27514",
    "phone": "719.638.1953",
    "hours": "Call for hours",
    "lat": 35.9344265,
    "lng": -79.0278974
  },
  {
    "id": "10214",
    "name": "Whole Foods Market",
    "address": "3000 Telegraph Ave, Berkeley, CA, 94705",
    "phone": "510.649.1333",
    "hours": "Call for hours",
    "lat": 37.8555051,
    "lng": -122.2603374
  },
  {
    "id": "10213",
    "name": "Whole Foods Market",
    "address": "774 Emerson St, Palo Alto, CA, 94301",
    "phone": "650.326.8676",
    "hours": "Call for hours",
    "lat": 37.4424053,
    "lng": -122.1596147
  }
];